var zM = Object.defineProperty;
var MM = (e, t, n) => t in e ? zM(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Nt = (e, t, n) => MM(e, typeof t != "symbol" ? t + "" : t, n);
import { ref as S, shallowRef as Ea, watch as Je, computed as A, getCurrentInstance as Zo, inject as bi, onMounted as jt, onBeforeUnmount as Tt, shallowReactive as PM, toRaw as OM, defineComponent as lt, openBlock as f, createElementBlock as h, normalizeStyle as Yt, normalizeClass as Re, Fragment as Te, createTextVNode as Ht, toDisplayString as y, createCommentVNode as O, renderList as nt, createVNode as Ze, createElementVNode as d, createBlock as Ge, unref as u, nextTick as Gt, Teleport as wi, Transition as Rr, withCtx as mt, withModifiers as yt, withKeys as Ca, renderSlot as On, resolveDynamicComponent as Ki, withDirectives as dn, vModelText as _n, provide as Wo, useSlots as LM, mergeProps as wv, h as DM, resolveComponent as RM, vModelCheckbox as zc, getCurrentScope as l2, onScopeDispose as Ey, createStaticVNode as u2, onUpdated as NM, reactive as c2, defineAsyncComponent as d2, watchEffect as IM, createSlots as BM, isRef as FM, vShow as UM } from "vue";
import { ChevronDown as HM, Check as _v, Sparkles as KM, Plus as VM, History as jM, X as qM, Trash2 as WM, Undo2 as YM, Ban as GM, CircleAlert as Gw, LoaderCircle as Xw, Square as XM, Send as JM } from "lucide-vue-next";
import { Popover as ZM, PopoverButton as QM, PopoverPanel as eP, Menu as tP, MenuButton as nP, MenuItems as aP, MenuItem as iP } from "@headlessui/vue";
function xv(e) {
  return !!e && e.enabled && e.state === "ok";
}
const el = {
  "toolbar.new_folder": "New folder",
  "toolbar.upload": "Upload",
  "toolbar.search": "Search",
  "toolbar.search.placeholder": "Search by name or tag:…",
  "toolbar.view.list": "List",
  "toolbar.view.grid": "Grid",
  "toolbar.refresh": "Refresh",
  "toolbar.go_up": "Up one level",
  "ctx.open": "Open",
  "ctx.preview": "Preview",
  "ctx.download": "Download",
  "ctx.archive_create": "Create archive…",
  "ctx.archive_extract": "Extract archive…",
  "ctx.rename": "Rename",
  "ctx.delete": "Delete",
  "ctx.delete_perm": "Delete permanently",
  "ctx.restore": "Restore",
  "ctx.share": "Share",
  "ctx.move": "Move",
  "ctx.copy": "Copy",
  "ctx.cut": "Cut",
  "ctx.show_hidden": "Show hidden files",
  "ctx.hide_hidden": "Hide hidden files",
  "ctx.keep_local": "Keep on this computer",
  "ctx.keep_online": "Keep online only",
  "ctx.keep_reveal": "Open local folder",
  "ctx.keep_inherited": "Kept on this computer with its parent",
  "keep.started": "Will be kept on this computer - sync started",
  "keep.failed": "Could not keep on this computer",
  "keep.badge_kept": "On this computer",
  "keep.badge_syncing": "Syncing…",
  "keep.badge_cloud": "Online only",
  "keep.badge_partial": "Contains items kept on this computer",
  "keep.strip_transfer": "Syncing {name} - {done}/{total} ({pct}%)",
  "keep.strip_inventory": "Syncing {name} - scanning the server…",
  "keep.strip_settling": "Syncing {name} - settling…",
  "ctx.paste": "Paste",
  "ctx.info": "Info",
  "ctx.duplicate": "Duplicate",
  "ctx.new_file": "New file",
  "modal.delete.title": "Delete?",
  "modal.delete.message": "{count} items will be moved to trash.",
  "modal.delete.message_one": "{count} item will be moved to trash.",
  "modal.delete.confirm": "Move to Trash",
  "modal.delete.working": "Moving to Trash…",
  "modal.delete.cancel": "Cancel",
  "modal.delete.permanent_title": "Delete permanently?",
  "modal.delete.permanent_message": "{count} items will be deleted for good. This cannot be undone.",
  "modal.delete.permanent_message_one": "{count} item will be deleted for good. This cannot be undone.",
  "modal.delete.permanent_confirm": "Delete permanently",
  "modal.delete.permanent_working": "Deleting…",
  "modal.rename.title": "Rename",
  "modal.rename.save": "Save",
  "modal.rename.saving": "Renaming…",
  "modal.rename.cancel": "Cancel",
  "modal.rename.empty": "Type a name.",
  "modal.newfolder.title": "New folder",
  "modal.newfolder.placeholder": "Folder name",
  "modal.newfolder.create": "Create",
  "modal.newfolder.creating": "Creating…",
  "modal.newfolder.cancel": "Cancel",
  "modal.share.title": "Share link",
  "archive.create_title": "Create archive",
  "archive.extract_title": "Extract archive",
  "archive.create_count": "{count} selected items",
  "archive.create_count_one": "{count} selected item",
  "archive.filename": "Archive name",
  "archive.format": "Format",
  "archive.password_optional": "Password (optional)",
  "archive.password_confirm": "Confirm password",
  "archive.password_mismatch": "Passwords do not match.",
  "archive.encrypt_names": "Encrypt file names",
  "archive.compression": "Compression",
  "archive.solid": "Create solid archive",
  "archive.dictionary_size": "Dictionary size",
  "archive.dictionary_size_value": "{n} MiB",
  "archive.dictionary_hint": "Larger dictionaries can improve compression but use more memory while creating and extracting.",
  "archive.destination_folder": "Extract to folder",
  "archive.create": "Create",
  "archive.creating": "Creating…",
  "archive.extract": "Extract",
  "archive.extract_here": "Extract here",
  "archive.extract_to_folder": "Extract to folder",
  "archive.extracting": "Extracting…",
  "archive.cancel": "Cancel",
  "archive.invalid_name": "Enter a file name without slashes.",
  "archive.invalid_extension": "Archive name must use one of the available format extensions.",
  "archive.invalid_folder": "Enter a folder name without slashes.",
  "archive.password_required": "This archive requires a password.",
  "archive.password_title": "Archive password",
  "archive.continue": "Continue",
  "archive.opening": "Opening…",
  "archive.bad_password": "The archive password is incorrect.",
  "archive.target_exists": "An item with that name already exists. Choose another name or remove it first.",
  "archive.password_charset": "A ZIP password can use only ASCII characters: unaccented letters, digits and ordinary punctuation. Choose 7z to use any characters.",
  "archive.error_unsupported": "This archive cannot be extracted: this server cannot read its format, or it holds something filex does not extract (a link, a special file, or a file whose size it does not state).",
  "archive.error_limit": "This archive is larger than the server allows to extract.",
  "archive.error_unavailable": "This server cannot open this kind of archive right now.",
  "archive.created": "Archive created",
  "archive.queued": "Archive creation is running in the background",
  "archive.extracted": "Extracted {count} files",
  "archive.extracted_one": "Extracted {count} file",
  "archive.extraction_queued": "Archive extraction is running in the background",
  "archive.preparing_extract": "Reading {name}… the whole archive is read before it can be extracted.",
  "archive.already_preparing": "Still reading {name} - it is extracted once that is done",
  "archive.extraction_completed": "Extraction completed",
  "archive.extraction_cancelled": "Extraction cancelled after {count} files",
  "archive.extraction_cancelled_one": "Extraction cancelled after {count} file",
  "modal.share.pin": "PIN protected",
  "modal.share.expires": "Expires at",
  "modal.share.max_downloads": "Download limit",
  "modal.share.create": "Share",
  "modal.share.cancel": "Cancel",
  "modal.share.close": "Close",
  "modal.share.limit_applied": "(server limit applied)",
  "modal.share.copy": "Copy",
  "modal.share.url_copied": "Link copied",
  "modal.share.pin_copied": "PIN copied",
  "modal.share.cli_copied": "CLI command copied",
  "upload.progress": "Uploading",
  "upload.done": "Done",
  "upload.error": "Error",
  "upload.failed": "Could not upload “{name}”",
  "upload.aborted": "Aborted",
  "upload.cancel": "Cancel",
  "upload.resuming": "Resuming “{name}” from {percent}%",
  "upload.saving": "Saving to the storage…",
  "empty.folder": "This folder is empty",
  "empty.search": "No results",
  loading: "Loading…",
  "notFound.title": "Folder not found",
  "notFound.desc": "This folder does not exist, was moved, or you do not have access to it.",
  "notFound.goRoot": "Go to root folder",
  "col.name": "Name",
  "col.size": "Size",
  "col.modified": "Modified",
  "col.type": "Type",
  "unit.bytes": "B",
  "unit.kb": "KB",
  "unit.mb": "MB",
  "unit.gb": "GB",
  "unit.tb": "TB",
  "unit.pb": "PB",
  "breadcrumb.root": "Root",
  "breadcrumb.copy_path": "Copy path",
  "breadcrumb.go_to_path": "Go to path",
  "breadcrumb.path_placeholder": "fileman/foo/bar",
  "ops.copy": "Copying",
  "ops.move": "Moving",
  "ops.delete": "Deleting",
  "ops.queued": "queued",
  "ops.done": "done",
  "ops.error": "error",
  "node.trash": "Trash",
  /* gorunum:v1 - the singular kind, printed under a folder's name on a card
   * and beside it in the list. The plural section heading is a different
   * string on purpose. */
  "node.folder": "Folder",
  // --- Rich viewer chrome ---
  "viewer.open_in_new_tab": "Open in new tab",
  "viewer.loading": "Loading…",
  "viewer.failed_to_load": "Failed to load file",
  /* ⚠ Said to a PERSON: it used to tell them to "install the peer dependency". */
  "viewer.peer_not_installed": "This kind of file cannot be shown here. Download it to open it on your device.",
  "viewer.remote_image.label": "Remote image",
  "viewer.remote_image.title": "Load a remote image?",
  "viewer.remote_image.body": "This image is on another server. Loading it tells that server that this file was opened, and your IP address.",
  "viewer.remote_image.setting_hint": "To load them without asking, turn on “Load remote images in previews” in User settings → Preferences.",
  "viewer.remote_image.load": "Load image",
  "viewer.remote_image.load_all": "Load all remote images in this file",
  "viewer.remote_image.book_held": "Pictures from other servers in this book are not loaded.",
  "viewer.remote_image.book_load": "Load remote images…",
  "viewer.format_unsupported_3d": "The preview shows 3D models in .glb, .gltf and .usdz only. Download the file to open it in a 3D program.",
  "viewer.zoom_in": "Zoom in",
  "viewer.zoom_out": "Zoom out",
  "viewer.fit_width": "Fit width",
  "viewer.next_page": "Next page",
  "viewer.prev_page": "Previous page",
  "viewer.page_n_of_m": "Page {n} of {m}",
  "viewer.tags": "Tags",
  "viewer.layers": "Layers",
  "viewer.toc": "Contents",
  "viewer.font_smaller": "Smaller text",
  "viewer.font_larger": "Larger text",
  "viewer.search": "Search",
  "viewer.download": "Download",
  "viewer.saving": "Saving…",
  "viewer.save": "Save (Ctrl+S)",
  "viewer.saved": "Saved",
  "viewer.save_error": "Error",
  "viewer.editor_loading": "Loading editor…",
  "viewer.no_preview": "No preview for this file type yet.",
  "viewer.edit": "Edit",
  "viewer.close": "Close",
  "presence.expand": "Show names",
  "presence.collapse": "Collapse",
  "viewer.save_annotations": "Save annotations",
  "viewer.annotations_on": "Annotations: on",
  "viewer.annotations_off": "Annotations: off",
  "viewer.read_only": "Read only",
  "viewer.csv_first_row_header": "First row as header",
  "viewer.csv_filter": "Filter rows…",
  "viewer.epub_prev": "Previous",
  "viewer.epub_next": "Next",
  /* ⚠ The old sentence named an ENVIRONMENT VARIABLE to every reader
     ("operator must wire FILEX_DRAWIO_URL"). A person who only wanted to look
     at a diagram is told what they can do; `_admin` - someone who can fix it -
     is told where. */
  "viewer.drawio.disabled": "Diagrams cannot be opened here: this server has no draw.io. Download the file to open it elsewhere.",
  "viewer.drawio.disabled_admin": "draw.io is not set up on this server. Set it up in the admin panel under External services.",
  "viewer.drawio.load_failed": "This diagram could not be read. Download it to open it elsewhere.",
  "viewer.drawio.save_failed": "The diagram could not be saved. Your changes are still in the editor - try again.",
  "viewer.archive.entries": "{n} files",
  "viewer.archive.entries_one": "{n} file",
  "viewer.archive.empty": "Archive is empty.",
  "viewer.archive.error": "Could not read archive contents.",
  "viewer.archive.unsupported": "This kind of archive cannot be listed here. Download it to see what is inside.",
  "viewer.archive.too_large": "This archive is too large to list here. Download it to see what is inside.",
  "viewer.archive.open": "Open archive",
  "viewer.archive.root": "Archive",
  "viewer.archive.location": "Archive location",
  "viewer.archive.reading": "Still reading… the whole archive is read before its contents can be listed, which takes a while for a large one.",
  "viewer.name": "Name",
  "viewer.size": "Size",
  // --- cila:a - sorting / date groups / density ---
  "col.sort": "Sort",
  "group.today": "Today",
  "group.yesterday": "Yesterday",
  "group.this_week": "This week",
  "group.this_month": "This month",
  "group.no_date": "No date",
  "toolbar.density.compact": "Compact view",
  "toolbar.density.comfortable": "Comfortable view",
  // --- cila:c - command palette + shortcuts help + breadcrumb ---
  "palette.placeholder": "Search files, folders or commands…",
  "palette.files": "Files",
  "palette.commands": "Commands",
  "palette.goto": "Go to path",
  "palette.empty": "No results",
  "palette.hint": "↑↓ navigate · Enter select · Esc close",
  "cmd.view_toggle": "Toggle view (list ⇄ grid)",
  "cmd.trash": "Open trash",
  "shortcuts.title": "Keyboard shortcuts",
  "shortcuts.group.nav": "Navigation",
  "shortcuts.group.selection": "Selection",
  "shortcuts.group.file": "File operations",
  "shortcuts.palette": "Command palette",
  "shortcuts.search": "Focus search",
  "shortcuts.go_up": "Go up one level",
  "shortcuts.open": "Open selected item",
  "shortcuts.close": "Close / cancel",
  "shortcuts.toggle_hidden": "Show/hide hidden files",
  "shortcuts.help": "This help dialog",
  "shortcuts.select_all": "Select all",
  "shortcuts.star": "Star / unstar",
  "shortcuts.rename": "Rename",
  "shortcuts.delete": "Delete",
  "shortcuts.cut": "Cut",
  "shortcuts.copy": "Copy",
  "shortcuts.paste": "Paste",
  "breadcrumb.more": "Folders in between",
  // --- State screens + undo snackbar + connection badge (cila:b) ---
  "empty.hint": "Drag and drop files here",
  "empty.upload": "Upload files",
  "empty.search.title": "No files match your search",
  "empty.search.hint": "Try a different search term",
  "empty.trash.title": "Trash is empty",
  "error.title": "Could not load this folder",
  "error.retry": "Try again",
  "toast.undo": "Undo",
  "toast.undone": "Undone",
  "toast.undoing": "Undoing…",
  "toast.undo_queued": "The undo is queued - the operations panel shows when it is done",
  "toast.undo_failed": "Could not undo",
  "toast.renamed": "Renamed",
  "toast.rename_queued": "Renaming to “{name}”…",
  "toast.moved": "Moved",
  "toast.trashed": "Moved to trash",
  /* i18n:hardcoded - toast copy that used to be Turkish string literals in
     FileExplorer.vue, unreachable by any locale. */
  "toast.failed": "Operation failed",
  /* ── errorWords (lib/errorWords): how a failure is SAID. ⚠ No status code,
     no JSON, no environment variable ever reaches these; an administrator
     sees the raw words on a second line, nobody else does. ── */
  "err.status.400": "Bad request",
  "err.status.401": "Sign-in required",
  "err.status.403": "You are not allowed to do this",
  "err.status.404": "Not found",
  "err.status.409": "Already exists / conflict",
  "err.status.413": "File too large",
  "err.status.415": "Unsupported file type",
  "err.status.422": "Invalid data",
  "err.status.429": "Too many requests",
  "err.status.500": "Server error",
  "err.status.501": "Not supported",
  "err.status.502": "A connected service reported an error",
  "err.status.503": "Service unavailable",
  "err.status.504": "A connected service took too long to answer",
  "err.status.other": "The server refused this request.",
  "err.upload_stalled": "The upload stopped making progress. Try again - it continues where it stopped.",
  "err.network": "The server could not be reached. Check your connection and try again.",
  /* 0.54 (audit A1/A2): a refusal the server names is said in the SERVER's
     words (`message`, backend internal/apierr `server.error.*`); the copies
     that stood here (err.read_only, err.quota, err.e2e_*, err.name_taken,
     opc.err.*…) are gone with the tables of lib/errorWords that used them. */
  "err.save_failed": "Your changes could not be saved.",
  "err.load_failed": "This file could not be loaded.",
  "err.viewer_failed": "The viewer for this file could not be started. Download the file to open it.",
  "err.detail": "Details",
  "toast.copied": "Copied",
  "toast.deleted": "Deleted",
  "toast.cut": "Cut",
  "toast.cut_ready": "Cut - ready to paste",
  "toast.copy_ready": "Copied - ready to paste",
  "toast.same_folder_cut": "Cannot cut into the same folder",
  "toast.restored": "{n} items restored",
  "toast.restored_one": "{n} item restored",
  "toast.delete_queued": "Delete queued",
  "toast.trash_retention": "Items in the trash are removed automatically once the retention window ends. Permanent deletion is done from the admin panel.",
  /* The Trash row a permanent delete is on its way for (the admin Trash
     page's words: one sentence, both catalogues - lesson #447). */
  "trash.purging": "Deleting permanently…",
  "trash.row_busy": "Something is already being done to this item",
  "dropzone.hint": "Drop files here",
  "modal.newfolder.invalid": "Invalid character",
  "names.reserved": "“{name}” is reserved for filex’s own use. Choose another name.",
  /* ⚠ A missing or broken document server is said in words, never as the
     HTTP layer (it used to read `Config fetch 503: {"error":"onlyoffice not
     configured"}`). `_admin` is what someone who can fix it reads - where to
     fix it; everybody else reads how to get the file anyway. */
  "viewer.office_unconfigured": "Office documents cannot be opened here: this server has no ONLYOFFICE document server. Download the file to open it on your computer.",
  "viewer.office_unconfigured_admin": "ONLYOFFICE is not set up on this server, so office documents cannot be opened here. Set it up in the admin panel under External services.",
  "viewer.office_unreachable": "The document server is not answering right now. Try again later, or download the file.",
  "viewer.office_unreachable_admin": "The ONLYOFFICE document server is not answering. Check it in the admin panel under External services.",
  /* Task #92: the editor runs in a frame on another origin (the document
     server's own, or the interface origin), and that page never answered -
     the address does not reach this filex. */
  "viewer.office_frame_unreachable_admin": "The ONLYOFFICE editor frame did not load from {origin}. Check that the reverse proxy there sends the frame to filex ({env}).",
  "viewer.office_failed": "This document could not be opened in ONLYOFFICE. Download it to open it on your computer.",
  "viewer.csv_office_note": "Saved as CSV: only the values of the active sheet are kept. Formatting, formulas and other sheets are not saved.",
  "viewer.office_forbidden": "You do not have permission to open this document in ONLYOFFICE.",
  /* After ONLYOFFICE's "Download failed": which of its two failures it was,
     as filex saw it (lib/officeDiagnosis, issue #80). */
  "viewer.office_download_served": "The document server downloaded this file from filex, but your browser could not load the converted copy from the document server. Check the X-Forwarded-Proto and X-Forwarded-Host headers on the reverse proxy in front of the document server.",
  "viewer.office_download_not_requested": "The document server never asked filex for this file. If the file was opened before, the document server may be using its own copy of it.",
  "viewer.office_download_refused": "filex refused the document server’s request for this file: {reason}.",
  "viewer.office_fetch_reason.bad_link": "the address was malformed",
  "viewer.office_fetch_reason.signature_expired": "the address had expired",
  "viewer.office_fetch_reason.signature_bad": "its signature did not match (the JWT secret changed, or the address was altered)",
  "viewer.office_fetch_reason.not_found": "the file no longer exists",
  "viewer.office_fetch_reason.storage_unavailable": "the storage could not be opened",
  "viewer.office_fetch_reason.body_unavailable": "the file’s contents could not be found",
  "viewer.office_fetch_reason.object_missing": "the file is missing from the storage",
  "viewer.office_fetch_reason.read_failed": "reading the file from the storage failed",
  /* The explorer's Open on a document the document server would open, when
     there is none - shown to an administrator only (everyone else is not
     offered the entry at all; lib/serviceGate). */
  "ctx.needs_onlyoffice": "ONLYOFFICE is not set up - set it up in the admin panel under External services.",
  "ctx.needs_drawio": "draw.io is not set up - set it up in the admin panel under External services.",
  "viewer.pdf_inline_failed": "Your browser could not display this PDF inline.",
  "viewer.too_large": "File is too large (>1 MB).",
  "viewer.csv_rows": "{n} rows",
  "viewer.csv_rows_one": "{n} row",
  "presence.others": "{n} people",
  "presence.others_one": "{n} person",
  "conn.offline": "No live connection - changes may be delayed",
  "conn.tooltip": "Live connection to the server is unavailable; the list refreshes periodically. This notice disappears once the connection is back.",
  /* === bul:s3 === */
  "palette.everywhere": "Everywhere",
  "palette.searching": "Searching…",
  "palette.everywhere_failed": "The search could not be done. Try again.",
  "palette.saved": "Saved searches",
  "palette.save": "Save search",
  "palette.saved.delete": "Delete saved search",
  /* #168 - the admin panel's search (components/PanelSearch.vue). */
  "panelsearch.label": "Search the admin panel",
  "panelsearch.trigger": "Search",
  "panelsearch.placeholder": "Search pages, settings, people, apps…",
  "panelsearch.close": "Close search",
  "panelsearch.clear": "Clear the search",
  "panelsearch.results": "Search results",
  "panelsearch.group.page": "Pages",
  "panelsearch.group.setting": "Settings",
  "panelsearch.group.app": "Apps",
  "panelsearch.group.user": "Users",
  "panelsearch.group.group": "Groups",
  "panelsearch.group.key": "API keys",
  "panelsearch.group.storage": "Storages",
  "panelsearch.group.share": "Shares",
  "panelsearch.group.file": "Files",
  "panelsearch.group.recent": "Recent searches",
  "panelsearch.files_all": "Search files: {q}",
  "panelsearch.recent_remove": "Remove from recent searches",
  "panelsearch.recent_clear": "Clear recent searches",
  "panelsearch.empty": "Nothing matches “{q}”.",
  "panelsearch.searching": "Searching…",
  "panelsearch.failed": "Some results could not be loaded. The rest are shown.",
  "panelsearch.prefixes": "Narrow to one kind:",
  "panelsearch.count_one": "{n} result",
  "panelsearch.count": "{n} results",
  "search.in_content": "In content",
  "search.truncated": "More results than shown - narrow your search",
  "nav.more_shown": "Showing {shown} of {total}",
  "nav.load_more": "Load more",
  /* Catalog coverage (docs/LAZY-CATALOGUE.md, lib/catalogCoverage). One
     sentence per reason; the banner sits over a listing and over search
     results, and says what is left out and why. */
  "coverage.first_scan": "This storage’s first sync has not finished. Until it does, search, folder sizes and usage leave part of it out.",
  "coverage.lazy_filling": "filex is still cataloging this storage ({pct}% of the folders found so far). Until it finishes, search, folder sizes and usage leave part of it out.",
  "coverage.lazy_on_open": "Only the folders people open on this storage are cataloged. Search, folder sizes and usage cover those folders only.",
  "coverage.search_some": "Not everything on these storages is cataloged yet: {names}. This search may miss files there.",
  "coverage.catalog_all": "Catalog everything",
  "coverage.catalog_started": "Sync started - the whole storage is being cataloged.",
  "coverage.catalog_running": "Cataloging…",
  "coverage.cataloging": "Cataloging {storage}… this runs in the background, and this page says when it is done.",
  "coverage.catalog_done": "{storage} is cataloged in full",
  "coverage.catalog_failed": "Cataloging {storage} failed. The admin panel shows why, under the storage’s sync runs.",
  "coverage.catalog_stopped": "Cataloging {storage} was stopped before it finished",
  "coverage.catalog_joined": "A scan of {storage} was already running - this page says when it is done.",
  "coverage.catalog_gone": "{storage} was removed while it was being cataloged",
  "coverage.catalog_unfollowed": "Cataloging {storage} goes on in the background; the admin panel shows how it ends, under the storage’s sync runs",
  "size.at_least": "≥ {size}",
  "size.partial_hint": "Part of this folder is not cataloged yet, so its size is at least this.",
  "size.unknown_hint": "This folder is not cataloged yet, so its size is not known.",
  /* === bag:b4 === */
  "toolbar.more": "More actions",
  "toolbar.search.close": "Close search",
  "sheet.menu": "Actions",
  "sheet.close": "Close",
  /* === koru:k1 === */
  "toolbar.inspector": "Details",
  "ctx.details": "Details",
  /* yildiz:s1 - starring is an action, so it has a verb in the menu. */
  "ctx.star": "Star",
  "ctx.unstar": "Unstar",
  "star.failed": "Could not change the star",
  "shortcuts.inspector": "Toggle details panel",
  "inspector.title": "Details",
  "inspector.copy_name": "Copy name",
  "inspector.items": "{n} items",
  "inspector.items_one": "{n} item",
  "inspector.type": "Type",
  "inspector.select_hint": "Select an item to see its details.",
  /* pane:p1 - the panel HOLDS the last selected thing (owner's ruling,
     2026-09-13), so it can be describing an item in the half of a split
     window nobody is looking at. This line says which one and where. */
  "inspector.held": "Last selected - in {where}",
  "inspector.close": "Close",
  "inspector.section.general": "General",
  "inspector.section.tags": "Tags",
  /* etiket:t1 - TagPicker's own chrome. It printed these three in English
     regardless of the catalogue until 2026-09-13; `tags.open` is the chip's new
     "show me everything with this tag". */
  "tags.open": "Open tag: {tag}",
  "tags.add": "+ Add tag",
  "tags.name": "Tag name",
  "tags.remove": "Remove tag",
  /* etiket:k2 (v0.43.0) - the two KINDS of tag. Every place a tag is drawn
     says which kind it is, in words as well as the icon, because until this
     release a tag was silently shared with every account on the server. */
  "tags.kind.label": "Who sees this tag",
  "tags.kind.personal": "Personal",
  "tags.kind.team": "Team",
  "tags.kind.personal_help": "Only you see it",
  "tags.kind.team_help": "Everyone on your team who can see this file",
  "tags.kind.team_locked": "Adding or removing a team tag needs edit permission on this file.",
  "tags.chip.personal": "Personal tag “{tag}” - only you see it",
  "tags.chip.team": "Team tag “{tag}” - everyone on your team who can see this file sees it",
  "tags.add_submit": "Add",
  "inspector.section.versions": "Versions",
  "inspector.section.permissions": "Permissions",
  "inspector.section.shares": "Shares",
  "inspector.path": "Path",
  "inspector.size": "Size",
  "inspector.modified": "Modified",
  "inspector.mime": "MIME type",
  "inspector.etag": "ETag",
  "inspector.nodeId": "Node ID",
  "inspector.copy": "Copy",
  "inspector.copied": "Copied",
  "inspector.error": "Could not load",
  "inspector.items_summary": "{n} items, {size} total",
  "inspector.items_summary_one": "{n} item, {size} total",
  "inspector.folder_items": "{n} items",
  "inspector.folder_items_one": "{n} item",
  "inspector.versions.empty": "No version history",
  "inspector.versions.v": "Version {n}",
  "inspector.versions.restore": "Restore",
  "inspector.versions.restore_confirm": "Restore this version?",
  "inspector.versions.snapshot_current": "Snapshot the current state first",
  "inspector.versions.confirm": "Confirm",
  "inspector.versions.restoring": "Restoring…",
  "inspector.versions.cancel": "Cancel",
  "inspector.versions.take_snapshot": "Snapshot current state",
  "inspector.versions.snapshotting": "Taking a snapshot…",
  "inspector.versions.restored": "Version restored",
  "inspector.versions.snapshotted": "Snapshot taken",
  "inspector.versions.unsupported": "The server does not support this operation",
  "inspector.perm.none": "No access",
  "inspector.perm.viewer": "Viewer",
  "inspector.perm.editor": "Editor",
  "inspector.perm.owner": "Owner",
  "inspector.perm.manage": "Manage permissions",
  "inspector.shares.empty": "No share links",
  "inspector.shares.copy": "Copy link",
  /* wiring:c1 - theme gallery */
  "theme.menu": "Theme",
  "theme.title": "Theme gallery",
  "theme.hint": "A theme only changes the color palette - day or night is the choice above.",
  "theme.mode.label": "Appearance",
  "theme.mode.light": "Day",
  "theme.mode.dark": "Night",
  "theme.mode.auto": "Automatic",
  "theme.reset": "Reset to default",
  "theme.close": "Close",
  "theme.selected": "Selected",
  "theme.name.default": "Default",
  "theme.name.night": "Night blue",
  "theme.name.forest": "Forest",
  "theme.name.amber": "Amber",
  "theme.name.lilac": "Lilac",
  "theme.name.contrast": "High contrast",
  "theme.name.gray": "Soft gray",
  "theme.name.terminal": "Terminal green",
  /* === zaman:z3 - the time-zone picker (embed dialog + web settings) === */
  "tz.menu": "Time zone",
  "tz.title": "Time zone",
  "tz.label": "Show dates in",
  "tz.search": 'Search a city, country or offset - try "Istanbul" or "GMT+3"',
  "tz.default.device": "Use this device's zone ({zone})",
  "tz.default.account": "Use the account's zone ({zone})",
  "tz.default.host": "Use this site's default ({zone})",
  "tz.no_match": "No zone matches “{query}”. Try a city, a country, or an offset like GMT+3.",
  "tz.more": "{n} more - keep typing to narrow the list.",
  "tz.hint": "Saved in this browser only. Every date is stored as one moment in time and shown on the clock you pick here.",
  "tz.now": "Right now in {zone}: {time}",
  /* #275 - an embed's own language setting ("⋯" → Language), kept in this browser */
  "lang.menu": "Language",
  "lang.title": "Language",
  "lang.label": "Interface language",
  "lang.default.browser": "Browser language ({lang})",
  "lang.default.account": "Your account's language ({lang})",
  "lang.default.host": "This site's default ({lang})",
  "lang.default.default": "Default ({lang})",
  "lang.hint": "Saved in this browser only.",
  "lang.hint_account": "Saved in this browser and on your account, so your other devices and your notifications use it too.",
  /* === wiring:c2 - customizable shortcuts + quick look === */
  "shortcuts.quicklook": "Quick look",
  "shortcuts.customize": "Customize",
  "shortcuts.settings.menu": "Shortcuts",
  "shortcuts.settings.title": "Shortcut settings",
  "shortcuts.settings.hint": 'To remap a shortcut, press "Change" and then the new key combination. Changes are stored in this browser only.',
  "shortcuts.settings.change": "Change",
  "shortcuts.settings.capture": "Press keys… (Esc cancels)",
  "shortcuts.settings.reset": "Reset to default",
  "shortcuts.settings.reset_all": "Reset all",
  "shortcuts.settings.unbound": "Not set",
  "shortcuts.settings.fixed": "Fixed",
  "shortcuts.settings.customized": "Customized",
  "shortcuts.settings.conflict": 'is already used by "{name}".',
  "shortcuts.settings.conflict_fixed": 'is reserved by the fixed shortcut "{name}" - it cannot be used.',
  "shortcuts.settings.conflict_take": "Unassign old and use here",
  "shortcuts.settings.conflict_cancel": "Cancel",
  "quicklook.hint_close": "close",
  "quicklook.hint_nav": "previous/next",
  "quicklook.hint_open": "open",
  /* === /wiring:c2 === */
  /* === wiring:c3 - operations center === */
  "opc.title": "Operations",
  "opc.aria_badge": "{n} operations - toggle operations center",
  "opc.aria_badge_one": "{n} operation - toggle operations center",
  "opc.close": "Close",
  "opc.active": "In progress",
  "opc.history": "History",
  "opc.clear": "Clear",
  "opc.empty": "No operations",
  "opc.cancel": "Cancel",
  "opc.retry": "Retry",
  "opc.dismiss": "Dismiss",
  "opc.queued": "Queued",
  "opc.cancelling": "Cancel requested…",
  "opc.percent": "{n}%",
  "opc.items": "{done} of {total} items",
  "opc.trash_items": "{n} items from the trash",
  "opc.trash_items_one": "{n} item from the trash",
  "opc.status.running": "In progress",
  "opc.status.done": "Done",
  "opc.status.error": "Failed",
  "opc.status.aborted": "Cancelled",
  "opc.kind.upload": "Upload",
  "opc.kind.copy": "Copy",
  "opc.kind.move": "Move",
  "opc.kind.delete": "Delete",
  "opc.kind.rename": "Rename",
  "opc.kind.restore": "Restore",
  "opc.kind.purge": "Delete permanently",
  "opc.kind.convert": "Convert",
  "opc.kind.archive": "Archive",
  "opc.kind.plugin": "App",
  "opc.kind.trash": "Empty trash",
  "opc.kind.thumbs": "Thumbnail repair",
  /* A folder's contents on hover (FolderPeek, useFolderPeek). */
  "peek.items": "{n} items",
  "peek.items_one": "{n} item",
  "peek.more": "+{n} more",
  "peek.empty": "Empty",
  "peek.loading": "Looking inside…",
  "opc.open": "Open",
  /* App plugins - rows a WebAssembly plugin adds to the file menu, and the
     jobs they queue (docs/APP-PLUGINS-API.md). "App" is what the feature is
     called on every surface; "plugin" is the wire word. */
  "plugin.queued": "{label} queued",
  "plugin.done": "{label} finished",
  "plugin.failed": "{label} failed",
  "plugin.cancel_failed": "Could not cancel the job",
  "plugin.not_applicable": "This action does not apply to the selection",
  "plugin.needs_engine": "{name} is not installed on this server - install it and restart filex.",
  "plugin.needs_other": "{name} is not available on this server.",
  "plugin.needs_office": "Office documents need an office engine, and none runs on this server - install the Office editor app (Apps) or connect {name} under External services.",
  "plugin.confirm.title": "Confirm",
  "plugin.confirm.cancel": "Cancel",
  "plugin.confirm.run": "Run",
  "plugin.view.close": "Close",
  "appframe.confirm_title": "Confirm",
  "appframe.consent_clipboard": "{app} wants to copy text to your clipboard.",
  "appframe.consent_download": "{app} wants to save “{name}” to your computer.",
  "appframe.consent_print": "{app} wants to print “{name}”.",
  "appframe.consent_job": "{app} wants to start “{action}”.",
  "appframe.consent_allow": "Allow",
  "appframe.consent_deny": "Don’t allow",
  "appframe.unsaved_title": "Unsaved changes",
  "appframe.unsaved_text": "{app} has changes that are not saved. Close it anyway?",
  "appframe.state_no_account": "The app’s settings for an encrypted file are kept sealed for the account you are signed in as, and this page could not tell which account that is, so nothing was kept. Sign in again, or open the file where you are signed in.",
  "appframe.discard": "Close without saving",
  "appframe.keep_open": "Keep editing",
  "appframe.save_close": "Save and close",
  "appframe.updated": "{app} was updated to {version}.",
  "appframe.updated_reload": "An administrator approved a new version of {app}. Reload it to use the new version - save your work first.",
  "appframe.reload": "Reload",
  "appframe.dismiss": "Dismiss",
  "appframe.not_connected": "{app} did not start. Close it and open it again; if it keeps happening, tell your administrator.",
  "appframe.save_as_title": "{app}: save “{name}” to",
  "plugin.view.busy": "Working…",
  "plugin.view.unsupported": "This screen uses a component this version cannot draw ({type})",
  "plugin.view.error": "The app answered with an error",
  "plugin.output_missing": "The output is no longer where it was",
  /* M2 - surface components (components/plugin/nodes/*) */
  "plugin.view.loading": "Loading…",
  "plugin.view.preview_failed": "The preview could not be loaded",
  "plugin.steps.label": "Steps",
  "plugin.list.empty": "Nothing here yet",
  "plugin.list.actions": "Actions",
  /* The label on a table row's ONE action control (core RowActions.vue).
     The explorer's handle is the ⋮ glyph; a panel row's says what it is.
     Owner, 2026-09-20: "adminde 'Aksiyon' diye yazmalı". */
  "row.actions": "Actions",
  "plugin.people.placeholder": "Name or email",
  "plugin.people.placeholder_email": "Email address",
  "plugin.people.add": "Add",
  "plugin.people.remove": "Remove {name}",
  "plugin.people.invalid_email": "Enter a valid email address",
  "plugin.people.external_off": "Only people with an account can be added",
  "plugin.pin.label": "PIN",
  "plugin.file.choose": "Choose…",
  "plugin.file.clear": "Clear",
  "plugin.file.none": "Nothing chosen",
  /* M3 - the sign track: signature-pad + pdf-fields nodes, and the outside
     participant's public page (views/PublicSurface.vue via usePublicPage). */
  "plugin.sig.mode_draw": "Draw",
  "plugin.sig.mode_type": "Type",
  "plugin.sig.mode_upload": "Upload",
  "plugin.sig.draw_hint": "Sign here with your finger or mouse",
  "plugin.sig.type_placeholder": "Type your name",
  "plugin.sig.upload_pick": "Choose a picture…",
  "plugin.sig.upload_hint": "PNG or JPEG, at most {kb} KB",
  "plugin.sig.upload_too_big": "The picture is larger than {kb} KB",
  "plugin.sig.upload_bad_type": "Only PNG or JPEG pictures can be used",
  "plugin.sig.upload_unreadable": "The picture could not be read",
  "plugin.sig.clear": "Clear signature",
  "plugin.sig.signed": "Signature captured",
  "plugin.pdf.load_failed": "The document could not be loaded",
  "plugin.pdf.palette": "Field types",
  "plugin.pdf.pending": "Boxes waiting for a place",
  "plugin.pdf.place_box_hint": "Tap the page where “{name}” goes, or drag to size it",
  "plugin.pdf.all_placed": "Every box has a place",
  "plugin.pdf.place_idle": "Choose one of the boxes above, then tap the page where it goes.",
  "plugin.pdf.place_idle_done": "Tap a box on the page to take it off or copy it; drag it to move it.",
  "plugin.pdf.no_boxes": "No boxes yet. Add one below: give it a name, say whose it is, and place it on the document in the next step.",
  "plugin.pdf.add_box": "Add a box",
  "plugin.pdf.unplace": "Take off the page",
  "plugin.pdf.place_hint": "Tap the page where the {type} field goes, or drag to size it",
  "plugin.pdf.type_signature": "Signature",
  "plugin.pdf.type_initials": "Initials",
  "plugin.pdf.type_date": "Date",
  "plugin.pdf.type_text": "Text",
  "plugin.pdf.type_checkbox": "Checkbox",
  "plugin.pdf.tap_signature": "Tap to sign",
  "plugin.pdf.tap_initials": "Tap to initial",
  "plugin.pdf.tap_date": "Tap for today",
  "plugin.pdf.tap_text": "Text",
  "plugin.pdf.tap_checkbox": "Tap to tick",
  "plugin.pdf.label": "Name",
  "plugin.pdf.assignee": "Signer",
  "plugin.pdf.unassigned": "Anyone",
  "plugin.pdf.filled_by": "Filled by",
  "plugin.pdf.style": "How it is signed",
  "plugin.pdf.style_drawn": "Drawn",
  "plugin.pdf.style_typed": "Typed",
  "plugin.pdf.lines": "Printed under it",
  "plugin.pdf.lines_preview": "Under the signature:",
  "plugin.pdf.lines_none": "Nothing is printed under this signature.",
  "plugin.pdf.required": "Required",
  "plugin.pdf.copy_to_page": "Copy to page",
  "plugin.pdf.copy": "Copy",
  "plugin.pdf.delete": "Delete field",
  "plugin.pdf.zoom_in": "Zoom in",
  "plugin.pdf.zoom_out": "Zoom out",
  "plugin.pdf.zoom_fit": "Fit to width",
  "plugin.pdf.zoom_fit_page": "Fit the page to the screen",
  "plugin.pdf.pad_for": "Your {type}",
  "plugin.pdf.pad_done": "Done",
  "plugin.page.loading": "Loading…",
  "plugin.page.pin_title": "This page is protected",
  "plugin.page.pin_hint": "Enter the PIN you were given to continue",
  "plugin.page.pin_submit": "Continue",
  "plugin.page.pin_wrong": "That PIN is not right",
  "plugin.page.pin_locked": "Too many wrong PINs - wait a few minutes and try again",
  "plugin.page.unavailable_title": "This link is not available",
  "plugin.page.unavailable_text": "It may have expired, been used up or been withdrawn. Ask the person who sent it for a new one.",
  "plugin.page.accepted_title": "Received, thank you",
  "plugin.page.accepted_text": "Your answer has been recorded. You can close this page.",
  "plugin.page.done_title": "All done",
  "plugin.page.done_text": "There is nothing more to do here. You can close this page.",
  "plugin.page.error_title": "Something went wrong",
  "plugin.page.retry": "Try again",
  "plugin.page.files": "Documents",
  "plugin.page.open_file": "Open {name} in a new tab",
  "plugin.page.footer": "Served by filex",
  /* The public pages' own sentences (share, file request) are the SERVER's
     `server.public.*` (composables/usePublicText) - not keys of this file. */
  /* === App plugins v2 - a `page` view, an app's lock on a file, the output
     mode a job wrote in, and the faces + rules a signature field carries. === */
  "plugin.page_view.back": "Back to the files",
  "plugin.page_view.queued_title": "The job is queued",
  "plugin.page_view.queued_text": "filex is working on it. This page says when it is done, and its progress is in the operations tray too.",
  "plugin.page_view.finished_title": "The job is done",
  "plugin.page_view.finished_text": "There is nothing more to do here. You can go back to the files or close this tab.",
  "plugin.page_view.failed_title": "The job did not finish",
  "plugin.page_view.opening_title": "Opening the result",
  "plugin.page_view.open_ops": "Open the operations tray",
  "plugin.page_view.done_title": "All done",
  "plugin.page_view.done_text": "There is nothing more to do here. You can close this tab.",
  "plugin.page_view.error_title": "This screen could not be opened",
  "plugin.page_view.retry": "Try again",
  "plugin.page_view.blocked": "The new tab was blocked - allow pop-ups for this site, or the screen will open in a dialog",
  "plugin.output.sibling": "new file",
  "plugin.output.version": "new version",
  "plugin.output.sibling_title": "The result lands as a new file beside the original",
  "plugin.output.version_title": "The result replaces the file as a new version of it",
  "plugin.sign.font_label": "Handwriting",
  "plugin.pdf.font": "Font",
  "plugin.pdf.rule_number": "Numbers only",
  "plugin.pdf.rule_email": "Email address",
  "plugin.pdf.rule_length": "Between {min} and {max} characters",
  "plugin.pdf.rule_min": "At least {min} characters",
  "plugin.pdf.rule_max": "At most {max} characters",
  "plugin.pdf.err_number": "Enter a number",
  "plugin.pdf.err_email": "Enter a valid email address",
  "plugin.pdf.err_min": "Too short - at least {min} characters",
  "plugin.pdf.err_max": "Too long - at most {max} characters",
  "applock.badge": "Locked",
  "applock.some_app": "an app",
  "applock.held": "{app} locked this file",
  "applock.held_reason": "{app} locked this file: {reason}",
  "applock.until": "- until {date}",
  "applock.inspector": "Held by an app",
  /* issue #34 - a symlink the server will NOT follow (lib/symlink). The badge
     is the short word on the row; `why` is the sentence behind it, shown on
     hover, in the details panel and in the toast when somebody tries to open
     one. ⚠ Broken and outside-of-root are DIFFERENT states and must read
     differently: only one has an administrator remedy, and offering that
     remedy for a target that has been deleted sends the person to a settings
     screen that cannot help them. */
  "symlink.badge.outside_root": "Outside storage",
  "symlink.badge.broken": "Broken link",
  "symlink.badge.unresolved": "Remote link",
  "symlink.badge.unknown": "Link",
  "symlink.why.outside_root": `A link whose target lies outside this storage, which is why it cannot be opened. An administrator can allow it with "Follow symlinks that leave this folder" in the storage's settings.`,
  "symlink.why.broken": "A link whose target no longer exists, so there is nothing to open. It has to be repaired or removed on the server - no setting can bring the target back.",
  "symlink.why.unresolved": "A link on a remote server. filex cannot tell whether its target is inside this storage, so it does not follow it and cannot open it.",
  "symlink.why.unknown": "A link filex will not follow, so it cannot be opened. Its target is either outside this storage, missing, or on a remote server filex cannot resolve.",
  "symlink.inspector": "A link that cannot be opened",
  /* Issue #104 - an entry the storage could not answer for (lib/unavailable).
     The sentence says what it means and what happens next; the storage's own
     answer follows it ({reason}), usually in English. */
  "unavailable.why.file": "The storage could not say whether this file still exists. It cannot be opened or changed until the storage answers for it again; the next scan checks.",
  "unavailable.why.dir": "The storage could not say whether this folder still exists. Neither the folder nor anything inside it can be opened or changed until the storage answers for it again; the next scan checks.",
  "unavailable.withReason": "{why} The storage answered: {reason}",
  "unavailable.inspector": "Unavailable",
  /* 0.50 - why a file has no thumbnail, on the file itself (lib/thumbNote):
     the marker's name and the sentence a resting pointer or a tap shows. */
  "thumbNote.corrupt": "Damaged",
  "thumbNote.corrupt_why": "No thumbnail: the file could not be read. It may be damaged or incomplete.",
  "thumbNote.encrypted": "Encrypted",
  "thumbNote.encrypted_why": "No thumbnail: the file is encrypted or protected by a password.",
  "thumbNote.too_large": "Too large",
  "thumbNote.too_large_why": "No thumbnail: the file is larger than the thumbnail size limit.",
  "thumbNote.full": "{label}. {why}",
  "plugin.pdf.rule": "Accepts",
  "plugin.pdf.rule_kind_any": "Any text",
  "plugin.pdf.rule_kind_number": "Numbers only",
  "plugin.pdf.rule_kind_email": "Email address",
  "plugin.pdf.rule_min_label": "Min length",
  "plugin.pdf.rule_max_label": "Max length",
  "plugin.pdf.format": "Date layout",
  "plugin.pdf.date_order": "Date order",
  "plugin.pdf.date_separator": "Separator",
  "plugin.pdf.date_example": "Example",
  "opc.kind.archive-create": "Creating archive",
  "opc.kind.archive-extract": "Extracting archive",
  /* === wiring:c4 - onboarding tour + accessibility + error card === */
  "tour.aria": "Onboarding tour",
  "tour.restart": "Restart the tour",
  "tour.skip": "Skip tour",
  "tour.back": "Back",
  "tour.next": "Next",
  "tour.done": "Done",
  "tour.progress": "{n} / {m}",
  "tour.step.nav.title": "Storages & views",
  "tour.step.nav.desc": "Home, Shared with me, Recent, Starred and Trash are always in this panel, with your storages and connections underneath. The button in the top-left corner collapses it to a rail and brings it back.",
  "tour.step.nav.desc_closed": "This button opens the navigation panel: Home, Shared with me, Recent, Starred and Trash, with your storages and connections underneath.",
  "tour.step.new.title": "Add something",
  "tour.step.new.desc": "Everything new starts here - upload from this device, create a folder, or ask somebody else for a file. Dropping files onto the window uploads them as well.",
  "tour.step.new.desc_fab": "This button uploads files from this device. Dropping files onto the window works as well.",
  "tour.step.search.title": "Search",
  "tour.step.search.desc": 'This field searches the whole storage by name - separators and one typo are forgiven, so "invoice 2026" finds invoice_2026.pdf. Add tag:invoice to filter by tag. The sliders button opens advanced search, and {palette} opens the command palette, which runs commands too.',
  "tour.step.crumb.title": "Where you are",
  "tour.step.crumb.desc": "This trail is the address of the folder on screen. Click any step to go back up, and the chevron beside the last one lists the folders inside it.",
  "tour.step.filters.title": "Narrow the list",
  "tour.step.filters.desc": "Type, Owner, Modified and Size filter the folder you are in, the box beside them matches names as you type, and the control at the end of the row sorts.",
  "tour.step.view.title": "Switch views",
  "tour.step.view.desc": "Change how this folder is drawn; your choice is remembered.",
  "tour.step.details.title": "Details & sharing",
  "tour.step.details.desc": 'Select a file and open this panel for its details, its activity and its share links. For the full menu, right-click the file or use the button at the end of its row - "Share" there creates a link with an optional PIN and expiry.',
  "tour.step.help.title": "Shortcuts",
  "tour.step.help.desc": 'Press {help} for the shortcut cheat-sheet and {palette} for the command palette. Theme and "Restart the tour" are in the "More actions" menu at the top right; your account and sign-out are behind the avatar beside it.',
  "error.hint": "This may be a temporary network or server problem. Please try again.",
  "error.details": "Technical details",
  "col.star": "Star",
  "toolbar.view_label": "View",
  "list.aria": "File list",
  "grid.aria": "File grid",
  /* === wiring:d1 - tabs + split pane === */
  "tabs.strip": "Tabs",
  "tabs.new": "New tab",
  "tabs.close": "Close tab",
  "tabs.split": "Split view",
  "tabs.split_off": "Close split",
  "ctx.open_new_tab": "Open in new tab",
  "ctx.open_with": "Open with {app}",
  "ctx.open_with_builtin": "Open with the built-in viewer",
  "ctx.open_with_choose": "Choose an app…",
  "openWith.title": "Open with",
  "openWith.lead": "Which app should open {name}?",
  "openWith.builtin": "filex viewer (built-in)",
  "openWith.onlyoffice": "ONLYOFFICE (spreadsheet editor)",
  "openWith.now": "Opens it now",
  "openWith.always": "Always use this app for {ext} files",
  "openWith.hint": "Kept on your account. You can change it in Settings, Default apps.",
  "openWith.open": "Open",
  "shortcuts.group.tabs": "Tabs",
  "shortcuts.tab_new": "New tab",
  "shortcuts.tab_close": "Close tab",
  "shortcuts.tab_next": "Next tab",
  "shortcuts.tab_prev": "Previous tab",
  /* tus:t1 - the menu verbs */
  "shortcuts.new_folder": "New folder",
  "shortcuts.upload": "Upload files",
  "shortcuts.refresh": "Refresh the listing",
  "shortcuts.download": "Download",
  "shortcuts.preview": "Preview",
  "shortcuts.share": "Share",
  "shortcuts.tags": "Tags",
  "shortcuts.open_tab": "Open in a new tab",
  "shortcuts.copy_path": "Copy path",
  "shortcuts.copy_id": "Copy id",
  "shortcuts.restore": "Restore from trash",
  "shortcuts.settings.reserved": "is taken by the browser before the page sees it, so it would do nothing here. Pick another key.",
  "shortcuts.settings.reserved_badge": "Desktop app only",
  "shortcuts.settings.reserved_title": "The browser handles this combination itself. It fires in the desktop app and in an installed PWA, not in a browser tab.",
  "cmd.tab_new": "Open a new tab",
  "cmd.split_toggle": "Toggle split view",
  "split.pane": "Secondary pane",
  "split.close": "Close the side pane",
  "split.error": "Could not load the listing",
  "split.retry": "Retry",
  "split.copy_queued": "Copy queued",
  "split.move_queued": "Move queued",
  "toast.move_kept_both": "Move queued. A name was already taken there, so that item will be kept beside the existing one with “-copy” added. This move cannot be undone.",
  "split.cross_copy": "Different storages - copy queued instead",
  "dragout.downloading": "Downloading into the folder you dropped on…",
  "dragout.downloading_n": "Downloading into the folder you dropped on - {n} files so far…",
  "dragout.downloading_n_one": "Downloading into the folder you dropped on - {n} file so far…",
  "dragout.stop": "Stop",
  "dragout.stopping": "Stopping…",
  "dragout.stopped": "Stopped - what had arrived stays in the folder",
  "dragout.not_found": "Could not find where it was dropped - a drop onto an application (rather than a folder) cannot be filled in",
  "dragout.done": "Download finished",
  "dragout.ready": "Files are ready - drag them to your desktop",
  "dragout.preparing": "Getting them ready to drag…",
  "split.cross_move": "Different storages - move queued (bytes travel, then the original is removed)",
  /* === /wiring:d1 === */
  /* wiring:d2 - gallery view */
  "toolbar.view.gallery": "Gallery",
  "gallery.aria": "File gallery",
  /* /wiring:d2 */
  /* wiring:d3 - inspector node comments */
  "inspector.section.comments": "Comments",
  "inspector.comments.empty": "No comments yet.",
  "inspector.comments.placeholder": "Write a comment…",
  "inspector.comments.send": "Send",
  "inspector.comments.delete": "Delete comment",
  /* wiring:e2 - end-to-end encrypted folders */
  "e2e.create.title": "Create encrypted folder",
  "e2e.create.option": "Create encrypted folder…",
  "e2e.create.pw_label": "Folder password",
  "e2e.create.pw_placeholder": "At least 8 characters",
  "e2e.create.pw2_label": "Repeat the password",
  "e2e.create.warn_title": "NO WAY BACK",
  "e2e.create.warn_body": "Files in this folder can only be opened with this password or the recovery key shown once when the folder is created. The password is NEVER stored on the server, and filex keeps no copy of the recovery key either. Lose both and the contents are gone for good.",
  "e2e.create.ack": "I understand: if I lose both the password and the recovery key, my data cannot be recovered.",
  "e2e.create.ack_required": "Please confirm the warning to continue.",
  "e2e.create.pw_short": "Password must be at least 8 characters.",
  "e2e.create.pw_mismatch": "Passwords do not match.",
  "e2e.create.bad_name": "Invalid folder name.",
  "e2e.create.create": "Create encrypted folder",
  "e2e.create.busy": "Creating…",
  "e2e.create.done": "Encrypted folder created",
  "e2e.create.failed": "Could not create the encrypted folder",
  "e2e.create.nested": "You cannot create an encrypted folder inside another one.",
  /* wiring:e2 policy - asking an administrator to allow one encryption
     (E2eRequestModal), where the tenant's policy wants an approval first. */
  "e2e.request.ctx": "Request encryption…",
  "e2e.request.option": "Request an encrypted folder…",
  "e2e.request.title": "Request encryption for “{name}”",
  "e2e.request.lead": "Making an encrypted folder here needs an administrator’s approval. Say why you need it; you will be told the answer. An approval is for you and this folder: it can be used once, to make one new encrypted folder directly inside it.",
  "e2e.request.lead_folder": "Encrypting this folder needs an administrator’s approval. Say why you need it; you will be told the answer. An approval is for you and this folder: it can be used once, to encrypt this folder where it is, and not a folder inside it.",
  "e2e.request.lead_file": "Encrypting this file needs an administrator’s approval. Say why you need it; you will be told the answer. An approval is for you and the folder this file is in: it can be used once, for one new encrypted file there.",
  "e2e.request.reason": "Reason",
  "e2e.request.reason_placeholder": "What it holds, and why it must be encrypted",
  "e2e.request.reason_required": "Write a reason for the administrator.",
  "e2e.request.send": "Send request",
  "e2e.request.sending": "Sending…",
  "e2e.request.sent": "Request sent. You will be notified when an administrator answers.",
  "e2e.request.already": "You already asked for this; it is waiting for an administrator.",
  "e2e.request.failed": "The request could not be sent.",
  "e2e.locked.title": "This folder is end-to-end encrypted",
  "e2e.locked.hint": "Enter the folder password to see its contents. The password stays in this tab’s memory only.",
  "e2e.locked.pw_placeholder": "Folder password",
  "e2e.locked.unlock": "Unlock",
  "e2e.locked.busy": "Verifying…",
  "e2e.unlock.wrong": "Wrong password.",
  "e2e.unlock.damaged": "The password is right, but the folder key in the key file (.filex-e2e.json) does not open: the file is damaged. Try the recovery key.",
  "e2e.unlock.marker_missing": "Could not read the key file (.filex-e2e.json).",
  /* ikon:emoji - the listing marker's accessible name. The row used to print
     a 🔒 and nothing else; the padlock that replaced it is aria-hidden inside
     the tile, so the span that carries it says this instead. */
  "e2e.badge": "Encrypted folder",
  "e2e.strip.label": "Encrypted folder - unlocked",
  "e2e.strip.lock": "Lock",
  /* wiring:e2 password - changing a folder's password */
  "e2e.password.strip_action": "Change password…",
  "e2e.password.title": "Change the folder password",
  "e2e.password.reset_title": "Set a new password for this folder",
  "e2e.password.reset_lead": "You opened this folder with its recovery key, so its password was lost or may be known to someone. Set a new one now. Closing this dialog locks the folder again.",
  "e2e.password.current": "Current password",
  "e2e.password.recovery": "Recovery key",
  "e2e.password.use_recovery": "I do not remember it - use the recovery key",
  "e2e.password.use_current": "Use the current password instead",
  "e2e.password.new": "New password",
  "e2e.password.current_required": "Enter the current password, or use the recovery key.",
  "e2e.password.bad_recovery": "That is not a recovery key (32 characters, in groups of four).",
  "e2e.password.same": "The new password is the same as the current one.",
  "e2e.password.cheap_note": "Only the folder’s key file changes. No file is re-encrypted, and the recovery key and any escrow key keep working.",
  "e2e.password.old_copies": "Someone who knows the old password and has an old copy of the key file (a version, a backup) can still open the folder with it. If that is a risk, tick “Also replace the folder key”.",
  "e2e.password.rotate_label": "Also replace the folder key (re-wraps every file’s key; use this if the old password may be known)",
  "e2e.password.rekey_title": "This folder is from before v0.31: its key comes from its password",
  "e2e.password.rekey_body": "A new password therefore needs a new folder key, and the key of every file in the folder is re-wrapped under it. The contents are not re-encrypted. It can take a while, and if it is interrupted it continues where it stopped; the files open throughout.",
  "e2e.password.rotate_title": "The folder key is replaced too",
  "e2e.password.rotate_body": "Every file’s key is re-wrapped under a new folder key. The contents are not re-encrypted. If it is interrupted it continues where it stopped; the files open throughout.",
  "e2e.password.rekey_rk_new": "You get a new recovery key, shown once; the old one stops working.",
  "e2e.password.rekey_rk_kept": "The recovery key you used keeps working.",
  "e2e.password.rekey_escrow": "The operator’s escrow key keeps working: its slot is sealed to the new folder key.",
  "e2e.password.rekey_ack": "I understand: this re-wraps the key of every file in the folder.",
  "e2e.password.submit": "Change password",
  "e2e.password.busy": "Changing…",
  "e2e.password.lock_instead": "Lock the folder instead",
  "e2e.password.wrong_current": "Wrong password.",
  "e2e.password.wrong_recovery": "Wrong recovery key.",
  "e2e.password.escrow_blocked": "This folder has an escrow slot for a key this installation does not have, and replacing the folder key would lose it. Nothing was changed.",
  "e2e.password.failed": "Could not change the password. Nothing was changed.",
  "e2e.password.done": "Password changed. The old password no longer opens this folder.",
  "e2e.password.resume_title": "File keys are still being re-wrapped",
  "e2e.password.resume_body": "The password was changed and a new folder key issued. Some files still have their key under the previous one; they open either way. Continue to finish.",
  "e2e.password.progress": "{n} files re-wrapped so far · {failed} failed",
  "e2e.password.progress_one": "{n} file re-wrapped so far · {failed} failed",
  "e2e.password.rekey_partial": "{n} files could not be re-wrapped. They still open with the previous key; continue to try again.",
  "e2e.password.rekey_partial_one": "{n} file could not be re-wrapped. It still opens with the previous key; continue to try again.",
  "e2e.password.rekey_done": "New folder key in place ({n} files re-wrapped). The old password opens nothing here any more.",
  "e2e.password.rekey_done_one": "New folder key in place ({n} file re-wrapped). The old password opens nothing here any more.",
  "e2e.recovery.lead_replaced": "The folder has a new key, so it has a new recovery key too - the old one no longer opens it. Shown once; filex keeps no copy.",
  /* wiring:e2 names - encrypted file and folder names */
  "e2e.unlock.unsupported": "This folder needs a newer filex: it uses {features}, which this version does not understand. Nothing was changed.",
  "e2e.settings.open": "Encryption settings…",
  "e2e.settings.title": "Encryption settings",
  "e2e.settings.level": "Encryption level",
  "e2e.settings.password": "Password",
  "e2e.settings.escrow": "Escrow key",
  "e2e.settings.close": "Close",
  "e2e.level.content": "Contents only",
  "e2e.level.names": "Contents and names",
  "e2e.level.content_hint": "File contents are encrypted. File and folder names stay readable to the server, so WebDAV, the command line and desktop sync keep working with them, and every filex since 0.31 opens the folder.",
  "e2e.level.names_hint": "Contents and file and folder names are encrypted: the server sees only scrambled names. WebDAV, the command line and desktop sync see them scrambled too, and filex 0.47 and older will not open the folder.",
  "e2e.level.pending": "the change of level has not finished",
  "e2e.level.change": "Change level…",
  "e2e.level.raise_title": "Move this folder to “Contents and names”?",
  "e2e.level.raise_body": "filex gives every file and folder in here an encrypted name, in this browser. The contents are not touched, and if it is interrupted it continues where it stopped. filex does not offer the way back to readable names.",
  "e2e.level.raise_ack": "I understand what changes",
  "e2e.level.raise_go": "Encrypt the names",
  /* wiring:e2 vault - level 3, the vault (docs/E2E-VAULT-FORMAT.md) */
  "e2e.level.vault": "Vault",
  "e2e.level.vault_hint": "Contents, names and the whole tree are encrypted: the server keeps only packs of one size, and does not see how many files there are, their names, their sizes or their dates.",
  "e2e.level.vault_cost": "What it costs: one person writes at a time, and only filex opens it (the web app, the desktop app, filex decrypt and filex vault mount). WebDAV, folder sync, share links and previews on the server do not reach inside.",
  "e2e.vault.pack_label": "Pack size",
  "e2e.vault.pack_4": "4 MiB",
  "e2e.vault.pack_4_help": "The default. The smallest change uploads 4 MiB.",
  "e2e.vault.pack_16": "16 MiB",
  "e2e.vault.pack_16_help": "Fewer, larger files on the server. Every change uploads at least 16 MiB.",
  "e2e.vault.pack_hint": "Chosen now and never again. Every pack on the server is this size, and what it does not use is filled with random bytes.",
  "e2e.vault.read_only": "Read-only. An upload, a new folder or any other change takes the write lock, when nobody else holds it.",
  "e2e.vault.writing": "You are writing to this vault. If you do nothing for {left}, it goes back to read-only.",
  "e2e.vault.lock_countdown": "If nothing is done in it for {left}, the vault locks and asks for the password again.",
  "e2e.vault.held_by": "{name} has been writing since {since}. The vault is read-only for you.",
  "e2e.vault.someone": "Someone",
  "e2e.vault.take_over": "Take over",
  "e2e.vault.lost_idle": "You did nothing for {n} minutes, so this vault went back to read-only. Nothing was lost.",
  "e2e.vault.lost_idle_one": "You did nothing for {n} minute, so this vault went back to read-only. Nothing was lost.",
  "e2e.vault.lost_taken": "Someone else took over writing. What you saved stays; the vault is read-only for you.",
  "e2e.vault.lost_taken_by": "{name} took over writing. What you saved stays; the vault is read-only for you.",
  "e2e.vault.lost_broken_by": "{name} ended your write lock. What you saved stays; the vault is read-only for you.",
  "e2e.vault.lost_connection": "The connection was lost, so this vault went back to read-only.",
  "e2e.vault.lost_expired": "The write lock ran out, so this vault went back to read-only.",
  "e2e.vault.unsaved": "Not saved: {names}. Do it again when the vault is free.",
  "e2e.vault.saving": "Saving…",
  "e2e.vault.saving_progress": "Saving: {done} of {total}",
  "e2e.vault.dismiss": "OK",
  "e2e.vault.continue": "Continue from this state",
  "e2e.vault.ro_damaged": "The newest state of this vault is damaged. You are looking at the one from {when}, read-only.",
  "e2e.vault.ro_damaged_short": "The newest state of this vault is damaged. You are looking at an older one, read-only.",
  "e2e.vault.ro_rollback": "The server offers an older state of this vault than this tab has already seen. It stays read-only here.",
  "e2e.vault.ro_newer": "A newer filex wrote this vault. This version reads it and does not change it.",
  "e2e.vault.unreadable": "No state of this vault can be read: nothing can be shown, and nothing is written.",
  "e2e.vault.limit_warn": "This vault holds {held} of at most {max} files and folders.",
  "e2e.vault.cross": "Nothing moves between a vault and the folders outside it on the server: download it from one, then upload it into the other.",
  "e2e.vault.dl_too_big": "This browser cannot save a file this large from memory. Use a browser that saves straight to disk (Chrome, Edge), or filex decrypt.",
  "e2e.vault.damaged_file": "This file is damaged in the vault and could not be read.",
  "e2e.vault.level_fixed": "A vault stays a vault: its level does not change and its key is not replaced. To start again with a new key, make a new vault and move the files into it.",
  "e2e.vault.locked_idle_toast": "Nothing was done in “{name}” for 15 minutes, so the vault locked itself. Enter the password to open it again.",
  "e2e.vault.open_failed": "The vault could not be opened.",
  "e2e.vault.err.parent_missing": "The folder it was going into is not there any more.",
  "e2e.vault.err.parent_not_folder": "“{name}” is a file, not a folder.",
  "e2e.vault.err.name_taken": "“{name}” is already taken there.",
  "e2e.vault.err.bad_name": "“{name}” cannot be a name in a vault: 1 to 255 bytes, without slashes or control characters, and not . or ..",
  "e2e.vault.err.too_deep": "Folders in a vault go at most 256 deep.",
  "e2e.vault.err.not_found": "“{name}” is not in the vault any more.",
  "e2e.vault.err.is_folder": "“{name}” is a folder.",
  "e2e.vault.err.into_itself": "A folder cannot go into itself.",
  "e2e.vault.err.too_many_entries": "This vault is full: it holds at most 250 000 files and folders. Nothing was changed.",
  "e2e.vault.err.index_too_large": "This vault's index has reached its limit. Nothing was changed.",
  "e2e.vault.err.newer_format": "A newer filex wrote this vault. This version reads it and does not change it.",
  "e2e.vault.err.size_mismatch": "A file changed while it was being uploaded. Upload it again.",
  "e2e.vault.err.changed": "“{name}” changed in the vault since it was opened, so it was not saved over. Open it again to see the newer version.",
  "e2e.vault.err.failed": "The change could not be saved.",
  "userSettings.vault.idle": "Vault: back to read-only after",
  "userSettings.vault.idle_help": "How long a vault you write to stays yours while you do nothing in it. Then others may write; your vault goes back to read-only, and 15 minutes later it locks.",
  "userSettings.vault.minutes": "{n} minutes",
  "userSettings.vault.minutes_one": "{n} minute",
  "userSettings.vault.saved": "Saved",
  "userSettings.vault.failed": "Could not save the vault setting.",
  "e2e.names.move_unreadable": "Not moved: the name of one of the items cannot be read.",
  "e2e.names.move_taken": "Not moved: “{name}” is already taken in that folder. Rename one of the two first.",
  "e2e.convert.ctx": "Encrypt with E2EE…",
  "e2e.convert.title": "Encrypt “{name}”",
  "e2e.convert.lead": "Every file in this folder is encrypted where it is, in this browser, with the password below. Nothing moves; at level 1 the names stay as they are. If it is interrupted, opening the folder again continues it.",
  "e2e.convert.past_title": "What the server already has",
  "e2e.convert.past_body": "Encrypting protects these files from now on. Until now the server has had them in the clear, and some copies remain: filex drops its thumbnails and the text it extracted for search, and can delete older versions and trash entries from this folder.",
  "e2e.convert.drop_versions": "Delete the older versions of these files (they are plaintext)",
  "e2e.convert.drop_trash": "Delete the trash entries that came from this folder",
  "e2e.convert.past_outside": "Backups, replicas and copies anyone already made are outside filex and stay as they are.",
  "e2e.convert.submit": "Encrypt folder",
  "e2e.convert.nested": "This folder holds an encrypted folder. Encrypted folders cannot be nested, so nothing was changed.",
  "e2e.convert.failed": "The folder could not be encrypted. Files already encrypted stay so; open the folder to continue.",
  "e2e.convert.stopped": "Stopped after {n} files. Continue from the strip above the folder.",
  "e2e.convert.stopped_one": "Stopped after {n} file. Continue from the strip above the folder.",
  "e2e.convert.partial": "{n} files could not be encrypted (changed meanwhile, too large, or not writable). They are still plaintext; try again to continue.",
  "e2e.convert.partial_one": "{n} file could not be encrypted (changed meanwhile, too large, or not writable). It is still plaintext; try again to continue.",
  "e2e.convert.too_large_here": "{n} files are too large for this browser to send in one piece, and this server takes no upload in pieces, so they could not be encrypted where they are. They are still plaintext, and the folder stays unfinished until they are encrypted.",
  "e2e.convert.too_large_here_one": "{n} file is too large for this browser to send in one piece, and this server takes no upload in pieces, so it could not be encrypted where it is. It is still plaintext, and the folder stays unfinished until it is encrypted.",
  "e2e.convert.large_progress": "Encrypting “{name}”: {percent}%",
  "e2e.convert.busy": "Encrypting the folder…",
  "e2e.convert.resume_title": "Finish encrypting this folder",
  "e2e.convert.resume_body": "Encrypting this folder started and did not finish. Files it has not reached yet are still plaintext on the server. Continuing picks up where it stopped.",
  "e2e.convert.progress": "{n} of {total} files encrypted · {failed} not done",
  "e2e.convert.progress_one": "{n} of {total} files encrypted · {failed} not done",
  "e2e.convert.done": "Folder encrypted ({n} files). Old versions deleted: {versions}; trash entries deleted: {trash}.",
  "e2e.convert.done_one": "Folder encrypted ({n} file). Old versions deleted: {versions}; trash entries deleted: {trash}.",
  "e2e.convert.cleanup_failed": "The folder is encrypted, but its old versions and trash entries could not be deleted - only the folder’s owner or an administrator can.",
  "e2e.names.locked_item": "🔒 Encrypted item",
  "e2e.names.unreadable_item": "🔒 Unreadable name",
  "e2e.names.key_failed": "The key file says the names in this folder are encrypted, but their key does not open with this one. Nothing was changed.",
  "e2e.names.write_failed": "Could not write the name file of a long name, so nothing was uploaded.",
  "e2e.names.bad_name": "“{name}” cannot be used in an encrypted folder: a name must be 1-255 bytes, with no slash, backslash or control character.",
  "e2e.names.offer_cost": "What changes: WebDAV, the command line and desktop sync will see scrambled names, and filex 0.47 and older will refuse to open this folder. The server still sees how many items there are and how big they are.",
  "e2e.names.resume_title": "Finish encrypting the names",
  "e2e.names.resume_body": "Encrypting the names in this folder started and did not finish. Items it has not reached yet still have readable names. Continuing picks up where it stopped.",
  "e2e.names.resume": "Continue",
  "e2e.names.stop": "Stop",
  "e2e.names.busy": "Encrypting names…",
  "e2e.names.progress": "{n} names encrypted so far · {failed} could not be renamed",
  "e2e.names.progress_one": "{n} name encrypted so far · {failed} could not be renamed",
  "e2e.names.done": "Names encrypted ({n} items renamed). The server no longer sees them.",
  "e2e.names.done_one": "Names encrypted ({n} item renamed). The server no longer sees them.",
  "e2e.names.stopped": "Stopped after {n} names. The rest keep their readable names until you continue.",
  "e2e.names.stopped_one": "Stopped after {n} name. The rest keep their readable names until you continue.",
  "e2e.names.partial": "{n} items could not be renamed (no permission, or a name a disk cannot hold). Their names stay readable; try again to continue.",
  "e2e.names.partial_one": "{n} item could not be renamed (no permission, or a name a disk cannot hold). Its name stays readable; try again to continue.",
  "e2e.names.failed": "Could not encrypt the names. Nothing already renamed is lost; try again to continue.",
  "e2e.names.strip_fix": "Fix {n} names (readable, or moved in from outside filex)",
  "e2e.names.strip_fix_one": "Fix {n} name (readable, or moved in from outside filex)",
  "e2e.create.names_root_hint": "The folder’s own name stays readable either way - it sits in a folder that is not encrypted. Pick a name that gives nothing away.",
  "e2e.locked_toast": "Folder locked",
  "e2e.app_closed_unsaved": "The changes to “{name}” that were not saved are gone: the app closed when the folder locked.",
  "e2e.upload.locked": "Unlock the folder first",
  "e2e.decrypting": "Decrypting…",
  "e2e.decrypt_failed": "Could not decrypt the file (password changed or file corrupted).",
  /* wiring:e2 recovery - recovery keys + operator escrow */
  "e2e.create.escrow_title": "This server holds a second key",
  "e2e.create.escrow_body": "Key escrow is enabled on this installation, so its operator can open this folder without your password. Using that key notifies you. Escrow is fixed when the server is installed and cannot be turned off for a folder.",
  "e2e.locked.use_recovery": "Lost the password? Use a recovery key",
  "e2e.recovery.title": "Save your recovery key",
  "e2e.recovery.title_upgraded": "Your recovery key",
  "e2e.recovery.lead": "This key opens the folder without its password. It is shown once - filex does not store it and cannot show it again.",
  "e2e.recovery.lead_upgraded": "This folder now has a recovery key. It opens the folder without its password, is shown once, and is not stored by filex.",
  "e2e.recovery.copy": "Copy",
  "e2e.recovery.copied": "Copied",
  "e2e.recovery.download": "Download as a file",
  "e2e.recovery.warn_title": "TREAT THIS LIKE A PASSWORD",
  "e2e.recovery.warn_body": "Anyone holding this key can read the folder. Keep it somewhere separate from the password - a key stored next to the password protects you from forgetting, not from anyone else.",
  "e2e.recovery.escrow_title": "This server also holds a key",
  "e2e.recovery.escrow_body": "Key escrow is enabled here, so the operator of this installation can open this folder without your password. You are notified when that key is used.",
  "e2e.recovery.escrow_kid": "Escrow key",
  "e2e.recovery.ack": "I have saved this key somewhere safe.",
  "e2e.recovery.done": "Done",
  "e2e.recover.title": "Unlock without the password",
  "e2e.recover.none": "This folder was created before recovery keys existed, so it has none. Its password is the only way in. Unlock it with the password once and filex will offer to add a recovery key.",
  "e2e.recover.tab_recovery": "Recovery key",
  "e2e.recover.tab_escrow": "Escrow key",
  "e2e.recover.recovery_hint": "The key shown once when this folder was created.",
  "e2e.recover.recovery_placeholder": "XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX",
  "e2e.recover.escrow_warn_title": "The owner will be told",
  "e2e.recover.escrow_warn_body": "Opening a folder with the escrow key notifies its owner. Use it only when you are entitled to.",
  "e2e.recover.escrow_kid": "Escrow key",
  "e2e.recover.escrow_predates": "This installation has an escrow key, but this folder does not. It was created before escrow was turned on here, so its master key was never wrapped to the escrow identity. The escrow key will not open it. Nothing the operator can do changes that - adding a slot needs this folder’s password, which the server has never had. The folder’s owner can grant it: unlock with the password, then choose to give the operator a key. Until they do, use the password or the recovery key.",
  "e2e.recover.escrow_other_key": "This folder carries an escrow key from a DIFFERENT installation. It was created elsewhere and restored here, so this installation’s escrow key does not open it. Only the private key belonging to the escrow key it was sealed to can.",
  "e2e.recover.escrow_placeholder": "Paste the escrow private key (PKCS#8, base64 or PEM)",
  "e2e.recover.bad_format": "That does not look like a recovery key. It is 32 characters in eight groups of four.",
  "e2e.recover.escrow_required": "Paste the escrow private key.",
  "e2e.recover.wrong_recovery": "That recovery key does not open this folder.",
  "e2e.recover.wrong_escrow": "That escrow key does not open this folder. A folder created before escrow was turned on has no escrow slot until its owner grants one - until then, use the password or the recovery key.",
  "e2e.recover.bad_escrow_key": "That is not a readable private key (expected PKCS#8, base64 or PEM).",
  "e2e.recover.notify_failed": "Could not notify the folder owner, so the folder was not unlocked. Escrow use is always announced.",
  "e2e.recover.recovery_done": "Unlocked with the recovery key",
  "e2e.recover.escrow_done": "Unlocked with the escrow key - the owner has been notified",
  "e2e.recover.unlock": "Unlock",
  "e2e.recover.busy": "Unlocking…",
  "e2e.escrowoffer.title": "Give the operator a key to this folder?",
  "e2e.escrowoffer.body": "This folder was created before key escrow was turned on here, so the operator of this installation cannot open it. Right now - while your password is in memory - filex can seal this folder to the escrow key. Your files are not re-encrypted or moved; only the key file changes.",
  "e2e.escrowoffer.consequence": "What this means: the operator gains a second, permanent way into this folder, without your password. You are notified when that key is used, but that notification is an announcement rather than a control.",
  "e2e.escrowoffer.learn_more": "What escrow can and cannot do",
  "e2e.escrowoffer.password_label": "Folder password",
  "e2e.escrowoffer.password_required": "Enter the folder password.",
  "e2e.escrowoffer.wrong_password": "That is not this folder’s password.",
  "e2e.escrowoffer.accept": "Give the operator a key",
  "e2e.escrowoffer.decline": "No, keep it to myself",
  "e2e.escrowoffer.cancel": "Cancel",
  "e2e.escrowoffer.busy": "Sealing…",
  "e2e.escrowoffer.done": "The operator can now open this folder with the escrow key",
  "e2e.escrowoffer.declined_toast": "Kept to yourself. filex will not ask again for this folder.",
  "e2e.escrowoffer.decline_failed": "Could not record your answer, so filex will ask again next time. Nothing about the folder changed.",
  "e2e.escrowoffer.failed": "Could not give the operator a key to this folder",
  "e2e.escrowoffer.strip_action": "Escrow key…",
  "e2e.upgrade.title": "This folder has no recovery key",
  "e2e.upgrade.body": "It was created before recovery keys existed, so its password is the only way in. Right now - and only right now, while the password is in memory - filex can add one. Your files are not re-encrypted or moved.",
  "e2e.upgrade.escrow_note": "Note: this installation has key escrow enabled, so adding a recovery key also lets its operator open this folder without your password.",
  "e2e.upgrade.accept": "Create a recovery key",
  "e2e.upgrade.decline": "Not now",
  "e2e.upgrade.busy": "Creating…",
  "e2e.upgrade.failed": "Could not add a recovery key to this folder",
  "e2e.download.failed": "Could not download the encrypted file.",
  /* /wiring:e2 */
  /* ── connections: storage config + "how to connect" ──────────────
     `storages.*` keys are the ones the BACKEND's driver descriptors
     name (each driver package declares one next to its Init). They are
     kept identical to web/src/locales/*.json on purpose: the same
     descriptor is rendered on both surfaces, so a field that reads
     "Base path" in the admin panel and something else in the desktop
     app would be the same drift this whole mechanism exists to stop. */
  "conn.title": "Connections",
  "conn.subtitle": "How to reach {host} from your own computer: mount it, or point a client at it.",
  "conn.close": "Close",
  "conn.list.disabled": "Disabled",
  "conn.form.required": "Required",
  "conn.form.advanced": "Advanced settings",
  /* A two-button decision's own words, when the declaration did not name them. */
  "conn.form.yes": "Yes",
  "conn.form.no": "No",
  "conn.form.noFields": "This server did not describe any settings for this driver.",
  "conn.form.reveal": "Show",
  "conn.form.hide": "Hide",
  "conn.guide.protocol": "Protocol",
  "conn.guide.storage": "Storage",
  "conn.guide.allStorages": "All storages",
  "conn.guide.copy": "Copy",
  "conn.guide.copied": "Copied",
  "conn.guide.goodToKnow": "Good to know",
  "conn.guide.userPlaceholder": "your-email@example.com",
  "conn.guide.secretPlaceholder": "your-password-or-api-key",
  "conn.guide.fact.url": "Address",
  "conn.guide.fact.urlRootHint": "Every storage you can see appears as a folder under this address.",
  "conn.guide.fact.urlStorageHint": "Mounts “{storage}” directly. Drop the last segment to see every storage.",
  "conn.guide.fact.user": "Username",
  "conn.guide.fact.password": "Password",
  "conn.guide.webdav.summary": "WebDAV mounts filex as a drive: Windows Explorer, macOS Finder, Linux, rclone and Cyberduck all speak it, and every change is mirrored back into filex.",
  "conn.guide.webdav.userHint": "Your username or your email - not your display name.",
  "conn.guide.webdav.passwordHint": "Your account password, or an API key (API keys, in the navigation panel). An account with two-factor authentication MUST use an API key: Basic auth has no second-factor slot.",
  "conn.guide.webdav.win.s1": "Open File Explorer, right-click This PC and choose “Map network drive…”.",
  "conn.guide.webdav.win.s2": "Pick a drive letter and enter {url} as the folder.",
  "conn.guide.webdav.win.s3": "Tick “Connect using different credentials” and sign in with the username and password above.",
  "conn.guide.webdav.win.cmdCaption": "Command Prompt (same thing, without the wizard)",
  "conn.guide.webdav.win.limits": "Windows has three built-in limits that look exactly like filex bugs: transfers stop at ~47.7 MB, folders with about a thousand files refuse to open (“Disk is not formatted”), and the WebClient service must be restarted after changing either.",
  "conn.guide.webdav.win.regCaption": "Run as administrator, then reconnect the drive",
  "conn.guide.webdav.win.https": "HTTPS is mandatory. Windows sends Basic credentials over TLS only, and over plain http:// it silently refuses with no useful message. Do not set BasicAuthLevel to 2 - use TLS.",
  "conn.guide.webdav.win.persist": "The mapped drive does not survive a sign-out: since Windows 7 Basic credentials cannot be stored in Credential Manager, and /persistent:yes does not change that. Re-run the command from a logon script if you need it back automatically.",
  "conn.guide.webdav.win.service": "If nothing mounts at all, make sure the WebClient service is running: sc config WebClient start= auto && net start WebClient.",
  "conn.guide.webdav.mac.s1": "In Finder choose Go → Connect to Server… (⌘K).",
  "conn.guide.webdav.mac.s2": "Enter {url} and connect.",
  "conn.guide.webdav.mac.s3": "Authenticate with the username and password above.",
  "conn.guide.webdav.mac.note": "The drive appears under Locations; each storage is a top-level folder.",
  "conn.guide.webdav.linux.mountCaption": "davfs2, or the desktop file manager (GNOME Files, Dolphin)",
  "conn.guide.webdav.linux.gvfsComment": "or paste this address into GNOME Files / Dolphin",
  "conn.guide.webdav.linux.locks": "davfs2 needs locking turned off. filex keeps WebDAV locks in process memory, so they do not survive a restart and are not shared between replicas - davfs2 assumes otherwise and hangs.",
  "conn.guide.webdav.rclone.obscureCaption": "rclone stores an obscured password - run this first and paste the output below",
  "conn.guide.webdav.rclone.passPlaceholder": "<output of rclone obscure>",
  "conn.guide.webdav.rclone.useCaption": "Using it",
  "conn.guide.webdav.duck.s1": "New Bookmark → WebDAV (HTTPS).",
  "conn.guide.webdav.duck.s2": "Server {host}, port 443.",
  "conn.guide.webdav.duck.s3": "Path {path}.",
  "conn.guide.webdav.duck.s4": "Username {user}, password as above.",
  "conn.guide.webdav.note.delete": "A WebDAV delete is permanent. The web UI moves files to the filex trash; a client delete removes the object from the backing storage directly.",
  "conn.guide.webdav.note.locks": "Locks live in server memory: they do not survive a restart and are not shared between replicas. They exist to satisfy Windows and Office, not to arbitrate concurrent edits.",
  "conn.guide.webdav.note.permissions": "You see exactly what you see in the web UI. The root lists only the storages you may open, and a path outside your grants answers 404 rather than 403, so the tree never leaks what exists.",
  "conn.guide.webdav.note.http": "This server is reachable over plain http://. Windows will refuse to send your credentials at all, and every other client sends your password in the clear. Put filex behind TLS before mounting it.",
  // ── S3 endpoint: keys and the guide ──────────────────────────────
  "conn.s3keys.title": "S3 access keys",
  "conn.s3keys.lead": "An access key lets any S3 client - rclone, restic, the AWS CLI, mc, s3fs, Cyberduck - connect to filex. It carries your own permissions and nothing more.",
  "conn.s3keys.disabled": "The S3 endpoint is switched off on this server (FILEX_S3). A key minted here will not connect until an operator turns it back on.",
  "conn.s3keys.cannotMint": "You are not signed in with an account that can mint access keys. The instructions below still apply - ask for a key and paste it in.",
  "conn.s3keys.label": "What is it for? (laptop backup, CI, …)",
  "conn.s3keys.defaultLabel": "access key",
  "conn.s3keys.everyBucket": "Every bucket I can see",
  "conn.s3keys.prefix": "Folder inside the bucket (optional)",
  "conn.s3keys.mint": "Create key",
  "conn.s3keys.inheritNote": "A key can only ever narrow what you already have: your grants and your role. Confining it to one bucket or folder is the difference between a laptop backup and a credential that can read everything.",
  "conn.s3keys.once": "Copy the secret now - this is the only time it is shown.",
  "conn.s3keys.accessKeyID": "Access key ID",
  "conn.s3keys.secret": "Secret key",
  "conn.s3keys.dismiss": "I have copied it",
  "conn.s3keys.col.label": "Label",
  "conn.s3keys.col.key": "Access key ID",
  "conn.s3keys.col.scope": "Limited to",
  "conn.s3keys.col.lastUsed": "Last used",
  "conn.s3keys.scopeAll": "everything you can see",
  "conn.s3keys.noLabel": "(no label)",
  "conn.s3keys.neverUsed": "never",
  "conn.s3keys.enable": "Enable",
  "conn.s3keys.disable": "Disable",
  "conn.s3keys.revoke": "Revoke",
  "conn.s3keys.confirm": "Sure?",
  "conn.s3keys.empty": "No access keys yet.",
  "conn.guide.s3.summary": "The S3 endpoint makes filex the destination for anything that speaks S3 - backups, sync tools, SDKs - using the storages you already have.",
  "conn.guide.s3.keyPlaceholder": "create a key above",
  "conn.guide.s3.secretPlaceholder": "shown once, when you create the key",
  "conn.guide.s3.fact.endpoint": "Endpoint",
  "conn.guide.s3.fact.endpointHint": "Point the client here, not at the web address of filex.",
  "conn.guide.s3.fact.bucket": "Bucket",
  "conn.guide.s3.fact.bucketHint": "A bucket is a filex storage. Buckets are created by an administrator, not by the client.",
  "conn.guide.s3.fact.key": "Access key ID",
  "conn.guide.s3.fact.keyHint": "The public half. It travels in every request.",
  "conn.guide.s3.fact.secret": "Secret key",
  "conn.guide.s3.fact.secretHint": "Shown once, when the key is created. filex cannot show it again - create a new key if it is lost.",
  "conn.guide.s3.fact.region": "Region",
  "conn.guide.s3.fact.regionHint": "filex has no regions; any value works and is echoed back. Clients still insist on one.",
  "conn.guide.s3.fact.addressing": "Addressing",
  "conn.guide.s3.fact.pathStyle": "path-style (required)",
  "conn.guide.s3.fact.pathStyleHint": "There is no dedicated S3 host on this install, so bucket.host does not resolve.",
  "conn.guide.s3.fact.virtualHosted": "virtual-hosted or path-style",
  "conn.guide.s3.fact.virtualHostedHint": "This install has its own S3 host, so both styles work.",
  "conn.guide.s3.rclone.useCaption": "Use it",
  "conn.guide.s3.rclone.mtime": "filex carries the file modification time (x-amz-meta-mtime), so rclone sync settles after the first run instead of re-uploading everything.",
  "conn.guide.s3.aws.configureCaption": "Configure once",
  "conn.guide.s3.aws.useCaption": "Use it",
  "conn.guide.s3.aws.pathStyle": "Add path addressing to your AWS config, or every command fails at DNS.",
  "conn.guide.s3.restic.envCaption": "Environment",
  "conn.guide.s3.restic.useCaption": "Back up, verify, prune",
  "conn.guide.s3.restic.verified": "Verified against this endpoint: restic check --read-data reads every pack byte for byte and reports no errors.",
  "conn.guide.s3.mc.aliasCaption": "Add the alias",
  "conn.guide.s3.mc.useCaption": "Use it",
  "conn.guide.s3.s3fs.credsCaption": "Credentials file",
  "conn.guide.s3.s3fs.mountCaption": "Mount it",
  "conn.guide.s3.s3fs.note": "Editing a file over s3fs rewrites the whole object, and a delete goes to the filex trash. Good for a shared folder, not for a database.",
  "conn.guide.s3.duck.s1": "New bookmark → Amazon S3.",
  "conn.guide.s3.duck.s2": "Server: {host}.",
  "conn.guide.s3.duck.s3": "Access key ID: {key}, secret as above.",
  "conn.guide.s3.duck.s4": "Open the bookmark; the buckets are your filex storages.",
  "conn.guide.s3.duck.pathStyle": 'In Preferences → S3, turn OFF "Use virtual host style" - this install has no wildcard S3 host.',
  "conn.guide.s3.sdk.note": "Any SigV4 client works the same way: endpoint, key, secret, and path addressing when this install has no S3 host of its own.",
  "conn.guide.s3.note.buckets": "A bucket is a filex storage. A client can create folders and objects inside one, but not the bucket itself - that needs a driver and a path, which an S3 request cannot express.",
  "conn.guide.s3.note.permissions": 'The key sees exactly what you see. A bucket you may not open answers "no such bucket" rather than "forbidden", so the endpoint never reveals what exists.',
  "conn.guide.s3.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.s3.note.mtime": "Uploads carry their modification time, and the checksums clients send (Content-MD5, x-amz-checksum-*) are verified - a corrupted upload is refused rather than stored.",
  "conn.guide.s3.note.pathStyle": "This install has no dedicated S3 host, so clients must be told to use path-style addressing. Without it a current SDK fails at DNS with an error that names neither filex nor the cause.",
  "conn.guide.s3.note.http": "This endpoint is plain http://. Signatures still protect the request, but the objects travel in the clear. Put filex behind TLS before pointing a backup at it.",
  // ── SFTP endpoint: keys and the guide ────────────────────────────
  "conn.sshkeys.title": "SSH keys",
  "conn.sshkeys.lead": "Register a public key and every SSH client - sftp, scp, WinSCP, FileZilla, rclone, sshfs - can connect without sending your password.",
  "conn.sshkeys.disabled": "The SFTP endpoint is switched off on this server (FILEX_SFTP). A key registered here will not connect until an operator turns it back on.",
  "conn.sshkeys.cannotAdd": "You are not signed in with an account that can register keys.",
  "conn.sshkeys.paste": "Paste the contents of ~/.ssh/id_ed25519.pub",
  "conn.sshkeys.name": "Name (optional - the key comment is used otherwise)",
  "conn.sshkeys.add": "Add key",
  "conn.sshkeys.noCopyId": "ssh-copy-id cannot work here: it appends to ~/.ssh/authorized_keys over a shell, and filex has none. This box is the way in.",
  "conn.sshkeys.col.name": "Name",
  "conn.sshkeys.col.fingerprint": "Fingerprint",
  "conn.sshkeys.col.added": "Added",
  "conn.sshkeys.col.lastUsed": "Last used",
  "conn.sshkeys.noName": "(no name)",
  "conn.sshkeys.neverUsed": "never",
  "conn.sshkeys.enable": "Enable",
  "conn.sshkeys.disable": "Disable",
  "conn.sshkeys.remove": "Remove",
  "conn.sshkeys.confirm": "Sure?",
  "conn.sshkeys.empty": "No keys yet. Without one, clients sign in with your account password.",
  "conn.guide.sftp.summary": "SFTP makes filex reachable by anything that already speaks SSH - a backup job, a scanner, WinSCP, rclone, or a mounted folder.",
  "conn.guide.sftp.fact.host": "Host",
  "conn.guide.sftp.fact.hostHint": "The same machine as the web app, on a port of its own.",
  "conn.guide.sftp.fact.port": "Port",
  "conn.guide.sftp.fact.portHint": "Not 22 and not 443: SFTP is raw TCP and cannot go through the web proxy.",
  "conn.guide.sftp.fact.userHint": "Your username. An @ in it would have to be quoted in most client config files, which is what the username avoids.",
  "conn.guide.sftp.fact.auth": "Sign in with",
  "conn.guide.sftp.fact.authKey": "your registered SSH key (or your password)",
  "conn.guide.sftp.fact.authPassword": "your account password - or register a key above",
  "conn.guide.sftp.fact.authHint": "An API key works as a password too, and is revocable on its own. An account with two-factor sign-in must use an SSH key or an API key.",
  "conn.guide.sftp.fact.path": "Path",
  "conn.guide.sftp.fact.pathHint": "The first folder is a storage; the root lists the ones you may open.",
  "conn.guide.sftp.openssh.connectCaption": "Connect, put, get",
  "conn.guide.sftp.openssh.noShell": "There is no shell here - only the SFTP subsystem. `ssh host command` is refused on purpose, and scp works because OpenSSH 9 speaks SFTP for it.",
  "conn.guide.sftp.key.tab": "Set up a key",
  "conn.guide.sftp.key.s1": "Generate a key pair on the machine that will connect (skip if you already have one).",
  "conn.guide.sftp.key.s2": "Copy the PUBLIC half - the .pub file, never the other one.",
  "conn.guide.sftp.key.s3": "Paste it into the box above and connect; no password is sent from then on.",
  "conn.guide.sftp.key.genCaption": "On your own machine",
  "conn.guide.sftp.key.noCopyId": "ssh-copy-id will NOT work against filex: it needs a shell to append to ~/.ssh/authorized_keys, and there is none. Paste the key above instead.",
  "conn.guide.sftp.winscp.s1": "New site → File protocol: SFTP.",
  "conn.guide.sftp.winscp.s2": "Host name: {host}, port: {port}.",
  "conn.guide.sftp.winscp.s3": "User name: {user}. For a key: Advanced → SSH → Authentication → private key file.",
  "conn.guide.sftp.winscp.s4": "WinSCP needs a .ppk private key - use its own tool (Tools → PuTTYgen) to convert an OpenSSH key once.",
  "conn.guide.sftp.filezilla.s1": "File → Site Manager → New site, Protocol: SFTP.",
  "conn.guide.sftp.filezilla.s2": "Host: {host}, port: {port}.",
  "conn.guide.sftp.filezilla.s3": "User: {user}. Logon type: Normal for a password, or Key file for a key.",
  "conn.guide.sftp.rclone.useCaption": "Use it",
  "conn.guide.sftp.sshfs.mountCaption": "Mount and unmount",
  "conn.guide.sftp.sshfs.note": "A mounted folder rewrites the whole file on every save. Good for documents, not for a database or a video you are editing in place.",
  "conn.guide.sftp.note.storages": "The root is not a home directory: it lists the storages you may open, and the first path segment names one.",
  "conn.guide.sftp.note.permissions": "The permission bits your client draws come from your access level here, so a file shown as read-only really is one for you.",
  "conn.guide.sftp.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.sftp.note.totp": "If your account has two-factor sign-in, the password will not work here - SSH has no way to ask for the code. Register an SSH key, or use an API key as the password.",
  "conn.guide.sftp.note.disabled": "The SFTP endpoint is switched off on this server. These instructions will work once an operator enables it.",
  // ── FTPS ─────────────────────────────────────────────────────────
  "conn.guide.ftps.summary": "FTPS is here for the equipment that only ever learned FTP - scan-to-folder printers, EDI counterparties, older lab and industrial software. Always over TLS.",
  "conn.guide.ftps.fact.host": "Host",
  "conn.guide.ftps.fact.hostHint": "The same machine as the web app, on a port of its own.",
  "conn.guide.ftps.fact.port": "Port",
  "conn.guide.ftps.fact.portHint": "The control channel. Data moves on a separate port from the passive range below.",
  "conn.guide.ftps.fact.mode": "Encryption",
  "conn.guide.ftps.fact.modeValue": "FTPS - explicit TLS (AUTH TLS), required",
  "conn.guide.ftps.fact.modeHint": 'Plain FTP is refused before the password is read. Choose "Require explicit FTP over TLS", never "plain FTP" and never "implicit".',
  "conn.guide.ftps.fact.userHint": "Your username, or your email. An API key works as the password too and can be revoked on its own.",
  "conn.guide.ftps.fact.passwordHint": "Your account password, or an API key. An account with two-factor sign-in must use an API key - FTP has no way to ask for the code.",
  "conn.guide.ftps.fact.pasv": "Passive ports",
  "conn.guide.ftps.fact.pasvHint": "Data connections land here. If your firewall blocks this range the transfer HANGS with no error on either side - that is the classic FTP failure.",
  "conn.guide.ftps.filezilla.s1": "File → Site Manager → New site, Protocol: FTP.",
  "conn.guide.ftps.filezilla.s2": "Host: {host}, port: {port}.",
  "conn.guide.ftps.filezilla.s3": 'Encryption: "Require explicit FTP over TLS". Logon type: Normal, user: {user}.',
  "conn.guide.ftps.filezilla.s4": "Transfer settings → Passive. Active mode is refused by this server.",
  "conn.guide.ftps.winscp.s1": "New site → File protocol: FTP, Encryption: TLS/SSL Explicit encryption.",
  "conn.guide.ftps.winscp.s2": "Host name: {host}, port: {port}.",
  "conn.guide.ftps.winscp.s3": "User name: {user}, password as above.",
  "conn.guide.ftps.curl.caption": "Upload and download",
  "conn.guide.ftps.curl.sslReqd": "--ssl-reqd is not optional: it makes curl REQUIRE TLS instead of falling back to plaintext. This server refuses plaintext anyway, but the habit protects you against the servers that do not.",
  "conn.guide.ftps.lftp.caption": "Connect",
  "conn.guide.ftps.lftp.protectData": "ssl-protect-data encrypts the FILE as well as the sign-in. Without it lftp signs in over TLS and then sends your file in the clear - which is the FTPS misconfiguration people actually ship.",
  "conn.guide.ftps.rclone.useCaption": "Use it",
  "conn.guide.ftps.printer.tab": "Scanner / printer",
  "conn.guide.ftps.printer.s1": "In the device's scan-to-FTP settings: server {host}, port {port}.",
  "conn.guide.ftps.printer.s2": "User: {user}, password as above. Create an API key for the device rather than using your own password - it can be revoked without changing anything else.",
  "conn.guide.ftps.printer.s3": "Path: {path} - or a folder inside it that you created first. The device cannot create a storage.",
  "conn.guide.ftps.printer.s4": 'Turn ON "SSL/TLS" or "FTPS explicit", and PASSIVE mode.',
  "conn.guide.ftps.printer.noTLS": "Plenty of scan-to-FTP firmware cannot do TLS at all. This server will not talk to such a device, and that is deliberate - the alternative is your documents and your password crossing the office network in the clear.",
  "conn.guide.ftps.note.tls": "TLS is mandatory and there is no switch to turn it off. Plain FTP sends your password in the clear and your file after it.",
  "conn.guide.ftps.note.passive": "Passive mode only. Active mode has the server dial back to the client, which does not survive NAT and is blocked by most firewalls.",
  "conn.guide.ftps.note.storages": "The root is not a home directory: it lists the storages you may open, and the first path segment names one.",
  "conn.guide.ftps.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.ftps.note.prefer": "If the client can speak SFTP, prefer it: one connection, one port, no passive-mode surprises.",
  "conn.guide.ftps.note.selfSigned": "This server is using a self-signed certificate. It encrypts the channel but proves nothing about who is on the other end - most clients will ask you to accept it once. Supply a real certificate for anything that matters.",
  "conn.guide.ftps.note.disabled": "The FTPS endpoint is switched off on this server. These instructions will work once an operator enables it.",
  // ── NFS ──────────────────────────────────────────────────────────
  "conn.nfs.title": "NFS exports",
  "conn.nfs.lead": "An export lets a machine on your network mount filex as a drive - a media player, a build server, a backup box.",
  "conn.nfs.pathIsSecret": "⚠ The export path IS the password. NFS cannot ask a client who it is without Kerberos, so filex puts 32 random bytes in the path instead: whoever knows it can mount as you. Treat the mount line like a credential - /etc/fstab is world-readable on most systems.",
  "conn.nfs.disabled": "The NFS endpoint is switched off on this server (FILEX_NFS). An export created here will not mount until an operator turns it back on.",
  "conn.nfs.cannotMint": "You are not signed in with an account that can create exports.",
  "conn.nfs.label": "What is it for? (media player, backup box, …)",
  "conn.nfs.defaultLabel": "nfs export",
  "conn.nfs.everyStorage": "Every storage I can see",
  "conn.nfs.prefix": "Folder inside the storage (optional)",
  "conn.nfs.allowCidrs": "Allowed addresses, e.g. 192.168.1.0/24 (optional)",
  "conn.nfs.readOnly": "Read-only",
  "conn.nfs.readOnlyHint": "Read-only is the safer default for a machine: it refuses every write through this mount whatever your own permissions are. An address list narrows it further - outside it, the mount is refused.",
  "conn.nfs.mint": "Create export",
  "conn.nfs.once": "Copy this now - the path is shown only once and cannot be recovered.",
  "conn.nfs.dismiss": "I have copied it",
  "conn.nfs.col.label": "Label",
  "conn.nfs.col.scope": "Limited to",
  "conn.nfs.col.mode": "Mode",
  "conn.nfs.col.lastUsed": "Last mounted",
  "conn.nfs.scopeAll": "everything you can see",
  "conn.nfs.modeRead": "read-only",
  "conn.nfs.modeWrite": "read/write",
  "conn.nfs.noLabel": "(no label)",
  "conn.nfs.neverUsed": "never",
  "conn.nfs.enable": "Enable",
  "conn.nfs.disable": "Disable",
  "conn.nfs.revoke": "Revoke",
  "conn.nfs.confirm": "Sure?",
  "conn.nfs.empty": "No exports yet.",
  "conn.guide.nfs.summary": "NFS mounts filex as a drive on a machine in your own network - the NAS protocol, for the devices that expect one.",
  "conn.guide.nfs.pathPlaceholder": "create an export above",
  "conn.guide.nfs.fact.host": "Host",
  "conn.guide.nfs.fact.hostHint": "The same machine as the web app, on a port of its own.",
  "conn.guide.nfs.fact.port": "Port",
  "conn.guide.nfs.fact.portHint": "Both port= and mountport= must be set to this; filex serves the mount and NFS services on one port.",
  "conn.guide.nfs.fact.export": "Export path",
  "conn.guide.nfs.fact.exportHint": "This is the credential. It is shown once, when you create the export, and is stored hashed - filex cannot show it again.",
  "conn.guide.nfs.fact.options": "Mount options",
  "conn.guide.nfs.fact.optionsHint": "nolock because filex does not run the NFS lock manager; nfsvers=3 because that is what this server speaks.",
  "conn.guide.nfs.linux.mountCaption": "Mount it",
  "conn.guide.nfs.linux.fstabSecret": "An /etc/fstab line containing this path is a password in a world-readable file. Use a credentials-protected automount, or keep the mount in a root-only unit, if that matters where you are.",
  "conn.guide.nfs.mac.mountCaption": "Mount it",
  "conn.guide.nfs.mac.resvport": "macOS needs resvport: its client insists on a privileged source port and refuses the mount without it.",
  "conn.guide.nfs.win.s1": 'Turn on "Services for NFS" → "Client for NFS" in Windows Features (Pro and Enterprise only; Home does not have it).',
  "conn.guide.nfs.win.s2": "Open a Command Prompt as administrator.",
  "conn.guide.nfs.win.s3": "Map the export to a drive letter with the command below.",
  "conn.guide.nfs.win.cmdCaption": "Map it to Z:",
  "conn.guide.nfs.win.port": "Windows has no way to say which port the mount service is on, so it can only reach an NFS server on the standard port 2049. If this server is on another port, use SFTP or the filex desktop app instead.",
  "conn.guide.nfs.nas.tab": "NAS / media player",
  "conn.guide.nfs.nas.s1": "In the device's NFS settings: server {host}, port {port} (set both the NFS and the mount port if it asks for them separately).",
  "conn.guide.nfs.nas.s2": "Remote path: the export path above, exactly as shown.",
  "conn.guide.nfs.nas.s3": "NFS version 3, no locking. Create the export read-only unless the device genuinely needs to write.",
  "conn.guide.nfs.note.unencrypted": "NFSv3 is not encrypted. Anyone who can read the traffic sees your files, and anyone who learns the path can mount them. Use it on a home or office network, or over a VPN - never across the internet.",
  "conn.guide.nfs.note.pathIsSecret": "The export path is the whole credential. Revoke it from the list above if it leaks; there is nothing else to change.",
  "conn.guide.nfs.note.noPortmapper": "There is no portmapper on port 111, so a client that is not told the port cannot find the server. That is why every command here carries port= and mountport=.",
  "conn.guide.nfs.note.uid": "The user and group ids your client sends are ignored: the mount already knows whose it is. The permissions you see come from your access in filex.",
  "conn.guide.nfs.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.nfs.note.revoke": "Revoking takes effect on the next request, not instantly: NFS has no session to end, so a client with the mount open sees its next operation fail.",
  "conn.guide.nfs.note.disabled": "The NFS endpoint is switched off on this server. These instructions will work once an operator enables it.",
  "conn.tokens.title": "API keys",
  "conn.tokens.lead": "FTPS, WebDAV and filex mount all sign in with an API key instead of your account password. Create one here - it can be revoked on its own, and an account with two-factor sign-in cannot use its password on these at all.",
  "conn.tokens.mint": "Create API key",
  "conn.tokens.once": "Copy it now - this is the only time it is shown. Only a hash is stored, so it cannot be shown again.",
  "conn.tokens.dismiss": "I have copied it",
  "conn.tokens.cannotMint": "This session cannot create API keys. Sign in with your own account to create one.",
  "conn.tokens.empty": "No API keys yet.",
  "conn.tokens.neverUsed": "never",
  "conn.tokens.revoke": "Revoke",
  "conn.tokens.confirm": "Sure?",
  "conn.tokens.col.label": "Name",
  "conn.tokens.col.scopes": "Permissions",
  "conn.tokens.col.comments": "Comments",
  "conn.tokens.col.used": "Last used",
  "conn.tokens.revokeHint": "Revoking stops a connection that is already open, not just the next sign-in: an SFTP or FTPS session is cut and a mount stops working within about half a minute.",
  "conn.guide.mount.summary": "filex mount attaches a remote filex server to a folder on this machine, over the same HTTPS the browser uses. It is the only one of these that works from anywhere - no LAN, no extra server, no third-party client.",
  "conn.guide.mount.fact.url": "Server URL",
  "conn.guide.mount.fact.urlHint": "The same address you use in the browser. Nothing else has to be reachable.",
  "conn.guide.mount.fact.token": "API key",
  "conn.guide.mount.fact.tokenPlaceholder": "create one under API keys",
  "conn.guide.mount.fact.tokenHint": "An API key, not your password - it can be revoked on its own, and an account with 2FA cannot use its password here at all.",
  "conn.guide.mount.fact.remote": "What to mount",
  "conn.guide.mount.fact.remoteHint": "Leave --remote off to see every storage as a folder, or name one storage - or a folder inside it - to mount just that.",
  "conn.guide.mount.linux.mountCaption": "Mount it",
  "conn.guide.mount.linux.umountCaption": "Unmount it",
  "conn.guide.mount.linux.umountWarn": "Unmount with fusermount, not by killing the process. A mount whose process died without detaching leaves a folder where every ls hangs until somebody runs fusermount by hand.",
  "conn.guide.mount.linux.systemdCaption": "Mount it at sign-in (systemd user unit)",
  "conn.guide.mount.win.winfsp": "Windows needs WinFsp installed once - it is free and open source: https://winfsp.dev. Nothing else, and no administrator rights after that.",
  "conn.guide.mount.win.mountCaption": "Mount it as a drive",
  "conn.guide.mount.win.freeLetter": "Pick a drive letter that is FREE. The letter is created by the mount, not attached to something that already exists, and pointing it at one that is in use fails with a message that does not say so.",
  "conn.guide.mount.win.stop": "Stop it with Ctrl-C in that window. The drive disappears and nothing is left behind on this machine.",
  "conn.guide.mount.mac.unsupported": "filex mount does not work on macOS. It needs macFUSE, whose license does not allow a program like filex to install it for you, and whose Go binding needs a C compiler filex deliberately does not require. The command refuses here rather than appearing to work and doing nothing.",
  "conn.guide.mount.mac.alternatives": "On macOS, use the filex desktop app with folder sync (keeps the files on disk), or SFTP with a client that mounts drives.",
  "conn.guide.mount.note.notASync": "This is not a sync. Nothing is copied to this machine except a small read cache, so a mount opens one file out of a hundred thousand without downloading the rest. If you want the files when you are offline, use folder sync instead.",
  "conn.guide.mount.note.reachable": "It reaches the server through whatever proxy or tunnel the browser goes through, because underneath it is the same API. Your permissions and your storages come with it.",
  "conn.guide.mount.note.wholeFileWrites": "A file you write through the mount is uploaded when the program closes it, not while it is being written. Editing a very large file in place is slower here than a local disk; copying it in and out is not.",
  "conn.guide.mount.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.mount.note.revoke": "Revoke the API key to stop a mount. It stops serving within half a minute, even if the mount is still attached.",
  "storages.driver.ftp": "FTP / FTPS",
  "storages.driver.local": "Local filesystem",
  "storages.driver.s3": "S3 / Hetzner / MinIO",
  "storages.driver.sftp": "SFTP",
  "storages.driver.smb": "SMB / CIFS (NAS)",
  "storages.driver.webdav": "WebDAV",
  "storages.fieldHelp.smbShare": "The share name alone, without the server: `media`, not `\\\\nas\\media`.",
  "storages.fieldHelp.smbDomain": "Only for a Windows domain account. Leave empty for a NAS.",
  "storages.fieldHelp.smbRoot": "Sub-folder inside the share. Leave empty for the whole share.",
  "storages.fields.share": "Share",
  "storages.fields.domain": "Domain / workgroup",
  "storages.fieldHelp.disablePresign": "On by default: uploads and the downloads behind public share links stream through filex, so the bucket endpoint never has to be reachable from a browser (a LAN-only MinIO just works). Turn it off only when the endpoint is reachable from your users' browsers (AWS, a public MinIO) and you want them to talk to the bucket directly - faster for very large files, and the store must accept SDK-signed URLs (Ceph RGW / some Hetzner setups answer SignatureDoesNotMatch).",
  "storages.fieldHelp.endpoint": "Leave empty for AWS S3. Any S3-compatible store needs its endpoint.",
  "storages.fieldHelp.hostKey": "A single public key in authorized_keys / known_hosts line form.",
  "storages.fieldHelp.insecureSkipHostKey": "Accepts any host key. Only for throwaway hosts.",
  "storages.fieldHelp.keyPath": "Path to a key file on the server, read when the storage starts. Used when the PEM field is empty.",
  "storages.fieldHelp.knownHosts": "OpenSSH known_hosts path for strict host-key checking. Default is trust-on-first-use in ~/.filex/known_hosts.",
  "storages.fieldHelp.passive": "Off switches to active mode, which needs the server to dial back into this host.",
  "storages.fieldHelp.path": "Directory on the server. It is created if missing; filex never mounts /.",
  "storages.fieldHelp.pathStyle": "On for every non-AWS store. It is turned on automatically when an endpoint is set and this was never touched.",
  "storages.fieldHelp.prefix": "Sub-folder inside the bucket. Required: filex never takes ownership of the bucket root.",
  "storages.fieldHelp.region": 'Defaults to "auto" when left empty.',
  "storages.fieldHelp.root": "Sub-folder on the backend. Required: filex never mounts the account root.",
  "storages.fieldHelp.sftpAuth": "Either a password or a private key is required.",
  "storages.fieldHelp.tls": "Plain FTP sends credentials in the clear - turn this on whenever the server supports it.",
  "storages.fields.accessKey": "Access key",
  "storages.fields.basePath": "Base path",
  "storages.fields.bucket": "Bucket",
  "storages.fields.disablePresign": "Stream transfers through filex",
  "storages.fields.endpoint": "Endpoint",
  "storages.fields.host": "Host",
  "storages.fields.hostKey": "Pinned host key",
  "storages.fields.insecureSkipHostKey": "Skip host-key verification (insecure)",
  "storages.fields.keyPath": "Private key file",
  "storages.fields.knownHosts": "known_hosts file",
  "storages.fields.name": "Display name",
  "storages.fields.namePlaceholder": "Personal photos",
  "storages.fields.passive": "Passive mode (PASV)",
  "storages.fields.password": "Password",
  "storages.fields.path": "Filesystem path",
  "storages.fields.pathStyle": "Use path-style URLs (Hetzner, MinIO)",
  "storages.fields.port": "Port",
  "storages.fields.prefix": "Prefix",
  "storages.fields.privateKey": "Private key (PEM)",
  "storages.fields.rbac": "Per-item access control (RBAC)",
  "storages.fields.rbacHint": "When on, non-admins see only the files and folders granted to them (listed under Folder access). When off, everyone opens the storage according to their role.",
  "storages.fields.readOnly": "Read-only mount",
  "storages.fields.region": "Region",
  "storages.fields.root": "Base path",
  "storages.fields.secretKey": "Secret key",
  "storages.fields.tls": "FTPS (explicit AUTH TLS)",
  "storages.fields.url": "Base URL",
  "storages.fields.user": "User",
  "storages.fields.s3AttemptTimeout": "Attempt timeout (seconds)",
  "storages.fields.s3MaxAttempts": "Attempts per request",
  "storages.fields.s3TotalTimeout": "Give up after (seconds)",
  "storages.fieldHelp.s3AttemptTimeout": "How long one attempt may wait for a sign of life from the store: connecting, the TLS handshake, the answer after the request is sent, and each next piece of the answer. A transfer that keeps moving is never cut, however long it takes; an upload the store stops taking is cut after 60 seconds, or after this if it is longer. Copies and renames wait up to 10 minutes for the answer, because the store answers them only when the copy is done.",
  "storages.fieldHelp.s3MaxAttempts": "How many times a request is tried in all when the failure can pass: a network error, a timeout, a 5xx answer, throttling. 1 turns retrying off. A refusal (403, a missing bucket, a host name that does not resolve) is never retried.",
  "storages.fieldHelp.s3TotalTimeout": "No new attempt starts unless it could finish within this many seconds of the first, so an upload or a listing on a store that is down reports the outage within this time. A transfer that is under way is not cut. A request that timed out is tried again only when this is at least twice the attempt timeout.",
  "storages.fields.attemptTimeout": "Attempt timeout (seconds)",
  "storages.fields.maxAttempts": "Attempts per request",
  "storages.fields.totalTimeout": "Give up after (seconds)",
  "storages.fieldHelp.attemptTimeout": "How long one attempt may wait for a sign of life from the server: connecting, logging in, the answer to each request, and each next piece of a transfer. A transfer that keeps moving is never cut, however long it takes; an upload the server stops taking is cut after 60 seconds, or after this if it is longer.",
  "storages.fieldHelp.webdavAttemptTimeout": "How long one attempt may wait for a sign of life from the server: connecting, logging in, the answer to each request, and each next piece of a transfer. A transfer that keeps moving is never cut, however long it takes; an upload the server stops taking is cut after 60 seconds, or after this if it is longer. Copies, moves and deletes wait up to 10 minutes for the answer, because the server answers them only when the work is done.",
  "storages.fieldHelp.maxAttempts": "How many times a request is tried in all when the failure can pass: the connection is refused or drops, no answer comes in time, the server answers that it is unavailable (5xx). 1 turns retrying off. A refusal (a wrong password, a missing folder, a certificate that does not verify) is never retried, and neither is an upload that has started sending.",
  "storages.fieldHelp.totalTimeout": "No new attempt starts unless it could finish within this many seconds of the first, so a server that is down is reported within this time. A transfer that is under way is not cut. A request that timed out is tried again only when this is at least twice the attempt timeout.",
  /* === gezinti:g1 - navigation panel (SideNav) === */
  "sidenav.title": "Navigation",
  "sidenav.views": "Views",
  "sidenav.storages": "Storages",
  "sidenav.home": "Home",
  "sidenav.myfiles": "My files",
  "sidenav.recent": "Recent",
  "sidenav.starred": "Starred",
  "sidenav.shared": "Shared with me",
  // The mirror of the row above, and it sits right under it: what came in,
  // and what went out. ⚠ "My shares", not "Shared by me" - the page lists
  // LINKS the person minted, not files they granted somebody access to.
  "sidenav.myshares": "My shares",
  "sidenav.trash": "Trash",
  "sidenav.collapse": "Collapse navigation",
  "sidenav.expand": "Expand navigation",
  "sidenav.close": "Close navigation",
  // ⚠ `open`/`close` are the DRAWER's pair, `expand`/`collapse` the docked
  // panel's, and they are not interchangeable - see the note on
  // `navToggleLabel` in Toolbar.vue. Below 560px the panel is a drawer over
  // the listing: it is not narrowed to a rail, it is not on screen at all, so
  // "expand" would promise a width change to something that has no width.
  "sidenav.open": "Open navigation",
  "sidenav.storage.shared": "Shared",
  "sidenav.storage.readOnly": "Read-only",
  // #57 - a storage row's order menu (right click, a long press, Shift+F10).
  // "Sort by name" writes an order the person can keep adjusting; it is not a
  // mode. "Use default order" lets the person's own order go: the panel then
  // follows the administrator's order (or, with none, the server's). The two
  // `.done`/`.none` lines are the reason a greyed row gives.
  "sidenav.storage.moveUp": "Move up",
  "sidenav.storage.moveDown": "Move down",
  "sidenav.storage.sortName": "Sort by name",
  "sidenav.storage.sortName.done": "Already sorted by name",
  "sidenav.storage.defaultOrder": "Use default order",
  "sidenav.storage.defaultOrder.none": "Already in the default order",
  // ⚠ `toolbar.nav` is GONE, and nothing replaced it. It was the one label on
  // the panel's collapse control, first as the noun "Navigation" - which names
  // the panel and never says the button does anything to it, so the owner
  // could not find how to collapse the panel (2026-09-13: "yan menüyü kısıp
  // açabilir olalım ya bence") - and then as the static stopgap "Show or hide
  // navigation". The four `sidenav.*` verbs above are the real fix: the label
  // is bound to `navOpen`, so it says *collapse* when it will collapse and
  // *expand* when it will expand.
  "node.home": "Home",
  "node.recent": "Recent",
  "node.starred": "Starred",
  "node.shared": "Shared with me",
  "empty.recent.title": "Nothing opened yet",
  "empty.recent.hint": "Files you open show up here",
  "empty.starred.title": "Nothing starred yet",
  "empty.starred.hint": "Star a file to find it here",
  "empty.shared.title": "Nothing has been shared with you",
  "empty.shared.hint": "Folders and files other people share appear here",
  /* etiket:t1 */
  "sidenav.tags": "Tags",
  "sidenav.tags.empty": "No tags yet - add one from a file’s right-click menu.",
  "sidenav.tags.more": "Show {count} more",
  "sidenav.tags.less": "Show fewer",
  "sidenav.tags.personal": "Personal",
  "sidenav.tags.team": "Team",
  "empty.tag.title": "Nothing is tagged “{tag}”",
  "empty.tag.hint": "Right-click a file and choose Tags to put it here",
  "sidenav.connections": "Connections",
  "sidenav.apps": "Apps",
  // #162 - the store screen: the catalog of the stores an administrator turned
  // on, where a person asks for an app.
  "sidenav.appstore": "App store",
  "sidenav.connect": "Connections",
  "sidenav.apikeys": "API keys",
  "overlay.close": "Close",
  "conn.tokens.scopes": "Permissions",
  "conn.tokens.root": "Limit to one folder (optional)",
  "conn.tokens.rootPlaceholder": "storage://folder",
  "conn.tokens.expiry": "Expires in (days)",
  "conn.tokens.expiryNever": "never",
  "conn.tokens.defaultName": "API key {date}",
  "conn.tokens.namePlaceholder": "Name - e.g. backup script",
  "conn.tokens.capNote": "Your own access is the ceiling - a permission you do not have is refused, not granted.",
  "conn.tokens.scopesRequired": "Choose at least one permission - an API key is never issued with none.",
  "conn.tokens.comments": "Comments",
  "conn.tokens.commentsRead": "Read",
  "conn.tokens.commentsRw": "Read and write",
  "conn.tokens.commentsHint": "Adding and deleting comments is a permission of its own - “write” does not include it. Every API key reads them.",
  "conn.tokens.commentsToRw": "Comments: allow writing",
  "conn.tokens.commentsToRead": "Comments: read only",
  /* === /gezinti:g1 === */
  /* === surucu:d1 - the shell (GitHub #14); every profile, no longer a
     `uiProfile: 'drive'` opt-in === */
  "drive.new": "New",
  "drive.new.upload": "Upload files",
  "drive.new.folder": "New folder",
  "drive.new.request": "Request files",
  "drive.new.document": "New document",
  /* === belge:n1 - "New document": the picker under + New =================
     Type names are NOT listed here. A tile reads its words from
     lib/fileIcons `typeLabelFor`, the same table the listing's Type column
     uses, so ".docx" is called the same thing in both places and a new type
     needs no string at all. Only this dialog's own chrome lives below. */
  "newdoc.title": "New document",
  "newdoc.type.label": "Document type",
  "newdoc.group.document": "Documents",
  "newdoc.group.text": "Text and code",
  "newdoc.group.diagram": "Diagrams",
  "newdoc.group.app": "Apps",
  /* ⚠ One name per service, the name its own project uses: draw.io (not
     "drawio", not "diagrams.net") and ONLYOFFICE - the QA sweep of
     2026-09-21 found draw.io called three things on three screens. */
  "newdoc.empty.title": "No document types are available",
  "newdoc.empty.body": "This server did not offer any type this app can create.",
  "newdoc.empty.blocked": "Every type this server can create needs an editor service that is not configured here.",
  "newdoc.name": "Name",
  "newdoc.name.placeholder": "File name, e.g. notes.txt or LICENSE",
  "newdoc.untitled": "Untitled",
  "newdoc.err.slash": "A name cannot contain a slash.",
  "newdoc.err.exists": "{name} is already here. Choose another name.",
  "newdoc.err.bare_ext": "Give the file a name, not only an extension.",
  "newdoc.err.ext_needs_type": "A .{ext} file has to be created as its own type - an empty one would not open. Choose that type, or another extension.",
  "newdoc.hint.ext_added": "This type keeps its extension, so the file will be created as {name}.",
  // Drafts (issue #71): a new document is a draft until its first save.
  "sidenav.drafts": "Drafts",
  "sidenav.drafts.count": "{n} drafts",
  "sidenav.drafts.count_one": "{n} draft",
  "node.drafts": "Drafts",
  "empty.drafts.title": "No drafts",
  "empty.drafts.hint": "A new document waits here until you save it where it belongs.",
  "drafts.lead": "New documents that have not been saved yet. Only you can see them.",
  "drafts.count_of": "{n} of {limit} drafts",
  "drafts.col.target": "Save to",
  "drafts.col.storage": "Storage",
  "drafts.action.save": "Save to disk",
  "drafts.open_hint": "Open {name}",
  "drafts.no_match": "No draft matches the filter.",
  "draft.badge": "Draft",
  "draft.bar.target": "will be saved to {folder}",
  "draft.save": "Save",
  "draft.saved_to": "{name} was saved to {folder}.",
  "draft.discarded": "{name} was moved to the trash.",
  "draft.kept": "Kept in Drafts",
  "draft.editing": "Editing…",
  "draft.close.title": "Close this draft?",
  "draft.close.body": "{name} is a draft for {folder} and has not been saved there yet.",
  "draft.close.hint": "A kept draft waits in Drafts. Discard moves it to the trash.",
  "draft.close.save": "Save to disk",
  "draft.close.keep": "Keep in Drafts",
  "draft.close.discard": "Discard",
  "outside.title": "This file changed outside filex",
  "outside.body": "{name} was changed somewhere else while it was open here, and this editor has changes of its own. Which version should stay?",
  "outside.theirs": "Keep the outside version",
  "outside.theirs_hint": "the changes made here are dropped and the outside version is loaded.",
  "outside.mine": "Write mine",
  "outside.mine_hint": "your version replaces the outside one when it is saved.",
  "outside.both": "Keep both",
  "outside.both_hint": "the outside version stays where it is, and yours is saved beside it as a separate copy (name.filex-conflict-time).",
  "outside.hint": "Until you choose, nothing is written over either version.",
  "outside.pending": "This file changed outside filex. Nothing is written over either version until you choose which one stays.",
  "outside.choose": "Choose…",
  "outside.note.reloaded": "The file was updated outside filex; the new version is loaded.",
  "outside.note.theirs": "The outside version is loaded; the changes made here were dropped.",
  "outside.note.mine": "Your version will replace the outside one when it is saved.",
  "outside.note.both": "The outside version stays; yours will be saved beside it as a separate copy.",
  "draft.taken.title": "A file with this name is already there",
  "draft.taken.body": "{folder} already has a file called {name}. Save the draft as {suggested} instead?",
  "draft.taken.confirm": "Save as {name}",
  "upload.taken.body": "{folder} already has something called {name}, and a vault keeps no earlier version. Upload it as {suggested} instead?",
  "upload.taken.confirm": "Upload as {name}",
  "newdoc.hint.draft": "It opens as a draft: nothing is created in the folder until you save it.",
  "newdoc.err.draft_limit": "You already keep as many drafts as this server allows ({limit}). Save or delete some in Drafts first.",
  "newdoc.err.draft_limit_any": "You already keep as many drafts as this server allows. Save or delete some in Drafts first.",
  "newdoc.open_drafts": "Open Drafts",
  "newdoc.location": "Location",
  "newdoc.location.none": "Choose a folder",
  "newdoc.location.change": "Change",
  "newdoc.location.noaccess": "You cannot save into this folder.",
  "newdoc.create": "Create",
  "newdoc.creating": "Creating…",
  "newdoc.cancel": "Cancel",
  // ⚠ The top search field searches the WHOLE storage (and every storage at
  // the root) - never only the open folder. The scope named here is therefore
  // the storage, not the folder; "Filter in this folder…" (FilterBar) is the
  // folder-scoped one. It used to say "Search in Photos" for a folder called
  // Photos, which was a lie (2026-09-19).
  "drive.search.placeholder": "Search in {scope}",
  "drive.search.placeholder_all": "Search all storages",
  "drive.search.hint_title": "Search everywhere and run commands ({combo})",
  "drive.storage.used": "{used} of {total} used",
  "drive.storage.used_unlimited": "{used} used",
  "drive.storage.used_partial": "at least {used} used",
  "drive.storage.label": "Storage",
  /* === gorunum:v3-shell - the Home view (the overview, inside the shell) ==
   * The section headings are `sidenav.storages` / `sidenav.recent` /
   * `sidenav.starred` and the two empty states are `empty.recent.*` /
   * `empty.starred.*`, on purpose: the block headed "Recent" on Home and the
   * panel row labelled "Recent" beside it are the same thing, and a second
   * string for it is how the two drift apart one translation at a time. Only
   * what exists nowhere else is below. */
  "home.title": "Home",
  "home.storages.empty": "No storages yet",
  "home.storages.hint": "A storage is a place filex reads and writes - an administrator adds them.",
  "drive.section.folders": "Folders",
  "drive.section.files": "Files",
  "filter.aria": "Filters",
  "filter.type": "Type",
  "filter.type.any": "Any type",
  "filter.type.folder": "Folders",
  "filter.type.document": "Documents",
  "filter.type.spreadsheet": "Spreadsheets",
  "filter.type.presentation": "Presentations",
  "filter.type.pdf": "PDFs",
  "filter.type.image": "Images",
  "filter.type.video": "Videos",
  "filter.type.audio": "Audio",
  "filter.type.archive": "Archives",
  "filter.type.code": "Code",
  "filter.modified": "Modified",
  "filter.modified.any": "Any time",
  "filter.modified.today": "Today",
  "filter.modified.7d": "Last 7 days",
  "filter.modified.30d": "Last 30 days",
  "filter.modified.year": "This year",
  "filter.size": "Size",
  "filter.size.any": "Any size",
  "filter.size.lt1": "Under 1 MB",
  "filter.size.1to10": "1 - 10 MB",
  "filter.size.10to100": "10 - 100 MB",
  "filter.size.gt100": "Over 100 MB",
  /* surucu:d1-actions - the ⋮ menu at the end of the filter row. Only its own
     NAME is new: every row inside it reuses the string that verb already has
     (`toolbar.new_folder`, `toolbar.upload`, `ctx.paste`, `shortcuts.select_all`,
     `selection.clear`), because a menu that renames a command is a menu the
     reader has to learn twice. */
  "filter.actions": "Listing actions",
  "filter.clear": "Clear filters",
  "filter.empty.title": "Nothing here matches those filters",
  "filter.empty.hint": "Clear a filter, or search everywhere with the field above.",
  "filter.count": "{shown} of {total}",
  "inspector.tab.details": "Details",
  "inspector.tab.activity": "Activity",
  "inspector.people": "People with access",
  "inspector.people.you": "You",
  "inspector.people.inherited": "from a parent folder",
  "inspector.people.empty": "Only you, and anyone with a link below.",
  "inspector.people.manage": "Manage access",
  "inspector.link": "Shared link",
  "inspector.link.none": "Not shared",
  "inspector.link.create": "Create link",
  "inspector.link.copy": "Copy link",
  "inspector.activity.empty": "No activity recorded for this item yet.",
  "inspector.activity.hint": "Versions are written when a file changes; comments are written by people.",
  "inspector.activity.version": "Version {n} saved",
  "inspector.activity.comment": "Comment by {who}",
  "inspector.activity.select": "Select a file or folder to see its activity.",
  /* === /surucu:d1 === */
  /* === gorunum:v1-chrome - the filter row's name box === */
  "filter.find": "Filter in this folder…",
  /* surucu:d1-scope - the same box where the rows are not a folder's contents.
     It has to say what it narrows: at the drive list "this folder" names
     nothing, and on Home it would name three blocks at once. */
  "filter.find.storages": "Filter storages…",
  "filter.find.home": "Filter Home…",
  /* === gorunum:v1-viewer - the full-bleed overlay's own chrome === */
  "viewer.share": "Share",
  "viewer.nav_prev": "Previous file",
  "viewer.nav_next": "Next file",
  /* The counter in the top bar's meta line: "246.3 KB • Sep 9, 2026 • 1 of 9". */
  "viewer.counter": "{i} of {n}",
  "viewer.zoom_reset": "Reset zoom",
  "viewer.fullscreen": "Full screen",
  "viewer.exit_fullscreen": "Exit full screen",
  "viewer.md_placeholder": "# Markdown here…",
  /* === gorunum:v1-selbar - the selection bar that replaces the filter row === */
  "selection.count": "{n} selected",
  "selection.clear": "Clear selection",
  /* === gorunum:v1-preview - the kind, said in words ======================
     The Type column used to print the extension in caps. These are what it
     prints instead; the table that picks one is in `lib/fileIcons.ts`
     (`typeLabelKey`), so this list and that one are the only two places a
     kind is named. Anything unmapped still falls back to the uppercased
     extension - these names improve on that fallback, they do not replace
     it. `Folder` is NOT here: it is `node.folder`, which the grid card's
     caption already prints. */
  "ftype.typescript": "TypeScript",
  "ftype.javascript": "JavaScript",
  "ftype.vue": "Vue component",
  "ftype.python": "Python",
  "ftype.go": "Go",
  "ftype.rust": "Rust",
  "ftype.php": "PHP",
  "ftype.ruby": "Ruby",
  "ftype.java": "Java",
  "ftype.kotlin": "Kotlin",
  "ftype.swift": "Swift",
  "ftype.c": "C source",
  "ftype.cpp": "C++ source",
  "ftype.csharp": "C# source",
  "ftype.stylesheet": "Stylesheet",
  "ftype.html": "HTML document",
  "ftype.json": "JSON data",
  "ftype.yaml": "YAML",
  "ftype.xml": "XML",
  "ftype.toml": "TOML",
  "ftype.sql": "SQL",
  "ftype.shell": "Shell script",
  "ftype.powershell": "PowerShell script",
  "ftype.markdown": "Markdown",
  "ftype.plaintext": "Plain text",
  "ftype.log": "Log file",
  "ftype.config": "Configuration",
  "ftype.sheet": "Spreadsheet",
  "ftype.figma": "Figma design",
  "ftype.drawio": "draw.io diagram",
  "ftype.design": "Design file",
  "ftype.image": "Image",
  "ftype.video": "Video",
  "ftype.audio": "Audio",
  "ftype.pdf": "PDF document",
  "ftype.document": "Document",
  "ftype.slides": "Presentation",
  "ftype.archive": "Archive",
  "ftype.code": "Code",
  /* === gorunum:v1-advsearch - the Advanced search dialog ==================
   * Two `filter.*` keys are added here rather than beside their siblings
   * because they are new members of shared unions the dialog introduced
   * (`modified: 'around'`, `size: 'range'`); the filter row never selects
   * them, but `chipLabel` would print the raw key if one ever reached it. */
  "filter.modified.around": "Around a date",
  "filter.size.range": "Custom range",
  "advsearch.open": "Advanced search",
  "advsearch.title": "Advanced search",
  "advsearch.subtitle": "Find files by name, content, path, or tags.",
  "advsearch.close": "Close",
  "advsearch.content.heading": "Content search",
  "advsearch.viewall": "View all results",
  "advsearch.where.any_short": "Anywhere",
  "advsearch.where.here_short": "Only here",
  "advsearch.where.skip_short": "Skip this",
  "advsearch.server.legend": "What the server searches",
  "advsearch.client.legend": "Narrow the results that come back",
  "advsearch.query.label": "Words",
  "advsearch.query.placeholder": "Part of a name, or words inside a file",
  "advsearch.scope.label": "Look in",
  "advsearch.scope.name": "Names and paths",
  "advsearch.scope.content": "File contents",
  "advsearch.scope.all": "Both",
  "advsearch.scope.hint": "Contents are searched from the index, which covers text-like files up to 200 KB.",
  "advsearch.people.name_only": "Owner is read off the rows that come back, and only a name search returns rows that carry one.",
  "advsearch.scope.name_only": "Only names and paths here: a content hit reaches the explorer without the storage it came from, so content search is offered on single-storage deployments only.",
  "advsearch.tags.label": "Tags",
  "advsearch.tags.placeholder": "invoice, quarterly report",
  "advsearch.tags.exclude": "Without tags",
  "advsearch.tags.exclude_placeholder": "archive",
  "advsearch.tags.hint": "Separate with commas. Tags narrow: several tags means files carrying all of them, and a tag nobody has applied returns nothing. A name matches your personal tag and your team’s tag of that name alike.",
  "advsearch.where.label": "Folder",
  "advsearch.where.any": "Anywhere in this storage",
  "advsearch.where.here": "Only in {folder}",
  "advsearch.where.skip": "Everywhere except {folder}",
  "advsearch.around.label": "Within",
  "advsearch.around.date": "Date and time",
  "advsearch.around.h1": "1 hour",
  "advsearch.around.d1": "1 day",
  "advsearch.around.w1": "1 week",
  "advsearch.size.range_label": "Between",
  "advsearch.size.from": "From",
  "advsearch.size.to": "To",
  "advsearch.count.idle": "Type something, or pick a tag.",
  "advsearch.count.counting": "Counting…",
  "advsearch.count.result": "{n} matching items",
  "advsearch.count.capped": "{n} matching items in the first page of hits",
  "advsearch.count.result_one": "{n} matching item",
  "advsearch.count.capped_one": "{n} matching item in the first page of hits",
  "advsearch.count.error": "The count could not be run.",
  "advsearch.count.cost": "The count runs this search. Type, owner, date, size and folder narrow the results it finds.",
  "advsearch.wire": "Type this in the search box next time:",
  "advsearch.reset": "Reset",
  "advsearch.cancel": "Cancel",
  "advsearch.submit": "Search",
  /* === gorunum:v2-topbar - the page bar is gone; the explorer's own header
     and breadcrumb row carry what it used to. === */
  "breadcrumb.subfolders": "Subfolders",
  "breadcrumb.subfolders.empty": "No subfolders here",
  "header.admin": "Admin panel",
  "header.settings": "Settings",
  "header.signout": "Sign out",
  "ai.assistant": "AI assistant",
  "assistant.new": "New conversation",
  "assistant.history": "Conversations",
  "assistant.history_empty": "No conversations yet.",
  "assistant.close": "Close the assistant",
  "assistant.delete": "Delete this conversation",
  "assistant.intro": "Ask the assistant to find, read, summarise, tidy up or move your files. It works with your permissions only. Changes that can be undone happen at once, with an Undo; anything that cannot be undone waits for your approval. Encrypted folders and the vault are never sent to it.",
  "assistant.placeholder": "Ask about your files...",
  "assistant.send": "Send",
  "assistant.stop": "Stop",
  "assistant.working": "Working...",
  "assistant.with_selection": "With the {count} selected items",
  "assistant.with_selection_one": "With the {count} selected item",
  "assistant.approve": "Approve",
  "assistant.decline": "Decline",
  "assistant.undo": "Undo",
  /* gorunum:v2-share - the Share / Permissions dialog's own chrome. The
     controls inside it keep the strings they already had; these are the new
     shell: the title, the one switch, the sentence that says who can open the
     item right now, and the three named sections it all folds into. */
  "access.title": 'Share "{name}"',
  "access.title_storage": 'Access to "{name}"',
  "access.close": "Close",
  "access.done": "Done",
  "access.copy": "Copy",
  "access.copied": "Copied",
  "access.link.switch": "Link sharing",
  "access.who.private": "Only people with access can open it.",
  "access.who.link": "Anyone with the link can open it.",
  "access.who.pin": "Anyone with the link and the PIN can open it.",
  "access.who.existing": "Link sharing is on - {n} links already exist.",
  "access.who.existing_one": "Link sharing is on - {n} link already exists.",
  "access.section.link": "Link options",
  "access.section.people": "People with access",
  "access.section.drop": "Request files",
  "access.sum.pin_on": "PIN on",
  "access.sum.pin_off": "No PIN",
  "access.sum.people": "{n} people",
  "access.sum.people_one": "{n} person",
  "access.sum.people_none": "No one yet",
  "access.sum.groups": "{n} groups",
  "access.sum.groups_one": "{n} group",
  "access.sum.drop": "{n} upload links",
  "access.sum.drop_one": "{n} upload link",
  "access.sum.drop_none": "No upload link",
  /* Ownership - the Owner column and the People chip. "System" is the honest
     word for a row nobody put here through filex (the scanner found it, or it
     was written straight into the bucket); it is a real answer, not a blank. */
  "col.owner": "Owner",
  "owner.you": "You",
  "owner.system": "System",
  "owner.unknown": "Unknown",
  "owner.external": "Uploaded through an upload link",
  "owner.last_actor": "Last changed by {who}",
  "filter.people": "Owner",
  "filter.people.any": "Anyone",
  "filter.people.me": "You",
  "filter.people.system": "System",
  "filter.people.someone": "Someone else",
  /* surucu:d1-sort - the listing sort control at the trailing edge of the
     filter row. The four key names are `col.*`: the menu offers exactly the
     words the list view's own column headers carry, so the two controls that
     drive one sort cannot name it differently. */
  "sort.by": "Sort by",
  "sort.asc": "Ascending",
  "sort.desc": "Descending",
  /* The order a SEARCH RESULT is in. It is not a fifth sort key - it is what
     the control prints instead of a key while the rows on screen were ranked
     by the server, so the button stops claiming a sort it is not performing.
     `_why` is the reason the control is closed, and the owner asked for the
     reason to be written rather than for the control to go quietly inert. */
  "sort.relevance": "Relevance",
  "sort.relevance_why": "Search results are listed by how well they match. Your sort comes back when you leave the search.",
  /* === tablo:t1 - the table's own configuration ==========================
     Since v0.43 everything about how a folder looks - view, sort AND columns -
     belongs to the folder it was changed in; a folder nobody changed opens
     with the person's default (their settings), else the instance's.
     `folder_hint` is that rule in one sentence, written where the person who
     is about to be surprised by it can read it. */
  "col.location": "Location",
  "col.deleted": "Deleted",
  "col.deleted_from": "Deleted from",
  "col.deleted_by": "Deleted by",
  "col.remaining": "Time left",
  "cols.menu": "Column options",
  "cols.title": "Columns",
  "cols.resize": "Resize {col}",
  "cols.sort_by": "Sort by {col}",
  "cols.move_left": "Move {col} left",
  "cols.move_right": "Move {col} right",
  "cols.reset": "Reset columns",
  "cols.folder_title": "Folder view",
  "cols.folder_hint": "A change you make here stays in this folder. Folders you have never changed open with your default view (Settings → Default folder view).",
  "cols.forget_folder": "Forget this folder's view",
  "cols.apply_all": "Make this my default for all folders ({count} remembered)",
  /* === tablo:t3 - THE ONE TABLE (components/DataTable.vue) ================
     Every table in the product speaks these, so a column menu or a pager is
     never the one English thing on a Turkish page. */
  "table.empty": "Nothing here yet",
  "table.prev": "Previous page",
  "table.next": "Next page",
  "table.sort_paged": "This list is split into pages. Sorting would only re-order the page on screen, so it is off here - narrow the list with the search or filters instead.",
  /* === tablo:t1 - the trash banner ======================================
     ⚠ `retention` is only used when the deployment has TOLD us the number
     (GET /api/admin/protection). Everywhere else `retention_unknown` says the
     same thing without naming a period we cannot verify: a banner that states
     the wrong retention is worse than no banner, because people act on it. */
  "trash.retention": "Items in the trash are permanently deleted after {days} days.",
  "trash.retention_one": "Items in the trash are permanently deleted after {days} day.",
  "trash.retention_unknown": "Items in the trash are permanently deleted after a retention period set by your administrator.",
  "trash.empty_action": "Empty trash",
  "trash.empty_confirm_title": "Empty the trash?",
  /* 0.54 (finding D1): the confirmation waits for the server's count of
     what "Empty trash" deletes, and the Trash view is paged. Every
     sentence about the trash itself is the server's (server.trash.*). */
  "trash.empty_counting": "Counting what is in the trash…",
  "trash.show_more": "Show more",
  "trash.shown_of": "{shown} of {total} shown",
  "trash.days_remaining": "{n} days",
  "trash.days_remaining_one": "{n} day",
  "trash.days_remaining_due": "Due for deletion",
  "trash.deleted_by_nobody": "Not recorded: quarantined by the virus scan, or deleted before filex kept this",
  "empty.trash.hint": "Files you delete land here first, so you can put them back.",
  /* tasi:m1 - the destination picker (modals/DestinationPickerModal.vue) and
     the two selection verbs built on it. */
  "destpicker.title.move": "Move to",
  "destpicker.title.copy": "Copy to",
  "destpicker.title.choose": "Choose a folder",
  "destpicker.confirm.move": "Move here",
  "destpicker.confirm.copy": "Copy here",
  "destpicker.confirm.choose": "Choose this folder",
  "destpicker.title.choose_file": "Choose a file",
  "destpicker.confirm.choose_file": "Choose this file",
  "destpicker.title.save": "Save to",
  "destpicker.confirm.save": "Save here",
  "destpicker.pick_a_file": "Select a file from the list.",
  "destpicker.empty_files": "This folder is empty",
  "destpicker.cancel": "Cancel",
  "destpicker.up": "Up one level",
  "destpicker.crumbs": "Location",
  "destpicker.drives": "Storages",
  "destpicker.loading": "Loading…",
  "destpicker.empty": "No subfolders here",
  "destpicker.unreadable": "This folder cannot be opened.",
  "destpicker.readonly": "Read-only",
  "destpicker.readonly_here": "You cannot write into this folder.",
  "destpicker.pick_a_drive": "Open a storage to choose a folder inside it.",
  "destpicker.target": "Destination: {name}",
  "destpicker.tag.blocked": "Not allowed",
  "destpicker.blocked.self": "A folder cannot be moved into itself.",
  "destpicker.blocked.descendant": "A folder cannot be moved into one of its own subfolders.",
  "destpicker.tag.vault": "Vault",
  "destpicker.blocked.vault_in": "Nothing goes into a vault from here: upload into it from inside the vault.",
  "destpicker.blocked.vault_out": "What is in a vault moves only inside that vault. Download it to take it out.",
  "ctx.move_to": "Move to…",
  "ctx.copy_to": "Copy to…",
  "ctx.access.one_only": "Sharing works on one item at a time.",
  "ctx.storage_access": "Access…",
  "toast.archive.preparing": "Preparing the archive…",
  "toast.archive.started": "Downloading {name} ({count} files)",
  "toast.archive.started_one": "Downloading {name} ({count} file)",
  "toast.archive.empty": "Nothing to download - the selection contains no readable file.",
  "toast.moved_to": "Move to {name} queued",
  "toast.copied_to": "Copy to {name} queued",
  "toast.already_there": "The selected items are already in {name} - nothing was sent",
  /* ── dil:paket - strings that used to be inline `en ? … : …` pairs in
     FileExplorer / RecentlyOpened, where no language pack could reach them
     (and where a pack's language fell through to TURKISH). */
  "ctx.tags_menu": "Tags…",
  "toast.node_id_copied": "Node id {id} copied",
  "toast.read_only_here": "Read-only here",
  "recents.title": "Recently opened",
  "recents.refresh": "Refresh",
  "recents.empty": "Nothing here yet.",
  "recents.loading": "Loading…",
  "recents.close": "Close",
  "tags.title": "Tags",
  "tags.close": "Close",
  "share.ttl.never": "This link does not expire.",
  "share.ttl.until": "This link is valid until {when}.",
  "share.ttl.ceiling": "Links can be valid for at most {days} days (server setting).",
  "share.ttl.ceiling_one": "Links can be valid for at most {days} day (server setting).",
  /* ── dil:paket - the share / access dialog (modals/PermissionsModal.vue). These were ~90 inline (tr, en) pairs: no language pack could reach them, and under any third language the dialog spoke TURKISH. access.ui.emails_comma_separated / access.ui.send / access.ui.mail_not_set_up are the mail-row lines another branch rewrote in the same release, converted at the v0.43.0 merge. */
  "access.ui.level_viewer": "Viewer",
  "access.ui.level_viewer_desc": "view + download",
  "access.ui.level_editor": "Editor",
  "access.ui.level_editor_desc": "read + write + delete",
  "access.ui.level_owner": "Owner",
  "access.ui.level_owner_desc": "edit + manage access",
  "access.ui.never": "Never",
  "access.ui.days": "{days} days",
  "access.ui.days_one": "{days} day",
  "access.ui.unlimited": "Unlimited",
  "access.ui.downloads": "{count} downloads",
  "access.ui.downloads_one": "{count} download",
  "access.ui.inherited_from": "Inherited from",
  "access.ui.whole_storage": "Whole storage",
  "access.ui.storage_root_hint": "Everyone added here reaches every file and folder in this storage, in the web interface, the desktop app and over every protocol. Folder grants inside it stay as they are; where two apply, the higher level counts.",
  "access.ui.access_granted": "Access granted.",
  "access.ui.enter_a_valid_email": "Enter a valid email.",
  "access.ui.recipient_lang": "Recipient's language",
  "access.ui.recipient_lang_server": "The server's language",
  "access.ui.user_created_invite_emailed": "User created, invite emailed.",
  "access.ui.user_created_share_the_temp_password": "User created. Share the temp password.",
  "access.ui.server_limit_applied": "(server limit applied)",
  "access.ui.protect_with_a_pin": "Protect with a PIN",
  "access.ui.expiry": "Expiry",
  "access.ui.download_limit": "Download limit",
  "access.ui.create_link": "Create link",
  "access.ui.replace_link": "Replace the link with these settings",
  "access.ui.replace_link_hint": "The address changes: the current link stops working.",
  "access.ui.create_then_send": "Create a link, then it will be sent to {email}.",
  "access.ui.command_line": "Command line",
  "access.ui.share": "Share",
  "access.ui.existing_links": "Existing links",
  "access.ui.rbac_off_here": "Per-item access control is off on this storage - everyone opens it according to their role, so people added here would change nothing. Turn it on in the admin panel under Storages (this storage → Per-item access control).",
  "access.ui.other_links": "Other links",
  "access.ui.revoke": "Revoke",
  "access.ui.loading": "Loading…",
  "access.ui.name_or_email": "Name or email",
  "access.ui.add": "Add",
  "access.ui.no_account_for_this_email_what_next": "No account for this email - what next?",
  "access.ui.user": "User",
  "access.ui.viewer": "Viewer",
  "access.ui.create_user_grant": "Create user + grant",
  "access.ui.just_send_a_share_link": "Just send a share link →",
  "access.ui.temp_password": "Temp password:",
  "access.ui.people_with_access": "Who has access",
  "access.ui.group": "Group",
  "access.ui.group_title": "The group “{name}” - everyone in it",
  "access.ui.group_owner_confirm": "Owner lets everyone in “{name}” manage who has access here - including sharing it with other people and groups. Give the group Owner?",
  "access.ui.group_owner_give": "Give owner access",
  "access.ui.not_shared_with_anyone_yet": "Not shared with anyone yet.",
  "access.ui.remove": "Remove",
  "access.ui.a_public_link_that_lets_anyone_upload_fi": "A public link that lets anyone UPLOAD files into this folder. Uploaders never see the folder's existing files.",
  "access.ui.hide_upload_limits": "Hide upload limits",
  "access.ui.upload_limits": "Upload limits",
  "access.ui.max_files": "Max files",
  "access.ui.mb_file": "MB / file",
  "access.ui.allowed_types": "Allowed types",
  "access.ui.all_e_g_pdf_jpg": "all (e.g. pdf, jpg)",
  "access.ui.ask_uploader_name": "Ask uploader name",
  "access.ui.emails_comma_separated": "email(s) - comma separated",
  "access.ui.send": "Send",
  "access.ui.mail_not_set_up": "Email is not set up - set it up in the admin panel under Settings (Email / SMTP).",
  /* ── wiring:e2 fxe - single encrypted files (.fxe), streamed downloads ── */
  "e2e.fxe.type": "Encrypted file",
  "e2e.fxe.ctx_encrypt": "Encrypt with E2EE…",
  "e2e.fxe.ctx_download_raw": "Download encrypted file",
  "e2e.fxe.ctx_password": "Change password…",
  "e2e.fxe.ctx_remove": "Remove encryption…",
  "e2e.fxe.encrypt_title": "Encrypt this file",
  "e2e.fxe.encrypt_lead": "“{name}” is encrypted in this browser with a password of its own. The server keeps only ciphertext. The password or the recovery key opens it - here, or offline with filex decrypt.",
  "e2e.fxe.pw_label": "File password",
  "e2e.fxe.hide_label": "Hide the file name too",
  "e2e.fxe.hide_on_hint": "Stored as “{stored}”: the server sees neither the name nor the type. The real name is sealed inside the file and shown once you open it here.",
  "e2e.fxe.hide_off_hint": "Stored as “{stored}”: the name stays readable to the server; the content does not.",
  "e2e.fxe.seen_title": "What the server has already seen",
  "e2e.fxe.seen_lead": "Until now this file was stored in the clear, and encrypting it cannot take that back:",
  "e2e.fxe.seen_trash": "The original goes to the trash and stays there until the trash retention period ends or an administrator empties it. You cannot delete it for good yourself.",
  "e2e.fxe.seen_versions": "Its earlier versions stay in its version history; only an administrator can delete them.",
  "e2e.fxe.seen_thumb": "A thumbnail made from it stays on the server until the original is deleted for good. Its search-index entry is removed when it goes to the trash.",
  "e2e.fxe.seen_backups": "Backups, copies and downloads made before now still hold it.",
  "e2e.fxe.warn_body": "This file opens only with this password or the recovery key shown once after it is encrypted. filex keeps neither. Lose both and the contents are gone for good.",
  "e2e.fxe.escrow_body": "Key escrow is enabled on this installation: its operator holds a key that opens this file without your password.",
  "e2e.fxe.encrypt_submit": "Encrypt",
  "e2e.fxe.encrypt_busy": "Encrypting and uploading… {percent}%",
  "e2e.fxe.size_unknown": "The size of this file is not known yet. Refresh the folder and try again.",
  "e2e.fxe.bad_name": "This name cannot be sealed into an encrypted file (it is over 255 bytes, or holds a slash or a control character). Rename the file first.",
  "e2e.fxe.name_too_long": "The name is too long to add “.fxe” to it. Tick “Hide the file name too”, or rename the file first.",
  "e2e.fxe.encrypted": "“{name}” is encrypted. The original is in the trash.",
  "e2e.fxe.original_kept": "The encrypted copy is saved, but “{name}” could not be moved to the trash. Delete the original yourself.",
  "e2e.fxe.upload_too_big": "This server has no chunked upload, and the file is too large to send in one piece from this browser.",
  "e2e.fxe.unlock_title_open": "Open an encrypted file",
  "e2e.fxe.unlock_title_download": "Download decrypted",
  "e2e.fxe.unlock_title_remove": "Remove encryption",
  "e2e.fxe.unlock_lead": "“{name}” is encrypted. Its password is checked here, in this browser, and is never sent to the server.",
  "e2e.fxe.known_note": "Already opened in this tab - no password needed.",
  "e2e.fxe.use_password": "Use the password instead",
  "e2e.fxe.remove_warn_title": "The plaintext goes back to the server",
  "e2e.fxe.remove_warn_body": "The file is decrypted here and uploaded as a plain file under its original name: the server, its administrators, thumbnails, search and backups can read it again. The encrypted file goes to the trash.",
  "e2e.fxe.unlock_open": "Open",
  "e2e.fxe.unlock_download": "Download",
  "e2e.fxe.unlock_remove": "Remove encryption",
  "e2e.fxe.unlock_busy": "Working…",
  "e2e.fxe.save_again": "Unlocked. Your browser wants one more click before it asks where to save the file.",
  "e2e.fxe.save_button": "Save…",
  "e2e.fxe.progress": "{percent}% done",
  "e2e.fxe.wrong_password": "Wrong password.",
  "e2e.fxe.wrong_recovery": "That recovery key does not open this file.",
  "e2e.fxe.damaged": "This file is damaged or was tampered with (or it changed since it was opened). Nothing was saved.",
  "e2e.fxe.not_readable": "This is not a filex encrypted file, or its header is damaged.",
  "e2e.fxe.unsupported": "This file needs a newer filex (it requires: {features}).",
  "e2e.fxe.downloaded": "“{name}” saved.",
  "e2e.fxe.removed": "Encryption removed: “{name}” is a plain file again. The encrypted file is in the trash.",
  "e2e.fxe.password_title": "Change the file password",
  "e2e.fxe.password_cost": "Only the file’s header changes: the content is sent back byte for byte, and the recovery key keeps working.",
  "e2e.fxe.password_old_copies": "An earlier version of this file - its version history, a backup, a copy someone downloaded - still opens with the OLD password.",
  "e2e.fxe.password_done": "Password changed. The old password no longer opens this file.",
  "e2e.recovery.warn_body_file": "Anyone holding this key can read the file. Keep it somewhere separate from the password - a key stored next to the password protects you from forgetting, not from anyone else.",
  "e2e.recovery.lead_file": "This key opens the file without its password. It is shown once - filex does not store it and cannot show it again.",
  "e2e.dl.ctx_encrypted_copy": "Download encrypted copy",
  "e2e.dl.too_big": "This browser can save at most {limit} of decrypted data at once, and this is {size}. Use Chrome or Edge (they save straight to disk), the filex desktop app, or download the encrypted file and run filex decrypt.",
  "e2e.dl.click_again": "Click Download again to choose where to save it.",
  "e2e.dl.zip_started": "Decrypting into “{name}”…",
  "e2e.dl.zip_done": "“{name}” saved - decrypted, with the real names.",
  "e2e.dl.zip_done_plain": "“{name}” saved. {n} files in it were never encrypted and are in it as they were.",
  "e2e.dl.zip_done_plain_one": "“{name}” saved. {n} file in it was never encrypted and is in it as it was.",
  "e2e.dl.zip_damaged": "A file in the folder is damaged or was tampered with. The download stopped and nothing was saved.",
  "e2e.upload.streaming_unsupported": "This file is over 200 MB, and this server has no chunked upload to send it encrypted piece by piece.",
  /* wiring:e2 fxe escrow - the escrow key opens a single file, and its owner is told */
  "e2e.fxe.use_escrow": "Use the escrow key",
  "e2e.fxe.escrow_warn_title": "The file’s owner will be told",
  "e2e.fxe.escrow_warn_body": "Opening a file with the escrow key notifies its owner, before the file is opened. Use it only when you are entitled to.",
  "e2e.fxe.escrow_predates": "This installation has an escrow key, but this file was encrypted without it (before escrow was turned on here), so the escrow key does not open it. Use the password or the recovery key.",
  "e2e.fxe.escrow_other_key": "This file is sealed to the escrow key of a DIFFERENT installation, so this installation’s escrow key does not open it.",
  "e2e.fxe.wrong_escrow": "That escrow key does not open this file.",
  "e2e.fxe.escrow_notify_failed": "Could not notify the file’s owner, so the file was not opened. Escrow use is always announced.",
  "e2e.fxe.escrow_done": "Opened with the escrow key - the owner has been notified",
  /* wiring:e2 fxe purge - an administrator deletes the original for good */
  "e2e.fxe.seen_trash_admin": "The original goes to the trash and stays there until the trash retention period ends - unless you delete it for good below.",
  "e2e.fxe.seen_versions_admin": "Its earlier versions stay in its version history - unless you delete them for good below.",
  "e2e.fxe.purge_label": "Delete the original for good (administrator)",
  "e2e.fxe.purge_hint": "Its earlier versions and its trash entry are deleted as soon as the encrypted copy is saved, so no plaintext of it stays on this server. There is no undo. Backups and copies made before now are not reached.",
  "e2e.fxe.purge_others": "This file belongs to {owner}, not to you. Delete their original and its versions for good.",
  "e2e.fxe.purge_others_unknown": "This file has no recorded owner - it is not yours. Delete the original and its versions for good.",
  "e2e.fxe.purge_others_required": "Confirm that you are deleting someone else’s file for good.",
  "e2e.fxe.purge_no_id": "This file is not in the catalog yet, so it cannot be deleted for good. Refresh the folder and try again.",
  "e2e.fxe.purged": "“{name}” is encrypted. The original, its versions and its trash entry are deleted for good.",
  "e2e.fxe.purge_failed": "The encrypted copy of “{name}” is saved, but the original could not be deleted for good ({reason}). Delete it from the trash and its version history.",
  /* wiring:e2 fxe big - a decrypted download too large for this browser's memory */
  "e2e.big.title": "Too large to decrypt in this browser",
  "e2e.big.lead": "“{name}” is {size} once decrypted. This browser decrypts a download in its memory and can hold at most {limit} of it, so nothing was downloaded.",
  "e2e.big.lead_grew": "“{name}” grew past {limit} while it was being decrypted. This browser decrypts a download in its memory and cannot hold more, so nothing was saved.",
  "e2e.big.instead": "Decrypt it on your own computer instead:",
  "e2e.big.step_file": "Download the encrypted file, as it is (the button below).",
  "e2e.big.step_folder": "Download the encrypted folder as a zip (the button below) - it carries the folder’s key file.",
  "e2e.big.step_run": "In the folder you saved it to, run filex decrypt and give it the password:",
  "e2e.big.copy": "Copy",
  "e2e.big.copied": "Copied",
  "e2e.big.other_ways": "Chrome, Edge and the filex desktop app decrypt straight to disk, whatever the size.",
  "e2e.big.close": "Close",
  "e2e.big.download_file": "Download encrypted file",
  "e2e.big.download_folder": "Download encrypted folder (zip)",
  /* /wiring:e2 fxe */
  /* ── dil:paket - accessible names that were English literals */
  "breadcrumb.aria": "Breadcrumb",
  "e2e.recovery_key_aria": "Recovery key",
  "modal.close": "Close",
  "modal.busy_close.keep": "Keep going",
  "modal.busy_close.confirm": "Stop and close",
  /* ── the bell and the account menu (2026-09-27: moved here from the admin
     app so the desktop app's explorer draws the same ones). ⚠ SHARED keys:
     the admin app's catalogue has every one of them under the same name, with
     the same English and Turkish (web/tests/i18n/langPackCatalogue.test.ts),
     so a language pack translates each once for both screens. */
  "notifications.bell": "Notifications",
  "notifications.unreadCount": "{n} unread",
  "notifications.title": "Notifications",
  "notifications.markAllRead": "Mark all read",
  "notifications.markRead": "Mark read",
  "notifications.empty": "No notifications yet",
  "notifications.viewAll": "View all",
  "notifications.manageAdmin": "Manage notifications",
  "notifications.openTarget": "Open what this is about",
  "notifications.unreadOnly": "Unread only",
  "notifications.pageOf": "Page {page} of {pages} · {total} in total",
  "notifications.severity.info": "Info",
  "notifications.severity.warning": "Warning",
  "notifications.severity.error": "Error",
  "notifications.severity.critical": "Critical",
  "common.prev": "Previous",
  "common.next": "Next",
  "explore.account": "Account",
  /* ── the user settings dialog (2026-09-27: moved here from the admin app
     so the desktop app opens the same dialog inside its window). ⚠ SHARED
     keys: the admin app's catalogue has each under the same name with the same
     English and Turkish (web/tests/i18n/langPackCatalogue.test.ts). An
     account field's refusal is the server's sentence (POST
     /api/auth/account/check, lib/accountRules), not a key here. */
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.confirm": "Confirm",
  "common.currentPassword": "Current password",
  "common.email": "Email",
  "common.loading": "Loading…",
  "common.newPassword": "New password",
  "common.remove": "Remove",
  "common.save": "Save",
  "common.saving": "Saving…",
  "errors.generic": "Something went wrong",
  "errors.validationFailed": "Please check the highlighted fields",
  "install.desktopAllDownloads": "All downloads and release notes",
  "install.desktopSubtitle": "Sync folders to this computer and keep them up to date in the background. Available for {platform}.",
  "install.install": "Install",
  "install.menuInstructions": "Open your browser's menu and choose “Install app” or “Add to Home screen”.",
  "install.iosInstructions": "Tap Share (on iOS 26: ⋯, then Share), then “Add to Home Screen” and Add.",
  "nav.themeAuto": "Auto",
  "nav.themeDark": "Dark",
  "nav.themeLight": "Light",
  "notifications.prefs.browser": "Browser notifications",
  "notifications.prefs.browserHint": "Raise a notification outside the tab when something new arrives. Clicking it opens the file, folder or share it is about.",
  "notifications.prefs.desktopHandled": "The desktop app shows these itself",
  "notifications.prefs.enableBrowser": "Allow notifications",
  "notifications.prefs.inApp": "In-app bell",
  "notifications.prefs.inAppHint": "Turning this off empties your bell. Nothing stops being recorded - an admin still sees every event.",
  "notifications.prefs.iosHomeScreen": "On an iPhone or iPad, notifications work in {name} added to the Home Screen (iOS 16.4 or later), not in a browser tab.",
  "notifications.prefs.movedToSettings": "Your own notification settings - the bell, browser pop-ups, which events - are in your user settings.",
  "notifications.prefs.openSettings": "Open my notification settings",
  "notifications.prefs.permDefault": "Permission not asked yet",
  "notifications.prefs.permDenied": "Blocked by this browser",
  "notifications.prefs.permDeniedHint": "Re-allow notifications for this site in your browser settings.",
  "notifications.prefs.permGranted": "Allowed by this browser",
  "notifications.prefs.permUnsupported": "This browser cannot show notifications",
  "notifications.prefs.push": "Push notifications on this device",
  "notifications.prefs.pushAdded": "Added {date}",
  "notifications.prefs.pushDevices": "Devices that receive push notifications",
  "notifications.prefs.pushDisabled": "Turned off on the server (FILEX_PUSH_ENABLED).",
  "notifications.prefs.pushFailed": "Push notifications could not be turned on for this device.",
  "notifications.prefs.pushHint": "What your bell tells you reaches this phone or browser even while {name} is closed - the same notifications, at the same moment.",
  "notifications.prefs.pushKeyUnreadable": "The server's push key no longer opens (FILEX_SECRET_KEY changed). Rotate it under Admin → Notifications.",
  "notifications.prefs.pushNoSecretKey": "Push notifications need FILEX_SECRET_KEY on the server: the key they are signed with is stored encrypted with it.",
  "notifications.prefs.pushOn": "On for this device",
  "notifications.prefs.pushRemove": "Remove",
  "notifications.prefs.pushRemoveLabel": "Remove {device}",
  "notifications.prefs.pushTest": "Send a test",
  "notifications.prefs.pushTestNone": "No device took the test.",
  "notifications.prefs.pushTestSent": "Test sent to {count} devices",
  "notifications.prefs.pushTestSent_one": "Test sent to {count} device",
  "notifications.prefs.pushThisDevice": "This device",
  "notifications.prefs.pushUnavailable": "Not available on this server",
  "notifications.prefs.pushUnnamed": "A device",
  "notifications.prefs.pushUnsupported": "This browser cannot receive push notifications",
  "notifications.prefs.saved": "Preference saved",
  "notifications.prefs.title": "Your notifications",
  "profile.avatar.change": "Change photo",
  "profile.avatar.failed": "That image could not be processed - try another one.",
  "profile.avatar.help": "Shown next to your name, and in the file explorer's collaboration bar - on every client signed in as you. Resized to 160px automatically.",
  "profile.avatar.label": "Profile picture",
  "profile.avatar.notImage": "Please choose an image file.",
  "profile.locale": "Language",
  "profile.passwordChanged": "Password changed",
  "profile.saved": "Profile saved",
  "profile.totp.code": "Verification code",
  "profile.totp.disable": "Disable 2FA",
  "profile.totp.disabled": "Disabled",
  "profile.totp.enable": "Enable 2FA",
  "profile.totp.enabled": "Enabled",
  "profile.totp.recoveryHint": "Save these now - each one signs you in once if you lose your authenticator. They are shown only this time.",
  "profile.totp.recoveryTitle": "Recovery codes",
  "profile.totp.scanHint": "Scan this QR code with your authenticator app, then enter the 6-digit code.",
  "profile.totp.title": "Two-factor authentication",
  "profile.username.label": "Username",
  "quota.title": "Storage quota",
  "quota.tooltip": "{used} of {limit} used ({percent})",
  "quota.unlimitedTooltip": "{used} used · unlimited",
  "userSettings.adminBadge": "Admin",
  "userSettings.demoReadOnly": "This is a shared demo account, so its profile, password and second factor cannot be changed.",
  "userSettings.footNote.ai": "There is nothing on this tab to save.",
  "userSettings.footNote.notifications": "Saved as you change them.",
  "userSettings.footNote.preferences": "Saved as you change them.",
  "userSettings.footNote.profile": "Changes on this tab are saved when you press Save.",
  "userSettings.footNote.security": "Each action here applies on its own.",
  "userSettings.heading": "User settings",
  "userSettings.headingSub": "Manage your profile, preferences, and security.",
  "userSettings.notifications.adminAlerts": "Administrator alerts",
  "userSettings.notifications.adminAlertsHint": "Updates, replicas, sign-in providers, tenant domains and the other alerts for administrators",
  "userSettings.notifications.device": "Desktop notifications",
  "userSettings.notifications.deviceHint": "Your computer's own notifications when something new arrives, also while filex runs in the background.",
  "userSettings.notifications.digestHint": "Kinds marked urgent reach you at once. The rest are held for {minutes} min and arrive as one summary, folder by folder.",
  "userSettings.notifications.digestOffHint": "Every kind reaches you at once. Turn Urgent off for a kind to get it in one summary instead, folder by folder.",
  "userSettings.notifications.events.archive_created": "An archive finishes being created",
  "userSettings.notifications.events.archive_extracted": "An archive finishes extracting",
  "userSettings.notifications.events.comment_added": "Someone comments on a file",
  "userSettings.notifications.events.drop_received": "A file arrives through a request link",
  "userSettings.notifications.events.e2e_escrow_used": "An encrypted folder is opened with the escrow key",
  "userSettings.notifications.events.e2e_password_changed": "The password of your encrypted folder is changed",
  "userSettings.notifications.events.e2e_request_created": "Someone asks to encrypt a folder or a file",
  "userSettings.notifications.events.e2e_request_decided": "Your encryption request is answered",
  "userSettings.notifications.events.file_deleted": "A file is deleted for good",
  "userSettings.notifications.events.file_infected": "A virus is found in a file",
  "userSettings.notifications.events.file_moved": "A file is moved or renamed",
  "userSettings.notifications.events.file_trashed": "A file goes to the trash",
  "userSettings.notifications.events.file_updated": "A file is changed",
  "userSettings.notifications.events.file_upload_failed": "An upload does not finish",
  "userSettings.notifications.events.file_uploaded": "A new file arrives",
  "userSettings.notifications.events.notification_digest": "A summary of the notifications I did not mark urgent",
  "userSettings.notifications.events.plugin_notice": "An installed app sends you a message",
  "userSettings.notifications.events.share_created": "Someone creates a share link",
  "userSettings.notifications.eventsHint": "Turning one off keeps it out of your bell. Nothing stops being recorded - an administrator still sees every event.",
  "userSettings.notifications.eventsTitle": "What to tell me about",
  "userSettings.notifications.urgent": "Urgent",
  "userSettings.notifications.urgentFor": "Tell me at once: {event}",
  "userSettings.open": "User settings",
  "userSettings.prefs.appearance": "Appearance",
  "userSettings.prefs.compact": "Use compact file list",
  "userSettings.prefs.compactHint": "Tighter rows in the file explorer.",
  "userSettings.prefs.remoteImages": "Load remote images in previews",
  "userSettings.prefs.remoteImagesHint": "Pictures from other servers in a file's preview load without asking. Off, each one waits for a click, because loading it tells that server the file was opened. Thumbnails never load them.",
  "userSettings.prefs.desktopApp": "Desktop app",
  "userSettings.prefs.desktopAppHint": "The reminder in the corner of the app can be closed for good - these downloads stay here.",
  "userSettings.prefs.folderView": "Default folder view",
  "userSettings.prefs.folderViewHint": "How a folder you have never changed opens. A folder you have changed keeps its own view - changing this does not touch it.",
  "userSettings.prefs.fvColumns": "Your default columns are customized (set with “Make this my default for all folders”).",
  "userSettings.prefs.fvColumnsReset": "Reset them",
  "userSettings.prefs.fvDir": "Direction",
  "userSettings.prefs.fvDir_asc": "Ascending",
  "userSettings.prefs.fvDir_desc": "Descending",
  "userSettings.prefs.fvForget": "Forget them all",
  "userSettings.prefs.fvInherit": "Server default ({value})",
  "userSettings.prefs.fvMode": "View",
  "userSettings.prefs.fvSort": "Sort by",
  "userSettings.prefs.fvSort_modified": "Modified",
  "userSettings.prefs.fvSort_name": "Name",
  "userSettings.prefs.fvSort_size": "Size",
  "userSettings.prefs.fvSort_type": "Type",
  "userSettings.prefs.fvView_gallery": "Gallery",
  "userSettings.prefs.fvView_grid": "Grid",
  "userSettings.prefs.fvView_list": "List",
  "userSettings.prefs.installApp": "Install as a web app",
  "userSettings.prefs.installAppLead": "Put {name} on this device's home screen: it opens in a window of its own, like an app.",
  "userSettings.prefs.languageHint": "Applies here right away, and is saved on your account for the next browser you sign in from.",
  "userSettings.prefs.mode": "Light or dark",
  "userSettings.prefs.modeHint": "Which variant is painted. Auto follows your operating system.",
  "userSettings.prefs.openTrigger": "Open files with",
  "userSettings.prefs.openTriggerDouble": "Double-click",
  "userSettings.prefs.openTriggerHint": "How a mouse opens a file. On a touchscreen a tap always opens, and the checkbox always selects.",
  "userSettings.prefs.openTriggerSingle": "Single-click",
  "userSettings.prefs.palette": "Color palette",
  "userSettings.prefs.paletteHint": "Which colors that variant is made of. Every palette has a light and a dark version, so this and the setting above work together.",
  "userSettings.prefs.shortcuts": "Keyboard shortcuts",
  "userSettings.prefs.shortcutsEdit": "Edit…",
  "userSettings.prefs.shortcutsHint": "The keys the file manager answers to.",
  "userSettings.prefs.startPage": "Start page",
  "userSettings.prefs.startPageHint": "Where filex opens when you sign in or go to the front door. Following a link straight to a page still takes you there.",
  "userSettings.prefs.startPage_admin": "Admin panel",
  "userSettings.prefs.startPage_files": "Files",
  "userSettings.prefs.startPage_home": "Home",
  "userSettings.prefs.timezone": "Time zone",
  "userSettings.prefs.timezoneHint": "Dates are stored as a moment in time and shown on the clock you pick here, so everyone sees the same instant on their own clock. Saved to your account, so it follows you to another browser.",
  "userSettings.prefs.timezoneNow": "Right now in {zone}: {time}",
  "userSettings.saveChanges": "Save changes",
  "userSettings.scope.account": "Account",
  "userSettings.scope.accountHint": "Saved on your account: the same wherever you sign in.",
  "userSettings.scope.device": "This device",
  "userSettings.scope.deviceHint": "Saved on this device only: another computer, phone or browser keeps its own.",
  "userSettings.scope.deviceNotifyHint": "How this device tells you about something new, saved on this device only.",
  "userSettings.scope.myAccount": "My account",
  "userSettings.scope.myAccountHint": "What reaches your bell, saved on your account.",
  "userSettings.security.passwordTitle": "Change password",
  "userSettings.security.totpDisabled": "Two-factor authentication is off",
  "userSettings.security.totpEnabled": "Two-factor authentication is on",
  "userSettings.subtitle.ai": "Nothing for you to set here yet.",
  "userSettings.subtitle.notifications": "What reaches your bell, and what reaches your desktop.",
  "userSettings.subtitle.preferences": "How this app looks and reads on your devices.",
  "userSettings.subtitle.profile": "Your name, email and picture - what other people see.",
  "userSettings.subtitle.security": "Your password and second factor.",
  "userSettings.tabs.ai": "AI assistant",
  "userSettings.ai.state.on": "The assistant is on.",
  "userSettings.ai.state.off": "The assistant is turned off on this server.",
  "userSettings.ai.state.not_configured": "The administrator has not set the assistant up yet.",
  "userSettings.ai.state.not_permitted": "The assistant is on, but your role does not include it.",
  "userSettings.ai.provider": "Who reads what you write",
  "userSettings.ai.providerHint": "Your messages, and the files the assistant reads for you, are sent to this provider. Every file it reads is in the audit log.",
  "userSettings.ai.confirmAll": "Ask me before every change",
  "userSettings.ai.confirmAllHint": "Off: changes that can be undone (move, rename, edit, delete to the trash) happen at once, with an Undo. On: they wait for your approval too. Anything that cannot be undone always waits.",
  "userSettings.ai.history": "Conversation history",
  "userSettings.ai.retention": "Conversations are kept on the server for {count} days after they were last used.",
  "userSettings.ai.retention_one": "Conversations are kept on the server for {count} day after they were last used.",
  "userSettings.ai.clear": "Delete my conversations",
  "userSettings.ai.clearConfirm": "Delete them all for good?",
  "userSettings.ai.cleared": "Your conversations were deleted.",
  "userSettings.ai.saveFailed": "That could not be saved.",
  "userSettings.tabs.notifications": "Notifications",
  "userSettings.tabs.preferences": "Preferences",
  "userSettings.tabs.profile": "Profile",
  "userSettings.tabs.security": "Security",
  "userSettings.apps.title": "Default apps",
  "userSettings.apps.lead": `Choose one in a file's menu: Open with, Choose an app…, then tick "Always use this app". Only the apps your administrator left on for a kind are offered.`,
  "userSettings.apps.empty": "You have not chosen an app for any kind of file yet: every file opens with what your administrator put first.",
  "userSettings.apps.reset": "Reset",
  "userSettings.apps.resetAll": "Reset all",
  "userSettings.apps.unavailable": "No longer available: it opens with {app} until you choose again.",
  "userSettings.apps.change": "The app that opens {ext} files",
  "userSettings.title": "User settings",
  "users.fields.displayName": "Display name",
  "profile.username.helpText": "Your username. You can sign in with it or with your email - and connection clients (SFTP, FTP) need it, because an @ in the name they sign in with has to be escaped in their config files.",
  "userSettings.prefs.fvKeptCount": "{count} folders keep a view of their own.",
  "userSettings.prefs.fvKeptCount_one": "{count} folder keeps a view of its own."
}, f2 = {
  "toolbar.new_folder": "Yeni klasör",
  "toolbar.upload": "Yükle",
  "toolbar.search": "Ara",
  "toolbar.search.placeholder": "Ada ya da tag: ile ara…",
  "toolbar.view.list": "Liste",
  "toolbar.view.grid": "Izgara",
  "toolbar.refresh": "Yenile",
  "toolbar.go_up": "Üst klasör",
  "ctx.open": "Aç",
  "ctx.preview": "Önizle",
  "ctx.download": "İndir",
  "ctx.archive_create": "Arşiv oluştur…",
  "ctx.archive_extract": "Arşivi çıkar…",
  "ctx.rename": "Yeniden adlandır",
  "ctx.delete": "Sil",
  "ctx.delete_perm": "Kalıcı olarak sil",
  "ctx.restore": "Geri getir",
  "ctx.share": "Paylaş",
  "ctx.move": "Taşı",
  "ctx.copy": "Kopyala",
  "ctx.cut": "Kes",
  "ctx.show_hidden": "Gizli dosyaları göster",
  "ctx.hide_hidden": "Gizli dosyaları gizle",
  "ctx.keep_local": "Bilgisayarda tut",
  "ctx.keep_online": "Yalnızca çevrimiçi tut",
  "ctx.keep_reveal": "Yerel klasörü aç",
  "ctx.keep_inherited": "Üst klasörle bilgisayarda tutuluyor",
  "keep.started": "Bilgisayarda tutulacak - eşitleme başladı",
  "keep.failed": "Bilgisayarda tutulamadı",
  "keep.badge_kept": "Bilgisayarda",
  "keep.badge_syncing": "Eşitleniyor…",
  "keep.badge_cloud": "Yalnızca çevrimiçi",
  "keep.badge_partial": "İçinde bilgisayarda tutulanlar var",
  "keep.strip_transfer": "{name} eşitleniyor - {done}/{total} (%{pct})",
  "keep.strip_inventory": "{name} eşitleniyor - sunucu taranıyor…",
  "keep.strip_settling": "{name} eşitleniyor - son durum kaydediliyor…",
  "ctx.paste": "Yapıştır",
  "ctx.info": "Bilgi",
  "ctx.duplicate": "Kopyasını oluştur",
  "ctx.new_file": "Yeni dosya",
  "modal.delete.title": "Silinsin mi?",
  "modal.delete.message": "{count} öğe çöpe atılacak.",
  "modal.delete.message_one": "{count} öğe çöpe atılacak.",
  "modal.delete.confirm": "Çöpe at",
  "modal.delete.working": "Çöpe taşınıyor…",
  "modal.delete.cancel": "Vazgeç",
  "modal.delete.permanent_title": "Kalıcı olarak silinsin mi?",
  "modal.delete.permanent_message": "{count} öğe kalıcı olarak silinecek. Bu geri alınamaz.",
  "modal.delete.permanent_message_one": "{count} öğe kalıcı olarak silinecek. Bu geri alınamaz.",
  "modal.delete.permanent_confirm": "Kalıcı olarak sil",
  "modal.delete.permanent_working": "Siliniyor…",
  "modal.rename.title": "Yeniden adlandır",
  "modal.rename.save": "Kaydet",
  "modal.rename.saving": "Yeniden adlandırılıyor…",
  "modal.rename.cancel": "Vazgeç",
  "modal.rename.empty": "Bir ad yazın.",
  "modal.newfolder.title": "Yeni klasör",
  "modal.newfolder.placeholder": "Klasör adı",
  "modal.newfolder.create": "Oluştur",
  "modal.newfolder.creating": "Oluşturuluyor…",
  "modal.newfolder.cancel": "Vazgeç",
  "modal.share.title": "Paylaşım bağlantısı",
  "archive.create_title": "Arşiv oluştur",
  "archive.extract_title": "Arşivi çıkar",
  "archive.create_count": "{count} öğe seçildi",
  "archive.create_count_one": "{count} öğe seçildi",
  "archive.filename": "Arşiv adı",
  "archive.format": "Biçim",
  "archive.password_optional": "Parola (isteğe bağlı)",
  "archive.password_confirm": "Parolayı doğrula",
  "archive.password_mismatch": "Parolalar birbiriyle eşleşmiyor.",
  "archive.encrypt_names": "Dosya adlarını şifrele",
  "archive.compression": "Sıkıştırma",
  "archive.solid": "Katı arşiv oluştur",
  "archive.dictionary_size": "Sözlük boyutu",
  "archive.dictionary_size_value": "{n} MiB",
  "archive.dictionary_hint": "Daha büyük sözlükler sıkıştırmayı iyileştirebilir ancak oluşturma ve çıkarma sırasında daha fazla bellek kullanır.",
  "archive.destination_folder": "Çıkarılacak klasör",
  "archive.create": "Oluştur",
  "archive.creating": "Oluşturuluyor…",
  "archive.extract": "Çıkar",
  "archive.extract_here": "Buraya çıkar",
  "archive.extract_to_folder": "Klasöre çıkar",
  "archive.extracting": "Çıkarılıyor…",
  "archive.cancel": "Vazgeç",
  "archive.invalid_name": "Eğik çizgi içermeyen bir dosya adı girin.",
  "archive.invalid_extension": "Arşiv adı kullanılabilir biçim uzantılarından biriyle bitmelidir.",
  "archive.invalid_folder": "Eğik çizgi içermeyen bir klasör adı girin.",
  "archive.password_required": "Bu arşiv için parola gerekiyor.",
  "archive.password_title": "Arşiv parolası",
  "archive.continue": "Devam et",
  "archive.opening": "Açılıyor…",
  "archive.bad_password": "Arşiv parolası yanlış.",
  "archive.target_exists": "Bu ada sahip bir öğe zaten var. Başka bir ad seçin veya önce mevcut öğeyi kaldırın.",
  "archive.password_charset": "ZIP parolasında yalnızca ASCII karakterler kullanılabilir; ç, ğ, ı, İ, ö, ş, ü gibi harfler kullanılamaz. Her karakteri kullanmak için 7z biçimini seçin.",
  "archive.error_unsupported": "Bu arşiv çıkarılamıyor: bu sunucu biçimini okuyamıyor ya da içinde filex’in çıkarmadığı bir şey var (bağlantı, özel dosya ya da boyutunu belirtmeyen bir dosya).",
  "archive.error_limit": "Bu arşiv, sunucunun çıkarmaya izin verdiği boyutu aşıyor.",
  "archive.error_unavailable": "Bu sunucu şu anda bu tür bir arşivi açamıyor.",
  "archive.created": "Arşiv oluşturuldu",
  "archive.queued": "Arşiv oluşturma arka planda çalışıyor",
  "archive.extracted": "{count} dosya çıkarıldı",
  "archive.extracted_one": "{count} dosya çıkarıldı",
  "archive.extraction_queued": "Arşiv çıkarma arka planda çalışıyor",
  "archive.preparing_extract": "{name} okunuyor… çıkarılmadan önce arşivin tamamı okunur.",
  "archive.already_preparing": "{name} hâlâ okunuyor - okuma bitince bir kez çıkarılacak",
  "archive.extraction_completed": "Çıkarma tamamlandı",
  "archive.extraction_cancelled": "Çıkarma {count} dosyadan sonra iptal edildi",
  "archive.extraction_cancelled_one": "Çıkarma {count} dosyadan sonra iptal edildi",
  "modal.share.pin": "PIN koruması",
  "modal.share.expires": "Son kullanma",
  "modal.share.max_downloads": "İndirme limiti",
  "modal.share.create": "Paylaş",
  "modal.share.cancel": "Vazgeç",
  "modal.share.close": "Kapat",
  "modal.share.limit_applied": "(sunucu sınırı uygulandı)",
  "modal.share.copy": "Kopyala",
  "modal.share.url_copied": "Bağlantı kopyalandı",
  "modal.share.pin_copied": "PIN kopyalandı",
  "modal.share.cli_copied": "CLI komutu kopyalandı",
  "upload.progress": "Yükleniyor",
  "upload.done": "Tamamlandı",
  "upload.error": "Hata",
  "upload.failed": "“{name}” yüklenemedi",
  "upload.aborted": "İptal edildi",
  "upload.cancel": "İptal",
  "upload.resuming": "“{name}” %{percent} noktasından devam ediyor",
  "upload.saving": "Depoya kaydediliyor…",
  "empty.folder": "Bu klasör boş",
  "empty.search": "Sonuç bulunamadı",
  loading: "Yükleniyor…",
  "notFound.title": "Klasör bulunamadı",
  "notFound.desc": "Bu klasör mevcut değil, taşınmış ya da erişim yetkiniz yok.",
  "notFound.goRoot": "Kök klasöre dön",
  "col.name": "Ad",
  "col.size": "Boyut",
  "col.modified": "Değiştirilme",
  "col.type": "Tür",
  "unit.bytes": "B",
  "unit.kb": "KB",
  "unit.mb": "MB",
  "unit.gb": "GB",
  "unit.tb": "TB",
  "unit.pb": "PB",
  "breadcrumb.root": "Kök",
  "breadcrumb.copy_path": "Yolu kopyala",
  "breadcrumb.go_to_path": "Yola git",
  "breadcrumb.path_placeholder": "fileman/foo/bar",
  "ops.copy": "Kopyalanıyor",
  "ops.move": "Taşınıyor",
  "ops.delete": "Siliniyor",
  "ops.queued": "sırada",
  "ops.done": "tamamlandı",
  "ops.error": "hata",
  "node.trash": "Çöp kutusu",
  "node.folder": "Klasör",
  // --- Zengin önizleyici chrome ---
  "viewer.open_in_new_tab": "Yeni sekmede aç",
  "viewer.loading": "Yükleniyor…",
  "viewer.failed_to_load": "Dosya yüklenemedi",
  "viewer.peer_not_installed": "Bu tür bir dosya burada gösterilemiyor. Cihazınızda açmak için indirin.",
  "viewer.remote_image.label": "Uzak görsel",
  "viewer.remote_image.title": "Uzak görsel yüklensin mi?",
  "viewer.remote_image.body": "Bu görsel başka bir sunucuda. Yüklerseniz o sunucu bu dosyanın açıldığını ve IP adresinizi öğrenir.",
  "viewer.remote_image.setting_hint": "Sormadan yüklenmeleri için Kullanıcı ayarları → Tercihler bölümünde “Önizlemelerde uzak görselleri yükle” seçeneğini açın.",
  "viewer.remote_image.load": "Görseli yükle",
  "viewer.remote_image.load_all": "Bu dosyadaki tüm uzak görselleri yükle",
  "viewer.remote_image.book_held": "Bu kitapta başka sunuculardaki görseller yüklenmedi.",
  "viewer.remote_image.book_load": "Uzak görselleri yükle…",
  "viewer.format_unsupported_3d": "Önizleme yalnızca .glb, .gltf ve .usdz biçimindeki 3B modelleri gösterir. Dosyayı indirip bir 3B programında açın.",
  "viewer.zoom_in": "Yakınlaştır",
  "viewer.zoom_out": "Uzaklaştır",
  "viewer.fit_width": "Sayfa genişliğine sığdır",
  "viewer.next_page": "Sonraki sayfa",
  "viewer.prev_page": "Önceki sayfa",
  "viewer.page_n_of_m": "Sayfa {n} / {m}",
  "viewer.tags": "Etiketler",
  "viewer.layers": "Katmanlar",
  "viewer.toc": "İçindekiler",
  "viewer.font_smaller": "Yazıyı küçült",
  "viewer.font_larger": "Yazıyı büyüt",
  "viewer.search": "Ara",
  "viewer.download": "İndir",
  "viewer.saving": "Kaydediliyor…",
  "viewer.save": "Kaydet (Ctrl+S)",
  "viewer.saved": "Kaydedildi",
  "viewer.save_error": "Hata",
  "viewer.editor_loading": "Editör yükleniyor…",
  "viewer.no_preview": "Bu dosya tipi için önizleme henüz yok.",
  "viewer.edit": "Düzenle",
  "viewer.close": "Kapat",
  "presence.expand": "Adları göster",
  "presence.collapse": "Küçült",
  "viewer.save_annotations": "Açıklamaları kaydet",
  "viewer.annotations_on": "Açıklamalar: açık",
  "viewer.annotations_off": "Açıklamalar: kapalı",
  "viewer.read_only": "Salt okunur",
  "viewer.csv_first_row_header": "İlk satır başlık olsun",
  "viewer.csv_filter": "Satır filtrele…",
  "viewer.epub_prev": "Önceki",
  "viewer.epub_next": "Sonraki",
  /* ⚠ Eski cümle her okuyucuya bir ORTAM DEĞİŞKENİ söylüyordu ("yönetici
     FILEX_DRAWIO_URL'yi ayarlamalı"). Yalnızca bir diyagrama bakmak isteyen
     kişiye ne yapabileceği; `_admin` - düzeltebilecek kişiye - nereden
     düzelteceği söylenir. */
  "viewer.drawio.disabled": "Diyagramlar burada açılamıyor: bu sunucuda draw.io yok. Başka bir yerde açmak için dosyayı indirin.",
  "viewer.drawio.disabled_admin": "Bu sunucuda draw.io kurulu değil. Yönetim panelinde Dış servisler altından kurabilirsiniz.",
  "viewer.drawio.load_failed": "Bu diyagram okunamadı. Başka bir yerde açmak için indirin.",
  "viewer.drawio.save_failed": "Diyagram kaydedilemedi. Değişiklikleriniz hâlâ düzenleyicide - yeniden deneyin.",
  "viewer.archive.entries": "{n} dosya",
  "viewer.archive.entries_one": "{n} dosya",
  "viewer.archive.empty": "Arşiv boş.",
  "viewer.archive.error": "Arşiv okunamadı.",
  "viewer.archive.unsupported": "Bu tür bir arşiv burada listelenemiyor. İçinde ne olduğunu görmek için indirin.",
  "viewer.archive.too_large": "Bu arşiv burada listelenemeyecek kadar büyük. İçinde ne olduğunu görmek için indirin.",
  "viewer.archive.open": "Arşivi aç",
  "viewer.archive.root": "Arşiv",
  "viewer.archive.location": "Arşiv konumu",
  "viewer.archive.reading": "Hâlâ okunuyor… İçeriği listelenmeden önce arşivin tamamı okunur; büyük bir arşivde bu biraz sürer.",
  "viewer.name": "Ad",
  "viewer.size": "Boyut",
  // --- cila:a - sıralama / tarih grupları / yoğunluk ---
  "col.sort": "Sırala",
  "group.today": "Bugün",
  "group.yesterday": "Dün",
  "group.this_week": "Bu hafta",
  "group.this_month": "Bu ay",
  "group.no_date": "Tarihsiz",
  "toolbar.density.compact": "Sıkışık görünüm",
  "toolbar.density.comfortable": "Rahat görünüm",
  // --- cila:c - komut paleti + kısayol yardımı + breadcrumb ---
  "palette.placeholder": "Dosya, klasör veya komut ara…",
  "palette.files": "Dosyalar",
  "palette.commands": "Komutlar",
  "palette.goto": "Yola git",
  "palette.empty": "Sonuç bulunamadı",
  "palette.hint": "↑↓ gezin · Enter seç · Esc kapat",
  "cmd.view_toggle": "Görünümü değiştir (liste ⇄ ızgara)",
  "cmd.trash": "Çöp kutusunu aç",
  "shortcuts.title": "Klavye kısayolları",
  "shortcuts.group.nav": "Gezinme",
  "shortcuts.group.selection": "Seçim",
  "shortcuts.group.file": "Dosya işlemleri",
  "shortcuts.palette": "Komut paleti",
  "shortcuts.search": "Aramaya odaklan",
  "shortcuts.go_up": "Üst klasöre çık",
  "shortcuts.open": "Seçili öğeyi aç",
  "shortcuts.close": "Kapat / vazgeç",
  "shortcuts.toggle_hidden": "Gizli dosyaları göster/gizle",
  "shortcuts.help": "Bu yardım penceresi",
  "shortcuts.select_all": "Tümünü seç",
  "shortcuts.star": "Yıldızla / yıldızı kaldır",
  "shortcuts.rename": "Yeniden adlandır",
  "shortcuts.delete": "Sil",
  "shortcuts.cut": "Kes",
  "shortcuts.copy": "Kopyala",
  "shortcuts.paste": "Yapıştır",
  "breadcrumb.more": "Aradaki klasörler",
  // --- State screens + undo snackbar + connection badge (cila:b) ---
  "empty.hint": "Dosyaları buraya sürükleyip bırakın",
  "empty.upload": "Dosya yükle",
  "empty.search.title": "Aramanızla eşleşen dosya yok",
  "empty.search.hint": "Farklı bir arama terimi deneyin",
  "empty.trash.title": "Çöp kutusu boş",
  "error.title": "Liste yüklenemedi",
  "error.retry": "Yeniden dene",
  "toast.undo": "Geri al",
  "toast.undone": "Geri alındı",
  "toast.undoing": "Geri alınıyor…",
  "toast.undo_queued": "Geri alma kuyruğa alındı - bittiğini işlemler paneli gösterecek",
  "toast.undo_failed": "Geri alınamadı",
  "toast.renamed": "Yeniden adlandırıldı",
  "toast.rename_queued": "“{name}” olarak yeniden adlandırılıyor…",
  "toast.moved": "Taşındı",
  "toast.trashed": "Çöpe taşındı",
  /* i18n:hardcoded - FileExplorer.vue'da düz string olarak duran, hiçbir dilin
     değiştiremediği bildirim metinleri. */
  "toast.failed": "İşlem başarısız",
  "err.status.400": "Geçersiz istek",
  "err.status.401": "Oturum açmanız gerekiyor",
  "err.status.403": "Bu işlem için yetkiniz yok",
  "err.status.404": "Bulunamadı",
  "err.status.409": "Zaten var / çakışma",
  "err.status.413": "Dosya çok büyük",
  "err.status.415": "Bu dosya türü desteklenmiyor",
  "err.status.422": "Geçersiz veri",
  "err.status.429": "Çok fazla istek, biraz bekleyin",
  "err.status.500": "Sunucu hatası",
  "err.status.501": "Bu işlem desteklenmiyor",
  "err.status.502": "Bağlı bir servis hata verdi",
  "err.status.503": "Servis şu an kullanılamıyor",
  "err.status.504": "Bağlı bir servis zamanında yanıt vermedi",
  "err.status.other": "Sunucu bu isteği kabul etmedi.",
  "err.upload_stalled": "Yükleme ilerlemeyi bıraktı. Yeniden deneyin - kaldığı yerden devam eder.",
  "err.network": "Sunucuya ulaşılamadı. Bağlantınızı kontrol edip yeniden deneyin.",
  /* 0.54: sunucunun adını verdiği ret, sunucunun cümlesiyle söylenir (`message`, server.error.*). */
  "err.save_failed": "Değişiklikleriniz kaydedilemedi.",
  "err.load_failed": "Bu dosya yüklenemedi.",
  "err.viewer_failed": "Bu dosyanın görüntüleyicisi başlatılamadı. Açmak için dosyayı indirin.",
  "err.detail": "Ayrıntı",
  "toast.copied": "Kopyalandı",
  "toast.deleted": "Silindi",
  "toast.cut": "Kesildi",
  "toast.cut_ready": "Kes → Yapıştır hazır",
  "toast.copy_ready": "Kopyala → Yapıştır hazır",
  "toast.same_folder_cut": "Aynı klasöre kesilemez",
  "toast.restored": "{n} öğe geri getirildi",
  "toast.restored_one": "{n} öğe geri getirildi",
  "toast.delete_queued": "Silme kuyruğa alındı",
  "toast.trash_retention": "Çöpteki öğeler saklama süresi sonunda otomatik silinir. Kalıcı silme yönetici panelinden yapılır.",
  /* Kalıcı silinmesi yolda olan çöp satırı (yönetici Çöp sayfasının sözleri:
     iki katalogda tek cümle - ders #447). */
  "trash.purging": "Kalıcı olarak siliniyor…",
  "trash.row_busy": "Bu öğe üzerinde zaten bir iş sürüyor",
  "dropzone.hint": "Dosyaları buraya bırak",
  "modal.newfolder.invalid": "Geçersiz karakter",
  "names.reserved": "“{name}” adı filex’in kendi kullanımına ayrılmış. Başka bir ad seçin.",
  /* ⚠ Eksik ya da bozuk belge sunucusu kelimelerle söylenir, asla HTTP
     katmanıyla değil (eskiden `Config fetch 503: {"error":"onlyoffice not
     configured"}` yazıyordu). `_admin`, düzeltebilecek kişinin okuduğu -
     nereden düzelteceği; diğer herkes dosyayı yine de nasıl alacağını okur. */
  "viewer.office_unconfigured": "Ofis belgeleri burada açılamıyor: bu sunucuda ONLYOFFICE belge sunucusu yok. Dosyayı bilgisayarınızda açmak için indirin.",
  "viewer.office_unconfigured_admin": "Bu sunucuda ONLYOFFICE kurulu değil, bu yüzden ofis belgeleri burada açılamıyor. Yönetim panelinde Dış servisler altından kurabilirsiniz.",
  "viewer.office_unreachable": "Belge sunucusu şu anda yanıt vermiyor. Daha sonra yeniden deneyin ya da dosyayı indirin.",
  "viewer.office_unreachable_admin": "ONLYOFFICE belge sunucusu yanıt vermiyor. Yönetim panelinde Dış servisler altından kontrol edin.",
  /* Görev #92: düzenleyici başka bir kökendeki (belge sunucusunun kendi
     kökeni ya da arayüz kökeni) bir çerçevede çalışır ve o sayfa hiç yanıt
     vermedi - adres bu filex'e ulaşmıyor. */
  "viewer.office_frame_unreachable_admin": "ONLYOFFICE düzenleyici çerçevesi {origin} adresinden yüklenmedi. Oradaki vekil sunucunun çerçeveyi filex'e yönlendirdiğini kontrol edin ({env}).",
  "viewer.office_failed": "Bu belge ONLYOFFICE ile açılamadı. Bilgisayarınızda açmak için indirin.",
  "viewer.csv_office_note": "CSV olarak kaydedilir: yalnızca etkin sayfanın değerleri kalır. Biçimlendirme, formüller ve diğer sayfalar kaydedilmez.",
  "viewer.office_forbidden": "Bu belgeyi ONLYOFFICE ile açma izniniz yok.",
  /* ONLYOFFICE'in "Download failed" (İndirme başarısız) hatasından sonra:
     iki durumdan hangisi olduğu, filex'in gördüğüyle (lib/officeDiagnosis,
     #80). */
  "viewer.office_download_served": "Belge sunucusu bu dosyayı filex’ten indirdi, ancak tarayıcınız dönüştürülmüş kopyayı belge sunucusundan yükleyemedi. Belge sunucusunun önündeki vekil sunucunun X-Forwarded-Proto ve X-Forwarded-Host başlıklarına bakın.",
  "viewer.office_download_not_requested": "Belge sunucusu bu dosyayı filex’ten hiç istemedi. Dosya daha önce açıldıysa belge sunucusu kendi kopyasını kullanıyor olabilir.",
  "viewer.office_download_refused": "filex, belge sunucusunun bu dosya için yaptığı isteği şu nedenle reddetti: {reason}.",
  "viewer.office_fetch_reason.bad_link": "adres bozuktu",
  "viewer.office_fetch_reason.signature_expired": "adresin süresi dolmuştu",
  "viewer.office_fetch_reason.signature_bad": "imzası eşleşmedi (JWT sırrı değişti ya da adres değiştirildi)",
  "viewer.office_fetch_reason.not_found": "dosya artık yok",
  "viewer.office_fetch_reason.storage_unavailable": "depo açılamadı",
  "viewer.office_fetch_reason.body_unavailable": "dosyanın içeriği bulunamadı",
  "viewer.office_fetch_reason.object_missing": "dosya depoda yok",
  "viewer.office_fetch_reason.read_failed": "dosya depodan okunamadı",
  /* Gezginin "Aç" girdisi, belge sunucusu yokken - yalnızca yöneticiye
     gösterilir (diğer herkese girdi hiç sunulmaz; lib/serviceGate). */
  "ctx.needs_onlyoffice": "ONLYOFFICE kurulu değil - yönetim panelinde Dış servisler altından kurun.",
  "ctx.needs_drawio": "draw.io kurulu değil - yönetim panelinde Dış servisler altından kurun.",
  "viewer.pdf_inline_failed": "Tarayıcı PDF'i inline açamadı.",
  "viewer.too_large": "Dosya çok büyük (>1 MB).",
  "viewer.csv_rows": "{n} satır",
  "viewer.csv_rows_one": "{n} satır",
  "presence.others": "{n} kişi",
  "presence.others_one": "{n} kişi",
  "conn.offline": "Canlı bağlantı yok - değişiklikler gecikebilir",
  "conn.tooltip": "Sunucuyla canlı bağlantı kurulamadı; liste belirli aralıklarla otomatik yenilenir. Bağlantı geri gelince bu uyarı kaybolur.",
  /* === bul:s3 === */
  "palette.everywhere": "Her yerde",
  "palette.searching": "Aranıyor…",
  "palette.everywhere_failed": "Arama yapılamadı. Yeniden deneyin.",
  "palette.saved": "Kayıtlı aramalar",
  "palette.save": "Aramayı kaydet",
  "palette.saved.delete": "Kayıtlı aramayı sil",
  /* #168 - yönetim panelinin araması (components/PanelSearch.vue). */
  "panelsearch.label": "Yönetim panelinde ara",
  "panelsearch.trigger": "Ara",
  "panelsearch.placeholder": "Sayfa, ayar, kişi, uygulama ara…",
  "panelsearch.close": "Aramayı kapat",
  "panelsearch.clear": "Aramayı temizle",
  "panelsearch.results": "Arama sonuçları",
  "panelsearch.group.page": "Sayfalar",
  "panelsearch.group.setting": "Ayarlar",
  "panelsearch.group.app": "Uygulamalar",
  "panelsearch.group.user": "Kullanıcılar",
  "panelsearch.group.group": "Gruplar",
  "panelsearch.group.key": "API anahtarları",
  "panelsearch.group.storage": "Depolar",
  "panelsearch.group.share": "Paylaşımlar",
  "panelsearch.group.file": "Dosyalar",
  "panelsearch.group.recent": "Son aramalar",
  "panelsearch.files_all": "Dosyalarda ara: {q}",
  "panelsearch.recent_remove": "Son aramalardan kaldır",
  "panelsearch.recent_clear": "Son aramaları temizle",
  "panelsearch.empty": "“{q}” ile eşleşen bir şey yok.",
  "panelsearch.searching": "Aranıyor…",
  "panelsearch.failed": "Sonuçların bir kısmı yüklenemedi. Gelenler gösteriliyor.",
  "panelsearch.prefixes": "Tek bir türe daraltın:",
  "panelsearch.count_one": "{n} sonuç",
  "panelsearch.count": "{n} sonuç",
  "search.in_content": "İçerikte",
  "search.truncated": "Gösterilenden daha fazla sonuç var - aramanızı daraltın",
  "nav.more_shown": "{total} öğeden {shown} tanesi gösteriliyor",
  "nav.load_more": "Daha fazla yükle",
  /* Katalog kapsamı (docs/LAZY-CATALOGUE.md, lib/catalogCoverage). */
  "coverage.first_scan": "Bu deponun ilk senkronu henüz bitmedi. Bitene kadar arama, klasör boyutları ve kullanım deponun bir kısmını kapsamaz.",
  "coverage.lazy_filling": "filex bu depoyu hâlâ kataloglıyor (şimdiye kadar bulunan klasörlerin %{pct} kadarı tamam). Bitene kadar arama, klasör boyutları ve kullanım deponun bir kısmını kapsamaz.",
  "coverage.lazy_on_open": "Bu depoda yalnız açılan klasörler kataloglanır. Arama, klasör boyutları ve kullanım yalnız bu klasörleri kapsar.",
  "coverage.search_some": "Şu depoların tamamı henüz kataloglanmadı: {names}. Bu arama oradaki bazı dosyaları bulamayabilir.",
  "coverage.catalog_all": "Tümünü katalogla",
  "coverage.catalog_started": "Senkron başladı - deponun tamamı kataloglanıyor.",
  "coverage.catalog_running": "Kataloglanıyor…",
  "coverage.cataloging": "{storage} kataloglanıyor… arka planda sürüyor, bittiğinde bu sayfa söyleyecek.",
  "coverage.catalog_done": "{storage} baştan sona kataloglandı",
  "coverage.catalog_failed": "{storage} kataloglanamadı. Nedenini yönetim panelinde, deponun senkron geçmişinde görebilirsiniz.",
  "coverage.catalog_stopped": "{storage} kataloglaması bitmeden durduruldu",
  "coverage.catalog_joined": "{storage} zaten taranıyordu - bittiğinde bu sayfa haber verecek.",
  "coverage.catalog_gone": "{storage} kataloglanırken kaldırıldı",
  "coverage.catalog_unfollowed": "{storage} arka planda kataloglanmaya devam ediyor; nasıl bittiğini yönetim panelinde deponun senkron geçmişi gösterir",
  "size.at_least": "≥ {size}",
  "size.partial_hint": "Bu klasörün bir kısmı henüz kataloglanmadı; boyutu en az bu kadar.",
  "size.unknown_hint": "Bu klasör henüz kataloglanmadı; boyutu bilinmiyor.",
  /* === bag:b4 === */
  "toolbar.more": "Diğer işlemler",
  "toolbar.search.close": "Aramayı kapat",
  "sheet.menu": "İşlemler",
  "sheet.close": "Kapat",
  /* === koru:k1 === */
  "toolbar.inspector": "Ayrıntılar",
  "ctx.details": "Ayrıntılar",
  /* yildiz:s1 - yıldızlamak bir eylem, menüde de öyle görünür. */
  "ctx.star": "Yıldızla",
  "ctx.unstar": "Yıldızı kaldır",
  "star.failed": "Yıldız değiştirilemedi",
  "shortcuts.inspector": "Ayrıntılar panelini aç/kapat",
  "inspector.title": "Ayrıntılar",
  "inspector.copy_name": "Adı kopyala",
  "inspector.items": "{n} öğe",
  "inspector.items_one": "{n} öğe",
  "inspector.type": "Tür",
  "inspector.select_hint": "Ayrıntılarını görmek için bir öğe seçin.",
  /* pane:p1 - panel SON seçilen şeyi tutar (bakımcının kararı, 2026-09-13);
     dolayısıyla bölünmüş pencerenin bakılmayan yarısındaki bir öğeyi
     anlatıyor olabilir. Bu satır hangisi olduğunu ve nerede durduğunu söyler. */
  "inspector.held": "Son seçilen - {where} içinde",
  "inspector.close": "Kapat",
  "inspector.section.general": "Genel",
  "inspector.section.tags": "Etiketler",
  /* etiket:t1 - TagPicker'ın kendi çerçevesi. 2026-09-13'e kadar bu üçü
     katalogdan bağımsız olarak İngilizce basılıyordu; `tags.open` ise çipin
     yeni "bu etiketi taşıyan her şeyi göster" kapısı. */
  "tags.open": "Etiketi aç: {tag}",
  "tags.add": "+ Etiket ekle",
  "tags.name": "Etiket adı",
  "tags.remove": "Etiketi kaldır",
  /* etiket:k2 (v0.43.0) - etiketin iki TÜRÜ. Etiket nerede çiziliyorsa türünü
     simgeyle birlikte sözcükle de söyler: bu sürüme kadar her etiket sessizce
     sunucudaki herkesle paylaşılıyordu. */
  "tags.kind.label": "Bu etiketi kim görür",
  "tags.kind.personal": "Kişisel",
  "tags.kind.team": "Ekip",
  "tags.kind.personal_help": "Yalnızca siz görürsünüz",
  "tags.kind.team_help": "Bu dosyayı görebilen ekibindeki herkes görür",
  "tags.kind.team_locked": "Ekip etiketi eklemek ya da kaldırmak için bu dosyada düzenleme yetkiniz olmalı.",
  "tags.chip.personal": "Kişisel etiket “{tag}” - yalnızca siz görürsünüz",
  "tags.chip.team": "Ekip etiketi “{tag}” - bu dosyayı görebilen ekibindeki herkes görür",
  "tags.add_submit": "Ekle",
  "inspector.section.versions": "Sürümler",
  "inspector.section.permissions": "İzinler",
  "inspector.section.shares": "Paylaşımlar",
  "inspector.path": "Yol",
  "inspector.size": "Boyut",
  "inspector.modified": "Değiştirilme",
  "inspector.mime": "MIME türü",
  "inspector.etag": "ETag",
  "inspector.nodeId": "Düğüm kimliği",
  "inspector.copy": "Kopyala",
  "inspector.copied": "Kopyalandı",
  "inspector.error": "Yüklenemedi",
  "inspector.items_summary": "{n} öğe, toplam {size}",
  "inspector.items_summary_one": "{n} öğe, toplam {size}",
  "inspector.folder_items": "{n} öğe",
  "inspector.folder_items_one": "{n} öğe",
  "inspector.versions.empty": "Sürüm geçmişi yok",
  "inspector.versions.v": "Sürüm {n}",
  "inspector.versions.restore": "Geri yükle",
  "inspector.versions.restore_confirm": "Bu sürüm geri yüklensin mi?",
  "inspector.versions.snapshot_current": "Önce şimdiki halin sürümünü al",
  "inspector.versions.confirm": "Onayla",
  "inspector.versions.restoring": "Geri yükleniyor…",
  "inspector.versions.cancel": "Vazgeç",
  "inspector.versions.take_snapshot": "Şimdiki halin sürümünü al",
  "inspector.versions.snapshotting": "Sürüm alınıyor…",
  "inspector.versions.restored": "Sürüm geri yüklendi",
  "inspector.versions.snapshotted": "Sürüm alındı",
  "inspector.versions.unsupported": "Sunucu bu işlemi desteklemiyor",
  "inspector.perm.none": "Erişim yok",
  "inspector.perm.viewer": "Görüntüleyen",
  "inspector.perm.editor": "Düzenleyen",
  "inspector.perm.owner": "Sahip",
  "inspector.perm.manage": "İzinleri yönet",
  "inspector.shares.empty": "Paylaşım bağlantısı yok",
  "inspector.shares.copy": "Bağlantıyı kopyala",
  /* wiring:c1 - tema galerisi */
  "theme.menu": "Tema",
  "theme.title": "Tema galerisi",
  "theme.hint": "Tema yalnız renk paletini değiştirir; gündüz mü gece mi olduğu yukarıdaki seçim.",
  "theme.mode.label": "Görünüm",
  "theme.mode.light": "Gündüz",
  "theme.mode.dark": "Gece",
  "theme.mode.auto": "Otomatik",
  "theme.reset": "Varsayılana dön",
  "theme.close": "Kapat",
  "theme.selected": "Seçili",
  "theme.name.default": "Varsayılan",
  "theme.name.night": "Gece mavisi",
  "theme.name.forest": "Orman",
  "theme.name.amber": "Kehribar",
  "theme.name.lilac": "Leylak",
  "theme.name.contrast": "Yüksek kontrast",
  "theme.name.gray": "Yumuşak gri",
  "theme.name.terminal": "Terminal yeşili",
  /* === zaman:z3 - saat dilimi seçici (gömme penceresi + web ayarları) === */
  "tz.menu": "Saat dilimi",
  "tz.title": "Saat dilimi",
  "tz.label": "Tarihleri şu saatle göster",
  "tz.search": "Şehir, ülke ya da saat farkı arayın - “İstanbul” veya “GMT+3” deneyin",
  "tz.default.device": "Bu cihazın saat dilimini kullan ({zone})",
  "tz.default.account": "Hesabınızın saat dilimini kullan ({zone})",
  "tz.default.host": "Bu sitenin varsayılanını kullan ({zone})",
  "tz.no_match": "“{query}” ile eşleşen saat dilimi yok. Bir şehir, bir ülke ya da GMT+3 gibi bir fark deneyin.",
  "tz.more": "{n} kayıt daha var - listeyi daraltmak için yazmayı sürdürün.",
  "tz.hint": "Yalnızca bu tarayıcıda saklanır. Her tarih tek bir an olarak saklanır ve burada seçtiğiniz saatle gösterilir.",
  "tz.now": "{zone} bölgesinde şu an: {time}",
  /* #275 - gömmenin kendi dil ayarı ("⋯" → Dil), bu tarayıcıda tutulur */
  "lang.menu": "Dil",
  "lang.title": "Dil",
  "lang.label": "Arayüz dili",
  "lang.default.browser": "Tarayıcının dili ({lang})",
  "lang.default.account": "Hesabınızın dili ({lang})",
  "lang.default.host": "Bu sitenin varsayılanı ({lang})",
  "lang.default.default": "Varsayılan ({lang})",
  "lang.hint": "Yalnızca bu tarayıcıda saklanır.",
  "lang.hint_account": "Bu tarayıcıda ve hesabınızda saklanır; diğer cihazlarınız ve bildirimleriniz de bu dili kullanır.",
  /* === wiring:c2 - özelleştirilebilir kısayollar + hızlı bakış === */
  "shortcuts.quicklook": "Hızlı bakış",
  "shortcuts.customize": "Özelleştir",
  "shortcuts.settings.menu": "Kısayollar",
  "shortcuts.settings.title": "Kısayol ayarları",
  "shortcuts.settings.hint": 'Bir kısayolu değiştirmek için "Değiştir"e basıp yeni tuş kombinasyonuna basın. Değişiklikler yalnızca bu tarayıcıda saklanır.',
  "shortcuts.settings.change": "Değiştir",
  "shortcuts.settings.capture": "Tuşlara basın… (Esc iptal)",
  "shortcuts.settings.reset": "Varsayılana dön",
  "shortcuts.settings.reset_all": "Tümünü sıfırla",
  "shortcuts.settings.unbound": "Atanmadı",
  "shortcuts.settings.fixed": "Sabit",
  "shortcuts.settings.customized": "Özelleştirildi",
  "shortcuts.settings.conflict": 'kombinasyonu "{name}" kısayolunda kullanılıyor.',
  "shortcuts.settings.conflict_fixed": 'kombinasyonu "{name}" sabit kısayoluna ayrılmış - kullanılamaz.',
  "shortcuts.settings.conflict_take": "Eskisini boşa çıkar ve ata",
  "shortcuts.settings.conflict_cancel": "Vazgeç",
  "quicklook.hint_close": "kapat",
  "quicklook.hint_nav": "önceki/sonraki",
  "quicklook.hint_open": "aç",
  /* === /wiring:c2 === */
  /* === wiring:c3 - işlem merkezi === */
  "opc.title": "İşlemler",
  "opc.aria_badge": "{n} işlem - işlem merkezini aç/kapat",
  "opc.aria_badge_one": "{n} işlem - işlem merkezini aç/kapat",
  "opc.close": "Kapat",
  "opc.active": "Sürüyor",
  "opc.history": "Geçmiş",
  "opc.clear": "Temizle",
  "opc.empty": "İşlem yok",
  "opc.cancel": "İptal",
  "opc.retry": "Yeniden dene",
  "opc.dismiss": "Kapat",
  "opc.queued": "Sırada",
  "opc.cancelling": "İptal isteniyor…",
  "opc.percent": "%{n}",
  "opc.items": "{total} öğeden {done}",
  "opc.trash_items": "Çöpten {n} öğe",
  "opc.trash_items_one": "Çöpten {n} öğe",
  "opc.status.running": "Sürüyor",
  "opc.status.done": "Bitti",
  "opc.status.error": "Hata",
  "opc.status.aborted": "İptal edildi",
  "opc.kind.upload": "Yükleme",
  "opc.kind.copy": "Kopyalama",
  "opc.kind.move": "Taşıma",
  "opc.kind.delete": "Silme",
  "opc.kind.rename": "Yeniden adlandırma",
  "opc.kind.restore": "Geri getirme",
  "opc.kind.purge": "Kalıcı silme",
  "opc.kind.convert": "Dönüştürme",
  "opc.kind.archive": "Arşiv",
  "opc.kind.plugin": "Uygulama",
  "opc.kind.trash": "Çöp kutusunu boşaltma",
  "opc.kind.thumbs": "Küçük resim onarımı",
  /* A folder's contents on hover (FolderPeek, useFolderPeek). */
  "peek.items": "{n} öğe",
  "peek.items_one": "{n} öğe",
  "peek.more": "+{n} tane daha",
  "peek.empty": "Boş",
  "peek.loading": "İçine bakılıyor…",
  "opc.open": "Aç",
  /* Uygulama eklentileri - dosya menüsüne eklenen satırlar ve kuyruğa
     aldıkları işler (docs/APP-PLUGINS-API.md). */
  "plugin.queued": "{label} kuyruğa alındı",
  "plugin.done": "{label} tamamlandı",
  "plugin.failed": "{label} başarısız",
  "plugin.cancel_failed": "İş iptal edilemedi",
  "plugin.not_applicable": "Bu işlem seçime uygulanamaz",
  "plugin.needs_engine": "{name} bu sunucuda kurulu değil - sunucuya kurup filex'i yeniden başlatın.",
  "plugin.needs_other": "{name} bu sunucuda kullanılamıyor.",
  "plugin.needs_office": "Ofis belgeleri için bir ofis motoru gerekiyor ve bu sunucuda çalışan yok - Ofis düzenleyici uygulamasını kurun (Uygulamalar) ya da Dış servisler sayfasından {name} bağlayın.",
  "plugin.confirm.title": "Onayla",
  "plugin.confirm.cancel": "Vazgeç",
  "plugin.confirm.run": "Çalıştır",
  "plugin.view.close": "Kapat",
  "appframe.confirm_title": "Onay",
  "appframe.consent_clipboard": "{app} panonuza metin kopyalamak istiyor.",
  "appframe.consent_download": "{app}, “{name}” dosyasını bilgisayarınıza kaydetmek istiyor.",
  "appframe.consent_print": "{app}, “{name}” belgesini yazdırmak istiyor.",
  "appframe.consent_job": "{app} “{action}” işini başlatmak istiyor.",
  "appframe.consent_allow": "İzin ver",
  "appframe.consent_deny": "İzin verme",
  "appframe.unsaved_title": "Kaydedilmemiş değişiklikler",
  "appframe.state_no_account": "Uygulamanın şifreli bir dosya için ayarları, oturum açtığınız hesaba göre mühürlenerek saklanır; bu sayfa hangi hesap olduğunu öğrenemedi, bu yüzden hiçbir şey saklanmadı. Yeniden oturum açın ya da dosyayı oturum açtığınız yerde açın.",
  "appframe.unsaved_text": "{app} içinde kaydedilmemiş değişiklikler var. Yine de kapatılsın mı?",
  "appframe.discard": "Kaydetmeden kapat",
  "appframe.keep_open": "Düzenlemeye devam et",
  "appframe.save_close": "Kaydet ve kapat",
  "appframe.updated": "{app}, {version} sürümüne güncellendi.",
  "appframe.updated_reload": "Bir yönetici {app} uygulamasının yeni sürümünü onayladı. Yeni sürümü kullanmak için yeniden yükleyin - önce çalışmanızı kaydedin.",
  "appframe.reload": "Yeniden yükle",
  "appframe.dismiss": "Kapat",
  "appframe.not_connected": "{app} başlamadı. Kapatıp yeniden açın; tekrar ederse yöneticinize haber verin.",
  "appframe.save_as_title": "{app}: “{name}” nereye kaydedilsin?",
  "plugin.view.busy": "Çalışıyor…",
  "plugin.view.unsupported": "Bu ekran, bu sürümün çizemediği bir bileşen kullanıyor ({type})",
  "plugin.view.error": "Uygulama hata döndürdü",
  "plugin.output_missing": "Çıktı artık eski yerinde değil",
  /* M2 - surface components (components/plugin/nodes/*) */
  "plugin.view.loading": "Yükleniyor…",
  "plugin.view.preview_failed": "Önizleme yüklenemedi",
  "plugin.steps.label": "Adımlar",
  "plugin.list.empty": "Henüz bir şey yok",
  "plugin.list.actions": "İşlemler",
  /* The label on a table row's ONE action control (core RowActions.vue).
     The explorer's handle is the ⋮ glyph; a panel row's says what it is.
     Owner, 2026-09-20: "adminde 'Aksiyon' diye yazmalı". */
  "row.actions": "Aksiyon",
  "plugin.people.placeholder": "Ad veya e-posta",
  "plugin.people.placeholder_email": "E-posta adresi",
  "plugin.people.add": "Ekle",
  "plugin.people.remove": "{name} kişisini kaldır",
  "plugin.people.invalid_email": "Geçerli bir e-posta adresi girin",
  "plugin.people.external_off": "Yalnızca hesabı olan kişiler eklenebilir",
  "plugin.pin.label": "PIN",
  "plugin.file.choose": "Seç…",
  "plugin.file.clear": "Temizle",
  "plugin.file.none": "Seçim yok",
  /* M3 - imza yolu: signature-pad + pdf-fields düğümleri ve dış katılımcının
     herkese açık sayfası (views/PublicSurface.vue, usePublicPage). */
  "plugin.sig.mode_draw": "Çiz",
  "plugin.sig.mode_type": "Yaz",
  "plugin.sig.mode_upload": "Yükle",
  "plugin.sig.draw_hint": "Parmağınızla ya da fareyle buraya imzalayın",
  "plugin.sig.type_placeholder": "Adınızı yazın",
  "plugin.sig.upload_pick": "Görsel seç…",
  "plugin.sig.upload_hint": "PNG ya da JPEG, en çok {kb} KB",
  "plugin.sig.upload_too_big": "Görsel {kb} KB sınırından büyük",
  "plugin.sig.upload_bad_type": "Yalnızca PNG ya da JPEG görsel kullanılabilir",
  "plugin.sig.upload_unreadable": "Görsel okunamadı",
  "plugin.sig.clear": "İmzayı temizle",
  "plugin.sig.signed": "İmza alındı",
  "plugin.pdf.load_failed": "Belge yüklenemedi",
  "plugin.pdf.palette": "Alan türleri",
  "plugin.pdf.pending": "Yeri bekleyen kutular",
  "plugin.pdf.place_box_hint": "“{name}” kutusunun gideceği yere dokunun ya da boyutlandırmak için sürükleyin",
  "plugin.pdf.all_placed": "Her kutunun bir yeri var",
  "plugin.pdf.place_idle": "Yukarıdaki kutulardan birini seçin, sonra sayfada gideceği yere dokunun.",
  "plugin.pdf.place_idle_done": "Kaldırmak ya da kopyalamak için sayfadaki bir kutuya dokunun; taşımak için sürükleyin.",
  "plugin.pdf.no_boxes": "Henüz kutu yok. Aşağıdan ekleyin: adını verin, kimin olduğunu söyleyin; yerini bir sonraki adımda belgede seçeceksiniz.",
  "plugin.pdf.add_box": "Kutu ekle",
  "plugin.pdf.unplace": "Sayfadan kaldır",
  "plugin.pdf.place_hint": "{type} alanının gideceği yere dokunun ya da boyutlandırmak için sürükleyin",
  "plugin.pdf.type_signature": "İmza",
  "plugin.pdf.type_initials": "Paraf",
  "plugin.pdf.type_date": "Tarih",
  "plugin.pdf.type_text": "Metin",
  "plugin.pdf.type_checkbox": "Onay kutusu",
  "plugin.pdf.tap_signature": "İmzalamak için dokunun",
  "plugin.pdf.tap_initials": "Paraflamak için dokunun",
  "plugin.pdf.tap_date": "Bugünün tarihi için dokunun",
  "plugin.pdf.tap_text": "Metin",
  "plugin.pdf.tap_checkbox": "İşaretlemek için dokunun",
  "plugin.pdf.label": "Ad",
  "plugin.pdf.assignee": "İmzacı",
  "plugin.pdf.unassigned": "Herkes",
  "plugin.pdf.filled_by": "Dolduran",
  "plugin.pdf.style": "Nasıl imzalanır",
  "plugin.pdf.style_drawn": "Çizerek",
  "plugin.pdf.style_typed": "Yazarak",
  "plugin.pdf.lines": "Altına yazılanlar",
  "plugin.pdf.lines_preview": "İmzanın altında:",
  "plugin.pdf.lines_none": "Bu imzanın altına bir şey yazılmaz.",
  "plugin.pdf.required": "Zorunlu",
  "plugin.pdf.copy_to_page": "Sayfaya kopyala",
  "plugin.pdf.copy": "Kopyala",
  "plugin.pdf.delete": "Alanı sil",
  "plugin.pdf.zoom_in": "Yakınlaştır",
  "plugin.pdf.zoom_out": "Uzaklaştır",
  "plugin.pdf.zoom_fit": "Genişliğe sığdır",
  "plugin.pdf.zoom_fit_page": "Sayfayı ekrana sığdır",
  "plugin.pdf.pad_for": "{type} alanınız",
  "plugin.pdf.pad_done": "Tamam",
  "plugin.page.loading": "Yükleniyor…",
  "plugin.page.pin_title": "Bu sayfa korumalı",
  "plugin.page.pin_hint": "Devam etmek için size verilen PIN'i girin",
  "plugin.page.pin_submit": "Devam et",
  "plugin.page.pin_wrong": "Bu PIN doğru değil",
  "plugin.page.pin_locked": "Çok fazla yanlış PIN girildi - birkaç dakika bekleyip yeniden deneyin",
  "plugin.page.unavailable_title": "Bu bağlantı kullanılamıyor",
  "plugin.page.unavailable_text": "Süresi dolmuş, hakkı tükenmiş ya da geri çekilmiş olabilir. Gönderen kişiden yeni bir bağlantı isteyin.",
  "plugin.page.accepted_title": "Alındı, teşekkürler",
  "plugin.page.accepted_text": "Yanıtınız kaydedildi. Bu sayfayı kapatabilirsiniz.",
  "plugin.page.done_title": "Tamamlandı",
  "plugin.page.done_text": "Burada yapılacak başka bir şey kalmadı. Bu sayfayı kapatabilirsiniz.",
  "plugin.page.error_title": "Bir sorun oluştu",
  "plugin.page.retry": "Yeniden dene",
  "plugin.page.files": "Belgeler",
  "plugin.page.open_file": "{name} dosyasını yeni sekmede aç",
  "plugin.page.footer": "filex ile sunuldu",
  /* Herkese açık sayfaların (paylaşım, dosya isteği) kendi cümleleri
     sunucunundur: `server.public.*` (composables/usePublicText). */
  /* === Uygulama eklentileri v2 - `page` görünümü, uygulamanın dosya kilidi,
     işin yazdığı çıktı kipi, imza alanının yazı tipleri ve kuralları. === */
  "plugin.page_view.back": "Dosyalara dön",
  "plugin.page_view.queued_title": "İş kuyruğa alındı",
  "plugin.page_view.queued_text": "filex işi yürütüyor. Bittiğinde bu sayfa söyler; ilerleyişi işlemler tepsisinde de görünür.",
  "plugin.page_view.finished_title": "İş bitti",
  "plugin.page_view.finished_text": "Burada yapılacak başka bir şey kalmadı. Dosyalara dönebilir ya da bu sekmeyi kapatabilirsiniz.",
  "plugin.page_view.failed_title": "İş tamamlanamadı",
  "plugin.page_view.opening_title": "Sonuç açılıyor",
  "plugin.page_view.open_ops": "İşlemler tepsisini aç",
  "plugin.page_view.done_title": "Tamamlandı",
  "plugin.page_view.done_text": "Burada yapılacak başka bir şey kalmadı. Bu sekmeyi kapatabilirsiniz.",
  "plugin.page_view.error_title": "Bu ekran açılamadı",
  "plugin.page_view.retry": "Yeniden dene",
  "plugin.page_view.blocked": "Yeni sekme engellendi - bu site için açılır pencerelere izin verin, yoksa ekran pencere içinde açılır",
  "plugin.output.sibling": "yeni dosya",
  "plugin.output.version": "yeni sürüm",
  "plugin.output.sibling_title": "Sonuç, aslının yanına yeni bir dosya olarak iner",
  "plugin.output.version_title": "Sonuç, dosyanın yerine yeni bir sürümü olarak geçer",
  "plugin.sign.font_label": "El yazısı",
  "plugin.pdf.font": "Yazı tipi",
  "plugin.pdf.rule_number": "Yalnızca sayı",
  "plugin.pdf.rule_email": "E-posta adresi",
  "plugin.pdf.rule_length": "{min} ile {max} karakter arasında",
  "plugin.pdf.rule_min": "En az {min} karakter",
  "plugin.pdf.rule_max": "En çok {max} karakter",
  "plugin.pdf.err_number": "Bir sayı girin",
  "plugin.pdf.err_email": "Geçerli bir e-posta adresi girin",
  "plugin.pdf.err_min": "Çok kısa - en az {min} karakter",
  "plugin.pdf.err_max": "Çok uzun - en çok {max} karakter",
  "applock.badge": "Kilitli",
  "applock.some_app": "bir uygulama",
  "applock.held": "{app} bu dosyayı kilitledi",
  "applock.held_reason": "{app} bu dosyayı kilitledi: {reason}",
  "applock.until": "- {date} tarihine kadar",
  "applock.inspector": "Uygulama kilidi",
  /* issue #34 - sunucunun İZLEMEDİĞİ sembolik bağ (lib/symlink). Rozet satırdaki
     kısa söz; `why` ise arkasındaki cümle - üzerine gelince, ayrıntılar panelinde
     ve biri açmaya kalkıştığında çıkan bildirimde. ⚠ Kırık bağ ile depo dışına
     çıkan bağ AYRI durumlardır ve ayrı okunmalıdır: yalnızca birinin yönetici
     çaresi vardır; silinmiş bir hedef için o çareyi önermek insanı işe yaramayacak
     bir ayar ekranına yollar. */
  "symlink.badge.outside_root": "Depo dışında",
  "symlink.badge.broken": "Kırık bağ",
  "symlink.badge.unresolved": "Uzak bağ",
  "symlink.badge.unknown": "Bağlantı",
  "symlink.why.outside_root": 'Hedefi bu deponun dışında kalan bir bağ; bu yüzden açılamıyor. Bir yönetici, deponun ayarlarındaki "Bu klasörün dışına çıkan sembolik bağları izle" seçeneğiyle buna izin verebilir.',
  "symlink.why.broken": "Hedefi artık var olmayan bir bağ; açılacak bir şey yok. Sunucuda onarılması ya da kaldırılması gerekir - hiçbir ayar silinmiş hedefi geri getirmez.",
  "symlink.why.unresolved": "Uzak sunucudaki bir bağ. filex hedefinin bu deponun içinde olup olmadığını bilemediği için bağı izlemez ve açamaz.",
  "symlink.why.unknown": "filex'in izlemediği bir bağ, bu yüzden açılamıyor. Hedefi ya bu deponun dışında, ya kayıp, ya da filex'in çözümleyemediği uzak bir sunucuda.",
  "symlink.inspector": "Açılamayan bir bağ",
  "unavailable.why.file": "Depo bu dosyanın hâlâ var olup olmadığını söyleyemedi. Depo yeniden yanıt verene kadar dosya açılamaz ve değiştirilemez; bir sonraki tarama yeniden denetler.",
  "unavailable.why.dir": "Depo bu klasörün hâlâ var olup olmadığını söyleyemedi. Depo yeniden yanıt verene kadar ne klasör ne de içindekiler açılabilir ya da değiştirilebilir; bir sonraki tarama yeniden denetler.",
  "unavailable.withReason": "{why} Deponun yanıtı: {reason}",
  "unavailable.inspector": "Kullanılamıyor",
  /* 0.50 - why a file has no thumbnail, on the file itself (lib/thumbNote). */
  "thumbNote.corrupt": "Bozuk",
  "thumbNote.corrupt_why": "Küçük resim yok: dosya okunamadı. Bozuk ya da eksik olabilir.",
  "thumbNote.encrypted": "Şifreli",
  "thumbNote.encrypted_why": "Küçük resim yok: dosya şifreli ya da parolayla korunuyor.",
  "thumbNote.too_large": "Çok büyük",
  "thumbNote.too_large_why": "Küçük resim yok: dosya, küçük resim boyut sınırından büyük.",
  "thumbNote.full": "{label}. {why}",
  "plugin.pdf.rule": "Kabul ettiği",
  "plugin.pdf.rule_kind_any": "Serbest metin",
  "plugin.pdf.rule_kind_number": "Yalnızca sayı",
  "plugin.pdf.rule_kind_email": "E-posta adresi",
  "plugin.pdf.rule_min_label": "En az uzunluk",
  "plugin.pdf.rule_max_label": "En çok uzunluk",
  "plugin.pdf.format": "Tarih biçimi",
  "plugin.pdf.date_order": "Tarih sırası",
  "plugin.pdf.date_separator": "Ayraç",
  "plugin.pdf.date_example": "Örnek",
  "opc.kind.archive-create": "Arşiv oluşturuluyor",
  "opc.kind.archive-extract": "Arşiv çıkarılıyor",
  /* === wiring:c4 - onboarding turu + erişilebilirlik + hata kartı === */
  "tour.aria": "Tanıtım turu",
  "tour.restart": "Turu tekrar başlat",
  "tour.skip": "Turu atla",
  "tour.back": "Geri",
  "tour.next": "İleri",
  "tour.done": "Bitti",
  "tour.progress": "{n} / {m}",
  "tour.step.nav.title": "Depolar ve görünümler",
  "tour.step.nav.desc": "Ana sayfa, Benimle paylaşılanlar, Son kullanılanlar, Yıldızlılar ve Çöp kutusu hep bu panelde durur; altında da depolarınız ve bağlantılarınız. Sol üst köşedeki düğme paneli ince bir şeride indirir ve geri açar.",
  "tour.step.nav.desc_closed": "Bu düğme gezinti panelini açar: Ana sayfa, Benimle paylaşılanlar, Son kullanılanlar, Yıldızlılar ve Çöp kutusu; altında da depolarınız ve bağlantılarınız.",
  "tour.step.new.title": "Yeni bir şey ekle",
  "tour.step.new.desc": "Yeni olan her şey buradan başlar: bu cihazdan dosya yükleyebilir, klasör oluşturabilir ya da birinden dosya isteyebilirsiniz. Dosyaları pencereye sürükleyip bırakmak da yükler.",
  "tour.step.new.desc_fab": "Bu düğme bu cihazdan dosya yükler. Dosyaları pencereye sürükleyip bırakmak da çalışır.",
  "tour.step.search.title": "Arama",
  "tour.step.search.desc": 'Bu alan deponun tamamında ada göre arar; ayraçları ve bir harflik yazım hatasını affeder, yani "fatura 2026" yazdığınızda fatura_2026.pdf gelir. tag:fatura yazarak etikete göre filtreleyebilirsiniz. Yanındaki sürgü düğmesi gelişmiş aramayı, {palette} ise komut paletini açar; palet komut da çalıştırır.',
  "tour.step.crumb.title": "Bulunduğunuz yer",
  "tour.step.crumb.desc": "Bu iz, ekrandaki klasörün adresidir. Adımlardan birine tıklayarak üste çıkabilir, sonuncusunun yanındaki oktan içindeki klasörleri görebilirsiniz.",
  "tour.step.filters.title": "Listeyi daralt",
  "tour.step.filters.desc": "Tür, Sahibi, Değiştirilme ve Boyut bulunduğunuz klasörü filtreler; yanındaki kutu siz yazdıkça adlara göre eşleşir, satırın sonundaki denetim ise sıralar.",
  "tour.step.view.title": "Görünümü değiştir",
  "tour.step.view.desc": "Bu klasörün nasıl çizildiğini değiştirir; seçiminiz hatırlanır.",
  "tour.step.details.title": "Ayrıntılar ve paylaşım",
  "tour.step.details.desc": 'Bir dosyayı seçip bu paneli açtığınızda ayrıntılarını, hareketlerini ve paylaşım bağlantılarını görürsünüz. Tam menü için dosyaya sağ tıklayın ya da satırının sonundaki düğmeyi kullanın: oradaki "Paylaş" ile PIN ve son kullanma süresi verilebilen bir bağlantı oluşturulur.',
  "tour.step.help.title": "Kısayollar",
  "tour.step.help.desc": '{help} tuşu kısayol kartını, {palette} komut paletini açar. Tema ve "Turu tekrar başlat" sağ üstteki "Diğer işlemler" menüsünde; hesabınız ve oturumu kapatma ise yanındaki avatarın arkasında.',
  "error.hint": "Bağlantı ya da sunucu kaynaklı geçici bir sorun olabilir. Yeniden deneyin.",
  "error.details": "Teknik ayrıntılar",
  "col.star": "Yıldız",
  "toolbar.view_label": "Görünüm",
  "list.aria": "Dosya listesi",
  "grid.aria": "Dosya ızgarası",
  /* === wiring:d1 - sekmeler + split panel === */
  "tabs.strip": "Sekmeler",
  "tabs.new": "Yeni sekme",
  "tabs.close": "Sekmeyi kapat",
  "tabs.split": "Görünümü böl",
  "tabs.split_off": "Bölmeyi kapat",
  "ctx.open_new_tab": "Yeni sekmede aç",
  "ctx.open_with": "{app} ile aç",
  "ctx.open_with_builtin": "Yerleşik görüntüleyiciyle aç",
  "ctx.open_with_choose": "Uygulama seç…",
  "openWith.title": "Birlikte aç",
  "openWith.lead": "{name} hangi uygulamayla açılsın?",
  "openWith.builtin": "filex görüntüleyicisi (yerleşik)",
  "openWith.onlyoffice": "ONLYOFFICE (tablo düzenleyici)",
  "openWith.now": "Şu an bununla açılıyor",
  "openWith.always": "{ext} dosyalarını her zaman bu uygulamayla aç",
  "openWith.hint": "Hesabınızda saklanır. Ayarlar, Varsayılan uygulamalar bölümünden değiştirebilirsiniz.",
  "openWith.open": "Aç",
  "shortcuts.group.tabs": "Sekmeler",
  "shortcuts.tab_new": "Yeni sekme",
  "shortcuts.tab_close": "Sekmeyi kapat",
  "shortcuts.tab_next": "Sonraki sekme",
  "shortcuts.tab_prev": "Önceki sekme",
  /* tus:t1 - menü fiilleri */
  "shortcuts.new_folder": "Yeni klasör",
  "shortcuts.upload": "Dosya yükle",
  "shortcuts.refresh": "Listeyi yenile",
  "shortcuts.download": "İndir",
  "shortcuts.preview": "Önizle",
  "shortcuts.share": "Paylaş",
  "shortcuts.tags": "Etiketler",
  "shortcuts.open_tab": "Yeni sekmede aç",
  "shortcuts.copy_path": "Yolu kopyala",
  "shortcuts.copy_id": "Kimliği kopyala",
  "shortcuts.restore": "Çöp kutusundan geri al",
  "shortcuts.settings.reserved": "tarayıcı tarafından sayfaya ulaşmadan yakalanıyor, burada hiçbir şey yapmaz. Başka bir tuş seçin.",
  "shortcuts.settings.reserved_badge": "Yalnız masaüstü uygulamasında",
  "shortcuts.settings.reserved_title": "Bu kombinasyonu tarayıcının kendisi işliyor. Masaüstü uygulamasında ve kurulu PWA’da çalışır, tarayıcı sekmesinde çalışmaz.",
  "cmd.tab_new": "Yeni sekme aç",
  "cmd.split_toggle": "Görünümü böl / birleştir",
  "split.pane": "İkincil panel",
  "split.close": "Yan paneli kapat",
  "split.error": "Liste yüklenemedi",
  "split.retry": "Yeniden dene",
  "split.copy_queued": "Kopyalama kuyruğa alındı",
  "split.move_queued": "Taşıma kuyruğa alındı",
  "toast.move_kept_both": "Taşıma kuyruğa alındı. Hedefte aynı adla bir öğe vardı, taşınan öğe onun yanına “-copy” ekiyle konacak. Bu taşıma geri alınamaz.",
  "split.cross_copy": "Depolar farklı - kopyalama kuyruğa alındı",
  "dragout.downloading": "Bırakılan klasöre indiriliyor…",
  "dragout.downloading_n": "Bırakılan klasöre indiriliyor - şimdiye dek {n} dosya…",
  "dragout.downloading_n_one": "Bırakılan klasöre indiriliyor - şimdiye dek {n} dosya…",
  "dragout.stop": "Durdur",
  "dragout.stopping": "Durduruluyor…",
  "dragout.stopped": "Durduruldu - gelenler klasörde kalıyor",
  "dragout.not_found": "Bırakılan yer bulunamadı - dosya bir klasöre değil bir uygulamaya bırakıldıysa indirme yapılamaz",
  "dragout.done": "İndirme tamamlandı",
  "dragout.ready": "Dosyalar hazır - masaüstüne sürükleyebilirsiniz",
  "dragout.preparing": "Sürükleme için hazırlanıyor…",
  "split.cross_move": "Depolar farklı - taşıma kuyruğa alındı (baytlar aktarılıp kaynak silinir)",
  /* === /wiring:d1 === */
  /* wiring:d2 - galeri görünümü */
  "toolbar.view.gallery": "Galeri",
  "gallery.aria": "Dosya galerisi",
  /* /wiring:d2 */
  /* wiring:d3 - Yorumlar (inspector node comments) */
  "inspector.section.comments": "Yorumlar",
  "inspector.comments.empty": "Henüz yorum yok.",
  "inspector.comments.placeholder": "Yorum yaz…",
  "inspector.comments.send": "Gönder",
  "inspector.comments.delete": "Yorumu sil",
  /* wiring:e2 - uçtan uca şifreli klasörler */
  "e2e.create.title": "Şifreli klasör oluştur",
  "e2e.create.option": "Şifreli klasör oluştur…",
  "e2e.create.pw_label": "Klasör parolası",
  "e2e.create.pw_placeholder": "En az 8 karakter",
  "e2e.create.pw2_label": "Parolayı tekrar girin",
  "e2e.create.warn_title": "GERİ DÖNÜŞÜ YOK",
  "e2e.create.warn_body": "Bu klasördeki dosyalar yalnız bu parolayla ya da klasör oluşturulurken bir kez gösterilen kurtarma anahtarıyla açılır. Parola sunucuda TUTULMAZ; kurtarma anahtarının da filex'te kopyası kalmaz. İkisini de kaybederseniz içerik sonsuza dek gider.",
  "e2e.create.ack": "Anladım: parolayı da kurtarma anahtarını da kaybedersem verilerim kurtarılamaz.",
  "e2e.create.ack_required": "Devam etmek için uyarıyı onaylayın.",
  "e2e.create.pw_short": "Parola en az 8 karakter olmalı.",
  "e2e.create.pw_mismatch": "Parolalar birbirini tutmuyor.",
  "e2e.create.bad_name": "Geçersiz klasör adı.",
  "e2e.create.create": "Şifreli klasörü oluştur",
  "e2e.create.busy": "Oluşturuluyor…",
  "e2e.create.done": "Şifreli klasör oluşturuldu",
  "e2e.create.failed": "Şifreli klasör oluşturulamadı",
  "e2e.create.nested": "Şifreli klasörün içine ikinci bir şifreli klasör açılamaz.",
  /* wiring:e2 policy - bir yöneticiden şifreleme izni istemek. */
  "e2e.request.ctx": "Şifreleme iste…",
  "e2e.request.option": "Şifreli klasör iste…",
  "e2e.request.title": "“{name}” için şifreleme iste",
  "e2e.request.lead": "Burada şifreli klasör oluşturmak için yönetici onayı gerekiyor. Neden gerektiğini yazın; yanıt size bildirilir. Onay sizin ve bu klasör içindir: hemen içinde yeni bir şifreli klasör oluşturmak için bir kez kullanılabilir.",
  "e2e.request.lead_folder": "Bu klasörü şifrelemek için yönetici onayı gerekiyor. Neden gerektiğini yazın; yanıt size bildirilir. Onay sizin ve bu klasör içindir: bu klasörü olduğu yerde şifrelemek için bir kez kullanılabilir, içindeki bir klasör için kullanılamaz.",
  "e2e.request.lead_file": "Bu dosyayı şifrelemek için yönetici onayı gerekiyor. Neden gerektiğini yazın; yanıt size bildirilir. Onay sizin ve bu dosyanın bulunduğu klasör içindir: orada yeni bir şifreli dosya için bir kez kullanılabilir.",
  "e2e.request.reason": "Gerekçe",
  "e2e.request.reason_placeholder": "İçinde ne var, neden şifrelenmesi gerekiyor",
  "e2e.request.reason_required": "Yönetici için bir gerekçe yazın.",
  "e2e.request.send": "İsteği gönder",
  "e2e.request.sending": "Gönderiliyor…",
  "e2e.request.sent": "İstek gönderildi. Bir yönetici yanıtladığında size bildirilecek.",
  "e2e.request.already": "Bunu zaten istediniz; bir yöneticinin yanıtını bekliyor.",
  "e2e.request.failed": "İstek gönderilemedi.",
  "e2e.locked.title": "Bu klasör uçtan uca şifreli",
  "e2e.locked.hint": "İçeriği görmek için klasör parolasını girin. Parola yalnız bu sekmede, bellekte tutulur.",
  "e2e.locked.pw_placeholder": "Klasör parolası",
  "e2e.locked.unlock": "Kilidi aç",
  "e2e.locked.busy": "Doğrulanıyor…",
  "e2e.unlock.wrong": "Parola yanlış.",
  "e2e.unlock.damaged": "Parola doğru ama anahtar dosyasındaki (.filex-e2e.json) klasör anahtarı açılmıyor: dosya bozulmuş. Kurtarma anahtarını deneyin.",
  "e2e.unlock.marker_missing": "Anahtar dosyası (.filex-e2e.json) okunamadı.",
  /* ikon:emoji - listedeki işaretin erişilebilir adı. Satır eskiden yalnız
     bir 🔒 basıyordu; onun yerini alan asma kilit kutunun içinde
     aria-hidden, dolayısıyla adı taşıyan yer bu. */
  "e2e.badge": "Şifreli klasör",
  "e2e.strip.label": "Şifreli klasör - kilit açık",
  "e2e.strip.lock": "Kilitle",
  /* wiring:e2 password - klasör parolasını değiştirme */
  "e2e.password.strip_action": "Parolayı değiştir…",
  "e2e.password.title": "Klasör parolasını değiştir",
  "e2e.password.reset_title": "Bu klasör için yeni bir parola belirleyin",
  "e2e.password.reset_lead": "Bu klasörü kurtarma anahtarıyla açtınız; parolası kaybolmuş ya da başkası tarafından biliniyor olabilir. Şimdi yeni bir parola belirleyin. Bu pencereyi kapatmak klasörü yeniden kilitler.",
  "e2e.password.current": "Mevcut parola",
  "e2e.password.recovery": "Kurtarma anahtarı",
  "e2e.password.use_recovery": "Hatırlamıyorum - kurtarma anahtarını kullan",
  "e2e.password.use_current": "Bunun yerine mevcut parolayı kullan",
  "e2e.password.new": "Yeni parola",
  "e2e.password.current_required": "Mevcut parolayı girin ya da kurtarma anahtarını kullanın.",
  "e2e.password.bad_recovery": "Bu bir kurtarma anahtarı değil (dörderli gruplar hâlinde 32 karakter).",
  "e2e.password.same": "Yeni parola mevcut parolayla aynı.",
  "e2e.password.cheap_note": "Yalnız klasörün anahtar dosyası değişir. Hiçbir dosya yeniden şifrelenmez; kurtarma anahtarı ve varsa emanet anahtarı çalışmaya devam eder.",
  "e2e.password.old_copies": "Eski parolayı bilen ve anahtar dosyasının eski bir kopyasına (bir sürüm, bir yedek) sahip olan biri klasörü onunla hâlâ açabilir. Bu bir risk ise “Klasör anahtarını da değiştir”i işaretleyin.",
  "e2e.password.rotate_label": "Klasör anahtarını da değiştir (her dosyanın anahtarı yeniden sarılır; eski parola başkasınca biliniyor olabilirse kullanın)",
  "e2e.password.rekey_title": "Bu klasör v0.31 öncesinden: anahtarı parolasından türetiliyor",
  "e2e.password.rekey_body": "Bu yüzden yeni bir parola yeni bir klasör anahtarı gerektirir ve klasördeki her dosyanın anahtarı onunla yeniden sarılır. İçerik yeniden şifrelenmez. Biraz sürebilir; yarıda kalırsa kaldığı yerden devam eder, dosyalar bu sırada da açılır.",
  "e2e.password.rotate_title": "Klasör anahtarı da değişir",
  "e2e.password.rotate_body": "Her dosyanın anahtarı yeni bir klasör anahtarıyla yeniden sarılır. İçerik yeniden şifrelenmez. Yarıda kalırsa kaldığı yerden devam eder; dosyalar bu sırada da açılır.",
  "e2e.password.rekey_rk_new": "Yeni bir kurtarma anahtarı alırsınız, bir kez gösterilir; eskisi artık çalışmaz.",
  "e2e.password.rekey_rk_kept": "Kullandığınız kurtarma anahtarı çalışmaya devam eder.",
  "e2e.password.rekey_escrow": "İşletmecinin emanet anahtarı çalışmaya devam eder: yuvası yeni klasör anahtarına mühürlenir.",
  "e2e.password.rekey_ack": "Anlıyorum: bu, klasördeki her dosyanın anahtarını yeniden sarar.",
  "e2e.password.submit": "Parolayı değiştir",
  "e2e.password.busy": "Değiştiriliyor…",
  "e2e.password.lock_instead": "Bunun yerine klasörü kilitle",
  "e2e.password.wrong_current": "Parola yanlış.",
  "e2e.password.wrong_recovery": "Kurtarma anahtarı yanlış.",
  "e2e.password.escrow_blocked": "Bu klasörün, bu kurulumda bulunmayan bir anahtar için emanet yuvası var; klasör anahtarını değiştirmek onu kaybettirir. Hiçbir şey değiştirilmedi.",
  "e2e.password.failed": "Parola değiştirilemedi. Hiçbir şey değiştirilmedi.",
  "e2e.password.done": "Parola değişti. Eski parola bu klasörü artık açmıyor.",
  "e2e.password.resume_title": "Dosya anahtarları hâlâ yeniden sarılıyor",
  "e2e.password.resume_body": "Parola değişti ve yeni bir klasör anahtarı verildi. Bazı dosyaların anahtarı hâlâ öncekinin altında; her iki durumda da açılırlar. Bitirmek için devam edin.",
  "e2e.password.progress": "Şu ana kadar {n} dosya yeniden sarıldı · {failed} başarısız",
  "e2e.password.progress_one": "Şu ana kadar {n} dosya yeniden sarıldı · {failed} başarısız",
  "e2e.password.rekey_partial": "{n} dosya yeniden sarılamadı. Önceki anahtarla hâlâ açılıyorlar; yeniden denemek için devam edin.",
  "e2e.password.rekey_partial_one": "{n} dosya yeniden sarılamadı. Önceki anahtarla hâlâ açılıyor; yeniden denemek için devam edin.",
  "e2e.password.rekey_done": "Yeni klasör anahtarı yerinde ({n} dosya yeniden sarıldı). Eski parola burada artık hiçbir şey açmıyor.",
  "e2e.password.rekey_done_one": "Yeni klasör anahtarı yerinde ({n} dosya yeniden sarıldı). Eski parola burada artık hiçbir şey açmıyor.",
  "e2e.recovery.lead_replaced": "Klasörün yeni bir anahtarı var, bu yüzden yeni bir kurtarma anahtarı da var - eskisi artık açmıyor. Bir kez gösterilir; filex kopyasını tutmaz.",
  /* wiring:e2 names - şifreli dosya ve klasör adları */
  "e2e.unlock.unsupported": "Bu klasör daha yeni bir filex istiyor: bu sürümün tanımadığı bir özellik kullanıyor ({features}). Hiçbir şey değiştirilmedi.",
  "e2e.settings.open": "Şifreleme ayarları…",
  "e2e.settings.title": "Şifreleme ayarları",
  "e2e.settings.level": "Şifreleme seviyesi",
  "e2e.settings.password": "Parola",
  "e2e.settings.escrow": "Emanet anahtarı",
  "e2e.settings.close": "Kapat",
  "e2e.level.content": "Yalnız içerik",
  "e2e.level.names": "İçerik ve adlar",
  "e2e.level.content_hint": "Dosya içerikleri şifrelenir. Dosya ve klasör adları sunucuya açık kalır; böylece WebDAV, komut satırı ve masaüstü senkronu adlarla çalışmayı sürdürür ve 0.31'den beri her filex klasörü açar.",
  "e2e.level.names_hint": "İçerik de dosya ve klasör adları da şifrelenir: sunucu yalnız karıştırılmış adlar görür. WebDAV, komut satırı ve masaüstü senkronu da adları karıştırılmış görür; filex 0.47 ve öncesi klasörü açmaz.",
  "e2e.level.pending": "seviye değişikliği bitmedi",
  "e2e.level.change": "Seviyeyi değiştir…",
  "e2e.level.raise_title": "Bu klasör “İçerik ve adlar” seviyesine geçsin mi?",
  "e2e.level.raise_body": "filex buradaki her dosya ve klasöre bu tarayıcıda şifreli bir ad verir. İçeriğe dokunulmaz; yarıda kalırsa kaldığı yerden devam eder. filex açık adlara geri dönüş yolu sunmaz.",
  "e2e.level.raise_ack": "Neyin değiştiğini anladım",
  "e2e.level.raise_go": "Adları şifrele",
  /* wiring:e2 vault - 3. seviye, kasa (docs/E2E-VAULT-FORMAT.md) */
  "e2e.level.vault": "Kasa",
  "e2e.level.vault_hint": "İçerik, adlar ve bütün ağaç şifrelenir: sunucu yalnız aynı boyda paketler tutar; kaç dosya olduğunu, adlarını, boyutlarını ve tarihlerini görmez.",
  "e2e.level.vault_cost": "Bedeli: aynı anda yalnız bir kişi yazar ve kasayı yalnız filex açar (web, masaüstü, filex decrypt ve filex vault mount). WebDAV, klasör eşitleme, paylaşım bağlantıları ve sunucudaki önizlemeler içine ulaşmaz.",
  "e2e.vault.pack_label": "Paket boyutu",
  "e2e.vault.pack_4": "4 MiB",
  "e2e.vault.pack_4_help": "Varsayılan. En küçük değişiklik 4 MiB yükler.",
  "e2e.vault.pack_16": "16 MiB",
  "e2e.vault.pack_16_help": "Sunucuda daha az ve daha büyük dosya. Her değişiklik en az 16 MiB yükler.",
  "e2e.vault.pack_hint": "Yalnız şimdi seçilir, sonra değişmez. Sunucudaki her paket bu boydadır; kullanılmayan yeri rastgele baytlarla doldurulur.",
  "e2e.vault.read_only": "Salt okunur. Bir yükleme, yeni bir klasör ya da başka bir değişiklik, kimse tutmuyorsa yazma kilidini alır.",
  "e2e.vault.writing": "Bu kasaya şu an siz yazıyorsunuz. {left} boyunca hiçbir şey yapmazsanız salt okunura döner.",
  "e2e.vault.lock_countdown": "{left} boyunca içinde hiçbir şey yapılmazsa kasa kilitlenir ve parolayı yeniden sorar.",
  "e2e.vault.held_by": "{name} {since} tarihinden beri yazıyor. Kasa sizin için salt okunur.",
  "e2e.vault.someone": "Biri",
  "e2e.vault.take_over": "Devral",
  "e2e.vault.lost_idle": "{n} dakika boyunca hiçbir şey yapmadığınız için kasa salt okunura döndü. Hiçbir şey kaybolmadı.",
  "e2e.vault.lost_idle_one": "{n} dakika boyunca hiçbir şey yapmadığınız için kasa salt okunura döndü. Hiçbir şey kaybolmadı.",
  "e2e.vault.lost_taken": "Yazmayı başka biri devraldı. Kaydettikleriniz yerinde duruyor; kasa sizin için salt okunur.",
  "e2e.vault.lost_taken_by": "{name} yazmayı devraldı. Kaydettikleriniz yerinde duruyor; kasa sizin için salt okunur.",
  "e2e.vault.lost_broken_by": "{name} yazma kilidinizi kaldırdı. Kaydettikleriniz yerinde duruyor; kasa sizin için salt okunur.",
  "e2e.vault.lost_connection": "Bağlantı koptuğu için kasa salt okunura döndü.",
  "e2e.vault.lost_expired": "Yazma kilidinin süresi dolduğu için kasa salt okunura döndü.",
  "e2e.vault.unsaved": "Kaydedilmedi: {names}. Kasa boşalınca yeniden yapın.",
  "e2e.vault.saving": "Kaydediliyor…",
  "e2e.vault.saving_progress": "Kaydediliyor: {total} içinden {done}",
  "e2e.vault.dismiss": "Tamam",
  "e2e.vault.continue": "Bu durumdan devam et",
  "e2e.vault.ro_damaged": "Bu kasanın en yeni durumu bozuk. {when} tarihli durumu görüyorsunuz, salt okunur.",
  "e2e.vault.ro_damaged_short": "Bu kasanın en yeni durumu bozuk. Daha eski bir durumu görüyorsunuz, salt okunur.",
  "e2e.vault.ro_rollback": "Sunucu bu kasanın, bu sekmenin daha önce gördüğünden eski bir durumunu sunuyor. Kasa burada salt okunur kalır.",
  "e2e.vault.ro_newer": "Bu kasayı daha yeni bir filex yazmış. Bu sürüm onu okur ama değiştirmez.",
  "e2e.vault.unreadable": "Bu kasanın hiçbir durumu okunamıyor: hiçbir şey gösterilemez ve hiçbir şey yazılmaz.",
  "e2e.vault.limit_warn": "Bu kasa en fazla {max} dosya ve klasör tutabilir; şu an {held} tane tutuyor.",
  "e2e.vault.cross": "Sunucuda kasa ile dışındaki klasörler arasında hiçbir şey taşınmaz: birinden indirin, sonra ötekine yükleyin.",
  "e2e.vault.dl_too_big": "Bu tarayıcı bu kadar büyük bir dosyayı bellekten kaydedemez. Doğrudan diske kaydeden bir tarayıcı (Chrome, Edge) ya da filex decrypt kullanın.",
  "e2e.vault.damaged_file": "Bu dosya kasada bozuk ve okunamadı.",
  "e2e.vault.level_fixed": "Kasa kasa olarak kalır: seviyesi değişmez, anahtarı yenilenmez. Yeni bir anahtarla baştan başlamak için yeni bir kasa oluşturup dosyaları içine taşıyın.",
  "e2e.vault.locked_idle_toast": "“{name}” içinde 15 dakika hiçbir şey yapılmadığı için kasa kendini kilitledi. Yeniden açmak için parolayı girin.",
  "e2e.vault.open_failed": "Kasa açılamadı.",
  "e2e.vault.err.parent_missing": "İçine gideceği klasör artık yok.",
  "e2e.vault.err.parent_not_folder": "“{name}” bir klasör değil, bir dosya.",
  "e2e.vault.err.name_taken": "Orada “{name}” adı zaten var.",
  "e2e.vault.err.bad_name": "“{name}” kasada ad olamaz: 1 ile 255 bayt arası olmalı, eğik çizgi ya da denetim karakteri içermemeli, . ya da .. olmamalı.",
  "e2e.vault.err.too_deep": "Kasada klasörler en fazla 256 düzey iç içe olabilir.",
  "e2e.vault.err.not_found": "“{name}” artık kasada yok.",
  "e2e.vault.err.is_folder": "“{name}” bir klasör.",
  "e2e.vault.err.into_itself": "Bir klasör kendi içine taşınamaz.",
  "e2e.vault.err.too_many_entries": "Bu kasa dolu: en fazla 250 000 dosya ve klasör tutar. Hiçbir şey değiştirilmedi.",
  "e2e.vault.err.index_too_large": "Bu kasanın dizini sınırına ulaştı. Hiçbir şey değiştirilmedi.",
  "e2e.vault.err.newer_format": "Bu kasayı daha yeni bir filex yazmış. Bu sürüm onu okur ama değiştirmez.",
  "e2e.vault.err.size_mismatch": "Bir dosya yüklenirken değişti. Yeniden yükleyin.",
  "e2e.vault.err.changed": "“{name}” açıldığından beri kasada değişti, bu yüzden üzerine kaydedilmedi. Yeni sürümü görmek için yeniden açın.",
  "e2e.vault.err.failed": "Değişiklik kaydedilemedi.",
  "userSettings.vault.idle": "Kasa: salt okunura dönme süresi",
  "userSettings.vault.idle_help": "Yazdığınız bir kasada hiçbir şey yapmadığınızda kasanın ne kadar süre sizde kalacağı. Sonra başkaları yazabilir; kasanız salt okunura döner ve 15 dakika sonra kilitlenir.",
  "userSettings.vault.minutes": "{n} dakika",
  "userSettings.vault.minutes_one": "{n} dakika",
  "userSettings.vault.saved": "Kaydedildi",
  "userSettings.vault.failed": "Kasa ayarı kaydedilemedi.",
  "e2e.names.move_unreadable": "Taşınmadı: öğelerden birinin adı okunamıyor.",
  "e2e.names.move_taken": "Taşınmadı: o klasörde “{name}” adı zaten var. Önce ikisinden birinin adını değiştirin.",
  "e2e.convert.ctx": "E2EE ile şifrele…",
  "e2e.convert.title": "“{name}” klasörünü şifrele",
  "e2e.convert.lead": "Bu klasördeki her dosya bulunduğu yerde, bu tarayıcıda, aşağıdaki parolayla şifrelenir. Hiçbir şey yer değiştirmez; 1. seviyede adlar olduğu gibi kalır. Yarıda kalırsa klasörü yeniden açınca devam eder.",
  "e2e.convert.past_title": "Sunucuda zaten olanlar",
  "e2e.convert.past_body": "Şifreleme bu dosyaları bundan sonrası için korur. Şimdiye kadar sunucu onları açık hâlde tuttu ve bazı kopyalar kalır: filex küçük resimlerini ve arama için çıkardığı metni siler; bu klasörün eski sürümlerini ve çöp kutusundaki kayıtlarını da silebilir.",
  "e2e.convert.drop_versions": "Bu dosyaların eski sürümlerini sil (şifresizdirler)",
  "e2e.convert.drop_trash": "Bu klasörden çöp kutusuna gidenleri sil",
  "e2e.convert.past_outside": "Yedekler, kopya sunucular ve birinin önceden aldığı kopyalar filex'in dışındadır ve olduğu gibi kalır.",
  "e2e.convert.submit": "Klasörü şifrele",
  "e2e.convert.nested": "Bu klasörün içinde şifreli bir klasör var. Şifreli klasörler iç içe olamaz; hiçbir şey değiştirilmedi.",
  "e2e.convert.failed": "Klasör şifrelenemedi. Şifrelenmiş dosyalar öyle kalır; devam etmek için klasörü açın.",
  "e2e.convert.stopped": "{n} dosyadan sonra durduruldu. Klasörün üstündeki şeritten devam edebilirsiniz.",
  "e2e.convert.stopped_one": "{n} dosyadan sonra durduruldu. Klasörün üstündeki şeritten devam edebilirsiniz.",
  "e2e.convert.partial": "{n} dosya şifrelenemedi (bu arada değişti, çok büyük ya da yazılamıyor). Hâlâ şifresizler; devam etmek için yeniden deneyin.",
  "e2e.convert.partial_one": "{n} dosya şifrelenemedi (bu arada değişti, çok büyük ya da yazılamıyor). Hâlâ şifresiz; devam etmek için yeniden deneyin.",
  "e2e.convert.too_large_here": "{n} dosya bu tarayıcının tek parçada gönderebileceğinden büyük ve bu sunucu parça parça yükleme almıyor; bu yüzden yerlerinde şifrelenemediler. Hâlâ şifresizler ve onlar şifrelenene kadar klasörün şifrelenmesi tamamlanmış sayılmaz.",
  "e2e.convert.too_large_here_one": "{n} dosya bu tarayıcının tek parçada gönderebileceğinden büyük ve bu sunucu parça parça yükleme almıyor; bu yüzden yerinde şifrelenemedi. Hâlâ şifresiz ve o şifrelenene kadar klasörün şifrelenmesi tamamlanmış sayılmaz.",
  "e2e.convert.large_progress": "“{name}” şifreleniyor: %{percent}",
  "e2e.convert.busy": "Klasör şifreleniyor…",
  "e2e.convert.resume_title": "Bu klasörü şifrelemeyi bitirin",
  "e2e.convert.resume_body": "Bu klasörü şifreleme işi başladı ama bitmedi. Henüz ulaşılmayan dosyalar sunucuda hâlâ şifresiz. Devam ederseniz kaldığı yerden sürer.",
  "e2e.convert.progress": "{total} dosyanın {n} tanesi şifrelendi · {failed} dosya kaldı",
  "e2e.convert.progress_one": "{total} dosyanın {n} tanesi şifrelendi · {failed} dosya kaldı",
  "e2e.convert.done": "Klasör şifrelendi ({n} dosya). Silinen eski sürüm: {versions}; silinen çöp kaydı: {trash}.",
  "e2e.convert.done_one": "Klasör şifrelendi ({n} dosya). Silinen eski sürüm: {versions}; silinen çöp kaydı: {trash}.",
  "e2e.convert.cleanup_failed": "Klasör şifrelendi ama eski sürümleri ve çöp kayıtları silinemedi - bunu yalnız klasörün sahibi ya da bir yönetici yapabilir.",
  "e2e.names.locked_item": "🔒 Şifreli öğe",
  "e2e.names.unreadable_item": "🔒 Adı okunamıyor",
  "e2e.names.key_failed": "Anahtar dosyası bu klasördeki adların şifreli olduğunu söylüyor ama ad anahtarı bu anahtarla açılmıyor. Hiçbir şey değiştirilmedi.",
  "e2e.names.write_failed": "Uzun bir adın ad dosyası yazılamadı, bu yüzden hiçbir şey yüklenmedi.",
  "e2e.names.bad_name": "“{name}” şifreli klasörde kullanılamaz: ad 1-255 bayt olmalı; bölü, ters bölü ya da kontrol karakteri içeremez.",
  "e2e.names.offer_cost": "Ne değişir: WebDAV, komut satırı ve masaüstü senkronu adları karıştırılmış görür; filex 0.47 ve öncesi bu klasörü açmayı reddeder. Sunucu kaç öğe olduğunu ve boyutlarını hâlâ görür.",
  "e2e.names.resume_title": "Adları şifrelemeyi bitirin",
  "e2e.names.resume_body": "Bu klasördeki adları şifreleme işi başladı ama bitmedi. Henüz ulaşılmayan öğelerin adları hâlâ açık. Devam ederseniz kaldığı yerden sürer.",
  "e2e.names.resume": "Devam et",
  "e2e.names.stop": "Durdur",
  "e2e.names.busy": "Adlar şifreleniyor…",
  "e2e.names.progress": "Şu ana kadar {n} ad şifrelendi · {failed} öğe yeniden adlandırılamadı",
  "e2e.names.progress_one": "Şu ana kadar {n} ad şifrelendi · {failed} öğe yeniden adlandırılamadı",
  "e2e.names.done": "Adlar şifrelendi ({n} öğe yeniden adlandırıldı). Sunucu artık adları göremiyor.",
  "e2e.names.done_one": "Adlar şifrelendi ({n} öğe yeniden adlandırıldı). Sunucu artık adları göremiyor.",
  "e2e.names.stopped": "{n} addan sonra durduruldu. Kalanlar siz devam edene kadar açık adlarını korur.",
  "e2e.names.stopped_one": "{n} addan sonra durduruldu. Kalanlar siz devam edene kadar açık adlarını korur.",
  "e2e.names.partial": "{n} öğe yeniden adlandırılamadı (izin yok ya da ad bir diskte tutulamıyor). Adları açık kalıyor; devam etmek için yeniden deneyin.",
  "e2e.names.partial_one": "{n} öğe yeniden adlandırılamadı (izin yok ya da ad bir diskte tutulamıyor). Adı açık kalıyor; devam etmek için yeniden deneyin.",
  "e2e.names.failed": "Adlar şifrelenemedi. Zaten yeniden adlandırılanlar kaybolmaz; devam etmek için yeniden deneyin.",
  "e2e.names.strip_fix": "{n} adı düzelt (açık kalmış ya da filex dışından taşınmış)",
  "e2e.names.strip_fix_one": "{n} adı düzelt (açık kalmış ya da filex dışından taşınmış)",
  "e2e.create.names_root_hint": "Klasörün kendi adı her durumda açık kalır - şifresiz bir klasörün içinde durur. Hiçbir şey ele vermeyen bir ad seçin.",
  "e2e.locked_toast": "Klasör kilitlendi",
  "e2e.app_closed_unsaved": "“{name}” dosyasında kaydedilmemiş değişiklikler kayboldu: klasör kilitlenince uygulama kapandı.",
  "e2e.upload.locked": "Önce klasörün kilidini açın",
  "e2e.decrypting": "Çözülüyor…",
  "e2e.decrypt_failed": "Dosya çözülemedi (parola değişmiş ya da dosya bozulmuş olabilir).",
  /* wiring:e2 recovery - kurtarma anahtarı + yönetici escrow'u */
  "e2e.create.escrow_title": "Bu sunucunun da bir anahtarı var",
  "e2e.create.escrow_body": "Bu kurulumda anahtar emaneti (escrow) açık: sunucunun işletmecisi bu klasörü parolanız olmadan açabilir. O anahtar kullanıldığında size bildirim gelir. Escrow sunucu kurulurken sabitlenir; bir klasör için kapatılamaz.",
  "e2e.locked.use_recovery": "Parolayı mı kaybettiniz? Kurtarma anahtarı kullanın",
  "e2e.recovery.title": "Kurtarma anahtarınızı saklayın",
  "e2e.recovery.title_upgraded": "Kurtarma anahtarınız",
  "e2e.recovery.lead": "Bu anahtar klasörü parolasız açar. Yalnız bir kez gösterilir - filex bu anahtarı saklamaz ve bir daha gösteremez.",
  "e2e.recovery.lead_upgraded": "Bu klasörün artık bir kurtarma anahtarı var. Klasörü parolasız açar, yalnız bir kez gösterilir ve filex'te kopyası kalmaz.",
  "e2e.recovery.copy": "Kopyala",
  "e2e.recovery.copied": "Kopyalandı",
  "e2e.recovery.download": "Dosya olarak indir",
  "e2e.recovery.warn_title": "BUNU PAROLA GİBİ SAKLAYIN",
  "e2e.recovery.warn_body": "Bu anahtarı eline geçiren herkes klasörü okuyabilir. Parolanızdan ayrı bir yerde tutun - parolanın yanında duran bir anahtar sizi unutmaya karşı korur, başkasına karşı değil.",
  "e2e.recovery.escrow_title": "Bu sunucunun da bir anahtarı var",
  "e2e.recovery.escrow_body": "Bu kurulumda anahtar emaneti açık: sunucunun işletmecisi bu klasörü parolanız olmadan açabilir. O anahtar kullanıldığında size bildirim gelir.",
  "e2e.recovery.escrow_kid": "Emanet anahtarı",
  "e2e.recovery.ack": "Bu anahtarı güvenli bir yere kaydettim.",
  "e2e.recovery.done": "Tamam",
  "e2e.recover.title": "Parolasız kilit açma",
  "e2e.recover.none": "Bu klasör kurtarma anahtarları eklenmeden önce oluşturulmuş, bu yüzden anahtarı yok. Tek giriş yolu parolası. Bir kez parolayla açın, filex kurtarma anahtarı eklemeyi önerecek.",
  "e2e.recover.tab_recovery": "Kurtarma anahtarı",
  "e2e.recover.tab_escrow": "Emanet anahtarı",
  "e2e.recover.recovery_hint": "Klasör oluşturulurken bir kez gösterilen anahtar.",
  "e2e.recover.recovery_placeholder": "XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX",
  "e2e.recover.escrow_warn_title": "Klasörün sahibine haber gidecek",
  "e2e.recover.escrow_warn_body": "Emanet anahtarıyla açılan klasörün sahibine bildirim gönderilir. Yalnız yetkiniz olduğunda kullanın.",
  "e2e.recover.escrow_kid": "Emanet anahtarı",
  "e2e.recover.escrow_predates": "Bu kurulumun emanet anahtarı var ama bu klasörün yok. Klasör, emanet burada açılmadan önce oluşturulmuş; ana anahtarı emanet kimliğine hiç sarmalanmadı. Emanet anahtarı bu klasörü açmaz. İşletmecinin yapabileceği hiçbir şey bunu değiştirmez - sarmalama için klasörün parolası gerekir ve sunucu onu hiçbir zaman görmedi. Klasörün sahibi verebilir: parolayla kilidi açıp işletmeciye anahtar vermeyi seçebilir. O yapılana kadar parolayı ya da kurtarma anahtarını kullanın.",
  "e2e.recover.escrow_other_key": "Bu klasör BAŞKA bir kurulumun emanet anahtarını taşıyor. Başka yerde oluşturulup buraya geri yüklenmiş, bu yüzden bu kurulumun emanet anahtarı onu açmaz. Yalnızca sarmalandığı emanet anahtarının özel yarısı açabilir.",
  "e2e.recover.escrow_placeholder": "Emanet özel anahtarını yapıştırın (PKCS#8, base64 ya da PEM)",
  "e2e.recover.bad_format": "Bu bir kurtarma anahtarına benzemiyor. Dörtlü sekiz grup, toplam 32 karakter olmalı.",
  "e2e.recover.escrow_required": "Emanet özel anahtarını yapıştırın.",
  "e2e.recover.wrong_recovery": "Bu kurtarma anahtarı bu klasörü açmıyor.",
  "e2e.recover.wrong_escrow": "Bu emanet anahtarı bu klasörü açmıyor. Emanet açılmadan önce oluşturulmuş bir klasörün, sahibi izin verene kadar emanet anahtarı yoktur - o zamana kadar parolayı ya da kurtarma anahtarını kullanın.",
  "e2e.recover.bad_escrow_key": "Bu okunabilir bir özel anahtar değil (PKCS#8, base64 ya da PEM bekleniyor).",
  "e2e.recover.notify_failed": "Klasör sahibine bildirim gönderilemedi, bu yüzden kilit açılmadı. Emanet anahtarının kullanımı her zaman duyurulur.",
  "e2e.recover.recovery_done": "Kurtarma anahtarıyla açıldı",
  "e2e.recover.escrow_done": "Emanet anahtarıyla açıldı - klasör sahibine bildirildi",
  "e2e.recover.unlock": "Kilidi aç",
  "e2e.recover.busy": "Açılıyor…",
  "e2e.escrowoffer.title": "İşletmeciye bu klasörün anahtarı verilsin mi?",
  "e2e.escrowoffer.body": "Bu klasör, burada anahtar emaneti açılmadan önce oluşturulmuş; bu yüzden kurulumun işletmecisi onu açamıyor. Şu anda - parolanız bellekteyken - filex bu klasörü emanet anahtarına sarmalayabilir. Dosyalarınız yeniden şifrelenmez, hiçbir yere taşınmaz; yalnızca anahtar dosyası değişir.",
  "e2e.escrowoffer.consequence": "Bunun anlamı: işletmeci, parolanız olmadan bu klasöre giren ikinci ve kalıcı bir yol kazanır. O anahtar kullanıldığında size bildirim gelir, ama bu bildirim bir denetim değil yalnızca bir duyurudur.",
  "e2e.escrowoffer.learn_more": "Emanet anahtarı neyi yapar, neyi yapamaz",
  "e2e.escrowoffer.password_label": "Klasör parolası",
  "e2e.escrowoffer.password_required": "Klasör parolasını girin.",
  "e2e.escrowoffer.wrong_password": "Bu, bu klasörün parolası değil.",
  "e2e.escrowoffer.accept": "İşletmeciye anahtar ver",
  "e2e.escrowoffer.decline": "Hayır, bende kalsın",
  "e2e.escrowoffer.cancel": "Vazgeç",
  "e2e.escrowoffer.busy": "Sarmalanıyor…",
  "e2e.escrowoffer.done": "İşletmeci artık bu klasörü emanet anahtarıyla açabilir",
  "e2e.escrowoffer.declined_toast": "Sizde kaldı. filex bu klasör için bir daha sormayacak.",
  "e2e.escrowoffer.decline_failed": "Cevabınız kaydedilemedi, bu yüzden filex bir dahakine yine soracak. Klasörde hiçbir şey değişmedi.",
  "e2e.escrowoffer.failed": "İşletmeciye bu klasörün anahtarı verilemedi",
  "e2e.escrowoffer.strip_action": "Emanet anahtarı…",
  "e2e.upgrade.title": "Bu klasörün kurtarma anahtarı yok",
  "e2e.upgrade.body": "Kurtarma anahtarları eklenmeden önce oluşturulmuş, bu yüzden tek giriş yolu parolası. Şu anda - ve yalnız şu anda, parola bellekteyken - filex bir tane ekleyebilir. Dosyalarınız yeniden şifrelenmez, hiçbir yere taşınmaz.",
  "e2e.upgrade.escrow_note": "Not: bu kurulumda anahtar emaneti açık; kurtarma anahtarı eklemek aynı zamanda işletmecinin bu klasörü parolanız olmadan açabilmesi demektir.",
  "e2e.upgrade.accept": "Kurtarma anahtarı oluştur",
  "e2e.upgrade.decline": "Şimdi değil",
  "e2e.upgrade.busy": "Oluşturuluyor…",
  "e2e.upgrade.failed": "Bu klasöre kurtarma anahtarı eklenemedi",
  "e2e.download.failed": "Şifreli dosya indirilemedi.",
  /* /wiring:e2 */
  /* ── connections: storage config + "how to connect" ──────────────
     `storages.*` keys are the ones the BACKEND's driver descriptors
     name (each driver package declares one next to its Init). They are
     kept identical to web/src/locales/*.json on purpose: the same
     descriptor is rendered on both surfaces, so a field that reads
     "Base path" in the admin panel and something else in the desktop
     app would be the same drift this whole mechanism exists to stop. */
  "conn.title": "Bağlantılar",
  "conn.subtitle": "{host} sunucusuna kendi bilgisayarınızdan nasıl erişilir: bağlayın ya da bir istemciyi buraya yönlendirin.",
  "conn.close": "Kapat",
  "conn.list.disabled": "Kapalı",
  "conn.form.required": "Zorunlu",
  "conn.form.advanced": "Gelişmiş ayarlar",
  "conn.form.yes": "Evet",
  "conn.form.no": "Hayır",
  "conn.form.noFields": "Bu sunucu bu sürücü için hiçbir ayar tanımlamadı.",
  "conn.form.reveal": "Göster",
  "conn.form.hide": "Gizle",
  "conn.guide.protocol": "Protokol",
  "conn.guide.storage": "Depo",
  "conn.guide.allStorages": "Tüm depolar",
  "conn.guide.copy": "Kopyala",
  "conn.guide.copied": "Kopyalandı",
  "conn.guide.goodToKnow": "Bilmekte fayda var",
  "conn.guide.userPlaceholder": "eposta@ornek.com",
  "conn.guide.secretPlaceholder": "parolanız-ya-da-api-anahtarınız",
  "conn.guide.fact.url": "Adres",
  "conn.guide.fact.urlRootHint": "Görebildiğiniz her depo bu adresin altında bir klasör olarak görünür.",
  "conn.guide.fact.urlStorageHint": "Doğrudan “{storage}” deposunu bağlar. Son parçayı silerseniz tüm depoları görürsünüz.",
  "conn.guide.fact.user": "Kullanıcı adı",
  "conn.guide.fact.password": "Parola",
  "conn.guide.webdav.summary": "WebDAV, filex’i bir sürücü gibi bağlar: Windows Gezgini, macOS Finder, Linux, rclone ve Cyberduck bu protokolü konuşur ve yapılan her değişiklik filex’e yansır.",
  "conn.guide.webdav.userHint": "Kullanıcı adınız ya da e-postanız - görünen adınız değil.",
  "conn.guide.webdav.passwordHint": "Hesap parolanız ya da bir API anahtarı (gezinti panelindeki API anahtarları bölümü). İki adımlı doğrulaması açık bir hesap ZORUNLU olarak API anahtarı kullanır: Basic kimlik doğrulamasında ikinci adım için yer yoktur.",
  "conn.guide.webdav.win.s1": "Dosya Gezgini’ni açın, Bu bilgisayar’a sağ tıklayın ve “Ağ sürücüsü bağla…” deyin.",
  "conn.guide.webdav.win.s2": "Bir sürücü harfi seçin ve klasör olarak {url} adresini girin.",
  "conn.guide.webdav.win.s3": "“Farklı kimlik bilgileri kullanarak bağlan” kutusunu işaretleyin ve yukarıdaki kullanıcı adı/parola ile girin.",
  "conn.guide.webdav.win.cmdCaption": "Komut İstemi (sihirbaz olmadan aynı iş)",
  "conn.guide.webdav.win.limits": "Windows’un tam olarak filex hatası gibi görünen üç yerleşik sınırı vardır: aktarımlar ~47,7 MB’ta durur, yaklaşık bin dosyalı klasörler açılmaz (“Disk biçimlendirilmemiş”) ve her iki ayarı değiştirdikten sonra WebClient hizmeti yeniden başlatılmalıdır.",
  "conn.guide.webdav.win.regCaption": "Yönetici olarak çalıştırın, sonra sürücüyü yeniden bağlayın",
  "conn.guide.webdav.win.https": "HTTPS zorunludur. Windows Basic kimlik bilgilerini yalnızca TLS üzerinden gönderir; düz http:// üzerinde hiçbir açıklama vermeden reddeder. BasicAuthLevel değerini 2 yapmayın - TLS kullanın.",
  "conn.guide.webdav.win.persist": "Bağlanan sürücü oturum kapatmayı atlatamaz: Windows 7’den beri Basic kimlik bilgileri Kimlik Bilgisi Yöneticisi’nde saklanamaz ve /persistent:yes bunu değiştirmez. Kendiliğinden geri gelsin istiyorsanız komutu bir oturum açma betiğinden yeniden çalıştırın.",
  "conn.guide.webdav.win.service": "Hiç bağlanamıyorsa WebClient hizmetinin çalıştığından emin olun: sc config WebClient start= auto && net start WebClient.",
  "conn.guide.webdav.mac.s1": "Finder’da Git → Sunucuya Bağlan… (⌘K) yolunu izleyin.",
  "conn.guide.webdav.mac.s2": "{url} adresini girip bağlanın.",
  "conn.guide.webdav.mac.s3": "Yukarıdaki kullanıcı adı ve parolayla kimliğinizi doğrulayın.",
  "conn.guide.webdav.mac.note": "Sürücü Konumlar altında görünür; her depo en üst düzeyde bir klasördür.",
  "conn.guide.webdav.linux.mountCaption": "davfs2 ya da masaüstü dosya yöneticisi (GNOME Dosyalar, Dolphin)",
  "conn.guide.webdav.linux.gvfsComment": "ya da bu adresi GNOME Dosyalar / Dolphin icine yapistirin",
  "conn.guide.webdav.linux.locks": "davfs2 için kilitler kapatılmalıdır. filex WebDAV kilitlerini süreç belleğinde tutar; yeniden başlatmayı atlatamazlar ve kopyalar arasında paylaşılmazlar - davfs2 tersini varsayar ve takılır.",
  "conn.guide.webdav.rclone.obscureCaption": "rclone parolayı gizlenmiş biçimde saklar - önce bunu çalıştırıp çıktısını aşağıya yapıştırın",
  "conn.guide.webdav.rclone.passPlaceholder": "<rclone obscure çıktısı>",
  "conn.guide.webdav.rclone.useCaption": "Kullanımı",
  "conn.guide.webdav.duck.s1": "Yeni Yer İmi → WebDAV (HTTPS).",
  "conn.guide.webdav.duck.s2": "Sunucu {host}, port 443.",
  "conn.guide.webdav.duck.s3": "Yol {path}.",
  "conn.guide.webdav.duck.s4": "Kullanıcı adı {user}, parola yukarıdaki gibi.",
  "conn.guide.webdav.note.delete": "WebDAV üzerinden silme kalıcıdır. Web arayüzü dosyaları filex çöp kutusuna taşır; istemciden silme ise nesneyi doğrudan arka uçtan kaldırır.",
  "conn.guide.webdav.note.locks": "Kilitler sunucu belleğinde durur: yeniden başlatmayı atlatamazlar ve kopyalar arasında paylaşılmazlar. Windows ile Office’i memnun etmek için varlar, eşzamanlı düzenlemeyi hakemlemek için değil.",
  "conn.guide.webdav.note.permissions": "Web arayüzünde ne görüyorsanız burada da onu görürsünüz. Kök yalnızca açabildiğiniz depoları listeler; yetkiniz dışındaki bir yol 403 değil 404 döner, böylece ağaç neyin var olduğunu sızdırmaz.",
  "conn.guide.webdav.note.http": "Bu sunucuya düz http:// ile erişiliyor. Windows kimlik bilgilerinizi hiç göndermez, diğer tüm istemciler ise parolanızı açık metin olarak yollar. Bağlamadan önce filex’i TLS arkasına alın.",
  // ── S3 ucu: anahtarlar ve rehber ─────────────────────────────────
  "conn.s3keys.title": "S3 erişim anahtarları",
  "conn.s3keys.lead": "Bir erişim anahtarı, S3 konuşan her istemcinin - rclone, restic, AWS CLI, mc, s3fs, Cyberduck - filex’e bağlanmasını sağlar. Anahtar sizin yetkinizi taşır, bir fazlasını değil.",
  "conn.s3keys.disabled": "Bu sunucuda S3 ucu kapalı (FILEX_S3). Burada üretilen anahtar, yönetici ucu tekrar açana kadar bağlanmaz.",
  "conn.s3keys.cannotMint": "Erişim anahtarı üretebilecek bir hesapla oturum açmış değilsiniz. Aşağıdaki talimatlar yine geçerli - bir anahtar isteyip yapıştırmanız yeter.",
  "conn.s3keys.label": "Ne için? (dizüstü yedeği, CI, …)",
  "conn.s3keys.defaultLabel": "erişim anahtarı",
  "conn.s3keys.everyBucket": "Görebildiğim tüm kovalar",
  "conn.s3keys.prefix": "Kova içindeki klasör (isteğe bağlı)",
  "conn.s3keys.mint": "Anahtar oluştur",
  "conn.s3keys.inheritNote": "Bir anahtar sahip olduğunuz yetkiyi yalnızca DARALTABİLİR: yetkileriniz ve rolünüz. Anahtarı tek bir kovaya ya da klasöre kısıtlamak, bir dizüstü yedeği ile her şeyi okuyabilen bir kimlik arasındaki farktır.",
  "conn.s3keys.once": "Gizli anahtarı şimdi kopyalayın - bir daha gösterilmeyecek.",
  "conn.s3keys.accessKeyID": "Erişim anahtarı kimliği",
  "conn.s3keys.secret": "Gizli anahtar",
  "conn.s3keys.dismiss": "Kopyaladım",
  "conn.s3keys.col.label": "Etiket",
  "conn.s3keys.col.key": "Erişim anahtarı kimliği",
  "conn.s3keys.col.scope": "Kapsam",
  "conn.s3keys.col.lastUsed": "Son kullanım",
  "conn.s3keys.scopeAll": "görebildiğiniz her şey",
  "conn.s3keys.noLabel": "(etiketsiz)",
  "conn.s3keys.neverUsed": "hiç",
  "conn.s3keys.enable": "Aç",
  "conn.s3keys.disable": "Kapat",
  "conn.s3keys.revoke": "İptal et",
  "conn.s3keys.confirm": "Emin misiniz?",
  "conn.s3keys.empty": "Henüz erişim anahtarı yok.",
  "conn.guide.s3.summary": "S3 ucu, S3 konuşan her şeyin - yedekleme, eşitleme araçları, SDK’lar - hedefi olarak filex’i kullanmanızı sağlar; hem de zaten sahip olduğunuz depolarla.",
  "conn.guide.s3.keyPlaceholder": "yukarıdan bir anahtar oluşturun",
  "conn.guide.s3.secretPlaceholder": "anahtarı oluştururken bir kez gösterilir",
  "conn.guide.s3.fact.endpoint": "Uç adresi",
  "conn.guide.s3.fact.endpointHint": "İstemciyi buraya yöneltin, filex’in web adresine değil.",
  "conn.guide.s3.fact.bucket": "Kova",
  "conn.guide.s3.fact.bucketHint": "Kova = filex deposu. Kovaları istemci değil yönetici oluşturur.",
  "conn.guide.s3.fact.key": "Erişim anahtarı kimliği",
  "conn.guide.s3.fact.keyHint": "Genel yarısı; her istekte gider.",
  "conn.guide.s3.fact.secret": "Gizli anahtar",
  "conn.guide.s3.fact.secretHint": "Yalnızca anahtar oluşturulurken bir kez gösterilir. filex bir daha gösteremez - kaybolduysa yeni anahtar üretin.",
  "conn.guide.s3.fact.region": "Bölge",
  "conn.guide.s3.fact.regionHint": "filex’te bölge yok; hangi değeri verirseniz aynen geri döner. Yine de istemciler bir değer ister.",
  "conn.guide.s3.fact.addressing": "Adresleme",
  "conn.guide.s3.fact.pathStyle": "yol tabanlı (zorunlu)",
  "conn.guide.s3.fact.pathStyleHint": "Bu kurulumda S3’e ayrılmış bir alan adı yok, yani kova.host çözülmez.",
  "conn.guide.s3.fact.virtualHosted": "sanal-host ya da yol tabanlı",
  "conn.guide.s3.fact.virtualHostedHint": "Bu kurulumun kendi S3 alan adı var, iki adresleme de çalışır.",
  "conn.guide.s3.rclone.useCaption": "Kullanımı",
  "conn.guide.s3.rclone.mtime": "filex dosyanın değişiklik zamanını taşır (x-amz-meta-mtime); böylece rclone sync ilk turdan sonra oturur, her seferinde her şeyi yeniden yüklemez.",
  "conn.guide.s3.aws.configureCaption": "Bir kez ayarlayın",
  "conn.guide.s3.aws.useCaption": "Kullanımı",
  "conn.guide.s3.aws.pathStyle": "AWS yapılandırmanıza yol tabanlı adreslemeyi ekleyin; yoksa her komut DNS aşamasında düşer.",
  "conn.guide.s3.restic.envCaption": "Ortam değişkenleri",
  "conn.guide.s3.restic.useCaption": "Yedekle, doğrula, buda",
  "conn.guide.s3.restic.verified": "Bu uca karşı ölçüldü: restic check --read-data her pack’i bayt bayt okuyor ve hata bulmuyor.",
  "conn.guide.s3.mc.aliasCaption": "Takma adı ekleyin",
  "conn.guide.s3.mc.useCaption": "Kullanımı",
  "conn.guide.s3.s3fs.credsCaption": "Kimlik dosyası",
  "conn.guide.s3.s3fs.mountCaption": "Bağlayın",
  "conn.guide.s3.s3fs.note": "s3fs üzerinden bir dosyayı düzenlemek nesnenin tamamını yeniden yazar; silme ise filex çöp kutusuna gider. Paylaşılan bir klasör için iyi, veritabanı için değil.",
  "conn.guide.s3.duck.s1": "Yeni yer imi → Amazon S3.",
  "conn.guide.s3.duck.s2": "Sunucu: {host}.",
  "conn.guide.s3.duck.s3": "Erişim anahtarı kimliği: {key}, gizli anahtar yukarıdaki.",
  "conn.guide.s3.duck.s4": "Yer imini açın; kovalar sizin filex depolarınızdır.",
  "conn.guide.s3.duck.pathStyle": 'Tercihler → S3 altında "Use virtual host style" seçeneğini KAPATIN - bu kurulumda joker S3 alan adı yok.',
  "conn.guide.s3.sdk.note": "SigV4 konuşan her istemci aynı şekilde çalışır: uç adresi, anahtar, gizli anahtar ve bu kurulumun kendi S3 alan adı yoksa yol tabanlı adresleme.",
  "conn.guide.s3.note.buckets": "Kova = filex deposu. İstemci kovanın İÇİNDE klasör ve nesne oluşturabilir, ama kovanın kendisini oluşturamaz: kova bir sürücü ve bir yol ister, bunu bir S3 isteği ifade edemez.",
  "conn.guide.s3.note.permissions": 'Anahtar tam olarak sizin gördüğünüzü görür. Açamayacağınız bir kova "yasak" değil "böyle bir kova yok" der; böylece uç, neyin var olduğunu sızdırmaz.',
  "conn.guide.s3.note.trash": "Silme her yerdeki gibi filex çöp kutusuna gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.s3.note.mtime": "Yüklemeler değişiklik zamanını taşır; istemcinin gönderdiği sağlama toplamları (Content-MD5, x-amz-checksum-*) doğrulanır - bozulmuş bir yükleme saklanmaz, reddedilir.",
  "conn.guide.s3.note.pathStyle": "Bu kurulumda S3’e ayrılmış alan adı yok; istemcilere yol tabanlı adresleme söylenmeli. Söylenmezse güncel bir SDK, ne filex’i ne de sebebi anan bir DNS hatasıyla düşer.",
  "conn.guide.s3.note.http": "Bu uç düz http://. İmzalar isteği yine korur ama nesneler açık metin gider. Bir yedeği buraya yöneltmeden önce filex’i TLS arkasına alın.",
  // ── SFTP ucu: anahtarlar ve rehber ───────────────────────────────
  "conn.sshkeys.title": "SSH anahtarları",
  "conn.sshkeys.lead": "Bir açık anahtar kaydedin; SSH konuşan her istemci - sftp, scp, WinSCP, FileZilla, rclone, sshfs - parolanızı göndermeden bağlansın.",
  "conn.sshkeys.disabled": "Bu sunucuda SFTP ucu kapalı (FILEX_SFTP). Burada kaydedilen anahtar, yönetici ucu açana kadar bağlanmaz.",
  "conn.sshkeys.cannotAdd": "Anahtar kaydedebilecek bir hesapla oturum açmış değilsiniz.",
  "conn.sshkeys.paste": "~/.ssh/id_ed25519.pub dosyasının içeriğini yapıştırın",
  "conn.sshkeys.name": "Ad (isteğe bağlı - boşsa anahtarın kendi yorumu kullanılır)",
  "conn.sshkeys.add": "Anahtar ekle",
  "conn.sshkeys.noCopyId": "ssh-copy-id burada çalışamaz: kabuk üzerinden ~/.ssh/authorized_keys dosyasına ekler, filex’in kabuğu yoktur. Anahtar eklemenin yolu bu kutudur.",
  "conn.sshkeys.col.name": "Ad",
  "conn.sshkeys.col.fingerprint": "Parmak izi",
  "conn.sshkeys.col.added": "Eklendi",
  "conn.sshkeys.col.lastUsed": "Son kullanım",
  "conn.sshkeys.noName": "(adsız)",
  "conn.sshkeys.neverUsed": "hiç",
  "conn.sshkeys.enable": "Aç",
  "conn.sshkeys.disable": "Kapat",
  "conn.sshkeys.remove": "Sil",
  "conn.sshkeys.confirm": "Emin misiniz?",
  "conn.sshkeys.empty": "Henüz anahtar yok. Anahtarsız istemciler hesap parolanızla oturum açar.",
  "conn.guide.sftp.summary": "SFTP, filex’i SSH konuşan her şeyin erişebileceği hâle getirir: bir yedekleme işi, bir tarayıcı, WinSCP, rclone ya da bağlanmış bir klasör.",
  "conn.guide.sftp.fact.host": "Sunucu",
  "conn.guide.sftp.fact.hostHint": "Web uygulamasıyla aynı makine, kendine ait bir portta.",
  "conn.guide.sftp.fact.port": "Port",
  "conn.guide.sftp.fact.portHint": "Ne 22 ne 443: SFTP ham TCP’dir, web vekilinin içinden geçemez.",
  "conn.guide.sftp.fact.userHint": "Kullanıcı adınız. İçinde @ işareti olsaydı çoğu istemcinin ayar dosyasında tırnaklanması gerekirdi; kullanıcı adı tam da bunu ortadan kaldırır.",
  "conn.guide.sftp.fact.auth": "Oturum açma yöntemi",
  "conn.guide.sftp.fact.authKey": "kayıtlı SSH anahtarınız (ya da parolanız)",
  "conn.guide.sftp.fact.authPassword": "hesap parolanız - ya da yukarıdan bir anahtar kaydedin",
  "conn.guide.sftp.fact.authHint": "API anahtarı da parola yerine geçer ve tek başına iptal edilebilir. İki adımlı doğrulaması açık bir hesap SSH anahtarı ya da API anahtarı kullanmalıdır.",
  "conn.guide.sftp.fact.path": "Yol",
  "conn.guide.sftp.fact.pathHint": "İlk klasör bir depodur; kök, açabildiğiniz depoları listeler.",
  "conn.guide.sftp.openssh.connectCaption": "Bağlan, gönder, al",
  "conn.guide.sftp.openssh.noShell": "Burada kabuk yok, yalnız SFTP alt sistemi var. `ssh sunucu komut` bilerek reddedilir; scp çalışır çünkü OpenSSH 9 onun için de SFTP konuşur.",
  "conn.guide.sftp.key.tab": "Anahtar kurulumu",
  "conn.guide.sftp.key.s1": "Bağlanacak makinede bir anahtar çifti üretin (zaten varsa atlayın).",
  "conn.guide.sftp.key.s2": "AÇIK yarısını kopyalayın - .pub dosyası, asla diğeri değil.",
  "conn.guide.sftp.key.s3": "Yukarıdaki kutuya yapıştırıp bağlanın; o andan sonra parola gönderilmez.",
  "conn.guide.sftp.key.genCaption": "Kendi makinenizde",
  "conn.guide.sftp.key.noCopyId": "ssh-copy-id filex’e karşı ÇALIŞMAZ: ~/.ssh/authorized_keys dosyasına eklemek için kabuğa ihtiyacı var, filex’te kabuk yok. Anahtarı yukarıdan yapıştırın.",
  "conn.guide.sftp.winscp.s1": "Yeni site → Dosya protokolü: SFTP.",
  "conn.guide.sftp.winscp.s2": "Sunucu adı: {host}, port: {port}.",
  "conn.guide.sftp.winscp.s3": "Kullanıcı adı: {user}. Anahtar için: Gelişmiş → SSH → Kimlik Doğrulama → özel anahtar dosyası.",
  "conn.guide.sftp.winscp.s4": "WinSCP .ppk biçiminde özel anahtar ister - OpenSSH anahtarını kendi aracıyla (Araçlar → PuTTYgen) bir kez dönüştürün.",
  "conn.guide.sftp.filezilla.s1": "Dosya → Site Yöneticisi → Yeni site, Protokol: SFTP.",
  "conn.guide.sftp.filezilla.s2": "Sunucu: {host}, port: {port}.",
  "conn.guide.sftp.filezilla.s3": "Kullanıcı: {user}. Giriş türü: parola için Normal, anahtar için Anahtar dosyası.",
  "conn.guide.sftp.rclone.useCaption": "Kullanımı",
  "conn.guide.sftp.sshfs.mountCaption": "Bağla ve çöz",
  "conn.guide.sftp.sshfs.note": "Bağlanmış bir klasörde her kayıt dosyanın tamamını yeniden yazar. Belgeler için iyi; veritabanı ya da yerinde düzenlediğiniz bir video için değil.",
  "conn.guide.sftp.note.storages": "Kök bir ev dizini değildir: açabildiğiniz depoları listeler ve yolun ilk parçası bir depoyu adlandırır.",
  "conn.guide.sftp.note.permissions": "İstemcinizin çizdiği izin bitleri buradaki erişim seviyenizden gelir; yani salt-okunur görünen bir dosya sizin için gerçekten öyledir.",
  "conn.guide.sftp.note.trash": "Silme her yerdeki gibi filex çöp kutusuna gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.sftp.note.totp": "Hesabınızda iki adımlı doğrulama açıksa parola burada çalışmaz - SSH’ın kodu soracak bir kanalı yok. Bir SSH anahtarı kaydedin ya da parola yerine API anahtarı kullanın.",
  "conn.guide.sftp.note.disabled": "Bu sunucuda SFTP ucu kapalı. Yönetici açtığında bu talimatlar çalışacaktır.",
  // ── FTPS ─────────────────────────────────────────────────────────
  "conn.guide.ftps.summary": "FTPS, yalnızca FTP öğrenmiş ekipman için var: tarayıp-klasöre-atan yazıcılar, EDI muhatapları, eski laboratuvar ve endüstri yazılımları. Her zaman TLS üzerinden.",
  "conn.guide.ftps.fact.host": "Sunucu",
  "conn.guide.ftps.fact.hostHint": "Web uygulamasıyla aynı makine, kendine ait bir portta.",
  "conn.guide.ftps.fact.port": "Port",
  "conn.guide.ftps.fact.portHint": "Kontrol kanalı. Veri, aşağıdaki pasif aralıktan ayrı bir porttan akar.",
  "conn.guide.ftps.fact.mode": "Şifreleme",
  "conn.guide.ftps.fact.modeValue": "FTPS - açık (explicit) TLS, zorunlu",
  "conn.guide.ftps.fact.modeHint": 'Düz FTP, parola okunmadan reddedilir. "Require explicit FTP over TLS" seçin; "plain FTP" ya da "implicit" asla.',
  "conn.guide.ftps.fact.userHint": "Kullanıcı adınız ya da e-postanız. Parola yerine bir API anahtarı da kullanılabilir ve tek başına iptal edilebilir.",
  "conn.guide.ftps.fact.passwordHint": "Hesap parolanız ya da bir API anahtarı. İki adımlı doğrulaması açık bir hesap API anahtarı kullanmalıdır - FTP'nin kodu soracak bir yolu yok.",
  "conn.guide.ftps.fact.pasv": "Pasif portlar",
  "conn.guide.ftps.fact.pasvHint": "Veri bağlantıları buraya düşer. Güvenlik duvarınız bu aralığı kapatıyorsa aktarım iki tarafta da hata vermeden ASILI KALIR - FTP'nin klasik arızası budur.",
  "conn.guide.ftps.filezilla.s1": "Dosya → Site Yöneticisi → Yeni site, Protokol: FTP.",
  "conn.guide.ftps.filezilla.s2": "Sunucu: {host}, port: {port}.",
  "conn.guide.ftps.filezilla.s3": 'Şifreleme: "Require explicit FTP over TLS". Giriş türü: Normal, kullanıcı: {user}.',
  "conn.guide.ftps.filezilla.s4": "Aktarım ayarları → Pasif. Bu sunucu aktif modu reddeder.",
  "conn.guide.ftps.winscp.s1": "Yeni site → Dosya protokolü: FTP, Şifreleme: TLS/SSL Explicit encryption.",
  "conn.guide.ftps.winscp.s2": "Sunucu adı: {host}, port: {port}.",
  "conn.guide.ftps.winscp.s3": "Kullanıcı adı: {user}, parola yukarıdaki.",
  "conn.guide.ftps.curl.caption": "Gönder ve al",
  "conn.guide.ftps.curl.sslReqd": "--ssl-reqd isteğe bağlı değil: curl'ün düz metne geri düşmek yerine TLS'i ZORUNLU kılmasını sağlar. Bu sunucu zaten düz metni reddediyor, ama alışkanlık sizi reddetmeyen sunuculara karşı korur.",
  "conn.guide.ftps.lftp.caption": "Bağlan",
  "conn.guide.ftps.lftp.protectData": "ssl-protect-data yalnız oturum açmayı değil DOSYAYI da şifreler. Olmazsa lftp TLS ile oturum açar ve dosyayı açık metin gönderir - sahada en sık yapılan FTPS yanlışı budur.",
  "conn.guide.ftps.rclone.useCaption": "Kullanımı",
  "conn.guide.ftps.printer.tab": "Tarayıcı / yazıcı",
  "conn.guide.ftps.printer.s1": "Cihazın tara-ve-FTP'ye-gönder ayarlarında: sunucu {host}, port {port}.",
  "conn.guide.ftps.printer.s2": "Kullanıcı: {user}, parola yukarıdaki. Cihaz için kendi parolanız yerine bir API anahtarı oluşturun - başka hiçbir şeyi değiştirmeden iptal edilebilir.",
  "conn.guide.ftps.printer.s3": "Yol: {path} - ya da önceden oluşturduğunuz bir alt klasör. Cihaz depo oluşturamaz.",
  "conn.guide.ftps.printer.s4": '"SSL/TLS" ya da "FTPS explicit" seçeneğini AÇIN ve PASİF modu seçin.',
  "conn.guide.ftps.printer.noTLS": "Tara-ve-gönder yazılımlarının önemli bir kısmı TLS konuşamıyor. Bu sunucu öyle bir cihazla konuşmayacak ve bu bilinçli: alternatifi, belgelerinizin ve parolanızın ofis ağında açık metin dolaşması.",
  "conn.guide.ftps.note.tls": "TLS zorunludur ve kapatan bir düğme yoktur. Düz FTP parolanızı açık metin gönderir, ardından dosyanızı da.",
  "conn.guide.ftps.note.passive": "Yalnızca pasif mod. Aktif modda sunucu istemciyi geri arar; bu NAT arkasında çalışmaz ve çoğu güvenlik duvarı tarafından engellenir.",
  "conn.guide.ftps.note.storages": "Kök bir ev dizini değildir: açabildiğiniz depoları listeler ve yolun ilk parçası bir depoyu adlandırır.",
  "conn.guide.ftps.note.trash": "Silme her yerdeki gibi filex çöp kutusuna gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.ftps.note.prefer": "İstemci SFTP konuşabiliyorsa onu tercih edin: tek bağlantı, tek port, pasif mod sürprizi yok.",
  "conn.guide.ftps.note.selfSigned": "Bu sunucu kendinden imzalı bir sertifika kullanıyor. Kanalı şifreler ama karşı tarafın kim olduğunu kanıtlamaz; çoğu istemci bir kez onay ister. Önemli bir iş için gerçek sertifika koyun.",
  "conn.guide.ftps.note.disabled": "Bu sunucuda FTPS ucu kapalı. Yönetici açtığında bu talimatlar çalışacaktır.",
  // ── NFS ──────────────────────────────────────────────────────────
  "conn.nfs.title": "NFS export'ları",
  "conn.nfs.lead": "Bir export, ağınızdaki bir makinenin filex'i sürücü olarak bağlamasını sağlar - medya oynatıcı, derleme sunucusu, yedek kutusu.",
  "conn.nfs.pathIsSecret": "⚠ Export yolu PAROLANIN TA KENDİSİDİR. NFS, Kerberos olmadan istemciye kim olduğunu soramaz; bu yüzden filex yola 32 rastgele bayt koyar: yolu bilen sizin adınıza bağlanır. Bağlama satırını bir kimlik bilgisi gibi saklayın - /etc/fstab çoğu sistemde herkes tarafından okunabilir.",
  "conn.nfs.disabled": "Bu sunucuda NFS ucu kapalı (FILEX_NFS). Burada oluşturulan export, yönetici ucu açana kadar bağlanmaz.",
  "conn.nfs.cannotMint": "Export oluşturabilecek bir hesapla oturum açmış değilsiniz.",
  "conn.nfs.label": "Ne için? (medya oynatıcı, yedek kutusu, …)",
  "conn.nfs.defaultLabel": "nfs export",
  "conn.nfs.everyStorage": "Görebildiğim tüm depolar",
  "conn.nfs.prefix": "Depo içindeki klasör (isteğe bağlı)",
  "conn.nfs.allowCidrs": "İzinli adresler, örn. 192.168.1.0/24 (isteğe bağlı)",
  "conn.nfs.readOnly": "Salt okunur",
  "conn.nfs.readOnlyHint": "Bir makine için güvenli varsayılan salt okunurdur: sizin yetkiniz ne olursa olsun bu bağlantı üzerinden her yazmayı reddeder. Adres listesi daha da daraltır - listenin dışından gelen bağlanamaz.",
  "conn.nfs.mint": "Export oluştur",
  "conn.nfs.once": "Şimdi kopyalayın - yol yalnızca bir kez gösterilir ve geri alınamaz.",
  "conn.nfs.dismiss": "Kopyaladım",
  "conn.nfs.col.label": "Etiket",
  "conn.nfs.col.scope": "Kapsam",
  "conn.nfs.col.mode": "Mod",
  "conn.nfs.col.lastUsed": "Son bağlanma",
  "conn.nfs.scopeAll": "görebildiğiniz her şey",
  "conn.nfs.modeRead": "salt okunur",
  "conn.nfs.modeWrite": "okuma/yazma",
  "conn.nfs.noLabel": "(etiketsiz)",
  "conn.nfs.neverUsed": "hiç",
  "conn.nfs.enable": "Aç",
  "conn.nfs.disable": "Kapat",
  "conn.nfs.revoke": "İptal et",
  "conn.nfs.confirm": "Emin misiniz?",
  "conn.nfs.empty": "Henüz export yok.",
  "conn.guide.nfs.summary": "NFS, filex'i kendi ağınızdaki bir makinede sürücü olarak bağlar - NAS protokolü, onu bekleyen cihazlar için.",
  "conn.guide.nfs.pathPlaceholder": "yukarıdan bir export oluşturun",
  "conn.guide.nfs.fact.host": "Sunucu",
  "conn.guide.nfs.fact.hostHint": "Web uygulamasıyla aynı makine, kendine ait bir portta.",
  "conn.guide.nfs.fact.port": "Port",
  "conn.guide.nfs.fact.portHint": "Hem port= hem mountport= buna ayarlanmalı; filex mount ve NFS servislerini tek portta veriyor.",
  "conn.guide.nfs.fact.export": "Export yolu",
  "conn.guide.nfs.fact.exportHint": "Kimlik bilgisi budur. Export oluşturulurken bir kez gösterilir ve hash'li saklanır - filex bir daha gösteremez.",
  "conn.guide.nfs.fact.options": "Bağlama seçenekleri",
  "conn.guide.nfs.fact.optionsHint": "nolock, çünkü filex NFS kilit yöneticisini çalıştırmıyor; nfsvers=3, çünkü bu sunucunun konuştuğu sürüm bu.",
  "conn.guide.nfs.linux.mountCaption": "Bağla",
  "conn.guide.nfs.linux.fstabSecret": "Bu yolu içeren bir /etc/fstab satırı, herkesin okuyabildiği bir dosyadaki paroladır. Ortamınızda önemliyse kimlik korumalı automount kullanın ya da bağlamayı yalnız root'un okuyabildiği bir unit dosyasında tutun.",
  "conn.guide.nfs.mac.mountCaption": "Bağla",
  "conn.guide.nfs.mac.resvport": "macOS resvport ister: istemcisi ayrıcalıklı bir kaynak portta ısrar eder ve olmadan bağlantıyı reddeder.",
  "conn.guide.nfs.win.s1": `Windows Özellikleri'nden "Services for NFS" → "Client for NFS" bileşenini açın (yalnız Pro ve Enterprise; Home'da yok).`,
  "conn.guide.nfs.win.s2": "Komut İstemi'ni yönetici olarak açın.",
  "conn.guide.nfs.win.s3": "Aşağıdaki komutla export'u bir sürücü harfine bağlayın.",
  "conn.guide.nfs.win.cmdCaption": "Z: sürücüsüne bağla",
  "conn.guide.nfs.win.port": "Windows'un mount servisinin portunu söyleme imkânı yok; yalnızca standart 2049 portundaki bir NFS sunucusuna erişebilir. Bu sunucu başka bir porttaysa SFTP'yi ya da filex masaüstü uygulamasını kullanın.",
  "conn.guide.nfs.nas.tab": "NAS / medya oynatıcı",
  "conn.guide.nfs.nas.s1": "Cihazın NFS ayarlarında: sunucu {host}, port {port} (ayrı ayrı soruyorsa hem NFS hem mount portunu ayarlayın).",
  "conn.guide.nfs.nas.s2": "Uzak yol: yukarıdaki export yolu, birebir.",
  "conn.guide.nfs.nas.s3": "NFS sürüm 3, kilitleme kapalı. Cihazın gerçekten yazması gerekmiyorsa export'u salt okunur oluşturun.",
  "conn.guide.nfs.note.unencrypted": "NFSv3 şifreli değildir. Trafiği okuyabilen dosyalarınızı görür, yolu öğrenen bağlanabilir. Ev/ofis ağında ya da VPN üzerinden kullanın - internet üzerinden asla.",
  "conn.guide.nfs.note.pathIsSecret": "Export yolu kimlik bilgisinin tamamıdır. Sızarsa yukarıdaki listeden iptal edin; değiştirilecek başka bir şey yok.",
  "conn.guide.nfs.note.noPortmapper": "111 portunda portmapper yok; portu söylenmeyen istemci sunucuyu bulamaz. Buradaki her komutun port= ve mountport= taşımasının sebebi bu.",
  "conn.guide.nfs.note.uid": "İstemcinizin gönderdiği kullanıcı ve grup kimlikleri yok sayılır: bağlantı zaten kime ait olduğunu biliyor. Gördüğünüz izinler filex'teki erişiminizden gelir.",
  "conn.guide.nfs.note.trash": "Silme her yerdeki gibi filex çöp kutusuna gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.nfs.note.revoke": "İptal anında değil, bir sonraki istekte etkili olur: NFS'te sonlandırılacak bir oturum yok, bağlantısı açık olan istemci sıradaki işleminde hata alır.",
  "conn.guide.nfs.note.disabled": "Bu sunucuda NFS ucu kapalı. Yönetici açtığında bu talimatlar çalışacaktır.",
  "conn.tokens.title": "API anahtarları",
  "conn.tokens.lead": "FTPS, WebDAV ve filex mount hesap parolanız yerine bir API anahtarıyla oturum açar. Buradan oluşturun - tek başına iptal edilebilir, ayrıca iki adımlı doğrulaması açık bir hesap bunlarda parolasını zaten kullanamaz.",
  "conn.tokens.mint": "API anahtarı oluştur",
  "conn.tokens.once": "Şimdi kopyalayın - yalnızca bir kez gösterilir. Sunucuda yalnız özeti saklandığı için bir daha gösterilemez.",
  "conn.tokens.dismiss": "Kopyaladım",
  "conn.tokens.cannotMint": "Bu oturum API anahtarı oluşturamıyor. Kendi hesabınızla oturum açıp oluşturun.",
  "conn.tokens.empty": "Henüz API anahtarı yok.",
  "conn.tokens.neverUsed": "hiç",
  "conn.tokens.revoke": "İptal et",
  "conn.tokens.confirm": "Emin misiniz?",
  "conn.tokens.col.label": "Ad",
  "conn.tokens.col.scopes": "İzinler",
  "conn.tokens.col.comments": "Yorumlar",
  "conn.tokens.col.used": "Son kullanım",
  "conn.tokens.revokeHint": "İptal, yalnız bir sonraki oturum açmayı değil AÇIK bağlantıyı da durdurur: SFTP ya da FTPS oturumu kesilir, bağlı bir sürücü yarım dakika içinde çalışmayı bırakır.",
  "conn.guide.mount.summary": "filex mount, uzaktaki bir filex sunucusunu bu makinede bir klasöre bağlar - tarayıcının kullandığı aynı HTTPS üzerinden. Buradakilerin her yerden çalışan tek yöntemi: yerel ağ da gerekmez, ek sunucu da, üçüncü parti bir istemci de.",
  "conn.guide.mount.fact.url": "Sunucu adresi",
  "conn.guide.mount.fact.urlHint": "Tarayıcıda kullandığınız adresin aynısı. Başka hiçbir şeye erişilebilir olması gerekmez.",
  "conn.guide.mount.fact.token": "API anahtarı",
  "conn.guide.mount.fact.tokenPlaceholder": "API anahtarları bölümünden oluşturun",
  "conn.guide.mount.fact.tokenHint": "Parolanız değil, bir API anahtarı - tek başına iptal edilebilir, ayrıca 2FA açık bir hesap burada parolasını zaten kullanamaz.",
  "conn.guide.mount.fact.remote": "Neyi bağlayacağınız",
  "conn.guide.mount.fact.remoteHint": "--remote vermezseniz her depo bir klasör olarak görünür; tek bir depoyu - ya da onun içindeki bir klasörü - adlandırırsanız yalnızca o bağlanır.",
  "conn.guide.mount.linux.mountCaption": "Bağlayın",
  "conn.guide.mount.linux.umountCaption": "Ayırın",
  "conn.guide.mount.linux.umountWarn": "Süreci öldürerek değil, fusermount ile ayırın. Ayrılmadan ölen bir bağlantı, birileri elle fusermount çalıştırana kadar her ls komutunun asılı kaldığı bir klasör bırakır.",
  "conn.guide.mount.linux.systemdCaption": "Oturum açılınca otomatik bağlansın (systemd kullanıcı birimi)",
  "conn.guide.mount.win.winfsp": "Windows'ta bir kez WinFsp kurulması gerekiyor - ücretsiz ve açık kaynak: https://winfsp.dev. Başka bir şey gerekmiyor, sonrasında yönetici hakkı da istemiyor.",
  "conn.guide.mount.win.mountCaption": "Sürücü olarak bağlayın",
  "conn.guide.mount.win.freeLetter": "BOŞ bir sürücü harfi seçin. Harf bağlama sırasında oluşturulur, var olan bir şeye eklenmez; kullanımdaki bir harfi verirseniz bunu söylemeyen bir hatayla başarısız olur.",
  "conn.guide.mount.win.stop": "O pencerede Ctrl-C ile durdurun. Sürücü kaybolur ve bu makinede hiçbir şey kalmaz.",
  "conn.guide.mount.mac.unsupported": "filex mount macOS'ta çalışmıyor. macFUSE gerekiyor; lisansı filex gibi bir programın onu sizin yerinize kurmasına izin vermiyor ve Go bağlaması filex'in bilinçli olarak kullanmadığı bir C derleyicisi istiyor. Komut burada çalışıyormuş gibi görünüp hiçbir şey yapmak yerine açıkça reddediyor.",
  "conn.guide.mount.mac.alternatives": "macOS'ta filex masaüstü uygulamasını klasör eşitlemesiyle kullanın (dosyalar diskte durur) ya da sürücü bağlayabilen bir istemciyle SFTP.",
  "conn.guide.mount.note.notASync": "Bu bir eşitleme değildir. Küçük bir okuma önbelleği dışında bu makineye hiçbir şey kopyalanmaz; yüz bin dosyanın içinden birini gerisini indirmeden açar. Dosyaları çevrimdışıyken istiyorsanız klasör eşitlemesini kullanın.",
  "conn.guide.mount.note.reachable": "Sunucuya, tarayıcının geçtiği hangi vekil ya da tünel varsa oradan ulaşır - çünkü altında aynı API vardır. İzinleriniz ve depolarınız da birlikte gelir.",
  "conn.guide.mount.note.wholeFileWrites": "Bağlantı üzerinden yazdığınız dosya, yazılırken değil, program onu kapattığında yüklenir. Çok büyük bir dosyayı yerinde düzenlemek burada yerel diskten yavaştır; içeri ve dışarı kopyalamak değildir.",
  "conn.guide.mount.note.trash": "Silme her yerdeki gibi filex çöp kutusuna gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.mount.note.revoke": "Bir bağlantıyı durdurmak için API anahtarını iptal edin. Bağlantı hâlâ takılı olsa bile yarım dakika içinde hizmet vermeyi bırakır.",
  "storages.driver.ftp": "FTP / FTPS",
  "storages.driver.local": "Yerel dosya sistemi",
  "storages.driver.s3": "S3 / Hetzner / MinIO",
  "storages.driver.sftp": "SFTP",
  "storages.driver.smb": "SMB / CIFS (NAS)",
  "storages.driver.webdav": "WebDAV",
  "storages.fieldHelp.smbShare": "Sunucu adı olmadan yalnızca paylaşım adı: `\\\\nas\\media` değil, `media`.",
  "storages.fieldHelp.smbDomain": "Yalnızca Windows etki alanı hesabı için. NAS kullanıyorsanız boş bırakın.",
  "storages.fieldHelp.smbRoot": "Paylaşımın içindeki alt klasör. Paylaşımın tamamı için boş bırakın.",
  "storages.fields.share": "Paylaşım",
  "storages.fields.domain": "Etki alanı / çalışma grubu",
  "storages.fieldHelp.disablePresign": "Varsayılan olarak açık: yüklemeler ve herkese açık paylaşım bağlantılarındaki indirmeler filex üzerinden akar; kova endpoint'inin tarayıcıdan erişilebilir olması gerekmez (yalnız yerel ağdaki MinIO doğrudan çalışır). Yalnızca endpoint kullanıcıların tarayıcısından erişilebiliyorsa (AWS, herkese açık MinIO) ve tarayıcının kovayla doğrudan konuşmasını istiyorsanız kapatın - çok büyük dosyalarda daha hızlıdır, ama depo SDK'nın imzaladığı URL'leri kabul etmelidir (Ceph RGW / bazı Hetzner kurulumları SignatureDoesNotMatch döner).",
  "storages.fieldHelp.endpoint": "AWS S3 için boş bırakın. S3 uyumlu diğer tüm depolar kendi endpoint'ini ister.",
  "storages.fieldHelp.hostKey": "authorized_keys / known_hosts satır biçiminde tek bir açık anahtar.",
  "storages.fieldHelp.insecureSkipHostKey": "Her sunucu anahtarını kabul eder. Yalnızca geçici sunucular için.",
  "storages.fieldHelp.keyPath": "Sunucudaki anahtar dosyasının yolu; depo başlarken okunur. PEM alanı boşken kullanılır.",
  "storages.fieldHelp.knownHosts": "Katı sunucu anahtarı denetimi için OpenSSH known_hosts yolu. Varsayılan, ~/.filex/known_hosts içinde ilk bağlantıda güven.",
  "storages.fieldHelp.passive": "Kapatmak aktif moda geçirir; bu, sunucunun bu makineye geri bağlanmasını gerektirir.",
  "storages.fieldHelp.path": "Sunucudaki dizin. Yoksa oluşturulur; filex asla / dizinini mount etmez.",
  "storages.fieldHelp.pathStyle": "AWS dışındaki tüm depolarda açık olmalı. Endpoint girildiyse ve bu alana hiç dokunulmadıysa kendiliğinden açılır.",
  "storages.fieldHelp.prefix": "Kova içindeki alt klasör. Zorunlu: filex kova kökünün sahipliğini asla almaz.",
  "storages.fieldHelp.region": 'Boş bırakılırsa "auto" kullanılır.',
  "storages.fieldHelp.root": "Arka uçtaki alt klasör. Zorunlu: filex hesabın kökünü asla mount etmez.",
  "storages.fieldHelp.sftpAuth": "Parola ya da özel anahtardan biri zorunludur.",
  "storages.fieldHelp.tls": "Düz FTP kimlik bilgilerini açık metin gönderir - sunucu destekliyorsa açın.",
  "storages.fields.accessKey": "Access key",
  "storages.fields.basePath": "Temel yol",
  "storages.fields.bucket": "Kova",
  "storages.fields.disablePresign": "Aktarımları filex üzerinden geçir",
  "storages.fields.endpoint": "Endpoint",
  "storages.fields.host": "Sunucu",
  "storages.fields.hostKey": "Sabitlenmiş sunucu anahtarı",
  "storages.fields.insecureSkipHostKey": "Sunucu anahtarı doğrulamasını atla (güvensiz)",
  "storages.fields.keyPath": "Özel anahtar dosyası",
  "storages.fields.knownHosts": "known_hosts dosyası",
  "storages.fields.name": "Görünen ad",
  "storages.fields.namePlaceholder": "Kişisel fotoğraflar",
  "storages.fields.passive": "Pasif mod (PASV)",
  "storages.fields.password": "Parola",
  "storages.fields.path": "Dizin yolu",
  "storages.fields.pathStyle": "Path-style URL kullan (Hetzner, MinIO)",
  "storages.fields.port": "Port",
  "storages.fields.prefix": "Önek (prefix)",
  "storages.fields.privateKey": "Özel anahtar (PEM)",
  "storages.fields.rbac": "Öğe bazlı erişim denetimi (RBAC)",
  "storages.fields.rbacHint": "Açıkken yönetici olmayanlar yalnızca kendilerine yetki verilen dosya ve klasörleri görür (Klasör erişimi sayfasında listelenir). Kapalıyken herkes depoyu rolüne göre açar.",
  "storages.fields.readOnly": "Salt okunur mount",
  "storages.fields.region": "Bölge",
  "storages.fields.root": "Temel yol",
  "storages.fields.secretKey": "Secret key",
  "storages.fields.tls": "FTPS (açık AUTH TLS)",
  "storages.fields.url": "Temel URL",
  "storages.fields.user": "Kullanıcı",
  "storages.fields.s3AttemptTimeout": "Deneme zaman aşımı (saniye)",
  "storages.fields.s3MaxAttempts": "İstek başına deneme sayısı",
  "storages.fields.s3TotalTimeout": "Vazgeçme süresi (saniye)",
  "storages.fieldHelp.s3AttemptTimeout": "Tek bir denemenin depodan bir yaşam belirtisi için bekleyebileceği süre: bağlanma, TLS el sıkışması, istek gönderildikten sonraki cevap ve cevabın her yeni parçası. İlerleyen bir aktarım, süresi ne olursa olsun hiçbir zaman kesilmez; deponun almayı bıraktığı bir yükleme 60 saniye sonra, bu değer daha uzunsa bu kadar sonra kesilir. Kopyalama ve yeniden adlandırma cevap için 10 dakikaya kadar bekler, çünkü depo bunları ancak kopya bittiğinde cevaplar.",
  "storages.fieldHelp.s3MaxAttempts": "Hata geçebilecek türdeyse bir isteğin toplamda kaç kez deneneceği: ağ hatası, zaman aşımı, 5xx cevabı, hız sınırlaması. 1 yeniden denemeyi kapatır. Bir ret (403, bulunmayan bir kova, çözümlenmeyen bir sunucu adı) hiçbir zaman yeniden denenmez.",
  "storages.fieldHelp.s3TotalTimeout": "İlk denemeden itibaren bu kadar saniye içinde bitemeyecek yeni bir deneme başlatılmaz; böylece çalışmayan bir depoya yükleme ya da listeleme, kesintiyi bu süre içinde bildirir. Sürmekte olan bir aktarım kesilmez. Zaman aşımına uğrayan bir istek ancak bu değer deneme zaman aşımının en az iki katıysa yeniden denenir.",
  "storages.fields.attemptTimeout": "Deneme zaman aşımı (saniye)",
  "storages.fields.maxAttempts": "İstek başına deneme sayısı",
  "storages.fields.totalTimeout": "Vazgeçme süresi (saniye)",
  "storages.fieldHelp.attemptTimeout": "Tek bir denemenin sunucudan bir yaşam belirtisi için bekleyebileceği süre: bağlanma, oturum açma, her isteğin cevabı ve bir aktarımın her yeni parçası. İlerleyen bir aktarım, süresi ne olursa olsun hiçbir zaman kesilmez; sunucunun almayı bıraktığı bir yükleme 60 saniye sonra, bu değer daha uzunsa bu kadar sonra kesilir.",
  "storages.fieldHelp.webdavAttemptTimeout": "Tek bir denemenin sunucudan bir yaşam belirtisi için bekleyebileceği süre: bağlanma, oturum açma, her isteğin cevabı ve bir aktarımın her yeni parçası. İlerleyen bir aktarım, süresi ne olursa olsun hiçbir zaman kesilmez; sunucunun almayı bıraktığı bir yükleme 60 saniye sonra, bu değer daha uzunsa bu kadar sonra kesilir. Kopyalama, taşıma ve silme cevap için 10 dakikaya kadar bekler, çünkü sunucu bunları ancak iş bittiğinde cevaplar.",
  "storages.fieldHelp.maxAttempts": "Hata geçebilecek türdeyse bir isteğin toplamda kaç kez deneneceği: bağlantı reddedilir ya da kopar, cevap zamanında gelmez, sunucu şu an hizmet veremediğini söyler (5xx). 1 yeniden denemeyi kapatır. Bir ret (yanlış parola, bulunmayan bir klasör, doğrulanamayan bir sertifika) hiçbir zaman yeniden denenmez; gönderilmeye başlamış bir yükleme de yeniden denenmez.",
  "storages.fieldHelp.totalTimeout": "İlk denemeden itibaren bu kadar saniye içinde bitemeyecek yeni bir deneme başlatılmaz; böylece çalışmayan bir sunucu bu süre içinde bildirilir. Sürmekte olan bir aktarım kesilmez. Zaman aşımına uğrayan bir istek ancak bu değer deneme zaman aşımının en az iki katıysa yeniden denenir.",
  /* === gezinti:g1 - gezinti paneli (SideNav) === */
  "sidenav.title": "Gezinti",
  "sidenav.views": "Görünümler",
  "sidenav.storages": "Depolar",
  "sidenav.home": "Ana sayfa",
  "sidenav.myfiles": "Dosyalarım",
  "sidenav.recent": "Son kullanılanlar",
  "sidenav.starred": "Yıldızlılar",
  "sidenav.shared": "Benimle paylaşılanlar",
  // Üstteki satırın aynası ve tam altında durur: gelen ile giden.
  "sidenav.myshares": "Paylaştıklarım",
  "sidenav.trash": "Çöp kutusu",
  "sidenav.collapse": "Gezintiyi daralt",
  "sidenav.expand": "Gezintiyi genişlet",
  "sidenav.close": "Gezintiyi kapat",
  // ⚠ aç/kapat çifti ÇEKMECENİN, daralt/genişlet çifti yerleşik PANELİN -
  // ikisi birbirinin yerine kullanılamaz; bkz. en.ts'teki not ve Toolbar.vue
  // içindeki `navToggleLabel`. 560px altında panel listenin üzerine gelen bir
  // çekmecedir: raya inmez, hiç ekranda değildir; "genişlet" olmayan bir
  // genişliği büyütmeyi vaat ederdi.
  "sidenav.open": "Gezintiyi aç",
  "sidenav.storage.shared": "Paylaşılan",
  "sidenav.storage.readOnly": "Salt okunur",
  // #57 - depo satırının sıralama menüsü (sağ tık, uzun basış, Shift+F10).
  // "Ada göre sırala" bir mod değildir; kişinin elle düzeltmeye devam
  // edebileceği bir sıra yazar. "Varsayılan sırayı kullan" kişinin kendi
  // sırasını bırakır: panel yöneticinin sırasına (yoksa sunucununkine) döner.
  "sidenav.storage.moveUp": "Yukarı taşı",
  "sidenav.storage.moveDown": "Aşağı taşı",
  "sidenav.storage.sortName": "Ada göre sırala",
  "sidenav.storage.sortName.done": "Zaten ada göre sıralı",
  "sidenav.storage.defaultOrder": "Varsayılan sırayı kullan",
  "sidenav.storage.defaultOrder.none": "Zaten varsayılan sırada",
  // ⚠ `toolbar.nav` KALDIRILDI, yerine bir şey konmadı - bkz. en.ts'teki not.
  // Paneli daraltan tek denetimin etiketiydi; önce "Gezinti" (panelin adı,
  // düğmenin ne yaptığını söylemiyor), sonra "Gezintiyi göster/gizle" (sabit
  // geçici çözüm). Gerçek düzeltme yukarıdaki dört `sidenav.*` fiili:
  // etiket `navOpen`'a bağlı, daraltacaksa "daralt", genişletecekse
  // "genişlet" yazıyor.
  "node.home": "Ana sayfa",
  "node.recent": "Son kullanılanlar",
  "node.starred": "Yıldızlılar",
  "node.shared": "Benimle paylaşılanlar",
  "empty.recent.title": "Henüz hiçbir şey açılmadı",
  "empty.recent.hint": "Açtığınız dosyalar burada görünür",
  "empty.starred.title": "Henüz yıldızlı dosya yok",
  "empty.starred.hint": "Bir dosyayı yıldızlayın; burada bulursunuz",
  "empty.shared.title": "Sizinle henüz bir şey paylaşılmadı",
  "empty.shared.hint": "Başkalarının paylaştığı klasör ve dosyalar burada görünür",
  /* etiket:t1 */
  "sidenav.tags": "Etiketler",
  "sidenav.tags.empty": "Henüz etiket yok - bir dosyaya sağ tıklayıp Etiketler’den ekleyebilirsiniz.",
  "sidenav.tags.more": "{count} tane daha göster",
  "sidenav.tags.less": "Daha az göster",
  "sidenav.tags.personal": "Kişisel",
  "sidenav.tags.team": "Ekip",
  "empty.tag.title": "“{tag}” etiketli hiçbir şey yok",
  "empty.tag.hint": "Bir dosyaya sağ tıklayıp Etiketler’i seçin; dosya burada görünür",
  "sidenav.connections": "Bağlantılar",
  "sidenav.apps": "Uygulamalar",
  // #162 - mağaza ekranı: yöneticinin açtığı mağazaların kataloğu.
  "sidenav.appstore": "Uygulama mağazası",
  "sidenav.connect": "Bağlantılar",
  "sidenav.apikeys": "API anahtarları",
  "overlay.close": "Kapat",
  "conn.tokens.scopes": "İzinler",
  "conn.tokens.root": "Tek bir klasörle sınırla (isteğe bağlı)",
  "conn.tokens.rootPlaceholder": "depo://klasör",
  "conn.tokens.expiry": "Geçerlilik (gün)",
  "conn.tokens.expiryNever": "süresiz",
  "conn.tokens.defaultName": "API anahtarı {date}",
  "conn.tokens.namePlaceholder": "Ad - ör. yedekleme betiği",
  "conn.tokens.capNote": "Tavan kendi erişiminizdir - sahip olmadığınız bir izin reddedilir, verilmez.",
  "conn.tokens.scopesRequired": "En az bir izin seçin - hiçbir izni olmayan bir API anahtarı verilmez.",
  "conn.tokens.comments": "Yorumlar",
  "conn.tokens.commentsRead": "Okuma",
  "conn.tokens.commentsRw": "Okuma ve yazma",
  "conn.tokens.commentsHint": "Yorum eklemek ve silmek ayrı bir izindir - “write” bunu kapsamaz. Her API anahtarı yorumları okur.",
  "conn.tokens.commentsToRw": "Yorumlar: yazmaya izin ver",
  "conn.tokens.commentsToRead": "Yorumlar: yalnız okuma",
  /* === /gezinti:g1 === */
  /* === surucu:d1 - kabuk (GitHub #14); artık `uiProfile: 'drive'` ile
     gelen bir seçenek değil, her profilde çizilir === */
  "drive.new": "Yeni",
  "drive.new.upload": "Dosya yükle",
  "drive.new.folder": "Yeni klasör",
  "drive.new.request": "Dosya iste",
  "drive.new.document": "Yeni belge",
  /* === belge:n1 - "Yeni belge": + Yeni altındaki seçici ==================
     Tür adları BURADA durmuyor. Her kutucuk sözcüklerini lib/fileIcons
     `typeLabelFor`den okur - listedeki Tür sütununun okuduğu tablonun
     aynısı - böylece ".docx" iki yerde de aynı adla anılır ve yeni bir tür
     için hiç dizge gerekmez. Aşağıda yalnız bu pencerenin kendi metni var. */
  "newdoc.title": "Yeni belge",
  "newdoc.type.label": "Belge türü",
  "newdoc.group.document": "Belgeler",
  "newdoc.group.text": "Metin ve kod",
  "newdoc.group.diagram": "Çizimler",
  "newdoc.group.app": "Uygulamalar",
  /* ⚠ Her servisin tek adı, kendi projesinin kullandığı ad: draw.io
     ("drawio" ya da "diagrams.net" değil) ve ONLYOFFICE. */
  "newdoc.empty.title": "Kullanılabilir belge türü yok",
  "newdoc.empty.body": "Bu sunucu, bu uygulamanın oluşturabileceği bir tür sunmadı.",
  "newdoc.empty.blocked": "Bu sunucunun oluşturabildiği her tür, burada tanımlı olmayan bir düzenleyici servisine bağlı.",
  "newdoc.name": "Ad",
  "newdoc.name.placeholder": "Dosya adı, ör. notlar.txt ya da LICENSE",
  "newdoc.untitled": "Adsız",
  "newdoc.err.slash": "Ad eğik çizgi içeremez.",
  "newdoc.err.exists": "{name} burada zaten var. Başka bir ad seçin.",
  "newdoc.err.bare_ext": "Dosyaya yalnız bir uzantı değil, bir ad verin.",
  "newdoc.err.ext_needs_type": ".{ext} dosyası kendi türüyle oluşturulmalı - boş bir dosya açılmaz. O türü ya da başka bir uzantıyı seçin.",
  "newdoc.hint.ext_added": "Bu tür uzantısını korur; dosya {name} adıyla oluşturulacak.",
  // Drafts (issue #71): a new document is a draft until its first save.
  "sidenav.drafts": "Taslaklar",
  "sidenav.drafts.count": "{n} taslak",
  "sidenav.drafts.count_one": "{n} taslak",
  "node.drafts": "Taslaklar",
  "empty.drafts.title": "Taslak yok",
  "empty.drafts.hint": "Yeni bir belge, ait olduğu yere kaydedilene kadar burada bekler.",
  "drafts.lead": "Henüz kaydedilmemiş yeni belgeler. Bunları yalnızca siz görebilirsiniz.",
  "drafts.count_of": "{n} / {limit} taslak",
  "drafts.col.target": "Kaydedileceği yer",
  "drafts.col.storage": "Depo",
  "drafts.action.save": "Diske kaydet",
  "drafts.open_hint": "{name} dosyasını aç",
  "drafts.no_match": "Filtreye uyan taslak yok.",
  "draft.badge": "Taslak",
  "draft.bar.target": "{folder} konumuna kaydedilecek",
  "draft.save": "Kaydet",
  "draft.saved_to": "{name}, {folder} konumuna kaydedildi.",
  "draft.discarded": "{name} çöp kutusuna taşındı.",
  "draft.kept": "Taslaklarda tutuluyor",
  "draft.editing": "Düzenleniyor…",
  "draft.close.title": "Bu taslak kapatılsın mı?",
  "draft.close.body": "{name}, {folder} için bir taslak ve henüz oraya kaydedilmedi.",
  "draft.close.hint": "Tutulan taslak Taslaklar’da bekler. Çöpe at, taslağı çöp kutusuna taşır.",
  "draft.close.save": "Diske kaydet",
  "draft.close.keep": "Taslaklarda tut",
  "draft.close.discard": "Çöpe at",
  "outside.title": "Bu dosya dışarıda değişti",
  "outside.body": "{name} burada açıkken başka bir yerde değiştirildi ve bu düzenleyicide de değişiklikler var. Hangi sürüm kalsın?",
  "outside.theirs": "Dışarıdakini koru",
  "outside.theirs_hint": "burada yapılan değişiklikler atılır, dışarıdaki sürüm yüklenir.",
  "outside.mine": "Benimkini yaz",
  "outside.mine_hint": "kaydedildiğinde sizin sürümünüz dışarıdakinin üstüne yazılır.",
  "outside.both": "İkisini de tut",
  "outside.both_hint": "dışarıdaki sürüm yerinde kalır, sizinki yanına ayrı bir kopya olarak kaydedilir (ad.filex-conflict-zaman).",
  "outside.hint": "Siz seçene kadar hiçbir sürümün üstüne yazılmaz.",
  "outside.pending": "Bu dosya dışarıda değişti. Hangi sürümün kalacağını seçene kadar hiçbir sürümün üstüne yazılmaz.",
  "outside.choose": "Seç…",
  "outside.note.reloaded": "Dosya dışarıda güncellendi, yeni sürüm yüklendi.",
  "outside.note.theirs": "Dışarıdaki sürüm yüklendi; burada yapılan değişiklikler atıldı.",
  "outside.note.mine": "Sizin sürümünüz kaydedildiğinde dışarıdakinin üstüne yazılacak.",
  "outside.note.both": "Dışarıdaki sürüm yerinde kalıyor; sizinki kaydedildiğinde yanına ayrı bir kopya olarak yazılacak.",
  "draft.taken.title": "Bu adda bir dosya zaten var",
  "draft.taken.body": "{folder} konumunda {name} adında bir dosya zaten var. Taslak {suggested} olarak kaydedilsin mi?",
  "draft.taken.confirm": "{name} olarak kaydet",
  "upload.taken.body": "{folder} konumunda {name} adında bir öğe zaten var ve kasa eski sürümleri saklamaz. {suggested} olarak yüklensin mi?",
  "upload.taken.confirm": "{name} olarak yükle",
  "newdoc.hint.draft": "Taslak olarak açılır: siz kaydedene kadar klasörde hiçbir şey oluşturulmaz.",
  "newdoc.err.draft_limit": "Bu sunucunun izin verdiği kadar taslağınız var ({limit}). Önce Taslaklar’da bazılarını kaydedin ya da silin.",
  "newdoc.err.draft_limit_any": "Bu sunucunun izin verdiği sayıda taslağınız var. Önce Taslaklar’da bazılarını kaydedin ya da silin.",
  "newdoc.open_drafts": "Taslakları aç",
  "newdoc.location": "Konum",
  "newdoc.location.none": "Bir klasör seçin",
  "newdoc.location.change": "Değiştir",
  "newdoc.location.noaccess": "Bu klasöre kaydedemezsiniz.",
  "newdoc.create": "Oluştur",
  "newdoc.creating": "Oluşturuluyor…",
  "newdoc.cancel": "Vazgeç",
  "drive.search.placeholder": "{scope} deposunda ara",
  "drive.search.placeholder_all": "Tüm depolarda ara",
  "drive.search.hint_title": "Her yerde ara ve komut çalıştır ({combo})",
  "drive.storage.used": "{total} alanın {used} kadarı dolu",
  "drive.storage.used_unlimited": "{used} kullanılıyor",
  "drive.storage.used_partial": "en az {used} kullanılıyor",
  "drive.storage.label": "Depolama",
  /* === gorunum:v3-shell - Ana sayfa görünümü (kabuğun içindeki genel bakış)
   * Bölüm başlıkları `sidenav.storages` / `sidenav.recent` / `sidenav.starred`,
   * boş durumlar da `empty.recent.*` / `empty.starred.*` - bilerek: Ana
   * sayfadaki "Son kullanılanlar" başlığı ile yanındaki panel satırı aynı
   * şeydir, ikisine ayrı metin yazmak onları çeviri çeviri birbirinden
   * ayırmanın yoludur. Aşağıda yalnızca başka hiçbir yerde olmayanlar var. */
  "home.title": "Ana sayfa",
  "home.storages.empty": "Henüz depo yok",
  "home.storages.hint": "Depo, filex’in okuyup yazdığı yerdir - depoları yönetici ekler.",
  "drive.section.folders": "Klasörler",
  "drive.section.files": "Dosyalar",
  "filter.aria": "Filtreler",
  "filter.type": "Tür",
  "filter.type.any": "Her tür",
  "filter.type.folder": "Klasörler",
  "filter.type.document": "Belgeler",
  "filter.type.spreadsheet": "Hesap tabloları",
  "filter.type.presentation": "Sunumlar",
  "filter.type.pdf": "PDF’ler",
  "filter.type.image": "Görseller",
  "filter.type.video": "Videolar",
  "filter.type.audio": "Ses dosyaları",
  "filter.type.archive": "Arşivler",
  "filter.type.code": "Kod",
  "filter.modified": "Değiştirilme",
  "filter.modified.any": "Her zaman",
  "filter.modified.today": "Bugün",
  "filter.modified.7d": "Son 7 gün",
  "filter.modified.30d": "Son 30 gün",
  "filter.modified.year": "Bu yıl",
  "filter.size": "Boyut",
  "filter.size.any": "Her boyut",
  "filter.size.lt1": "1 MB altı",
  "filter.size.1to10": "1 - 10 MB",
  "filter.size.10to100": "10 - 100 MB",
  "filter.size.gt100": "100 MB üstü",
  /* surucu:d1-actions - filtre satırının sonundaki ⋮ menüsü. Yalnızca menünün
     KENDİ adı yeni: içindeki her satır o eylemin zaten sahip olduğu metni
     kullanır (`toolbar.new_folder`, `toolbar.upload`, `ctx.paste`,
     `shortcuts.select_all`, `selection.clear`) - bir komutu yeniden adlandıran
     menü, okuyucuya aynı şeyi iki kez öğretir. */
  "filter.actions": "Liste işlemleri",
  "filter.clear": "Filtreleri temizle",
  "filter.empty.title": "Bu filtrelere uyan bir şey yok",
  "filter.empty.hint": "Bir filtreyi kaldırın ya da yukarıdaki alandan her yerde arayın.",
  "filter.count": "{total} öğeden {shown} tanesi",
  "inspector.tab.details": "Ayrıntılar",
  "inspector.tab.activity": "Etkinlik",
  "inspector.people": "Erişimi olan kişiler",
  "inspector.people.you": "Siz",
  "inspector.people.inherited": "üst klasörden",
  "inspector.people.empty": "Yalnızca siz ve aşağıdaki bağlantıya sahip olanlar.",
  "inspector.people.manage": "Erişimi yönet",
  "inspector.link": "Paylaşım bağlantısı",
  "inspector.link.none": "Paylaşılmadı",
  "inspector.link.create": "Bağlantı oluştur",
  "inspector.link.copy": "Bağlantıyı kopyala",
  "inspector.activity.empty": "Bu öğe için henüz etkinlik kaydı yok.",
  "inspector.activity.hint": "Sürümler dosya değiştikçe, yorumlar ise insanlar yazdıkça birikir.",
  "inspector.activity.version": "{n}. sürüm kaydedildi",
  "inspector.activity.comment": "{who} yorum yaptı",
  "inspector.activity.select": "Etkinliğini görmek için bir dosya ya da klasör seçin.",
  /* === /surucu:d1 === */
  /* === gorunum:v1-chrome - filtre satırındaki ad kutusu === */
  "filter.find": "Bu klasörde filtrele…",
  /* surucu:d1-scope - satırların bir klasörün içeriği olmadığı yerlerde aynı
     kutu. Neyi daralttığını söylemek zorunda: depo listesinde "bu klasör" hiçbir
     şeyi adlandırmaz, Ana sayfada ise üç bloğu birden adlandırırdı. */
  "filter.find.storages": "Depolarda filtrele…",
  "filter.find.home": "Ana sayfada filtrele…",
  /* === gorunum:v1-viewer - tam ekran görüntüleyicinin kendi çerçevesi === */
  "viewer.share": "Paylaş",
  "viewer.nav_prev": "Önceki dosya",
  "viewer.nav_next": "Sonraki dosya",
  /* Üst çubuğun künye satırındaki sayaç: "246,3 KB • 9 Eyl 2026 • 1 / 9". */
  "viewer.counter": "{i} / {n}",
  "viewer.zoom_reset": "Yakınlaştırmayı sıfırla",
  "viewer.fullscreen": "Tam ekran",
  "viewer.exit_fullscreen": "Tam ekrandan çık",
  "viewer.md_placeholder": "# Markdown buraya…",
  /* === gorunum:v1-selbar - filtre satırının yerini alan seçim çubuğu === */
  "selection.count": "{n} seçildi",
  "selection.clear": "Seçimi temizle",
  /* === gorunum:v1-preview - türün adı, kelimeyle =======================
     Tür sütunu eskiden uzantıyı büyük harfle yazıyordu; artık bunları
     yazıyor. Hangisinin seçileceğine `lib/fileIcons.ts` karar verir
     (`typeLabelKey`) - bir türü adlandıran yalnız iki yer var: o tablo ve bu
     liste. Eşleşmeyen her şey yine büyük harfli uzantıya düşer. `Klasör`
     burada DEĞİL: o `node.folder`, grid kartının alt yazısı zaten onu basar. */
  "ftype.typescript": "TypeScript",
  "ftype.javascript": "JavaScript",
  "ftype.vue": "Vue bileşeni",
  "ftype.python": "Python",
  "ftype.go": "Go",
  "ftype.rust": "Rust",
  "ftype.php": "PHP",
  "ftype.ruby": "Ruby",
  "ftype.java": "Java",
  "ftype.kotlin": "Kotlin",
  "ftype.swift": "Swift",
  "ftype.c": "C kaynağı",
  "ftype.cpp": "C++ kaynağı",
  "ftype.csharp": "C# kaynağı",
  "ftype.stylesheet": "Stil dosyası",
  "ftype.html": "HTML belgesi",
  "ftype.json": "JSON verisi",
  "ftype.yaml": "YAML",
  "ftype.xml": "XML",
  "ftype.toml": "TOML",
  "ftype.sql": "SQL",
  "ftype.shell": "Kabuk betiği",
  "ftype.powershell": "PowerShell betiği",
  "ftype.markdown": "Markdown",
  "ftype.plaintext": "Düz metin",
  "ftype.log": "Günlük dosyası",
  "ftype.config": "Ayar dosyası",
  "ftype.sheet": "Hesap tablosu",
  "ftype.drawio": "draw.io diyagramı",
  "ftype.figma": "Figma tasarımı",
  "ftype.design": "Tasarım dosyası",
  "ftype.image": "Görsel",
  "ftype.video": "Video",
  "ftype.audio": "Ses",
  "ftype.pdf": "PDF belgesi",
  "ftype.document": "Belge",
  "ftype.slides": "Sunum",
  "ftype.archive": "Arşiv",
  "ftype.code": "Kod",
  /* === gorunum:v1-advsearch - Gelişmiş arama penceresi ===================
   * İki `filter.*` anahtarı kardeşlerinin yanında değil burada: paylaşılan
   * birleşimlere pencerenin eklediği yeni üyeler (`modified: 'around'`,
   * `size: 'range'`). Filtre satırı bunları hiç seçmez ama biri oraya
   * ulaşırsa `chipLabel` ham anahtarı yazardı. */
  "filter.modified.around": "Bir tarihin çevresinde",
  "filter.size.range": "Özel aralık",
  "advsearch.open": "Gelişmiş arama",
  "advsearch.title": "Gelişmiş arama",
  "advsearch.subtitle": "Dosyaları ada, içeriğe, yola ya da etikete göre bulun.",
  "advsearch.close": "Kapat",
  "advsearch.content.heading": "İçerik araması",
  "advsearch.viewall": "Tüm sonuçları gör",
  "advsearch.where.any_short": "Her yerde",
  "advsearch.where.here_short": "Yalnız burada",
  "advsearch.where.skip_short": "Burayı atla",
  "advsearch.server.legend": "Sunucunun aradığı",
  "advsearch.client.legend": "Gelen sonuçları daralt",
  "advsearch.query.label": "Kelimeler",
  "advsearch.query.placeholder": "Adın bir parçası ya da dosyanın içindeki kelimeler",
  "advsearch.scope.label": "Nerede arasın",
  "advsearch.scope.name": "Ad ve yol",
  "advsearch.scope.content": "Dosya içeriği",
  "advsearch.scope.all": "İkisi de",
  "advsearch.scope.hint": "İçerik, dizinden aranır; dizin metin türü dosyaların ilk 200 KB’ını kapsar.",
  "advsearch.people.name_only": "Sahip, gelen satırlardan okunur; sahip bilgisi taşıyan satırları da yalnız ad araması döndürür.",
  "advsearch.scope.name_only": "Burada yalnız ad ve yol: içerik sonucu gezgine hangi depodan geldiği bilgisi olmadan ulaşır, bu yüzden içerik araması yalnız tek depolu kurulumlarda sunulur.",
  "advsearch.tags.label": "Etiketler",
  "advsearch.tags.placeholder": "fatura, üç aylık rapor",
  "advsearch.tags.exclude": "Şu etiketler hariç",
  "advsearch.tags.exclude_placeholder": "arşiv",
  "advsearch.tags.hint": "Virgülle ayırın. Etiket daraltır: birden çok etiket hepsini birden taşıyan dosyalar demektir, hiç kullanılmamış bir etiket ise hiçbir şey döndürmez. Bir ad, o adı taşıyan kişisel etiketinizi de ekibinizin etiketini de bulur.",
  "advsearch.where.label": "Klasör",
  "advsearch.where.any": "Bu deponun her yerinde",
  "advsearch.where.here": "Yalnız {folder} içinde",
  "advsearch.where.skip": "{folder} dışındaki her yerde",
  "advsearch.around.label": "Şu kadar içinde",
  "advsearch.around.date": "Tarih ve saat",
  "advsearch.around.h1": "1 saat",
  "advsearch.around.d1": "1 gün",
  "advsearch.around.w1": "1 hafta",
  "advsearch.size.range_label": "Şunun arasında",
  "advsearch.size.from": "En az",
  "advsearch.size.to": "En çok",
  "advsearch.count.idle": "Bir şeyler yazın ya da etiket seçin.",
  "advsearch.count.counting": "Sayılıyor…",
  "advsearch.count.result": "{n} eşleşen öğe",
  "advsearch.count.capped": "Sonuçların ilk sayfasında {n} eşleşen öğe",
  "advsearch.count.result_one": "{n} eşleşen öğe",
  "advsearch.count.capped_one": "Sonuçların ilk sayfasında {n} eşleşen öğe",
  "advsearch.count.error": "Sayım çalıştırılamadı.",
  "advsearch.count.cost": "Sayım bu aramayı çalıştırır. Tür, sahip, tarih, boyut ve klasör bulduğu sonuçları daraltır.",
  "advsearch.wire": "Bir dahaki sefere arama kutusuna şunu yazabilirsiniz:",
  "advsearch.reset": "Sıfırla",
  "advsearch.cancel": "Vazgeç",
  "advsearch.submit": "Ara",
  /* === gorunum:v2-topbar - sayfanın üst barı kalktı; onun taşıdıklarını
     artık gezginin kendi başlığı ve kırıntı satırı taşıyor. === */
  "breadcrumb.subfolders": "Alt klasörler",
  "breadcrumb.subfolders.empty": "Burada alt klasör yok",
  "header.admin": "Yönetim paneli",
  "header.settings": "Ayarlar",
  "header.signout": "Oturumu kapat",
  "ai.assistant": "AI asistanı",
  "assistant.new": "Yeni konuşma",
  "assistant.history": "Konuşmalar",
  "assistant.history_empty": "Henüz konuşma yok.",
  "assistant.close": "Asistanı kapat",
  "assistant.delete": "Bu konuşmayı sil",
  "assistant.intro": "Asistandan dosyalarınızı bulmasını, okumasını, özetlemesini, düzenlemesini ya da taşımasını isteyin. Yalnız sizin izinlerinizle çalışır. Geri alınabilen değişiklikler hemen yapılır ve Geri al bağlantısı bırakır; geri alınamayan her şey onayınızı bekler. Şifreli klasörler ve kasa ona hiçbir zaman gönderilmez.",
  "assistant.placeholder": "Dosyalarınız hakkında sorun...",
  "assistant.send": "Gönder",
  "assistant.stop": "Durdur",
  "assistant.working": "Çalışıyor...",
  "assistant.with_selection": "Seçili {count} öğeyle birlikte",
  "assistant.with_selection_one": "Seçili {count} öğeyle birlikte",
  "assistant.approve": "Onayla",
  "assistant.decline": "Reddet",
  "assistant.undo": "Geri al",
  /* gorunum:v2-share - Paylaş / İzinler penceresinin kendi çerçevesi. İçindeki
     denetimler eski metinlerini koruyor; buradakiler yeni kabuk: başlık, tek
     anahtar, "şu anda kim açabilir" cümlesi ve her şeyin katlandığı üç adlı
     bölüm. */
  "access.title": '"{name}" paylaşımı',
  "access.title_storage": '"{name}" erişimi',
  "access.close": "Kapat",
  "access.done": "Bitti",
  "access.copy": "Kopyala",
  "access.copied": "Kopyalandı",
  "access.link.switch": "Bağlantı paylaşımı",
  "access.who.private": "Yalnızca erişimi olan kişiler açabilir.",
  "access.who.link": "Bağlantıyı bilen herkes açabilir.",
  "access.who.pin": "Bağlantıyı ve PIN'i bilen herkes açabilir.",
  "access.who.existing": "Bağlantı paylaşımı açık - {n} bağlantı var.",
  "access.who.existing_one": "Bağlantı paylaşımı açık - {n} bağlantı var.",
  "access.section.link": "Bağlantı seçenekleri",
  "access.section.people": "Erişimi olanlar",
  "access.section.drop": "Dosya iste",
  "access.sum.pin_on": "PIN var",
  "access.sum.pin_off": "PIN yok",
  "access.sum.people": "{n} kişi",
  "access.sum.people_one": "{n} kişi",
  "access.sum.people_none": "Henüz kimse yok",
  "access.sum.groups": "{n} grup",
  "access.sum.groups_one": "{n} grup",
  "access.sum.drop": "{n} yükleme bağlantısı",
  "access.sum.drop_one": "{n} yükleme bağlantısı",
  "access.sum.drop_none": "Yükleme bağlantısı yok",
  /* Sahiplik - Sahibi sütunu ve Kişiler çipi. "Sistem", filex üzerinden kimsenin
     koymadığı satırın dürüst karşılığıdır (tarayıcı buldu ya da doğrudan kovaya
     yazıldı); boşluk değil, gerçek bir cevaptır. */
  "col.owner": "Sahibi",
  "owner.you": "Siz",
  "owner.system": "Sistem",
  "owner.unknown": "Bilinmiyor",
  "owner.external": "Yükleme bağlantısıyla geldi",
  "owner.last_actor": "Son değiştiren: {who}",
  "filter.people": "Sahibi",
  "filter.people.any": "Herkes",
  "filter.people.me": "Siz",
  "filter.people.system": "Sistem",
  "filter.people.someone": "Başka biri",
  /* surucu:d1-sort - filtre satırının sağ ucundaki sıralama denetimi. Dört
     ölçütün adı `col.*`: menü, liste görünümünün sütun başlıklarındaki
     sözcüklerin aynısını sunar - tek bir sıralamayı süren iki denetim onu
     farklı adlarla anamaz. */
  "sort.by": "Sıralama ölçütü",
  "sort.asc": "Artan",
  "sort.desc": "Azalan",
  /* Bir ARAMA SONUCUNUN sırası. Beşinci bir sıralama ölçütü değildir -
     ekrandaki satırları sunucu sıraladığında denetim, ölçüt adı yerine bunu
     yazar; böylece yapmadığı bir sıralamayı üstlenmez. `_why` denetimin neden
     kapalı olduğudur: bakımcı, denetimin sessizce işlevsizleşmesini değil
     nedeninin yazılmasını istedi. */
  "sort.relevance": "Alaka",
  "sort.relevance_why": "Arama sonuçları eşleşme yakınlığına göre listelenir. Seçtiğiniz sıralama, aramadan çıkınca geri gelir.",
  /* === tablo:t1 - tablonun kendi yapılandırması ==========================
     v0.43'ten beri bir klasörün görünüşüne dair her şey - görünüm, sıralama VE
     sütunlar - değiştirildiği klasöre aittir; kimsenin değiştirmediği klasör
     kişinin varsayılanıyla (ayarlarından), o yoksa kurulumunkiyle açılır.
     `folder_hint` bu kuralı tek cümlede, tam da ona şaşıracak kişinin
     okuyabileceği yerde söyler. */
  "col.location": "Konum",
  "col.deleted": "Silinme",
  "col.deleted_from": "Silindiği yer",
  "col.deleted_by": "Silen",
  "col.remaining": "Kalan süre",
  "cols.menu": "Sütun seçenekleri",
  "cols.title": "Sütunlar",
  "cols.resize": "{col} sütununu yeniden boyutlandır",
  "cols.sort_by": "{col} sütununa göre sırala",
  "cols.move_left": "{col} sütununu sola taşı",
  "cols.move_right": "{col} sütununu sağa taşı",
  "cols.reset": "Sütunları sıfırla",
  "cols.folder_title": "Klasör görünümü",
  "cols.folder_hint": "Burada yaptığınız değişiklik bu klasörde kalır. Hiç değiştirmediğiniz klasörler varsayılan görünümünüzle açılır (Ayarlar → Varsayılan klasör görünümü).",
  "cols.forget_folder": "Bu klasörün görünümünü unut",
  "cols.apply_all": "Bunu tüm klasörler için varsayılanım yap ({count} klasör hatırlanıyor)",
  /* === tablo:t3 - TEK TABLO (components/DataTable.vue) ====================
     Üründeki her tablo bunları konuşur; Türkçe bir sayfada sütun menüsü ya da
     sayfalayıcı İngilizce kalmasın. */
  "table.empty": "Henüz burada bir şey yok",
  "table.prev": "Önceki sayfa",
  "table.next": "Sonraki sayfa",
  "table.sort_paged": "Bu liste sayfalara bölünmüş. Sıralama yalnızca ekrandaki sayfayı yeniden dizerdi, bu yüzden burada kapalı - listeyi arama ya da filtrelerle daraltın.",
  /* === tablo:t1 - çöp kutusu bilgi şeridi ================================
     ⚠ `retention` yalnızca kurulum bize sayıyı SÖYLEDİĞİNDE kullanılır
     (GET /api/admin/protection). Diğer her durumda `retention_unknown` aynı
     şeyi, doğrulayamadığımız bir süreyi taahhüt etmeden söyler: yanlış saklama
     süresi yazan bir şerit, hiç şerit olmamasından kötüdür - insanlar ona
     bakıp karar verir. */
  "trash.retention": "Çöp kutusundaki öğeler {days} gün sonra kalıcı olarak silinir.",
  "trash.retention_one": "Çöp kutusundaki öğeler {days} gün sonra kalıcı olarak silinir.",
  "trash.retention_unknown": "Çöp kutusundaki öğeler, yöneticinizin belirlediği saklama süresi dolunca kalıcı olarak silinir.",
  "trash.empty_action": "Çöp kutusunu boşalt",
  "trash.empty_confirm_title": "Çöp kutusu boşaltılsın mı?",
  "trash.empty_counting": "Çöp kutusundakiler sayılıyor…",
  "trash.show_more": "Daha fazla göster",
  "trash.shown_of": "{total} öğenin {shown} tanesi gösteriliyor",
  "trash.days_remaining": "{n} gün",
  "trash.days_remaining_one": "{n} gün",
  "trash.days_remaining_due": "Silinmek üzere",
  "trash.deleted_by_nobody": "Kayıt yok: virüs taraması karantinaya almış ya da filex bunu tutmaya başlamadan önce silinmiş",
  "empty.trash.hint": "Sildiğiniz dosyalar önce buraya düşer, böylece geri alabilirsiniz.",
  /* tasi:m1 - hedef klasör seçici (modals/DestinationPickerModal.vue) ve
     üzerine kurulan iki seçim eylemi. */
  "destpicker.title.move": "Şuraya taşı",
  "destpicker.title.copy": "Şuraya kopyala",
  "destpicker.title.choose": "Klasör seç",
  "destpicker.confirm.move": "Buraya taşı",
  "destpicker.confirm.copy": "Buraya kopyala",
  "destpicker.confirm.choose": "Bu klasörü seç",
  "destpicker.title.choose_file": "Dosya seç",
  "destpicker.confirm.choose_file": "Bu dosyayı seç",
  "destpicker.title.save": "Şuraya kaydet",
  "destpicker.confirm.save": "Buraya kaydet",
  "destpicker.pick_a_file": "Listeden bir dosya seçin.",
  "destpicker.empty_files": "Bu klasör boş",
  "destpicker.cancel": "Vazgeç",
  "destpicker.up": "Bir üst klasör",
  "destpicker.crumbs": "Konum",
  "destpicker.drives": "Depolar",
  "destpicker.loading": "Yükleniyor…",
  "destpicker.empty": "Burada alt klasör yok",
  "destpicker.unreadable": "Bu klasör açılamıyor.",
  "destpicker.readonly": "Salt okunur",
  "destpicker.readonly_here": "Bu klasöre yazamazsınız.",
  "destpicker.pick_a_drive": "Bir klasör seçmek için önce bir depo açın.",
  "destpicker.target": "Hedef: {name}",
  "destpicker.tag.blocked": "Uygun değil",
  "destpicker.blocked.self": "Bir klasör kendi içine taşınamaz.",
  "destpicker.blocked.descendant": "Bir klasör kendi alt klasörlerinden birine taşınamaz.",
  "destpicker.tag.vault": "Kasa",
  "destpicker.blocked.vault_in": "Buradan kasaya bir şey konmaz: kasanın içinden yükleyin.",
  "destpicker.blocked.vault_out": "Kasadakiler yalnız o kasanın içinde taşınır. Dışarı almak için indirin.",
  "ctx.move_to": "Şuraya taşı…",
  "ctx.copy_to": "Şuraya kopyala…",
  "ctx.access.one_only": "Paylaşım aynı anda tek öğe için çalışır.",
  "ctx.storage_access": "Erişim…",
  "toast.archive.preparing": "Arşiv hazırlanıyor…",
  "toast.archive.started": "{name} indiriliyor ({count} dosya)",
  "toast.archive.started_one": "{name} indiriliyor ({count} dosya)",
  "toast.archive.empty": "İndirilecek bir şey yok - seçimde okunabilir dosya bulunmuyor.",
  "toast.moved_to": "{name} klasörüne taşıma kuyruğa alındı",
  "toast.copied_to": "{name} klasörüne kopyalama kuyruğa alındı",
  "toast.already_there": "Seçilen öğeler zaten {name} içinde - hiçbir şey gönderilmedi",
  /* ── dil:paket - bkz. en.ts */
  "ctx.tags_menu": "Etiketler…",
  "toast.node_id_copied": "Node id {id} kopyalandı",
  "toast.read_only_here": "Burada yazma yetkiniz yok",
  "recents.title": "Son açılanlar",
  "recents.refresh": "Yenile",
  "recents.empty": "Henüz bir şey yok.",
  "recents.loading": "Yükleniyor…",
  "recents.close": "Kapat",
  "tags.title": "Etiketler",
  "tags.close": "Kapat",
  "share.ttl.never": "Bu bağlantının süresi yoktur.",
  "share.ttl.until": "Bu bağlantı {when} tarihine kadar geçerli.",
  "share.ttl.ceiling": "Bağlantılar en fazla {days} gün geçerli olabilir (sunucu ayarı).",
  "share.ttl.ceiling_one": "Bağlantılar en fazla {days} gün geçerli olabilir (sunucu ayarı).",
  /* ── dil:paket - paylaşım / erişim penceresi (bkz. en.ts) */
  "access.ui.level_viewer": "Görüntüleyen",
  "access.ui.level_viewer_desc": "görüntüle + indir",
  "access.ui.level_editor": "Düzenleyen",
  "access.ui.level_editor_desc": "oku + yaz + sil",
  "access.ui.level_owner": "Sahip",
  "access.ui.level_owner_desc": "düzenle + izin yönet",
  "access.ui.never": "Süresiz",
  "access.ui.days": "{days} gün",
  "access.ui.days_one": "{days} gün",
  "access.ui.unlimited": "Sınırsız",
  "access.ui.downloads": "{count} indirme",
  "access.ui.downloads_one": "{count} indirme",
  "access.ui.inherited_from": "Üst klasörden gelir",
  "access.ui.whole_storage": "Tüm depo",
  "access.ui.storage_root_hint": "Buraya eklenen herkes bu depodaki her dosya ve klasöre erişir: web arayüzünde, masaüstü uygulamasında ve her protokolde. İçindeki klasör yetkileri olduğu gibi kalır; ikisi birden geçerliyse yüksek olan sayılır.",
  "access.ui.access_granted": "Yetki verildi.",
  "access.ui.enter_a_valid_email": "Geçerli bir e-posta girin.",
  "access.ui.recipient_lang": "Alıcının dili",
  "access.ui.recipient_lang_server": "Sunucunun dili",
  "access.ui.user_created_invite_emailed": "Kullanıcı açıldı, davet e-postası gönderildi.",
  "access.ui.user_created_share_the_temp_password": "Kullanıcı açıldı. Geçici parolayı iletin.",
  "access.ui.server_limit_applied": "(sunucu sınırı uygulandı)",
  "access.ui.protect_with_a_pin": "PIN ile koru",
  "access.ui.expiry": "Süre",
  "access.ui.download_limit": "İndirme limiti",
  "access.ui.create_link": "Bağlantı oluştur",
  "access.ui.replace_link": "Bağlantıyı bu ayarlarla yenile",
  "access.ui.replace_link_hint": "Adres değişir: şu anki bağlantı çalışmayı bırakır.",
  "access.ui.create_then_send": "Bir bağlantı oluşturun, ardından {email} adresine gönderin.",
  "access.ui.command_line": "Komut satırı",
  "access.ui.share": "Paylaş",
  "access.ui.existing_links": "Mevcut bağlantılar",
  "access.ui.rbac_off_here": "Bu depoda öğe bazlı erişim denetimi kapalı - herkes depoyu rolüne göre açar, burada eklenen kişiler bir şey değiştirmez. Yönetim panelinde Depolar altından (bu depo → Öğe bazlı erişim denetimi) açın.",
  "access.ui.other_links": "Diğer bağlantılar",
  "access.ui.revoke": "İptal",
  "access.ui.loading": "Yükleniyor…",
  "access.ui.name_or_email": "Ad ya da e-posta",
  "access.ui.add": "Ekle",
  "access.ui.no_account_for_this_email_what_next": "Bu e-postada hesap yok. Ne yapmak istersiniz?",
  "access.ui.user": "Kullanıcı",
  "access.ui.viewer": "Görüntüleyen",
  "access.ui.create_user_grant": "Kullanıcı oluştur + yetki ver",
  "access.ui.just_send_a_share_link": "Yalnızca paylaşım bağlantısı gönder →",
  "access.ui.temp_password": "Geçici parola:",
  "access.ui.people_with_access": "Erişimi olanlar",
  "access.ui.group": "Grup",
  "access.ui.group_title": "“{name}” grubu - içindeki herkes",
  "access.ui.group_owner_confirm": "Sahip düzeyi, “{name}” grubundaki herkesin buraya kimin erişebileceğini yönetmesine izin verir - başka kişi ve gruplarla paylaşmak dâhil. Gruba Sahip verilsin mi?",
  "access.ui.group_owner_give": "Sahip yap",
  "access.ui.not_shared_with_anyone_yet": "Henüz kimseyle paylaşılmadı.",
  "access.ui.remove": "Kaldır",
  "access.ui.a_public_link_that_lets_anyone_upload_fi": "Bu klasöre herkesin dosya YÜKLEYEBİLECEĞİ herkese açık bir bağlantı. Yükleyenler klasördeki mevcut dosyaları göremez.",
  "access.ui.hide_upload_limits": "Yükleme sınırlarını gizle",
  "access.ui.upload_limits": "Yükleme sınırları",
  "access.ui.max_files": "En fazla dosya",
  "access.ui.mb_file": "Dosya başı MB",
  "access.ui.allowed_types": "İzinli türler",
  "access.ui.all_e_g_pdf_jpg": "hepsi (örn. pdf, jpg)",
  "access.ui.ask_uploader_name": "Yükleyenin adını sor",
  "access.ui.emails_comma_separated": "e-posta(lar) - virgülle ayırın",
  "access.ui.send": "Gönder",
  "access.ui.mail_not_set_up": "E-posta kurulu değil - yönetim panelinde Ayarlar altından (E-posta / SMTP) kurun.",
  /* ── wiring:e2 fxe - tek şifreli dosyalar (.fxe), akışlı indirmeler ── */
  "e2e.fxe.type": "Şifreli dosya",
  "e2e.fxe.ctx_encrypt": "E2EE ile şifrele…",
  "e2e.fxe.ctx_download_raw": "Şifreli dosyayı indir",
  "e2e.fxe.ctx_password": "Parolayı değiştir…",
  "e2e.fxe.ctx_remove": "Şifrelemeyi kaldır…",
  "e2e.fxe.encrypt_title": "Bu dosyayı şifrele",
  "e2e.fxe.encrypt_lead": "“{name}” bu tarayıcıda, kendine ait bir parolayla şifrelenir. Sunucu yalnızca şifreli veriyi saklar. Dosyayı parola ya da kurtarma anahtarı açar - burada ya da çevrimdışı olarak filex decrypt ile.",
  "e2e.fxe.pw_label": "Dosya parolası",
  "e2e.fxe.hide_label": "Dosya adını da gizle",
  "e2e.fxe.hide_on_hint": "“{stored}” olarak saklanır: sunucu ne adı ne de türü görür. Gerçek ad dosyanın içinde mühürlüdür; dosyayı burada açınca görünür.",
  "e2e.fxe.hide_off_hint": "“{stored}” olarak saklanır: ad sunucu tarafından okunabilir kalır, içerik kalmaz.",
  "e2e.fxe.seen_title": "Sunucunun zaten gördükleri",
  "e2e.fxe.seen_lead": "Bu dosya şimdiye kadar şifresiz saklandı ve şifrelemek bunu geri almaz:",
  "e2e.fxe.seen_trash": "Asıl dosya çöp kutusuna gider ve çöp kutusunun saklama süresi dolana ya da bir yönetici boşaltana kadar orada kalır. Kalıcı olarak kendiniz silemezsiniz.",
  "e2e.fxe.seen_versions": "Önceki sürümleri sürüm geçmişinde kalır; onları yalnızca bir yönetici silebilir.",
  "e2e.fxe.seen_thumb": "Ondan üretilmiş bir küçük resim, asıl dosya kalıcı olarak silinene kadar sunucuda kalır. Arama dizinindeki kaydı, dosya çöp kutusuna gidince kaldırılır.",
  "e2e.fxe.seen_backups": "Bundan önce alınmış yedekler, kopyalar ve indirmeler onu hâlâ içerir.",
  "e2e.fxe.warn_body": "Bu dosya yalnızca bu parolayla ya da şifrelemeden sonra bir kez gösterilen kurtarma anahtarıyla açılır. filex ikisini de saklamaz. İkisini de kaybederseniz içerik kalıcı olarak kaybolur.",
  "e2e.fxe.escrow_body": "Bu kurulumda anahtar emaneti açık: işletmecisi, bu dosyayı parolanız olmadan açan bir anahtara sahip.",
  "e2e.fxe.encrypt_submit": "Şifrele",
  "e2e.fxe.encrypt_busy": "Şifreleniyor ve yükleniyor… %{percent}",
  "e2e.fxe.size_unknown": "Bu dosyanın boyutu henüz bilinmiyor. Klasörü yenileyip tekrar deneyin.",
  "e2e.fxe.bad_name": "Bu ad şifreli bir dosyanın içine mühürlenemez (255 baytı aşıyor ya da eğik çizgi veya denetim karakteri içeriyor). Önce dosyayı yeniden adlandırın.",
  "e2e.fxe.name_too_long": "Ad, sonuna “.fxe” eklenemeyecek kadar uzun. “Dosya adını da gizle” kutusunu işaretleyin ya da önce dosyayı yeniden adlandırın.",
  "e2e.fxe.encrypted": "“{name}” şifrelendi. Asıl dosya çöp kutusunda.",
  "e2e.fxe.original_kept": "Şifreli kopya kaydedildi, ancak “{name}” çöp kutusuna taşınamadı. Asıl dosyayı kendiniz silin.",
  "e2e.fxe.upload_too_big": "Bu sunucuda parçalı yükleme yok ve dosya bu tarayıcıdan tek parça gönderilemeyecek kadar büyük.",
  "e2e.fxe.unlock_title_open": "Şifreli dosyayı aç",
  "e2e.fxe.unlock_title_download": "Çözerek indir",
  "e2e.fxe.unlock_title_remove": "Şifrelemeyi kaldır",
  "e2e.fxe.unlock_lead": "“{name}” şifreli. Parolası burada, bu tarayıcıda denetlenir ve asla sunucuya gönderilmez.",
  "e2e.fxe.known_note": "Bu sekmede zaten açıldı - parola gerekmiyor.",
  "e2e.fxe.use_password": "Onun yerine parolayı kullan",
  "e2e.fxe.remove_warn_title": "Şifresiz içerik sunucuya geri döner",
  "e2e.fxe.remove_warn_body": "Dosya burada çözülür ve özgün adıyla şifresiz bir dosya olarak yüklenir: sunucu, yöneticileri, küçük resimler, arama ve yedekler onu yeniden okuyabilir. Şifreli dosya çöp kutusuna gider.",
  "e2e.fxe.unlock_open": "Aç",
  "e2e.fxe.unlock_download": "İndir",
  "e2e.fxe.unlock_remove": "Şifrelemeyi kaldır",
  "e2e.fxe.unlock_busy": "İşleniyor…",
  "e2e.fxe.save_again": "Kilit açıldı. Tarayıcınız, dosyanın nereye kaydedileceğini sormadan önce bir tıklama daha istiyor.",
  "e2e.fxe.save_button": "Kaydet…",
  "e2e.fxe.progress": "%{percent} tamamlandı",
  "e2e.fxe.wrong_password": "Parola yanlış.",
  "e2e.fxe.wrong_recovery": "Bu kurtarma anahtarı bu dosyayı açmıyor.",
  "e2e.fxe.damaged": "Bu dosya bozuk ya da kurcalanmış (veya açıldığından beri değişmiş). Hiçbir şey kaydedilmedi.",
  "e2e.fxe.not_readable": "Bu bir filex şifreli dosyası değil ya da başlığı bozuk.",
  "e2e.fxe.unsupported": "Bu dosya daha yeni bir filex gerektiriyor (gereken: {features}).",
  "e2e.fxe.downloaded": "“{name}” kaydedildi.",
  "e2e.fxe.removed": "Şifreleme kaldırıldı: “{name}” yeniden şifresiz bir dosya. Şifreli dosya çöp kutusunda.",
  "e2e.fxe.password_title": "Dosya parolasını değiştir",
  "e2e.fxe.password_cost": "Yalnızca dosyanın başlığı değişir: içerik bayt bayt aynen geri gönderilir ve kurtarma anahtarı çalışmaya devam eder.",
  "e2e.fxe.password_old_copies": "Bu dosyanın önceki bir sürümü - sürüm geçmişi, bir yedek, birinin indirdiği bir kopya - ESKİ parolayla açılmaya devam eder.",
  "e2e.fxe.password_done": "Parola değişti. Eski parola bu dosyayı artık açmıyor.",
  "e2e.recovery.warn_body_file": "Bu anahtara sahip olan herkes dosyayı okuyabilir. Onu paroladan ayrı bir yerde saklayın - parolanın yanında duran bir anahtar sizi unutmaktan korur, başkalarından değil.",
  "e2e.recovery.lead_file": "Bu anahtar dosyayı parolası olmadan açar. Yalnızca bir kez gösterilir - filex onu saklamaz ve bir daha gösteremez.",
  "e2e.dl.ctx_encrypted_copy": "Şifreli kopyayı indir",
  "e2e.dl.too_big": "Bu tarayıcı tek seferde en çok {limit} çözülmüş veri kaydedebilir, bu ise {size}. Chrome ya da Edge (doğrudan diske kaydeder), filex masaüstü uygulamasını kullanın ya da şifreli dosyayı indirip filex decrypt çalıştırın.",
  "e2e.dl.click_again": "Nereye kaydedileceğini seçmek için İndir’e bir kez daha tıklayın.",
  "e2e.dl.zip_started": "“{name}” içine çözülerek yazılıyor…",
  "e2e.dl.zip_done": "“{name}” kaydedildi - çözülmüş, gerçek adlarla.",
  "e2e.dl.zip_done_plain": "“{name}” kaydedildi. İçindeki {n} dosya hiç şifrelenmemişti ve olduğu gibi eklendi.",
  "e2e.dl.zip_done_plain_one": "“{name}” kaydedildi. İçindeki {n} dosya hiç şifrelenmemişti ve olduğu gibi eklendi.",
  "e2e.dl.zip_damaged": "Klasördeki bir dosya bozuk ya da kurcalanmış. İndirme durduruldu ve hiçbir şey kaydedilmedi.",
  "e2e.upload.streaming_unsupported": "Bu dosya 200 MB’tan büyük ve bu sunucuda onu parça parça şifreli göndermek için parçalı yükleme yok.",
  /* wiring:e2 fxe escrow - emanet anahtarı tek bir dosyayı açar, sahibine haber gider */
  "e2e.fxe.use_escrow": "Emanet anahtarını kullan",
  "e2e.fxe.escrow_warn_title": "Dosyanın sahibine haber gidecek",
  "e2e.fxe.escrow_warn_body": "Emanet anahtarıyla açılan dosyanın sahibine, dosya açılmadan önce bildirim gönderilir. Yalnız yetkiniz olduğunda kullanın.",
  "e2e.fxe.escrow_predates": "Bu kurulumun emanet anahtarı var, ama bu dosya onsuz şifrelenmiş (emanet burada açılmadan önce), bu yüzden emanet anahtarı onu açmaz. Parolayı ya da kurtarma anahtarını kullanın.",
  "e2e.fxe.escrow_other_key": "Bu dosya BAŞKA bir kurulumun emanet anahtarına mühürlenmiş, bu yüzden bu kurulumun emanet anahtarı onu açmaz.",
  "e2e.fxe.wrong_escrow": "Bu emanet anahtarı bu dosyayı açmıyor.",
  "e2e.fxe.escrow_notify_failed": "Dosyanın sahibine bildirim gönderilemedi, bu yüzden dosya açılmadı. Emanet anahtarının kullanımı her zaman duyurulur.",
  "e2e.fxe.escrow_done": "Emanet anahtarıyla açıldı - dosya sahibine bildirildi",
  /* wiring:e2 fxe purge - yönetici aslını kalıcı olarak siler */
  "e2e.fxe.seen_trash_admin": "Asıl dosya çöp kutusuna gider ve çöp kutusunun saklama süresi dolana kadar orada kalır - aşağıda kalıcı olarak silmediğiniz sürece.",
  "e2e.fxe.seen_versions_admin": "Önceki sürümleri sürüm geçmişinde kalır - aşağıda kalıcı olarak silmediğiniz sürece.",
  "e2e.fxe.purge_label": "Aslını kalıcı olarak sil (yönetici)",
  "e2e.fxe.purge_hint": "Şifreli kopya kaydedilir kaydedilmez önceki sürümleri ve çöp kutusundaki kaydı silinir; açık hâlinden bu sunucuda hiçbir şey kalmaz. Geri alınamaz. Daha önce alınmış yedeklere ve kopyalara ulaşılmaz.",
  "e2e.fxe.purge_others": "Bu dosya sizin değil, {owner} adlı kullanıcının. Onun aslını ve sürümlerini kalıcı olarak sil.",
  "e2e.fxe.purge_others_unknown": "Bu dosyanın kayıtlı bir sahibi yok - sizin değil. Aslını ve sürümlerini kalıcı olarak sil.",
  "e2e.fxe.purge_others_required": "Başkasının dosyasını kalıcı olarak sildiğinizi onaylayın.",
  "e2e.fxe.purge_no_id": "Bu dosya henüz katalogda değil, bu yüzden kalıcı olarak silinemez. Klasörü yenileyip tekrar deneyin.",
  "e2e.fxe.purged": "“{name}” şifrelendi. Aslı, sürümleri ve çöp kutusundaki kaydı kalıcı olarak silindi.",
  "e2e.fxe.purge_failed": "“{name}” dosyasının şifreli kopyası kaydedildi, ama aslı kalıcı olarak silinemedi ({reason}). Çöp kutusundan ve sürüm geçmişinden silin.",
  /* wiring:e2 fxe big - bu tarayıcının belleğine sığmayan çözülmüş indirme */
  "e2e.big.title": "Bu tarayıcıda çözülemeyecek kadar büyük",
  "e2e.big.lead": "“{name}” çözüldüğünde {size}. Bu tarayıcı indirmeyi belleğinde çözer ve en çok {limit} tutabilir, bu yüzden hiçbir şey indirilmedi.",
  "e2e.big.lead_grew": "“{name}” çözülürken {limit} sınırını aştı. Bu tarayıcı indirmeyi belleğinde çözer ve daha fazlasını tutamaz, bu yüzden hiçbir şey kaydedilmedi.",
  "e2e.big.instead": "Bunun yerine kendi bilgisayarınızda çözün:",
  "e2e.big.step_file": "Şifreli dosyayı olduğu gibi indirin (aşağıdaki düğme).",
  "e2e.big.step_folder": "Şifreli klasörü zip olarak indirin (aşağıdaki düğme) - klasörün anahtar dosyası da içindedir.",
  "e2e.big.step_run": "Kaydettiğiniz klasörde filex decrypt komutunu çalıştırıp parolayı girin:",
  "e2e.big.copy": "Kopyala",
  "e2e.big.copied": "Kopyalandı",
  "e2e.big.other_ways": "Chrome, Edge ve filex masaüstü uygulaması, boyutu ne olursa olsun doğrudan diske çözer.",
  "e2e.big.close": "Kapat",
  "e2e.big.download_file": "Şifreli dosyayı indir",
  "e2e.big.download_folder": "Şifreli klasörü indir (zip)",
  /* /wiring:e2 fxe */
  /* ── dil:paket - İngilizce sabit yazılmış erişilebilir adlar */
  "breadcrumb.aria": "Konum yolu",
  "e2e.recovery_key_aria": "Kurtarma anahtarı",
  "modal.close": "Kapat",
  "modal.busy_close.keep": "Devam etsin",
  "modal.busy_close.confirm": "Durdur ve kapat",
  /* ── zil ve hesap menüsü (2026-09-27: masaüstü uygulamasının gezgini de
     aynılarını çizsin diye yönetim uygulamasından buraya taşındı). ⚠ ORTAK
     anahtarlar: yönetim uygulamasının kataloğunda her biri aynı adla, aynı
     İngilizce ve Türkçeyle durur (web/tests/i18n/langPackCatalogue.test.ts),
     bir dil paketi her birini iki ekran için bir kez çevirir. */
  "notifications.bell": "Bildirim zili",
  "notifications.unreadCount": "{n} okunmamış",
  "notifications.title": "Bildirimler",
  "notifications.markAllRead": "Tümünü okundu işaretle",
  "notifications.markRead": "Okundu işaretle",
  "notifications.empty": "Henüz bildirim yok",
  "notifications.viewAll": "Tüm bildirimleri gör",
  "notifications.manageAdmin": "Bildirim yönetimi",
  "notifications.openTarget": "Bildirimin konusunu aç",
  "notifications.unreadOnly": "Sadece okunmamış",
  "notifications.pageOf": "Sayfa {page} / {pages} · toplam {total}",
  "notifications.severity.info": "Bilgi",
  "notifications.severity.warning": "Uyarı",
  "notifications.severity.error": "Hata",
  "notifications.severity.critical": "Kritik",
  "common.prev": "Önceki",
  "common.next": "İleri",
  "explore.account": "Hesap",
  /* ── kullanıcı ayarları penceresi (2026-09-27: masaüstü uygulaması aynı
     pencereyi kendi içinde açsın diye yönetim uygulamasından buraya taşındı).
     ⚠ ORTAK anahtarlar; ardından gelenler bu tablonun kendisinin (yönetim
     kataloğu onları yalnız vue-i18n'in anladığı sözdizimiyle yazar). */
  "common.cancel": "İptal",
  "common.close": "Kapat",
  "common.confirm": "Onayla",
  "common.currentPassword": "Mevcut parola",
  "common.email": "E-posta",
  "common.loading": "Yükleniyor…",
  "common.newPassword": "Yeni parola",
  "common.remove": "Kaldır",
  "common.save": "Kaydet",
  "common.saving": "Kaydediliyor…",
  "errors.generic": "Bir şeyler ters gitti",
  "errors.validationFailed": "Lütfen işaretli alanları kontrol edin",
  "install.desktopAllDownloads": "Tüm indirmeler ve sürüm notları",
  "install.desktopSubtitle": "Klasörleri bu bilgisayara eşitleyin, arka planda güncel kalsınlar. {platform} için mevcut.",
  "install.install": "Kur",
  "install.menuInstructions": "Tarayıcınızın menüsünü açıp “Uygulamayı yükle” ya da “Ana ekrana ekle”yi seçin.",
  "install.iosInstructions": "Paylaş'a dokunun (iOS 26'da önce ⋯, sonra Paylaş), ardından “Ana Ekrana Ekle” ve Ekle'ye dokunun.",
  "nav.themeAuto": "Otomatik",
  "nav.themeDark": "Karanlık",
  "nav.themeLight": "Aydınlık",
  "notifications.prefs.browser": "Tarayıcı bildirimleri",
  "notifications.prefs.browserHint": "Yeni bir şey geldiğinde sekmenin dışında bildirim göster. Bildirime tıklayınca konusu olan dosya, klasör ya da paylaşım açılır.",
  "notifications.prefs.desktopHandled": "Masaüstü uygulaması bunları kendisi gösteriyor",
  "notifications.prefs.enableBrowser": "Bildirimlere izin ver",
  "notifications.prefs.inApp": "Uygulama içi zil",
  "notifications.prefs.inAppHint": "Kapatırsanız ziliniz boşalır. Hiçbir kayıt silinmez - yönetici tüm olayları görmeye devam eder.",
  "notifications.prefs.iosHomeScreen": "iPhone ve iPad'de bildirimler tarayıcı sekmesinde değil, ana ekrana eklenmiş {name} uygulamasında çalışır (iOS 16.4 ve sonrası).",
  "notifications.prefs.movedToSettings": "Kendi bildirim ayarlarınız - zil, tarayıcı bildirimleri, hangi olaylar - kullanıcı ayarlarınızda.",
  "notifications.prefs.openSettings": "Bildirim ayarlarımı aç",
  "notifications.prefs.permDefault": "İzin henüz istenmedi",
  "notifications.prefs.permDenied": "Bu tarayıcıda engellendi",
  "notifications.prefs.permDeniedHint": "Tarayıcı ayarlarından bu siteye bildirim iznini yeniden verin.",
  "notifications.prefs.permGranted": "Bu tarayıcıda izin verildi",
  "notifications.prefs.permUnsupported": "Bu tarayıcı bildirim gösteremiyor",
  "notifications.prefs.push": "Bu cihazda anlık bildirim",
  "notifications.prefs.pushAdded": "Eklendi: {date}",
  "notifications.prefs.pushDevices": "Anlık bildirim alan cihazlar",
  "notifications.prefs.pushDisabled": "Sunucuda kapatılmış (FILEX_PUSH_ENABLED).",
  "notifications.prefs.pushFailed": "Bu cihazda anlık bildirimler açılamadı.",
  "notifications.prefs.pushHint": "Zilinizin size söyledikleri, {name} kapalıyken de bu telefona ya da tarayıcıya ulaşır: aynı bildirimler, aynı anda.",
  "notifications.prefs.pushKeyUnreadable": "Sunucunun anlık bildirim anahtarı artık açılamıyor (FILEX_SECRET_KEY değişmiş). Yönetim → Bildirimler sayfasında anahtarı yenileyin.",
  "notifications.prefs.pushNoSecretKey": "Anlık bildirimler için sunucuda FILEX_SECRET_KEY tanımlı olmalı: bildirimleri imzalayan anahtar onunla şifrelenerek saklanır.",
  "notifications.prefs.pushOn": "Bu cihazda açık",
  "notifications.prefs.pushRemove": "Kaldır",
  "notifications.prefs.pushRemoveLabel": "Kaldır: {device}",
  "notifications.prefs.pushTest": "Deneme gönder",
  "notifications.prefs.pushTestNone": "Deneme hiçbir cihaza ulaşmadı.",
  "notifications.prefs.pushTestSent": "Deneme {count} cihaza gönderildi",
  "notifications.prefs.pushTestSent_one": "Deneme {count} cihaza gönderildi",
  "notifications.prefs.pushThisDevice": "Bu cihaz",
  "notifications.prefs.pushUnavailable": "Bu sunucuda kullanılamıyor",
  "notifications.prefs.pushUnnamed": "Bir cihaz",
  "notifications.prefs.pushUnsupported": "Bu tarayıcı anlık bildirim alamıyor",
  "notifications.prefs.saved": "Tercih kaydedildi",
  "notifications.prefs.title": "Bildirimleriniz",
  "profile.avatar.change": "Fotoğrafı değiştir",
  "profile.avatar.failed": "Bu görsel işlenemedi - başka bir tane deneyin.",
  "profile.avatar.help": "Adınızın yanında ve dosya yöneticisinin işbirliği çubuğunda görünür - hesabınızla açılan her istemcide. Otomatik olarak 160 piksele küçültülür.",
  "profile.avatar.label": "Profil fotoğrafı",
  "profile.avatar.notImage": "Lütfen bir görsel dosyası seçin.",
  "profile.locale": "Dil",
  "profile.passwordChanged": "Parola değiştirildi",
  "profile.saved": "Profil kaydedildi",
  "profile.totp.code": "Doğrulama kodu",
  "profile.totp.disable": "2FA'yı kapat",
  "profile.totp.disabled": "Pasif",
  "profile.totp.enable": "2FA'yı aç",
  "profile.totp.enabled": "Aktif",
  "profile.totp.recoveryHint": "Bunları şimdi kaydedin - doğrulayıcınızı kaybederseniz her biri bir kez oturum açmanızı sağlar. Yalnızca bu sefer gösterilir.",
  "profile.totp.recoveryTitle": "Kurtarma kodları",
  "profile.totp.scanHint": "Bu QR kodu doğrulayıcı uygulamanızla tarayın, sonra 6 haneli kodu girin.",
  "profile.totp.title": "İki adımlı doğrulama",
  "profile.username.label": "Kullanıcı adı",
  "quota.title": "Depolama kotası",
  "quota.tooltip": "{used} / {limit} kullanıldı ({percent})",
  "quota.unlimitedTooltip": "{used} kullanıldı · sınırsız",
  "userSettings.adminBadge": "Yönetici",
  "userSettings.demoReadOnly": "Bu ortak bir demo hesabı; profili, parolası ve ikinci faktörü değiştirilemez.",
  "userSettings.footNote.ai": "Bu sekmede kaydedilecek bir şey yok.",
  "userSettings.footNote.notifications": "Değiştirdiğiniz anda kaydedilir.",
  "userSettings.footNote.preferences": "Değiştirdiğiniz anda kaydedilir.",
  "userSettings.footNote.profile": "Bu sekmedeki değişiklikler Kaydet'e bastığınızda kaydedilir.",
  "userSettings.footNote.security": "Buradaki her işlem kendi başına uygulanır.",
  "userSettings.heading": "Kullanıcı ayarları",
  "userSettings.headingSub": "Profilinizi, tercihlerinizi ve güvenliğinizi yönetin.",
  "userSettings.notifications.adminAlerts": "Yönetici uyarıları",
  "userSettings.notifications.adminAlertsHint": "Güncellemeler, kopyalar, oturum açma sağlayıcıları, kiracı alan adları ve yöneticilere yönelik diğer uyarılar",
  "userSettings.notifications.device": "Masaüstü bildirimleri",
  "userSettings.notifications.deviceHint": "Yeni bir şey geldiğinde, filex arka planda çalışırken de bilgisayarınızın kendi bildirimleri.",
  "userSettings.notifications.digestHint": "Acil olarak işaretlenen türler size hemen ulaşır. Diğerleri {minutes} dakika bekletilir ve klasör klasör tek bir özet olarak gelir.",
  "userSettings.notifications.digestOffHint": "Her tür size hemen ulaşır. Bir türün Acil anahtarını kapatırsanız o tür, klasör klasör tek bir özet olarak gelir.",
  "userSettings.notifications.events.archive_created": "Bir arşiv oluşturulduğunda",
  "userSettings.notifications.events.archive_extracted": "Bir arşiv çıkarıldığında",
  "userSettings.notifications.events.comment_added": "Biri bir dosyaya yorum yaptığında",
  "userSettings.notifications.events.drop_received": "İstek bağlantısıyla bir dosya geldiğinde",
  "userSettings.notifications.events.e2e_escrow_used": "Şifreli bir klasör emanet anahtarıyla açıldığında",
  "userSettings.notifications.events.e2e_password_changed": "Şifreli klasörünüzün parolası değiştiğinde",
  "userSettings.notifications.events.e2e_request_created": "Biri bir klasörü ya da dosyayı şifrelemek istediğinde",
  "userSettings.notifications.events.e2e_request_decided": "Şifreleme isteğiniz yanıtlandığında",
  "userSettings.notifications.events.file_deleted": "Bir dosya kalıcı olarak silindiğinde",
  "userSettings.notifications.events.file_infected": "Bir dosyada virüs bulunduğunda",
  "userSettings.notifications.events.file_moved": "Bir dosya taşındığında ya da adı değiştiğinde",
  "userSettings.notifications.events.file_trashed": "Bir dosya çöp kutusuna taşındığında",
  "userSettings.notifications.events.file_updated": "Bir dosya değiştiğinde",
  "userSettings.notifications.events.file_upload_failed": "Bir yükleme tamamlanmadığında",
  "userSettings.notifications.events.file_uploaded": "Yeni bir dosya geldiğinde",
  "userSettings.notifications.events.notification_digest": "Acil olarak işaretlemediğim bildirimlerin özeti",
  "userSettings.notifications.events.plugin_notice": "Kurulu bir uygulama size mesaj gönderdiğinde",
  "userSettings.notifications.events.share_created": "Biri paylaşım bağlantısı oluşturduğunda",
  "userSettings.notifications.eventsHint": "Birini kapatmak onu zilinizin dışında tutar. Hiçbir şey kaydedilmekten çıkmaz - yönetici her olayı görmeye devam eder.",
  "userSettings.notifications.eventsTitle": "Nelerden haberdar olayım",
  "userSettings.notifications.urgent": "Acil",
  "userSettings.notifications.urgentFor": "Hemen bildir: {event}",
  "userSettings.open": "Kullanıcı ayarları",
  "userSettings.prefs.appearance": "Görünüm",
  "userSettings.prefs.compact": "Sıkışık dosya listesi kullan",
  "userSettings.prefs.compactHint": "Dosya gezgininde daha dar satırlar.",
  "userSettings.prefs.remoteImages": "Önizlemelerde uzak görselleri yükle",
  "userSettings.prefs.remoteImagesHint": "Bir dosyanın önizlemesinde başka sunuculardaki görseller sormadan yüklenir. Kapalıyken her biri bir tıklama bekler, çünkü yüklemek o sunucuya dosyanın açıldığını bildirir. Küçük resimler bunları hiçbir zaman yüklemez.",
  "userSettings.prefs.desktopApp": "Masaüstü uygulaması",
  "userSettings.prefs.desktopAppHint": "Uygulamanın köşesindeki hatırlatmayı kapattığınızda bir daha çıkmaz - indirmeler burada kalır.",
  "userSettings.prefs.folderView": "Varsayılan klasör görünümü",
  "userSettings.prefs.folderViewHint": "Hiç değiştirmediğiniz bir klasörün nasıl açılacağı. Değiştirdiğiniz klasörler kendi görünümünü korur - bu ayar onlara dokunmaz.",
  "userSettings.prefs.fvColumns": "Varsayılan sütunlarınız özelleştirilmiş (“Bunu tüm klasörler için varsayılanım yap” ile ayarlandı).",
  "userSettings.prefs.fvColumnsReset": "Sıfırla",
  "userSettings.prefs.fvDir": "Yön",
  "userSettings.prefs.fvDir_asc": "Artan",
  "userSettings.prefs.fvDir_desc": "Azalan",
  "userSettings.prefs.fvForget": "Hepsini unut",
  "userSettings.prefs.fvInherit": "Sunucu varsayılanı ({value})",
  "userSettings.prefs.fvMode": "Görünüm",
  "userSettings.prefs.fvSort": "Sıralama",
  "userSettings.prefs.fvSort_modified": "Değiştirilme",
  "userSettings.prefs.fvSort_name": "Ad",
  "userSettings.prefs.fvSort_size": "Boyut",
  "userSettings.prefs.fvSort_type": "Tür",
  "userSettings.prefs.fvView_gallery": "Galeri",
  "userSettings.prefs.fvView_grid": "Izgara",
  "userSettings.prefs.fvView_list": "Liste",
  "userSettings.prefs.installApp": "Web uygulaması olarak kur",
  "userSettings.prefs.installAppLead": "Bu cihazın ana ekranına ekleyin: {name} bir uygulama gibi kendi penceresinde açılır.",
  "userSettings.prefs.languageHint": "Burada hemen uygulanır; bir sonraki tarayıcıda da açılsın diye hesabınıza kaydedilir.",
  "userSettings.prefs.mode": "Aydınlık ya da karanlık",
  "userSettings.prefs.modeHint": "Hangi sürümün çizileceği. Otomatik, işletim sisteminizi izler.",
  "userSettings.prefs.openTrigger": "Dosyaları açma",
  "userSettings.prefs.openTriggerDouble": "Çift tık",
  "userSettings.prefs.openTriggerHint": "Farenin dosyayı nasıl açtığı. Dokunmatik ekranda tek dokunuş her zaman açar, kutucuk her zaman seçer.",
  "userSettings.prefs.openTriggerSingle": "Tek tık",
  "userSettings.prefs.palette": "Renk paleti",
  "userSettings.prefs.paletteHint": "O sürümün hangi renklerden oluştuğu. Her paletin aydınlık ve karanlık bir sürümü vardır; bu ayarla üstteki ayar birlikte çalışır.",
  "userSettings.prefs.shortcuts": "Klavye kısayolları",
  "userSettings.prefs.shortcutsEdit": "Düzenle…",
  "userSettings.prefs.shortcutsHint": "Dosya yöneticisinin yanıt verdiği tuşlar.",
  "userSettings.prefs.startPage": "Açılış sayfası",
  "userSettings.prefs.startPageHint": "Oturum açtığınızda ya da ana adrese geldiğinizde filex burayı açar. Doğrudan bir sayfanın bağlantısına tıkladığınızda yine o sayfaya gidersiniz.",
  "userSettings.prefs.startPage_admin": "Yönetim paneli",
  "userSettings.prefs.startPage_files": "Dosyalar",
  "userSettings.prefs.startPage_home": "Ana sayfa",
  "userSettings.prefs.timezone": "Saat dilimi",
  "userSettings.prefs.timezoneHint": "Tarihler bir an olarak saklanır ve burada seçtiğiniz saatle gösterilir; böylece herkes aynı anı kendi saatiyle görür. Hesabınıza kaydedilir, başka bir tarayıcıda da geçerli olur.",
  "userSettings.prefs.timezoneNow": "{zone} bölgesinde şu an: {time}",
  "userSettings.saveChanges": "Değişiklikleri kaydet",
  "userSettings.scope.account": "Hesap",
  "userSettings.scope.accountHint": "Hesabınızda saklanır: nerede oturum açarsanız açın aynıdır.",
  "userSettings.scope.device": "Bu cihaz",
  "userSettings.scope.deviceHint": "Yalnızca bu cihazda saklanır: başka bir bilgisayar, telefon ya da tarayıcı kendi ayarını tutar.",
  "userSettings.scope.deviceNotifyHint": "Bu cihazın size yeni bir şeyi nasıl haber vereceği; yalnızca bu cihazda saklanır.",
  "userSettings.scope.myAccount": "Hesabım",
  "userSettings.scope.myAccountHint": "Zilinize nelerin düşeceği; hesabınızda saklanır.",
  "userSettings.security.passwordTitle": "Parolayı değiştir",
  "userSettings.security.totpDisabled": "İki adımlı doğrulama kapalı",
  "userSettings.security.totpEnabled": "İki adımlı doğrulama açık",
  "userSettings.subtitle.ai": "Burada henüz ayarlayabileceğiniz bir şey yok.",
  "userSettings.subtitle.notifications": "Zilinize ve masaüstünüze neyin ulaşacağı.",
  "userSettings.subtitle.preferences": "Uygulamanın cihazlarınızda nasıl göründüğü ve okunduğu.",
  "userSettings.subtitle.profile": "Adınız, e-postanız ve fotoğrafınız - başkalarının gördüğü bilgiler.",
  "userSettings.subtitle.security": "Parolanız ve ikinci faktörünüz.",
  "userSettings.tabs.ai": "AI asistanı",
  "userSettings.ai.state.on": "Asistan açık.",
  "userSettings.ai.state.off": "Asistan bu sunucuda kapalı.",
  "userSettings.ai.state.not_configured": "Yönetici asistanı henüz kurmadı.",
  "userSettings.ai.state.not_permitted": "Asistan açık ama rolünüz onu kapsamıyor.",
  "userSettings.ai.provider": "Yazdıklarınızı kim okuyor",
  "userSettings.ai.providerHint": "Mesajlarınız ve asistanın sizin için okuduğu dosyalar bu sağlayıcıya gönderilir. Okuduğu her dosya denetim kaydında yer alır.",
  "userSettings.ai.confirmAll": "Her değişiklikten önce bana sor",
  "userSettings.ai.confirmAllHint": "Kapalıyken geri alınabilen değişiklikler (taşıma, yeniden adlandırma, düzenleme, çöp kutusuna silme) hemen yapılır ve Geri al bırakır. Açıkken bunlar da onayınızı bekler. Geri alınamayan her şey her zaman bekler.",
  "userSettings.ai.history": "Konuşma geçmişi",
  "userSettings.ai.retention": "Konuşmalar son kullanımlarından sonra {count} gün sunucuda saklanır.",
  "userSettings.ai.retention_one": "Konuşmalar son kullanımlarından sonra {count} gün sunucuda saklanır.",
  "userSettings.ai.clear": "Konuşmalarımı sil",
  "userSettings.ai.clearConfirm": "Hepsi kalıcı olarak silinsin mi?",
  "userSettings.ai.cleared": "Konuşmalarınız silindi.",
  "userSettings.ai.saveFailed": "Bu kaydedilemedi.",
  "userSettings.tabs.notifications": "Bildirimler",
  "userSettings.tabs.preferences": "Tercihler",
  "userSettings.tabs.profile": "Profil",
  "userSettings.tabs.security": "Güvenlik",
  "userSettings.apps.title": "Varsayılan uygulamalar",
  "userSettings.apps.lead": 'Bir dosyanın menüsünden seçin: Birlikte aç, Uygulama seç…, sonra "Her zaman bu uygulamayla aç" kutusunu işaretleyin. Yalnız yöneticinizin o tür için açık bıraktığı uygulamalar sunulur.',
  "userSettings.apps.empty": "Henüz hiçbir dosya türü için uygulama seçmediniz: her dosya, yöneticinizin ilk sıraya koyduğu uygulamayla açılır.",
  "userSettings.apps.reset": "Sıfırla",
  "userSettings.apps.resetAll": "Tümünü sıfırla",
  "userSettings.apps.unavailable": "Artık kullanılamıyor: siz yeniden seçene kadar {app} ile açılıyor.",
  "userSettings.apps.change": "{ext} dosyalarını açan uygulama",
  "userSettings.title": "Kullanıcı ayarları",
  "users.fields.displayName": "Görünen ad",
  "profile.username.helpText": "Kullanıcı adınız. Oturum açarken bunu da e-postanızı da kullanabilirsiniz - bağlantı istemcileri (SFTP, FTP) için ise bu ad gerekir, çünkü oturum açtıkları addaki @ işareti onların ayar dosyalarında kaçış gerektirir.",
  "userSettings.prefs.fvKeptCount": "{count} klasör kendi görünümünü koruyor.",
  "userSettings.prefs.fvKeptCount_one": "{count} klasör kendi görünümünü koruyor."
}, oP = "filex-base", rP = /^(\/[A-Za-z0-9_~.-]+)+$/;
function sP(e) {
  var a, i;
  const t = e ?? (typeof document < "u" ? document : null);
  if (!t) return "";
  let n = "";
  try {
    n = ((i = (a = t.querySelector(`meta[name="${oP}"]`)) == null ? void 0 : a.getAttribute("content")) == null ? void 0 : i.trim()) ?? "";
  } catch {
    return "";
  }
  return !n || !rP.test(n) || n.split("/").some((r) => r === "." || r === "..") ? "" : n;
}
function rc() {
  return sP();
}
function Lfe(e) {
  return rc() + e;
}
function Cy(e, t) {
  if (/^[a-z][a-z0-9+.-]*:\/\//i.test(t)) return t;
  const n = String(e ?? "").replace(/\/+$/, "");
  return !n || !t.startsWith("/") ? t : n + t;
}
function Yo(e) {
  return String(e ?? rc()).replace(/\/+$/, "");
}
const oi = S(0), bl = S(!1), p2 = ["en", "tr"], Jw = {
  en: "English",
  tr: "Türkçe",
  de: "Deutsch",
  fr: "Français",
  es: "Español",
  it: "Italiano",
  nl: "Nederlands",
  pt: "Português",
  pl: "Polski",
  ru: "Русский",
  uk: "Українська",
  ar: "العربية",
  fa: "فارسی",
  az: "Azərbaycanca",
  ja: "日本語",
  ko: "한국어",
  zh: "中文"
};
function h2(e) {
  if (Jw[e]) return Jw[e];
  try {
    const t = new Intl.DisplayNames([e], { type: "language" }).of(e);
    if (t && t.toLowerCase() !== e)
      return t.charAt(0).toLocaleUpperCase(e) + t.slice(1);
  } catch {
  }
  return e.toUpperCase();
}
const Gu = { en: el, tr: f2 }, ka = /* @__PURE__ */ new Map(), Xu = /* @__PURE__ */ new Map(), Ap = /^[a-z]{2,3}(-[a-z0-9]{2,8})*$/;
function m2(e) {
  return Ap.test(String(e ?? "").trim().toLowerCase().replace(/_/g, "-"));
}
function Aa(e) {
  const t = String(e ?? "").trim().toLowerCase().replace(/_/g, "-");
  if (!Ap.test(t)) return "";
  if (ka.has(t)) return t;
  const n = t.split("-")[0];
  if (Dl(n) || ka.has(n)) return n;
  for (const a of ka.keys()) if (a.startsWith(`${n}-`)) return a;
  return t;
}
function Dl(e) {
  return p2.includes(e);
}
function v2(e) {
  const t = {};
  for (const [n, a] of Object.entries(e ?? {}))
    typeof a != "string" || !a.trim() || !n || n.split(".").some((i) => i === "__proto__" || i === "constructor" || i === "prototype") || (t[n] = a);
  return t;
}
function lP(e) {
  const t = String((e == null ? void 0 : e.code) ?? "").trim().toLowerCase().replace(/_/g, "-"), n = Ap.test(t) ? t : "";
  n && (ka.set(n, {
    code: n,
    label: String(e.label ?? "").trim() || h2(n),
    source: e.source === "plugin" ? "plugin" : e.source || "builtin",
    plugin: e.plugin,
    rtl: e.rtl === !0,
    strings: e.strings ? v2(e.strings) : null
  }), oi.value += 1);
}
function y2(e) {
  ka.clear(), Xu.clear();
  for (const t of e ?? []) lP(t);
  oi.value += 1;
}
function Dfe(e) {
  let t = !1;
  for (const [n, a] of ka)
    a.source === "plugin" && a.plugin === e && (ka.delete(n), t = !0);
  t && (oi.value += 1);
}
function Rfe() {
  ka.clear(), Xu.clear(), vo = {}, ll = null, bl.value = !1, oi.value += 1;
}
function mo() {
  oi.value;
  const e = p2.map((t) => ({
    code: t,
    label: h2(t),
    source: "builtin"
  }));
  for (const [t, n] of ka)
    Dl(t) || e.push({ code: t, label: n.label, source: n.source, plugin: n.plugin, rtl: n.rtl });
  return e;
}
function Vf(e) {
  oi.value;
  const t = Aa(e);
  return !!t && (Dl(t) || ka.has(t));
}
function Vu(e) {
  return Vf(e) ? !0 : !bl.value && m2(e);
}
function uP(e) {
  const t = Aa(e), n = Dl(t) ? Gu[t] : void 0, a = ka.get(t);
  return a && a.strings === null && b2(t), !(a != null && a.strings) || !Object.keys(a.strings).length ? n ?? Gu.en : { ...Gu.en, ...n ?? {}, ...a.strings };
}
function g2(e) {
  const t = Aa(e), n = Dl(t) ? Gu[t] : void 0, a = ka.get(t);
  a && a.strings === null && b2(t);
  const i = a != null && a.strings && Object.keys(a.strings).length ? a.strings : null;
  return n ? { lang: t, strings: i ? { ...n, ...i } : n } : i ? { lang: t, strings: i } : { lang: "en", strings: Gu.en };
}
function Nfe(e) {
  var t;
  return { ...((t = ka.get(Aa(e))) == null ? void 0 : t.strings) ?? {} };
}
const cP = 1e4;
let vo = {}, ll = null;
function b2(e) {
  const t = Aa(e), n = ka.get(t);
  if (!n) return Promise.resolve(!1);
  if (n.strings !== null) return Promise.resolve(Object.keys(n.strings).length > 0);
  const a = Xu.get(t);
  if (a) return a;
  const i = vo.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
  if (!i) return Promise.resolve(!1);
  const r = Yo(vo.base), l = (async () => {
    let c = {};
    try {
      const m = vo.headers ? await vo.headers() : {}, v = await i(`${r}/api/public/ui-locales/${encodeURIComponent(t)}`, {
        method: "GET",
        headers: { Accept: "application/json", ...m },
        credentials: "same-origin"
      });
      if (v.ok) {
        const x = await v.json();
        c = v2(x == null ? void 0 : x.strings);
      }
    } catch {
    }
    const p = ka.get(t);
    return p === n && (p.strings = c, oi.value += 1), Xu.delete(t), Object.keys(c).length > 0;
  })();
  return Xu.set(t, l), l;
}
function k2(e, t) {
  if (t && (vo = t), !e) return mo();
  const n = Array.isArray(e.ui_locales) ? e.ui_locales : [], a = new Set(n.map((r) => String((r == null ? void 0 : r.code) ?? "").toLowerCase())), i = (e.locales ?? []).map((r) => String(r ?? "").trim().toLowerCase()).filter((r) => Ap.test(r) && !Dl(r) && !a.has(r)).map((r) => ({ code: r, source: "plugin" }));
  return y2([...n, ...i]), bl.value = !0, mo();
}
function dP(e = {}) {
  const t = hP(e);
  return ll = t, t.finally(() => {
    ll === t && (ll = null);
  }), t;
}
function fP(e = {}) {
  return ll || (bl.value ? Promise.resolve(mo()) : dP(e));
}
async function pP(e, t) {
  const n = t.timeoutMs && t.timeoutMs > 0 ? t.timeoutMs : 0, a = n && typeof AbortController == "function" ? new AbortController() : null, i = (async () => {
    try {
      const c = t.headers ? await t.headers() : {}, p = await e(`${Yo(t.base)}/api/public/branding`, {
        method: "GET",
        headers: { Accept: "application/json", ...c },
        credentials: "same-origin",
        ...a ? { signal: a.signal } : {}
      });
      return p.ok ? await p.json() : null;
    } catch {
      return null;
    }
  })();
  if (!n) return i;
  let r;
  const l = new Promise((c) => {
    r = setTimeout(() => {
      a == null || a.abort(), c(null);
    }, n);
  });
  try {
    return await Promise.race([i, l]);
  } finally {
    clearTimeout(r);
  }
}
async function hP(e) {
  Yo(vo.base) !== Yo(e.base) && (y2([]), bl.value = !1), vo = e;
  const t = e.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
  if (!t) return mo();
  const n = await pP(t, e);
  return vo !== e ? mo() : n ? (k2(n), mo()) : (bl.value = !0, oi.value += 1, mo());
}
const mP = "en";
function Wi(e) {
  return e && Vu(e) ? Aa(e) : w2();
}
function w2() {
  return _2(Sv()) || mP;
}
function Sv() {
  try {
    const e = typeof navigator > "u" ? void 0 : navigator;
    return e ? e.languages && e.languages.length ? e.languages : [e.language] : [];
  } catch {
    return [];
  }
}
function _2(e) {
  for (const t of e)
    if (t && Vf(t)) return Aa(t);
  return "";
}
const vP = [".filex-trash", ".versions", ".thumbs", ".filex-open", ".filex-drafts"], yP = ".filex-drafts", x2 = ".keepdir", S2 = new Set(vP);
function $2(e) {
  let t = String(e ?? "").trim().replace(/\\/g, "/");
  const n = t.indexOf("://");
  return n >= 0 && (t = t.slice(n + 3)), t.split("/").filter((a) => a && a !== ".");
}
function Ep(e) {
  const t = String(e ?? "").trim();
  return S2.has(t) || t === x2;
}
function jf(e) {
  const t = $2(e);
  return t.some((n) => S2.has(n)) ? !0 : t.length > 0 && t[t.length - 1] === x2;
}
function $v(e) {
  const t = String(e ?? "");
  if (!jf(t)) return t;
  const n = t.indexOf("://");
  return n >= 0 ? t.slice(0, n + 3) : "";
}
function Zw(e) {
  const t = $2(e);
  return t.length !== 4 || t[0] !== yP || !/^[1-9][0-9]*$/.test(t[1]) || !/^[0-9a-f]{8,32}$/.test(t[2]) || Ep(t[3]) ? "" : t[2];
}
const Ru = (e) => Array.isArray(e) ? e.filter((t) => typeof t == "string").map((t) => t.toLowerCase()) : [], Mc = Ea(null), T2 = Ea({});
function gP(e) {
  if (!e) return;
  const t = e.edit_kinds;
  t && typeof t == "object" && (Mc.value = {
    office: new Set(Ru(t.office)),
    text: new Set(Ru(t.text)),
    names: new Set(Ru(t.text_names)),
    prefixes: Ru(t.text_mime_prefixes),
    mimes: new Set(Ru(t.text_mimes))
  });
  const n = e.limits;
  n && typeof n == "object" && (T2.value = { ...n });
}
function Ife() {
  return Mc.value !== null;
}
function Tv(e) {
  var t;
  return ((t = Mc.value) == null ? void 0 : t.office.has(String(e ?? "").toLowerCase())) ?? !1;
}
function A2(e) {
  const t = Mc.value;
  if (!t) return !1;
  const n = String(e ?? "").split(";")[0].trim().toLowerCase();
  return n ? t.mimes.has(n) || t.prefixes.some((a) => n.startsWith(a)) : !1;
}
function bP(e) {
  const t = e.replace(/[\\/]+$/, "").split(/[\\/]/);
  return (t[t.length - 1] ?? "").toLowerCase();
}
function kP(e) {
  const t = e.lastIndexOf(".");
  return t >= 0 ? e.slice(t + 1) : "";
}
function Bfe(e) {
  const t = Mc.value;
  if (!t || !e) return !1;
  const n = bP(String(e.basename ?? "")), a = String(e.extension ?? kP(n)).toLowerCase();
  return a && t.text.has(a) || n && t.names.has(n) ? !0 : A2(e.mime_type);
}
function Pc(e) {
  const t = T2.value[e];
  return typeof t == "number" && t > 0 ? t : void 0;
}
function Ffe(e) {
  return Array.from(e).length;
}
function zy(e, t) {
  if (!t) return e;
  const n = Array.from(e);
  return n.length > t ? n.slice(0, t).join("") : e;
}
const wP = A(() => {
  oi.value;
  const e = /* @__PURE__ */ new Set();
  for (const t of mo())
    t.rtl === !0 && e.add(t.code);
  return e;
});
function kl(e) {
  const t = Aa(e ?? "");
  return t && wP.value.has(t) ? "rtl" : "ltr";
}
function Ufe(e = typeof document < "u" ? document.documentElement : null) {
  if (!e) return () => {
  };
  const t = () => {
    const i = kl(e.getAttribute("lang"));
    e.getAttribute("dir") !== i && e.setAttribute("dir", i);
  };
  t();
  const n = typeof MutationObserver < "u" ? new MutationObserver(t) : null;
  n == null || n.observe(e, { attributes: !0, attributeFilter: ["lang"] });
  const a = Je(oi, t);
  return () => {
    n == null || n.disconnect(), a();
  };
}
function ei(e) {
  var n;
  const t = (n = e == null ? void 0 : e.closest) == null ? void 0 : n.call(e, '[dir="rtl"], [dir="ltr"]');
  return (t == null ? void 0 : t.getAttribute("dir")) === "rtl" ? "rtl" : "ltr";
}
function Av(e) {
  return e === "rtl" ? -1 : 1;
}
function qf(e, t) {
  const n = e === "ArrowRight" ? 1 : e === "ArrowLeft" ? -1 : 0;
  return n === 0 ? 0 : n * Av(t);
}
function Ur(e, t) {
  return t === "rtl" ? e.right : e.left;
}
function Qw(e, t) {
  return t === "rtl" ? e.left : e.right;
}
function Ev(e) {
  const t = Math.abs(e.scrollLeft);
  return { start: t > 0, end: e.scrollWidth - e.clientWidth - t > 1 };
}
function e_(e, t, n, a, i = 8) {
  const r = a === "rtl" ? n - e : e;
  let l = r;
  if (r + t > n - i) {
    const c = r - t;
    l = c >= i ? c : Math.max(i, n - t - i);
  }
  return a === "rtl" ? n - l - t : l;
}
function Oc(e, t, n, a, i = 8) {
  const r = a === "rtl" ? n - e : e, l = r + t > n - i ? Math.max(i, n - i - t) : r;
  return a === "rtl" ? n - l - t : l;
}
const Wf = "⁦", t_ = "⁧", Yf = "⁨", sc = "⁩", _P = new RegExp("[\\u2066-\\u2069]?\\d[\\d.,]*(?:\\s?[A-Za-z%]{1,3})?[\\u2066-\\u2069]?\\s*\\/\\s*[\\u2066-\\u2069]?\\d[\\d.,]*(?:\\s?[A-Za-z%]{1,3})?[\\u2066-\\u2069]?|[A-Za-z][\\w+.-]*:[^\\s,\\u060C)\\u2066-\\u2069]+|\\/(?:[A-Za-z0-9_.~%+-]+\\/)+[A-Za-z0-9_.~%+-]*|(?<![A-Za-z0-9_.~%+:\\/-])\\/(?=[A-Za-z0-9_.~%+-]*[A-Za-z0-9])[A-Za-z0-9_.~%+-]*[A-Za-z0-9_~%+-](?!\\.?[A-Za-z0-9_~%+:-])", "g");
function xP(e) {
  if (!(e[0] === Wf || e[0] === Yf || e[0] === t_) || e[e.length - 1] !== sc) return !1;
  let t = 0;
  for (let n = 0; n < e.length; n++) {
    const a = e[n];
    if (a === Wf || a === Yf || a === t_ ? t += 1 : a === sc && (t -= 1), t === 0 && n < e.length - 1) return !1;
  }
  return t === 0;
}
function E2(e) {
  return e.replace(_P, (t, n, a) => {
    if (xP(t)) return t;
    const i = a[n - 1], r = a[n + t.length];
    return (i === Wf || i === Yf) && r === sc ? t : Wf + t + sc;
  });
}
function Yi(e, t) {
  return kl(e) === "rtl" ? E2(t) : t;
}
function SP(e) {
  return Yf + e + sc;
}
function C2(e) {
  if (e === "code") return "ltr";
  if (e === "text") return "auto";
}
function Gf(e, t) {
  return typeof (e == null ? void 0 : e.foreign) == "function" ? e.foreign(t) : t;
}
function wl(e) {
  const t = (n, a = {}) => {
    const i = uP(e)[n] ?? n, r = Object.entries(a).reduce((l, [c, p]) => l.replaceAll(`{${c}}`, String(p)), i);
    return Yi(e, r);
  };
  return t.foreign = (n) => Yi(e, n), t;
}
const z2 = {
  400: "err.status.400",
  401: "err.status.401",
  403: "err.status.403",
  404: "err.status.404",
  409: "err.status.409",
  413: "err.status.413",
  415: "err.status.415",
  422: "err.status.422",
  429: "err.status.429",
  500: "err.status.500",
  501: "err.status.501",
  /* ⚠ 502 and 504 are what an APP answers with (handlers/app_plugins.go
     callFail: any plugin error, and a plugin that ran out of time). */
  502: "err.status.502",
  503: "err.status.503",
  504: "err.status.504"
};
function Hfe(e, t) {
  return M2(e, wl(t));
}
function M2(e, t) {
  return t(z2[e] ?? (e >= 500 ? "err.status.500" : "err.status.other"));
}
function Kfe(e) {
  return e >= 400 && e < 500 && e in z2;
}
function My(e) {
  const t = e.message;
  return typeof t == "string" ? t.trim() : "";
}
function Vfe(e, t) {
  if (!e || typeof e != "object" || Array.isArray(e)) return "";
  const n = My(e);
  return n ? Yi(t, n) : "";
}
function Py(e) {
  try {
    const t = JSON.parse(e);
    return t && typeof t == "object" && !Array.isArray(t) ? t : {};
  } catch {
    return {};
  }
}
function $P(e) {
  const t = Py(e).error;
  return typeof t == "string" ? t : "";
}
function jfe(e, t, n) {
  return Oy(e, t, wl(n));
}
function Oy(e, t, n, a = {}) {
  const i = a.server || My(Py(t));
  return i ? Gf(n, i) : M2(e, n);
}
function fa(e, t, n) {
  const a = Py(t), i = My(a), r = new Error(Oy(e, t, wl(n), { server: i }));
  r.status = e, r.code = $P(t), r.detail = t.slice(0, 300), r.said = !0, i && (r.server = i);
  const l = a.admin_hint;
  return typeof l == "string" && l && (r.hint = l), typeof a.reason == "string" && a.reason && (r.reason = a.reason), r;
}
function Za(e, t) {
  const n = (r) => Yi(t, r), a = e;
  if (!a || a.said !== !0) return n(a instanceof Error ? a.message : e ? String(e) : "");
  if (a.server) return n(a.server);
  const i = a.code ?? "";
  return i && !Ly(i) && !/^[a-z0-9_]+$/.test(i) ? n(i) : n(a.message ?? "");
}
function Cv(e, t) {
  const n = new Error(wl(e)("err.network"));
  return n.detail = t instanceof Error ? t.message : t ? String(t) : "", n.said = !0, n;
}
function Ly(e) {
  const t = e.trim();
  return t ? /^[[{]/.test(t) || // a JSON body
  /\b[1-5]\d\d\b\s+[A-Z][a-z]+/.test(t) || // "500 Internal Server Error"
  /\b[A-Z][A-Z0-9]+_[A-Z0-9_]+\b/.test(t) || // FILEX_SECRET_KEY
  /\b(panic|goroutine|stack trace|Traceback|at [\w$.]+ \()/i.test(t) || /^[\w.-]+: [\w.-]+(: |$)/.test(t) || // "protocolauth: no secret key…"
  /(^|\s)\/(?:[\w.-]+\/){2,}/.test(t) || // /var/lib/filex/…
  /\b[a-z][\w.-]*: [^:()]{1,60}: [a-z][\w.-]*: /i.test(t) || // a Go error chain "a: b: c: d"
  /\b(ECONNREFUSED|ETIMEDOUT|EOF|nil pointer|dial tcp|x509|context deadline exceeded)\b/i.test(t) : !1;
}
function TP(e) {
  const t = /^(.*\S)\s*\(([^()]*)\)\s*$/.exec(e);
  return t && Ly(t[2]) ? [t[1], t[2]] : [e, ""];
}
function P2(e, t, n = {}) {
  const a = e, i = (a == null ? void 0 : a.said) === !0, r = i ? (a == null ? void 0 : a.detail) ?? "" : a instanceof Error ? a.message : e ? String(e) : "", l = i ? n.t && typeof (a == null ? void 0 : a.status) == "number" ? Oy(a.status, a.detail ?? "", n.t, { server: a.server }) : (a == null ? void 0 : a.message) || t : t;
  !i && r && typeof console < "u" && console.warn("[filex]", r);
  const c = Gf(n.t, l), p = Gf(n.t, r);
  return n.callerAdmin && r && r !== l ? { text: c, detail: p } : { text: c };
}
function Xf(e, t, n = {}) {
  const i = e.op_type === "plugin" || e.op_type === "plugin-action" ? t("plugin.failed", { label: e.label || e.action || t("opc.kind.plugin") }) : t("toast.failed");
  return AP(
    { error: e.error_message, error_code: e.error_code, error_engine: e.error_engine, error_text: e.error_text },
    i,
    t,
    n
  );
}
function AP(e, t, n, a = {}) {
  const i = (e.error ?? "").trim(), r = a.callerAdmin === !0, l = (m) => Gf(n, m), c = (m) => r && i && i !== m ? { text: l(m), detail: l(i) } : { text: l(m) }, p = (e.error_text ?? "").trim();
  if (p) return c(p);
  switch (e.error_code) {
    case "cancelled":
      return { text: n("opc.status.aborted") };
    case "app": {
      const [m, v] = TP(i);
      return m && !Ly(m) ? v && r ? { text: l(m), detail: l(i) } : { text: l(m) } : c(t);
    }
  }
  return c(t);
}
const EP = "DRAFT_LIMIT", CP = "TARGET_TAKEN", zP = "FOLDER_GONE";
function Dy(e, t) {
  const n = e == null ? void 0 : e.detail;
  if (n)
    try {
      const a = JSON.parse(n);
      return a && typeof a == "object" ? a[t] : void 0;
    } catch {
      return;
    }
}
function qfe(e) {
  return Dy(e, "code") === EP;
}
function Wfe(e) {
  return Dy(e, "code") === zP;
}
function Yfe(e) {
  const t = Dy(e, "limit");
  return typeof t == "number" && t > 0 ? t : null;
}
function MP(e, t) {
  const n = e.replace(/\/+$/, ""), a = (l) => `${n}/${encodeURIComponent(l)}`;
  async function i(l, c = {}) {
    const p = await t.request(l, {
      ...c,
      headers: { "Content-Type": "application/json", ...c.headers ?? {} }
    }), m = await p.text().catch(() => "");
    let v = null;
    if (m)
      try {
        v = JSON.parse(m);
      } catch {
        v = null;
      }
    return { status: p.status, body: v, text: m };
  }
  function r(l, c) {
    throw fa(l, c, t.locale);
  }
  return {
    /**
     * New document, as a draft (the New document dialog's request): the same
     * body as `action=newfile`, answered with the same fields — `path` is the
     * draft's — plus the draft itself. A refusal throws; DRAFT_LIMIT is the
     * one the dialog says in its own words (isDraftLimit).
     */
    async create(l, c, p, m = {}) {
      var x;
      const v = await i(n, {
        method: "POST",
        body: JSON.stringify(m.exactName ? { path: l, name: c, type: p, exact_name: !0 } : { path: l, name: c, type: p })
      });
      return (v.status !== 201 || !((x = v.body) != null && x.draft)) && r(v.status, v.text), v.body;
    },
    /** Every draft of the caller's, across every storage they can see. */
    async list() {
      const l = await i(n);
      return (l.status !== 200 || !l.body) && r(l.status, l.text), { drafts: l.body.drafts ?? [], count: l.body.count ?? 0, limit: l.body.limit ?? 0 };
    },
    /** How many — the navigation panel's badge. */
    async count() {
      const l = await i(`${n}/count`);
      return (l.status !== 200 || !l.body) && r(l.status, l.text), { count: l.body.count ?? 0, limit: l.body.limit ?? 0 };
    },
    /** One draft — what an editor on a draft's path asks. */
    async get(l) {
      const c = await i(a(l));
      return (c.status !== 200 || !c.body) && r(c.status, c.text), c.body;
    },
    /**
     * Save the draft where it is meant to go — under `as` when given (only
     * ever the `suggested` name a taken answer offered).
     */
    async save(l, c) {
      var m, v;
      const p = await i(`${a(l)}/save`, { method: "POST", body: JSON.stringify(c ? { as: c } : {}) });
      if (p.status === 200 && ((m = p.body) != null && m.path))
        return { saved: !0, path: p.body.path, name: p.body.name ?? "", targetDir: p.body.target_dir ?? "" };
      if (p.status === 409 && ((v = p.body) == null ? void 0 : v.code) === CP && p.body.suggested)
        return {
          saved: !1,
          taken: !0,
          name: p.body.name ?? "",
          suggested: p.body.suggested,
          targetDir: p.body.target_dir ?? ""
        };
      r(p.status, p.text);
    },
    /** Discard it: the draft goes to the trash (restorable until it ages out). */
    async discard(l) {
      const c = await i(a(l), { method: "DELETE" });
      c.status !== 200 && r(c.status, c.text);
    }
  };
}
function O2(e) {
  const t = e.indexOf("://"), n = t >= 0 ? e.slice(0, t) : "", a = (t >= 0 ? e.slice(t + 3) : e).replace(/^\/+|\/+$/g, "");
  return [n, ...a.split("/").filter(Boolean)].filter(Boolean).join(" / ");
}
const PP = "X-Filex-Text-Dialect", L2 = [",", ";", "	", "|"], D2 = /^[a-z0-9_-]{1,40}$/i;
function OP(e) {
  if (!e) return;
  let t;
  try {
    t = JSON.parse(e);
  } catch {
    return;
  }
  const n = t;
  if (!(!n || typeof n != "object" || typeof n.delimiter != "string" || !L2.includes(n.delimiter) || typeof n.bom != "boolean" || typeof n.crlf != "boolean" || typeof n.encoding != "string" || !D2.test(n.encoding)))
    return { delimiter: n.delimiter, bom: n.bom, crlf: n.crlf, encoding: n.encoding.toLowerCase() };
}
function LP(e, t) {
  try {
    return new TextDecoder(t).decode(e);
  } catch {
    return new TextDecoder().decode(e);
  }
}
function R2(e) {
  if (e == null) return;
  if (typeof e != "object" || Array.isArray(e)) return null;
  const t = e, n = {};
  if (t.delimiter !== void 0) {
    if (typeof t.delimiter != "string" || !L2.includes(t.delimiter)) return null;
    n.csv_delimiter = t.delimiter;
  }
  if (t.encoding !== void 0) {
    if (typeof t.encoding != "string" || !D2.test(t.encoding)) return null;
    n.csv_encoding = t.encoding;
  }
  if (t.bom !== void 0) {
    if (typeof t.bom != "boolean") return null;
    n.csv_bom = t.bom ? "1" : "0";
  }
  if (t.eol !== void 0) {
    if (t.eol !== "crlf" && t.eol !== "lf") return null;
    n.csv_eol = t.eol;
  }
  return n;
}
const DP = "/api/files/pdf";
function RP(e) {
  return /\.pdf$/i.test(e);
}
function NP(e, t) {
  const n = t.slice(t.lastIndexOf("/") + 1);
  return `${e.replace(/\/+$/, "")}/${encodeURIComponent(n)}?${new URLSearchParams({ path: t }).toString()}`;
}
const IP = ["zero", "one", "two", "few", "many", "other"], n_ = ["one", "other"], a_ = /* @__PURE__ */ new Map();
function N2(e) {
  const t = String(e ?? ""), n = a_.get(t);
  if (n !== void 0) return n;
  let a = null;
  if (typeof Intl < "u" && typeof Intl.PluralRules == "function")
    try {
      a = new Intl.PluralRules(t || "en");
    } catch {
      try {
        a = new Intl.PluralRules("en");
      } catch {
        a = null;
      }
    }
  return a_.set(t, a), a;
}
const i_ = /* @__PURE__ */ new Map(), BP = 999;
function FP(e) {
  const t = String(e ?? ""), n = i_.get(t);
  if (n) return n;
  let a = n_;
  const i = N2(t);
  if (i)
    try {
      const r = /* @__PURE__ */ new Set(["other"]);
      for (let l = 0; l <= BP; l++) r.add(i.select(l));
      a = IP.filter((l) => r.has(l));
    } catch {
      a = n_;
    }
  return i_.set(t, a), a;
}
function Ry(e, t) {
  if (!Number.isFinite(t)) return "other";
  const n = Math.abs(t), a = N2(e);
  if (!a) return n === 1 ? "one" : "other";
  try {
    return a.select(n);
  } catch {
    return n === 1 ? "one" : "other";
  }
}
function Gfe(e, t, n) {
  const a = Math.abs(t), i = FP(e), r = Ry(e, a);
  if (n === i.length && n > 1) {
    const l = i.indexOf(r);
    return l >= 0 ? l : n - 1;
  }
  return n === 1 ? 0 : n === 2 ? r === "one" ? 0 : 1 : n === 3 ? a === 0 ? 0 : r === "one" ? 1 : 2 : n - 1;
}
function UP(e) {
  return e.includes(".") && e.replace(/[. ]/g, "") === "";
}
function HP(e) {
  return e !== "" && e.replace(/ /g, "") === "";
}
const KP = String.fromCodePoint(0), VP = new RegExp(
  "[" + String.fromCodePoint(1) + "-" + String.fromCodePoint(31) + String.fromCodePoint(127) + "]"
);
function Ny(e) {
  return e.replace(new RegExp("^\\p{White_Space}+|\\p{White_Space}+$", "gu"), "");
}
function I2(e) {
  return e === "" || HP(e) ? "empty" : e.includes("/") || e.includes("\\") ? "separator" : e.includes(KP) ? "nul" : VP.test(e) ? "control" : UP(e) ? "dots" : null;
}
const B2 = /* @__PURE__ */ new Set([
  1564,
  8206,
  8207,
  8234,
  8235,
  8236,
  8237,
  8238,
  8294,
  8295,
  8296,
  8297
]), xf = String.fromCodePoint(65533);
function jP(e) {
  return B2.has(e);
}
const F2 = new RegExp(
  "[" + [...B2].map((e) => String.fromCodePoint(e)).join("") + "]",
  "u"
);
function da(e) {
  if (!e || !F2.test(e)) return e;
  let t = "";
  for (const n of e)
    t += jP(n.codePointAt(0) ?? 0) ? xf : n;
  return t;
}
const qP = 8294, WP = 8295, YP = 8296, GP = 8297;
function XP(e) {
  return e >= 8234 && e <= 8238;
}
function U2(e) {
  if (!e || !F2.test(e)) return e;
  const t = [...e], n = [];
  for (let a = 0; a < t.length; a++) {
    const i = t[a].codePointAt(0) ?? 0;
    XP(i) ? t[a] = xf : i === qP || i === WP || i === YP ? n.push(a) : i === GP && (n.length ? n.pop() : t[a] = xf);
  }
  for (const a of n) t[a] = xf;
  return t.join("");
}
const JP = Object.freeze([
  "viewer",
  "host",
  "account",
  "device"
]);
function H2(e) {
  for (const t of JP) {
    if (t === "device") break;
    const n = e[t];
    if (typeof n == "string" && n && ns(n)) return { zone: n, tier: t };
  }
  return { zone: void 0, tier: "device" };
}
const Ju = "filex.timezone.viewer", Jf = "filex.timezone", ZP = [
  "UTC",
  "Europe/Istanbul",
  "Europe/London",
  "Europe/Berlin",
  "Europe/Paris",
  "Europe/Madrid",
  "Europe/Moscow",
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "America/Sao_Paulo",
  "Africa/Cairo",
  "Africa/Lagos",
  "Asia/Dubai",
  "Asia/Karachi",
  "Asia/Kolkata",
  "Asia/Shanghai",
  "Asia/Tokyo",
  "Asia/Seoul",
  "Asia/Singapore",
  "Australia/Sydney",
  "Pacific/Auckland"
];
function K2() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
}
function ns(e) {
  if (!e) return !1;
  try {
    return new Intl.DateTimeFormat("en-US", { timeZone: e }), !0;
  } catch {
    return !1;
  }
}
function Xfe() {
  try {
    const e = Intl.supportedValuesOf;
    if (typeof e == "function") {
      const t = e("timeZone");
      if (Array.isArray(t) && t.length)
        return t.includes("UTC") ? [...t] : ["UTC", ...t];
    }
  } catch {
  }
  return [...ZP];
}
function o_(e, t) {
  const n = t ?? QP();
  try {
    const a = new Intl.DateTimeFormat("en-CA", {
      timeZone: n,
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    }).formatToParts(e), i = (p) => {
      var m;
      return Number((m = a.find((v) => v.type === p)) == null ? void 0 : m.value);
    }, r = i("year"), l = i("month"), c = i("day");
    if (!Number.isFinite(r) || !Number.isFinite(l) || !Number.isFinite(c))
      throw new Error("unparsable");
    return Math.floor(Date.UTC(r, l - 1, c) / 864e5);
  } catch {
    return Math.floor(
      Date.UTC(e.getFullYear(), e.getMonth(), e.getDate()) / 864e5
    );
  }
}
function Zu(e) {
  try {
    const t = localStorage.getItem(e);
    return t && ns(t) ? t : "";
  } catch {
    return "";
  }
}
function V2(e, t) {
  try {
    t ? localStorage.setItem(e, t) : localStorage.removeItem(e);
  } catch {
  }
}
const Iy = typeof window < "u", Hr = S(Iy ? Zu(Ju) : "");
function j2() {
  const e = S([]);
  return {
    set(t, n) {
      const a = e.value.find((i) => i.owner === t);
      if (n === null) {
        a && (e.value = e.value.filter((i) => i !== a));
        return;
      }
      a && a.zone === n || (e.value = [...e.value.filter((i) => i.owner !== t), { owner: t, zone: n }]);
    },
    of(t) {
      var n;
      return ((n = e.value.find((a) => a.owner === t)) == null ? void 0 : n.zone) ?? null;
    },
    current() {
      const t = e.value;
      return t.length ? t[t.length - 1].zone : "";
    },
    /** The newest answer among the owners `pick` accepts. */
    currentWhere(t) {
      const n = e.value.filter((a) => t(a.owner));
      return n.length ? n[n.length - 1].zone : "";
    }
  };
}
const Lc = j2(), wo = j2(), Cp = /* @__PURE__ */ new Set(), By = A(
  () => H2({
    viewer: Hr.value,
    host: Lc.current(),
    account: wo.current()
  })
);
function QP() {
  return By.value.zone;
}
function Jfe() {
  return By.value;
}
const q2 = Symbol("filex-explorer-clock");
function eO(e) {
  return e ? {
    viewer: Hr.value,
    host: Lc.of(e) ?? "",
    account: wo.of(e) ?? wo.currentWhere((t) => Cp.has(t))
  } : nO();
}
function tO(e) {
  return e ? H2(eO(e)) : By.value;
}
function W2(e) {
  return tO(e).zone;
}
function nO() {
  return {
    viewer: Hr.value,
    host: Lc.current(),
    account: wo.current()
  };
}
function Zfe() {
  return Hr.value;
}
function aO(e) {
  const t = e && ns(e) ? e : "";
  Hr.value = t, V2(Ju, t);
  try {
    window.dispatchEvent(new CustomEvent("filex:timezone", { detail: t }));
  } catch {
  }
}
function iO(e, t) {
  Lc.set(e, t && ns(t) ? t : null);
}
function Sf(e, t, n = {}) {
  if (t == null) {
    wo.set(e, null);
    return;
  }
  const a = t && ns(t) ? t : "";
  wo.set(e, a), n.remember && (Cp.add(e), V2(Jf, a));
}
function oO(e) {
  return wo.of(e);
}
function rO(e) {
  return {
    get: () => oO(e) ?? "",
    set: (t) => {
      Sf(e, t && ns(t) ? t : "", { remember: !0 }), aO("");
    }
  };
}
function Qfe() {
  return Iy ? Zu(Jf) : "";
}
function sO(e) {
  Lc.set(e, null), wo.set(e, null), Cp.delete(e);
}
if (Iy)
  try {
    window.addEventListener("storage", (e) => {
      if ((e.key === null || e.key === Ju) && (Hr.value = Zu(Ju)), e.key === null || e.key === Jf) {
        const t = Zu(Jf);
        for (const n of Cp) wo.set(n, t);
      }
    }), window.addEventListener("filex:timezone", (e) => {
      const t = e.detail;
      Hr.value = typeof t == "string" ? t && ns(t) ? t : "" : Zu(Ju);
    });
  } catch {
  }
const r_ = /* @__PURE__ */ new Map();
function gi(e) {
  if (!e || e === "en") return "en-US";
  if (e === "tr") return "tr-TR";
  let t = r_.get(e);
  if (!t) {
    try {
      t = Intl.getCanonicalLocales(e)[0] || "en-US";
    } catch {
      t = "en-US";
    }
    r_.set(e, t);
  }
  return t;
}
const s_ = [
  "unit.bytes",
  "unit.kb",
  "unit.mb",
  "unit.gb",
  "unit.tb",
  "unit.pb"
], lO = {
  "unit.bytes": "B",
  "unit.kb": "KB",
  "unit.mb": "MB",
  "unit.gb": "GB",
  "unit.tb": "TB",
  "unit.pb": "PB"
};
function uO(e, t = {}) {
  const n = t.empty ?? "-";
  if (e == null || !Number.isFinite(e) || e < 0) return n;
  const a = t.base ?? 1e3, i = t.unit ?? ((m) => lO[m]);
  let r = 0, l = e;
  for (; l >= a && r < s_.length - 1; )
    l /= a, r += 1;
  const c = r === 0 ? 0 : t.digits === "fixed1" ? 1 : l < 10 ? 2 : 1;
  let p;
  if (t.numberLocale == null)
    p = l.toFixed(c);
  else {
    const m = cO(t.numberLocale, c, t.digits === "fixed1" ? c : 0);
    p = m ? m.format(l) : l.toFixed(c);
  }
  return `${p} ${i(s_[r])}`;
}
const lf = /* @__PURE__ */ new Map();
function cO(e, t, n) {
  const a = `${e}|${t}|${n}`;
  if (!lf.has(a))
    try {
      lf.set(a, new Intl.NumberFormat(e, {
        maximumFractionDigits: t,
        minimumFractionDigits: n
      }));
    } catch {
      lf.set(a, null);
    }
  return lf.get(a) ?? null;
}
const l_ = /* @__PURE__ */ new Map();
function Y2(e, t, n) {
  const a = W2(n), i = `${e}|${a ?? `device:${K2()}`}|${JSON.stringify(t)}`;
  let r = l_.get(i);
  return r || (r = new Intl.DateTimeFormat(e, { ...t, timeZone: a }), l_.set(i, r)), r;
}
function Zf(e, t, n, a) {
  try {
    return Y2(gi(t), n, a).format(e);
  } catch {
    return e.toISOString();
  }
}
const dO = /^(\d{4})-(\d{2})-(\d{2})$/, u_ = /* @__PURE__ */ new Map();
function fO(e, t) {
  const n = dO.exec(e.trim());
  if (!n) return "";
  const a = new Date(Date.UTC(Number(n[1]), Number(n[2]) - 1, Number(n[3])));
  if (Number.isNaN(a.getTime())) return "";
  const i = gi(t);
  let r = u_.get(i);
  try {
    return r || (r = new Intl.DateTimeFormat(i, { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" }), u_.set(i, r)), r.format(a);
  } catch {
    return "";
  }
}
function $f(e) {
  if (!e) return null;
  const t = new Date(e * (e < 1e12 ? 1e3 : 1));
  return Number.isNaN(t.getTime()) ? null : t;
}
function G2(e) {
  if (e == null || e === "") return null;
  if (e instanceof Date) return Number.isNaN(e.getTime()) ? null : e;
  if (typeof e == "number") return $f(e);
  const t = new Date(e);
  return Number.isNaN(t.getTime()) ? null : t;
}
const pO = { month: "short", day: "numeric", year: "numeric" }, hO = { timeStyle: "short" };
function X2(e, t, n = {}, a) {
  const i = G2(e);
  if (!i) return "";
  const r = Zf(i, t, pO, a);
  return n.time ? `${r}, ${Zf(i, t, hO, a)}` : r;
}
function mO(e, t, n) {
  const a = G2(e);
  if (!a) return "";
  const i = W2(n) ?? K2();
  return `${Zf(a, t, { dateStyle: "full", timeStyle: "long" }, n)} (${i})`;
}
const J2 = Symbol("filex-explorer-locale"), vO = ["count", "n", "days"];
function c_(e, t, n, a = "en") {
  const i = vO.find((c) => c in t);
  if (i === void 0) return e;
  const r = Ry(a, Number(t[i]));
  if (r === "other") return e;
  const l = `${e}_${r}`;
  return n(l) ? l : e;
}
function Vs(e, t) {
  const n = e[t];
  return typeof n == "string" && n ? n : void 0;
}
function yO(e, t, n = {}) {
  const a = e.strings, i = c_(t, n, (c) => Vs(a, c) !== void 0, e.lang), r = Vs(a, i) ?? Vs(a, t);
  if (r !== void 0) return r;
  if (a === el) return t;
  const l = c_(t, n, (c) => Vs(el, c) !== void 0, "en");
  return Vs(el, l) ?? Vs(el, t) ?? t;
}
function gO(e) {
  if (e.trashed) return !0;
  const t = e.extra_metadata;
  return t && typeof t == "object" && "deleted_at" in t ? !0 : typeof e.path == "string" && /(^|[/:])\.trash\//.test(e.path);
}
function d_(e, t) {
  return Object.entries(t).reduce(
    (n, [a, i]) => n.replaceAll(`{${a}}`, String(i)),
    e
  );
}
function Z2(e, t, n, a) {
  const i = yO(e, t, n), r = {};
  for (const [c, p] of Object.entries(n)) r[c] = typeof p == "string" ? U2(p) : p;
  if (!a) return d_(i, r);
  const l = {};
  for (const [c, p] of Object.entries(r)) l[c] = typeof p == "string" ? SP(p) : p;
  return E2(d_(i, l));
}
function epe(e, t, n = {}) {
  return Z2(g2(e), t, n, kl(e) === "rtl");
}
function ht(e) {
  const t = () => typeof e == "function" ? e() : e.value, n = A(() => (oi.value, g2(t()))), a = Zo() ? bi(q2, void 0) : void 0, i = A(() => kl(t()));
  function r(b, C = {}) {
    return Z2(n.value, b, C, i.value === "rtl");
  }
  r.foreign = (b) => Yi(t(), b);
  function l(b) {
    return uO(b, {
      unit: (C) => r(C),
      numberLocale: gi(t())
    });
  }
  function c(b) {
    return b ? b.size_partial ? typeof b.size == "number" && b.size > 0 ? r("size.at_least", { size: l(b.size) }) : "-" : l(b.size) : l(null);
  }
  function p(b) {
    if (b != null && b.size_partial)
      return typeof b.size == "number" && b.size > 0 ? r("size.partial_hint") : r("size.unknown_hint");
  }
  function m(b) {
    return b.basename === ".trash" ? r("node.trash") : da(v(b));
  }
  function v(b) {
    if (b.basename === ".trash") return r("node.trash");
    if (typeof b.fxe_name == "string" && b.fxe_name) return b.fxe_name;
    if (gO(b)) {
      const C = b.basename.match(/^\d{8}-\d{6}-[A-Za-z0-9]+__(.+)$/);
      if (C) return C[1];
    }
    return b.basename;
  }
  function x(b, C = {}) {
    return X2(b, t(), C, a);
  }
  function w(b) {
    return mO(b, t(), a);
  }
  function $(b) {
    const C = b instanceof Date ? b : $f(b);
    return C ? Zf(C, t(), { month: "long", year: "numeric" }, a) : "";
  }
  function k(b) {
    const C = b instanceof Date ? b : $f(b);
    if (!C) return "";
    try {
      return Y2("en-CA", { year: "numeric", month: "2-digit" }, a).format(C);
    } catch {
      return `${C.getFullYear()}-${String(C.getMonth() + 1).padStart(2, "0")}`;
    }
  }
  return {
    t: r,
    formatSize: l,
    formatNodeSize: c,
    nodeSizeHint: p,
    formatDate: x,
    formatDateFull: w,
    formatMonthYear: $,
    zonedYearMonth: k,
    /**
     * zaman:z1 — the wire's `last_modified` as a `Date`, or null.
     *
     * Handed out because "seconds or milliseconds" is a fact about the WIRE,
     * not about formatting, and every caller that needs the instant itself
     * (rather than a string) was otherwise re-typing `v * (v < 1e12 ? 1000 :
     * 1)`. ListView had the third copy and used it to group rows by day — so
     * the grouping and the cell four pixels away were reading the same number
     * through two different converters.
     */
    toDate: $f,
    nodeDisplayName: m,
    nodeName: v,
    /**
     * ⚠ RTL — which way this surface's language is written (`lib/direction`,
     * the server's one list). Bind it as `dir` on anything Teleported out of
     * the explorer's root: under `<body>` a menu inherits the HOST page's
     * direction, not the language its own words are in.
     */
    dir: i
  };
}
const Kr = S(0), lc = S(0), bO = A(() => Kr.value !== 0), tpe = A(() => Kr.value), npe = A(() => lc.value), kO = 3e3;
let uc = 0;
function f_(e = Date.now()) {
  uc = e || 1;
}
function wO() {
  uc = 0;
}
typeof window < "u" && typeof window.addEventListener == "function" && (window.addEventListener("beforeunload", () => f_()), window.addEventListener("pagehide", () => f_()), window.addEventListener("pageshow", () => wO()));
function _O(e) {
  const t = e;
  return !t || typeof t != "object" ? !1 : t.name === "AbortError" || t.name === "CanceledError" || t.code === "ERR_CANCELED" ? !0 : t.code === "ECONNABORTED" && typeof t.message == "string" && /aborted/i.test(t.message);
}
function xO(e, t = Date.now()) {
  return _O(e) ? !0 : uc !== 0 && t - uc < kO;
}
function zv(e, t = Date.now(), n) {
  return xO(n, t) ? "folded" : (Kr.value === 0 && (Kr.value = t || 1), e === "background" ? (lc.value += 1, "folded") : "say");
}
function Mv() {
  Kr.value === 0 && lc.value === 0 || (Kr.value = 0, lc.value = 0);
}
function ape() {
  Kr.value = 0, lc.value = 0, uc = 0;
}
function SO(e) {
  const t = String(e ?? "get").toLowerCase();
  return t === "get" || t === "head" || t === "options" ? "background" : "action";
}
function Q2(e) {
  const t = e.apiBase != null ? e.apiBase.replace(/\/+$/, "") : null;
  function n(i, r) {
    return i || (t === null ? null : `${t}${r}`);
  }
  const a = e.endpoint ?? (t !== null ? `${t}/api/files/manager` : null);
  if (!a)
    throw new Error(
      "[@brftech/filex-core] config requires either `apiBase` or `endpoint`"
    );
  return {
    manager: a,
    // Staged (chunked + resumable) uploads — what useUploadChunked speaks on
    // every driver. The {id} routes are derived from this one.
    uploadBegin: n(e.uploadBegin, "/api/files/upload/begin"),
    shareCreate: n(e.shareCreate, "/api/files/share"),
    shareList: n(e.shareList, "/api/files/share"),
    shareDelete: n(e.shareDelete, "/api/files/share/{uuid}"),
    limits: n(e.limits, "/api/files/limits"),
    capabilities: n(e.capabilities, "/api/files/capabilities"),
    pdfPreview: n(e.pdfPreview, DP),
    me: n(e.me, "/api/auth/me"),
    archiveList: n(e.archiveList, "/api/files/archive/list"),
    archiveExtract: n(e.archiveExtract, "/api/files/archive/extract"),
    archiveCreate: n(e.archiveCreate, "/api/files/archive/create"),
    archiveAdd: n(e.archiveAdd, "/api/files/archive/add"),
    copy: n(e.copy, "/api/files/copy"),
    moveAsync: n(e.moveAsync, "/api/files/move"),
    deleteAsync: n(e.deleteAsync, "/api/files/delete"),
    opsList: n(e.opsList, "/api/files/ops"),
    opsShow: n(e.opsShow, "/api/files/ops/{id}"),
    onlyOfficeConfig: n(e.onlyOfficeConfig, "/api/files/onlyoffice/config"),
    saveText: n(e.saveText, "/api/files/save-text"),
    restore: n(e.restore, "/api/files/restore"),
    // filex trash: list soft-deleted nodes + restore one by node id.
    trashList: n(e.trashList, "/api/files/manager/trash"),
    trashRestore: n(e.trashRestore, "/api/files/manager/restore"),
    /* An operator's "Delete permanently" of one trash entry (`{id}`). */
    trashPurge: n(e.trashPurge, "/api/admin/trash/{id}"),
    /* An operator's permanent delete of a selection, in one request. */
    trashPurgeBatch: n(e.trashPurgeBatch, "/api/admin/trash/purge"),
    /* An operator's "Empty trash": POST starts it, GET follows it,
       `/preview` counts what it would delete. */
    trashEmpty: n(e.trashEmpty, "/api/admin/trash/empty"),
    /* An operator's hard delete of one version (`{id}`). */
    versionPurge: n(e.versionPurge, "/api/admin/versions/{id}"),
    /* wiring:e2 — escrow proof-of-possession, then the owner is told. */
    e2eEscrowChallenge: n(e.e2eEscrowChallenge, "/api/files/e2e/escrow/challenge"),
    e2eEscrowUsed: n(e.e2eEscrowUsed, "/api/files/e2e/escrow/used"),
    /* wiring:e2 convert — after a folder is encrypted in place. */
    e2eCleanup: n(e.e2eCleanup, "/api/files/e2e/cleanup"),
    /* wiring:e2 policy — may this account encrypt here, and asking for it. */
    e2eAllowed: n(e.e2eAllowed, "/api/files/e2e/allowed"),
    e2eRequests: n(e.e2eRequests, "/api/files/e2e/requests"),
    /* App plugins — docs/APP-PLUGINS-API.md. */
    pluginActions: n(e.pluginActions, "/api/files/plugins/actions"),
    pluginActionRun: n(e.pluginActionRun, "/api/files/plugins/actions/{plugin}/{action}/run"),
    pluginView: n(e.pluginView, "/api/files/plugins/views/{plugin}/{view}"),
    pluginViewEvent: n(e.pluginViewEvent, "/api/files/plugins/views/{plugin}/{view}/event"),
    pluginUsers: n(e.pluginUsers, "/api/files/plugins/users"),
    opsCancel: n(e.opsCancel, "/api/files/ops/{id}/cancel"),
    /* v4 — an app's own interface (AppFrame): its module, and its saves. */
    pluginUICall: n(e.pluginUICall, "/api/files/plugins/ui/{plugin}/{view}/call"),
    pluginUISave: n(e.pluginUISave, "/api/files/plugins/ui/{plugin}/{view}/save"),
    /* 0.54 - what an interface reads of its file, checked by the server (#211). */
    pluginUIRead: n(e.pluginUIRead, "/api/files/plugins/ui/{plugin}/{view}/read"),
    /* 0.56 - editing together (files:co-edit): the relay's routes (#189). */
    pluginUICoEdit: n(e.pluginUICoEdit, "/api/files/plugins/ui/{plugin}/{view}/coedit"),
    /* 0.52.0 - a paid app's license, as the app itself reads it (fx.license.get()). */
    pluginLicense: n(e.pluginLicense, "/api/files/plugins/license/{plugin}")
  };
}
const $O = ["allowed", "request", "denied"];
function TO(e) {
  return typeof e == "string" && $O.includes(e) ? e : "allowed";
}
async function AO(e) {
  if (typeof e == "function") {
    const t = e();
    return t instanceof Promise ? await t : t;
  }
  return e;
}
function EO(e) {
  return e ? "kind" in e ? e : e.type === "bearer" ? { kind: "bearer", token: e.token } : e.type === "csrf" ? { kind: "csrf", csrf: e.csrf } : { kind: "none" } : { kind: "none" };
}
const CO = 8 << 20;
function Rl(e, t = {}) {
  const n = Q2(e), a = EO(e.auth);
  let i = null;
  async function r(ae = {}) {
    const oe = { Accept: "application/json", ...ae };
    if (a.kind === "bearer") {
      const ze = await AO(a.token);
      ze && (oe.Authorization = `Bearer ${ze}`, i = ze);
    } else if (a.kind === "csrf")
      oe["X-CSRF-TOKEN"] = a.csrf, oe["X-Requested-With"] = "XMLHttpRequest";
    else if (a.kind === "basic") {
      const ze = btoa(`${a.user}:${a.pass}`);
      oe.Authorization = `Basic ${ze}`;
    }
    return oe;
  }
  function l(ae = {}) {
    const oe = { Accept: "application/json", ...ae };
    if (a.kind === "bearer") {
      const ze = typeof a.token == "string" ? a.token : i;
      ze && (oe.Authorization = `Bearer ${ze}`);
    } else if (a.kind === "csrf")
      oe["X-CSRF-TOKEN"] = a.csrf, oe["X-Requested-With"] = "XMLHttpRequest";
    else if (a.kind === "basic") {
      const ze = btoa(`${a.user}:${a.pass}`);
      oe.Authorization = `Basic ${ze}`;
    }
    return oe;
  }
  function c() {
    return a.kind === "csrf" ? "include" : "same-origin";
  }
  const p = () => {
    var ae;
    return ((ae = t.screenLocale) == null ? void 0 : ae.call(t)) ?? Wi(e.locale);
  };
  async function m(ae, oe = {}) {
    const ze = await v(ae, oe);
    if (!ze.ok) {
      const it = await ze.text().catch(() => "");
      throw fa(ze.status, it, p());
    }
    if (ze.status === 204 || ze.status === 205) return;
    const Ke = await ze.text();
    if (Ke)
      return JSON.parse(Ke);
  }
  async function v(ae, oe = {}) {
    const ze = {
      // ⚠⚠ The language on SCREEN, not the one the browser was installed in.
      // Everything the server writes for a person — a plugin's surface, the
      // labels inside it, the message on a queued job — is rendered with the
      // request's `Accept-Language`. Chrome sends `en-US` whatever filex is
      // set to, so a Turkish window asked a signing wizard for its screens
      // and got "Identity" and an English help line in the middle of Turkish
      // ones. The window's own language is the only right answer here.
      "Accept-Language": gi(p()),
      ...await r(),
      ...oe.headers ?? {}
    };
    let Ke;
    try {
      Ke = await fetch(ae, {
        ...oe,
        headers: ze,
        credentials: c()
      });
    } catch (it) {
      throw (it == null ? void 0 : it.name) === "AbortError" ? it : (zv(SO(oe.method), Date.now(), it), Cv(p(), it));
    }
    return Mv(), Ke;
  }
  const x = n.manager.replace(/\/manager(\?.*)?$/, "/drafts"), w = MP(x, {
    request: v,
    get locale() {
      return p();
    }
  });
  function $(ae = "") {
    return n.manager.replace(/\/manager(\?.*)?$/, "/permissions") + ae;
  }
  async function k(ae) {
    return m($() + "?path=" + encodeURIComponent(ae));
  }
  async function b(ae) {
    return m($("/resolve") + "?email=" + encodeURIComponent(ae));
  }
  async function C(ae) {
    return m($("/users") + "?q=" + encodeURIComponent(ae));
  }
  async function T(ae) {
    try {
      return await m($("/groups") + "?q=" + encodeURIComponent(ae));
    } catch {
      return { groups: [] };
    }
  }
  async function E(ae, oe) {
    return m($("/groups/" + ae), { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ level: oe }) });
  }
  async function R(ae) {
    return m($("/groups/" + ae), { method: "DELETE" });
  }
  async function z(ae) {
    return m($(), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(ae) });
  }
  async function D(ae, oe) {
    return m($("/" + ae), { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ level: oe }) });
  }
  async function U(ae) {
    return m($("/" + ae), { method: "DELETE" });
  }
  async function H(ae) {
    return m($("/invite"), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(ae) });
  }
  async function L(ae) {
    return m($("/share-mail"), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(ae) });
  }
  async function P(ae, oe) {
    const ze = new URLSearchParams({ share: ae });
    return oe && ze.set("lang", oe), m($("/share-message") + "?" + ze.toString());
  }
  function K(ae) {
    const oe = new URLSearchParams();
    for (const [ze, Ke] of Object.entries(ae))
      Ke != null && oe.set(ze, String(Ke));
    return oe.toString();
  }
  function N(ae, oe = {}) {
    const ze = n.manager.includes("?") ? "&" : "?";
    return `${n.manager}${ze}${K({ q: ae, action: ae, ...oe })}`;
  }
  async function J(ae) {
    return m(N("index", { path: $v(ae) }));
  }
  async function j(ae, oe, ze) {
    return m(N("search", { ...ze ?? {}, path: $v(ae), filter: oe }));
  }
  async function re(ae, oe = {}) {
    return (await q(ae, oe)).hits;
  }
  async function q(ae, oe = {}) {
    const ze = n.manager.replace(/\/manager(\?.*)?$/, "/search"), Ke = ze.includes("?") ? "&" : "?", it = `${ze}${Ke}${K({ ...oe.narrow ?? {}, q: ae, limit: oe.limit, scope: oe.scope })}`, Z = await m(it);
    return {
      hits: Array.isArray(Z == null ? void 0 : Z.results) ? Z.results : [],
      truncated: typeof (Z == null ? void 0 : Z.truncated) == "boolean" ? Z.truncated : void 0,
      total: typeof (Z == null ? void 0 : Z.total) == "number" ? Z.total : void 0
    };
  }
  async function le(ae, oe, ze) {
    const Ke = n.manager.replace(/\/manager(\?.*)?$/, "/search/match"), it = await m(Ke, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ q: ae, names: oe }),
      signal: ze
    });
    return Array.isArray(it == null ? void 0 : it.matches) ? it.matches : [];
  }
  async function ve() {
    const ae = n.manager.replace(/\/manager(\?.*)?$/, "/quota/me");
    try {
      const oe = await m(ae);
      return oe && typeof oe.used_bytes == "number" ? oe : null;
    } catch {
      return null;
    }
  }
  async function ce() {
    const ae = n.manager.replace(/\/manager(\?.*)?$/, "/quota/storages");
    try {
      const oe = await m(ae);
      return Array.isArray(oe == null ? void 0 : oe.storages) ? oe.storages : null;
    } catch {
      return null;
    }
  }
  async function se() {
    const ae = n.manager.replace(/\/api\/files\/manager(\?.*)?$/, "").replace(/\/$/, "");
    try {
      const oe = await m(`${ae}/api/app-store`);
      return {
        visible: (oe == null ? void 0 : oe.visible) === !0,
        stores: Array.isArray(oe == null ? void 0 : oe.stores) ? oe.stores.filter((ze) => typeof ze == "string") : []
      };
    } catch {
      return null;
    }
  }
  async function fe(ae) {
    return m(N("subfolders", { path: ae }));
  }
  async function _(ae, oe) {
    return m(N("newfolder"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: ae, name: oe })
    });
  }
  async function ee(ae, oe, ze, Ke = {}) {
    return m(N("newfile"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(Ke.exactName ? { path: ae, name: oe, type: ze, exact_name: !0 } : { path: ae, name: oe, type: ze })
    });
  }
  async function Y(ae, oe, ze) {
    return m(N("newfile"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: ae, name: oe, type: ze, exact_name: !0, dry_run: !0 })
    });
  }
  async function B(ae, oe, ze) {
    return m(N("rename"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: ae, item: oe, name: ze })
    });
  }
  async function W(ae, oe, ze) {
    return m(N("rename", { queued: 1 }), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: ae, item: oe, name: ze })
    });
  }
  async function F(ae, oe, ze) {
    return m(N("move"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: ae, item: ze, items: oe.map((Ke) => ({ path: Ke })) })
    });
  }
  async function V(ae, oe) {
    return m(N("delete"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: ae, items: oe.map((ze) => ({ path: ze })) })
    });
  }
  async function ke(ae, oe) {
    const ze = [];
    for (let Ke = 0; Ke < ae.length; Ke += 1e3) {
      const it = ae.slice(Ke, Ke + 1e3), Z = await m(N("allowed"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ permissions: oe, items: it.map((Q) => ({ path: Q })) })
      });
      it.forEach((Q, we) => {
        var Ye;
        return ze.push(((Ye = Z.allowed) == null ? void 0 : Ye[we]) ?? []);
      });
    }
    return ze;
  }
  async function qe(ae, oe) {
    if (!n.copy) throw new Error("copy endpoint not configured");
    return m(n.copy, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: ae, target: oe })
    });
  }
  async function Me(ae, oe, ze, Ke, it) {
    const Z = ae === "copy" ? n.copy : n.moveAsync;
    if (!Z) throw new Error(`${ae} endpoint not configured`);
    return m(Z, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: [oe], target: ze, name: Ke, ...it ? { sourceDir: it } : {} })
    });
  }
  async function Fe(ae, oe, ze) {
    if (!n.moveAsync) throw new Error("moveAsync endpoint not configured");
    return m(n.moveAsync, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: ae, target: oe, sourceDir: ze })
    });
  }
  async function We(ae, oe) {
    if (!n.deleteAsync) throw new Error("deleteAsync endpoint not configured");
    return m(n.deleteAsync, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: ae, sourceDir: oe })
    });
  }
  async function $t(ae) {
    if (!n.restore) throw new Error("restore endpoint not configured");
    return m(n.restore, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: ae })
    });
  }
  async function St(ae) {
    if (!n.trashRestore) throw new Error("trashRestore endpoint not configured");
    const oe = n.trashRestore.includes("?") ? "&" : "?", ze = await m(
      ge(`${n.trashRestore}${oe}queued=1`),
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ node_ids: ae })
      }
    );
    return { ops: ze.ops ?? [], summary: ze.summary ?? "" };
  }
  async function at(ae, oe = {}) {
    if (!n.trashList) throw new Error("trashList endpoint not configured");
    const ze = [];
    ae && ze.push(`storage=${encodeURIComponent(ae)}`), oe.limit && ze.push(`limit=${oe.limit}`), oe.offset && ze.push(`offset=${oe.offset}`);
    const Ke = n.trashList, it = ze.length ? `${Ke}${Ke.includes("?") ? "&" : "?"}${ze.join("&")}` : Ke;
    return m(ge(it));
  }
  async function kt(ae) {
    const oe = n.trashRestore;
    if (!oe) throw new Error("trashRestore endpoint not configured");
    return m(ge(oe), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ node_ids: ae })
    });
  }
  async function pt(ae, oe = {}) {
    const ze = n.trashPurgeBatch;
    if (!ze) throw new Error("trashPurgeBatch endpoint not configured");
    const Ke = oe.queued ? `${ze}${ze.includes("?") ? "&" : "?"}queued=1` : ze;
    return m(ge(Ke), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ node_ids: ae })
    });
  }
  async function Ne() {
    const ae = n.trashEmpty;
    if (!ae) throw new Error("trashEmpty endpoint not configured");
    return m(ge(`${ae.replace(/\/+$/, "")}/preview`));
  }
  async function ie(ae, oe = {}) {
    const ze = n.trashPurge;
    if (!ze) throw new Error("trashPurge endpoint not configured");
    let Ke = ze.replace("{id}", encodeURIComponent(String(ae)));
    oe.queued && (Ke += `${Ke.includes("?") ? "&" : "?"}queued=1`);
    const it = await m(Ke, { method: "DELETE" });
    return it != null && it.op ? { op: it.op } : {};
  }
  async function xe(ae) {
    const oe = n.versionPurge;
    if (!oe) throw new Error("versionPurge endpoint not configured");
    await m(oe.replace("{id}", encodeURIComponent(String(ae))), { method: "DELETE" });
  }
  async function he(ae, oe, ze, Ke) {
    const it = new FormData();
    it.append("path", ae);
    for (const [Q, we] of Object.entries(Ke ?? {})) it.append(Q, we);
    for (const Q of oe)
      it.append("file[]", Q, Q.name);
    for (const Q of oe)
      it.append("name[]", Q.name);
    const Z = await r();
    return new Promise((Q, we) => {
      const Ye = new XMLHttpRequest();
      Ye.open("POST", N("upload"));
      for (const [rt, vt] of Object.entries(Z))
        rt !== "Content-Type" && Ye.setRequestHeader(rt, vt);
      Ye.withCredentials = c() === "include", Ye.upload.onprogress = (rt) => {
        ze && rt.lengthComputable && ze(Math.round(rt.loaded / rt.total * 100));
      }, Ye.onload = () => {
        if (Mv(), Ye.status >= 200 && Ye.status < 300)
          try {
            Q(JSON.parse(Ye.responseText));
          } catch (rt) {
            we(rt);
          }
        else
          we(fa(Ye.status, Ye.responseText || "", p()));
      }, Ye.onerror = () => {
        zv("action"), we(Cv(p()));
      }, Ye.send(it);
    });
  }
  function De(ae) {
    return N("download", { path: ae });
  }
  let ot = !!e.pdfPreview;
  function ft(ae) {
    return ot && n.pdfPreview && RP(ae) ? NP(n.pdfPreview, ae) : N("preview", { path: ae });
  }
  async function gt(ae, oe = {}) {
    const ze = await r(), Ke = await fetch(ft(ae), {
      headers: ze,
      credentials: c(),
      // ⚠ The preview endpoint answers `Cache-Control: private, max-age=60`,
      // which is right for the thing it was built for — a viewer re-opening
      // an image — and wrong for anything the client treats as CONTROL data.
      // `.filex-e2e.json` is control data: after the client rewrites it
      // (recovery upgrade, escrow slot, escrow refusal) the next read inside
      // that minute came back PRE-write, so the folder looked un-upgraded
      // and the question filex had just been answered was asked again.
      // Measured 2026-09-05 in a real browser: decline the escrow offer,
      // reopen the folder, and the offer was back.
      cache: oe.fresh ? "no-store" : "default"
    });
    if (!Ke.ok) {
      const we = await Ke.text().catch(() => "");
      throw fa(Ke.status, we, p());
    }
    const it = await Ke.blob(), Z = it.type || Ke.headers.get("content-type") || "";
    return { url: URL.createObjectURL(it), blob: it, mime: Z };
  }
  async function Ut(ae) {
    const oe = await r(), ze = await fetch(ft(ae), {
      headers: oe,
      credentials: c()
    });
    if (!ze.ok) {
      const Ke = await ze.text().catch(() => "");
      throw fa(ze.status, Ke, p());
    }
    return ze.arrayBuffer();
  }
  async function Xe() {
    return n.limits ? m(n.limits) : { max_upload_mb: 1024 };
  }
  async function Ve() {
    if (!n.capabilities)
      return {
        ffmpeg: !1,
        ghostscript: !1,
        max_chunk_mb: 5,
        upload_limit_mb: 1024,
        onlyoffice_url: e.onlyOfficeBase ?? null,
        drawio_url: e.drawioBase ?? null
      };
    const ae = await m(n.capabilities);
    return gP(ae), ae.pdf_preview === !0 && (ot = !0), ae;
  }
  async function Be() {
    var oe;
    if (!n.me) return null;
    const ae = await m(n.me);
    return !ae || !Array.isArray(ae.permissions) ? null : {
      admin: ((oe = ae.user) == null ? void 0 : oe.role) === "admin",
      permissions: [...ae.permissions, ...ae.permissions_in_folders ?? []],
      byFolder: ae.permissions_by_folder ?? []
    };
  }
  function ne(ae, oe) {
    return Object.entries(oe).reduce(
      (ze, [Ke, it]) => ze.replaceAll(`{${Ke}}`, encodeURIComponent(String(it))),
      ae
    );
  }
  function ge(ae) {
    return `${ae}${ae.includes("?") ? "&" : "?"}lang=${encodeURIComponent(p())}`;
  }
  function G(ae) {
    return /^https?:\/\//i.test(ae) ? ae : n.manager.replace(/\/api\/files\/manager(\?.*)?$/, "").replace(/\/$/, "") + (ae.startsWith("/") ? ae : `/${ae}`);
  }
  function ye() {
    return n.manager.replace(/\/api\/files\/manager(\?.*)?$/, "").replace(/\/$/, "") + "/_print/";
  }
  async function te(ae) {
    if (!n.pluginLicense) throw new Error("pluginLicense endpoint not configured");
    return m(ne(n.pluginLicense, { plugin: ae }));
  }
  async function Ce(ae, oe, ze) {
    if (!n.pluginUICall) throw new Error("pluginUICall endpoint not configured");
    return m(ge(ne(n.pluginUICall, { plugin: ae, view: oe })), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(ze)
    });
  }
  async function Ie(ae, oe, ze, Ke, it) {
    if (!n.pluginUISave) throw new Error("pluginUISave endpoint not configured");
    const Z = { ...(it == null ? void 0 : it.extra) ?? {}, ...R2(it == null ? void 0 : it.csv) ?? {} }, Q = Object.entries(Z).map(([be, Oe]) => `&${encodeURIComponent(be)}=${encodeURIComponent(Oe)}`).join(""), we = ("path" in ze ? `path=${encodeURIComponent(ze.path)}` : `dir=${encodeURIComponent(ze.dir)}&name=${encodeURIComponent(ze.name)}`) + Q, Ye = `${it != null && it.e2e ? "&e2e=1" : ""}${it != null && it.expect ? `&expect=${encodeURIComponent(it.expect)}` : ""}`, rt = ne(n.pluginUISave, { plugin: ae, view: oe }), vt = `${rt}${rt.includes("?") ? "&" : "?"}${we}${Ye}`, Bt = Pc("app_ui_save_chunk_bytes") ?? CO, Qt = (be, Oe) => m(be, { method: "PUT", headers: { "Content-Type": "application/octet-stream" }, body: Oe });
    if (Ke instanceof Blob && Ke.size <= Bt)
      return m(vt, {
        method: "PUT",
        headers: { "Content-Type": Ke.type || "application/octet-stream" },
        body: Ke
      });
    let en = "", Ot = 0;
    const kn = async (be, Oe) => {
      const st = en ? `${vt}&session=${encodeURIComponent(en)}&offset=${Ot}${Oe ? "&final=1" : ""}` : `${vt}&chunk=start${Oe ? "&final=1" : ""}`, tn = await Qt(st, be);
      return Oe || (en = tn.session ?? en, Ot = tn.received ?? Ot + be.size), tn;
    };
    if (Ke instanceof Blob)
      for (let be = 0; ; be += Bt) {
        const Oe = Math.min(be + Bt, Ke.size), st = Ke.slice(be, Oe);
        if (Oe >= Ke.size) return await kn(st, !0);
        await kn(st, !1);
      }
    const Pa = Ke.getReader();
    let un = [], pe = 0;
    for (; ; ) {
      const { done: be, value: Oe } = await Pa.read();
      for (Oe && Oe.byteLength && (un.push(Oe), pe += Oe.byteLength); pe >= Bt && !be; ) {
        const st = new Blob(un);
        await kn(st.slice(0, Bt), !1);
        const tn = new Uint8Array(await st.slice(Bt).arrayBuffer());
        un = tn.byteLength ? [tn] : [], pe = tn.byteLength;
      }
      if (be) {
        const st = new Blob(un);
        return !en && st.size <= Bt ? m(vt, { method: "PUT", headers: { "Content-Type": "application/octet-stream" }, body: st }) : await kn(st, !0);
      }
    }
  }
  async function _e(ae) {
    const oe = await r(), ze = await fetch(ft(ae), { headers: oe, credentials: c(), cache: "no-store" });
    if (!ze.ok) {
      const Ke = await ze.text().catch(() => "");
      throw fa(ze.status, Ke, p());
    }
    return ze;
  }
  async function Ae(ae, oe, ze, Ke) {
    if (!n.pluginUIRead) {
      if (Ke != null && Ke.e2e) throw new Error("pluginUIRead endpoint not configured");
      return _e(ze);
    }
    const it = ne(n.pluginUIRead, { plugin: ae, view: oe }), Z = await r(), Q = Ke != null && Ke.e2e ? "&e2e=1" : "", we = await fetch(`${it}${it.includes("?") ? "&" : "?"}path=${encodeURIComponent(ze)}${Q}`, {
      headers: Z,
      credentials: c(),
      cache: "no-store"
    });
    if (!we.ok) {
      const Ye = await we.text().catch(() => "");
      throw fa(we.status, Ye, p());
    }
    return we;
  }
  function Pe(ae, oe) {
    if (!n.pluginUICoEdit) throw new Error("pluginUICoEdit endpoint not configured");
    return ne(n.pluginUICoEdit, { plugin: ae, view: oe });
  }
  async function _t(ae, oe, ze, Ke = {}) {
    return m(`${Pe(ae, oe)}/join`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: ze, ...Ke })
    });
  }
  async function Et(ae, oe, ze, Ke, it, Z = {}) {
    const Q = `${Pe(ae, oe)}/${encodeURIComponent(ze)}/${Ke}`;
    return Z.keepalive === !0 && xn(Q, JSON.stringify(it)) ? {} : m(Q, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(it),
      keepalive: Z.keepalive === !0
    });
  }
  function xn(ae, oe) {
    if (a.kind !== "none") return !1;
    const ze = typeof navigator > "u" ? void 0 : navigator;
    if (typeof (ze == null ? void 0 : ze.sendBeacon) != "function") return !1;
    try {
      return ze.sendBeacon(ae, oe);
    } catch {
      return !1;
    }
  }
  function Dt(ae, oe, ze, Ke, it) {
    return `${Pe(ae, oe)}/${encodeURIComponent(ze)}/blob/${encodeURIComponent(Ke)}?client=${encodeURIComponent(it.client)}&token=${encodeURIComponent(it.token)}`;
  }
  async function bn(ae, oe, ze, Ke, it, Z) {
    await m(Dt(ae, oe, ze, Ke, it), {
      method: "PUT",
      headers: { "Content-Type": "application/octet-stream" },
      body: new Blob([Z])
    });
  }
  async function ln(ae, oe, ze, Ke, it) {
    const Z = await v(Dt(ae, oe, ze, Ke, it), { cache: "no-store" });
    if (!Z.ok) {
      const Q = await Z.text().catch(() => "");
      throw fa(Z.status, Q, p());
    }
    return Z.arrayBuffer();
  }
  async function Jt() {
    if (!n.pluginActions) return { actions: [], views: [] };
    const ae = await m(n.pluginActions);
    return {
      actions: (ae == null ? void 0 : ae.actions) ?? [],
      views: (ae == null ? void 0 : ae.views) ?? [],
      ...ae != null && ae.open_rules ? { open_rules: ae.open_rules } : {}
    };
  }
  async function Ln(ae, oe, ze) {
    if (!n.pluginActionRun) throw new Error("pluginActionRun endpoint not configured");
    return m(ge(ne(n.pluginActionRun, { plugin: ae, action: oe })), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(ze)
    });
  }
  async function Vn(ae, oe, ze, Ke) {
    if (!n.pluginView) throw new Error("pluginView endpoint not configured");
    const it = ne(n.pluginView, { plugin: ae, view: oe }), Z = [
      ze ? `path=${encodeURIComponent(ze)}` : "",
      Ke ? `section=${encodeURIComponent(Ke)}` : ""
    ].filter(Boolean);
    return m(ge(it + (Z.length ? `?${Z.join("&")}` : "")));
  }
  async function Ft(ae, oe, ze) {
    if (!n.pluginViewEvent) throw new Error("pluginViewEvent endpoint not configured");
    return m(ge(ne(n.pluginViewEvent, { plugin: ae, view: oe })), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(ze)
    });
  }
  async function na(ae, oe) {
    if (!n.pluginUsers) throw Object.assign(new Error("pluginUsers endpoint not configured"), { status: 404 });
    const ze = `${n.pluginUsers}?plugin=${encodeURIComponent(ae)}&q=${encodeURIComponent(oe)}`, Ke = await m(ze);
    return { users: (Ke == null ? void 0 : Ke.users) ?? [] };
  }
  async function Kt(ae) {
    if (!n.opsCancel) throw new Error("opsCancel endpoint not configured");
    await m(ne(n.opsCancel, { id: ae }), { method: "POST" });
  }
  async function bt(ae) {
    if (!n.e2eEscrowChallenge) throw new Error("e2e escrow endpoint not configured");
    return m(n.e2eEscrowChallenge, {
      method: "POST",
      body: JSON.stringify({ path: ae })
    });
  }
  async function Dn(ae) {
    if (!n.e2eEscrowUsed) throw new Error("e2e escrow endpoint not configured");
    return m(n.e2eEscrowUsed, {
      method: "POST",
      body: JSON.stringify(ae)
    });
  }
  async function Nn(ae, oe = 16) {
    const ze = { ...await r(), Range: `bytes=0-${oe - 1}` }, Ke = await fetch(ft(ae), { headers: ze, credentials: c(), cache: "no-store" });
    if (!Ke.ok) {
      const we = await Ke.text().catch(() => "");
      throw fa(Ke.status, we, p());
    }
    if (!Ke.body) return new Uint8Array(await Ke.arrayBuffer()).slice(0, oe);
    const it = Ke.body.getReader(), Z = new Uint8Array(oe);
    let Q = 0;
    try {
      for (; Q < oe; ) {
        const { done: we, value: Ye } = await it.read();
        if (we || !Ye) break;
        const rt = Math.min(Ye.length, oe - Q);
        Z.set(Ye.subarray(0, rt), Q), Q += rt;
      }
    } finally {
      it.cancel().catch(() => {
      });
    }
    return Z.slice(0, Q);
  }
  async function Cn(ae) {
    if (!n.e2eCleanup) throw new Error("e2e cleanup endpoint not configured");
    return m(n.e2eCleanup, { method: "POST", body: JSON.stringify(ae) });
  }
  async function fn(ae, oe = {}) {
    var it;
    const ze = n.e2eAllowed;
    if (!ze || !ae.length) return ae.map(() => "allowed");
    const Ke = [];
    try {
      for (let Z = 0; Z < ae.length; Z += 1e3) {
        const Q = ae.slice(Z, Z + 1e3), we = await m(ze, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: Q.map((Ye) => typeof Ye == "string" ? { path: Ye } : Ye.kind ? { path: Ye.path, kind: Ye.kind } : { path: Ye.path })
          })
        });
        Q.forEach((Ye, rt) => {
          var vt;
          return Ke.push(TO((vt = we == null ? void 0 : we.encrypt) == null ? void 0 : vt[rt]));
        });
      }
    } catch (Z) {
      return console.warn("[filex] could not ask who may encrypt here; offering encryption as before", Z), (it = oe.onFailed) == null || it.call(oe), ae.map(() => "allowed");
    }
    return Ke;
  }
  async function mn(ae) {
    if (!n.e2eRequests) throw new Error("e2e requests endpoint not configured");
    return m(n.e2eRequests, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(ae)
    });
  }
  async function aa(ae) {
    if (!n.shareCreate) throw new Error("shareCreate endpoint not configured");
    return m(n.shareCreate, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(ae)
    });
  }
  async function zn(ae) {
    if (!n.shareList) return { shares: [] };
    const oe = n.shareList.includes("?") ? "&" : "?";
    return m(`${n.shareList}${oe}path=${encodeURIComponent(ae)}`);
  }
  async function Mn(ae) {
    if (!n.shareDelete) throw new Error("shareDelete endpoint not configured");
    const oe = n.shareDelete.replace("{uuid}", encodeURIComponent(ae));
    return m(oe, { method: "DELETE" });
  }
  async function rn(ae, oe) {
    if (!n.archiveList) throw new Error("archiveList endpoint not configured");
    return {
      entries: (await m(
        n.archiveList,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ path: ae, password: oe })
        }
      )).entries.map((Ke) => ({
        name: Ke.name,
        size: Ke.size,
        isDir: Ke.is_dir,
        lastModified: Ke.mtime
      }))
    };
  }
  async function me(ae, oe = {}) {
    if (!n.archiveExtract) throw new Error("archiveExtract endpoint not configured");
    return m(n.archiveExtract, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: ae, ...oe })
    });
  }
  async function Le(ae) {
    if (!n.archiveCreate) throw new Error("archiveCreate endpoint not configured");
    return m(n.archiveCreate, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(ae)
    });
  }
  async function Ue(ae, oe) {
    if (!n.archiveAdd) throw new Error("archiveAdd endpoint not configured");
    return m(n.archiveAdd, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: ae, files: oe })
    });
  }
  function He(ae = "") {
    return n.manager.replace(/\/manager(\?.*)?$/, "/versions") + ae;
  }
  async function xt(ae) {
    const oe = await m(
      He() + "?node_id=" + encodeURIComponent(String(ae))
    );
    return Array.isArray(oe == null ? void 0 : oe.versions) ? oe.versions : [];
  }
  async function Qe(ae, oe, ze = !0) {
    await m(He("/restore"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        node_id: ae,
        version_id: oe,
        snapshot_current: ze
      })
    });
  }
  async function ue(ae) {
    await m(He("/snapshot"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ node_id: ae })
    });
  }
  function je(ae = "") {
    return n.manager.replace(/\/manager(\?.*)?$/, "/comments") + ae;
  }
  async function dt(ae) {
    const oe = await m(
      je() + "?node_id=" + encodeURIComponent(String(ae))
    );
    return Array.isArray(oe == null ? void 0 : oe.comments) ? oe.comments : [];
  }
  async function It(ae, oe) {
    return (await m(je(), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ node_id: ae, body: oe })
    })).comment;
  }
  async function hn(ae) {
    await m(je("/" + encodeURIComponent(String(ae))), {
      method: "DELETE"
    });
  }
  async function nn() {
    const ae = n.manager.replace(/\/manager(\?.*)?$/, "/ws-ticket");
    try {
      return await m(ae, { method: "POST" });
    } catch {
      return null;
    }
  }
  return {
    /** The language this client says things in (`FileApiOptions.screenLocale`). */
    screenLocale: p,
    // Realtime
    wsTicket: nn,
    // Manager
    index: J,
    search: j,
    globalSearch: re,
    globalSearchPage: q,
    matchNames: le,
    quotaMe: ve,
    storageUsage: ce,
    appStoreStatus: se,
    subfolders: fe,
    newFolder: _,
    newFile: ee,
    newFileCheck: Y,
    drafts: w,
    draftsBase: x,
    rename: B,
    renameQueued: W,
    move: F,
    copy: qe,
    moveAsync: Fe,
    deleteAsync: We,
    deleteItems: V,
    allowedAt: ke,
    myPermissions: Be,
    restore: $t,
    listTrash: at,
    restoreBatch: kt,
    restoreQueued: St,
    purgeTrash: ie,
    purgeBatch: pt,
    trashEmptyPreview: Ne,
    purgeVersion: xe,
    uploadMultipart: he,
    downloadUrl: De,
    previewUrl: ft,
    fetchBlob: gt,
    fetchArrayBuffer: Ut,
    // Peripheral
    limits: Xe,
    capabilities: Ve,
    /* wiring:e2 */
    e2eEscrowChallenge: bt,
    e2eEscrowUsed: Dn,
    e2eCleanup: Cn,
    /* wiring:e2 policy */
    e2eAllowedAt: fn,
    e2eRequest: mn,
    fetchHead: Nn,
    transferNamed: Me,
    /* App plugins */
    pluginActions: Jt,
    pluginActionRun: Ln,
    pluginView: Vn,
    pluginViewEvent: Ft,
    pluginUsers: na,
    opsCancel: Kt,
    appUIUrl: G,
    printFrameUrl: ye,
    pluginUICall: Ce,
    pluginUISave: Ie,
    pluginUIRead: Ae,
    pluginLicense: te,
    coeditJoin: _t,
    coeditCall: Et,
    coeditBlobPut: bn,
    coeditBlobGet: ln,
    fetchResponse: _e,
    createShare: aa,
    listShares: zn,
    revokeShare: Mn,
    archiveList: rn,
    archiveExtract: me,
    archiveCreate: Le,
    archiveAdd: Ue,
    // Version history (koru:k1 inspector)
    listVersions: xt,
    restoreVersion: Qe,
    snapshotVersion: ue,
    // Node comments (calisma:d3 inspector)
    listComments: dt,
    addComment: It,
    deleteComment: hn,
    // Permissions (RBAC panel)
    listPermissions: k,
    resolveEmail: b,
    searchUsers: C,
    searchGroups: T,
    addPermission: z,
    updatePermission: D,
    deletePermission: U,
    updateGroupPermission: E,
    deleteGroupPermission: R,
    invitePermission: H,
    shareMail: L,
    shareMessage: P,
    // Internals (exposed for useUploadChunked + PreviewModal)
    endpoints: n,
    authHeaders: r,
    authHeadersSync: l,
    credentialsMode: c,
    jsonFetch: m,
    // One request with this client's credential and language, answered as
    // the Response (a stream's reader: the AI assistant, lib/assistant).
    rawRequest: v,
    withScreenLang: ge
  };
}
function ul() {
  const e = globalThis.crypto;
  if (typeof (e == null ? void 0 : e.randomUUID) == "function") return e.randomUUID();
  const t = new Uint8Array(16);
  if (typeof (e == null ? void 0 : e.getRandomValues) == "function") e.getRandomValues(t);
  else for (let a = 0; a < t.length; a++) t[a] = Math.floor(Math.random() * 256);
  t[6] = t[6] & 15 | 64, t[8] = t[8] & 63 | 128;
  const n = Array.from(t, (a) => a.toString(16).padStart(2, "0")).join("");
  return `${n.slice(0, 8)}-${n.slice(8, 12)}-${n.slice(12, 16)}-${n.slice(16, 20)}-${n.slice(20)}`;
}
const Fy = "filex:uploads:v1";
function Pm(e) {
  if (!e) return;
  const t = Date.parse(e);
  return Number.isFinite(t) ? t : void 0;
}
function Om(e, t) {
  return [e, t.name, t.size, t.lastModified ?? 0].join("\0");
}
function zO() {
  try {
    return typeof localStorage > "u" ? null : (localStorage.getItem(Fy), localStorage);
  } catch {
    return null;
  }
}
function Uy(e) {
  if (!e) return {};
  try {
    const t = e.getItem(Fy);
    if (!t) return {};
    const n = JSON.parse(t);
    return n && typeof n == "object" ? n : {};
  } catch {
    return {};
  }
}
function Hy(e, t) {
  if (e)
    try {
      e.setItem(Fy, JSON.stringify(t));
    } catch {
    }
}
function ex(e, t = Date.now()) {
  const n = Uy(e);
  let a = !1;
  for (const [i, r] of Object.entries(n)) {
    const l = r == null ? void 0 : r.expiresAt;
    (!(r != null && r.uploadId) || typeof l != "number" || !Number.isFinite(l) || t >= l) && (delete n[i], a = !0);
  }
  return a && Hy(e, n), n;
}
function p_(e, t, n = Date.now()) {
  return ex(e, n)[t] ?? null;
}
function h_(e, t, n, a = Date.now()) {
  const i = Uy(e);
  i[t] = { ...n, updatedAt: a }, Hy(e, i);
}
function Nu(e, t) {
  const n = Uy(e);
  t in n && (delete n[t], Hy(e, n));
}
function MO(e, t = Date.now()) {
  return Object.values(ex(e, t)).sort((n, a) => a.updatedAt - n.updatedAt);
}
function PO(e) {
  return !e || e === "staging";
}
function m_(e) {
  return e.stagedUnsupported = !0, e;
}
function Ky(e) {
  return !!(e != null && e.stagedUnsupported);
}
function OO(e, t, n = zO()) {
  const a = e.chunkSize ?? 8388608, i = () => {
    var k;
    return ((k = t.screenLocale) == null ? void 0 : k.call(t)) ?? Wi(e.locale);
  };
  function r() {
    const k = t.endpoints.uploadBegin;
    return k ? k.replace(/\/begin$/, "") : t.endpoints.manager.replace(/\/manager(\?.*)?$/, "/upload");
  }
  function l() {
    return !!r();
  }
  function c() {
    return a;
  }
  function p(k) {
    return l() && k.size > c();
  }
  function m(k, b) {
    return p_(n, Om(k, b));
  }
  function v() {
    return MO(n);
  }
  async function x(k) {
    Nu(n, Om(k.path, { name: k.name, size: k.size, lastModified: k.lastModified }));
    try {
      await t.jsonFetch(`${r()}/${encodeURIComponent(k.uploadId)}`, { method: "DELETE" });
    } catch {
    }
  }
  async function w(k) {
    return t.jsonFetch(`${r()}/${encodeURIComponent(k)}`);
  }
  async function $(k) {
    var N, J, j;
    const b = Om(k.path, k.file), C = k.source ?? null, T = C ? C.size : k.file.size, E = C ? null : n, R = {
      id: ul(),
      file: k.file,
      path: k.path,
      totalBytes: T,
      uploadedBytes: 0,
      percent: 0,
      status: "initializing",
      cancel: () => {
      }
    };
    let z = !1, D = null, U;
    R.cancel = () => {
      var re;
      z = !0, D == null || D.abort(), (re = C == null ? void 0 : C.cancel) == null || re.call(C);
    };
    let H = 0;
    function L(re = 0) {
      var q;
      R.uploadedBytes = Math.min(R.totalBytes, H + re), R.percent = R.totalBytes > 0 ? Math.min(100, Math.round(R.uploadedBytes / R.totalBytes * 100)) : R.status === "done" ? 100 : 0, (q = k.onProgress) == null || q.call(k, R);
    }
    try {
      if (!l())
        throw m_(new Error("staged upload endpoint not configured"));
      const re = r();
      let q = "", le = k.chunkSize ?? a, ve;
      U = void 0;
      const ce = p_(E, b);
      if (ce)
        try {
          const ee = await w(ce.uploadId);
          PO(ee.state) && (ee.total_size ?? 0) === T ? (q = ce.uploadId, ve = Pm(ee.expires_at) ?? ce.expiresAt, le = ee.chunk_size ?? ee.chunkSize ?? ce.chunkSize, H = ee.offset ?? 0, R.resumedFrom = H) : Nu(E, b);
        } catch {
          Nu(E, b);
        }
      if (!q) {
        let ee;
        try {
          ee = await t.jsonFetch(`${re}/begin`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              path: k.path,
              name: k.file.name,
              size: T,
              mime: k.file.type || "application/octet-stream",
              // Asked for, not imposed: the server clamps this to its own
              // limits and its answer is what the loop below uses.
              chunk_size: k.chunkSize ?? a
            })
          });
        } catch (Y) {
          const B = Y.status;
          throw (B === 404 || B === 501) && m_(Y), Y;
        }
        if (!(ee != null && ee.id)) throw new Error("begin returned no upload id");
        q = ee.id, ve = Pm(ee.expires_at), le = ee.chunk_size ?? ee.chunkSize ?? le, H = ee.offset ?? 0;
      }
      R.uploadId = q, R.status = "uploading", h_(E, b, {
        uploadId: q,
        path: k.path,
        name: k.file.name,
        size: T,
        lastModified: k.file.lastModified,
        chunkSize: le,
        offset: H,
        expiresAt: ve
      }), L();
      const se = 4;
      for (; H < T; ) {
        if (z) throw new DOMException("Aborted by user", "AbortError");
        const ee = Math.min(H + le, T), Y = C ? await C.read(H, ee) : new Blob([await k.file.slice(H, ee).arrayBuffer()]);
        if (z) throw new DOMException("Aborted by user", "AbortError");
        let B = -1, W = null;
        for (let F = 0; F < se; F++) {
          if (F > 0) {
            if (await y_(300 * F + Math.floor(Math.random() * 150)), z) throw new DOMException("Aborted by user", "AbortError");
            try {
              const V = await w(q);
              if ((V.offset ?? 0) >= ee) {
                B = V.offset ?? ee;
                break;
              }
              if ((V.offset ?? 0) !== H) {
                H = V.offset ?? H, L(), B = -2;
                break;
              }
            } catch {
            }
          }
          try {
            if (z) throw new DOMException("Aborted by user", "AbortError");
            B = await P(q, Y, H, ee, T);
            break;
          } catch (V) {
            const ke = V instanceof Error ? V : new Error(String(V));
            if (z || ke.name === "AbortError") throw ke;
            const qe = ke.status;
            if (qe && qe !== 400 && qe !== 409 && qe < 500) throw ke;
            W = ke;
          }
        }
        if (B !== -2) {
          if (B < 0) throw W ?? new Error("chunk upload failed");
          if (B <= H)
            throw console.warn("[filex] upload stalled at byte", H), new Error(wl(i())("err.upload_stalled"));
          H = B, U !== void 0 && (ve = U), L(), h_(E, b, {
            uploadId: q,
            path: k.path,
            name: k.file.name,
            size: T,
            lastModified: k.file.lastModified,
            chunkSize: le,
            offset: H,
            expiresAt: ve
          });
        }
      }
      if (z) throw new DOMException("Aborted by user", "AbortError");
      R.status = "committing", L();
      const fe = new URLSearchParams(k.commitQuery ?? {}).toString(), _ = await t.jsonFetch(
        `${re}/${encodeURIComponent(q)}/commit${fe ? `?${fe}` : ""}`,
        { method: "POST" }
      );
      return Nu(E, b), R.opId = _ == null ? void 0 : _.op_id, R.nodeId = _ == null ? void 0 : _.node_id, k.waitForTransfer !== !1 && (_ != null && _.op_id) && t.endpoints.opsShow && (R.status = "transferring", L(), await K(_.op_id)), R.status = "done", H = R.totalBytes, L(), (N = k.onDone) == null || N.call(k, R, _), _;
    } catch (re) {
      const q = re instanceof Error ? re : new Error(String(re));
      if (R.status = q.name === "AbortError" ? "aborted" : "error", R.error = q.message, L(), Ky(q) || (J = C == null ? void 0 : C.cancel) == null || J.call(C), R.uploadId && (R.status === "aborted" || C)) {
        Nu(E, b);
        try {
          await t.jsonFetch(`${r()}/${encodeURIComponent(R.uploadId)}`, {
            method: "DELETE"
          });
        } catch {
        }
      }
      throw (j = k.onError) == null || j.call(k, R, q), q;
    }
    function P(re, q, le, ve, ce) {
      return new Promise((se, fe) => {
        const _ = new XMLHttpRequest(), ee = 12e4;
        let Y, B = 0, W = 0;
        const F = () => {
          clearTimeout(Y), D = null, _.onload = _.onerror = _.onabort = _.onprogress = null, _.upload.onprogress = null;
        }, V = () => {
          clearTimeout(Y), Y = setTimeout(() => {
            F(), _.abort(), fe(new Error(wl(i())("err.upload_stalled")));
          }, ee);
        };
        D = _, _.open("PUT", `${r()}/${encodeURIComponent(re)}`);
        const ke = t.authHeadersSync({
          "Content-Type": "application/octet-stream",
          "Content-Range": `bytes ${le}-${ve - 1}/${ce}`
        });
        for (const [qe, Me] of Object.entries(ke)) _.setRequestHeader(qe, Me);
        _.withCredentials = t.credentialsMode() === "include", _.upload.onprogress = (qe) => {
          qe.loaded > B && (B = qe.loaded, V()), qe.lengthComputable && L(qe.loaded);
        }, _.onprogress = (qe) => {
          qe.loaded > W && (W = qe.loaded, V());
        }, _.onload = () => {
          if (F(), Mv(), _.status >= 200 && _.status < 300) {
            try {
              const qe = JSON.parse(_.responseText);
              U = Pm(qe.expires_at) ?? U, se(qe.offset ?? ve);
            } catch {
              se(ve);
            }
            return;
          }
          fe(fa(_.status, _.responseText || "", i()));
        }, _.onerror = () => {
          F(), zv("action"), fe(Cv(i()));
        }, _.onabort = () => {
          F(), fe(new DOMException("Aborted", "AbortError"));
        }, V();
        try {
          _.send(q);
        } catch (qe) {
          F(), fe(qe);
        }
      });
    }
    async function K(re) {
      const q = t.endpoints.opsShow;
      if (!q) return;
      const le = q.replace("{id}", String(re));
      let ve = 200, ce = 0;
      for (; ; ) {
        if (z) throw new DOMException("Aborted by user", "AbortError");
        try {
          const se = await t.jsonFetch(le);
          if ((se == null ? void 0 : se.status) === "ok") return;
          if ((se == null ? void 0 : se.status) === "failed" || (se == null ? void 0 : se.status) === "partial")
            throw new v_(se.error || "transfer failed");
          ce = 0;
        } catch (se) {
          if (se instanceof v_ || se.name === "AbortError") throw se;
          if (++ce >= LO) return;
        }
        await y_(ve), ve = Math.min(ve * 2, 2e3);
      }
    }
  }
  return {
    uploadFile: $,
    /** True when this file is big enough (and the endpoints exist) to chunk. */
    shouldChunk: p,
    /** The size at which chunking kicks in. */
    threshold: c,
    resumableFor: m,
    listResumable: v,
    discardResumable: x
  };
}
const LO = 6;
class v_ extends Error {
  constructor(t) {
    super(t), this.name = "TransferFailedError";
  }
}
function y_(e) {
  return new Promise((t) => setTimeout(t, e));
}
function g_(e) {
  const t = S(/* @__PURE__ */ new Set()), n = S(null);
  function a(w, $ = {}) {
    if ($.shift && n.value) {
      const k = e(), b = k.findIndex((z) => z.path === n.value), C = k.findIndex((z) => z.path === w);
      if (b === -1 || C === -1) {
        t.value = /* @__PURE__ */ new Set([w]), n.value = w;
        return;
      }
      const [T, E] = b < C ? [b, C] : [C, b], R = /* @__PURE__ */ new Set();
      for (let z = T; z <= E; z++) R.add(k[z].path);
      t.value = R;
      return;
    }
    if ($.ctrl) {
      const k = new Set(t.value);
      k.has(w) ? k.delete(w) : k.add(w), t.value = k, n.value = w;
      return;
    }
    t.value = /* @__PURE__ */ new Set([w]), n.value = w;
  }
  function i() {
    t.value = /* @__PURE__ */ new Set(), n.value = null;
  }
  function r() {
    t.value = new Set(e().map((w) => w.path));
  }
  function l(w) {
    return t.value.has(w);
  }
  function c(w) {
    const $ = new Set(t.value);
    $.add(w), t.value = $;
  }
  function p(w) {
    const $ = new Set(t.value);
    $.delete(w), t.value = $;
  }
  const m = A(() => t.value.size), v = A(() => t.value.size === 0), x = A(() => e().filter(($) => t.value.has($.path)));
  return { selected: t, anchor: n, click: a, clear: i, selectAll: r, has: l, add: c, remove: p, size: m, isEmpty: v, nodes: x };
}
function tx(e) {
  var n;
  const t = e;
  return !t || typeof t.tagName != "string" ? !1 : t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.tagName === "SELECT" || t.isContentEditable || ((n = t.getAttribute) == null ? void 0 : n.call(t, "role")) === "textbox" ? !0 : typeof t.closest == "function" && !!t.closest(".monaco-editor");
}
const DO = /* @__PURE__ */ new Set([
  "Ctrl+N",
  "Ctrl+Shift+N",
  "Ctrl+T",
  "Ctrl+Shift+T",
  "Ctrl+W",
  "Ctrl+Shift+W",
  "Ctrl+Tab",
  "Ctrl+Shift+Tab",
  "Ctrl+Q",
  "Ctrl+Shift+I",
  "Ctrl+Shift+J",
  "Ctrl+Shift+C",
  "F11",
  "F12"
]);
function ipe(e) {
  return DO.has(e);
}
const as = [
  // Navigation
  { id: "palette", defaultCombo: "Ctrl+K", labelKey: "shortcuts.palette", groupKey: "shortcuts.group.nav" },
  { id: "search", defaultCombo: "/", labelKey: "shortcuts.search", groupKey: "shortcuts.group.nav" },
  { id: "go-up", defaultCombo: "Alt+↑", fixedCombos: ["Backspace"], labelKey: "shortcuts.go_up", groupKey: "shortcuts.group.nav" },
  { id: "open", defaultCombo: "Enter", prevent: !1, labelKey: "shortcuts.open", groupKey: "shortcuts.group.nav" },
  { id: "quicklook", defaultCombo: "Space", labelKey: "shortcuts.quicklook", groupKey: "shortcuts.group.nav" },
  { id: "close", defaultCombo: "Esc", customizable: !1, prevent: !1, inForms: !0, labelKey: "shortcuts.close", groupKey: "shortcuts.group.nav" },
  { id: "inspector", defaultCombo: "I", labelKey: "shortcuts.inspector", groupKey: "shortcuts.group.nav" },
  { id: "help", defaultCombo: "?", labelKey: "shortcuts.help", groupKey: "shortcuts.group.nav" },
  { id: "toggle-hidden", defaultCombo: "Ctrl+Shift+.", labelKey: "shortcuts.toggle_hidden", groupKey: "shortcuts.group.nav" },
  /* yildiz:s1 — starring is an action, so it belongs where the other verbs
   * are. A bare letter like the inspector's `I`; the handler ignores events
   * from form controls, so it never eats a keystroke meant for a filename. */
  { id: "star", defaultCombo: "S", labelKey: "shortcuts.star", groupKey: "shortcuts.group.file" },
  // Selection
  { id: "select-all", defaultCombo: "Ctrl+A", labelKey: "shortcuts.select_all", groupKey: "shortcuts.group.selection" },
  // File operations
  { id: "rename", defaultCombo: "F2", labelKey: "shortcuts.rename", groupKey: "shortcuts.group.file" },
  { id: "delete", defaultCombo: "Del", labelKey: "shortcuts.delete", groupKey: "shortcuts.group.file" },
  { id: "cut", defaultCombo: "Ctrl+X", labelKey: "shortcuts.cut", groupKey: "shortcuts.group.file" },
  { id: "copy", defaultCombo: "Ctrl+C", labelKey: "shortcuts.copy", groupKey: "shortcuts.group.file" },
  { id: "paste", defaultCombo: "Ctrl+V", labelKey: "shortcuts.paste", groupKey: "shortcuts.group.file" },
  /* wiring:d1 — tabs. Note: browsers reserve Ctrl+T/W/Tab in normal pages
   * (preventDefault can't stop them there); they work in webcomponent/PWA/
   * kiosk contexts and stay remappable through the settings modal. */
  { id: "tab-new", defaultCombo: "Ctrl+T", labelKey: "shortcuts.tab_new", groupKey: "shortcuts.group.tabs" },
  { id: "tab-close", defaultCombo: "Ctrl+W", labelKey: "shortcuts.tab_close", groupKey: "shortcuts.group.tabs" },
  { id: "tab-next", defaultCombo: "Ctrl+Tab", labelKey: "shortcuts.tab_next", groupKey: "shortcuts.group.tabs" },
  { id: "tab-prev", defaultCombo: "Ctrl+Shift+Tab", labelKey: "shortcuts.tab_prev", groupKey: "shortcuts.group.tabs" },
  /* /wiring:d1 */
  /* tus:t1 — the rest of the menu verbs. Until now these were reachable only
   * by right-clicking, and the right-click menu named no keys at all, so 16 of
   * the registry's actions were invisible unless somebody opened the `?` sheet
   * on their own. The ones with no default are deliberate: they are rare
   * enough that taking a key from the user by default is the wrong trade, and
   * they are in the registry so the user can take one. */
  { id: "new-folder", defaultCombo: "Shift+N", labelKey: "shortcuts.new_folder", groupKey: "shortcuts.group.file" },
  { id: "upload", defaultCombo: "U", labelKey: "shortcuts.upload", groupKey: "shortcuts.group.file" },
  { id: "refresh", defaultCombo: "R", labelKey: "shortcuts.refresh", groupKey: "shortcuts.group.nav" },
  { id: "download", defaultCombo: "D", labelKey: "shortcuts.download", groupKey: "shortcuts.group.file" },
  { id: "preview", defaultCombo: "P", labelKey: "shortcuts.preview", groupKey: "shortcuts.group.nav" },
  { id: "share", defaultCombo: "Shift+S", labelKey: "shortcuts.share", groupKey: "shortcuts.group.file" },
  { id: "tags", defaultCombo: "T", labelKey: "shortcuts.tags", groupKey: "shortcuts.group.file" },
  { id: "open-tab", defaultCombo: "", labelKey: "shortcuts.open_tab", groupKey: "shortcuts.group.tabs" },
  { id: "copy-path", defaultCombo: "", labelKey: "shortcuts.copy_path", groupKey: "shortcuts.group.file" },
  { id: "copy-id", defaultCombo: "", labelKey: "shortcuts.copy_id", groupKey: "shortcuts.group.file" },
  { id: "restore", defaultCombo: "", labelKey: "shortcuts.restore", groupKey: "shortcuts.group.file" }
  /* /tus:t1 */
], RO = {
  palette: "onPathJump",
  search: "onFocusSearch",
  "go-up": "onGoUp",
  open: "onOpen",
  quicklook: "onQuickLook",
  close: "onClose",
  inspector: "onToggleInspector",
  "toggle-hidden": "onToggleHidden",
  star: "onStar",
  help: "onShowHelp",
  "select-all": "onSelectAll",
  rename: "onRename",
  delete: "onDelete",
  cut: "onCut",
  copy: "onCopy",
  paste: "onPaste",
  /* wiring:d1 */
  "tab-new": "onTabNew",
  "tab-close": "onTabClose",
  "tab-next": "onTabNext",
  "tab-prev": "onTabPrev",
  /* tus:t1 */
  "new-folder": "onNewFolder",
  upload: "onUpload",
  refresh: "onRefresh",
  download: "onDownload",
  preview: "onPreview",
  share: "onShare",
  tags: "onTags",
  "open-tab": "onOpenTab",
  "copy-path": "onCopyPath",
  "copy-id": "onCopyId",
  restore: "onRestore"
}, Pv = "filex.shortcuts";
function NO() {
  try {
    const e = localStorage.getItem(Pv);
    if (!e) return {};
    const t = JSON.parse(e);
    if (!t || typeof t != "object") return {};
    const n = {};
    for (const [a, i] of Object.entries(t))
      typeof i == "string" && as.some((r) => r.id === a) && (n[a] = i);
    return n;
  } catch {
    return {};
  }
}
const Vi = S(NO());
function Vy() {
  try {
    Object.keys(Vi.value).length === 0 ? localStorage.removeItem(Pv) : localStorage.setItem(Pv, JSON.stringify(Vi.value));
  } catch {
  }
}
function jy(e) {
  return as.find((t) => t.id === e);
}
function Dc(e) {
  var n;
  const t = Vi.value[e];
  return t !== void 0 ? t : ((n = jy(e)) == null ? void 0 : n.defaultCombo) ?? "";
}
function ope(e, t) {
  const n = jy(e);
  if (!n || n.customizable === !1) return;
  const a = { ...Vi.value };
  t === n.defaultCombo ? delete a[e] : a[e] = t, Vi.value = a, Vy();
}
function rpe(e) {
  if (!(e in Vi.value)) return;
  const t = { ...Vi.value };
  delete t[e], Vi.value = t, Vy();
}
function spe() {
  Vi.value = {}, Vy();
}
function lpe(e, t) {
  var n;
  if (!e) return null;
  for (const a of as)
    if (a.id !== t) {
      if ((n = a.fixedCombos) != null && n.includes(e)) return { id: a.id, fixed: !0 };
      if (Dc(a.id) === e) return { id: a.id, fixed: a.customizable === !1 };
    }
  return null;
}
const IO = {
  " ": "Space",
  Spacebar: "Space",
  Escape: "Esc",
  Delete: "Del",
  ArrowUp: "↑",
  ArrowDown: "↓",
  ArrowLeft: "←",
  ArrowRight: "→",
  PageUp: "PgUp",
  PageDown: "PgDn"
}, BO = /* @__PURE__ */ new Set(["Control", "Alt", "Shift", "Meta", "AltGraph", "CapsLock", "NumLock", "ScrollLock", "Fn", "Dead"]);
function FO(e) {
  const t = e.key;
  if (!t || BO.has(t)) return null;
  const n = IO[t];
  return n || (t.length === 1 ? t.toUpperCase() : t);
}
function nx(e) {
  const t = FO(e);
  if (!t) return null;
  const n = [];
  (e.ctrlKey || e.metaKey) && n.push("Ctrl"), e.altKey && n.push("Alt");
  const a = t.length === 1 && t.toUpperCase() === t.toLowerCase();
  return e.shiftKey && !a && n.push("Shift"), n.push(t), n.join("+");
}
function UO() {
  return A(
    () => as.map((e) => {
      const t = Dc(e.id), n = e.fixedCombos ?? [];
      return {
        id: e.id,
        combo: t,
        fixedCombos: n,
        keys: [t, ...n].filter((a) => !!a),
        labelKey: e.labelKey,
        groupKey: e.groupKey,
        customizable: e.customizable !== !1,
        overridden: Vi.value[e.id] !== void 0
      };
    })
  );
}
function HO() {
  return typeof navigator < "u" && /mac|iphone|ipad|ipod/i.test(navigator.platform || navigator.userAgent || "");
}
function KO(e) {
  return e ? HO() ? e.replace(/\bCtrl\b/g, "⌘") : e : "";
}
const VO = {
  open: "open",
  "open-tab": "open-tab",
  preview: "preview",
  download: "download",
  access: "share",
  details: "inspector",
  "copy-id": "copy-id",
  "copy-path": "copy-path",
  rename: "rename",
  cut: "cut",
  copy: "copy",
  paste: "paste",
  star: "star",
  tags: "tags",
  delete: "delete",
  restore: "restore",
  "new-folder": "new-folder",
  "toggle-hidden": "toggle-hidden",
  upload: "upload",
  refresh: "refresh"
};
function ax(e) {
  const t = VO[e] ?? e;
  return as.some((n) => n.id === t) ? qy(t) : "";
}
function qy(e) {
  return KO(Dc(e));
}
function ix(e, t) {
  var i, r;
  const n = Dc(t);
  if (!n) return !1;
  const a = nx(e);
  return a === n ? !0 : ((r = (i = jy(t)) == null ? void 0 : i.fixedCombos) == null ? void 0 : r.includes(a ?? "")) ?? !1;
}
as.map((e) => ({
  keys: [e.defaultCombo, ...e.fixedCombos ?? []].filter((t) => !!t),
  labelKey: e.labelKey,
  groupKey: e.groupKey
}));
function jO(e, t) {
  const n = A(() => {
    const i = /* @__PURE__ */ new Map();
    for (const r of as) {
      const l = Dc(r.id);
      l && i.set(l, r);
    }
    return i;
  });
  function a(i) {
    var x;
    if (!e.value || i.key !== "Escape" && document.querySelector(".fe-ctx-backdrop")) return;
    const l = i.target, c = tx(l), p = nx(i);
    if (!p) return;
    if (p === "Backspace") {
      if (c) return;
      (x = t.hasSelection) != null && x.call(t) && t.onDelete ? (i.preventDefault(), t.onDelete()) : t.onGoUp && (i.preventDefault(), t.onGoUp());
      return;
    }
    const m = n.value.get(p);
    if (!m || c && !m.inForms || p === "Space" && l && typeof l.closest == "function" && l.closest('button, a, select, summary, [role="button"], [role="menuitem"]'))
      return;
    const v = t[RO[m.id]];
    v && (m.prevent !== !1 && i.preventDefault(), v());
  }
  jt(() => window.addEventListener("keydown", a)), Tt(() => window.removeEventListener("keydown", a));
}
function Nl() {
  let e;
  try {
    e = typeof window < "u" && typeof window.matchMedia == "function" ? window.matchMedia("(prefers-color-scheme: dark)") : void 0;
  } catch {
    e = void 0;
  }
  const t = S(!!(e != null && e.matches)), n = (a) => {
    t.value = a.matches;
  };
  return jt(() => {
    var a;
    return (a = e == null ? void 0 : e.addEventListener) == null ? void 0 : a.call(e, "change", n);
  }), Tt(() => {
    var a;
    return (a = e == null ? void 0 : e.removeEventListener) == null ? void 0 : a.call(e, "change", n);
  }), t;
}
const qO = "apps";
function WO(e) {
  const t = `${qO}/${encodeURIComponent(e.plugin)}/${encodeURIComponent(e.view)}`;
  return e.path ? `${t}?path=${encodeURIComponent(e.path)}` : t;
}
function ox(e, t) {
  return `${String(e ?? "").replace(/\/+$/, "")}/${WO(t)}`;
}
function Qf(e) {
  return e === "page";
}
function zp(e) {
  if (!e || typeof e != "object") return !1;
  const t = e;
  return typeof t.path == "string" && t.path.trim() !== "";
}
function YO(e) {
  const t = String(e ?? "").indexOf("://");
  if (t <= 0) return "";
  const n = e.slice(0, t), a = e.slice(t + 3).replace(/^\/+/, ""), i = a.lastIndexOf("/"), r = i > 0 ? a.slice(0, i) : "";
  return r ? `${n}/${r}` : n;
}
function b_(e, t) {
  var r;
  if (!zp(e) || !t.plugin) return { href: "", newTab: !1 };
  const n = String(t.base ?? "").replace(/\/+$/, "");
  if (e.view && Qf((r = t.placementOf) == null ? void 0 : r.call(t, e.view)))
    return { href: ox(n, { plugin: t.plugin, view: e.view, path: e.path }), newTab: !0 };
  const a = [`select=${encodeURIComponent(e.path)}`, `app=${encodeURIComponent(t.plugin)}`];
  e.action ? a.push(`appAction=${encodeURIComponent(e.action)}`) : e.view && a.push(`appView=${encodeURIComponent(e.view)}`);
  const i = YO(e.path);
  return { href: `${n}/explore?${a.join("&")}${i ? `#${i}` : ""}`, newTab: !1 };
}
const GO = 2e3, XO = 8e3;
function k_(e) {
  const t = (...m) => {
    for (const v of m) if (typeof v == "number") return v;
    return 0;
  }, n = (...m) => {
    for (const v of m) if (typeof v == "string" && v !== "") return v;
    return null;
  }, a = String(e.status ?? "pending"), i = a === "ok" || a === "done" ? "done" : a === "failed" || a === "partial" || a === "error" ? "error" : a === "cancelled" ? "cancelled" : a === "cancelling" ? "cancelling" : a === "running" ? "running" : "pending", r = Array.isArray(e.sources) ? e.sources : [], l = n(e.op_type, e.kind) ?? "delete", c = Array.isArray(e.outputs) ? e.outputs.map((m) => m && typeof m == "object" ? n(m.path) : null).filter((m) => m !== null).map((m) => ({ path: m })) : void 0;
  let p;
  if (zp(e.open)) {
    const m = n(e.open.action), v = n(e.open.view);
    p = { path: e.open.path, ...m ? { action: m } : {}, ...v ? { view: v } : {} };
  }
  return {
    id: t(e.id),
    op_type: l === "plugin-action" ? "plugin" : l,
    status: i,
    progress_total: t(e.progress_total, e.total, r.length),
    progress_done: t(e.progress_done, e.done),
    bytes_total: t(e.bytes_total),
    bytes_done: t(e.bytes_done),
    objects_total: t(e.objects_total),
    objects_done: t(e.objects_done),
    target_path: n(e.target_path, e.dest),
    source_dir: n(e.source_dir),
    source_count: t(e.source_count, r.length),
    error_message: n(e.error_message, e.error),
    error_code: n(e.error_code) ?? void 0,
    error_engine: n(e.error_engine) ?? void 0,
    error_text: n(e.error_text) ?? void 0,
    cancellable: e.cancellable === !0,
    started_at: n(e.started_at),
    finished_at: n(e.finished_at),
    created_at: n(e.created_at),
    plugin: n(e.plugin) ?? void 0,
    action: n(e.action) ?? void 0,
    label: n(e.label) ?? void 0,
    message: n(e.message) ?? void 0,
    summary: n(e.summary) ?? void 0,
    wait_text: n(e.wait_text) ?? void 0,
    outputs: c,
    ...p ? { open: p } : {}
  };
}
function rx(e, t, n = {}) {
  const a = S([]), i = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Map();
  let c = !1;
  const p = A(
    () => a.value.some((b) => b.status === "pending" || b.status === "running" || b.status === "cancelling")
  );
  let m;
  function v() {
    m || t.endpoints.opsList && (m = setInterval(() => {
      w();
    }, GO), w());
  }
  function x() {
    m && (clearInterval(m), m = void 0);
  }
  async function w() {
    var b;
    if (t.endpoints.opsList)
      try {
        const T = ((await t.jsonFetch(t.withScreenLang(t.endpoints.opsList))).ops || []).map(k_);
        for (const P of T)
          (P.status === "done" || P.status === "error" || P.status === "cancelled") && !i.has(P.id) && (i.add(P.id), l.set(P.id, Date.now()), r.delete(P.id) && ((b = n.onSettled) == null || b.call(n, P)));
        const E = new Set(a.value.map((P) => P.id)), R = T.filter((P) => P.status === "pending" || P.status === "running" || P.status === "cancelling" ? !0 : c ? E.has(P.id) : !1), z = new Set(R.map((P) => P.id)), D = a.value.filter((P) => !z.has(P.id)), U = [...R, ...D];
        c = !0;
        const H = Date.now(), L = U.filter((P) => {
          if (P.status === "pending" || P.status === "running" || P.status === "cancelling") return !0;
          const K = l.get(P.id);
          return K !== void 0 && H - K < XO;
        });
        a.value = L, !p.value && L.length === 0 && x();
      } catch (C) {
        console.warn("[usePendingOps] poll failed:", C);
      }
  }
  function $(b) {
    const C = k_(b);
    i.has(C.id) || r.add(C.id), a.value.some((E) => E.id === C.id) || (a.value = [C, ...a.value]), v();
  }
  function k(b) {
    a.value = a.value.filter((C) => C.id !== b), l.delete(b);
  }
  return Tt(() => {
    x();
  }), {
    ops: a,
    hasActive: p,
    register: $,
    dismiss: k,
    poll: w,
    startPolling: v,
    stopPolling: x
  };
}
function Qu(e) {
  return e === "folder" || e === "vault" || e === "file";
}
function Wy(e) {
  return e ? e.e2e === !0 || e.encrypted === "folder" || e.encrypted === "vault" || typeof e.e2e_root == "string" && e.e2e_root !== "" : !1;
}
function sx(e) {
  return e ? Wy(e) || e.encrypted === "file" : !1;
}
function lx(e, t) {
  if (!t || !Array.isArray(e.app_state)) return [];
  const n = `${t}:`;
  return e.app_state.filter((a) => typeof a == "string" && a.startsWith(n)).map((a) => a.slice(n.length));
}
function Yy(e, t) {
  let n = String(e.extension ?? "").toLowerCase();
  if (!n && e.basename) {
    const a = e.basename.lastIndexOf(".");
    a > 0 && (n = e.basename.slice(a + 1).toLowerCase());
  }
  return {
    kind: e.type === "dir" ? "dir" : "file",
    ext: n,
    mime: e.mime_type ?? "",
    state: lx(e, t)
  };
}
function JO(e, t) {
  return e === t ? !0 : e.endsWith("/*") ? t.startsWith(e.slice(0, -1)) : !1;
}
function Gy(e, t) {
  const n = e ?? {}, a = t.length;
  if (a === 0 || a > 1 && !n.multi) return !1;
  const i = n.min ?? 0, r = n.max ?? 0;
  if (i > 0 && a < i || r > 0 && a > r) return !1;
  const l = n.kind || "file", c = (n.ext ?? []).map((x) => x.toLowerCase()), p = (n.mime ?? []).map((x) => x.toLowerCase()), m = n.state ?? [], v = n.no_state ?? [];
  for (const x of t) {
    if (l !== "any" && l !== x.kind) return !1;
    const w = x.state ?? [];
    if (m.length > 0 && !m.some((b) => w.includes(b)) || v.some((b) => w.includes(b))) return !1;
    if (c.length === 0 && p.length === 0) continue;
    const $ = String(x.ext ?? "").toLowerCase();
    let k = c.includes($);
    if (!k) {
      const b = String(x.mime ?? "").toLowerCase();
      k = p.some((C) => JO(C, b));
    }
    if (!k) return !1;
  }
  return !0;
}
function Xy(e, t, n) {
  return Gy(e, t.map((a) => Yy(a, n)));
}
function Xt(e, t) {
  if (!e) return "";
  if (typeof e == "string") return e;
  const n = String(t || "en").toLowerCase().split("-")[0], a = e[n];
  if (typeof a == "string" && a !== "") return a;
  const i = e.en;
  if (typeof i == "string" && i !== "") return i;
  for (const r of Object.values(e))
    if (typeof r == "string" && r !== "") return r;
  return "";
}
function ZO(e, t) {
  if (!e) return "";
  if (typeof e == "string") return e;
  const n = String(t || "en").toLowerCase().split("-")[0], a = e[n];
  return typeof a == "string" && a !== "" ? a : "";
}
function Jy(e, t, n) {
  const a = ZO(e, t);
  if (a) return a;
  const i = n();
  return i || Xt(e, t);
}
function QO(e, t) {
  switch (e.kind) {
    case "engine":
      return t("plugin.needs_engine", { name: e.name });
    case "office":
      return t("plugin.needs_office", { name: e.name });
  }
  return t("plugin.needs_other", { name: e.name });
}
function Zy(e) {
  return e.key || `plugin:${e.plugin}/${e.id}`;
}
function e3(e) {
  return e.startsWith("plugin:");
}
function t3(e) {
  var t;
  return e.output_mode === "sibling" || e.output_mode === "version" || ((t = e.applies) == null ? void 0 : t.writable) === !0;
}
function n3(e) {
  return e.read_only_ok === !1;
}
const Lm = { none: 0, viewer: 1, editor: 2, owner: 3 };
function a3(e) {
  return e.min_role === "owner" ? "owner" : e.min_role === "editor" || t3(e) ? "editor" : "viewer";
}
function i3(e, t, n) {
  var i;
  if ((i = t.lock) != null && i.plugin && t.lock.plugin === e.plugin) return !0;
  const a = n(t);
  return a === void 0 || !(a in Lm) ? !0 : Lm[a] >= Lm[a3(e)];
}
function ux(e, t) {
  return t.length === 0 ? [] : e.filter((n) => Xy(n.applies, t, n.plugin));
}
function o3(e, t, n) {
  var w;
  if (n.trash || n.e2e) return [];
  if (t.some(($) => sx($) || $.mime_type === "inode/storage")) return [];
  const a = n.permOf, i = ($) => !(n.readOnly && n3($)) && (!a || t.every((k) => i3($, k, a))), r = ux(e, t).filter(i), l = /* @__PURE__ */ new Map();
  if (n.needWords)
    for (const $ of e) {
      if (r.includes($) || !((w = $.gated) != null && w.length) || !i($)) continue;
      const k = $.gated.find(
        (b) => Xy({ ...$.applies, ext: b.ext ?? [], mime: [] }, t, $.plugin)
      );
      k && l.set($, n.needWords(k.needs));
    }
  const c = e.filter(($) => r.includes($) || l.has($));
  if (c.length === 0) return [];
  const p = n.hasIcon ?? (() => !1), m = /* @__PURE__ */ new Map();
  for (const $ of c) {
    const k = m.get($.plugin);
    k ? k.push($) : m.set($.plugin, [$]);
  }
  const v = [];
  let x = !0;
  for (const [$, k] of m) {
    v.push({ divider: !0, key: x ? "sep-plugins" : `sep-plugin:${$}`, label: "" }), x = !1;
    for (const b of k) {
      const C = l.get(b);
      v.push({
        key: Zy(b),
        label: Xt(b.label, n.locale),
        icon: b.icon && p(b.icon) ? b.icon : "plugin",
        danger: b.danger === !0,
        ...C ? { disabled: !0, title: C } : {}
      });
    }
  }
  return v;
}
const r3 = 5 * 60 * 1e3, Ov = /* @__PURE__ */ new Map();
function s3() {
  Ov.clear();
}
function l3(e) {
  let t = Ov.get(e);
  return t || (t = { at: 0, data: S({ actions: [], views: [] }), inflight: null }, Ov.set(e, t)), t;
}
function u3(e, t) {
  const n = e.endpoints.pluginActions ?? "", a = l3(n || "(none)"), i = S(!1), r = S(null), l = A(() => t() && n !== ""), c = A(() => l.value ? a.data.value.actions : []), p = A(() => l.value ? a.data.value.views : []), m = A(() => l.value ? a.data.value.open_rules ?? {} : {});
  async function v(k = !1) {
    return l.value ? a.at > 0 && Date.now() - a.at < r3 && !k ? (i.value = !0, a.data.value) : (a.inflight || (a.inflight = e.pluginActions().then((C) => (a.data.value = { actions: C.actions ?? [], views: C.views ?? [], open_rules: C.open_rules ?? {} }, a.at = Date.now(), r.value = null, a.data.value)).catch((C) => (r.value = String((C == null ? void 0 : C.message) ?? C), a.data.value)).finally(() => {
      a.inflight = null, i.value = !0;
    })), a.inflight) : { actions: [], views: [] };
  }
  Je(
    l,
    (k) => {
      k && v();
    },
    { immediate: !0 }
  );
  function x(k) {
    return ux(c.value, k);
  }
  function w(k) {
    return c.value.find((b) => Zy(b) === k);
  }
  function $(k, b, C) {
    return e.pluginActionRun(k.plugin, k.id, {
      paths: b.map((T) => T.path),
      params: C
    });
  }
  return { enabled: l, actions: c, views: p, openRules: m, loaded: i, error: r, refresh: v, actionsFor: x, byKey: w, run: $ };
}
const c3 = 25e3, d3 = 15e3, f3 = 6;
class p3 {
  constructor(t) {
    Nt(this, "ws", null);
    Nt(this, "opts");
    Nt(this, "closed", !1);
    Nt(this, "connecting", !1);
    Nt(this, "retries", 0);
    Nt(this, "fallback", !1);
    Nt(this, "pingTimer", null);
    Nt(this, "reconnectTimer", null);
    // Last-known intent, replayed on (re)connect.
    Nt(this, "currentPath", null);
    Nt(this, "currentFocus", null);
    this.opts = t, this.connect();
  }
  /** Subscribe to a folder ("<adapter>://<dir>"). Swaps the active room and
   *  resets focus. Passing null unsubscribes (drive list / trash have no room). */
  subscribe(t) {
    this.currentPath = t, this.currentFocus = null, t && this.send({ type: "subscribe", path: t });
  }
  /** Report the file the user is focused on (or null to clear). */
  setFocus(t) {
    this.currentFocus = t, this.send({ type: "focus", file: t });
  }
  /** Tear down permanently — call on unmount. */
  close() {
    this.closed = !0, this.clearTimers(), this.dropSocket();
  }
  async connect() {
    if (this.closed || this.connecting || this.ws) return;
    this.connecting = !0;
    let t = null;
    try {
      t = await this.opts.getTicket();
    } catch {
      t = null;
    }
    if (this.connecting = !1, this.closed) return;
    if (!t || !t.ticket || !t.ws_url) {
      this.fail();
      return;
    }
    const n = t.ws_url.includes("?") ? "&" : "?";
    let a;
    try {
      a = new WebSocket(`${t.ws_url}${n}ticket=${encodeURIComponent(t.ticket)}`);
    } catch {
      this.fail();
      return;
    }
    this.ws = a, a.onopen = () => {
      var i, r;
      this.retries = 0, this.setFallback(!1), (r = (i = this.opts.handlers).onStatus) == null || r.call(i, !0), this.currentPath && this.send({ type: "subscribe", path: this.currentPath }), this.currentFocus !== null && this.send({ type: "focus", file: this.currentFocus }), this.startPing();
    }, a.onmessage = (i) => {
      var c, p, m, v, x, w, $, k, b, C;
      let r;
      try {
        r = JSON.parse(typeof i.data == "string" ? i.data : "");
      } catch {
        return;
      }
      const l = r;
      if ((l == null ? void 0 : l.type) === "change") (p = (c = this.opts.handlers).onChange) == null || p.call(c, r);
      else if ((l == null ? void 0 : l.type) === "presence") (v = (m = this.opts.handlers).onPresence) == null || v.call(m, r);
      else if ((l == null ? void 0 : l.type) === "app.updated") {
        const T = r;
        typeof T.app == "string" && typeof T.version == "string" && ((w = (x = this.opts.handlers).onAppUpdated) == null || w.call(x, T));
      } else if ((l == null ? void 0 : l.type) === "vault.generation" || (l == null ? void 0 : l.type) === "vault.lock") {
        const T = r;
        typeof T.path == "string" && ((k = ($ = this.opts.handlers).onVault) == null || k.call($, T));
      } else (l == null ? void 0 : l.type) === "access.changed" && ((C = (b = this.opts.handlers).onAccessChanged) == null || C.call(b, { all: r.scope === "all" }));
    }, a.onerror = () => {
    }, a.onclose = () => {
      var i, r;
      this.stopPing(), this.ws = null, (r = (i = this.opts.handlers).onStatus) == null || r.call(i, !1), this.fail();
    };
  }
  // fail schedules a capped reconnect; after MAX_RETRIES it gives up on the live
  // socket and flips to fallback (polling) mode.
  fail() {
    if (this.closed || this.reconnectTimer) return;
    if (this.retries >= f3) {
      this.setFallback(!0);
      return;
    }
    const t = Math.min(1e3 * 2 ** this.retries, d3);
    this.retries += 1, this.reconnectTimer = setTimeout(() => {
      this.reconnectTimer = null, this.connect();
    }, t);
  }
  setFallback(t) {
    var n, a;
    this.fallback !== t && (this.fallback = t, (a = (n = this.opts.handlers).onFallback) == null || a.call(n, t));
  }
  send(t) {
    const n = this.ws;
    if (!(!n || n.readyState !== WebSocket.OPEN))
      try {
        n.send(JSON.stringify(t));
      } catch {
      }
  }
  startPing() {
    this.stopPing(), this.pingTimer = setInterval(() => this.send({ type: "ping" }), c3);
  }
  stopPing() {
    this.pingTimer && (clearInterval(this.pingTimer), this.pingTimer = null);
  }
  dropSocket() {
    if (this.ws) {
      try {
        this.ws.onclose = null, this.ws.close();
      } catch {
      }
      this.ws = null;
    }
  }
  clearTimers() {
    this.stopPing(), this.reconnectTimer && (clearTimeout(this.reconnectTimer), this.reconnectTimer = null);
  }
}
function h3(e, t) {
  const n = t.now ?? (() => Date.now());
  let a = null, i = null;
  const r = () => {
    const l = n();
    i === null && (i = l);
    const c = i + t.maxWait - l, p = Math.max(0, Math.min(t.wait, c));
    a && clearTimeout(a), a = setTimeout(() => {
      a = null, i = null, e();
    }, p);
  };
  return r.cancel = () => {
    a && clearTimeout(a), a = null, i = null;
  }, r;
}
const Lv = /* @__PURE__ */ new Set();
function m3(e, t) {
  for (const n of [...Lv])
    try {
      n(e, t);
    } catch {
    }
}
function v3(e) {
  return Lv.add(e), () => {
    Lv.delete(e);
  };
}
const y3 = 200, g3 = 2e3, b3 = 12e3;
function k3(e, t) {
  const n = S([]), a = S(!1), i = S(!1);
  let r = null, l = null, c = !1;
  const p = h3(() => t.reload(), {
    wait: y3,
    maxWait: g3
  });
  let m = null;
  function v(T) {
    l && T.path && T.path !== l || (n.value = Array.isArray(T.users) ? T.users : []);
  }
  function x(T) {
    s3(), m3(T.app, T.version);
  }
  function w(T) {
    i.value = T, T ? (n.value = [], m || (m = setInterval(() => t.reload(), b3))) : m && (clearInterval(m), m = null);
  }
  function $() {
    r || (r = new p3({
      getTicket: () => e.wsTicket(),
      handlers: {
        onChange: p,
        onPresence: v,
        onAppUpdated: x,
        onVault: (T) => {
          var E;
          return (E = t.onVault) == null ? void 0 : E.call(t, T);
        },
        onAccessChanged: (T) => {
          var E;
          return (E = t.onAccess) == null ? void 0 : E.call(t, { all: T.all, resync: !1 });
        },
        onFallback: w,
        onStatus: (T) => {
          var E;
          a.value = T, T && c && ((E = t.onAccess) == null || E.call(t, { all: !1, resync: !0 })), T && (c = !0);
        }
      }
    }));
  }
  function k(T) {
    n.value = [], l = T, r == null || r.subscribe(T);
  }
  function b(T) {
    r == null || r.setFocus(T);
  }
  function C() {
    p.cancel(), m && (clearInterval(m), m = null), r == null || r.close(), r = null, c = !1, i.value = !1;
  }
  return { presenceUsers: n, connected: a, degraded: i, start: $, subscribe: k, setFocus: b, stop: C };
}
const w3 = 500;
function _3(e) {
  const t = e.thumb_url;
  if (!t) return null;
  const n = t.indexOf("?");
  if (n === -1) return `${t}||${e.last_modified ?? ""}`;
  const a = new URLSearchParams(t.slice(n + 1)).get("v") ?? "";
  return `${t.slice(0, n)}|${a}|${e.last_modified ?? ""}`;
}
function x3(e, t) {
  const n = PM(/* @__PURE__ */ new Map()), a = [], i = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), l = (m) => Cy(e, m);
  function c(m) {
    const v = m.thumb_url, x = _3(m);
    if (!v || !x) return null;
    const w = n.get(x);
    return w || (!i.has(v) && !r.has(x) && p(v, x), null);
  }
  async function p(m, v) {
    r.add(v);
    try {
      const x = await fetch(l(m), {
        headers: await t.authHeaders({ Accept: "*/*" }),
        credentials: t.credentialsMode()
      });
      if (!x.ok) throw new Error(String(x.status));
      const w = await x.blob();
      if (a.length >= w3) {
        const $ = a.shift(), k = OM(n), b = $ ? k.get($) : void 0;
        $ && b && (URL.revokeObjectURL(b), k.delete($));
      }
      a.push(v), n.set(v, URL.createObjectURL(w));
    } catch {
      i.add(m);
    } finally {
      r.delete(v);
    }
  }
  return { src: c };
}
let ep = null, tp = null, Tf = null, Af = null;
function Mp() {
  ep || (ep = import(
    /* @vite-ignore */
    "monaco-editor"
  ).then((e) => (Tf = e.default ?? e, Tf)).catch(() => (Tf = null, null))), tp || (tp = import(
    /* @vite-ignore */
    "./common-xdTjul80.js"
  ).then((e) => (Af = e.default ?? e, Af)).catch(() => (Af = null, null)));
}
async function S3() {
  return ep || Mp(), ep;
}
async function $3() {
  return tp || Mp(), tp;
}
function T3() {
  return Tf;
}
function A3() {
  return Af;
}
function upe() {
  return Mp(), {
    ensureMonaco: S3,
    ensureHighlight: $3,
    getMonaco: T3,
    getHighlight: A3
  };
}
const E3 = ["title"], C3 = ["src", "alt"], z3 = {
  key: 2,
  class: "fx-presence-dot",
  "aria-hidden": "true"
}, w_ = /* @__PURE__ */ lt({
  __name: "PresenceAvatar",
  props: {
    user: {},
    title: {}
  },
  setup(e) {
    const t = e, n = A(() => {
      const c = (t.user.avatar ?? "").trim();
      return /^(data:image\/|https?:\/\/|\/)/.test(c) ? c : "";
    }), a = S(!1), i = A(() => !!n.value && !a.value), r = A(() => {
      const c = t.user.name.trim().split(/\s+/).filter(Boolean);
      return c.length === 0 ? "?" : c.length === 1 ? c[0].slice(0, 2).toUpperCase() : (c[0][0] + c[c.length - 1][0]).toUpperCase();
    }), l = A(() => {
      const c = t.user.uid ?? String(t.user.id);
      let p = 0;
      for (let m = 0; m < c.length; m++) p = p * 31 + c.charCodeAt(m) >>> 0;
      return p % 360;
    });
    return (c, p) => (f(), h("span", {
      class: Re(["fx-presence-avatar", { "fx-presence-avatar--photo": i.value }]),
      style: Yt({ backgroundColor: `hsl(${l.value} 60% 45%)` }),
      title: e.title
    }, [
      i.value ? (f(), h("img", {
        key: 0,
        class: "fx-presence-photo",
        src: n.value,
        alt: e.user.name,
        onError: p[0] || (p[0] = (m) => a.value = !0)
      }, null, 40, C3)) : (f(), h(Te, { key: 1 }, [
        Ht(y(r.value), 1)
      ], 64)),
      e.user.file ? (f(), h("span", z3)) : O("", !0)
    ], 14, E3));
  }
}), M3 = {
  key: 0,
  class: "fx-presence-chips"
}, P3 = ["title"], O3 = { class: "fx-presence-chip-name" }, L3 = {
  key: 0,
  class: "fx-presence-chip-file"
}, D3 = ["title"], R3 = {
  key: 0,
  class: "fx-presence-more"
}, N3 = ["title"], I3 = { class: "fx-presence-file" }, B3 = ["title", "aria-expanded"], __ = "filex.presence.expanded", F3 = /* @__PURE__ */ lt({
  __name: "PresenceBar",
  props: {
    users: {},
    selfId: {},
    locale: {}
  },
  setup(e) {
    const t = e, { t: n } = ht(() => Wi(t.locale)), a = A(
      () => (t.users ?? []).filter((p) => t.selfId == null || p.id !== t.selfId)
    ), i = S((() => {
      try {
        return localStorage.getItem(__) === "1";
      } catch {
        return !1;
      }
    })());
    function r() {
      i.value = !i.value;
      try {
        localStorage.setItem(__, i.value ? "1" : "0");
      } catch {
      }
    }
    function l(p) {
      return p.uid ?? String(p.id);
    }
    function c(p) {
      return p.file ? `${p.name} · ${p.file}` : p.name;
    }
    return (p, m) => a.value.length ? (f(), h("div", {
      key: 0,
      class: Re(["fx-presence", { "fx-presence--wide": i.value }])
    }, [
      i.value ? (f(), h("div", M3, [
        (f(!0), h(Te, null, nt(a.value, (v) => (f(), h("span", {
          key: l(v),
          class: "fx-presence-chip",
          title: c(v)
        }, [
          Ze(w_, { user: v }, null, 8, ["user"]),
          d("span", O3, [
            d("bdi", null, y(v.name), 1)
          ]),
          v.file ? (f(), h("span", L3, "· " + y(v.file), 1)) : O("", !0)
        ], 8, P3))), 128))
      ])) : (f(), h(Te, { key: 1 }, [
        d("div", {
          class: "fx-presence-avatars",
          title: a.value.map(c).join(", ")
        }, [
          (f(!0), h(Te, null, nt(a.value.slice(0, 5), (v) => (f(), Ge(w_, {
            key: l(v),
            user: v,
            title: c(v)
          }, null, 8, ["user", "title"]))), 128)),
          a.value.length > 5 ? (f(), h("span", R3, "+" + y(a.value.length - 5), 1)) : O("", !0)
        ], 8, D3),
        d("span", {
          class: "fx-presence-text",
          title: a.value.map(c).join(", ")
        }, [
          Ht(y(a.value.length === 1 ? a.value[0].name : u(n)("presence.others", { n: a.value.length })) + " ", 1),
          a.value.length === 1 && a.value[0].file ? (f(), h(Te, { key: 0 }, [
            m[0] || (m[0] = Ht(" · ", -1)),
            d("span", I3, y(a.value[0].file), 1)
          ], 64)) : O("", !0)
        ], 8, N3)
      ], 64)),
      d("button", {
        type: "button",
        class: "fx-presence-toggle",
        title: i.value ? u(n)("presence.collapse") : u(n)("presence.expand"),
        "aria-expanded": i.value,
        onClick: r
      }, y(i.value ? "‹" : "›"), 9, B3)
    ], 2)) : O("", !0);
  }
}), U3 = '<path d="M4.5 15.5v3A2 2 0 0 0 6.5 20.5h11a2 2 0 0 0 2-2v-3"/>', H3 = '<path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z"/><circle cx="12" cy="12" r="3"/>', x_ = "M12 3.6l2.6 5.3 5.85.85-4.23 4.12 1 5.83L12 16.97l-5.22 2.73 1-5.83L3.55 9.75l5.85-.85z", S_ = '<path d="M8 3.5h8"/><path d="M9.6 3.5v6.1L7.2 12.3v1.7h9.6v-1.7L14.4 9.6V3.5"/><path d="M12 14v6.5"/>', Dm = '<rect x="3.5" y="4.5" width="17" height="15" rx="2"/>', $_ = '<path d="M4 6.5h16"/><path d="M9.5 6.5V4.9a1.4 1.4 0 0 1 1.4-1.4h2.2a1.4 1.4 0 0 1 1.4 1.4v1.6"/><path d="M6.6 6.5l.85 12.1a2 2 0 0 0 2 1.9h5.1a2 2 0 0 0 2-1.9l.85-12.1"/><path d="M10.3 10.3v6.4"/><path d="M13.7 10.3v6.4"/>', T_ = '<path d="M6.8 3.5h10.4a1.6 1.6 0 0 1 1.6 1.6v15.4l-6.8-3.9-6.8 3.9V5.1A1.6 1.6 0 0 1 6.8 3.5z"/>', cx = {
  /* ── opening ─────────────────────────────────────────────────────────── */
  open: '<path d="M14 3.5h6.5V10"/><path d="M20.5 3.5L12 12"/><path d="M18 13.5v5a2 2 0 0 1-2 2H5.5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h5"/>',
  "open-tab": '<rect x="3" y="4.5" width="18" height="15" rx="2"/><path d="M3 9.5h18"/><path d="M9.5 4.5v5"/>',
  preview: H3,
  download: U3 + '<path d="M12 4v11.5"/><path d="M7.5 11L12 15.5 16.5 11"/>',
  "archive-create": '<path d="M5 8.5h14v11H5z"/><path d="M4 4h16v4.5H4z"/><path d="M12 11v5"/><path d="M9.5 13.5h5"/>',
  "archive-extract": '<path d="M5 8.5h14v11H5z"/><path d="M4 4h16v4.5H4z"/><path d="M12 10.5v6"/><path d="M9.5 14l2.5 2.5 2.5-2.5"/>',
  upload: '<path d="M4.5 15.5v3A2 2 0 0 0 6.5 20.5h11a2 2 0 0 0 2-2v-3"/><path d="M12 15.5V4"/><path d="M7.5 8.5L12 4l4.5 4.5"/>',
  convert: '<path d="M4 8.5h13"/><path d="M13.5 5L17 8.5 13.5 12"/><path d="M20 15.5H7"/><path d="M10.5 12L7 15.5 10.5 19"/>',
  /* "Paylaş / İzinler" — the three-node share, not a chain link: this row
     opens permissions as well as a link, and people are the subject. */
  access: '<circle cx="17.5" cy="6" r="2.5"/><circle cx="6.5" cy="12" r="2.5"/><circle cx="17.5" cy="18" r="2.5"/><path d="M8.75 10.8l6.5-3.6"/><path d="M8.75 13.2l6.5 3.6"/>',
  details: '<circle cx="12" cy="12" r="8.5"/><path d="M12 11.2v5.6"/><circle cx="12" cy="7.7" r="0.9" fill="currentColor" stroke="none"/>',
  /* ── identity / clipboard ────────────────────────────────────────────── */
  "copy-id": '<rect x="2.5" y="5" width="19" height="14" rx="2.5"/><circle cx="8.5" cy="10.8" r="2"/><path d="M5.3 16.2c.5-1.5 1.75-2.4 3.2-2.4s2.7.9 3.2 2.4"/><path d="M14.8 10h4.2"/><path d="M14.8 13.6h4.2"/>',
  /* A clipboard carrying a path separator — this copies the location, not the
     thing that lives at it. */
  "copy-path": '<path d="M9 4.5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-12a2 2 0 0 0-2-2h-2"/><rect x="9" y="2.8" width="6" height="3.6" rx="1.2"/><path d="M10 11.2l2.4 2.4-2.4 2.4"/>',
  rename: '<path d="M4 20l.9-4.1 11-11a2.05 2.05 0 0 1 2.9 2.9l-11 11z"/><path d="M14 7l3 3"/>',
  cut: '<circle cx="6.5" cy="17.5" r="2.5"/><circle cx="6.5" cy="6.5" r="2.5"/><path d="M8.6 8.3L19 19"/><path d="M8.6 15.7L19 5"/>',
  copy: '<rect x="9" y="9" width="11.5" height="11.5" rx="2"/><path d="M15 6v-.5a2 2 0 0 0-2-2H5.5a2 2 0 0 0-2 2V13a2 2 0 0 0 2 2H6"/>',
  paste: '<path d="M9 4.5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-12a2 2 0 0 0-2-2h-2"/><rect x="9" y="2.8" width="6" height="3.6" rx="1.2"/>',
  /* ── metadata ────────────────────────────────────────────────────────── */
  /* star = "not starred yet, do it" (outline); unstar = the state you are in
     (filled). The renderer picks between them by name, see FileExplorer. */
  star: `<path d="${x_}"/>`,
  unstar: `<path d="${x_}" fill="currentColor"/>`,
  tags: '<path d="M3.5 11.4V5.2a1.7 1.7 0 0 1 1.7-1.7h6.2a1.7 1.7 0 0 1 1.2.5l7.2 7.2a1.7 1.7 0 0 1 0 2.4l-6.2 6.2a1.7 1.7 0 0 1-2.4 0L4 12.6a1.7 1.7 0 0 1-.5-1.2z"/><circle cx="8" cy="8" r="1.3"/>',
  /* ── destructive / recovery ──────────────────────────────────────────── */
  delete: $_,
  "open-trash": $_,
  /* The undo arrow, not a rotating one: "Geri Yükle" puts a thing back where
     it was, and that is the gesture people already read as undo. */
  restore: '<path d="M9 6L5 10l4 4"/><path d="M5 10h9a5 5 0 0 1 0 10h-3.5"/>',
  /* ── folder-level ────────────────────────────────────────────────────── */
  "new-folder": '<path d="M3 7.5a2 2 0 0 1 2-2h4.2a2 2 0 0 1 1.4.6l1.4 1.4H19a2 2 0 0 1 2 2V17a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><path d="M12 11.3v5"/><path d="M9.5 13.8h5"/>',
  /* belge:n1 — a page with a plus: "make me a new document of some type".
     Keyed by the action's own key, so the menu row carries no icon of its
     own and no emoji enters the markup. */
  "new-document": '<path d="M13.5 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h5"/><path d="M13.5 3l5 5"/><path d="M13.5 3v5h5"/><path d="M17.5 14.5v6"/><path d="M14.5 17.5h6"/>',
  refresh: '<path d="M20.5 12a8.5 8.5 0 1 1-2.49-6.01"/><path d="M18 1.5V6h-4.5"/>',
  /* ── desktop sync ("keep on this device") ────────────────────────────── */
  "keep-local": S_,
  "keep-online": '<path d="M7 18.5h10a3.5 3.5 0 0 0 0-7 5 5 0 0 0-9.6-1.2A4.2 4.2 0 0 0 7 18.5z"/>',
  /* Kept because a parent folder is kept — the pin, with the branch it came
     down. The row is disabled; the glyph says why. */
  "keep-inherited": S_ + '<path d="M2.5 20.5h3.6a1.6 1.6 0 0 0 1.6-1.6V17"/>',
  "keep-reveal": '<path d="M2.5 17.5V6.5a2 2 0 0 1 2-2h3.8a2 2 0 0 1 1.4.6l1.4 1.4h4.4a2 2 0 0 1 2 2v1.8"/><path d="M4 19.5h13.4a2 2 0 0 0 1.9-1.37l2-6A1.4 1.4 0 0 0 20 10.3H9.4a2 2 0 0 0-1.9 1.37L5.5 18"/>',
  /* ── view preferences ────────────────────────────────────────────────── */
  "toggle-hidden": '<path d="M3.5 3.5l17 17"/><path d="M9.9 6A9.6 9.6 0 0 1 12 5.5c6 0 9.5 6.5 9.5 6.5a17.3 17.3 0 0 1-3.35 4.15"/><path d="M6.55 7.7A17.4 17.4 0 0 0 2.5 12S6 18.5 12 18.5a9.7 9.7 0 0 0 3.95-.85"/><path d="M10.2 10.3a2.9 2.9 0 0 0 3.9 4.1"/>',
  density: '<path d="M8.5 8L12 4.5 15.5 8"/><path d="M8.5 16L12 19.5 15.5 16"/><path d="M12 4.5v15"/>',
  "view-list": '<path d="M8.5 6.5h12"/><path d="M8.5 12h12"/><path d="M8.5 17.5h12"/><path d="M4 6.5h.01"/><path d="M4 12h.01"/><path d="M4 17.5h.01"/>',
  "view-grid": '<rect x="3.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="3.5" y="13.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="13.5" width="7" height="7" rx="1.5"/>',
  "view-gallery": '<rect x="3" y="4.5" width="18" height="15" rx="2"/><circle cx="8.3" cy="9.6" r="1.5"/><path d="M4.3 17l4.7-4.7 3 3 3-3 5 4.7"/>',
  nav: Dm + '<path d="M9.5 4.5v15"/>',
  inspector: Dm + '<path d="M14.5 4.5v15"/>',
  /* ── explorer settings ───────────────────────────────────────────────── */
  "shortcut-settings": '<rect x="2.5" y="6" width="19" height="12" rx="2.5"/><path d="M6.5 9.8h.01"/><path d="M10 9.8h.01"/><path d="M13.5 9.8h.01"/><path d="M17 9.8h.01"/><path d="M6.5 12.9h.01"/><path d="M10 12.9h.01"/><path d="M13.5 12.9h.01"/><path d="M17 12.9h.01"/><path d="M8.6 15.6h6.8"/>',
  /* Light/dark as the thing it actually switches: one disc, half of it inked. */
  theme: '<circle cx="12" cy="12" r="8.5"/><path d="M12 3.5a8.5 8.5 0 0 1 0 17z" fill="currentColor" stroke="none"/>',
  /* zaman:z3 — a clock face, for the Time zone row. */
  timezone: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.2V12l3.2 2"/>',
  /* #275 — a globe, for an embed's Language row. */
  language: '<circle cx="12" cy="12" r="8.5"/><path d="M3.5 12h17"/><path d="M12 3.5c2.3 2.3 3.5 5.1 3.5 8.5s-1.2 6.2-3.5 8.5c-2.3-2.3-3.5-5.1-3.5-8.5s1.2-6.2 3.5-8.5z"/>',
  tour: '<path d="M2.5 9L12 4.5 21.5 9 12 13.5z"/><path d="M6.6 11.1v4.4c0 1.6 2.4 2.9 5.4 2.9s5.4-1.3 5.4-2.9v-4.4"/>',
  /* "Dosya İste" — the public drop link. A chain, because what this makes is
     a URL to hand somebody. */
  "request-files": '<path d="M10.2 13.8a4.2 4.2 0 0 0 6.1 0l2.3-2.3a4.3 4.3 0 0 0-6.1-6.1l-1.35 1.35"/><path d="M13.8 10.2a4.2 4.2 0 0 0-6.1 0l-2.3 2.3a4.3 4.3 0 0 0 6.1 6.1l1.35-1.35"/>',
  /* ── toolbar chrome that is not a ContextAction ──────────────────────── */
  "go-up": '<path d="M12 20V5"/><path d="M5.5 11.5L12 5l6.5 6.5"/>',
  /* #57 — the storage row's order menu (SideNav). One step up or down is a
     SHORT arrow, so it does not read as `go-up`'s "to the parent folder";
     "Sort by name" is the A→Z mark every file manager uses; "Use default order" is
     the refresh circle turning back. All vertical or rotational, so none of
     them is mirrored in a right-to-left interface. */
  "move-up": '<path d="M12 18V7"/><path d="M7.5 11.5L12 7l4.5 4.5"/>',
  "move-down": '<path d="M12 6v11"/><path d="M7.5 12.5L12 17l4.5-4.5"/>',
  "sort-name": '<path d="M3.5 10.5L6.5 3.5l3 7"/><path d="M4.7 8h3.6"/><path d="M4 13.5h5l-5 7h5"/><path d="M17 4v16"/><path d="M13.5 16.5L17 20l3.5-3.5"/>',
  "reset-order": '<path d="M3.5 12a8.5 8.5 0 1 0 2.49-6.01"/><path d="M6 1.5V6h4.5"/>',
  /* === gorunum:v2-topbar — the breadcrumb row's own controls ============
     The crumb trail gained the reference shell's three affordances: a home
     crumb in place of the bare "/" root, a chevron on the last crumb that
     lists what is inside it, and the path editor we already had (its glyph
     moves here from Breadcrumb.vue so every mark in the row comes from one
     file). */
  home: '<path d="M3.5 10.6L12 3.5l8.5 7.1"/><path d="M5.6 9.4V19a1.5 1.5 0 0 0 1.5 1.5h9.8a1.5 1.5 0 0 0 1.5-1.5V9.4"/><path d="M9.9 20.5v-5.2h4.2v5.2"/>',
  subfolders: '<path d="M6.8 9.8L12 15l5.2-5.2"/>',
  "edit-path": '<path d="M4 20h4l10-10a2.1 2.1 0 0 0-3-3L5 17z"/><path d="M14.5 6.5l3 3"/>',
  /* === gorunum:v2-topbar — the header's trailing cluster ================
     The page chrome around the explorer is gone, so the account-level doors
     are drawn by the header itself (the host fills them through the
     `header-actions` slot). The glyphs live here so an embedder's cluster
     comes out the same weight and colour as everything beside it. */
  admin: '<rect x="3" y="3.5" width="7.4" height="7.4" rx="1.6"/><rect x="13.6" y="3.5" width="7.4" height="4.6" rx="1.6"/><rect x="13.6" y="10.7" width="7.4" height="9.8" rx="1.6"/><rect x="3" y="13.6" width="7.4" height="6.9" rx="1.6"/>',
  /* ⚠ A PERSON, not a cog. The first draft drew the gear as a ringed disc with
     eight spokes and at 16px it came out as a SUN — sitting in the very row
     the light/dark toggle had just been removed from, which is the one thing
     the mark must not be mistaken for (measured at 1440 and 390: it read as a
     theme switch in both). The account bust is what the reference hangs this
     menu on, and the tooltip says which settings. */
  account: '<circle cx="12" cy="8.2" r="3.6"/><path d="M4.9 20.3a7.35 7.35 0 0 1 14.2 0"/>',
  "sign-out": '<path d="M9.5 20.5H6a2 2 0 0 1-2-2v-13a2 2 0 0 1 2-2h3.5"/><path d="M15.5 16.5L20 12l-4.5-4.5"/><path d="M20 12H9"/>',
  /* The AI assistant (task #269) - a spark, the mark every assistant in this
     class of product wears; it is the same glyph the "coming soon" button
     wore, so it did not change under people's fingers when it came alive. */
  ai: '<path d="M12 3.2l1.75 4.3 4.3 1.75-4.3 1.75L12 15.3l-1.75-4.3L5.95 9.25l4.3-1.75z"/><path d="M18.2 15.1l.8 1.95 1.95.8-1.95.8-.8 1.95-.8-1.95-1.95-.8 1.95-.8z"/>',
  /* The notification bell, for the host's header cluster (web/src
     NotificationBell.vue). ⚠ Drawn HERE, not taken from the app's icon
     library: it sits in the same row as refresh, the spark and the avatar,
     and a glyph at a foreign stroke weight in that row is the exact mismatch
     this set exists to prevent. A dome on a flared rim, the clapper below. */
  bell: '<path d="M6.2 16.6V11a5.8 5.8 0 0 1 11.6 0v5.6l1.7 1.9H4.5z"/><path d="M10.1 21a2.1 2.1 0 0 0 3.8 0"/>',
  /* === /gorunum:v2-topbar === */
  search: '<circle cx="10.8" cy="10.8" r="6.3"/><path d="M15.4 15.4l5.1 5.1"/>',
  /* gorunum:v1-advsearch — sliders, not a funnel. A funnel says "throw rows
     away"; this control opens a dialog where you SET things, and two of its
     three rows are exactly a slider's job (a size range, a time window). */
  filter: '<path d="M4 7.5h4"/><path d="M13 7.5h7"/><circle cx="10.5" cy="7.5" r="2.4"/><path d="M4 16.5h7"/><path d="M16 16.5h4"/><circle cx="13.5" cy="16.5" r="2.4"/>',
  more: '<circle cx="5.5" cy="12" r="1.2" fill="currentColor" stroke="none"/><circle cx="12" cy="12" r="1.2" fill="currentColor" stroke="none"/><circle cx="18.5" cy="12" r="1.2" fill="currentColor" stroke="none"/>',
  close: '<path d="M5.5 5.5l13 13"/><path d="M18.5 5.5l-13 13"/>',
  /* A share link. Two half-chains, which is what a link IS. The details
     panel's "Not shared / Create link" row used to draw a chain EMOJI
     there, i.e. whatever glyph the OS happened to ship, full-colour,
     beside a column of stroked grey ones. */
  link: '<path d="M10 13.5a4.5 4.5 0 0 0 6.8.5l2.7-2.7a4.5 4.5 0 0 0-6.36-6.36L11.6 6.5"/><path d="M14 10.5a4.5 4.5 0 0 0-6.8-.5l-2.7 2.7a4.5 4.5 0 0 0 6.36 6.36l1.53-1.53"/>',
  /* baglan:b1 — "Connections". A PLUG, deliberately not the chain above:
     the empty screen's account menu draws both rows one under the other
     ("Paylaştıklarım", then "Bağlantılar"), and one mark on two adjacent rows
     is the misreading this set exists to stop. It is also the mark the admin
     panel's own Connections entry already wears (web lib/adminNav.ts, lucide `Cable`),
     so the two ways into the same screen agree on what it looks like. */
  connect: '<path d="M9 8.5V3"/><path d="M15 8.5V3"/><path d="M6 8.5h12v4.5a4.5 4.5 0 0 1-4.5 4.5h-3A4.5 4.5 0 0 1 6 13z"/><path d="M12 17.5V21"/>',
  /* === ikon:emoji — the command palette's own rows =======================
   * The palette printed `{{ it.icon }}` as TEXT: `➜ 📁 ⬆ ▦ 🗑 ⟳ ↑ 🎨 ⌨ 🎓 ⧉ ◫
   * 💾 🔖`. Thirteen marks from four different type families, in a list whose
   * neighbours — the context menu it duplicates and the toolbar it launches —
   * had already moved here. Most of the keys it needed were drawn already
   * (`tour` is the mortarboard, `shortcut-settings` the keyboard, the three
   * `view-*` the mode chips); these six are what was genuinely missing. */
  /* "Go to path" — the arrow goes INTO the box, the mirror of `sign-out`.
     A bare arrow would have said "next", which this row is not. */
  goto: '<path d="M13.5 4.5h4a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-4"/><path d="M10 8.2L13.8 12 10 15.8"/><path d="M4.5 12h9.3"/>',
  /* A second pane opened beside the first — `nav`/`inspector`'s panel with the
     divider down the middle, because that is literally what split view is. */
  split: Dm + '<path d="M12 4.5v15"/>',
  /* A new tab: `open-tab`'s window, with the plus in the body rather than on
     the tab strip (at 16px a plus up there merges into the tab). */
  "tab-new": '<rect x="3" y="4.5" width="18" height="15" rx="2"/><path d="M3 9.5h18"/><path d="M9.5 4.5v5"/><path d="M12 12.1v5"/><path d="M9.5 14.6h5"/>',
  bookmark: T_,
  "save-search": T_ + '<path d="M12 7.2v5.2"/><path d="M9.4 9.8h5.2"/>',
  /* The padlock, for the rows and strips that talk ABOUT encryption ("create
     an encrypted folder", "this one is unlocked"). The listing marker is a
     different drawing on purpose — there the lock is cut out of the folder,
     because the row still has to read as a folder. */
  lock: '<rect x="4.5" y="10.3" width="15" height="10.2" rx="2.2"/><path d="M7.9 10.3V7.6a4.1 4.1 0 0 1 8.2 0v2.7"/><circle cx="12" cy="15.4" r="1.5"/>',
  /* === ikon:emoji — states the viewers and modals report ================
   * `✓ ✗ ⚠️ ⏳` in the viewer chrome. The first two are typographic and came
   * out at whatever weight the UI font had; the last two are colour emoji, so
   * a fallback screen's 48px mark was the only full-colour thing on a grey
   * page. `progress` is drawn as an open ring because it is SPUN by CSS
   * (`@keyframes fe-spin`) — an hourglass cannot say "still going". */
  /* An app plugin's row when its manifest names no glyph this set draws: a
     puzzle piece, the mark every extension surface already wears. Rows whose
     manifest icon IS a key here (`convert`, `lock`, …) get that glyph instead
     — lib/pluginMenu decides, this only draws. */
  plugin: '<path d="M9.5 4.5a2 2 0 1 1 4 0h3a1.5 1.5 0 0 1 1.5 1.5v3a2 2 0 1 1 0 4v3a1.5 1.5 0 0 1-1.5 1.5h-3a2 2 0 1 1-4 0h-3A1.5 1.5 0 0 1 5 16v-3a2 2 0 1 1 0-4V6a1.5 1.5 0 0 1 1.5-1.5z"/>',
  /* A pen signing on a line — the e-signature app's own icon (manifest
     `icon: "sign"`). ⚠ Drawn here because a key the catalogue does not know
     falls back to the generic plugin piece: the sidebar and every menu showed
     the Signatures app as "some app" until it was (2026-09-21, a tester). */
  sign: '<path d="M12.5 20.5h8"/><path d="M16.2 3.9a2.05 2.05 0 0 1 2.9 2.9L8 17.9l-3.9 1 1-3.9z"/><path d="M14.6 5.5l2.9 2.9"/>',
  check: '<path d="M4.8 12.6l4.7 4.7L19.2 6.9"/>',
  alert: '<path d="M10.7 4.6L2.9 18.2a1.5 1.5 0 0 0 1.3 2.25h15.6a1.5 1.5 0 0 0 1.3-2.25L13.3 4.6a1.5 1.5 0 0 0-2.6 0z"/><path d="M12 9.9v4.3"/><circle cx="12" cy="17.4" r="0.9" fill="currentColor" stroke="none"/>',
  progress: '<path d="M20.5 12a8.5 8.5 0 1 1-8.5-8.5"/>'
}, K3 = /* @__PURE__ */ new Set(["restore", "goto", "sign-out", "copy-path", "nav", "inspector"]), A_ = /* @__PURE__ */ new Map();
function zt(e) {
  if (!e) return "";
  const t = A_.get(e);
  if (t !== void 0) return t;
  const n = cx[e], a = n ? `<svg class="${K3.has(e) ? "fe-aicon fe-aicon--dir" : "fe-aicon"}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${n}</svg>` : "";
  return A_.set(e, a), a;
}
function cpe() {
  return Object.keys(cx);
}
const V3 = "__fe-ctx-late";
function Dv(e) {
  const t = [];
  for (const n of e)
    n.hidden || n.divider && (t.length === 0 || t[t.length - 1].divider) || t.push(n);
  for (; t.length > 0 && t[t.length - 1].divider; ) t.pop();
  return t;
}
function j3(e, t) {
  const n = /* @__PURE__ */ new Map();
  for (const c of Dv(t))
    !c.divider && !n.has(c.key) && n.set(c.key, c);
  const a = /* @__PURE__ */ new Set(), i = e.map((c) => c.divider ? c : (a.add(c.key), n.get(c.key) ?? { ...c, disabled: !0 })), r = [...n.values()].filter((c) => !a.has(c.key));
  if (!r.length) return i;
  const l = { key: V3, label: "", divider: !0 };
  return [...i, l, ...r];
}
const Qy = 80;
function Rc(e, t = Qy) {
  var i;
  if (typeof window > "u" || typeof document > "u") return t;
  const n = Array.isArray(e) ? e : [e];
  let a = t;
  for (const r of n) {
    let l = r ?? null;
    for (let c = 0; l && c < 200 && !(l === document.body || l === document.documentElement); c++) {
      let p = Number.NaN, m = !1;
      try {
        const v = window.getComputedStyle(l);
        m = (v.position || "static") !== "static", p = Number.parseInt(v.zIndex, 10);
      } catch {
      }
      m && Number.isFinite(p) && p + 1 > a && (a = p + 1), l = l.parentElement ?? /* Out the top of a shadow tree, if the host put us in one. */
      ((i = l.getRootNode()) == null ? void 0 : i.host) ?? null;
    }
  }
  return a;
}
function q3(e, t) {
  if (typeof document > "u") return [];
  const n = [document.activeElement];
  if (typeof e == "number" && typeof t == "number" && document.elementFromPoint)
    try {
      n.push(document.elementFromPoint(e, t));
    } catch {
    }
  return n;
}
const W3 = ["dir", "data-prefers-dark"], Y3 = ["aria-label"], G3 = ["aria-label", "onKeydown"], X3 = { class: "fe-sheet__items" }, J3 = {
  key: 0,
  class: "fe-ctx__sep",
  role: "separator"
}, Z3 = ["disabled", "title", "data-testid", "onClick"], Q3 = ["innerHTML"], eL = {
  key: 1,
  class: "fe-ctx__icon",
  "aria-hidden": "true"
}, tL = { class: "fe-ctx__label" }, nL = {
  key: 2,
  class: "fe-ctx__key",
  "aria-hidden": "true"
}, aL = ["aria-label"], iL = {
  key: 0,
  class: "fe-ctx__sep",
  role: "separator"
}, oL = ["disabled", "title", "data-testid", "onClick"], rL = ["innerHTML"], sL = {
  key: 1,
  class: "fe-ctx__icon",
  "aria-hidden": "true"
}, lL = { class: "fe-ctx__label" }, uL = {
  key: 2,
  class: "fe-ctx__key",
  "aria-hidden": "true"
}, _l = /* @__PURE__ */ lt({
  __name: "ContextMenu",
  props: {
    locale: {},
    actions: {},
    theme: {},
    sheet: { type: Boolean }
  },
  emits: ["select"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, { t: r, dir: l } = ht(() => a.locale);
    function c(Y) {
      return ax(Y.shortcutId ?? Y.key);
    }
    function p(Y) {
      return zt(Y.icon || Y.key);
    }
    const m = S(!1), v = S(0), x = S(0), w = S(Qy), $ = S([]), k = S(null);
    let b = 0, C = 0, T = null;
    async function E(Y, B) {
      var W, F;
      if (T = document.activeElement ?? null, w.value = Rc(q3(Y.clientX, Y.clientY)), se.value = null, q.value = null, m.value = !0, v.value = Y.clientX, x.value = Y.clientY, b = Y.clientX, C = Y.clientY, $.value = B, await Gt(), m.value && (se.value = Dv(a.actions)), a.sheet) {
        const V = (W = L.value) == null ? void 0 : W.getBoundingClientRect().height;
        V && (q.value = V), (F = L.value) == null || F.focus();
        return;
      }
      R(), U(0);
    }
    function R() {
      const Y = k.value;
      if (!Y || typeof window > "u") return;
      Y.style.maxHeight = "", Y.style.overflowY = "";
      const B = Y.getBoundingClientRect(), W = 8, F = window.innerWidth, V = window.innerHeight, ke = V - 2 * W;
      if (B.height > ke) {
        Y.style.maxHeight = ke + "px", Y.style.overflowY = "auto", x.value = W, v.value = e_(b, B.width, F, l.value, W);
        return;
      }
      if (C + B.height > V - W) {
        const qe = C - B.height;
        x.value = qe >= W ? qe : Math.max(W, V - B.height - W);
      }
      v.value = e_(b, B.width, F, l.value, W);
    }
    function z() {
      var Y;
      m.value = !1, se.value = null, q.value = null, P.value = !1, K.value = 0, (Y = T == null ? void 0 : T.focus) == null || Y.call(T), T = null;
    }
    function D() {
      const Y = a.sheet ? L.value : k.value;
      return Y ? Array.from(
        Y.querySelectorAll(".fe-ctx__item:not(:disabled)")
      ) : [];
    }
    function U(Y) {
      var F;
      const B = D();
      if (B.length === 0) return;
      const W = (Y % B.length + B.length) % B.length;
      (F = B[W]) == null || F.focus();
    }
    function H(Y) {
      const B = D();
      if (B.length === 0) return;
      const W = document.activeElement, F = W ? B.indexOf(W) : -1;
      if (F === -1) {
        U(Y > 0 ? 0 : B.length - 1);
        return;
      }
      U(F + Y);
    }
    const L = S(null), P = S(!1), K = S(0);
    let N = 0;
    function J(Y) {
      const B = Y.touches[0];
      B && (P.value = !0, N = B.clientY, K.value = 0);
    }
    function j(Y) {
      if (!P.value) return;
      const B = Y.touches[0];
      B && (K.value = Math.max(0, B.clientY - N));
    }
    function re() {
      if (!P.value) return;
      const Y = K.value > 72;
      P.value = !1, Y ? z() : K.value = 0;
    }
    const q = S(null), le = A(() => {
      const Y = {};
      return q.value !== null && (Y.height = `${q.value}px`), K.value > 0 && (Y.transform = `translateY(${K.value}px)`, Y.transition = "none"), Object.keys(Y).length ? Y : void 0;
    });
    function ve(Y) {
      Y.disabled || (i("select", Y, $.value), z());
    }
    function ce(Y) {
      if (Y.key === "Escape") {
        Y.stopPropagation(), z();
        return;
      }
      if (Y.key === "Enter" || Y.key === " ") {
        Y.stopPropagation();
        return;
      }
      Y.key === "ArrowDown" ? (Y.preventDefault(), Y.stopPropagation(), H(1)) : Y.key === "ArrowUp" ? (Y.preventDefault(), Y.stopPropagation(), H(-1)) : Y.key === "Home" ? (Y.preventDefault(), U(0)) : Y.key === "End" ? (Y.preventDefault(), U(-1)) : Y.key === "Tab" && (Y.preventDefault(), z());
    }
    const se = S(null), fe = A(
      () => se.value ? j3(se.value, a.actions) : Dv(a.actions)
    );
    Je(
      () => fe.value.length,
      async () => {
        if (!m.value || !se.value || a.sheet) return;
        await Gt();
        const Y = k.value;
        if (!Y || typeof window > "u") return;
        const B = Y.getBoundingClientRect(), W = window.innerHeight - 8 - B.top;
        W > 0 && B.height > W && (Y.style.maxHeight = W + "px", Y.style.overflowY = "auto");
      }
    );
    const _ = Nl(), ee = A(() => `fe-ctx-backdrop--theme-${a.theme || "auto"}`);
    return t({ show: E, hide: z }), (Y, B) => (f(), Ge(wi, { to: "body" }, [
      Ze(Rr, {
        name: e.sheet ? "fe-sheet" : "fe-ctx"
      }, {
        default: mt(() => [
          m.value ? (f(), h("div", {
            key: 0,
            class: Re(["fe-ctx-backdrop", [ee.value, { "fe-ctx-backdrop--sheet": e.sheet }]]),
            dir: u(l),
            style: Yt({
              zIndex: w.value
              /* katman:z1 */
            }),
            "data-prefers-dark": u(_) ? "1" : "0",
            onClick: z,
            onContextmenu: yt(z, ["prevent"]),
            onKeydown: ce
          }, [
            e.sheet ? (f(), h("div", {
              key: 0,
              ref_key: "sheetEl",
              ref: L,
              class: "fe-sheet",
              role: "menu",
              "aria-label": u(r)("sheet.menu"),
              tabindex: "-1",
              style: Yt(le.value),
              onClick: B[0] || (B[0] = yt(() => {
              }, ["stop"]))
            }, [
              d("div", {
                class: "fe-sheet__handle",
                role: "button",
                tabindex: "0",
                "aria-label": u(r)("sheet.close"),
                onClick: z,
                onKeydown: Ca(yt(z, ["prevent"]), ["enter"]),
                onTouchstartPassive: J,
                onTouchmovePassive: j,
                onTouchend: re,
                onTouchcancel: re
              }, null, 40, G3),
              d("div", X3, [
                (f(!0), h(Te, null, nt(fe.value, (W, F) => (f(), h(Te, {
                  key: W.key || F
                }, [
                  W.divider ? (f(), h("div", J3)) : (f(), h("button", {
                    key: 1,
                    type: "button",
                    class: Re(["fe-ctx__item fe-sheet__item", { "is-danger": W.danger, "is-disabled": W.disabled }]),
                    disabled: W.disabled,
                    title: W.title,
                    "data-testid": W.testid,
                    role: "menuitem",
                    onClick: (V) => ve(W)
                  }, [
                    p(W) ? (f(), h("span", {
                      key: 0,
                      class: "fe-ctx__icon",
                      "aria-hidden": "true",
                      innerHTML: p(W)
                    }, null, 8, Q3)) : W.icon ? (f(), h("span", eL, y(W.icon), 1)) : O("", !0),
                    d("span", tL, y(W.label), 1),
                    c(W) ? (f(), h("span", nL, y(c(W)), 1)) : O("", !0)
                  ], 10, Z3))
                ], 64))), 128))
              ])
            ], 12, Y3)) : (f(), h("div", {
              key: 1,
              ref_key: "menuEl",
              ref: k,
              class: "fe-ctx",
              role: "menu",
              "aria-orientation": "vertical",
              "aria-label": u(r)("sheet.menu"),
              style: Yt({ top: x.value + "px", left: v.value + "px" }),
              onClick: B[1] || (B[1] = yt(() => {
              }, ["stop"]))
            }, [
              (f(!0), h(Te, null, nt(fe.value, (W, F) => (f(), h(Te, {
                key: W.key || F
              }, [
                W.divider ? (f(), h("div", iL)) : (f(), h("button", {
                  key: 1,
                  type: "button",
                  class: Re(["fe-ctx__item", { "is-danger": W.danger, "is-disabled": W.disabled }]),
                  disabled: W.disabled,
                  title: W.title,
                  "data-testid": W.testid,
                  role: "menuitem",
                  onClick: (V) => ve(W)
                }, [
                  p(W) ? (f(), h("span", {
                    key: 0,
                    class: "fe-ctx__icon",
                    "aria-hidden": "true",
                    innerHTML: p(W)
                  }, null, 8, rL)) : W.icon ? (f(), h("span", sL, y(W.icon), 1)) : O("", !0),
                  d("span", lL, y(W.label), 1),
                  c(W) ? (f(), h("span", uL, y(c(W)), 1)) : O("", !0)
                ], 10, oL))
              ], 64))), 128))
            ], 12, aL))
          ], 46, W3)) : O("", !0)
        ]),
        _: 1
      }, 8, ["name"])
    ]));
  }
}), cL = ["aria-pressed", "title", "aria-label"], dL = {
  key: 1,
  class: "fe-toolbar__mark"
}, fL = ["src"], pL = { key: 1 }, hL = { class: "fe-toolbar__primary" }, mL = ["title"], vL = ["innerHTML"], yL = { class: "fe-btn__label" }, gL = ["title", "aria-label"], bL = ["innerHTML"], kL = ["title"], wL = ["innerHTML"], _L = { class: "fe-btn__label" }, xL = { class: "fe-toolbar__search-group fe-toolbar__search-group--drive" }, SL = {
  class: "fe-search fe-drivesearch",
  "data-testid": "drive-search"
}, $L = ["placeholder", "value", "aria-label"], TL = ["title", "aria-label"], AL = ["innerHTML"], EL = ["title", "aria-label"], CL = { class: "fe-toolbar__tail" }, zL = ["title", "aria-label"], ML = ["innerHTML"], PL = ["title", "aria-label", "aria-pressed"], OL = ["innerHTML"], LL = ["title", "aria-label"], DL = ["innerHTML"], RL = {
  class: "fe-drivesearch",
  "data-testid": "drive-search"
}, NL = ["placeholder", "value", "aria-label"], IL = ["title", "aria-label"], BL = ["innerHTML"], FL = ["title", "aria-label"], UL = { class: "fe-toolbar__tail" }, HL = ["title", "aria-label", "aria-pressed"], KL = ["innerHTML"], VL = ["title", "aria-label"], jL = ["innerHTML"], qL = ["aria-label"], WL = {
  class: "fe-selbar__count",
  role: "status",
  "data-testid": "selection-count"
}, YL = ["disabled", "title", "aria-label", "data-key", "data-testid", "onClick"], GL = ["innerHTML"], XL = ["title", "aria-label"], JL = ["innerHTML"], ZL = ["data-key"], QL = ["innerHTML"], eD = ["title", "aria-label"], tD = ["innerHTML"], uf = "filex.density", nD = 32, E_ = "fe:header-menu", aD = /* @__PURE__ */ lt({
  __name: "Toolbar",
  props: {
    viewMode: {},
    searchQuery: {},
    trashActive: { type: Boolean },
    actions: {},
    selectionMode: {},
    selectionCount: {},
    selectionPane: {},
    pasteEnabled: { type: Boolean },
    canGoUp: { type: Boolean },
    atVirtualRoot: { type: Boolean },
    canWrite: { type: Boolean },
    locale: {},
    languageRow: { type: Boolean },
    narrow: { type: Boolean },
    theme: {},
    inspectorOpen: { type: Boolean },
    assistantButton: { type: Boolean },
    assistantOpen: { type: Boolean },
    navOpen: { type: Boolean },
    navEnabled: { type: Boolean },
    viewModes: {},
    scopeLabel: {},
    brandName: {},
    brandMarkUrl: {},
    searchEscalates: { type: Boolean }
  },
  emits: ["update:viewMode", "update:searchQuery", "open-advanced-search", "new-folder", "upload", "refresh", "go-up", "action", "open-recents", "update:density", "toggle-inspector", "toggle-assistant", "toggle-nav", "open-theme", "open-shortcut-settings", "open-timezone", "open-language", "open-palette"],
  setup(e, { expose: t, emit: n }) {
    function a(te) {
      return zt(te.icon || te.key);
    }
    const i = e, r = n, l = S(
      (() => {
        try {
          return localStorage.getItem(uf) === "compact" ? "compact" : "comfortable";
        } catch {
          return "comfortable";
        }
      })()
    );
    function c() {
      try {
        const te = localStorage.getItem(uf) === "compact" ? "compact" : "comfortable";
        te !== l.value && (l.value = te, r("update:density", te));
      } catch {
      }
    }
    function p(te) {
      (te.key === null || te.key === uf) && c();
    }
    jt(() => {
      r("update:density", l.value), window.addEventListener("storage", p), window.addEventListener("filex:density", c);
    }), Tt(() => {
      window.removeEventListener("storage", p), window.removeEventListener("filex:density", c);
    });
    function m() {
      l.value = l.value === "compact" ? "comfortable" : "compact";
      try {
        localStorage.setItem(uf, l.value);
      } catch {
      }
      r("update:density", l.value);
    }
    const { t: v, dir: x } = ht(() => i.locale), w = S(null), $ = S(i.searchQuery);
    Je(() => i.searchQuery, (te) => {
      $.value = te;
    });
    let k;
    function b(te) {
      const Ce = te.target.value;
      $.value = Ce, k && clearTimeout(k), k = setTimeout(() => r("update:searchQuery", Ce), 200);
    }
    async function C() {
      var te, Ce;
      await Gt(), (te = w.value) == null || te.focus(), (Ce = w.value) == null || Ce.select();
    }
    t({ focusSearch: C });
    const T = A(() => i.selectionMode ?? "none"), E = A(() => i.actions.filter((te) => !te.divider && !te.hidden)), R = /* @__PURE__ */ new Set(["download", "access", "cut", "copy", "star", "restore", "delete"]), z = A(() => T.value !== "none"), D = A(() => {
      const te = [], Ce = [];
      let Ie = 0;
      for (const _e of i.actions)
        if (!_e.hidden) {
          if (_e.divider) {
            Ce.push(_e);
            continue;
          }
          R.has(_e.key) && a(_e) ? te.push(_e) : (Ce.push(_e), Ie++);
        }
      return { icons: te, rest: Ie ? Ce : [], restCount: Ie };
    }), U = S(null), H = S(null), L = S(null), P = S(null), K = S(Number.MAX_SAFE_INTEGER), N = A(() => D.value.icons.slice(0, K.value)), J = A(() => D.value.icons.slice(K.value)), j = A(() => {
      const te = J.value, Ce = D.value.rest;
      return te.length && Ce.length ? [...te, { divider: !0, key: "selbar-sep", label: "" }, ...Ce] : [...te, ...Ce];
    });
    function re() {
      var bn;
      const te = U.value, Ce = H.value, Ie = D.value.icons.length;
      if (!te || !Ce) {
        K.value = Ie;
        return;
      }
      const _e = parseFloat(getComputedStyle(te).gap) || 4, Ae = Array.from(Ce.children).map((ln) => ln.offsetWidth + _e), Pe = Ae.reduce((ln, Jt) => ln + Jt, 0), _t = te.clientWidth, Et = (((bn = L.value) == null ? void 0 : bn.offsetWidth) || nD) + _e;
      if (Pe <= _t - (D.value.rest.length ? Et : 0)) {
        K.value = Ae.length;
        return;
      }
      let xn = Et, Dt = 0;
      for (const ln of Ae) {
        if (xn + ln > _t) break;
        xn += ln, Dt += 1;
      }
      K.value = Dt;
    }
    let q;
    Je(U, (te) => {
      q == null || q.disconnect(), q = void 0, te && typeof ResizeObserver < "u" && (q = new ResizeObserver(() => re()), q.observe(te)), Gt(re);
    }), Tt(() => q == null ? void 0 : q.disconnect()), Je(
      () => [E.value, i.narrow, i.trashActive, T.value],
      () => void Gt(re),
      { deep: !1 }
    );
    function le() {
      var Ce, Ie;
      const te = (Ce = L.value) == null ? void 0 : Ce.getBoundingClientRect();
      (Ie = P.value) == null || Ie.show({ clientX: te ? Qw(te, x.value) : 0, clientY: te ? te.bottom + 4 : 0 }, []);
    }
    const ve = S(null), ce = Ea(null), se = S(!1), fe = Ea(null), _ = Ea(null);
    function ee() {
      var Ie;
      const te = (Ie = ve.value) == null ? void 0 : Ie.closest(".fe");
      if (!te) return null;
      const Ce = i.selectionPane;
      if (Ce && /^[A-Za-z][\w-]*$/.test(Ce)) {
        const _e = te.querySelector(`.fe__primary[data-pane="${Ce}"]`);
        if (_e) return _e;
      }
      return te.querySelector(".fe__primary");
    }
    function Y() {
      const te = ce.value;
      te && (te.classList.remove("is-active"), se.value && te.remove()), ce.value = null, se.value = !1;
    }
    function B() {
      var Ie;
      const te = ee();
      if (!te) {
        Y(), _.value = null, fe.value = null;
        return;
      }
      if (_.value === te && ((Ie = ce.value) != null && Ie.isConnected)) return;
      Y(), _.value = te, fe.value = te.querySelector(":scope > .fe__body");
      const Ce = te.querySelector(":scope > .fe-selbar-slot");
      if (Ce)
        ce.value = Ce, se.value = !1;
      else {
        const _e = document.createElement("div");
        _e.className = "fe-selbar-slot";
        const Ae = te.querySelector(":scope > .fe-tabs") ?? te.querySelector(":scope > .fe-subhead, :scope > .fe-subhead--plain");
        Ae ? Ae.insertAdjacentElement("afterend", _e) : te.prepend(_e), ce.value = _e, se.value = !0;
      }
      W(), Fe();
    }
    jt(B), Tt(Y);
    function W() {
      var te;
      (te = ce.value) == null || te.classList.toggle("is-active", z.value);
    }
    Je(z, W, { immediate: !0 }), Je([() => i.selectionPane, z], () => B());
    const F = S(0);
    let V, ke = !1;
    function qe() {
      const te = _.value;
      te && (F.value = te.querySelectorAll('[data-fe-path][aria-selected="true"]').length);
    }
    function Me() {
      if (ke) return;
      ke = !0, ((Ce) => typeof requestAnimationFrame == "function" ? requestAnimationFrame(Ce) : setTimeout(Ce, 16))(() => {
        ke = !1, qe();
      });
    }
    function Fe() {
      if (V == null || V.disconnect(), V = void 0, !z.value) {
        F.value = 0;
        return;
      }
      qe(), !(typeof MutationObserver > "u" || !_.value) && (V = new MutationObserver(Me), V.observe(_.value, {
        subtree: !0,
        childList: !0,
        attributes: !0,
        attributeFilter: ["aria-selected"]
      }));
    }
    Je(z, Fe), Tt(() => V == null ? void 0 : V.disconnect());
    const We = A(() => typeof i.selectionCount == "number" ? i.selectionCount : T.value === "none" ? 0 : Math.max(F.value, T.value === "multi" ? 2 : 1)), $t = A(() => v("selection.count", { n: String(We.value) }));
    function St() {
      var te;
      r("action", "clear-selection"), (te = fe.value) == null || te.dispatchEvent(new MouseEvent("click", { bubbles: !0 }));
    }
    function at(te) {
      r("action", te);
    }
    const kt = S(!1);
    let pt;
    function Ne(te) {
      kt.value = !!(te && "matches" in te && te.matches);
    }
    jt(() => {
      var te;
      typeof window > "u" || !window.matchMedia || (pt = window.matchMedia("(pointer: coarse)"), Ne(pt), (te = pt.addEventListener) == null || te.call(pt, "change", Ne));
    }), Tt(() => {
      var te;
      (te = pt == null ? void 0 : pt.removeEventListener) == null || te.call(pt, "change", Ne);
    });
    const ie = S(null), xe = S(null);
    function he(te) {
      return !i.viewModes || i.viewModes.includes(te);
    }
    const De = A(() => {
      const te = [];
      return i.narrow && te.push({ key: "refresh", label: v("toolbar.refresh") }), te.push({
        key: "density",
        label: l.value === "compact" ? v("toolbar.density.comfortable") : v("toolbar.density.compact")
      }), i.viewMode !== "list" && he("list") && te.push({ key: "view-list", label: v("toolbar.view.list") }), i.viewMode !== "grid" && he("grid") && te.push({ key: "view-grid", label: v("toolbar.view.grid") }), i.viewMode !== "gallery" && he("gallery") && te.push({ key: "view-gallery", label: v("toolbar.view.gallery") }), te.push({ key: "inspector", label: v("toolbar.inspector") }), te.push({ key: "theme", label: v("theme.menu") }), te.push({ key: "timezone", label: v("tz.menu") }), i.languageRow && te.push({ key: "language", label: v("lang.menu") }), te.push({ key: "shortcut-settings", label: v("shortcuts.settings.menu") }), te.push({ key: "tour", label: v("tour.restart") }), te;
    });
    function ot(te) {
      const Ce = [], Ie = !i.trashActive && !i.atVirtualRoot && i.canWrite !== !1;
      return T.value === "none" && Ie && (Ce.push({ key: "new-folder", label: v("toolbar.new_folder") }), i.pasteEnabled && Ce.push({ key: "paste", label: v("ctx.paste") })), z.value || Ce.push(...E.value), te.length && (Ce.length && Ce.push({ divider: !0, key: "bag-sep", label: "" }), Ce.push(...te)), Ce;
    }
    const ft = A(() => qy("palette"));
    function gt(te, Ce) {
      const Ie = ax(Ce);
      return Ie ? `${te} (${Ie})` : te;
    }
    const Ut = A(() => i.narrow ? i.navOpen ? v("sidenav.close") : v("sidenav.open") : i.navOpen ? v("sidenav.collapse") : v("sidenav.expand")), Xe = A(
      () => i.scopeLabel ? v("drive.search.placeholder", { scope: i.scopeLabel }) : v("drive.search.placeholder_all")
    );
    function Ve(te) {
      if (ix(te, "palette")) {
        te.preventDefault(), te.stopPropagation(), r("open-palette", $.value);
        return;
      }
      i.searchEscalates && te.key === "Enter" && $.value && (te.preventDefault(), te.stopPropagation(), r("open-palette", $.value));
    }
    const Be = S(!1);
    function ne() {
      const te = ve.value;
      if (!te) return;
      const Ce = {
        items: De.value.map((Ie) => ({ ...Ie })),
        run: (Ie) => ye({ key: Ie }),
        claimed: !1
      };
      te.dispatchEvent(
        new CustomEvent(E_, { detail: Ce, bubbles: !0, composed: !0 })
      ), Be.value = !!Ce.claimed;
    }
    jt(() => void Gt(ne)), Je(De, () => void Gt(ne), { deep: !1 }), Tt(() => {
      typeof document > "u" || document.dispatchEvent(
        new CustomEvent(E_, {
          detail: { items: [], run: () => {
          }, claimed: !1 }
        })
      );
    });
    const ge = A(() => {
      const te = Be.value ? [] : De.value;
      return i.narrow ? ot(te) : te;
    });
    function G() {
      var Ce, Ie;
      const te = (Ce = ie.value) == null ? void 0 : Ce.getBoundingClientRect();
      (Ie = xe.value) == null || Ie.show({ clientX: te ? Qw(te, x.value) : 0, clientY: te ? te.bottom + 4 : 0 }, []);
    }
    function ye(te) {
      var Ce;
      switch (te.key) {
        case "new-folder":
          r("new-folder");
          break;
        case "refresh":
          r("refresh");
          break;
        case "density":
          m();
          break;
        case "view-list":
          r("update:viewMode", "list");
          break;
        case "view-grid":
          r("update:viewMode", "grid");
          break;
        case "view-gallery":
          r("update:viewMode", "gallery");
          break;
        case "inspector":
          r("toggle-inspector");
          break;
        case "nav":
          r("toggle-nav");
          break;
        case "theme":
          r("open-theme");
          break;
        case "shortcut-settings":
          r("open-shortcut-settings");
          break;
        case "timezone":
          r("open-timezone");
          break;
        case "language":
          r("open-language");
          break;
        case "tour":
          (Ce = ve.value) == null || Ce.dispatchEvent(new CustomEvent("fe:tour-restart", { bubbles: !0 }));
          break;
        default:
          at(te.key);
      }
    }
    return (te, Ce) => (f(), h("div", {
      ref_key: "rootEl",
      ref: ve,
      class: Re(["fe-toolbar", {
        "fe-toolbar--narrow": e.narrow,
        /* surucu:d1 — ALWAYS on. It is no longer a variant: this is the only
           header filex has, and the modifier survives as the hook the one
           visual definition in styles/base.css was written against. Dropping it
           would mean moving those rules, not deleting a state. */
        "fe-toolbar--drive": !0
      }])
    }, [
      e.navEnabled !== !1 || te.$slots.brand || e.brandName || e.brandMarkUrl ? (f(), h("div", {
        key: 0,
        class: Re(["fe-toolbar__brand", {
          "fe-toolbar__brand--gutter": e.navEnabled !== !1,
          /* gezinti:g3 — the panel collapsed to its rail, so this gutter has to
             collapse with it. `navOpen === false`, never `!navOpen`: the prop is
             optional, and an embedder that does not pass it must keep the
             expanded layout rather than lose its wordmark to a `undefined`. */
          "fe-toolbar__brand--rail": !e.narrow && e.navEnabled !== !1 && e.navOpen === !1
        }])
      }, [
        e.navEnabled !== !1 ? (f(), h("button", {
          key: 0,
          type: "button",
          class: "fe-btn fe-btn--icon-only fe-toolbar__nav",
          "aria-pressed": !!e.navOpen,
          title: Ut.value,
          "aria-label": Ut.value,
          "data-testid": "toolbar-nav",
          onClick: Ce[0] || (Ce[0] = (Ie) => r("toggle-nav"))
        }, [...Ce[12] || (Ce[12] = [
          d("svg", {
            class: "fe-ficon",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.8",
            "stroke-linecap": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            d("path", { d: "M4 7h16M4 12h16M4 17h16" })
          ], -1)
        ])], 8, cL)) : O("", !0),
        !e.narrow && e.navOpen !== !1 ? (f(), h("div", dL, [
          On(te.$slots, "brand", {}, () => [
            e.brandMarkUrl ? (f(), h("img", {
              key: 0,
              class: "fe-toolbar__markimg",
              src: e.brandMarkUrl,
              alt: ""
            }, null, 8, fL)) : O("", !0),
            e.brandName ? (f(), h("span", pL, y(e.brandName), 1)) : O("", !0)
          ])
        ])) : O("", !0)
      ], 2)) : O("", !0),
      e.narrow ? (f(), h(Te, { key: 2 }, [
        d("div", RL, [
          Ce[14] || (Ce[14] = d("svg", {
            class: "fe-ficon fe-drivesearch__glass",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.9",
            "stroke-linecap": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            d("circle", {
              cx: "11",
              cy: "11",
              r: "6.5"
            }),
            d("path", { d: "M16 16l4.5 4.5" })
          ], -1)),
          d("input", {
            ref_key: "searchEl",
            ref: w,
            type: "search",
            class: "fe-drivesearch__input",
            placeholder: Xe.value,
            value: $.value,
            "aria-label": u(v)("toolbar.search"),
            onInput: b,
            onKeydown: Ve
          }, null, 40, NL),
          d("button", {
            type: "button",
            class: "fe-drivesearch__tune",
            title: u(v)("advsearch.open"),
            "aria-label": u(v)("advsearch.open"),
            "data-testid": "drive-search-advanced",
            onClick: Ce[8] || (Ce[8] = (Ie) => r("open-advanced-search", $.value))
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("filter")
            }, null, 8, BL)
          ], 8, IL),
          d("button", {
            type: "button",
            class: "fe-drivesearch__kbd",
            title: u(v)("drive.search.hint_title", { combo: ft.value }),
            "aria-label": u(v)("drive.search.hint_title", { combo: ft.value }),
            "data-testid": "drive-search-palette",
            onClick: Ce[9] || (Ce[9] = (Ie) => r("open-palette", $.value))
          }, y(ft.value), 9, FL)
        ]),
        d("div", UL, [
          e.assistantButton ? (f(), h("button", {
            key: 0,
            type: "button",
            class: Re(["fe-btn fe-btn--icon-only", { "is-active": e.assistantOpen }]),
            title: u(v)("ai.assistant"),
            "aria-label": u(v)("ai.assistant"),
            "aria-pressed": e.assistantOpen ? "true" : "false",
            "data-testid": "header-ai",
            onClick: Ce[10] || (Ce[10] = (Ie) => r("toggle-assistant"))
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("ai")
            }, null, 8, KL)
          ], 10, HL)) : O("", !0),
          ge.value.length > 0 ? (f(), h("button", {
            key: 1,
            ref_key: "moreBtnEl",
            ref: ie,
            type: "button",
            class: "fe-btn fe-btn--icon-only",
            title: u(v)("toolbar.more"),
            "aria-label": u(v)("toolbar.more"),
            "aria-haspopup": "menu",
            "data-testid": "drive-more",
            onClick: G
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("more")
            }, null, 8, jL)
          ], 8, VL)) : O("", !0),
          On(te.$slots, "header-actions")
        ])
      ], 64)) : (f(), h(Te, { key: 1 }, [
        d("div", hL, [
          e.navEnabled === !1 && T.value === "none" && !e.trashActive && !e.atVirtualRoot && e.canWrite !== !1 ? (f(), h("button", {
            key: 0,
            type: "button",
            class: "fe-btn fe-btn--primary",
            title: gt(u(v)("toolbar.new_folder"), "new-folder"),
            onClick: Ce[1] || (Ce[1] = (Ie) => r("new-folder"))
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("new-folder")
            }, null, 8, vL),
            d("span", yL, y(u(v)("toolbar.new_folder")), 1)
          ], 8, mL)) : O("", !0),
          e.navEnabled === !1 && !e.atVirtualRoot && e.canWrite !== !1 ? (f(), h("button", {
            key: 1,
            type: "button",
            class: "fe-btn fe-btn--icon-only",
            title: gt(u(v)("toolbar.upload"), "upload"),
            "aria-label": u(v)("toolbar.upload"),
            onClick: Ce[2] || (Ce[2] = (Ie) => r("upload"))
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("upload")
            }, null, 8, bL)
          ], 8, gL)) : O("", !0),
          e.pasteEnabled && T.value === "none" && !e.trashActive && !e.atVirtualRoot && e.canWrite !== !1 ? (f(), h("button", {
            key: 2,
            type: "button",
            class: "fe-btn",
            title: gt(u(v)("ctx.paste"), "paste"),
            onClick: Ce[3] || (Ce[3] = (Ie) => at("paste"))
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("paste")
            }, null, 8, wL),
            d("span", _L, y(u(v)("ctx.paste")), 1)
          ], 8, kL)) : O("", !0)
        ]),
        d("div", xL, [
          d("div", SL, [
            Ce[13] || (Ce[13] = d("svg", {
              class: "fe-ficon fe-drivesearch__glass",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.9",
              "stroke-linecap": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              d("circle", {
                cx: "11",
                cy: "11",
                r: "6.5"
              }),
              d("path", { d: "M16 16l4.5 4.5" })
            ], -1)),
            d("input", {
              ref_key: "searchEl",
              ref: w,
              type: "search",
              class: "fe-search__input fe-drivesearch__input",
              placeholder: Xe.value,
              value: $.value,
              "aria-label": u(v)("toolbar.search"),
              onInput: b,
              onKeydown: Ve
            }, null, 40, $L),
            d("button", {
              type: "button",
              class: "fe-drivesearch__tune",
              title: u(v)("advsearch.open"),
              "aria-label": u(v)("advsearch.open"),
              "data-testid": "drive-search-advanced",
              onClick: Ce[4] || (Ce[4] = (Ie) => r("open-advanced-search", $.value))
            }, [
              d("span", {
                class: "fe-icon",
                "aria-hidden": "true",
                innerHTML: u(zt)("filter")
              }, null, 8, AL)
            ], 8, TL),
            d("button", {
              type: "button",
              class: "fe-drivesearch__kbd",
              title: u(v)("drive.search.hint_title", { combo: ft.value }),
              "aria-label": u(v)("drive.search.hint_title", { combo: ft.value }),
              "data-testid": "drive-search-palette",
              onClick: Ce[5] || (Ce[5] = (Ie) => r("open-palette", $.value))
            }, y(ft.value), 9, EL)
          ])
        ]),
        d("div", CL, [
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--icon-only",
            title: gt(u(v)("toolbar.refresh"), "refresh"),
            "aria-label": u(v)("toolbar.refresh"),
            onClick: Ce[6] || (Ce[6] = (Ie) => r("refresh"))
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("refresh")
            }, null, 8, ML)
          ], 8, zL),
          e.assistantButton ? (f(), h("button", {
            key: 0,
            type: "button",
            class: Re(["fe-btn fe-btn--icon-only", { "is-active": e.assistantOpen }]),
            title: u(v)("ai.assistant"),
            "aria-label": u(v)("ai.assistant"),
            "aria-pressed": e.assistantOpen ? "true" : "false",
            "data-testid": "header-ai",
            onClick: Ce[7] || (Ce[7] = (Ie) => r("toggle-assistant"))
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("ai")
            }, null, 8, OL)
          ], 10, PL)) : O("", !0),
          ge.value.length > 0 ? (f(), h("button", {
            key: 1,
            ref_key: "moreBtnEl",
            ref: ie,
            type: "button",
            class: "fe-btn fe-btn--icon-only",
            title: u(v)("toolbar.more"),
            "aria-label": u(v)("toolbar.more"),
            "aria-haspopup": "menu",
            "data-testid": "drive-more",
            onClick: G
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("more")
            }, null, 8, DL)
          ], 8, LL)) : O("", !0),
          On(te.$slots, "header-actions")
        ])
      ], 64)),
      Ze(_l, {
        ref_key: "moreRef",
        ref: xe,
        locale: e.locale,
        theme: e.theme || "auto",
        sheet: kt.value,
        actions: ge.value,
        onSelect: ye
      }, null, 8, ["locale", "theme", "sheet", "actions"]),
      (f(), Ge(wi, {
        to: ce.value || "body",
        disabled: !ce.value
      }, [
        z.value ? (f(), h("div", {
          key: 0,
          class: Re(["fe-selbar", { "fe-selbar--inline": !ce.value }]),
          role: "toolbar",
          "aria-label": $t.value,
          "data-testid": "selection-bar"
        }, [
          d("span", WL, y($t.value), 1),
          d("div", {
            ref_key: "selBarEl",
            ref: U,
            class: "fe-selbar__actions"
          }, [
            (f(!0), h(Te, null, nt(N.value, (Ie) => (f(), h("button", {
              key: Ie.key,
              type: "button",
              class: Re(["fe-selbar__btn", { "fe-selbar__btn--danger": Ie.danger, "is-disabled": Ie.disabled }]),
              disabled: Ie.disabled,
              title: Ie.title || gt(Ie.label, Ie.key),
              "aria-label": Ie.label,
              "data-key": Ie.key,
              "data-testid": `selbar-${Ie.key}`,
              onClick: (_e) => at(Ie.key)
            }, [
              d("span", {
                class: "fe-icon",
                "aria-hidden": "true",
                innerHTML: a(Ie)
              }, null, 8, GL)
            ], 10, YL))), 128)),
            j.value.length > 0 ? (f(), h("button", {
              key: 0,
              ref_key: "selMoreBtnEl",
              ref: L,
              type: "button",
              class: "fe-selbar__btn",
              title: u(v)("toolbar.more"),
              "aria-label": u(v)("toolbar.more"),
              "aria-haspopup": "menu",
              "data-testid": "selbar-more",
              onClick: le
            }, [
              d("span", {
                class: "fe-icon",
                "aria-hidden": "true",
                innerHTML: u(zt)("more")
              }, null, 8, JL)
            ], 8, XL)) : O("", !0),
            d("div", {
              ref_key: "measureEl",
              ref: H,
              class: "fe-selbar__measure",
              "aria-hidden": "true"
            }, [
              (f(!0), h(Te, null, nt(D.value.icons, (Ie) => (f(), h("button", {
                key: "m-" + Ie.key,
                type: "button",
                class: "fe-selbar__btn",
                "data-key": Ie.key,
                tabindex: "-1"
              }, [
                d("span", {
                  class: "fe-icon",
                  "aria-hidden": "true",
                  innerHTML: a(Ie)
                }, null, 8, QL)
              ], 8, ZL))), 128))
            ], 512)
          ], 512),
          d("button", {
            type: "button",
            class: "fe-selbar__close",
            title: u(v)("selection.clear"),
            "aria-label": u(v)("selection.clear"),
            "data-testid": "selection-clear",
            onClick: St
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("close")
            }, null, 8, tD)
          ], 8, eD)
        ], 10, qL)) : O("", !0)
      ], 8, ["to", "disabled"])),
      Ze(_l, {
        ref_key: "selMoreRef",
        ref: P,
        locale: e.locale,
        theme: e.theme || "auto",
        sheet: kt.value,
        actions: j.value,
        onSelect: Ce[11] || (Ce[11] = (Ie) => at(Ie.key))
      }, null, 8, ["locale", "theme", "sheet", "actions"])
    ], 2));
  }
}), iD = 6e4;
function oD(e) {
  return e === "personal" || e === "team";
}
function dpe(e, t) {
  var n;
  return (n = e.find((a) => a.name === t)) == null ? void 0 : n.key;
}
function Rv(e) {
  const t = e ?? {};
  return Array.isArray(t.items) ? t.items.filter(
    (n) => !!n && typeof n.name == "string" && n.name !== "" && oD(n.kind)
  ) : Array.isArray(t.tags) ? t.tags.filter((n) => typeof n == "string" && n !== "").map((n) => ({ name: n, kind: "team" })) : [];
}
const Nv = /* @__PURE__ */ new Map(), Ef = /* @__PURE__ */ new Map();
function rD() {
  Nv.clear(), Ef.clear();
}
const Iv = /* @__PURE__ */ new Set();
function sD(e) {
  return Iv.add(e), () => {
    Iv.delete(e);
  };
}
function lD() {
  rD();
  for (const e of [...Iv])
    try {
      e();
    } catch {
    }
}
async function C_(e = {}) {
  const t = e.apiBase ?? "", n = t || "(same-origin)";
  if (!e.force) {
    const i = Nv.get(n);
    if (i && Date.now() - i.at < iD) return i.tags;
    const r = Ef.get(n);
    if (r) return r;
  }
  const a = (async () => {
    try {
      const i = await fetch(`${t}/api/files/manager/tags/all`, {
        headers: await (e.authHeaders ?? (() => ({})))(),
        credentials: e.authCredentials ?? "same-origin"
      });
      if (!i.ok) return [];
      const r = Rv(await i.json());
      return Nv.set(n, { at: Date.now(), tags: r }), r;
    } catch {
      return [];
    } finally {
      Ef.delete(n);
    }
  })();
  return Ef.set(n, a), a;
}
async function uD(e, t = {}, n = {}) {
  const a = t.apiBase ?? "", i = new URLSearchParams({ tag: e, limit: String(n.limit ?? 100), offset: String(n.offset ?? 0) });
  n.kind && i.set("kind", n.kind), n.sort && i.set("sort", n.sort);
  const r = await fetch(`${a}/api/files/manager/tagged?${i}`, {
    headers: await (t.authHeaders ?? (() => ({})))(),
    credentials: t.authCredentials ?? "same-origin"
  });
  if (!r.ok) throw new Error(String(r.status));
  const l = await r.json(), c = Array.isArray(l == null ? void 0 : l.nodes) ? l.nodes : [];
  return {
    rows: c,
    total: typeof (l == null ? void 0 : l.total) == "number" ? l.total : (n.offset ?? 0) + c.length,
    truncated: (l == null ? void 0 : l.truncated) === !0
  };
}
const cD = ["width", "height", "data-tag-kind"], Bv = /* @__PURE__ */ lt({
  __name: "TagKindIcon",
  props: {
    kind: {},
    size: {}
  },
  setup(e) {
    return (t, n) => (f(), h("svg", {
      class: Re(["fe-tagkind", `fe-tagkind--${e.kind}`]),
      width: e.size ?? 12,
      height: e.size ?? 12,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true",
      focusable: "false",
      "data-tag-kind": e.kind
    }, [
      e.kind === "team" ? (f(), h(Te, { key: 0 }, [
        n[0] || (n[0] = d("circle", {
          cx: "9",
          cy: "8",
          r: "3.2"
        }, null, -1)),
        n[1] || (n[1] = d("path", { d: "M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" }, null, -1)),
        n[2] || (n[2] = d("circle", {
          cx: "17",
          cy: "9",
          r: "2.6"
        }, null, -1)),
        n[3] || (n[3] = d("path", { d: "M16.5 14.2c2.6.3 4.5 2.6 4.5 5.3" }, null, -1))
      ], 64)) : (f(), h(Te, { key: 1 }, [
        n[4] || (n[4] = d("circle", {
          cx: "12",
          cy: "8",
          r: "3.6"
        }, null, -1)),
        n[5] || (n[5] = d("path", { d: "M5 20c0-3.9 3.1-7 7-7s7 3.1 7 7" }, null, -1))
      ], 64))
    ], 10, cD));
  }
}), dD = ["role", "aria-labelledby", "aria-label", "data-testid"], fD = { class: "fe-choice__strip" }, pD = ["role", "aria-checked", "aria-pressed", "aria-label", "aria-describedby", "tabindex", "disabled", "data-testid", "onClick", "onKeydown"], hD = {
  key: 1,
  class: "fe-choice__label"
}, mD = {
  key: 2,
  class: "fe-choice__help"
}, vD = ["id", "data-testid"], yD = ["data-testid"], mi = /* @__PURE__ */ lt({
  __name: "ChoiceButtons",
  props: {
    options: {},
    modelValue: {},
    multi: { type: Boolean },
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    segmented: { type: Boolean },
    iconOnly: { type: Boolean },
    ariaLabelledby: {},
    ariaLabel: {},
    testidPrefix: {},
    testid: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = A(() => !!n.segmented || !!n.iconOnly), r = `fe-choice-${Math.random().toString(36).slice(2, 10)}`, l = (C) => `${r}-tip-${C}`;
    function c(C) {
      return i.value ? C.help || (n.iconOnly ? C.label : "") : "";
    }
    const p = A(() => {
      var C;
      return !i.value || n.multi ? "" : ((C = n.options.find((T) => v(T.value))) == null ? void 0 : C.help) ?? "";
    }), m = A(() => {
      const C = n.modelValue;
      return Array.isArray(C) ? C.map((T) => String(T)) : C == null || C === "" ? [] : [String(C)];
    });
    function v(C) {
      return m.value.includes(C);
    }
    function x(C) {
      var T;
      return !!n.disabled || !!((T = n.options.find((E) => E.value === C)) != null && T.disabled);
    }
    function w(C) {
      if (!x(C)) {
        if (n.multi) {
          const T = v(C) ? m.value.filter((R) => R !== C) : [...m.value, C], E = n.options.map((R) => R.value);
          a("update:modelValue", E.filter((R) => T.includes(R)));
          return;
        }
        a("update:modelValue", C);
      }
    }
    function $(C) {
      const T = n.options.length;
      for (let E = 0; E < T; E++) {
        const R = C === 1 ? E : T - 1 - E;
        if (!n.options[R].disabled) return R;
      }
      return -1;
    }
    function k(C, T) {
      var U;
      if (n.multi || n.disabled) return;
      const E = n.options.length;
      let R;
      if (C.key === "Home" || C.key === "End") {
        if (C.preventDefault(), R = $(C.key === "Home" ? 1 : -1), R < 0) return;
      } else {
        if (!["ArrowRight", "ArrowDown", "ArrowLeft", "ArrowUp"].includes(C.key)) return;
        C.preventDefault();
        const L = C.key === "ArrowDown" ? 1 : C.key === "ArrowUp" ? -1 : qf(C.key, ei(C.currentTarget));
        if (!E || (R = (T + L + E) % E, n.options[R].disabled)) return;
      }
      w(n.options[R].value);
      const z = C.currentTarget.closest(".fe-choice"), D = z == null ? void 0 : z.querySelectorAll("[data-choice]");
      (U = D == null ? void 0 : D[R]) == null || U.focus();
    }
    function b(C, T) {
      return n.multi ? 0 : m.value.length ? v(C) ? 0 : -1 : T === 0 ? 0 : -1;
    }
    return (C, T) => (f(), h("div", {
      class: Re(["fe-choice", {
        "is-invalid": e.invalid,
        "is-disabled": e.disabled,
        "fe-choice--segmented": i.value,
        "fe-choice--icons": e.iconOnly
      }]),
      role: e.multi ? "group" : "radiogroup",
      "aria-labelledby": e.ariaLabelledby,
      "aria-label": e.ariaLabel,
      "data-testid": e.testid ?? "choice-buttons"
    }, [
      d("div", fD, [
        (f(!0), h(Te, null, nt(e.options, (E, R) => (f(), h("span", {
          key: E.value,
          class: "fe-choice__cell"
        }, [
          d("button", {
            type: "button",
            "data-choice": "",
            class: Re(["fe-choice__btn", { "is-on": v(E.value) }]),
            role: e.multi ? void 0 : "radio",
            "aria-checked": e.multi ? void 0 : v(E.value) ? "true" : "false",
            "aria-pressed": e.multi ? v(E.value) ? "true" : "false" : void 0,
            "aria-label": e.iconOnly ? E.label : void 0,
            "aria-describedby": i.value && E.help ? l(R) : void 0,
            tabindex: b(E.value, R),
            disabled: e.disabled || E.disabled,
            "data-testid": e.testidPrefix ? `${e.testidPrefix}-${E.value}` : void 0,
            onClick: (z) => w(E.value),
            onKeydown: (z) => k(z, R)
          }, [
            E.icon ? (f(), Ge(Ki(E.icon), {
              key: 0,
              class: "fe-choice__icon",
              "aria-hidden": "true"
            })) : O("", !0),
            e.iconOnly ? O("", !0) : (f(), h("span", hD, y(E.label), 1)),
            E.help && !i.value ? (f(), h("span", mD, y(E.help), 1)) : O("", !0)
          ], 42, pD),
          c(E) ? (f(), h("span", {
            key: 0,
            id: l(R),
            class: "fe-choice__tip",
            "aria-hidden": "true",
            "data-testid": e.testidPrefix ? `${e.testidPrefix}-${E.value}-tip` : void 0
          }, y(c(E)), 9, vD)) : O("", !0)
        ]))), 128))
      ]),
      p.value ? (f(), h("p", {
        key: 0,
        class: "fe-choice__note",
        "aria-hidden": "true",
        "data-testid": e.testidPrefix ? `${e.testidPrefix}-note` : void 0
      }, y(p.value), 9, yD)) : O("", !0)
    ], 10, dD));
  }
}), gD = ["data-tag-kind"], bD = ["title", "aria-label", "data-testid", "onClick"], kD = ["aria-label", "onClick"], wD = ["placeholder", "aria-label"], dx = /* @__PURE__ */ lt({
  __name: "TagPicker",
  props: {
    nodeId: {},
    locale: {},
    apiBase: {},
    authHeaders: { type: Function },
    authCredentials: {},
    palette: {}
  },
  emits: ["change", "error", "open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale ?? "en");
    function r(J) {
      return `${i("tags.open", { tag: J.name })} · ${i(`tags.chip.${J.kind}`, { tag: J.name })}`;
    }
    const l = S([]), c = S(!0), p = S(!1), m = S(!1), v = S(!1), x = S(""), w = S("personal"), $ = S(null), k = A(() => [
      ...l.value.filter((J) => J.kind === "personal"),
      ...l.value.filter((J) => J.kind === "team")
    ]), b = A(() => [
      { value: "personal", label: i("tags.kind.personal"), help: i("tags.kind.personal_help") },
      {
        value: "team",
        label: i("tags.kind.team"),
        help: c.value ? i("tags.kind.team_help") : i("tags.kind.team_locked"),
        disabled: !c.value
      }
    ]), C = A(() => n.palette ?? [
      "#ef4444",
      "#f59e0b",
      "#10b981",
      "#3b82f6",
      "#8b5cf6",
      "#ec4899",
      "#14b8a6",
      "#f97316"
    ]);
    function T(J) {
      let j = 0;
      for (let q = 0; q < J.length; q++) j = j * 31 + J.charCodeAt(q) | 0;
      const re = C.value;
      return re[Math.abs(j) % re.length];
    }
    function E(J) {
      return J.kind === "personal" || c.value;
    }
    async function R(J = {}) {
      return { ...await (n.authHeaders ?? (() => ({})))(), ...J };
    }
    function z(J) {
      const j = J ?? {};
      p.value = !Array.isArray(j.items), l.value = Rv(J), typeof j.can_edit_team == "boolean" && (c.value = j.can_edit_team);
    }
    async function D() {
      m.value = !0;
      try {
        const J = n.apiBase ?? "", j = await fetch(`${J}/api/files/manager/tags?node_id=${n.nodeId}`, {
          headers: await R(),
          credentials: n.authCredentials ?? "same-origin"
        });
        j.ok && z(await j.json());
      } catch (J) {
        a("error", J instanceof Error ? J.message : String(J));
      } finally {
        m.value = !1;
      }
    }
    async function U(J) {
      const j = [...l.value];
      l.value = J;
      try {
        const re = n.apiBase ?? "", q = p.value ? { node_id: n.nodeId, tags: J.map((ce) => ce.name) } : { node_id: n.nodeId, items: J }, le = await fetch(`${re}/api/files/manager/tags`, {
          method: "POST",
          headers: await R({ "Content-Type": "application/json" }),
          credentials: n.authCredentials ?? "same-origin",
          body: JSON.stringify(q)
        });
        if (!le.ok) throw fa(le.status, await le.text().catch(() => ""), n.locale);
        const ve = await le.json().catch(() => null);
        !p.value && ve && Array.isArray(ve.items) && (l.value = Rv(ve)), lD(), a("change", l.value.map((ce) => ce.name), l.value);
      } catch (re) {
        l.value = j, a("error", re instanceof Error ? re.message : String(re));
      }
    }
    function H() {
      x.value = "", w.value = "personal", v.value = !1;
    }
    const L = A(() => Pc("tag_max_runes"));
    Je(x, (J) => {
      const j = zy(J, L.value);
      j !== J && (x.value = j);
    });
    function P() {
      const J = x.value.trim(), j = p.value ? "team" : w.value;
      if (!J || l.value.some((re) => re.kind === j && re.name === J)) {
        H();
        return;
      }
      U([...l.value, { name: J, kind: j }]), H();
    }
    function K(J) {
      var re;
      if (p.value) {
        P();
        return;
      }
      const j = J.relatedTarget;
      j && ((re = $.value) != null && re.contains(j)) || x.value.trim() || H();
    }
    function N(J) {
      U(l.value.filter((j) => j !== J));
    }
    return jt(D), Je(() => n.nodeId, D), (J, j) => (f(), h("div", {
      class: Re(["filex-tag-picker", { "is-loading": m.value }])
    }, [
      (f(!0), h(Te, null, nt(k.value, (re) => (f(), h("span", {
        key: `${re.kind}:${re.name}`,
        class: Re(["filex-tag", `filex-tag--${re.kind}`]),
        "data-tag-kind": re.kind,
        style: Yt({ "--filex-tag-color": T(re.name) })
      }, [
        Ze(Bv, {
          kind: re.kind
        }, null, 8, ["kind"]),
        d("button", {
          class: "filex-tag-open",
          type: "button",
          title: r(re),
          "aria-label": r(re),
          "data-testid": `tag-open-${re.name}`,
          onClick: (q) => a("open", re.name, re.kind)
        }, y(re.name), 9, bD),
        E(re) ? (f(), h("button", {
          key: 0,
          class: "filex-tag-x",
          type: "button",
          "aria-label": `${u(i)("tags.remove")}: ${re.name}`,
          onClick: (q) => N(re)
        }, "×", 8, kD)) : O("", !0)
      ], 14, gD))), 128)),
      v.value ? (f(), h("form", {
        key: 0,
        ref_key: "addForm",
        ref: $,
        class: "filex-tag-add",
        onSubmit: yt(P, ["prevent"])
      }, [
        dn(d("input", {
          "onUpdate:modelValue": j[0] || (j[0] = (re) => x.value = re),
          autofocus: "",
          placeholder: u(i)("tags.name"),
          "aria-label": u(i)("tags.name"),
          onBlur: K,
          onKeydown: Ca(H, ["escape"])
        }, null, 40, wD), [
          [_n, x.value]
        ]),
        p.value ? O("", !0) : (f(), h("div", {
          key: 0,
          class: "filex-tag-kindwrap",
          onMousedown: j[2] || (j[2] = yt(() => {
          }, ["prevent"]))
        }, [
          Ze(mi, {
            "model-value": w.value,
            options: b.value,
            "aria-label": u(i)("tags.kind.label"),
            "testid-prefix": "tag-kind",
            "onUpdate:modelValue": j[1] || (j[1] = (re) => w.value = re === "team" ? "team" : "personal")
          }, null, 8, ["model-value", "options", "aria-label"])
        ], 32)),
        d("button", {
          class: "filex-tag-add-submit",
          type: "submit",
          onMousedown: j[3] || (j[3] = yt(() => {
          }, ["prevent"]))
        }, y(u(i)("tags.add_submit")), 33)
      ], 544)) : (f(), h("button", {
        key: 1,
        class: "filex-tag-add-btn",
        type: "button",
        onClick: j[4] || (j[4] = (re) => v.value = !0)
      }, y(u(i)("tags.add")), 1))
    ], 2));
  }
}), z_ = { tr: f2, en: el }, fx = {};
function _i(e, t) {
  for (const n of t) fx[n] = e;
}
_i("image", ["jpg", "jpeg", "png", "webp", "gif", "bmp", "avif", "heic", "svg", "ico", "tiff", "tif"]);
_i("video", ["mp4", "webm", "mov", "mkv", "avi", "ogv", "m4v"]);
_i("audio", ["mp3", "wav", "flac", "ogg", "m4a", "aac", "opus"]);
_i("pdf", ["pdf"]);
_i("doc", ["doc", "docx", "odt", "rtf"]);
_i("sheet", ["xls", "xlsx", "ods", "csv", "tsv"]);
_i("slides", ["ppt", "pptx", "odp"]);
_i("archive", ["zip", "tar", "gz", "bz2", "7z", "rar", "xz", "zst"]);
const px = /* @__PURE__ */ new Set([
  "jar",
  "war",
  "ear",
  "aar",
  "apk",
  "aab",
  "apks",
  "xapk",
  "ipa",
  "whl",
  "egg",
  "vsix",
  "nupkg",
  "snupkg",
  "xpi",
  "crx",
  "appx",
  "appxbundle",
  "msix",
  "msixbundle",
  "deb",
  "rpm",
  "snap",
  "gem",
  "crate"
]);
_i("archive", [...px]);
_i("code", [
  "js",
  "ts",
  "jsx",
  "tsx",
  "mjs",
  "cjs",
  "vue",
  "py",
  "go",
  "rs",
  "php",
  "rb",
  "java",
  "kt",
  "swift",
  "c",
  "cpp",
  "h",
  "hpp",
  "cs",
  "css",
  "scss",
  "less",
  "html",
  "htm",
  "json",
  "yml",
  "yaml",
  "xml",
  "sh",
  "bash",
  "ps1",
  "sql",
  "toml"
]);
_i("text", ["txt", "md", "markdown", "log", "ini", "conf", "cfg", "env"]);
function cc(e) {
  return e.mime_type === "inode/storage";
}
function xi(e) {
  if (cc(e)) return "storage";
  if (e.basename === ".trash") return "trash";
  if (e.type === "dir") return "folder";
  const t = (e.extension || "").toLowerCase();
  return t ? fx[t] ?? "unknown" : A2(e.mime_type) ? "text" : "unknown";
}
const Ho = '<path d="M6.5 3h7L18.5 8v11.5a1.5 1.5 0 0 1-1.5 1.5H6.5A1.5 1.5 0 0 1 5 19.5v-15A1.5 1.5 0 0 1 6.5 3z"/><path d="M13.5 3v5h5"/>', _D = {
  // Folder is the one "filled" member — a soft currentColor wash keeps it
  // visually anchored without breaking the line style.
  /**
   * gorunum:v1 — the folder is SOLID, and it is the one glyph that never
   * gets a tile. A folder is the most common thing in a listing; drawn as an
   * outline in the same weight as the file glyphs it disappears into them,
   * and the eye has to read the label to tell a folder from a document. Filled
   * and in its own colour it is recognisable before the name is read.
   */
  folder: '<path d="M2.5 6.5A2.5 2.5 0 0 1 5 4h4.6a2.5 2.5 0 0 1 1.77.73L13 6.4h6a2.5 2.5 0 0 1 2.5 2.5v8.6A2.5 2.5 0 0 1 19 20H5a2.5 2.5 0 0 1-2.5-2.5z" fill="currentColor" stroke="none"/>',
  image: '<rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="8.6" cy="10" r="1.6"/><path d="M5.2 16.6l4.3-4.3 3 3 2.4-2.4 3.9 3.7"/>',
  video: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M10.2 9.3v5.4l4.8-2.7z" fill="currentColor" stroke="none"/>',
  audio: '<path d="M9 17.5V7.2l9-2.2v10.4"/><circle cx="6.8" cy="17.6" r="2.2"/><circle cx="15.8" cy="15.5" r="2.2"/>',
  pdf: Ho + '<rect x="7.5" y="12" width="9" height="5" rx="1" fill="currentColor" fill-opacity="0.14"/>',
  doc: Ho + '<path d="M8.5 13h7M8.5 16h7"/>',
  sheet: Ho + '<path d="M8 12.5h8M8 15.5h8M8 18h8M12 12.5V18"/>',
  slides: Ho + '<rect x="8" y="12.5" width="8" height="5" rx="0.8"/>',
  archive: Ho + '<path d="M10 3v1.6M10 6.6v1.6M10 10.2v1.6"/><rect x="8.6" y="14" width="2.8" height="3.4" rx="0.8"/>',
  code: Ho + '<path d="M10.4 12.5L8.3 15l2.1 2.5M13.6 12.5l2.1 2.5-2.1 2.5"/>',
  text: Ho + '<path d="M8.5 12h7M8.5 15h7M8.5 18h4.5"/>',
  // The two-bay drive the sidebar already draws for the same storages, so a
  // drive is one shape across the panel rather than one per surface.
  storage: '<rect x="3" y="5" width="18" height="6" rx="1.6"/><rect x="3" y="13" width="18" height="6" rx="1.6"/><path d="M6.5 8h.01M6.5 16h.01"/>',
  trash: '<path d="M4 7h16"/><path d="M9.5 7V5.6A1.6 1.6 0 0 1 11.1 4h1.8a1.6 1.6 0 0 1 1.6 1.6V7"/><path d="M6.2 7l.85 11.6A1.6 1.6 0 0 0 8.65 20h6.7a1.6 1.6 0 0 0 1.6-1.4L17.8 7"/><path d="M10.2 10.8v5.6M13.8 10.8v5.6"/>',
  unknown: Ho + '<path d="M10.3 13.1a1.8 1.8 0 1 1 2.5 1.9c-.6.3-.8.7-.8 1.4"/><circle cx="12" cy="18.4" r="0.9" fill="currentColor" stroke="none"/>'
}, M_ = /* @__PURE__ */ new Map();
function P_(e) {
  let t = M_.get(e);
  return t || (t = `<svg class="fe-ficon fe-ficon--${e}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${_D[e]}</svg>`, M_.set(e, t)), t;
}
const O_ = /* @__PURE__ */ new Map();
function hx(e) {
  if (e === "folder")
    return `<span class="fe-ftile fe-ftile--folder">${P_(e)}</span>`;
  let t = O_.get(e);
  return t || (t = `<span class="fe-ftile fe-ftile--${e}">${P_(e)}</span>`, O_.set(e, t)), t;
}
function wa(e) {
  return xD(e) ? $D() : hx(xi(e));
}
function xD(e) {
  return e.type === "dir" ? !1 : (e.extension || "").toLowerCase() === "fxe" ? !0 : typeof e.basename == "string" && e.basename.toLowerCase().endsWith(".fxe") && e.basename.length > 4;
}
const SD = '<path fill="currentColor" stroke="none" fill-rule="evenodd" d="M6.5 3h7L18.5 8v11.5a1.5 1.5 0 0 1-1.5 1.5H6.5A1.5 1.5 0 0 1 5 19.5v-15A1.5 1.5 0 0 1 6.5 3zM9.7 12.2a2.3 2.3 0 0 1 4.6 0h-1.05a1.25 1.25 0 0 0-2.5 0zM9.2 12.2h5.6a1 1 0 0 1 1 1v3.6a1 1 0 0 1-1 1H9.2a1 1 0 0 1-1-1v-3.6a1 1 0 0 1 1-1z"/>';
let Rm = "";
function $D() {
  return Rm || (Rm = `<span class="fe-ftile fe-ftile--unknown fe-ftile--file-locked"><svg class="fe-ficon fe-ficon--file-locked" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${SD}</svg></span>`), Rm;
}
function Vr(e) {
  return e.type === "dir" && e.e2e === !0;
}
const TD = '<path fill="currentColor" stroke="none" fill-rule="evenodd" d="M2.5 6.5A2.5 2.5 0 0 1 5 4h4.6a2.5 2.5 0 0 1 1.77.73L13 6.4h6a2.5 2.5 0 0 1 2.5 2.5v8.6A2.5 2.5 0 0 1 19 20H5a2.5 2.5 0 0 1-2.5-2.5zM9.7 12a2.3 2.3 0 0 1 4.6 0h-1.05a1.25 1.25 0 0 0-2.5 0zM9.2 12h5.6a1 1 0 0 1 1 1v3.6a1 1 0 0 1-1 1H9.2a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1z"/>';
let Nm = "";
function xl() {
  return Nm || (Nm = `<span class="fe-ftile fe-ftile--folder fe-ftile--folder-locked"><svg class="fe-ficon fe-ficon--folder" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${TD}</svg></span>`), Nm;
}
const AD = {
  // Languages the person reading the column thinks of by name.
  ts: "ftype.typescript",
  tsx: "ftype.typescript",
  mts: "ftype.typescript",
  cts: "ftype.typescript",
  js: "ftype.javascript",
  jsx: "ftype.javascript",
  mjs: "ftype.javascript",
  cjs: "ftype.javascript",
  vue: "ftype.vue",
  py: "ftype.python",
  go: "ftype.go",
  rs: "ftype.rust",
  php: "ftype.php",
  rb: "ftype.ruby",
  java: "ftype.java",
  kt: "ftype.kotlin",
  swift: "ftype.swift",
  c: "ftype.c",
  h: "ftype.c",
  cpp: "ftype.cpp",
  hpp: "ftype.cpp",
  cs: "ftype.csharp",
  // Structured text that is code by family but not a language.
  css: "ftype.stylesheet",
  scss: "ftype.stylesheet",
  less: "ftype.stylesheet",
  html: "ftype.html",
  htm: "ftype.html",
  json: "ftype.json",
  yml: "ftype.yaml",
  yaml: "ftype.yaml",
  xml: "ftype.xml",
  toml: "ftype.toml",
  sql: "ftype.sql",
  sh: "ftype.shell",
  bash: "ftype.shell",
  zsh: "ftype.shell",
  ps1: "ftype.powershell",
  // Plain-text family members that are each their own thing.
  md: "ftype.markdown",
  markdown: "ftype.markdown",
  txt: "ftype.plaintext",
  log: "ftype.log",
  ini: "ftype.config",
  conf: "ftype.config",
  cfg: "ftype.config",
  env: "ftype.config",
  // Tabular: a `.csv` IS a spreadsheet to the person looking at the column,
  // whatever the program that wrote it was.
  csv: "ftype.sheet",
  tsv: "ftype.sheet",
  // Design files. No icon family of their own (they fall to `unknown`, which
  // is a decision for the GLYPH, not for the word) — naming them still beats
  // printing "FIG".
  fig: "ftype.figma",
  // ⚠ Named, not "DRAWIO": the uppercased extension was a fourth spelling of
  // draw.io beside "Drawio", "drawio" and "diagrams.net" (QA, 2026-09-21).
  drawio: "ftype.drawio",
  dio: "ftype.drawio",
  sketch: "ftype.design",
  xd: "ftype.design",
  psd: "ftype.design",
  ai: "ftype.design"
}, ED = {
  folder: "node.folder",
  image: "ftype.image",
  video: "ftype.video",
  audio: "ftype.audio",
  pdf: "ftype.pdf",
  doc: "ftype.document",
  sheet: "ftype.sheet",
  slides: "ftype.slides",
  archive: "ftype.archive",
  code: "ftype.code",
  text: "ftype.plaintext"
};
function mx(e) {
  if (e.type === "dir") return "node.folder";
  const t = (e.extension || "").trim().toLowerCase();
  if (t === "fxe") return "e2e.fxe.type";
  const n = AD[t];
  return n || (px.has(t) ? null : ED[xi(e)] ?? null);
}
function Fv(e, t) {
  const n = mx(e);
  return n ? t(n) : vx(e) || "-";
}
function vx(e) {
  return (e.extension || "").trim().toUpperCase();
}
const Bn = 16, Pp = new Uint8Array(Bn);
class L_ extends Error {
  constructor(t = "aes-siv: authentication failed") {
    super(t), this.name = "SivAuthError";
  }
}
function Go(e) {
  return new Uint8Array(e).buffer;
}
function np(e) {
  const t = new Uint8Array(Bn);
  let n = 0;
  for (let a = Bn - 1; a >= 0; a--) {
    const i = e[a];
    t[a] = (i << 1 | n) & 255, n = i >>> 7;
  }
  return e[0] & 128 && (t[Bn - 1] ^= 135), t;
}
function Uv(e, t, n) {
  for (let a = 0; a < n.length; a++) e[t + a] ^= n[a];
}
function D_(e, t) {
  const n = new Uint8Array(Bn);
  for (let a = 0; a < Bn; a++) n[a] = e[a] ^ t[a];
  return n;
}
async function CD(e, t) {
  const n = await crypto.subtle.encrypt({ name: "AES-CBC", iv: Go(Pp) }, e, Go(t));
  return new Uint8Array(n).slice(0, Bn);
}
async function Im(e, t) {
  const n = Math.max(1, Math.ceil(t.length / Bn)), a = t.length > 0 && t.length % Bn === 0, i = new Uint8Array(n * Bn);
  i.set(t);
  const r = (n - 1) * Bn;
  return a ? Uv(i, r, e.k1) : (i[t.length] = 128, Uv(i, r, e.k2)), new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-CBC", iv: Go(Pp) }, e.mac, Go(i))
  ).slice(r, r + Bn);
}
async function yx(e, t, n) {
  let a = await Im(e, Pp);
  for (const r of t) a = D_(np(a), await Im(e, r));
  let i;
  if (n.length >= Bn)
    i = n.slice(), Uv(i, n.length - Bn, a);
  else {
    const r = new Uint8Array(Bn);
    r.set(n), r[n.length] = 128, i = D_(np(a), r);
  }
  return Im(e, i);
}
function zD(e) {
  const t = e.slice();
  return t[8] &= 127, t[12] &= 127, t;
}
async function gx(e, t, n) {
  if (n.length === 0) return new Uint8Array(0);
  const a = await crypto.subtle.encrypt(
    { name: "AES-CTR", counter: Go(zD(t)), length: 32 },
    e.ctr,
    Go(n)
  );
  return new Uint8Array(a);
}
async function MD(e) {
  if (e.length !== 32 && e.length !== 64)
    throw new Error("aes-siv: key must be 32 or 64 bytes");
  const t = e.length / 2, n = await crypto.subtle.importKey("raw", Go(e.slice(0, t)), { name: "AES-CBC" }, !1, [
    "encrypt"
  ]), a = await crypto.subtle.importKey("raw", Go(e.slice(t)), { name: "AES-CTR" }, !1, [
    "encrypt",
    "decrypt"
  ]), i = await CD(n, Pp), r = np(i), l = np(r);
  return { mac: n, ctr: a, k1: r, k2: l };
}
async function bx(e, t, n = []) {
  const a = await yx(e, n, t), i = await gx(e, a, t), r = new Uint8Array(Bn + i.length);
  return r.set(a, 0), r.set(i, Bn), r;
}
async function PD(e, t, n = []) {
  if (t.length < Bn) throw new L_("aes-siv: ciphertext too short");
  const a = t.slice(0, Bn), i = await gx(e, a, t.slice(Bn)), r = await yx(e, n, i);
  let l = 0;
  for (let c = 0; c < Bn; c++) l |= r[c] ^ a[c];
  if (l !== 0)
    throw i.fill(0), new L_();
  return i;
}
const kx = "AES-SIV-512", wx = "b64url", OD = 220, LD = 255, _x = 64, Sl = 16, DD = ".fxl", xx = ".fxl.name", RD = new TextEncoder().encode("filex-e2e-dir-id"), ND = 16, Sx = /^[A-Za-z0-9_-]+$/, eg = "[A-Za-z0-9_-]{43}", $x = "[A-Za-z0-9_-]{22}", ID = new RegExp(`^(${eg})\\.fxl\\.name$`), BD = new RegExp(`^(${eg})\\.fxl$`), FD = new RegExp(`^(${eg})\\.fxl\\.(${$x})$`), UD = new RegExp(`^([A-Za-z0-9_-]{23,})\\.(${$x})$`), HD = 23;
function Xo(e) {
  let t = "";
  for (let n = 0; n < e.length; n++) t += String.fromCharCode(e[n]);
  return btoa(t).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
function _o(e) {
  if (!e || !Sx.test(e) || e.length % 4 === 1) return null;
  const t = e.replace(/-/g, "+").replace(/_/g, "/"), n = t + "===".slice((t.length + 3) % 4);
  let a;
  try {
    a = atob(n);
  } catch {
    return null;
  }
  const i = new Uint8Array(a.length);
  for (let r = 0; r < a.length; r++) i[r] = a.charCodeAt(r);
  return Xo(i) !== e ? null : i;
}
function tg(e) {
  return (e ?? "").normalize("NFC");
}
function Gi(e) {
  const t = tg(e);
  return t ? t === "." || t === ".." ? "dot" : t.includes("/") || t.includes("\\") ? "slash" : /[\u0000-\u001f\u007f]/.test(t) ? "control" : new TextEncoder().encode(t).length > LD ? "too_long" : null : "empty";
}
function KD() {
  return crypto.getRandomValues(new Uint8Array(_x));
}
function Tx() {
  return crypto.getRandomValues(new Uint8Array(Sl));
}
const VD = Tx;
async function ng(e, t, n) {
  if (e.length !== _x) throw new Error("e2e: name key must be 64 bytes");
  if (n.length !== Sl) throw new Error("e2e: a folder id is 16 bytes");
  return { siv: await MD(e), long: t, rootId: n.slice() };
}
async function Ax(e) {
  const t = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(e));
  return Xo(new Uint8Array(t));
}
async function jD(e, t, n) {
  return (await bx(e.siv, new TextEncoder().encode(tg(n)), [
    t,
    RD
  ])).slice(0, Sl);
}
function Il(e) {
  let t = ID.exec(e);
  if (t) return { kind: "sidecar", hash: t[1] };
  if (t = FD.exec(e), t) {
    const n = _o(t[2]);
    if (n && n.length === Sl) return { kind: "longdir", hash: t[1], dirId: n };
  }
  if (t = BD.exec(e), t) return { kind: "long", hash: t[1] };
  if (t = UD.exec(e), t) {
    const n = _o(t[2]);
    if (n && n.length === Sl) return { kind: "dir", encoded: t[1], dirId: n };
  }
  return e.length >= HD && Sx.test(e) ? { kind: "file", encoded: e } : { kind: "plain" };
}
function qD(e) {
  return Il(e).dirId ?? null;
}
async function Hv(e, t, n) {
  return qD(n) ?? jD(e, t, n);
}
async function Kv(e, t, n, a = {}) {
  const i = Gi(t);
  if (i) throw new Error(`e2e: invalid name (${i})`);
  const r = new TextEncoder().encode(tg(t)), l = Xo(await bx(e.siv, r, [n])), p = a.isDir || !!a.dirId ? a.dirId ?? Tx() : void 0, m = p ? `.${Xo(p)}` : "";
  if (l.length + m.length <= e.long)
    return { stored: l + m, encoded: l, ...p ? { dirId: p } : {} };
  const v = await Ax(l);
  return {
    stored: `${v}${DD}${m}`,
    encoded: l,
    ...p ? { dirId: p } : {},
    sidecar: { name: `${v}${xx}`, content: l }
  };
}
async function Ex(e, t, n) {
  const a = _o(t);
  if (!a || a.length <= ND) return null;
  try {
    const i = await PD(e.siv, a, [n]);
    return new TextDecoder("utf-8", { fatal: !0 }).decode(i);
  } catch {
    return null;
  }
}
async function R_(e, t, n) {
  const a = await Ex(e, t, n);
  return a === null ? null : Gi(a) ? "unsafe" : a;
}
async function Cx(e, t, n, a) {
  const i = Il(t);
  if (i.kind === "sidecar") return { name: null, state: "sidecar" };
  if (i.kind === "plain") return { name: t, state: "plain" };
  if (i.kind === "long" || i.kind === "longdir") {
    const c = ((a ? await a(`${i.hash}${xx}`) : null) ?? "").trim();
    if (!c || await Ax(c) !== i.hash)
      return { name: null, state: "unreadable" };
    const p = await R_(e, c, n);
    return p === null || p === "unsafe" ? { name: null, state: "unreadable" } : { name: p, state: "enc" };
  }
  const r = await R_(e, i.encoded, n);
  return r === "unsafe" ? { name: null, state: "unreadable" } : r !== null ? { name: r, state: "enc" } : i.kind === "dir" ? { name: null, state: "unreadable" } : { name: t, state: "plain" };
}
function ap(e) {
  const t = e.lastIndexOf(".");
  return t <= 0 || t === e.length - 1 ? "" : e.slice(t + 1).toLowerCase();
}
const So = 20, WD = 10, YD = 24, jr = 7, Hi = 16, Nc = 2, GD = 4294967295, dc = 12, yi = 97, Vv = 9, jv = 21, zx = 48, qv = 69, Mx = 76, Px = 32, ip = new TextEncoder().encode("filexe2e");
function Ic(e) {
  return typeof e == "number" && Number.isInteger(e) && e >= WD && e <= YD;
}
function Bc(e) {
  if (!Ic(e)) throw new Error(`e2e: unsupported chunk size 2^${e}`);
  return 2 ** e;
}
function Ox(e, t, n) {
  if (e.length !== jr) throw new Error("e2e: the nonce prefix must be 7 bytes");
  if (!Number.isInteger(t) || t < 0 || t > GD)
    throw new Error("e2e: too many chunks for one stream");
  const a = new Uint8Array(dc);
  return a.set(e, 0), new DataView(a.buffer).setUint32(jr, t, !1), a[dc - 1] = n ? 1 : 0, a;
}
function Lx(e, t = So) {
  if (!Number.isSafeInteger(e) || e < 0) throw new Error("e2e: bad plaintext size");
  return e === 0 ? 1 : Math.ceil(e / Bc(t));
}
function ag(e, t = So) {
  return e + Hi * Lx(e, t);
}
function XD(e, t = So) {
  if (!Ic(t) || !Number.isSafeInteger(e) || e < Hi) return null;
  const n = 2 ** t + Hi, a = Math.ceil(e / n), i = e - (a - 1) * n;
  return i < Hi || a > 1 && i === Hi ? null : e - Hi * a;
}
function Dx() {
  return crypto.getRandomValues(new Uint8Array(jr));
}
class Op {
  constructor() {
    Nt(this, "parts", []);
    Nt(this, "head", 0);
    Nt(this, "length", 0);
  }
  push(t) {
    t.length !== 0 && (this.parts.push(t), this.length += t.length);
  }
  /** The next `n` bytes (n ≤ length), as a fresh buffer. */
  take(t) {
    if (t > this.length) throw new Error("ByteQueue: not enough bytes");
    const n = new Uint8Array(t);
    let a = 0;
    for (; a < t; ) {
      const i = this.parts[0], r = Math.min(i.length - this.head, t - a);
      n.set(i.subarray(this.head, this.head + r), a), a += r, this.head += r, this.head === i.length && (this.parts.shift(), this.head = 0);
    }
    return this.length -= t, n;
  }
}
function $l(e) {
  if (e instanceof Uint8Array) return e;
  if (e instanceof ArrayBuffer) return new Uint8Array(e);
  if (ArrayBuffer.isView(e)) return new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
  throw new TypeError("e2e: a stream carried something that is not bytes");
}
class Lp {
  constructor(t) {
    Nt(this, "reader");
    Nt(this, "q", new Op());
    Nt(this, "done", !1);
    this.reader = t.getReader();
  }
  /** Up to `n` bytes; fewer only when the stream ended. */
  async read(t) {
    for (; this.q.length < t && !this.done; ) {
      const { done: n, value: a } = await this.reader.read();
      n ? this.done = !0 : this.q.push($l(a));
    }
    return this.q.take(Math.min(t, this.q.length));
  }
  /** Everything not read yet, as a stream. The reader is spent afterwards. */
  rest() {
    const t = this.q.take(this.q.length), n = this.reader;
    let a = t.length > 0 ? t : null;
    const i = this.done;
    return new ReadableStream({
      async pull(r) {
        if (a) {
          r.enqueue(a), a = null;
          return;
        }
        if (i) {
          r.close();
          return;
        }
        const { done: l, value: c } = await n.read();
        l ? r.close() : r.enqueue($l(c));
      },
      cancel(r) {
        return n.cancel(r);
      }
    });
  }
  cancel(t) {
    return this.reader.cancel(t);
  }
}
function Fc(e, t) {
  const n = t.getReader();
  let a = !1;
  return new ReadableStream({
    async pull(i) {
      if (!a && (a = !0, e.length > 0)) {
        i.enqueue(e);
        return;
      }
      const { done: r, value: l } = await n.read();
      r ? i.close() : i.enqueue($l(l));
    },
    cancel(i) {
      return n.cancel(i);
    }
  });
}
async function JD(e, t = Number.MAX_SAFE_INTEGER) {
  const n = new Op(), a = e.getReader();
  for (; ; ) {
    const { done: i, value: r } = await a.read();
    if (i) break;
    if (n.push($l(r)), n.length > t)
      throw await a.cancel(), new Error("e2e: more data than expected");
  }
  return n.take(n.length);
}
async function N_(e, t, n, a, i) {
  return new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: Ox(t, n, a) }, e, i)
  );
}
async function Wv(e, t, n, a, i) {
  try {
    return new Uint8Array(
      await crypto.subtle.decrypt({ name: "AES-GCM", iv: Ox(t, n, a) }, e, i)
    );
  } catch {
    throw new cn(
      a ? "e2e: the last chunk failed authentication (the file is truncated, extended or damaged)" : `e2e: chunk ${n} failed authentication (the file is damaged, reordered or truncated)`
    );
  }
}
function Rx(e, t, n = So, a = {}) {
  const i = Bc(n);
  if (t.length !== jr) throw new Error("e2e: the nonce prefix must be 7 bytes");
  const r = new Op();
  let l = 0, c = 0;
  return new TransformStream({
    async transform(p, m) {
      var x;
      const v = $l(p);
      if (c += v.length, a.expectSize !== void 0 && c > a.expectSize)
        throw new Error("e2e: the file is longer than it said it was");
      for (r.push(v); r.length > i; )
        m.enqueue(await N_(e, t, l++, !1, r.take(i))), (x = a.onProgress) == null || x.call(a, l * i);
    },
    async flush(p) {
      var m;
      if (a.expectSize !== void 0 && c !== a.expectSize)
        throw new Error("e2e: the file is shorter than it said it was");
      p.enqueue(await N_(e, t, l++, !0, r.take(r.length))), (m = a.onProgress) == null || m.call(a, c);
    }
  });
}
function Nx(e, t, n = So, a = {}) {
  const i = Bc(n) + Hi;
  if (t.length !== jr) throw new Error("e2e: the nonce prefix must be 7 bytes");
  const r = new Op();
  let l = 0, c = 0;
  const p = (m) => {
    if (c += m.length, a.expectSize !== void 0 && c > a.expectSize)
      throw new cn("e2e: the file holds more than its header says");
    return m;
  };
  return new TransformStream({
    async transform(m, v) {
      for (r.push($l(m)); r.length > i; ) v.enqueue(p(await Wv(e, t, l++, !1, r.take(i))));
    },
    async flush(m) {
      if (r.length < Hi) throw new cn("e2e: the encrypted content is truncated");
      if (l > 0 && r.length === Hi)
        throw new cn("e2e: the encrypted content ends in an empty chunk no writer produces");
      if (m.enqueue(p(await Wv(e, t, l++, !0, r.take(r.length)))), a.expectSize !== void 0 && c !== a.expectSize)
        throw new cn("e2e: the file holds less than its header says");
    }
  });
}
async function ZD(e, t, n, a = So) {
  const i = Bc(a), r = i + Hi, l = XD(n.length, a);
  if (l === null) throw new cn("e2e: the encrypted content has an impossible length");
  const c = new Uint8Array(l), p = Lx(l, a);
  for (let m = 0; m < p; m++) {
    const v = m === p - 1, x = n.slice(m * r, v ? n.length : (m + 1) * r);
    c.set(await Wv(e, t, m, v, x), m * i);
  }
  return c;
}
function Ix() {
  return crypto.getRandomValues(new Uint8Array(Px));
}
async function Dp(e) {
  if (e.length !== Px) throw new cn("e2e: a file key must be 32 bytes");
  return crypto.subtle.importKey("raw", e, { name: "AES-GCM" }, !1, ["encrypt", "decrypt"]);
}
function QD(e) {
  if (e.wrapIV.length !== dc || e.wrappedDek.length !== zx)
    throw new Error("e2e: bad wrapped key");
  Bc(e.log2);
  const t = new Uint8Array(yi);
  return t.set(ip, 0), t[8] = Nc, t.set(e.wrapIV, Vv), t.set(e.wrappedDek, jv), t.set(e.prefix, qv), t[Mx] = e.log2, t;
}
function Bx(e) {
  if (e.length < yi) throw new Error("e2e: not an encrypted file");
  for (let n = 0; n < ip.length; n++)
    if (e[n] !== ip[n]) throw new Error("e2e: not an encrypted file");
  if (e[8] !== Nc) throw new Error(`e2e: unsupported version ${e[8]}`);
  const t = e[Mx];
  if (!Ic(t)) throw new Error(`e2e: unsupported chunk size 2^${t}`);
  return {
    wrapIV: e.slice(Vv, Vv + dc),
    wrappedDek: e.slice(jv, jv + zx),
    prefix: e.slice(qv, qv + jr),
    log2: t
  };
}
function e4(e, t = So) {
  return yi + ag(e, t);
}
async function Fx(e, t, n, a) {
  for (const i of t ? [e, t] : [e]) {
    let r;
    try {
      r = new Uint8Array(await crypto.subtle.decrypt({ name: "AES-GCM", iv: n }, i, a));
    } catch {
      continue;
    }
    try {
      return await Dp(r);
    } finally {
      r.fill(0);
    }
  }
  throw new cn("e2e: DEK unwrap failed (wrong key?)");
}
async function I_(e, t, n, a = {}) {
  const i = a.chunkLog2 ?? So, r = Ix(), l = crypto.getRandomValues(new Uint8Array(dc));
  let c, p;
  try {
    p = new Uint8Array(await crypto.subtle.encrypt({ name: "AES-GCM", iv: l }, e, r)), c = await Dp(r);
  } finally {
    r.fill(0);
  }
  const m = Dx(), v = QD({ wrapIV: l, wrappedDek: p, prefix: m, log2: i }), x = n.pipeThrough(
    Rx(c, m, i, { expectSize: t, onProgress: a.onProgress })
  );
  return { stream: Fc(v, x), size: e4(t, i) };
}
async function t4(e, t, n) {
  const a = Bx(t), i = await Fx(e, n, a.wrapIV, a.wrappedDek);
  return (await ZD(i, a.prefix, t.subarray(yi), a.log2)).buffer;
}
const n4 = 200 * 1024 * 1024 + yi + 16;
function Yv(e, t, n, a = {}) {
  const i = new Lp(n);
  let r = null;
  return new ReadableStream({
    async start(l) {
      var w;
      const c = await i.read(yi);
      if (!(c.length >= 8 && ip.every(($, k) => c[k] === $))) {
        if (!a.passPlain) throw new Error("e2e: not an encrypted file");
        (w = a.onPlain) == null || w.call(a), r = Fc(c, i.rest()).getReader();
        return;
      }
      if (c.length < yi) throw new cn("e2e: the encrypted file is truncated");
      if (c[8] === Nc) {
        const $ = Bx(c), k = await Fx(e, t, $.wrapIV, $.wrappedDek);
        r = i.rest().pipeThrough(Nx(k, $.prefix, $.log2)).getReader();
        return;
      }
      if (c[8] !== 1) throw new Error(`e2e: unsupported version ${c[8]}`);
      const m = await JD(i.rest(), n4 - yi), v = new Uint8Array(yi + m.length);
      v.set(c, 0), v.set(m, yi);
      let x;
      try {
        x = await sp(e, v.buffer);
      } catch ($) {
        if (!t || !($ instanceof cn)) throw $;
        x = await sp(t, v.buffer);
      }
      l.enqueue(new Uint8Array(x)), l.close();
    },
    async pull(l) {
      if (!r) return;
      const { done: c, value: p } = await r.read();
      c ? l.close() : l.enqueue(p);
    },
    cancel(l) {
      return r ? r.cancel(l) : i.cancel(l);
    }
  });
}
const a4 = yi, fc = "vault", Ux = 1, i4 = 16, o4 = 24, Hx = 22, r4 = 24, s4 = [Hx, r4], ig = 16, fpe = 25e4;
function l4(e) {
  return typeof e == "number" && Number.isInteger(e) && e >= i4 && e <= o4;
}
function Kx() {
  return import("./keys-TEZaHPYB.js");
}
const ga = ".filex-e2e.json", u4 = "filexe2e", og = 1, Rp = 2, $o = 3, c4 = ["names", "rekey", "conv", fc], Np = 6e5, Ip = 6e5, Vx = 1e8, ec = 200 * 1024 * 1024, op = 8, Cf = 20, jx = "RSA-OAEP-256", Qo = "filex-e2e-verify-v1", zf = new TextEncoder().encode(u4), pc = 97, cl = 9, dl = 21, qx = 48, Gv = 69, ji = 12, ki = 32, d4 = "filex-e2e-recovery-v1", f4 = 16;
class cn extends Error {
  constructor(t = "e2e: decrypt failed") {
    super(t), this.name = "E2eDecryptError";
  }
}
function Ma(e) {
  let t = "";
  for (let n = 0; n < e.length; n++) t += String.fromCharCode(e[n]);
  return btoa(t);
}
function ea(e) {
  const t = atob(e), n = new Uint8Array(t.length);
  for (let a = 0; a < t.length; a++) n[a] = t.charCodeAt(a);
  return n;
}
function gn(e) {
  return new Uint8Array(e).buffer;
}
function p4(e, t) {
  const n = new Uint8Array(e.length + t.length);
  return n.set(e, 0), n.set(t, e.length), Ma(n);
}
async function ni(e, t) {
  const n = crypto.getRandomValues(new Uint8Array(ji)), a = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: gn(n) }, e, gn(t))
  );
  return p4(n, a);
}
function B_(e, t) {
  return ni(e, t);
}
function F_(e, t) {
  return Ba(e, t);
}
async function Ba(e, t) {
  let n;
  try {
    n = ea(t);
  } catch {
    return null;
  }
  if (n.length <= ji) return null;
  try {
    const a = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv: gn(n.slice(0, ji)) },
      e,
      gn(n.slice(ji))
    );
    return new Uint8Array(a);
  } catch {
    return null;
  }
}
async function er(e, t, n) {
  const a = await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(e),
    "PBKDF2",
    !1,
    ["deriveKey"]
  );
  return crypto.subtle.deriveKey(
    { name: "PBKDF2", salt: gn(t), iterations: n, hash: "SHA-256" },
    a,
    { name: "AES-GCM", length: 256 },
    !1,
    // non-extractable
    ["encrypt", "decrypt"]
  );
}
async function rg(e, t, n) {
  const a = await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(e),
    "PBKDF2",
    !1,
    ["deriveBits"]
  ), i = await crypto.subtle.deriveBits(
    { name: "PBKDF2", salt: gn(t), iterations: n, hash: "SHA-256" },
    a,
    ki * 8
  );
  return new Uint8Array(i);
}
async function hc(e) {
  return crypto.subtle.importKey("raw", gn(e), { name: "AES-GCM" }, !1, [
    "encrypt",
    "decrypt"
  ]);
}
async function sg(e, t) {
  return qr(e) ? (await Kx()).importVaultFmk(t) : hc(t);
}
const Xv = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
function h4(e) {
  let t = 0, n = 0, a = "";
  for (let i = 0; i < e.length; i++)
    for (n = n << 8 | e[i], t += 8; t >= 5; )
      a += Xv[n >>> t - 5 & 31], t -= 5;
  return t > 0 && (a += Xv[n << 5 - t & 31]), (a.match(/.{1,4}/g) || []).join("-");
}
function Bp() {
  return h4(crypto.getRandomValues(new Uint8Array(Cf)));
}
function lg(e) {
  const t = (e || "").toUpperCase().replace(/[\s-]/g, "").replace(/O/g, "0").replace(/[IL]/g, "1"), n = Math.ceil(Cf * 8 / 5);
  if (t.length !== n) return null;
  const a = new Uint8Array(Cf);
  let i = 0, r = 0, l = 0;
  for (const c of t) {
    const p = Xv.indexOf(c);
    if (p < 0) return null;
    i = i << 5 | p, r += 5, r >= 8 && (a[l++] = i >>> r - 8 & 255, r -= 8);
  }
  return l === Cf ? a : null;
}
async function ug(e, t) {
  const n = await crypto.subtle.importKey("raw", gn(e), "HKDF", !1, ["deriveKey"]);
  return crypto.subtle.deriveKey(
    {
      name: "HKDF",
      hash: "SHA-256",
      salt: gn(t),
      info: gn(new TextEncoder().encode(d4))
    },
    n,
    { name: "AES-GCM", length: 256 },
    !1,
    ["encrypt", "decrypt"]
  );
}
async function Fp(e, t) {
  const n = lg(t);
  if (!n) throw new Error("e2e: malformed recovery key");
  const a = crypto.getRandomValues(new Uint8Array(f4)), i = await ug(n, a), r = { salt: Ma(a), blob: await ni(i, e) };
  return n.fill(0), r;
}
async function m4(e) {
  return crypto.subtle.importKey(
    "spki",
    gn(ea(e)),
    { name: "RSA-OAEP", hash: "SHA-256" },
    !0,
    ["encrypt"]
  );
}
async function Wx(e) {
  const t = (e || "").replace(/-----[A-Z ]+-----/g, "").replace(/\s+/g, "");
  return crypto.subtle.importKey(
    "pkcs8",
    gn(ea(t)),
    { name: "RSA-OAEP", hash: "SHA-256" },
    !1,
    ["decrypt"]
  );
}
async function Yx(e) {
  const t = new Uint8Array(await crypto.subtle.digest("SHA-256", gn(ea(e))));
  return Array.from(t.slice(0, 8)).map((n) => n.toString(16).padStart(2, "0")).join("");
}
async function Uc(e, t) {
  const n = await m4(t), a = new Uint8Array(await crypto.subtle.encrypt({ name: "RSA-OAEP" }, n, gn(e)));
  return { kid: await Yx(t), alg: jx, blob: Ma(a) };
}
async function ppe(e, t = Np) {
  const n = Math.max(Ip, t), a = crypto.getRandomValues(new Uint8Array(16)), i = await er(e, a, n), r = await ni(i, new TextEncoder().encode(Qo));
  return { marker: { v: 1, salt: Ma(a), iter: n, verify: r }, kek: i };
}
async function Gx(e, t) {
  const n = KD(), a = VD(), i = {
    alg: kx,
    enc: wx,
    long: OD,
    key: await ni(e, n),
    root_id: Xo(a)
  };
  t && (i.pending = !0);
  const r = await ng(n, i.long, a);
  return n.fill(0), { slot: i, key: r };
}
async function Jv(e, t = {}) {
  const n = Math.max(Ip, t.iterations ?? Np), a = crypto.getRandomValues(new Uint8Array(16)), i = await er(e, a, n), r = crypto.getRandomValues(new Uint8Array(ki)), l = Bp(), c = {
    v: Rp,
    salt: Ma(a),
    iter: n,
    verify: await ni(i, new TextEncoder().encode(Qo)),
    fmk: "wrapped",
    fmk_pw: await ni(i, r),
    rk: await Fp(r, l)
  };
  t.escrowPublicKey && (c.esc = await Uc(r, t.escrowPublicKey));
  const p = await hc(r);
  if (r.fill(0), !t.encryptNames) return { marker: c, fmk: p, recoveryKey: l };
  const m = await Gx(p, !1);
  return c.v = $o, c.req = ["names"], c.names = m.slot, { marker: c, fmk: p, recoveryKey: l, names: m.key };
}
async function v4(e, t = {}) {
  const n = t.packLog2 ?? Hx;
  if (!s4.includes(n)) throw new Error(`e2e: a vault's packs are 2^22 or 2^24 bytes, not 2^${n}`);
  const [{ importVaultFmk: a }, { cryptoRandom: i, sealIndexFile: r }, { encodeIndexBody: l }] = await Promise.all([
    Kx(),
    import("./writer-kADDq7Ej.js").then((C) => C.w),
    import("./vindex-D8NO6SIT.js")
  ]), c = Math.max(Ip, t.iterations ?? Np), p = crypto.getRandomValues(new Uint8Array(16)), m = await er(e, p, c), v = crypto.getRandomValues(new Uint8Array(ki)), x = Bp(), w = crypto.getRandomValues(new Uint8Array(ig)), $ = {
    v: $o,
    req: [fc],
    salt: Ma(p),
    iter: c,
    verify: await ni(m, new TextEncoder().encode(Qo)),
    fmk: "wrapped",
    fmk_pw: await ni(m, v),
    rk: await Fp(v, x)
  };
  t.escrowPublicKey && ($.esc = await Uc(v, t.escrowPublicKey)), $.vault = { v: Ux, id: Xo(w), pack: n };
  const k = await a(v);
  v.fill(0);
  const b = await r(k, w, 1, l(/* @__PURE__ */ new Map(), []).body, i);
  return { marker: $, fmk: k, recoveryKey: x, vaultId: w, index: b };
}
async function y4(e, t, n = {}) {
  if (e.v !== 1) throw new Error("e2e: not a v1 marker");
  const a = ea(e.salt), i = await er(t, a, e.iter), r = await Ba(i, e.verify);
  if (!r || new TextDecoder().decode(r) !== Qo)
    throw new cn("e2e: wrong password");
  const l = await rg(t, a, e.iter), c = Bp(), p = {
    v: Rp,
    salt: e.salt,
    iter: e.iter,
    verify: e.verify,
    fmk: "kek",
    rk: await Fp(l, c)
  };
  return n.escrowPublicKey && (p.esc = await Uc(l, n.escrowPublicKey)), l.fill(0), { marker: p, fmk: i, recoveryKey: c };
}
async function g4(e, t, n) {
  if (!Xi(e)) throw new Error("e2e: not a v2 marker");
  if (e.esc) throw new Error("e2e: this folder already has an escrow slot");
  if (!n) throw new Error("e2e: no escrow public key");
  const a = ea(e.salt), i = await er(t, a, e.iter), r = await Ba(i, e.verify);
  if (!r || new TextDecoder().decode(r) !== Qo)
    throw new cn("e2e: wrong password");
  let l;
  if (e.fmk === "wrapped") {
    const m = e.fmk_pw ? await Ba(i, e.fmk_pw) : null;
    if (!m || m.length !== ki)
      throw new cn("e2e: could not unwrap the folder master key");
    l = m;
  } else
    l = await rg(t, a, e.iter);
  const c = await Uc(l, n);
  l.fill(0);
  const p = { ...e, esc: c };
  return delete p.esc_declined, p;
}
function b4(e, t) {
  return { ...e, esc_declined: t };
}
function U_(e, t) {
  return !t || !e || !Xi(e) || e.esc ? "n/a" : e.esc_declined ? "declined" : "offer";
}
function Xi(e) {
  return e.v === 2 || e.v === $o;
}
function rp(e) {
  let t;
  try {
    t = JSON.parse(e);
  } catch {
    return null;
  }
  if (!t || typeof t != "object" || t.v !== 1 && !Xi(t) || typeof t.salt != "string" || typeof t.verify != "string" || typeof t.iter != "number" || !Number.isInteger(t.iter) || t.iter < 1 || t.iter > Vx || Xi(t) && (t.fmk !== "kek" && t.fmk !== "wrapped" || t.fmk === "wrapped" && typeof t.fmk_pw != "string"))
    return null;
  const n = [];
  if (t.v === $o) {
    if (!Array.isArray(t.req) || t.req.some((a) => typeof a != "string")) return null;
    for (const a of t.req) c4.includes(a) || n.push(a);
    if (t.req.includes(fc)) {
      if (t.req.length !== 1 || t.fmk !== "wrapped" || typeof t.fmk_pw != "string" || t.names !== void 0 || t.rekey !== void 0 || t.conv !== void 0) return null;
      const a = k4(t.vault);
      if (a === "malformed") return null;
      a === "newer" && n.push(`${fc} v${t.vault.v}`);
    } else if (t.vault !== void 0)
      return null;
    if (t.req.includes("names") && !w4(t.names)) return null;
    if (t.req.includes("rekey")) {
      if (t.fmk !== "wrapped" || !t.rekey || typeof t.rekey.from != "string") return null;
    } else if (t.rekey !== void 0)
      return null;
    if (t.req.includes("conv")) {
      if (!t.conv || typeof t.conv != "object" || t.conv.pending !== !0) return null;
    } else if (t.conv !== void 0)
      return null;
  } else if (t.req !== void 0 || t.names !== void 0 || t.rekey !== void 0 || t.conv !== void 0 || t.vault !== void 0)
    return null;
  return { marker: t, unsupported: n };
}
function k4(e) {
  var n;
  if (!e || typeof e != "object" || Array.isArray(e)) return "malformed";
  const t = e;
  return typeof t.v != "number" || !Number.isInteger(t.v) || t.v < 1 || typeof t.id != "string" || ((n = _o(t.id)) == null ? void 0 : n.length) !== ig || !l4(t.pack) ? "malformed" : t.v > Ux ? "newer" : null;
}
function qr(e) {
  return !!e && e.v === $o && Array.isArray(e.req) && e.req.length === 1 && e.req[0] === fc && !!e.vault;
}
function hpe(e) {
  if (!qr(e)) return null;
  const t = _o(e.vault.id);
  return t && t.length === ig ? t : null;
}
function w4(e) {
  var t;
  return !!e && typeof e == "object" && e.alg === kx && e.enc === wx && typeof e.key == "string" && typeof e.long == "number" && Number.isInteger(e.long) && e.long >= 64 && e.long <= 255 && typeof e.root_id == "string" && ((t = _o(e.root_id)) == null ? void 0 : t.length) === Sl;
}
function mpe(e) {
  const t = rp(e);
  return !t || t.unsupported.length > 0 ? null : t.marker;
}
function qi(e) {
  return !!e && e.v === $o && Array.isArray(e.req) && e.req.includes("names") && !!e.names;
}
async function _4(e, t) {
  if (!qi(e)) return null;
  const n = await Ba(t, e.names.key);
  if (!n || n.length !== 64) return null;
  const a = await ng(n, e.names.long, _o(e.names.root_id));
  return n.fill(0), a;
}
async function H_(e, t) {
  if (e.v !== 2) throw new Error("e2e: only a v2 folder can switch to encrypted names");
  const n = await Gx(t, !0);
  return { marker: {
    ...e,
    v: $o,
    req: ["names"],
    names: n.slot
  }, names: n.key };
}
function x4(e) {
  if (!qi(e)) throw new Error("e2e: this folder has no encrypted names");
  const t = { ...e.names };
  return delete t.pending, { ...e, names: t };
}
const S4 = ["content", "names", "vault"], vpe = "content";
function ype(e = {}) {
  return S4.filter((t) => t !== "vault" || e.vault === !0);
}
function $4(e) {
  return qr(e) ? "vault" : e && qi(e) ? e.names.pending ? "pending" : "names" : "content";
}
function T4(e) {
  return !!e && e.v === 2 && !qi(e);
}
function K_(e) {
  return !!e && Xi(e) && !!e.rk;
}
function Xx(e) {
  return !!e && Xi(e) && !!e.esc;
}
function Jx(e, t) {
  return t ? Xx(e) ? e.esc.kid === t ? "available" : "other-key" : "predates" : "off";
}
async function Zx(e, t) {
  const n = await er(t, ea(e.salt), e.iter), a = await Ba(n, e.verify);
  return !a || new TextDecoder().decode(a) !== Qo ? null : n;
}
async function Qx(e, t) {
  if (e.v === 1 || e.fmk === "kek") return t;
  if (!e.fmk_pw) return null;
  const n = await Ba(t, e.fmk_pw);
  if (!n || n.length !== ki) return null;
  const a = await sg(e, n);
  return n.fill(0), a;
}
async function gpe(e, t) {
  const n = await Zx(e, t);
  return n ? Qx(e, n) : null;
}
async function eS(e, t) {
  const n = await Zx(e, t);
  if (!n) return { error: "wrong" };
  const a = await Qx(e, n);
  return a ? { fmk: a } : { error: "damaged" };
}
async function tS(e, t) {
  if (!Xi(e) || !e.rk) return null;
  const n = lg(t);
  if (!n) return null;
  let a;
  try {
    a = ea(e.rk.salt);
  } catch {
    return null;
  }
  const i = await ug(n, a);
  n.fill(0);
  const r = await Ba(i, e.rk.blob);
  if (!r || r.length !== ki) return null;
  const l = await sg(e, r);
  return r.fill(0), l;
}
async function nS(e, t) {
  if (!Xi(e) || !e.esc || e.esc.alg !== jx) return null;
  let n;
  try {
    n = new Uint8Array(
      await crypto.subtle.decrypt(
        { name: "RSA-OAEP" },
        t,
        gn(ea(e.esc.blob))
      )
    );
  } catch {
    return null;
  }
  if (n.length !== ki) return null;
  const a = await sg(e, n);
  return n.fill(0), a;
}
function Tl(e) {
  const t = e instanceof Uint8Array ? e : new Uint8Array(e);
  if (t.length < zf.length) return !1;
  for (let n = 0; n < zf.length; n++)
    if (t[n] !== zf[n]) return !1;
  return !0;
}
async function Zv(e, t) {
  if (t.byteLength > ec)
    throw new Error("e2e: file exceeds the 200MB single-shot limit");
  const n = crypto.getRandomValues(new Uint8Array(32)), a = await crypto.subtle.importKey("raw", gn(n), { name: "AES-GCM" }, !1, [
    "encrypt"
  ]), i = crypto.getRandomValues(new Uint8Array(ji)), r = crypto.getRandomValues(new Uint8Array(ji)), l = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: gn(i) }, e, gn(n))
  ), c = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: gn(r) }, a, t)
  );
  n.fill(0);
  const p = new Uint8Array(pc + c.length);
  return p.set(zf, 0), p[8] = og, p.set(i, cl), p.set(l, dl), p.set(r, Gv), p.set(c, pc), p.buffer;
}
async function sp(e, t) {
  const n = new Uint8Array(t);
  if (!Tl(n) || n.length < pc)
    throw new Error("e2e: not an encrypted file");
  if (n[8] === Nc) return t4(e, n);
  if (n[8] !== og)
    throw new Error(`e2e: unsupported version ${n[8]}`);
  const a = n.slice(cl, cl + ji), i = n.slice(dl, dl + qx), r = n.slice(Gv, Gv + ji);
  let l;
  try {
    l = await crypto.subtle.decrypt({ name: "AES-GCM", iv: gn(a) }, e, gn(i));
  } catch {
    throw new cn("e2e: DEK unwrap failed (wrong key?)");
  }
  const c = await crypto.subtle.importKey("raw", l, { name: "AES-GCM" }, !1, ["decrypt"]);
  try {
    return await crypto.subtle.decrypt(
      { name: "AES-GCM", iv: gn(r) },
      c,
      gn(n.slice(pc))
    );
  } catch {
    throw new cn("e2e: content decrypt failed");
  }
}
async function aS(e, t) {
  if ("recoveryKey" in t) {
    if (!Xi(e) || !e.rk) throw new cn("e2e: this folder has no recovery key");
    const l = lg(t.recoveryKey);
    if (!l) throw new cn("e2e: wrong recovery key");
    let c;
    try {
      c = ea(e.rk.salt);
    } catch {
      throw new cn("e2e: damaged recovery slot");
    }
    const p = await ug(l, c);
    l.fill(0);
    const m = await Ba(p, e.rk.blob);
    if (!m || m.length !== ki) throw new cn("e2e: wrong recovery key");
    return m;
  }
  const n = ea(e.salt), a = await er(t.password, n, e.iter), i = await Ba(a, e.verify);
  if (!i || new TextDecoder().decode(i) !== Qo)
    throw new cn("e2e: wrong password");
  if (e.v === 1 || e.fmk === "kek") return rg(t.password, n, e.iter);
  const r = e.fmk_pw ? await Ba(a, e.fmk_pw) : null;
  if (!r || r.length !== ki) throw new cn("e2e: could not unwrap the folder master key");
  return r;
}
async function iS(e, t, n) {
  if ((e ?? "").length < op)
    throw new Error(`e2e: the new password must be at least ${op} characters`);
  const a = Math.max(Ip, n ?? Np), i = crypto.getRandomValues(new Uint8Array(16)), r = await er(e, i, a);
  return {
    salt: Ma(i),
    iter: a,
    verify: await ni(r, new TextEncoder().encode(Qo)),
    fmk: "wrapped",
    fmk_pw: await ni(r, t)
  };
}
function oS(e) {
  return e.v === 1 || e.fmk === "kek";
}
function fl(e) {
  return !!e && Array.isArray(e.req) && e.req.includes("rekey") && !!e.rekey;
}
async function rS(e, t, n, a = {}) {
  if (oS(e))
    throw new Error("e2e: this folder needs its file keys re-wrapped to change its password (startRekey)");
  if (fl(e)) throw new Error("e2e: finish the re-key first");
  const i = await aS(e, t);
  try {
    return { ...e, ...await iS(n, i, a.iterations) };
  } finally {
    i.fill(0);
  }
}
class sS extends Error {
  constructor(t = "e2e: the escrow slot cannot be carried over to the new folder key") {
    super(t), this.name = "E2eRekeyEscrowError";
  }
}
async function A4(e, t, n, a = {}) {
  if (fl(e)) throw new Error("e2e: a re-key is already in progress; resume it");
  if (qr(e)) throw new Error("e2e: a vault is not re-keyed; make a new vault instead");
  const i = await aS(e, t), r = crypto.getRandomValues(new Uint8Array(ki));
  try {
    const l = await hc(i), c = await hc(r);
    let p;
    if (Xi(e) && e.esc) {
      const b = a.escrowPublicKey || null;
      if (!b || await Yx(b) !== e.esc.kid) throw new sS();
      p = await Uc(r, b);
    }
    const m = "recoveryKey" in t, v = m ? t.recoveryKey : Bp();
    let x, w;
    if (qi(e)) {
      const b = await Ba(l, e.names.key);
      if (!b || b.length !== 64) throw new cn("e2e: could not open the name key");
      w = { ...e.names, key: await ni(c, b) }, x = await ng(b, e.names.long, _o(e.names.root_id)), b.fill(0);
    }
    const $ = Array.from(/* @__PURE__ */ new Set([...e.req ?? [], "rekey"])), k = {
      ...e,
      v: $o,
      req: $,
      ...await iS(n, r, a.iterations),
      rk: await Fp(r, v),
      rekey: { from: await ni(c, i), pending: !0 }
    };
    return p && (k.esc = p), w && (k.names = w), {
      marker: k,
      fmk: c,
      previous: l,
      recoveryKey: v,
      recoveryKeyIsNew: !m,
      ...x ? { names: x } : {}
    };
  } finally {
    i.fill(0), r.fill(0);
  }
}
async function E4(e, t) {
  if (!fl(e)) return null;
  const n = await Ba(t, e.rekey.from);
  if (!n || n.length !== ki) return null;
  const a = await hc(n);
  return n.fill(0), a;
}
async function lS(e, t, n) {
  const a = new Uint8Array(e);
  if (!Tl(a) || a.length < pc) throw new Error("e2e: not an encrypted file");
  if (a[8] !== og && a[8] !== Nc) throw new Error(`e2e: unsupported version ${a[8]}`);
  const i = a.slice(cl, cl + ji), r = a.slice(dl, dl + qx);
  try {
    return await crypto.subtle.decrypt({ name: "AES-GCM", iv: gn(i) }, n, gn(r)), null;
  } catch {
  }
  let l;
  try {
    l = new Uint8Array(
      await crypto.subtle.decrypt({ name: "AES-GCM", iv: gn(i) }, t, gn(r))
    );
  } catch {
    throw new cn("e2e: this file opens under neither the new nor the previous folder key");
  }
  const c = crypto.getRandomValues(new Uint8Array(ji)), p = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: gn(c) }, n, gn(l))
  );
  l.fill(0);
  const m = a.slice();
  return m.set(c, cl), m.set(p, dl), m.buffer;
}
function V_(e) {
  var t;
  return !!e && Array.isArray(e.req) && e.req.includes("conv") && ((t = e.conv) == null ? void 0 : t.pending) === !0;
}
function C4(e, t = (/* @__PURE__ */ new Date()).toISOString(), n) {
  if (qr(e)) throw new Error("e2e: a vault is never converted");
  const a = Array.from(/* @__PURE__ */ new Set([...e.req ?? [], "conv"])), i = { pending: !0, started: t, ...n ? { cleanup: n } : {} };
  return { ...e, v: $o, req: a, conv: i };
}
function z4(e) {
  const t = { ...e };
  delete t.conv;
  const n = (e.req ?? []).filter((a) => a !== "conv");
  return n.length > 0 ? t.req = n : (delete t.req, t.v = Rp), t;
}
function M4(e) {
  const t = { ...e };
  delete t.rekey;
  const n = (e.req ?? []).filter((a) => a !== "rekey");
  return n.length > 0 ? t.req = n : (delete t.req, t.v = Rp), t;
}
async function P4(e, t, n) {
  try {
    return await sp(e, n);
  } catch (a) {
    if (!t || !(a instanceof cn)) throw a;
    return sp(t, n);
  }
}
function O4() {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  return {
    get(a) {
      return e.get(a);
    },
    set(a, i, r, l) {
      e.set(a, i), r ? t.set(a, r) : t.delete(a), l ? n.set(a, l) : n.delete(a);
    },
    /** The previous FMK of a folder mid re-key (files not re-wrapped yet). */
    previous(a) {
      return n.get(a);
    },
    /** A re-key finished: the previous FMK is no longer needed. */
    dropPrevious(a) {
      n.delete(a);
    },
    /** The folder's name key; undefined for a content-only folder or a locked one. */
    names(a) {
      return t.get(a);
    },
    setNames(a, i) {
      e.has(a) && t.set(a, i);
    },
    /** Every unlocked root, for resolving a path from any view. */
    roots() {
      return [...e.keys()];
    },
    /** Drop one folder's keys ("Lock"). */
    lock(a) {
      e.delete(a), t.delete(a), n.delete(a);
    },
    has(a) {
      return e.has(a);
    },
    clear() {
      e.clear(), t.clear(), n.clear();
    }
  };
}
function cg(e) {
  const t = e.indexOf("://");
  return t === -1 ? e : e.slice(t + 3);
}
function L4(e) {
  const t = cg(String(e ?? "")), n = t.lastIndexOf("/");
  return n === -1 ? "" : t.slice(0, n);
}
function Nr(e) {
  return typeof e.e2e_display_dir == "string" ? e.e2e_display_dir : L4(e.path);
}
function D4(e) {
  return (e || []).filter((t) => !(Ep(t.basename) || jf(t.path) || t.basename === ".trash" || t.basename === ga));
}
const uS = "filex.showHidden";
function R4() {
  try {
    return localStorage.getItem(uS) === "1";
  } catch {
    return !1;
  }
}
const tc = S(R4());
function N4(e) {
  tc.value = e;
  try {
    localStorage.setItem(uS, e ? "1" : "0");
  } catch {
  }
}
function I4(e, t) {
  return t ? e || [] : (e || []).filter((n) => !(n.basename || "").startsWith("."));
}
function Mr(e) {
  return I4(D4(e), tc.value);
}
function B4(e) {
  const t = cg(e);
  return t === "fileman" || t === "";
}
function F4(e) {
  return cg(e).startsWith("fileman/.trash");
}
function U4(e) {
  return {
    type: "dir",
    path: `${e}://fileman/.trash`,
    basename: ".trash",
    extension: "",
    storage: e,
    visibility: "private",
    size: 0,
    file_size: 0,
    mime_type: "inode/directory",
    extra_metadata: {}
  };
}
function cS(e, t, n, a, i = {}) {
  return !a || i.navOffersTrash || i.isSearchResult || F4(n) || !B4(n) ? !1 : (e.unshift(U4(t)), !0);
}
async function dS(e, t, n) {
  try {
    const { storages: a } = await n.listTrash(t, { limit: 1 }), i = e.find((c) => c.basename === ".trash");
    if (!i) return;
    const r = (a ?? []).find((c) => c.storage_name === t);
    i.size = (r == null ? void 0 : r.bytes) ?? 0;
    const l = r != null && r.newest_deleted_at ? Date.parse(r.newest_deleted_at) : NaN;
    Number.isNaN(l) || (i.last_modified = l);
  } catch {
  }
}
const fS = {
  /* gorunum:v3-shell — Home is a destination like the rest, so it gets a
     sentinel like the rest: a restored tab, a reload and a pasted `#.home`
     all have to reopen the overview instead of asking the backend for a
     folder called `.home` and landing on "not found". */
  ".home": "node.home",
  ".trash": "node.trash",
  ".recent": "node.recent",
  ".starred": "node.starred",
  ".shared": "node.shared",
  /* Drafts (issue #71): a view like the rest — a reload on `#.drafts` opens
     it, instead of asking the backend for a folder called `.drafts`. */
  ".drafts": "node.drafts"
}, pS = ".tag~", hS = [
  [".mytag~", "personal"],
  [".teamtag~", "team"],
  [pS, ""]
];
function H4(e, t = "") {
  var a;
  return `${((a = hS.find(([, i]) => i === t)) == null ? void 0 : a[0]) ?? pS}${e}`;
}
function dg(e) {
  for (const [t, n] of hS)
    if (e.startsWith(t)) {
      const a = e.slice(t.length);
      return a ? { tag: a, kind: n } : null;
    }
  return null;
}
function mS(e) {
  var t;
  return ((t = dg(e)) == null ? void 0 : t.tag) ?? "";
}
function K4(e) {
  var n;
  const t = (e || "").replace(/^\/+|\/+$/g, "");
  return ((n = dg(t.split("/").pop() || t)) == null ? void 0 : n.kind) ?? "";
}
function V4(e) {
  const t = (e || "").replace(/^\/+|\/+$/g, "");
  return mS(t.split("/").pop() || t);
}
function lp(e, t) {
  const n = fS[e];
  if (n) return t(n);
  const a = dg(e);
  return a ? a.kind ? `#${a.tag} · ${t(`tags.kind.${a.kind}`)}` : `#${a.tag}` : "";
}
function vS(e) {
  const t = String(e ?? "").replace(/^\/+|\/+$/g, "");
  return t ? !!fS[t] || !!mS(t) : !1;
}
function up(e, t) {
  const n = e.type === "dir" ? 0 : 1, a = t.type === "dir" ? 0 : 1;
  return n - a;
}
function Up() {
  return { w: {}, hidden: [] };
}
function Hp(e, t) {
  const n = Up();
  if (!e || typeof e != "object" || Array.isArray(e)) return n;
  const a = (p) => t.find((m) => m.id === p), i = e, r = {};
  if (i.w && typeof i.w == "object")
    for (const [p, m] of Object.entries(i.w)) {
      const v = a(p);
      !v || typeof m != "number" || !Number.isFinite(m) || (r[v.id] = Math.min(v.max, Math.max(v.min, Math.round(m))));
    }
  const l = Array.isArray(i.hidden) ? [...new Set(i.hidden.filter((p) => {
    var m;
    return (m = a(p)) == null ? void 0 : m.hideable;
  }))] : [], c = Array.isArray(i.o) ? [...new Set(i.o.filter((p) => !!a(p)))] : void 0;
  return c && c.length ? { w: r, hidden: l, o: c } : { w: r, hidden: l };
}
function yS(e, t, n) {
  const a = [...e];
  if (t < 0 || t >= a.length) return a;
  const i = Math.max(0, Math.min(a.length - 1, n));
  if (i === t) return a;
  const [r] = a.splice(t, 1);
  return a.splice(i, 0, r), a;
}
function gS(e, t) {
  const n = (r) => {
    var l;
    return ((l = t.find((c) => c.id === r)) == null ? void 0 : l.hideable) === !0;
  };
  let a = 0;
  for (; a < e.length && !n(e[a]); ) a++;
  let i = e.length - 1;
  for (; i >= 0 && !n(e[i]); ) i--;
  return { lo: a, hi: Math.max(a, i) };
}
const j4 = 3;
function bS(e, t, n = {}) {
  var E;
  const a = n.lead ?? ((E = e()[0]) == null ? void 0 : E.id), i = A(() => Hp(t.get(), e())), r = (R) => e().find((z) => z.id === R);
  function l(R) {
    t.set(R);
  }
  function c() {
    const R = e().map((U) => U.id), z = i.value.o;
    if (!z || z.length === 0)
      return [a, ...R.filter((U) => U !== a)];
    const D = z.filter((U) => R.includes(U) && U !== a);
    D.unshift(a);
    for (const U of R) D.includes(U) || D.push(U);
    return D;
  }
  function p(R) {
    const z = r(R);
    return z ? i.value.w[R] ?? z.width : 0;
  }
  function m(R, z) {
    const D = r(R);
    if (!D || !D.resizable) return;
    const U = Math.min(D.max, Math.max(D.min, Math.round(z)));
    i.value.w[R] !== U && l({ ...i.value, w: { ...i.value.w, [R]: U } });
  }
  function v() {
    return i.value.w[a] === void 0;
  }
  function x(R) {
    const z = { ...i.value.w };
    let D = !1;
    for (const [U, H] of Object.entries(R)) {
      if (typeof H != "number" || !Number.isFinite(H) || z[U] !== void 0) continue;
      const L = r(U);
      !L || !L.resizable || (z[U] = Math.min(L.max, Math.max(L.min, Math.round(H))), D = !0);
    }
    D && l({ ...i.value, w: z });
  }
  function w(R) {
    return i.value.hidden.includes(R);
  }
  function $(R, z) {
    const D = r(R);
    if (!D || !D.hideable || R === a || w(R) === z) return;
    const U = new Set(i.value.hidden);
    z ? U.add(R) : U.delete(R), l({ ...i.value, hidden: [...U] });
  }
  function k(R, z) {
    const D = r(R);
    if (!D || !D.hideable || R === a) return;
    const U = c(), H = U.indexOf(R);
    if (H === -1) return;
    const L = gS(U, e()), P = Math.max(L.lo, Math.min(L.hi, z)), K = yS(U, H, P);
    K.join() !== U.join() && l({ ...i.value, o: K });
  }
  function b() {
    l(Up());
  }
  function C() {
    var R;
    return t.customised ? t.customised() : Object.keys(i.value.w).length > 0 || i.value.hidden.length > 0 || (((R = i.value.o) == null ? void 0 : R.length) ?? 0) > 0;
  }
  function T(R, z, D = {}) {
    var _;
    const U = D.gap ?? 8, H = D.padding ?? 24, L = D.check ?? 0, P = D.menu ?? 28, K = r(a), N = c().filter((ee) => ee !== a && z.includes(ee) && !w(ee)), J = {};
    for (const ee of N) J[ee] = p(ee);
    J[a] = p(a);
    const j = (ee) => {
      const Y = (L > 0 ? 1 : 0) + 1 + ee + 1;
      return L + P + H + U * (Y - 1);
    }, re = j(N.length), q = v(), le = D.leadAuto ?? (K == null ? void 0 : K.width) ?? J[a], ve = K ? Math.min(le, K.min) : J[a], ce = N.slice(0, j4), se = j(ce.length) + ve + ce.reduce((ee, Y) => {
      var B;
      return ee + (((B = r(Y)) == null ? void 0 : B.min) ?? J[Y]);
    }, 0);
    if (q && R > 0 && K) {
      const ee = R - re;
      let Y = N.reduce((W, F) => W + J[F], 0);
      const B = ee - le;
      if (Y > B) {
        const W = N.reduce((F, V) => {
          var ke;
          return F + (J[V] - (((ke = r(V)) == null ? void 0 : ke.min) ?? J[V]));
        }, 0);
        if (W > 0) {
          const F = Math.min(1, (Y - B) / W);
          for (const V of N) {
            const ke = ((_ = r(V)) == null ? void 0 : _.min) ?? J[V];
            J[V] = Math.max(ke, J[V] - Math.ceil((J[V] - ke) * F));
          }
          Y = N.reduce((V, ke) => V + J[ke], 0);
        }
      }
      J[a] = Math.round(Math.max(ve, Math.min(K.max, ee - Y)));
    }
    const fe = re + J[a] + N.reduce((ee, Y) => ee + J[Y], 0);
    return { visible: N, widths: J, total: fe, auto: q, stackBelow: se };
  }
  return {
    lead: a,
    specs: e,
    spec: r,
    order: c,
    width: p,
    setWidth: m,
    hidden: w,
    setHidden: $,
    move: k,
    widthsAreAuto: v,
    freeze: x,
    reset: b,
    customised: C,
    state: () => i.value,
    layout: T
  };
}
function q4(e = Up()) {
  const t = Ea(e);
  return {
    get: () => t.value,
    set: (n) => {
      t.value = n;
    }
  };
}
let Ji = null;
const is = S(!1), Hc = S(!1);
function Xs() {
  return is.value;
}
function bpe() {
  return !0;
}
function kpe(e) {
}
function kS() {
  return Math.floor(Date.now() / 1e3);
}
function fg(e) {
  return e === "list" || e === "grid" || e === "gallery";
}
function pg(e) {
  return e === "name" || e === "type" || e === "modified" || e === "size";
}
function hg(e) {
  return e === "asc" || e === "desc";
}
function Wr(e) {
  var t;
  return !!e && (Object.keys(e.w).length > 0 || e.hidden.length > 0 || (((t = e.o) == null ? void 0 : t.length) ?? 0) > 0);
}
const Fn = S({});
function W4(e) {
  if (!e || typeof e != "object" || Array.isArray(e)) return {};
  const t = {};
  for (const [n, a] of Object.entries(e)) {
    if (!a || typeof a != "object") continue;
    const i = a, l = { t: typeof i.t == "number" && Number.isFinite(i.t) ? i.t : 0 };
    if (fg(i.v) && (l.v = i.v), pg(i.k) && (l.k = i.k), hg(i.d) && (l.d = i.d), i.c !== void 0) {
      const c = Hp(i.c, tr);
      Wr(c) && (l.c = c);
    }
    (l.v || l.k || l.c) && (t[n] = l);
  }
  return t;
}
const j_ = 300;
function Y4() {
  const e = Object.entries(Fn.value);
  if (e.length <= j_) return;
  e.sort((n, a) => a[1].t - n[1].t);
  const t = {};
  for (const [n, a] of e.slice(0, j_)) t[n] = a;
  Fn.value = t;
}
function q_(e, t) {
  const n = String(e ?? "").trim(), a = String(t ?? "").replace(/^[a-z][a-z0-9+.-]*:\/\//i, "").replace(/\/{2,}/g, "/").replace(/^\/+|\/+$/g, "");
  return n ? a ? `${n}/${a}` : n : a;
}
const G4 = ".root", Bm = {};
function wS(e) {
  if (!e) return null;
  const t = Fn.value[e];
  if (t) {
    const { t: n, ...a } = t, i = Bm[e];
    return i && !a.k ? { ...i, ...a } : a;
  }
  return Bm[e] ? { ...Bm[e] } : null;
}
function Qv(e) {
  return !!e && !!Fn.value[e];
}
function X4() {
  return Object.keys(Fn.value).length;
}
function _S(e, t) {
  if (!e) return;
  const n = Fn.value[e], a = { ...n ?? {}, ...t, t: kS() };
  if (t.c !== void 0 && !Wr(t.c) && delete a.c, !a.v && !a.k && !a.c) {
    n && xS(e);
    return;
  }
  Fn.value = { ...Fn.value, [e]: a }, Y4(), xo();
}
function J4(e) {
  if (!e) return;
  const t = Fn.value[e];
  if (!t) return;
  const n = kS();
  t.t !== n && (Fn.value = { ...Fn.value, [e]: { ...t, t: n } }, xo());
}
function xS(e) {
  if (!e || !Fn.value[e]) return;
  const t = { ...Fn.value };
  delete t[e], Fn.value = t, xo();
}
function wpe() {
  Fn.value = {}, xo();
}
const za = S({}), Kc = S({});
function mg(e) {
  if (!e || typeof e != "object" || Array.isArray(e)) return {};
  const t = e, n = {};
  if (fg(t.v) && (n.v = t.v), pg(t.k) && (n.k = t.k, hg(t.d) && (n.d = t.d)), t.c !== void 0) {
    const a = Hp(t.c, tr);
    Wr(a) && (n.c = a);
  }
  return n;
}
function Z4(e) {
  let t = e;
  if (typeof e == "string")
    try {
      t = JSON.parse(e);
    } catch {
      return {};
    }
  if (!t || typeof t != "object" || Array.isArray(t)) return {};
  const n = t, a = {};
  if (fg(n.v) && (a.v = n.v), pg(n.k) && (a.k = n.k, hg(n.d) && (a.d = n.d)), Array.isArray(n.hidden)) {
    const i = n.hidden.filter(
      (r) => typeof r == "string" && tr.some((l) => l.id === r && l.hideable)
    );
    i.length && (a.hidden = [...new Set(i)]);
  }
  return a;
}
function _pe() {
  return za.value;
}
function SS(e) {
  const t = { ...za.value };
  for (const [n, a] of Object.entries(e))
    a == null ? delete t[n] : t[n] = a;
  za.value = mg(t), mc(), xo();
}
function Q4(e) {
  za.value = mg({ ...za.value, ...e }), Fn.value = {}, mc(), xo();
}
function xpe() {
  return Kc.value;
}
function e5(e) {
  Kc.value = Z4(e), mc();
}
function Kp() {
  const e = za.value, t = Kc.value, n = {}, a = e.v ?? t.v;
  return a && (n.v = a), e.k ? (n.k = e.k, e.d && (n.d = e.d)) : t.k && (n.k = t.k, t.d && (n.d = t.d)), n;
}
function t5(e) {
  const t = wS(e), n = Kp(), a = {}, i = (t == null ? void 0 : t.v) ?? n.v;
  return i && (a.v = i), t != null && t.k ? (a.k = t.k, t.d && (a.d = t.d)) : n.k && (a.k = n.k, n.d && (a.d = n.d)), a;
}
const tr = [
  { id: "name", width: 260, min: 120, max: 900, hideable: !1, resizable: !0 },
  { id: "type", width: 88, min: 64, max: 220, hideable: !0, resizable: !0 },
  { id: "location", width: 160, min: 80, max: 420, hideable: !0, resizable: !0 },
  { id: "owner", width: 104, min: 72, max: 260, hideable: !0, resizable: !0 },
  { id: "modified", width: 160, min: 96, max: 300, hideable: !0, resizable: !0 },
  /* The Trash only: how long an item has left before it is purged. */
  { id: "remaining", width: 112, min: 80, max: 220, hideable: !0, resizable: !0 },
  { id: "size", width: 88, min: 64, max: 200, hideable: !0, resizable: !0 },
  { id: "star", width: 24, min: 24, max: 24, hideable: !1, resizable: !1 }
], W_ = { check: 28, menu: 28 }, Spe = 120, n5 = 220, $S = {
  gap: 8,
  padding: 24,
  check: W_.check,
  menu: W_.menu,
  leadAuto: n5
};
function Y_() {
  if (za.value.c) return za.value.c;
  const e = Kc.value.hidden;
  return e && e.length ? { w: {}, hidden: [...e] } : Up();
}
function TS(e) {
  return bS(
    () => tr,
    {
      get: () => {
        var n;
        const t = e();
        return t ? ((n = Fn.value[t]) == null ? void 0 : n.c) ?? Y_() : Y_();
      },
      set: (t) => {
        const n = e();
        if (!n) {
          SS({ c: Wr(t) ? t : void 0 });
          return;
        }
        _S(n, { c: t });
      },
      customised: () => {
        var n;
        const t = e();
        return t ? !!((n = Fn.value[t]) != null && n.c) : Wr(za.value.c);
      }
    },
    { lead: "name" }
  );
}
const ri = TS(() => "");
function ey() {
  return ri.order();
}
const $pe = yS;
function Tpe(e) {
  return gS(e, tr);
}
function Ape(e, t) {
  ri.move(e, t);
}
function Epe(e, t) {
  const n = ey().filter((l) => {
    var c;
    return (c = tr.find((p) => p.id === l)) == null ? void 0 : c.hideable;
  }), a = n.indexOf(e);
  if (a === -1) return;
  const i = a + t;
  if (i < 0 || i >= n.length) return;
  const r = n[i];
  ri.move(e, ey().indexOf(r));
}
function Cpe(e, t) {
  const n = ey().filter((i) => {
    var r;
    return (r = tr.find((l) => l.id === i)) == null ? void 0 : r.hideable;
  }), a = n.indexOf(e);
  return a === -1 ? !1 : a + t >= 0 && a + t < n.length;
}
function zpe(e) {
  return ri.width(e);
}
function Mpe(e, t) {
  ri.setWidth(e, t);
}
function Ppe() {
  return ri.widthsAreAuto();
}
function Ope(e) {
  ri.freeze(e);
}
function Lpe(e) {
  return ri.hidden(e);
}
function Dpe(e, t) {
  ri.setHidden(e, t);
}
function Rpe() {
  ri.reset();
}
function Npe() {
  return ri.customised();
}
function Ipe(e, t, n = {}) {
  return ri.layout(e, t, { ...$S, ...n });
}
const cf = {
  sort: "filex.list-sort",
  view: "brf-file-explorer:view-mode"
};
function mc() {
  const e = Kp();
  try {
    if (e.k) {
      const t = e.d ?? (e.k === "modified" ? "desc" : "asc");
      localStorage.setItem(cf.sort, JSON.stringify({ key: e.k, dir: t }));
    } else localStorage.removeItem(cf.sort);
    e.v ? localStorage.setItem(cf.view, e.v) : localStorage.removeItem(cf.view);
  } catch {
  }
}
const AS = ["on", "f", "p", "c", "g", "u"], vc = S(0), po = S({});
function a5(e) {
  const t = {};
  for (const [n, a] of Object.entries(e))
    AS.includes(n) || (t[n] = a);
  return t;
}
function i5() {
  const e = {
    ...po.value,
    on: !0,
    f: Fn.value,
    u: vc.value
  };
  return Object.keys(za.value).length && (e.p = za.value), e;
}
function o5(e) {
  if (!e || AS.includes(e))
    throw new Error(`viewPrefsSlot: "${e}" is reserved by lib/viewPrefs`);
  return {
    get: () => po.value[e],
    set(t) {
      po.value = { ...po.value, [e]: t }, xo();
    },
    clear() {
      if (!(e in po.value)) return;
      const t = { ...po.value };
      delete t[e], po.value = t, xo();
    },
    ready: () => is.value,
    persistable: () => Hc.value
  };
}
const r5 = 800;
let go, yc = !1;
function xo() {
  !is.value || !Hc.value || !Ji || (yc = !0, go && clearTimeout(go), go = setTimeout(Al, r5));
}
function Al() {
  go && clearTimeout(go), go = void 0, !(!yc || !Ji || !Hc.value) && (yc = !1, vc.value = Date.now(), Ji.save(i5()));
}
typeof window < "u" && (window.addEventListener("pagehide", Al), window.addEventListener("visibilitychange", () => {
  typeof document < "u" && document.visibilityState === "hidden" && Al();
}));
function s5(e) {
  Ji || (Ji = e, (async () => (await CS(!0), is.value = !0, u5()))());
}
function Bpe() {
  Al(), zS();
}
function Fpe() {
  return Ji !== null;
}
const cp = /* @__PURE__ */ new Set();
function ES(e) {
  return cp.add(e), () => cp.delete(e);
}
function G_() {
  for (const e of cp)
    try {
      e();
    } catch {
    }
}
async function CS(e) {
  if (!Ji) return;
  let t = null;
  try {
    t = await Ji.load();
  } catch {
    t = null;
  }
  if (!t || typeof t != "object" || Array.isArray(t)) {
    mc(), G_();
    return;
  }
  const n = t, a = typeof n.u == "number" && Number.isFinite(n.u) ? n.u : 0;
  if (!e) {
    if (yc) {
      Al();
      return;
    }
    if (a <= vc.value) return;
  }
  Fn.value = W4(n.f);
  let i = !1;
  if (n.p !== void 0)
    za.value = mg(n.p);
  else {
    const r = Hp(n.c, tr);
    za.value = Wr(r) ? { c: r } : {}, i = Wr(r) || n.g !== void 0 || n.c !== void 0;
  }
  vc.value = a, po.value = a5(n), Hc.value = !0, mc(), i && (is.value = !0, xo()), G_();
}
const l5 = 3e3;
let ty = 0, X_ = !1;
function J_(e = !1) {
  if (!Ji || !is.value) return;
  const t = Date.now();
  !e && t - ty < l5 || (ty = t, CS(!1));
}
function u5() {
  X_ || typeof window > "u" || (X_ = !0, window.addEventListener("focus", () => J_()), typeof document < "u" && document.addEventListener("visibilitychange", () => {
    document.visibilityState === "visible" && J_();
  }));
}
function zS() {
  Ji = null, is.value = !1, Hc.value = !1, Fn.value = {}, za.value = {}, Kc.value = {}, vc.value = 0, ty = 0, po.value = {}, yc = !1, go && clearTimeout(go), go = void 0;
}
function Upe() {
  zS(), cp.clear();
}
function Hpe() {
  Al();
}
const vg = ["name", "type", "modified", "size"], c5 = "filex.list-sort", nc = "name";
function El(e) {
  return e === "modified" ? "desc" : "asc";
}
function d5(e) {
  return typeof e == "string" && vg.includes(e);
}
function f5() {
  const e = { key: nc, dir: El(nc) };
  if (typeof localStorage > "u") return e;
  try {
    const t = localStorage.getItem(c5);
    if (!t) return e;
    const n = JSON.parse(t), a = d5(n.key) ? n.key : nc, i = n.dir === "asc" || n.dir === "desc" ? n.dir : El(a);
    return { key: a, dir: i };
  } catch {
    return e;
  }
}
const MS = S("en");
function yg(e) {
  MS.value = e;
}
function Z_(e) {
  const t = e.last_modified;
  return t ? t * (t < 1e12 ? 1e3 : 1) : null;
}
function PS(e, t) {
  return (e || "").localeCompare(t || "", void 0, {
    numeric: !0,
    sensitivity: "base"
  });
}
function Q_(e, t) {
  return PS(e.basename, t.basename);
}
function e1(e) {
  const t = mx(e);
  if (t)
    return (z_[MS.value] ?? z_.en)[t] ?? t;
  const n = (e.extension || "").trim();
  return n ? n.toUpperCase() : "";
}
function p5(e, t, n, a) {
  const i = t === "asc" ? 1 : -1;
  switch (e) {
    case "name":
      return i * Q_(n, a);
    case "size":
      return i * ((n.size ?? -1) - (a.size ?? -1));
    case "type": {
      const r = e1(n).localeCompare(e1(a), void 0, { sensitivity: "base" });
      return r !== 0 ? i * r : Q_(n, a);
    }
    default: {
      const r = Z_(n), l = Z_(a);
      return r == null && l == null ? 0 : r == null ? 1 : l == null ? -1 : i * (r - l);
    }
  }
}
const OS = /* @__PURE__ */ new Set(), ny = /* @__PURE__ */ new WeakMap();
function LS() {
  const e = gg(), t = S(e.key), n = S(e.dir);
  function a(v, x) {
    t.value = v, n.value = x ?? El(v);
  }
  function i(v, x) {
    t.value = v, n.value = x;
  }
  function r() {
    n.value = n.value === "asc" ? "desc" : "asc";
  }
  function l(v) {
    t.value === v ? r() : a(v);
  }
  function c(v, x) {
    return up(v, x) || p5(t.value, n.value, v, x);
  }
  function p(v) {
    return v === "relevance" ? up : c;
  }
  const m = {
    key: t,
    dir: n,
    setSort: a,
    applySort: i,
    toggleSortDir: r,
    chooseSortKey: l,
    compareNodes: c,
    compareInOrder: p,
    sortListing: (v, x = "sort") => [...v || []].sort(p(x))
  };
  return OS.add(m), ny.set(m, { ...e }), m;
}
const Vp = LS(), DS = Symbol("fe-sort-store");
function Vc() {
  return bi(DS, Vp);
}
function t1() {
  return Vp.key.value;
}
function n1() {
  return Vp.dir.value;
}
function a1(e, t) {
  Vp.applySort(e, t);
}
function gg() {
  const e = Kp();
  return e.k ? { key: e.k, dir: e.d ?? El(e.k) } : Xs() ? { key: nc, dir: El(nc) } : f5();
}
ES(() => {
  const e = gg();
  for (const t of OS) {
    const n = ny.get(t);
    !n || t.key.value !== n.key || t.dir.value !== n.dir || (t.applySort(e.key, e.dir), ny.set(t, { ...e }));
  }
});
function h5(e) {
  const t = `${(e.apiBase ?? "").replace(/\/+$/, "")}/api/files/manager/view-prefs`, n = e.credentials ?? "same-origin";
  return {
    async load() {
      var r;
      const a = await fetch(t, {
        headers: { ...await ((r = e.headers) == null ? void 0 : r.call(e)) ?? {} },
        credentials: n
      });
      if (!a.ok) return null;
      const i = await a.json();
      return e5((i == null ? void 0 : i.instance_default) ?? null), (i == null ? void 0 : i.prefs) ?? null;
    },
    save(a) {
      (async () => {
        var i;
        try {
          const r = JSON.stringify({ prefs: a });
          await fetch(t, {
            method: "PUT",
            headers: {
              ...await ((i = e.headers) == null ? void 0 : i.call(e)) ?? {},
              "Content-Type": "application/json"
            },
            credentials: n,
            body: r,
            /* ⚠ `keepalive` is what lets the save fired on `pagehide` outlive
             * the page — but browsers reject a keepalive body over 64 KB
             * outright, so the flag goes only on documents that fit. */
            keepalive: r.length < 6e4
          });
        } catch {
        }
      })();
    }
  };
}
function m5(e) {
  s5(h5(e));
}
const RS = Symbol("fe-table-env");
function v5(e) {
  Wo(RS, e);
}
function y5() {
  return bi(RS, null);
}
function Fm(e, t, n) {
  return e ? {} : t ? { disabled: !0, title: n } : { hidden: !0 };
}
function Kpe(e) {
  var n;
  if (!e) return !1;
  const t = (n = e.external) == null ? void 0 : n.onlyoffice;
  return t && !xv(t) ? !1 : !!e.onlyoffice_url;
}
const Um = {
  links: "share.links",
  uploadLinks: "share.upload_links",
  users: "share.users"
}, g5 = Object.freeze({ links: !0, uploadLinks: !0, users: !0 });
function b5(e) {
  return {
    links: e(Um.links),
    uploadLinks: e(Um.uploadLinks),
    users: e(Um.users)
  };
}
function k5(e, t) {
  return e.links || e.users || t && e.uploadLinks;
}
function w5(e) {
  const t = e.indexOf("://");
  return t > 0 && e.slice(t + 3).replace(/\/+/g, "") === "";
}
function Vpe(e, t) {
  return w5(e) ? { ...t, links: !1, uploadLinks: !1 } : t;
}
function _5(e) {
  const t = String(e.storage || e.path).replace(/:\/\/.*$/, "").replace(/^\/+|\/+$/g, "");
  return {
    path: `${t}://`,
    basename: e.basename || t,
    type: "dir",
    mime_type: "inode/storage",
    perm: "owner"
  };
}
function x5(e, t) {
  return [
    { key: "open", label: e("ctx.open") },
    { key: "open-tab", label: e("ctx.open_new_tab") },
    {
      key: "storage-access",
      label: e("ctx.storage_access"),
      icon: "access",
      hidden: !(t.manages && t.shareUsers)
    }
  ];
}
const S5 = /* @__PURE__ */ new Set(["none", "viewer", "editor", "owner"]);
function NS(e) {
  return typeof e == "string" && S5.has(e) ? e : void 0;
}
function $5(e) {
  const t = {};
  if (!Array.isArray(e)) return t;
  for (const n of e) {
    const a = n, i = NS(a == null ? void 0 : a.perm);
    typeof (a == null ? void 0 : a.name) == "string" && i && (t[a.name] = i);
  }
  return t;
}
function T5(e, t, n) {
  var a;
  return NS((a = t == null ? void 0 : t.find((i) => i.name === e)) == null ? void 0 : a.perm) ?? n[e];
}
function A5(e) {
  return e.admin || e.level === "owner";
}
function IS(e, t) {
  return e && !t;
}
function i1(e, t, n) {
  return IS(e, t) && (n == null ? void 0 : n.visible) === !0;
}
function BS(e, t) {
  return t ? !0 : e.some(Wy);
}
function FS(e, t = {}) {
  return t.busy || e.op_type !== "plugin" || e.status !== "done" || !e.plugin || !zp(e.open) ? null : { plugin: e.plugin, open: e.open };
}
const E5 = ["standard", "simple"], Hm = "standard", ay = /* @__PURE__ */ new Set();
function C5(e) {
  if (e === "simple") return "simple";
  if (e === "standard" || e === void 0 || e === null || e === "")
    return Hm;
  const t = typeof e == "string" ? e : String(e);
  return !ay.has(t) && typeof console < "u" && (ay.add(t), console.warn(
    `[filex] unknown uiProfile ${JSON.stringify(t)} - using "${Hm}". Valid values: ${E5.map((n) => `"${n}"`).join(", ")}. (The former "drive" profile was removed; pass "simple" for the reduced explorer.)`
  )), Hm;
}
function jpe() {
  ay.clear();
}
function tl(e, t) {
  return e ? e.endsWith("://") || e.endsWith("/") ? e + t : `${e}/${t}` : t;
}
function Ia(e) {
  const t = e.indexOf("://"), n = t === -1 ? "" : e.slice(0, t + 3), a = (t === -1 ? e : e.slice(t + 3)).replace(/\/+$/, ""), i = a.lastIndexOf("/");
  return i === -1 ? n : n + a.slice(0, i);
}
function pl(e) {
  const t = e.indexOf("://"), n = (t === -1 ? e : e.slice(t + 3)).replace(/\/+$/, ""), a = n.lastIndexOf("/");
  return a === -1 ? n : n.slice(a + 1);
}
function Pn(e) {
  const t = e.indexOf("://");
  return t === -1 ? e.replace(/^\/+|\/+$/g, "") : e.slice(0, t + 3) + e.slice(t + 3).replace(/^\/+|\/+$/g, "");
}
function Km(e) {
  const t = e.indexOf("://");
  return t === -1 ? e : e.slice(t + 3);
}
function nl(e, t) {
  const n = Pn(e), a = Pn(t);
  if (!a) return !1;
  const i = a.endsWith("://") ? a : `${a}/`;
  return n.length > i.length && n.startsWith(i);
}
function o1(e, t) {
  const n = Pn(e), a = Pn(t), i = a.endsWith("://") ? a : `${a}/`;
  return n.slice(i.length).split("/").filter(Boolean);
}
function Mf(e) {
  return typeof e.e2e_stored == "string" ? e.e2e_stored : e.basename;
}
function z5(e) {
  const { api: t, ring: n } = e, a = S(0), i = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Set();
  function p() {
    a.value++;
  }
  async function m(le) {
    try {
      const { blob: ve, url: ce } = await t.fetchBlob(tl(le, ga), { fresh: !0 });
      URL.revokeObjectURL(ce);
      const se = rp(await ve.text()), fe = se ? { marker: se.marker, unsupported: se.unsupported } : { marker: null, unsupported: [] };
      return r.set(le, fe.marker), fe;
    } catch {
      return r.set(le, null), { marker: null, unsupported: [] };
    }
  }
  async function v(le) {
    const ve = Pn(le);
    let ce = i.get(ve);
    return ce || (ce = m(ve), i.set(ve, ce)), (await ce).marker;
  }
  function x(le) {
    const ve = Pn(le);
    return r.has(ve) ? r.get(ve) : void 0;
  }
  function w(le, ve) {
    const ce = Pn(le);
    r.set(ce, ve), i.set(ce, Promise.resolve({ marker: ve, unsupported: [] })), p();
  }
  function $(le) {
    const ve = Pn(le);
    i.delete(ve), r.delete(ve), l.delete(ve);
    for (const ce of [...T.keys()]) ce.startsWith(`${ve}|`) && T.delete(ce);
    p();
  }
  function k(le) {
    return qi(x(le) ?? null);
  }
  function b(le, ve) {
    if (ve && nl(le, ve)) return Pn(ve);
    let ce = null;
    const se = /* @__PURE__ */ new Set([...n.roots(), ...r.keys()]);
    for (const fe of se)
      nl(le, fe) && (!ce || fe.length > ce.length) && (ce = Pn(fe));
    return ce;
  }
  function C(le) {
    const ve = Pn(le);
    let ce = l.get(ve);
    return ce || (ce = /* @__PURE__ */ new Map(), l.set(ve, ce)), ce;
  }
  const T = /* @__PURE__ */ new Map();
  function E(le, ve, ce) {
    const se = Pn(ce), fe = Pn(ve);
    if (se === fe || !nl(se, fe)) return Promise.resolve(le.rootId);
    const _ = `${fe}|${se}`;
    let ee = T.get(_);
    return ee || (ee = E(le, ve, Ia(se)).then((Y) => Hv(le, Y, pl(se))), T.set(_, ee)), ee;
  }
  const R = /* @__PURE__ */ new Map();
  function z(le, ve, ce, se) {
    const fe = C(ve), _ = `${Pn(ce)}/${se}`, ee = fe.get(_);
    if (ee) return Promise.resolve(ee);
    const Y = `${Pn(ve)}|${_}`, B = R.get(Y);
    if (B) return B;
    const W = E(le, ve, ce).then((F) => Cx(le, se, F, async (V) => {
      try {
        const ke = await t.fetchArrayBuffer(tl(ce, V));
        return new TextDecoder().decode(ke);
      } catch {
        return null;
      }
    })).then((F) => (F.state !== "unreadable" && fe.set(_, F), F)).finally(() => R.delete(Y));
    return R.set(Y, W), W;
  }
  function D(le, ve, ce, se) {
    C(le).set(`${Pn(ve)}/${ce.stored}`, { name: se, state: "enc" }), p();
  }
  async function U(le, ve) {
    const ce = n.names(le), se = o1(ve, le);
    if (!ce) return se.map(() => null);
    const fe = [];
    let _ = Pn(le);
    for (const ee of se) {
      const Y = await z(ce, le, _, ee);
      fe.push(Y.name), _ = tl(_, ee);
    }
    return fe;
  }
  async function H(le) {
    const ve = b(le);
    if (!ve) return null;
    const ce = n.names(ve);
    return ce ? z(ce, ve, Ia(le), pl(le)) : null;
  }
  async function L(le, ve) {
    const ce = Km(Pn(le)), fe = (await U(le, Ia(ve))).map((_) => _ === null ? e.lockedLabel() : _);
    return [ce, ...fe].filter(Boolean).join("/");
  }
  async function P(le, ve = {}) {
    return ve.root && await v(ve.root), (await Promise.all(le.map((se) => K(se, ve.root ?? null)))).filter((se) => se !== null);
  }
  async function K(le, ve) {
    var ke;
    const ce = le.type === "file" ? (ke = e.fileName) == null ? void 0 : ke.call(e, le.path) : void 0;
    ce && (le = { ...le, fxe_name: ce });
    const se = typeof le.e2e_root == "string" && le.e2e_root || ve, fe = b(le.path, se);
    if (!fe) return le;
    const _ = await v(fe);
    if (!qi(_)) return le;
    const ee = Mf(le);
    if (ee === ga || Il(ee).kind === "sidecar") return null;
    const B = n.names(fe), W = await L(fe, le.path), F = { ...le, e2e_stored: ee, e2e_root: fe, e2e_display_dir: W };
    if (!B)
      return { ...F, basename: e.lockedLabel(), extension: "", e2e_name_state: "locked" };
    const V = await z(B, fe, Ia(le.path), ee);
    return V.state === "enc" && V.name !== null ? {
      ...F,
      basename: V.name,
      extension: le.type === "dir" ? "" : ap(V.name),
      e2e_name_state: "enc"
    } : V.state === "plain" ? { ...F, basename: ee, e2e_name_state: "plain" } : { ...F, basename: e.unreadableLabel(), extension: "", e2e_name_state: "unreadable" };
  }
  function N(le) {
    a.value;
    const ve = b(le);
    if (!ve) return null;
    const ce = x(ve);
    if (ce === void 0)
      return v(ve).then(p), null;
    if (!qi(ce)) return null;
    const se = n.names(ve);
    if (!se) return e.lockedLabel();
    const fe = pl(le), _ = Ia(le), ee = `${Pn(_)}/${fe}`, Y = C(ve).get(ee);
    if (Y) return Y.name ?? e.unreadableLabel();
    const B = `${ve}|${ee}`;
    return c.has(B) || (c.add(B), z(se, ve, _, fe).finally(() => {
      c.delete(B), p();
    })), "…";
  }
  function J(le) {
    a.value;
    const ve = b(le);
    if (!ve || !k(ve)) return Km(Pn(le));
    const ce = Km(Pn(ve)), se = o1(le, ve), fe = [];
    let _ = Pn(ve);
    for (const ee of se)
      _ = tl(_, ee), fe.push(N(_) ?? ee);
    return [ce, ...fe].filter(Boolean).join("/");
  }
  function j(le) {
    const ve = Pn(le);
    for (const ce of /* @__PURE__ */ new Set([...n.roots(), ...r.keys()])) {
      const se = Pn(ce);
      if ((ve === se || nl(ve, se)) && k(se)) return se;
    }
    return null;
  }
  async function re(le, ve, ce = {}) {
    const se = j(le);
    if (!se) return null;
    const fe = n.names(se);
    if (!fe) throw new Error("e2e: the folder is locked");
    const _ = await E(fe, se, le), ee = ce.keepIdOf ? await E(fe, se, ce.keepIdOf) : void 0, Y = await Kv(fe, ve, _, { isDir: ce.isDir, dirId: ee });
    return D(se, le, Y, ve.normalize("NFC")), Y;
  }
  async function q(le) {
    const ve = b(le) ?? j(le);
    if (!ve) return null;
    const ce = n.names(ve);
    return ce ? E(ce, ve, le) : null;
  }
  return {
    version: a,
    markerFor: v,
    markerCached: x,
    setMarker: w,
    forget: $,
    namesOn: k,
    rootOf: b,
    decorate: P,
    decodePath: U,
    plainNameOf: H,
    segmentLabel: N,
    displayPath: J,
    writesEncrypted: j,
    nameForWrite: re,
    dirIdFor: q,
    remember: D,
    bump: p
  };
}
const jc = Symbol("filex.e2eNameView"), M5 = { class: "filex-recent" }, P5 = ["title", "aria-label", "disabled"], O5 = ["innerHTML"], L5 = { key: 0 }, D5 = ["data-fe-path"], R5 = ["onClick", "onContextmenu"], N5 = { class: "filex-recent-name" }, I5 = { class: "filex-recent-meta" }, B5 = {
  key: 1,
  class: "filex-recent-empty"
}, F5 = {
  key: 2,
  class: "filex-recent-empty"
}, U5 = /* @__PURE__ */ lt({
  __name: "RecentlyOpened",
  props: {
    apiBase: {},
    authHeaders: { type: Function },
    authCredentials: {},
    limit: {},
    refreshKey: {},
    locale: {}
  },
  emits: ["open", "context", "error"],
  setup(e, { emit: t }) {
    const n = e, { t: a } = ht(() => n.locale ?? "en"), i = t, r = S([]), l = S(!1), c = bi(jc, null), p = S({});
    async function m(w) {
      if (!c) return;
      const $ = w.map((T) => ({
        id: T.id,
        type: T.type === "dir" ? "dir" : "file",
        path: typeof T.storage == "string" && T.storage ? `${T.storage}://${String(T.path).replace(/^\/+/, "")}` : String(T.path),
        basename: T.name,
        ...typeof T.e2e_root == "string" && T.e2e_root ? { e2e_root: T.e2e_root } : {}
      })), k = await c.decorate($), b = new Set(k.map((T) => T.id)), C = {};
      for (const T of k) typeof T.id == "number" && T.e2e_stored && (C[T.id] = T.basename);
      p.value = C, b.size !== w.length && (r.value = w.filter((T) => b.has(T.id)));
    }
    c && Je(c.version, () => void m(r.value));
    async function v() {
      l.value = !0;
      try {
        const w = await (n.authHeaders ?? (() => ({})))(), $ = n.apiBase ?? "", k = n.limit ?? 20, b = await fetch(`${$}/api/files/manager/recent?limit=${k}`, {
          headers: w,
          credentials: n.authCredentials ?? "same-origin"
        });
        if (b.ok) {
          const C = await b.json();
          r.value = Array.isArray(C.nodes) ? C.nodes : Array.isArray(C.entries) ? C.entries : Array.isArray(C) ? C : [], await m(r.value);
        }
      } catch (w) {
        i("error", w instanceof Error ? w.message : String(w));
      } finally {
        l.value = !1;
      }
    }
    function x(w) {
      if (!w) return "";
      const $ = new Date(w).getTime();
      if (Number.isNaN($)) return "";
      const k = Date.now() - $;
      try {
        const b = new Intl.RelativeTimeFormat(gi(n.locale), { numeric: "auto", style: "short" });
        return k < 6e4 ? b.format(0, "second") : k < 36e5 ? b.format(-Math.floor(k / 6e4), "minute") : k < 864e5 ? b.format(-Math.floor(k / 36e5), "hour") : b.format(-Math.floor(k / 864e5), "day");
      } catch {
        return new Date($).toISOString().slice(0, 16).replace("T", " ");
      }
    }
    return jt(v), Je(() => n.refreshKey, v), (w, $) => (f(), h("div", M5, [
      d("header", null, [
        d("h3", null, y(u(a)("recents.title")), 1),
        d("button", {
          class: "filex-recent-refresh",
          type: "button",
          title: u(a)("recents.refresh"),
          "aria-label": u(a)("recents.refresh"),
          onClick: v,
          disabled: l.value
        }, [
          d("span", {
            "aria-hidden": "true",
            innerHTML: u(zt)("refresh")
          }, null, 8, O5)
        ], 8, P5)
      ]),
      r.value.length ? (f(), h("ul", L5, [
        (f(!0), h(Te, null, nt(r.value, (k) => (f(), h("li", {
          key: k.id,
          "data-testid": "recent-tray-item",
          "data-fe-path": k.path
        }, [
          d("button", {
            type: "button",
            class: "filex-recent-item",
            onClick: (b) => i("open", k),
            onContextmenu: yt((b) => i("context", k, b), ["prevent"])
          }, [
            d("span", N5, [
              d("bdi", null, y(p.value[k.id] ?? k.name), 1)
            ]),
            d("span", I5, y(x(k.last_opened)), 1)
          ], 40, R5)
        ], 8, D5))), 128))
      ])) : l.value ? (f(), h("p", F5, y(u(a)("recents.loading")), 1)) : (f(), h("p", B5, y(u(a)("recents.empty")), 1))
    ]));
  }
}), jo = {
  type: "any",
  modified: "any",
  size: "any",
  name: "",
  aroundDate: "",
  aroundSpan: "d1",
  sizeMin: null,
  sizeMax: null,
  pathMode: "any",
  pathBase: "",
  people: "any"
};
function yo(e) {
  return e.normalize("NFD").replace(new RegExp("\\p{M}+", "gu"), "").toLowerCase().replace(/ı/g, "i");
}
function bg(e) {
  return (e.name ?? "").trim();
}
function US(e) {
  return (e.pathMode ?? "any") !== "any" && !!(e.pathBase ?? "");
}
function kg(e) {
  return e.people ?? "any";
}
function al(e) {
  return e.type !== "any" || e.modified !== "any" || e.size !== "any" || bg(e) !== "" || US(e) || kg(e) !== "any";
}
function H5(e) {
  return (e.type !== "any" ? 1 : 0) + (e.modified !== "any" ? 1 : 0) + (e.size !== "any" ? 1 : 0) + (bg(e) !== "" ? 1 : 0) + (US(e) ? 1 : 0) + (kg(e) !== "any" ? 1 : 0);
}
const K5 = {
  folder: ["folder"],
  document: ["doc", "text"],
  spreadsheet: ["sheet"],
  presentation: ["slides"],
  pdf: ["pdf"],
  image: ["image"],
  video: ["video"],
  audio: ["audio"],
  archive: ["archive"],
  code: ["code"]
};
function V5(e, t) {
  if (t === "any") return !0;
  if (t === "folder") return e.type === "dir";
  if (e.type === "dir") return !1;
  const n = e.kind;
  return typeof n == "string" && n !== "" ? n === t || t === "document" && n === "text" : K5[t].includes(xi(e));
}
const j5 = {
  h1: 36e5,
  d1: 864e5,
  w1: 7 * 864e5
};
function q5(e) {
  const t = (e ?? "").trim();
  if (!t) return null;
  const n = Date.parse(t.includes("T") ? t : `${t}T00:00`);
  return Number.isNaN(n) ? null : n;
}
function HS(e, t = Date.now()) {
  const n = e.modified;
  if (n === "any") return null;
  if (n === "around") {
    const i = q5(e.aroundDate);
    if (i === null) return null;
    const r = j5[e.aroundSpan ?? "d1"];
    return { after: i - r, before: i + r };
  }
  if (n === "year") {
    const i = new Date(t).getFullYear();
    return { after: new Date(i, 0, 1).getTime(), before: new Date(i + 1, 0, 1).getTime() - 1 };
  }
  if (n === "today") {
    const i = new Date(t);
    return i.setHours(0, 0, 0, 0), { after: i.getTime() };
  }
  return { after: t - (n === "7d" ? 7 : 30) * 864e5 };
}
function W5(e, t, n) {
  const a = HS(t, n);
  if (!a) return !0;
  const i = typeof e.last_modified == "number" ? e.last_modified : 0;
  return !(!i || a.after !== void 0 && i < a.after || a.before !== void 0 && i > a.before);
}
const js = 1024 * 1024;
function KS(e) {
  switch (e.size) {
    case "any":
      return null;
    case "lt1":
      return { max: js - 1 };
    case "1to10":
      return { min: js, max: 10 * js - 1 };
    case "10to100":
      return { min: 10 * js, max: 100 * js - 1 };
    case "gt100":
      return { min: 100 * js };
    case "range": {
      const t = typeof e.sizeMin == "number" ? e.sizeMin : void 0, n = typeof e.sizeMax == "number" ? e.sizeMax : void 0;
      return { min: t, max: n };
    }
  }
  return null;
}
function Y5(e, t) {
  const n = KS(t);
  if (!n) return !0;
  if (e.type === "dir") return !1;
  const a = typeof e.size == "number" ? e.size : 0;
  return !(n.min !== void 0 && a < n.min || n.max !== void 0 && a > n.max);
}
function VS(e, t) {
  return t ? yo(e || "").includes(yo(t)) : !0;
}
function G5(e, t) {
  const n = t.pathMode ?? "any", a = (t.pathBase ?? "").replace(/\/+$/, "");
  if (n === "any" || !a) return !0;
  const i = e.path || "", r = i === a || i.startsWith(`${a}/`);
  return n === "here" ? r : !r;
}
function gc(e) {
  const t = e.owner_id;
  return typeof t == "number" && t > 0 ? t : null;
}
function jp(e) {
  return e.owner_self === !0;
}
function wg(e) {
  const t = e.owner_name;
  return typeof t == "string" ? t : "";
}
function r1(e) {
  const t = e.deleted_by_id;
  return typeof t == "number" && t > 0 ? t : null;
}
function s1(e) {
  return e.deleted_by_self === !0;
}
function X5(e) {
  const t = e.deleted_by_name;
  return typeof t == "string" ? t : "";
}
function J5(e) {
  return e.external_upload === !0;
}
function Z5(e) {
  const t = [{ value: "any" }, { value: "me" }, { value: "system" }], n = /* @__PURE__ */ new Set();
  for (const r of e) {
    const l = gc(r);
    l === null || jp(r) || n.has(l) || (n.add(l), t.push({ value: `u:${l}`, name: wg(r) }));
  }
  const a = t.slice(0, 3), i = t.slice(3).sort((r, l) => (r.name ?? "").localeCompare(l.name ?? "", void 0, { sensitivity: "base" }));
  return [...a, ...i];
}
function Q5(e, t) {
  const n = kg(t);
  if (n === "any") return !0;
  if (n === "me") return jp(e);
  if (n === "system") return gc(e) === null;
  const a = Number(n.slice(2));
  return Number.isFinite(a) && gc(e) === a;
}
function iy(e, t, n = Date.now()) {
  return al({ ...t, name: "" }) ? e.filter(
    (a) => V5(a, t.type) && W5(a, t, n) && Y5(a, t) && G5(a, t) && Q5(a, t)
  ) : e;
}
const eR = /* @__PURE__ */ lt({
  __name: "UploadProgress",
  props: {
    jobs: {},
    locale: {},
    center: {}
  },
  emits: ["cancel", "dismiss", "retry"],
  setup(e, { emit: t }) {
    const n = e, { t: a } = ht(() => n.locale);
    function i(c) {
      return c === "committing" || c === "transferring";
    }
    const r = t;
    function l(c) {
      return c === "done" ? "done" : c === "error" ? "error" : c === "aborted" ? "aborted" : "running";
    }
    return Je(
      () => n.jobs,
      (c) => {
        n.center.sync(
          "upload",
          c.map((p) => ({
            input: {
              id: p.id,
              kind: "upload",
              name: p.displayName ?? p.file.name,
              percent: i(p.status) ? null : p.totalBytes > 0 || p.status === "done" ? p.percent : null,
              message: i(p.status) ? a("upload.saving") : null,
              status: l(p.status),
              error: p.error ?? null,
              uploadedBytes: p.uploadedBytes,
              totalBytes: p.totalBytes,
              // Cancellable only while chunks are still moving: once the commit is
              // accepted the bytes are filex's and the ops worker owns the rest.
              cancellable: p.status === "uploading" || p.status === "initializing",
              retryable: p.status === "error"
            },
            actions: {
              cancel: () => r("cancel", p),
              dismiss: () => r("dismiss", p),
              retry: () => r("retry", p)
            }
          }))
        );
      },
      { immediate: !0 }
    ), (c, p) => O("", !0);
  }
});
function Vm(e) {
  return Math.max(0, Math.min(100, Math.round(e)));
}
function jS(e) {
  if (e.progress_total > 1) return null;
  const t = e.objects_total ?? 0;
  return t > 0 ? { done: e.objects_done ?? 0, total: t } : null;
}
function tR(e) {
  if (e.status === "done") return 100;
  const t = e.bytes_total ?? 0, n = e.bytes_done ?? 0;
  if (t > 0) return Vm(n / t * 100);
  if (n > 0) return null;
  if (e.progress_total <= 1) {
    const a = jS(e);
    return a ? Vm(a.done / a.total * 100) : null;
  }
  return Vm(e.progress_done / e.progress_total * 100);
}
const nR = /* @__PURE__ */ lt({
  __name: "PendingOpsTray",
  props: {
    ops: {},
    locale: {},
    center: {},
    outputModeOf: { type: Function },
    callerAdmin: { type: Boolean }
  },
  emits: ["dismiss", "cancel", "open"],
  setup(e, { emit: t }) {
    const n = e, { t: a } = ht(() => n.locale);
    function i(k) {
      return Xf(k, a, { callerAdmin: n.callerAdmin === !0 });
    }
    const r = t;
    function l(k) {
      return k.status === "done" ? "done" : k.status === "cancelled" ? "aborted" : k.status === "error" ? "error" : "running";
    }
    const c = /* @__PURE__ */ new Set([
      "copy",
      "move",
      "delete",
      "rename",
      "restore",
      "purge",
      "plugin",
      "archive-create",
      "archive-extract"
    ]);
    function p(k) {
      return k.op_type === "trash-empty" ? "trash" : k.op_type === "thumb-repair" ? "thumbs" : c.has(k.op_type) ? k.op_type : "plugin";
    }
    function m(k) {
      return k.op_type === "plugin";
    }
    function v(k) {
      return k.status !== "pending" && k.status !== "running" ? !1 : k.op_type === "archive-create" || k.op_type === "archive-extract" ? k.cancellable : m(k) ? !0 : (k.op_type === "trash-empty" || k.op_type === "thumb-repair") && n.callerAdmin === !0;
    }
    const x = (k) => tR(k);
    function w(k) {
      if (k.op_type === "trash-empty" || k.op_type === "thumb-repair") return "";
      const b = k.label || k.target_path || k.source_dir || "";
      return b || (k.op_type === "restore" || k.op_type === "purge" ? a("opc.trash_items", { n: k.progress_total || k.source_count }) : "");
    }
    function $(k) {
      const b = jS(k);
      return b ? { itemsDone: b.done, itemsTotal: b.total } : {};
    }
    return Je(
      () => n.ops,
      (k) => {
        n.center.sync(
          "ops",
          k.map((b) => {
            var C;
            return {
              input: {
                id: b.id,
                kind: p(b),
                name: w(b),
                percent: x(b),
                status: l(b),
                error: b.status === "error" ? i(b).text : null,
                errorDetail: b.status === "error" ? i(b).detail ?? null : null,
                queued: b.status === "pending",
                waitText: b.status === "pending" ? b.wait_text ?? null : null,
                cancelling: b.status === "cancelling",
                doneCount: b.progress_done,
                totalCount: b.progress_total,
                ...$(b),
                cancellable: v(b),
                retryable: !1,
                message: b.message ?? null,
                outputs: (b.outputs ?? []).map((T) => T.path),
                outputMode: (m(b) ? (C = n.outputModeOf) == null ? void 0 : C.call(n, b) : void 0) ?? null
              },
              actions: {
                cancel: () => r("cancel", b.id),
                dismiss: () => r("dismiss", b.id),
                open: (T) => r("open", b.id, T)
              }
            };
          })
        );
      },
      { immediate: !0 }
    ), (k, b) => O("", !0);
  }
});
function qc(e) {
  if (!e || e.locked !== !0) return null;
  const t = e.lock;
  return !t || typeof t != "object" || typeof t.plugin != "string" || !t.plugin ? null : t;
}
function qpe(e) {
  return e.some((t) => qc(t) !== null);
}
function oy(e) {
  const t = e;
  if (!t || t.status !== 423) return null;
  const n = { plugin: "" };
  typeof t.server == "string" && t.server && (n.message = t.server);
  try {
    const a = JSON.parse(String(t.detail ?? ""));
    typeof a.plugin == "string" && (n.plugin = a.plugin), a.plugin_label && typeof a.plugin_label == "object" && (n.plugin_label = a.plugin_label), typeof a.path == "string" && (n.path = a.path), typeof a.reason == "string" && a.reason && (n.reason = a.reason), a.reason_text && typeof a.reason_text == "object" && (n.reason_text = a.reason_text), typeof a.until == "string" && a.until && (n.until = a.until), !n.message && typeof a.message == "string" && a.message && (n.message = a.message);
  } catch {
  }
  return n;
}
function aR(e, t) {
  return e && (Xt(e.reason_text, t || "en") || e.reason) || "";
}
function Yr(e, t) {
  if (!e) return "";
  const n = e.message;
  if (n) return Yi(t.locale, n);
  const a = Xt(e.plugin_label, t.locale || "en") || e.plugin || t.t("applock.some_app"), i = aR(e, t.locale), r = i ? t.t("applock.held_reason", { app: a, reason: i }) : t.t("applock.held", { app: a }), l = iR(e.until, t);
  return l ? `${r} ${l}` : r;
}
function iR(e, t) {
  if (!e) return "";
  const n = Date.parse(e);
  if (!Number.isFinite(n)) return "";
  const a = t.formatDate ? t.formatDate(n, { time: !0 }) : new Date(n).toISOString();
  return t.t("applock.until", { date: a });
}
const oR = ["outside_root", "broken", "unresolved"];
function qS(e) {
  if (!e || e.symlink !== !0) return null;
  const t = e.link_state;
  return typeof t == "string" && oR.includes(t) ? t : "unknown";
}
function rR(e, t) {
  switch (e) {
    case "outside_root":
      return { state: e, badge: t.t("symlink.badge.outside_root"), why: t.t("symlink.why.outside_root") };
    case "broken":
      return { state: e, badge: t.t("symlink.badge.broken"), why: t.t("symlink.why.broken") };
    case "unresolved":
      return { state: e, badge: t.t("symlink.badge.unresolved"), why: t.t("symlink.why.unresolved") };
    case "unknown":
      return { state: e, badge: t.t("symlink.badge.unknown"), why: t.t("symlink.why.unknown") };
    default:
      return null;
  }
}
function Wc(e, t) {
  return rR(qS(e), t);
}
function Wpe(e) {
  return qS(e) !== null;
}
function WS(e) {
  return !!e && e.unavailable === !0;
}
function Yc(e, t) {
  if (!WS(e)) return null;
  const n = e.type === "dir" ? t.t("unavailable.why.dir") : t.t("unavailable.why.file"), a = typeof e.unavailable_reason == "string" ? e.unavailable_reason.trim() : "", i = a ? t.t("unavailable.withReason", { why: n, reason: a }) : n;
  return { badge: "!", why: n, reason: a, full: i };
}
function qp(e) {
  if (!e) return "";
  for (const t of [e.name, e.display_name, e.username, e.email]) {
    const n = typeof t == "string" ? t.trim() : "";
    if (n) return n;
  }
  return "";
}
function sR(e, t) {
  const n = qp(e);
  return n ? [...n][0].toLocaleUpperCase(t) : "";
}
function _g(e) {
  const t = Number(e);
  return Number.isFinite(t) ? (Math.round(t / 90) * 90 % 360 + 360) % 360 : 0;
}
const l1 = { w: 0.02, h: 0.01 }, dp = (e) => Math.min(1, Math.max(0, e));
function hl(e) {
  const t = Math.min(1, Math.max(l1.w, Number(e.w) || 0)), n = Math.min(1, Math.max(l1.h, Number(e.h) || 0)), a = Math.min(1 - t, dp(Number(e.x) || 0)), i = Math.min(1 - n, dp(Number(e.y) || 0));
  return { x: a, y: i, w: t, h: n };
}
function df(e, t) {
  return hl({
    x: Math.min(e.x, t.x),
    y: Math.min(e.y, t.y),
    w: Math.abs(e.x - t.x),
    h: Math.abs(e.y - t.y)
  });
}
function Ype(e, t) {
  return {
    left: e.x * t.width,
    top: e.y * t.height,
    width: e.w * t.width,
    height: e.h * t.height
  };
}
function Gpe(e, t) {
  const n = t.width || 1, a = t.height || 1;
  return { x: e.left / n, y: e.top / a, w: e.width / n, h: e.height / a };
}
function u1(e, t) {
  return { x: dp(e.x / (t.width || 1)), y: dp(e.y / (t.height || 1)) };
}
function YS(e) {
  const t = _g(e.rotation);
  return t === 90 || t === 270 ? { width: e.height, height: e.width } : { width: e.width, height: e.height };
}
function c1(e, t, n) {
  const a = _g(n.rotation), i = n.width, r = n.height;
  switch (a) {
    case 90:
      return { x: t, y: i - e };
    case 180:
      return { x: i - e, y: r - t };
    case 270:
      return { x: r - t, y: e };
    default:
      return { x: e, y: t };
  }
}
function d1(e, t, n) {
  const a = _g(n.rotation), i = n.width, r = n.height;
  switch (a) {
    case 90:
      return { X: i - t, Y: e };
    case 180:
      return { X: i - e, Y: r - t };
    case 270:
      return { X: t, Y: r - e };
    default:
      return { X: e, Y: t };
  }
}
function Xpe(e, t) {
  const n = c1(e.x * t.width, e.y * t.height, t), a = c1((e.x + e.w) * t.width, (e.y + e.h) * t.height, t), { height: i } = YS(t), r = Math.min(n.x, a.x), l = Math.max(n.x, a.x), c = Math.min(n.y, a.y), p = Math.max(n.y, a.y);
  return GS({ x: r, y: i - p, w: l - r, h: p - c });
}
function Jpe(e, t) {
  const { height: n } = YS(t), a = { x: e.x, y: n - (e.y + e.h) }, i = { x: e.x + e.w, y: n - e.y }, r = d1(a.x, a.y, t), l = d1(i.x, i.y, t), c = t.width || 1, p = t.height || 1;
  return GS({
    x: Math.min(r.X, l.X) / c,
    y: Math.min(r.Y, l.Y) / p,
    w: Math.abs(r.X - l.X) / c,
    h: Math.abs(r.Y - l.Y) / p
  });
}
function GS(e) {
  const t = {};
  for (const [n, a] of Object.entries(e)) t[n] = Math.round(a * 1e6) / 1e6;
  return t;
}
function lR(e, t, n = 16) {
  const a = Math.max(0, e.width), i = Math.max(0, e.height) - n;
  if (!t.width || !t.height || i <= 0) return a;
  const r = i * t.width / t.height;
  return Math.max(120, Math.min(a, r));
}
const Cl = [
  { key: "caveat", name: "Caveat", kind: "hand", className: "fe-signfont--caveat", stack: "'Caveat', cursive" },
  {
    key: "dancing-script",
    name: "Dancing Script",
    kind: "hand",
    className: "fe-signfont--dancing-script",
    stack: "'Dancing Script', cursive"
  },
  {
    key: "homemade-apple",
    name: "Homemade Apple",
    kind: "hand",
    className: "fe-signfont--homemade-apple",
    stack: "'Homemade Apple', cursive"
  },
  {
    key: "inter",
    name: "Inter",
    kind: "formal",
    className: "fe-signfont--inter",
    stack: 'Inter, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif'
  },
  {
    key: "source-serif",
    name: "Source Serif 4",
    kind: "formal",
    className: "fe-signfont--source-serif",
    stack: "'Source Serif 4', Georgia, 'Times New Roman', serif"
  }
], XS = "caveat";
function JS(e) {
  const t = String(e ?? "");
  return Cl.find((n) => n.key === t) ?? Cl.find((n) => n.key === XS);
}
function bc(e) {
  return typeof e == "string" && Cl.some((t) => t.key === e);
}
const ry = ["any", "number", "email"];
function uR(e) {
  return typeof e == "string" && ry.includes(e);
}
function cR(e) {
  if (!e || typeof e != "object") return null;
  const t = e, a = { kind: uR(t.kind) ? t.kind : "any" }, i = Math.trunc(Number(t.min)), r = Math.trunc(Number(t.max));
  return Number.isFinite(i) && i > 0 && (a.min = i), Number.isFinite(r) && r > 0 && (a.max = r), a.kind === "any" && a.min === void 0 && a.max === void 0 ? null : a;
}
function dR(e) {
  return e ? e.kind === "number" ? "numeric" : e.kind === "email" ? "email" : "text" : "text";
}
function ZS(e) {
  if (e)
    return e.max && e.max > 0 ? e.max : void 0;
}
function fR(e, t) {
  let n = String(e ?? "");
  if (!t) return n;
  if (t.kind === "number") {
    const i = n.startsWith("-");
    let r = !1;
    n = n.split("").filter((l) => l >= "0" && l <= "9" ? !0 : (l === "." || l === ",") && !r ? (r = !0, !0) : !1).join(""), i && (n = `-${n}`);
  } else t.kind === "email" && (n = n.replace(/\s+/g, ""));
  const a = ZS(t);
  return a && n.length > a && (n = n.slice(0, a)), n;
}
function pR(e, t) {
  const n = typeof e == "string" ? e.trim() : "";
  return !t || n === "" ? "" : t.min && n.length < t.min ? "min" : t.max && n.length > t.max ? "max" : t.kind === "number" ? /^-?\d+([.,]\d+)?$/.test(n) ? "" : "number" : t.kind === "email" ? /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(n) ? "" : "email" : "";
}
const Pf = ["signature", "initials", "date", "text", "checkbox"];
function QS(e) {
  return e === "signature" || e === "initials";
}
function e$(e, t) {
  if (!Array.isArray(e)) return [];
  const n = [], a = /* @__PURE__ */ new Set();
  for (const i of e) {
    if (!i || typeof i != "object") continue;
    const r = typeof i.id == "string" ? i.id.trim() : "";
    if (!r || a.has(r)) continue;
    a.add(r);
    const l = { id: r, label: i.label ?? r };
    t(l, i), n.push(l);
  }
  return n;
}
function hR(e) {
  return e$(e, (t, n) => {
    n.examples && typeof n.examples == "object" && !Array.isArray(n.examples) && (t.examples = n.examples), n.default === !0 && (t.default = !0);
  });
}
function mR(e, t) {
  if (Array.isArray(e.lines)) {
    const n = new Set(e.lines);
    return t.filter((a) => n.has(a.id)).map((a) => a.id);
  }
  return t.filter((n) => n.default).map((n) => n.id);
}
function vR(e, t) {
  const n = e.examples ?? {};
  return n[t || "*"] ?? n["*"] ?? "";
}
const fp = {
  signature: { w: 0.28, h: 0.06 },
  initials: { w: 0.1, h: 0.05 },
  date: { w: 0.16, h: 0.035 },
  text: { w: 0.26, h: 0.035 },
  checkbox: { w: 0.03, h: 0.022 }
}, jm = ["#2563eb", "#16a34a", "#d97706", "#9333ea", "#dc2626", "#0891b2"];
function t$(e) {
  return typeof e == "string" && Pf.includes(e);
}
function yR(e) {
  if (!Array.isArray(e)) return [...Pf];
  const t = e.filter(t$);
  return t.length ? Pf.filter((n) => t.includes(n)) : [...Pf];
}
function Of(e) {
  if (!Array.isArray(e)) return [];
  const t = [], n = /* @__PURE__ */ new Set();
  for (const a of e) {
    if (!a || typeof a != "object") continue;
    const i = String(a.id ?? "");
    if (!i || n.has(i) || !t$(a.type)) continue;
    n.add(i);
    const r = hl({ x: Number(a.x), y: Number(a.y), w: Number(a.w), h: Number(a.h) }), l = Math.max(1, Math.trunc(Number(a.page) || 1)), c = { id: i, type: a.type, page: l, ...r };
    typeof a.label == "string" && a.label && (c.label = a.label), typeof a.assignee == "string" && a.assignee && (c.assignee = a.assignee), a.required === !0 && (c.required = !0), a.placed === !1 && (c.placed = !1), a.value !== void 0 && a.value !== null && (c.value = a.value);
    const p = cR(a.rule);
    p && (c.rule = p), typeof a.format == "string" && a.format.trim() && (c.format = a.format.trim()), bc(a.font) && (c.font = a.font), QS(a.type) && (a.style === "typed" && (c.style = "typed"), Array.isArray(a.lines) && (c.lines = [...new Set(a.lines.filter((m) => typeof m == "string" && !!m))].slice(0, 16))), t.push(c);
  }
  return t;
}
function sy(e) {
  return e.placed !== !1;
}
function gR(e) {
  return e.filter((t) => !sy(t));
}
function bR(e, t, n = {}) {
  var r;
  const a = fp[t], i = {
    id: xg(t, e),
    type: t,
    page: 1,
    x: 0.1,
    y: 0.1,
    w: a.w,
    h: a.h,
    placed: !1
  };
  return (r = n.label) != null && r.trim() && (i.label = n.label.trim()), n.assignee && (i.assignee = n.assignee), n.required && (i.required = !0), i;
}
function kR(e) {
  return e$(e, (t, n) => {
    typeof n.example == "string" && n.example.trim() && (t.example = n.example.trim()), typeof n.order == "string" && n.order.trim() && (t.order = n.order.trim()), n.order_label && (t.orderLabel = n.order_label), typeof n.separator == "string" && n.separator !== "" && (t.separator = n.separator), n.separator_label && (t.separatorLabel = n.separator_label);
  });
}
function wR(e) {
  if (!e || typeof e != "object" || Array.isArray(e)) return {};
  const t = e, n = {};
  for (const a of ["order", "separator", "example"]) {
    const i = t[a];
    (typeof i == "string" ? i.trim() : i && typeof i == "object") && (n[a] = i);
  }
  return n;
}
function _R(e) {
  if (!e.length) return null;
  const t = [], n = [];
  for (const a of e) {
    if (a.order === void 0 || a.separator === void 0) return null;
    t.some((i) => i.id === a.order) || t.push({ id: a.order, label: a.orderLabel ?? a.order }), n.some((i) => i.id === a.separator) || n.push({ id: a.separator, label: a.separatorLabel ?? a.separator });
  }
  return t.length && n.length ? { orders: t, separators: n } : null;
}
function f1(e, t, n) {
  var i, r;
  const a = e.find((l) => l.order === t && l.separator === n);
  return a ? a.id : ((i = e.find((l) => l.order === t)) == null ? void 0 : i.id) ?? ((r = e[0]) == null ? void 0 : r.id) ?? "";
}
function xR(e, t) {
  const n = e.find((a) => a.id === t);
  return !n || n.order === void 0 || n.separator === void 0 ? null : { order: n.order, separator: n.separator };
}
function SR(e) {
  const t = [];
  let n = 0;
  for (; n < e.length; )
    e.startsWith("YYYY", n) ? (t.push("YYYY"), n += 4) : e.startsWith("YY", n) ? (t.push("YY"), n += 2) : e.startsWith("DD", n) ? (t.push("DD"), n += 2) : e.startsWith("MM", n) ? (t.push("MM"), n += 2) : n += 1;
  return t;
}
function $R(e, t, n) {
  return SR(e).map((i) => i === "YYYY" ? String(n.getFullYear()).padStart(4, "0") : i === "YY" ? String(n.getFullYear() % 100).padStart(2, "0") : i === "MM" ? String(n.getMonth() + 1).padStart(2, "0") : String(n.getDate()).padStart(2, "0")).join(t);
}
function TR(e) {
  return Array.isArray(e) ? e.filter((t) => t && typeof t == "object" && typeof t.id == "string" && t.id).map((t) => ({
    id: t.id,
    label: t.label ?? t.id,
    color: typeof t.color == "string" ? t.color : void 0
  })) : [];
}
function AR(e, t) {
  const n = e.findIndex((a) => a.id === t);
  return n < 0 ? jm[0] : e[n].color || jm[n % jm.length];
}
function n$(e, t) {
  return e.assignee ? !!t && e.assignee === t : !0;
}
function ly(e) {
  const t = e.value;
  return e.type === "checkbox" ? t === !0 : typeof t == "string" ? t !== "" : t != null;
}
function a$(e, t) {
  return {
    fields: e.filter((n) => n$(n, t) && ly(n)).map((n) => {
      const a = { id: n.id, value: n.value };
      return n.label && (a.label = n.label), n.font && (a.font = n.font), n.rule && (a.rule = n.rule), a;
    })
  };
}
function ER(e, t) {
  const n = t == null ? void 0 : t.fields;
  if (!Array.isArray(n)) return e;
  const a = /* @__PURE__ */ new Map();
  for (const i of n)
    i && typeof i.id == "string" && a.set(i.id, { value: i.value, font: bc(i.font) ? i.font : void 0 });
  return e.map((i) => {
    const r = a.get(i.id);
    return r ? { ...i, value: r.value, ...r.font ? { font: r.font } : {} } : i;
  });
}
function Zpe(e, t, n) {
  return e.map((a) => a.id === t ? { ...a, font: n } : a);
}
function CR(e, t, n) {
  return e.map((a) => {
    if (a.id !== t) return a;
    const i = { ...a };
    return n == null || n === "" || n === !1 ? delete i.value : i.value = n, i;
  });
}
function xg(e, t) {
  const n = { signature: "sig", initials: "ini", date: "date", text: "text", checkbox: "chk" }[e], a = new Set(t.map((i) => i.id));
  for (let i = 1; ; i++) {
    const r = `${n}-${i}`;
    if (!a.has(r)) return r;
  }
}
function p1(e, t, n, a, i = fp[t], r) {
  const l = hl({ x: a.x, y: a.y, w: i.w, h: i.h }), c = { id: xg(t, e), type: t, page: n, ...l };
  return r && (c.assignee = r), c;
}
function zR(e, t, n) {
  const a = e.find((r) => r.id === t);
  if (!a) return e;
  const i = { ...a, id: xg(a.type, e), page: Math.max(1, Math.trunc(n)) };
  return delete i.value, [...e, i];
}
function MR(e = /* @__PURE__ */ new Date()) {
  const t = e.getFullYear(), n = String(e.getMonth() + 1).padStart(2, "0"), a = String(e.getDate()).padStart(2, "0");
  return `${t}-${n}-${a}`;
}
function Gc(e, t) {
  var n;
  for (const a of e ?? [])
    t(a), (n = a.children) != null && n.length && Gc(a.children, t);
}
function PR(e) {
  const t = {};
  return Gc(e, (n) => {
    var i;
    const a = n.props ?? {};
    if (n.type === "form") {
      const r = a;
      for (const l of r.fields ?? []) {
        if (!(l != null && l.key)) continue;
        const c = (i = r.values) == null ? void 0 : i[l.key];
        c !== void 0 ? t[l.key] = h1(l, c) : l.default !== void 0 ? t[l.key] = h1(l, l.default) : l.multi === !0 && l.type === "select" && (t[l.key] = []);
      }
      return;
    }
    if (n.id) {
      if (n.type === "people-picker") {
        const r = a.value;
        t[n.id] = Array.isArray(r) ? r.filter((l) => l && typeof l.email == "string") : [];
      } else if (n.type === "file-chooser") {
        const r = a.value;
        t[n.id] = typeof r == "string" ? r : "";
      } else if (n.type === "pin-input")
        t[n.id] = "";
      else if (n.type === "signature-pad")
        t[n.id] = null;
      else if (n.type === "pdf-fields") {
        const r = a, l = Of(r.fields);
        t[n.id] = r.mode === "fill" ? a$(l, r.signer) : l;
      }
    }
  }), t;
}
function h1(e, t) {
  return e.multi !== !0 || e.type !== "select" ? t : Array.isArray(t) ? t.map((n) => String(n)) : t == null || t === "" ? [] : [String(t)];
}
const OR = /* @__PURE__ */ new Set(["string", "int", "bool", "password", "select"]);
function LR(e) {
  const t = String(e.style ?? "").toLowerCase();
  return t === "choice" ? !0 : t === "switch" ? !1 : (e.options ?? []).length > 0 ? !0 : e.required === !0;
}
function DR(e, t) {
  const n = e.secret ? "password" : OR.has(String(e.type)) ? e.type : "string";
  return {
    key: e.key,
    type: n,
    label: Xt(e.label, t) || e.key,
    help: Xt(e.help, t) || void 0,
    i18n_key: "",
    required: e.required === !0,
    secret: e.secret === !0,
    default: e.default,
    placeholder: Xt(e.placeholder, t) || void 0,
    options: (e.options ?? []).map((a) => ({ value: String(a.value), label: Xt(a.label, t) || String(a.value) })),
    min: e.min,
    max: e.max,
    monospace: e.monospace === !0,
    // ⚠⚠ `text` IS the contract's long text (wire.Field: "string | password
    // | int | bool | select | text"), and the field renderer draws a textarea
    // only on `multiline`. Nothing mapped the two, so every long field a
    // plugin asked for arrived as a one-line box — including the signing
    // app's list of signers, under a help line that says "one per line".
    multiline: e.multiline === !0 || String(e.type) === "text",
    choice: n === "select" || n === "bool" && LR(e),
    multi: e.multi === !0
  };
}
function RR(e) {
  const t = e.trim(), n = t.indexOf("@");
  return n > 0 && n < t.length - 1 && !/\s/.test(t) && t.indexOf("@", n + 1) === -1;
}
function uy(e) {
  return e == null ? !1 : typeof e == "string" ? e.trim() !== "" : Array.isArray(e) ? e.length > 0 : !0;
}
function NR(e) {
  return e == null ? [] : Array.isArray(e) ? e.map((t) => String(t)) : typeof e == "boolean" ? [e ? "true" : "false"] : [String(e)];
}
function i$(e, t) {
  if (!e || !e.key) return !0;
  const n = t == null ? void 0 : t[e.key], a = e.equals ?? [];
  if (!a.length) return uy(n);
  if (!uy(n)) return !1;
  const i = NR(n);
  return a.some((r) => i.includes(String(r)));
}
function Sg(e, t) {
  const n = (e ?? []).filter((i) => i && i.key);
  if (!n.length) return [];
  let a = n;
  for (let i = 0; i <= n.length; i++) {
    const r = o$(n, a, t), l = n.filter((c) => i$(c.show_when, r));
    if (l.length === a.length) return l;
    a = l;
  }
  return a;
}
function o$(e, t, n) {
  const a = new Set(t.map((r) => r.key)), i = { ...n };
  for (const r of e) a.has(r.key) || delete i[r.key];
  return i;
}
function r$(e, t) {
  return e.required === !0 ? !0 : e.required_when ? i$(e.required_when, t) : !1;
}
function s$(e) {
  const t = [];
  return Gc(e, (n) => {
    var i;
    if (n.type !== "form") return;
    const a = (i = n.props) == null ? void 0 : i.fields;
    for (const r of a ?? []) r && r.key && t.push(r);
  }), t;
}
function IR(e, t) {
  const n = s$(e);
  if (!n.length) return [];
  const a = new Set(Sg(n, t).map((i) => i.key));
  return n.filter((i) => !a.has(i.key)).map((i) => i.key);
}
function BR(e, t) {
  const n = IR(e, t);
  if (!n.length) return { ...t };
  const a = { ...t };
  for (const i of n) delete a[i];
  return a;
}
function m1(e, t) {
  const n = s$(e);
  if (!n.length) return [];
  const a = Sg(n, t), i = o$(n, a, t);
  return a.filter((r) => r$(r, i) && !uy(i[r.key]));
}
const FR = 300;
function Wp(e, t) {
  const n = S(null), a = S({}), i = S(!1), r = S(""), l = S([]), c = A(() => {
    var E;
    return ((E = n.value) == null ? void 0 : E.actions) ?? [];
  }), p = A(() => {
    var E;
    return (E = n.value) == null ? void 0 : E.errors;
  });
  function m(E, R = !1) {
    n.value = E, r.value = "", l.value = [];
    const z = PR(E == null ? void 0 : E.nodes);
    a.value = R ? { ...z, ...a.value } : z;
  }
  function v(E) {
    var R;
    if (a.value = E, l.value.length) {
      const z = m1((R = n.value) == null ? void 0 : R.nodes, E).map((D) => D.key);
      z.length !== l.value.length && (l.value = z);
    }
  }
  let x = null;
  function w() {
    x !== null && clearTimeout(x), x = null;
  }
  function $() {
    w(), x = setTimeout(() => {
      x = null, b("change");
    }, FR);
  }
  let k = 0;
  async function b(E, R, z = {}) {
    var L, P, K, N, J, j;
    if (!n.value) return;
    const D = E !== "change";
    if (D) {
      if (w(), i.value) return;
      i.value = !0;
    }
    const U = ++k;
    r.value = "";
    const H = (L = e.paths) == null ? void 0 : L.call(e);
    try {
      const re = await e.api.pluginViewEvent(e.plugin, e.view, {
        path: (P = e.path) == null ? void 0 : P.call(e),
        ...H != null && H.length ? { paths: [...H] } : {},
        state: ((K = n.value) == null ? void 0 : K.state) ?? {},
        event: E,
        action_id: R,
        // ⚠⚠ The values a HIDDEN field holds are dropped here, not blanked
        // (v3 §2.1: "a value belonging to a hidden field is dropped before
        // the job runs — it cannot arrive as a surprise"). The plugin is
        // re-asked the same question by the host at submit; this is the
        // client half of the same promise, and it also keeps a `change`
        // event from echoing back a field the step no longer shows.
        data: { values: BR((N = n.value) == null ? void 0 : N.nodes, a.value), ...z }
      });
      if (!D && U !== k) return;
      if (re.op) {
        t.onOp(re.op), t.onDone();
        return;
      }
      const q = re.surface;
      if (!q) {
        r.value = e.errorText();
        return;
      }
      const le = Xt(q.toast, e.locale());
      le && t.onToast(le);
      const ve = zp(q.open) ? q.open : null;
      if (q.done) {
        t.onDone(), ve && ((J = t.onOpen) == null || J.call(t, ve));
        return;
      }
      m(q, !D), ve && ((j = t.onOpen) == null || j.call(t, ve));
    } catch (re) {
      if (!D && U !== k) return;
      r.value = Yi(e.locale(), String((re == null ? void 0 : re.message) ?? re)) || e.errorText();
    } finally {
      D && (i.value = !1);
    }
  }
  function C(E) {
    var R;
    if (i.value || E.disabled) return Promise.resolve();
    if (E.primary) {
      const z = m1((R = n.value) == null ? void 0 : R.nodes, a.value);
      if (l.value = z.map((D) => D.key), z.length) return Promise.resolve();
    }
    return b(E.primary ? "submit" : "action", E.id);
  }
  function T(E) {
    return b("action", E.action_id, { row_id: E.row_id });
  }
  return Zo() && Tt(w), {
    current: n,
    values: a,
    busy: i,
    failure: r,
    footer: c,
    errors: p,
    invalidKeys: l,
    setSurface: m,
    updateValues: v,
    scheduleChange: $,
    post: b,
    press: C,
    rowAction: T,
    dispose: w
  };
}
const Lf = ["draw", "type", "upload"], UR = 200 * 1024, l$ = 600, u$ = 200, HR = 480, KR = 160, v1 = "#111111", cy = XS;
function c$(e) {
  return typeof e == "string" && Lf.includes(e);
}
function VR(e) {
  if (!Array.isArray(e)) return [...Lf];
  const t = e.filter(c$);
  return t.length ? Lf.filter((n) => t.includes(n)) : [...Lf];
}
function ju(e) {
  const t = e;
  return !!t && typeof t == "object" && typeof t.png_b64 == "string" && t.png_b64 !== "" && c$(t.mode);
}
function jR(e) {
  const t = e;
  return t && bc(t.font) ? t.font : cy;
}
function qR(e, t) {
  const n = Number(e), a = Number(t);
  return {
    width: Number.isFinite(n) && n > 0 ? Math.min(l$, Math.max(120, Math.round(n))) : HR,
    height: Number.isFinite(a) && a > 0 ? Math.min(u$, Math.max(60, Math.round(a))) : KR
  };
}
function WR(e, t, n, a) {
  if (!(e > 0) || !(t > 0)) return { width: n, height: a };
  const i = Math.min(1, n / e, a / t);
  return { width: Math.max(1, Math.round(e * i)), height: Math.max(1, Math.round(t * i)) };
}
function YR(e) {
  const t = e.indexOf("base64,");
  return t >= 0 ? e.slice(t + 7) : e;
}
function GR(e) {
  return e.type !== "image/png" && e.type !== "image/jpeg" ? "bad_type" : e.size > UR ? "too_big" : "ok";
}
function XR(e, t, n) {
  let a = Math.min(96, Math.floor(n * 0.6));
  for (; a > 12 && e(a) > t; ) a -= 2;
  return a;
}
const JR = 44;
function ZR(e, t, n, a) {
  const i = t.height - e.bottom - 8, r = e.top - 8, l = Math.min(320, a * JR + 8), c = i < Math.min(l, 160) && r > i, p = Math.min(Math.max(e.width, 180), t.width - 16), m = Oc(Ur(e, n), p, t.width, n);
  return {
    top: Math.round(e.bottom + 4),
    bottom: Math.round(t.height - e.top + 4),
    start: Math.round(n === "rtl" ? t.width - m - p : m),
    width: Math.round(p),
    maxHeight: Math.round(Math.max(120, Math.min(320, c ? r : i))),
    up: c
  };
}
const QR = ["id", "disabled", "aria-expanded", "aria-activedescendant", "aria-label", "aria-labelledby", "aria-describedby", "aria-required", "aria-invalid", "data-testid", "data-value"], eN = ["name", "value", "required", "disabled"], tN = ["dir", "aria-labelledby", "data-testid"], nN = ["id", "aria-selected", "aria-disabled", "data-value", "data-testid", "onMousemove", "onClick"], aN = { class: "fe-select__label" }, iN = { class: "fe-select__text" }, oN = {
  key: 0,
  class: "fe-select__help"
}, kc = /* @__PURE__ */ lt({
  __name: "ChoiceSelect",
  props: {
    modelValue: { default: null },
    options: {},
    id: { default: void 0 },
    name: { default: void 0 },
    placeholder: { default: "" },
    required: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    invalid: { type: Boolean, default: !1 },
    size: { default: "md" },
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaDescribedby: { default: void 0 },
    requiredMessage: { default: "" },
    testid: { default: void 0 }
  },
  emits: ["update:modelValue", "change", "invalid"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, r = `fe-sel-${Math.random().toString(36).slice(2, 10)}`, l = A(() => a.id ?? r), c = `${r}-list`, p = (F) => `${r}-opt-${F}`, m = S(!1), v = S(-1), x = S(null), w = S(null), $ = S(null), k = S(null), b = S({
      top: 0,
      bottom: 0,
      start: 0,
      width: 0,
      maxHeight: 280,
      up: !1,
      z: Qy,
      dir: "ltr"
    }), C = S({}), T = S(!1);
    let E = "", R = 0;
    const z = (F) => F == null || F === "", D = A(() => a.options.findIndex((F) => F.value === a.modelValue)), U = A(() => a.options[D.value]), H = A(() => {
      var F;
      return ((F = U.value) == null ? void 0 : F.label) ?? a.placeholder;
    }), L = A(() => a.invalid || T.value), P = A(() => a.required || !!a.name);
    function K() {
      var F;
      (F = $.value) == null || F.setCustomValidity(a.required && z(a.modelValue) ? a.requiredMessage || " " : "");
    }
    Je(
      () => a.modelValue,
      (F) => {
        z(F) || (T.value = !1), Gt(K);
      },
      { immediate: !0 }
    ), Je(() => a.required, () => void Gt(K)), Je(
      () => a.disabled,
      (F) => {
        F && ce(!1);
      }
    );
    function N(F, V) {
      const ke = a.options.length;
      for (let qe = 0, Me = F; qe < ke; qe++, Me += V) {
        if (Me < 0 || Me >= ke) return -1;
        if (!a.options[Me].disabled) return Me;
      }
      return -1;
    }
    const J = [
      "--fe-bg",
      "--fe-bg-hover",
      "--fe-border",
      "--fe-text",
      "--fe-text-muted",
      "--fe-primary",
      "--fe-primary-ink",
      "--fe-radius",
      "--fe-radius-sm",
      "--fe-shadow",
      "--fe-text-xs"
    ];
    function j(F) {
      const V = {};
      try {
        const ke = window.getComputedStyle(F);
        for (const qe of J) {
          const Me = ke.getPropertyValue(qe).trim();
          Me && (V[qe] = Me);
        }
        ke.fontFamily && (V["font-family"] = ke.fontFamily), ke.fontSize && (V["font-size"] = ke.fontSize);
      } catch {
      }
      return V;
    }
    function re() {
      const F = x.value;
      if (!F) return;
      const V = ei(F), ke = ZR(
        F.getBoundingClientRect(),
        { width: window.innerWidth, height: window.innerHeight },
        V,
        a.options.length
      );
      b.value = { ...ke, z: b.value.z, dir: V };
    }
    function q(F) {
      var ke, qe;
      const V = F.target;
      !V || (ke = x.value) != null && ke.contains(V) || (qe = w.value) != null && qe.contains(V) || ce(!1);
    }
    function le(F) {
      F ? (window.addEventListener("resize", re), window.addEventListener("scroll", re, !0), document.addEventListener("pointerdown", q, !0)) : (window.removeEventListener("resize", re), window.removeEventListener("scroll", re, !0), document.removeEventListener("pointerdown", q, !0));
    }
    async function ve(F) {
      if (a.disabled || m.value) return;
      const V = x.value;
      k.value = (V == null ? void 0 : V.closest("dialog[open]")) ?? document.body, V && (C.value = j(V), b.value = { ...b.value, z: Rc(V) }), re(), m.value = !0, v.value = F ?? (D.value >= 0 ? D.value : N(0, 1)), le(!0), await Gt(), fe();
    }
    function ce(F = !0) {
      var V;
      m.value && (m.value = !1, E = "", le(!1), F && ((V = x.value) == null || V.focus()));
    }
    function se(F, V = !0) {
      const ke = a.options[F];
      !ke || ke.disabled || (ke.value !== a.modelValue && (i("update:modelValue", ke.value), i("change", ke.value)), ce(V));
    }
    function fe() {
      const F = document.getElementById(p(v.value));
      F && typeof F.scrollIntoView == "function" && F.scrollIntoView({ block: "nearest" });
    }
    function _(F) {
      F < 0 || (v.value = F, Gt(fe));
    }
    function ee(F) {
      const V = Date.now();
      E = V - R > 600 ? F : E + F, R = V;
      const ke = a.options.length, qe = E.length > 1 ? Math.max(v.value, 0) : v.value + 1, Me = E.toLocaleLowerCase();
      for (let Fe = 0; Fe < ke; Fe++) {
        const We = (qe + Fe + ke) % ke, $t = a.options[We];
        if (!$t.disabled && $t.label.toLocaleLowerCase().startsWith(Me)) return We;
      }
      return -1;
    }
    function Y(F) {
      if (a.disabled) return;
      const V = F.key;
      if (!m.value) {
        if (V === "ArrowDown" || V === "ArrowUp" || V === "Enter" || V === " ")
          F.preventDefault(), ve();
        else if (V === "Home" || V === "End")
          F.preventDefault(), ve(V === "Home" ? N(0, 1) : N(a.options.length - 1, -1));
        else if (V.length === 1 && !F.ctrlKey && !F.metaKey && !F.altKey) {
          const ke = ee(V);
          ke >= 0 && ve(ke);
        }
        return;
      }
      switch (V) {
        case "ArrowDown":
          if (F.preventDefault(), F.altKey) return;
          _(N(v.value + 1, 1));
          return;
        case "ArrowUp":
          if (F.preventDefault(), F.altKey) return se(v.value);
          _(N(v.value - 1, -1));
          return;
        case "Home":
          F.preventDefault(), _(N(0, 1));
          return;
        case "End":
          F.preventDefault(), _(N(a.options.length - 1, -1));
          return;
        case "PageDown":
          F.preventDefault(), _(N(Math.min(v.value + 10, a.options.length - 1), -1));
          return;
        case "PageUp":
          F.preventDefault(), _(N(Math.max(v.value - 10, 0), 1));
          return;
        case "Enter":
        case " ":
          F.preventDefault(), se(v.value);
          return;
        case "Escape":
          F.preventDefault(), F.stopPropagation(), ce();
          return;
        case "Tab":
          se(v.value, !1);
          return;
      }
      if (V.length === 1 && !F.ctrlKey && !F.metaKey && !F.altKey) {
        const ke = ee(V);
        ke >= 0 && _(ke);
      }
    }
    function B() {
      m.value ? ce() : ve();
    }
    function W(F) {
      var ke, qe;
      F.preventDefault(), T.value = !0, i("invalid", F);
      const V = ((ke = $.value) == null ? void 0 : ke.form) ?? null;
      if (V) {
        if (V.dataset.fxInvalidFocus) return;
        V.dataset.fxInvalidFocus = "1", queueMicrotask(() => {
          delete V.dataset.fxInvalidFocus;
        });
      }
      (qe = x.value) == null || qe.focus();
    }
    return Tt(() => le(!1)), t({ focus: () => {
      var F;
      return (F = x.value) == null ? void 0 : F.focus();
    }, open: ve, close: ce }), (F, V) => (f(), h("span", {
      class: Re(["fe-select", [
        e.size !== "md" ? `fe-select--${e.size}` : "",
        { "is-open": m.value, "is-disabled": e.disabled, "is-invalid": L.value }
      ]])
    }, [
      d("button", {
        id: l.value,
        ref_key: "trigger",
        ref: x,
        type: "button",
        class: "fe-select__trigger",
        role: "combobox",
        disabled: e.disabled,
        "aria-haspopup": "listbox",
        "aria-expanded": m.value ? "true" : "false",
        "aria-controls": c,
        "aria-activedescendant": m.value && v.value >= 0 ? p(v.value) : void 0,
        "aria-label": e.ariaLabel,
        "aria-labelledby": e.ariaLabelledby,
        "aria-describedby": e.ariaDescribedby,
        "aria-required": e.required ? "true" : void 0,
        "aria-invalid": L.value ? "true" : void 0,
        "data-testid": e.testid,
        "data-value": e.modelValue ?? "",
        onClick: B,
        onKeydown: Y,
        onKeyup: V[0] || (V[0] = Ca(yt(() => {
        }, ["prevent"]), ["space"]))
      }, [
        d("span", {
          class: Re(["fe-select__value", { "is-placeholder": !U.value }])
        }, y(H.value), 3),
        Ze(u(HM), {
          class: "fe-select__chev",
          "aria-hidden": "true"
        })
      ], 40, QR),
      P.value ? (f(), h("input", {
        key: 0,
        ref_key: "hidden",
        ref: $,
        class: "fe-select__native",
        tabindex: "-1",
        "aria-hidden": "true",
        name: e.name,
        value: e.modelValue ?? "",
        required: e.required,
        disabled: e.disabled,
        onInvalid: W
      }, null, 40, eN)) : O("", !0),
      m.value && k.value ? (f(), Ge(wi, {
        key: 1,
        to: k.value
      }, [
        d("ul", {
          id: c,
          ref_key: "panel",
          ref: w,
          class: Re(["fe-select__panel", { "is-up": b.value.up }]),
          dir: b.value.dir,
          role: "listbox",
          "aria-labelledby": e.ariaLabelledby ?? l.value,
          style: Yt([
            C.value,
            {
              insetInlineStart: b.value.start + "px",
              width: b.value.width + "px",
              maxHeight: b.value.maxHeight + "px",
              top: b.value.up ? void 0 : b.value.top + "px",
              bottom: b.value.up ? b.value.bottom + "px" : void 0,
              zIndex: b.value.z
            }
          ]),
          "data-testid": e.testid ? `${e.testid}-list` : void 0,
          onMousedown: V[1] || (V[1] = yt(() => {
          }, ["prevent"]))
        }, [
          (f(!0), h(Te, null, nt(e.options, (ke, qe) => (f(), h("li", {
            id: p(qe),
            key: String(ke.value),
            class: Re(["fe-select__option", { "is-active": qe === v.value, "is-selected": ke.value === e.modelValue }]),
            role: "option",
            "aria-selected": ke.value === e.modelValue ? "true" : "false",
            "aria-disabled": ke.disabled ? "true" : void 0,
            "data-value": ke.value,
            "data-testid": e.testid ? `${e.testid}-option-${ke.value === "" ? "none" : ke.value}` : void 0,
            onMousemove: (Me) => !ke.disabled && (v.value = qe),
            onClick: (Me) => se(qe)
          }, [
            d("span", aN, [
              d("span", iN, y(ke.label), 1),
              ke.help ? (f(), h("span", oN, y(ke.help), 1)) : O("", !0)
            ]),
            ke.value === e.modelValue ? (f(), Ge(u(_v), {
              key: 0,
              class: "fe-select__check",
              "aria-hidden": "true"
            })) : O("", !0)
          ], 42, nN))), 128))
        ], 46, tN)
      ], 8, ["to"])) : O("", !0)
    ], 2));
  }
}), rN = { class: "fe-cfield" }, sN = {
  key: 0,
  class: "fe-cfield__empty"
}, lN = {
  key: 0,
  class: "fe-cfield__check"
}, uN = ["checked", "disabled", "onChange"], cN = ["for"], dN = {
  key: 0,
  class: "fe-cfield__req",
  "aria-hidden": "true"
}, fN = ["id", "value", "placeholder", "disabled", "onInput"], pN = {
  key: 5,
  class: "fe-cfield__secret"
}, hN = ["id", "type", "value", "placeholder", "disabled", "onInput"], mN = ["title", "aria-label", "onClick"], vN = ["innerHTML"], yN = ["id", "type", "value", "placeholder", "min", "max", "disabled", "onInput"], gN = {
  key: 7,
  class: "fe-cfield__help"
}, bN = {
  key: 8,
  class: "fe-cfield__error"
}, kN = {
  key: 1,
  class: "fe-cfield__adv"
}, wN = {
  key: 0,
  class: "fe-cfield__advbody"
}, _N = {
  key: 0,
  class: "fe-cfield__check"
}, xN = ["checked", "disabled", "onChange"], SN = ["for"], $N = ["id", "type", "value", "placeholder", "disabled", "onInput"], TN = {
  key: 2,
  class: "fe-cfield__help"
}, AN = {
  key: 3,
  class: "fe-cfield__error"
}, EN = /* @__PURE__ */ lt({
  __name: "StorageFields",
  props: {
    fields: {},
    modelValue: {},
    locale: {},
    invalid: {},
    errors: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = S(!1), l = S({}), c = A(() => n.fields.filter((P) => !P.advanced)), p = A(() => n.fields.filter((P) => P.advanced));
    function m(P) {
      const K = i(P.i18n_key);
      return K === P.i18n_key ? P.label : K;
    }
    function v(P) {
      if (!P.help_i18n_key) return P.help ?? "";
      const K = i(P.help_i18n_key);
      return K === P.help_i18n_key ? P.help ?? "" : K;
    }
    function x(P) {
      if (!P.i18n_key) return P.label;
      const K = i(P.i18n_key);
      return K === P.i18n_key ? P.label : K;
    }
    function w(P, K) {
      a("update:modelValue", { ...n.modelValue, [P]: K });
    }
    function $(P) {
      var N, J;
      const K = (N = n.modelValue) == null ? void 0 : N[P.key];
      if (K != null) return K;
      for (const j of P.aliases ?? []) {
        const re = (J = n.modelValue) == null ? void 0 : J[j];
        if (re != null) return re;
      }
      return P.default ?? void 0;
    }
    function k(P) {
      const K = $(P);
      return K == null ? "" : String(K);
    }
    function b(P) {
      const K = $(P);
      return K === "" || K === void 0 || K === null ? "" : String(K);
    }
    function C(P) {
      return $(P) === !0;
    }
    function T(P) {
      var K;
      return (n.invalid ?? []).includes(P.key) || !!((K = n.errors) != null && K[P.key]);
    }
    function E(P) {
      var K;
      return ((K = n.errors) == null ? void 0 : K[P.key]) || (T(P) ? i("conn.form.required") : "");
    }
    function R(P) {
      if (P.type === "bool") {
        const K = (P.options ?? []).filter((j) => j.value === "true" || j.value === "false"), N = K.find((j) => j.value === "true"), J = K.find((j) => j.value === "false");
        return [
          { value: "true", label: N ? x(N) : i("conn.form.yes") },
          { value: "false", label: J ? x(J) : i("conn.form.no") }
        ];
      }
      return (P.options ?? []).map((K) => ({ value: K.value, label: x(K) }));
    }
    function z(P) {
      const K = $(P);
      return P.type === "bool" ? K === !0 || K === "true" ? "true" : K === !1 || K === "false" ? "false" : "" : P.multi ? Array.isArray(K) ? K.map((N) => String(N)) : K == null || K === "" ? [] : [String(K)] : K == null ? "" : String(K);
    }
    function D(P, K) {
      if (P.type === "bool") {
        w(P.key, K === "true");
        return;
      }
      w(P.key, K);
    }
    function U(P) {
      return P.choice === !0 && (P.type === "select" || P.type === "bool");
    }
    function H(P) {
      return P.type === "int" ? "number" : P.type === "password" && !l.value[P.key] ? "password" : "text";
    }
    function L(P) {
      l.value = { ...l.value, [P]: !l.value[P] };
    }
    return (P, K) => (f(), h("div", rN, [
      e.fields.length ? O("", !0) : (f(), h("p", sN, y(u(i)("conn.form.noFields")), 1)),
      (f(!0), h(Te, null, nt(c.value, (N) => (f(), h("div", {
        key: N.key,
        class: Re(["fe-cfield__row", { "is-invalid": T(N) }])
      }, [
        N.type === "bool" && !U(N) ? (f(), h("label", lN, [
          d("input", {
            type: "checkbox",
            checked: C(N),
            disabled: e.disabled,
            onChange: (J) => w(N.key, J.target.checked)
          }, null, 40, uN),
          d("span", null, y(m(N)), 1)
        ])) : (f(), h("label", {
          key: 1,
          class: "fe-cfield__label",
          for: `fe-cf-${N.key}`
        }, [
          Ht(y(m(N)), 1),
          N.required ? (f(), h("span", dN, "*")) : O("", !0)
        ], 8, cN)),
        U(N) ? (f(), Ge(mi, {
          key: 2,
          options: R(N),
          "model-value": z(N),
          multi: N.multi === !0,
          disabled: e.disabled,
          invalid: T(N),
          "aria-label": m(N),
          "testid-prefix": `fe-choice-${N.key}`,
          "onUpdate:modelValue": (J) => D(N, J)
        }, null, 8, ["options", "model-value", "multi", "disabled", "invalid", "aria-label", "testid-prefix", "onUpdate:modelValue"])) : N.type === "select" ? (f(), Ge(kc, {
          key: 3,
          id: `fe-cf-${N.key}`,
          "model-value": k(N),
          options: R(N),
          disabled: e.disabled,
          invalid: T(N),
          "onUpdate:modelValue": (J) => w(N.key, String(J))
        }, null, 8, ["id", "model-value", "options", "disabled", "invalid", "onUpdate:modelValue"])) : N.multiline ? (f(), h("textarea", {
          key: 4,
          id: `fe-cf-${N.key}`,
          class: Re(["fe-cfield__input fe-cfield__input--area", { "fe-cfield__input--mono": N.monospace }]),
          rows: "4",
          value: k(N),
          placeholder: N.placeholder,
          disabled: e.disabled,
          onInput: (J) => w(N.key, J.target.value)
        }, null, 42, fN)) : N.type === "password" ? (f(), h("div", pN, [
          d("input", {
            id: `fe-cf-${N.key}`,
            class: "fe-cfield__input fe-cfield__input--mono",
            type: H(N),
            autocomplete: "new-password",
            spellcheck: "false",
            value: k(N),
            placeholder: N.placeholder,
            disabled: e.disabled,
            onInput: (J) => w(N.key, J.target.value)
          }, null, 40, hN),
          d("button", {
            type: "button",
            class: "fe-cfield__eye",
            title: l.value[N.key] ? u(i)("conn.form.hide") : u(i)("conn.form.reveal"),
            "aria-label": l.value[N.key] ? u(i)("conn.form.hide") : u(i)("conn.form.reveal"),
            onClick: (J) => L(N.key)
          }, [
            d("span", {
              "aria-hidden": "true",
              innerHTML: u(zt)(l.value[N.key] ? "toggle-hidden" : "preview")
            }, null, 8, vN)
          ], 8, mN)
        ])) : N.type !== "bool" ? (f(), h("input", {
          key: 6,
          id: `fe-cf-${N.key}`,
          class: Re(["fe-cfield__input", { "fe-cfield__input--mono": N.monospace }]),
          type: H(N),
          value: N.type === "int" ? b(N) : k(N),
          placeholder: N.placeholder,
          min: N.min,
          max: N.max,
          disabled: e.disabled,
          onInput: (J) => w(
            N.key,
            N.type === "int" ? J.target.value === "" ? null : Number(J.target.value) : J.target.value
          )
        }, null, 42, yN)) : O("", !0),
        v(N) ? (f(), h("p", gN, y(v(N)), 1)) : O("", !0),
        E(N) ? (f(), h("p", bN, y(E(N)), 1)) : O("", !0)
      ], 2))), 128)),
      p.value.length ? (f(), h("div", kN, [
        d("button", {
          type: "button",
          class: "fe-cfield__advtoggle",
          onClick: K[0] || (K[0] = (N) => r.value = !r.value)
        }, y(r.value ? "▾" : "▸") + " " + y(u(i)("conn.form.advanced")), 1),
        r.value ? (f(), h("div", wN, [
          (f(!0), h(Te, null, nt(p.value, (N) => (f(), h("div", {
            key: N.key,
            class: "fe-cfield__row"
          }, [
            N.type === "bool" ? (f(), h("label", _N, [
              d("input", {
                type: "checkbox",
                checked: C(N),
                disabled: e.disabled,
                onChange: (J) => w(N.key, J.target.checked)
              }, null, 40, xN),
              d("span", null, y(m(N)), 1)
            ])) : (f(), h(Te, { key: 1 }, [
              d("label", {
                class: "fe-cfield__label",
                for: `fe-cfa-${N.key}`
              }, y(m(N)), 9, SN),
              d("input", {
                id: `fe-cfa-${N.key}`,
                class: Re(["fe-cfield__input", { "fe-cfield__input--mono": N.monospace }]),
                type: H(N),
                value: N.type === "int" ? b(N) : k(N),
                placeholder: N.placeholder,
                disabled: e.disabled,
                onInput: (J) => w(
                  N.key,
                  N.type === "int" ? J.target.value === "" ? null : Number(J.target.value) : J.target.value
                )
              }, null, 42, $N)
            ], 64)),
            v(N) ? (f(), h("p", TN, y(v(N)), 1)) : O("", !0),
            E(N) ? (f(), h("p", AN, y(E(N)), 1)) : O("", !0)
          ]))), 128))
        ])) : O("", !0)
      ])) : O("", !0)
    ]));
  }
}), CN = {
  class: "fe-surface__form",
  "data-testid": "surface-form"
}, zN = /* @__PURE__ */ lt({
  __name: "SurfaceForm",
  props: {
    fields: {},
    values: {},
    locale: {},
    errors: {},
    disabled: { type: Boolean },
    invalid: {}
  },
  emits: ["update:values"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = A(() => Sg(n.fields, n.values)), r = A(
      () => i.value.map((c) => ({ ...DR(c, n.locale), required: r$(c, n.values) }))
    ), l = A(() => {
      var p;
      const c = {};
      for (const m of r.value) {
        const v = Xt((p = n.errors) == null ? void 0 : p[m.key], n.locale);
        v && (c[m.key] = v);
      }
      return c;
    });
    return (c, p) => (f(), h("div", CN, [
      Ze(EN, {
        fields: r.value,
        "model-value": e.values,
        locale: e.locale,
        errors: l.value,
        invalid: e.invalid,
        disabled: e.disabled,
        "onUpdate:modelValue": p[0] || (p[0] = (m) => a("update:values", m))
      }, null, 8, ["fields", "model-value", "locale", "errors", "invalid", "disabled"])
    ]));
  }
}), MN = ["aria-label"], PN = ["aria-current", "data-step"], ON = {
  class: "fe-steps__marker",
  "aria-hidden": "true"
}, LN = {
  key: 0,
  class: "fe-ficon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  focusable: "false"
}, DN = { class: "fe-steps__label" }, RN = /* @__PURE__ */ lt({
  __name: "SurfaceSteps",
  props: {
    items: {},
    locale: {}
  },
  setup(e) {
    const t = e, { t: n } = ht(() => t.locale);
    function a(i) {
      return i === "done" || i === "active" ? i : "todo";
    }
    return (i, r) => (f(), h("ol", {
      class: "fe-steps",
      "aria-label": u(n)("plugin.steps.label"),
      "data-testid": "surface-steps"
    }, [
      (f(!0), h(Te, null, nt(e.items ?? [], (l, c) => (f(), h("li", {
        key: l.id || c,
        class: Re(["fe-steps__item", `is-${a(l.state)}`]),
        "aria-current": a(l.state) === "active" ? "step" : void 0,
        "data-step": l.id
      }, [
        d("span", ON, [
          a(l.state) === "done" ? (f(), h("svg", LN, [...r[0] || (r[0] = [
            d("path", { d: "M4.8 12.6l4.7 4.7L19.2 6.9" }, null, -1)
          ])])) : (f(), h(Te, { key: 1 }, [
            Ht(y(c + 1), 1)
          ], 64))
        ]),
        d("span", DN, y(u(Xt)(l.label, e.locale)), 1)
      ], 10, PN))), 128))
    ], 8, MN));
  }
});
let qm = null;
function d$() {
  return qm || (qm = o5("t")), qm;
}
function $g() {
  const e = d$().get();
  return e && typeof e == "object" && !Array.isArray(e) ? e : {};
}
function f$(e, t) {
  const n = $g(), a = { ...n[e] ?? {} };
  for (const [r, l] of Object.entries(t))
    l === void 0 ? delete a[r] : a[r] = l;
  const i = { ...n };
  Object.keys(a).length ? i[e] = a : delete i[e], d$().set(i);
}
function NN(e) {
  return {
    get: () => {
      var t;
      return (t = $g()[e]) == null ? void 0 : t.c;
    },
    set: (t) => {
      var a;
      const n = Object.keys(t.w).length > 0 || t.hidden.length > 0 || (((a = t.o) == null ? void 0 : a.length) ?? 0) > 0;
      f$(e, { c: n ? t : void 0 });
    }
  };
}
function IN(e) {
  var n;
  const t = (n = $g()[e]) == null ? void 0 : n.s;
  return !t || typeof t.k != "string" || t.d !== "asc" && t.d !== "desc" ? null : { key: t.k, dir: t.d };
}
function BN(e, t) {
  f$(e, { s: t ? { k: t.key, d: t.dir } : void 0 });
}
const Wm = "data-fe-cut-title";
function y1(e) {
  const t = e;
  return t.scrollWidth > t.clientWidth;
}
function FN(e) {
  return (e.textContent ?? "").replace(/\s+/g, " ").trim();
}
function UN(e, t) {
  if (!t || typeof Element > "u" || !(e instanceof Element)) return;
  const n = e.closest(".tbl-pill");
  if (!n || !t.contains(n)) return;
  const a = n.getAttribute(Wm), i = n.getAttribute("title");
  if (i !== null && i !== a) return;
  const r = Array.from(n.querySelectorAll(".tbl-pill__text")), l = y1(n) || r.some(y1), c = FN(n);
  l && c ? (n.setAttribute("title", c), n.setAttribute(Wm, c)) : a !== null && (n.removeAttribute("title"), n.removeAttribute(Wm));
}
const HN = ["aria-checked", "aria-label", "title"], Tg = /* @__PURE__ */ lt({
  __name: "ItemCheck",
  props: {
    on: { type: Boolean },
    label: {}
  },
  setup(e) {
    return (t, n) => (f(), h("button", {
      type: "button",
      class: Re(["fe-list__check", { "is-on": e.on }]),
      role: "checkbox",
      "aria-checked": e.on ? "true" : "false",
      "aria-label": e.label,
      title: e.label,
      onMousedown: n[0] || (n[0] = yt(() => {
      }, ["prevent"]))
    }, null, 42, HN));
  }
}), KN = ["disabled", "data-testid"], VN = /* @__PURE__ */ lt({
  __name: "RowActions",
  props: {
    actions: {},
    locale: { default: "en" },
    label: {},
    disabled: { type: Boolean },
    theme: {},
    testid: {}
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, dir: r } = ht(() => n.locale), l = S(
      null
    ), c = A(() => n.label || i("row.actions")), p = A(
      () => n.actions.filter((w) => !w.hidden).map((w) => ({
        ...w,
        shortcutId: w.shortcutId ?? "",
        testid: w.testid ?? (n.testid ? `${n.testid}-${w.key}` : void 0)
      }))
    ), m = A(() => p.value.some((w) => !w.divider && !w.disabled));
    function v(w) {
      var k, b;
      const $ = (k = w.currentTarget) == null ? void 0 : k.getBoundingClientRect();
      (b = l.value) == null || b.show(
        // ⚠ RTL: the START corner (right in RTL), as ListView `onRowMenu` does.
        { clientX: $ ? Ur($, r.value) : w.clientX, clientY: $ ? $.bottom : w.clientY },
        []
      );
    }
    function x(w) {
      a("select", w.key, w);
    }
    return (w, $) => (f(), h("div", {
      class: "tbl-rowactions",
      onClick: $[0] || ($[0] = yt(() => {
      }, ["stop"]))
    }, [
      d("button", {
        type: "button",
        class: "tbl-rowactions__btn",
        disabled: e.disabled || !m.value,
        "data-testid": e.testid,
        "data-fe-control": "",
        "aria-haspopup": "menu",
        onClick: yt(v, ["stop"])
      }, [
        d("span", null, y(c.value), 1),
        $[1] || ($[1] = d("span", {
          class: "tbl-rowactions__caret",
          "aria-hidden": "true"
        }, "▾", -1))
      ], 8, KN),
      Ze(_l, {
        ref_key: "menu",
        ref: l,
        locale: e.locale,
        theme: e.theme,
        actions: p.value,
        onSelect: x
      }, null, 8, ["locale", "theme", "actions"])
    ]));
  }
}), jN = {
  key: 0,
  class: "tbl-bar"
}, qN = {
  key: 1,
  class: "fe-list__refreshing",
  role: "status"
}, WN = { class: "fe-sr-only" }, YN = ["aria-label", "aria-busy", "data-table-id"], GN = ["data-sort-label"], XN = {
  key: 0,
  class: "fe-list__col fe-list__col--check",
  role: "columnheader"
}, JN = ["aria-sort", "data-col"], ZN = ["disabled", "title"], QN = { class: "fe-list__sort-label" }, eI = {
  key: 0,
  class: "fe-list__sort-arrow",
  "aria-hidden": "true"
}, tI = ["title"], nI = ["aria-valuenow", "aria-valuemin", "aria-valuemax", "aria-label", "title"], aI = ["aria-sort", "aria-label", "data-col", "onPointerdown", "onKeydown"], iI = ["disabled", "title", "onClick"], oI = { class: "fe-list__sort-label" }, rI = {
  key: 0,
  class: "fe-list__sort-arrow",
  "aria-hidden": "true"
}, sI = ["title"], lI = ["aria-valuenow", "aria-valuemin", "aria-valuemax", "aria-label", "title", "onPointerdown", "onDblclick", "onKeydown"], uI = ["title", "aria-label", "aria-expanded"], cI = ["role"], dI = {
  key: 0,
  class: "fe-list__group",
  role: "presentation"
}, fI = ["aria-selected", "onClick", "onDblclick", "onContextmenu", "onDragstart", "onDragover", "onDragleave", "onDrop", "onTouchstartPassive"], pI = ["onClick"], hI = ["title"], mI = { class: "fe-list__cell-text" }, vI = ["data-col", "data-label", "title"], yI = {
  key: 0,
  class: "fe-list__cell-text"
}, gI = {
  key: 0,
  class: "fe-list__empty fe-list__empty--loading",
  role: "row"
}, bI = ["aria-colspan"], kI = {
  key: 1,
  class: "fe-list__empty",
  role: "row"
}, wI = ["aria-colspan"], _I = {
  key: 2,
  class: "tbl-foot"
}, xI = {
  key: 0,
  class: "tbl-pager"
}, SI = ["disabled", "aria-label", "title"], $I = {
  class: "tbl-pager__at",
  dir: "ltr"
}, TI = ["disabled", "aria-label", "title"], AI = ["dir", "data-prefers-dark"], EI = ["aria-label", "onKeydown"], CI = { class: "fe-colmenu__title" }, zI = ["aria-checked", "onClick"], MI = { class: "fe-colmenu__label" }, PI = ["disabled", "title", "aria-label", "onClick"], OI = { "aria-hidden": "true" }, LI = ["disabled", "title", "aria-label", "onClick"], DI = { "aria-hidden": "true" }, RI = {
  key: 0,
  class: "fe-colmenu__sep",
  role: "separator"
}, NI = { class: "fe-colmenu__label" }, Ym = 8, qs = 12, g1 = 28, II = 160, BI = 160, FI = 5, UI = 300, os = /* @__PURE__ */ lt({
  inheritAttrs: !1,
  __name: "DataTable",
  props: {
    rows: {},
    columns: {},
    rowKey: { type: [String, Function], default: void 0 },
    tableId: { default: void 0 },
    columnStore: { default: void 0 },
    candidates: { default: void 0 },
    metrics: { default: void 0 },
    locale: { default: void 0 },
    theme: { default: void 0 },
    loading: { type: Boolean },
    empty: { default: void 0 },
    ariaLabel: { default: void 0 },
    selectable: { type: Boolean },
    isSelected: { type: Function, default: void 0 },
    sort: { default: void 0 },
    sortClosed: { default: void 0 },
    groups: { default: void 0 },
    rowClass: { type: Function, default: void 0 },
    rowAttrs: { type: Function, default: void 0 },
    rowActions: { type: Function, default: void 0 },
    rowActionsTestId: { type: Function, default: void 0 },
    actionsWidth: { default: void 0 },
    framed: { type: Boolean, default: !0 },
    page: { default: void 0 },
    pageSize: { default: void 0 },
    total: { default: void 0 },
    pages: { default: void 0 },
    footNote: { default: void 0 }
  },
  emits: ["sort", "row-click", "row-dblclick", "row-contextmenu", "check-click", "row-action", "row-dragstart", "row-dragover", "row-dragleave", "row-drop", "row-touchstart", "row-touchend", "row-touchmove", "page"],
  setup(e, { expose: t, emit: n }) {
    var un;
    const a = e, i = n, r = y5(), l = A(() => a.locale ?? (r == null ? void 0 : r.locale.value) ?? "en"), c = A(() => {
      var pe;
      return a.theme ?? ((pe = r == null ? void 0 : r.theme) == null ? void 0 : pe.value);
    }), { t: p, dir: m } = ht(() => l.value), v = A(() => {
      const pe = /* @__PURE__ */ new Map();
      for (const be of a.columns) pe.set(be.id, be);
      return pe;
    }), x = A(() => {
      var pe;
      return ((pe = a.columns.find((be) => be.lead) ?? a.columns[0]) == null ? void 0 : pe.id) ?? "";
    }), w = A(
      () => a.columns.map((pe) => {
        const be = pe.id === x.value, Oe = pe.width ?? (be ? 240 : 140);
        return {
          id: pe.id,
          width: Oe,
          min: Math.min(pe.min ?? (be ? 120 : 56), Oe),
          max: Math.max(pe.max ?? 900, Oe),
          hideable: be ? !1 : pe.hideable !== !1,
          resizable: pe.resizable !== !1
        };
      })
    ), $ = bS(
      () => w.value,
      a.tableId ? NN(a.tableId) : q4(),
      { lead: x.value }
    ), k = A(() => a.columnStore ?? $), b = A(
      () => (a.candidates ?? a.columns.map((pe) => pe.id)).filter((pe) => pe !== k.value.lead)
    ), C = g1 + qs, T = A(() => a.actionsWidth ?? (a.rowActions ? 92 : 28)), E = A(() => ({
      gap: Ym,
      padding: qs * 2,
      check: a.selectable ? g1 : 0,
      menu: T.value,
      ...a.metrics ?? {}
    })), R = S(null), z = S(0);
    let D = null, U = 0, H = 0;
    const L = S(!1), P = S(!1);
    function K(pe) {
      if (!pe) return;
      const be = Ev(pe).end;
      be !== P.value && (P.value = be);
    }
    function N(pe) {
      const be = pe.currentTarget;
      if (!be) return;
      const Oe = Ev(be).start;
      Oe !== L.value && (L.value = Oe), K(be);
    }
    Je(
      R,
      (pe) => {
        D == null || D.disconnect(), D = null, H && cancelAnimationFrame(H), H = 0, !(!pe || typeof ResizeObserver > "u") && (D = new ResizeObserver((be) => {
          var st, tn;
          U = ((tn = (st = be[0]) == null ? void 0 : st.contentRect) == null ? void 0 : tn.width) ?? 0, !H && (H = requestAnimationFrame(() => {
            H = 0, Math.abs(U - z.value) >= 1 && (z.value = U);
          }));
        }), D.observe(pe));
      },
      { flush: "post" }
    );
    const J = A(() => k.value.layout(z.value, b.value, E.value)), j = A(() => J.value.visible), re = A(() => z.value > 0 && z.value < J.value.stackBelow);
    Je(
      [() => J.value.total, z, re],
      () => K(R.value),
      { flush: "post" }
    ), Je(re, (pe) => {
      pe && (L.value = !1);
    });
    const q = (pe, { slots: be }) => {
      var Oe, st;
      return pe.on ? DM("div", { class: "fe-list__stack-value" }, (Oe = be.default) == null ? void 0 : Oe.call(be)) : (st = be.default) == null ? void 0 : st.call(be);
    };
    q.props = ["on"];
    function le(pe) {
      var be;
      return ((be = v.value.get(pe)) == null ? void 0 : be.headerLabel) === !1;
    }
    function ve(pe) {
      return re.value && !le(pe);
    }
    const ce = A(() => {
      if (!re.value) return null;
      const pe = j.value.filter((be) => !le(be));
      return pe.length ? pe[pe.length - 1] : null;
    });
    function se(pe) {
      UN(pe.target, R.value);
    }
    const fe = A(() => re.value ? void 0 : { width: `${J.value.total}px` }), _ = A(
      () => (a.selectable ? C + Ym : qs) + (J.value.widths[k.value.lead] ?? k.value.width(k.value.lead))
    ), ee = A(
      () => !re.value && z.value > 0 && z.value - _.value >= II
    ), Y = A(() => T.value + qs), B = A(
      () => !re.value && (z.value <= 0 || z.value - _.value - Y.value >= BI)
    ), W = A(() => ({
      "--fe-list-lead": a.selectable ? `${C + Ym}px` : "0px"
    }));
    function F(pe) {
      if (re.value) return;
      let be = J.value.widths[pe] ?? k.value.width(pe);
      return pe === k.value.lead && ee.value && !a.selectable && (be += qs), { flex: `0 0 ${be}px` };
    }
    const V = A(
      () => re.value || T.value === 28 ? void 0 : { flex: `0 0 ${T.value + qs}px` }
    );
    function ke(pe) {
      const be = v.value.get(pe), Oe = ["fe-list__col", "fe-list__cell"];
      return be != null && be.class && Oe.push(be.class), pe === k.value.lead && Oe.push("fe-list__col--lead"), (be == null ? void 0 : be.align) === "right" ? Oe.push("is-right") : (be == null ? void 0 : be.align) === "center" && Oe.push("is-center"), Oe;
    }
    function qe(pe) {
      var be;
      return ((be = v.value.get(pe)) == null ? void 0 : be.label) ?? pe;
    }
    const Me = A(() => a.sort !== void 0), Fe = S(
      a.tableId ? IN(a.tableId) : null
    ), We = A(() => Me.value ? a.sort ?? null : Fe.value), $t = A(
      () => (a.pages ?? 1) > 1 || a.total != null && a.total > a.rows.length
    ), St = A(() => a.sortClosed ? a.sortClosed : !Me.value && $t.value ? p("table.sort_paged") : null);
    function at(pe) {
      var be;
      return ((be = v.value.get(pe)) == null ? void 0 : be.sortable) === !0;
    }
    const kt = A(
      () => re.value && !St.value && [k.value.lead, ...j.value].some(at) ? p("sort.by") : void 0
    );
    function pt(pe) {
      if (St.value || !at(pe)) return;
      const be = We.value, Oe = v.value.get(pe), st = be && be.key === pe ? { key: pe, dir: be.dir === "asc" ? "desc" : "asc" } : { key: pe, dir: (Oe == null ? void 0 : Oe.sortDir) ?? "asc" };
      Me.value || (Fe.value = st, a.tableId && BN(a.tableId, st)), i("sort", st);
    }
    function Ne(pe) {
      const be = We.value;
      return St.value || !be || be.key !== pe ? "" : be.dir === "asc" ? "↑" : "↓";
    }
    function ie(pe) {
      if (!at(pe)) return;
      const be = We.value;
      return St.value || !be || be.key !== pe ? "none" : be.dir === "asc" ? "ascending" : "descending";
    }
    function xe(pe) {
      return St.value ?? p("cols.sort_by", { col: qe(pe) });
    }
    function he(pe, be) {
      const Oe = v.value.get(be);
      return Oe != null && Oe.sortValue ? Oe.sortValue(pe) : Oe != null && Oe.format ? Oe.format(pe) : pe == null ? void 0 : pe[be];
    }
    function De(pe, be) {
      const Oe = pe == null || pe === "", st = be == null || be === "";
      return Oe && st ? 0 : Oe ? 1 : st ? -1 : typeof pe == "number" && typeof be == "number" ? pe - be : typeof pe == "boolean" && typeof be == "boolean" ? Number(pe) - Number(be) : String(pe).localeCompare(String(be), l.value, { numeric: !0, sensitivity: "base" });
    }
    const ot = A(() => {
      const pe = We.value;
      if (Me.value || St.value || !pe || !v.value.has(pe.key)) return a.rows;
      const be = pe.dir === "asc" ? 1 : -1;
      return a.rows.map((Oe, st) => ({ row: Oe, i: st, v: he(Oe, pe.key) })).sort((Oe, st) => {
        const tn = Oe.v === null || Oe.v === void 0 || Oe.v === "", Lt = st.v === null || st.v === void 0 || st.v === "";
        return tn !== Lt ? tn ? 1 : -1 : be * De(Oe.v, st.v) || Oe.i - st.i;
      }).map((Oe) => Oe.row);
    }), ft = A(() => a.groups ?? [{ id: "all", items: ot.value }]), gt = LM(), Ut = A(() => a.empty === void 0 ? p("table.empty") : a.empty ?? ""), Xe = A(() => !a.loading && ne.value === 0 && (!!gt.empty || Ut.value !== "")), Ve = A(() => ne.value > 0 || a.loading && ne.value === 0 || Xe.value), Be = A(() => j.value.length + 2 + (a.selectable ? 1 : 0)), ne = A(() => ft.value.reduce((pe, be) => pe + be.items.length, 0));
    function ge(pe, be) {
      return typeof a.rowKey == "function" ? a.rowKey(pe) : a.rowKey ? pe == null ? void 0 : pe[a.rowKey] : be;
    }
    function G(pe) {
      return a.isSelected ? a.isSelected(pe) : !1;
    }
    function ye(pe, be) {
      return pe == null ? void 0 : pe[be];
    }
    function te(pe, be) {
      const Oe = v.value.get(be), st = Oe != null && Oe.format ? Oe.format(pe) : pe == null ? void 0 : pe[be];
      return st == null || st === "" ? "-" : U2(String(st));
    }
    function Ce(pe, be) {
      const Oe = v.value.get(be);
      if (Oe != null && Oe.title) return Oe.title(pe);
      const st = te(pe, be);
      return st === "-" ? void 0 : st;
    }
    function Ie(pe, be) {
      var Oe;
      return [
        "fe-list__row",
        { "is-selected": G(pe), "is-clickable": !!_e.value },
        (Oe = a.rowClass) == null ? void 0 : Oe.call(a, pe, be)
      ];
    }
    const _e = S(!1);
    let Ae = null;
    function Pe() {
      k.value.widthsAreAuto() && k.value.freeze(J.value.widths);
    }
    function _t(pe) {
      var be;
      return ((be = k.value.spec(pe)) == null ? void 0 : be.resizable) === !0;
    }
    function Et(pe) {
      return Math.round(J.value.widths[pe] ?? k.value.width(pe));
    }
    function xn(pe) {
      var be;
      return (be = k.value.spec(pe)) == null ? void 0 : be.min;
    }
    function Dt(pe) {
      var be;
      return (be = k.value.spec(pe)) == null ? void 0 : be.max;
    }
    function bn(pe, be) {
      _t(pe) && (be.preventDefault(), be.stopPropagation(), Pe(), Ae = { id: pe, startX: be.clientX, startW: k.value.width(pe), sign: Av(ei(R.value)) }, window.addEventListener("pointermove", ln), window.addEventListener("pointerup", Jt));
    }
    function ln(pe) {
      Ae && k.value.setWidth(Ae.id, Ae.startW + Ae.sign * (pe.clientX - Ae.startX));
    }
    function Jt() {
      Ae = null, window.removeEventListener("pointermove", ln), window.removeEventListener("pointerup", Jt);
    }
    function Ln(pe, be) {
      if (be.ctrlKey || be.metaKey) return;
      const Oe = 16 * qf(be.key, ei(R.value));
      Oe && (be.preventDefault(), Pe(), k.value.setWidth(pe, k.value.width(pe) + Oe));
    }
    function Vn(pe) {
      const be = k.value.spec(pe);
      be && (Pe(), k.value.setWidth(pe, be.width));
    }
    let Ft = null;
    const na = S(null), Kt = S(null);
    let bt = 0;
    function Dn(pe) {
      var be;
      return pe !== k.value.lead && ((be = k.value.spec(pe)) == null ? void 0 : be.hideable) === !0;
    }
    function Nn(pe, be) {
      be.button !== 0 || !Dn(pe) || re.value || (Ft = { id: pe, startX: be.clientX, armed: !1 }, window.addEventListener("pointermove", mn), window.addEventListener("pointerup", aa), window.addEventListener("keydown", Ue, !0), window.addEventListener("pointercancel", Cn), window.addEventListener("blur", Cn));
    }
    function Cn() {
      const pe = (Ft == null ? void 0 : Ft.armed) === !0;
      He(), pe && (bt = Date.now());
    }
    function fn() {
      const pe = j.value;
      let be = 0;
      for (; be < pe.length && !Dn(pe[be]); ) be++;
      let Oe = pe.length;
      for (; Oe > be && !Dn(pe[Oe - 1]); ) Oe--;
      return { first: be, last: Oe };
    }
    function mn(pe) {
      var Ul;
      if (!Ft) return;
      if (!Ft.armed) {
        if (Math.abs(pe.clientX - Ft.startX) < FI) return;
        Ft.armed = !0, na.value = Ft.id;
      }
      const be = (Ul = R.value) == null ? void 0 : Ul.querySelector(".fe-list__head");
      if (!be) return;
      const Oe = Array.from(be.children).filter((To) => To.classList.contains("fe-list__col")), st = a.selectable ? 2 : 1, tn = Oe.slice(st, st + j.value.length), Lt = Av(ei(R.value));
      let xa = tn.length;
      for (let To = 0; To < tn.length; To++) {
        const ad = tn[To].getBoundingClientRect();
        if (Lt * (pe.clientX - (ad.left + ad.width / 2)) < 0) {
          xa = To;
          break;
        }
      }
      const { first: Un, last: Si } = fn();
      xa = Math.max(Un, Math.min(Si, xa));
      const ir = j.value.indexOf(Ft.id);
      Kt.value = xa === ir || xa === ir + 1 ? null : xa;
    }
    function aa() {
      const pe = Ft, be = Kt.value;
      He(), pe != null && pe.armed && (bt = Date.now(), be != null && zn(pe.id, be));
    }
    function zn(pe, be) {
      const Oe = j.value, st = Oe.indexOf(pe);
      if (st === -1 || be === st || be === st + 1) return;
      const Lt = Oe.filter((Si) => Si !== pe)[be > st ? be - 1 : be], xa = k.value.order().filter((Si) => Si !== pe), Un = Lt ? xa.indexOf(Lt) : xa.length;
      Un !== -1 && k.value.move(pe, Un);
    }
    function Mn() {
      return k.value.order().filter((pe) => Dn(pe) && b.value.includes(pe));
    }
    function rn(pe, be) {
      const Oe = Mn(), st = Oe.indexOf(pe), tn = st + be;
      if (st === -1 || tn < 0 || tn >= Oe.length) return;
      const Lt = Oe[tn], Un = k.value.order().filter((Si) => Si !== pe).indexOf(Lt);
      Un !== -1 && k.value.move(pe, be === -1 ? Un : Un + 1);
    }
    function me(pe, be) {
      const Oe = Mn(), st = Oe.indexOf(pe);
      return st !== -1 && st + be >= 0 && st + be < Oe.length;
    }
    function Le(pe, be) {
      if (!be.ctrlKey && !be.metaKey) return;
      const Oe = qf(be.key, ei(R.value));
      !Oe || !Dn(pe) || (be.preventDefault(), be.stopPropagation(), rn(pe, Oe));
    }
    function Ue(pe) {
      pe.key === "Escape" && (pe.stopPropagation(), Cn());
    }
    function He() {
      Ft = null, na.value = null, Kt.value = null, window.removeEventListener("pointermove", mn), window.removeEventListener("pointerup", aa), window.removeEventListener("keydown", Ue, !0), window.removeEventListener("pointercancel", Cn), window.removeEventListener("blur", Cn);
    }
    function xt(pe) {
      Date.now() - bt > UI || (bt = 0, pe.preventDefault(), pe.stopPropagation());
    }
    const Qe = S(!1), ue = S(0), je = S(0);
    let dt = 0;
    const It = S(null), hn = Nl(), nn = A(() => `fe-ctx-backdrop--theme-${c.value || "auto"}`), ae = A(
      () => m.value === "rtl" ? { earlier: { key: "cols.move_right", arrow: "→" }, later: { key: "cols.move_left", arrow: "←" } } : { earlier: { key: "cols.move_left", arrow: "←" }, later: { key: "cols.move_right", arrow: "→" } }
    ), oe = A(
      () => (
        /* In the person's OWN order, so the list reads as the table on screen. */
        k.value.order().filter((pe) => Dn(pe) && b.value.includes(pe)).map((pe) => ({
          id: pe,
          label: qe(pe),
          on: !k.value.hidden(pe),
          canEarlier: me(pe, -1),
          canLater: me(pe, 1)
        }))
      )
    ), ze = A(() => k.value.customised());
    async function Ke(pe) {
      var st;
      pe.preventDefault(), pe.stopPropagation();
      const be = pe.currentTarget, Oe = be == null ? void 0 : be.getBoundingClientRect();
      dt = pe.clientX || (Oe ? Ur(Oe, m.value) : 0), ue.value = dt, je.value = pe.clientY || (Oe ? Oe.bottom : 0), Qe.value = !0, await Gt(), it(), (st = It.value) == null || st.focus();
    }
    function it() {
      const pe = It.value;
      if (!pe) return;
      const be = pe.getBoundingClientRect(), Oe = 8;
      ue.value = Oc(dt, be.width, window.innerWidth, m.value, Oe), be.bottom > window.innerHeight - Oe && (je.value = Math.max(Oe, window.innerHeight - Oe - be.height));
    }
    function Z() {
      Qe.value = !1;
    }
    function Q(pe) {
      pe.key === "Escape" && (pe.stopPropagation(), Z());
    }
    Je(Qe, (pe) => {
      typeof window > "u" || (pe ? window.addEventListener("keydown", Q, !0) : window.removeEventListener("keydown", Q, !0));
    });
    function we(pe) {
      k.value.setHidden(pe, !k.value.hidden(pe));
    }
    function Ye() {
      k.value.reset();
    }
    Tt(() => {
      D == null || D.disconnect(), D = null, H && cancelAnimationFrame(H), H = 0, Jt(), He(), typeof window < "u" && window.removeEventListener("keydown", Q, !0);
    });
    const rt = A(() => a.pages != null ? Math.max(1, a.pages) : !a.total || !a.pageSize ? 1 : Math.max(1, Math.ceil(a.total / a.pageSize))), vt = A(() => a.page ?? 1), Bt = A(() => rt.value > 1), Qt = A(() => {
      if (a.total != null && a.pageSize != null && a.total > 0) {
        const pe = (vt.value - 1) * a.pageSize + 1, be = Math.min(vt.value * a.pageSize, a.total);
        return `${pe} - ${be} / ${a.total}`;
      }
      return "";
    });
    function en(pe) {
      pe < 1 || pe > rt.value || i("page", pe);
    }
    const Ot = Zo();
    _e.value = !!((un = Ot == null ? void 0 : Ot.vnode.props) != null && un.onRowClick);
    function kn(pe, be) {
      i("row-click", pe, be);
    }
    function Pa(pe, be, Oe) {
      i("row-action", pe, be, Oe);
    }
    return t({ store: k, layout: J, pinLead: ee, stacked: re }), (pe, be) => (f(), h(Te, null, [
      d("div", wv(pe.$attrs, {
        class: ["fe-table", { "fe-table--framed": e.framed, "fe-table--bare": !e.framed }]
      }), [
        pe.$slots.toolbar ? (f(), h("div", jN, [
          On(pe.$slots, "toolbar")
        ])) : O("", !0),
        e.loading && ne.value > 0 ? (f(), h("div", qN, [
          d("span", WN, y(u(p)("loading")), 1)
        ])) : O("", !0),
        d("div", {
          ref_key: "listEl",
          ref: R,
          class: Re(["fe-list", {
            "is-loading": e.loading,
            "is-scrolled-x": L.value,
            "is-more-end": P.value,
            "is-pin-lead": ee.value,
            "is-pin-menu": B.value,
            "is-stacked": re.value,
            "fe-list--nocheck": !e.selectable
          }]),
          style: Yt(W.value),
          role: "grid",
          "aria-label": e.ariaLabel,
          "aria-busy": e.loading ? "true" : void 0,
          "data-table-id": e.tableId,
          onScrollPassive: N
        }, [
          d("div", {
            class: Re(["fe-list__head", { "is-dragging-col": !!na.value }]),
            role: "row",
            "data-sort-label": kt.value,
            style: Yt(fe.value),
            onContextmenu: Ke,
            onClickCapture: xt
          }, [
            e.selectable ? (f(), h("div", XN)) : O("", !0),
            d("div", {
              class: Re(ke(k.value.lead)),
              role: "columnheader",
              style: Yt(F(k.value.lead)),
              "aria-sort": ie(k.value.lead),
              "data-col": k.value.lead
            }, [
              at(k.value.lead) ? (f(), h("button", {
                key: 0,
                type: "button",
                class: "fe-list__sort",
                disabled: !!St.value,
                title: xe(k.value.lead),
                onClick: be[0] || (be[0] = (Oe) => pt(k.value.lead))
              }, [
                d("span", QN, y(qe(k.value.lead)), 1),
                Ne(k.value.lead) ? (f(), h("span", eI, y(Ne(k.value.lead)), 1)) : O("", !0)
              ], 8, ZN)) : (f(), h("span", {
                key: 1,
                class: "fe-list__head-label",
                title: qe(k.value.lead)
              }, y(qe(k.value.lead)), 9, tI)),
              _t(k.value.lead) && !re.value ? (f(), h("span", {
                key: 2,
                class: "fe-list__resize",
                role: "separator",
                "aria-orientation": "vertical",
                tabindex: "0",
                "aria-valuenow": Et(k.value.lead),
                "aria-valuemin": xn(k.value.lead),
                "aria-valuemax": Dt(k.value.lead),
                "aria-label": u(p)("cols.resize", { col: qe(k.value.lead) }),
                title: u(p)("cols.resize", { col: qe(k.value.lead) }),
                onPointerdown: be[1] || (be[1] = (Oe) => bn(k.value.lead, Oe)),
                onDblclick: be[2] || (be[2] = yt((Oe) => Vn(k.value.lead), ["stop"])),
                onKeydown: be[3] || (be[3] = (Oe) => Ln(k.value.lead, Oe))
              }, null, 40, nI)) : O("", !0)
            ], 14, JN),
            (f(!0), h(Te, null, nt(j.value, (Oe, st) => (f(), h("div", {
              key: Oe,
              class: Re([
                ke(Oe),
                {
                  "is-col-dragging": na.value === Oe,
                  "is-drop-before": Kt.value === st,
                  "is-drop-after": Kt.value === j.value.length && st === j.value.length - 1,
                  "is-movable": Dn(Oe) && !re.value
                }
              ]),
              role: "columnheader",
              style: Yt(F(Oe)),
              "aria-sort": ie(Oe),
              "aria-label": le(Oe) ? qe(Oe) : void 0,
              "data-col": Oe,
              onPointerdown: (tn) => Nn(Oe, tn),
              onKeydown: (tn) => Le(Oe, tn)
            }, [
              at(Oe) ? (f(), h("button", {
                key: 0,
                type: "button",
                class: "fe-list__sort",
                disabled: !!St.value,
                title: xe(Oe),
                onClick: (tn) => pt(Oe)
              }, [
                d("span", oI, y(qe(Oe)), 1),
                Ne(Oe) ? (f(), h("span", rI, y(Ne(Oe)), 1)) : O("", !0)
              ], 8, iI)) : le(Oe) ? O("", !0) : (f(), h("span", {
                key: 1,
                class: "fe-list__head-label",
                title: qe(Oe)
              }, y(qe(Oe)), 9, sI)),
              _t(Oe) && !re.value ? (f(), h("span", {
                key: 2,
                class: "fe-list__resize",
                role: "separator",
                "aria-orientation": "vertical",
                tabindex: "0",
                "aria-valuenow": Et(Oe),
                "aria-valuemin": xn(Oe),
                "aria-valuemax": Dt(Oe),
                "aria-label": u(p)("cols.resize", { col: qe(Oe) }),
                title: u(p)("cols.resize", { col: qe(Oe) }),
                onPointerdown: (tn) => bn(Oe, tn),
                onDblclick: yt((tn) => Vn(Oe), ["stop"]),
                onKeydown: (tn) => Ln(Oe, tn)
              }, null, 40, lI)) : O("", !0)
            ], 46, aI))), 128)),
            d("div", {
              class: Re(["fe-list__col fe-list__col--menu", { "is-wide": T.value !== 28 }]),
              style: Yt(V.value),
              role: "columnheader"
            }, [
              d("button", {
                type: "button",
                class: "fe-list__menu fe-list__colmenu-btn",
                title: u(p)("cols.menu"),
                "aria-label": u(p)("cols.menu"),
                "aria-haspopup": "dialog",
                "aria-expanded": Qe.value ? "true" : "false",
                onClick: Ke
              }, [...be[12] || (be[12] = [
                d("span", { "aria-hidden": "true" }, "⋮", -1)
              ])], 8, uI)
            ], 6)
          ], 46, GN),
          d("div", {
            class: "fe-list__body",
            role: Ve.value ? "rowgroup" : "presentation",
            onPointerover: se
          }, [
            (f(!0), h(Te, null, nt(ft.value, (Oe) => (f(), h(Te, {
              key: Oe.id
            }, [
              Oe.label ? (f(), h("div", dI, y(Oe.label), 1)) : O("", !0),
              (f(!0), h(Te, null, nt(Oe.items, (st, tn) => (f(), h("div", wv({
                key: ge(st, tn),
                class: Ie(st, tn),
                role: "row",
                style: fe.value,
                "aria-selected": e.selectable ? G(st) ? "true" : "false" : void 0
              }, { ref_for: !0 }, e.rowAttrs ? e.rowAttrs(st) : {}, {
                onClick: (Lt) => kn(st, Lt),
                onDblclick: (Lt) => i("row-dblclick", st, Lt),
                onContextmenu: (Lt) => i("row-contextmenu", st, Lt),
                onDragstart: (Lt) => i("row-dragstart", st, Lt),
                onDragover: (Lt) => i("row-dragover", st, Lt),
                onDragleave: (Lt) => i("row-dragleave", st, Lt),
                onDrop: (Lt) => i("row-drop", st, Lt),
                onTouchstartPassive: (Lt) => i("row-touchstart", st, Lt),
                onTouchend: be[7] || (be[7] = (Lt) => i("row-touchend", Lt)),
                onTouchmovePassive: be[8] || (be[8] = (Lt) => i("row-touchmove", Lt))
              }), [
                e.selectable ? (f(), h("div", {
                  key: 0,
                  class: "fe-list__col fe-list__col--check",
                  role: "gridcell",
                  "data-fe-control": "",
                  onClick: yt((Lt) => i("check-click", st, Lt), ["stop"]),
                  onDblclick: be[4] || (be[4] = yt(() => {
                  }, ["stop"]))
                }, [
                  Ze(Tg, {
                    on: G(st),
                    label: te(st, k.value.lead)
                  }, null, 8, ["on", "label"])
                ], 40, pI)) : O("", !0),
                d("div", {
                  class: Re(ke(k.value.lead)),
                  role: "gridcell",
                  style: Yt(F(k.value.lead)),
                  title: pe.$slots[`cell-${k.value.lead}`] ? void 0 : Ce(st, k.value.lead)
                }, [
                  On(pe.$slots, `cell-${k.value.lead}`, {
                    row: st,
                    value: ye(st, k.value.lead)
                  }, () => [
                    d("span", mI, [
                      d("bdi", null, y(te(st, k.value.lead)), 1)
                    ])
                  ])
                ], 14, hI),
                (f(!0), h(Te, null, nt(j.value, (Lt) => (f(), h("div", {
                  key: Lt,
                  class: Re([
                    ke(Lt),
                    { "is-stack-fact": ve(Lt), "is-stack-last": ce.value === Lt, "is-stack-tail": re.value && !ve(Lt) }
                  ]),
                  role: "gridcell",
                  style: Yt(F(Lt)),
                  "data-col": Lt,
                  "data-label": ve(Lt) ? qe(Lt) : void 0,
                  title: pe.$slots[`cell-${Lt}`] ? void 0 : Ce(st, Lt)
                }, [
                  Ze(q, {
                    on: ve(Lt)
                  }, {
                    default: mt(() => [
                      On(pe.$slots, `cell-${Lt}`, {
                        row: st,
                        value: ye(st, Lt)
                      }, () => [
                        le(Lt) ? O("", !0) : (f(), h("span", yI, [
                          d("bdi", null, y(te(st, Lt)), 1)
                        ]))
                      ])
                    ]),
                    _: 2
                  }, 1032, ["on"])
                ], 14, vI))), 128)),
                d("div", {
                  class: Re(["fe-list__col fe-list__col--menu", { "is-wide": T.value !== 28 }]),
                  style: Yt(V.value),
                  role: "gridcell",
                  "data-fe-control": "",
                  onClick: be[5] || (be[5] = yt(() => {
                  }, ["stop"])),
                  onDblclick: be[6] || (be[6] = yt(() => {
                  }, ["stop"]))
                }, [
                  On(pe.$slots, "actions", { row: st }, () => {
                    var Lt;
                    return [
                      e.rowActions && e.rowActions(st).length ? (f(), Ge(VN, {
                        key: 0,
                        locale: l.value,
                        theme: c.value,
                        actions: e.rowActions(st),
                        testid: (Lt = e.rowActionsTestId) == null ? void 0 : Lt.call(e, st),
                        onSelect: (xa, Un) => Pa(xa, st, Un)
                      }, null, 8, ["locale", "theme", "actions", "testid", "onSelect"])) : O("", !0)
                    ];
                  })
                ], 38)
              ], 16, fI))), 128))
            ], 64))), 128)),
            e.loading && ne.value === 0 ? (f(), h("div", gI, [
              d("div", {
                role: "gridcell",
                "aria-colspan": Be.value,
                "aria-live": "polite"
              }, y(u(p)("loading")), 9, bI)
            ])) : Xe.value ? (f(), h("div", kI, [
              d("div", {
                role: "gridcell",
                "aria-colspan": Be.value
              }, [
                On(pe.$slots, "empty", {}, () => [
                  Ht(y(Ut.value), 1)
                ])
              ], 8, wI)
            ])) : O("", !0)
          ], 40, cI)
        ], 46, YN),
        Bt.value || e.footNote || pe.$slots.foot ? (f(), h("div", _I, [
          d("span", null, [
            On(pe.$slots, "foot", {}, () => [
              Ht(y(e.footNote || Qt.value), 1)
            ])
          ]),
          Bt.value ? (f(), h("div", xI, [
            d("button", {
              type: "button",
              class: "tbl-page",
              disabled: vt.value <= 1,
              "aria-label": u(p)("table.prev"),
              title: u(p)("table.prev"),
              onClick: be[9] || (be[9] = (Oe) => en(vt.value - 1))
            }, "‹", 8, SI),
            d("span", $I, y(vt.value) + " / " + y(rt.value), 1),
            d("button", {
              type: "button",
              class: "tbl-page",
              disabled: vt.value >= rt.value,
              "aria-label": u(p)("table.next"),
              title: u(p)("table.next"),
              onClick: be[10] || (be[10] = (Oe) => en(vt.value + 1))
            }, "›", 8, TI)
          ])) : O("", !0)
        ])) : O("", !0)
      ], 16),
      (f(), Ge(wi, { to: "body" }, [
        Qe.value ? (f(), h("div", {
          key: 0,
          class: Re(["fe-colmenu__backdrop", nn.value]),
          dir: u(m),
          "data-prefers-dark": u(hn) ? "1" : "0",
          onClick: Z,
          onContextmenu: yt(Z, ["prevent"])
        }, [
          d("div", {
            ref_key: "colMenuEl",
            ref: It,
            class: "fe-colmenu",
            role: "dialog",
            tabindex: "-1",
            "aria-label": u(p)("cols.menu"),
            style: Yt({ top: je.value + "px", left: ue.value + "px" }),
            onClick: be[11] || (be[11] = yt(() => {
            }, ["stop"])),
            onKeydown: Ca(yt(Z, ["stop"]), ["esc"])
          }, [
            d("p", CI, y(u(p)("cols.title")), 1),
            (f(!0), h(Te, null, nt(oe.value, (Oe) => (f(), h("div", {
              key: Oe.id,
              class: "fe-colmenu__line"
            }, [
              d("button", {
                type: "button",
                class: "fe-colmenu__row",
                role: "checkbox",
                "aria-checked": Oe.on ? "true" : "false",
                onClick: (st) => we(Oe.id)
              }, [
                d("span", {
                  class: Re(["fe-list__check fe-colmenu__tick", { "is-on": Oe.on }]),
                  "aria-hidden": "true"
                }, null, 2),
                d("span", MI, y(Oe.label), 1)
              ], 8, zI),
              d("button", {
                type: "button",
                class: "fe-colmenu__nudge",
                disabled: !Oe.canEarlier,
                title: u(p)(ae.value.earlier.key, { col: Oe.label }),
                "aria-label": u(p)(ae.value.earlier.key, { col: Oe.label }),
                onClick: (st) => rn(Oe.id, -1)
              }, [
                d("span", OI, y(ae.value.earlier.arrow), 1)
              ], 8, PI),
              d("button", {
                type: "button",
                class: "fe-colmenu__nudge",
                disabled: !Oe.canLater,
                title: u(p)(ae.value.later.key, { col: Oe.label }),
                "aria-label": u(p)(ae.value.later.key, { col: Oe.label }),
                onClick: (st) => rn(Oe.id, 1)
              }, [
                d("span", DI, y(ae.value.later.arrow), 1)
              ], 8, LI)
            ]))), 128)),
            ze.value ? (f(), h("div", RI)) : O("", !0),
            ze.value ? (f(), h("button", {
              key: 1,
              type: "button",
              class: "fe-colmenu__row",
              onClick: Ye
            }, [
              d("span", NI, y(u(p)("cols.reset")), 1)
            ])) : O("", !0),
            On(pe.$slots, "colmenu-extra", { close: Z })
          ], 44, EI)
        ], 42, AI)) : O("", !0)
      ]))
    ], 64));
  }
});
function HI(e, t, n, a) {
  if (!e || t !== "date" && t !== "datetime") return e;
  const i = fO(e, n);
  if (i) return i;
  const r = Date.parse(e.trim());
  return Number.isNaN(r) ? e : a(r, { time: t === "datetime" }) || e;
}
const KI = {
  class: "fe-slist",
  "data-testid": "surface-list"
}, VI = /* @__PURE__ */ lt({
  __name: "SurfaceList",
  props: {
    columns: {},
    rows: {},
    empty: {},
    locale: {},
    disabled: { type: Boolean },
    tableId: {}
  },
  emits: ["action"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatDate: r } = ht(() => n.locale), l = A(() => n.rows ?? []), c = A(() => l.value.some((w) => (w.actions ?? []).length > 0)), p = A(() => Jy(n.empty, n.locale, () => i("plugin.list.empty")));
    function m(w, $) {
      var k;
      return Xt((k = w.cells) == null ? void 0 : k[$], n.locale);
    }
    const v = A(
      () => (n.columns ?? []).map((w) => {
        const $ = typeof w.width == "number" && Number.isFinite(w.width) ? Math.round(w.width) : void 0;
        return {
          id: w.key,
          label: Xt(w.label, n.locale),
          width: $ === void 0 ? void 0 : Math.min(900, Math.max(60, $)),
          align: w.align,
          sortable: w.sortable !== !1,
          // A date column is printed the explorer's way, and sorted by the value.
          format: (k) => HI(m(k, w.key), w.format, n.locale, r),
          sortValue: (k) => {
            var C;
            const b = (C = k.sort) == null ? void 0 : C[w.key];
            return typeof b == "number" || typeof b == "string" ? b : m(k, w.key);
          }
        };
      })
    );
    function x(w) {
      return (w.actions ?? []).map(($) => ({
        key: $.id,
        label: Xt($.label, n.locale),
        danger: $.danger,
        disabled: n.disabled,
        testid: `surface-list-action-${w.id}-${$.id}`
      }));
    }
    return (w, $) => (f(), h("div", KI, [
      Ze(os, {
        "table-id": e.tableId,
        columns: v.value,
        rows: l.value,
        "row-key": "id",
        locale: e.locale,
        empty: p.value,
        "row-attrs": (k) => ({ "data-row": k.id }),
        "row-actions": c.value ? x : void 0,
        "row-actions-test-id": (k) => (k.actions ?? []).length ? `surface-list-actions-${k.id}` : void 0,
        onRowAction: $[0] || ($[0] = (k, b) => a("action", { action_id: k, row_id: b.id }))
      }, null, 8, ["table-id", "columns", "rows", "locale", "empty", "row-attrs", "row-actions", "row-actions-test-id"])
    ]));
  }
}), jI = {
  class: "fe-sprogress",
  "data-testid": "surface-progress"
}, qI = { class: "fe-sprogress__head" }, WI = { class: "fe-sprogress__label" }, YI = {
  key: 0,
  class: "fe-sprogress__pct"
}, GI = ["aria-label", "aria-valuenow"], XI = /* @__PURE__ */ lt({
  __name: "SurfaceProgress",
  props: {
    value: {},
    label: {},
    locale: {}
  },
  setup(e) {
    const t = e, { t: n } = ht(() => t.locale), a = A(() => {
      const r = t.value;
      return r == null || !Number.isFinite(Number(r)) ? null : Math.min(100, Math.max(0, Math.round(Number(r))));
    }), i = A(() => Jy(t.label, t.locale, () => n("plugin.view.busy")));
    return (r, l) => (f(), h("div", jI, [
      d("div", qI, [
        d("span", WI, y(i.value), 1),
        a.value !== null ? (f(), h("span", YI, y(a.value) + "%", 1)) : O("", !0)
      ]),
      d("div", {
        class: Re(["fe-sprogress__track", { "is-indeterminate": a.value === null }]),
        role: "progressbar",
        "aria-label": i.value,
        "aria-valuemin": "0",
        "aria-valuemax": "100",
        "aria-valuenow": a.value === null ? void 0 : a.value
      }, [
        d("div", {
          class: "fe-sprogress__bar",
          style: Yt(a.value === null ? void 0 : { width: `${a.value}%` })
        }, null, 4)
      ], 10, GI)
    ]));
  }
}), p$ = ",،、，", JI = ";؛；", b1 = /* @__PURE__ */ new Map();
function ZI(e) {
  const t = `${e.spaces ? 1 : 0}${e.semicolons ? 1 : 0}${e.newlines ? 1 : 0}`;
  let n = b1.get(t);
  if (!n) {
    const a = p$ + (e.semicolons ? JI : "") + (e.newlines ? "\\n\\r" : "") + (e.spaces ? "\\s" : "");
    n = new RegExp(`[${a}]+`, "u"), b1.set(t, n);
  }
  return n;
}
function QI(e, t = {}) {
  return String(e ?? "").split(ZI(t)).map((n) => n.trim()).filter((n) => n !== "");
}
function e8(e) {
  return e.length === 1 && p$.includes(e);
}
const t8 = {
  key: 0,
  class: "fe-speople__chips",
  "data-testid": "surface-people-chips"
}, n8 = ["title"], a8 = {
  class: "fe-speople__av",
  "aria-hidden": "true"
}, i8 = { class: "fe-speople__name" }, o8 = ["disabled", "title", "aria-label", "data-testid", "onClick"], r8 = {
  key: 1,
  class: "fe-speople__addwrap"
}, s8 = ["placeholder", "disabled", "aria-invalid"], l8 = ["disabled"], u8 = {
  key: 1,
  class: "fe-share__suggest fe-speople__suggest",
  "data-testid": "surface-people-suggest"
}, c8 = ["onMousedown"], d8 = { class: "fe-share__av fe-share__av--sm" }, f8 = { class: "fe-share__suggesttxt" }, p8 = { class: "fe-share__suggestname" }, h8 = { class: "fe-share__suggestmeta" }, m8 = {
  key: 2,
  class: "fe-surface__error",
  role: "alert"
}, v8 = /* @__PURE__ */ lt({
  __name: "SurfacePeoplePicker",
  props: {
    id: {},
    modelValue: {},
    multi: { type: Boolean },
    allowExternal: { type: Boolean },
    api: {},
    plugin: {},
    locale: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = S(""), l = S([]), c = S(!1), p = S(!n.api || !n.plugin), m = S("");
    let v = null, x = 0;
    const w = A(() => n.modelValue ?? []), $ = A(() => n.allowExternal === !0 || p.value), k = A(() => n.multi !== !0 && w.value.length >= 1);
    function b(H) {
      return qp({ name: H.name, email: H.email });
    }
    function C(H) {
      const L = String(H.email ?? "").trim().toLowerCase();
      if (!L) return;
      const P = n.multi === !0 ? w.value.filter((K) => K.email.toLowerCase() !== L) : [];
      a("update:modelValue", [...P, { ...H, email: L }]), r.value = "", l.value = [], c.value = !1, m.value = "";
    }
    function T(H) {
      a("update:modelValue", w.value.filter((L) => L.email !== H));
    }
    function E() {
      m.value = "";
      const H = r.value.trim();
      if (v && clearTimeout(v), !H || p.value) {
        l.value = [], c.value = !1;
        return;
      }
      v = setTimeout(() => void R(H), 180);
    }
    async function R(H) {
      if (!n.api || !n.plugin || p.value) return;
      const L = ++x;
      try {
        const P = await n.api.pluginUsers(n.plugin, H);
        if (L !== x) return;
        l.value = (P.users ?? []).filter((K) => K && typeof K.email == "string"), c.value = l.value.length > 0;
      } catch (P) {
        if (L !== x) return;
        const K = P == null ? void 0 : P.status;
        (K === 403 || K === 404) && (p.value = !0), l.value = [], c.value = !1;
      }
    }
    function z() {
      const H = r.value.trim();
      if (H) {
        if (!$.value) {
          m.value = i("plugin.people.external_off");
          return;
        }
        if (!RR(H)) {
          m.value = i("plugin.people.invalid_email");
          return;
        }
        C({ email: H });
      }
    }
    function D(H) {
      H.key === "Enter" || e8(H.key) ? (H.preventDefault(), z()) : H.key === "Backspace" && r.value === "" && w.value.length ? T(w.value[w.value.length - 1].email) : H.key === "Escape" && (c.value = !1);
    }
    function U() {
      setTimeout(() => {
        c.value = !1;
      }, 120);
    }
    return Je(
      () => [n.api, n.plugin],
      ([H, L]) => {
        H && L && (p.value = !1);
      }
    ), Tt(() => {
      v && clearTimeout(v);
    }), (H, L) => (f(), h("div", {
      class: Re(["fe-speople", { "is-invalid": e.invalid }]),
      "data-testid": "surface-people"
    }, [
      w.value.length ? (f(), h("ul", t8, [
        (f(!0), h(Te, null, nt(w.value, (P) => (f(), h("li", {
          key: P.email,
          class: "fe-speople__chip",
          title: P.email
        }, [
          d("span", a8, y(b(P).charAt(0).toUpperCase()), 1),
          d("span", i8, y(b(P)), 1),
          d("button", {
            type: "button",
            class: "fe-speople__remove",
            disabled: e.disabled,
            title: u(i)("plugin.people.remove", { name: b(P) }),
            "aria-label": u(i)("plugin.people.remove", { name: b(P) }),
            "data-testid": `surface-people-remove-${P.email}`,
            onClick: (K) => T(P.email)
          }, [...L[1] || (L[1] = [
            d("svg", {
              class: "fe-ficon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              d("path", { d: "M6 6l12 12M18 6L6 18" })
            ], -1)
          ])], 8, o8)
        ], 8, n8))), 128))
      ])) : O("", !0),
      k.value ? O("", !0) : (f(), h("div", r8, [
        dn(d("input", {
          "onUpdate:modelValue": L[0] || (L[0] = (P) => r.value = P),
          class: "fe-cfield__input fe-speople__input",
          type: "email",
          autocomplete: "off",
          spellcheck: "false",
          placeholder: p.value ? u(i)("plugin.people.placeholder_email") : u(i)("plugin.people.placeholder"),
          disabled: e.disabled,
          "aria-invalid": e.invalid ? "true" : void 0,
          "data-testid": "surface-people-input",
          onInput: E,
          onKeydown: D,
          onFocus: E,
          onBlur: U
        }, null, 40, s8), [
          [_n, r.value]
        ]),
        $.value ? (f(), h("button", {
          key: 0,
          type: "button",
          class: "fe-btn fe-btn--sm",
          disabled: e.disabled || !r.value.trim(),
          "data-testid": "surface-people-add",
          onClick: z
        }, y(u(i)("plugin.people.add")), 9, l8)) : O("", !0),
        c.value ? (f(), h("ul", u8, [
          (f(!0), h(Te, null, nt(l.value, (P) => (f(), h("li", {
            key: P.user_id ?? P.email,
            onMousedown: yt((K) => C(P), ["prevent"])
          }, [
            d("span", d8, y(b(P).charAt(0).toUpperCase()), 1),
            d("span", f8, [
              d("span", p8, y(b(P)), 1),
              d("span", h8, y(P.email), 1)
            ])
          ], 40, c8))), 128))
        ])) : O("", !0)
      ])),
      m.value ? (f(), h("p", m8, y(m.value), 1)) : O("", !0)
    ], 2));
  }
}), y8 = {
  class: "fe-spin",
  "data-testid": "surface-pin"
}, g8 = ["for"], b8 = ["id", "maxlength", "size", "value", "disabled", "aria-invalid"], k8 = /* @__PURE__ */ lt({
  __name: "SurfacePinInput",
  props: {
    id: {},
    length: {},
    modelValue: {},
    locale: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = A(() => {
      const c = Number(n.length);
      return Number.isInteger(c) && c > 0 ? c : void 0;
    });
    function l(c) {
      const p = c.target.value.replace(/\s+/g, "").slice(0, r.value);
      c.target.value = p, a("update:modelValue", p);
    }
    return (c, p) => (f(), h("div", y8, [
      d("label", {
        class: "fe-cfield__label",
        for: `fe-spin-${e.id}`
      }, y(u(i)("plugin.pin.label")), 9, g8),
      d("input", {
        id: `fe-spin-${e.id}`,
        class: Re(["fe-cfield__input fe-cfield__input--mono fe-spin__input", { "is-invalid": e.invalid }]),
        type: "text",
        inputmode: "numeric",
        autocomplete: "one-time-code",
        spellcheck: "false",
        maxlength: r.value,
        size: r.value,
        value: e.modelValue,
        disabled: e.disabled,
        "aria-invalid": e.invalid ? "true" : void 0,
        style: Yt({ "--spin-len": r.value }),
        onInput: l
      }, null, 46, b8)
    ]));
  }
}), Jn = "@@drives";
function zl(e) {
  const t = e.indexOf("://");
  return t < 0 ? ["", dy(e)] : [e.slice(0, t), dy(e.slice(t + 3))];
}
function Ml(e, t) {
  const n = dy(t);
  return n ? `${e}://${n}` : `${e}://`;
}
function dy(e) {
  return e.replace(/^\/+|\/+$/g, "");
}
function Ag(e, t) {
  if (e === Jn) return null;
  const [n, a] = zl(e);
  if (!n) return null;
  if (!a) return t ? Jn : null;
  const i = a.split("/");
  return i.pop(), Ml(n, i.join("/"));
}
function ml(e, t) {
  if (e === Jn) return t;
  const [n, a] = zl(e);
  if (!a) return n || t;
  const i = a.split("/");
  return i[i.length - 1] || n;
}
function w8(e) {
  if (e === Jn || !e) return [];
  const [t, n] = zl(e);
  if (!t) return [];
  const a = [{ label: t, path: Ml(t, "") }];
  if (!n) return a;
  let i = "";
  for (const r of n.split("/"))
    i = i ? `${i}/${r}` : r, a.push({ label: r, path: Ml(t, i) });
  return a;
}
function h$(e) {
  return e == null || e === "" || e === "editor" || e === "owner";
}
function Eg(e, t) {
  if (e === Jn || t === Jn) return !1;
  const [n, a] = zl(e), [i, r] = zl(t);
  return n !== i ? !1 : r === "" ? !0 : a === r || a.startsWith(r + "/");
}
function Cg(e, t) {
  if (!t || t.length === 0 || e === Jn) return null;
  const n = (i) => {
    const [r, l] = zl(i);
    return Ml(r, l);
  }, a = n(e);
  for (const i of t)
    if (i) {
      if (a === n(i)) return "self";
      if (Eg(e, i)) return "descendant";
    }
  return null;
}
function _8(e, t) {
  if (!e || e === Jn) return null;
  for (const n of t) if (n && Eg(e, n)) return n;
  return null;
}
function m$(e, t, n) {
  if (!e || e === Jn) return null;
  const a = n(e);
  return t ? a === t ? null : "out" : a ? "into" : null;
}
function x8(e, t, n) {
  return m$(e, t, n) ? !(t && Eg(t, e)) : !1;
}
function S8(e, t, n = {}) {
  const a = [];
  for (const i of e ?? []) {
    if (i.type !== "dir") {
      n.files && i.type === "file" && a.push({ path: i.path, label: i.basename, writable: !0, blocked: null, kind: "file" });
      continue;
    }
    a.push({
      path: i.path,
      label: i.basename,
      writable: h$(i.perm),
      blocked: Cg(i.path, t),
      kind: "dir"
    });
  }
  return a;
}
function $8(e, t) {
  return (e ?? []).map((n) => {
    const a = Ml(n, "");
    return {
      path: a,
      label: n,
      // A storage root's own writability is not knowable from the drive list;
      // it is answered by the listing when the user opens it. Offering it as
      // writable here and letting the listing correct that is the honest
      // order — the alternative greys out every drive until each is opened.
      writable: !0,
      blocked: Cg(a, t),
      kind: "dir"
    };
  });
}
function T8(e, t) {
  const n = ((t == null ? void 0 : t.length) ?? 0) > 1;
  if (e && e.includes("://")) return e;
  if (n) return Jn;
  const a = t == null ? void 0 : t[0];
  return a ? Ml(a, "") : Jn;
}
const wc = [];
function A8(e) {
  wc.push(e);
}
function E8(e) {
  const t = wc.lastIndexOf(e);
  t >= 0 && wc.splice(t, 1);
}
function k1(e) {
  return wc[wc.length - 1] === e;
}
const C8 = ["aria-labelledby", "aria-label", "aria-busy"], z8 = {
  key: 0,
  class: "fe-modal__head"
}, M8 = ["aria-label", "disabled"], P8 = { class: "fe-modal__body" }, O8 = {
  key: 1,
  class: "fe-modal__ask",
  role: "alert",
  "data-testid": "modal-busy-close"
}, L8 = { class: "fe-modal__ask-text" }, D8 = { class: "fe-modal__ask-actions" }, R8 = {
  key: 2,
  class: "fe-modal__actions"
}, Gm = 'input:not([disabled]),select:not([disabled]),textarea:not([disabled]),button:not([disabled]),a[href],[tabindex]:not([tabindex="-1"])', ta = /* @__PURE__ */ lt({
  __name: "Modal",
  props: {
    locale: {},
    open: { type: Boolean },
    title: {},
    size: {},
    closeOnBackdrop: { type: Boolean, default: !0 },
    chromeless: { type: Boolean },
    fullbleed: { type: Boolean },
    theme: {},
    busy: { type: Boolean },
    busyClose: { default: null },
    bare: { type: Boolean },
    labelledby: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = e, a = Zo() ? bi(J2, void 0) : void 0, { t: i } = ht(() => n.locale ?? (a == null ? void 0 : a()) ?? "en"), r = t, l = S(null);
    let c = 0;
    const p = `fe-modal-title-${++c}-${Math.random().toString(36).slice(2, 7)}`;
    let m = null, v = null;
    const x = Symbol("fe-modal");
    let w = !1, $;
    function k() {
      const P = l.value;
      if (!P) return;
      const K = P.querySelector("[data-fe-autofocus]");
      if (K) {
        K.focus();
        return;
      }
      const N = (j) => {
        var re;
        return ((re = P.querySelector(j)) == null ? void 0 : re.querySelector(Gm)) ?? null;
      }, J = N(".fe-modal__body") ?? N(".fe-modal__actions") ?? P.querySelector(Gm);
      J == null || J.focus();
    }
    function b() {
      w || (w = !0, m = document.activeElement ?? null, v = null, A8(x), document.addEventListener("keydown", D), $ = setTimeout(() => {
        var P;
        if ($ = void 0, !(typeof document > "u") && w && k1(x) && !((P = l.value) != null && P.contains(document.activeElement))) {
          const K = document.activeElement;
          v = K && K !== document.body && K !== m ? K : null, k();
        }
      }, 30));
    }
    function C() {
      var K;
      if (!w) return;
      w = !1, $ !== void 0 && (clearTimeout($), $ = void 0), document.removeEventListener("keydown", D), E8(x);
      const P = m != null && m.isConnected ? m : v != null && v.isConnected ? v : m;
      (K = P == null ? void 0 : P.focus) == null || K.call(P), m = null, v = null;
    }
    Je(
      () => n.open,
      (P) => P ? b() : C(),
      { immediate: !0 }
    ), Tt(C);
    const T = S(!1), E = S(null);
    Je(
      () => [n.busy, n.open],
      ([P, K]) => {
        (!P || !K) && (T.value = !1);
      }
    );
    function R() {
      if (!n.busy) {
        r("close");
        return;
      }
      n.busyClose && (T.value = !0, Gt(() => {
        var P;
        return (P = E.value) == null ? void 0 : P.focus();
      }));
    }
    function z() {
      T.value = !1, r("close");
    }
    function D(P) {
      if (k1(x)) {
        if (P.key === "Escape") {
          if (n.chromeless) return;
          if (T.value) {
            T.value = !1;
            return;
          }
          if (n.busy) return;
          r("close");
          return;
        }
        if (P.key === "Tab" && l.value) {
          const K = Array.from(l.value.querySelectorAll(Gm)).filter(
            (re) => re.offsetParent !== null || re === document.activeElement
          );
          if (K.length === 0) return;
          const N = K[0], J = K[K.length - 1], j = document.activeElement;
          P.shiftKey && (j === N || !l.value.contains(j)) ? (P.preventDefault(), J.focus()) : !P.shiftKey && (j === J || !l.value.contains(j)) && (P.preventDefault(), N.focus());
        }
      }
    }
    let U = !1;
    function H(P) {
      U = P.target === P.currentTarget;
    }
    function L(P) {
      const K = U;
      U = !1, !(!n.closeOnBackdrop || n.chromeless || n.busy) && (P.target !== P.currentTarget || !K || r("close"));
    }
    return (P, K) => (f(), Ge(Rr, { name: "fe-modal" }, {
      default: mt(() => [
        e.open ? (f(), h("div", {
          key: 0,
          class: Re(["fe fe-modal__backdrop", [
            { "fe-modal__backdrop--chromeless": e.chromeless },
            { "fe-modal__backdrop--fullbleed": e.fullbleed && !e.chromeless },
            e.theme === "light" ? "fe--theme-light" : "",
            e.theme === "dark" ? "fe--theme-dark" : ""
          ]]),
          role: "presentation",
          onPointerdown: H,
          onClick: L
        }, [
          d("div", {
            ref_key: "cardEl",
            ref: l,
            class: Re(["fe-modal__card", [
              e.bare ? "fe-modal__card--bare" : `fe-modal__card--${e.size || "md"}`,
              e.chromeless && "fe-modal__card--chromeless",
              e.fullbleed && !e.chromeless && "fe-modal__card--fullbleed"
            ]]),
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": e.labelledby || (e.title && !e.chromeless && !e.fullbleed && !e.bare ? p : void 0),
            "aria-label": e.labelledby ? void 0 : (!e.title || e.chromeless || e.fullbleed || e.bare) && e.title || void 0,
            "aria-busy": e.busy ? "true" : void 0,
            onClick: K[1] || (K[1] = yt(() => {
            }, ["stop"]))
          }, [
            e.title && !e.chromeless && !e.fullbleed && !e.bare ? (f(), h("header", z8, [
              d("h2", {
                id: p,
                class: "fe-modal__title"
              }, y(e.title), 1),
              d("button", {
                type: "button",
                class: "fe-modal__close",
                "aria-label": u(i)("modal.close"),
                disabled: e.busy && !e.busyClose,
                onClick: R
              }, "×", 8, M8)
            ])) : O("", !0),
            d("div", P8, [
              On(P.$slots, "default")
            ]),
            T.value && e.busyClose ? (f(), h("div", O8, [
              d("p", L8, y(e.busyClose.question), 1),
              d("div", D8, [
                d("button", {
                  ref_key: "keepEl",
                  ref: E,
                  type: "button",
                  class: "fe-btn",
                  "data-testid": "modal-busy-close-keep",
                  onClick: K[0] || (K[0] = (N) => T.value = !1)
                }, y(u(i)("modal.busy_close.keep")), 513),
                d("button", {
                  type: "button",
                  class: "fe-btn fe-btn--danger",
                  "data-testid": "modal-busy-close-confirm",
                  onClick: z
                }, y(e.busyClose.confirm || u(i)("modal.busy_close.confirm")), 1)
              ])
            ])) : O("", !0),
            P.$slots.actions && !e.chromeless && !e.fullbleed && !e.bare ? (f(), h("footer", R8, [
              On(P.$slots, "actions")
            ])) : O("", !0)
          ], 10, C8)
        ], 34)) : O("", !0)
      ]),
      _: 3
    }));
  }
}), N8 = {
  class: "fe-destpick",
  "data-testid": "destpicker"
}, I8 = { class: "fe-destpick__bar" }, B8 = ["disabled", "title", "aria-label"], F8 = ["aria-label"], U8 = ["onClick"], H8 = {
  key: 1,
  class: "fe-destpick__crumb is-current"
}, K8 = {
  class: "fe-destpick__rows",
  "data-testid": "destpicker-rows"
}, V8 = {
  key: 0,
  class: "fe-destpick__note"
}, j8 = {
  key: 1,
  class: "fe-destpick__note"
}, q8 = {
  key: 2,
  class: "fe-destpick__note"
}, W8 = ["disabled", "title", "aria-pressed", "data-testid", "onClick"], Y8 = ["innerHTML"], G8 = { class: "fe-destpick__rowname" }, X8 = {
  key: 0,
  class: "fe-destpick__rowtag",
  "data-testid": "destpicker-vault-tag"
}, J8 = {
  key: 1,
  class: "fe-destpick__rowtag"
}, Z8 = {
  key: 2,
  class: "fe-destpick__rowtag"
}, Q8 = {
  key: 3,
  class: "fe-destpick__rowinto",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, eB = {
  key: 1,
  class: "fe-destpick__target",
  "data-testid": "destpicker-target"
}, tB = ["disabled"], zg = /* @__PURE__ */ lt({
  __name: "DestinationPickerModal",
  props: {
    open: { type: Boolean },
    api: {},
    locale: {},
    storages: {},
    startAt: {},
    moving: {},
    mode: {},
    title: {},
    theme: {},
    pick: {},
    busy: { type: Boolean },
    vaultRoots: {},
    vaultFrom: {}
  },
  emits: ["close", "pick"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = S(Jn), l = S([]), c = S(!1), p = S(void 0), m = S(!1), v = A(() => {
      var fe;
      return (((fe = n.storages) == null ? void 0 : fe.length) ?? 0) > 1;
    }), x = A(() => i("destpicker.drives")), w = A(() => n.pick === "file"), $ = S(null);
    let k = /* @__PURE__ */ new Map();
    const b = S([]);
    function C(fe) {
      const _ = String(fe ?? "").replace(/\/+$/, "");
      _ && !b.value.includes(_) && (b.value = [...b.value, _]);
    }
    function T(fe) {
      return _8(fe, [...n.vaultRoots ?? [], ...b.value]);
    }
    Je(
      () => n.open,
      (fe) => {
        fe && (k = /* @__PURE__ */ new Map(), b.value = [], z(T8(n.startAt, n.storages)));
      },
      { immediate: !0 }
    );
    const E = bi(jc, null);
    async function R(fe) {
      const _ = k.get(fe);
      if (_) return _;
      try {
        let ee = await n.api.index(fe);
        typeof ee.e2e_vault_root == "string" && ee.e2e_vault_root && C(ee.e2e_vault_root);
        for (const Y of ee.files ?? []) Y.type === "dir" && Y.e2e_vault && C(Y.path);
        if (E) {
          const Y = typeof ee.e2e_root == "string" && ee.e2e_root ? ee.e2e_root : null;
          ee = { ...ee, files: await E.decorate(ee.files ?? [], { root: Y }) };
        }
        return k.set(fe, ee), ee;
      } catch {
        return;
      }
    }
    async function z(fe) {
      if (r.value = fe, m.value = !1, $.value = null, fe === Jn) {
        p.value = void 0, l.value = $8(n.storages, n.moving);
        return;
      }
      c.value = !0;
      const _ = await R(fe);
      if (r.value !== fe) return;
      c.value = !1, p.value = _, m.value = !_;
      const ee = T(fe), Y = ee && ee !== (n.vaultFrom ?? null) ? [] : _ == null ? void 0 : _.files;
      l.value = S8(Y, n.moving, { files: w.value }).map((B) => {
        if (B.kind !== "dir") return B;
        const W = T(B.path) === B.path.replace(/\/+$/, ""), F = !B.blocked && x8(B.path, n.vaultFrom ?? null, T);
        return { ...B, vault: W, blocked: F ? "vault" : B.blocked };
      });
    }
    const D = A(() => Ag(r.value, v.value)), U = A(
      () => w8(r.value).map((fe) => ({ ...fe, label: (E == null ? void 0 : E.segmentLabel(fe.path)) ?? fe.label }))
    ), H = A(() => Cg(r.value, n.moving)), L = A(() => (b.value, m$(r.value, n.vaultFrom ?? null, T))), P = A(() => r.value === Jn || !p.value || p.value.read_only ? !1 : h$(p.value.perm)), K = A(() => n.busy || r.value === Jn || L.value ? !1 : w.value ? $.value !== null : P.value && H.value === null), N = A(() => r.value !== Jn && !(w.value && !m.value)), J = A(() => r.value === Jn ? i("destpicker.pick_a_drive") : w.value ? m.value ? i("destpicker.unreadable") : L.value ? i("destpicker.blocked.vault_in") : $.value === null ? i("destpicker.pick_a_file") : "" : H.value === "self" ? i("destpicker.blocked.self") : H.value === "descendant" ? i("destpicker.blocked.descendant") : L.value === "into" ? i("destpicker.blocked.vault_in") : L.value === "out" ? i("destpicker.blocked.vault_out") : m.value ? i("destpicker.unreadable") : p.value && !P.value ? i("destpicker.readonly_here") : ""), j = A(() => n.title ? n.title : n.mode === "move" ? i("destpicker.title.move") : n.mode === "copy" ? i("destpicker.title.copy") : n.mode === "save" ? i("destpicker.title.save") : w.value ? i("destpicker.title.choose_file") : i("destpicker.title.choose")), re = A(() => n.mode === "move" ? i("destpicker.confirm.move") : n.mode === "copy" ? i("destpicker.confirm.copy") : n.mode === "save" ? i("destpicker.confirm.save") : w.value ? i("destpicker.confirm.choose_file") : i("destpicker.confirm.choose")), q = A(
      () => w.value && $.value !== null ? ml($.value, x.value) : ml(r.value, x.value)
    );
    function le(fe) {
      return fe.kind === "file" ? wa({ type: "file", basename: fe.label }) : hx("folder");
    }
    function ve(fe) {
      return fe.kind === "file" ? fe.label : fe.blocked === "self" ? i("destpicker.blocked.self") : fe.blocked === "descendant" ? i("destpicker.blocked.descendant") : fe.blocked === "vault" ? i(n.vaultFrom ? "destpicker.blocked.vault_out" : "destpicker.blocked.vault_in") : fe.writable ? fe.label : i("destpicker.readonly");
    }
    function ce(fe) {
      if (fe.kind === "file") {
        $.value = fe.path;
        return;
      }
      fe.blocked || z(fe.path);
    }
    function se() {
      K.value && a("pick", w.value && $.value !== null ? $.value : r.value);
    }
    return (fe, _) => (f(), Ge(ta, {
      open: e.open,
      title: j.value,
      size: "md",
      locale: e.locale,
      theme: e.theme,
      busy: e.busy,
      onClose: _[3] || (_[3] = (ee) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          onClick: _[2] || (_[2] = (ee) => a("close"))
        }, y(u(i)("destpicker.cancel")), 1),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: !K.value,
          "data-testid": "destpicker-confirm",
          onClick: se
        }, y(re.value), 9, tB)
      ]),
      default: mt(() => [
        d("div", N8, [
          d("div", I8, [
            d("button", {
              type: "button",
              class: "fe-destpick__up",
              disabled: !D.value,
              title: u(i)("destpicker.up"),
              "aria-label": u(i)("destpicker.up"),
              "data-testid": "destpicker-up",
              onClick: _[0] || (_[0] = (ee) => z(D.value))
            }, [..._[4] || (_[4] = [
              d("svg", {
                class: "fe-ficon",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "aria-hidden": "true",
                focusable: "false"
              }, [
                d("path", { d: "M12 19V5M5 12l7-7 7 7" })
              ], -1)
            ])], 8, B8),
            d("nav", {
              class: "fe-destpick__crumbs",
              "aria-label": u(i)("destpicker.crumbs")
            }, [
              v.value ? (f(), h("button", {
                key: 0,
                type: "button",
                class: Re(["fe-destpick__crumb", { "is-current": r.value === u(Jn) }]),
                onClick: _[1] || (_[1] = (ee) => z(u(Jn)))
              }, y(x.value), 3)) : O("", !0),
              (f(!0), h(Te, null, nt(U.value, (ee) => (f(), h(Te, {
                key: ee.path
              }, [
                _[5] || (_[5] = d("span", {
                  class: "fe-destpick__sep",
                  "aria-hidden": "true"
                }, "/", -1)),
                d("button", {
                  type: "button",
                  class: Re(["fe-destpick__crumb", { "is-current": ee.path === r.value }]),
                  onClick: (Y) => z(ee.path)
                }, y(ee.label), 11, U8)
              ], 64))), 128)),
              !v.value && !U.value.length ? (f(), h("span", H8, y(u(ml)(r.value, x.value)), 1)) : O("", !0)
            ], 8, F8)
          ]),
          d("ul", K8, [
            c.value ? (f(), h("li", V8, y(u(i)("destpicker.loading")), 1)) : m.value ? (f(), h("li", j8, y(u(i)("destpicker.unreadable")), 1)) : l.value.length ? O("", !0) : (f(), h("li", q8, y(w.value ? u(i)("destpicker.empty_files") : u(i)("destpicker.empty")), 1)),
            (f(!0), h(Te, null, nt(l.value, (ee) => (f(), h("li", {
              key: ee.path
            }, [
              d("button", {
                type: "button",
                class: Re(["fe-destpick__row", {
                  "is-locked": !ee.writable,
                  "is-blocked": !!ee.blocked,
                  "is-file": ee.kind === "file",
                  "is-picked": ee.kind === "file" && $.value === ee.path
                }]),
                disabled: !!ee.blocked,
                title: ve(ee),
                "aria-pressed": ee.kind === "file" ? $.value === ee.path : void 0,
                "data-testid": "destpicker-row-" + ee.label,
                onClick: (Y) => ce(ee)
              }, [
                d("span", {
                  class: "fe-destpick__rowicon",
                  "aria-hidden": "true",
                  innerHTML: le(ee)
                }, null, 8, Y8),
                d("span", G8, [
                  d("bdi", null, y(ee.label), 1)
                ]),
                ee.vault ? (f(), h("span", X8, y(u(i)("destpicker.tag.vault")), 1)) : O("", !0),
                ee.blocked ? (f(), h("span", J8, y(u(i)("destpicker.tag.blocked")), 1)) : ee.writable ? O("", !0) : (f(), h("span", Z8, y(u(i)("destpicker.readonly")), 1)),
                ee.kind === "dir" ? (f(), h("svg", Q8, [..._[6] || (_[6] = [
                  d("path", { d: "M9 5l7 7-7 7" }, null, -1)
                ])])) : O("", !0)
              ], 10, W8)
            ]))), 128))
          ]),
          J.value ? (f(), h("p", {
            key: 0,
            class: Re(["fe-destpick__reason", { "is-hint": !N.value }]),
            "data-testid": "destpicker-reason"
          }, y(J.value), 3)) : (f(), h("p", eB, y(u(i)("destpicker.target", { name: q.value })), 1))
        ])
      ]),
      _: 1
    }, 8, ["open", "title", "locale", "theme", "busy"]));
  }
}), nB = ["title"], aB = ["disabled"], iB = ["disabled"], oB = /* @__PURE__ */ lt({
  __name: "SurfaceFileChooser",
  props: {
    id: {},
    kind: {},
    modelValue: {},
    locale: {},
    theme: {},
    api: {},
    storages: {},
    startAt: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = S(!1), l = A(() => n.kind === "dir" ? "dir" : "file"), c = A(() => n.modelValue ? ml(n.modelValue, "") || n.modelValue : ""), p = A(() => n.modelValue ? l.value === "dir" ? n.modelValue : Ag(n.modelValue, !1) ?? n.modelValue : n.startAt);
    function m(v) {
      r.value = !1, a("update:modelValue", v);
    }
    return (v, x) => (f(), h("div", {
      class: Re(["fe-sfile", { "is-invalid": e.invalid }]),
      "data-testid": "surface-file-chooser"
    }, [
      d("span", {
        class: Re(["fe-sfile__value", { "fe-sfile__value--empty": !e.modelValue }]),
        title: e.modelValue || void 0,
        "data-testid": "surface-file-chooser-value"
      }, y(c.value || u(i)("plugin.file.none")), 11, nB),
      d("button", {
        type: "button",
        class: "fe-btn fe-btn--sm",
        disabled: e.disabled || !e.api,
        "data-testid": "surface-file-chooser-open",
        onClick: x[0] || (x[0] = (w) => r.value = !0)
      }, y(u(i)("plugin.file.choose")), 9, aB),
      e.modelValue ? (f(), h("button", {
        key: 0,
        type: "button",
        class: "fe-btn fe-btn--sm",
        disabled: e.disabled,
        "data-testid": "surface-file-chooser-clear",
        onClick: x[1] || (x[1] = (w) => a("update:modelValue", ""))
      }, y(u(i)("plugin.file.clear")), 9, iB)) : O("", !0),
      e.api ? (f(), Ge(zg, {
        key: 1,
        open: r.value,
        api: e.api,
        locale: e.locale,
        mode: "choose",
        pick: l.value,
        storages: e.storages,
        "start-at": p.value,
        onClose: x[2] || (x[2] = (w) => r.value = !1),
        onPick: m
      }, null, 8, ["open", "api", "locale", "pick", "storages", "start-at"])) : O("", !0)
    ], 2));
  }
}), rB = ["data-state"], sB = {
  key: 0,
  class: "fe-surface__text fe-surface__text--muted"
}, lB = {
  key: 1,
  class: "fe-surface__text fe-surface__text--muted"
}, uB = ["src", "alt"], cB = ["src"], dB = ["src"], fB = ["src", "type"], pB = ["innerHTML"], hB = ["title"], mB = /* @__PURE__ */ lt({
  __name: "SurfacePreview",
  props: {
    path: {},
    fileRef: {},
    fileUrl: { type: Function },
    locale: {},
    api: {}
  },
  setup(e) {
    const t = e, { t: n } = ht(() => t.locale), a = S(null), i = S(""), r = S("loading");
    let l = 0;
    const c = A(() => t.fileRef && t.fileUrl ? t.fileUrl(t.fileRef) : null), p = A(() => {
      var $;
      return (($ = c.value) == null ? void 0 : $.name) || ml(t.path, "") || t.path || t.fileRef || "";
    }), m = A(() => {
      const $ = i.value;
      return $.startsWith("image/") ? "image" : $.startsWith("video/") ? "video" : $.startsWith("audio/") ? "audio" : "other";
    }), v = A(() => wa({ type: "file", basename: p.value }));
    function x() {
      a.value && a.value.startsWith("blob:") && URL.revokeObjectURL(a.value), a.value = null;
    }
    async function w() {
      const $ = ++l;
      if (x(), i.value = "", t.fileRef) {
        if (!c.value) {
          r.value = "error";
          return;
        }
        a.value = c.value.url, i.value = c.value.mime || "", r.value = "ok";
        return;
      }
      if (!t.api || !t.path) {
        r.value = "error";
        return;
      }
      r.value = "loading";
      try {
        const k = await t.api.fetchBlob(t.path);
        if ($ !== l) {
          URL.revokeObjectURL(k.url);
          return;
        }
        a.value = k.url, i.value = k.mime || "", r.value = "ok";
      } catch {
        if ($ !== l) return;
        r.value = "error";
      }
    }
    return Je([() => t.path, () => t.fileRef], () => void w(), { immediate: !0 }), Tt(() => {
      l++, x();
    }), ($, k) => (f(), h("figure", {
      class: "fe-spreview",
      "data-testid": "surface-preview",
      "data-state": r.value
    }, [
      r.value === "loading" ? (f(), h("p", sB, y(u(n)("plugin.view.loading")), 1)) : r.value === "error" ? (f(), h("p", lB, y(u(n)("plugin.view.preview_failed")), 1)) : (f(), h(Te, { key: 2 }, [
        m.value === "image" && a.value ? (f(), h("img", {
          key: 0,
          class: "fe-spreview__media",
          src: a.value,
          alt: p.value
        }, null, 8, uB)) : m.value === "video" && a.value ? (f(), h("video", {
          key: 1,
          class: "fe-spreview__media",
          src: a.value,
          controls: "",
          preload: "metadata"
        }, null, 8, cB)) : m.value === "audio" && a.value ? (f(), h("audio", {
          key: 2,
          class: "fe-spreview__audio",
          src: a.value,
          controls: "",
          preload: "metadata"
        }, null, 8, dB)) : e.fileRef && a.value ? (f(), h("embed", {
          key: 3,
          class: "fe-spreview__media fe-spreview__embed",
          src: a.value,
          type: i.value || void 0
        }, null, 8, fB)) : (f(), h("span", {
          key: 4,
          class: "fe-spreview__tile",
          "aria-hidden": "true",
          innerHTML: v.value
        }, null, 8, pB))
      ], 64)),
      d("figcaption", {
        class: "fe-spreview__name",
        title: e.path
      }, y(p.value), 9, hB)
    ], 8, rB));
  }
}), vB = ["data-mode", "role", "aria-labelledby"], yB = ["id"], gB = {
  key: 0,
  class: "fe-cfield__req",
  "aria-hidden": "true"
}, bB = {
  key: 1,
  class: "fe-ssig__modes",
  role: "tablist"
}, kB = ["aria-selected", "disabled", "data-testid", "onClick"], wB = ["aria-label"], _B = {
  key: 0,
  class: "fe-ssig__hint"
}, xB = {
  key: 3,
  class: "fe-ssig__typewrap"
}, SB = ["id", "placeholder", "disabled", "value"], $B = ["aria-label"], TB = ["disabled", "title", "aria-pressed", "data-testid", "onClick"], AB = ["src"], EB = {
  key: 4,
  class: "fe-ssig__uploadwrap"
}, CB = { class: "fe-btn fe-btn--sm fe-ssig__pick" }, zB = ["disabled"], MB = { class: "fe-ssig__hint" }, PB = {
  key: 0,
  class: "fe-surface__error",
  role: "alert"
}, OB = ["src"], LB = { class: "fe-ssig__foot" }, DB = ["disabled"], RB = {
  key: 0,
  class: "fe-ssig__signed"
}, v$ = /* @__PURE__ */ lt({
  __name: "SurfaceSignaturePad",
  props: {
    id: {},
    modes: {},
    width: {},
    height: {},
    modelValue: {},
    locale: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    font: {},
    fonts: {},
    label: {},
    required: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = A(() => VR(n.modes)), l = A(() => qR(n.width, n.height)), c = S(ju(n.modelValue) && r.value.includes(n.modelValue.mode) ? n.modelValue.mode : r.value[0]), p = A(() => {
      const se = Array.isArray(n.fonts) ? n.fonts.filter(bc) : [];
      return se.length ? Cl.filter((fe) => se.includes(fe.key)) : Cl;
    });
    function m() {
      const se = p.value.map((_) => _.key), fe = ju(n.modelValue) ? jR(n.modelValue) : void 0;
      return fe && se.includes(fe) ? fe : bc(n.font) && se.includes(n.font) ? n.font : se.includes(cy) ? cy : se[0];
    }
    const v = S(null), x = S(""), w = S(m()), $ = S(""), k = S(""), b = A(() => ju(n.modelValue)), C = A(() => ju(n.modelValue) ? `data:image/png;base64,${n.modelValue.png_b64}` : "");
    function T(se) {
      if (!se) return null;
      try {
        return se.getContext("2d");
      } catch {
        return null;
      }
    }
    function E() {
      return typeof window < "u" && window.devicePixelRatio > 0 ? Math.min(3, window.devicePixelRatio) : 1;
    }
    function R() {
      const se = v.value;
      if (!se) return;
      const fe = E();
      se.width = Math.round(l.value.width * fe), se.height = Math.round(l.value.height * fe);
      const _ = T(se);
      _ && (_.setTransform(1, 0, 0, 1, 0, 0), _.clearRect(0, 0, se.width, se.height), _.scale(fe, fe), _.lineWidth = 2.2, _.lineCap = "round", _.lineJoin = "round", _.strokeStyle = v1);
    }
    let z = !1, D = null;
    function U(se) {
      const fe = v.value, _ = fe == null ? void 0 : fe.getBoundingClientRect();
      if (!fe || !_ || !_.width) return { x: se.clientX, y: se.clientY };
      const ee = l.value.width / _.width, Y = l.value.height / _.height;
      return { x: (se.clientX - _.left) * ee, y: (se.clientY - _.top) * Y };
    }
    function H(se) {
      var _, ee, Y;
      if (n.disabled) return;
      const fe = T(v.value);
      if (fe) {
        z = !0, D = U(se);
        try {
          (ee = (_ = se.target).setPointerCapture) == null || ee.call(_, se.pointerId);
        } catch {
        }
        fe.beginPath(), fe.moveTo(D.x, D.y), fe.lineTo(D.x + 0.1, D.y + 0.1), fe.stroke(), (Y = se.preventDefault) == null || Y.call(se);
      }
    }
    function L(se) {
      var ee;
      if (!z || !D) return;
      const fe = T(v.value);
      if (!fe) return;
      const _ = U(se);
      fe.beginPath(), fe.moveTo(D.x, D.y), fe.lineTo(_.x, _.y), fe.stroke(), D = _, (ee = se.preventDefault) == null || ee.call(se);
    }
    function P() {
      z && (z = !1, D = null, K(v.value, "draw"));
    }
    function K(se, fe) {
      if (!se) return;
      let _ = "";
      try {
        _ = se.toDataURL("image/png");
      } catch {
        _ = "";
      }
      const ee = YR(_);
      ee && (fe !== "draw" && (k.value = _), a("update:modelValue", fe === "type" ? { png_b64: ee, mode: fe, font: w.value } : { png_b64: ee, mode: fe }));
    }
    async function N(se, fe) {
      const _ = document.fonts;
      if (!(!_ || typeof _.load != "function"))
        try {
          await _.load(`${se}px ${fe}`, "Aa");
        } catch {
        }
    }
    async function J() {
      const se = x.value.trim();
      if (!se) {
        k.value = "", a("update:modelValue", null);
        return;
      }
      const fe = JS(w.value).stack;
      if (await N(Math.round(l.value.height * 0.6), fe), x.value.trim() !== se) return;
      const _ = document.createElement("canvas"), ee = 2, { width: Y, height: B } = l.value;
      _.width = Y * ee, _.height = B * ee;
      const W = T(_);
      if (!W) return;
      W.scale(ee, ee), W.fillStyle = v1, W.textBaseline = "middle";
      const F = XR(
        (V) => (W.font = `${V}px ${fe}`, W.measureText(se).width),
        Y - 24,
        B
      );
      W.font = `${F}px ${fe}`, W.fillText(se, 12, B / 2), K(_, "type");
    }
    function j(se) {
      n.disabled || se === w.value || (w.value = se, x.value.trim() && J());
    }
    const re = S(null);
    function q(se) {
      var W;
      const fe = se.target, _ = (W = fe.files) == null ? void 0 : W[0];
      if (fe.value = "", !_) return;
      const ee = GR(_);
      if (ee !== "ok") {
        $.value = ee;
        return;
      }
      $.value = "";
      const Y = URL.createObjectURL(_), B = new Image();
      B.onload = () => {
        URL.revokeObjectURL(Y);
        const F = WR(B.naturalWidth, B.naturalHeight, l$, u$), V = document.createElement("canvas");
        V.width = F.width, V.height = F.height;
        const ke = T(V);
        ke && (ke.drawImage(B, 0, 0, F.width, F.height), K(V, "upload"));
      }, B.onerror = () => {
        URL.revokeObjectURL(Y), $.value = "unreadable";
      }, B.src = Y;
    }
    function le() {
      x.value = "", k.value = "", $.value = "", R(), a("update:modelValue", null);
    }
    function ve(se) {
      se !== c.value && (c.value = se);
    }
    Je(c, async (se) => {
      se === "draw" && (await Gt(), R());
    }), Je(l, () => {
      c.value === "draw" && R();
    }), jt(() => {
      c.value === "draw" && R();
    }), Tt(() => {
      z = !1;
    });
    const ce = A(() => {
      switch ($.value) {
        case "too_big":
          return i("plugin.sig.upload_too_big", { kb: 200 });
        case "bad_type":
          return i("plugin.sig.upload_bad_type");
        case "unreadable":
          return i("plugin.sig.upload_unreadable");
        default:
          return "";
      }
    });
    return (se, fe) => (f(), h("div", {
      class: Re(["fe-ssig", { "is-invalid": e.invalid, "is-disabled": e.disabled }]),
      "data-testid": "surface-signature",
      "data-mode": c.value,
      role: e.label ? "group" : void 0,
      "aria-labelledby": e.label ? `fe-ssig-${e.id}-lbl` : void 0
    }, [
      e.label ? (f(), h("span", {
        key: 0,
        id: `fe-ssig-${e.id}-lbl`,
        class: "fe-cfield__label",
        "data-testid": "surface-signature-label"
      }, [
        Ht(y(e.label), 1),
        e.required ? (f(), h("span", gB, "*")) : O("", !0)
      ], 8, yB)) : O("", !0),
      r.value.length > 1 ? (f(), h("div", bB, [
        (f(!0), h(Te, null, nt(r.value, (_) => (f(), h("button", {
          key: _,
          type: "button",
          class: Re(["fe-btn fe-btn--sm", { "fe-btn--primary": _ === c.value }]),
          role: "tab",
          "aria-selected": _ === c.value ? "true" : "false",
          disabled: e.disabled,
          "data-testid": `surface-signature-mode-${_}`,
          onClick: (ee) => ve(_)
        }, y(u(i)(`plugin.sig.mode_${_}`)), 11, kB))), 128))
      ])) : O("", !0),
      c.value === "draw" ? (f(), h("div", {
        key: 2,
        class: "fe-ssig__padwrap",
        style: Yt({ maxWidth: `${l.value.width}px` })
      }, [
        d("canvas", {
          ref_key: "canvas",
          ref: v,
          class: "fe-ssig__canvas",
          style: Yt({ aspectRatio: `${l.value.width} / ${l.value.height}` }),
          "aria-label": u(i)("plugin.sig.draw_hint"),
          "data-testid": "surface-signature-canvas",
          onPointerdown: H,
          onPointermove: L,
          onPointerup: P,
          onPointercancel: P,
          onPointerleave: P
        }, null, 44, wB),
        b.value ? O("", !0) : (f(), h("p", _B, y(u(i)("plugin.sig.draw_hint")), 1))
      ], 4)) : c.value === "type" ? (f(), h("div", xB, [
        d("input", {
          id: `fe-ssig-${e.id}`,
          class: "fe-cfield__input fe-ssig__typed",
          type: "text",
          placeholder: u(i)("plugin.sig.type_placeholder"),
          disabled: e.disabled,
          value: x.value,
          autocomplete: "name",
          "data-testid": "surface-signature-typed",
          onInput: fe[0] || (fe[0] = (_) => {
            x.value = _.target.value, J();
          })
        }, null, 40, SB),
        p.value.length > 1 ? (f(), h("div", {
          key: 0,
          class: "fe-signfonts",
          role: "group",
          "aria-label": u(i)("plugin.sign.font_label"),
          "data-testid": "surface-signature-fonts"
        }, [
          (f(!0), h(Te, null, nt(p.value, (_) => (f(), h("button", {
            key: _.key,
            type: "button",
            class: Re(["fe-signfonts__btn", [_.className, { "is-on": _.key === w.value }]]),
            disabled: e.disabled,
            title: _.name,
            "aria-pressed": _.key === w.value ? "true" : "false",
            "data-testid": `surface-signature-font-${_.key}`,
            onClick: (ee) => j(_.key)
          }, y(x.value.trim() || _.name), 11, TB))), 128))
        ], 8, $B)) : O("", !0),
        d("div", {
          class: "fe-ssig__preview",
          style: Yt({ maxWidth: `${l.value.width}px`, aspectRatio: `${l.value.width} / ${l.value.height}` })
        }, [
          k.value || C.value ? (f(), h("img", {
            key: 0,
            class: "fe-ssig__img",
            src: k.value || C.value,
            alt: ""
          }, null, 8, AB)) : O("", !0)
        ], 4)
      ])) : (f(), h("div", EB, [
        d("label", CB, [
          d("input", {
            ref_key: "fileInput",
            ref: re,
            type: "file",
            accept: "image/png,image/jpeg",
            class: "fe-ssig__file",
            disabled: e.disabled,
            "data-testid": "surface-signature-file",
            onChange: q
          }, null, 40, zB),
          Ht(" " + y(u(i)("plugin.sig.upload_pick")), 1)
        ]),
        d("p", MB, y(u(i)("plugin.sig.upload_hint", { kb: 200 })), 1),
        ce.value ? (f(), h("p", PB, y(ce.value), 1)) : O("", !0),
        k.value || C.value ? (f(), h("div", {
          key: 1,
          class: "fe-ssig__preview",
          style: Yt({ maxWidth: `${l.value.width}px` })
        }, [
          d("img", {
            class: "fe-ssig__img",
            src: k.value || C.value,
            alt: ""
          }, null, 8, OB)
        ], 4)) : O("", !0)
      ])),
      d("div", LB, [
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--sm",
          disabled: e.disabled || !b.value,
          "data-testid": "surface-signature-clear",
          onClick: le
        }, y(u(i)("plugin.sig.clear")), 9, DB),
        b.value ? (f(), h("span", RB, y(u(i)("plugin.sig.signed")), 1)) : O("", !0)
      ])
    ], 10, vB));
  }
});
async function y$(e) {
  const t = await fetch(e.url, {
    headers: e.headers ?? {},
    credentials: e.credentials ?? "same-origin",
    signal: e.signal
  });
  if (!t.ok) {
    const n = await t.text().catch(() => "");
    throw fa(t.status, n, void 0);
  }
  return t;
}
async function NB(e) {
  return (await y$(e)).arrayBuffer();
}
async function Qpe(e) {
  return (await y$(e)).text();
}
const pp = "filex", IB = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
function Mg(e) {
  const t = String(e ?? "").trim();
  return IB.test(t) ? t.length === 4 ? `#${t[1]}${t[1]}${t[2]}${t[2]}${t[3]}${t[3]}`.toLowerCase() : t.toLowerCase() : "";
}
function BB(e, t) {
  const n = Mg(e);
  if (!n) return "";
  const a = parseInt(n.slice(1), 16), i = (l) => Math.max(0, Math.min(255, Math.round((a >> l & 255) * t))), r = (l) => l.toString(16).padStart(2, "0");
  return `#${r(i(16))}${r(i(8))}${r(i(0))}`;
}
function g$(e) {
  const t = Mg(e);
  if (!t) return "";
  const n = parseInt(t.slice(1), 16), a = (r) => {
    const l = r / 255;
    return l <= 0.04045 ? l / 12.92 : ((l + 0.055) / 1.055) ** 2.4;
  };
  return 0.2126 * a(n >> 16 & 255) + 0.7152 * a(n >> 8 & 255) + 0.0722 * a(n & 255) > 0.42 ? "#0b0f14" : "#ffffff";
}
function b$(e) {
  const t = Mg(e);
  if (!t) return {};
  const n = parseInt(t.slice(1), 16), a = `${n >> 16 & 255}, ${n >> 8 & 255}, ${n & 255}`;
  return {
    "--fe-primary": t,
    "--fe-primary-hover": BB(t, 0.85),
    "--fe-text-on-primary": g$(t),
    // ⚠ The TINT and the ink on it, or the accent only half arrives: the
    // button turned orange while the round badge behind the padlock, the
    // focus ring on the PIN box and the row hover stayed the stock blue
    // (measured on the first after-shot of the restored gate). The old
    // Go-rendered page derived exactly these from the same colour
    // (`--px-accent-soft: rgba(r,g,b,0.14)`, `color: var(--px-accent)`), and
    // a translucent tint is right rather than a solid: it composites onto
    // the card in light and in dark without a second value.
    "--fe-primary-soft": `rgba(${a}, 0.14)`,
    "--fe-primary-ink": t
  };
}
function FB(e = {}) {
  const t = S(null), n = S(!1), a = A(() => {
    var w, $;
    return (($ = (w = t.value) == null ? void 0 : w.name) == null ? void 0 : $.trim()) || pp;
  }), i = A(() => {
    var w, $;
    return !!(($ = (w = t.value) == null ? void 0 : w.name) != null && $.trim()) && a.value !== pp;
  }), r = A(() => {
    var w, $;
    return (($ = (w = t.value) == null ? void 0 : w.logo_url) == null ? void 0 : $.trim()) || "";
  }), l = A(() => {
    var w, $;
    return (($ = (w = t.value) == null ? void 0 : w.footer_text) == null ? void 0 : $.trim()) || "";
  }), c = A(() => {
    var w;
    return ((w = t.value) == null ? void 0 : w.hide_powered_by) === !0;
  }), p = A(() => {
    var $;
    const w = ($ = t.value) == null ? void 0 : $.theme;
    return w === "light" || w === "dark" ? w : "auto";
  }), m = A(() => {
    var w;
    return ((w = t.value) == null ? void 0 : w.locales) ?? [];
  }), v = A(() => {
    var w;
    return b$((w = t.value) == null ? void 0 : w.accent);
  });
  async function x() {
    const w = e.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
    if (!w) return null;
    const $ = Yo(e.base);
    for (const k of ["/api/public/branding", "/api/branding"])
      try {
        const b = await w(`${$}${k}`, {
          method: "GET",
          headers: { Accept: "application/json" },
          credentials: "same-origin"
        });
        if (!b.ok) continue;
        return t.value = await b.json(), n.value = !0, k2(t.value, { base: e.base, fetchImpl: e.fetchImpl }), t.value;
      } catch {
      }
    return null;
  }
  return { branding: t, loaded: n, name: a, whitelabel: i, logo: r, footerText: l, hidePoweredBy: c, themeDefault: p, locales: m, accentStyle: v, load: x };
}
let Xm = null;
function UB(e) {
  return `https://cdn.jsdelivr.net/npm/pdfjs-dist@${e}/legacy/build/pdf.worker.min.mjs`;
}
function HB(e) {
  return Xm || (Xm = (async () => {
    try {
      const t = await import(
        /* @vite-ignore */
        "./pdf-CaPYsOUo.js"
      ), n = t.default ?? t;
      return n.GlobalWorkerOptions && !n.GlobalWorkerOptions.workerSrc && (n.GlobalWorkerOptions.workerSrc = e || UB(n.version || "5.7.284")), n;
    } catch {
      return null;
    }
  })()), Xm;
}
const KB = ["data-testid"], VB = { class: "fe-spdf__propname" }, jB = { class: "fe-spdf__prop" }, qB = ["value", "placeholder", "disabled", "data-testid"], WB = {
  key: 0,
  class: "fe-spdf__prop"
}, YB = ["id", "data-testid"], GB = ["data-testid"], XB = ["id"], JB = { class: "fe-spdf__prop fe-spdf__prop--check" }, ZB = ["checked", "disabled", "data-testid"], QB = { class: "fe-spdf__prop" }, e6 = ["id"], t6 = { class: "fe-spdf__prop" }, n6 = ["value", "disabled", "data-testid"], a6 = { class: "fe-spdf__prop" }, i6 = ["value", "disabled", "data-testid"], o6 = { class: "fe-spdf__prop" }, r6 = ["id"], s6 = { class: "fe-spdf__prop" }, l6 = ["id"], u6 = ["data-testid"], c6 = { class: "fe-spdf__dateex-title" }, d6 = { class: "fe-spdf__dateex-value" }, f6 = {
  key: 4,
  class: "fe-spdf__prop"
}, p6 = ["id"], h6 = ["aria-label", "data-testid"], m6 = ["title", "disabled", "aria-pressed", "data-testid", "onClick"], v6 = ["data-testid"], y6 = ["id"], g6 = ["data-testid"], b6 = { class: "fe-spdf__linepreview-title" }, k6 = {
  key: 1,
  class: "fe-spdf__linepreview-line is-none"
}, w6 = ["disabled", "data-testid"], Jm = "*", w1 = /* @__PURE__ */ lt({
  __name: "PdfFieldEditor",
  props: {
    field: {},
    signers: {},
    formats: {},
    dateLabels: {},
    locale: {},
    disabled: { type: Boolean },
    testidPrefix: {},
    stampLines: {}
  },
  emits: ["patch", "remove"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = A(() => n.testidPrefix || "surface-pdf");
    function l(F) {
      return i(`plugin.pdf.type_${F}`);
    }
    function c(F) {
      const V = { ...n.field };
      F(V), a("patch", V);
    }
    function p(F) {
      c((V) => {
        F ? V.label = F : delete V.label;
      });
    }
    function m(F) {
      c((V) => {
        F ? V.assignee = F : delete V.assignee;
      });
    }
    function v(F) {
      c((V) => {
        F ? V.required = !0 : delete V.required;
      });
    }
    function x(F) {
      c((V) => {
        const ke = ry.includes(F) ? F : "any", qe = { ...V.rule ?? { kind: "any" }, kind: ke };
        ke === "any" && !qe.min && !qe.max ? delete V.rule : V.rule = qe;
      });
    }
    function w(F, V) {
      const ke = Math.trunc(Number(String(V ?? "").trim()));
      c((qe) => {
        const Me = { ...qe.rule ?? { kind: "any" } };
        Number.isFinite(ke) && ke > 0 ? Me[F] = ke : delete Me[F], Me.kind === "any" && !Me.min && !Me.max ? delete qe.rule : qe.rule = Me;
      });
    }
    function $(F) {
      c((V) => {
        F ? V.format = F : delete V.format;
      });
    }
    function k(F) {
      c((V) => {
        V.font = F;
      });
    }
    const b = A(() => QS(n.field.type)), C = A(() => n.field.style ?? "drawn");
    function T(F) {
      c((V) => {
        F === "typed" ? V.style = "typed" : delete V.style;
      });
    }
    const E = A(() => [
      { value: "drawn", label: i("plugin.pdf.style_drawn") },
      { value: "typed", label: i("plugin.pdf.style_typed") }
    ]), R = A(() => n.field.type === "checkbox" ? !1 : b.value ? C.value === "typed" : !0), z = A(() => hR(n.stampLines)), D = A(() => mR(n.field, z.value)), U = A(
      () => z.value.map((F) => ({ value: F.id, label: Xt(F.label, n.locale) || F.id }))
    );
    function H(F) {
      const V = (Array.isArray(F) ? F : [F]).filter(Boolean);
      c((ke) => {
        ke.lines = V;
      });
    }
    const L = A(
      () => D.value.map((F) => z.value.find((V) => V.id === F)).filter((F) => !!F).map((F) => Xt(vR(F, n.field.assignee), n.locale) || Xt(F.label, n.locale))
    ), P = A(() => i(b.value ? "plugin.pdf.assignee" : "plugin.pdf.filled_by")), K = A(() => [
      { value: Jm, label: i("plugin.pdf.unassigned") },
      ...n.signers.map((F) => ({ value: F.id, label: Xt(F.label, n.locale) || F.id }))
    ]), N = A(
      () => ry.map((F) => ({ value: F, label: i(`plugin.pdf.rule_kind_${F}`) }))
    ), J = A(() => kR(n.formats)), j = A(
      () => J.value.map((F) => ({ value: F.id, label: Xt(F.label, n.locale) || F.id, help: F.example }))
    ), re = A(() => {
      var F;
      return n.field.format ?? ((F = J.value[0]) == null ? void 0 : F.id) ?? "";
    }), q = A(() => _R(J.value)), le = A(() => wR(n.dateLabels));
    function ve(F, V) {
      return Jy(le.value[F], n.locale, () => i(V));
    }
    const ce = A(() => xR(J.value, re.value)), se = A(() => {
      var F, V, ke;
      return ((F = ce.value) == null ? void 0 : F.order) ?? ((ke = (V = q.value) == null ? void 0 : V.orders[0]) == null ? void 0 : ke.id) ?? "";
    }), fe = A(() => {
      var F, V, ke;
      return ((F = ce.value) == null ? void 0 : F.separator) ?? ((ke = (V = q.value) == null ? void 0 : V.separators[0]) == null ? void 0 : ke.id) ?? "";
    }), _ = A(
      () => {
        var F;
        return (((F = q.value) == null ? void 0 : F.orders) ?? []).map((V) => ({ value: V.id, label: Xt(V.label, n.locale) || V.id }));
      }
    ), ee = A(
      () => {
        var F;
        return (((F = q.value) == null ? void 0 : F.separators) ?? []).map((V) => ({ value: V.id, label: Xt(V.label, n.locale) || V.id }));
      }
    ), Y = A(() => $R(se.value, fe.value, /* @__PURE__ */ new Date()));
    function B(F) {
      $(f1(J.value, F, fe.value));
    }
    function W(F) {
      $(f1(J.value, se.value, F));
    }
    return (F, V) => {
      var ke, qe, Me;
      return f(), h("div", {
        class: "fe-spdf__props",
        "data-testid": `${r.value}-editor`
      }, [
        d("span", VB, y(l(e.field.type)), 1),
        d("label", jB, [
          d("span", null, y(u(i)("plugin.pdf.label")), 1),
          d("input", {
            class: "fe-cfield__input fe-spdf__name",
            type: "text",
            value: e.field.label ?? "",
            placeholder: l(e.field.type),
            disabled: e.disabled,
            "data-testid": `${r.value}-label`,
            onInput: V[0] || (V[0] = (Fe) => p(Fe.target.value))
          }, null, 40, qB)
        ]),
        e.signers.length ? (f(), h("div", WB, [
          d("span", {
            id: `${r.value}-${e.field.id}-assignee-lbl`,
            "data-testid": `${r.value}-assignee-label`
          }, y(P.value), 9, YB),
          Ze(mi, {
            options: K.value,
            "model-value": e.field.assignee || Jm,
            disabled: e.disabled,
            "aria-labelledby": `${r.value}-${e.field.id}-assignee-lbl`,
            "testid-prefix": `${r.value}-assignee`,
            "onUpdate:modelValue": V[1] || (V[1] = (Fe) => m(String(Fe) === Jm ? "" : String(Fe)))
          }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
        ])) : O("", !0),
        b.value ? (f(), h("div", {
          key: 1,
          class: "fe-spdf__prop",
          "data-testid": `${r.value}-style`
        }, [
          d("span", {
            id: `${r.value}-${e.field.id}-style-lbl`
          }, y(u(i)("plugin.pdf.style")), 9, XB),
          Ze(mi, {
            options: E.value,
            "model-value": C.value,
            disabled: e.disabled,
            "aria-labelledby": `${r.value}-${e.field.id}-style-lbl`,
            "testid-prefix": `${r.value}-style`,
            "onUpdate:modelValue": V[2] || (V[2] = (Fe) => T(String(Fe)))
          }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
        ], 8, GB)) : O("", !0),
        d("label", JB, [
          d("input", {
            type: "checkbox",
            checked: e.field.required === !0,
            disabled: e.disabled,
            "data-testid": `${r.value}-required`,
            onChange: V[3] || (V[3] = (Fe) => v(Fe.target.checked))
          }, null, 40, ZB),
          d("span", null, y(u(i)("plugin.pdf.required")), 1)
        ]),
        e.field.type === "text" ? (f(), h(Te, { key: 2 }, [
          d("div", QB, [
            d("span", {
              id: `${r.value}-${e.field.id}-rule-lbl`
            }, y(u(i)("plugin.pdf.rule")), 9, e6),
            Ze(mi, {
              options: N.value,
              "model-value": ((ke = e.field.rule) == null ? void 0 : ke.kind) ?? "any",
              disabled: e.disabled,
              "aria-labelledby": `${r.value}-${e.field.id}-rule-lbl`,
              "testid-prefix": `${r.value}-rule`,
              "onUpdate:modelValue": V[4] || (V[4] = (Fe) => x(String(Fe)))
            }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
          ]),
          d("label", t6, [
            d("span", null, y(u(i)("plugin.pdf.rule_min_label")), 1),
            d("input", {
              class: "fe-cfield__input fe-spdf__num",
              type: "number",
              min: "0",
              value: ((qe = e.field.rule) == null ? void 0 : qe.min) ?? "",
              disabled: e.disabled,
              "data-testid": `${r.value}-rule-min`,
              onInput: V[5] || (V[5] = (Fe) => w("min", Fe.target.value))
            }, null, 40, n6)
          ]),
          d("label", a6, [
            d("span", null, y(u(i)("plugin.pdf.rule_max_label")), 1),
            d("input", {
              class: "fe-cfield__input fe-spdf__num",
              type: "number",
              min: "0",
              value: ((Me = e.field.rule) == null ? void 0 : Me.max) ?? "",
              disabled: e.disabled,
              "data-testid": `${r.value}-rule-max`,
              onInput: V[6] || (V[6] = (Fe) => w("max", Fe.target.value))
            }, null, 40, i6)
          ])
        ], 64)) : O("", !0),
        e.field.type === "date" && q.value ? (f(), h(Te, { key: 3 }, [
          d("div", o6, [
            d("span", {
              id: `${r.value}-${e.field.id}-order-lbl`
            }, y(ve("order", "plugin.pdf.date_order")), 9, r6),
            Ze(mi, {
              options: _.value,
              "model-value": se.value,
              disabled: e.disabled,
              "aria-labelledby": `${r.value}-${e.field.id}-order-lbl`,
              "testid-prefix": `${r.value}-order`,
              "onUpdate:modelValue": V[7] || (V[7] = (Fe) => B(String(Fe)))
            }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
          ]),
          d("div", s6, [
            d("span", {
              id: `${r.value}-${e.field.id}-sep-lbl`
            }, y(ve("separator", "plugin.pdf.date_separator")), 9, l6),
            Ze(mi, {
              options: ee.value,
              "model-value": fe.value,
              disabled: e.disabled,
              "aria-labelledby": `${r.value}-${e.field.id}-sep-lbl`,
              "testid-prefix": `${r.value}-sep`,
              "onUpdate:modelValue": V[8] || (V[8] = (Fe) => W(String(Fe)))
            }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
          ]),
          d("p", {
            class: "fe-spdf__dateex",
            "data-testid": `${r.value}-date-example`
          }, [
            d("span", c6, y(ve("example", "plugin.pdf.date_example")), 1),
            d("bdi", d6, y(Y.value), 1)
          ], 8, u6)
        ], 64)) : e.field.type === "date" && j.value.length ? (f(), h("div", f6, [
          d("span", {
            id: `${r.value}-${e.field.id}-format-lbl`
          }, y(u(i)("plugin.pdf.format")), 9, p6),
          Ze(mi, {
            options: j.value,
            "model-value": re.value,
            disabled: e.disabled,
            "aria-labelledby": `${r.value}-${e.field.id}-format-lbl`,
            "testid-prefix": `${r.value}-format`,
            "onUpdate:modelValue": V[9] || (V[9] = (Fe) => $(String(Fe)))
          }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
        ])) : O("", !0),
        R.value ? (f(), h("div", {
          key: 5,
          class: "fe-signfonts fe-spdf__prop",
          role: "group",
          "aria-label": u(i)("plugin.pdf.font"),
          "data-testid": `${r.value}-fonts`
        }, [
          (f(!0), h(Te, null, nt(u(Cl), (Fe) => (f(), h("button", {
            key: Fe.key,
            type: "button",
            class: Re(["fe-signfonts__btn", [Fe.className, { "is-on": (e.field.font ?? "caveat") === Fe.key }]]),
            title: Fe.name,
            disabled: e.disabled,
            "aria-pressed": (e.field.font ?? "caveat") === Fe.key ? "true" : "false",
            "data-testid": `${r.value}-font-${Fe.key}`,
            onClick: (We) => k(Fe.key)
          }, " Aa ", 10, m6))), 128))
        ], 8, h6)) : O("", !0),
        b.value && U.value.length ? (f(), h("div", {
          key: 6,
          class: "fe-spdf__prop fe-spdf__lines",
          "data-testid": `${r.value}-lines`
        }, [
          d("span", {
            id: `${r.value}-${e.field.id}-lines-lbl`
          }, y(u(i)("plugin.pdf.lines")), 9, y6),
          Ze(mi, {
            options: U.value,
            "model-value": D.value,
            multi: "",
            disabled: e.disabled,
            "aria-labelledby": `${r.value}-${e.field.id}-lines-lbl`,
            "testid-prefix": `${r.value}-line`,
            "onUpdate:modelValue": H
          }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"]),
          d("div", {
            class: "fe-spdf__linepreview",
            "data-testid": `${r.value}-lines-preview`
          }, [
            d("span", b6, y(u(i)("plugin.pdf.lines_preview")), 1),
            L.value.length ? (f(!0), h(Te, { key: 0 }, nt(L.value, (Fe, We) => (f(), h("span", {
              key: We,
              class: "fe-spdf__linepreview-line"
            }, y(Fe), 1))), 128)) : (f(), h("span", k6, y(u(i)("plugin.pdf.lines_none")), 1))
          ], 8, g6)
        ], 8, v6)) : O("", !0),
        On(F.$slots, "extra"),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--sm fe-btn--danger",
          disabled: e.disabled,
          "data-testid": `${r.value}-delete`,
          onClick: V[10] || (V[10] = (Fe) => a("remove"))
        }, y(u(i)("plugin.pdf.delete")), 9, w6)
      ], 8, KB);
    };
  }
}), _6 = ["data-state", "data-layout"], x6 = {
  key: 0,
  class: "fe-spdf__bar"
}, S6 = ["aria-label"], $6 = ["disabled", "aria-pressed", "data-testid", "onClick"], T6 = {
  key: 0,
  class: "fe-spdf__done",
  "data-testid": "surface-pdf-all-placed"
}, A6 = ["aria-label"], E6 = ["disabled", "aria-pressed", "data-testid", "onClick"], C6 = { class: "fe-spdf__zoom" }, z6 = ["aria-label", "disabled"], M6 = ["aria-label", "disabled"], P6 = ["aria-label", "disabled"], O6 = {
  key: 1,
  class: "fe-surface__text fe-surface__text--info fe-spdf__hint"
}, L6 = {
  key: 2,
  class: "fe-spdf__define",
  "data-testid": "surface-pdf-define"
}, D6 = {
  key: 0,
  class: "fe-spdf__empty",
  "data-testid": "surface-pdf-no-boxes"
}, R6 = ["data-testid"], N6 = {
  class: "fe-spdf__cardno",
  "aria-hidden": "true"
}, I6 = ["aria-label"], B6 = { class: "fe-spdf__addlbl" }, F6 = ["disabled", "data-testid", "onClick"], U6 = {
  key: 3,
  class: "fe-spdf__strip",
  "data-testid": "surface-pdf-strip"
}, H6 = {
  key: 0,
  class: "fe-spdf__props",
  "data-testid": "surface-pdf-selected"
}, K6 = {
  key: 0,
  class: "fe-spdf__propwho"
}, V6 = {
  key: 1,
  class: "fe-spdf__prop"
}, j6 = ["max"], q6 = {
  key: 1,
  class: "fe-surface__text fe-surface__text--info fe-spdf__hint",
  "data-testid": "surface-pdf-place-hint"
}, W6 = {
  key: 2,
  class: "fe-surface__text fe-surface__text--muted fe-spdf__hint",
  "data-testid": "surface-pdf-idle-hint"
}, Y6 = {
  key: 4,
  "data-testid": "surface-pdf-selected"
}, G6 = {
  key: 0,
  class: "fe-spdf__prop"
}, X6 = ["max"], J6 = {
  key: 0,
  class: "fe-surface__text fe-surface__text--muted"
}, Z6 = {
  key: 1,
  class: "fe-surface__unknown",
  role: "alert",
  "data-testid": "surface-pdf-error"
}, Q6 = {
  key: 2,
  class: "fe-spdf__pages"
}, eF = ["data-page", "onPointerdown"], tF = ["data-testid", "data-field-type", "role", "tabindex", "title", "onPointerdown", "onClick", "onKeydown"], nF = ["src"], aF = ["value", "placeholder", "aria-label", "inputmode", "maxlength", "aria-invalid", "aria-describedby", "title", "disabled", "data-testid", "onInput"], iF = ["innerHTML"], oF = {
  key: 4,
  class: "fe-spdf__label"
}, rF = {
  key: 0,
  class: "fe-spdf__who"
}, sF = {
  key: 1,
  class: "fe-spdf__who"
}, lF = ["id", "role", "data-testid"], uF = ["onPointerdown"], cF = {
  key: 6,
  class: "fe-spdf__pad",
  "data-testid": "surface-pdf-pad"
}, dF = { class: "fe-surface__text fe-surface__text--muted" }, fF = /* @__PURE__ */ lt({
  __name: "SurfacePdfFields",
  props: {
    id: {},
    src: {},
    mode: {},
    fields: {},
    signers: {},
    signer: {},
    types: {},
    formats: {},
    dateLabels: {},
    modelValue: {},
    locale: {},
    theme: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    api: {},
    fileUrl: { type: Function },
    pdfWorkerUrl: {},
    layout: {},
    pageHeight: {},
    stampLines: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = A(() => n.mode !== "fill"), l = A(() => n.mode === "define"), c = A(() => n.mode === "place"), p = A(() => TR(n.signers)), m = A(() => yR(n.types)), v = S([]);
    let x;
    function w() {
      r.value ? v.value = Array.isArray(n.modelValue) ? Of(n.modelValue) : Of(n.fields) : v.value = ER(Of(n.fields), n.modelValue);
    }
    function $() {
      const me = r.value ? v.value.map((Le) => ({ ...Le })) : a$(v.value, n.signer);
      x = me, a("update:modelValue", me);
    }
    let k = !1;
    function b() {
      if (ie) {
        k = !0;
        return;
      }
      w();
    }
    w(), Je([() => n.fields, () => n.mode, () => n.signer], () => b()), Je(
      () => n.modelValue,
      (me) => {
        me !== x && b();
      }
    );
    const C = A(() => {
      const me = /* @__PURE__ */ new Map();
      for (const Le of v.value) {
        if (!sy(Le)) continue;
        const Ue = me.get(Le.page) ?? [];
        Ue.push(Le), me.set(Le.page, Ue);
      }
      return me;
    });
    function T(me) {
      return AR(p.value, me.assignee);
    }
    function E(me) {
      const Le = T(me), Ue = g$(Le);
      return Ue ? { "--spdf-color": Le, "--spdf-ink": Ue } : { "--spdf-color": Le };
    }
    function R(me) {
      const Le = p.value.find((Ue) => Ue.id === me);
      return Le ? Xt(Le.label, n.locale) || Le.id : me || "";
    }
    function z(me) {
      return !r.value && n$(me, n.signer);
    }
    function D(me) {
      return i(`plugin.pdf.type_${me}`);
    }
    function U(me) {
      const Le = (me.label ?? "").trim();
      if (Le) return Le;
      const Ue = v.value.filter((He) => He.type === me.type && !(He.label ?? "").trim());
      return Ue.length < 2 ? D(me.type) : `${D(me.type)} ${Ue.findIndex((He) => He.id === me.id) + 1}`;
    }
    const H = S("loading"), L = S([]), P = S(1), K = S(null), N = S(640), J = S(0), j = A(() => n.layout === "page");
    let re = null, q = 0, le = null, ve = null;
    const ce = /* @__PURE__ */ new Map(), se = /* @__PURE__ */ new Map(), fe = /* @__PURE__ */ new Map(), _ = A(() => {
      if (!j.value) return N.value;
      const me = L.value[0];
      return me ? lR({ width: N.value, height: J.value }, me) : N.value;
    }), ee = A(() => Math.max(120, Math.round(_.value * P.value)));
    async function Y() {
      var Ue, He;
      const me = n.src ?? {};
      if (me.path) {
        if (!n.api) throw new Error("no api");
        const xt = await n.api.fetchBlob(me.path);
        return URL.revokeObjectURL(xt.url), xt.blob.arrayBuffer();
      }
      const Le = me.url || (me.ref ? (He = (Ue = n.fileUrl) == null ? void 0 : Ue.call(n, me.ref)) == null ? void 0 : He.url : "");
      if (!Le) throw new Error("no source");
      return NB({ url: Le, headers: {}, credentials: "same-origin" });
    }
    async function B() {
      var Le, Ue;
      const me = ++q;
      H.value = "loading", L.value = [], W();
      try {
        (Le = re == null ? void 0 : re.destroy) == null || Le.call(re);
      } catch {
      }
      re = null;
      try {
        const He = await HB(n.pdfWorkerUrl ?? void 0);
        if (!He) throw new Error("pdfjs unavailable");
        const xt = await Y();
        if (me !== q) return;
        const Qe = await He.getDocument({ data: xt }).promise;
        if (me !== q) {
          (Ue = Qe.destroy) == null || Ue.call(Qe);
          return;
        }
        re = Qe;
        const ue = [];
        for (let je = 1; je <= Qe.numPages; je++) {
          const It = (await Qe.getPage(je)).getViewport({ scale: 1 });
          ue.push({ num: je, width: It.width, height: It.height, rotation: It.rotation ?? 0 });
        }
        if (me !== q) return;
        L.value = ue, H.value = "ok", await Gt(), V();
      } catch {
        if (me !== q) return;
        H.value = "error";
      }
    }
    function W() {
      le == null || le.disconnect(), le = null, ce.clear(), se.clear(), fe.clear();
    }
    function F(me, Le) {
      if (!(Le instanceof HTMLDivElement)) return;
      const Ue = ce.get(me);
      Ue !== Le && (Ue && (le == null || le.unobserve(Ue)), ce.set(me, Le), re && (le ? le.observe(Le) : typeof IntersectionObserver > "u" && ke(me), Ue && (se.delete(me), fe.delete(me))));
    }
    function V() {
      if (typeof IntersectionObserver > "u") {
        for (const me of ce.keys()) ke(me);
        return;
      }
      le = new IntersectionObserver(
        (me) => {
          for (const Le of me) {
            const Ue = Number(Le.target.dataset.page);
            Le.isIntersecting && ke(Ue);
          }
        },
        { rootMargin: "200px 0px" }
      );
      for (const me of ce.values()) le.observe(me);
    }
    async function ke(me) {
      if (!re || !ce.get(me)) return;
      const Ue = ee.value;
      if (se.get(me) === Ue) return;
      se.set(me, Ue);
      const He = L.value.find((je) => je.num === me);
      if (!He) return;
      const xt = typeof window < "u" && window.devicePixelRatio > 0 ? Math.min(3, window.devicePixelRatio) : 1, Qe = Ue / He.width * xt, ue = re;
      try {
        const je = await ue.getPage(me), dt = je.getViewport({ scale: Qe }), It = document.createElement("canvas");
        It.className = "fe-spdf__canvas", It.width = Math.round(dt.width), It.height = Math.round(dt.height);
        const hn = It.getContext("2d");
        if (!hn || (await je.render({ canvasContext: hn, viewport: dt }).promise, ue !== re || se.get(me) !== Ue)) return;
        const nn = ce.get(me);
        if (!nn) return;
        const ae = fe.get(me);
        ae && ae.parentNode === nn ? nn.replaceChild(It, ae) : nn.prepend(It), fe.set(me, It);
      } catch {
        se.get(me) === Ue && se.delete(me);
      }
    }
    function qe() {
      for (const me of ce.keys())
        se.has(me) && (se.delete(me), ke(me));
    }
    Je(ee, () => qe());
    function Me() {
      P.value = Math.min(3, Math.round(P.value * 1.25 * 100) / 100);
    }
    function Fe() {
      P.value = Math.max(0.5, Math.round(P.value / 1.25 * 100) / 100);
    }
    function We() {
      P.value = 1;
    }
    function $t() {
      const me = K.value;
      me && (N.value = me.clientWidth || N.value, J.value = me.clientHeight || J.value, !(typeof ResizeObserver > "u") && (ve == null || ve.disconnect(), ve = new ResizeObserver(() => St()), ve.observe(me)));
    }
    function St() {
      var Ue, He;
      if (ie) {
        at = !0;
        return;
      }
      const me = ((Ue = K.value) == null ? void 0 : Ue.clientWidth) ?? 0, Le = ((He = K.value) == null ? void 0 : He.clientHeight) ?? 0;
      me > 0 && Math.abs(me - N.value) > 2 && (N.value = me), Le > 0 && Math.abs(Le - J.value) > 2 && (J.value = Le);
    }
    let at = !1;
    Je(K, () => {
      Gt($t);
    }), jt(() => {
      $t(), B();
    });
    const kt = A(() => {
      const me = n.src ?? {};
      return [me.ref ?? "", me.path ?? "", me.url ?? ""].join("\0");
    });
    Je(kt, () => void B()), Tt(() => {
      var me;
      q++, W(), ve == null || ve.disconnect();
      try {
        (me = re == null ? void 0 : re.destroy) == null || me.call(re);
      } catch {
      }
      re = null;
    });
    const pt = S(""), Ne = S("");
    let ie = null;
    const xe = S(null);
    function he(me, Le) {
      const Ue = Le.getBoundingClientRect();
      return u1({ x: me.clientX - Ue.left, y: me.clientY - Ue.top }, { width: Ue.width, height: Ue.height });
    }
    function De(me) {
      const Le = ce.get(me.page), Ue = Le && Le.isConnected ? Le : me.el;
      if (!Ue || !Ue.isConnected) return null;
      const He = Ue.getBoundingClientRect();
      return He.width >= 1 && He.height >= 1 ? He : null;
    }
    function ot(me, Le) {
      return u1({ x: me.clientX - Le.left, y: me.clientY - Le.top }, { width: Le.width, height: Le.height });
    }
    function ft(me) {
      Ne.value = Ne.value === me ? "" : me, pt.value = "";
    }
    function gt(me) {
      const Le = bR(v.value, me, {
        assignee: Pe(),
        required: !0
      });
      v.value = [...v.value, Le], $();
    }
    function Ut(me) {
      v.value = v.value.map((Le) => Le.id === me.id ? me : Le), $();
    }
    function Xe(me) {
      v.value = v.value.filter((Le) => Le.id !== me), pt.value === me && (pt.value = ""), $();
    }
    const Ve = A(() => gR(v.value)), Be = S("");
    function ne(me) {
      Be.value = Be.value === me ? "" : me, pt.value = "";
    }
    function ge(me, Le) {
      const Ue = Be.value;
      Ue && (v.value = v.value.map((He) => {
        if (He.id !== Ue) return He;
        const xt = { ...He, page: me, ...hl(Le) };
        return delete xt.placed, xt;
      }), Be.value = "", pt.value = Ue, $());
    }
    function G() {
      const me = pt.value;
      me && (v.value = v.value.map((Le) => Le.id === me ? { ...Le, placed: !1 } : Le), pt.value = "", $());
    }
    function ye(me) {
      const Le = R(me.assignee), Ue = U(me);
      return Le ? `${Ue} · ${Le}` : Ue;
    }
    function te(me, Le) {
      var He, xt;
      if (!r.value || n.disabled) return;
      const Ue = me.currentTarget;
      if (c.value && Be.value) {
        ie = { kind: "place", page: Le, el: Ue, start: he(me, Ue) }, xe.value = null, Et(), (He = me.preventDefault) == null || He.call(me);
        return;
      }
      if (Ne.value) {
        ie = { kind: "place", page: Le, el: Ue, start: he(me, Ue) }, xe.value = null, Et(), (xt = me.preventDefault) == null || xt.call(me);
        return;
      }
      pt.value = "";
    }
    function Ce(me, Le, Ue) {
      var xt;
      if (!r.value || n.disabled) return;
      const He = me.currentTarget.closest(".fe-spdf__page");
      He && (pt.value = Le.id, Ne.value = "", ie = { kind: "move", page: Ue, el: He, start: he(me, He), id: Le.id, orig: { ...Le } }, Et(), me.stopPropagation(), (xt = me.preventDefault) == null || xt.call(me));
    }
    function Ie(me, Le, Ue) {
      var xt;
      if (!r.value || n.disabled) return;
      const He = me.currentTarget.closest(".fe-spdf__page");
      He && (pt.value = Le.id, ie = { kind: "resize", page: Ue, el: He, start: he(me, He), id: Le.id, orig: { ...Le } }, Et(), me.stopPropagation(), (xt = me.preventDefault) == null || xt.call(me));
    }
    function _e(me) {
      if (!ie) return;
      const Le = De(ie);
      if (!Le) return;
      const Ue = ot(me, Le);
      if (ie.kind === "place") {
        const dt = df(ie.start, Ue);
        xe.value = { page: ie.page, ...dt };
        return;
      }
      if (!ie.id || !ie.orig) return;
      const He = Ue.x - ie.start.x, xt = Ue.y - ie.start.y, Qe = ie.orig, ue = ie.kind === "move" ? hl({ x: Qe.x + He, y: Qe.y + xt, w: Qe.w, h: Qe.h }) : hl({ x: Qe.x, y: Qe.y, w: Qe.w + He, h: Qe.h + xt }), je = ie.id;
      v.value = v.value.map((dt) => dt.id === je ? { ...dt, ...ue } : dt);
    }
    function Ae(me) {
      if (!ie) return;
      const Le = ie;
      ie = null, xn();
      const Ue = De(Le);
      at && (at = !1, St());
      const He = Le.kind === "place" || Le.kind === "move" || Le.kind === "resize";
      if (k && (k = !1, He || w()), !Ue) {
        xe.value = null, (Le.kind === "move" || Le.kind === "resize") && $();
        return;
      }
      if (Le.kind === "place" && c.value && Be.value) {
        const xt = ot(me, Ue), Qe = v.value.find((dt) => dt.id === Be.value), je = Math.abs(xt.x - Le.start.x) > 0.01 || Math.abs(xt.y - Le.start.y) > 0.01 ? df(Le.start, xt) : { x: xt.x - ((Qe == null ? void 0 : Qe.w) ?? 0.2) / 2, y: xt.y - ((Qe == null ? void 0 : Qe.h) ?? 0.05) / 2, w: (Qe == null ? void 0 : Qe.w) ?? 0.2, h: (Qe == null ? void 0 : Qe.h) ?? 0.05 };
        ge(Le.page, je), xe.value = null;
        return;
      }
      if (Le.kind === "place" && Ne.value) {
        const xt = ot(me, Ue), Qe = Math.abs(xt.x - Le.start.x) > 0.01 || Math.abs(xt.y - Le.start.y) > 0.01, ue = Ne.value, je = Qe ? p1(v.value, ue, Le.page, df(Le.start, xt), df(Le.start, xt), Pe()) : p1(v.value, ue, Le.page, { x: xt.x - fp[ue].w / 2, y: xt.y - fp[ue].h / 2 }, void 0, Pe());
        v.value = [...v.value, { ...je, label: D(ue) }], pt.value = je.id, xe.value = null, $();
        return;
      }
      if (xe.value = null, Le.kind === "move" || Le.kind === "resize") {
        const xt = v.value.find((ue) => ue.id === Le.id), Qe = Le.orig;
        (!xt || !Qe || xt.x !== Qe.x || xt.y !== Qe.y || xt.w !== Qe.w || xt.h !== Qe.h) && $();
      }
    }
    function Pe() {
      return p.value.length === 1 ? p.value[0].id : void 0;
    }
    const _t = S(!1);
    function Et() {
      _t.value = !0, window.addEventListener("pointermove", _e), window.addEventListener("pointerup", Ae), window.addEventListener("pointercancel", Ae);
    }
    function xn() {
      _t.value = !1, window.removeEventListener("pointermove", _e), window.removeEventListener("pointerup", Ae), window.removeEventListener("pointercancel", Ae);
    }
    const Dt = A(() => v.value.find((me) => me.id === pt.value) ?? null), bn = S(1);
    function ln() {
      if (!Dt.value) return;
      const me = v.value.length;
      v.value = zR(v.value, pt.value, bn.value), v.value.length !== me && (pt.value = v.value[v.value.length - 1].id, $());
    }
    function Jt() {
      const me = K.value, Le = Dt.value;
      if (!me || !Le || ie || !sy(Le)) return;
      const Ue = ce.get(Le.page);
      if (!Ue) return;
      const He = Ue.getBoundingClientRect(), xt = me.getBoundingClientRect();
      if (!He.height || !xt.height) return;
      const Qe = He.top - xt.top + me.scrollTop + Le.y * He.height, ue = Qe + Le.h * He.height, je = 24;
      Qe < me.scrollTop + je ? me.scrollTop = Math.max(0, Qe - je) : ue > me.scrollTop + me.clientHeight - je && (me.scrollTop = ue - me.clientHeight + je);
    }
    Je(pt, () => void Gt(Jt));
    const Ln = S("");
    function Vn(me, Le) {
      v.value = CR(v.value, me, Le), $();
    }
    function Ft(me) {
      if (!(r.value || n.disabled || !z(me)))
        switch (me.type) {
          case "signature":
          case "initials":
            Ln.value = Ln.value === me.id ? "" : me.id;
            break;
          case "checkbox":
            Vn(me.id, me.value !== !0);
            break;
          case "date":
            Vn(me.id, ly(me) ? "" : MR());
            break;
        }
    }
    function na(me, Le) {
      const Ue = Le.target, He = fR(Ue.value, mn(me));
      He !== Ue.value && (Ue.value = He), Vn(me.id, He);
    }
    const Kt = A(() => v.value.find((me) => me.id === Ln.value) ?? null), bt = A(() => {
      var me;
      return ((me = Kt.value) == null ? void 0 : me.style) === "typed" ? ["type"] : ["draw", "upload"];
    }), Dn = A(
      () => {
        var me;
        return ((me = Kt.value) == null ? void 0 : me.style) === "typed" && Kt.value.font ? [Kt.value.font] : void 0;
      }
    ), Nn = A(() => {
      var Le;
      const me = (Le = Kt.value) == null ? void 0 : Le.value;
      return typeof me == "string" && me ? { png_b64: me, mode: "draw" } : null;
    });
    function Cn(me) {
      Kt.value && Vn(Kt.value.id, (me == null ? void 0 : me.png_b64) ?? "");
    }
    function fn(me) {
      return typeof me.value == "string" && me.value ? `data:image/png;base64,${me.value}` : "";
    }
    function mn(me) {
      return me.type === "text" ? me.rule ?? null : null;
    }
    function aa(me) {
      const Le = mn(me);
      if (!Le) return "";
      const Ue = [];
      return Le.kind === "number" ? Ue.push(i("plugin.pdf.rule_number")) : Le.kind === "email" && Ue.push(i("plugin.pdf.rule_email")), Le.min && Le.max ? Ue.push(i("plugin.pdf.rule_length", { min: Le.min, max: Le.max })) : Le.min ? Ue.push(i("plugin.pdf.rule_min", { min: Le.min })) : Le.max && Ue.push(i("plugin.pdf.rule_max", { max: Le.max })), Ue.join(" · ");
    }
    function zn(me) {
      const Le = mn(me), Ue = pR(me.value, Le);
      return !Ue || !Le ? "" : Ue === "min" ? i("plugin.pdf.err_min", { min: Le.min ?? 0 }) : Ue === "max" ? i("plugin.pdf.err_max", { max: Le.max ?? 0 }) : i(`plugin.pdf.err_${Ue}`);
    }
    function Mn(me) {
      return JS(me.font).className;
    }
    const rn = zt("check");
    return (me, Le) => (f(), h("div", {
      class: Re(["fe-spdf", {
        "is-edit": r.value,
        "is-fill": !r.value,
        "is-invalid": e.invalid,
        "is-disabled": e.disabled,
        "is-placing": !!Ne.value || !!Be.value,
        "is-define": l.value,
        "fe-spdf--page": j.value && !l.value
      }]),
      "data-testid": "surface-pdf-fields",
      style: Yt(j.value ? { "--spdf-h": e.pageHeight || "100%" } : void 0),
      "data-state": H.value,
      "data-layout": j.value ? "page" : "inline"
    }, [
      l.value ? O("", !0) : (f(), h("div", x6, [
        c.value ? (f(), h("div", {
          key: 0,
          class: "fe-spdf__palette",
          role: "toolbar",
          "aria-label": u(i)("plugin.pdf.pending")
        }, [
          (f(!0), h(Te, null, nt(Ve.value, (Ue) => (f(), h("button", {
            key: Ue.id,
            type: "button",
            class: Re(["fe-btn fe-btn--sm", { "fe-btn--primary": Be.value === Ue.id }]),
            style: Yt({ "--spdf-color": T(Ue) }),
            disabled: e.disabled || H.value !== "ok",
            "aria-pressed": Be.value === Ue.id ? "true" : "false",
            "data-testid": `surface-pdf-pending-${Ue.id}`,
            onClick: (He) => ne(Ue.id)
          }, y(ye(Ue)), 15, $6))), 128)),
          Ve.value.length ? O("", !0) : (f(), h("span", T6, y(u(i)("plugin.pdf.all_placed")), 1))
        ], 8, S6)) : r.value ? (f(), h("div", {
          key: 1,
          class: "fe-spdf__palette",
          role: "toolbar",
          "aria-label": u(i)("plugin.pdf.palette")
        }, [
          (f(!0), h(Te, null, nt(m.value, (Ue) => (f(), h("button", {
            key: Ue,
            type: "button",
            class: Re(["fe-btn fe-btn--sm", { "fe-btn--primary": Ne.value === Ue }]),
            disabled: e.disabled || H.value !== "ok",
            "aria-pressed": Ne.value === Ue ? "true" : "false",
            "data-testid": `surface-pdf-type-${Ue}`,
            onClick: (He) => ft(Ue)
          }, y(D(Ue)), 11, E6))), 128))
        ], 8, A6)) : O("", !0),
        d("div", C6, [
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--sm",
            "aria-label": u(i)("plugin.pdf.zoom_out"),
            disabled: H.value !== "ok",
            onClick: Fe
          }, "−", 8, z6),
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--sm fe-spdf__zoomval",
            "aria-label": u(i)(j.value ? "plugin.pdf.zoom_fit_page" : "plugin.pdf.zoom_fit"),
            disabled: H.value !== "ok",
            onClick: We
          }, y(Math.round(P.value * 100)) + "% ", 9, M6),
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--sm",
            "aria-label": u(i)("plugin.pdf.zoom_in"),
            disabled: H.value !== "ok",
            onClick: Me
          }, "+", 8, P6)
        ])
      ])),
      r.value && !l.value && !c.value && Ne.value ? (f(), h("p", O6, y(u(i)("plugin.pdf.place_hint", { type: D(Ne.value) })), 1)) : O("", !0),
      l.value ? (f(), h("div", L6, [
        v.value.length ? O("", !0) : (f(), h("div", D6, y(u(i)("plugin.pdf.no_boxes")), 1)),
        (f(!0), h(Te, null, nt(v.value, (Ue, He) => (f(), h("div", {
          key: Ue.id,
          class: "fe-spdf__card",
          style: Yt(E(Ue)),
          "data-testid": `surface-pdf-card-${Ue.id}`
        }, [
          d("span", N6, y(He + 1), 1),
          Ze(w1, {
            field: Ue,
            signers: p.value,
            formats: e.formats,
            "date-labels": e.dateLabels,
            "stamp-lines": e.stampLines,
            locale: e.locale,
            disabled: e.disabled,
            "testid-prefix": `surface-pdf-card-${Ue.id}`,
            onPatch: Ut,
            onRemove: (xt) => Xe(Ue.id)
          }, null, 8, ["field", "signers", "formats", "date-labels", "stamp-lines", "locale", "disabled", "testid-prefix", "onRemove"])
        ], 12, R6))), 128)),
        d("div", {
          class: "fe-spdf__add",
          role: "toolbar",
          "aria-label": u(i)("plugin.pdf.add_box")
        }, [
          d("span", B6, y(u(i)("plugin.pdf.add_box")), 1),
          (f(!0), h(Te, null, nt(m.value, (Ue) => (f(), h("button", {
            key: Ue,
            type: "button",
            class: "fe-btn fe-btn--sm",
            disabled: e.disabled,
            "data-testid": `surface-pdf-add-${Ue}`,
            onClick: (He) => gt(Ue)
          }, " + " + y(D(Ue)), 9, F6))), 128))
        ], 8, I6)
      ])) : c.value ? (f(), h("div", U6, [
        Dt.value ? (f(), h("div", H6, [
          d("span", {
            class: "fe-spdf__propname",
            style: Yt({ "--spdf-color": T(Dt.value) })
          }, y(U(Dt.value)), 5),
          R(Dt.value.assignee) ? (f(), h("span", K6, y(R(Dt.value.assignee)), 1)) : O("", !0),
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--sm",
            "data-testid": "surface-pdf-unplace",
            onClick: G
          }, y(u(i)("plugin.pdf.unplace")), 1),
          L.value.length > 1 ? (f(), h("label", V6, [
            d("span", null, y(u(i)("plugin.pdf.copy_to_page")), 1),
            dn(d("input", {
              "onUpdate:modelValue": Le[0] || (Le[0] = (Ue) => bn.value = Ue),
              class: "fe-cfield__input fe-spdf__num",
              type: "number",
              min: "1",
              max: L.value.length,
              "data-testid": "surface-pdf-copy-page"
            }, null, 8, j6), [
              [
                _n,
                bn.value,
                void 0,
                { number: !0 }
              ]
            ]),
            d("button", {
              type: "button",
              class: "fe-btn fe-btn--sm",
              "data-testid": "surface-pdf-copy",
              onClick: ln
            }, y(u(i)("plugin.pdf.copy")), 1)
          ])) : O("", !0),
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--sm fe-btn--danger",
            "data-testid": "surface-pdf-delete",
            onClick: Le[1] || (Le[1] = (Ue) => Xe(Dt.value.id))
          }, y(u(i)("plugin.pdf.delete")), 1)
        ])) : Be.value ? (f(), h("p", q6, y(u(i)("plugin.pdf.place_box_hint", { name: ye(v.value.find((Ue) => Ue.id === Be.value) ?? v.value[0]) })), 1)) : (f(), h("p", W6, y(u(i)(Ve.value.length ? "plugin.pdf.place_idle" : "plugin.pdf.place_idle_done")), 1))
      ])) : r.value && Dt.value && !_t.value ? (f(), h("div", Y6, [
        Ze(w1, {
          field: Dt.value,
          signers: p.value,
          formats: e.formats,
          "date-labels": e.dateLabels,
          "stamp-lines": e.stampLines,
          locale: e.locale,
          disabled: e.disabled,
          "testid-prefix": "surface-pdf",
          onPatch: Ut,
          onRemove: Le[3] || (Le[3] = (Ue) => Xe(Dt.value.id))
        }, {
          extra: mt(() => [
            L.value.length > 1 ? (f(), h("label", G6, [
              d("span", null, y(u(i)("plugin.pdf.copy_to_page")), 1),
              dn(d("input", {
                "onUpdate:modelValue": Le[2] || (Le[2] = (Ue) => bn.value = Ue),
                class: "fe-cfield__input fe-spdf__num",
                type: "number",
                min: "1",
                max: L.value.length,
                "data-testid": "surface-pdf-copy-page"
              }, null, 8, X6), [
                [
                  _n,
                  bn.value,
                  void 0,
                  { number: !0 }
                ]
              ]),
              d("button", {
                type: "button",
                class: "fe-btn fe-btn--sm",
                "data-testid": "surface-pdf-copy",
                onClick: ln
              }, y(u(i)("plugin.pdf.copy")), 1)
            ])) : O("", !0)
          ]),
          _: 1
        }, 8, ["field", "signers", "formats", "date-labels", "stamp-lines", "locale", "disabled"])
      ])) : O("", !0),
      l.value ? O("", !0) : (f(), h("div", {
        key: 5,
        ref_key: "containerEl",
        ref: K,
        class: "fe-spdf__scroll"
      }, [
        H.value === "loading" ? (f(), h("p", J6, y(u(i)("plugin.view.loading")), 1)) : H.value === "error" ? (f(), h("p", Z6, y(u(i)("plugin.pdf.load_failed")), 1)) : (f(), h("div", Q6, [
          (f(!0), h(Te, null, nt(L.value, (Ue) => (f(), h("div", {
            key: Ue.num,
            ref_for: !0,
            ref: (He) => F(Ue.num, He),
            class: "fe-spdf__page",
            "data-page": Ue.num,
            style: Yt({ width: `${ee.value}px`, aspectRatio: `${Ue.width} / ${Ue.height}` }),
            onPointerdown: (He) => te(He, Ue.num)
          }, [
            (f(!0), h(Te, null, nt(C.value.get(Ue.num) ?? [], (He) => (f(), h("div", {
              key: He.id,
              class: Re(["fe-spdf__field", [
                `fe-spdf__field--${He.type}`,
                {
                  "is-selected": r.value && pt.value === He.id,
                  "is-mine": z(He),
                  "is-foreign": !r.value && !z(He),
                  "is-filled": u(ly)(He),
                  "is-required": He.required === !0
                }
              ]]),
              style: Yt({ left: `${He.x * 100}%`, top: `${He.y * 100}%`, width: `${He.w * 100}%`, height: `${He.h * 100}%`, "--spdf-color": T(He) }),
              "data-testid": `surface-pdf-field-${He.id}`,
              "data-field-type": He.type,
              role: z(He) ? "button" : void 0,
              tabindex: z(He) ? 0 : void 0,
              title: r.value || !z(He) ? R(He.assignee) : void 0,
              onPointerdown: (xt) => Ce(xt, He, Ue.num),
              onClick: (xt) => Ft(He),
              onKeydown: Ca(yt((xt) => Ft(He), ["prevent"]), ["enter"])
            }, [
              (He.type === "signature" || He.type === "initials") && fn(He) ? (f(), h("img", {
                key: 0,
                class: "fe-spdf__sig",
                src: fn(He),
                alt: ""
              }, null, 8, nF)) : He.type === "text" && z(He) ? (f(), h("input", {
                key: 1,
                class: Re(["fe-spdf__text", Mn(He)]),
                type: "text",
                value: typeof He.value == "string" ? He.value : "",
                placeholder: U(He),
                "aria-label": U(He),
                inputmode: u(dR)(mn(He)),
                maxlength: u(ZS)(mn(He)),
                "aria-invalid": zn(He) ? "true" : void 0,
                "aria-describedby": aa(He) ? `${e.id}-${He.id}-rule` : void 0,
                title: aa(He) || void 0,
                disabled: e.disabled,
                "data-testid": `surface-pdf-text-${He.id}`,
                onPointerdown: Le[4] || (Le[4] = yt(() => {
                }, ["stop"])),
                onClick: Le[5] || (Le[5] = yt(() => {
                }, ["stop"])),
                onInput: (xt) => na(He, xt)
              }, null, 42, aF)) : He.type === "checkbox" && He.value === !0 ? (f(), h("span", {
                key: 2,
                class: "fe-spdf__check",
                "aria-hidden": "true",
                innerHTML: u(rn)
              }, null, 8, iF)) : He.type === "date" && typeof He.value == "string" && He.value ? (f(), h("span", {
                key: 3,
                class: Re(["fe-spdf__val", Mn(He)])
              }, y(He.value), 3)) : (f(), h("span", oF, [
                Ht(y(U(He)) + " ", 1),
                z(He) ? (f(), h("small", rF, y(u(i)(`plugin.pdf.tap_${He.type}`)), 1)) : He.assignee && (r.value || !z(He)) ? (f(), h("small", sF, y(R(He.assignee)), 1)) : O("", !0)
              ])),
              !r.value && z(He) && He.type === "text" && (zn(He) || aa(He)) ? (f(), h("span", {
                key: 5,
                id: `${e.id}-${He.id}-rule`,
                class: Re(["fe-spdf__rule", { "is-bad": !!zn(He) }]),
                role: zn(He) ? "alert" : void 0,
                "data-testid": `surface-pdf-rule-${He.id}`
              }, y(zn(He) || aa(He)), 11, lF)) : O("", !0),
              r.value ? (f(), h("span", {
                key: 6,
                class: "fe-spdf__handle",
                "data-testid": "surface-pdf-handle",
                onPointerdown: (xt) => Ie(xt, He, Ue.num)
              }, null, 40, uF)) : O("", !0)
            ], 46, tF))), 128)),
            xe.value && xe.value.page === Ue.num ? (f(), h("div", {
              key: 0,
              class: "fe-spdf__field fe-spdf__field--ghost",
              style: Yt({ left: `${xe.value.x * 100}%`, top: `${xe.value.y * 100}%`, width: `${xe.value.w * 100}%`, height: `${xe.value.h * 100}%` })
            }, null, 4)) : O("", !0)
          ], 44, eF))), 128))
        ]))
      ], 512)),
      !r.value && Kt.value ? (f(), h("div", cF, [
        d("p", dF, y(u(i)("plugin.pdf.pad_for", { type: U(Kt.value) })), 1),
        Ze(v$, {
          id: `${e.id}-${Kt.value.id}`,
          "model-value": Nn.value,
          modes: bt.value,
          font: Kt.value.font,
          fonts: Dn.value,
          locale: e.locale,
          disabled: e.disabled,
          width: Kt.value.type === "initials" ? 240 : void 0,
          height: Kt.value.type === "initials" ? 120 : void 0,
          "onUpdate:modelValue": Cn
        }, null, 8, ["id", "model-value", "modes", "font", "fonts", "locale", "disabled", "width", "height"]),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--sm",
          "data-testid": "surface-pdf-pad-done",
          onClick: Le[6] || (Le[6] = (Ue) => Ln.value = "")
        }, y(u(i)("plugin.pdf.pad_done")), 1)
      ])) : O("", !0)
    ], 14, _6));
  }
}), pF = { class: "fe-surface" }, hF = ["data-node"], mF = {
  key: 1,
  class: "fe-surface__divider"
}, vF = {
  key: 2,
  class: "fe-surface__row"
}, yF = ["data-node-type"], gF = {
  key: 14,
  class: "fe-surface__error"
}, bF = /* @__PURE__ */ lt({
  __name: "SurfaceRenderer",
  props: {
    nodes: {},
    locale: {},
    theme: {},
    errors: {},
    values: {},
    api: {},
    plugin: {},
    storages: {},
    startAt: {},
    disabled: { type: Boolean },
    fileUrl: { type: Function },
    pdfWorkerUrl: {},
    invalidKeys: {},
    layout: {},
    pageHeight: {}
  },
  emits: ["update:values", "change", "action"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = () => n.values ?? {};
    function l(b, C) {
      a("update:values", { ...r(), [b]: C });
    }
    function c(b) {
      a("update:values", b), a("change");
    }
    function p(b, C) {
      l(b.id, C), m(b).mode !== "fill" && a("change");
    }
    function m(b) {
      return b.props ?? {};
    }
    function v(b) {
      const C = m(b);
      return Xt(C.text ?? C.value ?? "", n.locale);
    }
    function x(b) {
      const C = String(m(b).tone ?? "");
      return C === "muted" || C === "danger" || C === "info" ? `fe-surface__text--${C}` : "";
    }
    function w(b) {
      return !b.id || !n.errors ? "" : Xt(n.errors[b.id], n.locale);
    }
    function $(b) {
      return typeof b == "string" ? b : "";
    }
    function k(b) {
      return Array.isArray(b) ? b : [];
    }
    return (b, C) => {
      const T = RM("SurfaceRenderer", !0);
      return f(), h("div", pF, [
        (f(!0), h(Te, null, nt(e.nodes, (E, R) => (f(), h(Te, {
          key: E.id || R
        }, [
          E.type === "text" ? (f(), h("p", {
            key: 0,
            class: Re(["fe-surface__text", [x(E), m(E).heading ? "fe-surface__text--heading" : ""]]),
            "data-node": E.id || void 0
          }, y(v(E)), 11, hF)) : E.type === "divider" ? (f(), h("hr", mF)) : E.type === "row" ? (f(), h("div", vF, [
            Ze(T, {
              nodes: E.children ?? [],
              locale: e.locale,
              theme: e.theme,
              errors: e.errors,
              values: e.values,
              api: e.api,
              plugin: e.plugin,
              storages: e.storages,
              "start-at": e.startAt,
              disabled: e.disabled,
              "file-url": e.fileUrl,
              "pdf-worker-url": e.pdfWorkerUrl,
              "invalid-keys": e.invalidKeys,
              layout: e.layout,
              "page-height": e.pageHeight,
              "onUpdate:values": C[0] || (C[0] = (z) => a("update:values", z)),
              onChange: C[1] || (C[1] = (z) => a("change")),
              onAction: C[2] || (C[2] = (z) => a("action", z))
            }, null, 8, ["nodes", "locale", "theme", "errors", "values", "api", "plugin", "storages", "start-at", "disabled", "file-url", "pdf-worker-url", "invalid-keys", "layout", "page-height"])
          ])) : E.type === "form" ? (f(), Ge(zN, {
            key: 3,
            fields: m(E).fields ?? [],
            values: r(),
            locale: e.locale,
            errors: e.errors,
            invalid: e.invalidKeys,
            disabled: e.disabled,
            "onUpdate:values": c
          }, null, 8, ["fields", "values", "locale", "errors", "invalid", "disabled"])) : E.type === "steps" ? (f(), Ge(RN, {
            key: 4,
            items: m(E).items ?? [],
            locale: e.locale
          }, null, 8, ["items", "locale"])) : E.type === "list" ? (f(), Ge(VI, {
            key: 5,
            columns: m(E).columns ?? [],
            rows: m(E).rows ?? [],
            empty: m(E).empty,
            locale: e.locale,
            disabled: e.disabled,
            "table-id": e.plugin ? `app.${e.plugin}.${E.id || "list"}` : void 0,
            onAction: C[3] || (C[3] = (z) => a("action", z))
          }, null, 8, ["columns", "rows", "empty", "locale", "disabled", "table-id"])) : E.type === "progress" ? (f(), Ge(XI, {
            key: 6,
            value: m(E).value,
            label: m(E).label,
            locale: e.locale
          }, null, 8, ["value", "label", "locale"])) : E.type === "people-picker" && E.id ? (f(), Ge(v8, {
            key: 7,
            id: E.id,
            "model-value": k(r()[E.id]),
            multi: m(E).multi === !0,
            "allow-external": m(E).allow_external === !0,
            api: e.api,
            plugin: e.plugin,
            locale: e.locale,
            disabled: e.disabled,
            invalid: !!w(E),
            "onUpdate:modelValue": (z) => l(E.id, z)
          }, null, 8, ["id", "model-value", "multi", "allow-external", "api", "plugin", "locale", "disabled", "invalid", "onUpdate:modelValue"])) : E.type === "pin-input" && E.id ? (f(), Ge(k8, {
            key: 8,
            id: E.id,
            length: m(E).length,
            "model-value": $(r()[E.id]),
            locale: e.locale,
            disabled: e.disabled,
            invalid: !!w(E),
            "onUpdate:modelValue": (z) => l(E.id, z)
          }, null, 8, ["id", "length", "model-value", "locale", "disabled", "invalid", "onUpdate:modelValue"])) : E.type === "file-chooser" && E.id ? (f(), Ge(oB, {
            key: 9,
            id: E.id,
            kind: m(E).kind,
            "model-value": $(r()[E.id]),
            api: e.api,
            storages: e.storages,
            "start-at": e.startAt,
            locale: e.locale,
            theme: e.theme,
            disabled: e.disabled,
            invalid: !!w(E),
            "onUpdate:modelValue": (z) => l(E.id, z)
          }, null, 8, ["id", "kind", "model-value", "api", "storages", "start-at", "locale", "theme", "disabled", "invalid", "onUpdate:modelValue"])) : E.type === "preview" ? (f(), Ge(mB, {
            key: 10,
            path: $(m(E).path),
            "file-ref": $(m(E).ref),
            "file-url": e.fileUrl,
            api: e.api,
            locale: e.locale
          }, null, 8, ["path", "file-ref", "file-url", "api", "locale"])) : E.type === "signature-pad" && E.id ? (f(), Ge(v$, {
            key: 11,
            id: E.id,
            modes: m(E).modes,
            width: m(E).width,
            height: m(E).height,
            font: m(E).font,
            fonts: m(E).fonts,
            label: u(Xt)(m(E).label ?? "", e.locale),
            required: m(E).required === !0,
            "model-value": u(ju)(r()[E.id]) ? r()[E.id] : null,
            locale: e.locale,
            disabled: e.disabled,
            invalid: !!w(E),
            "onUpdate:modelValue": (z) => l(E.id, z)
          }, null, 8, ["id", "modes", "width", "height", "font", "fonts", "label", "required", "model-value", "locale", "disabled", "invalid", "onUpdate:modelValue"])) : E.type === "pdf-fields" && E.id ? (f(), Ge(fF, {
            key: 12,
            id: E.id,
            src: m(E).src,
            mode: m(E).mode,
            fields: m(E).fields,
            layout: e.layout,
            "page-height": e.pageHeight,
            signers: m(E).signers,
            signer: m(E).signer,
            types: m(E).types,
            formats: m(E).formats,
            "date-labels": m(E).date_labels,
            "stamp-lines": m(E).stamp_lines,
            "model-value": r()[E.id],
            api: e.api,
            "file-url": e.fileUrl,
            "pdf-worker-url": e.pdfWorkerUrl,
            locale: e.locale,
            theme: e.theme,
            disabled: e.disabled,
            invalid: !!w(E),
            "onUpdate:modelValue": (z) => p(E, z)
          }, null, 8, ["id", "src", "mode", "fields", "layout", "page-height", "signers", "signer", "types", "formats", "date-labels", "stamp-lines", "model-value", "api", "file-url", "pdf-worker-url", "locale", "theme", "disabled", "invalid", "onUpdate:modelValue"])) : (f(), h("p", {
            key: 13,
            class: "fe-surface__unknown",
            "data-node-type": E.type
          }, y(u(i)("plugin.view.unsupported", { type: E.type })), 9, yF)),
          w(E) && E.type !== "form" ? (f(), h("p", gF, y(w(E)), 1)) : O("", !0)
        ], 64))), 128))
      ]);
    };
  }
}), kF = {
  key: 1,
  class: "fe-surface__text fe-surface__text--info",
  role: "status"
}, wF = {
  key: 2,
  class: "fe-surface__text fe-surface__text--muted"
}, _F = {
  key: 3,
  class: "fe-surface__error",
  role: "alert"
}, Yp = /* @__PURE__ */ lt({
  __name: "SurfaceConversation",
  props: {
    conv: {},
    locale: {},
    theme: {},
    api: {},
    plugin: {},
    storages: {},
    startAt: {},
    fileUrl: { type: Function },
    toast: {},
    layout: {},
    pageHeight: {}
  },
  setup(e) {
    const t = e, { t: n } = ht(() => t.locale);
    return (a, i) => (f(), h(Te, null, [
      e.conv.current.value ? (f(), Ge(bF, {
        key: 0,
        nodes: e.conv.current.value.nodes ?? [],
        locale: e.locale,
        theme: e.theme,
        errors: e.conv.errors.value,
        values: e.conv.values.value,
        api: e.api,
        plugin: e.plugin,
        storages: e.storages,
        "start-at": e.startAt,
        "file-url": e.fileUrl,
        layout: e.layout,
        "page-height": e.pageHeight,
        "invalid-keys": e.conv.invalidKeys.value,
        disabled: e.conv.busy.value,
        "onUpdate:values": e.conv.updateValues,
        onChange: e.conv.scheduleChange,
        onAction: e.conv.rowAction
      }, null, 8, ["nodes", "locale", "theme", "errors", "values", "api", "plugin", "storages", "start-at", "file-url", "layout", "page-height", "invalid-keys", "disabled", "onUpdate:values", "onChange", "onAction"])) : O("", !0),
      e.toast ? (f(), h("p", kF, y(e.toast), 1)) : O("", !0),
      e.conv.busy.value ? (f(), h("p", wF, y(u(n)("plugin.view.busy")), 1)) : O("", !0),
      e.conv.failure.value ? (f(), h("p", _F, y(e.conv.failure.value), 1)) : O("", !0)
    ], 64));
  }
});
function xF(e) {
  let t = !1;
  return Gc(e, (n) => {
    n.type === "steps" && (t = !0);
  }), t;
}
const SF = /* @__PURE__ */ new Set(["back", "prev", "previous", "stepback", "goback", "prevstep", "previousstep"]);
function $F(e) {
  const t = String((e == null ? void 0 : e.id) ?? "").toLowerCase().replace(/[^a-z]/g, "");
  return SF.has(t);
}
function TF(e, t) {
  const n = (e ?? []).filter((l) => l && l.id);
  if (!t)
    return { back: null, others: n, primary: null };
  const a = n.find($F) ?? null, i = n.filter((l) => l !== a), r = i.find((l) => l.primary === !0) ?? null;
  return { back: a, others: i.filter((l) => l !== r), primary: r };
}
const AF = ["disabled", "data-testid", "onClick"], Gp = /* @__PURE__ */ lt({
  __name: "SurfaceFooterButtons",
  props: {
    conv: {},
    locale: {},
    testidPrefix: {},
    small: { type: Boolean }
  },
  setup(e) {
    const t = e, n = A(() => {
      var l;
      return xF((l = t.conv.current.value) == null ? void 0 : l.nodes);
    }), a = A(() => TF(t.conv.footer.value, n.value)), i = A(() => {
      const l = a.value;
      return [...l.back ? [l.back] : [], ...l.others, ...l.primary ? [l.primary] : []];
    });
    function r(l) {
      return n.value ? l === a.value.primary : l.primary === !0;
    }
    return (l, c) => (f(!0), h(Te, null, nt(i.value, (p) => (f(), h("button", {
      key: p.id,
      type: "button",
      class: Re(["fe-btn", {
        "fe-btn--sm": e.small,
        "fe-btn--primary": r(p) && !p.danger,
        "fe-btn--danger": p.danger,
        "fe-surface__back": n.value && p === a.value.back
      }]),
      disabled: t.conv.busy.value || p.disabled,
      "data-testid": `${e.testidPrefix}-action-${p.id}`,
      onClick: (m) => t.conv.press(p)
    }, y(u(Xt)(p.label, e.locale)), 11, AF))), 128));
  }
}), k$ = 1, EF = "filex:hello", CF = "filex:port", zF = [
  "session.get",
  "file.read",
  "file.save",
  "file.saveAs",
  "ui.dirty",
  "ui.title",
  "ui.toast",
  "ui.confirm",
  "ui.close",
  "clipboard.write",
  "ui.download",
  "engine.call",
  "job.submit",
  "state.get",
  "state.set",
  "license.get",
  "ui.print",
  "coedit.join",
  "coedit.subscribe",
  "coedit.append",
  "coedit.lease",
  "coedit.cursor",
  "coedit.blob.put",
  "coedit.blob.get",
  "coedit.leave"
], ya = {
  /** `file.read({as: 'text'})` refuses a file larger than this; read a stream. */
  maxTextBytes: 32 << 20,
  /** One `state.set` value, as JSON. */
  maxStateBytes: 8192,
  /** A `ui.toast` / `ui.title` text, in characters. */
  maxLineChars: 300,
  /** How long the SDK waits for the host's port. */
  connectTimeoutMs: 1e4,
  /** The largest file `ui.download` hands the person (streamed or not). */
  maxDownloadBytes: 256 << 20,
  /**
   * The largest PDF `ui.print` prints (filex 0.55). Lower than a download:
   * a download can stream to disk, a print is held whole in the page (one
   * Blob) until the print dialog has read it, and a document worth printing
   * is far smaller.
   */
  maxPrintBytes: 64 << 20,
  /**
   * The largest file of an encrypted folder filex hands an app in the clear
   * or takes back from it (filex 0.56, `FileInfo.plaintext`): it is
   * decrypted and encrypted whole in the page, as filex's own explorer does
   * for a file of this size.
   */
  maxEncryptedBytes: 200 << 20
};
function MF(e) {
  return !!e && typeof e == "object" && e.type === EF && typeof e.v == "number";
}
function PF(e) {
  return !!e && typeof e == "object" && typeof e.id == "number" && typeof e.method == "string";
}
function OF(e) {
  return zF.includes(e);
}
const Zm = { inFlight: 32, perWindow: 400, windowMs: 1e4 };
class ct extends Error {
  constructor(n, a) {
    super(a || n);
    Nt(this, "code");
    this.name = "BridgeFailure", this.code = n;
  }
}
function LF(e) {
  if (!e || typeof e != "object") return [];
  const t = [];
  for (const n of Object.values(e))
    (n instanceof ArrayBuffer || typeof ReadableStream < "u" && n instanceof ReadableStream) && t.push(n);
  return t;
}
const DF = /^[a-z][a-z0-9_]{0,39}$/;
function RF(e) {
  if (e instanceof ct) return { code: e.code, message: e.message };
  const t = e ?? {}, n = typeof t.status == "number" ? t.status : 0, a = typeof t.code == "string" && DF.test(t.code) ? t.code : "";
  let i = "failed";
  return n === 404 ? i = "not_found" : n === 413 ? i = "too_large" : n === 400 || n === 422 ? i = "invalid" : n === 409 && a === "read_only" ? i = "read_only" : n === 403 && a === "not_granted" && (i = "not_granted"), { code: i, message: a || i };
}
function NF(e) {
  const t = e.win ?? window;
  let n = null, a = !1, i = 0, r = !1, l = 0;
  const c = /* @__PURE__ */ new Map();
  function p(C) {
    var T;
    if (n) {
      n.onmessage = null;
      try {
        n.close();
      } catch {
      }
      n = null;
      for (const [, E] of c)
        clearTimeout(E.timer), E.reject(new ct("unavailable", "the interface went away"));
      c.clear(), (T = e.onDisconnect) == null || T.call(e, C);
    }
  }
  let m = 0, v = 0, x = 0;
  function w() {
    const C = Date.now();
    return C - v >= Zm.windowMs && (v = C, x = 0), x >= Zm.perWindow ? !1 : (x++, !0);
  }
  async function $(C, T, E, R) {
    let z, D = [];
    if (!w())
      z = { id: T, error: { code: "unavailable", message: "busy" } };
    else if (!OF(E))
      z = { id: T, error: { code: "unknown_method", message: E } };
    else {
      const U = e.handlers[E];
      if (!U)
        z = { id: T, error: { code: "unavailable", message: `${E} is not offered here` } };
      else if (m >= Zm.inFlight)
        z = { id: T, error: { code: "unavailable", message: "busy" } };
      else {
        m++;
        try {
          const H = await U(R);
          z = { id: T, result: H }, D = LF(H);
        } catch (H) {
          z = { id: T, error: RF(H) };
        } finally {
          m--;
        }
      }
    }
    if (C === n)
      try {
        C.postMessage(z, D);
      } catch {
        C.postMessage({ id: T, error: { code: "failed", message: "the answer cannot be sent to the interface" } });
      }
  }
  function k(C) {
    return (T) => {
      const E = T.data;
      if (!(!E || typeof E != "object")) {
        if (typeof E.hid == "number") {
          const R = c.get(E.hid);
          if (!R) return;
          if (c.delete(E.hid), clearTimeout(R.timer), E.error) {
            const z = E.error;
            R.reject(new ct(z.code ?? "failed", z.message));
          } else R.resolve(E.result);
          return;
        }
        PF(E) && $(C, E.id, E.method, E.params);
      }
    };
  }
  function b(C) {
    var z, D;
    if (r || a) return;
    const T = e.frame(), E = T == null ? void 0 : T.contentWindow;
    if (!T || !E || C.source !== E || !MF(C.data) || i > 1) return;
    a = !0;
    const R = new MessageChannel();
    n = R.port1, n.onmessage = k(n), (z = n.start) == null || z.call(n), E.postMessage({ type: CF, v: k$ }, "*", [R.port2]), (D = e.onConnect) == null || D.call(e);
  }
  return t.addEventListener("message", b), {
    connected: () => n !== null,
    emit(C, T, E = []) {
      if (n)
        try {
          n.postMessage({ event: C, data: T }, E);
        } catch {
        }
    },
    ask(C, T, E = 6e4) {
      const R = n;
      if (!R) return Promise.reject(new ct("unavailable", "the interface is not connected"));
      const z = ++l;
      return new Promise((D, U) => {
        const H = setTimeout(() => {
          c.delete(z), U(new ct("failed", `the interface did not answer "${C}"`));
        }, E);
        c.set(z, { resolve: D, reject: U, timer: H }), R.postMessage({ hid: z, request: C, params: T });
      });
    },
    frameLoaded() {
      i++, i > 1 && p("reload");
    },
    destroy() {
      r = !0, t.removeEventListener("message", b), p("destroyed");
    }
  };
}
const IF = [
  "theme",
  "palette",
  "density",
  "locale",
  "storageOrder",
  "tour",
  "appState",
  "appStateE2e",
  "appsSeen",
  "openWith",
  "remoteImages"
], BF = ["openWith"], hp = ["theme", "palette", "density", "locale", "storageOrder"], _c = {
  theme: "filex.theme",
  palette: "filex.palette",
  density: "filex.density",
  locale: "filex.locale",
  // New in 0.45.2 (#57); no earlier reader to stay compatible with.
  storageOrder: "filex.storageOrder"
}, w$ = 400, fy = "filex.session";
let Xp = !1;
function FF() {
  try {
    return localStorage.getItem(fy) === "1";
  } catch {
    return !1;
  }
}
function nr() {
  return Xp ? !1 : ai.sessionAware ? FF() : !0;
}
function UF(e) {
  try {
    e ? localStorage.setItem(fy, "1") : localStorage.removeItem(fy);
  } catch {
  }
  e && (Xp = !1);
}
function ehe() {
  Xp = !0;
}
const _$ = new Set(Object.values(_c));
function HF(e) {
  _$.add(e);
}
const x$ = /* @__PURE__ */ new Set();
function KF(e) {
  x$.add(e);
}
function the() {
  UF(!1);
  for (const e of _$)
    try {
      localStorage.removeItem(e);
    } catch {
    }
  for (const e of x$)
    try {
      e();
    } catch {
    }
  Qa = {}, Jp = !1, Xr = {}, ra !== null && clearTimeout(ra), ra = null, Df();
}
let ai = { surface: "web" }, Qa = {}, Jp = !1, Bl = !1, Xc = !1;
const mp = /* @__PURE__ */ new Set(), xc = /* @__PURE__ */ new Set();
function VF(e) {
  ai = { ...e }, Bl = !0;
}
function Fl() {
  return Bl;
}
function jF() {
  return Xc;
}
function qF(e) {
  return Xc ? (e(), () => {
  }) : (xc.add(e), () => xc.delete(e));
}
function Df() {
  Xc = !0;
  const e = [...xc];
  xc.clear();
  for (const t of e)
    try {
      t();
    } catch {
    }
}
function Qi() {
  return { ...Qa };
}
function S$() {
  return Jp;
}
function Jc(e) {
  return mp.add(e), () => mp.delete(e);
}
function $$() {
  const e = Qi();
  for (const t of mp)
    try {
      t(e);
    } catch {
    }
}
function vp(e) {
  try {
    return localStorage.getItem(_c[e]) ?? "";
  } catch {
    return "";
  }
}
function Gr(e, t) {
  try {
    t ? localStorage.setItem(_c[e], t) : localStorage.removeItem(_c[e]);
  } catch {
  }
}
function WF() {
  const e = {};
  for (const t of hp) {
    const n = vp(t);
    n && (e[t] = n);
  }
  return e;
}
function T$() {
  return `${Yo(ai.base)}/api/me/prefs?surface=${encodeURIComponent(ai.surface)}`;
}
async function Pg(e) {
  const t = { Accept: "application/json" };
  e && (t["Content-Type"] = "application/json");
  const n = ai.headers ? await ai.headers() : {};
  return { ...t, ...n };
}
function YF(e) {
  const t = { Accept: "application/json" };
  t["Content-Type"] = "application/json";
  const n = ai.headers ? ai.headers() : {};
  return n && typeof n.then != "function" ? { ...t, ...n } : t;
}
function GF(e) {
  const t = e && typeof e == "object" ? e : {}, n = t.prefs && typeof t.prefs == "object" ? t.prefs : t, a = {};
  for (const i of IF) {
    const r = n[i];
    typeof r == "string" && r && (a[i] = r);
  }
  return a;
}
async function XF() {
  if (!Bl)
    return Df(), null;
  const e = ai.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
  if (!e)
    return Df(), null;
  Xc = !1;
  try {
    const t = await e(T$(), {
      method: "GET",
      headers: await Pg(!1),
      credentials: "same-origin",
      cache: "no-store"
    });
    if (!t.ok) return null;
    if (Qa = GF(await t.json()), Jp = !0, !Object.keys(Qa).length) {
      const n = WF();
      if (delete n.locale, Object.keys(n).length) {
        Qa = n;
        for (const a of hp) n[a] && (Xr[a] = n[a]);
        ra !== null && clearTimeout(ra), ra = setTimeout(() => {
          Pl = Zp();
        }, w$);
      }
    }
    for (const n of hp)
      n === "locale" && !Qa[n] || Gr(n, Qa[n] ?? "");
    return $$(), Qi();
  } catch {
    return null;
  } finally {
    Df();
  }
}
let Xr = {}, ra = null, Pl = null;
async function Zp(e = !1) {
  ra = null;
  const t = Xr;
  if (Xr = {}, !Object.keys(t).length || !Bl) return;
  const n = Qi();
  for (const l of BF) delete n[l];
  const a = { prefs: n }, i = ai.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
  if (!i) return;
  const r = JSON.stringify(a);
  try {
    await i(T$(), {
      method: "PUT",
      headers: e ? YF(!0) : await Pg(!0),
      credentials: "same-origin",
      body: r,
      // ⚠ Sent while the page is going away: `keepalive` is what lets the
      // request outlive it. Browsers reject a keepalive body over 64 KB
      // outright, so the flag goes only on documents that fit.
      ...e && r.length < 6e4 ? { keepalive: !0 } : {}
    });
  } catch {
  }
}
function Zi(e, t) {
  Qa = { ...Qa, [e]: t }, hp.includes(e) && Gr(e, t), Xr = { ...Xr, [e]: t }, ra !== null && clearTimeout(ra), ra = setTimeout(() => {
    Pl = Zp();
  }, w$);
}
function Og(e, t) {
  Qa = { ...Qa, [e]: t }, $$();
}
async function A$(e, t) {
  if (!Bl) return null;
  const n = ai.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
  if (!n) return null;
  try {
    return await n(`${Yo(ai.base)}${e}`, {
      method: t.method,
      headers: await Pg(t.body !== void 0),
      credentials: "same-origin",
      body: t.body
    });
  } catch {
    return null;
  }
}
async function JF() {
  ra !== null && (clearTimeout(ra), Pl = Zp()), await Pl;
}
function _1() {
  ra !== null && (clearTimeout(ra), Pl = Zp(!0));
}
typeof window < "u" && (window.addEventListener("pagehide", _1), document.addEventListener("visibilitychange", () => {
  document.visibilityState === "hidden" && _1();
}));
function nhe() {
  Qa = {}, Jp = !1, Xp = !1, Xr = {}, ra !== null && clearTimeout(ra), ra = null, Pl = null, mp.clear(), Xc = !1, xc.clear(), Bl = !1;
}
function E$() {
  return Pc("app_state_max_bytes");
}
const ZF = new TextEncoder();
function C$(e) {
  return ZF.encode(e).length;
}
function Qp(e) {
  const t = Qi()[e];
  if (!t) return {};
  try {
    const n = JSON.parse(t);
    return n && typeof n == "object" && !Array.isArray(n) ? n : {};
  } catch {
    return {};
  }
}
function QF(e, t) {
  const n = Qp("appState")[e];
  return n && Object.prototype.hasOwnProperty.call(n, t) ? n[t] : void 0;
}
class Sc extends Error {
}
function z$(e, t) {
  if (!e || e.length > 128 || e === "__proto__" || e === "constructor" || e === "prototype")
    throw new Sc("a state key is 1-128 characters");
  const n = t === void 0 ? void 0 : JSON.stringify(t);
  if (n !== void 0 && n.length > ya.maxStateBytes)
    throw new Sc(`a state value is at most ${ya.maxStateBytes} bytes as JSON`);
  return n;
}
function eU(e, t, n) {
  const a = z$(t, n), i = Qp("appState"), r = { ...i[e] ?? {} };
  a === void 0 ? delete r[t] : r[t] = JSON.parse(a);
  const l = E$();
  if (l !== void 0 && C$(JSON.stringify(r)) > l)
    throw new Sc(`an app keeps at most ${l} bytes`);
  const c = { ...i, [e]: r };
  Object.keys(r).length || delete c[e], Zi("appState", JSON.stringify(c));
}
function tU(e) {
  const t = Qp("appsSeen")[e];
  return typeof t == "string" ? t : "";
}
function x1(e, t) {
  const n = Qp("appsSeen");
  n[e] !== t && Zi("appsSeen", JSON.stringify({ ...n, [e]: t }));
}
const nU = 1e4, aU = 1500, iU = 15 * 6e4, oU = 600, rU = 4 << 20, M$ = "application/pdf", Jr = [37, 80, 68, 70, 45], sU = [
  "background-color",
  "color",
  "border-top-color",
  "border-right-color",
  "border-bottom-color",
  "border-left-color",
  "border-top-width",
  "border-right-width",
  "border-bottom-width",
  "border-left-width",
  "border-top-style",
  "border-right-style",
  "border-bottom-style",
  "border-left-style",
  "border-top-left-radius",
  "border-top-right-radius",
  "border-bottom-right-radius",
  "border-bottom-left-radius",
  "font-family",
  "font-size",
  "font-weight",
  "line-height",
  "letter-spacing",
  "padding-top",
  "padding-right",
  "padding-bottom",
  "padding-left"
];
function ac(e) {
  const t = e instanceof Uint8Array ? e : e instanceof ArrayBuffer ? new Uint8Array(e) : null;
  return !t || t.byteLength < Jr.length ? !1 : Jr.every((n, a) => t[a] === n);
}
class ua extends Error {
  constructor(n, a) {
    super(a || n);
    Nt(this, "code");
    this.name = "PrintFailure", this.code = n;
  }
}
function Qm() {
  return new ua("invalid", "the data is not a PDF");
}
function lU(e, t) {
  const n = Math.min(Jr.length - e.byteLength, t.byteLength);
  if (n <= 0) return e;
  const a = new Uint8Array(e.byteLength + n);
  return a.set(e), a.set(t.subarray(0, n), e.byteLength), a;
}
async function uU(e, t) {
  const n = () => new ua("too_large", `at most ${Math.floor(t / 1048576)} MiB`);
  if (e instanceof ArrayBuffer) {
    if (e.byteLength > t) throw n();
    if (!ac(e)) throw Qm();
    return new Blob([e], { type: M$ });
  }
  let a = null, i = [], r = 0, l = 0, c = new Uint8Array(0);
  for await (const p of e) {
    if (!(p instanceof Uint8Array)) throw new ua("invalid", "a PDF stream carries bytes (Uint8Array)");
    if (c.byteLength < Jr.length && (c = lU(c, p), c.byteLength >= Jr.length && !ac(c)))
      throw Qm();
    if (l += p.byteLength, l > t) throw n();
    i.push(p), r += p.byteLength, r >= rU && (a = S1(a, i), i = [], r = 0);
  }
  if (!ac(c)) throw Qm();
  return i.length || !a ? S1(a, i) : a;
}
function S1(e, t) {
  return new Blob(e ? [e, ...t] : t, { type: M$ });
}
function cU(e) {
  var i;
  const t = {}, n = (i = e == null ? void 0 : e.ownerDocument) == null ? void 0 : i.defaultView;
  if (!e || !n || typeof n.getComputedStyle != "function") return t;
  const a = n.getComputedStyle(e);
  for (const r of sU) {
    const l = a.getPropertyValue(r).trim();
    l && (t[r] = l);
  }
  return t;
}
async function dU(e) {
  if (typeof Blob > "u" || !(e instanceof Blob) || e.size < Jr.length) return !1;
  try {
    return ac(await e.slice(0, Jr.length).arrayBuffer());
  } catch {
    return !1;
  }
}
const $1 = "position:absolute;width:1px;height:1px;border:0;opacity:0;pointer-events:none;inset-inline-start:-10000px;top:0";
function fU(e, t) {
  return `display:block;width:${e}px;height:${t}px;border:0;background:transparent;color-scheme:normal`;
}
function T1(e, t, n, a) {
  const i = typeof e == "number" && Number.isFinite(e) ? Math.round(e) : a;
  return Math.min(n, Math.max(t, i));
}
async function pU(e, t, n = {}) {
  var c, p;
  const a = n.win ?? window, i = a.document;
  if ((c = n.signal) != null && c.aborted) throw new ua("cancelled", "the person said no");
  if (!await dU(t)) throw new ua("invalid", "not a PDF");
  let r;
  try {
    r = new URL(e, a.location.href).origin;
  } catch {
    throw new ua("unavailable", "no print page");
  }
  if (!r || r === "null") throw new ua("unavailable", "no print page");
  if ((p = n.signal) != null && p.aborted) throw new ua("cancelled", "the person said no");
  const l = i.createElement("iframe");
  return l.setAttribute("referrerpolicy", "no-referrer"), l.setAttribute("aria-hidden", "true"), l.setAttribute("tabindex", "-1"), l.setAttribute("title", n.label || "print"), l.dataset.testid = "appframe-print", l.style.cssText = $1, l.setAttribute("src", e), new Promise((m, v) => {
    var L;
    let x = !1, w = !1, $ = null, k = null, b = null, C = null, T = null;
    function E() {
      l.style.cssText = $1, l.setAttribute("aria-hidden", "true"), l.setAttribute("tabindex", "-1");
    }
    function R(P) {
      var K;
      if (!x) {
        x = !0, a.removeEventListener("message", H), l.removeEventListener("load", D), (K = n.signal) == null || K.removeEventListener("abort", z);
        for (const N of [$, k, b, C]) N && clearTimeout(N);
        T && (T.port1.onmessage = null), P ? (l.remove(), v(P)) : (E(), m(l));
      }
    }
    function z() {
      try {
        T == null || T.port1.postMessage({ type: "cancel" });
      } catch {
      }
      R(new ua("cancelled", "the person said no"));
    }
    function D() {
      x || T || k || (k = setTimeout(() => {
        T || R(new ua("unavailable", "the print page may not be shown here"));
      }, n.loadGraceMs ?? aU));
    }
    function U(P) {
      var N;
      const K = P.data;
      if (!(x || !K || typeof K != "object")) {
        if (K.state === "ask") {
          if (w) return;
          w = !0;
          const J = T1(K.width, 24, 480, 96), j = T1(K.height, 16, 96, 36);
          l.style.cssText = fU(J, j), l.removeAttribute("aria-hidden"), l.removeAttribute("tabindex"), (N = n.onAsk) == null || N.call(n, { width: J, height: j }), C = setTimeout(() => {
            try {
              T == null || T.port1.postMessage({ type: "arm" });
            } catch {
            }
          }, n.armMs ?? oU);
          return;
        }
        K.ok === !0 ? R(null) : R(new ua(K.code === "invalid" ? "invalid" : "failed", "the PDF could not be printed"));
      }
    }
    function H(P) {
      const K = l.contentWindow;
      if (x || !K || P.source !== K) return;
      const N = P.data;
      if (!N || typeof N != "object" || N.type !== "filex:print-ready" || T || P.origin !== r) return;
      $ && clearTimeout($), k && clearTimeout(k);
      const J = new MessageChannel();
      T = J, J.port1.onmessage = U, b = setTimeout(() => R(new ua("failed", "the print page did not answer")), n.answerMs ?? iU);
      try {
        K.postMessage({ type: "filex:print", pdf: t, label: n.label ?? "", look: n.look ?? {} }, r, [J.port2]);
      } catch {
        R(new ua("failed", "the PDF could not be handed to the print page"));
      }
    }
    a.addEventListener("message", H), l.addEventListener("load", D), (L = n.signal) == null || L.addEventListener("abort", z), $ = setTimeout(() => R(new ua("unavailable", "the print page did not load")), n.readyMs ?? nU), (n.mount ?? i.body).appendChild(l);
  });
}
const Zc = new TextEncoder(), hU = new TextDecoder();
function Zr(e) {
  return new Uint8Array(e);
}
const mU = Zr(Zc.encode("filex-state1")), vU = Zr(Zc.encode("filex-app-state")), yU = "filex-app-state-v1-key", gU = "filex-app-state-v1-id", bU = "filex-app-state-v1", P$ = 1, vl = 12, kU = 16, wU = 16, _U = "local";
async function xU() {
  var t, n;
  if (!Fl()) return _U;
  const e = await A$("/api/auth/me", { method: "GET" });
  if (!e || !e.ok) return null;
  try {
    const a = (n = (t = await e.json()) == null ? void 0 : t.user) == null ? void 0 : n.id;
    if (typeof a == "number" && Number.isSafeInteger(a) && a > 0) return `u${a}`;
    if (typeof a == "string" && /^[A-Za-z0-9_-]{1,64}$/.test(a)) return `u${a}`;
  } catch {
  }
  return null;
}
async function SU(e) {
  var n;
  if (((n = e.algorithm) == null ? void 0 : n.name) === "HKDF") return e;
  const t = new Uint8Array(await crypto.subtle.encrypt({ name: "AES-GCM", iv: mU }, e, new Uint8Array(32)));
  try {
    return await crypto.subtle.importKey("raw", t.subarray(0, 32), "HKDF", !1, ["deriveKey", "deriveBits"]);
  } finally {
    t.fill(0);
  }
}
function A1(e, t, n) {
  return { name: "HKDF", hash: "SHA-256", salt: vU, info: Zr(Zc.encode(`${e}\0${t}\0${n}`)) };
}
const ff = /* @__PURE__ */ new WeakMap();
function O$(e) {
  let t = ff.get(e);
  if (!t) {
    const n = { account: xU().catch(() => null), byApp: /* @__PURE__ */ new Map() };
    n.account.then((a) => {
      a === null && ff.get(e) === n && ff.delete(e);
    }), ff.set(e, n), t = n;
  }
  return t;
}
function E1(e, t, n) {
  const { byApp: a } = O$(e), i = `${t}\0${n}`;
  let r = a.get(i);
  return r || (r = (async () => {
    const l = await SU(e), c = await crypto.subtle.deriveKey(A1(yU, t, n), l, { name: "AES-GCM", length: 256 }, !1, ["encrypt", "decrypt"]), p = new Uint8Array(await crypto.subtle.deriveBits(A1(gU, t, n), l, wU * 8));
    return { id: Xo(p), key: c, account: t };
  })(), a.set(i, r), r.catch(() => a.delete(i))), r;
}
async function $U(e, t, n) {
  const a = await O$(e).account;
  if (a === null) return null;
  const i = await E1(e, a, t);
  return n ? { ...i, previous: await E1(n, a, t) } : i;
}
function py() {
  const e = Qi().appStateE2e;
  if (!e) return {};
  try {
    const t = JSON.parse(e);
    return t && typeof t == "object" && !Array.isArray(t) ? t : {};
  } catch {
    return {};
  }
}
function L$(e, t) {
  const n = e[t];
  return n && typeof n == "object" && !Array.isArray(n) ? { ...n } : {};
}
function D$(e, t) {
  return Zr(Zc.encode(`${bU}\0${t.account}\0${e}\0${t.id}`));
}
async function TU(e, t, n) {
  const a = crypto.getRandomValues(new Uint8Array(vl)), i = Zr(Zc.encode(JSON.stringify(n)));
  try {
    const r = new Uint8Array(await crypto.subtle.encrypt({ name: "AES-GCM", iv: a, additionalData: D$(e, t) }, t.key, i)), l = new Uint8Array(1 + vl + r.length);
    return l[0] = P$, l.set(a, 1), l.set(r, 1 + vl), Xo(l);
  } finally {
    i.fill(0);
  }
}
async function C1(e, t, n) {
  if (typeof n != "string") return null;
  const a = _o(n);
  if (!a || a.length < 1 + vl + kU || a[0] !== P$) return null;
  let i;
  try {
    i = new Uint8Array(
      await crypto.subtle.decrypt(
        { name: "AES-GCM", iv: Zr(a.subarray(1, 1 + vl)), additionalData: D$(e, t) },
        t.key,
        Zr(a.subarray(1 + vl))
      )
    );
  } catch {
    return null;
  }
  try {
    const r = JSON.parse(hU.decode(i));
    return r && typeof r == "object" && !Array.isArray(r) ? r : null;
  } catch {
    return null;
  } finally {
    i.fill(0);
  }
}
async function R$(e, t) {
  const n = L$(py(), e);
  if (n[t.id] !== void 0) return await C1(e, t, n[t.id]) ?? {};
  const a = t.previous;
  return a && n[a.id] !== void 0 ? await C1(e, a, n[a.id]) ?? {} : {};
}
async function AU(e, t, n) {
  const a = await R$(e, t);
  return Object.prototype.hasOwnProperty.call(a, n) ? a[n] : void 0;
}
const pf = /* @__PURE__ */ new Map();
async function EU(e, t, n, a) {
  const i = z$(n, a), l = (pf.get(e) ?? Promise.resolve()).catch(() => {
  }).then(() => CU(e, t, n, i));
  pf.set(e, l);
  try {
    await l;
  } finally {
    pf.get(e) === l && pf.delete(e);
  }
}
async function CU(e, t, n, a) {
  const i = { ...await R$(e, t) };
  a === void 0 ? delete i[n] : i[n] = JSON.parse(a);
  const r = L$(py(), e);
  t.previous && delete r[t.previous.id], Object.keys(i).length ? r[t.id] = await TU(e, t, i) : delete r[t.id];
  const l = E$();
  if (l !== void 0 && C$(JSON.stringify(r)) > l)
    throw new Sc(`an app keeps at most ${l} bytes, sealed, in an encrypted folder`);
  const c = { ...py(), [e]: r };
  Object.keys(r).length || delete c[e], Zi("appStateE2e", JSON.stringify(c));
}
class N$ extends Error {
  constructor() {
    super("the sealed app store needs the account this page is signed in as"), this.name = "LedgerNeedsAccount";
  }
}
async function I$(e, t, n) {
  const a = await $U(e, t, n);
  if (!a) throw new N$();
  return a;
}
class Ir extends Error {
  constructor(t) {
    super(`at most ${t >> 20} MiB in an encrypted folder`), this.limit = t, this.name = "TooLargeToHand";
  }
}
const Ol = Math.min(ya.maxEncryptedBytes, ec);
function zU(e, t) {
  return {
    vault: t ?? null,
    async open(n, a, i = Ol) {
      const r = e(n);
      if (!r)
        return await a.cancel().catch(() => {
        }), null;
      const l = Yv(r.fmk, r.previous, a, { passPlain: !0 }).getReader(), c = [];
      let p = 0;
      try {
        for (; ; ) {
          const { done: x, value: w } = await l.read();
          if (x) break;
          if (p += w.byteLength, p > i) throw new Ir(i);
          c.push(w);
        }
      } catch (x) {
        await l.cancel(x).catch(() => {
        });
        for (const w of c) w.fill(0);
        throw x;
      }
      const m = new Uint8Array(p);
      let v = 0;
      for (const x of c)
        m.set(x, v), v += x.byteLength, x.fill(0);
      return m;
    },
    async seal(n, a, i = Ol) {
      if (a.byteLength > i) throw new Ir(i);
      const r = e(n);
      return r ? Zv(r.fmk, a.buffer.byteLength === a.byteLength ? a.buffer : a.slice().buffer) : null;
    },
    async ledger(n, a) {
      const i = e(n);
      return i ? I$(i.fmk, a, i.previous) : null;
    },
    folderKeys(n) {
      return e(n);
    }
  };
}
class yp extends Error {
  constructor(t) {
    super(`vault: ${t}`), this.why = t, this.name = "VaultAppRefused";
  }
}
function MU(e) {
  if (e.buffer instanceof ArrayBuffer && e.byteOffset === 0 && e.byteLength === e.buffer.byteLength) return e;
  const t = new Uint8Array(e.byteLength);
  return t.set(e), e.fill(0), t;
}
function PU(e) {
  return {
    async read(t, n = Ol) {
      const a = await e.readForApp(t, n);
      if (a.ok) return { bytes: MU(a.bytes), sig: a.sig };
      if (a.why === "locked") return null;
      throw a.why === "too_large" ? new Ir(n) : new yp(a.why);
    },
    async save(t, n, a, i = Ol) {
      if (n.byteLength > i) throw new Ir(i);
      const r = await e.saveForApp(t, n, a);
      if (!r.ok) throw new yp(r.why);
      return { size: r.size, sig: r.sig };
    },
    async ledger(t, n) {
      const a = e.keyForApp(t);
      return a ? I$(a, n) : null;
    }
  };
}
const OU = {
  txt: "text/plain",
  md: "text/markdown",
  log: "text/plain",
  csv: "text/csv",
  json: "application/json",
  xml: "application/xml",
  html: "text/html",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  gif: "image/gif",
  webp: "image/webp",
  bmp: "image/bmp",
  avif: "image/avif",
  svg: "image/svg+xml",
  pdf: "application/pdf",
  mp4: "video/mp4",
  webm: "video/webm",
  mov: "video/quicktime",
  m4v: "video/mp4",
  mp3: "audio/mpeg",
  wav: "audio/wav",
  ogg: "audio/ogg",
  flac: "audio/flac",
  m4a: "audio/mp4",
  aac: "audio/aac",
  opus: "audio/opus"
};
function il(e) {
  return OU[(e || "").toLowerCase()] || "application/octet-stream";
}
const B$ = "files:e2e-plaintext";
function LU(e) {
  return !!e && e.includes(B$);
}
const bo = "builtin", Ll = "onlyoffice", DU = ["csv"];
function eh(e) {
  return DU.includes(String(e ?? "").toLowerCase());
}
function F$(e, t) {
  return !!e && e.type === "file" && (!!(t != null && t.inEncrypted) || sx(e));
}
function U$(e) {
  return `app:${e.plugin}/${e.id}`;
}
function z1(e) {
  return e ? e === bo || e === Ll || e.startsWith("app:") ? e : `app:${e}` : null;
}
function Rf(e) {
  return (e == null ? void 0 : e.id) === Ll;
}
function Lr(e) {
  return e ? String(Yy(e).ext ?? "").toLowerCase() : "";
}
function H$(e) {
  return e.filter((t) => t.placement === "viewer" && !!t.ui);
}
function RU(e, t) {
  return !t || t.type !== "file" ? [] : H$(e).filter((n) => Gy(n.applies ?? {}, [Yy(t, n.plugin)]));
}
function NU(e) {
  const t = il(e);
  return t === "application/octet-stream" ? "" : t;
}
function IU(e, t, n) {
  const a = NU(n);
  return H$(e).filter(
    (i) => {
      var r;
      return LU((r = i.ui) == null ? void 0 : r.grants) && Gy(i.applies ?? {}, [{ kind: "file", ext: n, mime: a, state: lx({ app_state: t.app_state }, i.plugin) }]);
    }
  );
}
function BU(e, t, n) {
  var p;
  const a = typeof t == "string" ? { name: t } : t, i = ap(a.name ?? ""), r = IU(e, a, i), l = r.length === 0 ? { on: [{ id: bo, view: null }], off: [], custom: !1 } : V$([...r.map((m) => ({ id: U$(m), view: m })), { id: bo, view: null }], (p = n == null ? void 0 : n.rules) == null ? void 0 : p[i]), c = typeof (n == null ? void 0 : n.personal) == "function" ? n.personal(i) : n == null ? void 0 : n.personal;
  return { ...l, kind: i, handler: j$(l.on, n == null ? void 0 : n.choice, c) };
}
function FU(e, t) {
  if (!(t != null && t.e2ePlaintext) || e.type !== "file" || e.encrypted === "vault" || e.encrypted === "file") return !1;
  const n = e.e2e_name_state;
  return n === void 0 || n === "enc" || n === "plain";
}
function UU(e) {
  return { name: String(e.basename ?? ""), ...Array.isArray(e.app_state) ? { app_state: e.app_state } : {} };
}
function HU(e) {
  return !!e && typeof e.e2e_stored == "string";
}
function KU(e, t) {
  return !!(t != null && t.e2ePlaintext) && e.type === "file" && e.encrypted === "vault";
}
function K$(e, t, n, a) {
  if (!t || t.type !== "file") return { on: [], off: [], custom: !1 };
  if (F$(t, a)) {
    if (!(t.encrypted === "vault" ? KU(t, a) : FU(t, a))) return { on: [{ id: bo, view: null }], off: [], custom: !1 };
    const { on: l, off: c, custom: p } = BU(e, UU(t), { rules: n });
    return { on: l, off: c, custom: p };
  }
  const i = [
    ...a != null && a.onlyOffice && eh(Lr(t)) ? [{ id: Ll, view: null }] : [],
    ...RU(e, t).map((r) => ({ id: U$(r), view: r })),
    { id: bo, view: null }
  ];
  return V$(i, n == null ? void 0 : n[Lr(t)]);
}
function V$(e, t) {
  if (!t) return { on: e, off: [], custom: !1 };
  const n = new Set(t.off ?? []), a = new Map(e.map((c) => [c.id, c])), i = /* @__PURE__ */ new Set(), r = [];
  for (const c of t.order ?? []) {
    const p = a.get(c);
    !p || n.has(c) || i.has(c) || (i.add(c), r.push(p));
  }
  const l = [];
  for (const c of e)
    n.has(c.id) ? l.push(c) : i.has(c.id) || r.push(c);
  return { on: r, off: l, custom: !0 };
}
function qu(e, t, n, a, i, r) {
  return !t || t.type !== "file" ? null : j$(VU(K$(e, t, a, r).on, t, r), n, i);
}
function VU(e, t, n) {
  const a = Lr(t);
  return n != null && n.onlyOffice || !Tv(a) || eh(a) || !e.some((i) => i.view) ? e : e.filter((i) => i.id !== bo);
}
function j$(e, t, n) {
  const a = (i) => i ? e.find((r) => r.id === i) ?? null : null;
  return a(z1(t)) ?? a(z1(n)) ?? e[0] ?? null;
}
function ahe(e, t, n, a, i, r) {
  var l;
  return ((l = qu(e, t, n, a, i, r)) == null ? void 0 : l.view) ?? null;
}
const jU = "X-Filex-Version";
function qU(e) {
  const t = /^(\d{1,15}):(\d{1,15})$/.exec((e ?? "").trim());
  if (t)
    return { size: Number(t[1]), modified: Number(t[2]) };
}
const WU = /^[a-z0-9]{2,8}$/;
function YU(e) {
  const t = {}, n = e == null ? void 0 : e.beside;
  if (n != null && n !== "") {
    if (typeof n != "string") return null;
    const i = n.trim().replace(/^\./, "").toLowerCase();
    if (!WU.test(i)) return null;
    t.beside = i;
  }
  const a = e == null ? void 0 : e.conflict;
  if (a != null) {
    if (a !== "copy") return null;
    t.conflict = "copy";
  }
  return t;
}
const Lg = 32, GU = "", XU = ["changes", "lock", "release"], yl = 12, q$ = "filex-oo-sk-v1", W$ = "filex-oo-v1", Y$ = "filex-oo-eph-v1", G$ = "filex-oo-blob-v1", JU = "filex-oo-log", ZU = "filex-oo-eph", QU = "filex-oo-blob";
function ko(e) {
  return new Uint8Array(e).buffer;
}
const $c = new TextEncoder(), eH = new TextDecoder("utf-8", { fatal: !0 });
function ar(e, ...t) {
  return ko($c.encode(JSON.stringify([e, ...t])));
}
async function th(e, t, n) {
  const a = crypto.getRandomValues(new Uint8Array(yl)), i = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: ko(a), additionalData: n }, e, ko(t))
  ), r = new Uint8Array(yl + i.length);
  return r.set(a, 0), r.set(i, yl), r;
}
async function nh(e, t, n) {
  if (t.length <= yl) return null;
  try {
    const a = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv: ko(t.slice(0, yl)), additionalData: n },
      e,
      ko(t.slice(yl))
    );
    return new Uint8Array(a);
  } catch {
    return null;
  }
}
function ah(e) {
  try {
    return ea(e);
  } catch {
    return null;
  }
}
function X$(e) {
  try {
    return JSON.parse(eH.decode(e));
  } catch {
    return;
  }
}
function tH() {
  return crypto.getRandomValues(new Uint8Array(Lg));
}
async function nH(e, t, n) {
  if (t.length !== Lg) throw new Error("e2eoffice: a session key is 32 bytes");
  return Ma(await th(e, t, ar(q$, n.sid, n.file)));
}
async function aH(e, t, n) {
  const a = ah(t);
  if (!a) return null;
  const i = await nh(e, a, ar(q$, n.sid, n.file));
  if (!i || i.length !== Lg) return null;
  try {
    return await hy(i, n.sid);
  } finally {
    i.fill(0);
  }
}
async function hy(e, t) {
  const n = await crypto.subtle.importKey("raw", ko(e), "HKDF", !1, ["deriveKey"]), a = (c) => crypto.subtle.deriveKey(
    { name: "HKDF", hash: "SHA-256", salt: ko($c.encode(t)), info: ko($c.encode(c)) },
    n,
    { name: "AES-GCM", length: 256 },
    !1,
    ["encrypt", "decrypt"]
  ), [i, r, l] = await Promise.all([a(JU), a(ZU), a(QU)]);
  return { log: i, eph: r, blob: l };
}
async function iH(e, t, n, a) {
  const i = $c.encode(JSON.stringify({ p: n, b: a }));
  return Ma(await th(e, i, ar(W$, t.sid, t.seq, t.client, t.ctr, t.kind)));
}
async function oH(e, t, n) {
  const a = ah(n);
  if (!a) return null;
  const i = await nh(e, a, ar(W$, t.sid, t.seq, t.client, t.ctr, t.kind));
  if (!i) return null;
  const r = X$(i);
  if (!r || typeof r != "object" || Array.isArray(r)) return null;
  const l = r;
  return typeof l.p != "string" ? null : { prev: l.p, body: l.b };
}
async function rH(e) {
  const t = ah(e) ?? new Uint8Array(0), n = new Uint8Array(await crypto.subtle.digest("SHA-256", ko(t)));
  return Array.from(n, (a) => a.toString(16).padStart(2, "0")).join("");
}
const sH = ["join", "leave", "saved"];
class lH {
  constructor(t, n, a = 0, i = GU) {
    Nt(this, "seq");
    Nt(this, "last");
    Nt(this, "ctrs", /* @__PURE__ */ new Map());
    Nt(this, "failed", null);
    this.key = t, this.sid = n, this.seq = a, this.last = i;
  }
  /** The last entry taken. */
  get head() {
    return this.seq;
  }
  /** What the next sealed entry has to name as `prev`. */
  get digest() {
    return this.last;
  }
  /** The counter a writer used last (0 = none yet). */
  counter(t) {
    return this.ctrs.get(t) ?? 0;
  }
  async read(t) {
    const n = (r) => (this.failed = r, { ok: !1, seq: t.seq, problem: r });
    if (this.failed) return { ok: !1, seq: t.seq, problem: this.failed };
    if (t.seq !== this.seq + 1) return n("gap");
    if (sH.includes(t.kind))
      return this.seq = t.seq, { ok: !0, seq: t.seq, kind: t.kind, client: t.client };
    if (!XU.includes(t.kind)) return n("kind");
    const a = t.ctr ?? 0;
    if (typeof t.ct != "string" || a < 1) return n("forged");
    const i = await oH(
      this.key,
      { sid: this.sid, seq: t.seq, client: t.client, ctr: a, kind: t.kind },
      t.ct
    );
    return i ? i.prev !== this.last ? n("chain") : a <= this.counter(t.client) ? n("replay") : (this.ctrs.set(t.client, a), this.last = await rH(t.ct), this.seq = t.seq, { ok: !0, seq: t.seq, kind: t.kind, client: t.client, body: i.body }) : n("forged");
  }
}
async function uH(e, t, n) {
  const a = $c.encode(JSON.stringify(n));
  return Ma(await th(e, a, ar(Y$, t.sid, t.client, t.ctr)));
}
async function cH(e, t, n) {
  const a = ah(n);
  if (!a) return;
  const i = await nh(e, a, ar(Y$, t.sid, t.client, t.ctr));
  return i ? X$(i) : void 0;
}
function dH(e, t, n) {
  return th(e, n, ar(G$, t.sid, t.name));
}
function fH(e, t, n) {
  return nh(e, n, ar(G$, t.sid, t.name));
}
function gp() {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  let n = 0;
  return {
    async add(a) {
      const i = ++n;
      return e.set(i, { ...a, id: i }), i;
    },
    async remove(a) {
      e.delete(a);
    },
    async listPath(a) {
      return [...e.values()].filter((i) => i.path === a).sort((i, r) => (i.id ?? 0) - (r.id ?? 0));
    },
    hold(a) {
      t.set(a, (t.get(a) ?? 0) + 1);
      let i = !1;
      return () => {
        if (i) return;
        i = !0;
        const r = (t.get(a) ?? 1) - 1;
        r > 0 ? t.set(a, r) : t.delete(a);
      };
    },
    async live(a) {
      return t.has(a);
    }
  };
}
const pH = "filex-coedit", Ko = "outbox", M1 = "filex-coedit-member:";
function P1() {
  try {
    return typeof navigator < "u" && navigator.locks ? navigator.locks : void 0;
  } catch {
    return;
  }
}
function ev(e) {
  return new Promise((t, n) => {
    e.onsuccess = () => t(e.result), e.onerror = () => n(e.error);
  });
}
function hH() {
  const e = gp(), t = gp();
  let n = null;
  const a = () => (n || (n = new Promise((i) => {
    try {
      if (typeof indexedDB > "u") return i(null);
      const r = indexedDB.open(pH, 1);
      r.onupgradeneeded = () => {
        r.result.createObjectStore(Ko, { keyPath: "id", autoIncrement: !0 }).createIndex("by_path", "path");
      }, r.onsuccess = () => {
        const l = r.result;
        if (l.objectStoreNames.contains(Ko)) return i(l);
        l.close(), i(null);
      }, r.onerror = () => i(null), r.onblocked = () => i(null);
    } catch {
      i(null);
    }
  })), n);
  return {
    async add(i) {
      const r = await a();
      if (!r) return e.add(i);
      const l = r.transaction(Ko, "readwrite"), { id: c, ...p } = i;
      return Number(await ev(l.objectStore(Ko).add(p)));
    },
    async remove(i) {
      const r = await a();
      if (!r) return e.remove(i);
      await ev(r.transaction(Ko, "readwrite").objectStore(Ko).delete(i));
    },
    async listPath(i) {
      const r = await a();
      return r ? (await ev(r.transaction(Ko, "readonly").objectStore(Ko).index("by_path").getAll(i))).sort((c, p) => (c.id ?? 0) - (p.id ?? 0)) : e.listPath(i);
    },
    hold(i) {
      const r = t.hold(i), l = P1();
      if (!l || !i) return r;
      let c = () => {
      };
      const p = new Promise((m) => c = m);
      return l.request(M1 + i, () => p).catch(() => {
      }), () => {
        r(), c();
      };
    },
    async live(i) {
      if (!i) return !1;
      if (await t.live(i)) return !0;
      const r = P1();
      if (!r) return !1;
      try {
        return await r.request(M1 + i, { ifAvailable: !0 }, (l) => l === null);
      } catch {
        return !1;
      }
    }
  };
}
const gl = 12, mH = "filex-coedit-outbox-v1", J$ = new TextEncoder();
function Z$(e) {
  return new Uint8Array(J$.encode(JSON.stringify([mH, e]))).buffer;
}
async function vH(e, t, n) {
  const a = crypto.getRandomValues(new Uint8Array(gl)), i = J$.encode(JSON.stringify(n)), r = new Uint8Array(await crypto.subtle.encrypt({ name: "AES-GCM", iv: a, additionalData: Z$(t) }, e, i));
  i.fill(0);
  const l = new Uint8Array(gl + r.length);
  return l.set(a, 0), l.set(r, gl), Ma(l);
}
async function yH(e, t, n) {
  let a;
  try {
    a = ea(n);
  } catch {
    return;
  }
  if (!(a.length <= gl))
    for (const i of e)
      try {
        const r = await crypto.subtle.decrypt(
          { name: "AES-GCM", iv: a.slice(0, gl), additionalData: Z$(t) },
          i,
          a.slice(gl)
        );
        return JSON.parse(new TextDecoder().decode(r));
      } catch {
      }
}
const gH = [1e3, 2e3, 4e3, 8e3, 15e3, 3e4];
function O1(e) {
  const t = ol(e);
  return t ? t.status === 0 ? !0 : t.code === "coedit_off" || t.code === "coedit_no_secret_key" ? !1 : t.status === 502 || t.status === 503 || t.status === 504 : (e == null ? void 0 : e.said) === !0;
}
const L1 = 1;
function ol(e) {
  const t = e ?? {};
  if (typeof t.status != "number") return null;
  let n;
  if (typeof t.detail == "string")
    try {
      const a = JSON.parse(t.detail);
      typeof a.head == "number" && (n = a.head);
    } catch {
    }
  return { status: t.status, code: typeof t.code == "string" ? t.code : "", head: n };
}
function Cr(e) {
  if (e instanceof ct) return e;
  const t = ol(e);
  if (!t) return new ct("failed", "failed");
  switch (t.code) {
    case "coedit_read_only":
      return new ct("read_only", "read_only");
    case "coedit_too_large":
      return new ct("too_large", "too_large");
    case "coedit_no_blob":
      return new ct("not_found", "not_found");
    case "coedit_blob_exists":
      return new ct("failed", "exists");
    case "coedit_no_lease":
    case "coedit_log_full":
    case "coedit_save_order":
    case "coedit_conflict":
      return new ct("failed", t.code.slice(7));
    case "coedit_gone":
    case "coedit_not_ready":
    case "coedit_nothing_to_watch":
    case "coedit_busy":
      return new ct("unavailable", t.code.slice(7));
    case "coedit_off":
    case "coedit_no_secret_key":
    case "coedit_build":
    case "coedit_file_changed":
    case "coedit_full":
    case "encrypted":
      return new ct("unavailable", t.code);
    case "not_granted":
      return new ct("not_granted", "not_granted");
    case "coedit_invalid":
    case "bad_json":
      return new ct("invalid", "invalid");
  }
  return t.status === 404 ? new ct("not_found", t.code || "not_found") : new ct("failed", /^[a-z][a-z0-9_]{0,39}$/.test(t.code) ? t.code : "failed");
}
const bH = ["changes", "lock", "release"];
function kH(e) {
  try {
    return JSON.parse(e);
  } catch {
    return;
  }
}
function D1(e) {
  if (!e || typeof e != "object") return null;
  const t = e;
  return typeof t.client != "string" ? null : {
    client: t.client,
    user: typeof t.user == "string" ? t.user : "",
    name: typeof t.name == "string" ? t.name : "",
    indexUser: typeof t.index_user == "number" ? t.index_user : 0,
    canEdit: t.can_edit === !0
  };
}
class bp {
  constructor(t, n, a, i, r, l, c, p) {
    Nt(this, "reader");
    Nt(this, "t");
    /** The app subscribed from here (null: not yet - entries wait). */
    Nt(this, "from", null);
    /** Entries read before the app subscribed. */
    Nt(this, "held", []);
    /** Entries waiting to be read, in order (the reader takes one at a time). */
    Nt(this, "inbox", []);
    Nt(this, "reading", !1);
    Nt(this, "sock", null);
    Nt(this, "closed", !1);
    Nt(this, "broken", !1);
    Nt(this, "ctr", 0);
    Nt(this, "ephCtr", 0);
    Nt(this, "ephSeen", /* @__PURE__ */ new Map());
    Nt(this, "appending", Promise.resolve());
    Nt(this, "waiters", []);
    /** What the socket said of each entry besides what the reader checks. */
    Nt(this, "extras", /* @__PURE__ */ new Map());
    Nt(this, "cursorTimer", null);
    Nt(this, "cursorNext", null);
    Nt(this, "cursorLast", 0);
    Nt(this, "reconnectDelay", 1e3);
    /** The seq of the last `changes` entry the reader took. */
    Nt(this, "changesSeen", 0);
    Nt(this, "outbox");
    Nt(this, "doc", "");
    Nt(this, "owner", "");
    /** The file's path as the host named it (where its kept changes are found). */
    Nt(this, "path", "");
    /** Releases this member's lock (lib/coeditOutbox `hold`). */
    Nt(this, "release", null);
    this.transport = t, this.ev = n, this.sid = a, this.me = i, this.token = r, this.keys = l, this.info = c, this.reader = new lH(l.log, a), this.t = {
      catchUpMs: 15e3,
      cursorGapMs: 200,
      ...p
    }, this.outbox = p.outbox ?? gp();
  }
  /**
   * Join (or start) the session of the file at `path`. A session whose
   * creator has not stored the base yet is asked again for a while, then
   * `unavailable` (`not_ready`).
   */
  static async join(t, n, a, i = {}) {
    const r = Date.now() + (i.readyWaitMs ?? 2e4), l = (z) => new Promise((D) => (i.setTimeout ?? setTimeout)(D, z)), c = i.outbox ?? gp(), p = await c.listPath(n).catch(() => []), m = [];
    for (const z of p) await c.live(z.client).catch(() => !1) || m.push(z);
    const v = {};
    i.folder && (v.e2e = !0), m.length > 0 && (v.unsent = { count: m.length });
    let x;
    for (; ; )
      try {
        x = await t.join(n, v);
        break;
      } catch (z) {
        const D = ol(z);
        if ((D == null ? void 0 : D.code) === "coedit_not_ready" && Date.now() < r) {
          await l(1e3);
          continue;
        }
        throw Cr(z);
      }
    const w = String(x.session ?? ""), $ = D1(x.me), k = String(x.token ?? "");
    if (!/^[0-9a-f]{32}$/.test(w) || !$ || !k) throw new ct("failed", "failed");
    const b = String(x.doc ?? ""), C = await bp.keysOf(t, x, w, $.client, k, b, i), T = new bp(t, a, w, $, k, C, {
      head: Number(x.head ?? 0),
      changesHead: Number(x.changes_head ?? 0),
      savedThrough: Number(x.saved_through ?? 0),
      created: x.created === !0
    }, i);
    T.doc = b, T.owner = String(x.owner ?? ""), T.path = n, T.release = c.hold($.client);
    const E = x.socket ?? {};
    T.connect(String(E.url ?? ""), String(E.ticket ?? ""));
    const R = m.filter((z) => z.doc === T.doc && z.owner === T.owner && T.owner !== "");
    if (R.length > 0) {
      const z = x.unsent_words ?? {};
      await T.recover(R, Number(x.head ?? 0), z);
    }
    return T;
  }
  /**
   * The session's three keys. An ordinary folder: the server's key, handed
   * over. An encrypted folder (KeyFolder): the member that started the
   * session makes the key here, seals it with the folder key and gives the
   * server only that; a member that joins opens the one the starter sealed.
   */
  static async keysOf(t, n, a, i, r, l, c) {
    if (n.key_mode === "server" && typeof n.key == "string") {
      const x = ea(n.key);
      try {
        return await hy(x, a);
      } finally {
        x.fill(0);
      }
    }
    if (n.key_mode !== "folder" || !c.folder || !l) throw new ct("unavailable", "encrypted");
    const p = c.folder();
    if (!p) throw new ct("unavailable", "locked");
    const m = { sid: a, file: l };
    if (n.created === !0) {
      const x = tH();
      try {
        const w = await nH(p.fmk, x, m);
        try {
          await t.call(a, "key", { client: i, token: r, sealed: w });
        } catch ($) {
          throw Cr($);
        }
        return await hy(x, a);
      } finally {
        x.fill(0);
      }
    }
    const v = typeof n.sealed_key == "string" ? n.sealed_key : "";
    for (const x of [p.fmk, p.previous]) {
      if (!x || !v) continue;
      const w = await aH(x, v, m);
      if (w) return w;
    }
    throw new ct("failed", "forged");
  }
  /**
   * The changes of an earlier opening, kept in this browser (lib/coeditOutbox):
   * sent at once when they are this session's and nobody changed the
   * document since; otherwise the person is asked (the server's words), and
   * they are sent on top of what is there now, or thrown away. Sent before
   * the interface reads the log, so its editor opens with them in it.
   */
  async recover(t, n, a) {
    var x, w;
    try {
      await this.until(n);
    } catch {
      return;
    }
    const i = t[0], r = i.sid === this.sid && i.changesBase === this.changesSeen;
    let l = r;
    if (!r) {
      const $ = String((i.sid === this.sid ? a.behind : a.ended) ?? "");
      if (!$ || !this.t.askUnsent) return;
      const k = await this.t.askUnsent({ text: $, apply: String(a.apply ?? ""), discard: String(a.discard ?? "") }).catch(() => null);
      if (k === null) return;
      l = k;
    }
    if (!l) {
      for (const $ of t) $.id !== void 0 && await this.outbox.remove($.id).catch(() => {
      });
      return;
    }
    const c = ((w = (x = this.t).folder) == null ? void 0 : w.call(x)) ?? null, p = c ? [c.fmk, c.previous].filter(($) => !!$) : [];
    let m = !1, v = 0;
    try {
      for (const $ of t) {
        const k = $.sealed ? await yH(p, $.doc, $.body) : kH($.body);
        if ($.id !== void 0 && await this.outbox.remove($.id).catch(() => {
        }), k !== void 0) {
          if (m = m || await this.takeLease(), !m) {
            await this.keep("changes", k);
            continue;
          }
          v = (await this.append("changes", k)).seq;
        }
      }
    } finally {
      m && await this.lease("release", this.changesSeen).catch(() => !1);
    }
    v > 0 && (await this.until(v).catch(() => {
    }), this.info.head = Math.max(this.info.head, v), this.info.changesHead = Math.max(this.info.changesHead, v));
  }
  /** The lease for the changes being recovered, a few tries while another writer holds it. */
  async takeLease() {
    for (let t = 0; t < 10 && !this.closed; t++) {
      if (await this.lease("acquire", this.changesSeen).catch(() => !1)) return !0;
      await new Promise((n) => (this.t.setTimeout ?? setTimeout)(n, 1e3));
    }
    return !1;
  }
  /** What `coedit.join` answers the interface. */
  hello() {
    return { session: this.sid, me: { ...this.me }, ...this.info };
  }
  /** The query a save made in this session adds (`file.save`'s `through`). */
  saveParams(t) {
    return this.closed || !Number.isInteger(t) || t < 0 || t > this.reader.head ? null : { coedit: this.sid, client: this.me.client, token: this.token, through: String(t) };
  }
  /** The entries after `from` go to the interface, in order, then each new one. */
  subscribe(t) {
    if (!Number.isInteger(t) || t < 0) throw new ct("invalid", "from is an entry seq");
    this.from = t;
    const n = this.held;
    this.held = [];
    for (const a of n) a.seq > t && this.ev.entry(a);
  }
  /** Seal an entry at the place this page read last and have the relay place it. */
  append(t, n) {
    if (!bH.includes(t)) return Promise.reject(new ct("invalid", "kind is changes, lock or release"));
    const a = this.appending.then(() => this.place(t, n));
    return this.appending = a.catch(() => {
    }), a;
  }
  async place(t, n) {
    const a = t === "changes" ? await this.keep(t, n) : void 0, i = () => a !== void 0 ? this.outbox.remove(a).catch(() => {
    }) : void 0, r = this.t.retryMs ?? gH;
    let l = 0;
    for (let c = 0; c < 50; ) {
      if (this.closed || this.broken) throw new ct("unavailable", this.broken ? "broken" : "gone");
      const p = this.reader.head, m = ++this.ctr, v = await iH(this.keys.log, { sid: this.sid, seq: p + 1, client: this.me.client, ctr: m, kind: t }, this.reader.digest, n);
      try {
        const x = await this.transport.call(this.sid, "append", { client: this.me.client, token: this.token, kind: t, base: p, ctr: m, ct: v });
        return await i(), { seq: Number(x.seq ?? p + 1) };
      } catch (x) {
        const w = ol(x);
        if ((w == null ? void 0 : w.code) === "coedit_conflict" && typeof w.head == "number") {
          c++, await this.until(w.head);
          continue;
        }
        if (O1(x)) {
          await new Promise(($) => (this.t.setTimeout ?? setTimeout)($, r[Math.min(l, r.length - 1)])), l++;
          continue;
        }
        throw (w == null ? void 0 : w.code) === "coedit_gone" ? (this.gone(), Cr(x)) : (await i(), Cr(x));
      }
    }
    throw new ct("unavailable", "busy");
  }
  /** Keep a change in this browser (sealed in an encrypted folder); its record's id. */
  async keep(t, n) {
    var l, c;
    if (t !== "changes" || !this.doc || !this.owner || !this.me.canEdit) return;
    const a = ((c = (l = this.t).folder) == null ? void 0 : c.call(l)) ?? null;
    let i, r = !1;
    if (this.t.folder) {
      if (!a) return;
      i = await vH(a.fmk, this.doc, n), r = !0;
    } else
      i = JSON.stringify(n);
    try {
      return await this.outbox.add({
        doc: this.doc,
        owner: this.owner,
        sid: this.sid,
        client: this.me.client,
        path: this.path,
        changesBase: this.changesSeen,
        at: Date.now(),
        body: i,
        sealed: r
      });
    } catch {
      return;
    }
  }
  /** Resolves once the reader has taken entry `head` (or fails after catchUpMs). */
  until(t) {
    return this.reader.head >= t ? Promise.resolve() : new Promise((n, a) => {
      const i = this.t.setTimeout ?? setTimeout, r = this.t.clearTimeout ?? ((p) => clearTimeout(p)), l = {
        head: t,
        done: () => {
          r(c), n();
        },
        fail: (p) => {
          r(c), a(p);
        }
      }, c = i(() => {
        const p = this.waiters.indexOf(l);
        p >= 0 && this.waiters.splice(p, 1), a(new ct("unavailable", "behind"));
      }, this.t.catchUpMs);
      this.waiters.push(l);
    });
  }
  /** The changes lease: one writer at a time, and only one that has seen every change. */
  async lease(t, n) {
    var a;
    if (t !== "acquire" && t !== "release") throw new ct("invalid", "op is acquire or release");
    try {
      return (await this.transport.call(this.sid, "lease", { client: this.me.client, token: this.token, op: t, changes_seen: n })).granted === !0;
    } catch (i) {
      if (O1(i)) return !1;
      throw ((a = ol(i)) == null ? void 0 : a.code) === "coedit_gone" && this.gone(), Cr(i);
    }
  }
  /** A cursor for the others: sealed, not kept, a few a second at most (the last one wins). */
  cursor(t) {
    if (this.closed || !this.me.canEdit || (this.cursorNext = { cursor: t }, this.cursorTimer !== null)) return;
    const n = Math.max(0, this.cursorLast + this.t.cursorGapMs - Date.now()), a = this.t.setTimeout ?? setTimeout;
    this.cursorTimer = a(() => {
      this.cursorTimer = null;
      const i = this.cursorNext;
      this.cursorNext = null, i && this.sendCursor(i.cursor);
    }, n);
  }
  async sendCursor(t) {
    if (!this.sock || this.sock.readyState !== L1) return;
    this.cursorLast = Date.now();
    const n = ++this.ephCtr, a = await uH(this.keys.eph, { sid: this.sid, client: this.me.client, ctr: n }, t);
    this.sock && this.sock.readyState === L1 && this.sock.send(JSON.stringify({ type: "cursor", ctr: n, ct: a }));
  }
  /** Seal and store a blob of the session (the base document, an image). */
  async putBlob(t, n) {
    if (!/^[A-Za-z0-9._-]{1,128}$/.test(t)) throw new ct("invalid", "a blob name");
    const a = await dH(this.keys.blob, { sid: this.sid, name: t }, new Uint8Array(n));
    try {
      await this.transport.putBlob(this.sid, t, { client: this.me.client, token: this.token }, a);
    } catch (i) {
      throw Cr(i);
    }
  }
  /** Read and open a blob of the session. */
  async getBlob(t) {
    if (!/^[A-Za-z0-9._-]{1,128}$/.test(t)) throw new ct("invalid", "a blob name");
    let n;
    try {
      n = await this.transport.getBlob(this.sid, t, { client: this.me.client, token: this.token });
    } catch (i) {
      throw Cr(i);
    }
    const a = await fH(this.keys.blob, { sid: this.sid, name: t }, new Uint8Array(n));
    if (!a) throw new ct("failed", "forged");
    return a.buffer.slice(a.byteOffset, a.byteOffset + a.byteLength);
  }
  /** Leave the session. `keepalive` for a page that is going away. */
  async leave(t = {}) {
    if (!this.closed) {
      this.close();
      try {
        await this.transport.call(this.sid, "leave", { client: this.me.client, token: this.token }, t);
      } catch {
      }
    }
  }
  /** Stop: no socket, no event, nothing waits. */
  close() {
    var n;
    this.closed = !0, (n = this.release) == null || n.call(this), this.release = null;
    const t = this.sock;
    if (this.sock = null, t) {
      t.onclose = null, t.onmessage = null;
      try {
        t.close(1e3);
      } catch {
      }
    }
    this.cursorTimer !== null && (this.t.clearTimeout ?? ((a) => clearTimeout(a)))(this.cursorTimer), this.cursorTimer = null;
  }
  // -------------------------------------------------------------------------
  // The socket
  // -------------------------------------------------------------------------
  connect(t, n) {
    if (this.closed || !t || !n) return;
    const a = this.t.socket ?? ((r) => new WebSocket(r));
    let i;
    try {
      i = a(`${t}${t.includes("?") ? "&" : "?"}ticket=${encodeURIComponent(n)}`);
    } catch {
      this.reconnectLater();
      return;
    }
    this.sock = i, i.onopen = () => {
      this.reconnectDelay = 1e3, i.send(JSON.stringify({ type: "subscribe", from: this.reader.head + this.inbox.length }));
    }, i.onmessage = (r) => this.onFrame(r.data), i.onclose = () => {
      this.sock === i && (this.sock = null), this.reconnectLater();
    }, i.onerror = () => {
    };
  }
  reconnectLater() {
    if (this.closed || this.broken) return;
    const t = this.reconnectDelay;
    this.reconnectDelay = Math.min(this.reconnectDelay * 2, 3e4), (this.t.setTimeout ?? setTimeout)(() => void this.reconnect(), t);
  }
  async reconnect() {
    var t;
    if (!(this.closed || this.broken || this.sock))
      try {
        const n = await this.transport.call(this.sid, "ticket", { client: this.me.client, token: this.token });
        this.connect(String(n.url ?? ""), String(n.ticket ?? ""));
      } catch (n) {
        if (((t = ol(n)) == null ? void 0 : t.code) === "coedit_gone") {
          this.gone();
          return;
        }
        this.reconnectLater();
      }
  }
  onFrame(t) {
    if (this.closed || typeof t != "string") return;
    let n;
    try {
      n = JSON.parse(t);
    } catch {
      return;
    }
    switch (n.type) {
      case "entry":
        n.entry && this.take(n.entry);
        return;
      case "eph":
        this.takeCursor(n);
        return;
      case "ended":
        n.reason === "broken" ? this.stopBroken() : this.gone();
        return;
    }
  }
  take(t) {
    if (typeof t.seq != "number" || typeof t.kind != "string" || typeof t.client != "string") return;
    const n = this.reader.head + this.inbox.length;
    if (t.seq <= n) return;
    this.inbox.push({ seq: t.seq, kind: t.kind, client: t.client, ctr: t.ctr, ct: t.ct });
    const a = { at: typeof t.at == "number" ? t.at : 0, member: t.member, through: t.through };
    this.extras.set(t.seq, a), this.drain();
  }
  async drain() {
    if (!this.reading) {
      this.reading = !0;
      try {
        for (; this.inbox.length > 0 && !this.closed && !this.broken; ) {
          const t = this.inbox.shift(), n = this.extras.get(t.seq) ?? { at: 0 };
          this.extras.delete(t.seq);
          const a = await this.reader.read(t);
          if (!a.ok) {
            this.stopBroken();
            return;
          }
          a.kind === "changes" && (this.changesSeen = a.seq);
          const i = this.entryOf(a.seq, a.kind, a.client, a.body, n);
          i && (this.from === null ? this.held.push(i) : i.seq > this.from && this.ev.entry(i));
          for (const r of [...this.waiters])
            this.reader.head >= r.head && (this.waiters.splice(this.waiters.indexOf(r), 1), r.done());
        }
      } finally {
        this.reading = !1;
      }
    }
  }
  entryOf(t, n, a, i, r) {
    const l = { seq: t, at: r.at, client: a };
    switch (n) {
      case "join": {
        const c = D1(r.member);
        return c ? { ...l, kind: "join", member: c } : null;
      }
      case "leave":
        return { ...l, kind: "leave" };
      case "saved":
        return { ...l, kind: "saved", through: typeof r.through == "number" ? r.through : 0 };
      case "changes":
      case "lock":
      case "release":
        return { ...l, kind: n, body: i };
    }
    return null;
  }
  async takeCursor(t) {
    if (typeof t.client != "string" || typeof t.ctr != "number" || typeof t.ct != "string" || t.client === this.me.client || t.ctr <= (this.ephSeen.get(t.client) ?? 0)) return;
    this.ephSeen.set(t.client, t.ctr);
    const n = await cH(this.keys.eph, { sid: this.sid, client: t.client, ctr: t.ctr }, t.ct);
    n === void 0 || this.closed || this.ev.cursor({ client: t.client, cursor: n });
  }
  /** The membership ended: say so once, stop. */
  gone() {
    if (this.closed) return;
    const t = this.reader.head;
    this.close(), this.rejectWaiters("gone"), this.ev.dropped({ from: t, reason: "gone" });
  }
  /** The log stopped checking out: the editors would build different documents. */
  stopBroken() {
    if (this.broken || this.closed) return;
    this.broken = !0;
    const t = this.reader.head;
    this.close(), this.rejectWaiters("broken"), this.ev.dropped({ from: t, reason: "broken" });
  }
  rejectWaiters(t) {
    for (const n of this.waiters.splice(0)) n.fail(new ct("unavailable", t));
  }
}
const wH = { "data-testid": "plugin-confirm-message" }, Q$ = /* @__PURE__ */ lt({
  __name: "PluginConfirmModal",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    title: {},
    message: {},
    danger: { type: Boolean }
  },
  emits: ["close", "confirm"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale);
    return (r, l) => (f(), Ge(ta, {
      open: e.open,
      title: e.title || u(i)("plugin.confirm.title"),
      size: "sm",
      theme: e.theme,
      locale: e.locale,
      onClose: l[2] || (l[2] = (c) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          onClick: l[0] || (l[0] = (c) => a("close"))
        }, y(u(i)("plugin.confirm.cancel")), 1),
        d("button", {
          type: "button",
          class: Re(["fe-btn", e.danger ? "fe-btn--danger" : "fe-btn--primary"]),
          "data-testid": "plugin-confirm-run",
          onClick: l[1] || (l[1] = (c) => a("confirm"))
        }, y(u(i)("plugin.confirm.run")), 3)
      ]),
      default: mt(() => [
        d("p", wH, y(e.message), 1)
      ]),
      _: 1
    }, 8, ["open", "title", "theme", "locale"]));
  }
}), _H = ["data-app", "data-connected"], xH = {
  key: 0,
  class: "fe-appframe__note",
  role: "status",
  "data-testid": "appframe-updated"
}, SH = { class: "fe-appframe__note-text" }, $H = {
  key: 1,
  class: "fe-appframe__note fe-appframe__consent fe-appframe__over",
  role: "alertdialog",
  "aria-live": "assertive",
  "data-testid": "appframe-unsent"
}, TH = { class: "fe-appframe__note-text" }, AH = {
  key: 2,
  class: "fe-appframe__note fe-appframe__consent",
  role: "alertdialog",
  "aria-live": "assertive",
  "data-testid": "appframe-consent"
}, EH = { class: "fe-appframe__note-text" }, CH = ["disabled"], zH = ["role", "aria-live", "aria-hidden", "inert", "data-shown"], MH = { class: "fe-appframe__note-text" }, PH = { "data-testid": "appframe-unsaved" }, OH = ["disabled"], LH = ["disabled"], DH = ["disabled"], R1 = 5e3, N1 = 600, Dg = /* @__PURE__ */ lt({
  __name: "AppFrame",
  props: {
    api: {},
    app: {},
    version: {},
    view: {},
    placement: {},
    ui: {},
    files: {},
    savePath: {},
    readOnly: { type: Boolean },
    locale: {},
    theme: {},
    userName: {},
    title: {},
    storages: {},
    startAt: {},
    e2e: {}
  },
  emits: ["connected", "dirty", "title", "toast", "close", "saved", "saved-as", "op"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, { t: r } = ht(() => a.locale), l = Nl(), c = S(null);
    let p = null, m = null;
    const v = S(!1), x = S(!1), w = S(null), $ = S(!1), k = S(0), b = S(null), C = A(() => b.value ?? a.ui), T = S(""), E = S(""), R = A(() => a.api.appUIUrl(C.value.url)), z = A(() => new Set(C.value.grants ?? [])), D = A(() => {
      var Z;
      return ((Z = b.value) == null ? void 0 : Z.version) || a.version || a.ui.version || "";
    }), U = A(
      () => a.theme === "dark" || a.theme !== "light" && l.value ? "dark" : "light"
    ), H = [
      "--fe-bg",
      "--fe-bg-elev",
      "--fe-bg-hover",
      "--fe-bg-selected",
      "--fe-border",
      "--fe-border-soft",
      "--fe-border-strong",
      "--fe-text",
      "--fe-text-muted",
      "--fe-text-on-primary",
      "--fe-primary",
      "--fe-primary-hover",
      "--fe-primary-soft",
      "--fe-primary-ink",
      "--fe-danger",
      "--fe-danger-hover",
      "--fe-warning",
      "--fe-ok",
      "--fe-radius",
      "--fe-radius-sm",
      "--fe-radius-md",
      "--fe-radius-lg",
      "--fe-font",
      "--fe-font-mono",
      "--fe-text-xs",
      "--fe-text-sm",
      "--fe-text-md",
      "--fe-shadow",
      "--fe-shadow-sm"
    ];
    function L() {
      const Z = {};
      if (c.value && typeof getComputedStyle == "function") {
        const Q = getComputedStyle(c.value);
        for (const we of H) {
          const Ye = Q.getPropertyValue(we).trim();
          Ye && (Z[we] = Ye);
        }
      }
      return { mode: U.value, tokens: Z };
    }
    function P(Z) {
      const Q = Z.lastIndexOf(".");
      return Q > 0 ? Z.slice(Q + 1).toLowerCase() : "";
    }
    function K(Z) {
      const Q = a.e2e;
      return !Q || !z.value.has(B$) ? !1 : Z.encrypted === "folder" || Z.encrypted === "vault" && !!Q.vault;
    }
    const N = A(() => (a.files ?? []).some(K));
    function J(Z) {
      return !!a.readOnly || !!Z.readOnly || Qu(Z.encrypted) && !K(Z);
    }
    function j() {
      const Z = z.value.has("files:write");
      return (a.files ?? []).map((Q, we) => ({
        index: we,
        name: Q.name,
        ext: P(Q.name),
        size: Q.size ?? 0,
        mime: Q.mime ?? "",
        readOnly: !Z || J(Q),
        // Only when the server said so: absent means not encrypted.
        ...Qu(Q.encrypted) ? { encrypted: Q.encrypted } : {},
        ...K(Q) ? { plaintext: !0 } : {}
      }));
    }
    function re() {
      return {
        v: k$,
        app: { name: a.app, version: D.value },
        view: { id: a.view, placement: a.placement },
        locale: a.locale,
        dir: kl(a.locale),
        theme: L(),
        user: { name: a.userName ?? "" },
        // The document editors' fixed language (#214), as the server's list
        // said it for this interface (filex 0.57).
        ...C.value.editor_lang ? { editor_lang: C.value.editor_lang } : {},
        files: j(),
        grants: [...z.value]
      };
    }
    function q(Z) {
      if (!z.value.has(Z)) throw new ct("not_granted", `this app was not granted ${Z}`);
    }
    function le(Z) {
      const Q = typeof Z == "number" ? Z : 0, we = (a.files ?? [])[Q];
      if (!Number.isInteger(Q) || !we) throw new ct("not_found", `no file at ${String(Z)}`);
      return we;
    }
    async function ve(Z, Q) {
      const we = typeof Q == "string" && Q.length < 200 ? Q : "";
      if (typeof Z == "string") return new Blob([Z], { type: we || "text/plain;charset=utf-8" });
      if (Z instanceof ArrayBuffer) return new Blob([Z], { type: we });
      if (typeof ReadableStream < "u" && Z instanceof ReadableStream) return Z;
      throw new ct("invalid", "save takes a string, an ArrayBuffer or a ReadableStream");
    }
    const ce = /* @__PURE__ */ new Map(), se = /* @__PURE__ */ new Map();
    function fe(Z, Q) {
      const we = ce.get(Z);
      return we ? `${we.size}:${we.modified}` : typeof Q.size == "number" && typeof Q.modified == "number" ? `${Q.size}:${Q.modified}` : void 0;
    }
    function _() {
      return new ct("too_large", `at most ${Ol >> 20} MiB in an encrypted folder`);
    }
    function ee() {
      return new ct("unavailable", "the encrypted folder was locked");
    }
    async function Y() {
      const Z = (a.files ?? []).find(K);
      return !Z || !a.e2e ? null : Z.encrypted === "vault" ? a.e2e.vault ? a.e2e.vault.ledger(Z.path, a.app) : null : a.e2e.ledger(Z.path, a.app);
    }
    function B() {
      return r("appframe.state_no_account");
    }
    async function W(Z) {
      const Q = typeof ReadableStream < "u" && Z instanceof ReadableStream;
      if (typeof Z != "string" && !(Z instanceof ArrayBuffer) && !Q)
        throw new ct("invalid", "save takes a string, an ArrayBuffer or a ReadableStream");
      const we = [];
      let Ye = 0;
      try {
        for await (const Bt of te(Z)) {
          if (Ye += Bt.byteLength, Ye > Ol) throw _();
          we.push(Bt);
        }
      } catch (Bt) {
        for (const Qt of we) Qt.fill(0);
        throw Bt;
      }
      const rt = new Uint8Array(Ye);
      let vt = 0;
      for (const Bt of we)
        rt.set(Bt, vt), vt += Bt.byteLength, Bt.fill(0);
      return rt;
    }
    async function F(Z) {
      const Q = a.e2e, we = a.api.pluginUIRead;
      if (!Q || typeof we != "function") throw new ct("unavailable", "this host does not hand over encrypted files");
      const Ye = await we(a.app, a.view, Z.path, { e2e: !0 }), rt = Ye.body ?? new Blob([await Ye.arrayBuffer()]).stream();
      try {
        return await Q.open(Z.path, rt);
      } catch (vt) {
        throw vt instanceof Ir ? _() : new ct("failed", "the file could not be decrypted here");
      }
    }
    const V = /* @__PURE__ */ new Map();
    function ke(Z, Q) {
      if (Z instanceof ct) return Z;
      if (Z instanceof Ir) return _();
      if (!(Z instanceof yp)) return new ct("failed", Q);
      switch (Z.why) {
        case "locked":
          return new ct("unavailable", "the vault was locked");
        case "too_large":
          return _();
        case "gone":
          return new ct("not_found", "the file is not in the vault any more");
        case "read_only":
          return new ct("read_only", "the vault is read-only here");
        case "changed":
          return new ct("failed", "changed");
        case "held":
          return new ct("failed", "vault_locked");
        case "lock_lost":
          return new ct("failed", "vault_lock_lost");
        default:
          return new ct("failed", Q);
      }
    }
    async function qe(Z) {
      var we;
      const Q = (we = a.e2e) == null ? void 0 : we.vault;
      if (!Q) throw new ct("unavailable", "this host does not hand over files of a vault");
      try {
        const Ye = await Q.read(Z.path);
        return Ye ? (V.set(Z.path, Ye.sig), Ye.bytes) : null;
      } catch (Ye) {
        throw ke(Ye, "the file could not be decrypted here");
      }
    }
    async function Me(Z, Q, we) {
      var Qt;
      const Ye = (Qt = a.e2e) == null ? void 0 : Qt.vault;
      if (!Ye) throw new ct("unavailable", "the vault was locked");
      const rt = await W(we), vt = rt.byteLength;
      let Bt;
      try {
        Bt = await Ye.save(Q.path, rt, V.get(Q.path) ?? fe(Z, Q));
      } catch (en) {
        throw ke(en, "the vault did not save it");
      } finally {
        rt.fill(0);
      }
      return V.set(Q.path, Bt.sig), i("saved", { path: Q.path, size: Bt.size, index: Z }), x.value = !1, i("dirty", !1), { saved: !0, size: vt };
    }
    async function Fe(Z, Q) {
      const we = Z.encrypted === "vault" ? await qe(Z) : await F(Z);
      if (!we) throw Z.encrypted === "vault" ? ke(new yp("locked"), "") : ee();
      const Ye = { name: Z.name, size: we.byteLength, mime: Z.mime || "" };
      switch (Q ?? "stream") {
        case "text": {
          if (we.byteLength > ya.maxTextBytes)
            throw we.fill(0), new ct("too_large", "read a file this large as bytes");
          const rt = new TextDecoder().decode(we);
          return we.fill(0), { ...Ye, text: rt };
        }
        case "bytes":
          return { ...Ye, bytes: we.buffer };
        case "stream": {
          const rt = we;
          return {
            ...Ye,
            stream: new ReadableStream({
              start(vt) {
                vt.enqueue(rt), vt.close();
              }
            })
          };
        }
        default:
          throw we.fill(0), new ct("invalid", "as is stream, bytes or text");
      }
    }
    async function We(Z, Q, we, Ye) {
      if (Q.encrypted === "vault") return Me(Z, Q, we);
      const rt = a.e2e;
      if (!rt) throw ee();
      const vt = await W(we), Bt = vt.byteLength;
      let Qt;
      try {
        Qt = await rt.seal(Q.path, vt);
      } catch (kn) {
        throw kn instanceof Ir ? _() : kn;
      } finally {
        vt.fill(0);
      }
      if (!Qt) throw ee();
      const en = fn && typeof Ye == "number" ? fn.saveParams(Ye) : null, Ot = await a.api.pluginUISave(a.app, a.view, { path: Q.path }, new Blob([Qt], { type: "application/octet-stream" }), {
        e2e: !0,
        expect: fe(Z, Q),
        ...en ? { extra: en } : {}
      });
      return typeof Ot.modified == "number" && ce.set(Z, { size: Ot.size, modified: Ot.modified }), i("saved", { path: Ot.path || Q.path, size: Ot.size, index: Z }), x.value = !1, i("dirty", !1), { saved: !0, size: Bt };
    }
    function $t(Z) {
      if (N.value) throw new ct("unavailable", `${Z} is not offered while a file of an encrypted folder is open`);
    }
    const St = S(null), at = A(() => {
      const Z = (a.title || "").trim();
      return Z ? Z.toLowerCase().includes(a.app.toLowerCase()) ? Z : `${Z} (${a.app})` : a.app;
    }), kt = S(null);
    let pt = Number.NEGATIVE_INFINITY, Ne = Number.NEGATIVE_INFINITY;
    function ie() {
      const Z = typeof navigator < "u" ? navigator.userActivation : void 0;
      return !!(Z != null && Z.isActive);
    }
    function xe() {
      Ne = Date.now();
    }
    function he() {
      if (!ie()) return !1;
      const Z = Date.now();
      return Z - pt < R1 || Z - Ne < R1 ? !1 : (pt = Z, !0);
    }
    async function De(Z) {
      he() || await gt(Z);
    }
    const ot = S(!1);
    let ft = null;
    async function gt(Z) {
      if (kt.value) throw new ct("unavailable", "a question is already on screen");
      if (ot.value = !1, ft && clearTimeout(ft), ft = setTimeout(() => {
        ot.value = !0;
      }, N1), !await new Promise((we) => {
        kt.value = { text: Z, resolve: we };
      })) throw new ct("cancelled");
    }
    function Ut() {
      return r("appframe.consent_clipboard", { app: at.value });
    }
    function Xe(Z) {
      return r("appframe.consent_job", { app: at.value, action: Z });
    }
    function Ve(Z) {
      return r("appframe.consent_download", { app: at.value, name: Z });
    }
    function Be(Z) {
      return r("appframe.consent_print", { app: at.value, name: Z });
    }
    function ne() {
      return r("appframe.consent_allow");
    }
    function ge(Z) {
      if (Z && !ot.value) return;
      const Q = kt.value;
      kt.value = null, ft && clearTimeout(ft), ft = null, Q == null || Q.resolve(Z);
    }
    function G(Z) {
      const Q = typeof Z == "string" ? Z.trim() : "";
      if (!Q || Q.length > 255 || Q === "." || Q === ".." || /[\\/\u0000-\u001f]/.test(Q))
        throw new ct("invalid", "name is a file name, without a folder");
      return Q;
    }
    function ye() {
      return new ct("too_large", `at most ${ya.maxDownloadBytes >> 20} MiB`);
    }
    async function* te(Z) {
      if (typeof Z == "string") {
        yield new TextEncoder().encode(Z);
        return;
      }
      if (Z instanceof ArrayBuffer) {
        yield new Uint8Array(Z);
        return;
      }
      const Q = Z.getReader();
      let we = !1;
      try {
        for (; ; ) {
          const Ye = await Q.read();
          if (Ye.done) {
            we = !0;
            return;
          }
          Ye.value && (yield Ye.value);
        }
      } finally {
        we || await Q.cancel().catch(() => {
        });
      }
    }
    async function Ce(Z, Q, we) {
      var en;
      const Ye = window.showSaveFilePicker;
      if (typeof Ye == "function") {
        let Ot = null;
        try {
          Ot = await Ye.call(window, { suggestedName: Z });
        } catch (kn) {
          if ((kn == null ? void 0 : kn.name) === "AbortError") throw new ct("cancelled");
          Ot = null;
        }
        if (Ot) {
          const kn = await Ot.createWritable();
          let Pa = 0;
          try {
            for await (const un of te(Q)) {
              if (Pa += un.byteLength, Pa > ya.maxDownloadBytes) throw ye();
              await kn.write(un);
            }
          } catch (un) {
            throw await ((en = kn.abort) == null ? void 0 : en.call(kn).catch(() => {
            })), un;
          }
          return await kn.close(), { saved: !0, size: Pa };
        }
      }
      const rt = [];
      let vt = 0;
      for await (const Ot of te(Q)) {
        if (vt += Ot.byteLength, vt > ya.maxDownloadBytes) throw ye();
        rt.push(Ot);
      }
      const Bt = URL.createObjectURL(new Blob(rt, { type: we })), Qt = document.createElement("a");
      Qt.href = Bt, Qt.download = Z, Qt.rel = "noopener", Qt.style.display = "none", document.body.appendChild(Qt);
      try {
        Qt.click();
      } finally {
        Qt.remove(), setTimeout(() => URL.revokeObjectURL(Bt), 6e4);
      }
      return { saved: !0, size: vt };
    }
    const Ie = S(null), _e = S(null);
    let Ae = null, Pe = null, _t = !1;
    function Et() {
      Pe == null || Pe.abort(), Pe = null, Ae == null || Ae.remove(), Ae = null, Ie.value = null;
    }
    function xn() {
      Pe == null || Pe.abort();
    }
    function Dt() {
      const Z = c.value;
      if (!Z) return {};
      const Q = document.createElement("span");
      Q.className = "fe-btn fe-btn--primary", Q.setAttribute("aria-hidden", "true"), Q.style.cssText = "position:absolute;visibility:hidden;pointer-events:none;inset-inline-start:0;top:0", Q.textContent = r("appframe.consent_allow"), Z.appendChild(Q);
      try {
        return cU(Q);
      } finally {
        Q.remove();
      }
    }
    function bn() {
      return new ct("too_large", `at most ${ya.maxPrintBytes >> 20} MiB`);
    }
    const ln = S(null);
    let Jt = !1, Ln = null;
    function Vn() {
      var Ye, rt;
      const Z = ((rt = (Ye = a.files) == null ? void 0 : Ye[0]) == null ? void 0 : rt.path) ?? "", Q = Z.includes("://") ? Ag(Z, !1) ?? "" : "";
      if (Q && !jf(Q)) return Q;
      const we = a.startAt ?? "";
      return we.includes("://") && !jf(we) ? we : Q ? $v(Q) : void 0;
    }
    async function Ft(Z) {
      var Q;
      if ((Q = a.storages) != null && Q.length) return a.storages;
      if (Ln) return Ln;
      try {
        const we = await a.api.index(Z ?? "");
        return Ln = Array.isArray(we == null ? void 0 : we.storages) ? we.storages.filter((Ye) => typeof Ye == "string" && !!Ye) : [], Ln;
      } catch {
        return [];
      }
    }
    async function na(Z) {
      if (Jt || ln.value) throw new ct("unavailable", "a question is already on screen");
      Jt = !0;
      try {
        const Q = Vn(), we = await Ft(Q);
        if (!Q && !we.length) throw new ct("unavailable", "there is no folder to save into here");
        return await new Promise((Ye) => {
          ln.value = { name: Z, storages: we, startAt: Q, resolve: Ye };
        });
      } finally {
        Jt = !1;
      }
    }
    function Kt(Z) {
      const Q = ln.value;
      ln.value = null, Q == null || Q.resolve(Z);
    }
    function bt(Z) {
      return r("appframe.save_as_title", { app: at.value, name: Z });
    }
    async function Dn(Z) {
      typeof ReadableStream < "u" && Z instanceof ReadableStream && await Z.cancel().catch(() => {
      });
    }
    async function Nn(Z) {
      try {
        const we = (await a.api.pluginActions()).actions.find((rt) => rt.plugin === a.app && rt.id === Z), Ye = we ? Xt(we.label, a.locale) : "";
        if (Ye) return Ye;
      } catch {
      }
      return Z;
    }
    const Cn = {
      "session.get": () => re(),
      async "file.read"(Z) {
        q("files:read");
        const Q = Z ?? {}, we = le(Q.index);
        if (K(we)) return Fe(we, Q.as);
        const Ye = a.api.pluginUIRead, rt = typeof Ye == "function" ? await Ye(a.app, a.view, we.path) : await a.api.fetchResponse(we.path), vt = Number(rt.headers.get("content-length") ?? we.size ?? 0) || (we.size ?? 0), Bt = we.mime || rt.headers.get("content-type") || "", Qt = qU(rt.headers.get(jU));
        Qt && ce.set(typeof Q.index == "number" ? Q.index : 0, Qt);
        const en = OP(rt.headers.get(PP)), Ot = { name: we.name, size: vt, mime: Bt, ...en ? { text_dialect: en } : {} };
        switch (Q.as ?? "stream") {
          case "text": {
            if (vt > ya.maxTextBytes) throw new ct("too_large", "read a file this large as a stream");
            return en && en.encoding !== "utf-8" ? { ...Ot, text: LP(await rt.arrayBuffer(), en.encoding) } : { ...Ot, text: await rt.text() };
          }
          case "bytes":
            return { ...Ot, bytes: await rt.arrayBuffer() };
          case "stream":
            return rt.body ? { ...Ot, stream: rt.body } : { ...Ot, bytes: await rt.arrayBuffer() };
          default:
            throw new ct("invalid", "as is stream, bytes or text");
        }
      },
      async "file.save"(Z) {
        q("files:write");
        const Q = Z ?? {}, we = typeof Q.index == "number" ? Q.index : 0, Ye = le(we);
        if (J(Ye)) throw new ct("read_only", "this file cannot be saved over here");
        if (R2(Q.csv) === null) throw new ct("invalid", "csv is {delimiter, encoding, bom, eol}");
        const rt = YU(Q);
        if (rt === null) throw new ct("invalid", "beside is a file extension; conflict is 'copy'");
        if (K(Ye)) {
          if (rt.beside && rt.beside !== P(Ye.name))
            throw new ct("unavailable", "a file of an encrypted folder is saved only in its own format");
          return We(we, Ye, Q.data, Q.through);
        }
        const vt = await ve(Q.data, Q.mime), Bt = fn && typeof Q.through == "number" ? fn.saveParams(Q.through) : null, Qt = we === 0 && a.savePath ? a.savePath : Ye.path, en = Bt ? Qt : se.get(we) ?? Qt, Ot = rt.conflict && !Bt ? fe(we, Ye) : void 0, kn = { ...Bt ?? {} };
        rt.beside && (kn.beside = rt.beside), rt.conflict && (kn.conflict = rt.conflict);
        const Pa = {
          ...Object.keys(kn).length ? { extra: kn } : {},
          ...Q.csv ? { csv: Q.csv } : {},
          ...Ot ? { expect: Ot } : {}
        }, un = Object.keys(Pa).length ? await a.api.pluginUISave(a.app, a.view, { path: en }, vt, Pa) : await a.api.pluginUISave(a.app, a.view, { path: en }, vt);
        typeof un.modified == "number" && ce.set(we, { size: un.size, modified: un.modified }), !Bt && un.path && un.path !== en && (un.beside || un.conflict) && se.set(we, un.path), i("saved", { path: un.path || en, size: un.size, index: we }), x.value = !1, i("dirty", !1);
        const pe = un.beside || typeof un.conflict == "string";
        return {
          saved: !0,
          size: un.size,
          ...pe && un.name ? { name: un.name } : {},
          ...un.beside ? { beside: !0 } : {},
          ...typeof un.conflict == "string" ? { conflict: un.conflict } : {}
        };
      },
      async "file.saveAs"(Z) {
        q("files:write");
        const Q = Z ?? {}, we = typeof Q.name == "string" ? Q.name.trim() : "";
        if (!we || we.includes("/") || we.includes("\\") || we === "." || we === ".." || we.length > 255)
          throw new ct("invalid", "name is a file name, without a folder");
        N.value && (typeof ReadableStream < "u" && Q.data instanceof ReadableStream && await Q.data.cancel().catch(() => {
        }), $t("save as"));
        const Ye = await ve(Q.data, Q.mime);
        let rt;
        try {
          rt = await na(we);
        } catch (Bt) {
          throw await Dn(Ye), Bt;
        }
        if (!rt)
          throw await Dn(Ye), new ct("cancelled");
        const vt = await a.api.pluginUISave(a.app, a.view, { dir: rt, name: we }, Ye);
        return i("saved-as", { path: vt.path, name: vt.name, size: vt.size }), { saved: !0, name: vt.name, size: vt.size };
      },
      "ui.dirty"(Z) {
        return x.value = !!(Z != null && Z.dirty), i("dirty", x.value), null;
      },
      "ui.title"(Z) {
        const Q = String((Z == null ? void 0 : Z.text) ?? "").slice(0, ya.maxLineChars);
        return i("title", Q), null;
      },
      "ui.toast"(Z) {
        const Q = Z ?? {}, we = Q.tone === "success" || Q.tone === "warning" || Q.tone === "error" ? Q.tone : "info";
        return i("toast", { text: `${at.value}: ${String(Q.text ?? "").slice(0, ya.maxLineChars)}`, tone: we }), null;
      },
      "ui.confirm"(Z) {
        const Q = typeof Z == "object" && Z ? Z : {};
        if (St.value) throw new ct("unavailable", "a question is already on screen");
        return new Promise((we) => {
          St.value = {
            text: String(Q.text ?? "").slice(0, 1e3),
            title: Q.title ? String(Q.title).slice(0, ya.maxLineChars) : void 0,
            danger: !!Q.danger,
            resolve: we
          };
        });
      },
      "ui.close"() {
        return i("close"), null;
      },
      async "clipboard.write"(Z) {
        var we;
        const Q = String((Z == null ? void 0 : Z.text) ?? "");
        if (Q.length > 1 << 20) throw new ct("too_large", "at most 1 MiB of text");
        if (typeof navigator > "u" || !((we = navigator.clipboard) != null && we.writeText))
          throw new ct("unavailable", "this browser offers no clipboard here");
        if (he())
          try {
            return await navigator.clipboard.writeText(Q), null;
          } catch (Ye) {
            if ((Ye == null ? void 0 : Ye.name) !== "NotAllowedError") throw Ye;
          }
        return await gt(Ut()), await navigator.clipboard.writeText(Q), null;
      },
      async "ui.download"(Z) {
        q("ui:download");
        const Q = Z ?? {}, we = G(Q.name), Ye = Q.data, rt = typeof ReadableStream < "u" && Ye instanceof ReadableStream;
        if (typeof Ye != "string" && !(Ye instanceof ArrayBuffer) && !rt)
          throw new ct("invalid", "download takes a string, an ArrayBuffer or a ReadableStream");
        if ((typeof Ye == "string" ? new Blob([Ye]).size : Ye instanceof ArrayBuffer ? Ye.byteLength : 0) > ya.maxDownloadBytes) throw ye();
        const Bt = typeof Q.mime == "string" && /^[\w.+-]+\/[\w.+-]+$/.test(Q.mime) ? Q.mime : "application/octet-stream";
        try {
          await De(Ve(we));
        } catch (Qt) {
          throw rt && await Ye.cancel().catch(() => {
          }), Qt;
        }
        return Ce(we, Ye, Bt);
      },
      /**
       * 0.55: print a PDF the interface hands over (`ui:print`) - the print
       * dialog can save the PDF, so it is the person's call every time: filex
       * asks, and the dialog opens on their click on the row's Allow, a button of
       * the server's print page (lib/printPdf; security review sec055 S9). The
       * PDF is held once, as one Blob: refused at its first bytes when they are
       * not a PDF's and past LIMITS.maxPrintBytes (S10). `unavailable` where the
       * host names no print page, or while another print is being asked about.
       */
      async "ui.print"(Z) {
        q("ui:print");
        const Q = Z ?? {}, we = Q.data, Ye = typeof ReadableStream < "u" && we instanceof ReadableStream, rt = async () => {
          Ye && await we.cancel().catch(() => {
          });
        };
        let vt = "";
        try {
          if (vt = G(Q.name), !(we instanceof ArrayBuffer) && !Ye)
            throw new ct("invalid", "print takes a PDF as an ArrayBuffer or a ReadableStream");
          if (Q.mime !== void 0 && Q.mime !== "application/pdf") throw new ct("invalid", "print takes a PDF (application/pdf)");
          if (we instanceof ArrayBuffer && we.byteLength > ya.maxPrintBytes) throw bn();
          if (we instanceof ArrayBuffer && !ac(we)) throw new ct("invalid", "the data is not a PDF");
        } catch (Qt) {
          throw await rt(), Qt;
        }
        const Bt = typeof a.api.printFrameUrl == "function" ? a.api.printFrameUrl() : "";
        if (!Bt)
          throw await rt(), new ct("unavailable", "this host offers no printing");
        if (_t)
          throw await rt(), new ct("unavailable", "another print is waiting for the person");
        _t = !0;
        try {
          let Qt;
          try {
            Qt = await uU(we instanceof ArrayBuffer ? we : te(we), ya.maxPrintBytes);
          } catch (Ot) {
            throw Ot instanceof ua ? Ot.code === "too_large" ? bn() : new ct(Ot.code, Ot.message) : Ot;
          }
          Et();
          const en = new AbortController();
          Pe = en, Ie.value = { text: Be(vt), shown: !1, width: 0, height: 0 }, await Gt();
          try {
            Ae = await pU(Bt, Qt, {
              mount: _e.value ?? c.value,
              label: ne(),
              look: Dt(),
              armMs: N1,
              signal: en.signal,
              onAsk: ({ width: Ot, height: kn }) => {
                Pe === en && Ie.value && (Ie.value = { ...Ie.value, shown: !0, width: Ot, height: kn });
              }
            });
          } catch (Ot) {
            throw Pe === en && (Ie.value = null), Ot instanceof ua ? new ct(Ot.code, Ot.message) : Ot;
          }
          return Ie.value && (Ie.value = { ...Ie.value, shown: !1 }), { printed: !0, size: Qt.size };
        } finally {
          _t = !1, Pe = null;
        }
      },
      async "engine.call"(Z) {
        if (!C.value.engine) throw new ct("unavailable", "this app has no module");
        $t("the app's module");
        const Q = Z ?? {};
        if (typeof Q.method != "string" || !Q.method) throw new ct("invalid", "method is required");
        return (await a.api.pluginUICall(a.app, a.view, {
          method: Q.method,
          params: Q.params,
          paths: (a.files ?? []).map((Ye) => Ye.path)
        })).result;
      },
      async "job.submit"(Z) {
        if (!C.value.engine) throw new ct("unavailable", "this app has no module");
        $t("the app's module");
        const Q = Z ?? {};
        if (typeof Q.action != "string" || !Q.action) throw new ct("invalid", "action is required");
        he() || await gt(Xe(await Nn(Q.action)));
        const Ye = (await a.api.pluginActionRun(a.app, Q.action, {
          paths: (a.files ?? []).map((rt) => rt.path),
          params: Q.params && typeof Q.params == "object" ? Q.params : {}
        })).op;
        if (!Ye) throw new ct("failed", "nothing was queued");
        return i("op", Ye), { op: Ye };
      },
      /* An encrypted session (the frame holds plaintext of an encrypted folder)
         reads and writes its own sealed store; a locked folder reads as an empty
         one. Any other session: the app's ordinary store, as always. */
      async "state.get"(Z) {
        const Q = String((Z == null ? void 0 : Z.key) ?? "");
        if (N.value) {
          const we = await Y().catch(() => null);
          return we ? await AU(a.app, we, Q) ?? null : null;
        }
        return QF(a.app, Q) ?? null;
      },
      /**
       * 0.52.0: what the app's license says (`LicenseInfo`) - the status, and for a
       * valid license its dates. filex keeps the key and the licensee's name; the
       * app sees neither (only these three fields cross the bridge, whatever the
       * server answers). A free app reads `{status: "free"}`.
       */
      async "license.get"() {
        const Z = await a.api.pluginLicense(a.app), Q = { status: String(Z.status ?? "free") };
        return Z.valid_until && (Q.valid_until = Z.valid_until), Z.updates_until && (Q.updates_until = Z.updates_until), Q;
      },
      async "state.set"(Z) {
        const Q = Z ?? {};
        try {
          if (N.value) {
            const we = await Y();
            if (!we) throw ee();
            await EU(a.app, we, String(Q.key ?? ""), Q.value);
          } else
            eU(a.app, String(Q.key ?? ""), Q.value);
        } catch (we) {
          throw we instanceof Sc ? new ct("too_large", we.message) : we instanceof N$ ? new ct("unavailable", B()) : we;
        }
        return null;
      },
      /* ── editing together (0.56, files:co-edit) ─────────────────────────── */
      async "coedit.join"(Z) {
        q("files:co-edit"), q("files:read");
        const we = le((Z ?? {}).index), Ye = Qu(we.encrypted), rt = a.e2e;
        if (Ye && (we.encrypted !== "folder" || !K(we) || typeof (rt == null ? void 0 : rt.folderKeys) != "function"))
          throw new ct("unavailable", "encrypted");
        const vt = Ye && (rt != null && rt.folderKeys) ? () => rt.folderKeys(we.path) : void 0, Bt = aa();
        if (!Bt) throw new ct("unavailable", "this host offers no editing together");
        const Qt = fn;
        fn = null, Qt && await Qt.leave();
        const en = await bp.join(Bt, we.path, {
          entry: (Ot) => m == null ? void 0 : m.emit("coedit.entry", Ot),
          cursor: (Ot) => m == null ? void 0 : m.emit("coedit.cursor", Ot),
          dropped: (Ot) => {
            fn === en && (fn = null), m == null || m.emit("coedit.dropped", Ot);
          }
        }, { folder: vt, outbox: Mn(), askUnsent: me });
        if (!m)
          throw en.leave({ keepalive: !0 }), new ct("unavailable", "gone");
        return fn = en, en.hello();
      },
      "coedit.subscribe"(Z) {
        const Q = Z ?? {};
        return mn().subscribe(Number(Q.from ?? 0)), null;
      },
      async "coedit.append"(Z) {
        const Q = Z ?? {};
        return mn().append(Q.kind, Q.body);
      },
      async "coedit.lease"(Z) {
        const Q = Z ?? {};
        return { granted: await mn().lease(Q.op, Number(Q.changesSeen ?? 0)) };
      },
      "coedit.cursor"(Z) {
        return mn().cursor(Z == null ? void 0 : Z.cursor), null;
      },
      async "coedit.blob.put"(Z) {
        const Q = mn(), we = Z ?? {};
        if (!(we.data instanceof ArrayBuffer)) throw new ct("invalid", "a blob is an ArrayBuffer");
        return await Q.putBlob(String(we.name ?? ""), we.data), null;
      },
      async "coedit.blob.get"(Z) {
        const we = String((Z ?? {}).name ?? "");
        return { name: we, bytes: await mn().getBlob(we) };
      },
      async "coedit.leave"() {
        const Z = fn;
        return fn = null, await (Z == null ? void 0 : Z.leave()), null;
      }
    };
    let fn = null;
    function mn() {
      if (!fn) throw new ct("unavailable", "not in a session (coedit.join first)");
      return fn;
    }
    function aa() {
      const Z = a.api;
      return typeof Z.coeditJoin != "function" || typeof Z.coeditCall != "function" ? null : {
        join: (Q, we) => Z.coeditJoin(a.app, a.view, Q, we),
        call: (Q, we, Ye, rt) => Z.coeditCall(a.app, a.view, Q, we, Ye, rt),
        putBlob: (Q, we, Ye, rt) => Z.coeditBlobPut(a.app, a.view, Q, we, Ye, rt),
        getBlob: (Q, we, Ye) => Z.coeditBlobGet(a.app, a.view, Q, we, Ye)
      };
    }
    let zn = null;
    function Mn() {
      return zn ?? (zn = hH()), zn;
    }
    const rn = S(null);
    function me(Z) {
      return rn.value ? Promise.resolve(null) : new Promise((Q) => {
        rn.value = { ...Z, resolve: Q };
      });
    }
    function Le(Z) {
      const Q = rn.value;
      rn.value = null, Q == null || Q.resolve(Z);
    }
    function Ue() {
      const Z = fn;
      fn = null, Z && Z.leave({ keepalive: !0 });
    }
    function He(Z) {
      const Q = St.value;
      St.value = null, Q == null || Q.resolve(Z);
    }
    function xt() {
      const Z = document.createElement("iframe");
      return Z.setAttribute("sandbox", "allow-scripts"), Z.setAttribute("referrerpolicy", "no-referrer"), Z.setAttribute("title", a.title || a.app), Z.className = "fe-appframe__frame", Z.dataset.testid = "app-frame", Z.setAttribute("src", R.value), Z;
    }
    function Qe() {
      if (ue(), !c.value) return;
      const Z = xt(), Q = NF({
        frame: () => Z,
        handlers: Cn,
        onConnect: () => {
          v.value = !0, i("connected");
        },
        onDisconnect: () => {
          v.value = !1;
        }
      });
      Z.addEventListener("load", () => Q.frameLoaded()), p = Z, m = Q, c.value.appendChild(Z);
    }
    function ue() {
      Ue(), rn.value && Le(null), m == null || m.destroy(), m = null, Et(), p && (p.remove(), p = null), v.value = !1, x.value = !1, St.value && He(!1), kt.value && ge(!1), w.value && nn("keep"), ln.value && Kt(null);
    }
    let je = null;
    const dt = ["pointerdown", "keydown", "touchstart"];
    jt(() => {
      ie() && (Ne = Date.now());
      for (const Q of dt) window.addEventListener(Q, xe, !0);
      window.addEventListener("pagehide", Ue), Qe(), je = v3((Q, we) => {
        Q !== a.app || !we || we === D.value || (T.value = we, ae(we));
      });
      const Z = D.value;
      if (Z) {
        const Q = tU(a.app);
        Q && Q !== Z && (E.value = Z), Q !== Z && x1(a.app, Z);
      }
    }), Tt(() => {
      for (const Z of dt) window.removeEventListener(Z, xe, !0);
      window.removeEventListener("pagehide", Ue), je == null || je(), je = null, ue();
    }), Je([R, k], () => Qe()), Je(
      () => a.ui,
      () => {
        b.value = null;
      }
    ), Je(U, () => m == null ? void 0 : m.emit("theme", L())), Je(
      () => a.locale,
      (Z) => m == null ? void 0 : m.emit("locale", { locale: Z, dir: kl(Z) })
    );
    async function It() {
      if (!m || !v.value) return !1;
      try {
        return await m.ask("save"), !0;
      } catch {
        return !1;
      }
    }
    async function hn() {
      if (!x.value || !v.value)
        return oe(), !0;
      const Z = await new Promise((Q) => {
        w.value = Q;
      });
      if (Z === "keep") return !1;
      if (Z === "save") {
        $.value = !0;
        try {
          if (!await It()) return !1;
        } finally {
          $.value = !1;
        }
      }
      return oe(), !0;
    }
    function nn(Z) {
      const Q = w.value;
      w.value = null, Q == null || Q(Z);
    }
    function ae(Z) {
      m == null || m.emit("app.updated", { version: Z });
    }
    function oe() {
      m == null || m.emit("close.request");
    }
    function ze() {
      k.value++;
    }
    async function Ke() {
      var we, Ye;
      if (!await hn()) return;
      const Z = T.value;
      let Q = null;
      try {
        const rt = await a.api.pluginActions();
        Q = ((we = rt.views.find((vt) => vt.plugin === a.app && vt.id === a.view && vt.ui)) == null ? void 0 : we.ui) ?? ((Ye = rt.actions.find((vt) => vt.plugin === a.app && vt.view === a.view && vt.ui)) == null ? void 0 : Ye.ui) ?? null;
      } catch {
      }
      T.value = "", E.value = "", Q && (b.value = Q, x1(a.app, Q.version || Z)), ze();
    }
    function it() {
      T.value = "", E.value = "";
    }
    return t({ requestSave: It, confirmClose: hn, notifyUpdated: ae, notifyClosing: oe, reload: ze, reloadNewer: Ke, connected: v, dirty: x }), (Z, Q) => (f(), h("div", {
      ref_key: "host",
      ref: c,
      class: Re(["fe-appframe", `fe-appframe--${e.placement}`]),
      "data-app": e.app,
      "data-connected": v.value ? "true" : "false"
    }, [
      T.value || E.value ? (f(), h("div", xH, [
        d("span", SH, y(T.value ? u(r)("appframe.updated_reload", { app: e.title || e.app }) : u(r)("appframe.updated", { app: e.title || e.app, version: E.value })), 1),
        T.value ? (f(), h("button", {
          key: 0,
          type: "button",
          class: "fe-btn fe-btn--primary",
          "data-testid": "appframe-reload",
          onClick: Ke
        }, y(u(r)("appframe.reload")), 1)) : O("", !0),
        d("button", {
          type: "button",
          class: "fe-btn",
          "data-testid": "appframe-dismiss",
          onClick: it
        }, y(u(r)("appframe.dismiss")), 1)
      ])) : O("", !0),
      rn.value ? (f(), h("div", $H, [
        d("span", TH, y(rn.value.text), 1),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          "data-testid": "appframe-unsent-apply",
          onClick: Q[0] || (Q[0] = (we) => Le(!0))
        }, y(rn.value.apply), 1),
        d("button", {
          type: "button",
          class: "fe-btn",
          "data-testid": "appframe-unsent-discard",
          onClick: Q[1] || (Q[1] = (we) => Le(!1))
        }, y(rn.value.discard), 1)
      ])) : O("", !0),
      kt.value ? (f(), h("div", AH, [
        d("span", EH, y(kt.value.text), 1),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          "data-testid": "appframe-consent-allow",
          disabled: !ot.value,
          onClick: Q[2] || (Q[2] = (we) => ge(!0))
        }, y(u(r)("appframe.consent_allow")), 9, CH),
        d("button", {
          type: "button",
          class: "fe-btn",
          "data-testid": "appframe-consent-deny",
          onClick: Q[3] || (Q[3] = (we) => ge(!1))
        }, y(u(r)("appframe.consent_deny")), 1)
      ])) : O("", !0),
      Ie.value ? (f(), h("div", {
        key: 3,
        class: Re(["fe-appframe__note fe-appframe__consent fe-appframe__print", { "fe-appframe__print--parked": !Ie.value.shown }]),
        role: Ie.value.shown ? "alertdialog" : void 0,
        "aria-live": Ie.value.shown ? "assertive" : void 0,
        "aria-hidden": Ie.value.shown ? void 0 : "true",
        inert: Ie.value.shown ? void 0 : !0,
        "data-shown": Ie.value.shown ? "true" : "false",
        "data-testid": "appframe-print-ask"
      }, [
        d("span", MH, y(Ie.value.text), 1),
        d("span", {
          ref_key: "printSlot",
          ref: _e,
          class: "fe-appframe__print-slot",
          style: Yt(Ie.value.shown ? { width: `${Ie.value.width}px`, height: `${Ie.value.height}px` } : void 0)
        }, null, 4),
        d("button", {
          type: "button",
          class: "fe-btn",
          "data-testid": "appframe-print-deny",
          onClick: xn
        }, y(u(r)("appframe.consent_deny")), 1)
      ], 10, zH)) : O("", !0),
      St.value ? (f(), Ge(Q$, {
        key: 4,
        open: !0,
        locale: e.locale,
        theme: e.theme,
        title: `${at.value}: ${St.value.title || u(r)("appframe.confirm_title")}`,
        message: St.value.text,
        danger: St.value.danger,
        onClose: Q[4] || (Q[4] = (we) => He(!1)),
        onConfirm: Q[5] || (Q[5] = (we) => He(!0))
      }, null, 8, ["locale", "theme", "title", "message", "danger"])) : O("", !0),
      w.value ? (f(), Ge(ta, {
        key: 5,
        open: !0,
        size: "sm",
        locale: e.locale,
        theme: e.theme,
        busy: $.value,
        title: u(r)("appframe.unsaved_title"),
        onClose: Q[9] || (Q[9] = (we) => nn("keep"))
      }, {
        actions: mt(() => [
          d("button", {
            type: "button",
            class: "fe-btn",
            "data-testid": "appframe-keep",
            disabled: $.value,
            onClick: Q[6] || (Q[6] = (we) => nn("keep"))
          }, y(u(r)("appframe.keep_open")), 9, OH),
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--danger",
            "data-testid": "appframe-discard",
            disabled: $.value,
            onClick: Q[7] || (Q[7] = (we) => nn("discard"))
          }, y(u(r)("appframe.discard")), 9, LH),
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--primary",
            "data-testid": "appframe-save-close",
            disabled: $.value,
            onClick: Q[8] || (Q[8] = (we) => nn("save"))
          }, y(u(r)("appframe.save_close")), 9, DH)
        ]),
        default: mt(() => [
          d("p", PH, y(u(r)("appframe.unsaved_text", { app: e.title || e.app })), 1)
        ]),
        _: 1
      }, 8, ["locale", "theme", "busy", "title"])) : O("", !0),
      ln.value ? (f(), Ge(zg, {
        key: 6,
        open: !0,
        api: e.api,
        locale: e.locale,
        theme: e.theme,
        mode: "save",
        title: bt(ln.value.name),
        storages: ln.value.storages,
        "start-at": ln.value.startAt,
        onClose: Q[10] || (Q[10] = (we) => Kt(null)),
        onPick: Kt
      }, null, 8, ["api", "locale", "theme", "title", "storages", "start-at"])) : O("", !0)
    ], 10, _H));
  }
}), RH = ["data-testid"], NH = { class: "fe-inspector__heading fe-pinsp__heading" }, IH = ["aria-expanded", "aria-controls", "data-testid"], BH = ["id"], FH = ["id"], UH = {
  key: 0,
  class: "fe-inspector__empty"
}, HH = {
  key: 1,
  class: "fe-surface__error",
  role: "alert"
}, KH = {
  key: 0,
  class: "fe-pinsp__actions"
}, VH = /* @__PURE__ */ lt({
  __name: "PluginInspectorSection",
  props: {
    api: {},
    view: {},
    path: {},
    locale: {},
    theme: {},
    storages: {},
    node: {},
    writable: { type: Boolean },
    userName: {}
  },
  emits: ["op", "toast", "open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = S(!1), l = S(!1), c = S(""), p = Wp(
      {
        api: n.api,
        plugin: n.view.plugin,
        view: n.view.id,
        path: () => n.path,
        locale: () => n.locale,
        errorText: () => i("plugin.view.error")
      },
      {
        onOp: (k) => a("op", k),
        onOpen: (k) => a("open", k),
        // The conversation ended (a job was queued, or the plugin said `done`):
        // what the section shows next is the view's fresh state.
        onDone: () => void x(),
        onToast: (k) => a("toast", k)
      }
    ), m = A(() => Xt(n.view.label, n.locale) || n.view.id), v = A(() => `fe-plugin-insp-${n.view.plugin}-${n.view.id}`);
    async function x() {
      var k;
      l.value = !0, c.value = "";
      try {
        const b = await n.api.pluginView(n.view.plugin, n.view.id, n.path);
        p.setSurface((b == null ? void 0 : b.surface) ?? null), b != null && b.surface || (c.value = i("plugin.view.error"));
      } catch (b) {
        p.setSurface(null), c.value = ((k = i.foreign) == null ? void 0 : k.call(i, String((b == null ? void 0 : b.message) ?? b))) || i("plugin.view.error");
      } finally {
        l.value = !1;
      }
    }
    const w = A(
      () => n.node && n.node.type === "file" ? [{
        path: n.node.path,
        name: n.node.basename,
        size: n.node.size,
        mime: n.node.mime_type,
        readOnly: n.writable === !1 || !!n.node.read_only,
        ...n.node.encrypted ? { encrypted: n.node.encrypted } : {}
      }] : []
    );
    function $() {
      r.value = !r.value, !n.view.ui && r.value && !p.current.value && !l.value && x();
    }
    return Je(
      () => n.path,
      () => {
        r.value = !1, c.value = "", p.setSurface(null);
      }
    ), (k, b) => (f(), h("section", {
      class: "fe-inspector__section fe-pinsp",
      "data-testid": `inspector-plugin-${e.view.plugin}-${e.view.id}`
    }, [
      d("h3", NH, [
        d("button", {
          type: "button",
          class: "fe-pinsp__toggle",
          "aria-expanded": r.value,
          "aria-controls": v.value,
          "data-testid": `inspector-plugin-toggle-${e.view.plugin}-${e.view.id}`,
          onClick: $
        }, [
          (f(), h("svg", {
            class: Re(["fe-ficon fe-pinsp__chev", { "is-open": r.value }]),
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [...b[2] || (b[2] = [
            d("path", { d: "M9 5l7 7-7 7" }, null, -1)
          ])], 2)),
          d("span", null, y(m.value), 1)
        ], 8, IH)
      ]),
      r.value && e.view.ui ? (f(), h("div", {
        key: 0,
        id: v.value,
        class: "fe-pinsp__body"
      }, [
        (f(), Ge(Dg, {
          key: e.path,
          api: e.api,
          app: e.view.plugin,
          version: e.view.ui.version,
          view: e.view.id,
          placement: "inspector",
          ui: e.view.ui,
          files: w.value,
          storages: e.storages,
          "start-at": e.path,
          locale: e.locale,
          theme: e.theme,
          title: m.value,
          "user-name": e.userName,
          onToast: b[0] || (b[0] = (C) => a("toast", C.text)),
          onOp: b[1] || (b[1] = (C) => a("op", C))
        }, null, 8, ["api", "app", "version", "view", "ui", "files", "storages", "start-at", "locale", "theme", "title", "user-name"]))
      ], 8, BH)) : r.value ? (f(), h("div", {
        key: 1,
        id: v.value,
        class: "fe-pinsp__body"
      }, [
        l.value ? (f(), h("p", UH, y(u(i)("plugin.view.loading")), 1)) : c.value ? (f(), h("p", HH, y(c.value), 1)) : u(p).current.value ? (f(), h(Te, { key: 2 }, [
          Ze(Yp, {
            conv: u(p),
            locale: e.locale,
            theme: e.theme,
            api: e.api,
            plugin: e.view.plugin,
            storages: e.storages,
            "start-at": e.path
          }, null, 8, ["conv", "locale", "theme", "api", "plugin", "storages", "start-at"]),
          u(p).footer.value.length ? (f(), h("div", KH, [
            Ze(Gp, {
              conv: u(p),
              locale: e.locale,
              "testid-prefix": "inspector-plugin",
              small: ""
            }, null, 8, ["conv", "locale"])
          ])) : O("", !0)
        ], 64)) : O("", !0)
      ], 8, FH)) : O("", !0)
    ], 8, RH));
  }
}), jH = ["aria-label"], qH = { class: "fe-inspector__head" }, WH = ["innerHTML"], YH = { class: "fe-inspector__head-text" }, GH = ["title"], XH = { class: "fe-inspector__caption" }, JH = {
  key: 0,
  class: "fe-inspector__held",
  role: "note",
  "data-testid": "inspector-held"
}, ZH = ["title", "aria-label"], QH = ["innerHTML"], eK = ["title", "aria-label"], tK = ["innerHTML"], nK = ["aria-label"], aK = ["aria-selected"], iK = ["aria-selected"], oK = { class: "fe-inspector__scroll" }, rK = {
  key: 0,
  class: "fe-inspector__section"
}, sK = { class: "fe-inspector__heading" }, lK = {
  key: 0,
  class: "fe-inspector__lock",
  role: "note",
  "data-testid": "inspector-lock"
}, uK = ["data-link-state"], cK = {
  key: 2,
  class: "fe-inspector__unavailable",
  role: "note",
  "data-testid": "inspector-unavailable"
}, dK = {
  key: 3,
  class: "fe-inspector__meta"
}, fK = { class: "fe-inspector__row" }, pK = ["title"], hK = ["src"], mK = { class: "fe-inspector__meta" }, vK = { class: "fe-inspector__row" }, yK = { class: "fe-inspector__row" }, gK = { class: "fe-inspector__pathcell" }, bK = ["title"], kK = ["title", "aria-label"], wK = ["innerHTML"], _K = {
  key: 0,
  class: "fe-inspector__row"
}, xK = { class: "fe-inspector__row" }, SK = {
  key: 1,
  class: "fe-inspector__row"
}, $K = { class: "fe-inspector__mime" }, TK = {
  key: 2,
  class: "fe-inspector__row"
}, AK = { class: "fe-inspector__pathcell" }, EK = { class: "fe-inspector__path" }, CK = ["title", "aria-label"], zK = ["innerHTML"], MK = {
  key: 3,
  class: "fe-inspector__row"
}, PK = { class: "fe-inspector__pathcell" }, OK = ["title"], LK = ["title", "aria-label"], DK = ["innerHTML"], RK = {
  key: 5,
  class: "fe-inspector__empty"
}, NK = {
  key: 1,
  class: "fe-inspector__section",
  "data-testid": "inspector-tags"
}, IK = { class: "fe-inspector__heading" }, BK = {
  key: 3,
  class: "fe-inspector__section"
}, FK = { class: "fe-inspector__heading" }, UK = {
  key: 0,
  class: "fe-inspector__empty"
}, HK = {
  key: 0,
  class: "fe-inspector__empty"
}, KK = {
  key: 1,
  class: "fe-inspector__versions"
}, VK = { class: "fe-inspector__version-main" }, jK = { class: "fe-inspector__version-n" }, qK = { class: "fe-inspector__version-meta" }, WK = {
  key: 0,
  class: "fe-inspector__confirm"
}, YK = { class: "fe-inspector__confirm-q" }, GK = { class: "fe-inspector__check" }, XK = { class: "fe-inspector__confirm-actions" }, JK = ["disabled", "aria-busy", "onClick"], ZK = ["disabled"], QK = ["disabled", "onClick"], e9 = ["disabled", "aria-busy"], t9 = {
  key: 4,
  class: "fe-inspector__section"
}, n9 = { class: "fe-inspector__heading" }, a9 = { class: "fe-inspector__permrow" }, i9 = {
  key: 5,
  class: "fe-inspector__section",
  "data-testid": "inspector-people"
}, o9 = { class: "fe-inspector__heading" }, r9 = {
  key: 0,
  class: "fe-inspector__empty"
}, s9 = {
  key: 1,
  class: "fe-inspector__people"
}, l9 = {
  class: "fe-inspector__avatar",
  "aria-hidden": "true"
}, u9 = { class: "fe-inspector__person-main" }, c9 = ["title"], d9 = { class: "fe-inspector__person-sub" }, f9 = {
  key: 6,
  class: "fe-inspector__section",
  "data-testid": "inspector-shares"
}, p9 = { class: "fe-inspector__heading" }, h9 = {
  key: 0,
  class: "fe-inspector__linkrow"
}, m9 = ["innerHTML"], v9 = { class: "fe-inspector__linknone" }, y9 = ["disabled"], g9 = {
  key: 1,
  class: "fe-inspector__empty"
}, b9 = {
  key: 2,
  class: "fe-inspector__shares"
}, k9 = ["title"], w9 = {
  key: 0,
  class: "fe-inspector__badge fe-inspector__badge--pin"
}, _9 = {
  key: 1,
  class: "fe-inspector__share-exp"
}, x9 = ["title", "aria-label", "onClick"], S9 = ["innerHTML"], $9 = {
  key: 7,
  class: "fe-inspector__section"
}, T9 = { class: "fe-inspector__heading" }, A9 = {
  key: 0,
  class: "fe-inspector__countbadge"
}, E9 = {
  key: 0,
  class: "fe-inspector__empty"
}, C9 = {
  key: 0,
  class: "fe-inspector__empty"
}, z9 = {
  key: 1,
  class: "fe-inspector__comments"
}, M9 = { class: "fe-inspector__comment-top" }, P9 = ["title"], O9 = ["title"], L9 = ["disabled", "title", "aria-label", "onClick"], D9 = { class: "fe-inspector__comment-body" }, R9 = ["placeholder", "aria-label", "disabled"], N9 = ["disabled"], I9 = {
  key: 8,
  class: "fe-inspector__section",
  "data-testid": "inspector-activity-empty"
}, B9 = { class: "fe-inspector__empty" }, F9 = {
  key: 0,
  class: "fe-inspector__hint"
}, U9 = /* @__PURE__ */ lt({
  __name: "InspectorPanel",
  props: {
    api: {},
    nodes: {},
    dirLabel: {},
    dirCount: {},
    dirPerm: { default: "" },
    heldIn: {},
    locale: {},
    narrow: { type: Boolean, default: !1 },
    callerAdmin: { type: Boolean },
    sharing: {},
    inEncrypted: { type: Boolean },
    thumbSrc: { type: Function, default: void 0 },
    tabs: { type: Boolean, default: !0 },
    apiBase: {},
    authHeaders: {},
    authCredentials: {},
    pluginViews: { default: () => [] },
    theme: {},
    storages: {},
    userName: {}
  },
  emits: ["close", "share-created", "manage-permissions", "toast", "changed", "tags-changed", "open-tag", "plugin-op", "plugin-open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatSize: r, formatNodeSize: l, nodeSizeHint: c, formatDate: p, nodeDisplayName: m, nodeName: v } = ht(
      () => n.locale
    );
    function x(_e) {
      if (typeof _e.e2e_display_dir != "string" || typeof _e.e2e_stored != "string") return _e.path;
      const Ae = _e.path.indexOf("://");
      return `${Ae === -1 ? "" : _e.path.slice(0, Ae + 3)}${_e.e2e_display_dir ? `${_e.e2e_display_dir}/` : ""}${_e.basename}`;
    }
    const w = A(
      () => n.nodes.length === 1 ? n.nodes[0] : null
    ), $ = A(() => n.nodes.length > 1), k = A(() => Yr(qc(w.value), { t: i, formatDate: p, locale: n.locale })), b = A(() => Wc(w.value, { t: i })), C = A(() => Yc(w.value, { t: i })), T = A(() => {
      var _e;
      return ((_e = w.value) == null ? void 0 : _e.type) === "file";
    }), E = A(
      () => {
        var _e;
        return typeof ((_e = w.value) == null ? void 0 : _e.id) == "number" ? w.value.id : null;
      }
    ), R = A(
      () => n.nodes.reduce((_e, Ae) => _e + (typeof Ae.size == "number" ? Ae.size : 0), 0)
    ), z = A(() => ({
      size: R.value,
      size_partial: n.nodes.some((_e) => _e.size_partial === !0)
    })), D = A(() => {
      var Ae;
      const _e = (Ae = w.value) == null ? void 0 : Ae.etag;
      return typeof _e == "string" && _e !== "" ? _e : null;
    }), U = A(
      () => w.value && T.value && n.thumbSrc ? n.thumbSrc(w.value) : null
    ), H = A(() => {
      const _e = w.value;
      return !_e || cc(_e) || _e.trashed === !0 ? [] : (n.pluginViews ?? []).filter(
        (Ae) => Ae.placement === "inspector" && Xy(Ae.applies, [_e], Ae.plugin)
      );
    }), L = A(() => $.value ? i("inspector.items", { n: n.nodes.length }) : w.value ? m(w.value) : n.dirLabel), P = A(() => {
      if ($.value) return l(z.value);
      const _e = w.value;
      if (_e) {
        const Ae = Fv(_e, i);
        if (_e.type === "dir") return Ae;
        const Pe = typeof _e.size == "number" ? r(_e.size) : "";
        return Pe ? `${Ae} · ${Pe}` : Ae;
      }
      return i("inspector.folder_items", { n: n.dirCount });
    }), K = A(
      () => {
        var _e;
        return U.value && /^(image|video)[/]/.test(String(((_e = w.value) == null ? void 0 : _e.mime_type) ?? "")) ? U.value : null;
      }
    ), N = A(
      () => wa(w.value && !$.value ? w.value : { type: "dir" })
    ), J = A(
      () => E.value != null && n.apiBase !== void 0 && !$.value
    );
    function j(_e) {
      return _e.length > 12 ? `${_e.slice(0, 12)}…` : _e;
    }
    function re(_e) {
      return p(_e, { time: !0 }) || "-";
    }
    function q(_e) {
      if (!_e) return "-";
      const Ae = Date.parse(_e);
      return Number.isNaN(Ae) ? _e : re(Ae);
    }
    async function le(_e) {
      try {
        await navigator.clipboard.writeText(_e), a("toast", i("inspector.copied"));
      } catch {
        a("toast", _e);
      }
    }
    const ve = A(() => {
      if (!w.value) return "";
      const _e = w.value.perm;
      return typeof _e == "string" && _e !== "" ? _e : n.dirPerm || "";
    }), ce = A(() => n.sharing ?? g5), se = A(() => BS(n.nodes, n.inEncrypted === !0)), fe = A(() => ve.value === "owner" && ce.value.users);
    function _(_e) {
      return i(`inspector.perm.${_e}`) === `inspector.perm.${_e}` ? _e : i(`inspector.perm.${_e}`);
    }
    const ee = S("idle"), Y = S([]), B = S(null), W = S(!0), F = S(null), V = A(() => F.value !== null), ke = S("idle"), qe = S([]);
    let Me = 0;
    async function Fe() {
      const _e = ++Me;
      if (B.value = null, Y.value = [], qe.value = [], w.value && T.value && E.value != null ? (ee.value = "loading", We(_e)) : ee.value = "hidden", w.value) {
        ke.value = "loading";
        const Ae = w.value.path;
        try {
          const { shares: Pe } = await n.api.listShares(Ae);
          if (_e !== Me) return;
          qe.value = Array.isArray(Pe) ? Pe : [], ke.value = "ok";
        } catch {
          if (_e !== Me) return;
          ke.value = "hidden";
        }
      } else
        ke.value = "hidden";
    }
    async function We(_e) {
      const Ae = E.value;
      if (Ae != null)
        try {
          const Pe = await n.api.listVersions(Ae);
          if (_e !== Me) return;
          Y.value = Pe, ee.value = "ok";
        } catch (Pe) {
          if (_e !== Me) return;
          const _t = Pe.status;
          _t === 401 || _t === 403 || _t === 404 ? ee.value = "hidden" : ee.value = "error";
        }
    }
    function $t(_e) {
      B.value = _e.id, W.value = !0;
    }
    async function St(_e) {
      const Ae = E.value;
      if (!(Ae == null || V.value)) {
        F.value = "restore";
        try {
          await n.api.restoreVersion(Ae, _e.id, W.value), a("toast", i("inspector.versions.restored")), B.value = null, a("changed"), await We(++Me);
        } catch (Pe) {
          const _t = oy(Pe);
          a("toast", _t ? Yr(_t, { t: i, formatDate: p, locale: n.locale }) : Pe.message);
        } finally {
          F.value = null;
        }
      }
    }
    async function at() {
      const _e = E.value;
      if (!(_e == null || V.value)) {
        F.value = "snapshot";
        try {
          await n.api.snapshotVersion(_e), a("toast", i("inspector.versions.snapshotted")), await We(++Me);
        } catch (Ae) {
          const Pe = Ae.status;
          Pe === 404 || Pe === 405 || Pe === 501 ? a("toast", i("inspector.versions.unsupported")) : a("toast", Ae.message);
        } finally {
          F.value = null;
        }
      }
    }
    const kt = S("details"), pt = S("hidden"), Ne = S([]);
    let ie = 0;
    async function xe() {
      const _e = ++ie, Ae = w.value;
      if (!n.tabs || !Ae) {
        pt.value = "hidden", Ne.value = [];
        return;
      }
      pt.value = "loading";
      try {
        const Pe = await n.api.listPermissions(Ae.path);
        if (_e !== ie) return;
        if (!Pe.storage_rbac) {
          pt.value = "hidden", Ne.value = [];
          return;
        }
        Ne.value = [...Pe.direct ?? [], ...Pe.inherited ?? []], pt.value = "ok";
      } catch {
        if (_e !== ie) return;
        Ne.value = [], pt.value = "hidden";
      }
    }
    function he(_e) {
      return _e.kind === "group" ? { name: _e.group_name } : { name: _e.user_name, display_name: _e.user_display_name, email: _e.user_email };
    }
    function De(_e) {
      return qp(he(_e)) || `#${_e.kind === "group" ? _e.group_id : _e.user_id}`;
    }
    function ot(_e) {
      return sR(he(_e), gi(n.locale)) || (_e.kind === "group" ? "#" : "?");
    }
    A(() => qe.value.length ? qe.value[0] : null);
    const ft = S(!1);
    async function gt() {
      var Ae;
      const _e = w.value;
      if (!(!_e || ft.value || !ce.value.links || se.value)) {
        ft.value = !0;
        try {
          const _t = ((Ae = (await n.api.createShare({ path: _e.path })).share) == null ? void 0 : Ae.url) ?? "", { shares: Et } = await n.api.listShares(_e.path);
          qe.value = Array.isArray(Et) ? Et : [], ke.value = "ok", _t && (a("share-created", { path: _e.path, url: _t }), await le(_t));
        } catch (Pe) {
          a("toast", Pe.message);
        } finally {
          ft.value = !1;
        }
      }
    }
    Je(
      () => [n.nodes.map((_e) => _e.path).join("|"), n.tabs],
      () => void xe(),
      { immediate: !0 }
    );
    const Ut = A(
      () => ee.value !== "hidden" || Xe.value !== "hidden"
    );
    Je(
      () => n.nodes.map((_e) => _e.path).join("\0"),
      () => void Fe(),
      { immediate: !0 }
    );
    const Xe = S("hidden"), Ve = S([]), Be = S("");
    Je(Be, (_e) => {
      const Ae = zy(_e, Pc("comment_max_runes"));
      Ae !== _e && (Be.value = Ae);
    });
    const ne = S(!1), ge = A(
      () => {
        var _e;
        return typeof ((_e = w.value) == null ? void 0 : _e.id) == "number" ? w.value.id : null;
      }
    );
    let G = 0;
    async function ye() {
      const _e = ++G, Ae = ge.value;
      if (Ae == null) {
        Xe.value = "hidden", Ve.value = [];
        return;
      }
      Xe.value = Ve.value.length > 0 ? "ok" : "loading";
      try {
        const Pe = await n.api.listComments(Ae);
        if (_e !== G) return;
        Ve.value = Pe, Xe.value = "ok";
      } catch (Pe) {
        if (_e !== G) return;
        Ve.value = [];
        const _t = Pe.status;
        Xe.value = _t === 401 || _t === 403 || _t === 404 ? "hidden" : "error";
      }
    }
    async function te() {
      const _e = ge.value, Ae = Be.value.trim();
      if (!(_e == null || Ae === "" || ne.value)) {
        ne.value = !0;
        try {
          await n.api.addComment(_e, Ae), Be.value = "", await ye();
        } catch (Pe) {
          a("toast", Pe.message);
        } finally {
          ne.value = !1;
        }
      }
    }
    async function Ce(_e) {
      if (!ne.value) {
        ne.value = !0;
        try {
          await n.api.deleteComment(_e.id), await ye();
        } catch (Ae) {
          a("toast", Ae.message);
        } finally {
          ne.value = !1;
        }
      }
    }
    function Ie(_e) {
      const Ae = Date.parse(_e);
      if (Number.isNaN(Ae)) return _e;
      const Pe = Math.round((Ae - Date.now()) / 1e3), _t = Math.abs(Pe), Et = [
        ["year", 31536e3],
        ["month", 2592e3],
        ["day", 86400],
        ["hour", 3600],
        ["minute", 60]
      ];
      try {
        const xn = new Intl.RelativeTimeFormat(
          gi(n.locale),
          { numeric: "auto" }
        );
        for (const [Dt, bn] of Et)
          if (_t >= bn) return xn.format(Math.trunc(Pe / bn), Dt);
        return xn.format(Pe, "second");
      } catch {
        return q(_e);
      }
    }
    return Je(
      () => ge.value,
      () => {
        Ve.value = [], Be.value = "", ye();
      },
      { immediate: !0 }
    ), (_e, Ae) => (f(), h("aside", {
      class: Re(["fe-inspector", { "fe-inspector--overlay": e.narrow }]),
      role: "complementary",
      "aria-label": u(i)("inspector.title")
    }, [
      d("header", qH, [
        d("span", {
          class: "fe-inspector__head-icon",
          "aria-hidden": "true",
          innerHTML: N.value
        }, null, 8, WH),
        d("div", YH, [
          d("h2", {
            class: "fe-inspector__title",
            title: L.value
          }, [
            d("bdi", null, y(L.value), 1)
          ], 8, GH),
          d("p", XH, y(P.value), 1),
          e.heldIn ? (f(), h("p", JH, y(u(i)("inspector.held", { where: e.heldIn })), 1)) : O("", !0)
        ]),
        w.value ? (f(), h("button", {
          key: 0,
          type: "button",
          class: "fe-inspector__iconbtn",
          title: u(i)("inspector.copy_name"),
          "aria-label": u(i)("inspector.copy_name"),
          "data-testid": "inspector-copy-name",
          onClick: Ae[0] || (Ae[0] = (Pe) => le(w.value ? u(v)(w.value) : L.value))
        }, [
          d("span", {
            "aria-hidden": "true",
            innerHTML: u(zt)("copy")
          }, null, 8, QH)
        ], 8, ZH)) : O("", !0),
        d("button", {
          type: "button",
          class: "fe-inspector__iconbtn fe-inspector__close",
          title: u(i)("inspector.close"),
          "aria-label": u(i)("inspector.close"),
          onClick: Ae[1] || (Ae[1] = (Pe) => a("close"))
        }, [
          d("span", {
            "aria-hidden": "true",
            innerHTML: u(zt)("close")
          }, null, 8, tK)
        ], 8, eK)
      ]),
      e.tabs ? (f(), h("div", {
        key: 0,
        class: "fe-inspector__tabs",
        role: "tablist",
        "aria-label": u(i)("inspector.title")
      }, [
        d("button", {
          type: "button",
          class: Re(["fe-inspector__tab", { "is-active": kt.value === "details" }]),
          role: "tab",
          "aria-selected": kt.value === "details",
          "data-testid": "inspector-tab-details",
          onClick: Ae[2] || (Ae[2] = (Pe) => kt.value = "details")
        }, y(u(i)("inspector.tab.details")), 11, aK),
        d("button", {
          type: "button",
          class: Re(["fe-inspector__tab", { "is-active": kt.value === "activity" }]),
          role: "tab",
          "aria-selected": kt.value === "activity",
          "data-testid": "inspector-tab-activity",
          onClick: Ae[3] || (Ae[3] = (Pe) => kt.value = "activity")
        }, y(u(i)("inspector.tab.activity")), 11, iK)
      ], 8, nK)) : O("", !0),
      d("div", oK, [
        !e.tabs || kt.value === "details" ? (f(), h("section", rK, [
          d("h3", sK, y(u(i)("inspector.section.general")), 1),
          k.value ? (f(), h("p", lK, [
            Ae[18] || (Ae[18] = d("span", { "aria-hidden": "true" }, "🔒", -1)),
            d("span", null, [
              d("strong", null, y(u(i)("applock.inspector")), 1),
              Ae[17] || (Ae[17] = d("br", null, null, -1)),
              Ht(y(k.value), 1)
            ])
          ])) : O("", !0),
          b.value ? (f(), h("p", {
            key: 1,
            class: "fe-inspector__linknote",
            role: "note",
            "data-testid": "inspector-symlink",
            "data-link-state": b.value.state
          }, [
            Ae[20] || (Ae[20] = d("span", { "aria-hidden": "true" }, "🔗", -1)),
            d("span", null, [
              d("strong", null, y(u(i)("symlink.inspector")), 1),
              Ae[19] || (Ae[19] = d("br", null, null, -1)),
              Ht(y(b.value.why), 1)
            ])
          ], 8, uK)) : O("", !0),
          C.value ? (f(), h("p", cK, [
            Ae[23] || (Ae[23] = d("span", { "aria-hidden": "true" }, "!", -1)),
            d("span", null, [
              d("strong", null, y(u(i)("unavailable.inspector")), 1),
              Ae[22] || (Ae[22] = d("br", null, null, -1)),
              Ht(y(C.value.why) + " ", 1),
              C.value.reason ? (f(), h(Te, { key: 0 }, [
                Ae[21] || (Ae[21] = d("br", null, null, -1)),
                d("bdi", null, y(C.value.reason), 1)
              ], 64)) : O("", !0)
            ])
          ])) : O("", !0),
          $.value ? (f(), h("dl", dK, [
            d("div", fK, [
              d("dt", null, y(u(i)("inspector.size")), 1),
              d("dd", {
                title: u(c)(z.value)
              }, y(u(l)(z.value)), 9, pK)
            ])
          ])) : w.value ? (f(), h(Te, { key: 4 }, [
            K.value ? (f(), h("img", {
              key: 0,
              class: "fe-inspector__preview",
              src: K.value,
              alt: "",
              "aria-hidden": "true"
            }, null, 8, hK)) : O("", !0),
            d("dl", mK, [
              d("div", vK, [
                d("dt", null, y(u(i)("inspector.type")), 1),
                d("dd", null, y(u(Fv)(w.value, u(i))), 1)
              ]),
              d("div", yK, [
                d("dt", null, y(u(i)("inspector.path")), 1),
                d("dd", gK, [
                  d("span", {
                    class: "fe-inspector__path",
                    title: w.value.path
                  }, [
                    d("bdi", null, y(x(w.value)), 1)
                  ], 8, bK),
                  d("button", {
                    type: "button",
                    class: "fe-inspector__copy",
                    title: u(i)("inspector.copy"),
                    "aria-label": u(i)("inspector.copy"),
                    onClick: Ae[4] || (Ae[4] = (Pe) => le(w.value.path))
                  }, [
                    d("span", {
                      "aria-hidden": "true",
                      innerHTML: u(zt)("copy")
                    }, null, 8, wK)
                  ], 8, kK)
                ])
              ]),
              T.value ? (f(), h("div", _K, [
                d("dt", null, y(u(i)("inspector.size")), 1),
                d("dd", null, y(u(r)(typeof w.value.size == "number" ? w.value.size : null)), 1)
              ])) : O("", !0),
              d("div", xK, [
                d("dt", null, y(u(i)("inspector.modified")), 1),
                d("dd", null, y(re(w.value.last_modified)), 1)
              ]),
              T.value && w.value.mime_type ? (f(), h("div", SK, [
                d("dt", null, y(u(i)("inspector.mime")), 1),
                d("dd", $K, y(w.value.mime_type), 1)
              ])) : O("", !0),
              e.callerAdmin && typeof w.value.id == "number" ? (f(), h("div", TK, [
                d("dt", null, y(u(i)("inspector.nodeId")), 1),
                d("dd", AK, [
                  d("span", EK, y(w.value.id), 1),
                  d("button", {
                    type: "button",
                    class: "fe-inspector__copy",
                    title: u(i)("inspector.copy"),
                    "aria-label": u(i)("inspector.copy"),
                    onClick: Ae[5] || (Ae[5] = (Pe) => le(String(w.value.id)))
                  }, [
                    d("span", {
                      "aria-hidden": "true",
                      innerHTML: u(zt)("copy")
                    }, null, 8, zK)
                  ], 8, CK)
                ])
              ])) : O("", !0),
              D.value ? (f(), h("div", MK, [
                d("dt", null, y(u(i)("inspector.etag")), 1),
                d("dd", PK, [
                  d("span", {
                    class: "fe-inspector__path",
                    title: D.value
                  }, y(j(D.value)), 9, OK),
                  d("button", {
                    type: "button",
                    class: "fe-inspector__copy",
                    title: u(i)("inspector.copy"),
                    "aria-label": u(i)("inspector.copy"),
                    onClick: Ae[6] || (Ae[6] = (Pe) => le(D.value))
                  }, [
                    d("span", {
                      "aria-hidden": "true",
                      innerHTML: u(zt)("copy")
                    }, null, 8, DK)
                  ], 8, LK)
                ])
              ])) : O("", !0)
            ])
          ], 64)) : (f(), h("p", RK, y(u(i)("inspector.select_hint")), 1))
        ])) : O("", !0),
        J.value && (!e.tabs || kt.value === "details") ? (f(), h("section", NK, [
          d("h3", IK, y(u(i)("inspector.section.tags")), 1),
          Ze(dx, {
            "node-id": E.value,
            locale: e.locale,
            "api-base": e.apiBase,
            "auth-headers": e.authHeaders,
            "auth-credentials": e.authCredentials,
            onChange: Ae[7] || (Ae[7] = (Pe) => a("tags-changed", Pe)),
            onOpen: Ae[8] || (Ae[8] = (Pe, _t) => a("open-tag", Pe, _t)),
            onError: Ae[9] || (Ae[9] = () => a("toast", u(i)("inspector.error")))
          }, null, 8, ["node-id", "locale", "api-base", "auth-headers", "auth-credentials"])
        ])) : O("", !0),
        w.value && (!e.tabs || kt.value === "details") ? (f(!0), h(Te, { key: 2 }, nt(H.value, (Pe) => (f(), Ge(VH, {
          key: `${Pe.plugin}/${Pe.id}`,
          api: e.api,
          view: Pe,
          path: w.value.path,
          node: w.value,
          locale: e.locale,
          theme: e.theme,
          storages: e.storages,
          "user-name": e.userName,
          onOp: Ae[10] || (Ae[10] = (_t) => a("plugin-op", _t)),
          onToast: Ae[11] || (Ae[11] = (_t) => a("toast", _t)),
          onOpen: (_t) => a("plugin-open", { plugin: Pe.plugin, req: _t })
        }, null, 8, ["api", "view", "path", "node", "locale", "theme", "storages", "user-name", "onOpen"]))), 128)) : O("", !0),
        (ee.value === "ok" || ee.value === "error") && (!e.tabs || kt.value === "activity") ? (f(), h("section", BK, [
          d("h3", FK, y(u(i)("inspector.section.versions")), 1),
          ee.value === "error" ? (f(), h("p", UK, y(u(i)("inspector.error")), 1)) : (f(), h(Te, { key: 1 }, [
            Y.value.length === 0 ? (f(), h("p", HK, y(u(i)("inspector.versions.empty")), 1)) : (f(), h("ul", KK, [
              (f(!0), h(Te, null, nt(Y.value, (Pe) => (f(), h("li", {
                key: Pe.id,
                class: "fe-inspector__version"
              }, [
                d("div", VK, [
                  d("span", jK, y(u(i)("inspector.versions.v", { n: Pe.version_n })), 1),
                  d("span", qK, y(q(Pe.created_at)) + " · " + y(u(r)(Pe.size)), 1)
                ]),
                B.value === Pe.id ? (f(), h("div", WK, [
                  d("p", YK, y(u(i)("inspector.versions.restore_confirm")), 1),
                  d("label", GK, [
                    dn(d("input", {
                      "onUpdate:modelValue": Ae[12] || (Ae[12] = (_t) => W.value = _t),
                      type: "checkbox"
                    }, null, 512), [
                      [zc, W.value]
                    ]),
                    Ht(" " + y(u(i)("inspector.versions.snapshot_current")), 1)
                  ]),
                  d("div", XK, [
                    d("button", {
                      type: "button",
                      class: "fe-btn fe-btn--primary fe-btn--sm",
                      disabled: V.value,
                      "aria-busy": F.value === "restore",
                      onClick: (_t) => St(Pe)
                    }, y(F.value === "restore" ? u(i)("inspector.versions.restoring") : u(i)("inspector.versions.confirm")), 9, JK),
                    d("button", {
                      type: "button",
                      class: "fe-btn fe-btn--sm",
                      disabled: V.value,
                      onClick: Ae[13] || (Ae[13] = (_t) => B.value = null)
                    }, y(u(i)("inspector.versions.cancel")), 9, ZK)
                  ])
                ])) : (f(), h("button", {
                  key: 1,
                  type: "button",
                  class: "fe-btn fe-btn--sm",
                  disabled: V.value,
                  onClick: (_t) => $t(Pe)
                }, y(u(i)("inspector.versions.restore")), 9, QK))
              ]))), 128))
            ])),
            d("button", {
              type: "button",
              class: "fe-btn fe-btn--sm fe-inspector__snapshot",
              disabled: V.value,
              "aria-busy": F.value === "snapshot",
              onClick: at
            }, y(F.value === "snapshot" ? u(i)("inspector.versions.snapshotting") : u(i)("inspector.versions.take_snapshot")), 9, e9)
          ], 64))
        ])) : O("", !0),
        w.value && ve.value && (!e.tabs || kt.value === "details") && !(e.tabs && pt.value === "ok") ? (f(), h("section", t9, [
          d("h3", n9, y(u(i)("inspector.section.permissions")), 1),
          d("div", a9, [
            d("span", {
              class: Re(["fe-inspector__badge", `fe-inspector__badge--${ve.value}`])
            }, y(_(ve.value)), 3),
            fe.value ? (f(), h("button", {
              key: 0,
              type: "button",
              class: "fe-btn fe-btn--sm",
              onClick: Ae[14] || (Ae[14] = (Pe) => a("manage-permissions", w.value))
            }, y(u(i)("inspector.perm.manage")), 1)) : O("", !0)
          ])
        ])) : O("", !0),
        e.tabs && kt.value === "details" && pt.value === "ok" ? (f(), h("section", i9, [
          d("h3", o9, y(u(i)("inspector.people")), 1),
          Ne.value.length === 0 ? (f(), h("p", r9, y(u(i)("inspector.people.empty")), 1)) : (f(), h("ul", s9, [
            (f(!0), h(Te, null, nt(Ne.value, (Pe) => (f(), h("li", {
              key: `${Pe.kind ?? "user"}-${Pe.id}-${Pe.inherited ? "inherited" : "direct"}`,
              class: "fe-inspector__person"
            }, [
              d("span", l9, y(ot(Pe)), 1),
              d("span", u9, [
                d("span", {
                  class: "fe-inspector__person-name",
                  title: Pe.kind === "group" ? u(i)("access.ui.group_title", { name: De(Pe) }) : Pe.user_email
                }, y(De(Pe)), 9, c9),
                d("span", d9, [
                  Pe.kind === "group" ? (f(), h(Te, { key: 0 }, [
                    Ht(y(u(i)("access.ui.group")) + " · ", 1)
                  ], 64)) : O("", !0),
                  Ht(" " + y(_(Pe.level)), 1),
                  Pe.inherited ? (f(), h(Te, { key: 1 }, [
                    Ht(" · " + y(u(i)("inspector.people.inherited")), 1)
                  ], 64)) : O("", !0)
                ])
              ])
            ]))), 128))
          ])),
          fe.value && w.value ? (f(), h("button", {
            key: 2,
            type: "button",
            class: "fe-btn fe-btn--sm",
            onClick: Ae[15] || (Ae[15] = (Pe) => a("manage-permissions", w.value))
          }, y(u(i)("inspector.people.manage")), 1)) : O("", !0)
        ])) : O("", !0),
        ke.value === "ok" && (!e.tabs || kt.value === "details") ? (f(), h("section", f9, [
          d("h3", p9, y(e.tabs ? u(i)("inspector.link") : u(i)("inspector.section.shares")), 1),
          e.tabs && qe.value.length === 0 ? (f(), h("div", h9, [
            d("span", {
              class: "fe-inspector__linkicon",
              "aria-hidden": "true",
              innerHTML: u(zt)("link")
            }, null, 8, m9),
            d("span", v9, y(u(i)("inspector.link.none")), 1),
            ce.value.links && !se.value ? (f(), h("button", {
              key: 0,
              type: "button",
              class: "fe-btn fe-btn--sm",
              disabled: ft.value || !w.value,
              "data-testid": "inspector-create-link",
              onClick: gt
            }, y(u(i)("inspector.link.create")), 9, y9)) : O("", !0)
          ])) : qe.value.length === 0 ? (f(), h("p", g9, y(u(i)("inspector.shares.empty")), 1)) : (f(), h("ul", b9, [
            (f(!0), h(Te, null, nt(qe.value, (Pe) => (f(), h("li", {
              key: Pe.uuid,
              class: "fe-inspector__share"
            }, [
              d("span", {
                class: "fe-inspector__share-url",
                title: Pe.url
              }, y(Pe.url), 9, k9),
              Pe.password_pin ? (f(), h("span", w9, "PIN")) : O("", !0),
              Pe.expires_at ? (f(), h("span", _9, y(q(Pe.expires_at)), 1)) : O("", !0),
              d("button", {
                type: "button",
                class: "fe-inspector__copy",
                title: u(i)("inspector.shares.copy"),
                "aria-label": u(i)("inspector.shares.copy"),
                onClick: (_t) => le(Pe.url)
              }, [
                d("span", {
                  "aria-hidden": "true",
                  innerHTML: u(zt)("copy")
                }, null, 8, S9)
              ], 8, x9)
            ]))), 128))
          ]))
        ])) : O("", !0),
        (Xe.value === "ok" || Xe.value === "error") && (!e.tabs || kt.value === "activity") ? (f(), h("section", $9, [
          d("h3", T9, [
            Ht(y(u(i)("inspector.section.comments")) + " ", 1),
            Ve.value.length > 0 ? (f(), h("span", A9, y(Ve.value.length), 1)) : O("", !0)
          ]),
          Xe.value === "error" ? (f(), h("p", E9, y(u(i)("inspector.error")), 1)) : (f(), h(Te, { key: 1 }, [
            Ve.value.length === 0 ? (f(), h("p", C9, y(u(i)("inspector.comments.empty")), 1)) : (f(), h("ul", z9, [
              (f(!0), h(Te, null, nt(Ve.value, (Pe) => (f(), h("li", {
                key: Pe.id,
                class: "fe-inspector__comment"
              }, [
                d("div", M9, [
                  d("span", {
                    class: "fe-inspector__comment-author",
                    title: Pe.author_name
                  }, y(Pe.author_name || "-"), 9, P9),
                  d("span", {
                    class: "fe-inspector__comment-time",
                    title: q(Pe.created_at)
                  }, y(Ie(Pe.created_at)), 9, O9),
                  Pe.can_delete ? (f(), h("button", {
                    key: 0,
                    type: "button",
                    class: "fe-inspector__comment-del",
                    disabled: ne.value,
                    title: u(i)("inspector.comments.delete"),
                    "aria-label": u(i)("inspector.comments.delete"),
                    onClick: (_t) => Ce(Pe)
                  }, "×", 8, L9)) : O("", !0)
                ]),
                d("p", D9, y(Pe.body), 1)
              ]))), 128))
            ])),
            d("form", {
              class: "fe-inspector__comment-form",
              onSubmit: yt(te, ["prevent"])
            }, [
              dn(d("input", {
                "onUpdate:modelValue": Ae[16] || (Ae[16] = (Pe) => Be.value = Pe),
                type: "text",
                class: "fe-inspector__comment-input",
                placeholder: u(i)("inspector.comments.placeholder"),
                "aria-label": u(i)("inspector.comments.placeholder"),
                disabled: ne.value
              }, null, 8, R9), [
                [_n, Be.value]
              ]),
              d("button", {
                type: "submit",
                class: "fe-btn fe-btn--primary fe-btn--sm",
                disabled: ne.value || Be.value.trim() === ""
              }, y(u(i)("inspector.comments.send")), 9, N9)
            ], 32)
          ], 64))
        ])) : O("", !0),
        e.tabs && kt.value === "activity" && !Ut.value ? (f(), h("section", I9, [
          d("p", B9, y(w.value ? u(i)("inspector.activity.empty") : u(i)("inspector.activity.select")), 1),
          w.value ? (f(), h("p", F9, y(u(i)("inspector.activity.hint")), 1)) : O("", !0)
        ])) : O("", !0)
      ])
    ], 10, jH));
  }
});
/*! @license DOMPurify 3.4.2 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.2/LICENSE */
const {
  entries: eT,
  setPrototypeOf: I1,
  isFrozen: H9,
  getPrototypeOf: K9,
  getOwnPropertyDescriptor: V9
} = Object;
let {
  freeze: _a,
  seal: ii,
  create: Js
} = Object, {
  apply: my,
  construct: vy
} = typeof Reflect < "u" && Reflect;
_a || (_a = function(t) {
  return t;
});
ii || (ii = function(t) {
  return t;
});
my || (my = function(t, n) {
  for (var a = arguments.length, i = new Array(a > 2 ? a - 2 : 0), r = 2; r < a; r++)
    i[r - 2] = arguments[r];
  return t.apply(n, i);
});
vy || (vy = function(t) {
  for (var n = arguments.length, a = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    a[i - 1] = arguments[i];
  return new t(...a);
});
const Iu = Kn(Array.prototype.forEach), j9 = Kn(Array.prototype.lastIndexOf), B1 = Kn(Array.prototype.pop), Bu = Kn(Array.prototype.push), q9 = Kn(Array.prototype.splice), va = Array.isArray, Wu = Kn(String.prototype.toLowerCase), tv = Kn(String.prototype.toString), F1 = Kn(String.prototype.match), Ws = Kn(String.prototype.replace), U1 = Kn(String.prototype.indexOf), W9 = Kn(String.prototype.trim), Y9 = Kn(Number.prototype.toString), G9 = Kn(Boolean.prototype.toString), H1 = typeof BigInt > "u" ? null : Kn(BigInt.prototype.toString), K1 = typeof Symbol > "u" ? null : Kn(Symbol.prototype.toString), Rn = Kn(Object.prototype.hasOwnProperty), Fu = Kn(Object.prototype.toString), oa = Kn(RegExp.prototype.test), hf = X9(TypeError);
function Kn(e) {
  return function(t) {
    t instanceof RegExp && (t.lastIndex = 0);
    for (var n = arguments.length, a = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
      a[i - 1] = arguments[i];
    return my(e, t, a);
  };
}
function X9(e) {
  return function() {
    for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
      n[a] = arguments[a];
    return vy(e, n);
  };
}
function Wt(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Wu;
  if (I1 && I1(e, null), !va(t))
    return e;
  let a = t.length;
  for (; a--; ) {
    let i = t[a];
    if (typeof i == "string") {
      const r = n(i);
      r !== i && (H9(t) || (t[a] = r), i = r);
    }
    e[i] = !0;
  }
  return e;
}
function J9(e) {
  for (let t = 0; t < e.length; t++)
    Rn(e, t) || (e[t] = null);
  return e;
}
function Ta(e) {
  const t = Js(null);
  for (const [n, a] of eT(e))
    Rn(e, n) && (va(a) ? t[n] = J9(a) : a && typeof a == "object" && a.constructor === Object ? t[n] = Ta(a) : t[n] = a);
  return t;
}
function Z9(e) {
  switch (typeof e) {
    case "string":
      return e;
    case "number":
      return Y9(e);
    case "boolean":
      return G9(e);
    case "bigint":
      return H1 ? H1(e) : "0";
    case "symbol":
      return K1 ? K1(e) : "Symbol()";
    case "undefined":
      return Fu(e);
    case "function":
    case "object": {
      if (e === null)
        return Fu(e);
      const t = e, n = Zs(t, "toString");
      if (typeof n == "function") {
        const a = n(t);
        return typeof a == "string" ? a : Fu(a);
      }
      return Fu(e);
    }
    default:
      return Fu(e);
  }
}
function Zs(e, t) {
  for (; e !== null; ) {
    const a = V9(e, t);
    if (a) {
      if (a.get)
        return Kn(a.get);
      if (typeof a.value == "function")
        return Kn(a.value);
    }
    e = K9(e);
  }
  function n() {
    return null;
  }
  return n;
}
function Q9(e) {
  try {
    return oa(e, ""), !0;
  } catch {
    return !1;
  }
}
const V1 = _a(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), nv = _a(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), av = _a(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), e7 = _a(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), iv = _a(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), t7 = _a(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), j1 = _a(["#text"]), q1 = _a(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), ov = _a(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), W1 = _a(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), mf = _a(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), n7 = ii(/\{\{[\w\W]*|[\w\W]*\}\}/gm), a7 = ii(/<%[\w\W]*|[\w\W]*%>/gm), i7 = ii(/\$\{[\w\W]*/gm), o7 = ii(/^data-[\-\w.\u00B7-\uFFFF]+$/), r7 = ii(/^aria-[\-\w]+$/), tT = ii(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), s7 = ii(/^(?:\w+script|data):/i), l7 = ii(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), nT = ii(/^html$/i), u7 = ii(/^[a-z][.\w]*(-[.\w]+)+$/i);
var Y1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: r7,
  ATTR_WHITESPACE: l7,
  CUSTOM_ELEMENT: u7,
  DATA_ATTR: o7,
  DOCTYPE_NAME: nT,
  ERB_EXPR: a7,
  IS_ALLOWED_URI: tT,
  IS_SCRIPT_OR_DATA: s7,
  MUSTACHE_EXPR: n7,
  TMPLIT_EXPR: i7
});
const Uu = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, c7 = function() {
  return typeof window > "u" ? null : window;
}, d7 = function(t, n) {
  if (typeof t != "object" || typeof t.createPolicy != "function")
    return null;
  let a = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (a = n.getAttribute(i));
  const r = "dompurify" + (a ? "#" + a : "");
  try {
    return t.createPolicy(r, {
      createHTML(l) {
        return l;
      },
      createScriptURL(l) {
        return l;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + r + " could not be created."), null;
  }
}, G1 = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function aT() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : c7();
  const t = (Qe) => aT(Qe);
  if (t.version = "3.4.2", t.removed = [], !e || !e.document || e.document.nodeType !== Uu.document || !e.Element)
    return t.isSupported = !1, t;
  let {
    document: n
  } = e;
  const a = n, i = a.currentScript, {
    DocumentFragment: r,
    HTMLTemplateElement: l,
    Node: c,
    Element: p,
    NodeFilter: m,
    NamedNodeMap: v = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: x,
    DOMParser: w,
    trustedTypes: $
  } = e, k = p.prototype, b = Zs(k, "cloneNode"), C = Zs(k, "remove"), T = Zs(k, "nextSibling"), E = Zs(k, "childNodes"), R = Zs(k, "parentNode");
  if (typeof l == "function") {
    const Qe = n.createElement("template");
    Qe.content && Qe.content.ownerDocument && (n = Qe.content.ownerDocument);
  }
  let z, D = "";
  const {
    implementation: U,
    createNodeIterator: H,
    createDocumentFragment: L,
    getElementsByTagName: P
  } = n, {
    importNode: K
  } = a;
  let N = G1();
  t.isSupported = typeof eT == "function" && typeof R == "function" && U && U.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: J,
    ERB_EXPR: j,
    TMPLIT_EXPR: re,
    DATA_ATTR: q,
    ARIA_ATTR: le,
    IS_SCRIPT_OR_DATA: ve,
    ATTR_WHITESPACE: ce,
    CUSTOM_ELEMENT: se
  } = Y1;
  let {
    IS_ALLOWED_URI: fe
  } = Y1, _ = null;
  const ee = Wt({}, [...V1, ...nv, ...av, ...iv, ...j1]);
  let Y = null;
  const B = Wt({}, [...q1, ...ov, ...W1, ...mf]);
  let W = Object.seal(Js(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), F = null, V = null;
  const ke = Object.seal(Js(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let qe = !0, Me = !0, Fe = !1, We = !0, $t = !1, St = !0, at = !1, kt = !1, pt = !1, Ne = !1, ie = !1, xe = !1, he = !0, De = !1;
  const ot = "user-content-";
  let ft = !0, gt = !1, Ut = {}, Xe = null;
  const Ve = Wt({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let Be = null;
  const ne = Wt({}, ["audio", "video", "img", "source", "image", "track"]);
  let ge = null;
  const G = Wt({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), ye = "http://www.w3.org/1998/Math/MathML", te = "http://www.w3.org/2000/svg", Ce = "http://www.w3.org/1999/xhtml";
  let Ie = Ce, _e = !1, Ae = null;
  const Pe = Wt({}, [ye, te, Ce], tv);
  let _t = Wt({}, ["mi", "mo", "mn", "ms", "mtext"]), Et = Wt({}, ["annotation-xml"]);
  const xn = Wt({}, ["title", "style", "font", "a", "script"]);
  let Dt = null;
  const bn = ["application/xhtml+xml", "text/html"], ln = "text/html";
  let Jt = null, Ln = null;
  const Vn = n.createElement("form"), Ft = function(ue) {
    return ue instanceof RegExp || ue instanceof Function;
  }, na = function() {
    let ue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (Ln && Ln === ue)
      return;
    (!ue || typeof ue != "object") && (ue = {}), ue = Ta(ue), Dt = // eslint-disable-next-line unicorn/prefer-includes
    bn.indexOf(ue.PARSER_MEDIA_TYPE) === -1 ? ln : ue.PARSER_MEDIA_TYPE, Jt = Dt === "application/xhtml+xml" ? tv : Wu, _ = Rn(ue, "ALLOWED_TAGS") && va(ue.ALLOWED_TAGS) ? Wt({}, ue.ALLOWED_TAGS, Jt) : ee, Y = Rn(ue, "ALLOWED_ATTR") && va(ue.ALLOWED_ATTR) ? Wt({}, ue.ALLOWED_ATTR, Jt) : B, Ae = Rn(ue, "ALLOWED_NAMESPACES") && va(ue.ALLOWED_NAMESPACES) ? Wt({}, ue.ALLOWED_NAMESPACES, tv) : Pe, ge = Rn(ue, "ADD_URI_SAFE_ATTR") && va(ue.ADD_URI_SAFE_ATTR) ? Wt(Ta(G), ue.ADD_URI_SAFE_ATTR, Jt) : G, Be = Rn(ue, "ADD_DATA_URI_TAGS") && va(ue.ADD_DATA_URI_TAGS) ? Wt(Ta(ne), ue.ADD_DATA_URI_TAGS, Jt) : ne, Xe = Rn(ue, "FORBID_CONTENTS") && va(ue.FORBID_CONTENTS) ? Wt({}, ue.FORBID_CONTENTS, Jt) : Ve, F = Rn(ue, "FORBID_TAGS") && va(ue.FORBID_TAGS) ? Wt({}, ue.FORBID_TAGS, Jt) : Ta({}), V = Rn(ue, "FORBID_ATTR") && va(ue.FORBID_ATTR) ? Wt({}, ue.FORBID_ATTR, Jt) : Ta({}), Ut = Rn(ue, "USE_PROFILES") ? ue.USE_PROFILES && typeof ue.USE_PROFILES == "object" ? Ta(ue.USE_PROFILES) : ue.USE_PROFILES : !1, qe = ue.ALLOW_ARIA_ATTR !== !1, Me = ue.ALLOW_DATA_ATTR !== !1, Fe = ue.ALLOW_UNKNOWN_PROTOCOLS || !1, We = ue.ALLOW_SELF_CLOSE_IN_ATTR !== !1, $t = ue.SAFE_FOR_TEMPLATES || !1, St = ue.SAFE_FOR_XML !== !1, at = ue.WHOLE_DOCUMENT || !1, Ne = ue.RETURN_DOM || !1, ie = ue.RETURN_DOM_FRAGMENT || !1, xe = ue.RETURN_TRUSTED_TYPE || !1, pt = ue.FORCE_BODY || !1, he = ue.SANITIZE_DOM !== !1, De = ue.SANITIZE_NAMED_PROPS || !1, ft = ue.KEEP_CONTENT !== !1, gt = ue.IN_PLACE || !1, fe = Q9(ue.ALLOWED_URI_REGEXP) ? ue.ALLOWED_URI_REGEXP : tT, Ie = typeof ue.NAMESPACE == "string" ? ue.NAMESPACE : Ce, _t = Rn(ue, "MATHML_TEXT_INTEGRATION_POINTS") && ue.MATHML_TEXT_INTEGRATION_POINTS && typeof ue.MATHML_TEXT_INTEGRATION_POINTS == "object" ? Ta(ue.MATHML_TEXT_INTEGRATION_POINTS) : Wt({}, ["mi", "mo", "mn", "ms", "mtext"]), Et = Rn(ue, "HTML_INTEGRATION_POINTS") && ue.HTML_INTEGRATION_POINTS && typeof ue.HTML_INTEGRATION_POINTS == "object" ? Ta(ue.HTML_INTEGRATION_POINTS) : Wt({}, ["annotation-xml"]);
    const je = Rn(ue, "CUSTOM_ELEMENT_HANDLING") && ue.CUSTOM_ELEMENT_HANDLING && typeof ue.CUSTOM_ELEMENT_HANDLING == "object" ? Ta(ue.CUSTOM_ELEMENT_HANDLING) : Js(null);
    if (W = Js(null), Rn(je, "tagNameCheck") && Ft(je.tagNameCheck) && (W.tagNameCheck = je.tagNameCheck), Rn(je, "attributeNameCheck") && Ft(je.attributeNameCheck) && (W.attributeNameCheck = je.attributeNameCheck), Rn(je, "allowCustomizedBuiltInElements") && typeof je.allowCustomizedBuiltInElements == "boolean" && (W.allowCustomizedBuiltInElements = je.allowCustomizedBuiltInElements), $t && (Me = !1), ie && (Ne = !0), Ut && (_ = Wt({}, j1), Y = Js(null), Ut.html === !0 && (Wt(_, V1), Wt(Y, q1)), Ut.svg === !0 && (Wt(_, nv), Wt(Y, ov), Wt(Y, mf)), Ut.svgFilters === !0 && (Wt(_, av), Wt(Y, ov), Wt(Y, mf)), Ut.mathMl === !0 && (Wt(_, iv), Wt(Y, W1), Wt(Y, mf))), ke.tagCheck = null, ke.attributeCheck = null, Rn(ue, "ADD_TAGS") && (typeof ue.ADD_TAGS == "function" ? ke.tagCheck = ue.ADD_TAGS : va(ue.ADD_TAGS) && (_ === ee && (_ = Ta(_)), Wt(_, ue.ADD_TAGS, Jt))), Rn(ue, "ADD_ATTR") && (typeof ue.ADD_ATTR == "function" ? ke.attributeCheck = ue.ADD_ATTR : va(ue.ADD_ATTR) && (Y === B && (Y = Ta(Y)), Wt(Y, ue.ADD_ATTR, Jt))), Rn(ue, "ADD_URI_SAFE_ATTR") && va(ue.ADD_URI_SAFE_ATTR) && Wt(ge, ue.ADD_URI_SAFE_ATTR, Jt), Rn(ue, "FORBID_CONTENTS") && va(ue.FORBID_CONTENTS) && (Xe === Ve && (Xe = Ta(Xe)), Wt(Xe, ue.FORBID_CONTENTS, Jt)), Rn(ue, "ADD_FORBID_CONTENTS") && va(ue.ADD_FORBID_CONTENTS) && (Xe === Ve && (Xe = Ta(Xe)), Wt(Xe, ue.ADD_FORBID_CONTENTS, Jt)), ft && (_["#text"] = !0), at && Wt(_, ["html", "head", "body"]), _.table && (Wt(_, ["tbody"]), delete F.tbody), ue.TRUSTED_TYPES_POLICY) {
      if (typeof ue.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw hf('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof ue.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw hf('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      z = ue.TRUSTED_TYPES_POLICY, D = z.createHTML("");
    } else
      z === void 0 && (z = d7($, i)), z !== null && typeof D == "string" && (D = z.createHTML(""));
    _a && _a(ue), Ln = ue;
  }, Kt = Wt({}, [...nv, ...av, ...e7]), bt = Wt({}, [...iv, ...t7]), Dn = function(ue) {
    let je = R(ue);
    (!je || !je.tagName) && (je = {
      namespaceURI: Ie,
      tagName: "template"
    });
    const dt = Wu(ue.tagName), It = Wu(je.tagName);
    return Ae[ue.namespaceURI] ? ue.namespaceURI === te ? je.namespaceURI === Ce ? dt === "svg" : je.namespaceURI === ye ? dt === "svg" && (It === "annotation-xml" || _t[It]) : !!Kt[dt] : ue.namespaceURI === ye ? je.namespaceURI === Ce ? dt === "math" : je.namespaceURI === te ? dt === "math" && Et[It] : !!bt[dt] : ue.namespaceURI === Ce ? je.namespaceURI === te && !Et[It] || je.namespaceURI === ye && !_t[It] ? !1 : !bt[dt] && (xn[dt] || !Kt[dt]) : !!(Dt === "application/xhtml+xml" && Ae[ue.namespaceURI]) : !1;
  }, Nn = function(ue) {
    Bu(t.removed, {
      element: ue
    });
    try {
      R(ue).removeChild(ue);
    } catch {
      C(ue);
    }
  }, Cn = function(ue, je) {
    try {
      Bu(t.removed, {
        attribute: je.getAttributeNode(ue),
        from: je
      });
    } catch {
      Bu(t.removed, {
        attribute: null,
        from: je
      });
    }
    if (je.removeAttribute(ue), ue === "is")
      if (Ne || ie)
        try {
          Nn(je);
        } catch {
        }
      else
        try {
          je.setAttribute(ue, "");
        } catch {
        }
  }, fn = function(ue) {
    let je = null, dt = null;
    if (pt)
      ue = "<remove></remove>" + ue;
    else {
      const nn = F1(ue, /^[\r\n\t ]+/);
      dt = nn && nn[0];
    }
    Dt === "application/xhtml+xml" && Ie === Ce && (ue = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + ue + "</body></html>");
    const It = z ? z.createHTML(ue) : ue;
    if (Ie === Ce)
      try {
        je = new w().parseFromString(It, Dt);
      } catch {
      }
    if (!je || !je.documentElement) {
      je = U.createDocument(Ie, "template", null);
      try {
        je.documentElement.innerHTML = _e ? D : It;
      } catch {
      }
    }
    const hn = je.body || je.documentElement;
    return ue && dt && hn.insertBefore(n.createTextNode(dt), hn.childNodes[0] || null), Ie === Ce ? P.call(je, at ? "html" : "body")[0] : at ? je.documentElement : hn;
  }, mn = function(ue) {
    return H.call(
      ue.ownerDocument || ue,
      ue,
      // eslint-disable-next-line no-bitwise
      m.SHOW_ELEMENT | m.SHOW_COMMENT | m.SHOW_TEXT | m.SHOW_PROCESSING_INSTRUCTION | m.SHOW_CDATA_SECTION,
      null
    );
  }, aa = function(ue) {
    return ue instanceof x && (typeof ue.nodeName != "string" || typeof ue.textContent != "string" || typeof ue.removeChild != "function" || !(ue.attributes instanceof v) || typeof ue.removeAttribute != "function" || typeof ue.setAttribute != "function" || typeof ue.namespaceURI != "string" || typeof ue.insertBefore != "function" || typeof ue.hasChildNodes != "function");
  }, zn = function(ue) {
    return typeof c == "function" && ue instanceof c;
  };
  function Mn(Qe, ue, je) {
    Iu(Qe, (dt) => {
      dt.call(t, ue, je, Ln);
    });
  }
  const rn = function(ue) {
    let je = null;
    if (Mn(N.beforeSanitizeElements, ue, null), aa(ue))
      return Nn(ue), !0;
    const dt = Jt(ue.nodeName);
    if (Mn(N.uponSanitizeElement, ue, {
      tagName: dt,
      allowedTags: _
    }), St && ue.hasChildNodes() && !zn(ue.firstElementChild) && oa(/<[/\w!]/g, ue.innerHTML) && oa(/<[/\w!]/g, ue.textContent) || St && ue.namespaceURI === Ce && dt === "style" && zn(ue.firstElementChild) || ue.nodeType === Uu.progressingInstruction || St && ue.nodeType === Uu.comment && oa(/<[/\w]/g, ue.data))
      return Nn(ue), !0;
    if (F[dt] || !(ke.tagCheck instanceof Function && ke.tagCheck(dt)) && !_[dt]) {
      if (!F[dt] && Ue(dt) && (W.tagNameCheck instanceof RegExp && oa(W.tagNameCheck, dt) || W.tagNameCheck instanceof Function && W.tagNameCheck(dt)))
        return !1;
      if (ft && !Xe[dt]) {
        const It = R(ue) || ue.parentNode, hn = E(ue) || ue.childNodes;
        if (hn && It) {
          const nn = hn.length;
          for (let ae = nn - 1; ae >= 0; --ae) {
            const oe = b(hn[ae], !0);
            It.insertBefore(oe, T(ue));
          }
        }
      }
      return Nn(ue), !0;
    }
    return ue instanceof p && !Dn(ue) || (dt === "noscript" || dt === "noembed" || dt === "noframes") && oa(/<\/no(script|embed|frames)/i, ue.innerHTML) ? (Nn(ue), !0) : ($t && ue.nodeType === Uu.text && (je = ue.textContent, Iu([J, j, re], (It) => {
      je = Ws(je, It, " ");
    }), ue.textContent !== je && (Bu(t.removed, {
      element: ue.cloneNode()
    }), ue.textContent = je)), Mn(N.afterSanitizeElements, ue, null), !1);
  }, me = function(ue, je, dt) {
    if (V[je] || he && (je === "id" || je === "name") && (dt in n || dt in Vn))
      return !1;
    const It = Y[je] || ke.attributeCheck instanceof Function && ke.attributeCheck(je, ue);
    if (!(Me && !V[je] && oa(q, je))) {
      if (!(qe && oa(le, je))) {
        if (!It || V[je]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(Ue(ue) && (W.tagNameCheck instanceof RegExp && oa(W.tagNameCheck, ue) || W.tagNameCheck instanceof Function && W.tagNameCheck(ue)) && (W.attributeNameCheck instanceof RegExp && oa(W.attributeNameCheck, je) || W.attributeNameCheck instanceof Function && W.attributeNameCheck(je, ue)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            je === "is" && W.allowCustomizedBuiltInElements && (W.tagNameCheck instanceof RegExp && oa(W.tagNameCheck, dt) || W.tagNameCheck instanceof Function && W.tagNameCheck(dt)))
          ) return !1;
        } else if (!ge[je]) {
          if (!oa(fe, Ws(dt, ce, ""))) {
            if (!((je === "src" || je === "xlink:href" || je === "href") && ue !== "script" && U1(dt, "data:") === 0 && Be[ue])) {
              if (!(Fe && !oa(ve, Ws(dt, ce, "")))) {
                if (dt)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, Le = Wt({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), Ue = function(ue) {
    return !Le[Wu(ue)] && oa(se, ue);
  }, He = function(ue) {
    Mn(N.beforeSanitizeAttributes, ue, null);
    const {
      attributes: je
    } = ue;
    if (!je || aa(ue))
      return;
    const dt = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: Y,
      forceKeepAttr: void 0
    };
    let It = je.length;
    for (; It--; ) {
      const hn = je[It], {
        name: nn,
        namespaceURI: ae,
        value: oe
      } = hn, ze = Jt(nn), Ke = oe;
      let it = nn === "value" ? Ke : W9(Ke);
      if (dt.attrName = ze, dt.attrValue = it, dt.keepAttr = !0, dt.forceKeepAttr = void 0, Mn(N.uponSanitizeAttribute, ue, dt), it = dt.attrValue, De && (ze === "id" || ze === "name") && U1(it, ot) !== 0 && (Cn(nn, ue), it = ot + it), St && oa(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, it)) {
        Cn(nn, ue);
        continue;
      }
      if (ze === "attributename" && F1(it, "href")) {
        Cn(nn, ue);
        continue;
      }
      if (dt.forceKeepAttr)
        continue;
      if (!dt.keepAttr) {
        Cn(nn, ue);
        continue;
      }
      if (!We && oa(/\/>/i, it)) {
        Cn(nn, ue);
        continue;
      }
      $t && Iu([J, j, re], (Q) => {
        it = Ws(it, Q, " ");
      });
      const Z = Jt(ue.nodeName);
      if (!me(Z, ze, it)) {
        Cn(nn, ue);
        continue;
      }
      if (z && typeof $ == "object" && typeof $.getAttributeType == "function" && !ae)
        switch ($.getAttributeType(Z, ze)) {
          case "TrustedHTML": {
            it = z.createHTML(it);
            break;
          }
          case "TrustedScriptURL": {
            it = z.createScriptURL(it);
            break;
          }
        }
      if (it !== Ke)
        try {
          ae ? ue.setAttributeNS(ae, nn, it) : ue.setAttribute(nn, it), aa(ue) ? Nn(ue) : B1(t.removed);
        } catch {
          Cn(nn, ue);
        }
    }
    Mn(N.afterSanitizeAttributes, ue, null);
  }, xt = function(ue) {
    let je = null;
    const dt = mn(ue);
    for (Mn(N.beforeSanitizeShadowDOM, ue, null); je = dt.nextNode(); )
      Mn(N.uponSanitizeShadowNode, je, null), rn(je), He(je), je.content instanceof r && xt(je.content);
    Mn(N.afterSanitizeShadowDOM, ue, null);
  };
  return t.sanitize = function(Qe) {
    let ue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, je = null, dt = null, It = null, hn = null;
    if (_e = !Qe, _e && (Qe = "<!-->"), typeof Qe != "string" && !zn(Qe) && (Qe = Z9(Qe), typeof Qe != "string"))
      throw hf("dirty is not a string, aborting");
    if (!t.isSupported)
      return Qe;
    if (kt || na(ue), t.removed = [], typeof Qe == "string" && (gt = !1), gt) {
      const oe = Qe.nodeName;
      if (typeof oe == "string") {
        const ze = Jt(oe);
        if (!_[ze] || F[ze])
          throw hf("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (Qe instanceof c)
      je = fn("<!---->"), dt = je.ownerDocument.importNode(Qe, !0), dt.nodeType === Uu.element && dt.nodeName === "BODY" || dt.nodeName === "HTML" ? je = dt : je.appendChild(dt);
    else {
      if (!Ne && !$t && !at && // eslint-disable-next-line unicorn/prefer-includes
      Qe.indexOf("<") === -1)
        return z && xe ? z.createHTML(Qe) : Qe;
      if (je = fn(Qe), !je)
        return Ne ? null : xe ? D : "";
    }
    je && pt && Nn(je.firstChild);
    const nn = mn(gt ? Qe : je);
    for (; It = nn.nextNode(); )
      rn(It), He(It), It.content instanceof r && xt(It.content);
    if (gt)
      return Qe;
    if (Ne) {
      if ($t) {
        je.normalize();
        let oe = je.innerHTML;
        Iu([J, j, re], (ze) => {
          oe = Ws(oe, ze, " ");
        }), je.innerHTML = oe;
      }
      if (ie)
        for (hn = L.call(je.ownerDocument); je.firstChild; )
          hn.appendChild(je.firstChild);
      else
        hn = je;
      return (Y.shadowroot || Y.shadowrootmode) && (hn = K.call(a, hn, !0)), hn;
    }
    let ae = at ? je.outerHTML : je.innerHTML;
    return at && _["!doctype"] && je.ownerDocument && je.ownerDocument.doctype && je.ownerDocument.doctype.name && oa(nT, je.ownerDocument.doctype.name) && (ae = "<!DOCTYPE " + je.ownerDocument.doctype.name + `>
` + ae), $t && Iu([J, j, re], (oe) => {
      ae = Ws(ae, oe, " ");
    }), z && xe ? z.createHTML(ae) : ae;
  }, t.setConfig = function() {
    let Qe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    na(Qe), kt = !0;
  }, t.clearConfig = function() {
    Ln = null, kt = !1;
  }, t.isValidAttribute = function(Qe, ue, je) {
    Ln || na({});
    const dt = Jt(Qe), It = Jt(ue);
    return me(dt, It, je);
  }, t.addHook = function(Qe, ue) {
    typeof ue == "function" && Bu(N[Qe], ue);
  }, t.removeHook = function(Qe, ue) {
    if (ue !== void 0) {
      const je = j9(N[Qe], ue);
      return je === -1 ? void 0 : q9(N[Qe], je, 1)[0];
    }
    return B1(N[Qe]);
  }, t.removeHooks = function(Qe) {
    N[Qe] = [];
  }, t.removeAllHooks = function() {
    N = G1();
  }, t;
}
var f7 = aT();
const iT = [
  "a",
  "abbr",
  "b",
  "bdi",
  "bdo",
  "blockquote",
  "br",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "dd",
  "del",
  "details",
  "dfn",
  "div",
  "dl",
  "dt",
  "em",
  "figcaption",
  "figure",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "hr",
  "i",
  "img",
  "ins",
  "kbd",
  "li",
  "mark",
  "ol",
  "p",
  "picture",
  "pre",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "small",
  "source",
  "span",
  "strike",
  "strong",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "time",
  "tr",
  "tt",
  "u",
  "ul",
  "var",
  "wbr"
], oT = [
  "abbr",
  "align",
  "alt",
  "cite",
  "class",
  "colspan",
  "datetime",
  "dir",
  "height",
  "href",
  "id",
  "lang",
  "loading",
  "media",
  "open",
  "rel",
  "reversed",
  "rowspan",
  "scope",
  "span",
  "src",
  "srcset",
  "start",
  "style",
  "target",
  "title",
  "valign",
  "width"
], p7 = [
  "script",
  "iframe",
  "frame",
  "frameset",
  "object",
  "embed",
  "applet",
  "form",
  "input",
  "button",
  "select",
  "option",
  "textarea",
  "base",
  "meta",
  "link",
  "noscript",
  "template",
  "portal",
  "dialog"
], h7 = ["action", "formaction", "srcdoc", "ping", "background", "poster"], m7 = iT.filter((e) => e !== "picture" && e !== "source"), v7 = oT.filter((e) => e !== "srcset" && e !== "style" && e !== "loading" && e !== "media"), y7 = {
  document: {
    ALLOWED_TAGS: iT,
    ALLOWED_ATTR: oT,
    // Ids a document brings are prefixed (`user-content-…`) so they can never
    // shadow a global the page reads (DOM clobbering).
    SANITIZE_NAMED_PROPS: !0,
    // Parsed into an inert document and its pictures from elsewhere held
    // back there (documentMarkup, RemoteImages).
    RETURN_DOM_FRAGMENT: !0
  },
  assistant: {
    ALLOWED_TAGS: m7,
    ALLOWED_ATTR: v7,
    SANITIZE_NAMED_PROPS: !0,
    // Parsed into an inert document and reshaped there (assistantMarkup):
    // nothing is attached to the page, so nothing is fetched on the way.
    RETURN_DOM_FRAGMENT: !0
  },
  code: {
    ALLOWED_TAGS: ["span", "br"],
    ALLOWED_ATTR: ["class"]
  },
  diagram: {
    USE_PROFILES: { svg: !0, svgFilters: !0, html: !0 },
    // What Mermaid itself keeps when it sanitizes its output: HTML labels
    // live in <foreignObject> (an HTML integration point for them), and text
    // anchoring needs dominant-baseline.
    ADD_TAGS: ["foreignobject"],
    ADD_ATTR: ["dominant-baseline"],
    HTML_INTEGRATION_POINTS: { foreignobject: !0 }
  },
  math: {
    USE_PROFILES: { html: !0, mathMl: !0 }
  }
};
let rv = null;
function g7() {
  if (rv) return rv;
  if (typeof window > "u") return null;
  const e = f7(window);
  return e.isSupported ? (e.addHook("uponSanitizeAttribute", (t, n) => {
    if (n.attrName === "style") {
      const a = b7(n.attrValue);
      a === "" ? n.keepAttr = !1 : n.attrValue = a;
    }
  }), e.addHook("uponSanitizeElement", (t, n) => {
    n.tagName === "style" && t.textContent && (t.textContent = k7(t.textContent));
  }), e.addHook("afterSanitizeAttributes", (t) => {
    if (t.tagName === "A") {
      const n = t.getAttribute("target");
      n && n !== "_blank" && t.removeAttribute("target"), t.getAttribute("target") === "_blank" && t.setAttribute("rel", "noopener noreferrer");
    }
  }), rv = e, e) : null;
}
function b7(e) {
  return e.split(";").map((t) => t.trim()).filter((t) => t !== "" && !w7(t)).join("; ");
}
function k7(e) {
  return /\\/.test(e) ? "" : e.replace(/@import[^;]*;?/gi, "").replace(/url\s*\(\s*(['"]?)(?!#)[^)]*\)/gi, "none").replace(/image-set\s*\([^)]*\)/gi, "none").replace(/expression\s*\(/gi, "x(");
}
function w7(e) {
  return /\\/.test(e) || /expression\s*\(|@import|behavior\s*:|-moz-binding|image-set\s*\(|javascript:/i.test(e) ? !0 : (e.match(/url\s*\(\s*(['"]?)([^)'"]*)/gi) ?? []).some((n) => !/url\s*\(\s*['"]?#/i.test(n));
}
function _7(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
function rT() {
  try {
    return typeof location < "u" ? location.origin : null;
  } catch {
    return null;
  }
}
function Qr(e) {
  const t = e.trim();
  if (/^data:image\//i.test(t)) return !0;
  const n = rT();
  if (!n) return !1;
  let a;
  try {
    a = new URL(t, n + "/");
  } catch {
    return !1;
  }
  if (a.protocol === "blob:")
    try {
      return new URL(a.pathname).origin === n;
    } catch {
      return !1;
    }
  return (a.protocol === "https:" || a.protocol === "http:") && a.origin === n;
}
function x7(e) {
  const t = e.ownerDocument;
  for (const n of Array.from(e.querySelectorAll("img"))) {
    const a = n.getAttribute("src") ?? "";
    if (a && Qr(a)) continue;
    const i = (n.getAttribute("alt") ?? "").trim(), r = t.createElement("a");
    r.setAttribute("href", a), r.setAttribute("data-remote-image", ""), r.textContent = i || a, n.replaceWith(r);
  }
  for (const n of Array.from(e.querySelectorAll("a"))) {
    const a = n.getAttribute("href");
    if (!a) {
      n.removeAttribute("target"), n.removeAttribute("rel");
      continue;
    }
    if (n.setAttribute("target", "_blank"), n.setAttribute("rel", "noopener noreferrer nofollow"), n.setAttribute("title", a), (n.textContent ?? "").trim() !== a.trim()) {
      const r = t.createElement("span");
      r.setAttribute("class", "fe-md-href"), r.textContent = ` (${a})`, n.after(r);
    }
  }
  return Rg(e);
}
function Rg(e) {
  const t = e.ownerDocument.createElement("div");
  return t.appendChild(e), t.innerHTML;
}
function es(e) {
  if (!e.trim()) return null;
  const t = rT();
  try {
    const n = new URL(e.trim(), t ? t + "/" : void 0);
    return n.protocol === "https:" || n.protocol === "http:" ? n : null;
  } catch {
    return null;
  }
}
function Ng(e) {
  const t = [];
  let n = 0;
  for (; n < e.length; ) {
    for (; n < e.length && /[\s,]/.test(e[n]); ) n++;
    if (n >= e.length) break;
    let a = n;
    for (; a < e.length && !/\s/.test(e[a]); ) a++;
    let i = e.slice(n, a), r = "";
    if (i.endsWith(","))
      i = i.replace(/,+$/, ""), n = a;
    else {
      let l = a;
      for (; l < e.length && e[l] !== ","; ) l++;
      r = e.slice(a, l).trim(), n = l + 1;
    }
    i && t.push({ url: i, descriptor: r });
  }
  return t;
}
const sT = ["alt", "title", "width", "height", "class", "align"];
function lT(e, t) {
  var a;
  if (Qr(e)) return !0;
  const n = es(e);
  return !!n && !!((a = t.load) != null && a.call(t, n.href));
}
function X1(e, t) {
  const n = e.getAttribute("srcset");
  if (n === null) return;
  const a = Ng(n).filter((i) => lT(i.url, t));
  a.length ? e.setAttribute("srcset", a.map((i) => i.descriptor ? `${i.url} ${i.descriptor}` : i.url).join(", ")) : e.removeAttribute("srcset");
}
function S7(e, t, n, a) {
  const i = e.createElement("span");
  i.setAttribute("class", "fe-remote-img");
  const r = es(n);
  r && (i.setAttribute("data-remote-image", r.href), i.setAttribute("data-remote-host", r.host), i.setAttribute("role", "button"), i.setAttribute("tabindex", "0"), i.setAttribute("title", r.href));
  for (const p of sT) {
    const m = t.getAttribute(p);
    m && i.setAttribute(`data-remote-${p}`, m);
  }
  const l = (p, m) => {
    const v = e.createElement("span");
    v.setAttribute("class", p), m ? v.textContent = m : v.setAttribute("aria-hidden", "true"), i.appendChild(v);
  };
  l("fe-remote-img__icon", "");
  const c = (t.getAttribute("alt") ?? "").trim();
  return c && l("fe-remote-img__alt", c), l("fe-remote-img__label", a), r && l("fe-remote-img__host", r.host), i;
}
function $7(e, t) {
  return uT(e, t), Rg(e);
}
function uT(e, t) {
  var i;
  const n = e.ownerDocument, a = t.label || "Remote image";
  for (const r of Array.from(e.querySelectorAll("*")))
    for (const l of Array.from(r.attributes))
      l.name.startsWith("data-remote") && r.removeAttribute(l.name);
  for (const r of Array.from(e.querySelectorAll("source")))
    X1(r, t), r.hasAttribute("srcset") || r.remove();
  for (const r of Array.from(e.querySelectorAll("img"))) {
    const l = (r.getAttribute("src") ?? "").trim(), c = ((i = Ng(r.getAttribute("srcset") ?? "").find((m) => !Qr(m.url))) == null ? void 0 : i.url) ?? "";
    X1(r, t);
    const p = l && !Qr(l) ? l : !l && !r.hasAttribute("srcset") ? c : "";
    if (p && !lT(p, t)) {
      r.replaceWith(S7(n, r, p, a));
      continue;
    }
    M7(r) && r.setAttribute("referrerpolicy", "no-referrer");
  }
}
const Yu = "http://www.w3.org/2000/svg", cT = "http://www.w3.org/1999/xhtml", J1 = "#fe-remote=", T7 = ["x", "y", "width", "height", "transform", "preserveAspectRatio"];
function A7(e) {
  return (e.getAttribute("href") ?? e.getAttribute("xlink:href") ?? "").trim();
}
function E7(e) {
  const t = e.startsWith("data:") ? e.indexOf(J1) : -1;
  if (t < 0) return e;
  try {
    return decodeURIComponent(e.slice(t + J1.length));
  } catch {
    return "";
  }
}
function dT(e, t, n) {
  const a = e.createElementNS(Yu, "foreignObject");
  for (const r of ["x", "y", "width", "height", "transform"]) {
    const l = n(r);
    l !== null && l !== "" && a.setAttribute(r, l);
  }
  const i = e.createElementNS(cT, "img");
  return i.setAttribute("referrerpolicy", "no-referrer"), i.setAttribute("style", "width: 100%; height: 100%; object-fit: contain;"), i.setAttribute("alt", ""), i.setAttribute("src", t), a.appendChild(i), a;
}
function C7(e, t, n, a) {
  const i = e.createElementNS(Yu, "g");
  i.setAttribute("class", "fe-remote-svgimg");
  const r = es(n);
  if (r) {
    i.setAttribute("data-remote-image", r.href), i.setAttribute("data-remote-host", r.host), i.setAttribute("role", "button"), i.setAttribute("tabindex", "0"), i.setAttribute("aria-label", `${a} ${r.host}`);
    const b = e.createElementNS(Yu, "title");
    b.textContent = r.href, i.appendChild(b);
  }
  for (const b of T7) {
    const C = t.getAttribute(b);
    C && i.setAttribute(`data-remote-${b.toLowerCase()}`, C);
  }
  const l = t.getAttribute("transform");
  l && i.setAttribute("transform", l);
  const c = (b, C) => {
    const T = parseFloat(t.getAttribute(b) ?? "");
    return Number.isFinite(T) ? T : C;
  }, [p, m, v, x] = [c("x", 0), c("y", 0), c("width", 120), c("height", 80)], w = e.createElementNS(Yu, "rect");
  w.setAttribute("class", "fe-remote-svgimg__box");
  const $ = [["x", p], ["y", m], ["width", v], ["height", x], ["rx", 4]];
  for (const [b, C] of $) w.setAttribute(b, String(C));
  i.appendChild(w);
  const k = e.createElementNS(Yu, "text");
  return k.setAttribute("class", "fe-remote-svgimg__label"), k.setAttribute("x", String(p + v / 2)), k.setAttribute("y", String(m + x / 2)), k.setAttribute("text-anchor", "middle"), k.setAttribute("dominant-baseline", "middle"), k.textContent = a, i.appendChild(k), i;
}
function z7(e, t) {
  var i;
  const n = e.ownerDocument, a = t.label || "Remote image";
  uT(e, t);
  for (const r of Array.from(e.querySelectorAll("video, audio, track, input"))) r.remove();
  for (const r of Array.from(e.querySelectorAll("image"))) {
    const l = A7(r), c = E7(l);
    if (c === l && Qr(l)) continue;
    const p = es(c);
    if (p && ((i = t.load) != null && i.call(t, p.href))) {
      r.replaceWith(dT(n, p.href, (m) => r.getAttribute(m)));
      continue;
    }
    r.replaceWith(C7(n, r, c, a));
  }
  for (const r of Array.from(e.querySelectorAll("*")))
    if (!(r.localName === "a" || r.localName === "image" || r.namespaceURI === cT))
      for (const l of ["href", "xlink:href"]) {
        const c = (r.getAttribute(l) ?? "").trim();
        c && !c.startsWith("#") && r.removeAttribute(l);
      }
  return Rg(e);
}
function M7(e) {
  var a;
  const t = (i) => {
    const r = (i.getAttribute("src") ?? "").trim();
    return i.tagName === "IMG" && r && !Qr(r) ? !0 : Ng(i.getAttribute("srcset") ?? "").some((l) => !Qr(l.url));
  };
  if (t(e)) return !0;
  const n = ((a = e.parentElement) == null ? void 0 : a.tagName) === "PICTURE" ? e.parentElement : null;
  return !!n && Array.from(n.querySelectorAll("source")).some(t);
}
function P7(e, t = "document", n = {}) {
  const a = g7();
  if (!a) return _7(e);
  const i = {
    ...y7[t],
    FORBID_TAGS: p7,
    FORBID_ATTR: h7,
    ALLOW_UNKNOWN_PROTOCOLS: !1,
    RETURN_TRUSTED_TYPE: !1
  };
  if (t === "assistant")
    return x7(a.sanitize(e, { ...i, RETURN_DOM_FRAGMENT: !0 }));
  if (t === "document" || t === "diagram") {
    const r = a.sanitize(e, { ...i, RETURN_DOM_FRAGMENT: !0 });
    return t === "document" ? $7(r, n.remoteImages ?? {}) : z7(r, n.remoteImages ?? {});
  }
  return String(a.sanitize(e, i));
}
let vf = null;
function O7() {
  return vf || (vf = import(
    /* @vite-ignore */
    "markdown-it"
  ).then((e) => {
    const t = e, n = t.default ?? t;
    return new n({ html: !0, linkify: !0, breaks: !0, typographer: !0 });
  }).catch(() => (vf = null, null))), vf;
}
async function L7(e, t = "document", n = {}) {
  const a = await O7();
  return a ? P7(a.render(e), t, n) : null;
}
const D7 = ["aria-label"], R7 = { class: "fe-assistant__head" }, N7 = { class: "fe-assistant__head-text" }, I7 = { class: "fe-assistant__title" }, B7 = {
  key: 0,
  class: "fe-assistant__provider",
  "data-testid": "assistant-provider"
}, F7 = ["title", "aria-label", "disabled"], U7 = ["title", "aria-label", "aria-pressed"], H7 = ["title", "aria-label"], K7 = {
  key: 0,
  class: "fe-assistant__history",
  "data-testid": "assistant-history-list"
}, V7 = {
  key: 0,
  class: "fe-assistant__muted"
}, j7 = {
  key: 1,
  class: "fe-assistant__convs"
}, q7 = ["onClick"], W7 = { class: "fe-assistant__conv-title" }, Y7 = { class: "fe-assistant__conv-date" }, G7 = ["title", "aria-label", "onClick"], X7 = {
  key: 0,
  class: "fe-assistant__intro",
  "data-testid": "assistant-intro"
}, J7 = {
  key: 0,
  class: "fe-assistant__msg fe-assistant__msg--user"
}, Z7 = { class: "fe-assistant__text" }, Q7 = {
  key: 0,
  class: "fe-assistant__chips"
}, eV = ["title"], tV = {
  key: 1,
  class: "fe-assistant__msg fe-assistant__msg--bot"
}, nV = ["innerHTML"], aV = {
  key: 1,
  class: "fe-assistant__text"
}, iV = {
  key: 2,
  class: "fe-assistant__note",
  role: "note"
}, oV = ["data-testid"], rV = { class: "fe-assistant__step-body" }, sV = { class: "fe-assistant__step-label" }, lV = ["title"], uV = ["title"], cV = { class: "fe-assistant__step-status" }, dV = {
  key: 2,
  class: "fe-assistant__step-error"
}, fV = ["disabled", "data-testid", "onClick"], pV = {
  key: 0,
  class: "fe-assistant__msg fe-assistant__msg--user"
}, hV = { class: "fe-assistant__text" }, mV = {
  key: 0,
  class: "fe-assistant__chips"
}, vV = ["title"], yV = { class: "fe-assistant__step-body" }, gV = { class: "fe-assistant__step-label" }, bV = ["title"], kV = { class: "fe-assistant__step-status" }, wV = {
  key: 1,
  class: "fe-assistant__msg fe-assistant__msg--bot"
}, _V = { class: "fe-assistant__text" }, xV = {
  key: 2,
  class: "fe-assistant__muted"
}, SV = ["aria-label"], $V = { class: "fe-assistant__card-question" }, TV = {
  key: 0,
  class: "fe-assistant__card-note"
}, AV = {
  key: 1,
  class: "fe-assistant__card-args"
}, EV = { class: "fe-assistant__card-actions" }, CV = ["disabled"], zV = ["disabled"], MV = {
  key: 3,
  class: "fe-assistant__error",
  role: "alert",
  "data-testid": "assistant-error"
}, PV = { class: "fe-assistant__foot" }, OV = {
  key: 0,
  class: "fe-assistant__with"
}, LV = { class: "fe-assistant__compose" }, DV = ["placeholder", "aria-label"], RV = ["title", "aria-label"], NV = ["title", "aria-label", "disabled"], IV = /* @__PURE__ */ lt({
  __name: "AssistantPanel",
  props: {
    client: {},
    locale: {},
    selection: {},
    narrow: { type: Boolean }
  },
  emits: ["close", "changed"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatDate: r } = ht(() => n.locale ?? "en"), l = S(null), c = S(null), p = S(!1), m = S([]), v = S(""), x = S(!0), w = S(!1), $ = S("");
    let k = null;
    const b = S(null), C = S(null), T = S(null), E = A(() => {
      var B;
      return ((B = c.value) == null ? void 0 : B.items) ?? [];
    }), R = A(() => {
      var W, F;
      return ((W = b.value) == null ? void 0 : W.steps.find((V) => V.status === "waiting")) ?? ((F = c.value) == null ? void 0 : F.waiting) ?? null;
    }), z = A(() => n.selection.length), D = A(() => {
      const B = l.value;
      return !(B != null && B.provider) || !B.model ? "" : `${U(B.provider)} · ${B.model}`;
    });
    function U(B) {
      switch (B) {
        case "anthropic":
          return "Anthropic";
        case "openai":
          return "OpenAI";
        case "ollama":
          return "Ollama";
      }
      return B;
    }
    function H(B) {
      if (!B) return "";
      const W = B.replace(/\/+$/, ""), F = W.lastIndexOf("/");
      return F >= 0 && F < W.length - 1 ? W.slice(F + 1) : W;
    }
    const L = S({});
    async function P(B) {
      if (L.value[B] !== void 0) return;
      const W = await L7(B, "assistant");
      W !== null && (L.value = { ...L.value, [B]: W });
    }
    Je(
      E,
      (B) => {
        for (const W of B) W.kind === "assistant" && W.text && P(W.text);
      },
      { immediate: !0 }
    );
    function K() {
      Gt(() => {
        const B = C.value;
        B && (B.scrollTop = B.scrollHeight);
      });
    }
    function N(B) {
      if (!b.value) return;
      const W = b.value.steps.findIndex((F) => F.id === B.id);
      W >= 0 ? b.value.steps.splice(W, 1, B) : b.value.steps.push(B), B.class !== "read" && B.status === "done" && a("changed");
    }
    function J(B) {
      var W;
      switch (B.name) {
        case "conversation":
          (!c.value || c.value.id !== B.data.id) && (c.value = { id: B.data.id, title: B.data.title, updated_ms: Date.now(), provider: "", model: "", items: ((W = c.value) == null ? void 0 : W.items) ?? [] });
          break;
        case "text":
          b.value && (b.value.reply += B.data.delta);
          break;
        case "step":
        case "approval":
          N(B.data);
          break;
        case "error":
          $.value = B.data.message || B.data.error;
          break;
        case "done":
          c.value = B.data.conversation, b.value = null;
          break;
      }
      K();
    }
    async function j(B) {
      var W;
      $.value = "", w.value = !0, k = new AbortController();
      try {
        await B(k.signal);
      } catch (F) {
        if ((F == null ? void 0 : F.name) !== "AbortError" && ($.value = Za(F, n.locale)), (W = c.value) != null && W.id)
          try {
            c.value = await n.client.get(c.value.id);
          } catch {
          }
        b.value = null;
      } finally {
        w.value = !1, k = null, K();
      }
    }
    async function re() {
      const B = v.value.trim();
      if (!B || w.value) return;
      const W = x.value ? [...n.selection] : [];
      v.value = "", b.value = { text: B, paths: W, reply: "", steps: [] }, K(), await j(
        (F) => {
          var V;
          return n.client.chat(
            { conversation_id: ((V = c.value) == null ? void 0 : V.id) || void 0, message: B, paths: W.length ? W : void 0 },
            J,
            F
          );
        }
      );
    }
    async function q(B) {
      var F;
      const W = (F = c.value) == null ? void 0 : F.id;
      !W || w.value || (b.value = { text: "", paths: [], reply: "", steps: [] }, await j((V) => n.client.decide(W, B, J, V)));
    }
    function le() {
      k == null || k.abort();
    }
    async function ve(B) {
      var F;
      const W = (F = c.value) == null ? void 0 : F.id;
      if (!(!W || w.value)) {
        $.value = "";
        try {
          const V = await n.client.undo(W, B.id);
          c.value = V.conversation, a("changed");
        } catch (V) {
          $.value = Za(V, n.locale);
        }
      }
    }
    function ce() {
      w.value || (c.value = null, b.value = null, $.value = "", p.value = !1, Gt(() => {
        var B;
        return (B = T.value) == null ? void 0 : B.focus();
      }));
    }
    async function se() {
      if (p.value = !p.value, !!p.value)
        try {
          m.value = await n.client.list();
        } catch (B) {
          $.value = Za(B, n.locale);
        }
    }
    async function fe(B) {
      try {
        c.value = await n.client.get(B), p.value = !1, K();
      } catch (W) {
        $.value = Za(W, n.locale);
      }
    }
    async function _(B) {
      var W;
      try {
        await n.client.remove(B), m.value = m.value.filter((F) => F.id !== B), ((W = c.value) == null ? void 0 : W.id) === B && (c.value = null);
      } catch (F) {
        $.value = Za(F, n.locale);
      }
    }
    function ee(B) {
      B.key === "Enter" && !B.shiftKey && !B.isComposing && (B.preventDefault(), re());
    }
    function Y(B) {
      return Object.entries(B.args ?? {}).map(([W, F]) => [W, typeof F == "string" ? F : JSON.stringify(F)]);
    }
    return jt(async () => {
      try {
        l.value = await n.client.me();
      } catch {
      }
      Gt(() => {
        var B;
        return (B = T.value) == null ? void 0 : B.focus();
      });
    }), Tt(() => k == null ? void 0 : k.abort()), (B, W) => {
      var F;
      return f(), h("aside", {
        class: Re(["fe-assistant", { "fe-assistant--overlay": e.narrow }]),
        role: "complementary",
        "aria-label": u(i)("ai.assistant"),
        "data-testid": "assistant-panel"
      }, [
        d("header", R7, [
          Ze(u(KM), {
            class: "fe-assistant__mark",
            "aria-hidden": "true"
          }),
          d("div", N7, [
            d("h2", I7, y(((F = c.value) == null ? void 0 : F.title) || u(i)("ai.assistant")), 1),
            D.value ? (f(), h("p", B7, y(D.value), 1)) : O("", !0)
          ]),
          d("button", {
            type: "button",
            class: "fe-assistant__iconbtn",
            title: u(i)("assistant.new"),
            "aria-label": u(i)("assistant.new"),
            disabled: w.value,
            "data-testid": "assistant-new",
            onClick: ce
          }, [
            Ze(u(VM), { "aria-hidden": "true" })
          ], 8, F7),
          d("button", {
            type: "button",
            class: Re(["fe-assistant__iconbtn", { "is-active": p.value }]),
            title: u(i)("assistant.history"),
            "aria-label": u(i)("assistant.history"),
            "aria-pressed": p.value,
            "data-testid": "assistant-history",
            onClick: se
          }, [
            Ze(u(jM), { "aria-hidden": "true" })
          ], 10, U7),
          d("button", {
            type: "button",
            class: "fe-assistant__iconbtn",
            title: u(i)("assistant.close"),
            "aria-label": u(i)("assistant.close"),
            "data-testid": "assistant-close",
            onClick: W[0] || (W[0] = (V) => a("close"))
          }, [
            Ze(u(qM), { "aria-hidden": "true" })
          ], 8, H7)
        ]),
        p.value ? (f(), h("div", K7, [
          m.value.length === 0 ? (f(), h("p", V7, y(u(i)("assistant.history_empty")), 1)) : (f(), h("ul", j7, [
            (f(!0), h(Te, null, nt(m.value, (V) => (f(), h("li", {
              key: V.id,
              class: "fe-assistant__conv"
            }, [
              d("button", {
                type: "button",
                class: "fe-assistant__conv-open",
                onClick: (ke) => fe(V.id)
              }, [
                d("span", W7, [
                  d("bdi", null, y(V.title || u(i)("ai.assistant")), 1)
                ]),
                d("span", Y7, y(u(r)(V.updated_ms, { time: !0 })), 1)
              ], 8, q7),
              d("button", {
                type: "button",
                class: "fe-assistant__iconbtn",
                title: u(i)("assistant.delete"),
                "aria-label": u(i)("assistant.delete"),
                onClick: (ke) => _(V.id)
              }, [
                Ze(u(WM), { "aria-hidden": "true" })
              ], 8, G7)
            ]))), 128))
          ]))
        ])) : (f(), h("div", {
          key: 1,
          ref_key: "scroller",
          ref: C,
          class: "fe-assistant__scroll",
          "aria-live": "polite"
        }, [
          E.value.length === 0 && !b.value ? (f(), h("p", X7, y(u(i)("assistant.intro")), 1)) : O("", !0),
          (f(!0), h(Te, null, nt(E.value, (V, ke) => (f(), h(Te, { key: ke }, [
            V.kind === "user" ? (f(), h("div", J7, [
              d("p", Z7, y(V.text), 1),
              V.paths && V.paths.length ? (f(), h("ul", Q7, [
                (f(!0), h(Te, null, nt(V.paths, (qe) => (f(), h("li", {
                  key: qe,
                  class: "fe-assistant__chip",
                  title: qe
                }, [
                  d("bdi", null, y(H(qe)), 1)
                ], 8, eV))), 128))
              ])) : O("", !0)
            ])) : V.kind === "assistant" ? (f(), h("div", tV, [
              V.text && L.value[V.text] !== void 0 ? (f(), h("div", {
                key: 0,
                class: "fe-assistant__md",
                innerHTML: L.value[V.text]
              }, null, 8, nV)) : (f(), h("p", aV, y(V.text), 1))
            ])) : V.kind === "note" ? (f(), h("div", iV, y(V.text), 1)) : V.kind === "step" && V.step && V.step.status !== "waiting" ? (f(), h("div", {
              key: 3,
              class: Re(["fe-assistant__step", `is-${V.step.status}`]),
              "data-testid": `assistant-step-${V.step.id}`
            }, [
              V.step.status === "done" ? (f(), Ge(u(_v), {
                key: 0,
                class: "fe-assistant__step-icon",
                "aria-hidden": "true"
              })) : V.step.status === "undone" ? (f(), Ge(u(YM), {
                key: 1,
                class: "fe-assistant__step-icon",
                "aria-hidden": "true"
              })) : V.step.status === "denied" || V.step.status === "not_run" ? (f(), Ge(u(GM), {
                key: 2,
                class: "fe-assistant__step-icon",
                "aria-hidden": "true"
              })) : (f(), Ge(u(Gw), {
                key: 3,
                class: "fe-assistant__step-icon",
                "aria-hidden": "true"
              })),
              d("span", rV, [
                d("span", sV, y(V.step.label), 1),
                V.step.target ? (f(), h("span", {
                  key: 0,
                  class: "fe-assistant__step-target",
                  title: V.step.target
                }, [
                  d("bdi", null, y(H(V.step.target)), 1)
                ], 8, lV)) : O("", !0),
                V.step.to ? (f(), h("span", {
                  key: 1,
                  class: "fe-assistant__step-to",
                  title: V.step.to
                }, [
                  d("bdi", null, y(H(V.step.to)), 1)
                ], 8, uV)) : O("", !0),
                d("span", cV, y(V.step.status_label), 1),
                V.step.error ? (f(), h("span", dV, y(V.step.error), 1)) : O("", !0)
              ]),
              V.step.can_undo ? (f(), h("button", {
                key: 4,
                type: "button",
                class: "fe-assistant__undo",
                disabled: w.value,
                "data-testid": `assistant-undo-${V.step.id}`,
                onClick: (qe) => ve(V.step)
              }, y(u(i)("assistant.undo")), 9, fV)) : O("", !0)
            ], 10, oV)) : O("", !0)
          ], 64))), 128)),
          b.value ? (f(), h(Te, { key: 1 }, [
            b.value.text ? (f(), h("div", pV, [
              d("p", hV, y(b.value.text), 1),
              b.value.paths.length ? (f(), h("ul", mV, [
                (f(!0), h(Te, null, nt(b.value.paths, (V) => (f(), h("li", {
                  key: V,
                  class: "fe-assistant__chip",
                  title: V
                }, [
                  d("bdi", null, y(H(V)), 1)
                ], 8, vV))), 128))
              ])) : O("", !0)
            ])) : O("", !0),
            (f(!0), h(Te, null, nt(b.value.steps.filter((V) => V.status !== "waiting"), (V) => (f(), h("div", {
              key: `live-${V.id}`,
              class: Re(["fe-assistant__step", `is-${V.status}`])
            }, [
              V.status === "running" ? (f(), Ge(u(Xw), {
                key: 0,
                class: "fe-assistant__step-icon fe-assistant__spin",
                "aria-hidden": "true"
              })) : V.status === "done" ? (f(), Ge(u(_v), {
                key: 1,
                class: "fe-assistant__step-icon",
                "aria-hidden": "true"
              })) : (f(), Ge(u(Gw), {
                key: 2,
                class: "fe-assistant__step-icon",
                "aria-hidden": "true"
              })),
              d("span", yV, [
                d("span", gV, y(V.label), 1),
                V.target ? (f(), h("span", {
                  key: 0,
                  class: "fe-assistant__step-target",
                  title: V.target
                }, [
                  d("bdi", null, y(H(V.target)), 1)
                ], 8, bV)) : O("", !0),
                d("span", kV, y(V.status_label), 1)
              ])
            ], 2))), 128)),
            b.value.reply ? (f(), h("div", wV, [
              d("p", _V, y(b.value.reply), 1)
            ])) : w.value ? (f(), h("p", xV, [
              Ze(u(Xw), {
                class: "fe-assistant__spin fe-assistant__inline-icon",
                "aria-hidden": "true"
              }),
              Ht(y(u(i)("assistant.working")), 1)
            ])) : O("", !0)
          ], 64)) : O("", !0),
          R.value ? (f(), h("section", {
            key: 2,
            class: "fe-assistant__card",
            role: "group",
            "aria-label": R.value.label,
            "data-testid": "assistant-approval"
          }, [
            d("p", $V, y(R.value.question), 1),
            R.value.note ? (f(), h("p", TV, y(R.value.note), 1)) : O("", !0),
            Y(R.value).length ? (f(), h("dl", AV, [
              (f(!0), h(Te, null, nt(Y(R.value), ([V, ke]) => (f(), h(Te, { key: V }, [
                d("dt", null, y(V), 1),
                d("dd", null, [
                  d("bdi", null, y(ke), 1)
                ])
              ], 64))), 128))
            ])) : O("", !0),
            d("div", EV, [
              d("button", {
                type: "button",
                class: "fe-btn",
                disabled: w.value,
                "data-testid": "assistant-decline",
                onClick: W[1] || (W[1] = (V) => q(!1))
              }, y(u(i)("assistant.decline")), 9, CV),
              d("button", {
                type: "button",
                class: "fe-btn fe-btn--primary",
                disabled: w.value,
                "data-testid": "assistant-approve",
                onClick: W[2] || (W[2] = (V) => q(!0))
              }, y(u(i)("assistant.approve")), 9, zV)
            ])
          ], 8, SV)) : O("", !0),
          $.value ? (f(), h("p", MV, y($.value), 1)) : O("", !0)
        ], 512)),
        d("footer", PV, [
          z.value > 0 ? (f(), h("label", OV, [
            dn(d("input", {
              "onUpdate:modelValue": W[3] || (W[3] = (V) => x.value = V),
              type: "checkbox",
              "data-testid": "assistant-with-selection"
            }, null, 512), [
              [zc, x.value]
            ]),
            d("span", null, y(u(i)("assistant.with_selection", { count: z.value })), 1)
          ])) : O("", !0),
          d("div", LV, [
            dn(d("textarea", {
              ref_key: "field",
              ref: T,
              "onUpdate:modelValue": W[4] || (W[4] = (V) => v.value = V),
              class: "fe-assistant__input",
              rows: "2",
              placeholder: u(i)("assistant.placeholder"),
              "aria-label": u(i)("assistant.placeholder"),
              "data-testid": "assistant-input",
              onKeydown: ee
            }, null, 40, DV), [
              [_n, v.value]
            ]),
            w.value ? (f(), h("button", {
              key: 0,
              type: "button",
              class: "fe-btn fe-assistant__send",
              title: u(i)("assistant.stop"),
              "aria-label": u(i)("assistant.stop"),
              "data-testid": "assistant-stop",
              onClick: le
            }, [
              Ze(u(XM), { "aria-hidden": "true" })
            ], 8, RV)) : (f(), h("button", {
              key: 1,
              type: "button",
              class: "fe-btn fe-btn--primary fe-assistant__send",
              title: u(i)("assistant.send"),
              "aria-label": u(i)("assistant.send"),
              disabled: !v.value.trim(),
              "data-testid": "assistant-send",
              onClick: re
            }, [
              Ze(u(JM), { "aria-hidden": "true" })
            ], 8, NV))
          ])
        ])
      ], 10, D7);
    };
  }
});
function BV(e) {
  return e.replace(/\/manager(\?.*)?$/, "/assistant");
}
function FV(e) {
  let t = "";
  const n = (a) => {
    let i = "";
    const r = [];
    for (const l of a.split(`
`))
      l.startsWith("event:") ? i = l.slice(6).trim() : l.startsWith("data:") && r.push(l.slice(5).replace(/^ /, ""));
    if (!(!i || r.length === 0))
      try {
        e({ name: i, data: JSON.parse(r.join(`
`)) });
      } catch {
      }
  };
  return (a, i = !1) => {
    t += a.replace(/\r\n/g, `
`);
    let r = t.indexOf(`

`);
    for (; r >= 0; )
      n(t.slice(0, r)), t = t.slice(r + 2), r = t.indexOf(`

`);
    i && t.trim() && (n(t), t = "");
  };
}
async function Z1(e, t, n, a, i) {
  var m;
  const r = await e.request(t, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "text/event-stream" },
    body: JSON.stringify(n),
    signal: i
  });
  if (!r.ok)
    throw e.failure(r.status, await r.text().catch(() => ""));
  const l = FV(a), c = (m = r.body) == null ? void 0 : m.getReader();
  if (!c) {
    l(await r.text(), !0);
    return;
  }
  const p = new TextDecoder();
  for (; ; ) {
    const { done: v, value: x } = await c.read();
    if (v) break;
    l(p.decode(x, { stream: !0 }));
  }
  l(p.decode(), !0);
}
function UV(e, t) {
  const n = t.replace(/\/+$/, ""), a = (i, r) => ({
    method: i,
    headers: { "Content-Type": "application/json" },
    ...r === void 0 ? {} : { body: JSON.stringify(r) }
  });
  return {
    me: () => e.json(`${n}`),
    setPrefs: (i) => e.json(`${n}/prefs`, a("PUT", i)),
    list: async () => (await e.json(`${n}/conversations`)).conversations ?? [],
    get: (i) => e.json(`${n}/conversations/${i}`),
    remove: (i) => e.json(`${n}/conversations/${i}`, { method: "DELETE" }),
    clear: () => e.json(`${n}/conversations`, { method: "DELETE" }),
    chat: (i, r, l) => Z1(e, `${n}/chat`, i, r, l),
    decide: (i, r, l, c) => Z1(e, `${n}/conversations/${i}/decide`, { approve: r }, l, c),
    undo: (i, r) => e.json(
      `${n}/conversations/${i}/undo`,
      a("POST", { step_id: r })
    )
  };
}
const yy = 500, HV = 800, Q1 = 10, KV = 'button, a, input, select, textarea, label, [role="checkbox"], [data-fe-control]';
function Ig(e, t) {
  return { ctrl: e.ctrlKey || e.metaKey, shift: e.shiftKey, touch: t };
}
function Bg(e) {
  return { ctrl: !0, shift: e.shiftKey, check: !0 };
}
function VV(e) {
  const t = e.target;
  if (typeof (t == null ? void 0 : t.closest) != "function") return !1;
  const n = t.closest(KV), a = e.currentTarget;
  return n !== null && (a === null || typeof a.contains != "function" || a.contains(n));
}
function Fg(e, t = {}) {
  let n, a = null, i = { clientX: 0, clientY: 0 }, r = !1, l = 0, c = !1;
  function p() {
    n && clearTimeout(n), n = void 0;
  }
  function m($, k) {
    const b = k.touches[0];
    b && (p(), a = $, r = !1, i = { clientX: b.clientX, clientY: b.clientY }, c = !VV(k), n = setTimeout(() => {
      n = void 0, a !== null && (r = !0, e(a, i));
    }, yy));
  }
  function v($) {
    const k = $.touches[0];
    (!k || Math.abs(k.clientX - i.clientX) > Q1 || Math.abs(k.clientY - i.clientY) > Q1) && (p(), a = null);
  }
  function x($) {
    p();
    const k = a, b = r, C = k !== null && !b;
    C && (l = Date.now()), a = null, C && c && t.onTap && ($ != null && $.cancelable && $.preventDefault(), t.onTap(k)), b && ($ != null && $.cancelable) && $.preventDefault(), c = !1;
  }
  function w($) {
    const k = $.pointerType;
    return k ? k === "touch" : Date.now() - l < HV;
  }
  return Tt(p), { onTouchStart: m, onTouchMove: v, onTouchEnd: x, isTap: w };
}
const e0 = 5, t0 = 10, jV = 300, n0 = 28;
function qV(e) {
  const t = S(null), n = S(null), a = S(!1);
  let i = null, r = 0;
  function l(C) {
    const T = e.keys();
    for (let E = 0; E < T.length; E++) {
      const R = e.rowEl(T[E]);
      if (!R) continue;
      const z = R.getBoundingClientRect();
      if (C < z.top + z.height / 2) return E;
    }
    return T.length;
  }
  function c(C, T) {
    const E = T.pointerType === "touch";
    if (!E && T.button !== 0) return;
    k();
    const R = e.touchDelayMs ?? yy, z = {
      key: C,
      pointerId: T.pointerId,
      touch: E,
      startX: T.clientX,
      startY: T.clientY,
      pressed: !E || R <= 0,
      armed: !1
    };
    E && R > 0 && (z.timer = setTimeout(() => {
      i === z && (z.pressed = !0, t.value = C);
    }, R)), i = z, window.addEventListener("pointermove", m), window.addEventListener("pointerup", x), window.addEventListener("pointercancel", $), window.addEventListener("blur", $), window.addEventListener("keydown", w, !0), E && window.addEventListener("touchmove", p, { passive: !1 });
  }
  function p(C) {
    i != null && i.pressed && C.cancelable && C.preventDefault();
  }
  function m(C) {
    var H;
    const T = i;
    if (!T || C.pointerId !== T.pointerId) return;
    const E = C.clientX - T.startX, R = C.clientY - T.startY;
    if (!T.armed) {
      if (!T.pressed) {
        (Math.abs(E) > t0 || Math.abs(R) > t0) && k();
        return;
      }
      if (Math.abs(E) < e0 && Math.abs(R) < e0) return;
      T.armed = !0, t.value = T.key, a.value = !0;
    }
    const z = l(C.clientY), D = e.keys().indexOf(T.key);
    n.value = z === D || z === D + 1 ? null : z;
    const U = (H = e.scroller) == null ? void 0 : H.call(e);
    if (U) {
      const L = U.getBoundingClientRect();
      C.clientY < L.top + n0 ? U.scrollTop -= 12 : C.clientY > L.bottom - n0 && (U.scrollTop += 12);
    }
  }
  function v() {
    const C = (R) => {
      R.cancelable && R.preventDefault(), E();
    }, T = setTimeout(() => E(), 600);
    function E() {
      clearTimeout(T), window.removeEventListener("touchend", C, !0);
    }
    window.addEventListener("touchend", C, { capture: !0, passive: !1 });
  }
  function x(C) {
    var R;
    const T = i;
    if (!T || C.pointerId !== T.pointerId) return;
    const E = n.value;
    if (k(), T.touch && T.pressed && v(), T.armed) {
      r = Date.now(), E !== null && e.onDrop(T.key, E);
      return;
    }
    T.touch && T.pressed && (e.touchDelayMs ?? yy) > 0 && (r = Date.now(), (R = e.onHold) == null || R.call(e, T.key));
  }
  function w(C) {
    C.key !== "Escape" || !i || (C.preventDefault(), C.stopPropagation(), $());
  }
  function $() {
    const C = (i == null ? void 0 : i.armed) === !0;
    k(), C && (r = Date.now());
  }
  function k() {
    i != null && i.timer && clearTimeout(i.timer), i = null, t.value = null, n.value = null, a.value = !1, window.removeEventListener("pointermove", m), window.removeEventListener("pointerup", x), window.removeEventListener("pointercancel", $), window.removeEventListener("blur", $), window.removeEventListener("keydown", w, !0), window.removeEventListener("touchmove", p);
  }
  function b(C) {
    Date.now() - r < jV && (C.preventDefault(), C.stopPropagation());
  }
  return Tt(k), {
    dragKey: t,
    dropGap: n,
    reordering: a,
    touchActive: () => (i == null ? void 0 : i.touch) === !0,
    onPointerDown: c,
    onClickCapture: b
  };
}
function Ja(e) {
  return e.uid || e.name;
}
function fT(e) {
  return e.map(Ja);
}
function ih(e) {
  if (typeof e != "string" || !e) return [];
  let t;
  try {
    t = JSON.parse(e);
  } catch {
    return [];
  }
  if (!Array.isArray(t)) return [];
  const n = [], a = /* @__PURE__ */ new Set();
  for (const i of t)
    typeof i != "string" || !i || a.has(i) || (a.add(i), n.push(i));
  return n;
}
function WV(e) {
  return e.length ? JSON.stringify(e) : "";
}
function YV(e) {
  return typeof e == "number" && Number.isFinite(e) ? e : null;
}
function GV(e) {
  return e.map((t, n) => ({ s: t, i: n, p: YV(t.sortOrder) })).sort((t, n) => t.p === null || n.p === null ? t.p === n.p ? t.i - n.i : t.p === null ? 1 : -1 : t.p - n.p || t.i - n.i).map((t) => t.s);
}
function XV(e, t) {
  const n = GV(e);
  if (!t.length || n.length < 2) return n;
  const a = /* @__PURE__ */ new Map();
  t.forEach((c, p) => {
    a.has(c) || a.set(c, p);
  });
  const i = (c) => (c.uid ? a.get(c.uid) : void 0) ?? a.get(c.name), r = n.filter((c) => i(c) !== void 0).sort((c, p) => (i(c) ?? 0) - (i(p) ?? 0));
  let l = 0;
  return n.map((c) => i(c) === void 0 ? c : r[l++]);
}
function a0(e, t, n) {
  const a = fT(e), i = a.indexOf(t), r = i + n;
  return i < 0 || n === 0 || r < 0 || r >= a.length ? null : (a.splice(i, 1), a.splice(r, 0, t), a);
}
function JV(e, t, n) {
  const a = fT(e), i = a.indexOf(t);
  if (i < 0) return null;
  const r = Math.max(0, Math.min(a.length, Math.trunc(n)));
  return r === i || r === i + 1 ? null : (a.splice(i, 1), a.splice(r > i ? r - 1 : r, 0, t), a);
}
function i0(e) {
  return e.map((t, n) => ({ s: t, i: n })).sort((t, n) => PS(t.s.label || t.s.name, n.s.label || n.s.name) || t.i - n.i).map((t) => Ja(t.s));
}
function ZV(e, t, n) {
  const a = [...e];
  if (!n.length) return a;
  const i = /* @__PURE__ */ new Map();
  for (const l of t)
    i.set(l.name, Ja(l)), l.uid && i.set(l.uid, Ja(l));
  let r = null;
  for (const l of n) {
    const c = i.get(l);
    if (c !== void 0) {
      r = c;
      continue;
    }
    if (a.includes(l)) continue;
    const p = r === null ? 0 : a.indexOf(r) + 1;
    a.splice(p, 0, l), r = l;
  }
  return a;
}
const qo = S([]);
let Ys = null, sv = "";
function QV() {
  return nr() ? ih(vp("storageOrder")) : [];
}
function ej(e, t) {
  const n = e.length ? ZV(e, t, qo.value) : [];
  qo.value = n;
  const a = WV(n);
  if (!Fl()) {
    Gr("storageOrder", a);
    return;
  }
  if (S$()) {
    o0(a);
    return;
  }
  Gr("storageOrder", a), sv = a, !Ys && (Ys = Jc(() => {
    Ys == null || Ys(), Ys = null, o0(sv), qo.value = ih(sv);
  }));
}
function o0(e) {
  Zi("storageOrder", e), JF();
}
function tj() {
  qo.value = QV();
  const e = Jc(() => {
    qo.value = ih(Qi().storageOrder);
  });
  return Zo() && Tt(e), { saved: qo, custom: A(() => qo.value.length > 0) };
}
if (typeof window < "u")
  try {
    window.addEventListener("storage", (e) => {
      e.key !== _c.storageOrder || !nr() || (qo.value = ih(e.newValue));
    });
  } catch {
  }
const nj = {
  class: "fe-stags",
  "data-testid": "storage-tags"
}, aj = ["title"], ij = {
  key: 1,
  class: "fe-stag fe-stag--warn tbl-pill",
  "data-testid": "storage-tag-readonly"
}, oj = {
  key: 2,
  class: "fe-stag tbl-pill",
  "data-testid": "storage-tag-disabled"
}, pT = /* @__PURE__ */ lt({
  __name: "StorageTags",
  props: {
    driver: {},
    readOnly: { type: Boolean },
    enabled: { type: Boolean, default: void 0 },
    locale: {}
  },
  setup(e) {
    const t = e, { t: n } = ht(() => t.locale ?? "en"), a = A(() => {
      if (!t.driver) return "";
      const i = `storages.driver.${t.driver}`, r = n(i);
      return r === i ? t.driver : r;
    });
    return (i, r) => (f(), h("span", nj, [
      e.driver ? (f(), h("span", {
        key: 0,
        class: "fe-stag tbl-pill",
        title: e.driver,
        "data-testid": "storage-tag-driver"
      }, y(a.value), 9, aj)) : O("", !0),
      e.readOnly ? (f(), h("span", ij, y(u(n)("sidenav.storage.readOnly")), 1)) : O("", !0),
      e.enabled === !1 ? (f(), h("span", oj, y(u(n)("conn.list.disabled")), 1)) : O("", !0)
    ]));
  }
}), rj = ["aria-label"], sj = {
  key: 0,
  class: "fe-sidenav__head"
}, lj = ["aria-expanded", "title", "aria-label"], uj = { class: "fe-sidenav__primary" }, cj = ["title", "aria-label"], dj = { class: "fe-sidenav__new-main" }, fj = {
  key: 0,
  class: "fe-sidenav__text"
}, pj = {
  key: 0,
  class: "fe-sidenav__new-rule",
  "aria-hidden": "true"
}, hj = {
  key: 1,
  class: "fe-sidenav__new-caret",
  "aria-hidden": "true"
}, mj = { class: "fe-sidenav__scroll" }, vj = ["aria-label"], yj = ["aria-current", "title", "aria-label", "data-testid", "onClick"], gj = {
  class: "fe-ficon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, bj = {
  key: 1,
  d: "M3.5 7.5A1.5 1.5 0 0 1 5 6h4l2 2.5h8A1.5 1.5 0 0 1 20.5 10v7.5A1.5 1.5 0 0 1 19 19H5a1.5 1.5 0 0 1-1.5-1.5z"
}, kj = {
  key: 3,
  d: "M12 4l2.4 4.9 5.4.8-3.9 3.8.9 5.4-4.8-2.5-4.8 2.5.9-5.4-3.9-3.8 5.4-.8z"
}, wj = {
  key: 0,
  class: "fe-sidenav__text"
}, _j = { key: 0 }, xj = ["title", "aria-label"], Sj = {
  key: 0,
  class: "fe-sidenav__text"
}, $j = {
  key: 0,
  class: "fe-sidenav__section"
}, Tj = { class: "fe-sidenav__heading" }, Aj = ["data-testid"], Ej = ["aria-label"], Cj = ["aria-current", "title", "aria-label", "data-testid", "data-tag-kind", "onClick"], zj = { class: "fe-sidenav__text" }, Mj = ["aria-label"], Pj = { key: 0 }, Oj = { class: "fe-sidenav__hint" }, Lj = { key: 1 }, Dj = { key: 2 }, Rj = ["aria-label"], Nj = ["title", "aria-label"], Ij = {
  key: 1,
  class: "fe-sidenav__section"
}, Bj = {
  key: 0,
  class: "fe-sidenav__heading"
}, Fj = {
  key: 1,
  class: "fe-sidenav__rule",
  "aria-hidden": "true"
}, Uj = ["aria-label"], Hj = ["title", "aria-label", "data-testid", "onClick", "onContextmenu", "onKeydown", "onPointerdown"], Kj = {
  class: "fe-ficon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, Vj = {
  key: 0,
  class: "fe-sidenav__text"
}, jj = ["aria-label"], qj = {
  key: 2,
  class: "fe-sidenav__section",
  "data-testid": "sidenav-apps"
}, Wj = {
  key: 0,
  class: "fe-sidenav__heading"
}, Yj = {
  key: 1,
  class: "fe-sidenav__rule",
  "aria-hidden": "true"
}, Gj = ["aria-label"], Xj = ["title", "aria-label", "data-testid", "onClick"], Jj = ["innerHTML"], Zj = {
  key: 0,
  class: "fe-sidenav__text"
}, Qj = { key: 0 }, eq = ["title", "aria-label"], tq = {
  key: 0,
  class: "fe-sidenav__text"
}, nq = {
  key: 3,
  class: "fe-sidenav__section",
  "data-testid": "sidenav-connections"
}, aq = ["aria-label"], iq = ["title", "aria-label"], oq = {
  key: 0,
  class: "fe-sidenav__text"
}, rq = { key: 0 }, sq = ["title", "aria-label"], lq = {
  key: 0,
  class: "fe-sidenav__text"
}, uq = {
  key: 1,
  class: "fe-sidenav__quota",
  "data-testid": "sidenav-quota"
}, cq = {
  key: 0,
  class: "fe-sidenav__quota-label"
}, dq = ["aria-valuenow", "aria-label", "title"], fq = {
  key: 1,
  class: "fe-sidenav__quota-text"
}, r0 = 8, pq = /* @__PURE__ */ lt({
  __name: "SideNav",
  props: {
    expanded: { type: Boolean },
    narrow: { type: Boolean },
    activeView: {},
    activeStorage: {},
    storages: {},
    storageOrderCustom: { type: Boolean },
    sharedStorages: {},
    trashVisible: { type: Boolean },
    draftsVisible: { type: Boolean },
    draftCount: {},
    tags: {},
    tagsLoaded: { type: Boolean },
    activeTag: {},
    activeTagKind: {},
    showConnections: { type: Boolean },
    showMyShares: { type: Boolean },
    showAppStore: { type: Boolean },
    showIdentitySurfaces: { type: Boolean },
    canWrite: { type: Boolean },
    locale: {},
    canRequestFiles: { type: Boolean },
    requestFilesAllowed: { type: Boolean, default: !0 },
    canNewDocument: { type: Boolean },
    quota: {},
    theme: {},
    apps: {}
  },
  emits: ["toggle", "open-view", "open-tag", "open-storage", "open-root", "upload", "new-folder", "new-document", "open-connections", "open-tokens", "open-my-shares", "open-app-store", "open-app", "request-files", "reorder-storages", "close"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatSize: r, dir: l } = ht(() => n.locale), c = A(() => n.expanded || !!n.narrow), p = A(() => new Set(n.sharedStorages ?? [])), m = /* @__PURE__ */ new Set(["recent", "starred", "shared", "drafts"]), v = A(() => {
      const Ne = [
        { key: "home", label: i("sidenav.home") },
        ...n.storages.length <= 1 ? [{ key: "myfiles", label: i("sidenav.myfiles") }] : [],
        { key: "shared", label: i("sidenav.shared") },
        { key: "recent", label: i("sidenav.recent") },
        { key: "starred", label: i("sidenav.starred") }
      ];
      return n.draftsVisible && Ne.push({ key: "drafts", label: i("sidenav.drafts") }), n.trashVisible !== !1 && Ne.push({ key: "trash", label: i("sidenav.trash") }), n.showIdentitySurfaces === !1 ? Ne.filter((ie) => !m.has(ie.key)) : Ne;
    }), x = A(() => n.canWrite !== !1), w = A(
      () => (n.apps ?? []).map((Ne) => ({
        ...Ne,
        svg: zt(Ne.icon && zt(Ne.icon) !== "" ? Ne.icon : "plugin")
      }))
    ), $ = A(
      () => !!n.activeStorage && n.storages.some((Ne) => Ne.name === n.activeStorage && Ne.readOnly === !0)
    ), k = A(() => !$.value && n.activeView !== "trash");
    function b(Ne) {
      const ie = n.draftCount ?? 0;
      return Ne.key !== "drafts" || ie <= 0 ? Ne.label : `${Ne.label}, ${i("sidenav.drafts.count", { n: ie })}`;
    }
    function C(Ne) {
      return Ne === "myfiles" ? !n.activeView && !n.activeStorage : n.activeView === Ne;
    }
    const T = S(!1), E = A(() => n.tags ?? []), R = A(
      () => ["personal", "team"].map((Ne) => {
        const ie = E.value.filter((xe) => xe.kind === Ne);
        return { kind: Ne, list: ie, visible: T.value ? ie : ie.slice(0, r0) };
      }).filter((Ne) => Ne.list.length > 0)
    ), z = A(
      () => R.value.reduce((Ne, ie) => Ne + ie.list.length - ie.visible.length, 0)
    ), D = A(() => R.value.some((Ne) => Ne.list.length > r0));
    function U(Ne) {
      return n.activeView !== "tag" || n.activeTag !== Ne.name ? !1 : !n.activeTagKind || n.activeTagKind === Ne.kind;
    }
    const H = A(() => !!n.tagsLoaded || E.value.length > 0), L = S(null), P = S(null), K = A(() => {
      const Ne = [
        /* ⚠ NO `icon:` on any of these three, and that is the fix rather than an
           omission. `ContextMenu.iconFor` resolves `actionIconSvg(a.icon || a.key)`,
           so an `icon` string is an OVERRIDE — and `'⬆'` / `'📁'` / `'🔗'` are not
           keys, so the lookup missed, the component fell through to its literal
           branch and printed the emoji. Meanwhile `new-document`, which carries no
           override, resolved by key and drew a proper glyph: one menu, two icon
           systems, three rows apart. All three keys have had stroked glyphs in
           `lib/actionIcons.ts` the whole time (`upload`, `new-folder`,
           `request-files`); dropping the override is what reaches them.
           ⚠ Emoji in markup is forbidden here for a reason that is visible in this
           very menu: they are rendered by whatever font the OS ships, so the row
           came out flat-grey on one machine and full-colour on another, at a weight
           that matched nothing beside it. */
        { key: "upload", label: i("drive.new.upload"), disabled: !x.value },
        { key: "new-folder", label: i("drive.new.folder"), disabled: !x.value }
      ];
      return n.canNewDocument && Ne.push({ key: "new-document", label: i("drive.new.document"), disabled: !x.value }), n.requestFilesAllowed !== !1 && (Ne.push({ divider: !0, key: "new-sep", label: "" }), Ne.push({
        key: "request-files",
        label: i("drive.new.request"),
        disabled: !n.canRequestFiles
      })), Ne;
    });
    function N() {
      var ie, xe;
      const Ne = (ie = L.value) == null ? void 0 : ie.getBoundingClientRect();
      (xe = P.value) == null || xe.show(
        // ⚠ RTL: hangs from the pill's START edge (its right side in RTL).
        { clientX: Ne ? Ur(Ne, l.value) : 0, clientY: Ne ? Ne.bottom + 6 : 0 },
        []
      );
    }
    function J(Ne) {
      Ne.key === "upload" ? a("upload") : Ne.key === "new-document" ? a("new-document") : Ne.key === "new-folder" ? a("new-folder") : Ne.key === "request-files" && a("request-files");
    }
    const j = A(() => {
      const Ne = n.quota;
      return !Ne || Ne.unlimited || Ne.total <= 0 ? 0 : Math.max(0, Math.min(100, Math.round(Ne.used / Ne.total * 100)));
    }), re = A(() => {
      const Ne = n.quota;
      return Ne ? Ne.unlimited || Ne.total <= 0 ? Ne.partial ? i("drive.storage.used_partial", { used: r(Ne.used) }) : i("drive.storage.used_unlimited", { used: r(Ne.used) }) : i("drive.storage.used", { used: r(Ne.used), total: r(Ne.total) }) : "";
    }), q = A(() => i("sidenav.close")), le = A(() => n.storages.length > 1), ve = /* @__PURE__ */ new Map();
    function ce(Ne, ie) {
      ie instanceof HTMLElement ? ve.set(Ne, ie) : ve.delete(Ne);
    }
    const se = S(null), fe = S(null), _ = S(""), ee = S(!1);
    function Y(Ne) {
      return n.storages.findIndex((ie) => Ja(ie) === Ne);
    }
    const B = A(() => {
      const Ne = Y(_.value), ie = n.storages.length, xe = n.storages.map(Ja), De = i0(n.storages).every((ot, ft) => ot === xe[ft]);
      return [
        {
          key: "storage-move-up",
          icon: "move-up",
          label: i("sidenav.storage.moveUp"),
          disabled: Ne <= 0,
          testid: "sidenav-storage-move-up"
        },
        {
          key: "storage-move-down",
          icon: "move-down",
          label: i("sidenav.storage.moveDown"),
          disabled: Ne < 0 || Ne >= ie - 1,
          testid: "sidenav-storage-move-down"
        },
        { divider: !0, key: "storage-order-sep", label: "" },
        {
          key: "storage-sort-name",
          icon: "sort-name",
          label: i("sidenav.storage.sortName"),
          disabled: De,
          // ⚠ A greyed row says why, or it reads as broken (ContextAction.title).
          title: De ? i("sidenav.storage.sortName.done") : void 0,
          testid: "sidenav-storage-sort-name"
        },
        {
          // "Use default order": drop the person's own order and fall back to the
          // administrator's (or, with none, the host's). Not "Reset": nothing of
          // the default is being reset, the person's order is being let go.
          key: "storage-default-order",
          icon: "reset-order",
          label: i("sidenav.storage.defaultOrder"),
          disabled: !n.storageOrderCustom,
          title: n.storageOrderCustom ? void 0 : i("sidenav.storage.defaultOrder.none"),
          testid: "sidenav-storage-default-order"
        }
      ];
    });
    function W(Ne, ie, xe = !1) {
      var ot, ft;
      if (!le.value) return;
      const he = Ja(Ne);
      _.value = he, ee.value = xe;
      let De = ie;
      if (!De) {
        const gt = (ot = ve.get(he)) == null ? void 0 : ot.getBoundingClientRect();
        De = gt ? { clientX: Ur(gt, l.value), clientY: gt.bottom + 4 } : { clientX: 0, clientY: 0 };
      }
      (ft = fe.value) == null || ft.show(De, []);
    }
    function F(Ne, ie) {
      le.value && (ie.preventDefault(), ie.stopPropagation(), !We.touchActive() && W(Ne, { clientX: ie.clientX, clientY: ie.clientY }));
    }
    let V = null;
    function ke(Ne = !1) {
      V == null || V();
      const ie = (De) => {
        const ot = De.target, ft = typeof (ot == null ? void 0 : ot.closest) == "function" && !!ot.closest(".fe-ctx-backdrop");
        !Ne && !ft || (De.preventDefault(), De.stopPropagation(), he());
      }, xe = setTimeout(() => he(), 1e3);
      function he() {
        clearTimeout(xe), window.removeEventListener("contextmenu", ie, !0), V = null;
      }
      window.addEventListener("contextmenu", ie, !0), V = he;
    }
    Tt(() => V == null ? void 0 : V());
    function qe(Ne, ie) {
      ie.key !== "ContextMenu" && !(ie.key === "F10" && ie.shiftKey) || le.value && (ie.preventDefault(), ie.stopPropagation(), ke(), W(Ne, null));
    }
    async function Me(Ne, ie) {
      var xe;
      Ne !== null && (a("reorder-storages", Ne), await Gt(), (xe = ve.get(ie)) == null || xe.focus());
    }
    function Fe(Ne) {
      const ie = _.value;
      Ne.key === "storage-move-up" ? Me(a0(n.storages, ie, -1), ie) : Ne.key === "storage-move-down" ? Me(a0(n.storages, ie, 1), ie) : Ne.key === "storage-sort-name" ? Me(i0(n.storages), ie) : Ne.key === "storage-default-order" && Me([], ie);
    }
    const We = qV({
      keys: () => n.storages.map(Ja),
      rowEl: (Ne) => ve.get(Ne),
      scroller: () => {
        var Ne;
        return (Ne = se.value) == null ? void 0 : Ne.querySelector(".fe-sidenav__scroll");
      },
      onDrop: (Ne, ie) => void Me(JV(n.storages, Ne, ie), Ne),
      onHold: (Ne) => {
        const ie = n.storages.find((xe) => Ja(xe) === Ne);
        ie && (ke(!0), W(ie, null, !0));
      }
    }), { dragKey: $t, dropGap: St, reordering: at, onClickCapture: kt } = We;
    function pt(Ne, ie) {
      le.value && We.onPointerDown(Ja(Ne), ie);
    }
    return (Ne, ie) => (f(), h("nav", {
      ref_key: "navEl",
      ref: se,
      class: Re(["fe-sidenav", {
        "fe-sidenav--rail": !e.expanded && !e.narrow,
        "fe-sidenav--drawer": e.narrow,
        "fe-sidenav--reordering": u(at)
      }]),
      role: "navigation",
      "aria-label": u(i)("sidenav.title"),
      "data-testid": "sidenav"
    }, [
      e.narrow ? (f(), h("div", sj, [
        d("button", {
          type: "button",
          class: "fe-sidenav__toggle",
          "aria-expanded": c.value,
          title: q.value,
          "aria-label": q.value,
          "data-testid": "sidenav-toggle",
          onClick: ie[0] || (ie[0] = (xe) => a("close"))
        }, [...ie[9] || (ie[9] = [
          d("svg", {
            class: "fe-ficon",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.8",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            d("path", { d: "M6 6l12 12M18 6L6 18" })
          ], -1)
        ])], 8, lj)
      ])) : O("", !0),
      d("div", uj, [
        k.value ? (f(), h("button", {
          key: 0,
          ref_key: "newBtnEl",
          ref: L,
          type: "button",
          class: "fe-sidenav__new",
          "aria-haspopup": "menu",
          title: u(i)("drive.new"),
          "aria-label": u(i)("drive.new"),
          "data-testid": "sidenav-new",
          onClick: N
        }, [
          d("span", dj, [
            ie[10] || (ie[10] = d("svg", {
              class: "fe-ficon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              d("path", { d: "M12 5v14M5 12h14" })
            ], -1)),
            c.value ? (f(), h("span", fj, y(u(i)("drive.new")), 1)) : O("", !0)
          ]),
          c.value ? (f(), h("span", pj)) : O("", !0),
          c.value ? (f(), h("span", hj, [...ie[11] || (ie[11] = [
            d("svg", {
              class: "fe-ficon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              d("path", { d: "M7 10l5 5 5-5" })
            ], -1)
          ])])) : O("", !0)
        ], 8, cj)) : O("", !0)
      ]),
      d("div", mj, [
        d("ul", {
          class: "fe-sidenav__group",
          "aria-label": u(i)("sidenav.views")
        }, [
          (f(!0), h(Te, null, nt(v.value, (xe) => (f(), h(Te, {
            key: xe.key
          }, [
            d("li", null, [
              d("button", {
                type: "button",
                class: Re(["fe-sidenav__item", { "is-active": C(xe.key) }]),
                "aria-current": C(xe.key) ? "page" : void 0,
                title: b(xe),
                "aria-label": b(xe),
                "data-testid": `sidenav-view-${xe.key}`,
                onClick: (he) => a("open-view", xe.key)
              }, [
                (f(), h("svg", gj, [
                  xe.key === "home" ? (f(), h(Te, { key: 0 }, [
                    ie[12] || (ie[12] = d("path", { d: "M4 10.5L12 4l8 6.5" }, null, -1)),
                    ie[13] || (ie[13] = d("path", { d: "M6 9.8V19a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.8" }, null, -1)),
                    ie[14] || (ie[14] = d("path", { d: "M10 20v-5.5h4V20" }, null, -1))
                  ], 64)) : xe.key === "myfiles" ? (f(), h("path", bj)) : xe.key === "recent" ? (f(), h(Te, { key: 2 }, [
                    ie[15] || (ie[15] = d("circle", {
                      cx: "12",
                      cy: "12",
                      r: "8.5"
                    }, null, -1)),
                    ie[16] || (ie[16] = d("path", { d: "M12 7.5V12l3 2" }, null, -1))
                  ], 64)) : xe.key === "starred" ? (f(), h("path", kj)) : xe.key === "shared" ? (f(), h(Te, { key: 4 }, [
                    ie[17] || (ie[17] = d("circle", {
                      cx: "17.5",
                      cy: "6.5",
                      r: "2.5"
                    }, null, -1)),
                    ie[18] || (ie[18] = d("circle", {
                      cx: "6.5",
                      cy: "12",
                      r: "2.5"
                    }, null, -1)),
                    ie[19] || (ie[19] = d("circle", {
                      cx: "17.5",
                      cy: "17.5",
                      r: "2.5"
                    }, null, -1)),
                    ie[20] || (ie[20] = d("path", { d: "M8.8 10.8l6.4-3.2M8.8 13.2l6.4 3.2" }, null, -1))
                  ], 64)) : xe.key === "drafts" ? (f(), h(Te, { key: 5 }, [
                    ie[21] || (ie[21] = d("path", { d: "M13.5 4H7a1.5 1.5 0 0 0-1.5 1.5v13A1.5 1.5 0 0 0 7 20h10a1.5 1.5 0 0 0 1.5-1.5V9z" }, null, -1)),
                    ie[22] || (ie[22] = d("path", { d: "M13.5 4v5h5" }, null, -1)),
                    ie[23] || (ie[23] = d("path", { d: "M9 15.5l4.8-4.8 1.7 1.7-4.8 4.8H9z" }, null, -1))
                  ], 64)) : (f(), h(Te, { key: 6 }, [
                    ie[24] || (ie[24] = d("path", { d: "M4.5 7h15" }, null, -1)),
                    ie[25] || (ie[25] = d("path", { d: "M9.5 7V5.2A1.2 1.2 0 0 1 10.7 4h2.6a1.2 1.2 0 0 1 1.2 1.2V7" }, null, -1)),
                    ie[26] || (ie[26] = d("path", { d: "M6.5 7l.9 11.1A1.4 1.4 0 0 0 8.8 19.4h6.4a1.4 1.4 0 0 0 1.4-1.3L17.5 7" }, null, -1))
                  ], 64))
                ])),
                c.value ? (f(), h("span", wj, y(xe.label), 1)) : O("", !0),
                xe.key === "drafts" && (e.draftCount ?? 0) > 0 ? (f(), h("span", {
                  key: 1,
                  class: Re(["fe-sidenav__count", { "fe-sidenav__count--rail": !c.value }]),
                  "aria-hidden": "true",
                  "data-testid": "sidenav-drafts-count"
                }, y(e.draftCount), 3)) : O("", !0)
              ], 10, yj)
            ]),
            xe.key === "shared" && e.showMyShares ? (f(), h("li", _j, [
              d("button", {
                type: "button",
                class: "fe-sidenav__item",
                title: u(i)("sidenav.myshares"),
                "aria-label": u(i)("sidenav.myshares"),
                "data-testid": "sidenav-my-shares",
                onClick: ie[1] || (ie[1] = (he) => a("open-my-shares"))
              }, [
                ie[27] || (ie[27] = d("svg", {
                  class: "fe-ficon",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true",
                  focusable: "false"
                }, [
                  d("path", { d: "M10 13.5a4.5 4.5 0 0 0 6.8.5l2.7-2.7a4.5 4.5 0 0 0-6.36-6.36L11.6 6.5" }),
                  d("path", { d: "M14 10.5a4.5 4.5 0 0 0-6.8-.5l-2.7 2.7a4.5 4.5 0 0 0 6.36 6.36l1.53-1.53" })
                ], -1)),
                c.value ? (f(), h("span", Sj, y(u(i)("sidenav.myshares")), 1)) : O("", !0)
              ], 8, xj)
            ])) : O("", !0)
          ], 64))), 128))
        ], 8, vj),
        H.value ? (f(), h("div", $j, [
          c.value ? (f(), h(Te, { key: 0 }, [
            d("p", Tj, y(u(i)("sidenav.tags")), 1),
            (f(!0), h(Te, null, nt(R.value, (xe) => (f(), h(Te, {
              key: xe.kind
            }, [
              d("p", {
                class: "fe-sidenav__subheading",
                "data-testid": `sidenav-tags-${xe.kind}`
              }, [
                Ze(Bv, {
                  kind: xe.kind,
                  size: 12
                }, null, 8, ["kind"]),
                d("span", null, y(u(i)(`sidenav.tags.${xe.kind}`)), 1)
              ], 8, Aj),
              d("ul", {
                class: "fe-sidenav__group",
                "aria-label": `${u(i)("sidenav.tags")} - ${u(i)(`sidenav.tags.${xe.kind}`)}`
              }, [
                (f(!0), h(Te, null, nt(xe.visible, (he) => (f(), h("li", {
                  key: `${he.kind}:${he.name}`
                }, [
                  d("button", {
                    type: "button",
                    class: Re(["fe-sidenav__item fe-sidenav__item--tag", { "is-active": U(he) }]),
                    "aria-current": U(he) ? "page" : void 0,
                    title: u(i)(`tags.chip.${he.kind}`, { tag: he.name }),
                    "aria-label": u(i)(`tags.chip.${he.kind}`, { tag: he.name }),
                    "data-testid": `sidenav-tag-${he.name}`,
                    "data-tag-kind": he.kind,
                    onClick: (De) => a("open-tag", he.name, he.kind)
                  }, [
                    Ze(Bv, {
                      class: "fe-ficon",
                      kind: he.kind,
                      size: 16
                    }, null, 8, ["kind"]),
                    d("span", zj, y(he.name), 1)
                  ], 10, Cj)
                ]))), 128))
              ], 8, Ej)
            ], 64))), 128)),
            d("ul", {
              class: "fe-sidenav__group",
              "aria-label": u(i)("sidenav.tags")
            }, [
              E.value.length === 0 ? (f(), h("li", Pj, [
                d("p", Oj, y(u(i)("sidenav.tags.empty")), 1)
              ])) : O("", !0),
              z.value > 0 ? (f(), h("li", Lj, [
                d("button", {
                  type: "button",
                  class: "fe-sidenav__more",
                  "data-testid": "sidenav-tags-more",
                  onClick: ie[2] || (ie[2] = (xe) => T.value = !0)
                }, y(u(i)("sidenav.tags.more", { count: z.value })), 1)
              ])) : T.value && D.value ? (f(), h("li", Dj, [
                d("button", {
                  type: "button",
                  class: "fe-sidenav__more",
                  "data-testid": "sidenav-tags-less",
                  onClick: ie[3] || (ie[3] = (xe) => T.value = !1)
                }, y(u(i)("sidenav.tags.less")), 1)
              ])) : O("", !0)
            ], 8, Mj)
          ], 64)) : (f(), h(Te, { key: 1 }, [
            ie[29] || (ie[29] = d("hr", {
              class: "fe-sidenav__rule",
              "aria-hidden": "true"
            }, null, -1)),
            d("ul", {
              class: "fe-sidenav__group",
              "aria-label": u(i)("sidenav.tags")
            }, [
              d("li", null, [
                d("button", {
                  type: "button",
                  class: Re(["fe-sidenav__item", { "is-active": e.activeView === "tag" }]),
                  title: u(i)("sidenav.tags"),
                  "aria-label": u(i)("sidenav.tags"),
                  "data-testid": "sidenav-tags-rail",
                  onClick: ie[4] || (ie[4] = (xe) => a("toggle"))
                }, [...ie[28] || (ie[28] = [
                  d("svg", {
                    class: "fe-ficon",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "aria-hidden": "true",
                    focusable: "false"
                  }, [
                    d("path", { d: "M4 4.5h7l9 9-6.5 6.5-9-9z" }),
                    d("circle", {
                      cx: "8",
                      cy: "8.5",
                      r: "1.4"
                    })
                  ], -1)
                ])], 10, Nj)
              ])
            ], 8, Rj)
          ], 64))
        ])) : O("", !0),
        e.storages.length ? (f(), h("div", Ij, [
          c.value ? (f(), h("p", Bj, y(u(i)("sidenav.storages")), 1)) : (f(), h("hr", Fj)),
          d("ul", {
            class: "fe-sidenav__group",
            "aria-label": u(i)("sidenav.storages"),
            "data-testid": "sidenav-storages",
            onClickCapture: ie[5] || (ie[5] = //@ts-ignore
            (...xe) => u(kt) && u(kt)(...xe))
          }, [
            (f(!0), h(Te, null, nt(e.storages, (xe, he) => (f(), h("li", {
              key: xe.name,
              class: Re({
                "is-drop-before": u(St) === he,
                "is-drop-after": u(St) === e.storages.length && he === e.storages.length - 1
              })
            }, [
              d("button", {
                ref_for: !0,
                ref: (De) => ce(u(Ja)(xe), De),
                type: "button",
                class: Re(["fe-sidenav__item fe-sidenav__item--storage", {
                  "is-active": !e.activeView && e.activeStorage === xe.name,
                  "is-dragging": u($t) === u(Ja)(xe)
                }]),
                title: p.value.has(xe.name) ? `${xe.label || xe.name} - ${u(i)("sidenav.storage.shared")}` : xe.label || xe.name,
                "aria-label": p.value.has(xe.name) ? `${xe.label || xe.name} - ${u(i)("sidenav.storage.shared")}` : xe.label || xe.name,
                "data-testid": `sidenav-storage-${xe.name}`,
                onClick: (De) => a("open-storage", xe.name),
                onContextmenu: (De) => F(xe, De),
                onKeydown: (De) => qe(xe, De),
                onPointerdown: (De) => pt(xe, De)
              }, [
                (f(), h("svg", Kj, [
                  p.value.has(xe.name) ? (f(), h(Te, { key: 0 }, [
                    ie[30] || (ie[30] = d("path", { d: "M3 8.5A1.5 1.5 0 0 1 4.5 7h5L11 9h8.5A1.5 1.5 0 0 1 21 10.5v7A1.5 1.5 0 0 1 19.5 19h-15A1.5 1.5 0 0 1 3 17.5z" }, null, -1)),
                    ie[31] || (ie[31] = d("circle", {
                      cx: "15.6",
                      cy: "13.6",
                      r: "1.6"
                    }, null, -1)),
                    ie[32] || (ie[32] = d("circle", {
                      cx: "9.4",
                      cy: "15.4",
                      r: "1.6"
                    }, null, -1)),
                    ie[33] || (ie[33] = d("path", { d: "M10.9 14.7l3.3-.9" }, null, -1))
                  ], 64)) : (f(), h(Te, { key: 1 }, [
                    ie[34] || (ie[34] = d("rect", {
                      x: "3",
                      y: "5",
                      width: "18",
                      height: "6",
                      rx: "1.6"
                    }, null, -1)),
                    ie[35] || (ie[35] = d("rect", {
                      x: "3",
                      y: "13",
                      width: "18",
                      height: "6",
                      rx: "1.6"
                    }, null, -1)),
                    ie[36] || (ie[36] = d("path", { d: "M6.5 8h.01M6.5 16h.01" }, null, -1))
                  ], 64))
                ])),
                c.value ? (f(), h("span", Vj, y(xe.label || xe.name), 1)) : O("", !0),
                c.value && p.value.has(xe.name) ? (f(), h("span", {
                  key: 1,
                  class: "fe-sidenav__tag",
                  role: "img",
                  "aria-label": u(i)("sidenav.storage.shared")
                }, y(u(i)("sidenav.storage.shared")), 9, jj)) : O("", !0),
                c.value && xe.readOnly ? (f(), Ge(pT, {
                  key: 2,
                  "read-only": "",
                  locale: e.locale,
                  class: "fe-sidenav__stags",
                  "data-testid": "sidenav-storage-readonly"
                }, null, 8, ["locale"])) : O("", !0)
              ], 42, Hj)
            ], 2))), 128))
          ], 40, Uj)
        ])) : O("", !0),
        w.value.length || e.showAppStore ? (f(), h("div", qj, [
          c.value ? (f(), h("p", Wj, y(u(i)("sidenav.apps")), 1)) : (f(), h("hr", Yj)),
          d("ul", {
            class: "fe-sidenav__group",
            "aria-label": u(i)("sidenav.apps")
          }, [
            (f(!0), h(Te, null, nt(w.value, (xe) => (f(), h("li", {
              key: xe.key
            }, [
              d("button", {
                type: "button",
                class: "fe-sidenav__item",
                title: xe.label,
                "aria-label": xe.label,
                "data-testid": `sidenav-app-${xe.key}`,
                onClick: (he) => a("open-app", xe.key)
              }, [
                d("span", {
                  class: "fe-sidenav__appicon",
                  "aria-hidden": "true",
                  innerHTML: xe.svg
                }, null, 8, Jj),
                c.value ? (f(), h("span", Zj, y(xe.label), 1)) : O("", !0)
              ], 8, Xj)
            ]))), 128)),
            e.showAppStore ? (f(), h("li", Qj, [
              d("button", {
                type: "button",
                class: "fe-sidenav__item",
                title: u(i)("sidenav.appstore"),
                "aria-label": u(i)("sidenav.appstore"),
                "data-testid": "sidenav-app-store",
                onClick: ie[6] || (ie[6] = (xe) => a("open-app-store"))
              }, [
                ie[37] || (ie[37] = d("svg", {
                  class: "fe-ficon",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true",
                  focusable: "false"
                }, [
                  d("path", { d: "M3 9l1.5-5h15L21 9" }),
                  d("path", { d: "M3 9a3 3 0 0 0 6 0a3 3 0 0 0 6 0a3 3 0 0 0 6 0" }),
                  d("path", { d: "M5 11.5V20h14v-8.5" }),
                  d("path", { d: "M10 20v-5h4v5" })
                ], -1)),
                c.value ? (f(), h("span", tq, y(u(i)("sidenav.appstore")), 1)) : O("", !0)
              ], 8, eq)
            ])) : O("", !0)
          ], 8, Gj)
        ])) : O("", !0),
        e.showConnections ? (f(), h("div", nq, [
          ie[40] || (ie[40] = d("hr", {
            class: "fe-sidenav__rule",
            "aria-hidden": "true"
          }, null, -1)),
          d("ul", {
            class: "fe-sidenav__group",
            "aria-label": u(i)("sidenav.connections")
          }, [
            d("li", null, [
              d("button", {
                type: "button",
                class: "fe-sidenav__item",
                title: u(i)("sidenav.connect"),
                "aria-label": u(i)("sidenav.connect"),
                "data-testid": "sidenav-connect",
                onClick: ie[7] || (ie[7] = (xe) => a("open-connections"))
              }, [
                ie[38] || (ie[38] = d("svg", {
                  class: "fe-ficon",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true",
                  focusable: "false"
                }, [
                  d("path", { d: "M9.5 14.5l-2.6 2.6a3.7 3.7 0 0 1-5.2-5.2l2.6-2.6" }),
                  d("path", { d: "M14.5 9.5l2.6-2.6a3.7 3.7 0 0 1 5.2 5.2l-2.6 2.6" }),
                  d("path", { d: "M9 15l6-6" })
                ], -1)),
                c.value ? (f(), h("span", oq, y(u(i)("sidenav.connect")), 1)) : O("", !0)
              ], 8, iq)
            ]),
            e.showIdentitySurfaces !== !1 ? (f(), h("li", rq, [
              d("button", {
                type: "button",
                class: "fe-sidenav__item",
                title: u(i)("sidenav.apikeys"),
                "aria-label": u(i)("sidenav.apikeys"),
                "data-testid": "sidenav-apikeys",
                onClick: ie[8] || (ie[8] = (xe) => a("open-tokens"))
              }, [
                ie[39] || (ie[39] = d("svg", {
                  class: "fe-ficon",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true",
                  focusable: "false"
                }, [
                  d("circle", {
                    cx: "8",
                    cy: "12",
                    r: "3.5"
                  }),
                  d("path", { d: "M11.5 12H21" }),
                  d("path", { d: "M17.5 12v3.2M20 12v2.2" })
                ], -1)),
                c.value ? (f(), h("span", lq, y(u(i)("sidenav.apikeys")), 1)) : O("", !0)
              ], 8, sq)
            ])) : O("", !0)
          ], 8, aq)
        ])) : O("", !0)
      ]),
      e.quota ? (f(), h("div", uq, [
        c.value ? (f(), h("p", cq, y(u(i)("drive.storage.label")), 1)) : O("", !0),
        d("div", {
          class: "fe-sidenav__quota-bar",
          role: "progressbar",
          "aria-valuenow": j.value,
          "aria-valuemin": "0",
          "aria-valuemax": "100",
          "aria-label": re.value,
          title: re.value
        }, [
          d("span", {
            class: "fe-sidenav__quota-fill",
            style: Yt({ width: j.value + "%" })
          }, null, 4)
        ], 8, dq),
        c.value ? (f(), h("p", fq, y(re.value), 1)) : O("", !0)
      ])) : O("", !0),
      Ze(_l, {
        ref_key: "newMenuRef",
        ref: P,
        locale: e.locale,
        theme: e.theme,
        actions: K.value,
        onSelect: J
      }, null, 8, ["locale", "theme", "actions"]),
      Ze(_l, {
        ref_key: "storageMenuRef",
        ref: fe,
        locale: e.locale,
        theme: e.theme,
        sheet: ee.value,
        actions: B.value,
        onSelect: Fe
      }, null, 8, ["locale", "theme", "sheet", "actions"])
    ], 10, rj));
  }
}), hq = 200;
function s0(e) {
  if (!e || typeof e != "object") return !1;
  const t = e, n = t.e2e_name_state;
  return n === "enc" || n === "locked" || n === "unreadable" ? !0 : typeof t.vault_root == "string" && t.vault_root !== "";
}
function ic(e, t, n, a) {
  const i = S(null), r = S(!1), l = S(!1);
  let c = null, p = null;
  function m() {
    c && clearTimeout(c), c = null, p == null || p.abort(), p = null;
  }
  async function v(x, w) {
    const $ = a();
    if (!$) {
      r.value = !0;
      return;
    }
    const k = new AbortController();
    p = k, l.value = !0;
    try {
      const b = await $(x, w, k.signal);
      if (k.signal.aborted) return;
      i.value = { q: x, names: new Set(b.map((C) => w[C]).filter((C) => typeof C == "string")) }, r.value = !1;
    } catch (b) {
      if ((b == null ? void 0 : b.name) === "AbortError" || k.signal.aborted) return;
      r.value = !0;
    } finally {
      p === k && (p = null, l.value = !1);
    }
  }
  return Je(
    () => {
      const x = e().trim();
      if (!x) return "";
      const w = /* @__PURE__ */ new Set();
      for (const $ of t())
        s0($) || w.add(n($) || "");
      return JSON.stringify([x, [...w].sort()]);
    },
    (x) => {
      if (m(), !x) {
        i.value = null, l.value = !1;
        return;
      }
      const [w, $] = JSON.parse(x);
      if ($.length === 0) {
        i.value = { q: w, names: /* @__PURE__ */ new Set() };
        return;
      }
      l.value = !0, c = setTimeout(() => {
        c = null, v(w, $);
      }, hq);
    },
    { immediate: !0 }
  ), l2() && Ey(m), {
    pending: l,
    apply(x) {
      const w = e().trim();
      if (!w) return x;
      const $ = i.value;
      return x.filter((k) => {
        const b = n(k) || "";
        return s0(k) || r.value || !a() ? VS(b, w) : !$ || $.q !== w ? !0 : $.names.has(b);
      });
    }
  };
}
const hT = "application/x-brf-files", mq = "application/x-brf-files-src";
let rl = null;
const vq = 5 * 6e4;
function yq(e, t) {
  rl = { items: e.slice(), origin: t, startedAt: Date.now() };
}
function zr() {
  rl = null;
}
function Tc() {
  return rl ? Date.now() - rl.startedAt > vq ? (rl = null, null) : rl : null;
}
function ti(e) {
  var t;
  return (t = e.dataTransfer) != null && t.types.includes(hT) ? !0 : Tc() !== null;
}
function Nf(e) {
  var a;
  const t = (a = e.dataTransfer) == null ? void 0 : a.getData(hT);
  if (t)
    try {
      const i = JSON.parse(t);
      return Array.isArray(i) && i.length > 0 ? i : null;
    } catch {
      return null;
    }
  const n = Tc();
  return n && n.items.length > 0 ? n.items : null;
}
function gy(e) {
  var n, a;
  const t = (n = e.dataTransfer) == null ? void 0 : n.getData(mq);
  return t || ((a = Tc()) == null ? void 0 : a.origin) || void 0;
}
function lv(e) {
  const t = gq(e);
  return t === void 0 || t === "none" || t === "csrf";
}
function gq(e) {
  if (!e || typeof e != "object") return;
  const t = e;
  return typeof t.kind == "string" ? t.kind : typeof t.type == "string" ? t.type : void 0;
}
function bq(e, t, n) {
  if (e.type !== "file") return null;
  let a = t;
  try {
    a = new URL(t, typeof location < "u" ? location.href : void 0).toString();
  } catch {
    return null;
  }
  if (!/^https?:/i.test(a)) return null;
  const i = e.basename.replace(/[:\r\n]/g, "_");
  return `${n && n.trim() ? n : "application/octet-stream"}:${i}:${a}`;
}
function kq(e) {
  return e.map((t) => t.path).sort().join("\0");
}
function wq(e, t = {}) {
  const n = t.now ?? (() => Date.now()), a = t.refreshBelowMs ?? 3e4, i = t.usableAboveMs ?? 5e3, r = t.failPauseMs ?? 3e4, l = t.max ?? 32, c = /* @__PURE__ */ new Map(), p = /* @__PURE__ */ new Map();
  let m = null, v = null, x = !0;
  function w(C) {
    const T = c.get(C);
    return T ? T.expiresAt - n() : -1 / 0;
  }
  function $(C) {
    m = C;
    let T;
    try {
      T = e(C);
    } catch (E) {
      T = Promise.reject(E);
    }
    T.then((E) => {
      var R;
      if (E === null) {
        x && (x = !1, c.clear(), (R = t.onUnsupported) == null || R.call(t));
        return;
      }
      for (c.delete(C), c.set(C, { url: E.url, expiresAt: n() + E.ttlMs }); c.size > l; ) {
        const z = c.keys().next().value;
        if (z === void 0) break;
        c.delete(z);
      }
    }).catch(() => {
      p.set(C, n() + r);
    }).finally(() => {
      m = null;
      const E = v;
      v = null, E && k(E);
    });
  }
  function k(C) {
    if (!x || !C || w(C) > a) return;
    const T = p.get(C);
    if (T !== void 0) {
      if (T > n()) return;
      p.delete(C);
    }
    if (m !== C) {
      if (m !== null) {
        v = C;
        return;
      }
      $(C);
    }
  }
  function b(C) {
    const T = c.get(C);
    return T ? (c.delete(C), T.expiresAt - n() > i ? T.url : null) : null;
  }
  return {
    warm: k,
    take: b,
    get supported() {
      return x;
    }
  };
}
function kp(e) {
  return !!e && e.basename !== ".trash" && !Wy(e) && !(typeof e.vault_root == "string" && e.vault_root !== "");
}
function If(e) {
  return { path: e.path, basename: e.basename, type: e.type };
}
function l0(e, t = {}) {
  return t.inEncryptedFolder || e.length === 0 || !e.every((n) => kp(n)) ? null : e.map(If);
}
function u0(e) {
  return !!e && e.type === "file" && kp(e);
}
function _q(e, t) {
  const { t: n } = t, a = !!e.dropped;
  return e.error === "drop_not_found" ? { kind: "flash", message: n("dragout.not_found") } : e.error === "cancelled" ? { kind: "flash", message: n("dragout.stopped") } : e.error ? a || !t.quiet ? { kind: "flash", message: e.error } : null : a ? e.finished ? { kind: "flash", message: n("dragout.done") } : {
    kind: "hold",
    message: e.files ? n("dragout.downloading_n", { n: e.files }) : n("dragout.downloading"),
    stoppable: t.stoppable
  } : t.quiet ? null : !e.finished && e.done === 0 ? { kind: "flash", message: n("dragout.preparing") } : null;
}
const xq = ["corrupt", "encrypted", "too_large"], Sq = {
  corrupt: [
    "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
    "M14 2v4a2 2 0 0 0 2 2h4",
    "m14.5 12.5-5 5",
    "m9.5 12.5 5 5"
  ],
  encrypted: ["M5 11h14a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2Z", "M7 11V7a5 5 0 0 1 10 0v4"],
  too_large: ["M15 3h6v6", "M9 21H3v-6", "M21 3l-7 7", "M3 21l7-7"]
}, c0 = /* @__PURE__ */ new Map();
function $q(e) {
  if (!e || e.type !== "file" || e.thumb_url) return null;
  const t = e.thumb_note;
  return t && xq.includes(t) ? t : null;
}
function Ug(e, t) {
  const n = $q(e);
  if (!n) return null;
  let a, i;
  switch (n) {
    case "corrupt":
      a = t.t("thumbNote.corrupt"), i = t.t("thumbNote.corrupt_why");
      break;
    case "encrypted":
      a = t.t("thumbNote.encrypted"), i = t.t("thumbNote.encrypted_why");
      break;
    default:
      a = t.t("thumbNote.too_large"), i = t.t("thumbNote.too_large_why");
  }
  const r = t.t("thumbNote.full", { label: a, why: i }), l = `${n}|${r}`;
  let c = c0.get(l);
  return c || (c = { note: n, label: a, why: i, full: r, paths: Sq[n] }, c0.set(l, c)), c;
}
const Gs = 8 * 1024, Tq = 4 * 1024 * 1024, Aq = 3, Eq = 24, d0 = 120, Cq = 16, zq = 8, Mq = 400, Pq = /* @__PURE__ */ new Set(["csv", "tsv"]);
function Oq(e) {
  if (e.trashed) return !0;
  const t = e.extra_metadata;
  return !!t && typeof t == "object" && "deleted_at" in t;
}
function wp(e) {
  if (e.type !== "file" || e.basename === ".trash" || e.mime_type === "inode/storage" || Oq(e)) return null;
  const t = e.size ?? 0;
  if (t <= 0 || t > Tq) return null;
  const n = (e.extension || "").trim().toLowerCase();
  if (Pq.has(n)) return "table";
  const a = xi(e);
  return a === "code" ? "code" : a === "text" ? "text" : null;
}
function Hg(e) {
  if (e.type !== "file") return !1;
  switch (xi(e)) {
    case "pdf":
    case "doc":
    case "sheet":
    case "slides":
      return !0;
    default:
      return !1;
  }
}
function mT(e) {
  return e.type === "file" && xi(e) === "video";
}
const Lq = /* @__PURE__ */ new Set([
  "pdf",
  "doc",
  "sheet",
  "slides",
  "text",
  "archive"
]);
function Dq(e) {
  return e.type === "file" && Lq.has(xi(e));
}
const Rq = /* @__PURE__ */ new Set(["image", "video"]), f0 = /* @__PURE__ */ new Map();
function vT(e) {
  if (e.type !== "file") return null;
  const t = xi(e);
  if (Rq.has(t)) return null;
  const n = vx(e);
  if (!n) return null;
  const a = `${t}:${n}`;
  let i = f0.get(a);
  return i || (i = { family: t, label: n }, f0.set(a, i)), i;
}
const Nq = /* @__PURE__ */ new Set([
  "import",
  "export",
  "from",
  "require",
  "include",
  "use",
  "using",
  "package",
  "module",
  "namespace",
  "const",
  "let",
  "var",
  "function",
  "func",
  "fn",
  "def",
  "class",
  "struct",
  "enum",
  "interface",
  "type",
  "impl",
  "trait",
  "public",
  "private",
  "protected",
  "static",
  "async",
  "await",
  "return",
  "if",
  "else",
  "for",
  "while",
  "switch",
  "case",
  "try",
  "catch",
  "select",
  "insert",
  "update",
  "delete",
  "create",
  "alter",
  "drop"
]), Iq = /^(#{1,6}|[-*+]|>|\d+\.)$/;
function Bq(e) {
  return e.replace(/[(){}[\];:,.]+$/, "").toLowerCase();
}
function Fq(e, t) {
  const n = e.length > d0 ? e.slice(0, d0) : e, a = /^(\s*)(\S+)([\s\S]*)$/.exec(n);
  if (!a) return { indent: "", tint: "", text: n };
  const [, i, r, l] = a;
  return (t === "code" ? Nq.has(Bq(r)) : Iq.test(r)) ? { indent: i, tint: r, text: l } : { indent: "", tint: "", text: n };
}
function Uq(e, t) {
  const n = [];
  let a = "", i = !1;
  for (let r = 0; r < e.length; r++) {
    const l = e[r];
    i ? l === '"' ? e[r + 1] === '"' ? (a += '"', r++) : i = !1 : a += l : l === '"' ? i = !0 : l === t ? (n.push(a), a = "") : a += l;
  }
  return n.push(a), n;
}
function Hq(e, t) {
  return e === "tsv" ? "	" : !t.includes(",") && t.includes(";") ? ";" : ",";
}
function Kq(e, t, n, a) {
  for (let c = 0; c < e.length; c++)
    if (e[c] === 0) return null;
  const i = new TextDecoder("utf-8", { fatal: !1 }).decode(e);
  let r = 0;
  for (const c of i) c === "�" && r++;
  if (i.length > 0 && r / i.length > 0.1) return null;
  const l = i.split(/\r\n|\r|\n/);
  for (a && l.length > 1 && l.pop(); l.length && l[0].trim() === ""; ) l.shift();
  for (; l.length && l[l.length - 1].trim() === ""; ) l.pop();
  if (l.length === 0) return null;
  if (t === "table") {
    const c = Hq(n, l[0]), p = l.filter((v) => v.trim() !== "").slice(0, Cq).map((v) => Uq(v, c).slice(0, zq).map((x) => x.trim().slice(0, 24)));
    if (p.length === 0) return null;
    const m = p.reduce((v, x) => Math.max(v, x.length), 0);
    for (const v of p) for (; v.length < m; ) v.push("");
    return { kind: t, lines: [], rows: p, cols: m };
  }
  return {
    kind: t,
    lines: l.slice(0, Eq).map((c) => Fq(c, t)),
    rows: [],
    cols: 0
  };
}
const Vq = "\0";
function Hu(e) {
  const n = (typeof e.etag == "string" ? e.etag : "") || String(e.last_modified ?? "") || String(e.size ?? "");
  return `${e.path}${Vq}${n}`;
}
function yT(e) {
  const t = e.apiBase !== void 0 && typeof e.authHeaders == "function" && typeof IntersectionObserver < "u" && typeof fetch == "function", n = S({}), a = [], i = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), l = [], c = /* @__PURE__ */ new Set(), p = /* @__PURE__ */ new WeakMap();
  let m = 0, v = null;
  const x = /* @__PURE__ */ new Map();
  function w(z) {
    const D = Q2({ apiBase: e.apiBase }).manager, U = D.includes("?") ? "&" : "?", H = new URLSearchParams({ q: "preview", action: "preview", path: z });
    return `${D}${U}${H.toString()}`;
  }
  function $(z, D) {
    if (a.length >= Mq) {
      const U = a.shift();
      if (U) {
        const H = { ...n.value };
        delete H[U], n.value = H;
      }
    }
    a.push(z), n.value = { ...n.value, [z]: D };
  }
  async function k(z) {
    const D = z.body;
    if (!D) {
      const N = new Uint8Array(await z.arrayBuffer());
      return { bytes: N.slice(0, Gs), truncated: N.length > Gs };
    }
    const U = D.getReader(), H = [];
    let L = 0;
    try {
      for (; L < Gs; ) {
        const { done: N, value: J } = await U.read();
        if (N) break;
        J && J.length && (H.push(J), L += J.length);
      }
    } finally {
      try {
        await U.cancel();
      } catch {
      }
    }
    const P = new Uint8Array(Math.min(L, Gs));
    let K = 0;
    for (const N of H) {
      if (K >= P.length) break;
      P.set(N.subarray(0, P.length - K), K), K += N.length;
    }
    return { bytes: P, truncated: L >= Gs };
  }
  async function b(z, D) {
    const U = Hu(z), H = new AbortController();
    c.add(H);
    try {
      const L = e.authHeaders ? await e.authHeaders() : {}, P = await fetch(w(z.path), {
        headers: { ...L, Accept: "*/*", Range: `bytes=0-${Gs - 1}` },
        credentials: e.credentials,
        signal: H.signal
      });
      if (!P.ok && P.status !== 206) throw new Error(String(P.status));
      const { bytes: K, truncated: N } = await k(P);
      H.abort();
      const J = (z.extension || "").trim().toLowerCase(), j = Kq(K, D, J, N);
      if (!j) {
        i.add(U);
        return;
      }
      $(U, j);
    } catch {
      i.add(U);
    } finally {
      c.delete(H);
    }
  }
  function C() {
    for (; m < Aq && l.length > 0; ) {
      const z = l.shift(), D = wp(z);
      r.delete(Hu(z)), D && (m++, b(z, D).finally(() => {
        m--, C();
      }));
    }
  }
  function T(z) {
    const D = Hu(z);
    n.value[D] || i.has(D) || r.has(D) || (r.add(D), l.push(z), C());
  }
  function E() {
    return t ? (v || (v = new IntersectionObserver(
      (z) => {
        for (const D of z) {
          if (!D.isIntersecting) continue;
          const U = x.get(D.target);
          v == null || v.unobserve(D.target), x.delete(D.target), U && T(U);
        }
      },
      { rootMargin: "150px" }
    )), v) : null;
  }
  function R(z) {
    var D;
    return !t || (D = e.disabled) != null && D.call(e) ? null : wp(z);
  }
  return {
    enabled: t,
    kindFor: R,
    get(z) {
      return t ? n.value[Hu(z)] ?? null : null;
    },
    bind(z, D) {
      if (!z || !R(D)) return;
      const U = Hu(D);
      if (p.get(z) === U || (p.set(z, U), n.value[U] || i.has(U))) return;
      const H = E();
      H && (x.set(z, D), H.observe(z));
    },
    stats: () => ({
      loaded: a.length,
      inflight: m,
      queued: l.length,
      failed: i.size
    }),
    dispose() {
      v == null || v.disconnect(), v = null, x.clear();
      for (const z of c) z.abort();
      c.clear(), l.length = 0, r.clear();
    }
  };
}
function jq(e, t) {
  if (!e) return { id: "none", label: t.t("group.no_date") };
  const n = /* @__PURE__ */ new Date(), a = o_(n), i = o_(e);
  if (i >= a) return { id: "today", label: t.t("group.today") };
  if (i === a - 1) return { id: "yesterday", label: t.t("group.yesterday") };
  if (i > a - 7) return { id: "week", label: t.t("group.this_week") };
  const r = t.zonedYearMonth(e);
  return r === t.zonedYearMonth(n) ? { id: "month", label: t.t("group.this_month") } : { id: `m-${r}`, label: t.formatMonthYear(e) };
}
function Kg(e, t) {
  return t !== "relevance" && e === "modified";
}
function Vg(e, t) {
  var i;
  const n = [];
  if (!t.active)
    n.push({ id: "all", label: null, items: [...e] });
  else {
    let r = null;
    for (const l of e) {
      const c = ((i = t.aside) == null ? void 0 : i.call(t, l)) ?? null, p = c ? { id: c.id, label: c.label ?? null } : jq(t.dateOf(l), t.labels);
      (!r || r.id !== p.id) && (r = { id: p.id, label: p.label, items: [] }, n.push(r)), r.items.push(l);
    }
  }
  const a = /* @__PURE__ */ new Map();
  for (const r of n)
    r.label && r.items.length && a.set(r.items[0], r.label);
  return {
    active: t.active,
    runs: n,
    headingBefore: (r) => a.get(r) ?? null
  };
}
async function gT(e, t, n = {}) {
  const a = {
    "Content-Type": "application/json",
    ...await (n.authHeaders ?? (() => ({})))()
  }, i = n.apiBase ?? "", r = await fetch(`${i}/api/files/manager/star`, {
    method: "POST",
    headers: a,
    credentials: n.authCredentials ?? "same-origin",
    body: JSON.stringify({ node_id: e, starred: t })
  });
  if (!r.ok) throw fa(r.status, await r.text().catch(() => ""), n.locale);
}
const qq = ["aria-pressed", "title", "aria-label"], Wq = {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  "aria-hidden": "true"
}, Yq = ["fill"], Gq = {
  key: 0,
  class: "filex-star-label"
}, jg = /* @__PURE__ */ lt({
  __name: "StarButton",
  props: {
    starred: { type: Boolean },
    nodeId: {},
    apiBase: {},
    authHeaders: { type: Function },
    authCredentials: {},
    compact: { type: Boolean },
    card: { type: Boolean },
    locale: {}
  },
  emits: ["change", "error"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = S(n.starred);
    Je(() => n.starred, (p) => {
      i.value = p;
    });
    const { t: r } = ht(() => Wi(n.locale)), l = A(() => r(i.value ? "ctx.unstar" : "ctx.star"));
    async function c() {
      const p = !i.value;
      i.value = p;
      try {
        await gT(n.nodeId, p, {
          apiBase: n.apiBase,
          authHeaders: n.authHeaders,
          authCredentials: n.authCredentials,
          locale: Wi(n.locale)
        }), a("change", p);
      } catch (m) {
        i.value = !p, a("error", m instanceof Error ? m.message : String(m));
      }
    }
    return (p, m) => (f(), h("button", {
      type: "button",
      class: Re(["filex-star-btn", { "is-starred": i.value, "is-compact": e.compact, "is-card": e.card }]),
      "aria-pressed": i.value,
      title: l.value,
      "aria-label": l.value,
      "data-testid": "star-toggle",
      onClick: yt(c, ["stop"])
    }, [
      (f(), h("svg", Wq, [
        d("path", {
          fill: i.value ? "currentColor" : "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linejoin": "round",
          d: "M12 2.5l3.09 6.26 6.91 1-5 4.87 1.18 6.87L12 18.27l-6.18 3.23L7 14.63 2 9.76l6.91-1z"
        }, null, 8, Yq)
      ])),
      e.compact ? O("", !0) : (f(), h("span", Gq, y(l.value), 1))
    ], 10, qq));
  }
}), p0 = "300px";
let ho = null;
const sl = /* @__PURE__ */ new Map();
function Xq() {
  return ho || (ho = new IntersectionObserver(
    (e) => {
      for (const t of e) {
        if (!t.isIntersecting) continue;
        const n = sl.get(t.target);
        n && (sl.delete(t.target), ho == null || ho.unobserve(t.target), n.forEach((a) => a()));
      }
    },
    // `rootMargin` widens the viewport only: a tile in the pane's own scroll
    // box is still cut off at that box's edge. `scrollMargin` widens the
    // scroll boxes too (Chromium 120+; an engine that does not know it
    // ignores it, and the picture is asked for as the tile scrolls in).
    { rootMargin: p0, scrollMargin: p0 }
  )), ho;
}
function Jq(e, t) {
  if (!e || typeof IntersectionObserver > "u")
    return t(), () => {
    };
  let n = sl.get(e);
  return n || (n = /* @__PURE__ */ new Set(), sl.set(e, n), Xq().observe(e)), n.add(t), () => {
    const a = sl.get(e);
    a && (a.delete(t), a.size === 0 && (sl.delete(e), ho == null || ho.unobserve(e)));
  };
}
const Zq = ["src"], Qq = {
  key: 2,
  class: "fe-thumb__play",
  "aria-hidden": "true"
}, eW = ["aria-label", "data-note"], tW = {
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  focusable: "false"
}, nW = ["d"], aW = ["dir"], Qc = /* @__PURE__ */ lt({
  inheritAttrs: !1,
  __name: "ThumbTile",
  props: {
    node: {},
    srcOf: { type: Function },
    videoBadge: { type: Boolean },
    typeBadge: {},
    note: {}
  },
  setup(e) {
    const t = e, n = S(!1);
    let a = null;
    jt(() => {
      var R;
      const E = (R = Zo()) == null ? void 0 : R.subTree.el;
      a = Jq(E == null ? void 0 : E.parentElement, () => {
        n.value = !0;
      });
    }), Tt(() => {
      a == null || a(), w();
    });
    const i = A(() => n.value ? t.srcOf(t.node) : null), r = S(null), l = S(null), c = S(!1), p = S("ltr");
    function m() {
      const E = l.value, R = r.value;
      if (!E || !R) return;
      const z = R.getBoundingClientRect(), D = window.innerWidth, U = window.innerHeight, H = E.offsetWidth, L = E.offsetHeight, P = p.value, K = Oc(P === "rtl" ? z.right : z.left, H, D, P);
      let N = z.bottom + 6;
      N + L > U - 8 && (N = Math.max(8, z.top - L - 6)), E.style.insetInlineStart = `${Math.round(P === "rtl" ? D - K - H : K)}px`, E.style.top = `${Math.round(N)}px`, E.style.zIndex = String(Rc(R));
    }
    function v(E) {
      r.value && E.target instanceof Node && r.value.contains(E.target) || w();
    }
    function x() {
      c.value || !r.value || (p.value = ei(r.value), c.value = !0, document.addEventListener("pointerdown", v, !0), window.addEventListener("scroll", w, !0), Gt(m));
    }
    function w() {
      c.value && (c.value = !1, document.removeEventListener("pointerdown", v, !0), window.removeEventListener("scroll", w, !0));
    }
    function $(E) {
      E.pointerType === "mouse" && x();
    }
    function k(E) {
      E.pointerType === "mouse" && w();
    }
    let b = "";
    function C(E) {
      b = E.pointerType;
    }
    function T() {
      if (b === "mouse") {
        x();
        return;
      }
      c.value ? w() : x();
    }
    return (E, R) => (f(), h(Te, null, [
      i.value ? (f(), h("img", wv({ key: 0 }, E.$attrs, {
        src: i.value,
        draggable: "false"
      }), null, 16, Zq)) : On(E.$slots, "default", { key: 1 }),
      i.value && e.videoBadge ? (f(), h("span", Qq)) : O("", !0),
      i.value && e.typeBadge ? (f(), h("span", {
        key: 3,
        class: Re(["fe-thumb__type", `fe-ftile--${e.typeBadge.family}`, { "fe-thumb__type--long": e.typeBadge.label.length > 4 }]),
        "aria-hidden": "true"
      }, y(e.typeBadge.label), 3)) : O("", !0),
      !i.value && e.note ? (f(), h("span", {
        key: 4,
        ref_key: "mark",
        ref: r,
        class: Re(["fe-thumb__note", `fe-thumb__note--${e.note.note}`]),
        role: "img",
        "aria-label": e.note.full,
        "data-note": e.note.note,
        "data-testid": "thumb-note",
        onPointerenter: $,
        onPointerleave: k,
        onPointerdown: C,
        onClick: yt(T, ["stop"]),
        onDblclick: R[0] || (R[0] = yt(() => {
        }, ["stop"]))
      }, [
        (f(), h("svg", tW, [
          (f(!0), h(Te, null, nt(e.note.paths, (z, D) => (f(), h("path", {
            key: D,
            d: z
          }, null, 8, nW))), 128))
        ]))
      ], 42, eW)) : O("", !0),
      (f(), Ge(wi, { to: "body" }, [
        c.value && e.note ? (f(), h("span", {
          key: 0,
          ref_key: "tip",
          ref: l,
          class: "fe-thumb__note-tip",
          dir: p.value,
          role: "tooltip",
          "data-testid": "thumb-note-tip"
        }, y(e.note.full), 9, aW)) : O("", !0)
      ]))
    ], 64));
  }
}), iW = ["innerHTML"], oW = {
  key: 1,
  class: "fe-fmosaic__stage"
}, rW = ["innerHTML"], qg = /* @__PURE__ */ lt({
  __name: "FolderMosaic",
  props: {
    node: {},
    srcOf: {},
    shape: { default: "peek" }
  },
  setup(e) {
    const t = e, n = A(() => t.shape === "mini" ? 1 : 3), a = A(
      () => (t.node.preview ?? []).slice(0, n.value).map((r) => {
        const l = r.name.lastIndexOf(".");
        return {
          path: `${t.node.path.replace(/\/+$/, "")}/${r.name}`,
          basename: r.name,
          type: "file",
          extension: l > 0 ? r.name.slice(l + 1).toLowerCase() : void 0,
          thumb_url: r.thumb_url
        };
      })
    ), i = A(() => {
      const [r, l, c] = a.value;
      return c ? [{ it: c, at: 1 }, { it: l, at: 3 }, { it: r, at: 2 }] : l ? [{ it: l, at: 1 }, { it: r, at: 2 }] : r ? [{ it: r, at: 1 }] : [];
    });
    return (r, l) => (f(), h("div", {
      class: Re(["fe-fmosaic", [`fe-fmosaic--${e.shape}`, `fe-fmosaic--${a.value.length}`]]),
      "aria-hidden": "true",
      "data-fe-mosaic": ""
    }, [
      u(Vr)(e.node) ? (f(), h("span", {
        key: 0,
        class: "fe-fmosaic__glyph fe-grid__icon fe-grid__icon--svg",
        innerHTML: u(xl)()
      }, null, 8, iW)) : (f(), h("div", oW, [
        l[0] || (l[0] = d("svg", {
          class: "fe-fmosaic__back",
          viewBox: "0 0 120 88",
          preserveAspectRatio: "none",
          focusable: "false"
        }, [
          d("path", { d: "M0 10a6 6 0 0 1 6-6h27.5a6 6 0 0 1 4.4 1.9L43.6 12H114a6 6 0 0 1 6 6v64a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z" })
        ], -1)),
        (f(!0), h(Te, null, nt(i.value, (c) => (f(), h("div", {
          key: c.it.path,
          class: Re(["fe-fmosaic__print", [`fe-fmosaic__print--${c.at}`, { "is-icon": !c.it.thumb_url }]])
        }, [
          Ze(Qc, {
            node: c.it,
            "src-of": e.srcOf,
            alt: "",
            class: "fe-fmosaic__img"
          }, {
            default: mt(() => [
              d("span", {
                class: "fe-fmosaic__icon fe-grid__icon--svg",
                innerHTML: u(wa)(c.it)
              }, null, 8, rW)
            ]),
            _: 2
          }, 1032, ["node", "src-of"])
        ], 2))), 128)),
        l[1] || (l[1] = d("svg", {
          class: "fe-fmosaic__front",
          viewBox: "0 0 120 56",
          preserveAspectRatio: "none",
          focusable: "false"
        }, [
          d("path", { d: "M5 0h110a5 5 0 0 1 5 5.4l-3.3 44.6a6 6 0 0 1-6 5.6H9.3a6 6 0 0 1-6-5.6L0 5.4A5 5 0 0 1 5 0z" })
        ], -1))
      ]))
    ], 2));
  }
});
function by(e) {
  const t = [];
  if (!e) return t;
  const n = /«([^«»]*)»/g;
  let a = 0, i;
  for (; (i = n.exec(e)) !== null; )
    i.index > a && t.push({ text: e.slice(a, i.index), match: !1 }), i[1] && t.push({ text: i[1], match: !0 }), a = i.index + i[0].length;
  return a < e.length && t.push({ text: e.slice(a), match: !1 }), t;
}
function sW(e) {
  return e === "content" || e === "both";
}
function Wg(e, t, n) {
  const a = e.dataTransfer;
  if (!(!a || typeof document > "u" || typeof a.setDragImage != "function"))
    try {
      const i = document.createElement("div");
      i.className = "fe-dragghost";
      const r = document.createElement("span");
      if (r.className = "fe-dragghost__name", r.dir = "auto", r.textContent = t, i.appendChild(r), n > 1) {
        const l = document.createElement("span");
        l.className = "fe-dragghost__badge", l.textContent = String(n), i.appendChild(l);
      }
      i.style.position = "fixed", i.style.top = "-1000px", i.style.left = "-1000px", document.body.appendChild(i), a.setDragImage(i, 14, 14), setTimeout(() => i.remove(), 0);
    } catch {
    }
}
const lW = { class: "fe-gridbox" }, uW = {
  key: 0,
  class: "fe-grid__refreshing",
  role: "status"
}, cW = { class: "fe-sr-only" }, dW = ["aria-label", "aria-busy"], fW = {
  key: 0,
  class: "fe-grid__heading",
  "aria-hidden": "true"
}, pW = ["aria-selected", "aria-label", "data-fe-path", "onClick", "onDblclick", "onContextmenu", "onDragstart", "onDragover", "onDragleave", "onDrop", "onTouchstartPassive", "onPointerenter", "onPointerleave"], hW = ["dir"], mW = {
  key: 0,
  class: "fe-fprev__tint"
}, vW = ["innerHTML"], yW = ["aria-label", "innerHTML"], gW = ["innerHTML"], bW = {
  key: 1,
  class: "fe-grid__thumb fe-grid__thumb--folder"
}, kW = { class: "fe-grid__foot" }, wW = ["aria-label", "innerHTML"], _W = ["innerHTML"], xW = ["onClick"], SW = { class: "fe-grid__main" }, $W = ["title"], TW = ["title", "aria-label"], AW = ["title"], EW = ["title", "aria-label"], CW = ["title", "aria-label", "data-link-state"], zW = ["title", "aria-label"], MW = ["title"], PW = ["title"], OW = {
  key: 0,
  class: "fe-grid__mark"
}, LW = ["aria-label", "title", "onClick"], DW = {
  key: 0,
  class: "fe-grid__empty"
}, ky = /* @__PURE__ */ lt({
  __name: "GridView",
  props: {
    files: {},
    selected: {},
    clipped: {},
    showParentPath: { type: Boolean },
    locale: {},
    loading: { type: Boolean },
    thumbSrc: {},
    keepBadgeFor: {},
    starredIds: {},
    starEnabled: { type: Boolean },
    apiBase: {},
    authHeaders: {},
    authCredentials: {},
    sections: { type: Boolean },
    order: {},
    e2eActive: { type: Boolean },
    selectable: { type: Boolean, default: !0 }
  },
  emits: ["click-card", "dbl-card", "context-card", "item-drag-start", "item-drop-into", "star-change", "display-order", "peek", "peek-end"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = A(() => n.files.some((Me) => {
      var Fe;
      return Me.type === "dir" && (((Fe = Me.preview) == null ? void 0 : Fe.length) ?? 0) > 0;
    }));
    function r(Me, Fe) {
      Me.type === "dir" && a("peek", Me, Fe.currentTarget, Fe.pointerType);
    }
    const { t: l, formatSize: c, nodeDisplayName: p, formatDate: m, formatMonthYear: v, zonedYearMonth: x, toDate: w } = ht(() => n.locale);
    function $(Me) {
      return Yr(qc(Me), { t: l, formatDate: m, locale: n.locale });
    }
    function k(Me) {
      return Wc(Me, { t: l });
    }
    function b(Me) {
      return Yc(Me, { t: l });
    }
    function C(Me) {
      return Ug(Me, { t: l });
    }
    const T = A(() => [...n.files].sort(up));
    Je(
      T,
      (Me) => a("display-order", Me),
      { immediate: !0 }
    );
    const E = A(() => {
      var Me;
      return ((Me = T.value.find((Fe) => Fe.type === "dir")) == null ? void 0 : Me.path) ?? null;
    }), R = A(() => {
      var Me;
      return ((Me = T.value.find((Fe) => Fe.type !== "dir")) == null ? void 0 : Me.path) ?? null;
    }), z = Vc(), D = A(
      () => Vg(T.value, {
        active: Kg(z.key.value, n.order),
        dateOf: (Me) => w(Me.last_modified),
        /* Folders keep their own run at the top — the same rule the list follows,
         * and the reason "folders before files" survives a date sort. Here the run
         * is the one that already had a name. */
        aside: (Me) => Me.type === "dir" ? { id: "dirs", label: n.sections ? l("drive.section.folders") : null } : null,
        labels: { t: l, formatMonthYear: v, zonedYearMonth: x }
      })
    );
    function U(Me) {
      return D.value.active ? D.value.headingBefore(Me) : n.sections ? Me.path === E.value ? l("drive.section.folders") : Me.path === R.value ? l("drive.section.files") : null : null;
    }
    function H(Me) {
      return n.thumbSrc ? n.thumbSrc(Me) : Me.thumb_url ?? null;
    }
    const L = yT({
      // Read once: the explorer's `config.apiBase` is fixed for the life of a
      // mounted panel, and `enabled` has to be answerable at construction.
      apiBase: n.apiBase,
      // Wrapped rather than passed, so a parent that re-creates its arrow on each
      // render is still called through the CURRENT prop. ⚠ The builder is async;
      // `createFilePreviews` awaits it (see the note there — a Promise spread into
      // a headers object sends no Authorization and 401s in silence).
      authHeaders: n.authHeaders ? () => n.authHeaders() : void 0,
      credentials: n.authCredentials,
      disabled: () => n.e2eActive === !0
    });
    Tt(() => L.dispose());
    function P(Me) {
      return L.kindFor(Me);
    }
    function K(Me) {
      const Fe = L.get(Me);
      return Fe ? [Fe] : [];
    }
    function N(Me, Fe) {
      L.bind(Me instanceof Element ? Me : null, Fe);
    }
    function J(Me) {
      return n.starEnabled === !1 ? !1 : n.apiBase !== void 0 && typeof Me.id == "number" && Me.type === "file";
    }
    function j(Me) {
      return n.selected.has(Me.path);
    }
    function re(Me, Fe) {
      a("click-card", Me, Bg(Fe));
    }
    function q(Me, Fe) {
      a("click-card", Me, Ig(Fe, B.isTap(Fe)));
    }
    function le(Me) {
      a("dbl-card", Me);
    }
    function ve(Me, Fe) {
      Fe.preventDefault(), Fe.stopPropagation(), a("context-card", Me, Fe);
    }
    function ce(Me, Fe) {
      ve(Me, Fe);
    }
    function se(Me, Fe) {
      Wg(
        Fe,
        p(Me),
        n.selected.has(Me.path) ? n.selected.size : 1
      ), a("item-drag-start", Me, Fe);
    }
    const fe = S(null);
    function _(Me, Fe) {
      Me.type === "dir" && ti(Fe) && (Fe.preventDefault(), Fe.stopPropagation(), Fe.dataTransfer && (Fe.dataTransfer.dropEffect = "move"), fe.value = Me.path);
    }
    function ee(Me) {
      fe.value === Me.path && (fe.value = null);
    }
    function Y(Me, Fe) {
      fe.value = null, Me.type === "dir" && ti(Fe) && (Fe.preventDefault(), Fe.stopPropagation(), a("item-drop-into", Me, Fe));
    }
    const B = Fg(
      (Me, Fe) => a("context-card", Me, { ...Fe, preventDefault: () => {
      }, stopPropagation: () => {
      } }),
      {
        // A finger lifted on the item, off its controls, opens at touchend — see useRowTouch.
        onTap: (Me) => a("click-card", Me, { ctrl: !1, shift: !1, touch: !0 })
      }
    );
    function W(Me) {
      return m(Me);
    }
    function F(Me) {
      if (Me.type === "dir") return l("node.folder");
      const Fe = W(Me.last_modified), We = c(Me.size);
      return Fe ? `${We} • ${Fe}` : We;
    }
    function V(Me) {
      return Me === "kept" ? "✓" : Me === "syncing" ? "⟳" : Me === "partial" ? "◐" : "☁";
    }
    function ke(Me) {
      const Fe = Me.snippet;
      return typeof Fe == "string" ? Fe : "";
    }
    function qe(Me) {
      return by(Me).map((Fe) => Fe.text).join("");
    }
    return (Me, Fe) => (f(), h("div", lW, [
      e.loading && T.value.length > 0 ? (f(), h("div", uW, [
        d("span", cW, y(u(l)("loading")), 1)
      ])) : O("", !0),
      d("div", {
        class: Re(["fe-grid", { "is-loading": e.loading, "has-selection": e.selectable && e.selected.size > 0, "has-folder-previews": i.value }]),
        role: "listbox",
        "aria-multiselectable": "true",
        "aria-label": u(l)("grid.aria"),
        "aria-busy": e.loading ? "true" : void 0
      }, [
        (f(!0), h(Te, null, nt(T.value, (We) => {
          var $t, St;
          return f(), h(Te, {
            key: We.path
          }, [
            U(We) ? (f(), h("p", fW, y(U(We)), 1)) : O("", !0),
            d("div", {
              class: Re(["fe-grid__card", {
                "fe-grid__card--folder": We.type === "dir",
                "fe-grid__card--file": We.type !== "dir",
                "is-selected": j(We),
                "is-dir": We.type === "dir",
                "is-trash": We.trashed,
                "is-clipped": ($t = e.clipped) == null ? void 0 : $t.has(We.path),
                "is-droptarget": fe.value === We.path
              }]),
              tabindex: "0",
              role: "option",
              "aria-selected": j(We) ? "true" : "false",
              "aria-label": u(p)(We),
              "data-fe-path": We.path,
              draggable: "true",
              onClick: (at) => q(We, at),
              onDblclick: (at) => le(We),
              onContextmenu: (at) => ve(We, at),
              onDragstart: (at) => se(We, at),
              onDragover: (at) => _(We, at),
              onDragleave: (at) => ee(We),
              onDrop: (at) => Y(We, at),
              onTouchstartPassive: (at) => u(B).onTouchStart(We, at),
              onTouchend: Fe[4] || (Fe[4] = //@ts-ignore
              (...at) => u(B).onTouchEnd && u(B).onTouchEnd(...at)),
              onTouchmovePassive: Fe[5] || (Fe[5] = //@ts-ignore
              (...at) => u(B).onTouchMove && u(B).onTouchMove(...at)),
              onPointerenter: (at) => r(We, at),
              onPointerleave: (at) => We.type === "dir" && a("peek-end"),
              onPointerdown: Fe[6] || (Fe[6] = (at) => a("peek-end"))
            }, [
              We.type !== "dir" ? (f(), h("div", {
                key: 0,
                class: "fe-grid__thumb",
                ref_for: !0,
                ref: (at) => N(at, We)
              }, [
                P(We) ? (f(), h(Te, { key: 0 }, [
                  (f(!0), h(Te, null, nt(K(We), (at) => (f(), h("div", {
                    key: "fprev",
                    class: Re(["fe-fprev", "fe-fprev--" + at.kind]),
                    dir: u(C2)(at.kind),
                    style: Yt(at.kind === "table" ? { "--fprev-cols": String(at.cols) } : void 0),
                    "aria-hidden": "true"
                  }, [
                    at.kind === "table" ? (f(!0), h(Te, { key: 0 }, nt(at.rows, (kt, pt) => (f(), h(Te, { key: pt }, [
                      (f(!0), h(Te, null, nt(kt, (Ne, ie) => (f(), h("span", {
                        key: ie,
                        class: Re(["fe-fprev__cell", { "is-head": pt === 0 }])
                      }, y(Ne), 3))), 128))
                    ], 64))), 128)) : (f(!0), h(Te, { key: 1 }, nt(at.lines, (kt, pt) => (f(), h("div", {
                      key: pt,
                      class: "fe-fprev__line"
                    }, [
                      kt.tint ? (f(), h("span", mW, y(kt.indent) + y(kt.tint), 1)) : O("", !0),
                      Ht(y(kt.text), 1)
                    ]))), 128))
                  ], 14, hW))), 128)),
                  K(We).length === 0 ? (f(), h("span", {
                    key: 0,
                    class: "fe-grid__icon fe-grid__icon--svg",
                    innerHTML: u(wa)(We)
                  }, null, 8, vW)) : O("", !0)
                ], 64)) : (f(), Ge(Qc, {
                  key: 1,
                  node: We,
                  "src-of": H,
                  "video-badge": u(mT)(We),
                  note: C(We),
                  alt: We.basename,
                  class: Re({
                    "fe-thumb--page": u(Hg)(We)
                    /* gorunum:v1-preview — crop a page from its TOP */
                  })
                }, {
                  default: mt(() => [
                    u(Vr)(We) ? (f(), h("span", {
                      key: 0,
                      class: "fe-grid__icon fe-grid__icon--svg",
                      role: "img",
                      "aria-label": u(l)("e2e.badge"),
                      innerHTML: u(xl)()
                    }, null, 8, yW)) : (f(), h("span", {
                      key: 1,
                      class: "fe-grid__icon fe-grid__icon--svg",
                      innerHTML: u(wa)(We)
                    }, null, 8, gW))
                  ]),
                  _: 2
                }, 1032, ["node", "video-badge", "note", "alt", "class"])),
                J(We) ? (f(), h("div", {
                  key: 2,
                  class: "fe-grid__star",
                  onClick: Fe[0] || (Fe[0] = yt(() => {
                  }, ["stop"])),
                  onDblclick: Fe[1] || (Fe[1] = yt(() => {
                  }, ["stop"]))
                }, [
                  Ze(jg, {
                    starred: !!((St = e.starredIds) != null && St.has(We.id)),
                    "node-id": We.id,
                    "api-base": e.apiBase,
                    "auth-headers": e.authHeaders,
                    "auth-credentials": e.authCredentials,
                    locale: e.locale,
                    compact: "",
                    card: "",
                    onChange: (at) => a("star-change", We, at)
                  }, null, 8, ["starred", "node-id", "api-base", "auth-headers", "auth-credentials", "locale", "onChange"])
                ], 32)) : O("", !0)
              ], 512)) : i.value ? (f(), h("div", bW, [
                Ze(qg, {
                  node: We,
                  "src-of": H
                }, null, 8, ["node"])
              ])) : O("", !0),
              d("div", kW, [
                d("span", {
                  class: Re(["fe-grid__lead", { "fe-grid__lead--pick": e.selectable }])
                }, [
                  u(Vr)(We) ? (f(), h("span", {
                    key: 0,
                    class: "fe-grid__tile fe-grid__tile--svg",
                    role: "img",
                    "aria-label": u(l)("e2e.badge"),
                    innerHTML: u(xl)()
                  }, null, 8, wW)) : (f(), h("span", {
                    key: 1,
                    class: "fe-grid__tile fe-grid__tile--svg",
                    innerHTML: u(wa)(We)
                  }, null, 8, _W)),
                  e.selectable ? (f(), h("span", {
                    key: 2,
                    class: "fe-item-check",
                    "data-fe-control": "",
                    onClick: yt((at) => re(We, at), ["stop"]),
                    onDblclick: Fe[2] || (Fe[2] = yt(() => {
                    }, ["stop"]))
                  }, [
                    Ze(Tg, {
                      on: j(We),
                      label: u(p)(We)
                    }, null, 8, ["on", "label"])
                  ], 40, xW)) : O("", !0)
                ], 2),
                d("div", SW, [
                  d("div", {
                    class: "fe-grid__label",
                    title: u(p)(We)
                  }, [
                    d("bdi", null, y(u(p)(We)), 1),
                    e.keepBadgeFor && e.keepBadgeFor(We) ? (f(), h("span", {
                      key: 0,
                      class: Re(["fe-keepbadge", "fe-keepbadge--" + e.keepBadgeFor(We)]),
                      title: u(l)("keep.badge_" + e.keepBadgeFor(We)),
                      role: "img",
                      "aria-label": u(l)("keep.badge_" + e.keepBadgeFor(We))
                    }, y(V(e.keepBadgeFor(We))), 11, TW)) : O("", !0)
                  ], 8, $W),
                  d("div", {
                    class: "fe-grid__meta",
                    title: F(We)
                  }, [
                    $(We) ? (f(), h("span", {
                      key: 0,
                      class: "fe-applock",
                      role: "img",
                      title: $(We),
                      "aria-label": $(We),
                      "data-testid": "lock-badge"
                    }, [
                      Fe[7] || (Fe[7] = d("span", {
                        class: "fe-applock__glyph",
                        "aria-hidden": "true"
                      }, "🔒", -1)),
                      Ht(y(u(l)("applock.badge")), 1)
                    ], 8, EW)) : O("", !0),
                    k(We) ? (f(), h("span", {
                      key: 1,
                      class: Re(["fe-symlink", "fe-symlink--" + k(We).state]),
                      role: "img",
                      title: k(We).why,
                      "aria-label": k(We).why,
                      "data-testid": "symlink-badge",
                      "data-link-state": k(We).state
                    }, [
                      Fe[8] || (Fe[8] = d("span", {
                        class: "fe-symlink__glyph",
                        "aria-hidden": "true"
                      }, "🔗", -1)),
                      Ht(y(k(We).badge), 1)
                    ], 10, CW)) : O("", !0),
                    b(We) ? (f(), h("span", {
                      key: 2,
                      class: "fe-unavailable",
                      role: "img",
                      title: b(We).full,
                      "aria-label": b(We).full,
                      "data-testid": "unavailable-badge"
                    }, y(b(We).badge), 9, zW)) : O("", !0),
                    Ht(" " + y(F(We)), 1)
                  ], 8, AW),
                  e.showParentPath && u(Nr)(We) ? (f(), h("div", {
                    key: 0,
                    class: "fe-grid__parent",
                    title: u(Nr)(We)
                  }, [
                    d("bdi", null, y(u(Nr)(We)), 1)
                  ], 8, MW)) : O("", !0),
                  ke(We) ? (f(), h("div", {
                    key: 1,
                    class: "fe-grid__snippet",
                    title: qe(ke(We))
                  }, [
                    (f(!0), h(Te, null, nt(u(by)(ke(We)), (at, kt) => (f(), h(Te, { key: kt }, [
                      at.match ? (f(), h("mark", OW, y(at.text), 1)) : (f(), h(Te, { key: 1 }, [
                        Ht(y(at.text), 1)
                      ], 64))
                    ], 64))), 128))
                  ], 8, PW)) : O("", !0)
                ]),
                d("button", {
                  type: "button",
                  class: "fe-grid__menu",
                  "aria-label": u(l)("toolbar.more"),
                  title: u(l)("toolbar.more"),
                  onClick: yt((at) => ce(We, at), ["stop"]),
                  onDblclick: Fe[3] || (Fe[3] = yt(() => {
                  }, ["stop"]))
                }, "⋮", 40, LW)
              ])
            ], 42, pW)
          ], 64);
        }), 128)),
        !e.loading && e.files.length === 0 ? (f(), h("div", DW, y(u(l)("empty.folder")), 1)) : O("", !0)
      ], 10, dW)
    ]));
  }
}), RW = {
  class: "fe-home",
  "data-testid": "home-view"
}, NW = {
  class: "fe-home__section",
  "data-testid": "home-storages"
}, IW = { class: "fe-home__heading" }, BW = {
  key: 0,
  class: "fe-home__storages"
}, FW = ["data-storage", "title", "onClick"], UW = ["innerHTML"], HW = { class: "fe-home__storage-main" }, KW = { class: "fe-home__storage-label" }, VW = ["data-partial"], jW = {
  key: 1,
  class: "fe-home__nomatch",
  "data-testid": "home-storages-nomatch"
}, qW = {
  key: 2,
  class: "fe-state fe-home__state",
  "data-testid": "home-storages-empty"
}, WW = { class: "fe-state__title" }, YW = { class: "fe-state__hint" }, GW = {
  class: "fe-home__section",
  "data-testid": "home-recent"
}, XW = { class: "fe-home__heading" }, JW = {
  key: 1,
  class: "fe-home__loading"
}, ZW = {
  key: 2,
  class: "fe-home__nomatch",
  "data-testid": "home-recent-nomatch"
}, QW = {
  key: 3,
  class: "fe-state fe-home__state",
  "data-testid": "home-recent-empty"
}, eY = { class: "fe-state__title" }, tY = { class: "fe-state__hint" }, nY = {
  class: "fe-home__section",
  "data-testid": "home-starred"
}, aY = { class: "fe-home__heading" }, iY = {
  key: 1,
  class: "fe-home__loading"
}, oY = {
  key: 2,
  class: "fe-home__nomatch",
  "data-testid": "home-starred-nomatch"
}, rY = {
  key: 3,
  class: "fe-state fe-home__state",
  "data-testid": "home-starred-empty"
}, sY = { class: "fe-state__title" }, lY = { class: "fe-state__hint" }, uY = /* @__PURE__ */ lt({
  __name: "HomeView",
  props: {
    storages: {},
    recent: {},
    starred: {},
    loading: { type: Boolean },
    locale: {},
    nameFilter: {},
    matchNames: { type: Function },
    thumbSrc: { type: Function }
  },
  emits: ["open-storage", "open-node", "context-node"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatSize: r } = ht(() => n.locale), l = A(() => (n.nameFilter ?? "").trim()), c = A(() => l.value !== ""), p = ic(
      () => l.value,
      () => n.storages,
      (z) => z.label || z.name,
      () => n.matchNames
    ), m = ic(
      () => l.value,
      () => n.recent,
      (z) => z.basename || "",
      () => n.matchNames
    ), v = ic(
      () => l.value,
      () => n.starred,
      (z) => z.basename || "",
      () => n.matchNames
    ), x = A(() => p.apply(n.storages)), w = A(() => m.apply(n.recent)), $ = A(() => v.apply(n.starred));
    function k(z, D) {
      return c.value && z > 0 && D === 0;
    }
    const b = /* @__PURE__ */ new Set(), C = wa({ type: "dir", mime_type: "inode/storage" });
    function T(z) {
      return typeof z.usedBytes != "number" || z.usedBytes < 0 ? i("conn.guide.storage") : z.usedPartial ? i("drive.storage.used_partial", { used: r(z.usedBytes) }) : i("drive.storage.used_unlimited", { used: r(z.usedBytes) });
    }
    const E = S({ path: "", at: 0 });
    function R(z) {
      const D = Date.now();
      z.path === E.value.path && D - E.value.at < 700 || (E.value = { path: z.path, at: D }, a("open-node", z));
    }
    return (z, D) => (f(), h("div", RW, [
      d("section", NW, [
        d("h2", IW, y(u(i)("sidenav.storages")), 1),
        x.value.length ? (f(), h("div", BW, [
          (f(!0), h(Te, null, nt(x.value, (U) => (f(), h("button", {
            key: U.name,
            type: "button",
            class: "fe-home__storage",
            "data-testid": "home-storage-card",
            "data-storage": U.name,
            title: U.label || U.name,
            onClick: (H) => a("open-storage", U.name)
          }, [
            d("span", {
              class: "fe-home__storage-tile",
              "aria-hidden": "true",
              innerHTML: u(C)
            }, null, 8, UW),
            d("span", HW, [
              d("span", KW, y(U.label || U.name), 1),
              d("span", {
                class: "fe-home__storage-meta",
                "data-testid": "home-storage-used",
                "data-partial": U.usedPartial ? "true" : void 0
              }, y(T(U)), 9, VW),
              U.readOnly ? (f(), Ge(pT, {
                key: 0,
                "read-only": "",
                locale: e.locale,
                class: "fe-home__storage-ro",
                "data-testid": "home-storage-readonly"
              }, null, 8, ["locale"])) : O("", !0)
            ])
          ], 8, FW))), 128))
        ])) : k(e.storages.length, x.value.length) ? (f(), h("p", jW, y(u(i)("filter.empty.title")), 1)) : (f(), h("div", qW, [
          D[2] || (D[2] = d("svg", {
            class: "fe-state__art",
            viewBox: "0 0 120 100",
            width: "96",
            height: "80",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            d("rect", {
              x: "26",
              y: "30",
              width: "68",
              height: "18",
              rx: "5"
            }),
            d("rect", {
              x: "26",
              y: "54",
              width: "68",
              height: "18",
              rx: "5"
            }),
            d("path", { d: "M38 39h.01M38 63h.01" })
          ], -1)),
          d("p", WW, y(u(i)("home.storages.empty")), 1),
          d("p", YW, y(u(i)("home.storages.hint")), 1)
        ]))
      ]),
      d("section", GW, [
        d("h2", XW, y(u(i)("sidenav.recent")), 1),
        w.value.length ? (f(), Ge(ky, {
          key: 0,
          files: w.value,
          selected: u(b),
          selectable: !1,
          locale: e.locale,
          "thumb-src": e.thumbSrc,
          onClickCard: R,
          onDblCard: R,
          onContextCard: D[0] || (D[0] = (U, H) => a("context-node", U, H))
        }, null, 8, ["files", "selected", "locale", "thumb-src"])) : e.loading ? (f(), h("p", JW, y(u(i)("loading")), 1)) : k(e.recent.length, w.value.length) ? (f(), h("p", ZW, y(u(i)("filter.empty.title")), 1)) : (f(), h("div", QW, [
          D[3] || (D[3] = d("svg", {
            class: "fe-state__art",
            viewBox: "0 0 120 100",
            width: "96",
            height: "80",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            d("circle", {
              cx: "60",
              cy: "50",
              r: "28"
            }),
            d("path", { d: "M60 32v18l12 8" })
          ], -1)),
          d("p", eY, y(u(i)("empty.recent.title")), 1),
          d("p", tY, y(u(i)("empty.recent.hint")), 1)
        ]))
      ]),
      d("section", nY, [
        d("h2", aY, y(u(i)("sidenav.starred")), 1),
        $.value.length ? (f(), Ge(ky, {
          key: 0,
          files: $.value,
          selected: u(b),
          selectable: !1,
          locale: e.locale,
          "thumb-src": e.thumbSrc,
          onClickCard: R,
          onDblCard: R,
          onContextCard: D[1] || (D[1] = (U, H) => a("context-node", U, H))
        }, null, 8, ["files", "selected", "locale", "thumb-src"])) : e.loading ? (f(), h("p", iY, y(u(i)("loading")), 1)) : k(e.starred.length, $.value.length) ? (f(), h("p", oY, y(u(i)("filter.empty.title")), 1)) : (f(), h("div", rY, [
          D[4] || (D[4] = d("svg", {
            class: "fe-state__art",
            viewBox: "0 0 120 100",
            width: "96",
            height: "80",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            d("path", { d: "M60 26l9 18.6 20.4 3-14.8 14.4 3.5 20.4L60 72.8 41.9 82.4l3.5-20.4L30.6 47.6l20.4-3z" })
          ], -1)),
          d("p", sY, y(u(i)("empty.starred.title")), 1),
          d("p", lY, y(u(i)("empty.starred.hint")), 1)
        ]))
      ])
    ]));
  }
}), cY = {
  class: "fe-drafts",
  "data-testid": "drafts-view"
}, dY = { class: "fe-drafts__head" }, fY = { class: "fe-drafts__lead" }, pY = {
  key: 0,
  class: "fe-drafts__count",
  "data-testid": "drafts-count-line"
}, hY = {
  key: 0,
  class: "fe-state",
  "data-testid": "empty-drafts"
}, mY = { class: "fe-state__title" }, vY = { class: "fe-state__hint" }, yY = { class: "fe-drafts__name" }, gY = ["innerHTML"], bY = ["title", "data-testid", "onClick"], kY = { class: "fe-drafts__target" }, wY = /* @__PURE__ */ lt({
  __name: "DraftsView",
  props: {
    drafts: {},
    loading: { type: Boolean },
    limit: {},
    locale: {},
    nameFilter: {},
    matchNames: { type: Function },
    busyKey: {}
  },
  emits: ["open", "save", "delete"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatDate: r } = ht(() => n.locale), l = ic(
      () => n.nameFilter ?? "",
      () => n.drafts,
      (C) => C.name,
      () => n.matchNames
    ), c = A(() => l.apply(n.drafts));
    function p(C) {
      const T = C.lastIndexOf(".");
      return T > 0 ? C.slice(T + 1).toLowerCase() : "";
    }
    function m(C) {
      return wa({ type: "file", basename: C.name, extension: p(C.name) || C.type });
    }
    function v(C) {
      const T = C.target_dir.indexOf("://"), E = (T >= 0 ? C.target_dir.slice(T + 3) : C.target_dir).replace(/^\/+|\/+$/g, "");
      return E ? E.split("/").filter(Boolean).join(" / ") : "/";
    }
    function x(C) {
      return Date.parse(C.modified_at || C.created_at) || 0;
    }
    const w = A(() => [
      {
        id: "name",
        label: i("col.name"),
        lead: !0,
        sortable: !0,
        width: 280,
        min: 160,
        format: (C) => C.name
      },
      {
        id: "target",
        label: i("drafts.col.target"),
        sortable: !0,
        width: 240,
        format: v,
        title: (C) => C.target
      },
      {
        id: "storage",
        label: i("drafts.col.storage"),
        sortable: !0,
        width: 140,
        format: (C) => C.storage
      },
      {
        id: "modified",
        label: i("col.modified"),
        sortable: !0,
        sortDir: "desc",
        width: 170,
        format: (C) => r(x(C)),
        sortValue: (C) => x(C)
      }
    ]);
    function $(C) {
      const T = n.busyKey === C.key;
      return [
        { key: "open", label: i("ctx.open"), icon: "open", disabled: T },
        { key: "save", label: i("drafts.action.save"), icon: "check", disabled: T },
        { key: "delete", label: i("ctx.delete"), icon: "delete", danger: !0, disabled: T }
      ];
    }
    function k(C, T) {
      C === "open" ? a("open", T) : C === "save" ? a("save", T) : C === "delete" && a("delete", T);
    }
    const b = A(
      () => n.limit && n.limit > 0 ? i("drafts.count_of", { n: n.drafts.length, limit: n.limit }) : ""
    );
    return (C, T) => (f(), h("section", cY, [
      d("header", dY, [
        d("p", fY, y(u(i)("drafts.lead")), 1),
        b.value && e.drafts.length ? (f(), h("p", pY, y(b.value), 1)) : O("", !0)
      ]),
      !e.loading && e.drafts.length === 0 ? (f(), h("div", hY, [
        T[2] || (T[2] = d("svg", {
          class: "fe-state__art",
          viewBox: "0 0 120 100",
          width: "110",
          height: "92",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "aria-hidden": "true"
        }, [
          d("path", { d: "M66 18H38a6 6 0 0 0-6 6v52a6 6 0 0 0 6 6h44a6 6 0 0 0 6-6V40z" }),
          d("path", { d: "M66 18v22h22" }),
          d("path", { d: "M50 66l18-18 6 6-18 18H50z" })
        ], -1)),
        d("p", mY, y(u(i)("empty.drafts.title")), 1),
        d("p", vY, y(u(i)("empty.drafts.hint")), 1)
      ])) : (f(), Ge(os, {
        key: 1,
        "table-id": "explorer.drafts",
        columns: w.value,
        rows: c.value,
        "row-key": "key",
        locale: e.locale,
        loading: e.loading,
        framed: !1,
        empty: u(i)("drafts.no_match"),
        "aria-label": u(i)("node.drafts"),
        "row-attrs": (E) => ({ "data-testid": `draft-row-${E.key}`, "data-draft-name": E.name }),
        "row-actions": $,
        "row-actions-test-id": (E) => `draft-actions-${E.key}`,
        onRowAction: T[0] || (T[0] = (E, R) => k(E, R)),
        onRowDblclick: T[1] || (T[1] = (E) => a("open", E))
      }, {
        "cell-name": mt(({ row: E }) => [
          d("span", yY, [
            d("span", {
              class: "fe-drafts__tile",
              "aria-hidden": "true",
              innerHTML: m(E)
            }, null, 8, gY),
            d("button", {
              type: "button",
              class: "fe-drafts__open",
              title: u(i)("drafts.open_hint", { name: E.name }),
              "data-testid": `draft-open-${E.key}`,
              onClick: yt((R) => a("open", E), ["stop"])
            }, [
              d("bdi", null, y(u(da)(E.name)), 1)
            ], 8, bY)
          ])
        ]),
        "cell-target": mt(({ row: E }) => [
          d("bdi", kY, y(v(E)), 1)
        ]),
        _: 1
      }, 8, ["columns", "rows", "locale", "loading", "empty", "aria-label", "row-attrs", "row-actions-test-id"]))
    ]));
  }
});
function ca(e) {
  if (e.apiBase != null) return e.apiBase.replace(/\/+$/, "");
  const t = e.endpoint ?? "", n = t.indexOf("/api/");
  return n >= 0 ? t.slice(0, n) : "";
}
function _Y(e, t) {
  const n = String(t ?? "").trim();
  if (/^https?:\/\/[^/]/i.test(n)) return n.replace(/\/+$/, "");
  const a = ca(e);
  if (/^https?:\/\//i.test(a))
    try {
      const i = new URL(a);
      return i.origin + i.pathname.replace(/\/+$/, "");
    } catch {
      return a;
    }
  return typeof window < "u" && window.location ? window.location.origin + (a.startsWith("/") ? a : "") : a;
}
function xY(e) {
  const t = Rl(e), n = ca(e), a = (N) => `${n}${N}`, i = Ea([]), r = Ea([]), l = Ea([]), c = S(null), p = S(null), m = S(null), v = S(!1), x = S(!1), w = S(null), $ = S(null), k = S(null);
  function b(N) {
    return N == null ? void 0 : N.status;
  }
  function C(N) {
    return Za(N, e.locale);
  }
  async function T() {
    v.value = !0, w.value = null;
    try {
      const N = t.capabilities().then((J) => {
        const j = J == null ? void 0 : J.public_url;
        m.value = typeof j == "string" && j ? j : null;
      }).catch(() => {
        m.value = null;
      });
      try {
        const J = await t.jsonFetch(a("/api/auth/me"));
        c.value = (J == null ? void 0 : J.user) ?? null, p.value = typeof (J == null ? void 0 : J.realm) == "string" && J.realm ? J.realm : null;
      } catch (J) {
        b(J) === 401 && ($.value = !1, k.value = "anonymous"), c.value = null;
      }
      try {
        i.value = await t.jsonFetch(
          a("/api/admin/storage-drivers")
        ), $.value = !0, k.value = null;
      } catch (J) {
        i.value = [], $.value = !1;
        const j = b(J);
        j === 403 ? k.value = "none" : j === 401 ? k.value = "anonymous" : (k.value = "unreachable", w.value = C(J));
      }
      if ($.value)
        try {
          const J = await t.jsonFetch(a("/api/admin/storages"));
          r.value = Array.isArray(J) ? J : [], l.value = r.value.map((j) => j.name);
        } catch (J) {
          w.value = C(J);
        }
      else
        try {
          const J = await t.index("");
          l.value = Array.isArray(J == null ? void 0 : J.storages) ? J.storages : [];
        } catch {
          l.value = [];
        }
      await N, x.value = !0;
    } finally {
      v.value = !1;
    }
  }
  async function E(N) {
    const J = await t.jsonFetch(a("/api/admin/storages"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(N)
    });
    return await T(), J;
  }
  async function R(N, J) {
    const j = await t.jsonFetch(a(`/api/admin/storages/${N}`), {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(J)
    });
    return await T(), j;
  }
  async function z(N) {
    await t.jsonFetch(a(`/api/admin/storages/${N}`), { method: "DELETE" }), await T();
  }
  async function D(N) {
    try {
      return await t.jsonFetch(a("/api/admin/storages/test"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(N)
      });
    } catch (J) {
      return { ok: !1, error: C(J) };
    }
  }
  function U(N) {
    return i.value.find((J) => J.driver === N);
  }
  function H(N) {
    var J;
    return ((J = U(N)) == null ? void 0 : J.fields) ?? [];
  }
  function L(N) {
    const J = {};
    for (const j of H(N))
      j.default !== void 0 && j.default !== null && (J[j.key] = j.default);
    return J;
  }
  function P(N, J) {
    return H(N).filter((j) => {
      if (!j.required || j.default !== void 0) return !1;
      for (const re of [j.key, ...j.aliases ?? []]) {
        const q = J[re];
        if (q != null && !(typeof q == "string" && q.trim() === ""))
          return !1;
      }
      return !0;
    });
  }
  const K = A(() => i.value.map((N) => N.driver));
  return {
    // state
    drivers: i,
    driverNames: K,
    storages: r,
    visible: l,
    me: c,
    realm: p,
    publicUrl: m,
    loading: v,
    loaded: x,
    error: w,
    canManage: $,
    denial: k,
    // actions
    load: T,
    createStorage: E,
    updateStorage: R,
    deleteStorage: z,
    testStorage: D,
    // descriptor helpers
    descriptor: U,
    fields: H,
    defaults: L,
    missingRequired: P
  };
}
function bT(e) {
  return /^http:\/\//i.test(e);
}
function SY(e, t) {
  const n = e.replace(/\/+$/, "");
  return t ? `${n}/dav/${t}/` : `${n}/dav/`;
}
function $Y(e, t) {
  let n;
  try {
    n = new URL(e);
  } catch {
    return e.replace(/^https:/i, "davs:").replace(/^http:/i, "dav:");
  }
  return `${n.protocol === "http:" ? "dav" : "davs"}://${n.host}${n.pathname}`;
}
function TY(e) {
  return ["use", e.letter, e.url, `/user:${e.user}`, e.password, "/persistent:yes"];
}
function AY(e) {
  const [t, n, a, ...i] = TY(e);
  return ["net", t, n, `"${a}"`, ...i].join(" ");
}
const h0 = "HKLM\\SYSTEM\\CurrentControlSet\\Services\\WebClient\\Parameters", EY = 4294967295, CY = 2e7, zY = [
  `reg add "${h0}" /v FileSizeLimitInBytes /t REG_DWORD /d ${EY} /f`,
  `reg add "${h0}" /v FileAttributesLimitInBytes /t REG_DWORD /d ${CY} /f`,
  "net stop webclient && net start webclient"
];
function ts(e) {
  try {
    return new URL(e).host;
  } catch {
    return e.replace(/^https?:\/\//i, "").replace(/\/+$/, "");
  }
}
function MY(e) {
  try {
    return new URL(e).pathname.replace(/\/+$/, "");
  } catch {
    return "";
  }
}
function PY(e, t) {
  const n = String(e ?? "").trim(), a = String(t ?? "").trim();
  return n && a ? `${a}/${n}` : n;
}
function Yg(e, t) {
  return e.user || t("conn.guide.userPlaceholder");
}
const OY = (e, t) => {
  const n = e.origin.replace(/\/+$/, ""), a = SY(n, e.storage), i = Yg(e, t), r = t("conn.guide.secretPlaceholder"), l = [
    { label: t("conn.guide.fact.url"), value: a, hint: e.storage ? t("conn.guide.fact.urlStorageHint", { storage: e.storage }) : t("conn.guide.fact.urlRootHint") },
    { label: t("conn.guide.fact.user"), value: i, hint: t("conn.guide.webdav.userHint") },
    { label: t("conn.guide.fact.password"), value: r, hint: t("conn.guide.webdav.passwordHint"), placeholderOnly: !0 }
  ], c = [
    {
      id: "windows",
      name: "Windows Explorer",
      platform: "windows",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.webdav.win.s1"),
            t("conn.guide.webdav.win.s2", { url: a }),
            t("conn.guide.webdav.win.s3")
          ]
        },
        {
          kind: "code",
          caption: t("conn.guide.webdav.win.cmdCaption"),
          code: AY({ letter: "Z:", url: a, user: i, password: r })
        },
        {
          kind: "warn",
          text: t("conn.guide.webdav.win.limits")
        },
        {
          kind: "code",
          caption: t("conn.guide.webdav.win.regCaption"),
          code: zY.join(`
`)
        },
        { kind: "note", text: t("conn.guide.webdav.win.https") },
        { kind: "note", text: t("conn.guide.webdav.win.persist") },
        { kind: "note", text: t("conn.guide.webdav.win.service") }
      ]
    },
    {
      id: "macos",
      name: "macOS Finder",
      platform: "macos",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.webdav.mac.s1"),
            t("conn.guide.webdav.mac.s2", { url: a }),
            t("conn.guide.webdav.mac.s3")
          ]
        },
        { kind: "note", text: t("conn.guide.webdav.mac.note") }
      ]
    },
    {
      id: "linux",
      name: "Linux (davfs2 / GNOME / KDE)",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.webdav.linux.mountCaption"),
          code: [
            `sudo mount -t davfs ${a} /mnt/filex`,
            "",
            `# ${t("conn.guide.webdav.linux.gvfsComment")}`,
            `gio mount ${$Y(a)}`
          ].join(`
`)
        },
        {
          kind: "warn",
          text: t("conn.guide.webdav.linux.locks")
        },
        {
          kind: "code",
          caption: "/etc/davfs2/davfs2.conf",
          code: "use_locks 0"
        }
      ]
    },
    {
      id: "rclone",
      name: "rclone",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.webdav.rclone.obscureCaption"),
          code: `rclone obscure "${r}"`
        },
        {
          kind: "code",
          caption: "~/.config/rclone/rclone.conf",
          code: [
            "[filex]",
            "type = webdav",
            `url = ${n}/dav`,
            "vendor = other",
            `user = ${i}`,
            `pass = ${t("conn.guide.webdav.rclone.passPlaceholder")}`
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.webdav.rclone.useCaption"),
          code: [
            "rclone lsd filex:",
            e.storage ? `rclone lsl filex:${e.storage}` : "rclone lsl filex:<storage>",
            e.storage ? `rclone copy ./local filex:${e.storage}/backup` : "rclone copy ./local filex:<storage>/backup",
            "rclone mount filex: /mnt/filex"
          ].join(`
`)
        }
      ]
    },
    {
      id: "cyberduck",
      name: "Cyberduck / Mountain Duck",
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.webdav.duck.s1"),
            t("conn.guide.webdav.duck.s2", { host: ts(n) }),
            t("conn.guide.webdav.duck.s3", { path: MY(n) + (e.storage ? `/dav/${e.storage}/` : "/dav/") }),
            t("conn.guide.webdav.duck.s4", { user: i })
          ]
        }
      ]
    }
  ], p = [
    { kind: "note", text: t("conn.guide.webdav.note.delete") },
    { kind: "note", text: t("conn.guide.webdav.note.locks") },
    { kind: "note", text: t("conn.guide.webdav.note.permissions") }
  ];
  return bT(n) && p.unshift({ kind: "warn", text: t("conn.guide.webdav.note.http") }), {
    id: "webdav",
    name: "WebDAV",
    summary: t("conn.guide.webdav.summary"),
    facts: l,
    clients: c,
    notes: p
  };
}, LY = (e, t) => {
  const n = (e.s3Endpoint || `${e.origin.replace(/\/+$/, "")}/s3`).replace(/\/+$/, ""), a = e.storage || e.storages[0] || "<bucket>", i = e.s3AccessKeyID || t("conn.guide.s3.keyPlaceholder"), r = e.s3Secret || t("conn.guide.s3.secretPlaceholder"), l = e.s3PathStyle !== !1, c = ts(n), p = [
    { label: t("conn.guide.s3.fact.endpoint"), value: n, hint: t("conn.guide.s3.fact.endpointHint") },
    { label: t("conn.guide.s3.fact.bucket"), value: a, hint: t("conn.guide.s3.fact.bucketHint") },
    { label: t("conn.guide.s3.fact.key"), value: i, hint: t("conn.guide.s3.fact.keyHint") },
    {
      label: t("conn.guide.s3.fact.secret"),
      value: r,
      hint: t("conn.guide.s3.fact.secretHint"),
      // ⚠ Only real right after minting. filex stores the secret sealed and
      // cannot show it again, and a guide that printed something secret-shaped
      // would be teaching a value that authenticates as nothing.
      placeholderOnly: !e.s3Secret
    },
    { label: t("conn.guide.s3.fact.region"), value: "us-east-1", hint: t("conn.guide.s3.fact.regionHint") },
    {
      label: t("conn.guide.s3.fact.addressing"),
      value: t(l ? "conn.guide.s3.fact.pathStyle" : "conn.guide.s3.fact.virtualHosted"),
      hint: t(l ? "conn.guide.s3.fact.pathStyleHint" : "conn.guide.s3.fact.virtualHostedHint")
    }
  ], m = [
    {
      id: "rclone",
      name: "rclone",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "~/.config/rclone/rclone.conf",
          code: [
            "[filex]",
            "type = s3",
            "provider = Other",
            `endpoint = ${n}`,
            `access_key_id = ${i}`,
            `secret_access_key = ${r}`,
            "region = us-east-1",
            ...l ? ["force_path_style = true"] : []
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.s3.rclone.useCaption"),
          code: [
            "rclone lsd filex:",
            `rclone copy ./local filex:${a}/backup -P`,
            `rclone sync ./local filex:${a}/backup`,
            `rclone mount filex:${a} /mnt/filex`
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.s3.rclone.mtime") }
      ]
    },
    {
      id: "awscli",
      name: "AWS CLI",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.s3.aws.configureCaption"),
          code: [
            "aws configure set aws_access_key_id " + i,
            "aws configure set aws_secret_access_key " + r,
            "aws configure set region us-east-1"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.s3.aws.useCaption"),
          code: [
            `aws --endpoint-url ${n} s3 ls`,
            `aws --endpoint-url ${n} s3 cp ./file.pdf s3://${a}/file.pdf`,
            `aws --endpoint-url ${n} s3 sync ./local s3://${a}/backup`,
            `aws --endpoint-url ${n} s3 presign s3://${a}/file.pdf --expires-in 300`
          ].join(`
`)
        },
        ...l ? [
          {
            kind: "note",
            text: t("conn.guide.s3.aws.pathStyle")
          },
          {
            kind: "code",
            caption: "~/.aws/config",
            code: ["[default]", "s3 =", "    addressing_style = path"].join(`
`)
          }
        ] : []
      ]
    },
    {
      id: "restic",
      name: "restic",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.s3.restic.envCaption"),
          code: [
            `export AWS_ACCESS_KEY_ID=${i}`,
            `export AWS_SECRET_ACCESS_KEY=${r}`,
            `export RESTIC_REPOSITORY="s3:${n}/${a}/restic"`,
            "export RESTIC_PASSWORD=…"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.s3.restic.useCaption"),
          code: [
            `restic init${l ? " -o s3.bucket-lookup=path" : ""}`,
            `restic backup ~/Documents${l ? " -o s3.bucket-lookup=path" : ""}`,
            `restic check --read-data${l ? " -o s3.bucket-lookup=path" : ""}`,
            `restic forget --keep-daily 7 --prune${l ? " -o s3.bucket-lookup=path" : ""}`
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.s3.restic.verified") }
      ]
    },
    {
      id: "mc",
      name: "MinIO Client (mc)",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.s3.mc.aliasCaption"),
          code: `mc alias set filex ${n} ${i} ${r} --api S3v4${l ? " --path on" : ""}`
        },
        {
          kind: "code",
          caption: t("conn.guide.s3.mc.useCaption"),
          code: [
            "mc ls filex",
            `mc cp ./file.pdf filex/${a}/file.pdf`,
            `mc mirror ./local filex/${a}/backup`,
            `mc du filex/${a}`
          ].join(`
`)
        }
      ]
    },
    {
      id: "s3fs",
      name: "s3fs (Linux / macOS)",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.s3.s3fs.credsCaption"),
          code: [
            `echo "${i}:${r}" > ~/.passwd-s3fs`,
            "chmod 600 ~/.passwd-s3fs"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.s3.s3fs.mountCaption"),
          code: [
            `s3fs ${a} /mnt/filex \\`,
            "  -o passwd_file=~/.passwd-s3fs \\",
            `  -o url=${n} \\`,
            ...l ? ["  -o use_path_request_style"] : []
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.s3.s3fs.note") }
      ]
    },
    {
      id: "cyberduck",
      name: "Cyberduck / Mountain Duck",
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.s3.duck.s1"),
            t("conn.guide.s3.duck.s2", { host: c }),
            t("conn.guide.s3.duck.s3", { key: i }),
            t("conn.guide.s3.duck.s4")
          ]
        },
        ...l ? [{ kind: "warn", text: t("conn.guide.s3.duck.pathStyle") }] : []
      ]
    },
    {
      id: "sdk",
      name: "SDK (Go / Python / JS)",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "boto3",
          code: [
            "import boto3",
            "s3 = boto3.client(",
            '    "s3",',
            `    endpoint_url="${n}",`,
            `    aws_access_key_id="${i}",`,
            `    aws_secret_access_key="${r}",`,
            '    region_name="us-east-1",',
            ...l ? [
              '    config=boto3.session.Config(s3={"addressing_style": "path"}),'
            ] : [],
            ")",
            `print([o["Key"] for o in s3.list_objects_v2(Bucket="${a}").get("Contents", [])])`
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.s3.sdk.note") }
      ]
    }
  ], v = [
    { kind: "note", text: t("conn.guide.s3.note.buckets") },
    { kind: "note", text: t("conn.guide.s3.note.permissions") },
    { kind: "note", text: t("conn.guide.s3.note.trash") },
    { kind: "note", text: t("conn.guide.s3.note.mtime") }
  ];
  return l && v.unshift({ kind: "warn", text: t("conn.guide.s3.note.pathStyle") }), bT(n) && v.unshift({ kind: "warn", text: t("conn.guide.s3.note.http") }), {
    id: "s3",
    name: "S3",
    summary: t("conn.guide.s3.summary"),
    facts: p,
    clients: m,
    notes: v
  };
}, DY = (e, t) => {
  const n = e.sftpHost || ts(e.origin), a = e.sftpPort || 2022, i = e.sftpLogin || Yg(e, t), r = e.storage ? `/${e.storage}` : "/<storage>", l = a === 22 ? "" : ` -P ${a}`, c = [
    { label: t("conn.guide.sftp.fact.host"), value: n, hint: t("conn.guide.sftp.fact.hostHint") },
    { label: t("conn.guide.sftp.fact.port"), value: String(a), hint: t("conn.guide.sftp.fact.portHint") },
    { label: t("conn.guide.fact.user"), value: i, hint: t("conn.guide.sftp.fact.userHint") },
    {
      label: t("conn.guide.sftp.fact.auth"),
      value: e.sftpHasKey ? t("conn.guide.sftp.fact.authKey") : t("conn.guide.sftp.fact.authPassword"),
      hint: t("conn.guide.sftp.fact.authHint"),
      placeholderOnly: !0
    },
    { label: t("conn.guide.sftp.fact.path"), value: r, hint: t("conn.guide.sftp.fact.pathHint") }
  ], p = [
    {
      id: "openssh",
      name: "OpenSSH (sftp / scp)",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.sftp.openssh.connectCaption"),
          code: [
            `sftp${l} ${i}@${n}`,
            `scp${l} ./report.pdf ${i}@${n}:${r}/report.pdf`,
            `scp${l} ${i}@${n}:${r}/report.pdf ./`
          ].join(`
`)
        },
        {
          kind: "code",
          caption: "~/.ssh/config",
          code: [
            "Host filex",
            `  HostName ${n}`,
            `  Port ${a}`,
            `  User ${i}`,
            "  # IdentityFile ~/.ssh/id_ed25519"
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.sftp.openssh.noShell") }
      ]
    },
    {
      id: "key",
      name: t("conn.guide.sftp.key.tab"),
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.sftp.key.s1"),
            t("conn.guide.sftp.key.s2"),
            t("conn.guide.sftp.key.s3")
          ]
        },
        {
          kind: "code",
          caption: t("conn.guide.sftp.key.genCaption"),
          code: ['ssh-keygen -t ed25519 -C "filex"', "cat ~/.ssh/id_ed25519.pub"].join(`
`)
        },
        // ⚠ The one command people reach for, and the one that cannot work.
        { kind: "warn", text: t("conn.guide.sftp.key.noCopyId") }
      ]
    },
    {
      id: "winscp",
      name: "WinSCP",
      platform: "windows",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.sftp.winscp.s1"),
            t("conn.guide.sftp.winscp.s2", { host: n, port: String(a) }),
            t("conn.guide.sftp.winscp.s3", { user: i }),
            t("conn.guide.sftp.winscp.s4")
          ]
        }
      ]
    },
    {
      id: "filezilla",
      name: "FileZilla",
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.sftp.filezilla.s1"),
            t("conn.guide.sftp.filezilla.s2", { host: `sftp://${n}`, port: String(a) }),
            t("conn.guide.sftp.filezilla.s3", { user: i })
          ]
        }
      ]
    },
    {
      id: "rclone",
      name: "rclone",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "~/.config/rclone/rclone.conf",
          code: [
            "[filex-sftp]",
            "type = sftp",
            `host = ${n}`,
            `port = ${a}`,
            `user = ${i}`,
            "key_file = ~/.ssh/id_ed25519",
            "# filex has no shell, so tell rclone not to look for one:",
            "shell_type = none",
            "md5sum_command = none",
            "sha1sum_command = none"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.sftp.rclone.useCaption"),
          code: [
            "rclone lsd filex-sftp:",
            `rclone copy ./local filex-sftp:${r}/backup -P`,
            `rclone sync ./local filex-sftp:${r}/backup`
          ].join(`
`)
        }
      ]
    },
    {
      id: "sshfs",
      name: "sshfs (Linux / macOS)",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.sftp.sshfs.mountCaption"),
          code: [
            `sshfs -p ${a} ${i}@${n}:${r} /mnt/filex`,
            "fusermount -u /mnt/filex"
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.sftp.sshfs.note") }
      ]
    }
  ], m = [
    { kind: "note", text: t("conn.guide.sftp.note.storages") },
    { kind: "note", text: t("conn.guide.sftp.note.permissions") },
    { kind: "note", text: t("conn.guide.sftp.note.trash") },
    { kind: "note", text: t("conn.guide.sftp.note.totp") }
  ];
  return e.sftpEnabled === !1 && m.unshift({ kind: "warn", text: t("conn.guide.sftp.note.disabled") }), {
    id: "sftp",
    name: "SFTP",
    summary: t("conn.guide.sftp.summary"),
    facts: c,
    clients: p,
    notes: m
  };
}, RY = (e, t) => {
  const n = e.ftpsHost || ts(e.origin), a = e.ftpsPort || 2121, i = e.sftpLogin || Yg(e, t), r = t("conn.guide.secretPlaceholder"), l = e.storage ? `/${e.storage}` : "/<storage>", c = e.ftpsPasvMin && e.ftpsPasvMax ? `${e.ftpsPasvMin}-${e.ftpsPasvMax}` : "30000-30100", p = [
    { label: t("conn.guide.ftps.fact.host"), value: n, hint: t("conn.guide.ftps.fact.hostHint") },
    { label: t("conn.guide.ftps.fact.port"), value: String(a), hint: t("conn.guide.ftps.fact.portHint") },
    { label: t("conn.guide.ftps.fact.mode"), value: t("conn.guide.ftps.fact.modeValue"), hint: t("conn.guide.ftps.fact.modeHint") },
    { label: t("conn.guide.fact.user"), value: i, hint: t("conn.guide.ftps.fact.userHint") },
    { label: t("conn.guide.fact.password"), value: r, hint: t("conn.guide.ftps.fact.passwordHint"), placeholderOnly: !0 },
    { label: t("conn.guide.ftps.fact.pasv"), value: c, hint: t("conn.guide.ftps.fact.pasvHint") }
  ], m = [
    {
      id: "filezilla",
      name: "FileZilla",
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.ftps.filezilla.s1"),
            t("conn.guide.ftps.filezilla.s2", { host: n, port: String(a) }),
            t("conn.guide.ftps.filezilla.s3", { user: i }),
            t("conn.guide.ftps.filezilla.s4")
          ]
        }
      ]
    },
    {
      id: "winscp",
      name: "WinSCP",
      platform: "windows",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.ftps.winscp.s1"),
            t("conn.guide.ftps.winscp.s2", { host: n, port: String(a) }),
            t("conn.guide.ftps.winscp.s3", { user: i })
          ]
        }
      ]
    },
    {
      id: "curl",
      name: "curl",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.ftps.curl.caption"),
          code: [
            `curl --ssl-reqd --ftp-pasv --user ${i} \\`,
            `  -T ./report.pdf "ftp://${n}:${a}${l}/report.pdf"`,
            "",
            `curl --ssl-reqd --ftp-pasv --user ${i} \\`,
            `  -o ./report.pdf "ftp://${n}:${a}${l}/report.pdf"`
          ].join(`
`)
        },
        // ⚠ The flag that matters. Without it curl will happily fall back to
        // plaintext against a server that allows it — this one does not, but
        // the habit is what protects you against the ones that do.
        { kind: "note", text: t("conn.guide.ftps.curl.sslReqd") }
      ]
    },
    {
      id: "lftp",
      name: "lftp",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "~/.lftprc",
          code: [
            "set ftp:ssl-force true",
            "set ftp:ssl-protect-data true",
            "set ftp:passive-mode true"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.ftps.lftp.caption"),
          code: [
            `lftp -u ${i} ftp://${n}:${a}`,
            `# then: cd ${l}; put ./report.pdf; ls`
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.ftps.lftp.protectData") }
      ]
    },
    {
      id: "rclone",
      name: "rclone",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "~/.config/rclone/rclone.conf",
          code: [
            "[filex-ftp]",
            "type = ftp",
            `host = ${n}`,
            `port = ${a}`,
            `user = ${i}`,
            '# rclone obscure "<your password>"',
            "pass = …",
            "explicit_tls = true"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.ftps.rclone.useCaption"),
          code: [
            "rclone lsd filex-ftp:",
            `rclone copy ./local filex-ftp:${l}/backup -P`
          ].join(`
`)
        }
      ]
    },
    {
      id: "printer",
      name: t("conn.guide.ftps.printer.tab"),
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.ftps.printer.s1", { host: n, port: String(a) }),
            t("conn.guide.ftps.printer.s2", { user: i }),
            t("conn.guide.ftps.printer.s3", { path: l }),
            t("conn.guide.ftps.printer.s4")
          ]
        },
        // ⚠ The honest warning: plenty of scan-to-FTP firmware cannot do TLS
        // at all, and this endpoint will not talk to it. Saying so beats an
        // afternoon spent debugging a device that was never going to connect.
        { kind: "warn", text: t("conn.guide.ftps.printer.noTLS") }
      ]
    }
  ], v = [
    { kind: "warn", text: t("conn.guide.ftps.note.tls") },
    { kind: "note", text: t("conn.guide.ftps.note.passive") },
    { kind: "note", text: t("conn.guide.ftps.note.storages") },
    { kind: "note", text: t("conn.guide.ftps.note.trash") },
    { kind: "note", text: t("conn.guide.ftps.note.prefer") }
  ];
  return e.ftpsSelfSigned && v.push({ kind: "warn", text: t("conn.guide.ftps.note.selfSigned") }), e.ftpsEnabled === !1 && v.unshift({ kind: "warn", text: t("conn.guide.ftps.note.disabled") }), {
    id: "ftps",
    name: "FTPS",
    summary: t("conn.guide.ftps.summary"),
    facts: p,
    clients: m,
    notes: v
  };
}, NY = (e, t) => {
  const n = e.nfsHost || ts(e.origin), a = e.nfsPort || 2049, i = e.nfsPath || t("conn.guide.nfs.pathPlaceholder"), r = e.nfsReadOnly ? ",ro" : "", l = `nfsvers=3,tcp,port=${a},mountport=${a},nolock${r}`, c = [
    { label: t("conn.guide.nfs.fact.host"), value: n, hint: t("conn.guide.nfs.fact.hostHint") },
    { label: t("conn.guide.nfs.fact.port"), value: String(a), hint: t("conn.guide.nfs.fact.portHint") },
    {
      label: t("conn.guide.nfs.fact.export"),
      value: i,
      hint: t("conn.guide.nfs.fact.exportHint"),
      // ⚠ Only real right after minting: the path is stored hashed and cannot
      // be shown again, and printing something path-shaped would produce a
      // mount line that fails with no clue why.
      placeholderOnly: !e.nfsPath
    },
    { label: t("conn.guide.nfs.fact.options"), value: l, hint: t("conn.guide.nfs.fact.optionsHint") }
  ], p = [
    {
      id: "linux",
      name: "Linux",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.nfs.linux.mountCaption"),
          code: [
            "sudo mkdir -p /mnt/filex",
            `sudo mount -t nfs -o ${l} ${n}:${i} /mnt/filex`,
            "",
            "# and to unmount:",
            "sudo umount /mnt/filex"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: "/etc/fstab",
          code: `${n}:${i}  /mnt/filex  nfs  ${l},_netdev,noauto,x-systemd.automount  0  0`
        },
        // ⚠ The warning that belongs next to the fstab line rather than in a
        // document: that file is world-readable on most systems.
        { kind: "warn", text: t("conn.guide.nfs.linux.fstabSecret") }
      ]
    },
    {
      id: "macos",
      name: "macOS",
      platform: "macos",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.nfs.mac.mountCaption"),
          code: [
            "sudo mkdir -p /Volumes/filex",
            `sudo mount -t nfs -o vers=3,tcp,port=${a},mountport=${a},nolock${r},resvport ${n}:${i} /Volumes/filex`
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.nfs.mac.resvport") }
      ]
    },
    {
      id: "windows",
      name: "Windows (Client for NFS)",
      platform: "windows",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.nfs.win.s1"),
            t("conn.guide.nfs.win.s2"),
            t("conn.guide.nfs.win.s3")
          ]
        },
        {
          kind: "code",
          caption: t("conn.guide.nfs.win.cmdCaption"),
          code: `mount -o anon nolock ${n}:${i} Z:`
        },
        // ⚠ Windows' client has no way to say "the mount service is on this
        // port", so it only works when filex is on 2049.
        { kind: "warn", text: t("conn.guide.nfs.win.port") }
      ]
    },
    {
      id: "synology",
      name: t("conn.guide.nfs.nas.tab"),
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.nfs.nas.s1", { host: n, port: String(a) }),
            t("conn.guide.nfs.nas.s2"),
            t("conn.guide.nfs.nas.s3")
          ]
        }
      ]
    }
  ], m = [
    { kind: "warn", text: t("conn.guide.nfs.note.unencrypted") },
    { kind: "warn", text: t("conn.guide.nfs.note.pathIsSecret") },
    { kind: "note", text: t("conn.guide.nfs.note.noPortmapper") },
    { kind: "note", text: t("conn.guide.nfs.note.uid") },
    { kind: "note", text: t("conn.guide.nfs.note.trash") },
    { kind: "note", text: t("conn.guide.nfs.note.revoke") }
  ];
  return e.nfsEnabled === !1 && m.unshift({ kind: "warn", text: t("conn.guide.nfs.note.disabled") }), {
    id: "nfs",
    name: "NFS",
    summary: t("conn.guide.nfs.summary"),
    facts: c,
    clients: p,
    notes: m
  };
}, IY = (e, t) => {
  const n = e.origin.replace(/\/+$/, ""), a = e.storage || e.storages[0] || "main", i = [
    { label: t("conn.guide.mount.fact.url"), value: n, hint: t("conn.guide.mount.fact.urlHint") },
    {
      label: t("conn.guide.mount.fact.token"),
      value: t("conn.guide.mount.fact.tokenPlaceholder"),
      hint: t("conn.guide.mount.fact.tokenHint"),
      // filex never has the plaintext of a token after it is minted, and a
      // fact row that looked like one would be a lie the user pastes.
      placeholderOnly: !0
    },
    { label: t("conn.guide.mount.fact.remote"), value: `${a}://`, hint: t("conn.guide.mount.fact.remoteHint") }
  ], r = [
    {
      id: "linux",
      name: "Linux",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.mount.linux.mountCaption"),
          code: [
            `export FILEX_URL=${n}`,
            "export FILEX_TOKEN=<token>",
            "",
            "mkdir -p ~/filex",
            "filex mount ~/filex",
            "",
            "# one storage only, or a subfolder of it:",
            `filex mount --remote '${a}://' ~/filex`,
            `filex mount --remote '${a}://projects/acme' --read-only ~/acme`
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.mount.linux.umountCaption"),
          code: "fusermount -u ~/filex"
        },
        // ⚠ The one that costs an afternoon if it is not said: killing the
        // process leaves a directory where every `ls` hangs.
        { kind: "warn", text: t("conn.guide.mount.linux.umountWarn") },
        {
          kind: "code",
          caption: t("conn.guide.mount.linux.systemdCaption"),
          code: [
            "# ~/.config/systemd/user/filex-mount.service",
            "[Unit]",
            "Description=filex mount",
            "After=network-online.target",
            "",
            "[Service]",
            `Environment=FILEX_URL=${n}`,
            "Environment=FILEX_TOKEN=<token>",
            "ExecStart=%h/.local/bin/filex mount %h/filex",
            "ExecStop=/bin/fusermount -u %h/filex",
            "Restart=on-failure",
            "",
            "[Install]",
            "WantedBy=default.target"
          ].join(`
`)
        }
      ]
    },
    {
      id: "windows",
      name: "Windows",
      platform: "windows",
      blocks: [
        { kind: "note", text: t("conn.guide.mount.win.winfsp") },
        {
          kind: "code",
          caption: t("conn.guide.mount.win.mountCaption"),
          code: [
            `$env:FILEX_URL   = "${n}"`,
            '$env:FILEX_TOKEN = "<token>"',
            "",
            "filex mount Z:"
          ].join(`
`)
        },
        // ⚠ The drive letter is CREATED, not reused — pointing it at one that
        // already exists is the commonest way this fails, and the message the
        // driver gives for it says nothing useful.
        { kind: "warn", text: t("conn.guide.mount.win.freeLetter") },
        { kind: "note", text: t("conn.guide.mount.win.stop") }
      ]
    },
    {
      id: "macos",
      name: "macOS",
      platform: "macos",
      blocks: [
        // ⚠⚠ A refusal stated up front rather than discovered. macFUSE's Go
        // binding needs a C toolchain filex deliberately does not use, and its
        // licence forbids a commercial program from installing it. Pretending
        // otherwise would mean a command that appears to work and does nothing.
        { kind: "warn", text: t("conn.guide.mount.mac.unsupported") },
        { kind: "note", text: t("conn.guide.mount.mac.alternatives") }
      ]
    }
  ], l = [
    { kind: "note", text: t("conn.guide.mount.note.notASync") },
    { kind: "note", text: t("conn.guide.mount.note.reachable") },
    { kind: "note", text: t("conn.guide.mount.note.wholeFileWrites") },
    { kind: "note", text: t("conn.guide.mount.note.trash") },
    { kind: "note", text: t("conn.guide.mount.note.revoke") }
  ];
  return {
    id: "mount",
    name: "filex mount",
    summary: t("conn.guide.mount.summary"),
    facts: i,
    clients: r,
    notes: l
  };
}, kT = {
  webdav: OY,
  s3: LY,
  sftp: DY,
  ftps: RY,
  nfs: NY,
  mount: IY
}, BY = {
  webdav: "WebDAV",
  s3: "S3",
  sftp: "SFTP",
  ftps: "FTPS",
  nfs: "NFS",
  mount: "filex mount"
};
function FY(e) {
  return BY[e] || e.toUpperCase();
}
function UY() {
  return Object.keys(kT);
}
function HY(e, t, n) {
  const a = kT[e];
  return a ? a(t, n) : null;
}
const KY = { class: "fe-guide" }, VY = { class: "fe-guide__summary" }, jY = {
  class: "fe-guide__facts",
  "data-testid": "guide-facts"
}, qY = { class: "fe-guide__factlabel" }, WY = { class: "fe-guide__factvalue" }, YY = ["data-testid", "onClick"], GY = {
  key: 0,
  class: "fe-guide__facthint"
}, XY = {
  class: "fe-guide__tabs",
  role: "tablist"
}, JY = ["aria-selected", "data-testid", "onClick"], ZY = {
  key: 0,
  class: "fe-guide__body",
  role: "tabpanel"
}, QY = {
  key: 0,
  class: "fe-guide__steps"
}, eG = {
  key: 1,
  class: "fe-guide__codewrap"
}, tG = { class: "fe-guide__codehead" }, nG = { class: "fe-guide__caption" }, aG = ["data-testid", "onClick"], iG = { class: "fe-guide__code" }, oG = {
  key: 2,
  class: "fe-guide__warn"
}, rG = {
  key: 3,
  class: "fe-guide__note"
}, sG = {
  key: 4,
  class: "fe-guide__text"
}, lG = {
  key: 1,
  class: "fe-guide__notes"
}, uG = { class: "fe-guide__notestitle" }, cG = /* @__PURE__ */ lt({
  __name: "ConnectionGuideView",
  props: {
    guide: {},
    locale: {}
  },
  setup(e) {
    var v;
    const t = e, { t: n } = ht(() => t.locale), a = S(((v = t.guide.clients[0]) == null ? void 0 : v.id) ?? ""), i = S(null);
    let r = null;
    const l = A(
      () => t.guide.clients.find((x) => x.id === a.value) ?? t.guide.clients[0]
    );
    async function c(x, w) {
      let $ = !1;
      try {
        await navigator.clipboard.writeText(x), $ = !0;
      } catch {
        try {
          const k = document.createElement("textarea");
          k.value = x, k.setAttribute("readonly", ""), k.style.position = "fixed", k.style.opacity = "0", document.body.appendChild(k), k.select(), $ = document.execCommand("copy"), document.body.removeChild(k);
        } catch {
          $ = !1;
        }
      }
      i.value = $ ? w : null, r && clearTimeout(r), r = setTimeout(() => {
        i.value = null;
      }, 1600);
    }
    function p(x, w) {
      return `${x}-${w}`;
    }
    function m(x) {
      return x.kind === "code";
    }
    return (x, w) => (f(), h("div", KY, [
      d("p", VY, y(e.guide.summary), 1),
      d("section", jY, [
        (f(!0), h(Te, null, nt(e.guide.facts, ($, k) => (f(), h("div", {
          key: $.label,
          class: "fe-guide__fact"
        }, [
          d("span", qY, y($.label), 1),
          d("span", WY, [
            d("code", {
              class: Re({ "fe-guide__ph": $.placeholderOnly })
            }, y($.value), 3),
            $.placeholderOnly ? O("", !0) : (f(), h("button", {
              key: 0,
              type: "button",
              class: "fe-guide__copy",
              "data-testid": `copy-fact-${k}`,
              onClick: (b) => c($.value, p("fact", k))
            }, y(i.value === p("fact", k) ? u(n)("conn.guide.copied") : u(n)("conn.guide.copy")), 9, YY))
          ]),
          $.hint ? (f(), h("span", GY, y($.hint), 1)) : O("", !0)
        ]))), 128))
      ]),
      d("nav", XY, [
        (f(!0), h(Te, null, nt(e.guide.clients, ($) => (f(), h("button", {
          key: $.id,
          type: "button",
          role: "tab",
          class: Re(["fe-guide__tab", { "is-active": l.value && $.id === l.value.id }]),
          "aria-selected": l.value && $.id === l.value.id,
          "data-testid": `guide-tab-${$.id}`,
          onClick: (k) => a.value = $.id
        }, y($.name), 11, JY))), 128))
      ]),
      l.value ? (f(), h("div", ZY, [
        (f(!0), h(Te, null, nt(l.value.blocks, ($, k) => (f(), h(Te, { key: k }, [
          $.kind === "steps" ? (f(), h("ol", QY, [
            (f(!0), h(Te, null, nt($.steps ?? [], (b, C) => (f(), h("li", { key: C }, y(b), 1))), 128))
          ])) : m($) ? (f(), h("div", eG, [
            d("div", tG, [
              d("span", nG, y($.caption), 1),
              d("button", {
                type: "button",
                class: "fe-guide__copy",
                "data-testid": `copy-code-${k}`,
                onClick: (b) => c($.code ?? "", p(l.value.id, k))
              }, y(i.value === p(l.value.id, k) ? u(n)("conn.guide.copied") : u(n)("conn.guide.copy")), 9, aG)
            ]),
            d("pre", iG, [
              d("code", null, y($.code), 1)
            ])
          ])) : $.kind === "warn" ? (f(), h("p", oG, y($.text), 1)) : $.kind === "note" ? (f(), h("p", rG, y($.text), 1)) : (f(), h("p", sG, y($.text), 1))
        ], 64))), 128))
      ])) : O("", !0),
      e.guide.notes.length ? (f(), h("section", lG, [
        d("h4", uG, y(u(n)("conn.guide.goodToKnow")), 1),
        (f(!0), h(Te, null, nt(e.guide.notes, ($, k) => (f(), h("p", {
          key: k,
          class: Re($.kind === "warn" ? "fe-guide__warn" : "fe-guide__note")
        }, y($.text), 3))), 128))
      ])) : O("", !0)
    ]));
  }
});
function dG(e) {
  const t = Rl(e), n = ca(e), a = (z) => `${n}${z}`, i = Ea([]), r = S(null), l = S(!1), c = S(!1), p = S(null), m = S(null), v = S(null), x = S(null);
  function w(z) {
    return m.value = (z == null ? void 0 : z.hint) ?? null, Za(z, e.locale);
  }
  function $(z) {
    return z == null ? void 0 : z.status;
  }
  async function k() {
    l.value = !0, p.value = null, m.value = null;
    try {
      const z = await t.jsonFetch(
        a("/api/auth/s3-keys")
      );
      i.value = Array.isArray(z == null ? void 0 : z.keys) ? z.keys : [], r.value = {
        endpoint: (z == null ? void 0 : z.endpoint) ?? "",
        enabled: (z == null ? void 0 : z.enabled) !== !1,
        path_style: (z == null ? void 0 : z.path_style) !== !1
      }, v.value = !0;
    } catch (z) {
      i.value = [];
      const D = $(z);
      D === 401 || D === 403 ? v.value = !1 : (v.value = !1, p.value = w(z));
    } finally {
      l.value = !1, c.value = !0;
    }
  }
  async function b(z) {
    p.value = null, m.value = null;
    try {
      const D = await t.jsonFetch(a("/api/auth/s3-keys"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(z)
      });
      return x.value = D, D != null && D.endpoint && (r.value = {
        endpoint: D.endpoint,
        enabled: D.enabled !== !1,
        path_style: D.path_style !== !1
      }), await k(), D;
    } catch (D) {
      return p.value = w(D), null;
    }
  }
  async function C(z, D) {
    p.value = null, m.value = null;
    try {
      await t.jsonFetch(a(`/api/auth/s3-keys/${z}/state`), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ disabled: D })
      }), await k();
    } catch (U) {
      p.value = w(U);
    }
  }
  async function T(z) {
    var D, U;
    p.value = null, m.value = null;
    try {
      await t.jsonFetch(a(`/api/auth/s3-keys/${z}`), { method: "DELETE" }), ((U = (D = x.value) == null ? void 0 : D.key) == null ? void 0 : U.id) === z && (x.value = null), await k();
    } catch (H) {
      p.value = w(H);
    }
  }
  function E() {
    x.value = null;
  }
  const R = A(() => {
    var D;
    if ((D = x.value) != null && D.key) return x.value.key;
    const z = i.value.filter((U) => !U.disabled_at);
    return z.length ? z.reduce((U, H) => U.created_at >= H.created_at ? U : H) : null;
  });
  return {
    keys: i,
    connection: r,
    loading: l,
    loaded: c,
    error: p,
    errorHint: m,
    canMint: v,
    revealed: x,
    guideKey: R,
    load: k,
    create: b,
    setDisabled: C,
    remove: T,
    dismissSecret: E
  };
}
const fG = {
  class: "fe-s3keys",
  "data-testid": "s3-keys"
}, pG = { class: "fe-s3keys__head" }, hG = { class: "fe-s3keys__title" }, mG = { class: "fe-s3keys__lead" }, vG = {
  key: 0,
  class: "fe-s3keys__warn"
}, yG = {
  key: 1,
  class: "fe-s3keys__muted"
}, gG = {
  key: 2,
  class: "fe-s3keys__warn"
}, bG = {
  key: 3,
  class: "fe-s3keys__hint",
  "data-testid": "s3keys-admin-hint"
}, kG = {
  key: 4,
  class: "fe-s3keys__form"
}, wG = ["placeholder"], _G = ["placeholder", "disabled"], xG = ["disabled"], SG = {
  key: 5,
  class: "fe-s3keys__hint"
}, $G = {
  key: 6,
  class: "fe-s3keys__secret",
  "data-testid": "s3-key-secret"
}, TG = { class: "fe-s3keys__once" }, AG = { class: "fe-s3keys__pair" }, EG = { class: "fe-s3keys__k" }, CG = { class: "fe-s3keys__pair" }, zG = { class: "fe-s3keys__k" }, MG = {
  key: 7,
  class: "fe-s3keys__muted"
}, PG = { class: "tbl-mono" }, OG = /* @__PURE__ */ lt({
  __name: "S3KeysPanel",
  props: {
    config: {},
    storages: {}
  },
  emits: ["active"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = A(() => Wi(n.config.locale)), { t: r, formatDate: l } = ht(i), {
      keys: c,
      connection: p,
      loading: m,
      error: v,
      errorHint: x,
      canMint: w,
      revealed: $,
      guideKey: k,
      load: b,
      create: C,
      setDisabled: T,
      remove: E,
      dismissSecret: R
    } = dG(n.config), z = S(""), D = S(""), U = A(() => [
      { value: "", label: r("conn.s3keys.everyBucket") },
      ...n.storages.map((ee) => ({ value: ee, label: ee }))
    ]), H = S(""), L = S(!1), P = S(null), K = S(null);
    let N = null;
    function J() {
      var Y, B, W, F, V;
      const ee = p.value;
      ee && a("active", {
        accessKeyID: ((Y = k.value) == null ? void 0 : Y.access_key_id) ?? "",
        // Only the freshly minted one. Re-emitting a stale secret would put a
        // dead credential into the commands.
        secret: ((W = (B = $.value) == null ? void 0 : B.key) == null ? void 0 : W.id) === ((F = k.value) == null ? void 0 : F.id) ? (V = $.value) == null ? void 0 : V.secret : void 0,
        endpoint: ee.endpoint,
        pathStyle: ee.path_style
      });
    }
    jt(async () => {
      await b(), J();
    });
    async function j() {
      L.value = !0;
      try {
        await C({
          label: z.value.trim() || r("conn.s3keys.defaultLabel"),
          bucket: D.value.trim() || void 0,
          prefix: H.value.trim() || void 0
        }), z.value = "", J();
      } finally {
        L.value = !1;
      }
    }
    function re(ee) {
      return [
        {
          key: "toggle",
          label: ee.disabled_at ? r("conn.s3keys.enable") : r("conn.s3keys.disable"),
          icon: ee.disabled_at ? "check" : "lock",
          disabled: L.value
        },
        {
          key: "revoke",
          label: P.value === ee.id ? r("conn.s3keys.confirm") : r("conn.s3keys.revoke"),
          icon: "delete",
          danger: !0,
          disabled: L.value
        }
      ];
    }
    const q = A(() => [
      {
        id: "label",
        label: r("conn.s3keys.col.label"),
        sortable: !0,
        width: 180,
        format: (ee) => ee.label || r("conn.s3keys.noLabel")
      },
      {
        id: "key",
        label: r("conn.s3keys.col.key"),
        sortable: !0,
        width: 200,
        sortValue: (ee) => ee.access_key_id,
        title: (ee) => ee.access_key_id
      },
      { id: "scope", label: r("conn.s3keys.col.scope"), sortable: !0, width: 160, format: _ },
      {
        id: "lastUsed",
        label: r("conn.s3keys.col.lastUsed"),
        sortable: !0,
        sortDir: "desc",
        width: 140,
        format: (ee) => ee.last_used_at ? fe(ee.last_used_at) : r("conn.s3keys.neverUsed"),
        sortValue: (ee) => ee.last_used_at ? new Date(ee.last_used_at).getTime() : null
      }
    ]);
    function le(ee, Y) {
      ee === "toggle" ? ve(Y) : ee === "revoke" && ce(Y);
    }
    async function ve(ee) {
      L.value = !0;
      try {
        await T(ee.id, !ee.disabled_at), J();
      } finally {
        L.value = !1;
      }
    }
    async function ce(ee) {
      if (P.value !== ee.id) {
        P.value = ee.id;
        return;
      }
      P.value = null, L.value = !0;
      try {
        await E(ee.id), J();
      } finally {
        L.value = !1;
      }
    }
    async function se(ee, Y) {
      let B = !1;
      try {
        await navigator.clipboard.writeText(ee), B = !0;
      } catch {
        try {
          const W = document.createElement("textarea");
          W.value = ee, W.setAttribute("readonly", ""), W.style.position = "fixed", W.style.opacity = "0", document.body.appendChild(W), W.select(), B = document.execCommand("copy"), document.body.removeChild(W);
        } catch {
          B = !1;
        }
      }
      B && (K.value = Y, N && clearTimeout(N), N = setTimeout(() => K.value = null, 1600));
    }
    function fe(ee) {
      const Y = new Date(ee ?? "").getTime();
      return Number.isNaN(Y) ? "" : l(Y);
    }
    function _(ee) {
      return ee.bucket ? ee.prefix ? `${ee.bucket}/${ee.prefix}` : ee.bucket : r("conn.s3keys.scopeAll");
    }
    return (ee, Y) => (f(), h("section", fG, [
      d("header", pG, [
        d("h4", hG, y(u(r)("conn.s3keys.title")), 1),
        d("p", mG, y(u(r)("conn.s3keys.lead")), 1)
      ]),
      u(p) && !u(p).enabled ? (f(), h("p", vG, y(u(r)("conn.s3keys.disabled")), 1)) : O("", !0),
      u(w) === !1 ? (f(), h("p", yG, y(u(r)("conn.s3keys.cannotMint")), 1)) : O("", !0),
      u(v) ? (f(), h("p", gG, y(u(v)), 1)) : O("", !0),
      u(v) && u(x) ? (f(), h("p", bG, y(u(x)), 1)) : O("", !0),
      u(w) ? (f(), h("div", kG, [
        dn(d("input", {
          "onUpdate:modelValue": Y[0] || (Y[0] = (B) => z.value = B),
          class: "fe-cfield__input",
          placeholder: u(r)("conn.s3keys.label"),
          "data-testid": "s3-key-label"
        }, null, 8, wG), [
          [_n, z.value]
        ]),
        Ze(kc, {
          "model-value": D.value,
          options: U.value,
          "aria-label": u(r)("conn.s3keys.col.scope"),
          testid: "s3-key-bucket",
          "onUpdate:modelValue": Y[1] || (Y[1] = (B) => D.value = String(B))
        }, null, 8, ["model-value", "options", "aria-label"]),
        dn(d("input", {
          "onUpdate:modelValue": Y[2] || (Y[2] = (B) => H.value = B),
          class: "fe-cfield__input",
          placeholder: u(r)("conn.s3keys.prefix"),
          disabled: !D.value,
          "data-testid": "s3-key-prefix"
        }, null, 8, _G), [
          [_n, H.value]
        ]),
        d("button", {
          class: "fe-s3keys__btn",
          disabled: L.value,
          "data-testid": "s3-key-mint",
          onClick: j
        }, y(u(r)("conn.s3keys.mint")), 9, xG)
      ])) : O("", !0),
      u(w) ? (f(), h("p", SG, y(u(r)("conn.s3keys.inheritNote")), 1)) : O("", !0),
      u($) ? (f(), h("div", $G, [
        d("p", TG, y(u(r)("conn.s3keys.once")), 1),
        d("div", AG, [
          d("span", EG, y(u(r)("conn.s3keys.accessKeyID")), 1),
          d("code", null, y(u($).key.access_key_id), 1),
          d("button", {
            class: "fe-s3keys__copy",
            onClick: Y[3] || (Y[3] = (B) => se(u($).key.access_key_id, "akid"))
          }, y(K.value === "akid" ? u(r)("conn.guide.copied") : u(r)("conn.guide.copy")), 1)
        ]),
        d("div", CG, [
          d("span", zG, y(u(r)("conn.s3keys.secret")), 1),
          d("code", null, y(u($).secret), 1),
          d("button", {
            class: "fe-s3keys__copy",
            onClick: Y[4] || (Y[4] = (B) => se(u($).secret, "secret"))
          }, y(K.value === "secret" ? u(r)("conn.guide.copied") : u(r)("conn.guide.copy")), 1)
        ]),
        d("button", {
          class: "fe-s3keys__dismiss",
          onClick: Y[5] || (Y[5] = //@ts-ignore
          (...B) => u(R) && u(R)(...B))
        }, y(u(r)("conn.s3keys.dismiss")), 1)
      ])) : O("", !0),
      u(m) ? (f(), h("p", MG, "…")) : (f(), Ge(os, {
        key: 8,
        "table-id": "conn.s3keys",
        columns: q.value,
        rows: u(c),
        "row-key": "id",
        locale: i.value,
        empty: u(r)("conn.s3keys.empty"),
        "row-class": (B) => B.disabled_at ? "is-muted" : void 0,
        "row-actions": re,
        "row-actions-test-id": (B) => `s3-key-actions-${B.id}`,
        onRowAction: Y[6] || (Y[6] = (B, W) => le(B, W))
      }, {
        "cell-key": mt(({ row: B }) => [
          d("code", PG, y(B.access_key_id), 1)
        ]),
        _: 1
      }, 8, ["columns", "rows", "locale", "empty", "row-class", "row-actions-test-id"]))
    ]));
  }
});
function LG(e) {
  const t = Rl(e), n = ca(e), a = (T) => `${n}${T}`, i = Ea([]), r = S(null), l = S(!1), c = S(!1), p = S(null), m = S(null);
  function v(T) {
    return Za(T, e.locale);
  }
  function x(T) {
    return T == null ? void 0 : T.status;
  }
  async function w() {
    l.value = !0, p.value = null;
    try {
      const T = await t.jsonFetch(
        a("/api/auth/ssh-keys")
      );
      i.value = Array.isArray(T == null ? void 0 : T.keys) ? T.keys : [], r.value = {
        enabled: (T == null ? void 0 : T.enabled) !== !1,
        host: (T == null ? void 0 : T.host) ?? "",
        port: (T == null ? void 0 : T.port) ?? 2022,
        login: (T == null ? void 0 : T.login) ?? "",
        ftps: T == null ? void 0 : T.ftps
      }, m.value = !0;
    } catch (T) {
      i.value = [], m.value = !1, x(T) !== 401 && x(T) !== 403 && (p.value = v(T));
    } finally {
      l.value = !1, c.value = !0;
    }
  }
  async function $(T, E) {
    p.value = null;
    try {
      return await t.jsonFetch(a("/api/auth/ssh-keys"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ key: T, name: E })
      }), await w(), !0;
    } catch (R) {
      return p.value = v(R), !1;
    }
  }
  async function k(T, E) {
    p.value = null;
    try {
      await t.jsonFetch(a(`/api/auth/ssh-keys/${T}/state`), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ disabled: E })
      }), await w();
    } catch (R) {
      p.value = v(R);
    }
  }
  async function b(T) {
    p.value = null;
    try {
      await t.jsonFetch(a(`/api/auth/ssh-keys/${T}`), { method: "DELETE" }), await w();
    } catch (E) {
      p.value = v(E);
    }
  }
  const C = A(() => i.value.some((T) => !T.disabled_at));
  return { keys: i, connection: r, loading: l, loaded: c, error: p, canAdd: m, hasUsableKey: C, load: w, add: $, setDisabled: k, remove: b };
}
const DG = {
  key: 0,
  class: "fe-s3keys",
  "data-testid": "ssh-keys"
}, RG = { class: "fe-s3keys__head" }, NG = { class: "fe-s3keys__title" }, IG = { class: "fe-s3keys__lead" }, BG = {
  key: 0,
  class: "fe-s3keys__warn"
}, FG = {
  key: 1,
  class: "fe-s3keys__muted"
}, UG = {
  key: 2,
  class: "fe-s3keys__warn"
}, HG = {
  key: 3,
  class: "fe-sshkeys__form"
}, KG = ["placeholder"], VG = { class: "fe-sshkeys__row" }, jG = ["placeholder"], qG = ["disabled"], WG = { class: "fe-s3keys__hint" }, YG = {
  key: 4,
  class: "fe-s3keys__muted"
}, GG = { class: "tbl-mono" }, XG = /* @__PURE__ */ lt({
  __name: "SSHKeysPanel",
  props: {
    config: {},
    keysVisible: { type: Boolean }
  },
  emits: ["active"],
  setup(e, { emit: t }) {
    const n = e, a = A(() => n.keysVisible !== !1), i = t, r = A(() => Wi(n.config.locale)), { t: l, formatDate: c } = ht(r), { keys: p, connection: m, loading: v, error: x, canAdd: w, hasUsableKey: $, load: k, add: b, setDisabled: C, remove: T } = LG(n.config), E = S(""), R = S(""), z = S(!1), D = S(null);
    function U() {
      const q = m.value;
      q && i("active", {
        host: q.host,
        port: q.port,
        login: q.login,
        enabled: q.enabled,
        hasKey: $.value,
        // The FTPS endpoint travels with the SSH facts: for the user this is one
        // question ("how do I reach this from a program?"), and two calls to
        // answer it would be two chances to disagree.
        ftps: q.ftps
      });
    }
    jt(async () => {
      await k(), U();
    });
    async function H() {
      if (E.value.trim()) {
        z.value = !0;
        try {
          await b(E.value.trim(), R.value.trim() || void 0) && (E.value = "", R.value = ""), U();
        } finally {
          z.value = !1;
        }
      }
    }
    function L(q) {
      return [
        {
          key: "toggle",
          label: q.disabled_at ? l("conn.sshkeys.enable") : l("conn.sshkeys.disable"),
          icon: q.disabled_at ? "check" : "lock",
          disabled: z.value
        },
        {
          key: "remove",
          label: D.value === q.id ? l("conn.sshkeys.confirm") : l("conn.sshkeys.remove"),
          icon: "delete",
          danger: !0,
          disabled: z.value
        }
      ];
    }
    const P = A(() => [
      {
        id: "name",
        label: l("conn.sshkeys.col.name"),
        sortable: !0,
        width: 180,
        format: (q) => q.name || l("conn.sshkeys.noName")
      },
      {
        id: "fingerprint",
        label: l("conn.sshkeys.col.fingerprint"),
        sortable: !0,
        width: 240,
        sortValue: (q) => re(q),
        title: (q) => re(q)
      },
      {
        id: "lastUsed",
        label: l("conn.sshkeys.col.lastUsed"),
        sortable: !0,
        sortDir: "desc",
        width: 140,
        format: (q) => q.last_used_at ? j(q.last_used_at) : l("conn.sshkeys.neverUsed"),
        sortValue: (q) => q.last_used_at ? new Date(q.last_used_at).getTime() : null
      }
    ]);
    function K(q, le) {
      q === "toggle" ? N(le) : q === "remove" && J(le);
    }
    async function N(q) {
      z.value = !0;
      try {
        await C(q.id, !q.disabled_at), U();
      } finally {
        z.value = !1;
      }
    }
    async function J(q) {
      if (D.value !== q.id) {
        D.value = q.id;
        return;
      }
      D.value = null, z.value = !0;
      try {
        await T(q.id), U();
      } finally {
        z.value = !1;
      }
    }
    function j(q) {
      const le = new Date(q ?? "").getTime();
      return Number.isNaN(le) ? "" : c(le);
    }
    function re(q) {
      return "SHA256:" + q.fingerprint;
    }
    return (q, le) => a.value ? (f(), h("section", DG, [
      d("header", RG, [
        d("h4", NG, y(u(l)("conn.sshkeys.title")), 1),
        d("p", IG, y(u(l)("conn.sshkeys.lead")), 1)
      ]),
      u(m) && !u(m).enabled ? (f(), h("p", BG, y(u(l)("conn.sshkeys.disabled")), 1)) : O("", !0),
      u(w) === !1 ? (f(), h("p", FG, y(u(l)("conn.sshkeys.cannotAdd")), 1)) : O("", !0),
      u(x) ? (f(), h("p", UG, y(u(x)), 1)) : O("", !0),
      u(w) ? (f(), h("div", HG, [
        dn(d("textarea", {
          "onUpdate:modelValue": le[0] || (le[0] = (ve) => E.value = ve),
          class: "fe-cfield__input fe-sshkeys__paste",
          rows: "2",
          spellcheck: "false",
          placeholder: u(l)("conn.sshkeys.paste"),
          "data-testid": "ssh-key-input"
        }, null, 8, KG), [
          [_n, E.value]
        ]),
        d("div", VG, [
          dn(d("input", {
            "onUpdate:modelValue": le[1] || (le[1] = (ve) => R.value = ve),
            class: "fe-cfield__input",
            placeholder: u(l)("conn.sshkeys.name"),
            "data-testid": "ssh-key-name"
          }, null, 8, jG), [
            [_n, R.value]
          ]),
          d("button", {
            class: "fe-s3keys__btn",
            disabled: z.value,
            "data-testid": "ssh-key-add",
            onClick: H
          }, y(u(l)("conn.sshkeys.add")), 9, qG)
        ]),
        d("p", WG, y(u(l)("conn.sshkeys.noCopyId")), 1)
      ])) : O("", !0),
      u(v) ? (f(), h("p", YG, "…")) : (f(), Ge(os, {
        key: 5,
        "table-id": "conn.sshkeys",
        columns: P.value,
        rows: u(p),
        "row-key": "id",
        locale: r.value,
        empty: u(l)("conn.sshkeys.empty"),
        "row-class": (ve) => ve.disabled_at ? "is-muted" : void 0,
        "row-actions": L,
        "row-actions-test-id": (ve) => `ssh-key-actions-${ve.id}`,
        onRowAction: le[2] || (le[2] = (ve, ce) => K(ve, ce))
      }, {
        "cell-fingerprint": mt(({ row: ve }) => [
          d("code", GG, y(re(ve)), 1)
        ]),
        _: 1
      }, 8, ["columns", "rows", "locale", "empty", "row-class", "row-actions-test-id"]))
    ])) : O("", !0);
  }
});
function JG(e) {
  const t = Rl(e), n = ca(e), a = (R) => `${n}${R}`, i = Ea([]), r = S(null), l = S(!1), c = S(!1), p = S(null), m = S(null), v = S(null);
  function x(R) {
    return Za(R, e.locale);
  }
  function w(R) {
    return R == null ? void 0 : R.status;
  }
  async function $() {
    l.value = !0, p.value = null;
    try {
      const R = await t.jsonFetch(
        a("/api/auth/nfs-exports")
      );
      i.value = Array.isArray(R == null ? void 0 : R.exports) ? R.exports : [], r.value = {
        enabled: (R == null ? void 0 : R.enabled) !== !1,
        host: (R == null ? void 0 : R.host) ?? "",
        port: (R == null ? void 0 : R.port) ?? 2049
      }, m.value = !0;
    } catch (R) {
      i.value = [], m.value = !1, w(R) !== 401 && w(R) !== 403 && (p.value = x(R));
    } finally {
      l.value = !1, c.value = !0;
    }
  }
  async function k(R) {
    p.value = null;
    try {
      const z = await t.jsonFetch(a("/api/auth/nfs-exports"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(R)
      });
      return v.value = z, z != null && z.host && (r.value = { enabled: z.enabled !== !1, host: z.host, port: z.port }), await $(), z;
    } catch (z) {
      return p.value = x(z), null;
    }
  }
  async function b(R, z) {
    p.value = null;
    try {
      await t.jsonFetch(a(`/api/auth/nfs-exports/${R}/state`), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ disabled: z })
      }), await $();
    } catch (D) {
      p.value = x(D);
    }
  }
  async function C(R) {
    var z, D;
    p.value = null;
    try {
      await t.jsonFetch(a(`/api/auth/nfs-exports/${R}`), { method: "DELETE" }), ((D = (z = v.value) == null ? void 0 : z.export) == null ? void 0 : D.id) === R && (v.value = null), await $();
    } catch (U) {
      p.value = x(U);
    }
  }
  function T() {
    v.value = null;
  }
  const E = A(() => {
    var z;
    if ((z = v.value) != null && z.export) return v.value.export;
    const R = i.value.filter((D) => !D.disabled_at);
    return R.length ? R.reduce((D, U) => D.created_at >= U.created_at ? D : U) : null;
  });
  return {
    exports: i,
    connection: r,
    loading: l,
    loaded: c,
    error: p,
    canMint: m,
    revealed: v,
    guideExport: E,
    load: $,
    create: k,
    setDisabled: b,
    remove: C,
    dismissPath: T
  };
}
const ZG = {
  class: "fe-s3keys",
  "data-testid": "nfs-exports"
}, QG = { class: "fe-s3keys__head" }, eX = { class: "fe-s3keys__title" }, tX = { class: "fe-s3keys__lead" }, nX = { class: "fe-s3keys__warn" }, aX = {
  key: 0,
  class: "fe-s3keys__warn"
}, iX = {
  key: 1,
  class: "fe-s3keys__muted"
}, oX = {
  key: 2,
  class: "fe-s3keys__warn"
}, rX = {
  key: 3,
  class: "fe-s3keys__form fe-nfs__form"
}, sX = ["placeholder"], lX = ["placeholder", "disabled"], uX = ["placeholder"], cX = { class: "fe-nfs__ro" }, dX = ["disabled"], fX = {
  key: 4,
  class: "fe-s3keys__hint"
}, pX = {
  key: 5,
  class: "fe-s3keys__secret",
  "data-testid": "nfs-path"
}, hX = { class: "fe-s3keys__once" }, mX = { class: "fe-s3keys__pair" }, vX = {
  key: 6,
  class: "fe-s3keys__muted"
}, yX = /* @__PURE__ */ lt({
  __name: "NFSExportsPanel",
  props: {
    config: {},
    storages: {}
  },
  emits: ["active"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = A(() => Wi(n.config.locale)), { t: r, formatDate: l } = ht(i), {
      exports: c,
      connection: p,
      loading: m,
      error: v,
      canMint: x,
      revealed: w,
      guideExport: $,
      load: k,
      create: b,
      setDisabled: C,
      remove: T,
      dismissPath: E
    } = JG(n.config), R = S(""), z = S(""), D = A(() => [
      { value: "", label: r("conn.nfs.everyStorage") },
      ...n.storages.map((B) => ({ value: B, label: B }))
    ]), U = S(""), H = S(!0), L = S(""), P = S(!1), K = S(null), N = S(!1);
    let J = null;
    function j() {
      var W, F;
      const B = p.value;
      B && a("active", {
        host: B.host,
        port: B.port,
        enabled: B.enabled,
        // Only the freshly minted path — the stored ones cannot be recovered, and
        // printing a placeholder in a mount line somebody copies would produce a
        // command that fails with no clue why.
        path: (W = w.value) == null ? void 0 : W.path,
        readOnly: ((F = $.value) == null ? void 0 : F.read_only) ?? H.value
      });
    }
    jt(async () => {
      await k(), j();
    });
    async function re() {
      P.value = !0;
      try {
        await b({
          label: R.value.trim() || r("conn.nfs.defaultLabel"),
          storage: z.value.trim() || void 0,
          prefix: U.value.trim() || void 0,
          read_only: H.value,
          allow_cidrs: L.value.trim() || void 0
        }), R.value = "", j();
      } finally {
        P.value = !1;
      }
    }
    function q(B) {
      return [
        {
          key: "toggle",
          label: B.disabled_at ? r("conn.nfs.enable") : r("conn.nfs.disable"),
          icon: B.disabled_at ? "check" : "lock",
          disabled: P.value
        },
        {
          key: "revoke",
          label: K.value === B.id ? r("conn.nfs.confirm") : r("conn.nfs.revoke"),
          icon: "delete",
          danger: !0,
          disabled: P.value
        }
      ];
    }
    const le = A(() => [
      {
        id: "label",
        label: r("conn.nfs.col.label"),
        sortable: !0,
        width: 180,
        format: (B) => B.label || r("conn.nfs.noLabel")
      },
      { id: "scope", label: r("conn.nfs.col.scope"), sortable: !0, width: 180, format: Y },
      {
        id: "mode",
        label: r("conn.nfs.col.mode"),
        sortable: !0,
        width: 120,
        format: (B) => B.read_only ? r("conn.nfs.modeRead") : r("conn.nfs.modeWrite")
      },
      {
        id: "lastUsed",
        label: r("conn.nfs.col.lastUsed"),
        sortable: !0,
        sortDir: "desc",
        width: 140,
        format: (B) => B.last_used_at ? ee(B.last_used_at) : r("conn.nfs.neverUsed"),
        sortValue: (B) => B.last_used_at ? new Date(B.last_used_at).getTime() : null
      }
    ]);
    function ve(B, W) {
      B === "toggle" ? ce(W) : B === "revoke" && se(W);
    }
    async function ce(B) {
      P.value = !0;
      try {
        await C(B.id, !B.disabled_at), j();
      } finally {
        P.value = !1;
      }
    }
    async function se(B) {
      if (K.value !== B.id) {
        K.value = B.id;
        return;
      }
      K.value = null, P.value = !0;
      try {
        await T(B.id), j();
      } finally {
        P.value = !1;
      }
    }
    const fe = A(() => {
      var V, ke, qe;
      const B = p.value, W = (V = w.value) == null ? void 0 : V.path;
      if (!B || !W) return "";
      const F = (qe = (ke = w.value) == null ? void 0 : ke.export) != null && qe.read_only ? ",ro" : "";
      return `sudo mount -t nfs -o nfsvers=3,tcp,port=${B.port},mountport=${B.port},nolock${F} ${B.host}:${W} /mnt/filex`;
    });
    async function _() {
      const B = fe.value;
      if (!B) return;
      let W = !1;
      try {
        await navigator.clipboard.writeText(B), W = !0;
      } catch {
        try {
          const F = document.createElement("textarea");
          F.value = B, F.setAttribute("readonly", ""), F.style.position = "fixed", F.style.opacity = "0", document.body.appendChild(F), F.select(), W = document.execCommand("copy"), document.body.removeChild(F);
        } catch {
          W = !1;
        }
      }
      W && (N.value = !0, J && clearTimeout(J), J = setTimeout(() => N.value = !1, 1600));
    }
    function ee(B) {
      const W = new Date(B ?? "").getTime();
      return Number.isNaN(W) ? "" : l(W);
    }
    function Y(B) {
      return B.storage_name ? B.prefix ? `${B.storage_name}/${B.prefix}` : B.storage_name : r("conn.nfs.scopeAll");
    }
    return (B, W) => (f(), h("section", ZG, [
      d("header", QG, [
        d("h4", eX, y(u(r)("conn.nfs.title")), 1),
        d("p", tX, y(u(r)("conn.nfs.lead")), 1)
      ]),
      d("p", nX, y(u(r)("conn.nfs.pathIsSecret")), 1),
      u(p) && !u(p).enabled ? (f(), h("p", aX, y(u(r)("conn.nfs.disabled")), 1)) : O("", !0),
      u(x) === !1 ? (f(), h("p", iX, y(u(r)("conn.nfs.cannotMint")), 1)) : O("", !0),
      u(v) ? (f(), h("p", oX, y(u(v)), 1)) : O("", !0),
      u(x) ? (f(), h("div", rX, [
        dn(d("input", {
          "onUpdate:modelValue": W[0] || (W[0] = (F) => R.value = F),
          class: "fe-cfield__input",
          placeholder: u(r)("conn.nfs.label"),
          "data-testid": "nfs-label"
        }, null, 8, sX), [
          [_n, R.value]
        ]),
        Ze(kc, {
          "model-value": z.value,
          options: D.value,
          "aria-label": u(r)("conn.nfs.col.scope"),
          testid: "nfs-storage",
          "onUpdate:modelValue": W[1] || (W[1] = (F) => z.value = String(F))
        }, null, 8, ["model-value", "options", "aria-label"]),
        dn(d("input", {
          "onUpdate:modelValue": W[2] || (W[2] = (F) => U.value = F),
          class: "fe-cfield__input",
          placeholder: u(r)("conn.nfs.prefix"),
          disabled: !z.value,
          "data-testid": "nfs-prefix"
        }, null, 8, lX), [
          [_n, U.value]
        ]),
        dn(d("input", {
          "onUpdate:modelValue": W[3] || (W[3] = (F) => L.value = F),
          class: "fe-cfield__input",
          placeholder: u(r)("conn.nfs.allowCidrs"),
          "data-testid": "nfs-cidrs"
        }, null, 8, uX), [
          [_n, L.value]
        ]),
        d("label", cX, [
          dn(d("input", {
            type: "checkbox",
            "onUpdate:modelValue": W[4] || (W[4] = (F) => H.value = F),
            "data-testid": "nfs-readonly"
          }, null, 512), [
            [zc, H.value]
          ]),
          Ht(" " + y(u(r)("conn.nfs.readOnly")), 1)
        ]),
        d("button", {
          class: "fe-s3keys__btn",
          disabled: P.value,
          "data-testid": "nfs-mint",
          onClick: re
        }, y(u(r)("conn.nfs.mint")), 9, dX)
      ])) : O("", !0),
      u(x) ? (f(), h("p", fX, y(u(r)("conn.nfs.readOnlyHint")), 1)) : O("", !0),
      u(w) ? (f(), h("div", pX, [
        d("p", hX, y(u(r)("conn.nfs.once")), 1),
        d("div", mX, [
          d("code", null, y(fe.value), 1),
          d("button", {
            class: "fe-s3keys__copy",
            onClick: _
          }, y(N.value ? u(r)("conn.guide.copied") : u(r)("conn.guide.copy")), 1)
        ]),
        d("button", {
          class: "fe-s3keys__dismiss",
          onClick: W[5] || (W[5] = //@ts-ignore
          (...F) => u(E) && u(E)(...F))
        }, y(u(r)("conn.nfs.dismiss")), 1)
      ])) : O("", !0),
      u(m) ? (f(), h("p", vX, "…")) : (f(), Ge(os, {
        key: 7,
        "table-id": "conn.nfs",
        columns: le.value,
        rows: u(c),
        "row-key": "id",
        locale: i.value,
        empty: u(r)("conn.nfs.empty"),
        "row-class": (F) => F.disabled_at ? "is-muted" : void 0,
        "row-actions": q,
        "row-actions-test-id": (F) => `nfs-export-actions-${F.id}`,
        onRowAction: W[6] || (W[6] = (F, V) => ve(F, V))
      }, null, 8, ["columns", "rows", "locale", "empty", "row-class", "row-actions-test-id"]))
    ]));
  }
});
function gX(e) {
  const t = Rl(e), n = ca(e), a = (T) => `${n}${T}`, i = Ea([]), r = S(!1), l = S(!1), c = S(null), p = S(null), m = S(null);
  function v(T) {
    return Za(T, e.locale);
  }
  function x(T) {
    return T == null ? void 0 : T.status;
  }
  async function w() {
    r.value = !0, c.value = null;
    try {
      const T = await t.jsonFetch(a("/api/tokens"));
      i.value = Array.isArray(T == null ? void 0 : T.tokens) ? T.tokens : [], p.value = !0;
    } catch (T) {
      i.value = [];
      const E = x(T);
      p.value = !1, E !== 401 && E !== 403 && (c.value = v(T));
    } finally {
      r.value = !1, l.value = !0;
    }
  }
  async function $(T) {
    c.value = null;
    try {
      const E = await t.jsonFetch(a("/api/tokens"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(T)
      });
      return m.value = E, await w(), E;
    } catch (E) {
      return c.value = v(E), null;
    }
  }
  async function k(T) {
    var E, R;
    c.value = null;
    try {
      await t.jsonFetch(a(`/api/tokens/${T}`), { method: "DELETE" }), ((R = (E = m.value) == null ? void 0 : E.row) == null ? void 0 : R.id) === T && (m.value = null), await w();
    } catch (z) {
      c.value = v(z);
    }
  }
  async function b(T, E) {
    c.value = null;
    try {
      return await t.jsonFetch(a(`/api/tokens/${T}`), {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ permissions: E })
      }), await w(), !0;
    } catch (R) {
      return c.value = v(R), !1;
    }
  }
  function C() {
    m.value = null;
  }
  return { tokens: i, loading: r, loaded: l, error: c, canMint: p, revealed: m, load: w, create: $, remove: k, setPermissions: b, dismiss: C };
}
const bX = {
  class: "fe-s3keys",
  "data-testid": "api-tokens"
}, kX = { class: "fe-s3keys__head" }, wX = { class: "fe-s3keys__title" }, _X = { class: "fe-s3keys__lead" }, xX = {
  key: 0,
  class: "fe-s3keys__muted"
}, SX = {
  key: 1,
  class: "fe-s3keys__warn"
}, $X = {
  key: 2,
  class: "fe-s3keys__form"
}, TX = ["placeholder"], AX = ["disabled"], EX = {
  key: 3,
  class: "fe-tokform",
  "data-testid": "token-form-full"
}, CX = ["placeholder"], zX = { class: "fe-tokform__scopes" }, MX = { class: "fe-tokform__legend" }, PX = ["onUpdate:modelValue", "data-testid"], OX = {
  key: 0,
  class: "fe-s3keys__hint fe-tokform__required",
  role: "alert",
  "data-testid": "token-scopes-required"
}, LX = { class: "fe-tokform__field" }, DX = {
  id: "token-comments-label",
  class: "fe-tokform__label"
}, RX = { class: "fe-s3keys__hint" }, NX = { class: "fe-tokform__field" }, IX = { class: "fe-tokform__label" }, BX = ["placeholder"], FX = { class: "fe-tokform__row" }, UX = { class: "fe-tokform__field fe-tokform__field--narrow" }, HX = { class: "fe-tokform__label" }, KX = ["placeholder"], VX = ["disabled"], jX = { class: "fe-s3keys__hint" }, qX = {
  key: 4,
  class: "fe-s3keys__secret",
  "data-testid": "token-secret"
}, WX = { class: "fe-s3keys__once" }, YX = { class: "fe-s3keys__pair" }, GX = {
  key: 5,
  class: "fe-s3keys__muted"
}, XX = { class: "tbl-mono" }, JX = {
  key: 7,
  class: "fe-s3keys__hint"
}, wT = /* @__PURE__ */ lt({
  __name: "TokensPanel",
  props: {
    config: {},
    full: { type: Boolean },
    protocol: {},
    host: {}
  },
  emits: ["active"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = A(() => Wi(n.config.locale)), { t: r, formatDate: l } = ht(i), { tokens: c, loading: p, error: m, canMint: v, revealed: x, load: w, create: $, remove: k, setPermissions: b, dismiss: C } = gX(
      n.config
    ), T = S(""), E = S(!1), R = S(!1), z = S(null), D = ["read", "write", "delete", "mcp"], U = S({
      read: !0,
      write: !1,
      delete: !1,
      mcp: !1
    }), H = S(""), L = S(null), P = S("read"), K = A(() => [
      { value: "read", label: r("conn.tokens.commentsRead") },
      { value: "rw", label: r("conn.tokens.commentsRw") }
    ]);
    function N(W) {
      var F;
      return ((F = W.permissions) == null ? void 0 : F.comments) === "rw" ? r("conn.tokens.commentsRw") : r("conn.tokens.commentsRead");
    }
    const J = A(() => !D.some((W) => U.value[W]));
    function j() {
      const W = D.filter((V) => U.value[V]), F = H.value.trim();
      return F && W.push("root:" + F), P.value === "rw" && W.push("comments:rw"), W.join(",");
    }
    jt(async () => {
      await w(), a("active", { hasToken: c.value.length > 0 });
    });
    function re() {
      const W = (n.protocol || "").toUpperCase();
      return W ? n.host ? `${W} - ${n.host}` : W : r("conn.tokens.defaultName", { date: (/* @__PURE__ */ new Date()).toISOString().slice(0, 10) });
    }
    function q() {
      return n.protocol ? re() : r("conn.tokens.namePlaceholder");
    }
    async function le() {
      if (!E.value) {
        E.value = !0, R.value = !1;
        try {
          if (n.full) {
            if (J.value) return;
            const W = j();
            await $({
              label: T.value.trim() || re(),
              scopes: W,
              expires_in_days: L.value && L.value > 0 ? L.value : void 0
            }), await w(), a("active", { hasToken: c.value.length > 0 }), T.value = "", H.value = "", P.value = "read";
            return;
          }
          await $({ label: T.value.trim() || re(), scopes: "read,write,delete" }), await w(), a("active", { hasToken: c.value.length > 0 }), T.value = "";
        } finally {
          E.value = !1;
        }
      }
    }
    const ve = A(() => [
      {
        id: "label",
        label: r("conn.tokens.col.label"),
        sortable: !0,
        width: 200,
        format: (W) => W.label || "-"
      },
      { id: "scopes", label: r("conn.tokens.col.scopes"), sortable: !0, width: 200 },
      {
        id: "comments",
        label: r("conn.tokens.col.comments"),
        sortable: !0,
        width: 140,
        format: N
      },
      {
        id: "used",
        label: r("conn.tokens.col.used"),
        sortable: !0,
        sortDir: "desc",
        width: 140,
        format: B,
        sortValue: (W) => W.last_used_at ? new Date(W.last_used_at).getTime() : null
      }
    ]);
    function ce(W) {
      var V;
      const F = ((V = W.permissions) == null ? void 0 : V.comments) === "rw";
      return [
        {
          key: "comments",
          label: r(F ? "conn.tokens.commentsToRead" : "conn.tokens.commentsToRw"),
          icon: "rename",
          disabled: E.value
        },
        {
          key: "revoke",
          label: z.value === W.id ? r("conn.tokens.confirm") : r("conn.tokens.revoke"),
          icon: "delete",
          danger: !0,
          /* The whole control used to be `:disabled="busy"`; the table draws the
             control, so the verb carries it — RowActions greys a button with
             nothing usable behind it. */
          disabled: E.value
        }
      ];
    }
    function se(W, F) {
      W === "revoke" ? _(F) : W === "comments" && fe(F);
    }
    async function fe(W) {
      var F;
      E.value = !0;
      try {
        await b(W.id, { comments: ((F = W.permissions) == null ? void 0 : F.comments) === "rw" ? "read" : "rw" });
      } finally {
        E.value = !1;
      }
    }
    async function _(W) {
      if (z.value !== W.id) {
        z.value = W.id;
        return;
      }
      z.value = null, E.value = !0;
      try {
        await k(W.id), a("active", { hasToken: c.value.length > 0 });
      } finally {
        E.value = !1;
      }
    }
    async function ee() {
      var W;
      if ((W = x.value) != null && W.token)
        try {
          await navigator.clipboard.writeText(x.value.token), R.value = !0, window.setTimeout(() => R.value = !1, 1600);
        } catch {
        }
    }
    function Y(W) {
      const F = new Date(W ?? "").getTime();
      return Number.isNaN(F) ? "" : l(F);
    }
    function B(W) {
      return W.last_used_at ? Y(W.last_used_at) : r("conn.tokens.neverUsed");
    }
    return (W, F) => (f(), h("section", bX, [
      d("header", kX, [
        d("h4", wX, y(u(r)("conn.tokens.title")), 1),
        d("p", _X, y(u(r)("conn.tokens.lead")), 1)
      ]),
      u(v) === !1 ? (f(), h("p", xX, y(u(r)("conn.tokens.cannotMint")), 1)) : O("", !0),
      u(m) ? (f(), h("p", SX, y(u(m)), 1)) : O("", !0),
      u(v) && !e.full ? (f(), h("div", $X, [
        dn(d("input", {
          "onUpdate:modelValue": F[0] || (F[0] = (V) => T.value = V),
          class: "fe-cfield__input",
          placeholder: q(),
          "data-testid": "token-label"
        }, null, 8, TX), [
          [_n, T.value]
        ]),
        d("button", {
          class: "fe-s3keys__btn",
          disabled: E.value,
          "data-testid": "token-mint",
          onClick: le
        }, y(u(r)("conn.tokens.mint")), 9, AX)
      ])) : u(v) ? (f(), h("div", EX, [
        dn(d("input", {
          "onUpdate:modelValue": F[1] || (F[1] = (V) => T.value = V),
          class: "fe-cfield__input",
          placeholder: q(),
          "data-testid": "token-label"
        }, null, 8, CX), [
          [_n, T.value]
        ]),
        d("fieldset", zX, [
          d("legend", MX, y(u(r)("conn.tokens.scopes")), 1),
          (f(), h(Te, null, nt(D, (V) => d("label", {
            key: V,
            class: "fe-tokform__scope"
          }, [
            dn(d("input", {
              "onUpdate:modelValue": (ke) => U.value[V] = ke,
              type: "checkbox",
              "data-testid": `token-scope-${V}`
            }, null, 8, PX), [
              [zc, U.value[V]]
            ]),
            d("span", null, y(V), 1)
          ])), 64)),
          J.value ? (f(), h("p", OX, y(u(r)("conn.tokens.scopesRequired")), 1)) : O("", !0)
        ]),
        d("div", LX, [
          d("span", DX, y(u(r)("conn.tokens.comments")), 1),
          Ze(mi, {
            "model-value": P.value,
            options: K.value,
            "aria-labelledby": "token-comments-label",
            "testid-prefix": "token-comments",
            "onUpdate:modelValue": F[2] || (F[2] = (V) => P.value = V)
          }, null, 8, ["model-value", "options"]),
          d("p", RX, y(u(r)("conn.tokens.commentsHint")), 1)
        ]),
        d("label", NX, [
          d("span", IX, y(u(r)("conn.tokens.root")), 1),
          dn(d("input", {
            "onUpdate:modelValue": F[3] || (F[3] = (V) => H.value = V),
            class: "fe-cfield__input",
            placeholder: u(r)("conn.tokens.rootPlaceholder"),
            "data-testid": "token-root"
          }, null, 8, BX), [
            [_n, H.value]
          ])
        ]),
        d("div", FX, [
          d("label", UX, [
            d("span", HX, y(u(r)("conn.tokens.expiry")), 1),
            dn(d("input", {
              "onUpdate:modelValue": F[4] || (F[4] = (V) => L.value = V),
              type: "number",
              min: "0",
              class: "fe-cfield__input",
              placeholder: u(r)("conn.tokens.expiryNever"),
              "data-testid": "token-expiry"
            }, null, 8, KX), [
              [
                _n,
                L.value,
                void 0,
                { number: !0 }
              ]
            ])
          ]),
          d("button", {
            class: "fe-s3keys__btn",
            disabled: E.value || J.value,
            "data-testid": "token-mint",
            onClick: le
          }, y(u(r)("conn.tokens.mint")), 9, VX)
        ]),
        d("p", jX, y(u(r)("conn.tokens.capNote")), 1)
      ])) : O("", !0),
      u(x) ? (f(), h("div", qX, [
        d("p", WX, y(u(r)("conn.tokens.once")), 1),
        d("div", YX, [
          d("code", null, y(u(x).token), 1),
          d("button", {
            class: "fe-s3keys__copy",
            onClick: ee
          }, y(R.value ? u(r)("conn.guide.copied") : u(r)("conn.guide.copy")), 1)
        ]),
        d("button", {
          class: "fe-s3keys__dismiss",
          onClick: F[5] || (F[5] = //@ts-ignore
          (...V) => u(C) && u(C)(...V))
        }, y(u(r)("conn.tokens.dismiss")), 1)
      ])) : O("", !0),
      u(p) ? (f(), h("p", GX, "…")) : (f(), Ge(os, {
        key: 6,
        "table-id": "conn.tokens",
        columns: ve.value,
        rows: u(c),
        "row-key": "id",
        locale: i.value,
        empty: u(r)("conn.tokens.empty"),
        "row-actions": ce,
        "row-actions-test-id": (V) => `api-token-actions-${V.id}`,
        onRowAction: F[6] || (F[6] = (V, ke) => se(V, ke))
      }, {
        "cell-scopes": mt(({ row: V }) => [
          d("code", XX, y(V.scopes), 1)
        ]),
        _: 1
      }, 8, ["columns", "rows", "locale", "empty", "row-actions-test-id"])),
      u(v) ? (f(), h("p", JX, y(u(r)("conn.tokens.revokeHint")), 1)) : O("", !0)
    ]));
  }
}), ZX = { class: "fe-conn__head" }, QX = { class: "fe-conn__title" }, eJ = { class: "fe-conn__sub" }, tJ = ["aria-label"], nJ = ["innerHTML"], aJ = {
  key: 0,
  class: "fe-conn__error",
  "data-testid": "conn-error"
}, iJ = { class: "fe-conn__body" }, oJ = { class: "fe-conn__guidebar" }, rJ = {
  key: 0,
  class: "fe-conn__pick"
}, sJ = { class: "fe-cfield__label" }, lJ = { class: "fe-conn__pick" }, uJ = { class: "fe-cfield__label" }, cJ = /* @__PURE__ */ lt({
  __name: "ConnectionsPanel",
  props: {
    config: {},
    closable: { type: Boolean }
  },
  emits: ["close", "error"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = A(() => Wi(n.config.locale)), { t: r } = ht(i), { visible: l, me: c, realm: p, publicUrl: m, error: v, load: x } = xY(n.config), w = A(() => {
      var P;
      return PY(((P = c.value) == null ? void 0 : P.email) ?? "", p.value);
    }), $ = Nl(), k = A(() => {
      const P = n.config.theme ?? "auto";
      return P === "light" || P === "dark" ? P : $.value ? "dark" : "light";
    }), b = UY(), C = S(b[0] ?? "webdav"), T = S(""), E = A(() => b.map((P) => ({ value: P, label: FY(P) }))), R = A(() => [
      { value: "", label: r("conn.guide.allStorages") },
      ...l.value.map((P) => ({ value: P, label: P }))
    ]), z = S(
      null
    ), D = A(() => _Y(n.config, m.value)), U = S(
      null
    ), H = S(null), L = A(
      () => {
        var P, K, N, J, j, re, q, le, ve, ce, se, fe, _, ee, Y, B, W, F, V, ke, qe, Me, Fe, We, $t, St;
        return HY(
          C.value,
          {
            origin: D.value,
            user: w.value,
            storages: l.value,
            storage: T.value || void 0,
            s3Endpoint: (P = U.value) == null ? void 0 : P.endpoint,
            s3PathStyle: (K = U.value) == null ? void 0 : K.pathStyle,
            s3AccessKeyID: ((N = U.value) == null ? void 0 : N.accessKeyID) || void 0,
            s3Secret: (J = U.value) == null ? void 0 : J.secret,
            sftpHost: ((j = H.value) == null ? void 0 : j.host) || void 0,
            sftpPort: (re = H.value) == null ? void 0 : re.port,
            sftpEnabled: (q = H.value) == null ? void 0 : q.enabled,
            sftpLogin: ((le = H.value) == null ? void 0 : le.login) || void 0,
            sftpHasKey: (ve = H.value) == null ? void 0 : ve.hasKey,
            ftpsHost: ((se = (ce = H.value) == null ? void 0 : ce.ftps) == null ? void 0 : se.host) || void 0,
            ftpsPort: (_ = (fe = H.value) == null ? void 0 : fe.ftps) == null ? void 0 : _.port,
            ftpsEnabled: (Y = (ee = H.value) == null ? void 0 : ee.ftps) == null ? void 0 : Y.enabled,
            ftpsPasvMin: (W = (B = H.value) == null ? void 0 : B.ftps) == null ? void 0 : W.pasv_min,
            ftpsPasvMax: (V = (F = H.value) == null ? void 0 : F.ftps) == null ? void 0 : V.pasv_max,
            ftpsSelfSigned: (qe = (ke = H.value) == null ? void 0 : ke.ftps) == null ? void 0 : qe.self_signed,
            nfsHost: ((Me = z.value) == null ? void 0 : Me.host) || void 0,
            nfsPort: (Fe = z.value) == null ? void 0 : Fe.port,
            nfsEnabled: (We = z.value) == null ? void 0 : We.enabled,
            nfsPath: ($t = z.value) == null ? void 0 : $t.path,
            nfsReadOnly: (St = z.value) == null ? void 0 : St.readOnly
          },
          r
        );
      }
    );
    return Je(
      () => l.value,
      (P) => {
        !T.value && P.length === 1 && (T.value = P[0]);
      }
    ), jt(() => {
      x();
    }), Je(
      () => [n.config.apiBase, n.config.endpoint],
      () => {
        x();
      }
    ), (P, K) => (f(), h("div", {
      class: Re(["fe-conn", {
        "fe--theme-dark": k.value === "dark",
        "fe--theme-light": k.value === "light"
      }]),
      "data-testid": "connections-panel"
    }, [
      d("header", ZX, [
        d("div", null, [
          d("h2", QX, y(u(r)("conn.title")), 1),
          d("p", eJ, y(u(r)("conn.subtitle", { host: u(ts)(D.value) })), 1)
        ]),
        e.closable ? (f(), h("button", {
          key: 0,
          type: "button",
          class: "fe-conn__btn",
          "data-testid": "connections-close",
          "aria-label": u(r)("conn.close"),
          onClick: K[0] || (K[0] = (N) => a("close"))
        }, [
          d("span", {
            "aria-hidden": "true",
            innerHTML: u(zt)("close")
          }, null, 8, nJ)
        ], 8, tJ)) : O("", !0)
      ]),
      u(v) ? (f(), h("p", aJ, y(u(v)), 1)) : O("", !0),
      d("section", iJ, [
        d("div", oJ, [
          u(b).length > 1 ? (f(), h("label", rJ, [
            d("span", sJ, y(u(r)("conn.guide.protocol")), 1),
            Ze(kc, {
              "model-value": C.value,
              options: E.value,
              testid: "guide-protocol",
              "onUpdate:modelValue": K[1] || (K[1] = (N) => C.value = String(N))
            }, null, 8, ["model-value", "options"])
          ])) : O("", !0),
          d("label", lJ, [
            d("span", uJ, y(u(r)("conn.guide.storage")), 1),
            Ze(kc, {
              "model-value": T.value,
              options: R.value,
              testid: "guide-storage",
              "onUpdate:modelValue": K[2] || (K[2] = (N) => T.value = String(N))
            }, null, 8, ["model-value", "options"])
          ])
        ]),
        C.value === "s3" ? (f(), Ge(OG, {
          key: 0,
          config: e.config,
          storages: u(l),
          onActive: K[3] || (K[3] = (N) => U.value = N)
        }, null, 8, ["config", "storages"])) : O("", !0),
        C.value === "sftp" || C.value === "ftps" ? (f(), Ge(XG, {
          key: 1,
          config: e.config,
          "keys-visible": C.value === "sftp",
          onActive: K[4] || (K[4] = (N) => H.value = N)
        }, null, 8, ["config", "keys-visible"])) : O("", !0),
        C.value === "nfs" ? (f(), Ge(yX, {
          key: 2,
          config: e.config,
          storages: u(l),
          onActive: K[5] || (K[5] = (N) => z.value = N)
        }, null, 8, ["config", "storages"])) : O("", !0),
        C.value === "ftps" || C.value === "webdav" || C.value === "mount" ? (f(), Ge(wT, {
          key: 3,
          config: e.config,
          protocol: C.value,
          host: u(ts)(D.value)
        }, null, 8, ["config", "protocol", "host"])) : O("", !0),
        L.value ? (f(), Ge(cG, {
          key: 4,
          guide: L.value,
          locale: i.value
        }, null, 8, ["guide", "locale"])) : O("", !0)
      ])
    ], 2));
  }
});
function ihe(e = "") {
  return {
    text: "",
    tags: [],
    excludeTags: [],
    scope: "name",
    filters: { ...jo, pathBase: e }
  };
}
function m0(e, t) {
  const n = e.trim();
  if (!n) return "";
  const a = /\s/.test(n) ? `"${n}"` : n;
  return `${t ? "-" : ""}tag:${a}`;
}
function wy(e) {
  const t = [], n = e.text.trim();
  n && t.push(n);
  for (const a of e.tags) {
    const i = m0(a, !1);
    i && t.push(i);
  }
  for (const a of e.excludeTags) {
    const i = m0(a, !0);
    i && t.push(i);
  }
  return t.join(" ");
}
function dJ(e, t = Date.now(), n = {}) {
  const a = {};
  e.type && e.type !== "any" && (a.type = e.type === "folder" ? "dir" : e.type);
  const i = HS(e, t);
  (i == null ? void 0 : i.after) !== void 0 && (a.modified_after = String(Math.floor(i.after))), (i == null ? void 0 : i.before) !== void 0 && (a.modified_before = String(Math.floor(i.before)));
  const r = KS(e);
  (r == null ? void 0 : r.min) !== void 0 && (a.min_size = String(Math.max(0, Math.floor(r.min)))), (r == null ? void 0 : r.max) !== void 0 && (a.max_size = String(Math.max(0, Math.floor(r.max))));
  const l = (e.pathBase ?? "").replace(/\/+$/, "");
  l && e.pathMode === "here" && (a.under = l), l && e.pathMode === "skip" && (a.not_under = l);
  const c = e.people ?? "any";
  return c === "me" || c === "system" ? a.owner = c : c.startsWith("u:") && (a.owner = c.slice(2)), n.showHidden === !1 && (a.hidden = "false"), a;
}
function ohe(e) {
  return wy(e) === "";
}
function rhe(e) {
  return QI(e, { newlines: !0 });
}
function uv(e, t, n) {
  return typeof n == "boolean" ? n : e >= t;
}
const fJ = { class: "fe-shortcuts" }, pJ = { class: "fe-shortcuts__heading" }, hJ = { class: "fe-shortcuts__table" }, mJ = { class: "fe-shortcuts__keys" }, vJ = {
  key: 0,
  class: "fe-shortcuts__unbound"
}, yJ = { class: "fe-kbd" }, gJ = {
  key: 0,
  class: "fe-shortcuts__or",
  "aria-hidden": "true"
}, bJ = { class: "fe-shortcuts__desc" }, kJ = ["title"], wJ = ["innerHTML"], _J = /* @__PURE__ */ lt({
  __name: "ShortcutsHelp",
  props: {
    open: { type: Boolean },
    locale: {}
  },
  emits: ["close", "customize"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = UO(), l = A(() => {
      const c = [], p = /* @__PURE__ */ new Map();
      for (const m of r.value)
        p.has(m.groupKey) || (p.set(m.groupKey, []), c.push(m.groupKey)), p.get(m.groupKey).push(m);
      return c.map((m) => ({ key: m, items: p.get(m) }));
    });
    return (c, p) => (f(), Ge(ta, {
      open: e.open,
      title: u(i)("shortcuts.title"),
      size: "md",
      onClose: p[2] || (p[2] = (m) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          onClick: p[0] || (p[0] = (m) => a("customize"))
        }, [
          d("span", {
            class: "fe-icon",
            "aria-hidden": "true",
            innerHTML: u(zt)("shortcut-settings")
          }, null, 8, wJ),
          Ht(" " + y(u(i)("shortcuts.customize")), 1)
        ]),
        d("button", {
          type: "button",
          class: "fe-btn",
          onClick: p[1] || (p[1] = (m) => a("close"))
        }, y(u(i)("viewer.close")), 1)
      ]),
      default: mt(() => [
        d("div", fJ, [
          (f(!0), h(Te, null, nt(l.value, (m) => (f(), h("section", {
            key: m.key,
            class: "fe-shortcuts__group"
          }, [
            d("h3", pJ, y(u(i)(m.key)), 1),
            d("div", hJ, [
              (f(!0), h(Te, null, nt(m.items, (v) => (f(), h("div", {
                key: v.id,
                class: "fe-shortcuts__row"
              }, [
                d("span", mJ, [
                  v.keys.length === 0 ? (f(), h("span", vJ, y(u(i)("shortcuts.settings.unbound")), 1)) : (f(!0), h(Te, { key: 1 }, nt(v.keys, (x, w) => (f(), h(Te, { key: x }, [
                    d("kbd", yJ, y(x), 1),
                    w < v.keys.length - 1 ? (f(), h("span", gJ, "/")) : O("", !0)
                  ], 64))), 128))
                ]),
                d("span", bJ, [
                  Ht(y(u(i)(v.labelKey)) + " ", 1),
                  v.overridden ? (f(), h("span", {
                    key: 0,
                    class: "fe-shortcuts__custom",
                    title: u(i)("shortcuts.settings.customized")
                  }, "●", 8, kJ)) : O("", !0)
                ])
              ]))), 128))
            ])
          ]))), 128))
        ])
      ]),
      _: 1
    }, 8, ["open", "title"]));
  }
});
function _T(e) {
  return !e || typeof e != "object" || e.complete === !0 ? null : e;
}
function xJ(e) {
  const t = Math.max(0, e.catalogued_folders ?? 0), n = Math.max(0, e.pending_folders ?? 0);
  if (t + n === 0) return 0;
  const a = Math.floor(t * 100 / (t + n));
  return n > 0 ? Math.min(a, 99) : a;
}
function SJ(e) {
  switch (e.reason) {
    case "lazy_on_open":
      return { key: "coverage.lazy_on_open", vars: {} };
    case "lazy_filling":
      return { key: "coverage.lazy_filling", vars: { pct: xJ(e) } };
    default:
      return { key: "coverage.first_scan", vars: {} };
  }
}
function $J(e) {
  const t = {};
  if (!Array.isArray(e)) return t;
  for (const n of e)
    !n || typeof n.name != "string" || n.name === "" || (t[n.name] = _T(n.coverage ?? null));
  return t;
}
function TJ(e) {
  const { map: t, adapter: n, searching: a, crossStorage: i, admin: r } = e;
  if (a && i) {
    const c = Object.keys(t).filter((p) => t[p] !== null).sort((p, m) => p.localeCompare(m));
    return c.length === 0 ? null : c.length === 1 ? v0(c[0], t[c[0]], r) : { key: "coverage.search_some", vars: { names: c.join(", ") }, offerCatalogAll: !1 };
  }
  const l = t[n];
  return l ? v0(n, l, r) : null;
}
function v0(e, t, n) {
  const a = SJ(t);
  return { key: a.key, vars: a.vars, storage: e, offerCatalogAll: n && t.reason === "lazy_on_open" };
}
function AJ() {
  let e = 0, t = null, n = Promise.resolve();
  return {
    begin(a, i) {
      return e += 1, { ticket: e, want: a ?? t ?? i };
    },
    going(a) {
      t = a;
    },
    view() {
      return t = null, e += 1, e;
    },
    isNewest(a) {
      return a === e;
    },
    end(a) {
      a === e && (t = null);
    },
    async follow(a) {
      let i;
      const r = new Promise((c) => i = c);
      n = r;
      try {
        await a();
      } finally {
        i();
      }
      let l = r;
      for (; n !== l; )
        l = n, await l;
    }
  };
}
function EJ() {
  let e = 0, t = [];
  function n() {
    if (e > 0 || t.length === 0) return;
    const a = t;
    t = [];
    for (const i of a) i();
  }
  return {
    start() {
      e++;
      let a = !1;
      return () => {
        a || (a = !0, e--, n());
      };
    },
    settled(a) {
      return e === 0 ? Promise.resolve(!0) : new Promise((i) => {
        let r;
        const l = () => {
          r !== void 0 && clearTimeout(r), i(!0);
        };
        t.push(l), r = setTimeout(() => {
          t = t.filter((c) => c !== l), i(!1);
        }, Math.max(0, a));
      });
    },
    get count() {
      return e;
    }
  };
}
const oc = "filex.menuAnswers.v1|", yf = 1, CJ = 1500, zJ = 6, MJ = 196608, y0 = 7 * 24 * 60 * 60 * 1e3, PJ = 3e4, OJ = 400, LJ = ["allowed", "request", "denied"], DJ = ["p", "e:file", "e:folder", "e:new_folder"], _p = /* @__PURE__ */ new Set();
function gf(e) {
  const t = e.indexOf("://");
  return t > 0 ? e.slice(0, t) : "";
}
function g0(e) {
  const t = e.indexOf("://");
  return t < 0 ? e : e.slice(0, t + 3) + e.slice(t + 3).replace(/^\/+|\/+$/g, "");
}
function cv(e) {
  const t = e.indexOf("://");
  if (t < 0) return null;
  const n = e.slice(t + 3);
  if (!n) return null;
  const a = n.lastIndexOf("/");
  return e.slice(0, t + 3) + (a < 0 ? "" : n.slice(0, a));
}
function dv(e) {
  return e === "p" ? "p" : "e";
}
function RJ(e, t) {
  return e === "p" ? Array.isArray(t) && t.every((n) => typeof n == "string") : typeof t == "string" && LJ.includes(t);
}
function NJ(e) {
  let t = 2166136261, n = 1523705862;
  for (let a = 0; a < e.length; a++) {
    const i = e.charCodeAt(a);
    t = Math.imul(t ^ i, 16777619), n = Math.imul(n ^ i, 1540483477);
  }
  return (t >>> 0).toString(16).padStart(8, "0") + (n >>> 0).toString(16).padStart(8, "0");
}
function IJ() {
  try {
    const e = globalThis.localStorage;
    if (!e) return null;
    const t = `${oc}probe`;
    return e.setItem(t, "1"), e.removeItem(t), e;
  } catch {
    return null;
  }
}
function BJ(e = {}) {
  const t = e.now ?? (() => Date.now()), n = S(0), a = /* @__PURE__ */ new Map(), i = Math.random().toString(36).slice(2, 8);
  let r = 0, l = `${i}.0`, c = null, p = null, m = {}, v = null, x = !1;
  const w = () => `${oc}${c}`, $ = (U) => `${oc}${c}|${encodeURIComponent(U)}`;
  function k(U, H) {
    var N;
    if (!p || !c || !U) return;
    let L = null;
    try {
      L = JSON.parse(p.getItem($(U)) ?? "null");
    } catch {
      L = null;
    }
    if (!L || L.v !== yf || !Array.isArray(L.r)) return;
    const P = t(), K = /* @__PURE__ */ new Map();
    for (const J of L.r) {
      if (!Array.isArray(J)) continue;
      const [j, re, q] = J;
      if (typeof j != "string" || typeof q != "number" || P - q > y0) continue;
      const le = j.slice(0, j.indexOf("|"));
      !DJ.includes(le) || ((N = L.sig) == null ? void 0 : N[dv(le)]) !== m[dv(le)] || !RJ(le, re) || H.rows.has(j) || K.set(j, [re, q, "", 1]);
    }
    for (const [J, j] of H.rows) K.set(J, j);
    H.rows = K;
  }
  function b(U) {
    let H = a.get(U);
    return H || (H = { sig: { ...m }, rows: /* @__PURE__ */ new Map(), dirty: !1 }, a.set(U, H), k(U, H)), H;
  }
  function C() {
    !p || !c || v || x || (v = setTimeout(R, OJ));
  }
  function T(U, H, L) {
    if (!p) return;
    let P = [...H.rows].filter(([, K]) => K[3] === 1).map(([K, N]) => [K, N[0], N[1]]);
    for (; P.length > 0; ) {
      const K = JSON.stringify({ v: yf, at: L, sig: H.sig, r: P });
      if (K.length <= MJ)
        try {
          p.setItem($(U), K);
          return;
        } catch {
        }
      P = P.slice(Math.ceil(P.length / 2));
    }
    try {
      p.removeItem($(U));
    } catch {
    }
  }
  function E() {
    try {
      const U = JSON.parse((p == null ? void 0 : p.getItem(w())) ?? "null");
      if (U && U.v === yf && U.s && typeof U.s == "object") {
        const H = {};
        for (const [L, P] of Object.entries(U.s)) typeof P == "number" && (H[L] = P);
        return H;
      }
    } catch {
    }
    return {};
  }
  function R() {
    if (v && clearTimeout(v), v = null, !p || !c) return;
    const U = t(), H = E();
    for (const [P, K] of a)
      K.dirty && (K.dirty = !1, P && (H[P] = U, T(P, K, U)));
    const L = Object.entries(H).sort((P, K) => K[1] - P[1]);
    for (const [P] of L.slice(zJ)) {
      delete H[P];
      try {
        p.removeItem($(P));
      } catch {
      }
    }
    try {
      p.setItem(w(), JSON.stringify({ v: yf, at: U, s: H }));
    } catch {
    }
  }
  function z() {
    var L;
    if (!p) return;
    const U = t(), H = [];
    try {
      for (let P = 0; P < p.length; P++) {
        const K = p.key(P);
        if (!K || !K.startsWith(oc)) continue;
        let N = 0;
        try {
          N = Number((L = JSON.parse(p.getItem(K) ?? "null")) == null ? void 0 : L.at) || 0;
        } catch {
          N = 0;
        }
        U - N > y0 && H.push(K);
      }
      for (const P of H) p.removeItem(P);
    } catch {
    }
  }
  const D = {
    rev: n,
    attach(U, H) {
      if (x) return;
      R();
      const L = U ? NJ(U) : null;
      c !== null && L !== c && a.clear(), c = L, p = L ? e.storage ? e.storage() : IJ() : null;
      for (const P of ["p", "e"]) m[P] !== void 0 && m[P] !== H[P] && D.sign(P, H[P]);
      if (m = { ...H }, p) {
        z();
        for (const [P, K] of a)
          K.sig = { ...m }, k(P, K), K.dirty = !0;
        C();
      }
      n.value++;
    },
    sign(U, H) {
      if (m[U] !== H) {
        m = { ...m, [U]: H };
        for (const L of a.values()) {
          for (const P of [...L.rows.keys()]) dv(P.slice(0, P.indexOf("|"))) === U && L.rows.delete(P);
          L.sig = { ...m }, L.dirty = !0;
        }
        C(), n.value++;
      }
    },
    peek(U, H) {
      var L;
      return n.value, (L = b(gf(H)).rows.get(`${U}|${H}`)) == null ? void 0 : L[0];
    },
    fresh(U, H) {
      const L = b(gf(H)).rows.get(`${U}|${H}`);
      return !!L && L[2] === l && t() - L[1] < PJ;
    },
    put(U, H, L, P = !0) {
      if (x) return;
      const K = b(gf(H)), N = `${U}|${H}`;
      for (K.rows.delete(N), K.rows.set(N, [L, t(), l, P ? 1 : 0]); K.rows.size > CJ; ) {
        const J = K.rows.keys().next().value;
        if (J === void 0) break;
        K.rows.delete(J);
      }
      P && (K.dirty = !0, C());
    },
    stale() {
      r++, l = `${i}.${r}`, n.value++;
    },
    around(U) {
      const H = gf(U);
      if (!H) return [];
      const L = g0(U), P = `${H}://`, K = cv(L), N = /* @__PURE__ */ new Set([P, L]);
      K !== null && N.add(K);
      const J = [];
      for (const j of b(H).rows.keys()) {
        const re = j.indexOf("|"), q = j.slice(re + 1), le = g0(q), ve = cv(le);
        (N.has(le) || ve !== null && (N.has(ve) || cv(ve) === L)) && J.push({ q: j.slice(0, re), path: q });
      }
      return J;
    },
    flush() {
      R();
    },
    forget() {
      v && clearTimeout(v), v = null, a.clear(), c = null, p = null, n.value++;
    },
    dispose() {
      R(), x = !0, _p.delete(D);
    }
  };
  return _p.add(D), D;
}
function FJ() {
  for (const e of _p) e.forget();
  try {
    const e = globalThis.localStorage;
    if (!e) return;
    const t = [];
    for (let n = 0; n < e.length; n++) {
      const a = e.key(n);
      a && a.startsWith(oc) && t.push(a);
    }
    for (const n of t) e.removeItem(n);
  } catch {
  }
}
KF(FJ);
typeof window < "u" && typeof window.addEventListener == "function" && window.addEventListener("pagehide", () => {
  for (const e of _p) e.flush();
});
function Bf(e) {
  return typeof e == "number" && Number.isFinite(e) && e >= 0 ? e : null;
}
function xT(e) {
  return !!e && !e.unlimited && e.quota_bytes > 0;
}
function UJ(e, t) {
  return !e || xT(e) ? !1 : t.length === 0 || t.some((n) => Bf(n.usedBytes) === null);
}
function HJ(e, t, n) {
  if (!e) return null;
  if (xT(e))
    return { used: Bf(e.used_bytes) ?? 0, total: e.quota_bytes, unlimited: !1, partial: !1 };
  const a = /* @__PURE__ */ new Map();
  for (const m of n ?? []) m && typeof m.name == "string" && a.set(m.name, m);
  const i = t.length ? t : [...a.keys()].map((m) => ({ name: m }));
  let r = 0, l = 0, c = !1;
  const p = /* @__PURE__ */ new Set();
  for (const m of i) {
    if (p.has(m.name)) continue;
    p.add(m.name);
    const v = Bf(m.usedBytes), x = v === null ? a.get(m.name) : void 0, w = v ?? Bf(x == null ? void 0 : x.used_bytes);
    if (w === null) {
      c = !0;
      continue;
    }
    r += w, l++, (v !== null ? m.usedPartial === !0 : _T(x == null ? void 0 : x.coverage) !== null) && (c = !0);
  }
  return !l || r <= 0 ? null : { used: r, total: 0, unlimited: !0, partial: c };
}
const KJ = "custom:", xp = "filex.palette", b0 = "filex.theme", Fa = "default", ST = [
  {
    // Stock palette — the maps duplicate variables.css ONLY for the
    // gallery preview; applying this theme clears all overrides.
    id: Fa,
    nameKey: "theme.name.default",
    light: {
      /* ⚠ Mirrors styles/variables.css exactly — web/tests/api/themeContrast.test.ts
       * fails on any drift. It has drifted before: the stock primary was
       * darkened for contrast and this preview map kept the old blue, so the
       * gallery card advertised a colour the product no longer used. */
      "--fe-bg": "#ffffff",
      "--fe-bg-elev": "#f7f8fb",
      "--fe-bg-hover": "#f3f4f6",
      "--fe-bg-selected": "#eef3ff",
      "--fe-border": "#e5e7eb",
      "--fe-border-soft": "#eef0f4",
      "--fe-border-strong": "#d1d5db",
      "--fe-text": "#1f2937",
      "--fe-text-muted": "#6b7280",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#2f6ceb",
      "--fe-primary-hover": "#2559c9",
      "--fe-primary-soft": "#e6ecfa",
      "--fe-primary-ink": "#2559c9",
      "--fe-danger": "#dc2626",
      "--fe-danger-hover": "#b91c1c",
      /* The outward-facing pages, as the stock palette defines them (#74):
       * the share page's ground and card (variables.css `.fe.fe-ppage`) and
       * the sign-in page's (`--fe-login-*`, which are the palette's own
       * sunken ground and surface). Optional for every theme - PAGE_TOKENS
       * below. */
      "--fe-ppage-ground-1": "#f5f7fb",
      "--fe-ppage-ground-2": "#e9edf4",
      "--fe-ppage-card": "#ffffff",
      "--fe-login-ground": "#f7f8fb",
      "--fe-login-card": "#ffffff"
    },
    dark: {
      "--fe-bg": "#15171c",
      "--fe-bg-elev": "#1a1d23",
      "--fe-bg-hover": "#1f232a",
      "--fe-bg-selected": "#1c2740",
      "--fe-border": "#2e333c",
      "--fe-border-soft": "#262a32",
      "--fe-border-strong": "#3d444f",
      "--fe-text": "#e6e8ec",
      "--fe-text-muted": "#888f9b",
      /* Dark ink, not white: white on the button measures 3.16 against the 4.5
       * this file claims. Mirrors styles/variables.css. */
      "--fe-text-on-primary": "#15171c",
      "--fe-primary": "#5b8cff",
      "--fe-primary-hover": "#7ba3ff",
      "--fe-primary-soft": "#1c2740",
      "--fe-primary-ink": "#7ba3ff",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444",
      "--fe-ppage-ground-1": "#12151a",
      "--fe-ppage-ground-2": "#191e25",
      "--fe-ppage-card": "#1f242c",
      "--fe-login-ground": "#1a1d23",
      "--fe-login-card": "#15171c"
    }
  },
  {
    // Night Blue — deep indigo/navy.
    id: "night",
    nameKey: "theme.name.night",
    light: {
      "--fe-bg": "#f6f8fd",
      "--fe-bg-elev": "#edf1fa",
      "--fe-bg-hover": "#e2e9f7",
      "--fe-bg-selected": "#d2ddf4",
      "--fe-border": "#d6deee",
      "--fe-border-soft": "#e3e8f4",
      "--fe-border-strong": "#aebfda",
      "--fe-text": "#151f38",
      "--fe-text-muted": "#49587a",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#2c4a9e",
      "--fe-primary-hover": "#213a80",
      "--fe-primary-soft": "#e0e6f4",
      "--fe-primary-ink": "#213a80",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#0a1024",
      "--fe-bg-elev": "#111a35",
      "--fe-bg-hover": "#1a2547",
      "--fe-bg-selected": "#243665",
      "--fe-border": "#26335a",
      "--fe-border-soft": "#1d2748",
      "--fe-border-strong": "#3c4e84",
      "--fe-text": "#dfe6f7",
      "--fe-text-muted": "#96a5cc",
      "--fe-text-on-primary": "#050b26",
      "--fe-primary": "#6d8dfc",
      "--fe-primary-hover": "#5273f2",
      "--fe-primary-soft": "#182243",
      "--fe-primary-ink": "#6d8dfc",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // Forest — calm greens.
    id: "forest",
    nameKey: "theme.name.forest",
    light: {
      "--fe-bg": "#f5faf5",
      "--fe-bg-elev": "#eaf3eb",
      "--fe-bg-hover": "#dcecdf",
      "--fe-bg-selected": "#c8e2ce",
      "--fe-border": "#d2e2d4",
      "--fe-border-soft": "#e0ece1",
      "--fe-border-strong": "#a2c3a8",
      "--fe-text": "#182b1d",
      "--fe-text-muted": "#42604a",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#2b7a41",
      "--fe-primary-hover": "#226334",
      "--fe-primary-soft": "#dbe9dc",
      "--fe-primary-ink": "#226334",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#0d1611",
      "--fe-bg-elev": "#132019",
      "--fe-bg-hover": "#1b2d23",
      "--fe-bg-selected": "#264532",
      "--fe-border": "#28402f",
      "--fe-border-soft": "#1f3225",
      "--fe-border-strong": "#3e5f49",
      "--fe-text": "#dcebe0",
      "--fe-text-muted": "#93b09b",
      "--fe-text-on-primary": "#04180b",
      "--fe-primary": "#54c17a",
      "--fe-primary-hover": "#3fae66",
      "--fe-primary-soft": "#16291d",
      "--fe-primary-ink": "#54c17a",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // Amber — warm amber/bronze.
    id: "amber",
    nameKey: "theme.name.amber",
    light: {
      "--fe-bg": "#fdf9f0",
      "--fe-bg-elev": "#f7efdd",
      "--fe-bg-hover": "#f0e3c8",
      "--fe-bg-selected": "#ead6ab",
      "--fe-border": "#e6dabf",
      "--fe-border-soft": "#efe6d3",
      "--fe-border-strong": "#c6b184",
      "--fe-text": "#33270f",
      "--fe-text-muted": "#655631",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#9a4b00",
      "--fe-primary-hover": "#7c3c00",
      "--fe-primary-soft": "#f3e5d7",
      "--fe-primary-ink": "#7c3c00",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#191307",
      "--fe-bg-elev": "#231a0c",
      "--fe-bg-hover": "#2f2312",
      "--fe-bg-selected": "#44331b",
      "--fe-border": "#3b2e17",
      "--fe-border-soft": "#302512",
      "--fe-border-strong": "#5b4a29",
      "--fe-text": "#f2e7d4",
      "--fe-text-muted": "#bda887",
      "--fe-text-on-primary": "#2a1c02",
      "--fe-primary": "#f5a524",
      "--fe-primary-hover": "#ffb84d",
      "--fe-primary-soft": "#31230c",
      "--fe-primary-ink": "#ffb84d",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // Lilac — soft purple.
    id: "lilac",
    nameKey: "theme.name.lilac",
    light: {
      "--fe-bg": "#faf7fd",
      "--fe-bg-elev": "#f2ecfa",
      "--fe-bg-hover": "#e8ddf5",
      "--fe-bg-selected": "#dccaf0",
      "--fe-border": "#e1d6ee",
      "--fe-border-soft": "#ebe3f4",
      "--fe-border-strong": "#bda6d9",
      "--fe-text": "#241a33",
      "--fe-text-muted": "#584871",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#7231e0",
      "--fe-primary-hover": "#5f21c4",
      "--fe-primary-soft": "#e9e3fc",
      "--fe-primary-ink": "#5f21c4",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#130f1c",
      "--fe-bg-elev": "#1b1527",
      "--fe-bg-hover": "#261d37",
      "--fe-bg-selected": "#37294f",
      "--fe-border": "#302546",
      "--fe-border-soft": "#261e38",
      "--fe-border-strong": "#4b3a6d",
      "--fe-text": "#e9e2f5",
      "--fe-text-muted": "#a999c5",
      "--fe-text-on-primary": "#180d33",
      "--fe-primary": "#b197fa",
      "--fe-primary-hover": "#9c7cf4",
      "--fe-primary-soft": "#272038",
      "--fe-primary-ink": "#b197fa",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // High Contrast — black/white with strong borders, saturated accents.
    id: "contrast",
    nameKey: "theme.name.contrast",
    light: {
      "--fe-bg": "#ffffff",
      "--fe-bg-elev": "#f2f2f2",
      "--fe-bg-hover": "#e0e0e0",
      "--fe-bg-selected": "#c9dcff",
      "--fe-border": "#5c5c5c",
      "--fe-border-soft": "#5c5c5c",
      "--fe-border-strong": "#000000",
      "--fe-text": "#000000",
      "--fe-text-muted": "#3d3d3d",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#003d99",
      "--fe-primary-hover": "#002a6b",
      "--fe-primary-soft": "#e7edf7",
      "--fe-primary-ink": "#002a6b",
      "--fe-danger": "#a80000",
      "--fe-danger-hover": "#7d0000",
      "--fe-shadow": "0 0 0 1px #000000, 0 10px 32px rgba(0, 0, 0, 0.25)",
      "--fe-shadow-sm": "0 0 0 1px #000000"
    },
    dark: {
      "--fe-bg": "#000000",
      "--fe-bg-elev": "#0d0d0d",
      "--fe-bg-hover": "#212121",
      "--fe-bg-selected": "#003d80",
      "--fe-border": "#8f8f8f",
      "--fe-border-soft": "#8f8f8f",
      "--fe-border-strong": "#ffffff",
      "--fe-text": "#ffffff",
      "--fe-text-muted": "#d6d6d6",
      "--fe-text-on-primary": "#001430",
      "--fe-primary": "#7ab8ff",
      "--fe-primary-hover": "#9ccaff",
      "--fe-primary-soft": "#0e1a29",
      "--fe-primary-ink": "#9ccaff",
      "--fe-danger": "#ff7575",
      "--fe-danger-hover": "#ff9999",
      "--fe-shadow": "0 0 0 1px #ffffff, 0 12px 32px rgba(0, 0, 0, 0.65)",
      "--fe-shadow-sm": "0 0 0 1px #ffffff"
    }
  },
  {
    // Soft Gray — desaturated, quiet neutral.
    id: "gray",
    nameKey: "theme.name.gray",
    light: {
      "--fe-bg": "#f7f7f8",
      "--fe-bg-elev": "#efeff1",
      "--fe-bg-hover": "#e4e4e7",
      "--fe-bg-selected": "#d6d7db",
      "--fe-border": "#dfdfe2",
      "--fe-border-soft": "#e9e9eb",
      "--fe-border-strong": "#b9b9c0",
      "--fe-text": "#26272b",
      "--fe-text-muted": "#585a63",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#4b4b54",
      "--fe-primary-hover": "#38383f",
      "--fe-primary-soft": "#e4e4e6",
      "--fe-primary-ink": "#38383f",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#131316",
      "--fe-bg-elev": "#1b1b1f",
      "--fe-bg-hover": "#26262b",
      "--fe-bg-selected": "#35353c",
      "--fe-border": "#2d2d33",
      "--fe-border-soft": "#242429",
      "--fe-border-strong": "#4a4a52",
      "--fe-text": "#e6e6e9",
      "--fe-text-muted": "#a4a4ad",
      "--fe-text-on-primary": "#17171b",
      "--fe-primary": "#b0b0ba",
      "--fe-primary-hover": "#c4c4cd",
      "--fe-primary-soft": "#242428",
      "--fe-primary-ink": "#c4c4cd",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // Terminal Green — phosphor green, monospace face for the full CRT vibe.
    id: "terminal",
    nameKey: "theme.name.terminal",
    light: {
      "--fe-bg": "#f3f9f4",
      "--fe-bg-elev": "#e5f2e8",
      "--fe-bg-hover": "#d5ead9",
      "--fe-bg-selected": "#bce3c6",
      "--fe-border": "#cbe2d1",
      "--fe-border-soft": "#dbebdf",
      "--fe-border-strong": "#94c2a0",
      "--fe-text": "#0c2913",
      "--fe-text-muted": "#31573c",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#116b33",
      "--fe-primary-hover": "#0c5427",
      "--fe-primary-soft": "#dbe9dd",
      "--fe-primary-ink": "#0c5427",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f",
      "--fe-font": 'ui-monospace, "SF Mono", Consolas, Menlo, monospace'
    },
    dark: {
      "--fe-bg": "#050d07",
      "--fe-bg-elev": "#0a1710",
      "--fe-bg-hover": "#112418",
      "--fe-bg-selected": "#1a3a26",
      "--fe-border": "#1c3a2a",
      "--fe-border-soft": "#142b1e",
      "--fe-border-strong": "#316144",
      "--fe-text": "#4fdd8b",
      "--fe-text-muted": "#38a668",
      "--fe-text-on-primary": "#03180a",
      "--fe-primary": "#25c95e",
      "--fe-primary-hover": "#4fdd8b",
      "--fe-primary-soft": "#0c2412",
      "--fe-primary-ink": "#4fdd8b",
      "--fe-danger": "#ff6b62",
      "--fe-danger-hover": "#ff8d86",
      "--fe-font": 'ui-monospace, "SF Mono", Consolas, Menlo, monospace'
    }
  }
], oh = S([]);
function she(e) {
  oh.value = Array.isArray(e) ? e : [], Jo.value !== Fa && !ed(Jo.value) && AT(Fa);
}
function lhe() {
  return { customThemes: oh };
}
function $T() {
  return [...ST, ...oh.value];
}
function ed(e) {
  if (e)
    return ST.find((t) => t.id === e) ?? oh.value.find((t) => t.id === e);
}
function VJ(e, t) {
  return e.name ?? (e.nameKey ? t(e.nameKey) : e.id);
}
function jJ() {
  return Array.from(
    new Set($T().flatMap((e) => [...Object.keys(e.light), ...Object.keys(e.dark)]))
  );
}
function td(e) {
  return !!e && (!!ed(e) || e.startsWith(KJ));
}
function TT() {
  if (!nr()) return Fa;
  try {
    const e = localStorage.getItem(xp);
    if (td(e)) return e;
    const t = localStorage.getItem(b0);
    return t && ed(t) ? (localStorage.setItem(xp, t), localStorage.removeItem(b0), t) : Fa;
  } catch {
    return Fa;
  }
}
const Jo = S(
  typeof window > "u" ? Fa : TT()
);
function qJ(e) {
  const t = td(e) ? e : Fa;
  Jo.value = t;
  try {
    localStorage.setItem(xp, t);
  } catch {
  }
  Zi("palette", t);
}
function AT(e) {
  if (!e) return;
  const t = td(e) ? e : Fa;
  Jo.value = t, Gr("palette", t);
}
function uhe(e) {
  e && td(e) && (Jo.value = e);
}
function WJ() {
  return { themeId: Jo, setTheme: qJ };
}
const Ac = "filex.thememode";
HF(Ac);
const Gg = ["host", "auto", "light", "dark"];
function ET() {
  if (!nr()) return "host";
  try {
    const e = localStorage.getItem(Ac);
    return e && Gg.includes(e) ? e : "host";
  } catch {
    return "host";
  }
}
const rh = S(
  typeof window > "u" ? "host" : ET()
);
function YJ(e) {
  const t = Gg.includes(e) ? e : "host";
  rh.value = t;
  try {
    t === "host" ? localStorage.removeItem(Ac) : localStorage.setItem(Ac, t);
  } catch {
  }
}
function che() {
  Jo.value = TT(), rh.value = ET();
}
function GJ() {
  return { themeMode: rh, setThemeMode: YJ };
}
if (typeof window < "u")
  try {
    window.addEventListener("storage", (e) => {
      if (e.key !== Ac || !nr()) return;
      const t = e.newValue;
      rh.value = t && Gg.includes(t) ? t : "host";
    });
  } catch {
  }
if (typeof window < "u")
  try {
    window.addEventListener("storage", (e) => {
      e.key !== xp || !nr() || (Jo.value = td(e.newValue) ? e.newValue : Fa);
    });
  } catch {
  }
function XJ(e, t, n) {
  for (const r of jJ()) e.style.removeProperty(r);
  if (t === Fa) return;
  const a = ed(t);
  if (!a) return;
  const i = n ? a.dark : a.light;
  for (const [r, l] of Object.entries(i)) e.style.setProperty(r, l);
}
const k0 = "data-filex-theme";
function bf(e) {
  return Object.entries(e).map(([t, n]) => `${t}:${n};`).join("");
}
const Xg = ["--fe-ppage-ground-1", "--fe-ppage-ground-2", "--fe-ppage-card"], JJ = ["--fe-login-ground", "--fe-login-card"], dhe = [...Xg, ...JJ], ZJ = {
  light: {
    "--fe-ppage-ground-1": "color-mix(in srgb, var(--fe-bg) 96%, var(--fe-text))",
    "--fe-ppage-ground-2": "color-mix(in srgb, var(--fe-bg) 90%, var(--fe-text))",
    "--fe-ppage-card": "var(--fe-bg)"
  },
  dark: {
    "--fe-ppage-ground-1": "color-mix(in srgb, var(--fe-bg) 88%, #000000)",
    "--fe-ppage-ground-2": "color-mix(in srgb, var(--fe-bg) 96%, var(--fe-text))",
    "--fe-ppage-card": "color-mix(in srgb, var(--fe-bg) 92%, var(--fe-text))"
  }
};
function w0(e, t) {
  const n = e[t] ?? {}, a = {};
  for (const i of Xg) {
    const r = typeof n[i] == "string" ? n[i].trim() : "";
    a[i] = r || ZJ[t][i];
  }
  return a;
}
const QJ = new Set(Xg);
function _0(e) {
  const t = {};
  for (const [n, a] of Object.entries(e)) QJ.has(n) || (t[n] = a);
  return t;
}
function eZ(e) {
  const t = bf(_0(e.light)), n = bf(_0(e.dark)), a = bf(w0(e, "light")), i = bf(w0(e, "dark")), r = [
    ".fe.fe-ppage.fe--theme-dark",
    ":root[data-theme='dark'] .fe.fe-ppage",
    ":root.dark .fe.fe-ppage",
    ".dark .fe.fe-ppage"
  ].join(","), l = [
    ".fe--theme-dark",
    ":root[data-theme='dark'] .fe",
    ".fe.fe--theme-dark",
    ":root.dark",
    ".dark",
    ":root.dark .fe",
    ".dark .fe",
    ".fe-ctx-backdrop--theme-dark",
    ".fe-ctx-backdrop--theme-auto[data-prefers-dark='1']"
  ].join(","), c = [
    ".fe:not(.fe--theme-light)",
    ".fe-ctx-backdrop--theme-auto:not(.fe-ctx-backdrop--theme-light)"
  ].join(",");
  return `/* filex theme: ${e.id} */:root,.fe{${t}}${l}{${n}}@media (prefers-color-scheme: dark){${c}{${n}}}.fe.fe-ppage{${a}}${r}{${i}}@media (prefers-color-scheme: dark){.fe.fe-ppage:not(.fe--theme-light){${i}}}`;
}
function tZ(e) {
  if (typeof document > "u") return;
  let t = document.head.querySelector(`style[${k0}]`);
  const n = e === Fa ? void 0 : ed(e);
  if (!n) {
    t && (t.textContent = "");
    return;
  }
  t ? t !== document.head.lastElementChild && document.head.appendChild(t) : (t = document.createElement("style"), t.setAttribute(k0, ""), document.head.appendChild(t));
  const a = eZ(n);
  t.textContent !== a && (t.textContent = a);
}
const nZ = {
  key: 0,
  class: "fe-themes__hint"
}, aZ = ["aria-label"], iZ = ["aria-selected", "data-theme-id", "onClick"], oZ = { class: "fe-themecard__name" }, rZ = ["title"], sZ = /* @__PURE__ */ lt({
  __name: "ThemePalette",
  props: {
    locale: {},
    dark: { type: Boolean },
    current: {},
    hint: { type: Boolean }
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale);
    function r(l) {
      return n.dark ? l.dark : l.light;
    }
    return (l, c) => (f(), h(Te, null, [
      e.hint !== !1 ? (f(), h("p", nZ, y(u(i)("theme.hint")), 1)) : O("", !0),
      d("div", {
        class: "fe-themes",
        role: "listbox",
        "aria-label": u(i)("theme.title")
      }, [
        (f(!0), h(Te, null, nt(u($T)(), (p) => (f(), h("button", {
          key: p.id,
          type: "button",
          class: Re(["fe-themecard", { "is-selected": p.id === e.current }]),
          role: "option",
          "aria-selected": p.id === e.current,
          "data-theme-id": p.id,
          style: Yt(r(p)),
          onClick: (m) => a("select", p.id)
        }, [
          c[0] || (c[0] = u2('<span class="fe-themecard__preview" aria-hidden="true"><span class="fe-themecard__topbar"><span class="fe-themecard__chip fe-themecard__chip--primary"></span><span class="fe-themecard__chip"></span><span class="fe-themecard__chip fe-themecard__chip--ghost"></span></span><span class="fe-themecard__row"><span class="fe-themecard__dot"></span><span class="fe-themecard__line" style="width:62%;"></span></span><span class="fe-themecard__row fe-themecard__row--selected"><span class="fe-themecard__dot fe-themecard__dot--primary"></span><span class="fe-themecard__line" style="width:44%;"></span></span><span class="fe-themecard__row"><span class="fe-themecard__dot fe-themecard__dot--muted"></span><span class="fe-themecard__line fe-themecard__line--muted" style="width:74%;"></span></span></span>', 1)),
          d("span", oZ, [
            Ht(y(u(VJ)(p, u(i))) + " ", 1),
            p.id === e.current ? (f(), h("span", {
              key: 0,
              class: "fe-themecard__check",
              title: u(i)("theme.selected")
            }, "✓", 8, rZ)) : O("", !0)
          ])
        ], 14, iZ))), 128))
      ], 8, aZ)
    ], 64));
  }
}), lZ = ["aria-label"], uZ = { class: "fe-thememode__label" }, cZ = { class: "fe-thememode__seg" }, dZ = ["aria-pressed", "onClick"], fZ = {
  class: "fe-ficon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, pZ = {
  key: 1,
  d: "M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"
}, hZ = ["disabled"], mZ = /* @__PURE__ */ lt({
  __name: "ThemeGallery",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    dark: { type: Boolean },
    current: {},
    mode: {},
    hostMode: {}
  },
  emits: ["close", "select", "mode"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = [
      { id: "light", labelKey: "theme.mode.light" },
      { id: "dark", labelKey: "theme.mode.dark" },
      { id: "auto", labelKey: "theme.mode.auto" }
    ], l = A(() => n.mode === "host" ? n.hostMode : n.mode), c = Fa;
    return (p, m) => (f(), Ge(ta, {
      open: e.open,
      title: u(i)("theme.title"),
      size: "lg",
      theme: e.theme,
      onClose: m[3] || (m[3] = (v) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.current === u(c),
          onClick: m[1] || (m[1] = (v) => a("select", u(c)))
        }, y(u(i)("theme.reset")), 9, hZ),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          onClick: m[2] || (m[2] = (v) => a("close"))
        }, y(u(i)("theme.close")), 1)
      ]),
      default: mt(() => [
        d("div", {
          class: "fe-thememode",
          role: "group",
          "aria-label": u(i)("theme.mode.label")
        }, [
          d("span", uZ, y(u(i)("theme.mode.label")), 1),
          d("div", cZ, [
            (f(), h(Te, null, nt(r, (v) => d("button", {
              key: v.id,
              type: "button",
              class: Re(["fe-thememode__opt", { "is-active": l.value === v.id }]),
              "aria-pressed": l.value === v.id,
              onClick: (x) => a("mode", v.id)
            }, [
              (f(), h("svg", fZ, [
                v.id === "light" ? (f(), h(Te, { key: 0 }, [
                  m[4] || (m[4] = d("circle", {
                    cx: "12",
                    cy: "12",
                    r: "4"
                  }, null, -1)),
                  m[5] || (m[5] = d("path", { d: "M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" }, null, -1))
                ], 64)) : v.id === "dark" ? (f(), h("path", pZ)) : (f(), h(Te, { key: 2 }, [
                  m[6] || (m[6] = d("circle", {
                    cx: "12",
                    cy: "12",
                    r: "9"
                  }, null, -1)),
                  m[7] || (m[7] = d("path", {
                    d: "M12 3a9 9 0 0 1 0 18z",
                    fill: "currentColor",
                    stroke: "none"
                  }, null, -1))
                ], 64))
              ])),
              d("span", null, y(u(i)(v.labelKey)), 1)
            ], 10, dZ)), 64))
          ])
        ], 8, lZ),
        Ze(sZ, {
          locale: e.locale,
          dark: e.dark,
          current: e.current,
          onSelect: m[0] || (m[0] = (v) => a("select", v))
        }, null, 8, ["locale", "dark", "current"])
      ]),
      _: 1
    }, 8, ["open", "title", "theme"]));
  }
}), CT = "filex.density";
function vZ(e) {
  if (!(e !== "comfortable" && e !== "compact")) {
    Gr("density", e);
    try {
      window.dispatchEvent(new CustomEvent("filex:density", { detail: e }));
    } catch {
    }
  }
}
function fhe() {
  try {
    return localStorage.getItem(CT) === "compact" ? "compact" : "comfortable";
  } catch {
    return "comfortable";
  }
}
function phe(e) {
  try {
    localStorage.setItem(CT, e);
  } catch {
  }
  Zi("density", e);
  try {
    window.dispatchEvent(new CustomEvent("filex:density", { detail: e }));
  } catch {
  }
}
function yZ(e) {
  const t = Symbol("filex-explorer");
  Wo(q2, t), Je(
    () => e.config().timeZone,
    (i) => iO(t, i),
    { immediate: !0 }
  );
  const n = () => {
    var i;
    return e.config().callerKind ?? ((i = e.capabilities.value) == null ? void 0 : i.caller_kind);
  };
  let a = !1;
  return Je(
    n,
    (i) => {
      if (i !== "user") {
        Sf(t, null);
        return;
      }
      a || (a = !0, e.fetchMe().then((r) => {
        var c;
        if (n() !== "user") return;
        const l = (c = r == null ? void 0 : r.user) == null ? void 0 : c.timezone;
        Sf(t, typeof l == "string" ? l : null);
      }).catch(() => Sf(t, null)));
    },
    { immediate: !0 }
  ), Tt(() => sO(t)), t;
}
const gZ = ["aria-label"], bZ = { class: "fe-opc__head" }, kZ = ["aria-label"], wZ = { class: "fe-opc__body" }, _Z = {
  key: 0,
  class: "fe-opc__section",
  "aria-live": "polite"
}, xZ = { class: "fe-opc__section-title" }, SZ = { class: "fe-opc__list" }, $Z = {
  class: "fe-opc__kicon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, TZ = ["d"], AZ = { class: "fe-opc__mid" }, EZ = ["title"], CZ = { class: "fe-opc__sub" }, zZ = { class: "fe-opc__kind" }, MZ = ["title"], PZ = { class: "fe-opc__state" }, OZ = {
  key: 0,
  class: "fe-opc__sub fe-opc__sub--detail",
  "data-testid": "opc-error-detail"
}, LZ = ["aria-valuenow"], DZ = {
  key: 0,
  class: "fe-opc__spin",
  "aria-hidden": "true"
}, RZ = { class: "fe-opc__acts" }, NZ = ["onClick"], IZ = ["onClick"], BZ = ["onClick"], FZ = ["aria-label", "onClick"], UZ = {
  key: 1,
  class: "fe-opc__section"
}, HZ = { class: "fe-opc__section-title" }, KZ = { class: "fe-opc__list fe-opc__list--history" }, VZ = {
  class: "fe-opc__kicon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, jZ = ["d"], qZ = { class: "fe-opc__mid" }, WZ = ["title"], YZ = {
  key: 0,
  class: "fe-opc__sub"
}, GZ = ["title"], XZ = {
  key: 1,
  class: "fe-opc__sub fe-opc__sub--err"
}, JZ = {
  key: 2,
  class: "fe-opc__sub fe-opc__sub--detail",
  "data-testid": "opc-error-detail"
}, ZZ = ["onClick"], QZ = {
  key: 2,
  class: "fe-opc__empty"
}, eQ = ["aria-expanded", "aria-label"], tQ = ["stroke-dashoffset"], nQ = { class: "fe-opc__count" }, aQ = {
  key: 0,
  class: "fe-opc__pct"
}, fv = 8.5, iQ = /* @__PURE__ */ lt({
  __name: "OperationsCenter",
  props: {
    center: {},
    locale: {},
    narrow: { type: Boolean }
  },
  setup(e) {
    const t = e, { t: n, formatSize: a } = ht(() => t.locale), i = S(!1), r = S(null), l = A(() => t.center.active.value), c = A(() => t.center.history.value), p = A(() => t.center.hasError.value), m = A(() => t.center.overallPercent.value), v = A(() => t.center.runningCount.value), x = A(() => l.value.length > 0 || i.value && c.value.length > 0);
    Je(x, (N) => {
      N || (i.value = !1);
    }), Je(
      () => {
        var N;
        return ((N = t.center.revealRequests) == null ? void 0 : N.value) ?? 0;
      },
      (N, J) => {
        N > J && (i.value = !0);
      }
    );
    const w = 2 * Math.PI * fv, $ = A(() => {
      const N = m.value;
      return N === null ? w * 0.72 : w * (1 - Math.min(100, Math.max(0, N)) / 100);
    }), k = A(() => m.value === null && v.value > 0), b = A(() => v.value === 0 || m.value === null ? "" : n("opc.percent", { n: m.value })), C = A(() => n("opc.aria_badge", { n: l.value.length })), T = {
      upload: "M12 16V5M7 9.5 12 5l5 4.5M5 19h14",
      copy: "M9 9h11v11H9zM5 15V4h11",
      move: "M4 12h13M12 6l6 6-6 6",
      delete: "M5 7h14M9 7V5h6v2M8 7l1 13h6l1-13",
      /* A folder given a new name, and one brought back from the trash. */
      rename: "M4 20h4L18.5 9.5l-4-4L4 16zM13 7l4 4",
      restore: "M9 14 4 9l5-5M4 9h10.5a5.5 5.5 0 0 1 0 11H11",
      /* A trash entry taken out for good: the bin, crossed. */
      purge: "M5 7h14M9 7V5h6v2M8 7l1 13h6l1-13M10 11l4 5M14 11l-4 5",
      convert: "M20 8A8 8 0 0 0 6 6L4 8M4 16a8 8 0 0 0 14 2l2-2M20 3v5h-5M4 21v-5h5",
      archive: "M4 8V5h16v3zM5 8h14v12H5zM10 12h4",
      /* "Empty the trash" — the bin, with the lines of what is going. */
      trash: "M5 7h14M9 7V5h6v2M8 7l1 13h6l1-13M10.5 11v5M13.5 11v5",
      /* "Repair thumbnails" (Admin → Tools): a picture, its frame and its hill. */
      thumbs: "M4 5h16v14H4zM4 16l5-5 4 4 3-3 4 4M15 9.5h.01",
      /* An app-plugin job — the puzzle piece its menu row wears (lib/actionIcons). */
      plugin: "M9.5 4.5a2 2 0 1 1 4 0h3a1.5 1.5 0 0 1 1.5 1.5v3a2 2 0 1 1 0 4v3a1.5 1.5 0 0 1-1.5 1.5h-3a2 2 0 1 1-4 0h-3A1.5 1.5 0 0 1 5 16v-3a2 2 0 1 1 0-4V6a1.5 1.5 0 0 1 1.5-1.5z",
      "archive-create": "M4 8V5h16v3zM5 8h14v12H5zM10 12h4",
      "archive-extract": "M4 8V5h16v3zM5 8h14v12H5zM10 12h4"
    };
    function E(N) {
      return n(`opc.kind.${N.kind}`);
    }
    function R(N) {
      return N.name || E(N);
    }
    function z(N) {
      return N.outputMode === "sibling" ? n("plugin.output.sibling") : N.outputMode === "version" ? n("plugin.output.version") : "";
    }
    function D(N) {
      return N.outputMode === "sibling" ? n("plugin.output.sibling_title") : N.outputMode === "version" ? n("plugin.output.version_title") : "";
    }
    function U(N) {
      return N.status === "running" ? N.cancelling ? n("opc.cancelling") : N.queued ? N.waitText || n("opc.queued") : N.message ? N.message : N.totalBytes && N.totalBytes > 0 ? `${a(N.uploadedBytes ?? 0)} / ${a(N.totalBytes)}` : (N.kind === "archive-create" || N.kind === "archive-extract") && N.percent !== null ? n("opc.percent", { n: N.percent }) : N.itemsTotal && N.itemsTotal > 0 ? n("opc.items", { done: N.itemsDone ?? 0, total: N.itemsTotal }) : N.percent !== null && N.totalCount && N.totalCount > 1 ? `${N.doneCount ?? 0}/${N.totalCount}` : n("opc.status.running") : N.status === "done" ? N.message || n("opc.status.done") : N.status === "aborted" ? n("opc.status.aborted") : N.error || n("opc.status.error");
    }
    function H(N) {
      return N.status === "done" && N.outputs.length > 0;
    }
    function L(N) {
      return n(`opc.status.${N.status === "running" ? "running" : N.status}`);
    }
    function P(N) {
      if (!i.value) return;
      const J = r.value;
      J && N.target instanceof Node && !J.contains(N.target) && (i.value = !1);
    }
    function K(N) {
      i.value && N.key === "Escape" && (i.value = !1);
    }
    return jt(() => {
      document.addEventListener("mousedown", P), document.addEventListener("keydown", K);
    }), Tt(() => {
      document.removeEventListener("mousedown", P), document.removeEventListener("keydown", K);
    }), (N, J) => x.value ? (f(), h("div", {
      key: 0,
      ref_key: "rootEl",
      ref: r,
      class: Re(["fe-opc", { "fe-opc--narrow": e.narrow, "fe-opc--open": i.value }])
    }, [
      Ze(Rr, { name: "fe-opc-pop" }, {
        default: mt(() => [
          i.value ? (f(), h("section", {
            key: 0,
            class: "fe-opc__panel",
            role: "dialog",
            "aria-label": u(n)("opc.title")
          }, [
            d("header", bZ, [
              d("strong", null, y(u(n)("opc.title")), 1),
              d("button", {
                type: "button",
                class: "fe-opc__x",
                "aria-label": u(n)("opc.close"),
                onClick: J[0] || (J[0] = (j) => i.value = !1)
              }, "×", 8, kZ)
            ]),
            d("div", wZ, [
              l.value.length > 0 ? (f(), h("div", _Z, [
                d("h3", xZ, y(u(n)("opc.active")), 1),
                d("ul", SZ, [
                  (f(!0), h(Te, null, nt(l.value, (j) => (f(), h("li", {
                    key: j.key,
                    class: Re(["fe-opc__item", `is-${j.status}`])
                  }, [
                    (f(), h("svg", $Z, [
                      d("path", {
                        d: T[j.kind]
                      }, null, 8, TZ)
                    ])),
                    d("div", AZ, [
                      d("div", {
                        class: "fe-opc__name",
                        title: R(j)
                      }, y(R(j)), 9, EZ),
                      d("div", CZ, [
                        d("span", zZ, y(E(j)), 1),
                        z(j) ? (f(), h(Te, { key: 0 }, [
                          J[3] || (J[3] = d("span", {
                            class: "fe-opc__dot",
                            "aria-hidden": "true"
                          }, "·", -1)),
                          d("span", {
                            class: "fe-opc__outmode",
                            title: D(j),
                            "data-testid": "opc-output-mode"
                          }, y(z(j)), 9, MZ)
                        ], 64)) : O("", !0),
                        J[4] || (J[4] = d("span", {
                          class: "fe-opc__dot",
                          "aria-hidden": "true"
                        }, "·", -1)),
                        d("span", PZ, y(U(j)), 1)
                      ]),
                      j.status === "error" && j.errorDetail ? (f(), h("div", OZ, y(j.errorDetail), 1)) : O("", !0),
                      j.status === "running" && j.percent !== null ? (f(), h("div", {
                        key: 1,
                        class: "fe-opc__bar",
                        role: "progressbar",
                        "aria-valuenow": j.percent,
                        "aria-valuemin": "0",
                        "aria-valuemax": "100"
                      }, [
                        d("div", {
                          class: "fe-opc__bar-fill",
                          style: Yt({ width: j.percent + "%" })
                        }, null, 4)
                      ], 8, LZ)) : O("", !0)
                    ]),
                    j.status === "running" && j.percent === null && !j.queued ? (f(), h("span", DZ)) : O("", !0),
                    d("div", RZ, [
                      j.status === "running" && j.cancellable ? (f(), h("button", {
                        key: 0,
                        type: "button",
                        class: "fe-opc__act",
                        onClick: (re) => e.center.cancel(j.key)
                      }, y(u(n)("opc.cancel")), 9, NZ)) : O("", !0),
                      H(j) ? (f(), h("button", {
                        key: 1,
                        type: "button",
                        class: "fe-opc__act",
                        "data-testid": "opc-open",
                        onClick: (re) => e.center.open(j.key)
                      }, y(u(n)("opc.open")), 9, IZ)) : O("", !0),
                      j.status === "error" && j.retryable ? (f(), h("button", {
                        key: 2,
                        type: "button",
                        class: "fe-opc__act fe-opc__act--retry",
                        onClick: (re) => e.center.retry(j.key)
                      }, y(u(n)("opc.retry")), 9, BZ)) : O("", !0),
                      j.status !== "running" ? (f(), h("button", {
                        key: 3,
                        type: "button",
                        class: "fe-opc__x",
                        "aria-label": u(n)("opc.dismiss"),
                        onClick: (re) => e.center.dismiss(j.key)
                      }, "×", 8, FZ)) : O("", !0)
                    ])
                  ], 2))), 128))
                ])
              ])) : O("", !0),
              c.value.length > 0 ? (f(), h("div", UZ, [
                d("h3", HZ, [
                  Ht(y(u(n)("opc.history")) + " ", 1),
                  d("button", {
                    type: "button",
                    class: "fe-opc__act",
                    onClick: J[1] || (J[1] = (j) => e.center.clearHistory())
                  }, y(u(n)("opc.clear")), 1)
                ]),
                d("ul", KZ, [
                  (f(!0), h(Te, null, nt(c.value, (j) => (f(), h("li", {
                    key: "h-" + j.key,
                    class: Re(["fe-opc__item fe-opc__item--history", `is-${j.status}`])
                  }, [
                    (f(), h("svg", VZ, [
                      d("path", {
                        d: T[j.kind]
                      }, null, 8, jZ)
                    ])),
                    d("div", qZ, [
                      d("div", {
                        class: "fe-opc__name",
                        title: R(j)
                      }, y(R(j)), 9, WZ),
                      z(j) ? (f(), h("div", YZ, [
                        d("span", {
                          class: "fe-opc__outmode",
                          title: D(j),
                          "data-testid": "opc-output-mode"
                        }, y(z(j)), 9, GZ)
                      ])) : O("", !0),
                      j.status === "error" && j.error ? (f(), h("div", XZ, y(j.error), 1)) : O("", !0),
                      j.status === "error" && j.errorDetail ? (f(), h("div", JZ, y(j.errorDetail), 1)) : O("", !0)
                    ]),
                    H(j) ? (f(), h("button", {
                      key: 0,
                      type: "button",
                      class: "fe-opc__act",
                      onClick: (re) => e.center.open(j.key)
                    }, y(u(n)("opc.open")), 9, ZZ)) : O("", !0),
                    d("span", {
                      class: Re(["fe-opc__chip", `is-${j.status}`])
                    }, y(L(j)), 3)
                  ], 2))), 128))
                ])
              ])) : O("", !0),
              l.value.length === 0 && c.value.length === 0 ? (f(), h("p", QZ, y(u(n)("opc.empty")), 1)) : O("", !0)
            ])
          ], 8, gZ)) : O("", !0)
        ]),
        _: 1
      }),
      d("button", {
        type: "button",
        class: Re(["fe-opc__badge", { "is-error": p.value }]),
        "aria-expanded": i.value,
        "aria-label": C.value,
        onClick: J[2] || (J[2] = (j) => i.value = !i.value)
      }, [
        (f(), h("svg", {
          class: Re(["fe-opc__ring", { "fe-opc__ring--spin": k.value }]),
          viewBox: "0 0 22 22",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          d("circle", {
            class: "fe-opc__ring-track",
            cx: "11",
            cy: "11",
            r: fv,
            fill: "none",
            "stroke-width": "2.5"
          }),
          d("circle", {
            class: "fe-opc__ring-fill",
            cx: "11",
            cy: "11",
            r: fv,
            fill: "none",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-dasharray": w,
            "stroke-dashoffset": $.value,
            transform: "rotate(-90 11 11)"
          }, null, 8, tQ)
        ], 2)),
        d("span", nQ, y(l.value.length), 1),
        b.value ? (f(), h("span", aQ, y(b.value), 1)) : O("", !0)
      ], 10, eQ)
    ], 2)) : O("", !0);
  }
}), oQ = 4e3, x0 = 50;
function rQ(e, t, n) {
  const a = t.status !== "running";
  return {
    key: e,
    kind: t.kind,
    name: t.name,
    percent: t.percent,
    status: t.status,
    error: t.error ?? null,
    errorDetail: t.errorDetail ?? null,
    queued: t.queued ?? !1,
    waitText: t.waitText ?? null,
    cancelling: t.cancelling ?? !1,
    doneCount: t.doneCount ?? null,
    totalCount: t.totalCount ?? null,
    itemsDone: t.itemsDone ?? null,
    itemsTotal: t.itemsTotal ?? null,
    uploadedBytes: t.uploadedBytes ?? null,
    totalBytes: t.totalBytes ?? null,
    cancellable: t.cancellable ?? !1,
    retryable: t.retryable ?? !1,
    message: t.message ?? null,
    outputs: t.outputs ?? [],
    outputMode: t.outputMode ?? null,
    startedAt: (n == null ? void 0 : n.startedAt) ?? Date.now(),
    settledAt: (n == null ? void 0 : n.settledAt) ?? (a ? Date.now() : null)
  };
}
function sQ() {
  const e = S([]), t = S([]), n = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Map();
  function r(z) {
    const D = i.get(z);
    D !== void 0 && (clearTimeout(D), i.delete(z));
  }
  function l(z, D = {}) {
    r(z);
    const U = e.value.findIndex((L) => L.key === z);
    if (U === -1) return;
    const [H] = e.value.splice(U, 1);
    e.value = [...e.value], a.add(z), D.toHistory !== !1 && (t.value = [{ ...H, settledAt: H.settledAt ?? Date.now() }, ...t.value].slice(
      0,
      x0
    ));
  }
  function c(z) {
    i.has(z) || i.set(
      z,
      setTimeout(() => {
        var U;
        i.delete(z);
        const D = n.get(z);
        l(z), (U = D == null ? void 0 : D.dismiss) == null || U.call(D);
      }, oQ)
    );
  }
  function p(z, D) {
    const U = `${z}:`, H = /* @__PURE__ */ new Set();
    let L = [...e.value], P = !1;
    for (const K of D) {
      const N = `${z}:${K.input.id}`;
      if (H.add(N), K.actions && n.set(N, K.actions), a.has(N)) continue;
      const J = L.findIndex((re) => re.key === N), j = rQ(N, K.input, J === -1 ? void 0 : L[J]);
      J === -1 ? (L = [j, ...L], P = !0) : JSON.stringify(L[J]) !== JSON.stringify(j) && (L[J] = j, P = !0), (j.status === "done" || j.status === "aborted") && c(N);
    }
    for (const K of [...L])
      !K.key.startsWith(U) || H.has(K.key) || K.status !== "error" && (r(K.key), L = L.filter((N) => N.key !== K.key), P = !0, K.status !== "running" && (a.add(K.key), t.value = [{ ...K, settledAt: K.settledAt ?? Date.now() }, ...t.value].slice(
        0,
        x0
      )));
    for (const K of [...a])
      K.startsWith(U) && !H.has(K) && a.delete(K);
    for (const K of [...n.keys()])
      if (K.startsWith(U) && !H.has(K) && !e.value.some((N) => N.key === K)) {
        if (L.some((N) => N.key === K) || t.value.some((N) => N.key === K && N.outputs.length > 0)) continue;
        n.delete(K);
      }
    P && (e.value = L);
  }
  function m(z) {
    var D, U;
    (U = (D = n.get(z)) == null ? void 0 : D.cancel) == null || U.call(D);
  }
  function v(z) {
    var U, H;
    const D = n.get(z);
    l(z), (U = D == null ? void 0 : D.dismiss) == null || U.call(D), (H = D == null ? void 0 : D.retry) == null || H.call(D);
  }
  function x(z) {
    var U;
    const D = n.get(z);
    l(z), (U = D == null ? void 0 : D.dismiss) == null || U.call(D);
  }
  function w(z, D) {
    var L, P;
    const U = e.value.find((K) => K.key === z) ?? t.value.find((K) => K.key === z), H = D ?? (U == null ? void 0 : U.outputs[0]);
    H && ((P = (L = n.get(z)) == null ? void 0 : L.open) == null || P.call(L, H));
  }
  function $() {
    t.value = [];
  }
  const k = S(0);
  function b() {
    k.value += 1;
  }
  const C = A(
    () => e.value.filter((z) => z.status === "running").length
  ), T = A(() => e.value.filter((z) => z.status === "error").length), E = A(() => T.value > 0), R = A(() => {
    const z = e.value.filter((H) => H.status === "running");
    let D = 0, U = 0;
    for (const H of z)
      H.percent !== null && (D += Math.min(1, Math.max(0, H.percent / 100)), U += 1);
    return U === 0 ? null : Math.round(D / U * 100);
  });
  return l2() && Ey(() => {
    for (const z of i.values()) clearTimeout(z);
    i.clear();
  }), {
    active: e,
    history: t,
    runningCount: C,
    errorCount: T,
    hasError: E,
    overallPercent: R,
    sync: p,
    cancel: m,
    retry: v,
    dismiss: x,
    open: w,
    clearHistory: $,
    revealRequests: k,
    reveal: b
  };
}
const zT = "filex.tourDone", S0 = "done", lQ = 900, uQ = 5e3;
function cQ() {
  try {
    return !!localStorage.getItem(zT);
  } catch {
    return !0;
  }
}
function pv() {
  return cQ() || !!Qi().tour;
}
let Dr = null;
function MT() {
  try {
    localStorage.setItem(zT, "1");
  } catch {
  }
  if (!Fl()) return;
  if (S$()) {
    Qi().tour || Zi("tour", S0);
    return;
  }
  if (Dr) return;
  const e = Jc((t) => {
    e(), Dr = null, t.tour || Zi("tour", S0);
  });
  Dr = e;
}
function dQ(e, t = {}) {
  const n = t.delayMs ?? lQ, a = t.accountWaitMs ?? uQ;
  let i = !1, r, l, c;
  const p = () => {
    i = !0, r && clearTimeout(r), l && clearTimeout(l), c == null || c();
  };
  if (pv()) return p;
  const m = () => {
    l && clearTimeout(l), c == null || c(), !(i || pv()) && (MT(), e());
  };
  return r = setTimeout(() => {
    if (!(i || pv())) {
      if (!Fl() || jF()) {
        m();
        return;
      }
      l = setTimeout(m, a), c = qF(m);
    }
  }, n), p;
}
function hhe() {
  Dr == null || Dr(), Dr = null;
}
const fQ = ["aria-label"], pQ = {
  key: 0,
  class: "fe-tabs__scroll"
}, hQ = ["aria-selected", "title", "onClick", "onKeydown", "onAuxclick", "onDragstart", "onDragover", "onDragleave", "onDrop"], mQ = {
  key: 0,
  class: "fe-tabs__splitdot",
  "aria-hidden": "true"
}, vQ = { class: "fe-tabs__label" }, yQ = ["aria-label", "title", "onClick"], gQ = ["aria-label", "title"], bQ = ["aria-label", "title", "aria-pressed"], kQ = ["aria-pressed", "title", "aria-label"], wQ = /* @__PURE__ */ lt({
  __name: "TabBar",
  props: {
    tabs: {},
    activeId: {},
    locale: {},
    splitEnabled: { type: Boolean },
    splitActive: { type: Boolean },
    inspectorEnabled: { type: Boolean },
    inspectorOpen: { type: Boolean },
    hideTabs: { type: Boolean }
  },
  emits: ["select", "close", "new", "reorder", "toggle-split", "toggle-inspector"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = S(null), l = S(null);
    function c(k, b) {
      var C;
      r.value = k, b.dataTransfer && (b.dataTransfer.effectAllowed = "move", b.dataTransfer.setData("text/plain", ((C = n.tabs[k]) == null ? void 0 : C.id) ?? ""));
    }
    function p(k, b) {
      r.value !== null && (b.preventDefault(), b.stopPropagation(), b.dataTransfer && (b.dataTransfer.dropEffect = "move"), l.value = k);
    }
    function m(k) {
      l.value === k && (l.value = null);
    }
    function v(k, b) {
      r.value !== null && (b.preventDefault(), b.stopPropagation(), r.value !== k && a("reorder", r.value, k), r.value = null, l.value = null);
    }
    function x() {
      r.value = null, l.value = null;
    }
    function w(k) {
      k.button === 1 && k.preventDefault();
    }
    function $(k, b) {
      b.button === 1 && (b.preventDefault(), b.stopPropagation(), !(n.tabs.length <= 1) && a("close", k));
    }
    return (k, b) => (f(), h("div", {
      class: "fe-tabs",
      role: "tablist",
      "aria-label": u(i)("tabs.strip")
    }, [
      e.hideTabs ? O("", !0) : (f(), h("div", pQ, [
        (f(!0), h(Te, null, nt(e.tabs, (C, T) => (f(), h("div", {
          key: C.id,
          class: Re(["fe-tabs__tab", {
            "is-active": C.id === e.activeId,
            "is-dragover": l.value === T && r.value !== null && r.value !== T
          }]),
          role: "tab",
          "aria-selected": C.id === e.activeId ? "true" : "false",
          tabindex: "0",
          draggable: "true",
          title: C.label,
          onClick: (E) => a("select", C.id),
          onKeydown: Ca(yt((E) => a("select", C.id), ["prevent"]), ["enter"]),
          onMousedown: b[0] || (b[0] = (E) => w(E)),
          onAuxclick: (E) => $(C.id, E),
          onDragstart: (E) => c(T, E),
          onDragover: (E) => p(T, E),
          onDragleave: (E) => m(T),
          onDrop: (E) => v(T, E),
          onDragend: x
        }, [
          C.split ? (f(), h("span", mQ)) : O("", !0),
          d("span", vQ, [
            d("bdi", null, y(C.label), 1)
          ]),
          e.tabs.length > 1 ? (f(), h("button", {
            key: 1,
            type: "button",
            class: "fe-tabs__close",
            "aria-label": u(i)("tabs.close"),
            title: u(i)("tabs.close"),
            onClick: yt((E) => a("close", C.id), ["stop"])
          }, "×", 8, yQ)) : O("", !0)
        ], 42, hQ))), 128))
      ])),
      e.hideTabs ? O("", !0) : (f(), h("button", {
        key: 1,
        type: "button",
        class: "fe-tabs__new",
        "aria-label": u(i)("tabs.new"),
        title: u(i)("tabs.new"),
        onClick: b[1] || (b[1] = (C) => a("new"))
      }, "+", 8, gQ)),
      e.splitEnabled !== !1 ? (f(), h("button", {
        key: 2,
        type: "button",
        class: Re(["fe-tabs__split", { "is-active": e.splitActive }]),
        "aria-label": e.splitActive ? u(i)("tabs.split_off") : u(i)("tabs.split"),
        title: e.splitActive ? u(i)("tabs.split_off") : u(i)("tabs.split"),
        "aria-pressed": e.splitActive ? "true" : "false",
        "data-testid": "tabs-split",
        onClick: b[2] || (b[2] = (C) => a("toggle-split"))
      }, [...b[4] || (b[4] = [
        d("svg", {
          class: "fe-ficon",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "1.8",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          d("rect", {
            x: "3",
            y: "4",
            width: "18",
            height: "16",
            rx: "2"
          }),
          d("path", { d: "M12 4v16" })
        ], -1)
      ])], 10, bQ)) : O("", !0),
      e.inspectorEnabled ? (f(), h("button", {
        key: 3,
        type: "button",
        class: Re(["fe-tabs__inspector", { "is-active": e.inspectorOpen }]),
        "aria-pressed": e.inspectorOpen ? "true" : "false",
        title: u(i)("toolbar.inspector"),
        "aria-label": u(i)("toolbar.inspector"),
        "data-testid": "tabs-inspector",
        onClick: b[3] || (b[3] = (C) => a("toggle-inspector"))
      }, [...b[5] || (b[5] = [
        d("svg", {
          class: "fe-ficon",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "1.8",
          "stroke-linecap": "round",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          d("circle", {
            cx: "12",
            cy: "12",
            r: "9"
          }),
          d("path", { d: "M12 11v5" }),
          d("circle", {
            cx: "12",
            cy: "7.6",
            r: "1",
            fill: "currentColor",
            stroke: "none"
          })
        ], -1)
      ])], 10, kQ)) : O("", !0)
    ], 8, fQ));
  }
}), PT = Symbol("filex.e2eLock"), _Q = ["width", "height"], xQ = { class: "fe-state__title" }, SQ = { class: "fe-state__hint" }, $Q = ["placeholder", "aria-label", "disabled"], TQ = ["disabled"], AQ = {
  key: 0,
  class: "fe-form__error",
  role: "alert"
}, OT = /* @__PURE__ */ lt({
  __name: "E2eLockScreen",
  props: {
    locale: {},
    busy: { type: Boolean, default: !1 },
    error: { default: "" },
    showRecovery: { type: Boolean, default: !0 },
    compact: { type: Boolean, default: !1 }
  },
  emits: ["unlock", "recovery"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, { t: r } = ht(() => a.locale), l = S("");
    function c() {
      !l.value || a.busy || i("unlock", l.value);
    }
    return t({ clear: () => l.value = "" }), (p, m) => (f(), h("div", {
      class: Re(["fe-state fe-e2e-lock", { "fe-e2e-lock--compact": e.compact }]),
      "data-testid": "e2e-lock"
    }, [
      (f(), h("svg", {
        class: "fe-state__art",
        viewBox: "0 0 120 100",
        width: e.compact ? 80 : 110,
        height: e.compact ? 67 : 92,
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "aria-hidden": "true"
      }, [...m[2] || (m[2] = [
        d("rect", {
          x: "38",
          y: "44",
          width: "44",
          height: "34",
          rx: "6"
        }, null, -1),
        d("path", { d: "M46 44v-8a14 14 0 0 1 28 0v8" }, null, -1),
        d("circle", {
          cx: "60",
          cy: "59",
          r: "3",
          fill: "currentColor",
          stroke: "none"
        }, null, -1),
        d("path", { d: "M60 62v7" }, null, -1)
      ])], 8, _Q)),
      d("p", xQ, y(u(r)("e2e.locked.title")), 1),
      d("p", SQ, y(u(r)("e2e.locked.hint")), 1),
      d("form", {
        class: "fe-e2e-lock__form",
        onSubmit: yt(c, ["prevent"])
      }, [
        dn(d("input", {
          "onUpdate:modelValue": m[0] || (m[0] = (v) => l.value = v),
          type: "password",
          class: "fe-input fe-e2e-lock__input",
          placeholder: u(r)("e2e.locked.pw_placeholder"),
          "aria-label": u(r)("e2e.locked.pw_placeholder"),
          autocomplete: "current-password",
          disabled: e.busy
        }, null, 8, $Q), [
          [_n, l.value]
        ]),
        d("button", {
          type: "submit",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy || !l.value
        }, y(e.busy ? u(r)("e2e.locked.busy") : u(r)("e2e.locked.unlock")), 9, TQ)
      ], 32),
      e.error ? (f(), h("p", AQ, y(e.error), 1)) : O("", !0),
      e.showRecovery ? (f(), h("button", {
        key: 1,
        type: "button",
        class: "fe-e2e-optlink",
        onClick: m[1] || (m[1] = (v) => i("recovery"))
      }, y(u(r)("e2e.locked.use_recovery")), 1)) : O("", !0)
    ], 2));
  }
}), EQ = ["aria-label"], CQ = ["aria-current", "title", "aria-label"], zQ = ["innerHTML"], MQ = {
  key: 0,
  class: "fe-breadcrumb__sep",
  "aria-hidden": "true"
}, PQ = ["aria-current", "onClick", "onContextmenu", "onDrop"], OQ = {
  key: 0,
  class: "fe-breadcrumb__sep",
  "aria-hidden": "true"
}, LQ = ["aria-expanded", "aria-label", "title"], DQ = {
  key: 0,
  class: "fe-breadcrumb__menu",
  role: "menu"
}, RQ = ["onClick"], NQ = ["aria-current", "onClick", "onContextmenu", "onDrop"], IQ = {
  key: 0,
  class: "fe-breadcrumb__sep",
  "aria-hidden": "true"
}, BQ = ["aria-expanded", "title", "aria-label"], FQ = ["innerHTML"], UQ = {
  key: 0,
  class: "fe-breadcrumb__menu",
  role: "menu"
}, HQ = ["onClick"], KQ = {
  key: 0,
  class: "fe-breadcrumb__menu-empty"
}, VQ = ["title", "aria-label"], jQ = ["innerHTML"], qQ = ["placeholder", "onKeydown"], WQ = 4, YQ = /* @__PURE__ */ lt({
  __name: "Breadcrumb",
  props: {
    dirname: {},
    adapter: {},
    rootLabel: {},
    locale: {},
    multiStorageRoot: { type: Boolean },
    rootPath: {},
    subfolders: {}
  },
  emits: ["navigate", "copy-path", "crumb-context", "crumb-drop"],
  setup(e, { emit: t }) {
    const n = e, a = A(() => {
      if (!n.rootPath) return "";
      const Y = n.rootPath, B = Y.indexOf("://");
      return (B >= 0 ? Y.slice(B + 3) : Y).replace(/^\/+|\/+$/g, "");
    }), i = A(() => {
      const Y = a.value;
      if (!Y) return n.rootLabel || n.adapter;
      const B = Y.split("/");
      return B[B.length - 1] || n.rootLabel || n.adapter;
    }), { t: r } = ht(() => n.locale), l = bi(jc, null), c = t, p = A(() => {
      const Y = n.adapter ? `${n.adapter}://` : "", B = Y && n.dirname.startsWith(Y) ? n.dirname.slice(Y.length) : n.dirname, W = B.split("/").filter(Boolean), F = (qe) => (l == null ? void 0 : l.segmentLabel(qe)) ?? null, V = [];
      if (n.rootPath) {
        const qe = a.value, Me = B.replace(/^\/+|\/+$/g, ""), Fe = qe && (Me === qe || Me.startsWith(qe + "/")) ? Me.slice(qe.length).replace(/^\/+/, "") : "";
        V.push({ label: i.value, adapterPath: n.rootPath });
        let We = qe;
        for (const $t of Fe.split("/").filter(Boolean))
          We = We ? `${We}/${$t}` : $t, V.push({
            label: lp($t, r) || da(F(`${Y}${We}`) || $t),
            adapterPath: `${Y}${We}`
          });
        return V;
      }
      n.multiStorageRoot ? (V.push({ label: "/", adapterPath: "" }), n.adapter && V.push({ label: n.rootLabel || n.adapter, adapterPath: Y })) : (n.adapter || n.rootLabel) && V.push({
        label: n.rootLabel || n.adapter,
        adapterPath: Y
      });
      let ke = "";
      for (const qe of W) {
        ke = ke ? `${ke}/${qe}` : qe;
        const Me = lp(qe, r) || da(F(`${Y}${ke}`) || qe);
        V.push({ label: Me, adapterPath: `${Y}${ke}` });
      }
      return V;
    }), m = A(() => {
      const Y = p.value[0];
      return Y && n.multiStorageRoot && Y.adapterPath === "" ? Y : null;
    }), v = A(
      () => m.value ? p.value.slice(1) : p.value
    ), x = A(() => !!m.value && v.value.length === 0), w = A(() => v.value.length > WQ), $ = A(
      () => w.value ? v.value.slice(0, 1) : v.value
    ), k = A(
      () => w.value ? v.value.slice(1, -2) : []
    ), b = A(
      () => w.value ? v.value.slice(-2) : []
    ), C = S(!1), T = S(null), E = S(!1), R = S(null), z = A(() => C.value || E.value);
    function D() {
      C.value = !1, E.value = !1;
    }
    function U(Y) {
      D(), c("navigate", Y.adapterPath);
    }
    function H() {
      C.value = !1, E.value = !E.value;
    }
    function L(Y) {
      var W, F;
      const B = Y.target;
      if (!(B instanceof Node)) {
        D();
        return;
      }
      (W = T.value) != null && W.contains(B) || (F = R.value) != null && F.contains(B) || D();
    }
    function P(Y) {
      Y.key === "Escape" && (Y.stopPropagation(), D());
    }
    Je(z, (Y) => {
      Y ? (document.addEventListener("click", L, !0), document.addEventListener("keydown", P, !0)) : (document.removeEventListener("click", L, !0), document.removeEventListener("keydown", P, !0));
    }), Je(p, D), Tt(() => {
      document.removeEventListener("click", L, !0), document.removeEventListener("keydown", P, !0);
    });
    function K(Y) {
      c("navigate", Y.adapterPath);
    }
    function N() {
      m.value && K(m.value);
    }
    function J(Y) {
      m.value && re(Y, m.value);
    }
    function j(Y) {
      m.value && le(Y, m.value);
    }
    function re(Y, B) {
      Y.preventDefault(), Y.stopPropagation(), c("crumb-context", {
        x: Y.clientX,
        y: Y.clientY,
        adapterPath: B.adapterPath,
        label: B.label
      });
    }
    function q(Y) {
      ti(Y) && (Y.preventDefault(), Y.stopPropagation(), Y.dataTransfer && (Y.dataTransfer.dropEffect = "move"));
    }
    function le(Y, B) {
      ti(Y) && (Y.preventDefault(), Y.stopPropagation(), c("crumb-drop", B.adapterPath, Y));
    }
    const ve = S(!1), ce = S(""), se = S(null);
    function fe() {
      const Y = `${n.adapter}://`, B = n.dirname.startsWith(Y) ? n.dirname.slice(Y.length) : n.dirname;
      if (n.rootPath) {
        const W = a.value, F = B.replace(/^\/+|\/+$/g, ""), V = W && (F === W || F.startsWith(W + "/")) ? F.slice(W.length).replace(/^\/+/, "") : "";
        ce.value = V ? `/${V}` : "/", ve.value = !0, Gt(() => {
          var ke, qe;
          (ke = se.value) == null || ke.focus(), (qe = se.value) == null || qe.select();
        });
        return;
      }
      if (n.multiStorageRoot)
        if (!n.adapter)
          ce.value = "/";
        else {
          const W = B.replace(/^\/+|\/+$/g, "");
          ce.value = W ? `/${n.adapter}/${W}` : `/${n.adapter}`;
        }
      else
        ce.value = B;
      ve.value = !0, Gt(() => {
        var W, F;
        (W = se.value) == null || W.focus(), (F = se.value) == null || F.select();
      });
    }
    function _() {
      const Y = ce.value.trim();
      if (ve.value = !1, n.rootPath) {
        const W = Y.replace(/^\/+|\/+$/g, ""), F = a.value, V = W ? F ? `${F}/${W}` : W : F;
        c("navigate", V ? `${n.adapter}://${V}` : `${n.adapter}://`);
        return;
      }
      if (n.multiStorageRoot) {
        const W = Y.replace(/^\/+|\/+$/g, "");
        if (!W) {
          c("navigate", "");
          return;
        }
        const F = W.indexOf("/"), V = F === -1 ? W : W.slice(0, F), ke = F === -1 ? "" : W.slice(F + 1);
        c("navigate", ke ? `${V}://${ke}` : `${V}://`);
        return;
      }
      const B = Y.replace(/^\/+|\/+$/g, "");
      B && c("navigate", `${n.adapter}://${B}`);
    }
    function ee() {
      ve.value = !1;
    }
    return (Y, B) => (f(), h("nav", {
      class: "fe-breadcrumb",
      "aria-label": u(r)("breadcrumb.aria")
    }, [
      ve.value ? dn((f(), h("input", {
        key: 1,
        ref_key: "pathInput",
        ref: se,
        "onUpdate:modelValue": B[1] || (B[1] = (W) => ce.value = W),
        type: "text",
        class: "fe-breadcrumb__input",
        placeholder: u(r)("breadcrumb.path_placeholder"),
        spellcheck: "false",
        autocomplete: "off",
        onKeydown: [
          Ca(yt(_, ["prevent"]), ["enter"]),
          Ca(yt(ee, ["prevent"]), ["escape"])
        ],
        onBlur: ee
      }, null, 40, qQ)), [
        [_n, ce.value]
      ]) : (f(), h(Te, { key: 0 }, [
        m.value ? (f(), h("button", {
          key: 0,
          type: "button",
          class: Re(["fe-breadcrumb__crumb fe-breadcrumb__home", { "is-last": x.value }]),
          "aria-current": x.value ? "page" : void 0,
          title: u(r)("breadcrumb.root"),
          "aria-label": u(r)("breadcrumb.root"),
          "data-testid": "breadcrumb-home",
          onClick: N,
          onContextmenu: J,
          onDragover: q,
          onDrop: j
        }, [
          d("span", {
            class: "fe-icon",
            "aria-hidden": "true",
            innerHTML: u(zt)("home")
          }, null, 8, zQ),
          x.value ? O("", !0) : (f(), h("span", MQ, "›"))
        ], 42, CQ)) : O("", !0),
        (f(!0), h(Te, null, nt($.value, (W, F) => (f(), h("button", {
          key: W.adapterPath,
          class: Re(["fe-breadcrumb__crumb", { "is-last": !w.value && F === $.value.length - 1 }]),
          type: "button",
          "aria-current": !w.value && F === $.value.length - 1 ? "page" : void 0,
          onClick: (V) => K(W),
          onContextmenu: (V) => re(V, W),
          onDragover: q,
          onDrop: (V) => le(V, W)
        }, [
          d("span", null, [
            d("bdi", null, y(W.label), 1)
          ]),
          w.value || F < $.value.length - 1 ? (f(), h("span", OQ, "›")) : O("", !0)
        ], 42, PQ))), 128)),
        k.value.length ? (f(), h("span", {
          key: 1,
          ref_key: "moreWrapEl",
          ref: T,
          class: "fe-breadcrumb__more-wrap"
        }, [
          d("button", {
            type: "button",
            class: "fe-breadcrumb__more",
            "aria-haspopup": "menu",
            "aria-expanded": C.value,
            "aria-label": u(r)("breadcrumb.more"),
            title: u(r)("breadcrumb.more"),
            onClick: B[0] || (B[0] = (W) => C.value = !C.value)
          }, "…", 8, LQ),
          B[2] || (B[2] = d("span", {
            class: "fe-breadcrumb__sep",
            "aria-hidden": "true"
          }, "›", -1)),
          C.value ? (f(), h("div", DQ, [
            (f(!0), h(Te, null, nt(k.value, (W) => (f(), h("button", {
              key: W.adapterPath,
              type: "button",
              class: "fe-breadcrumb__menu-item",
              role: "menuitem",
              onClick: (F) => U(W)
            }, [
              d("bdi", null, y(W.label), 1)
            ], 8, RQ))), 128))
          ])) : O("", !0)
        ], 512)) : O("", !0),
        (f(!0), h(Te, null, nt(b.value, (W, F) => (f(), h("button", {
          key: W.adapterPath,
          class: Re(["fe-breadcrumb__crumb", { "is-last": F === b.value.length - 1 }]),
          type: "button",
          "aria-current": F === b.value.length - 1 ? "page" : void 0,
          onClick: (V) => K(W),
          onContextmenu: (V) => re(V, W),
          onDragover: q,
          onDrop: (V) => le(V, W)
        }, [
          d("span", null, [
            d("bdi", null, y(W.label), 1)
          ]),
          F < b.value.length - 1 ? (f(), h("span", IQ, "›")) : O("", !0)
        ], 42, NQ))), 128)),
        e.subfolders ? (f(), h("span", {
          key: 2,
          ref_key: "subWrapEl",
          ref: R,
          class: "fe-breadcrumb__sub-wrap"
        }, [
          d("button", {
            type: "button",
            class: "fe-breadcrumb__sub",
            "aria-haspopup": "menu",
            "aria-expanded": E.value,
            title: u(r)("breadcrumb.subfolders"),
            "aria-label": u(r)("breadcrumb.subfolders"),
            "data-testid": "breadcrumb-subfolders",
            onClick: H
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("subfolders")
            }, null, 8, FQ)
          ], 8, BQ),
          E.value ? (f(), h("div", UQ, [
            (f(!0), h(Te, null, nt(e.subfolders, (W) => (f(), h("button", {
              key: W.adapterPath,
              type: "button",
              class: "fe-breadcrumb__menu-item",
              role: "menuitem",
              onClick: (F) => U(W)
            }, [
              d("bdi", null, y(W.label), 1)
            ], 8, HQ))), 128)),
            e.subfolders.length ? O("", !0) : (f(), h("p", KQ, y(u(r)("breadcrumb.subfolders.empty")), 1))
          ])) : O("", !0)
        ], 512)) : O("", !0),
        d("button", {
          type: "button",
          class: "fe-breadcrumb__edit",
          title: u(r)("breadcrumb.go_to_path"),
          "aria-label": u(r)("breadcrumb.go_to_path"),
          "data-testid": "breadcrumb-edit-path",
          onClick: fe
        }, [
          d("span", {
            class: "fe-icon",
            "aria-hidden": "true",
            innerHTML: u(zt)("edit-path")
          }, null, 8, jQ)
        ], 8, VQ)
      ], 64))
    ], 8, EQ));
  }
}), GQ = ["data-mode"], XQ = ["aria-label"], JQ = ["aria-expanded", "data-testid", "onClick"], ZQ = { class: "fe-filterbar__label" }, QQ = { class: "fe-filterbar__find" }, eee = ["placeholder", "aria-label", "value", "onKeydown"], tee = {
  key: 2,
  class: "fe-filterbar__count",
  role: "status",
  "data-testid": "filter-count"
}, nee = {
  key: 3,
  class: "fe-filterbar__sort"
}, aee = ["disabled", "title"], iee = { class: "fe-sr-only" }, oee = {
  key: 0,
  class: "fe-ficon fe-filterbar__sortarrow",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, ree = ["aria-label", "title", "disabled", "aria-expanded"], see = ["aria-label", "title", "aria-expanded"], lee = ["dir", "role", "aria-label"], uee = {
  key: 0,
  class: "fe-filterpop__rule",
  "aria-hidden": "true"
}, cee = ["disabled", "aria-disabled", "data-testid", "onClick"], dee = ["data-active", "data-testid", "onClick"], fee = ["aria-selected", "data-checked", "data-active", "data-testid", "onClick"], pee = {
  class: "fe-filterpop__tick",
  "aria-hidden": "true"
}, hee = /* @__PURE__ */ lt({
  __name: "FilterBar",
  props: {
    value: {},
    locale: {},
    theme: {},
    shown: {},
    total: {},
    files: {},
    canPaste: { type: Boolean },
    canWrite: { type: Boolean },
    order: {},
    mode: {},
    findLabel: {}
  },
  emits: ["update:value", "new-folder", "upload", "paste", "select-all"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, dir: r } = ht(() => n.locale), l = A(() => (n.mode ?? "full") === "full"), c = A(() => n.findLabel || i("filter.find")), p = ["type", "people", "modified", "size"], m = [
      "any",
      "folder",
      "document",
      "spreadsheet",
      "presentation",
      "pdf",
      "image",
      "video",
      "audio",
      "archive",
      "code"
    ], v = ["any", "today", "7d", "30d", "year"], x = ["any", "lt1", "1to10", "10to100", "gt100"], w = A(() => Z5(n.files ?? []));
    function $(ie) {
      return ie === "people" ? w.value.map((xe) => xe.value) : ie === "type" ? m : ie === "modified" ? v : x;
    }
    function k(ie, xe) {
      var he;
      return ie === "people" && xe.startsWith("u:") ? ((he = w.value.find((De) => De.value === xe)) == null ? void 0 : he.name) || xe.slice(2) : i(`filter.${ie}.${xe}`);
    }
    function b(ie) {
      const xe = ie === "people" ? n.value.people ?? "any" : n.value[ie];
      return xe === "any" ? i(`filter.${ie}`) : k(ie, xe);
    }
    function C(ie) {
      return ie === "people" ? n.value.people ?? "any" : n.value[ie];
    }
    const T = A(() => H5(n.value)), E = Vc(), R = A(() => E.key.value), z = A(() => E.dir.value === "asc"), D = A(() => n.order === "relevance"), U = A(() => D.value ? i("sort.relevance") : i(`col.${R.value}`)), H = A(
      () => D.value ? i("sort.relevance_why") : i(z.value ? "sort.asc" : "sort.desc")
    );
    Je(() => n.locale, (ie) => yg(ie), { immediate: !0 });
    function L(ie) {
      E.setSort(ie), W(!0);
    }
    function P() {
      D.value || E.toggleSortDir();
    }
    function K() {
      D.value || B("sort");
    }
    const N = A(() => [
      { key: "new-folder", label: i("toolbar.new_folder"), disabled: n.canWrite === !1 },
      { key: "upload", label: i("toolbar.upload"), disabled: n.canWrite === !1 },
      { key: "paste", label: i("ctx.paste"), disabled: !n.canPaste || n.canWrite === !1 },
      { key: "sep", label: "", divider: !0, disabled: !0 },
      { key: "select-all", label: i("shortcuts.select_all"), disabled: !1 }
    ]);
    function J(ie) {
      W(!0), ie === "new-folder" ? a("new-folder") : ie === "upload" ? a("upload") : ie === "paste" ? a("paste") : ie === "select-all" && a("select-all");
    }
    const j = S(null), re = S({ x: 0, y: 0 }), q = S(null), le = S({});
    function ve(ie, xe) {
      le.value[ie] = xe ?? null;
    }
    const ce = A(
      () => j.value && j.value !== "sort" && j.value !== "actions" ? j.value : null
    ), se = A(() => ce.value ? $(ce.value) : []), fe = A(
      () => ce.value ? i(`filter.${ce.value}`) : j.value === "actions" ? i("filter.actions") : i("sort.by")
    );
    function _(ie) {
      return !!ce.value && C(ce.value) === ie;
    }
    function ee(ie) {
      return ce.value ? k(ce.value, ie) : ie;
    }
    function Y(ie) {
      ce.value && F(ce.value, ie);
    }
    async function B(ie) {
      var ot, ft, gt;
      if (j.value === ie) {
        W();
        return;
      }
      const xe = (ot = le.value[ie]) == null ? void 0 : ot.getBoundingClientRect(), he = xe ? Ur(xe, r.value) : 8;
      re.value = { x: he, y: xe ? xe.bottom + 6 : 8 }, j.value = ie, await Gt();
      const De = q.value;
      if (De) {
        const Ut = De.getBoundingClientRect();
        if (re.value = { ...re.value, x: Oc(he, Ut.width, window.innerWidth, r.value) }, Ut.bottom > window.innerHeight - 8) {
          const Xe = (ft = le.value[ie]) == null ? void 0 : ft.getBoundingClientRect();
          re.value = { ...re.value, y: Math.max(8, (Xe ? Xe.top : 0) - Ut.height - 6) };
        }
        (gt = De.querySelector('[data-active="true"]')) == null || gt.focus();
      }
    }
    function W(ie = !1) {
      var he;
      const xe = j.value;
      j.value = null, ie && xe && ((he = le.value[xe]) == null || he.focus());
    }
    Je(
      () => n.order,
      (ie) => {
        ie === "relevance" && j.value === "sort" && W();
      }
    );
    function F(ie, xe) {
      a("update:value", { ...n.value, [ie]: xe }), W(!0);
    }
    function V() {
      ke.value = "", a("update:value", {
        ...n.value,
        type: "any",
        modified: "any",
        size: "any",
        name: "",
        people: "any"
      });
    }
    const ke = S(n.value.name ?? "");
    Je(
      () => n.value.name ?? "",
      (ie) => {
        ie !== ke.value.trim() && (ke.value = ie);
      }
    );
    let qe;
    function Me(ie) {
      ke.value = ie.target.value, qe && clearTimeout(qe), qe = setTimeout(() => {
        a("update:value", { ...n.value, name: ke.value.trim() });
      }, 140);
    }
    function Fe() {
      qe && clearTimeout(qe), ke.value = "", a("update:value", { ...n.value, name: "" });
    }
    Tt(() => {
      qe && clearTimeout(qe);
    });
    function We(ie) {
      var he;
      if (!j.value) return;
      const xe = ie.target;
      (he = q.value) != null && he.contains(xe) || Object.values(le.value).some((De) => De == null ? void 0 : De.contains(xe)) || W();
    }
    function $t(ie) {
      ie.key === "Escape" && j.value && (ie.stopPropagation(), W(!0));
    }
    jt(() => {
      document.addEventListener("pointerdown", We, !0), document.addEventListener("keydown", $t, !0);
    }), Tt(() => {
      document.removeEventListener("pointerdown", We, !0), document.removeEventListener("keydown", $t, !0);
    });
    const St = S(null), at = S({ start: !1, end: !1 });
    function kt() {
      const ie = St.value;
      if (!ie) return;
      const xe = Ev(ie);
      (xe.start !== at.value.start || xe.end !== at.value.end) && (at.value = xe);
    }
    let pt = null;
    function Ne() {
      const ie = St.value;
      if (!(!ie || !pt)) {
        pt.observe(ie);
        for (const xe of Array.from(ie.querySelectorAll(":scope > *, .fe-filterbar__chip"))) pt.observe(xe);
      }
    }
    return Je(
      St,
      (ie) => {
        pt == null || pt.disconnect(), pt = null, ie && (typeof ResizeObserver < "u" && (pt = new ResizeObserver(() => kt()), Ne()), kt());
      },
      { flush: "post" }
    ), NM(() => {
      Ne(), kt();
    }), Tt(() => {
      pt == null || pt.disconnect(), pt = null;
    }), (ie, xe) => (f(), h("div", {
      class: "fe-filterbar",
      "data-mode": l.value ? "full" : "find",
      "data-testid": "filterbar"
    }, [
      d("div", {
        ref_key: "trackEl",
        ref: St,
        class: Re(["fe-filterbar__track", { "is-more-start": at.value.start, "is-more-end": at.value.end }]),
        "data-testid": "filterbar-track",
        onScrollPassive: kt
      }, [
        l.value ? (f(), h("div", {
          key: 0,
          class: "fe-filterbar__chips",
          role: "group",
          "aria-label": u(i)("filter.aria")
        }, [
          (f(), h(Te, null, nt(p, (he) => d("button", {
            key: he,
            ref_for: !0,
            ref: (De) => ve(he, De),
            type: "button",
            class: Re(["fe-filterbar__chip", { "is-set": C(he) !== "any", "is-open": j.value === he }]),
            "aria-expanded": j.value === he,
            "aria-haspopup": "listbox",
            "data-testid": `filter-${he}`,
            onClick: (De) => B(he)
          }, [
            d("span", ZQ, y(b(he)), 1),
            xe[3] || (xe[3] = d("svg", {
              class: "fe-ficon fe-filterbar__caret",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              d("path", { d: "M7 10l5 5 5-5" })
            ], -1))
          ], 10, JQ)), 64))
        ], 8, XQ)) : O("", !0),
        d("div", QQ, [
          xe[4] || (xe[4] = d("svg", {
            class: "fe-ficon fe-filterbar__find-glass",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.9",
            "stroke-linecap": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            d("circle", {
              cx: "11",
              cy: "11",
              r: "6.5"
            }),
            d("path", { d: "M16 16l4.5 4.5" })
          ], -1)),
          d("input", {
            type: "search",
            class: "fe-filterbar__find-input",
            placeholder: c.value,
            "aria-label": c.value,
            value: ke.value,
            "data-testid": "filter-find",
            onInput: Me,
            onKeydown: Ca(yt(Fe, ["stop", "prevent"]), ["esc"])
          }, null, 40, eee)
        ]),
        l.value && T.value > 0 ? (f(), h("button", {
          key: 1,
          type: "button",
          class: "fe-filterbar__clear",
          "data-testid": "filter-clear",
          onClick: V
        }, y(u(i)("filter.clear")), 1)) : O("", !0),
        l.value && T.value > 0 && typeof e.shown == "number" && typeof e.total == "number" ? (f(), h("span", tee, y(u(i)("filter.count", { shown: String(e.shown), total: String(e.total) })), 1)) : O("", !0),
        l.value ? (f(), h("div", nee, [
          d("button", {
            ref: (he) => ve("sort", he),
            type: "button",
            class: Re(["fe-filterbar__sortdir", { "is-ranked": D.value }]),
            disabled: D.value,
            title: D.value ? H.value : void 0,
            "data-testid": "sort-dir",
            onClick: xe[0] || (xe[0] = (he) => P())
          }, [
            d("span", null, y(U.value), 1),
            d("span", iee, ", " + y(H.value), 1),
            D.value ? O("", !0) : (f(), h("svg", oee, [
              z.value ? (f(), h(Te, { key: 0 }, [
                xe[5] || (xe[5] = d("path", { d: "M12 19V5" }, null, -1)),
                xe[6] || (xe[6] = d("path", { d: "M5 12l7-7 7 7" }, null, -1))
              ], 64)) : (f(), h(Te, { key: 1 }, [
                xe[7] || (xe[7] = d("path", { d: "M12 5v14" }, null, -1)),
                xe[8] || (xe[8] = d("path", { d: "M19 12l-7 7-7-7" }, null, -1))
              ], 64))
            ]))
          ], 10, aee),
          d("button", {
            type: "button",
            class: "fe-filterbar__sortpick",
            "aria-label": D.value ? H.value : u(i)("sort.by"),
            title: D.value ? H.value : u(i)("sort.by"),
            disabled: D.value,
            "aria-haspopup": "menu",
            "aria-expanded": j.value === "sort",
            "data-testid": "sort-menu",
            onClick: xe[1] || (xe[1] = (he) => K())
          }, [...xe[9] || (xe[9] = [
            d("svg", {
              class: "fe-ficon fe-filterbar__caret",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              d("path", { d: "M7 10l5 5 5-5" })
            ], -1)
          ])], 8, ree)
        ])) : O("", !0)
      ], 34),
      l.value ? (f(), h("button", {
        key: 0,
        ref: (he) => ve("actions", he),
        type: "button",
        class: "fe-filterbar__actions",
        "aria-label": u(i)("filter.actions"),
        title: u(i)("filter.actions"),
        "aria-haspopup": "menu",
        "aria-expanded": j.value === "actions",
        "data-testid": "listing-actions",
        onClick: xe[2] || (xe[2] = (he) => B("actions"))
      }, [...xe[10] || (xe[10] = [
        d("svg", {
          class: "fe-ficon",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          d("circle", {
            cx: "12",
            cy: "5.5",
            r: "1.2",
            fill: "currentColor",
            stroke: "none"
          }),
          d("circle", {
            cx: "12",
            cy: "12",
            r: "1.2",
            fill: "currentColor",
            stroke: "none"
          }),
          d("circle", {
            cx: "12",
            cy: "18.5",
            r: "1.2",
            fill: "currentColor",
            stroke: "none"
          })
        ], -1)
      ])], 8, see)) : O("", !0),
      (f(), Ge(wi, { to: "body" }, [
        j.value ? (f(), h("div", {
          key: 0,
          ref_key: "panelEl",
          ref: q,
          class: Re(["fe-filterpop", {
            "fe--theme-light": e.theme === "light",
            "fe--theme-dark": e.theme === "dark",
            "fe-filterpop--sort": j.value === "sort",
            "fe-filterpop--actions": j.value === "actions"
          }]),
          dir: u(r),
          role: j.value === "sort" || j.value === "actions" ? "menu" : "listbox",
          "aria-label": fe.value,
          style: Yt({ left: re.value.x + "px", top: re.value.y + "px" })
        }, [
          j.value === "actions" ? (f(!0), h(Te, { key: 0 }, nt(N.value, (he) => (f(), h(Te, {
            key: he.key
          }, [
            he.divider ? (f(), h("hr", uee)) : (f(), h("button", {
              key: 1,
              type: "button",
              class: "fe-filterpop__item",
              role: "menuitem",
              disabled: he.disabled,
              "aria-disabled": he.disabled,
              "data-active": "false",
              "data-testid": `listing-action-${he.key}`,
              onClick: (De) => J(he.key)
            }, [
              d("span", null, y(he.label), 1)
            ], 8, cee))
          ], 64))), 128)) : j.value === "sort" ? (f(!0), h(Te, { key: 1 }, nt(u(vg), (he) => (f(), h("button", {
            key: he,
            type: "button",
            class: "fe-filterpop__item",
            role: "menuitem",
            "data-active": R.value === he ? "true" : "false",
            "data-testid": `sort-opt-${he}`,
            onClick: (De) => L(he)
          }, [
            d("span", null, y(u(i)(`col.${he}`)), 1)
          ], 8, dee))), 128)) : (f(!0), h(Te, { key: 2 }, nt(se.value, (he) => (f(), h("button", {
            key: he,
            type: "button",
            class: "fe-filterpop__item",
            role: "option",
            "aria-selected": _(he),
            "data-checked": _(he) ? "true" : "false",
            "data-active": _(he) ? "true" : "false",
            "data-testid": `filter-opt-${he}`,
            onClick: (De) => Y(he)
          }, [
            d("span", pee, y(_(he) ? "✓" : ""), 1),
            d("span", null, y(ee(he)), 1)
          ], 8, fee))), 128))
        ], 14, lee)) : O("", !0)
      ]))
    ], 8, GQ));
  }
}), mee = ["aria-label"], vee = ["aria-selected", "title", "aria-label"], yee = ["innerHTML"], gee = ["aria-selected", "title", "aria-label"], bee = ["innerHTML"], kee = ["aria-selected", "title", "aria-label"], wee = ["innerHTML"], _ee = /* @__PURE__ */ lt({
  __name: "ViewSwitcher",
  props: {
    viewMode: {},
    locale: {},
    modes: {}
  },
  emits: ["update:viewMode"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale);
    function r(l) {
      return !n.modes || n.modes.includes(l);
    }
    return (l, c) => (f(), h("div", {
      class: "fe-toolbar__view",
      role: "tablist",
      "aria-label": u(i)("toolbar.view_label")
    }, [
      r("list") ? (f(), h("button", {
        key: 0,
        type: "button",
        class: Re(["fe-btn fe-btn--icon-only", { "is-active": e.viewMode === "list" }]),
        role: "tab",
        "aria-selected": e.viewMode === "list",
        title: u(i)("toolbar.view.list"),
        "aria-label": u(i)("toolbar.view.list"),
        "data-testid": "view-list",
        onClick: c[0] || (c[0] = (p) => a("update:viewMode", "list"))
      }, [
        d("span", {
          class: "fe-icon",
          "aria-hidden": "true",
          innerHTML: u(zt)("view-list")
        }, null, 8, yee)
      ], 10, vee)) : O("", !0),
      r("grid") ? (f(), h("button", {
        key: 1,
        type: "button",
        class: Re(["fe-btn fe-btn--icon-only", { "is-active": e.viewMode === "grid" }]),
        role: "tab",
        "aria-selected": e.viewMode === "grid",
        title: u(i)("toolbar.view.grid"),
        "aria-label": u(i)("toolbar.view.grid"),
        "data-testid": "view-grid",
        onClick: c[1] || (c[1] = (p) => a("update:viewMode", "grid"))
      }, [
        d("span", {
          class: "fe-icon",
          "aria-hidden": "true",
          innerHTML: u(zt)("view-grid")
        }, null, 8, bee)
      ], 10, gee)) : O("", !0),
      r("gallery") ? (f(), h("button", {
        key: 2,
        type: "button",
        class: Re(["fe-btn fe-btn--icon-only", { "is-active": e.viewMode === "gallery" }]),
        role: "tab",
        "aria-selected": e.viewMode === "gallery",
        title: u(i)("toolbar.view.gallery"),
        "aria-label": u(i)("toolbar.view.gallery"),
        "data-testid": "view-gallery",
        onClick: c[2] || (c[2] = (p) => a("update:viewMode", "gallery"))
      }, [
        d("span", {
          class: "fe-icon",
          "aria-hidden": "true",
          innerHTML: u(zt)("view-gallery")
        }, null, 8, wee)
      ], 10, kee)) : O("", !0)
    ], 8, mee));
  }
});
function xee(e, t) {
  return typeof e != "number" || !Number.isFinite(e) ? "-" : e <= 0 ? t("trash.days_remaining_due") : t("trash.days_remaining", { n: e });
}
const See = ["aria-label", "innerHTML"], $ee = {
  key: 2,
  class: "fe-list__thumb"
}, Tee = ["innerHTML"], Aee = { class: "fe-list__name-wrap" }, Eee = ["title"], Cee = {
  key: 0,
  class: "fe-list__badge"
}, zee = ["title", "aria-label"], Mee = {
  key: 0,
  class: "fe-list__snippet"
}, Pee = {
  key: 0,
  class: "fe-list__mark"
}, Oee = ["title", "aria-label"], Lee = { class: "tbl-pill__text" }, Dee = ["title", "aria-label", "data-link-state"], Ree = { class: "tbl-pill__text" }, Nee = ["title", "aria-label"], Iee = {
  key: 6,
  class: "fe-list__kind"
}, Bee = ["title", "aria-label", "onClick"], Fee = {
  key: 0,
  class: "fe-colmenu__sep",
  role: "separator"
}, Uee = {
  key: 1,
  class: "fe-colmenu__title"
}, Hee = {
  key: 2,
  class: "fe-colmenu__hint"
}, Kee = ["onClick"], Vee = { class: "fe-colmenu__label" }, jee = ["onClick"], qee = { class: "fe-colmenu__label" }, Wee = /* @__PURE__ */ lt({
  __name: "ListView",
  props: {
    files: {},
    selected: {},
    clipped: {},
    showParentPath: { type: Boolean },
    locale: {},
    loading: { type: Boolean },
    starredIds: {},
    starEnabled: { type: Boolean },
    apiBase: {},
    authHeaders: { type: Function },
    authCredentials: {},
    keepBadgeFor: { type: Function },
    order: {},
    folderKey: {},
    theme: {},
    thumbSrc: { type: Function },
    trash: { type: Boolean }
  },
  emits: ["click-row", "dbl-row", "context-row", "item-drag-start", "item-drop-into", "star-change", "display-order", "peek", "peek-end"],
  setup(e, { emit: t }) {
    const n = e, a = t, {
      t: i,
      formatNodeSize: r,
      nodeSizeHint: l,
      formatDate: c,
      formatDateFull: p,
      formatMonthYear: m,
      zonedYearMonth: v,
      toDate: x,
      nodeDisplayName: w,
      dir: $
    } = ht(() => n.locale);
    function k(G) {
      return Yr(qc(G), { t: i, formatDate: c, locale: n.locale });
    }
    function b(G) {
      return Wc(G, { t: i });
    }
    function C(G) {
      return Yc(G, { t: i });
    }
    function T(G) {
      return Ug(G, { t: i });
    }
    function E(G) {
      return n.selected.has(G.path);
    }
    function R(G, ye) {
      a("click-row", G, Ig(ye, j.isTap(ye)));
    }
    function z(G) {
      a("dbl-row", G);
    }
    function D(G, ye) {
      ye.preventDefault(), ye.stopPropagation(), a("context-row", G, ye);
    }
    function U(G, ye) {
      const te = ye.currentTarget, Ce = te == null ? void 0 : te.getBoundingClientRect();
      a("context-row", G, {
        // ⚠ RTL: the button's START corner — its right one in RTL — so the menu
        // hangs from the control and opens the way the line reads.
        clientX: Ce ? Ur(Ce, $.value) : ye.clientX,
        clientY: Ce ? Ce.bottom : ye.clientY,
        preventDefault: () => {
        },
        stopPropagation: () => {
        }
      });
    }
    function H(G, ye) {
      a("click-row", G, Bg(ye));
    }
    function L(G, ye) {
      Wg(
        ye,
        w(G),
        n.selected.has(G.path) ? n.selected.size : 1
      ), a("item-drag-start", G, ye);
    }
    const P = S(null);
    function K(G, ye) {
      G.type === "dir" && ti(ye) && (ye.preventDefault(), ye.stopPropagation(), ye.dataTransfer && (ye.dataTransfer.dropEffect = "move"), P.value = G.path);
    }
    function N(G) {
      P.value === G.path && (P.value = null);
    }
    function J(G, ye) {
      P.value = null, G.type === "dir" && ti(ye) && (ye.preventDefault(), ye.stopPropagation(), a("item-drop-into", G, ye));
    }
    const j = Fg(
      (G, ye) => a("context-row", G, { ...ye, preventDefault: () => {
      }, stopPropagation: () => {
      } }),
      {
        // A finger lifted on the item, off its controls, opens at touchend — see useRowTouch.
        onTap: (G) => a("click-row", G, { ctrl: !1, shift: !1, touch: !0 })
      }
    );
    function re(G) {
      return G === "kept" ? "✓" : G === "syncing" ? "⟳" : G === "partial" ? "◐" : "☁";
    }
    function q(G) {
      return G.basename === ".trash" || cc(G);
    }
    function le(G) {
      return c(G, { time: !0 }) || "-";
    }
    function ve(G) {
      return p(G);
    }
    function ce(G) {
      return q(G) ? "-" : Fv(G, i);
    }
    function se(G) {
      return G.type === "dir" || wp(G) ? null : n.thumbSrc ? n.thumbSrc(G) : G.thumb_url ?? null;
    }
    const fe = A(() => n.files.some((G) => {
      var ye;
      return G.type === "dir" && (((ye = G.preview) == null ? void 0 : ye.length) ?? 0) > 0;
    }));
    function _(G) {
      return n.thumbSrc ? n.thumbSrc(G) : G.thumb_url ?? null;
    }
    const ee = A(() => at.value.includes("type"));
    function Y(G) {
      return G.type === "dir" && !q(G);
    }
    function B(G) {
      var Ce;
      if ((Ce = G.extra_metadata) != null && Ce.draft)
        return i("node.drafts");
      const ye = Nr(G);
      return [String(G.storage ?? "").trim(), ye].filter(Boolean).join("/");
    }
    function W(G) {
      const ye = G.extra_metadata;
      if (ye != null && ye.purging) return i("trash.purging");
      const te = ye == null ? void 0 : ye.ttl_days;
      return xee(te, i);
    }
    function F(G) {
      const ye = G.snippet;
      return typeof ye == "string" ? ye : "";
    }
    function V(G) {
      return sW(G.matched);
    }
    const ke = Vc(), qe = A(() => ke.key.value), Me = A(() => n.order === "relevance");
    Je(() => n.locale, (G) => yg(G), { immediate: !0 });
    const Fe = A(
      () => Me.value ? null : { key: qe.value, dir: ke.dir.value }
    );
    function We(G) {
      Me.value || vg.includes(G.key) && ke.chooseSortKey(G.key);
    }
    const $t = A(() => {
      if (n.trash) return ["type", "location", "owner", "modified", "remaining", "size"];
      const G = ["type"];
      return n.showParentPath && G.push("location"), G.push("owner", "modified", "size"), n.starEnabled !== !1 && (n.apiBase || n.apiBase === "") && G.push("star"), G;
    }), St = TS(() => n.folderKey ?? ""), at = A(
      () => St.order().filter((G) => G !== "name" && $t.value.includes(G) && !St.hidden(G))
    ), kt = A(() => [
      { id: "name", label: i("col.name"), lead: !0, sortable: !0, class: "fe-list__col--name" },
      { id: "type", label: i("col.type"), sortable: !0, class: "fe-list__col--type", format: ce },
      {
        id: "location",
        label: n.trash ? i("col.deleted_from") : i("col.location"),
        class: "fe-list__col--location",
        format: B,
        title: (G) => B(G) || void 0
      },
      {
        id: "owner",
        label: n.trash ? i("col.deleted_by") : i("col.owner"),
        class: "fe-list__col--owner",
        format: n.trash ? Ve : Ut,
        title: n.trash ? Be : Xe
      },
      {
        id: "modified",
        label: n.trash ? i("col.deleted") : i("col.modified"),
        sortable: !0,
        sortDir: "desc",
        class: "fe-list__col--mod",
        format: (G) => le(G.last_modified),
        title: (G) => ve(G.last_modified)
      },
      {
        id: "remaining",
        label: i("col.remaining"),
        class: "fe-list__col--remaining",
        format: W
      },
      {
        id: "size",
        label: i("col.size"),
        sortable: !0,
        class: "fe-list__col--size",
        // A folder the catalog does not cover in full says so: "≥ 1.2 GB", or
        // "—" when nothing below it is known (useLocale formatNodeSize).
        format: (G) => r(G),
        title: (G) => l(G)
      },
      { id: "star", label: i("col.star"), class: "fe-list__col--star", headerLabel: !1 }
    ]);
    function pt(G) {
      const ye = w(G);
      if (!n.showParentPath || at.value.includes("location")) return ye;
      const te = B(G);
      return te ? `${ye} · ${te}` : ye;
    }
    function Ne(G) {
      const ye = {
        tabindex: 0,
        "aria-label": w(G),
        "data-fe-path": G.path,
        draggable: "true"
      };
      return G.type === "dir" && (ye.onPointerenter = (te) => a("peek", G, te.currentTarget, te.pointerType), ye.onPointerleave = () => a("peek-end"), ye.onPointerdown = () => a("peek-end")), ye;
    }
    function ie(G) {
      var ye;
      return {
        "is-dir": G.type === "dir",
        "is-trash": !!G.trashed,
        "is-clipped": !!((ye = n.clipped) != null && ye.has(G.path)),
        "is-droptarget": P.value === G.path
      };
    }
    const xe = A(() => X4()), he = A(() => !!n.folderKey && Qv(n.folderKey));
    function De(G) {
      Q4({
        v: "list",
        ...Me.value ? {} : { k: ke.key.value, d: ke.dir.value },
        c: St.state()
      }), G();
    }
    function ot(G) {
      n.folderKey && xS(n.folderKey), G();
    }
    const ft = A(() => {
      const G = [], ye = [];
      for (const te of n.files) (q(te) ? G : ye).push(te);
      return [...G, ...ye.sort(ke.compareInOrder(n.order ?? "sort"))];
    }), gt = A(() => ({ t: i, formatMonthYear: m, zonedYearMonth: v }));
    Je(
      ft,
      (G) => a("display-order", G),
      { immediate: !0 }
    );
    function Ut(G) {
      return jp(G) ? i("owner.you") : gc(G) === null ? i("owner.system") : wg(G) || i("owner.unknown");
    }
    function Xe(G) {
      const ye = [Ut(G)];
      J5(G) && ye.push(i("owner.external"));
      const te = G.last_actor_name, Ce = G.last_actor_self === !0, Ie = G.last_actor_id;
      if (Ce || typeof te == "string" && te) {
        const _e = Ce ? i("owner.you") : String(te);
        _e !== ye[0] && ye.push(i("owner.last_actor", { who: _e }));
      } else Ie === void 0 && gc(G) !== null && ye.push(i("owner.last_actor", { who: i("owner.system") }));
      return ye.join(" · ");
    }
    function Ve(G) {
      return s1(G) ? i("owner.you") : r1(G) === null ? "-" : X5(G) || i("owner.unknown");
    }
    function Be(G) {
      return r1(G) === null && !s1(G) ? i("trash.deleted_by_nobody") : Ve(G);
    }
    const ne = A(
      () => Vg(ft.value, {
        /* ⚠ `ranked` is half of this and not a detail: over a search's ranked
         * answer the key is still `modified` (nothing cleared it), the listing
         * just is not obeying it — see `lib/dateGroups.groupingActive`. */
        active: Kg(qe.value, n.order),
        dateOf: (G) => x(G.last_modified),
        /* ⚠ Folders are their OWN run, above the first date heading, and that is
         * what lets "folders before files" hold while sorted by date. The rule
         * used to be softened instead — rows sorted by date, folders floating to
         * the top of each bucket — because hoisting them all would have split a
         * bucket in two and drawn "Today" twice, once over the folders and once
         * over the files. A run of their own removes that reason, and a folder has
         * no meaningful modification date to file under anyway. */
        aside: (G) => q(G) ? { id: "pinned" } : G.type === "dir" ? { id: "dirs" } : null,
        labels: gt.value
      }).runs
    ), ge = A(
      () => ne.value.map((G) => ({ id: G.id, label: G.label ?? void 0, items: G.items }))
    );
    return (G, ye) => (f(), Ge(os, {
      rows: ft.value,
      groups: ge.value,
      columns: kt.value,
      "column-store": u(St),
      candidates: $t.value,
      metrics: u($S),
      "row-key": (te) => te.path,
      locale: e.locale,
      theme: e.theme,
      loading: e.loading,
      empty: u(i)("empty.folder"),
      "aria-label": u(i)("list.aria"),
      framed: !1,
      selectable: "",
      "is-selected": E,
      sort: Fe.value,
      "sort-closed": Me.value ? u(i)("sort.relevance_why") : null,
      "row-class": ie,
      "row-attrs": Ne,
      onSort: We,
      onRowClick: R,
      onRowDblclick: z,
      onRowContextmenu: D,
      onCheckClick: H,
      onRowDragstart: L,
      onRowDragover: K,
      onRowDragleave: N,
      onRowDrop: J,
      onRowTouchstart: ye[2] || (ye[2] = (te, Ce) => u(j).onTouchStart(te, Ce)),
      onRowTouchend: ye[3] || (ye[3] = (te) => u(j).onTouchEnd(te)),
      onRowTouchmove: ye[4] || (ye[4] = (te) => u(j).onTouchMove(te))
    }, {
      "cell-name": mt(({ row: te }) => [
        u(Vr)(te) ? (f(), h("span", {
          key: 0,
          class: "fe-list__icon fe-list__icon--svg",
          role: "img",
          "aria-label": u(i)("e2e.badge"),
          innerHTML: u(xl)()
        }, null, 8, See)) : te.type === "dir" && fe.value ? (f(), Ge(qg, {
          key: 1,
          shape: "mini",
          node: te,
          "src-of": _,
          class: "fe-list__icon"
        }, null, 8, ["node"])) : (f(), h("span", $ee, [
          Ze(Qc, {
            node: te,
            "src-of": se,
            "type-badge": u(vT)(te),
            note: T(te),
            class: Re(["fe-list__icon fe-list__icon--img", { "fe-thumb--page": u(Hg)(te) }]),
            alt: "",
            "aria-hidden": "true"
          }, {
            default: mt(() => [
              d("span", {
                class: "fe-list__icon fe-list__icon--svg",
                "aria-hidden": "true",
                innerHTML: u(wa)(te)
              }, null, 8, Tee)
            ]),
            _: 2
          }, 1032, ["node", "type-badge", "note", "class"])
        ])),
        d("div", Aee, [
          d("span", {
            class: "fe-list__name",
            title: pt(te)
          }, [
            d("bdi", null, y(u(w)(te)), 1),
            V(te) ? (f(), h("span", Cee, y(u(i)("search.in_content")), 1)) : O("", !0),
            e.keepBadgeFor && e.keepBadgeFor(te) ? (f(), h("span", {
              key: 1,
              class: Re(["fe-keepbadge", "fe-keepbadge--" + e.keepBadgeFor(te)]),
              title: u(i)("keep.badge_" + e.keepBadgeFor(te)),
              role: "img",
              "aria-label": u(i)("keep.badge_" + e.keepBadgeFor(te))
            }, y(re(e.keepBadgeFor(te))), 11, zee)) : O("", !0)
          ], 8, Eee),
          F(te) ? (f(), h("span", Mee, [
            (f(!0), h(Te, null, nt(u(by)(F(te)), (Ce, Ie) => (f(), h(Te, { key: Ie }, [
              Ce.match ? (f(), h("mark", Pee, y(Ce.text), 1)) : (f(), h(Te, { key: 1 }, [
                Ht(y(Ce.text), 1)
              ], 64))
            ], 64))), 128))
          ])) : O("", !0)
        ]),
        k(te) ? (f(), h("span", {
          key: 3,
          class: "fe-applock tbl-pill",
          role: "img",
          title: k(te),
          "aria-label": k(te),
          "data-testid": "lock-badge"
        }, [
          ye[5] || (ye[5] = d("span", {
            class: "fe-applock__glyph",
            "aria-hidden": "true"
          }, "🔒", -1)),
          d("span", Lee, y(u(i)("applock.badge")), 1)
        ], 8, Oee)) : O("", !0),
        b(te) ? (f(), h("span", {
          key: 4,
          class: Re(["fe-symlink tbl-pill", "fe-symlink--" + b(te).state]),
          role: "img",
          title: b(te).why,
          "aria-label": b(te).why,
          "data-testid": "symlink-badge",
          "data-link-state": b(te).state
        }, [
          ye[6] || (ye[6] = d("span", {
            class: "fe-symlink__glyph",
            "aria-hidden": "true"
          }, "🔗", -1)),
          d("span", Ree, y(b(te).badge), 1)
        ], 10, Dee)) : O("", !0),
        C(te) ? (f(), h("span", {
          key: 5,
          class: "fe-unavailable",
          role: "img",
          title: C(te).full,
          "aria-label": C(te).full,
          "data-testid": "unavailable-badge"
        }, y(C(te).badge), 9, Nee)) : O("", !0),
        Y(te) && !ee.value ? (f(), h("span", Iee, y(u(i)("node.folder")), 1)) : O("", !0)
      ]),
      "cell-star": mt(({ row: te }) => {
        var Ce;
        return [
          e.starEnabled !== !1 && typeof te.id == "number" && te.type === "file" ? (f(), h("span", {
            key: 0,
            class: "fe-list__star-hit",
            "data-fe-control": "",
            onClick: ye[0] || (ye[0] = yt(() => {
            }, ["stop"])),
            onDblclick: ye[1] || (ye[1] = yt(() => {
            }, ["stop"]))
          }, [
            Ze(jg, {
              starred: !!((Ce = e.starredIds) != null && Ce.has(te.id)),
              "node-id": te.id,
              "api-base": e.apiBase,
              "auth-headers": e.authHeaders,
              "auth-credentials": e.authCredentials,
              locale: e.locale,
              compact: "",
              onChange: (Ie) => a("star-change", te, Ie)
            }, null, 8, ["starred", "node-id", "api-base", "auth-headers", "auth-credentials", "locale", "onChange"])
          ], 32)) : O("", !0)
        ];
      }),
      actions: mt(({ row: te }) => [
        d("button", {
          type: "button",
          class: "fe-list__menu",
          title: u(i)("toolbar.more"),
          "aria-label": u(i)("toolbar.more"),
          onClick: (Ce) => U(te, Ce)
        }, [...ye[7] || (ye[7] = [
          d("span", { "aria-hidden": "true" }, "⋮", -1)
        ])], 8, Bee)
      ]),
      "colmenu-extra": mt(({ close: te }) => [
        he.value || xe.value > 0 ? (f(), h("div", Fee)) : O("", !0),
        he.value || xe.value > 0 ? (f(), h("p", Uee, y(u(i)("cols.folder_title")), 1)) : O("", !0),
        he.value || xe.value > 0 ? (f(), h("p", Hee, y(u(i)("cols.folder_hint")), 1)) : O("", !0),
        he.value ? (f(), h("button", {
          key: 3,
          type: "button",
          class: "fe-colmenu__row",
          onClick: (Ce) => ot(te)
        }, [
          d("span", Vee, y(u(i)("cols.forget_folder")), 1)
        ], 8, Kee)) : O("", !0),
        xe.value > 0 || he.value ? (f(), h("button", {
          key: 4,
          type: "button",
          class: "fe-colmenu__row",
          onClick: (Ce) => De(te)
        }, [
          d("span", qee, y(u(i)("cols.apply_all", { count: xe.value })), 1)
        ], 8, jee)) : O("", !0)
      ]),
      _: 1
    }, 8, ["rows", "groups", "columns", "column-store", "candidates", "metrics", "row-key", "locale", "theme", "loading", "empty", "aria-label", "sort", "sort-closed"]));
  }
}), Yee = ["aria-label", "aria-busy"], Gee = {
  key: 0,
  class: "fe-gal__heading",
  "aria-hidden": "true"
}, Xee = ["aria-selected", "aria-label", "data-fe-path", "onClick", "onDblclick", "onContextmenu", "onDragstart", "onDragover", "onDragleave", "onDrop", "onTouchstartPassive"], Jee = ["dir"], Zee = {
  key: 0,
  class: "fe-fprev__tint"
}, Qee = ["innerHTML"], ete = ["aria-label", "innerHTML"], tte = ["innerHTML"], nte = ["onClick"], ate = {
  class: "fe-gal__meta",
  "aria-hidden": "true"
}, ite = {
  key: 0,
  class: "fe-gal__meta-line"
}, ote = ["title"], rte = ["title"], ste = {
  key: 0,
  class: "fe-gal__meta-line"
}, lte = ["title", "aria-label", "data-link-state"], ute = {
  key: 1,
  class: "fe-gal__meta-line"
}, cte = ["title", "aria-label"], dte = {
  key: 2,
  class: "fe-gal__meta-line"
}, fte = ["title", "aria-label"], pte = {
  key: 0,
  class: "fe-gal__empty"
}, hte = /* @__PURE__ */ lt({
  __name: "GalleryView",
  props: {
    files: {},
    selected: {},
    clipped: {},
    showParentPath: { type: Boolean },
    locale: {},
    loading: { type: Boolean },
    thumbSrc: {},
    starredIds: {},
    starEnabled: { type: Boolean },
    apiBase: {},
    authHeaders: {},
    authCredentials: {},
    e2eActive: { type: Boolean },
    order: {},
    selectable: { type: Boolean, default: !0 }
  },
  emits: ["click-card", "dbl-card", "context-card", "item-drag-start", "item-drop-into", "star-change"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatSize: r, nodeDisplayName: l, formatDate: c, formatMonthYear: p, zonedYearMonth: m, toDate: v } = ht(() => n.locale);
    function x(_) {
      return Yr(qc(_), { t: i, formatDate: c, locale: n.locale });
    }
    function w(_) {
      return Wc(_, { t: i });
    }
    function $(_) {
      return Yc(_, { t: i });
    }
    function k(_) {
      return Ug(_, { t: i });
    }
    const b = Vc(), C = A(
      () => Vg(n.files, {
        active: Kg(b.key.value, n.order),
        dateOf: (_) => v(_.last_modified),
        aside: (_) => _.type === "dir" ? { id: "dirs" } : null,
        labels: { t: i, formatMonthYear: p, zonedYearMonth: m }
      })
    ), T = A(() => n.files.some((_) => {
      var ee;
      return _.type === "dir" && (((ee = _.preview) == null ? void 0 : ee.length) ?? 0) > 0;
    }));
    function E(_) {
      return n.thumbSrc ? n.thumbSrc(_) : _.thumb_url ?? null;
    }
    const R = yT({
      apiBase: n.apiBase,
      authHeaders: n.authHeaders ? () => n.authHeaders() : void 0,
      credentials: n.authCredentials,
      disabled: () => n.e2eActive === !0
    });
    Tt(() => R.dispose());
    function z(_) {
      return R.kindFor(_);
    }
    function D(_) {
      const ee = R.get(_);
      return ee ? [ee] : [];
    }
    function U(_, ee) {
      R.bind(_ instanceof Element ? _ : null, ee);
    }
    function H(_) {
      return n.starEnabled === !1 ? !1 : n.apiBase !== void 0 && typeof _.id == "number" && _.type === "file";
    }
    function L(_) {
      return n.selected.has(_.path);
    }
    function P(_, ee) {
      a("click-card", _, Bg(ee));
    }
    function K(_, ee) {
      a("click-card", _, Ig(ee, ce.isTap(ee)));
    }
    function N(_) {
      a("dbl-card", _);
    }
    function J(_, ee) {
      ee.preventDefault(), ee.stopPropagation(), a("context-card", _, ee);
    }
    function j(_, ee) {
      Wg(
        ee,
        l(_),
        n.selected.has(_.path) ? n.selected.size : 1
      ), a("item-drag-start", _, ee);
    }
    const re = S(null);
    function q(_, ee) {
      _.type === "dir" && ti(ee) && (ee.preventDefault(), ee.stopPropagation(), ee.dataTransfer && (ee.dataTransfer.dropEffect = "move"), re.value = _.path);
    }
    function le(_) {
      re.value === _.path && (re.value = null);
    }
    function ve(_, ee) {
      re.value = null, _.type === "dir" && ti(ee) && (ee.preventDefault(), ee.stopPropagation(), a("item-drop-into", _, ee));
    }
    const ce = Fg(
      (_, ee) => a("context-card", _, { ...ee, preventDefault: () => {
      }, stopPropagation: () => {
      } }),
      {
        // A finger lifted on the item, off its controls, opens at touchend — see useRowTouch.
        onTap: (_) => a("click-card", _, { ctrl: !1, shift: !1, touch: !0 })
      }
    );
    function se(_) {
      return c(_, { time: !0 });
    }
    function fe(_) {
      const ee = se(_.last_modified);
      return [_.type === "dir" ? "" : r(_.size), ee].filter((B) => !!B).join(" · ");
    }
    return (_, ee) => (f(), h("div", {
      class: Re(["fe-gal", { "is-loading": e.loading, "has-selection": e.selectable && e.selected.size > 0 }]),
      role: "listbox",
      "aria-multiselectable": "true",
      "aria-label": u(i)("gallery.aria"),
      "aria-busy": e.loading ? "true" : void 0
    }, [
      (f(!0), h(Te, null, nt(e.files, (Y) => {
        var B, W;
        return f(), h(Te, {
          key: Y.path
        }, [
          C.value.headingBefore(Y) ? (f(), h("p", Gee, y(C.value.headingBefore(Y)), 1)) : O("", !0),
          d("div", {
            class: Re(["fe-gal__card", {
              "is-selected": L(Y),
              "is-dir": Y.type === "dir",
              "is-trash": Y.trashed,
              "is-clipped": (B = e.clipped) == null ? void 0 : B.has(Y.path),
              "is-droptarget": re.value === Y.path
            }]),
            tabindex: "0",
            role: "option",
            "aria-selected": L(Y) ? "true" : "false",
            "aria-label": u(l)(Y),
            "data-fe-path": Y.path,
            draggable: "true",
            onClick: (F) => K(Y, F),
            onDblclick: (F) => N(Y),
            onContextmenu: (F) => J(Y, F),
            onDragstart: (F) => j(Y, F),
            onDragover: (F) => q(Y, F),
            onDragleave: (F) => le(Y),
            onDrop: (F) => ve(Y, F),
            onTouchstartPassive: (F) => u(ce).onTouchStart(Y, F),
            onTouchend: ee[3] || (ee[3] = //@ts-ignore
            (...F) => u(ce).onTouchEnd && u(ce).onTouchEnd(...F)),
            onTouchmovePassive: ee[4] || (ee[4] = //@ts-ignore
            (...F) => u(ce).onTouchMove && u(ce).onTouchMove(...F))
          }, [
            d("div", {
              class: "fe-gal__thumb",
              ref_for: !0,
              ref: (F) => U(F, Y)
            }, [
              z(Y) ? (f(), h(Te, { key: 0 }, [
                (f(!0), h(Te, null, nt(D(Y), (F) => (f(), h("div", {
                  key: "fprev",
                  class: Re(["fe-fprev", "fe-fprev--" + F.kind]),
                  dir: u(C2)(F.kind),
                  style: Yt(F.kind === "table" ? { "--fprev-cols": String(F.cols) } : void 0),
                  "aria-hidden": "true"
                }, [
                  F.kind === "table" ? (f(!0), h(Te, { key: 0 }, nt(F.rows, (V, ke) => (f(), h(Te, { key: ke }, [
                    (f(!0), h(Te, null, nt(V, (qe, Me) => (f(), h("span", {
                      key: Me,
                      class: Re(["fe-fprev__cell", { "is-head": ke === 0 }])
                    }, y(qe), 3))), 128))
                  ], 64))), 128)) : (f(!0), h(Te, { key: 1 }, nt(F.lines, (V, ke) => (f(), h("div", {
                    key: ke,
                    class: "fe-fprev__line"
                  }, [
                    V.tint ? (f(), h("span", Zee, y(V.indent) + y(V.tint), 1)) : O("", !0),
                    Ht(y(V.text), 1)
                  ]))), 128))
                ], 14, Jee))), 128)),
                D(Y).length === 0 ? (f(), h("span", {
                  key: 0,
                  class: "fe-gal__icon fe-gal__icon--svg",
                  innerHTML: u(wa)(Y)
                }, null, 8, Qee)) : O("", !0)
              ], 64)) : Y.type === "dir" && T.value && !u(Vr)(Y) ? (f(), Ge(qg, {
                key: 1,
                shape: "fan",
                node: Y,
                "src-of": E
              }, null, 8, ["node"])) : (f(), Ge(Qc, {
                key: 2,
                node: Y,
                "src-of": E,
                "video-badge": u(mT)(Y),
                note: k(Y),
                alt: Y.basename,
                class: Re({
                  "fe-thumb--page": u(Hg)(Y)
                  /* gorunum:v1-preview — crop a page from its TOP */
                })
              }, {
                default: mt(() => [
                  u(Vr)(Y) ? (f(), h("span", {
                    key: 0,
                    class: "fe-gal__icon fe-gal__icon--svg",
                    role: "img",
                    "aria-label": u(i)("e2e.badge"),
                    innerHTML: u(xl)()
                  }, null, 8, ete)) : (f(), h("span", {
                    key: 1,
                    class: "fe-gal__icon fe-gal__icon--svg",
                    innerHTML: u(wa)(Y)
                  }, null, 8, tte))
                ]),
                _: 2
              }, 1032, ["node", "video-badge", "note", "alt", "class"])),
              e.selectable ? (f(), h("span", {
                key: 3,
                class: "fe-item-check fe-gal__check",
                "data-fe-control": "",
                onClick: yt((F) => P(Y, F), ["stop"]),
                onDblclick: ee[0] || (ee[0] = yt(() => {
                }, ["stop"]))
              }, [
                Ze(Tg, {
                  on: L(Y),
                  label: u(l)(Y)
                }, null, 8, ["on", "label"])
              ], 40, nte)) : O("", !0),
              H(Y) ? (f(), h("div", {
                key: 4,
                class: "fe-gal__star",
                onClick: ee[1] || (ee[1] = yt(() => {
                }, ["stop"])),
                onDblclick: ee[2] || (ee[2] = yt(() => {
                }, ["stop"]))
              }, [
                Ze(jg, {
                  starred: !!((W = e.starredIds) != null && W.has(Y.id)),
                  "node-id": Y.id,
                  "api-base": e.apiBase,
                  "auth-headers": e.authHeaders,
                  "auth-credentials": e.authCredentials,
                  locale: e.locale,
                  compact: "",
                  card: "",
                  onChange: (F) => a("star-change", Y, F)
                }, null, 8, ["starred", "node-id", "api-base", "auth-headers", "auth-credentials", "locale", "onChange"])
              ], 32)) : O("", !0),
              d("div", ate, [
                fe(Y) ? (f(), h("span", ite, y(fe(Y)), 1)) : O("", !0),
                e.showParentPath && u(Nr)(Y) ? (f(), h("span", {
                  key: 1,
                  class: "fe-gal__meta-line fe-gal__meta-line--path",
                  title: u(Nr)(Y)
                }, [
                  d("bdi", null, y(u(Nr)(Y)), 1)
                ], 8, ote)) : O("", !0)
              ])
            ], 512),
            d("div", {
              class: "fe-gal__label",
              title: u(l)(Y)
            }, [
              d("bdi", null, y(u(l)(Y)), 1)
            ], 8, rte),
            w(Y) ? (f(), h("div", ste, [
              d("span", {
                class: Re(["fe-symlink", "fe-symlink--" + w(Y).state]),
                role: "img",
                title: w(Y).why,
                "aria-label": w(Y).why,
                "data-testid": "symlink-badge",
                "data-link-state": w(Y).state
              }, [
                ee[5] || (ee[5] = d("span", {
                  class: "fe-symlink__glyph",
                  "aria-hidden": "true"
                }, "🔗", -1)),
                Ht(y(w(Y).badge), 1)
              ], 10, lte)
            ])) : O("", !0),
            $(Y) ? (f(), h("div", ute, [
              d("span", {
                class: "fe-unavailable",
                role: "img",
                title: $(Y).full,
                "aria-label": $(Y).full,
                "data-testid": "unavailable-badge"
              }, y($(Y).badge), 9, cte)
            ])) : O("", !0),
            x(Y) ? (f(), h("div", dte, [
              x(Y) ? (f(), h("span", {
                key: 0,
                class: "fe-applock",
                role: "img",
                title: x(Y),
                "aria-label": x(Y),
                "data-testid": "lock-badge"
              }, [
                ee[6] || (ee[6] = d("span", {
                  class: "fe-applock__glyph",
                  "aria-hidden": "true"
                }, "🔒", -1)),
                Ht(y(u(i)("applock.badge")), 1)
              ], 8, fte)) : O("", !0)
            ])) : O("", !0)
          ], 42, Xee)
        ], 64);
      }), 128)),
      !e.loading && e.files.length === 0 ? (f(), h("div", pte, y(u(i)("empty.folder")), 1)) : O("", !0)
    ], 10, Yee));
  }
}), mte = ["dir", "aria-label"], vte = { class: "fe-fpeek__head" }, yte = { class: "fe-fpeek__name" }, gte = {
  key: 0,
  class: "fe-fpeek__count"
}, bte = {
  key: 0,
  class: "fe-fpeek__loading"
}, kte = {
  key: 1,
  class: "fe-fpeek__list"
}, wte = { class: "fe-fpeek__tile" }, _te = ["innerHTML"], xte = ["innerHTML"], Ste = ["innerHTML"], $te = { class: "fe-fpeek__label" }, Tte = {
  key: 2,
  class: "fe-fpeek__more"
}, Ate = /* @__PURE__ */ lt({
  __name: "FolderPeek",
  props: {
    state: {},
    srcOf: { type: Function },
    locale: {}
  },
  setup(e) {
    const t = e, { t: n, dir: a, nodeDisplayName: i } = ht(() => t.locale), r = S(null), l = (m) => {
      if (m.type === "dir" || wp(m)) return !1;
      const v = xi(m);
      return v === "image" || v === "video" || Dq(m);
    }, c = A(() => t.state ? Math.max(0, t.state.total - t.state.items.length) : 0);
    function p() {
      const m = r.value, v = t.state;
      if (!m || !v) return;
      const x = window.innerWidth, w = window.innerHeight, $ = m.offsetWidth, k = m.offsetHeight, b = ei(m), C = b === "rtl" ? v.anchor.right : v.anchor.left, T = Oc(C, $, x, b);
      let E = v.anchor.bottom + 6;
      E + k > w - 8 && (E = Math.max(8, v.anchor.top - k - 6)), m.style.insetInlineStart = `${Math.round(b === "rtl" ? x - T - $ : T)}px`, m.style.top = `${Math.round(E)}px`, m.style.zIndex = String(Rc(document.elementFromPoint(v.anchor.left + 1, v.anchor.top + 1)));
    }
    return Je(
      () => t.state,
      async () => {
        await Gt(), p();
      }
    ), (m, v) => (f(), Ge(wi, { to: "body" }, [
      e.state ? (f(), h("div", {
        key: 0,
        ref_key: "box",
        ref: r,
        class: "fe-fpeek",
        dir: u(a),
        role: "tooltip",
        "data-fe-peek": "",
        "aria-label": u(i)(e.state.node)
      }, [
        d("p", vte, [
          d("bdi", yte, y(u(i)(e.state.node)), 1),
          e.state.loading ? O("", !0) : (f(), h("span", gte, y(e.state.total === 0 ? u(n)("peek.empty") : u(n)("peek.items", { n: e.state.total })), 1))
        ]),
        e.state.loading ? (f(), h("p", bte, y(u(n)("peek.loading")), 1)) : e.state.items.length ? (f(), h("ul", kte, [
          (f(!0), h(Te, null, nt(e.state.items, (x) => (f(), h("li", {
            key: x.path,
            class: "fe-fpeek__row"
          }, [
            d("span", wte, [
              l(x) ? (f(), Ge(Qc, {
                key: 0,
                node: x,
                "src-of": e.srcOf,
                "type-badge": u(vT)(x),
                alt: "",
                class: "fe-fpeek__img"
              }, {
                default: mt(() => [
                  d("span", {
                    class: "fe-grid__tile--svg",
                    innerHTML: u(wa)(x)
                  }, null, 8, _te)
                ]),
                _: 2
              }, 1032, ["node", "src-of", "type-badge"])) : u(Vr)(x) ? (f(), h("span", {
                key: 1,
                class: "fe-grid__tile--svg",
                innerHTML: u(xl)()
              }, null, 8, xte)) : (f(), h("span", {
                key: 2,
                class: "fe-grid__tile--svg",
                innerHTML: u(wa)(x)
              }, null, 8, Ste))
            ]),
            d("bdi", $te, y(u(i)(x)), 1)
          ]))), 128))
        ])) : O("", !0),
        !e.state.loading && c.value > 0 ? (f(), h("p", Tte, y(u(n)("peek.more", { n: c.value })), 1)) : O("", !0)
      ], 8, mte)) : O("", !0)
    ]));
  }
}), Ete = 500, Cte = 3e4, zte = 8;
function Mte(e, t = () => !0) {
  const n = Ea(null), a = /* @__PURE__ */ new Map();
  let i, r = 0;
  async function l(v) {
    const x = a.get(v);
    if (x && Date.now() - x.at < Cte) return x;
    const $ = [...(await e(v)).files ?? []].sort(up), k = { at: Date.now(), items: $.slice(0, zte), total: $.length };
    return a.set(v, k), k;
  }
  function c(v, x, w = "mouse") {
    if (v.type !== "dir" || w !== "mouse" || !x || !t()) return;
    const $ = ++r;
    clearTimeout(i), i = setTimeout(async () => {
      if ($ !== r) return;
      const k = x.getBoundingClientRect();
      n.value = { node: v, anchor: k, loading: !0, items: [], total: 0 };
      try {
        const b = await l(v.path);
        if ($ !== r) return;
        n.value = { node: v, anchor: k, loading: !1, items: b.items, total: b.total };
      } catch {
        $ === r && (n.value = null);
      }
    }, Ete);
  }
  function p() {
    r++, clearTimeout(i), i = void 0, n.value = null;
  }
  function m(v) {
    v ? a.delete(v) : a.clear();
  }
  return { state: n, enter: c, leave: p, forget: m };
}
const Pte = ["data-pane", "data-testid", "aria-label"], Ote = {
  key: 0,
  class: "fe-subhead"
}, Lte = { class: "fe-subhead__actions" }, Dte = ["title", "aria-label"], Rte = {
  key: 2,
  class: "fe__skeleton",
  role: "status"
}, Nte = { class: "fe-sr-only" }, Ite = {
  key: 0,
  class: "fe-skel-grid",
  "aria-hidden": "true"
}, Bte = {
  key: 1,
  class: "fe-skel-list",
  "aria-hidden": "true"
}, Fte = {
  key: 3,
  class: "fe-state"
}, Ute = { class: "fe-state__title" }, Hte = { class: "fe-state__hint" }, Kte = { class: "fe-state__actions" }, Vte = { class: "fe-state__details" }, jte = { class: "fe-state__details-summary" }, qte = { class: "fe-state__details-pre" }, Wte = {
  key: 4,
  class: "fe-state",
  "data-testid": "empty-filtered"
}, Yte = { class: "fe-state__title" }, Gte = { class: "fe-state__hint" }, Xte = { class: "fe-state__actions" }, Jte = { class: "fe-state" }, Zte = { class: "fe-state__title" }, Qte = "application/x-brf-files", ene = "application/x-brf-files-src", tne = 500, $0 = /* @__PURE__ */ lt({
  __name: "FilePane",
  props: {
    paneId: {},
    api: {},
    locale: {},
    theme: {},
    focused: { type: Boolean },
    closable: { type: Boolean },
    path: {},
    selfDriven: { type: Boolean },
    qualify: {},
    toUser: {},
    clamp: {},
    rootLabel: {},
    rootPath: {},
    floor: {},
    multiRoot: { type: Boolean },
    virtualRows: {},
    trashVisible: { type: Boolean, default: !0 },
    navOffersTrash: { type: Boolean },
    rows: {},
    loading: { type: Boolean },
    error: {},
    order: {},
    viewMode: {},
    viewModes: {},
    showCrumbs: { type: Boolean, default: !0 },
    showFilterBar: { type: Boolean, default: !0 },
    filterMode: {},
    findLabel: {},
    showViewSwitcher: { type: Boolean, default: !0 },
    crumbSubfolders: {},
    folderKey: {},
    showParentPath: { type: Boolean },
    trash: { type: Boolean },
    clipped: {},
    extraFilters: {},
    extraFiltersOnServer: { type: Boolean },
    canWrite: { type: Boolean },
    canPaste: { type: Boolean },
    selected: {},
    filters: {},
    thumbSrc: {},
    folderPreviews: { type: Boolean },
    keepBadgeFor: {},
    starredIds: {},
    starOverrides: {},
    starEnabled: { type: Boolean },
    apiBase: {},
    authHeaders: {},
    authCredentials: {},
    e2eActive: { type: Boolean },
    bodyOverride: { type: Boolean },
    openTrigger: { default: "double" }
  },
  emits: ["activate", "close", "navigate", "open", "open-trash", "click-row", "context", "clear-selection", "display-order", "item-drag-start", "item-drop-into", "transfer", "update:viewMode", "update:filters", "crumb-context", "copy-path", "crumb-drop", "new-folder", "upload", "paste", "select-all", "clear-filters", "star-change", "retry"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, { t: r } = ht(() => a.locale), l = a.paneId === "main" ? Vc() : LS();
    Wo(DS, l);
    const c = S(""), p = S([]), m = S(!1), v = S(""), x = S("");
    function w(Ve) {
      return xi(Ve) === "storage";
    }
    const $ = bi(jc, null), k = bi(PT, null), b = S(""), C = S(!1), T = S(""), E = A(
      () => a.selfDriven && !!k && !!b.value && k.locked(b.value)
    );
    async function R(Ve) {
      if (!(!k || !b.value || C.value)) {
        C.value = !0, T.value = "";
        try {
          const Be = await k.unlock(b.value, Ve);
          Be ? T.value = Be : await P(c.value);
        } finally {
          C.value = !1;
        }
      }
    }
    const z = A(() => a.selfDriven ? c.value : a.path ?? ""), D = A(
      () => a.selfDriven ? p.value : a.rows ?? []
    ), U = A(() => a.selfDriven ? m.value : !!a.loading), H = A(() => a.selfDriven ? v.value : a.error ?? ""), L = A(
      () => !!a.multiRoot && !(z.value ?? "").replace(/^\/+|\/+$/g, "")
    );
    async function P(Ve) {
      const Be = a.clamp(Ve ?? c.value ?? "");
      m.value = !0, v.value = "";
      try {
        if (a.multiRoot && !Be) {
          p.value = a.virtualRows ? a.virtualRows() : [], x.value = "", b.value = "", c.value = "", i("navigate", "");
          return;
        }
        const ne = await a.api.index(a.qualify(Be));
        x.value = ne.perm || "";
        const ge = typeof ne.e2e_root == "string" ? ne.e2e_root : "";
        ge !== b.value && (T.value = ""), b.value = ge;
        const G = $ ? await $.decorate(ne.files, { root: ge || null }) : ne.files;
        p.value = Mr(G), cS(p.value, ne.adapter, ne.dirname, a.trashVisible !== !1, {
          navOffersTrash: a.navOffersTrash
        }) && dS(p.value, ne.adapter, a.api), c.value = a.toUser(ne.dirname), i("navigate", c.value);
      } catch (ne) {
        v.value = ne instanceof Error ? ne.message : String(ne);
      } finally {
        m.value = !1;
      }
    }
    a.selfDriven && P(a.path ?? "");
    function K(Ve) {
      i("activate"), a.selfDriven ? P(Ve) : i("navigate", Ve);
    }
    const N = A(
      () => vS(z.value) ? z.value : a.qualify(z.value)
    ), J = A(() => {
      const Ve = N.value, Be = Ve.indexOf("://");
      return Be === -1 ? "" : Ve.slice(0, Be);
    });
    function j(Ve) {
      if (i("activate"), !a.selfDriven) {
        i("navigate", Ve);
        return;
      }
      if (a.multiRoot && !Ve) {
        P("");
        return;
      }
      P(a.toUser(Ve));
    }
    const re = Mte(
      (Ve) => a.api.index(Ve),
      () => a.folderPreviews !== !1
    );
    function q(Ve) {
      return a.thumbSrc ? a.thumbSrc(Ve) : Ve.thumb_url ?? null;
    }
    function le() {
      re.leave();
    }
    Je(D, () => re.forget()), jt(() => {
      window.addEventListener("scroll", le, !0), window.addEventListener("dragstart", le, !0), window.addEventListener("keydown", le, !0);
    }), Tt(() => {
      window.removeEventListener("scroll", le, !0), window.removeEventListener("dragstart", le, !0), window.removeEventListener("keydown", le, !0), re.leave();
    });
    const ve = ic(
      () => bg(a.filters),
      () => D.value,
      (Ve) => Ve.basename || "",
      () => a.api.matchNames
    ), ce = A(() => {
      const Ve = ve.apply(iy(D.value, a.filters));
      return l.sortListing(
        a.extraFilters && !a.extraFiltersOnServer ? iy(Ve, a.extraFilters) : Ve,
        a.order ?? "sort"
      );
    }), se = A(() => {
      const Ve = new Set(a.starredIds ?? []);
      for (const Be of D.value)
        typeof Be.id == "number" && Be.starred === !0 && Ve.add(Be.id);
      for (const [Be, ne] of a.starOverrides ?? /* @__PURE__ */ new Map())
        ne ? Ve.add(Be) : Ve.delete(Be);
      return Ve;
    }), fe = A(() => al(a.filters) || !!a.extraFilters), _ = A(
      () => L.value ? "find" : a.filterMode ?? "full"
    ), ee = A(
      () => L.value ? r("filter.find.storages") : a.findLabel ?? ""
    ), Y = A(
      () => D.value.filter((Ve) => Ve.type === "dir").map((Ve) => ({ label: Ve.basename, adapterPath: Ve.path }))
    );
    let B = 0;
    function W() {
      return Date.now() - B < tne;
    }
    function F(Ve, Be) {
      if (!W()) {
        if (Be.check) {
          i("activate"), i("click-row", Ve, { ctrl: !0, shift: Be.shift });
          return;
        }
        if (Be.touch || a.openTrigger === "single") {
          B = Date.now(), Fe(Ve);
          return;
        }
        i("activate"), i("click-row", Ve, { ctrl: Be.ctrl, shift: Be.shift });
      }
    }
    function V(Ve) {
      W() || (B = Date.now(), Fe(Ve));
    }
    function ke(Ve, Be) {
      Be.preventDefault(), Be.stopPropagation(), i("activate"), i("context", Ve, Be);
    }
    function qe(Ve) {
      Ve.preventDefault(), Ve.stopPropagation(), i("activate"), i("clear-selection"), i("context", null, Ve);
    }
    function Me() {
      i("clear-selection");
    }
    function Fe(Ve) {
      if (i("activate"), Ve.basename === ".trash") {
        i("open-trash");
        return;
      }
      if (Ve.type === "dir" && a.selfDriven) {
        P(w(Ve) ? Ve.path : a.toUser(Ve.path));
        return;
      }
      i("open", Ve);
    }
    function We(Ve, Be) {
      if (!Be.dataTransfer) return;
      if (w(Ve) || L.value || Ve.basename === ".trash") {
        Be.preventDefault();
        return;
      }
      const ne = D.value.filter((G) => a.selected.has(G.path) && !w(G)).filter((G) => {
        var ye;
        return !((ye = a.clipped) != null && ye.has(G.path));
      }).map((G) => ({ path: G.path, basename: G.basename, type: G.type })), ge = ne.length > 0 ? ne : [{ path: Ve.path, basename: Ve.basename, type: Ve.type }];
      Be.dataTransfer.setData(Qte, JSON.stringify(ge)), Be.dataTransfer.setData(ene, N.value), Be.dataTransfer.setData("text/plain", ge.map((G) => G.path).join(`
`)), Be.dataTransfer.effectAllowed = "move", i("item-drag-start", Ve, Be);
    }
    const $t = S(!1);
    function St(Ve) {
      return ti(Ve);
    }
    function at(Ve, Be) {
      const ne = Nf(Ve);
      if (!ne || !Be) return;
      const ge = gy(Ve), G = ne.map((ye) => ye.path).filter((ye) => ye && ye !== Be && !Be.startsWith(ye + "/"));
      G.length !== 0 && (Ve.preventDefault(), Ve.stopPropagation(), i("transfer", { sources: G, targetWire: Be, originWire: ge }));
    }
    function kt(Ve, Be) {
      $t.value = !1, !(Ve.type !== "dir" || w(Ve)) && St(Be) && i("item-drop-into", Ve, Be);
    }
    function pt(Ve) {
      !St(Ve) || L.value || (Ve.preventDefault(), Ve.stopPropagation(), Ve.dataTransfer && (Ve.dataTransfer.dropEffect = "move"), $t.value = !0);
    }
    function Ne() {
      $t.value = !1;
    }
    function ie(Ve) {
      $t.value = !1, !(!St(Ve) || L.value) && at(Ve, N.value);
    }
    function xe() {
      return a.selfDriven ? P() : Promise.resolve();
    }
    function he() {
      const Ve = (z.value ?? "").replace(/^\/+|\/+$/g, ""), Be = (a.floor || "").replace(/^\/+|\/+$/g, "");
      if (!Ve || Ve === Be) return;
      const ne = Ve.lastIndexOf("/");
      K(ne === -1 ? "" : Ve.slice(0, ne));
    }
    function De() {
      return z.value;
    }
    function ot() {
      return ce.value.filter((Ve) => !w(Ve));
    }
    function ft() {
      return D.value.length;
    }
    function gt() {
      return D.value.map((Ve) => Ve.path);
    }
    function Ut() {
      return a.selfDriven ? x.value : "";
    }
    function Xe() {
      return a.selfDriven ? b.value : "";
    }
    return t({ reload: xe, goUp: he, getPath: De, visibleNodes: ot, loadFolder: P, rowCount: ft, rowPaths: gt, dirPerm: Ut, e2eRoot: Xe }), Je(z, () => {
      $t.value = !1;
    }), (Ve, Be) => (f(), h("section", {
      class: Re(["fe__primary fe-pane", {
        "fe-pane--focus": e.focused,
        "fe-pane--split": e.paneId === "split",
        "fe-pane--dropover": $t.value
      }]),
      "data-pane": e.paneId,
      "data-testid": `pane-${e.paneId}`,
      role: "region",
      "aria-label": e.paneId === "split" ? u(r)("split.pane") : u(r)("toolbar.view_label"),
      onPointerdownCapture: Be[18] || (Be[18] = (ne) => i("activate"))
    }, [
      e.showCrumbs || Ve.$slots.heading || e.showViewSwitcher || e.closable ? (f(), h("div", Ote, [
        On(Ve.$slots, "heading", {}, () => [
          e.showCrumbs ? (f(), Ge(YQ, {
            key: 0,
            dirname: N.value,
            adapter: J.value,
            "root-label": e.rootLabel || J.value,
            locale: e.locale,
            "multi-storage-root": e.multiRoot,
            "root-path": e.rootPath,
            subfolders: e.crumbSubfolders ?? Y.value,
            onNavigate: j,
            onCopyPath: Be[0] || (Be[0] = (ne) => i("copy-path", ne)),
            onCrumbContext: Be[1] || (Be[1] = (ne) => i("crumb-context", ne)),
            onCrumbDrop: Be[2] || (Be[2] = (ne, ge) => i("crumb-drop", ne, ge))
          }, null, 8, ["dirname", "adapter", "root-label", "locale", "multi-storage-root", "root-path", "subfolders"])) : O("", !0)
        ]),
        d("div", Lte, [
          e.showViewSwitcher ? (f(), Ge(_ee, {
            key: 0,
            "view-mode": e.viewMode,
            locale: e.locale,
            modes: e.viewModes,
            "onUpdate:viewMode": Be[3] || (Be[3] = (ne) => {
              i("activate"), i("update:viewMode", ne);
            })
          }, null, 8, ["view-mode", "locale", "modes"])) : O("", !0),
          e.closable ? (f(), h("button", {
            key: 1,
            type: "button",
            class: "fe-btn fe-btn--icon-only fe-pane__close",
            title: u(r)("split.close"),
            "aria-label": u(r)("split.close"),
            "data-testid": "pane-close",
            onClick: Be[4] || (Be[4] = (ne) => i("close"))
          }, [...Be[19] || (Be[19] = [
            d("svg", {
              class: "fe-ficon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.8",
              "stroke-linecap": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              d("path", { d: "M6 6l12 12M18 6L6 18" })
            ], -1)
          ])], 8, Dte)) : O("", !0)
        ])
      ])) : O("", !0),
      Be[25] || (Be[25] = d("div", { class: "fe-selbar-slot" }, null, -1)),
      e.showFilterBar ? (f(), Ge(hee, {
        key: 1,
        value: e.filters,
        locale: e.locale,
        theme: e.theme,
        mode: _.value,
        "find-label": ee.value,
        order: e.order,
        shown: ce.value.length,
        total: D.value.length,
        files: D.value,
        "can-paste": e.canPaste,
        "can-write": e.canWrite,
        "onUpdate:value": Be[5] || (Be[5] = (ne) => {
          i("activate"), i("update:filters", ne);
        }),
        onNewFolder: Be[6] || (Be[6] = (ne) => {
          i("activate"), i("new-folder");
        }),
        onUpload: Be[7] || (Be[7] = (ne) => {
          i("activate"), i("upload");
        }),
        onPaste: Be[8] || (Be[8] = (ne) => {
          i("activate"), i("paste");
        }),
        onSelectAll: Be[9] || (Be[9] = (ne) => {
          i("activate"), i("select-all");
        })
      }, null, 8, ["value", "locale", "theme", "mode", "find-label", "order", "shown", "total", "files", "can-paste", "can-write"])) : O("", !0),
      On(Ve.$slots, "banners"),
      d("div", {
        class: Re(["fe__body", { "is-dropover": $t.value }]),
        onClick: yt(Me, ["self"]),
        onContextmenu: qe,
        onDragover: pt,
        onDragleave: Ne,
        onDrop: ie
      }, [
        e.bodyOverride ? On(Ve.$slots, "body", { key: 0 }) : E.value ? (f(), Ge(OT, {
          key: 1,
          compact: "",
          locale: e.locale,
          busy: C.value,
          error: T.value,
          onUnlock: R,
          onRecovery: Be[10] || (Be[10] = (ne) => {
            var ge;
            return (ge = u(k)) == null ? void 0 : ge.recovery(b.value);
          })
        }, null, 8, ["locale", "busy", "error"])) : U.value && D.value.length === 0 ? (f(), h("div", Rte, [
          d("span", Nte, y(u(r)("loading")), 1),
          e.viewMode !== "list" ? (f(), h("div", Ite, [
            (f(), h(Te, null, nt(8, (ne) => d("div", {
              key: ne,
              class: "fe-skel-card"
            }, [...Be[20] || (Be[20] = [
              d("div", { class: "fe-skel fe-skel--thumb" }, null, -1),
              d("div", { class: "fe-skel fe-skel--label" }, null, -1)
            ])])), 64))
          ])) : (f(), h("div", Bte, [
            (f(), h(Te, null, nt(8, (ne) => d("div", {
              key: ne,
              class: "fe-skel-row"
            }, [...Be[21] || (Be[21] = [
              d("div", { class: "fe-skel fe-skel--icon" }, null, -1),
              d("div", { class: "fe-skel fe-skel--name" }, null, -1),
              d("div", { class: "fe-skel fe-skel--size" }, null, -1),
              d("div", { class: "fe-skel fe-skel--date" }, null, -1)
            ])])), 64))
          ]))
        ])) : H.value && D.value.length === 0 ? (f(), h("div", Fte, [
          Be[22] || (Be[22] = u2('<svg class="fe-state__art" viewBox="0 0 120 100" width="110" height="92" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="60" cy="50" r="28"></circle><path d="M60 36v18"></path><circle cx="60" cy="63" r="1.8" fill="currentColor" stroke="none"></circle><path d="M24 88h72" stroke-dasharray="3 5"></path></svg>', 1)),
          d("p", Ute, y(u(r)("error.title")), 1),
          d("p", Hte, y(u(r)("error.hint")), 1),
          d("div", Kte, [
            d("button", {
              type: "button",
              class: "fe-btn fe-btn--primary",
              onClick: Be[11] || (Be[11] = (ne) => e.selfDriven ? P() : i("retry"))
            }, y(u(r)("error.retry")), 1)
          ]),
          d("details", Vte, [
            d("summary", jte, y(u(r)("error.details")), 1),
            d("pre", qte, y(H.value), 1)
          ])
        ])) : !U.value && fe.value && ce.value.length === 0 && D.value.length > 0 ? (f(), h("div", Wte, [
          Be[23] || (Be[23] = d("svg", {
            class: "fe-state__art",
            viewBox: "0 0 120 100",
            width: "110",
            height: "92",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            d("path", { d: "M26 28h68L68 58v24l-16 8V58z" })
          ], -1)),
          d("p", Yte, y(u(r)("filter.empty.title")), 1),
          d("p", Gte, y(u(r)("filter.empty.hint")), 1),
          d("div", Xte, [
            d("button", {
              type: "button",
              class: "fe-btn",
              onClick: Be[12] || (Be[12] = (ne) => i("clear-filters"))
            }, y(u(r)("filter.clear")), 1)
          ])
        ])) : !U.value && D.value.length === 0 ? On(Ve.$slots, "empty", { key: 5 }, () => [
          d("div", Jte, [
            Be[24] || (Be[24] = d("svg", {
              class: "fe-state__art",
              viewBox: "0 0 120 100",
              width: "110",
              height: "92",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true"
            }, [
              d("path", { d: "M18 36v42a6 6 0 0 0 6 6h72a6 6 0 0 0 6-6V44a6 6 0 0 0-6-6H62l-9-10H24a6 6 0 0 0-6 6z" })
            ], -1)),
            d("p", Zte, y(u(r)("empty.folder")), 1)
          ])
        ]) : e.viewMode === "list" ? (f(), Ge(Wee, {
          key: 6,
          files: ce.value,
          order: e.order,
          selected: e.selected,
          clipped: e.clipped,
          "show-parent-path": e.showParentPath,
          trash: e.trash,
          locale: e.locale,
          loading: U.value,
          "folder-key": e.folderKey,
          theme: e.theme,
          "thumb-src": e.thumbSrc,
          "keep-badge-for": e.keepBadgeFor,
          "starred-ids": se.value,
          "star-enabled": e.starEnabled,
          "api-base": e.apiBase,
          "auth-headers": e.authHeaders,
          "auth-credentials": e.authCredentials,
          onClickRow: F,
          onDisplayOrder: Be[13] || (Be[13] = (ne) => i("display-order", ne)),
          onDblRow: V,
          onContextRow: ke,
          onItemDragStart: We,
          onItemDropInto: kt,
          onStarChange: Be[14] || (Be[14] = (ne, ge) => i("star-change", ne, ge)),
          onPeek: u(re).enter,
          onPeekEnd: le
        }, null, 8, ["files", "order", "selected", "clipped", "show-parent-path", "trash", "locale", "loading", "folder-key", "theme", "thumb-src", "keep-badge-for", "starred-ids", "star-enabled", "api-base", "auth-headers", "auth-credentials", "onPeek"])) : e.viewMode === "grid" ? (f(), Ge(ky, {
          key: 7,
          files: ce.value,
          order: e.order,
          sections: !0,
          selected: e.selected,
          clipped: e.clipped,
          "show-parent-path": e.showParentPath,
          locale: e.locale,
          loading: U.value,
          "keep-badge-for": e.keepBadgeFor,
          "thumb-src": e.thumbSrc,
          "e2e-active": e.e2eActive,
          "starred-ids": se.value,
          "star-enabled": e.starEnabled,
          "api-base": e.apiBase,
          "auth-headers": e.authHeaders,
          "auth-credentials": e.authCredentials,
          onClickCard: F,
          onDisplayOrder: Be[15] || (Be[15] = (ne) => i("display-order", ne)),
          onDblCard: V,
          onContextCard: ke,
          onItemDragStart: We,
          onItemDropInto: kt,
          onStarChange: Be[16] || (Be[16] = (ne, ge) => i("star-change", ne, ge)),
          onPeek: u(re).enter,
          onPeekEnd: le
        }, null, 8, ["files", "order", "selected", "clipped", "show-parent-path", "locale", "loading", "keep-badge-for", "thumb-src", "e2e-active", "starred-ids", "star-enabled", "api-base", "auth-headers", "auth-credentials", "onPeek"])) : (f(), Ge(hte, {
          key: 8,
          files: ce.value,
          order: e.order,
          selected: e.selected,
          clipped: e.clipped,
          "show-parent-path": e.showParentPath,
          locale: e.locale,
          loading: U.value,
          "thumb-src": e.thumbSrc,
          "e2e-active": e.e2eActive,
          "starred-ids": se.value,
          "star-enabled": e.starEnabled,
          "api-base": e.apiBase,
          "auth-headers": e.authHeaders,
          "auth-credentials": e.authCredentials,
          onClickCard: F,
          onDblCard: V,
          onContextCard: ke,
          onItemDragStart: We,
          onItemDropInto: kt,
          onStarChange: Be[17] || (Be[17] = (ne, ge) => i("star-change", ne, ge))
        }, null, 8, ["files", "order", "selected", "clipped", "show-parent-path", "locale", "loading", "thumb-src", "e2e-active", "starred-ids", "star-enabled", "api-base", "auth-headers", "auth-credentials"]))
      ], 34),
      Ze(Ate, {
        state: u(re).state.value,
        "src-of": q,
        locale: e.locale
      }, null, 8, ["state", "locale"])
    ], 42, Pte));
  }
});
function nne(e) {
  const t = S([]), n = S(""), a = A(
    () => t.value.find((C) => C.id === n.value) ?? null
  ), i = A(() => t.value.findIndex((C) => C.id === n.value)), r = A(() => t.value.length > 1);
  function l() {
    if (!e.storageKey) return !1;
    try {
      const C = localStorage.getItem(e.storageKey);
      if (!C) return !1;
      const T = JSON.parse(C);
      if (!T || !Array.isArray(T.tabs) || T.tabs.length === 0) return !1;
      const E = [];
      for (const R of T.tabs) {
        if (!R || typeof R.path != "string") continue;
        const z = typeof R.viewMode == "string" && R.viewMode ? R.viewMode : "list", D = R.split, U = D && typeof D == "object" && typeof D.path == "string" ? {
          path: D.path,
          viewMode: typeof D.viewMode == "string" && D.viewMode ? D.viewMode : void 0
        } : null;
        E.push({
          id: typeof R.id == "string" && R.id ? R.id : ul(),
          path: R.path,
          viewMode: z,
          split: U
        });
      }
      return E.length === 0 ? !1 : (t.value = E, n.value = E.some((R) => R.id === T.active) ? String(T.active) : E[0].id, !0);
    } catch {
      return !1;
    }
  }
  function c() {
    if (e.storageKey)
      try {
        localStorage.setItem(
          e.storageKey,
          JSON.stringify({ v: 1, active: n.value, tabs: t.value })
        );
      } catch {
      }
  }
  Je([t, n], c, { deep: !0 });
  function p(C, T) {
    if (t.value.length > 0) return;
    const E = { id: ul(), path: C, viewMode: T, split: null };
    t.value = [E], n.value = E.id;
  }
  function m(C) {
    const T = a.value;
    T && (C.path !== void 0 && (T.path = C.path), C.viewMode !== void 0 && (T.viewMode = C.viewMode));
  }
  function v(C, T) {
    const E = { id: ul(), path: C, viewMode: T.viewMode, split: T.split ?? null }, R = i.value;
    return t.value.splice(R === -1 ? t.value.length : R + 1, 0, E), T.background || (n.value = E.id), E;
  }
  function x(C) {
    if (t.value.length <= 1) return null;
    const T = t.value.findIndex((z) => z.id === C);
    if (T === -1) return null;
    const E = t.value[T].id === n.value;
    if (t.value.splice(T, 1), !E) return null;
    const R = t.value[Math.min(T, t.value.length - 1)];
    return n.value = R.id, R;
  }
  function w(C) {
    const T = t.value.find((E) => E.id === C);
    return !T || T.id === n.value ? null : (n.value = T.id, T);
  }
  function $(C) {
    if (t.value.length < 2) return null;
    const T = i.value === -1 ? 0 : i.value, E = t.value[(T + C + t.value.length) % t.value.length];
    return w(E.id);
  }
  function k(C, T) {
    if (C === T || C < 0 || T < 0 || C >= t.value.length || T >= t.value.length) return;
    const E = [...t.value], [R] = E.splice(C, 1);
    E.splice(T, 0, R), t.value = E;
  }
  function b(C) {
    const T = a.value;
    T && (T.split = C);
  }
  return {
    tabs: t,
    activeId: n,
    activeTab: a,
    activeIndex: i,
    hasMultiple: r,
    restore: l,
    seed: p,
    syncActive: m,
    openTab: v,
    closeTab: x,
    activate: w,
    step: $,
    move: k,
    setSplit: b
  };
}
function LT(e, t) {
  const n = e.lastIndexOf(".");
  return n <= 0 ? `${e} (${t})` : `${e.slice(0, n)} (${t})${e.slice(n)}`;
}
function ane(e, t) {
  if (e.length !== t.length) return !1;
  for (let n = 0; n < e.length; n++) if (e[n] !== t[n]) return !1;
  return !0;
}
async function ine(e, t, n, a) {
  if (!t) return null;
  for (const i of a) {
    if (ane(i, n)) continue;
    const r = await Ex(e, t, i);
    if (r !== null) return Gi(r) ? null : r;
  }
  return null;
}
async function one(e, t, n) {
  var r;
  const a = Il(e);
  return a.kind === "file" || a.kind === "dir" ? a.encoded ?? null : a.kind !== "long" && a.kind !== "longdir" ? null : (((r = await n.readSidecar(t, `${a.hash}.fxl.name`)) == null ? void 0 : r.trim()) ?? "") || null;
}
async function rne(e, t, n, a) {
  const i = [], r = [{ wire: t, id: e.rootId }];
  for (; r.length; ) {
    if (n.stopped()) return;
    const c = r.shift();
    let p;
    try {
      p = await n.list(c.wire);
    } catch {
      a.failed++;
      continue;
    }
    i.push({ ...c, rows: p });
    for (const m of p)
      m.type === "dir" && r.push({ wire: m.path, id: await Hv(e, c.id, m.basename) });
  }
  const l = i.map((c) => c.id);
  for (const c of i.reverse()) {
    const p = new Set(c.rows.map((m) => m.basename));
    for (const m of c.rows) {
      if (n.stopped()) return;
      const v = m.basename;
      if (v === ga) continue;
      const x = await Cx(e, v, c.id, (C) => n.readSidecar(c.wire, C));
      if (x.state === "enc" || x.state === "sidecar") continue;
      a.seen++;
      const w = await ine(e, await one(v, c.wire, n), c.id, l), $ = w ?? (x.state === "plain" ? v : null);
      if ($ === null || Gi($)) {
        a.failed++;
        continue;
      }
      const k = m.type === "dir" ? { dirId: await Hv(e, c.id, v) } : {};
      let b = await Kv(e, $, c.id, k);
      for (let C = 2; p.has(b.stored) && C < 100; C++)
        b = await Kv(e, LT($, C), c.id, k);
      if (p.has(b.stored)) {
        a.failed++;
        continue;
      }
      try {
        b.sidecar && await n.writeSidecar(c.wire, b.sidecar.name, b.sidecar.content), await n.rename(c.wire, m, b.stored), p.delete(v), p.add(b.stored), a.renamed++, w !== null && (a.repaired = (a.repaired ?? 0) + 1);
      } catch {
        a.failed++;
      }
    }
  }
}
function T0(e) {
  return typeof e.size != "number" || typeof e.last_modified != "number" ? null : `${e.size}:${e.last_modified}`;
}
async function sne(e, t, n, a) {
  const i = [], r = [e], l = (c) => c.replace(/\/+$/, "") === e.replace(/\/+$/, "");
  for (; r.length; ) {
    if (t.stopped()) return;
    const c = r.shift();
    let p;
    try {
      p = await t.list(c);
    } catch {
      n.failed++;
      continue;
    }
    for (const m of p) {
      if (m.type === "dir") {
        r.push(m.path);
        continue;
      }
      l(c) && m.basename === ga || Il(m.basename).kind !== "sidecar" && i.push({ dir: c, row: m });
    }
  }
  n.total = i.length;
  for (const { dir: c, row: p } of i) {
    if (t.stopped()) return;
    try {
      if (Tl(await t.head(p.path))) {
        n.skipped++;
        continue;
      }
      if (typeof p.size == "number" && p.size > a.maxBytes) {
        t.writeLarge && await t.writeLarge(c, p, T0(p)) ? (n.done++, n.large = (n.large ?? 0) + 1) : n.tooBig++;
        continue;
      }
      const m = await t.read(p.path);
      if (m.byteLength > a.maxBytes) {
        n.tooBig++;
        continue;
      }
      const v = await t.encrypt(m);
      await t.write(c, p, new Blob([v], { type: "application/octet-stream" }), T0(p)), n.done++;
    } catch {
      n.failed++;
    }
  }
}
const _y = /* @__PURE__ */ new Set(), xy = S(0);
function lne(e) {
  return _y.add(e), xy.value++, () => {
    _y.delete(e) && xy.value++;
  };
}
function une(e, t) {
  xy.value;
  for (const n of _y) {
    const a = n(e, t);
    if (a) return a;
  }
  return null;
}
const cne = {
  key: 0,
  class: "fe-e2e-form",
  "data-testid": "e2e-too-big"
}, dne = { class: "fe-e2e-rk__lead" }, fne = { class: "fe-e2e-big__steps" }, pne = { class: "fe-e2e-big__cmd" }, hne = { "data-testid": "e2e-too-big-command" }, mne = { class: "fe-e2e-names__hint" }, vne = /* @__PURE__ */ lt({
  __name: "E2eTooBigModal",
  props: {
    open: { type: Boolean },
    locale: {},
    info: {}
  },
  emits: ["close", "download"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatSize: r } = ht(() => n.locale), l = S(!1);
    Je(
      () => n.open,
      (m) => {
        m && (l.value = !1);
      }
    );
    const c = A(() => {
      const m = n.info;
      if (!m) return "";
      const v = r(m.limit);
      return m.size !== null ? i("e2e.big.lead", { name: m.name, size: r(m.size), limit: v }) : i("e2e.big.lead_grew", { name: m.name, limit: v });
    });
    async function p() {
      var v;
      const m = (v = n.info) == null ? void 0 : v.command;
      if (m)
        try {
          await navigator.clipboard.writeText(m), l.value = !0;
        } catch {
        }
    }
    return (m, v) => (f(), Ge(ta, {
      open: e.open,
      title: u(i)("e2e.big.title"),
      size: "sm",
      onClose: v[2] || (v[2] = (x) => a("close"))
    }, {
      actions: mt(() => {
        var x;
        return [
          d("button", {
            type: "button",
            class: "fe-btn",
            onClick: v[0] || (v[0] = (w) => a("close"))
          }, y(u(i)("e2e.big.close")), 1),
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--primary",
            "data-testid": "e2e-too-big-download",
            onClick: v[1] || (v[1] = (w) => a("download"))
          }, y(((x = e.info) == null ? void 0 : x.encrypted.kind) === "folder" ? u(i)("e2e.big.download_folder") : u(i)("e2e.big.download_file")), 1)
        ];
      }),
      default: mt(() => [
        e.info ? (f(), h("div", cne, [
          d("p", dne, y(c.value), 1),
          d("p", null, y(u(i)("e2e.big.instead")), 1),
          d("ol", fne, [
            d("li", null, y(e.info.encrypted.kind === "file" ? u(i)("e2e.big.step_file") : u(i)("e2e.big.step_folder")), 1),
            d("li", null, [
              Ht(y(u(i)("e2e.big.step_run")) + " ", 1),
              d("span", pne, [
                d("code", hne, y(e.info.command), 1),
                d("button", {
                  type: "button",
                  class: "fe-e2e-optlink",
                  "data-testid": "e2e-too-big-copy",
                  onClick: p
                }, y(l.value ? u(i)("e2e.big.copied") : u(i)("e2e.big.copy")), 1)
              ])
            ])
          ]),
          d("p", mne, y(u(i)("e2e.big.other_ways")), 1)
        ])) : O("", !0)
      ]),
      _: 1
    }, 8, ["open", "title"]));
  }
}), yne = "filexfxe", DT = 1, Sp = ".fxe", RT = 64 * 1024, gne = [], Ff = new TextEncoder().encode(yne), Ec = 13, bne = 32;
function NT(e) {
  return typeof e == "string" && e.length > Sp.length && e.toLowerCase().endsWith(Sp);
}
function kne() {
  const e = crypto.getRandomValues(new Uint8Array(4));
  return `encrypted-${Array.from(e, (t) => t.toString(16).padStart(2, "0")).join("")}${Sp}`;
}
function wne(e) {
  return /^encrypted-[0-9a-f]{8}\.fxe$/i.test(e);
}
function A0(e, t) {
  return t ? kne() : `${e}${Sp}`;
}
function Jg(e) {
  const t = { v: 2, salt: e.salt, iter: e.iter, verify: e.verify, fmk: "wrapped", fmk_pw: e.fmk_pw };
  return e.rk && (t.rk = e.rk), e.esc && (t.esc = e.esc), t;
}
function E0(e) {
  return !!e.rk && typeof e.rk.salt == "string" && typeof e.rk.blob == "string";
}
function IT(e) {
  const t = new TextEncoder().encode(JSON.stringify(e));
  if (t.length === 0 || t.length > RT) throw new Error("e2e: the .fxe header is too large");
  const n = new Uint8Array(Ec + t.length);
  return n.set(Ff, 0), n[8] = DT, new DataView(n.buffer).setUint32(9, t.length, !1), n.set(t, Ec), n;
}
function _ne(e) {
  if (e.length < Ff.length) return !1;
  for (let t = 0; t < Ff.length; t++) if (e[t] !== Ff[t]) return !1;
  return !0;
}
class Br extends Error {
  constructor(t) {
    super(t), this.name = "FxeFormatError";
  }
}
function xne(e) {
  if (e.length < Ec || !_ne(e)) throw new Br("e2e: not a filex encrypted file (.fxe)");
  if (e[8] !== DT) throw new Br(`e2e: unsupported .fxe version ${e[8]} - a newer filex wrote it`);
  const t = new DataView(e.buffer, e.byteOffset, e.byteLength).getUint32(9, !1);
  if (t === 0 || t > RT) throw new Br("e2e: the .fxe header length is out of range");
  return t;
}
function C0(e, t) {
  if (typeof e != "string" || e.length === 0) return !1;
  try {
    const n = ea(e);
    return t === void 0 || n.length === t;
  } catch {
    return !1;
  }
}
function Sne(e, t) {
  var r, l, c, p, m;
  let n;
  try {
    n = JSON.parse(new TextDecoder("utf-8", { fatal: !0 }).decode(e));
  } catch {
    throw new Br("e2e: the .fxe header is not readable");
  }
  const a = (v) => new Br(`e2e: the .fxe header is damaged (${v})`);
  if (!n || typeof n != "object" || Array.isArray(n)) throw a("not an object");
  if (!C0(n.salt)) throw a("salt");
  if (typeof n.iter != "number" || !Number.isInteger(n.iter) || n.iter < 1 || n.iter > Vx) throw a("iter");
  if (typeof n.verify != "string") throw a("verify");
  if (n.fmk !== "wrapped" || typeof n.fmk_pw != "string") throw a("fmk");
  if (n.rk !== void 0 && (typeof n.rk != "object" || typeof ((r = n.rk) == null ? void 0 : r.salt) != "string" || typeof ((l = n.rk) == null ? void 0 : l.blob) != "string"))
    throw a("rk");
  if (n.esc !== void 0 && (typeof n.esc != "object" || typeof ((c = n.esc) == null ? void 0 : c.kid) != "string" || typeof ((p = n.esc) == null ? void 0 : p.alg) != "string" || typeof ((m = n.esc) == null ? void 0 : m.blob) != "string"))
    throw a("esc");
  if (typeof n.dek != "string" || typeof n.name != "string") throw a("dek/name");
  if (!Ic(n.chunk)) throw a("chunk");
  if (!C0(n.nonce, jr)) throw a("nonce");
  if (typeof n.size != "number" || !Number.isSafeInteger(n.size) || n.size < 0) throw a("size");
  const i = [];
  if (n.req !== void 0) {
    if (!Array.isArray(n.req) || n.req.some((v) => typeof v != "string")) throw a("req");
    for (const v of n.req) gne.includes(v) || i.push(v);
  }
  return { header: n, unsupported: i, prefixLength: t };
}
async function $ne(e) {
  const t = new Lp(e);
  try {
    const n = await t.read(Ec), a = xne(n), i = await t.read(a);
    if (i.length < a) throw new Br("e2e: the .fxe file is truncated");
    return { parsed: Sne(i, Ec + a), body: t.rest() };
  } catch (n) {
    throw await t.cancel().catch(() => {
    }), n;
  }
}
async function Tne(e, t) {
  const n = await F_(t, e.dek);
  if (!n || n.length !== bne) return null;
  let a;
  try {
    a = await Dp(new Uint8Array(n));
  } finally {
    n.fill(0);
  }
  const i = await F_(t, e.name);
  if (!i) return null;
  let r;
  try {
    r = new TextDecoder("utf-8", { fatal: !0 }).decode(i);
  } catch {
    return null;
  }
  return Gi(r) ? null : { header: e, fmk: t, dek: a, name: r.normalize("NFC") };
}
async function Ane(e, t) {
  const n = Jg(e);
  let a;
  if ("password" in t) {
    const r = await eS(n, t.password);
    if ("error" in r) return { error: r.error };
    a = r.fmk;
  } else if ("recoveryKey" in t) {
    if (a = await tS(n, t.recoveryKey), !a) return { error: "wrong" };
  } else if (a = await nS(n, t.escrowKey), !a) return { error: "wrong" };
  const i = await Tne(e, a);
  return i ? { key: i } : { error: "damaged" };
}
function Ene(e, t) {
  return { ...e, header: t };
}
async function Cne(e, t, n, a, i = {}) {
  const r = (e ?? "").normalize("NFC"), l = Gi(r);
  if (l) throw new Error(`e2e: invalid name (${l})`);
  if ((a ?? "").length < op)
    throw new Error(`e2e: the password must be at least ${op} characters`);
  if (!Number.isSafeInteger(t) || t < 0) throw new Error("e2e: bad file size");
  const c = i.chunkLog2 ?? So;
  if (!Ic(c)) throw new Error("e2e: bad chunk size");
  const p = await Jv(a, {
    escrowPublicKey: i.escrowPublicKey ?? null,
    iterations: i.iterations
  }), m = Ix();
  let v, x;
  try {
    v = await B_(p.fmk, m), x = await Dp(m);
  } finally {
    m.fill(0);
  }
  const w = Dx(), $ = p.marker, k = {
    salt: $.salt,
    iter: $.iter,
    verify: $.verify,
    fmk: "wrapped",
    fmk_pw: $.fmk_pw,
    ...$.rk ? { rk: $.rk } : {},
    ...$.esc ? { esc: $.esc } : {},
    dek: v,
    name: await B_(p.fmk, new TextEncoder().encode(r)),
    chunk: c,
    nonce: Ma(w),
    size: t
  }, b = IT(k), C = n.pipeThrough(
    Rx(x, w, c, { expectSize: t, onProgress: i.onProgress })
  );
  return {
    header: k,
    stream: Fc(b, C),
    size: b.length + ag(t, c),
    recoveryKey: p.recoveryKey,
    key: { header: k, fmk: p.fmk, dek: x, name: r }
  };
}
function hv(e, t) {
  const n = e.header;
  return t.pipeThrough(Nx(e.dek, ea(n.nonce), n.chunk, { expectSize: n.size }));
}
async function zne(e, t, n) {
  const a = await rS(Jg(e), t, n);
  if (a.fmk !== "wrapped" || !a.fmk_pw) throw new cn("e2e: the password slot did not re-seal");
  return { ...e, salt: a.salt, iter: a.iter, verify: a.verify, fmk: "wrapped", fmk_pw: a.fmk_pw };
}
function Mne(e, t) {
  const n = IT(e);
  return { stream: Fc(n, t), size: n.length + ag(e.size, e.chunk) };
}
const vi = 1024 * 1024 * 1024;
function BT() {
  if (typeof window > "u") return null;
  const e = window;
  return typeof e.showSaveFilePicker == "function" && e.isSecureContext !== !1 ? e.showSaveFilePicker.bind(window) : null;
}
function Pne() {
  return BT() !== null;
}
class Qs extends Error {
  constructor() {
    super("save cancelled"), this.name = "SaveCancelled";
  }
}
class Uf extends Error {
  constructor() {
    super("the save dialog needs a click"), this.name = "SaveNeedsGesture";
  }
}
class Xa extends Error {
  constructor(t, n) {
    super(`e2e: ${t} bytes is more than this browser can save from memory (${n})`), this.size = t, this.limit = n, this.name = "SaveTooLarge";
  }
}
async function mv(e, t) {
  const n = BT();
  if (n) {
    let a;
    try {
      a = await n({ suggestedName: e });
    } catch (i) {
      const r = i == null ? void 0 : i.name;
      throw r === "AbortError" ? new Qs() : r === "SecurityError" || r === "NotAllowedError" ? new Uf() : i;
    }
    return One(e, a);
  }
  if (t !== void 0 && t > vi) throw new Xa(t, vi);
  return Lne(e);
}
function One(e, t) {
  let n = null;
  return {
    kind: "fsa",
    name: e,
    async write(a) {
      var l;
      n = await t.createWritable();
      const i = n, r = a.getReader();
      try {
        for (; ; ) {
          const { done: c, value: p } = await r.read();
          if (c) break;
          await i.write(p);
        }
        await i.close();
      } catch (c) {
        throw await i.abort(c).catch(() => {
        }), await r.cancel(c).catch(() => {
        }), await ((l = t.remove) == null ? void 0 : l.call(t).catch(() => {
        })), c;
      }
    },
    async discard() {
      var a;
      n && await n.abort().catch(() => {
      }), await ((a = t.remove) == null ? void 0 : a.call(t).catch(() => {
      }));
    }
  };
}
function Lne(e) {
  return {
    kind: "blob",
    name: e,
    async write(t, n) {
      const a = [];
      let i = 0;
      const r = t.getReader();
      try {
        for (; ; ) {
          const { done: m, value: v } = await r.read();
          if (m) break;
          if (i += v.length, i > vi) throw new Xa(i, vi);
          a.push(new Blob([v]));
        }
      } catch (m) {
        throw await r.cancel(m).catch(() => {
        }), m;
      }
      const l = new Blob(a, { type: (n == null ? void 0 : n.mime) || "application/octet-stream" }), c = URL.createObjectURL(l), p = document.createElement("a");
      p.href = c, p.download = e, p.rel = "noopener", document.body.appendChild(p), p.click(), p.remove(), setTimeout(() => URL.revokeObjectURL(c), 6e4);
    },
    async discard() {
    }
  };
}
const ba = 4294967295, Hf = 65535, Dne = new TextEncoder();
let vv = null;
function Rne() {
  if (vv) return vv;
  const e = new Uint32Array(256);
  for (let t = 0; t < 256; t++) {
    let n = t;
    for (let a = 0; a < 8; a++) n = n & 1 ? 3988292384 ^ n >>> 1 : n >>> 1;
    e[t] = n >>> 0;
  }
  return vv = e, e;
}
function Nne(e, t = 0) {
  const n = Rne();
  let a = (t ^ ba) >>> 0;
  for (let i = 0; i < e.length; i++) a = n[(a ^ e[i]) & 255] ^ a >>> 8;
  return (a ^ ba) >>> 0;
}
class Fr {
  constructor(t) {
    Nt(this, "buf");
    Nt(this, "dv");
    Nt(this, "o", 0);
    this.buf = new Uint8Array(t), this.dv = new DataView(this.buf.buffer);
  }
  u16(t) {
    return this.dv.setUint16(this.o, t, !0), this.o += 2, this;
  }
  u32(t) {
    return this.dv.setUint32(this.o, t >>> 0, !0), this.o += 4, this;
  }
  u64(t) {
    return this.dv.setUint32(this.o, t % 2 ** 32, !0), this.dv.setUint32(this.o + 4, Math.floor(t / 2 ** 32), !0), this.o += 8, this;
  }
  bytes(t) {
    return this.buf.set(t, this.o), this.o += t.length, this;
  }
  done() {
    if (this.o !== this.buf.length) throw new Error(`zip: record size ${this.o} != ${this.buf.length}`);
    return this.buf;
  }
}
function Ine(e) {
  const t = e.getFullYear();
  return t < 1980 ? { time: 0, date: 33 } : {
    time: e.getHours() << 11 | e.getMinutes() << 5 | Math.floor(e.getSeconds() / 2),
    date: Math.min(t, 2107) - 1980 << 9 | e.getMonth() + 1 << 5 | e.getDate()
  };
}
const FT = 2048, UT = 8, HT = 813, Bne = 33188, Fne = 16877;
function Une(e) {
  const t = e.zip64Local ? 20 : 0, n = new Fr(30 + e.name.length + t).u32(67324752).u16(e.zip64Local ? 45 : 20).u16(FT | (e.dir ? 0 : UT)).u16(0).u16(e.time).u16(e.date).u32(0).u32(e.zip64Local ? ba : 0).u32(e.zip64Local ? ba : 0).u16(e.name.length).u16(t).bytes(e.name);
  return e.zip64Local && n.u16(1).u16(16).u64(0).u64(0), n.done();
}
function Hne(e) {
  return e.zip64Local ? new Fr(24).u32(134695760).u32(e.crc).u64(e.size).u64(e.size).done() : new Fr(16).u32(134695760).u32(e.crc).u32(e.size).u32(e.size).done();
}
function Kne(e, t) {
  const n = t || e.size >= ba, a = t || e.offset >= ba, i = n || a ? 4 + (n ? 16 : 0) + (a ? 8 : 0) : 0, r = new Fr(46 + e.name.length + i).u32(33639248).u16(HT).u16(n || a || e.zip64Local ? 45 : 20).u16(FT | (e.dir ? 0 : UT)).u16(0).u16(e.time).u16(e.date).u32(e.crc).u32(n ? ba : e.size).u32(n ? ba : e.size).u16(e.name.length).u16(i).u16(0).u16(0).u16(0).u32((e.dir ? Fne : Bne) * 65536 + (e.dir ? 16 : 0) >>> 0).u32(a ? ba : e.offset).bytes(e.name);
  return i && (r.u16(1).u16(i - 4), n && r.u64(e.size).u64(e.size), a && r.u64(e.offset)), r.done();
}
function Vne(e, t, n, a) {
  const i = [], r = a || e >= Hf || t >= ba || n >= ba;
  if (r) {
    const l = t + n;
    i.push(
      new Fr(56).u32(101075792).u64(44).u16(HT).u16(45).u32(0).u32(0).u64(e).u64(e).u64(n).u64(t).done()
    ), i.push(new Fr(20).u32(117853008).u32(0).u64(l).u32(1).done());
  }
  return i.push(
    new Fr(22).u32(101010256).u16(0).u16(0).u16(r ? Hf : e).u16(r ? Hf : e).u32(r ? ba : n).u32(r ? ba : t).u16(0).done()
  ), i;
}
function jne(e, t) {
  const n = e.replace(/\\/g, "/").split("/").filter((a) => a !== "" && a !== ".");
  if (n.length === 0 || n.some((a) => a === "..")) throw new Error(`zip: unsafe entry name ${JSON.stringify(e)}`);
  return n.join("/") + (t ? "/" : "");
}
async function* qne(e, t) {
  const n = !!t.forceZip64, a = [];
  let i = 0;
  const r = (p) => {
    var m;
    return i += p.length, (m = t.onProgress) == null || m.call(t, i), p;
  };
  for await (const p of e) {
    const m = p.name.endsWith("/") && !p.data, v = Dne.encode(jne(p.name, m));
    if (v.length > Hf) throw new Error("zip: entry name too long");
    const { time: x, date: w } = Ine(p.mtime ?? /* @__PURE__ */ new Date()), $ = {
      name: v,
      dir: m,
      zip64Local: !m && (n || p.sizeHint === void 0 || p.sizeHint >= ba),
      crc: 0,
      size: 0,
      offset: i,
      time: x,
      date: w
    };
    if (yield r(Une($)), !m && p.data) {
      const b = (typeof p.data == "function" ? await p.data() : p.data).getReader();
      try {
        for (; ; ) {
          const { done: C, value: T } = await b.read();
          if (C) break;
          !T || T.length === 0 || ($.crc = Nne(T, $.crc), $.size += T.length, yield r(T));
        }
      } catch (C) {
        throw await b.cancel(C).catch(() => {
        }), C;
      } finally {
        b.releaseLock();
      }
      if (!$.zip64Local && $.size >= ba) throw new Error(`zip: ${p.name} grew past its size hint and 4 GiB`);
      yield r(Hne($));
    }
    a.push($);
  }
  const l = i;
  for (const p of a) yield r(Kne(p, n));
  const c = i - l;
  for (const p of Vne(a.length, l, c, n)) yield r(p);
}
function Wne(e, t = {}) {
  const n = qne(e, t);
  return new ReadableStream({
    async pull(a) {
      const { value: i, done: r } = await n.next();
      r ? a.close() : a.enqueue(i);
    },
    async cancel() {
      await n.return(void 0);
    }
  });
}
function z0(e, t) {
  let n = null;
  const a = () => n ?? (n = new Lp(e));
  let i = 0, r = new Uint8Array(0), l = 0, c = !1;
  return {
    size: t,
    async read(p, m) {
      if (c) throw new Error("upload source cancelled");
      if (p < i || p > l || m < p || m > t)
        throw new Error(`upload source: cannot read [${p}, ${m}) after [${i}, ${l})`);
      const v = r.subarray(p - i);
      if (m > l) {
        const x = await a().read(m - l);
        if (x.length < m - l) throw new Error("upload source: the stream ended early");
        const w = new Uint8Array(v.length + x.length);
        w.set(v, 0), w.set(x, v.length), r = w, l = m;
      } else
        r = v.slice();
      return i = p, new Blob([r.subarray(0, m - p)]);
    },
    cancel() {
      c || (c = !0, (n ? n.cancel() : e.cancel()).catch(() => {
      }));
    }
  };
}
async function M0(e, t, n = "application/octet-stream") {
  const a = [], i = e.getReader();
  for (; ; ) {
    const { done: r, value: l } = await i.read();
    if (r) break;
    a.push(new Blob([l]));
  }
  return new File(a, t, { type: n });
}
const Yne = [
  "fxe-encrypt",
  "fxe-request",
  "fxe-download-raw",
  "fxe-remove",
  "fxe-password",
  "e2e-download-encrypted"
];
function Gne(e) {
  return Yne.includes(e);
}
function Ui(e) {
  return !!e && e.type === "file" && NT(typeof e.e2e_stored == "string" ? e.e2e_stored : e.basename);
}
function KT(e, t) {
  const n = e.length === 1 ? e[0] : null;
  return !n || n.type !== "file" || Ui(n) || t.inEncrypted || n.e2e_root || !t.canWrite ? null : n;
}
function Xne(e, t) {
  const n = e.lastIndexOf(".");
  return n <= 0 ? `${e} (${t})` : `${e.slice(0, n)} (${t})${e.slice(n)}`;
}
function Jne(e) {
  const { api: t, t: n } = e, a = /* @__PURE__ */ new Map(), i = S(0), r = /* @__PURE__ */ new Map();
  function l() {
    for (const ne of r.values()) URL.revokeObjectURL(ne);
    r.clear();
  }
  Tt(() => {
    l(), a.clear();
  });
  const c = S(null), p = S(!1), m = S(null), v = S(null), x = S(null), w = S("open"), $ = S(!1), k = S(null), b = S(null), C = S(!1), T = S(!0), E = S("off"), R = S(null), z = S(null), D = S(!1), U = S(null), H = S(null);
  async function L(ne) {
    const ge = await t.authHeaders(), G = await fetch(t.previewUrl(ne), {
      headers: ge,
      credentials: t.credentialsMode(),
      cache: "no-store"
    });
    if (!G.ok) {
      const ye = await G.text().catch(() => "");
      throw fa(G.status, ye, e.locale());
    }
    if (!G.body) throw new Error("e2e: this browser cannot read a download as a stream");
    return G.body;
  }
  async function P(ne) {
    const ge = await t.index(ne);
    return new Set((ge.files ?? []).map((G) => G.basename));
  }
  function K(ne, ge) {
    if (!ge.has(ne)) return ne;
    for (let G = 2; G < 1e3; G++) {
      const ye = Xne(ne, G);
      if (!ge.has(ye)) return ye;
    }
    throw new Error("e2e: no free name");
  }
  async function N(ne, ge, G, ye, te, Ce = {}) {
    const Ie = new File([], ge, { type: "application/octet-stream" }), { fields: _e, signal: Ae } = Ce;
    if (Ae != null && Ae.aborted)
      throw await G.cancel().catch(() => {
      }), new DOMException("Aborted by user", "AbortError");
    if (ye > e.chunked.threshold()) {
      const _t = z0(G, ye);
      let Et = null;
      const xn = () => Et == null ? void 0 : Et.cancel();
      Ae == null || Ae.addEventListener("abort", xn);
      try {
        await e.chunked.uploadFile({
          path: ne,
          file: Ie,
          source: _t,
          commitQuery: _e,
          onProgress: (Dt) => {
            Et = Dt, Ae != null && Ae.aborted && Dt.cancel(), te == null || te(Dt.uploadedBytes);
          }
        });
        return;
      } catch (Dt) {
        if (!Ky(Dt)) throw Dt;
        if (ye > vi)
          throw await G.cancel().catch(() => {
          }), new Xa(ye, vi);
      } finally {
        Ae == null || Ae.removeEventListener("abort", xn);
      }
    }
    const Pe = await M0(G, ge);
    if (Pe.size !== ye) throw new Error("e2e: the upload came out a different size than it should");
    if (Ae != null && Ae.aborted) throw new DOMException("Aborted by user", "AbortError");
    await t.uploadMultipart(ne, [Pe], (_t) => te == null ? void 0 : te(Math.round(_t / 100 * ye)), _e);
  }
  async function J(ne) {
    const ge = Ia(ne);
    if (t.endpoints.deleteAsync) {
      const { op: G } = await t.deleteAsync([ne], ge);
      e.registerOp(G);
      return;
    }
    await t.deleteItems(ge, [ne]);
  }
  function j(ne) {
    return ne instanceof Error && ne.message ? ne.message : String(ne);
  }
  function re(ne) {
    return ne instanceof Br ? n("e2e.fxe.not_readable") : ne instanceof cn ? n("e2e.fxe.damaged") : j(ne);
  }
  async function q(ne) {
    const { parsed: ge, body: G } = await $ne(await L(ne));
    return { header: ge.header, unsupported: ge.unsupported, body: G };
  }
  function le(ne, ge) {
    return ne.header.dek === ge.dek && ne.header.nonce === ge.nonce && ne.header.size === ge.size;
  }
  function ve(ne) {
    var ge;
    return i.value, (ge = a.get(ne)) == null ? void 0 : ge.name;
  }
  function ce(ne, ge) {
    const G = ne.length === 1 ? ne[0] : null, ye = !!G && Ui(G), te = KT(ne, ge) !== null, Ce = ge.encryptAnswer ?? "allowed";
    return [
      {
        key: "fxe-encrypt",
        label: n("e2e.fxe.ctx_encrypt"),
        icon: "lock",
        hidden: !te || Ce !== "allowed"
      },
      /* wiring:e2 policy — the same place, where encrypting needs an approval. */
      {
        key: "fxe-request",
        label: n("e2e.request.ctx"),
        icon: "lock",
        hidden: !te || Ce !== "request"
      },
      { key: "fxe-download-raw", label: n("e2e.fxe.ctx_download_raw"), icon: "download", hidden: !ye },
      {
        key: "e2e-download-encrypted",
        label: n("e2e.dl.ctx_encrypted_copy"),
        icon: "download",
        hidden: ye || ne.length === 0 || !ge.unlockedEncryptedCopy
      },
      { key: "fxe-password", label: n("e2e.fxe.ctx_password"), icon: "lock", hidden: !ye || !ge.canWrite },
      { key: "fxe-remove", label: n("e2e.fxe.ctx_remove"), icon: "restore", hidden: !ye || !ge.canWrite }
    ];
  }
  function se(ne) {
    c.value = ne, m.value = null, v.value = null;
  }
  function fe() {
    p.value || (c.value = null);
  }
  async function _(ne, ge) {
    for (const G of await t.listVersions(ge)) await t.purgeVersion(G.id);
    await t.deleteItems(Ia(ne.path), [ne.path]);
    try {
      await t.purgeTrash(ge);
    } catch (G) {
      if (G.status !== 404) throw G;
    }
  }
  async function ee(ne) {
    const ge = c.value;
    if (!(!ge || p.value)) {
      p.value = !0, m.value = null, v.value = 0;
      try {
        const G = Ia(ge.path), ye = typeof ge.size == "number" ? ge.size : NaN;
        if (!Number.isSafeInteger(ye) || ye < 0) throw new Error(n("e2e.fxe.size_unknown"));
        const te = ne.purge === !0;
        if (te && typeof ge.id != "number") throw new Error(n("e2e.fxe.purge_no_id"));
        if (Gi(ge.basename)) throw new Error(n("e2e.fxe.bad_name"));
        const Ce = await P(G);
        let Ie = A0(ge.basename, ne.hideName);
        if (ne.hideName)
          for (let Pe = 0; Ce.has(Ie) && Pe < 20; Pe++) Ie = A0(ge.basename, !0);
        else
          Ie = `${K(ge.basename, new Set([...Ce].filter(NT).map((Pe) => Pe.slice(0, -4))))}.fxe`;
        if (Gi(Ie)) throw new Error(n("e2e.fxe.name_too_long"));
        const _e = await Cne(ge.basename, ye, await L(ge.path), ne.password, {
          escrowPublicKey: e.escrowPublicKey()
        });
        await N(G, Ie, _e.stream, _e.size, (Pe) => {
          v.value = _e.size > 0 ? Math.min(100, Math.round(Pe / _e.size * 100)) : 100;
        });
        const Ae = tl(G, Ie);
        if (a.set(Ae, _e.key), i.value++, te) {
          try {
            await _(ge, ge.id);
          } catch (Pe) {
            c.value = null, e.emitError(j(Pe), "fxe-purge-original"), e.toast(n("e2e.fxe.purge_failed", { name: ge.basename, reason: j(Pe) }), !0), e.showRecoveryKey(_e.recoveryKey, ge.basename), await e.reload();
            return;
          }
          c.value = null, e.showRecoveryKey(_e.recoveryKey, ge.basename), e.toast(n("e2e.fxe.purged", { name: ge.basename })), await e.reload();
          return;
        }
        try {
          await J(ge.path);
        } catch (Pe) {
          c.value = null, e.emitError(j(Pe), "fxe-trash-original"), e.toast(n("e2e.fxe.original_kept", { name: ge.basename }), !0), e.showRecoveryKey(_e.recoveryKey, ge.basename), await e.reload();
          return;
        }
        c.value = null, e.showRecoveryKey(_e.recoveryKey, ge.basename), e.toast(n("e2e.fxe.encrypted", { name: ge.basename })), await e.reload();
      } catch (G) {
        m.value = G instanceof Xa ? n("e2e.fxe.upload_too_big") : j(G), e.emitError(j(G), "fxe-encrypt");
      } finally {
        p.value = !1, v.value = null;
      }
    }
  }
  function Y(ne, ge) {
    x.value = ne, w.value = ge, k.value = null, C.value = !1, b.value = null, T.value = !0, E.value = "off", R.value = null, a.has(ne.path) || B(ne);
  }
  async function B(ne) {
    var ge, G, ye;
    try {
      const { header: te, body: Ce } = await q(ne.path);
      if (await Ce.cancel().catch(() => {
      }), ((ge = x.value) == null ? void 0 : ge.path) !== ne.path) return;
      T.value = E0(te), E.value = Jx(Jg(te), ((G = e.escrowKid) == null ? void 0 : G.call(e)) ?? null), R.value = ((ye = te.esc) == null ? void 0 : ye.kid) ?? null;
    } catch {
    }
  }
  async function W(ne, ge) {
    const G = await t.e2eEscrowChallenge(ne), ye = new Uint8Array(
      await crypto.subtle.decrypt({ name: "RSA-OAEP" }, ge, ea(G.challenge).buffer)
    );
    await t.e2eEscrowUsed({ path: ne, id: G.id, nonce: Ma(ye) });
  }
  function F() {
    $.value || (x.value = null, C.value = !1);
  }
  async function V(ne) {
    const ge = a.get(ne.path);
    if (!ge) {
      Y(ne, "open");
      return;
    }
    try {
      await kt(ne, ge);
    } catch (G) {
      at(ne, G, "fxe-open");
    }
  }
  async function ke(ne) {
    if (await St(ne)) return;
    const ge = a.get(ne.path);
    if (!ge) {
      Y(ne, "download");
      return;
    }
    try {
      await pt(ne, ge);
    } catch (G) {
      if (G instanceof Uf) {
        Y(ne, "download"), C.value = !0;
        return;
      }
      at(ne, G, "fxe-download");
    }
  }
  function qe(ne) {
    Y(ne, "remove");
  }
  function Me(ne) {
    return `"${ne.replace(/(["\\$`])/g, "\\$1")}"`;
  }
  function Fe(ne, ge, G) {
    var te;
    const ye = pl(ne.path);
    H.value = {
      name: ((te = a.get(ne.path)) == null ? void 0 : te.name) ?? ne.basename,
      size: ge,
      limit: G,
      encrypted: { kind: "file", path: ne.path },
      command: `filex decrypt ${Me(ye)}`
    };
  }
  function We(ne, ge, G, ye) {
    const te = pl(ge) || "filex";
    H.value = {
      name: ne,
      size: G,
      limit: ye,
      encrypted: { kind: "folder", path: ge },
      command: `filex decrypt ${Me(`${te}.zip`)}`
    };
  }
  function $t() {
    H.value = null;
  }
  async function St(ne) {
    var ye;
    if (Pne()) return !1;
    const ge = (ye = a.get(ne.path)) == null ? void 0 : ye.header.size;
    let G = typeof ge == "number" ? ge : null;
    if (G === null) {
      if (typeof ne.size != "number" || ne.size <= vi) return !1;
      try {
        const { header: te, body: Ce } = await q(ne.path);
        await Ce.cancel().catch(() => {
        }), G = te.size;
      } catch {
        return !1;
      }
    }
    return G <= vi ? !1 : (Fe(ne, G, vi), !0);
  }
  function at(ne, ge, G) {
    if (!(ge instanceof Qs)) {
      if (ge instanceof Xa) {
        Fe(ne, ge.size, ge.limit);
        return;
      }
      ge instanceof cn && (a.delete(ne.path), i.value++), e.emitError(j(ge), G), e.toast(re(ge), !0);
    }
  }
  async function kt(ne, ge) {
    const { header: G, body: ye } = await q(ne.path);
    if (!le(ge, G))
      throw await ye.cancel().catch(() => {
      }), new cn("e2e: the file changed since it was opened");
    if (G.size > vi)
      throw await ye.cancel().catch(() => {
      }), new Xa(G.size, vi);
    const te = ap(ge.name), Ce = await M0(hv(ge, ye), ge.name, il(te)), Ie = r.get(ne.path);
    Ie && URL.revokeObjectURL(Ie);
    const _e = URL.createObjectURL(Ce);
    r.set(ne.path, _e), e.openPreview(
      { ...ne, basename: ge.name, extension: te, mime_type: il(te), size: G.size, fxe_name: ge.name },
      _e
    );
  }
  async function pt(ne, ge, G) {
    const ye = await mv(ge.name, ge.header.size);
    let te = !1;
    try {
      const { header: Ce, body: Ie } = await q(ne.path);
      if (!le(ge, Ce))
        throw await Ie.cancel().catch(() => {
        }), new cn("e2e: the file changed since it was opened");
      te = !0, await ye.write(hv(ge, Ie), { mime: il(ap(ge.name)) }), e.toast(n("e2e.fxe.downloaded", { name: ge.name }));
    } catch (Ce) {
      throw te || await ye.discard(), Ce;
    }
  }
  async function Ne(ne, ge) {
    const G = Ia(ne.path), { header: ye, body: te } = await q(ne.path);
    if (!le(ge, ye))
      throw await te.cancel().catch(() => {
      }), new cn("e2e: the file changed since it was opened");
    const Ce = K(ge.name, await P(G));
    b.value = 0, await N(G, Ce, hv(ge, te), ye.size, (Ie) => {
      b.value = ye.size > 0 ? Math.min(100, Math.round(Ie / ye.size * 100)) : 100;
    }), await J(ne.path), a.delete(ne.path), i.value++, e.toast(n("e2e.fxe.removed", { name: Ce })), await e.reload();
  }
  async function ie(ne = {}) {
    const ge = x.value;
    if (!(!ge || $.value)) {
      $.value = !0, k.value = null;
      try {
        let G = a.get(ge.path);
        if (!G || ne.password || ne.recoveryKey || ne.escrowKey) {
          let ye;
          if (ne.escrowKey)
            try {
              ye = { escrowKey: await Wx(ne.escrowKey) };
            } catch {
              k.value = n("e2e.recover.bad_escrow_key");
              return;
            }
          else ne.recoveryKey ? ye = { recoveryKey: ne.recoveryKey } : ye = { password: ne.password ?? "" };
          const { header: te, unsupported: Ce, body: Ie } = await q(ge.path);
          if (await Ie.cancel().catch(() => {
          }), T.value = E0(te), Ce.length > 0) {
            k.value = n("e2e.fxe.unsupported", { features: Ce.join(", ") });
            return;
          }
          const _e = await Ane(te, ye);
          if ("error" in _e) {
            k.value = _e.error === "damaged" ? n("e2e.fxe.damaged") : "escrowKey" in ye ? n("e2e.fxe.wrong_escrow") : "recoveryKey" in ye ? n("e2e.fxe.wrong_recovery") : n("e2e.fxe.wrong_password");
            return;
          }
          if ("escrowKey" in ye) {
            try {
              await W(ge.path, ye.escrowKey);
            } catch (Ae) {
              k.value = n("e2e.fxe.escrow_notify_failed"), e.emitError(j(Ae), "fxe-escrow-notify");
              return;
            }
            e.toast(n("e2e.fxe.escrow_done"));
          }
          G = _e.key, a.set(ge.path, G), i.value++;
        }
        if (w.value === "open")
          await kt(ge, G), x.value = null;
        else if (w.value === "download") {
          try {
            await pt(ge, G);
          } catch (ye) {
            if (ye instanceof Uf) {
              C.value = !0;
              return;
            }
            throw ye;
          }
          x.value = null, C.value = !1;
        } else
          await Ne(ge, G), x.value = null;
      } catch (G) {
        if (G instanceof Qs) return;
        if (G instanceof Xa && w.value === "download") {
          x.value = null, Fe(ge, G.size, G.limit);
          return;
        }
        k.value = G instanceof Xa ? n("e2e.dl.too_big", { size: Ve(G.size), limit: Ve(G.limit) }) : re(G), G instanceof cn && (a.delete(ge.path), i.value++), e.emitError(j(G), `fxe-${w.value}`);
      } finally {
        $.value = !1, b.value = null;
      }
    }
  }
  function xe(ne) {
    z.value = ne, U.value = null;
  }
  function he() {
    D.value || (z.value = null);
  }
  async function De(ne) {
    const ge = z.value;
    if (!ge || D.value) return;
    if (!ne.proof) {
      U.value = n("e2e.password.current_required");
      return;
    }
    D.value = !0, U.value = null;
    const G = "recoveryKey" in ne.proof ? "recovery_key" : "password";
    try {
      const { header: ye, unsupported: te, body: Ce } = await q(ge.path);
      if (te.length > 0) {
        await Ce.cancel().catch(() => {
        }), U.value = n("e2e.fxe.unsupported", { features: te.join(", ") });
        return;
      }
      let Ie;
      try {
        Ie = await zne(ye, ne.proof, ne.newPassword);
      } catch (Pe) {
        if (await Ce.cancel().catch(() => {
        }), Pe instanceof cn) {
          U.value = n(G === "recovery_key" ? "e2e.password.wrong_recovery" : "e2e.password.wrong_current");
          return;
        }
        throw Pe;
      }
      const _e = Mne(Ie, Ce);
      await N(Ia(ge.path), pl(ge.path), _e.stream, _e.size);
      const Ae = a.get(ge.path);
      Ae && a.set(ge.path, Ene(Ae, Ie)), i.value++, z.value = null, e.toast(n("e2e.fxe.password_done")), await e.reload();
    } catch (ye) {
      U.value = n("e2e.password.failed"), e.emitError(j(ye), "fxe-password");
    } finally {
      D.value = !1;
    }
  }
  async function ot(ne, ge, G, ye) {
    const te = (Ie) => {
      ye ? We(ne.basename, ye, Ie.size, Ie.limit) : e.toast(n("e2e.dl.too_big", { size: Ve(Ie.size), limit: Ve(Ie.limit) }), !0);
    };
    let Ce;
    try {
      Ce = await mv(ne.basename, ne.size);
    } catch (Ie) {
      Ie instanceof Xa ? te(Ie) : at(ne, Ie, "e2e-download");
      return;
    }
    try {
      const Ie = Yv(ge, G, await L(ne.path), { passPlain: !0 });
      await Ce.write(Ie, { mime: il(ne.extension) });
    } catch (Ie) {
      if (await Ce.discard(), Ie instanceof Qs) return;
      if (Ie instanceof Xa) {
        te(Ie);
        return;
      }
      e.emitError(j(Ie), "e2e-download"), e.toast(n("e2e.download.failed"), !0);
    }
  }
  async function ft(ne, ge) {
    let G;
    try {
      G = await mv(ge.zipName);
    } catch (Ae) {
      if (Ae instanceof Qs) return;
      if (Ae instanceof Uf) {
        e.toast(n("e2e.dl.click_again"), !0);
        return;
      }
      throw Ae;
    }
    let ye = 0;
    const te = (Ae, Pe) => ({
      name: Pe,
      sizeHint: typeof Ae.size == "number" ? Ae.size : void 0,
      mtime: typeof Ae.last_modified == "number" ? new Date(Ae.last_modified) : void 0,
      data: async () => Yv(ge.fmk, ge.previous, await L(Ae.path), {
        passPlain: !0,
        onPlain: () => ye++
      })
    }), Ce = (Ae) => (Ae.e2e_name_state === "locked" || Ae.e2e_name_state === "unreadable") && typeof Ae.e2e_stored == "string" ? Ae.e2e_stored : Ae.basename;
    async function* Ie(Ae, Pe) {
      yield { name: `${Pe}/` };
      const _t = await t.index(Ae.path), Et = await ge.decorate(_t.files ?? [], { root: ge.root }), xn = /* @__PURE__ */ new Set();
      for (const Dt of Et) {
        if (Dt.basename === ga || typeof Dt.e2e_stored != "string" && Dt.basename === ga) continue;
        const bn = K(Ce(Dt), xn);
        xn.add(bn), Dt.type === "dir" ? yield* Ie(Dt, `${Pe}/${bn}`) : yield te(Dt, `${Pe}/${bn}`);
      }
    }
    async function* _e() {
      const Ae = /* @__PURE__ */ new Set();
      for (const Pe of ne) {
        const _t = K(Ce(Pe), Ae);
        Ae.add(_t), Pe.type === "dir" ? yield* Ie(Pe, _t) : yield te(Pe, _t);
      }
    }
    e.toast(n("e2e.dl.zip_started", { name: ge.zipName }));
    try {
      await G.write(Wne(_e()), { mime: "application/zip" }), e.toast(
        ye > 0 ? n("e2e.dl.zip_done_plain", { name: ge.zipName, n: ye }) : n("e2e.dl.zip_done", { name: ge.zipName })
      );
    } catch (Ae) {
      if (await G.discard(), Ae instanceof Qs) return;
      if (Ae instanceof Xa) {
        We(ge.zipName, ge.root, null, Ae.limit);
        return;
      }
      e.emitError(j(Ae), "e2e-download-zip"), e.toast(Ae instanceof cn ? n("e2e.dl.zip_damaged") : n("e2e.download.failed"), !0);
    }
  }
  async function gt(ne, ge) {
    const G = await I_(ge, ne.size, ne.stream());
    return z0(G.stream, G.size);
  }
  async function Ut(ne, ge, G, ye = {}) {
    const te = ne.size;
    if (typeof te != "number" || !Number.isSafeInteger(te) || te < 0)
      throw new Error("e2e: unknown file size");
    const Ce = await I_(ge, te, await L(ne.path)), Ie = ye.onProgress ? (_e) => ye.onProgress(Ce.size > 0 ? Math.min(1, _e / Ce.size) : 1) : void 0;
    try {
      await N(Ia(ne.path), ne.basename, Ce.stream, Ce.size, Ie, {
        fields: { e2e_convert: "1", ...G ? { expect: G } : {} },
        signal: ye.signal
      });
    } catch (_e) {
      if (_e instanceof Xa) return !1;
      throw _e;
    }
    return !0;
  }
  async function Xe(ne, ge, G) {
    const ye = new Lp(await L(ne.path)), te = await ye.read(a4);
    if (!Tl(te))
      return await ye.cancel().catch(() => {
      }), !1;
    const Ce = await lS(te.buffer, ge, G);
    if (!Ce)
      return await ye.cancel().catch(() => {
      }), !0;
    const Ie = typeof ne.size == "number" ? ne.size : NaN;
    if (!Number.isSafeInteger(Ie))
      throw await ye.cancel().catch(() => {
      }), new Error("e2e: unknown file size");
    const _e = typeof ne.e2e_stored == "string" ? ne.e2e_stored : ne.basename;
    return await N(Ia(ne.path), _e, Fc(new Uint8Array(Ce), ye.rest()), Ie), !0;
  }
  const { formatSize: Ve } = ht(() => e.locale() ?? "en");
  async function Be(ne, ge, G) {
    var te;
    const ye = ge[0];
    switch (ne) {
      case "fxe-encrypt":
        return ye && se(ye), !0;
      case "fxe-request":
        return ye && ((te = e.requestEncrypt) == null || te.call(e, ye)), !0;
      case "fxe-download-raw":
        return ye && window.open(t.downloadUrl(ye.path), "_blank"), !0;
      case "fxe-password":
        return ye && xe(ye), !0;
      case "fxe-remove":
        return ye && qe(ye), !0;
      case "e2e-download-encrypted":
        return await G(ge), !0;
    }
    return !1;
  }
  return {
    ringVer: i,
    realName: ve,
    isHiddenFxeName: wne,
    menuRows: ce,
    dispatch: Be,
    // encrypt
    encryptTarget: c,
    encryptBusy: p,
    encryptError: m,
    encryptProgress: v,
    startEncrypt: se,
    closeEncrypt: fe,
    submitEncrypt: ee,
    // open / download / remove
    unlockTarget: x,
    unlockIntent: w,
    unlockBusy: $,
    unlockError: k,
    unlockProgress: b,
    unlockNeedsSave: C,
    unlockHasRecovery: T,
    unlockEscrow: E,
    unlockEscrowKid: R,
    open: V,
    download: ke,
    startRemove: qe,
    closeUnlock: F,
    submitUnlock: ie,
    // password
    pwTarget: z,
    pwBusy: D,
    pwError: U,
    // too big for this browser
    tooBig: H,
    closeTooBig: $t,
    startPassword: xe,
    closePassword: he,
    submitPassword: De,
    // encrypted folders
    downloadFolderFile: ot,
    downloadDecryptedZip: ft,
    folderUploadSource: gt,
    convertLarge: Ut,
    rewrapLarge: Xe,
    revokeAll: l
  };
}
function Zne(e, t) {
  const n = String(t ?? "").replace(/\/+$/, "");
  return n === e ? "" : n.slice(e.length + 1);
}
function Qne(e) {
  const t = new Set(eae()), n = c2({}), a = S(0);
  let i = null, r = null;
  function l(b) {
    t.has(b) || (t.add(b), P0([...t]));
  }
  function c(b) {
    t.delete(b) && P0([...t]);
  }
  function p(b) {
    const C = String(b ?? "").replace(/\/+$/, "");
    let T = null;
    for (const E of [...(i == null ? void 0 : i.openRoots()) ?? [], ...t])
      (C === E || C.startsWith(E + "/")) && (!T || E.length > T.length) && (T = E);
    return T;
  }
  function m() {
    return [.../* @__PURE__ */ new Set([...(i == null ? void 0 : i.openRoots()) ?? [], ...t])];
  }
  const v = { strips: n, version: a, rootOf: p, remember: l };
  function x() {
    return i ? Promise.resolve(i) : (r || (r = import("./e2eVaultEngine-C6xCWX1k.js").then(
      (b) => i = b.createVaultEngine(e, v),
      (b) => {
        throw r = null, b;
      }
    )), r);
  }
  function w(b) {
    return !!b && typeof b.vault_root == "string" && !!b.vault_root;
  }
  function $(b) {
    if (i) {
      i.lock(b);
      return;
    }
    e.dropKeys(b), e.onLocked(b, "manual");
  }
  function k() {
    i == null || i.onPageHide();
  }
  return {
    version: a,
    strips: n,
    rootOf: p,
    roots: m,
    isVaultRow: w,
    forget: c,
    relOf: Zne,
    isOpen: (b) => !!(i != null && i.isOpen(b)),
    permOf: (b) => i == null ? void 0 : i.permOf(b),
    node: (...b) => (i == null ? void 0 : i.node(...b)) ?? null,
    rows: (...b) => (i == null ? void 0 : i.rows(...b)) ?? null,
    search: (...b) => (i == null ? void 0 : i.search(...b)) ?? null,
    close: (...b) => i == null ? void 0 : i.close(...b),
    closeAll: (...b) => i == null ? void 0 : i.closeAll(...b),
    touch: (...b) => i == null ? void 0 : i.touch(...b),
    onVisible: () => i == null ? void 0 : i.onVisible(),
    onEvent: (...b) => i == null ? void 0 : i.onEvent(...b),
    dismiss: (...b) => i == null ? void 0 : i.dismiss(...b),
    lock: $,
    onPageHide: k,
    open: async (...b) => (await x()).open(...b),
    create: async (...b) => (await x()).create(...b),
    readBytes: async (...b) => (await x()).readBytes(...b),
    readUrl: async (...b) => (await x()).readUrl(...b),
    /** filex 0.56 (#189): an app's interface reads / saves a file of an open
     *  vault (lib/appPlaintext createAppVaultDoor). No engine: no vault is
     *  open, so nothing is loaded for it. */
    readForApp: async (...b) => i ? i.readForApp(...b) : { ok: !1, why: "locked" },
    saveForApp: async (...b) => i ? i.saveForApp(...b) : { ok: !1, why: "locked" },
    keyForApp: (...b) => (i == null ? void 0 : i.keyForApp(...b)) ?? null,
    download: async (...b) => (await x()).download(...b),
    upload: async (...b) => (await x()).upload(...b),
    mkdir: async (...b) => (await x()).mkdir(...b),
    rename: async (...b) => (await x()).rename(...b),
    move: async (...b) => (await x()).move(...b),
    copy: async (...b) => (await x()).copy(...b),
    remove: async (...b) => (await x()).remove(...b),
    takeOver: async (...b) => (await x()).takeOver(...b),
    continueFromShown: async (...b) => (await x()).continueFromShown(...b),
    /** The person's idle time (minutes, 1-10), kept on the server. */
    idlePrefs: {
      get: async () => (await x()).idlePrefs.get(),
      set: async (b) => (await x()).idlePrefs.set(b)
    }
  };
}
const VT = "filex.e2e.vaults", jT = 200;
function eae() {
  try {
    const e = typeof localStorage > "u" ? null : localStorage.getItem(VT), t = e ? JSON.parse(e) : [];
    return Array.isArray(t) ? t.filter((n) => typeof n == "string" && n.includes("://")).slice(-jT) : [];
  } catch {
    return [];
  }
}
function P0(e) {
  try {
    typeof localStorage < "u" && localStorage.setItem(VT, JSON.stringify(e.slice(-jT)));
  } catch {
  }
}
const tae = {
  class: "fe-e2e-names__hint",
  "data-testid": "e2e-request-lead"
}, nae = { class: "fe-field" }, aae = { class: "fe-field__label" }, iae = ["placeholder", "disabled"], oae = {
  key: 0,
  class: "fe-form__error",
  role: "alert",
  "data-testid": "e2e-request-error"
}, rae = ["disabled"], sae = ["disabled", "aria-busy"], lae = /* @__PURE__ */ lt({
  __name: "E2eRequestModal",
  props: {
    open: { type: Boolean },
    locale: {},
    api: {},
    path: {},
    kind: {},
    name: {}
  },
  emits: ["close", "sent"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = A(
      () => n.kind === "file" ? i("e2e.request.lead_file") : n.kind === "folder" ? i("e2e.request.lead_folder") : i("e2e.request.lead")
    ), l = A(() => Pc("e2e_request_reason_max_runes")), c = S("");
    Je(c, (x) => {
      const w = zy(x, l.value);
      w !== x && (c.value = w);
    });
    const p = S(!1), m = S(null);
    Je(
      () => n.open,
      (x) => {
        x && (c.value = "", m.value = null);
      }
    );
    async function v() {
      if (p.value) return;
      const x = c.value.trim();
      if (!x) {
        m.value = i("e2e.request.reason_required");
        return;
      }
      p.value = !0, m.value = null;
      try {
        const w = await n.api.e2eRequest({ path: n.path, kind: n.kind, reason: x });
        a("sent", w);
      } catch (w) {
        m.value = P2(w, i("e2e.request.failed"), { t: i }).text;
      } finally {
        p.value = !1;
      }
    }
    return (x, w) => (f(), Ge(ta, {
      open: e.open,
      locale: e.locale,
      title: u(i)("e2e.request.title", { name: e.name }),
      size: "sm",
      busy: p.value,
      onClose: w[2] || (w[2] = ($) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          disabled: p.value,
          onClick: w[1] || (w[1] = ($) => a("close"))
        }, y(u(i)("modal.newfolder.cancel")), 9, rae),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: p.value,
          "aria-busy": p.value ? "true" : void 0,
          "data-testid": "e2e-request-send",
          onClick: v
        }, y(p.value ? u(i)("e2e.request.sending") : u(i)("e2e.request.send")), 9, sae)
      ]),
      default: mt(() => [
        d("form", {
          class: "fe-e2e-form",
          "data-testid": "e2e-request",
          onSubmit: yt(v, ["prevent"])
        }, [
          d("p", tae, y(r.value), 1),
          d("label", nae, [
            d("span", aae, y(u(i)("e2e.request.reason")), 1),
            dn(d("textarea", {
              "onUpdate:modelValue": w[0] || (w[0] = ($) => c.value = $),
              class: "fe-input",
              rows: "4",
              placeholder: u(i)("e2e.request.reason_placeholder"),
              disabled: p.value,
              "data-testid": "e2e-request-reason"
            }, null, 8, iae), [
              [_n, c.value]
            ])
          ]),
          m.value ? (f(), h("p", oae, y(m.value), 1)) : O("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "locale", "title", "busy"]));
  }
}), uae = /* @__PURE__ */ new Set(["none", "viewer", "editor", "owner"]);
function O0(e) {
  if (typeof e != "string" || !e) return;
  const t = Date.parse(e);
  return Number.isFinite(t) ? t : void 0;
}
function cae(e, t) {
  var $;
  const n = String((e == null ? void 0 : e.path) ?? "").replace(/^\/+/, "");
  if (!n) return null;
  const a = t.storages ?? [], i = typeof e.storage == "string" && e.storage ? e.storage : a.length === 1 ? a[0].name : "";
  if (t.multiStorageRoot && !i) return null;
  const r = String(e.name ?? n.split("/").pop() ?? ""), l = e.type === "dir", c = e.type === "symlink", p = typeof e.size == "number" ? e.size : 0, m = typeof e.id == "number" ? e.id : void 0, v = typeof e.perm == "string" && uae.has(e.perm) ? e.perm : void 0, x = (($ = a.find((k) => k.name === i)) == null ? void 0 : $.readOnly) === !0, w = typeof e.read_only == "boolean" ? e.read_only : x;
  return {
    type: l ? "dir" : "file",
    id: m,
    /* tablo:t1 — ⚠⚠ THE DATE. A node row carries `backend_mtime` (what the
       storage says) and `db_mtime` (what our last scan recorded) as RFC3339
       strings; `FileNode.last_modified` is unix MILLISECONDS. Nothing mapped
       between the two, so every row from Recent, Starred and a tag view
       arrived with no date at all — measured on Recent: eleven rows, eleven em
       dashes in the Modified column, and a Modified column header you could
       click that then sorted nothing. It also made the date grouping this view
       is supposed to show impossible, because every row fell in the "No date"
       bucket. Storage first: `backend_mtime` is the file's own truth and
       `db_mtime` only says when we last looked at it. */
    last_modified: O0(e.backend_mtime) ?? O0(e.db_mtime),
    path: i ? `${i}://${n}` : n,
    basename: r,
    extension: l ? "" : r.includes(".") ? (r.split(".").pop() || "").toLowerCase() : "",
    storage: i,
    visibility: "private",
    size: p,
    file_size: p,
    mime_type: typeof e.mime == "string" ? e.mime : "",
    ...v ? { perm: v } : {},
    read_only: w,
    /* #207 (0.54) — whether the row is starred is the row's own fact: the
       server puts `starred: true` on every listing and view row it answers
       (handlers/meta.go), and the explorer no longer fetches a star list of
       its own to match ids against. Dropped here, every Starred / Recent /
       tag / Home row read as unstarred, so the menu offered "Star" on a file
       in Starred and the inline star was hollow. */
    ...e.starred === !0 ? { starred: !0 } : {},
    /* ...and WHY it will not open, under the folder listing's own name: the
       node row carries the reason the sync recorded (`link_state`, migration
       00098), so the badge here says "Outside storage" exactly where the
       folder says it. A row without one reads as the general "Link". */
    ...c ? {
      symlink: !0,
      ...typeof e.link_state == "string" && e.link_state ? { link_state: e.link_state } : {}
    } : {},
    /* issue #104 - an entry the storage could not answer for. The raw node
       row carries the flag and the storage's answer under the same names the
       folder listing uses, so Recent, Starred, a tag view and Home badge it
       and refuse it exactly as the folder does (lib/unavailable). */
    ...e.unavailable === !0 ? {
      unavailable: !0,
      ...typeof e.unavailable_reason == "string" ? { unavailable_reason: e.unavailable_reason } : {}
    } : {},
    // ⚠⚠ The SERVER's `thumb_url`, never one built here. It used to be
    // `/api/files/thumb/<id>` for every file, and the endpoint answers
    // `404 "not ready"` for everything it has not rendered — a docx, a
    // markdown note, a diagram: opening Recent with ten such files fired ten
    // requests and all ten 404'd (2026-09-21). The rows now carry the URL
    // exactly when there is an image behind it (handlers/meta.go, the folder
    // listing's rule), so a file with none is never asked about.
    thumb_url: !l && typeof e.thumb_url == "string" && e.thumb_url ? e.thumb_url : void 0,
    /* wiring:e2 names — the encrypted folder the row sits in (the server
       answers it for rows outside a folder listing). The explorer's name view
       reads it to name the row, and openNode to open it in its folder. */
    ...typeof e.e2e_root == "string" && e.e2e_root ? { e2e_root: e.e2e_root } : {},
    /* #189 - how the file is end-to-end encrypted, as the SERVER stamps the
       row (`folder` / `vault` / `file`, handlers/meta.go, the folder
       listing's rule). An app's interface opened from Recent, Starred, a tag
       view or Home is handed it as is (FileInfo.encrypted); dropped here, it
       was told an encrypted file is not. */
    ...Qu(e.encrypted) ? { encrypted: e.encrypted } : {},
    extra_metadata: {}
  };
}
const dae = /* @__PURE__ */ new Set(["none", "viewer", "editor", "owner"]);
function fae(e) {
  return typeof e == "string" && dae.has(e);
}
function pae(e, t) {
  return fae(t) ? e.map((n) => typeof n.perm == "string" ? n : { ...n, perm: t }) : e;
}
function hae(e, t) {
  if (!e)
    return t || void 0;
}
function yv(e, t) {
  return e.openInHost && t.type === "file" ? "host" : "page";
}
class qT extends Error {
}
const mae = 1500;
function WT(e) {
  try {
    const t = JSON.parse(e);
    return t && typeof t == "object" ? t : {};
  } catch {
    return {};
  }
}
async function vae(e) {
  return WT(await e.text().catch(() => ""));
}
async function yae(e, t = mae) {
  var c, p, m, v;
  const n = e.sleep ?? ((x) => new Promise((w) => setTimeout(w, x))), a = await e.start(), i = await a.text().catch(() => ""), r = WT(i);
  let l;
  if (a.status === 409 && r.code === "BUSY") {
    const x = r.job;
    if (!(x != null && x.running))
      throw new qT(typeof r.message == "string" && r.message ? r.message : String(r.error ?? "busy"));
    (c = e.onBusy) == null || c.call(e, typeof r.message == "string" ? r.message : ""), l = x;
  } else if (a.ok)
    l = r;
  else
    throw fa(a.status, i, e.locale);
  for ((p = e.onStart) == null || p.call(e, l); l.running; ) {
    if ((m = e.onProgress) == null || m.call(e, l), await n(t), (v = e.stopped) != null && v.call(e)) return null;
    try {
      const x = await e.status(), w = x.ok ? await vae(x) : {};
      typeof w.running == "boolean" && (l = w);
    } catch {
    }
  }
  return l;
}
function L0(e) {
  const t = String(e ?? "").indexOf("://");
  return t === -1 ? "" : e.slice(0, t);
}
function D0(e, t, n = "auto") {
  const a = L0(t), i = e.some((r) => {
    const l = L0(r);
    return l !== "" && a !== "" && l !== a;
  });
  return n === "copy" ? { kind: "copy", cross: i } : n === "move" ? { kind: "move", cross: i } : { kind: i ? "copy" : "move", cross: i };
}
function YT(e) {
  return e.split("?")[0].replace(/\/manager$/, "/archive/download");
}
const R0 = "/api/files/manager";
function GT(e, t) {
  if (/^https?:\/\//i.test(t)) return t;
  const n = e.split("?")[0];
  if (n.endsWith(R0)) return Cy(n.slice(0, -R0.length), t);
  const a = /^(https?:\/\/[^/]+)/i.exec(n);
  return a ? a[1] + t : t;
}
async function gae(e, t, n) {
  const a = YT(e.endpoints.manager);
  return e.jsonFetch(a, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(n ? { paths: t, name: n } : { paths: t })
  });
}
async function bae(e, t) {
  const n = await e.jsonFetch(
    YT(e.endpoints.manager),
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ paths: [t], mode: "file" })
    }
  );
  if (!n || n.mode !== "file" || typeof n.url != "string") return null;
  const a = Number(n.ttl_seconds);
  return {
    url: GT(e.endpoints.manager, n.url),
    ttlMs: Number.isFinite(a) && a > 0 ? a * 1e3 : 6e4
  };
}
const kae = 6e4;
function wae(e, t = document) {
  const n = t.createElement("iframe");
  n.hidden = !0, n.setAttribute("aria-hidden", "true"), n.style.display = "none", n.src = e, t.body.appendChild(n), setTimeout(() => n.remove(), kae);
}
async function _ae(e, t, n = {}) {
  const a = await gae(e, t, n.name);
  return wae(
    GT(e.endpoints.manager, a.url),
    n.doc ?? document
  ), a;
}
function XT(e) {
  return String(e.path ?? "").replace(/^\/+|\/+$/g, "");
}
function Sy(e, t) {
  return typeof e.storage == "string" && e.storage ? e.storage : typeof e.storage_name == "string" && e.storage_name ? e.storage_name : t.configured.length === 1 && t.configured[0] ? t.configured[0] : t.current || "";
}
function Kf(e, t) {
  const n = String(e.path ?? "").replace(/^\/+/, ""), a = typeof e.storage == "string" && e.storage ? e.storage : t, i = String(e.name ?? n.split("/").pop() ?? ""), r = i.lastIndexOf("."), l = typeof e.backend_mtime == "string" ? e.backend_mtime : e.updated_at, c = typeof l == "string" ? Date.parse(l) : NaN;
  return {
    id: typeof e.id == "number" ? e.id : void 0,
    path: a ? `${a}://${n}` : n,
    basename: i,
    relativePath: n,
    type: e.type === "dir" ? "dir" : "file",
    extension: r > 0 ? i.slice(r + 1).toLowerCase() : "",
    size: typeof e.size == "number" ? e.size : 0,
    // ⚠ Left UNSET when the row carries no parseable timestamp rather than
    // defaulted to 0 or to now: `matchesModified` treats a missing timestamp
    // as "unknown" and drops the row from a date filter, which is the honest
    // answer. Stamping it with `Date.now()` would file every such file under
    // "Today".
    last_modified: Number.isNaN(c) ? void 0 : c,
    mime_type: typeof e.mime == "string" ? e.mime : "",
    /* The content snippet the hit came with, so a content match can show why
       it matched. Undefined on name-only hits, exactly as the backend sends. */
    snippet: typeof e.snippet == "string" && e.snippet ? e.snippet : void 0,
    /* Owner, so the People filter and the Owner column mean the same thing in a
       content result as they do in a folder listing. Undefined rather than
       guessed when the backend does not send it. */
    owner_id: typeof e.owner_id == "number" ? e.owner_id : void 0,
    owner_name: typeof e.owner_name == "string" ? e.owner_name : void 0,
    owner_self: e.owner_self === !0 ? !0 : void 0,
    /* wiring:e2 names — the encrypted folder the hit sits in (the server
       answers it); the explorer's name view reads it. */
    ...typeof e.e2e_root == "string" && e.e2e_root ? { e2e_root: e.e2e_root } : {},
    /* #189 - how the hit is end-to-end encrypted, as the server stamps it
       (`folder` / `vault` / `file`); an app's interface opened from a
       search result is handed it as is (FileInfo.encrypted). */
    ...Qu(e.encrypted) ? { encrypted: e.encrypted } : {}
  };
}
function xae(e, t) {
  const n = Sy(e, t);
  if (!XT(e) || !n) return null;
  const a = Kf(e, n);
  return {
    path: a.path,
    basename: a.basename,
    type: a.type,
    ...a.e2e_root ? { e2e_root: a.e2e_root } : {},
    ...a.encrypted ? { encrypted: a.encrypted } : {}
  };
}
function mhe(e, t) {
  var i;
  const n = [], a = /* @__PURE__ */ new Map();
  for (const r of e) {
    const l = ((i = r.account) == null ? void 0 : i.id) ?? "";
    let c = a.get(l);
    c || (c = { account: r.account, hits: [] }, a.set(l, c), n.push(c)), c.hits.length < t && c.hits.push(r);
  }
  return n;
}
function Sae(e) {
  if (!e) return [];
  const t = e.items;
  if (t && t.length > 0) {
    const n = [];
    let a = !1;
    for (let i = 0; i < t.length; i++) {
      const r = t[i];
      if (!r || r.kind !== "file") continue;
      a = !0;
      const l = r.webkitGetAsEntry ?? r.getAsEntry, c = typeof l == "function" ? l.call(r) : null;
      if (c && c.isDirectory) {
        n.push({ kind: "entry", entry: c });
        continue;
      }
      const p = r.getAsFile();
      p ? n.push({ kind: "file", file: p }) : c && c.isFile && n.push({ kind: "entry", entry: c });
    }
    if (a) return n;
  }
  return Array.from(e.files ?? []).map((n) => ({ kind: "file", file: n }));
}
function $ae(e) {
  return new Promise((t, n) => {
    if (typeof e.file != "function") {
      n(new Error("not a file entry"));
      return;
    }
    e.file(t, n);
  });
}
async function Tae(e) {
  if (typeof e.createReader != "function") throw new Error("not a folder entry");
  const t = e.createReader(), n = [];
  for (; ; ) {
    const a = await new Promise((i, r) => t.readEntries(i, r));
    if (a.length === 0) return n;
    n.push(...a);
  }
}
function Aae(e, t) {
  return e ? `${e}/${t}` : t;
}
async function Eae(e) {
  const t = { dirs: [], files: [], unreadable: [] }, n = async (a, i) => {
    const r = Aae(i, a.name);
    if (a.isDirectory) {
      let l;
      try {
        l = await Tae(a);
      } catch {
        t.unreadable.push(r);
        return;
      }
      t.dirs.push(r);
      for (const c of l) await n(c, r);
      return;
    }
    if (a.isFile)
      try {
        t.files.push({ file: await $ae(a), dir: i });
      } catch {
        t.unreadable.push(r);
      }
  };
  for (const a of e)
    a.kind === "file" ? t.files.push({ file: a.file, dir: "" }) : await n(a.entry, "");
  return t;
}
function Cae(e) {
  const t = /* @__PURE__ */ new Set();
  for (const { dir: n } of e.files)
    for (let a = n; a; a = a.includes("/") ? a.slice(0, a.lastIndexOf("/")) : "") t.add(a);
  return e.dirs.filter((n) => !t.has(n));
}
async function zae(e, t, n) {
  const a = /* @__PURE__ */ new Map([["", t]]);
  for (const r of e.dirs) {
    const l = r.lastIndexOf("/"), c = a.get(l === -1 ? "" : r.slice(0, l));
    if (c !== void 0)
      try {
        a.set(r, await n.mkdir(c, r.slice(l + 1)));
      } catch (p) {
        n.failed(r, p);
      }
  }
  const i = /* @__PURE__ */ new Map();
  for (const { file: r, dir: l } of e.files) {
    const c = i.get(l);
    c ? c.push(r) : i.set(l, [r]);
  }
  for (const [r, l] of i) {
    const c = a.get(r);
    if (c !== void 0)
      try {
        await n.upload(l, c);
      } catch (p) {
        n.failed(r || l[0].name, p);
      }
  }
}
function Mae(e, t) {
  return Object.defineProperty(e, "webkitRelativePath", { value: t, configurable: !0 }), e;
}
const Pae = { class: "fe-field" }, Oae = { class: "fe-field__label" }, Lae = ["onKeydown"], Dae = {
  key: 0,
  class: "fe-form__error",
  role: "alert"
}, Rae = ["innerHTML"], Nae = ["innerHTML"], Iae = ["disabled"], Bae = ["disabled", "aria-busy"], Fae = /* @__PURE__ */ lt({
  __name: "NewFolderModal",
  props: {
    open: { type: Boolean },
    locale: {},
    encryptedOption: { type: Boolean },
    encryptedRequest: { type: Boolean },
    error: {},
    busy: { type: Boolean }
  },
  emits: ["close", "submit", "encrypted", "request-encrypted"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = S(""), l = S(null);
    Je(() => n.open, (p) => {
      p && (r.value = "", l.value = null);
    }), Je(
      () => n.error,
      (p) => {
        p && (l.value = p);
      }
    );
    function c() {
      if (n.busy) return;
      const p = Ny(r.value), m = I2(p);
      if (m === "empty") {
        l.value = i("modal.newfolder.placeholder");
        return;
      }
      if (m) {
        l.value = i("modal.newfolder.invalid");
        return;
      }
      if (Ep(p)) {
        l.value = i("names.reserved", { name: p });
        return;
      }
      a("submit", p);
    }
    return (p, m) => (f(), Ge(ta, {
      open: e.open,
      title: u(i)("modal.newfolder.title"),
      size: "sm",
      busy: e.busy,
      onClose: m[4] || (m[4] = (v) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: m[3] || (m[3] = (v) => a("close"))
        }, y(u(i)("modal.newfolder.cancel")), 9, Iae),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy,
          "aria-busy": e.busy ? "true" : void 0,
          onClick: c
        }, y(e.busy ? u(i)("modal.newfolder.creating") : u(i)("modal.newfolder.create")), 9, Bae)
      ]),
      default: mt(() => [
        d("form", {
          onSubmit: yt(c, ["prevent"])
        }, [
          d("label", Pae, [
            d("span", Oae, y(u(i)("modal.newfolder.placeholder")), 1),
            dn(d("input", {
              "onUpdate:modelValue": m[0] || (m[0] = (v) => r.value = v),
              type: "text",
              class: "fe-input",
              autocomplete: "off",
              onKeydown: Ca(yt(c, ["prevent"]), ["enter"])
            }, null, 40, Lae), [
              [_n, r.value]
            ])
          ]),
          l.value ? (f(), h("p", Dae, y(l.value), 1)) : O("", !0),
          e.encryptedOption !== !1 ? (f(), h("button", {
            key: 1,
            type: "button",
            class: "fe-e2e-optlink",
            onClick: m[1] || (m[1] = (v) => a("encrypted"))
          }, [
            d("span", {
              class: "fe-e2e-optlink__icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("lock")
            }, null, 8, Rae),
            Ht(" " + y(u(i)("e2e.create.option")), 1)
          ])) : e.encryptedRequest ? (f(), h("button", {
            key: 2,
            type: "button",
            class: "fe-e2e-optlink",
            "data-testid": "e2e-request-option",
            onClick: m[2] || (m[2] = (v) => a("request-encrypted"))
          }, [
            d("span", {
              class: "fe-e2e-optlink__icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("lock")
            }, null, 8, Nae),
            Ht(" " + y(u(i)("e2e.request.option")), 1)
          ])) : O("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
}), Uae = { class: "fe-field__hint" }, Hae = { class: "fe-field" }, Kae = { class: "fe-field__label" }, Vae = ["disabled"], jae = {
  key: 0,
  class: "fe-form__error"
}, qae = ["disabled"], Wae = ["disabled", "aria-busy"], Yae = /* @__PURE__ */ lt({
  __name: "ArchiveExtractModal",
  props: {
    open: { type: Boolean },
    locale: {},
    archiveName: {},
    suggestedFolder: {},
    busy: { type: Boolean },
    error: {}
  },
  emits: ["close", "submit"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = S(""), l = S("");
    Je(() => n.open, (p) => {
      p && (r.value = n.suggestedFolder, l.value = "");
    });
    function c() {
      if (!n.busy) {
        if (!r.value.trim() || /[\\/]/.test(r.value)) {
          l.value = i("archive.invalid_folder");
          return;
        }
        a("submit", { folder: r.value.trim() });
      }
    }
    return (p, m) => (f(), Ge(ta, {
      open: e.open,
      title: u(i)("archive.extract_title"),
      size: "sm",
      busy: e.busy,
      onClose: m[2] || (m[2] = (v) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: m[1] || (m[1] = (v) => a("close"))
        }, y(u(i)("archive.cancel")), 9, qae),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy,
          "aria-busy": e.busy ? "true" : void 0,
          onClick: c
        }, y(e.busy ? u(i)("archive.extracting") : u(i)("archive.extract_to_folder")), 9, Wae)
      ]),
      default: mt(() => [
        d("form", {
          class: "fe-form",
          onSubmit: yt(c, ["prevent"])
        }, [
          d("p", Uae, y(e.archiveName), 1),
          d("label", Hae, [
            d("span", Kae, y(u(i)("archive.destination_folder")), 1),
            dn(d("input", {
              "onUpdate:modelValue": m[0] || (m[0] = (v) => r.value = v),
              class: "fe-input",
              autocomplete: "off",
              disabled: e.busy
            }, null, 8, Vae), [
              [_n, r.value]
            ])
          ]),
          l.value || e.error ? (f(), h("p", jae, y(l.value || e.error), 1)) : O("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
}), Gae = { class: "fe-field__hint" }, Xae = { class: "fe-field" }, Jae = { class: "fe-field__label" }, Zae = ["disabled"], Qae = {
  key: 0,
  class: "fe-form__error",
  role: "alert"
}, eie = ["disabled"], tie = ["disabled", "aria-busy"], nie = /* @__PURE__ */ lt({
  __name: "ArchivePasswordModal",
  props: {
    open: { type: Boolean },
    locale: {},
    archiveName: {},
    busy: { type: Boolean },
    error: {}
  },
  emits: ["close", "submit"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = S("");
    Je(() => n.open, (c) => {
      c && (r.value = "");
    });
    function l() {
      !r.value || n.busy || a("submit", r.value);
    }
    return (c, p) => (f(), Ge(ta, {
      open: e.open,
      title: u(i)("archive.password_title"),
      size: "sm",
      busy: e.busy,
      onClose: p[2] || (p[2] = (m) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: p[1] || (p[1] = (m) => a("close"))
        }, y(u(i)("archive.cancel")), 9, eie),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy || !r.value,
          "aria-busy": e.busy ? "true" : void 0,
          onClick: l
        }, y(e.busy ? u(i)("archive.opening") : u(i)("archive.continue")), 9, tie)
      ]),
      default: mt(() => [
        d("form", {
          class: "fe-form",
          onSubmit: yt(l, ["prevent"])
        }, [
          d("p", Gae, y(e.archiveName), 1),
          d("label", Xae, [
            d("span", Jae, y(u(i)("archive.password_required")), 1),
            dn(d("input", {
              "onUpdate:modelValue": p[0] || (p[0] = (m) => r.value = m),
              class: "fe-input",
              type: "password",
              autocomplete: "off",
              "data-1p-ignore": "",
              "data-bwignore": "true",
              "data-lpignore": "true",
              autofocus: "",
              disabled: e.busy
            }, null, 8, Zae), [
              [_n, r.value]
            ])
          ]),
          e.error ? (f(), h("p", Qae, y(e.error), 1)) : O("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
}), aie = {
  class: "fe-draftq",
  "data-testid": "draft-taken-dialog"
}, iie = { class: "fe-draftq__body" }, oie = {
  key: 0,
  class: "fe-form__error",
  role: "alert"
}, rie = ["disabled"], sie = ["disabled", "aria-busy"], N0 = /* @__PURE__ */ lt({
  __name: "DraftConflictModal",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    name: {},
    suggested: {},
    folder: {},
    busy: { type: Boolean },
    error: {},
    kind: {}
  },
  emits: ["cancel", "confirm"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = () => n.kind === "upload";
    return (l, c) => (f(), Ge(ta, {
      open: e.open,
      locale: e.locale,
      theme: e.theme,
      title: u(i)("draft.taken.title"),
      size: "sm",
      busy: e.busy,
      onClose: c[2] || (c[2] = (p) => a("cancel"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          "data-testid": "draft-taken-cancel",
          onClick: c[0] || (c[0] = (p) => a("cancel"))
        }, y(u(i)("modal.rename.cancel")), 9, rie),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy,
          "aria-busy": e.busy ? "true" : void 0,
          "data-testid": "draft-taken-confirm",
          onClick: c[1] || (c[1] = (p) => a("confirm"))
        }, y(u(i)(r() ? "upload.taken.confirm" : "draft.taken.confirm", { name: e.suggested })), 9, sie)
      ]),
      default: mt(() => [
        d("div", aie, [
          d("p", iie, y(u(i)(r() ? "upload.taken.body" : "draft.taken.body", { name: e.name, folder: e.folder, suggested: e.suggested })), 1),
          e.error ? (f(), h("p", oie, y(e.error), 1)) : O("", !0)
        ])
      ]),
      _: 1
    }, 8, ["open", "locale", "theme", "title", "busy"]));
  }
});
function lie(e, t) {
  const n = S(!1), a = S(null), i = S(null);
  let r = null;
  function l(v) {
    i.value = null, a.value = null;
    const x = r;
    r = null, x == null || x(v);
  }
  async function c(v) {
    const x = e();
    if (!x) return null;
    n.value = !0;
    try {
      const w = await x.save(v.key);
      if (w.saved) return { path: w.path, name: w.name, targetDir: w.targetDir };
      i.value = {
        key: v.key,
        name: w.name,
        suggested: w.suggested,
        folder: O2(w.targetDir)
      }, a.value = null;
    } finally {
      n.value = !1;
    }
    return new Promise((w) => {
      r = w;
    });
  }
  async function p() {
    const v = i.value, x = e();
    if (!(!v || !x || n.value)) {
      n.value = !0, a.value = null;
      try {
        const w = await x.save(v.key, v.suggested);
        if (w.saved) {
          l({ path: w.path, name: w.name, targetDir: w.targetDir });
          return;
        }
        i.value = { ...v, name: w.name || v.name, suggested: w.suggested };
      } catch (w) {
        a.value = t(w);
      } finally {
        n.value = !1;
      }
    }
  }
  function m() {
    n.value || l(null);
  }
  return { busy: n, error: a, question: i, save: c, confirm: p, cancel: m };
}
const uie = ["onKeydown"], cie = {
  key: 0,
  class: "fe-form__error",
  role: "alert",
  "data-testid": "rename-error"
}, die = ["disabled"], fie = ["disabled", "aria-busy"], pie = /* @__PURE__ */ lt({
  __name: "RenameModal",
  props: {
    open: { type: Boolean },
    locale: {},
    currentName: {},
    error: {},
    busy: { type: Boolean }
  },
  emits: ["close", "submit"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = S(""), l = S(null);
    Je(
      () => [n.open, n.currentName],
      ([m, v]) => {
        m && (r.value = v, l.value = n.error ?? null);
      }
    ), Je(
      () => n.error,
      (m) => {
        l.value = m ?? null;
      },
      { immediate: !0 }
    );
    function c() {
      l.value = null;
    }
    function p() {
      if (n.busy) return;
      if (r.value === n.currentName) {
        a("close");
        return;
      }
      const m = Ny(r.value), v = I2(m);
      if (v === "empty") {
        l.value = i("modal.rename.empty");
        return;
      }
      if (v) {
        l.value = i("modal.newfolder.invalid");
        return;
      }
      if (Ep(m)) {
        l.value = i("names.reserved", { name: m });
        return;
      }
      a("submit", m);
    }
    return (m, v) => (f(), Ge(ta, {
      open: e.open,
      title: u(i)("modal.rename.title"),
      size: "sm",
      busy: e.busy,
      onClose: v[2] || (v[2] = (x) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: v[1] || (v[1] = (x) => a("close"))
        }, y(u(i)("modal.rename.cancel")), 9, die),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy,
          "aria-busy": e.busy ? "true" : void 0,
          onClick: p
        }, y(e.busy ? u(i)("modal.rename.saving") : u(i)("modal.rename.save")), 9, fie)
      ]),
      default: mt(() => [
        d("form", {
          onSubmit: yt(p, ["prevent"])
        }, [
          dn(d("input", {
            "onUpdate:modelValue": v[0] || (v[0] = (x) => r.value = x),
            type: "text",
            class: "fe-input",
            autocomplete: "off",
            onInput: c,
            onKeydown: Ca(yt(p, ["prevent"]), ["enter"])
          }, null, 40, uie), [
            [_n, r.value]
          ]),
          l.value ? (f(), h("p", cie, y(l.value), 1)) : O("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
}), hie = {
  key: 0,
  class: "fe-form__error",
  role: "alert"
}, mie = ["disabled"], vie = ["disabled", "aria-busy"], yie = /* @__PURE__ */ lt({
  __name: "DeleteConfirmModal",
  props: {
    open: { type: Boolean },
    locale: {},
    count: {},
    error: {},
    busy: { type: Boolean },
    permanent: { type: Boolean }
  },
  emits: ["close", "confirm"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale);
    function r() {
      n.busy || a("confirm");
    }
    return (l, c) => (f(), Ge(ta, {
      open: e.open,
      title: e.permanent ? u(i)("modal.delete.permanent_title") : u(i)("modal.delete.title"),
      size: "sm",
      busy: e.busy,
      onClose: c[1] || (c[1] = (p) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: c[0] || (c[0] = (p) => a("close"))
        }, y(u(i)("modal.delete.cancel")), 9, mie),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--danger",
          disabled: e.busy,
          "aria-busy": e.busy ? "true" : void 0,
          onClick: r
        }, y(e.busy ? u(i)(e.permanent ? "modal.delete.permanent_working" : "modal.delete.working") : u(i)(e.permanent ? "modal.delete.permanent_confirm" : "modal.delete.confirm")), 9, vie)
      ]),
      default: mt(() => [
        d("p", null, y(e.permanent ? u(i)("modal.delete.permanent_message", { count: e.count }) : u(i)("modal.delete.message", { count: e.count })), 1),
        e.error ? (f(), h("p", hie, y(e.error), 1)) : O("", !0)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
});
function gie(e, t) {
  return e && e.queued ? t("toast.undo_queued") : e && e.summary ? e.summary : t("toast.undone");
}
function I0(e, t, n) {
  return !e || e.source === t ? !0 : e.source === "drag-out-stopping" ? n === "end" : !1;
}
function B0(e, t, n, a) {
  return (e == null ? void 0 : e.kind) === "plain" ? t === "running" ? e.running : e.done : t === "running" ? a("toast.undoing") : gie(n, a);
}
function gv(e, t = {}) {
  const n = S(!1), a = S(null);
  let i = 0;
  Je(e, (l, c) => {
    !l || c || (i++, n.value = !1, a.value = null);
  });
  function r(l) {
    return l === i && e.value;
  }
  return {
    busy: n,
    error: a,
    begin() {
      return n.value ? null : (n.value = !0, a.value = null, i);
    },
    end(l) {
      l === i && (n.value = !1);
    },
    refuse(l, c) {
      var p;
      return r(l) ? (a.value = c, !0) : ((p = t.say) == null || p.call(t, c), !1);
    },
    inDialog: r
  };
}
const bie = 3e3, kie = 20;
function wie(e) {
  const t = e.last_sync_error || void 0;
  switch (e.last_sync_state) {
    case "ok":
      return { status: "ok" };
    case "failed":
    case "error":
      return t ? { status: "failed", error: t } : { status: "failed" };
    case "aborted":
      return { status: "aborted" };
    default:
      return { status: "unknown" };
  }
}
function _ie(e) {
  const t = e.pollMs ?? bie, n = e.giveUpAfter ?? kie, a = /* @__PURE__ */ new Map(), i = S(0);
  let r, l = !1, c = !1, p = 0;
  const m = /* @__PURE__ */ new Set();
  function v() {
    c || r !== void 0 || l || a.size === 0 || (r = setTimeout(() => {
      r = void 0, x();
    }, t));
  }
  async function x() {
    if (c || a.size === 0) return;
    l = !0;
    let $ = null;
    try {
      $ = await e.list(), p = 0;
    } catch {
      p++;
    } finally {
      l = !1;
    }
    if (c) return;
    const k = $ === null && p >= n;
    if ($ !== null || k) {
      for (const [b, C] of a) {
        const T = $ == null ? void 0 : $.find((R) => R.id === C.id), E = C.settle.filter((R) => !R(T, k));
        E.length === 0 ? a.delete(b) : C.settle = E;
      }
      i.value++;
    }
    v();
  }
  function w($, k, b) {
    return c ? Promise.resolve(null) : new Promise((C) => {
      const T = (D) => {
        m.delete(T), C(D);
      };
      m.add(T);
      const E = `${k}:${$}`, R = (D, U) => {
        const H = b(D, U);
        return H === void 0 ? !1 : (T(H), !0);
      }, z = a.get(E);
      z ? z.settle.push(R) : a.set(E, { id: $, kind: k, settle: [R] }), i.value++, v();
    });
  }
  return {
    scan: ($) => w($, "scan", (k, b) => b ? { status: "unknown" } : k ? k.running ? void 0 : wie(k) : { status: "gone" }),
    deletion: ($) => w($, "deletion", (k, b) => b ? !1 : k ? void 0 : !0),
    watching($) {
      return i.value, a.has(`deletion:${$}`) ? "deletion" : a.has(`scan:${$}`) ? "scan" : null;
    },
    stop() {
      c = !0, r !== void 0 && clearTimeout(r), r = void 0, a.clear(), i.value++;
      for (const $ of [...m]) $(null);
    }
  };
}
const xie = ["aria-label"], Sie = ["aria-selected", "tabindex", "disabled", "data-testid", "data-section", "onClick", "onKeydown"], $ie = { class: "fe-sections__label" }, Tie = ["data-testid"], JT = /* @__PURE__ */ lt({
  __name: "SurfaceSections",
  props: {
    sections: {},
    active: {},
    locale: {},
    label: {},
    disabled: { type: Boolean }
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = A(
      () => n.sections.filter((c) => c && typeof c.id == "string" && c.id).map((c) => ({
        id: c.id,
        label: Xt(c.label, n.locale) || c.id,
        count: typeof c.count == "number" && Number.isFinite(c.count) ? c.count : null
      }))
    );
    function r(c) {
      n.disabled || c === n.active || a("select", c);
    }
    function l(c, p) {
      var $, k;
      if (!["ArrowRight", "ArrowLeft", "Home", "End"].includes(c.key)) return;
      c.preventDefault();
      const v = i.value.length;
      if (!v) return;
      let x = p;
      c.key === "ArrowRight" ? x = (p + 1) % v : c.key === "ArrowLeft" ? x = (p - 1 + v) % v : c.key === "Home" ? x = 0 : c.key === "End" && (x = v - 1);
      const w = ($ = c.currentTarget.parentElement) == null ? void 0 : $.querySelectorAll('[role="tab"]');
      (k = w == null ? void 0 : w[x]) == null || k.focus(), r(i.value[x].id);
    }
    return (c, p) => (f(), h("nav", {
      class: "fe-sections",
      role: "tablist",
      "aria-label": e.label,
      "data-testid": "surface-sections"
    }, [
      (f(!0), h(Te, null, nt(i.value, (m, v) => (f(), h("button", {
        key: m.id,
        type: "button",
        role: "tab",
        class: Re(["fe-sections__tab", { "is-active": m.id === e.active }]),
        "aria-selected": m.id === e.active ? "true" : "false",
        tabindex: m.id === e.active || !e.active && v === 0 ? 0 : -1,
        disabled: e.disabled,
        "data-testid": `surface-section-${m.id}`,
        "data-section": m.id,
        onClick: (x) => r(m.id),
        onKeydown: (x) => l(x, v)
      }, [
        d("span", $ie, y(m.label), 1),
        m.count !== null ? (f(), h("span", {
          key: 0,
          class: "fe-sections__count",
          "data-testid": `surface-section-count-${m.id}`
        }, y(m.count), 9, Tie)) : O("", !0)
      ], 42, Sie))), 128))
    ], 8, xie));
  }
}), Aie = {
  class: "fe-plugin-view",
  "data-testid": "plugin-view"
}, Eie = {
  key: 0,
  class: "fe-surface__text fe-surface__text--muted",
  role: "status",
  "data-testid": "plugin-view-opening"
}, Cie = ["disabled"], zie = /* @__PURE__ */ lt({
  __name: "PluginViewModal",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    api: {},
    plugin: {},
    view: {},
    surface: {},
    path: {},
    paths: {},
    storages: {},
    startAt: {},
    size: {},
    label: {}
  },
  emits: ["close", "op", "toast", "open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = Wp(
      {
        api: n.api,
        plugin: n.plugin,
        view: n.view,
        path: () => n.path,
        paths: () => n.paths,
        locale: () => n.locale,
        errorText: () => i("plugin.view.error")
      },
      {
        onOp: (x) => a("op", x),
        onDone: () => a("close"),
        onToast: (x) => a("toast", x),
        onOpen: (x) => a("open", x)
      }
    );
    Je(
      () => n.surface,
      (x) => r.setSurface(x),
      { immediate: !0 }
    );
    const l = r.current, c = A(() => {
      var x;
      return Xt((x = l.value) == null ? void 0 : x.title, n.locale) || n.label || n.view;
    }), p = A(() => {
      var x;
      return ((x = l.value) == null ? void 0 : x.sections) ?? [];
    });
    async function m(x) {
      var w, $;
      if (!(!x || x === ((w = l.value) == null ? void 0 : w.section)))
        try {
          const k = await n.api.pluginView(n.plugin, n.view, n.path, x);
          k != null && k.surface && r.setSurface(k.surface);
        } catch (k) {
          a("toast", (($ = i.foreign) == null ? void 0 : $.call(i, String((k == null ? void 0 : k.message) ?? ""))) || i("plugin.view.error"));
        }
    }
    const v = A(() => {
      var w;
      if (n.size) return n.size;
      const x = (w = l.value) == null ? void 0 : w.size;
      return x === "sm" || x === "lg" || x === "xl" ? x : "md";
    });
    return (x, w) => (f(), Ge(ta, {
      open: e.open,
      title: c.value,
      size: v.value,
      theme: e.theme,
      locale: e.locale,
      busy: u(r).busy.value,
      onClose: w[1] || (w[1] = ($) => a("close"))
    }, {
      actions: mt(() => [
        u(r).footer.value.length ? O("", !0) : (f(), h("button", {
          key: 0,
          type: "button",
          class: "fe-btn",
          disabled: u(r).busy.value,
          "data-testid": "plugin-view-close",
          onClick: w[0] || (w[0] = ($) => a("close"))
        }, y(u(i)("plugin.view.close")), 9, Cie)),
        Ze(Gp, {
          conv: u(r),
          locale: e.locale,
          "testid-prefix": "plugin-view"
        }, null, 8, ["conv", "locale"])
      ]),
      default: mt(() => {
        var $;
        return [
          d("div", Aie, [
            u(l) ? O("", !0) : (f(), h("p", Eie, y(u(i)("plugin.view.loading")), 1)),
            p.value.length ? (f(), Ge(JT, {
              key: 1,
              sections: p.value,
              active: ($ = u(l)) == null ? void 0 : $.section,
              locale: e.locale,
              label: c.value,
              disabled: u(r).busy.value,
              onSelect: m
            }, null, 8, ["sections", "active", "locale", "label", "disabled"])) : O("", !0),
            Ze(Yp, {
              conv: u(r),
              locale: e.locale,
              theme: e.theme,
              api: e.api,
              plugin: e.plugin,
              storages: e.storages,
              "start-at": e.startAt
            }, null, 8, ["conv", "locale", "theme", "api", "plugin", "storages", "start-at"])
          ])
        ];
      }),
      _: 1
    }, 8, ["open", "title", "size", "theme", "locale", "busy"]));
  }
}), Mie = { class: "fe-appframe-modal__body" }, Pie = /* @__PURE__ */ lt({
  __name: "AppFrameModal",
  props: {
    api: {},
    locale: {},
    theme: {},
    plugin: {},
    view: {},
    placement: {},
    ui: {},
    label: {},
    files: {},
    userName: {},
    storages: {},
    startAt: {}
  },
  emits: ["close", "toast", "op"],
  setup(e, { emit: t }) {
    const n = t, a = S(null), i = S("");
    async function r() {
      a.value && !await a.value.confirmClose() || n("close");
    }
    return (l, c) => (f(), Ge(ta, {
      open: !0,
      size: e.placement === "home" ? "xl" : "lg",
      title: i.value ? `${e.label} - ${i.value}` : e.label,
      locale: e.locale,
      theme: e.theme,
      "close-on-backdrop": !1,
      "data-testid": "app-frame-modal",
      onClose: r
    }, {
      default: mt(() => [
        d("div", Mie, [
          Ze(Dg, {
            ref_key: "frame",
            ref: a,
            api: e.api,
            app: e.plugin,
            version: e.ui.version,
            view: e.view,
            placement: e.placement,
            ui: e.ui,
            files: e.files,
            storages: e.storages,
            "start-at": e.startAt,
            locale: e.locale,
            theme: e.theme,
            "user-name": e.userName,
            title: e.label,
            onTitle: c[0] || (c[0] = (p) => i.value = p),
            onToast: c[1] || (c[1] = (p) => n("toast", p.text)),
            onOp: c[2] || (c[2] = (p) => n("op", p)),
            onClose: r
          }, null, 8, ["api", "app", "version", "view", "placement", "ui", "files", "storages", "start-at", "locale", "theme", "user-name", "title"])
        ])
      ]),
      _: 1
    }, 8, ["size", "title", "locale", "theme"]));
  }
}), nd = S(0);
function ZT() {
  const e = Qi().openWith;
  if (!e) return {};
  try {
    const t = JSON.parse(e);
    if (!t || typeof t != "object" || Array.isArray(t)) return {};
    const n = {};
    for (const [a, i] of Object.entries(t))
      typeof i == "string" && Zg(a) && Qg(i, a) && (n[a] = i);
    return n;
  } catch {
    return {};
  }
}
function Zg(e) {
  return /^[a-z0-9][a-z0-9_+-]{0,31}$/.test(e);
}
function Qg(e, t) {
  return e === Ll ? t === void 0 || eh(t) : e === "builtin" || /^app:[a-z0-9][a-z0-9_-]{0,31}\/[a-z0-9][a-z0-9_.-]{0,63}$/.test(e);
}
function Oie() {
  return nd.value, ZT();
}
function Lie(e) {
  return e ? Oie()[e.toLowerCase()] ?? null : null;
}
async function QT(e, t) {
  const n = await A$(e, t);
  if (!(!n || !n.ok))
    try {
      const a = await n.json();
      if (!a || !a.choices || typeof a.choices != "object" || Array.isArray(a.choices)) return;
      const i = {};
      for (const [r, l] of Object.entries(a.choices))
        typeof l == "string" && Zg(r) && Qg(l, r) && (i[r] = l);
      Og("openWith", JSON.stringify(i)), nd.value++;
    } catch {
    }
}
function Die(e, t) {
  const n = e.toLowerCase();
  if (!Zg(n) || t !== null && !Qg(t, n)) return;
  const a = ZT();
  t === null ? delete a[n] : a[n] = t, Og("openWith", JSON.stringify(a)), nd.value++;
  const i = `/api/me/open-with/${encodeURIComponent(n)}`;
  QT(i, t === null ? { method: "DELETE" } : { method: "PUT", body: JSON.stringify({ handler: t }) });
}
function vhe() {
  Og("openWith", "{}"), nd.value++, QT("/api/me/open-with", { method: "DELETE" });
}
function Rie() {
  return Jc(() => {
    nd.value++;
  });
}
const Nie = {
  class: "fe-openwith",
  "data-testid": "open-with-dialog"
}, Iie = { class: "fe-openwith__lead" }, Bie = {
  key: 0,
  class: "fe-openwith__always"
}, Fie = {
  key: 1,
  class: "fe-openwith__hint"
}, Uie = ["disabled"], Hie = /* @__PURE__ */ lt({
  __name: "OpenWithDialog",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    name: {},
    kind: {},
    handlers: {},
    current: {},
    remembered: {}
  },
  emits: ["cancel", "open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = S(null), l = S(!1);
    Je(
      () => n.open,
      (v) => {
        var x;
        v && (r.value = n.current ?? ((x = n.handlers[0]) == null ? void 0 : x.id) ?? null, l.value = !!n.remembered && n.remembered === r.value);
      },
      { immediate: !0 }
    );
    function c(v) {
      return Rf(v) ? i("openWith.onlyoffice") : v.view ? Xt(v.view.label, n.locale) || v.view.plugin : i("openWith.builtin");
    }
    const p = A(
      () => n.handlers.map((v) => ({
        value: v.id,
        label: c(v),
        help: v.id === n.current ? i("openWith.now") : void 0
      }))
    );
    function m() {
      r.value && a("open", r.value, l.value && !!n.kind);
    }
    return (v, x) => (f(), Ge(ta, {
      open: e.open,
      locale: e.locale,
      theme: e.theme,
      title: u(i)("openWith.title"),
      size: "sm",
      onClose: x[3] || (x[3] = (w) => a("cancel"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          "data-testid": "open-with-cancel",
          onClick: x[2] || (x[2] = (w) => a("cancel"))
        }, y(u(i)("modal.rename.cancel")), 1),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: !r.value,
          "data-testid": "open-with-open",
          onClick: m
        }, y(u(i)("openWith.open")), 9, Uie)
      ]),
      default: mt(() => [
        d("div", Nie, [
          d("p", Iie, y(u(i)("openWith.lead", { name: e.name })), 1),
          Ze(mi, {
            "model-value": r.value,
            "onUpdate:modelValue": x[0] || (x[0] = (w) => r.value = typeof w == "string" ? w : null),
            options: p.value,
            "aria-label": u(i)("openWith.title"),
            "testid-prefix": "open-with-choice"
          }, null, 8, ["model-value", "options", "aria-label"]),
          e.kind ? (f(), h("label", Bie, [
            dn(d("input", {
              "onUpdate:modelValue": x[1] || (x[1] = (w) => l.value = w),
              type: "checkbox",
              "data-testid": "open-with-always"
            }, null, 512), [
              [zc, l.value]
            ]),
            d("span", null, y(u(i)("openWith.always", { ext: "." + e.kind })), 1)
          ])) : O("", !0),
          e.kind ? (f(), h("p", Fie, y(u(i)("openWith.hint")), 1)) : O("", !0)
        ])
      ]),
      _: 1
    }, 8, ["open", "locale", "theme", "title"]));
  }
}), $p = "filex.embed.locale", eA = "filex:embed-locale";
function Kie(e) {
  var t;
  return !((t = e.accountPrefs) != null && t.surface) && !Fl();
}
const Pr = (e) => String(e ?? "").trim();
function F0(e) {
  const t = () => _2(e.browser ?? []);
  if (!e.embedded) {
    const l = Pr(e.account) || Pr(e.host);
    if (l && Vu(l))
      return { locale: Aa(l), tier: Pr(e.account) ? "account" : "host" };
    const c = t();
    return c ? { locale: c, tier: "browser" } : { locale: "en", tier: "default" };
  }
  const n = Pr(e.chosen);
  if (n && Vu(n)) return { locale: Aa(n), tier: "chosen" };
  const a = Pr(e.account);
  if (a && Vu(a)) return { locale: Aa(a), tier: "account" };
  const i = t();
  if (i) return { locale: i, tier: "browser" };
  const r = Pr(e.host);
  return r && Vu(r) ? { locale: Aa(r), tier: "host" } : { locale: "en", tier: "default" };
}
async function Vie(e) {
  var i;
  if (!e.person) return "";
  let t;
  try {
    t = (i = await e.me()) == null ? void 0 : i.user;
  } catch {
    return "";
  }
  if (!t) return "";
  const n = typeof t.locale == "string" ? t.locale.trim() : "";
  if (n) return n;
  const a = Pr(e.host);
  return e.embedded || !a || e.updateProfile({ locale: a }).catch(() => {
  }), "";
}
function jie(e, t) {
  qie(e);
  const n = Cc.value;
  return n && t.person && t.updateProfile({ locale: n }).catch(() => {
  }), n;
}
function eb(e) {
  const t = typeof e == "string" ? e.trim().toLowerCase().replace(/_/g, "-") : "";
  return m2(t) ? t : "";
}
function tA() {
  try {
    return eb(localStorage.getItem($p));
  } catch {
    return "";
  }
}
const nA = typeof window < "u", Cc = S(nA ? tA() : "");
function U0() {
  return Cc.value;
}
function qie(e) {
  const t = eb(e);
  Cc.value = t;
  try {
    t ? localStorage.setItem($p, t) : localStorage.removeItem($p);
  } catch {
  }
  try {
    window.dispatchEvent(new CustomEvent(eA, { detail: t }));
  } catch {
  }
}
if (nA)
  try {
    window.addEventListener("storage", (e) => {
      (e.key === null || e.key === $p) && (Cc.value = tA());
    }), window.addEventListener(eA, (e) => {
      Cc.value = eb(e.detail);
    });
  } catch {
  }
function aA(e) {
  if (!e) return null;
  if (typeof HTMLElement < "u" && e instanceof HTMLElement) return e;
  const t = e.$el;
  return typeof HTMLElement < "u" && t instanceof HTMLElement ? t : null;
}
function tb() {
  if (typeof window > "u") return { width: 0, height: 0 };
  const e = typeof document < "u" ? document.documentElement : null, t = e && e.clientWidth > 0 ? e.clientWidth : window.innerWidth, n = e && e.clientHeight > 0 ? e.clientHeight : window.innerHeight;
  return { width: t, height: n };
}
function nb(e, t, n = {}) {
  const a = n.dir === "rtl", i = a ? "left" : "right", r = n.gutter ?? 8, l = Math.round(e.bottom + (n.gap ?? 6)), c = Math.round(a ? e.left ?? 0 : t.width - e.right), p = Math.max(200, t.height - l - r), m = `${n.maxHeight ? Math.min(n.maxHeight, p) : p}px`;
  if (!n.width) return { top: `${l}px`, [i]: `${c}px`, maxHeight: m };
  const v = Math.max(0, Math.min(n.width, t.width - r * 2)), x = Math.min(Math.max(c, r), t.width - v - r);
  return { top: `${l}px`, [i]: `${Math.round(x)}px`, width: `${Math.round(v)}px`, maxHeight: m };
}
function Vo(e) {
  return typeof e == "string" ? e : "";
}
function Wie(e, t) {
  const n = { title: Vo(e.title), body: Vo(e.body) }, a = e.e2e;
  if (!a || typeof t != "function" || !Array.isArray(a.names)) return n;
  const i = a.names.map((l) => {
    let c = null;
    try {
      c = t(Vo(l == null ? void 0 : l.wire), Vo(l == null ? void 0 : l.root));
    } catch {
      c = null;
    }
    return c ? l.part === "path" ? Vo(c.path) : Vo(c.name) : Vo(l == null ? void 0 : l.locked);
  }), r = (l, c) => Array.isArray(l) ? l.map((p) => typeof (p == null ? void 0 : p.name) == "number" ? i[p.name] ?? "" : Vo(p == null ? void 0 : p.text)).join("") : c;
  return { title: r(a.title, n.title), body: r(a.body, n.body) };
}
function Yie() {
  function e(t) {
    return Wie(t, une);
  }
  return { notificationText: e };
}
const Tp = ".trash";
function H0(e, t) {
  const n = (a) => {
    const i = String(a ?? ""), r = i.indexOf("://");
    return r < 0 ? i : `${i.slice(0, r + 3)}${i.slice(r + 3).replace(/^\/+/, "")}`;
  };
  return n(e) === n(t);
}
function Gie(e) {
  let t = String(e ?? "").trim().replace(/\\/g, "/");
  const n = t.indexOf("://");
  return n >= 0 && (t = t.slice(n + 3)), t.replace(/^\/+/, "").replace(/\/+$/, "");
}
function Xie(e) {
  const t = e.lastIndexOf("/");
  return t < 0 ? "" : e.slice(0, t);
}
function iA(e) {
  var i, r, l;
  if (!e || !e.kind || e.kind === "none") return { kind: "none" };
  if (e.kind === "share") {
    const c = String(e.id ?? "").trim();
    return c ? { kind: "share", token: c } : { kind: "none" };
  }
  if (e.kind === "app") {
    const c = String(((i = e.open) == null ? void 0 : i.plugin) ?? "").trim(), p = String(((r = e.open) == null ? void 0 : r.view) ?? "").trim(), m = String(((l = e.open) == null ? void 0 : l.section) ?? "").trim();
    return !c || !p ? { kind: "none" } : { kind: "app", plugin: c, view: p, ...m ? { section: m } : {} };
  }
  const t = String(e.storage ?? "").trim(), n = Gie(e.path);
  if (e.kind === "trash")
    return t && n ? { kind: "trash", select: `${t}://${n}` } : { kind: "trash" };
  if (!t) return { kind: "none" };
  const a = Jie(e);
  return e.kind === "dir" ? { kind: "folder", storage: t, folder: n, ...a ? { open: a } : {} } : e.kind === "file" ? n ? {
    kind: "folder",
    storage: t,
    folder: Xie(n),
    select: `${t}://${n}`,
    ...a ? { open: a } : {}
  } : { kind: "folder", storage: t, folder: "", ...a ? { open: a } : {} } : { kind: "none" };
}
function Jie(e) {
  const t = e.open;
  if (!t || typeof t != "object") return;
  const n = String(t.plugin ?? "").trim(), a = String(t.action ?? "").trim(), i = String(t.view ?? "").trim();
  if (!(!n || !a && !i))
    return { plugin: n, ...a ? { action: a } : {}, ...i ? { view: i } : {} };
}
function Zie(e) {
  return iA(e).kind !== "none";
}
function Qie(e) {
  return typeof e.opens == "boolean" ? e.opens : Zie(e.target);
}
function $y(e) {
  return e.kind === "trash" ? Tp : e.kind !== "folder" ? "" : e.folder ? `${e.storage}/${e.folder}` : e.storage;
}
function oA(e) {
  return e ? e.split("/").map(encodeURIComponent).join("/") : "";
}
function eoe(e) {
  return e.kind === "trash" ? Tp : e.kind !== "folder" ? "" : `${e.storage}://${e.folder}`;
}
function yhe(e, t = {}) {
  const n = String(e ?? "").replace(/^#/, "").replace(/^\/+/, "");
  if (!n) return "";
  let a = n;
  if (!t.decoded)
    try {
      a = decodeURIComponent(n);
    } catch {
    }
  const i = a.indexOf("/");
  return i < 0 ? `${a}://` : `${a.slice(0, i)}://${a.slice(i + 1)}`;
}
function ghe(e) {
  if (e.kind === "app")
    return {
      name: "app-home",
      params: { plugin: e.plugin, view: e.view },
      query: e.section ? { section: e.section } : {},
      hash: ""
    };
  if (e.kind === "folder") {
    const t = e.select ? { select: e.select } : {};
    return e.open && (t.app = e.open.plugin, e.open.action ? t.appAction = e.open.action : e.open.view && (t.appView = e.open.view)), {
      name: "explore",
      query: t,
      // vue-router wants the '#'; the explorer encodes segment-by-segment, so
      // we hand over the readable form and let the browser escape it.
      hash: `#${$y(e)}`
    };
  }
  return e.kind === "trash" ? {
    name: "explore",
    query: e.select ? { select: e.select } : {},
    hash: `#${$y(e)}`
  } : null;
}
function rA(e, t = "") {
  return `${t.replace(/\/+$/, "")}/s/${encodeURIComponent(e)}`;
}
function bhe(e, t = "/", n = "") {
  if (e.kind === "share") return rA(e.token, n);
  const a = `${String(t || "/").replace(/\/+$/, "")}/`;
  if (e.kind === "app") {
    const l = `${a}app/${encodeURIComponent(e.plugin)}/${encodeURIComponent(e.view)}`;
    return e.section ? `${l}?section=${encodeURIComponent(e.section)}` : l;
  }
  if (e.kind !== "folder" && e.kind !== "trash") return "";
  const i = [];
  e.select && i.push(`select=${encodeURIComponent(e.select)}`), e.kind === "folder" && e.open && (i.push(`app=${encodeURIComponent(e.open.plugin)}`), e.open.action ? i.push(`appAction=${encodeURIComponent(e.open.action)}`) : e.open.view && i.push(`appView=${encodeURIComponent(e.open.view)}`));
  const r = oA($y(e));
  return `${a}explore${i.length ? `?${i.join("&")}` : ""}${r ? `#${r}` : ""}`;
}
const toe = { class: "fx-nrow__body" }, noe = { class: "fx-nrow__meta" }, aoe = { class: "fx-nrow__when" }, ioe = { class: "fx-nrow__title" }, ooe = {
  key: 0,
  class: "fx-nrow__body-text"
}, sA = /* @__PURE__ */ lt({
  __name: "NotificationRow",
  props: {
    item: {},
    locale: {}
  },
  emits: ["open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), { notificationText: r } = Yie(), l = A(() => r(n.item)), c = A(() => Qie(n.item)), p = A(() => !n.item.read_at), m = A(() => X2(n.item.created_at, n.locale, { time: !0 }) || "-");
    function v(w) {
      const $ = `notifications.severity.${w}`, k = i($);
      return k === $ ? w : k;
    }
    function x(w) {
      return w === "critical" || w === "error" ? "danger" : w === "warning" ? "warning" : "info";
    }
    return (w, $) => (f(), Ge(Ki(c.value ? "button" : "div"), {
      type: c.value ? "button" : void 0,
      class: Re(["fx-nrow", { "is-unread": p.value, "has-target": c.value, "is-static": !c.value }]),
      title: c.value ? u(i)("notifications.openTarget") : void 0,
      "data-testid": "notification-row",
      "data-clickable": c.value ? "yes" : "no",
      "data-notification-id": e.item.id,
      onClick: $[0] || ($[0] = (k) => c.value ? a("open", e.item) : void 0)
    }, {
      default: mt(() => [
        $[1] || ($[1] = d("span", {
          class: "fx-nrow__dot",
          "aria-hidden": "true"
        }, null, -1)),
        d("span", toe, [
          d("span", noe, [
            d("span", {
              class: Re(["fx-nrow__sev", `is-${x(e.item.severity)}`])
            }, y(v(e.item.severity)), 3),
            d("span", aoe, y(m.value), 1)
          ]),
          d("span", ioe, y(l.value.title), 1),
          l.value.body ? (f(), h("span", ooe, y(l.value.body), 1)) : O("", !0)
        ])
      ]),
      _: 1
    }, 8, ["type", "class", "title", "data-clickable", "data-notification-id"]));
  }
}), K0 = 99;
function roe(e) {
  const t = Math.floor(Number(e ?? 0));
  return !Number.isFinite(t) || t <= 0 ? "" : t > K0 ? `${K0}+` : String(t);
}
function khe(e) {
  const t = Math.floor(Number(e ?? 0));
  return Number.isFinite(t) && t > 0 ? t : 0;
}
const soe = {
  key: 0,
  class: "fx-badge",
  "aria-hidden": "true",
  "data-testid": "unread-badge"
}, lA = /* @__PURE__ */ lt({
  __name: "UnreadBadge",
  props: {
    count: {}
  },
  setup(e) {
    const t = e, n = A(() => roe(t.count));
    return (a, i) => n.value ? (f(), h("span", soe, y(n.value), 1)) : O("", !0);
  }
}), loe = ["innerHTML"], uoe = { class: "fx-bell__heading" }, coe = ["innerHTML"], doe = {
  key: 0,
  class: "fx-bell__empty"
}, foe = { class: "fx-bell__foot" }, poe = ["onClick"], hoe = ["href", "onClick"], bv = 360, moe = /* @__PURE__ */ lt({
  __name: "NotificationBell",
  props: {
    feed: {},
    locale: {},
    manageHref: {}
  },
  emits: ["open", "manage"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = A(() => Math.max(0, n.feed.unreadCount || 0)), l = A(
      () => r.value > 0 ? `${i("notifications.bell")} - ${i("notifications.unreadCount", { n: r.value })}` : i("notifications.bell")
    ), c = S(null), p = S({
      top: "0px",
      right: "0px",
      width: `${bv}px`,
      maxHeight: "420px"
    });
    function m() {
      const b = aA(c.value), C = b == null ? void 0 : b.getBoundingClientRect();
      if (!C) return;
      const T = nb(
        C,
        tb(),
        // The list scrolls inside the panel; 520 keeps ~6 rows on a laptop and
        // the head + foot visible on a phone. ⚠ RTL: flush with the bell's END
        // edge — its left one in a right-to-left header.
        { width: bv, maxHeight: 520, dir: ei(b) }
      );
      p.value = { top: T.top, right: T.right, left: T.left, width: T.width ?? `${bv}px`, maxHeight: T.maxHeight };
    }
    function v() {
      m(), n.feed.refreshFeed();
    }
    async function x(b, C) {
      C(), b.read_at || await n.feed.markRead(b.id).catch(() => {
      }), a("open", b);
    }
    function w(b) {
      b(), n.feed.openPanel();
    }
    function $(b) {
      b(), a("manage");
    }
    const k = A(() => n.feed.feed.slice(0, 15));
    return (b, C) => (f(), Ge(u(ZM), { class: "fx-bell" }, {
      default: mt(({ open: T, close: E }) => [
        Ze(u(QM), {
          ref_key: "btnEl",
          ref: c,
          class: Re(["fx-bell__btn", { "is-open": T }]),
          title: l.value,
          "aria-label": l.value,
          "data-testid": "notification-bell",
          onClick: m,
          onKeydown: m
        }, {
          default: mt(() => [
            d("span", {
              class: "fx-bell__icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("bell")
            }, null, 8, loe),
            Ze(lA, { count: r.value }, null, 8, ["count"])
          ]),
          _: 1
        }, 8, ["class", "title", "aria-label"]),
        (f(), Ge(wi, { to: "body" }, [
          Ze(u(eP), {
            class: "fx-bell__panel",
            style: Yt({ top: p.value.top, right: p.value.right, left: p.value.left, width: p.value.width }),
            "data-testid": "notification-panel"
          }, {
            default: mt(() => [
              d("div", {
                class: "fx-bell__head",
                onVnodeMounted: v
              }, [
                d("span", uoe, y(u(i)("notifications.title")), 1),
                e.feed.hasUnread ? (f(), h("button", {
                  key: 0,
                  type: "button",
                  class: "fx-bell__markall",
                  "data-testid": "notification-mark-all",
                  onClick: C[0] || (C[0] = (R) => e.feed.markAllRead())
                }, [
                  d("span", {
                    class: "fx-bell__markall-icon",
                    "aria-hidden": "true",
                    innerHTML: u(zt)("check")
                  }, null, 8, coe),
                  Ht(" " + y(u(i)("notifications.markAllRead")), 1)
                ])) : O("", !0)
              ], 512),
              d("ul", {
                class: "fx-bell__list",
                style: Yt({ maxHeight: p.value.maxHeight }),
                "data-testid": "notification-list"
              }, [
                !k.value.length && !e.feed.feedLoading ? (f(), h("li", doe, y(u(i)("notifications.empty")), 1)) : O("", !0),
                (f(!0), h(Te, null, nt(k.value, (R) => (f(), h("li", {
                  key: R.id
                }, [
                  Ze(sA, {
                    item: R,
                    locale: e.locale,
                    onOpen: (z) => x(z, E)
                  }, null, 8, ["item", "locale", "onOpen"])
                ]))), 128))
              ], 4),
              d("div", foe, [
                d("button", {
                  type: "button",
                  class: "fx-bell__all",
                  "data-testid": "notification-view-all",
                  onClick: (R) => w(E)
                }, y(u(i)("notifications.viewAll")), 9, poe),
                e.manageHref ? (f(), h("a", {
                  key: 0,
                  href: e.manageHref,
                  class: "fx-bell__manage",
                  "data-testid": "notification-manage",
                  onClick: yt((R) => $(E), ["prevent"])
                }, y(u(i)("notifications.manageAdmin")), 9, hoe)) : O("", !0)
              ])
            ]),
            _: 2
          }, 1032, ["style"])
        ]))
      ]),
      _: 1
    }));
  }
}), voe = ["aria-label"], yoe = { class: "fx-nall__sheet" }, goe = { class: "fx-nall__head" }, boe = { class: "fx-nall__title" }, koe = {
  class: "fx-nall__title-icon",
  "aria-hidden": "true"
}, woe = ["innerHTML"], _oe = { class: "fx-nall__tools" }, xoe = ["aria-pressed"], Soe = ["aria-label"], $oe = ["innerHTML"], Toe = {
  key: 0,
  class: "fx-nall__error",
  "data-testid": "notifications-screen-error"
}, Aoe = {
  class: "fx-nall__list",
  "data-testid": "notifications-screen-list"
}, Eoe = {
  key: 0,
  class: "fx-nall__empty"
}, Coe = ["title", "aria-label", "onClick"], zoe = ["innerHTML"], Moe = {
  key: 1,
  class: "fx-nall__foot",
  "data-testid": "notifications-screen-pager"
}, Poe = ["disabled"], Ooe = { class: "fx-nall__count" }, Loe = ["disabled"], Doe = /* @__PURE__ */ lt({
  __name: "NotificationsPanel",
  props: {
    feed: {},
    locale: {}
  },
  emits: ["open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = A(() => Math.floor(n.feed.mineOffset / n.feed.mineLimit) + 1), l = A(() => Math.max(1, Math.ceil(n.feed.mineTotal / n.feed.mineLimit)));
    function c(w) {
      w < 1 || w > l.value || (n.feed.setMinePage(w), n.feed.fetchMine());
    }
    function p() {
      n.feed.setMineUnreadFilter(!n.feed.mineUnreadOnly), n.feed.fetchMine();
    }
    async function m(w) {
      n.feed.closePanel(), w.read_at || await n.feed.markRead(w.id).catch(() => {
      }), a("open", w);
    }
    async function v(w) {
      w.read_at || await n.feed.markRead(w.id).catch(() => {
      });
    }
    function x(w) {
      w.key === "Escape" && n.feed.closePanel();
    }
    return Je(
      () => n.feed.panelOpen,
      (w) => {
        w ? window.addEventListener("keydown", x) : window.removeEventListener("keydown", x);
      },
      { immediate: !0 }
    ), Tt(() => window.removeEventListener("keydown", x)), (w, $) => (f(), Ge(wi, { to: "body" }, [
      e.feed.panelOpen ? (f(), h("div", {
        key: 0,
        class: "fx-nall",
        role: "dialog",
        "aria-modal": "true",
        "aria-label": u(i)("notifications.title"),
        "data-testid": "notifications-screen"
      }, [
        d("div", {
          class: "fx-nall__scrim",
          onClick: $[0] || ($[0] = yt((k) => e.feed.closePanel(), ["self"]))
        }),
        d("section", yoe, [
          d("header", goe, [
            d("span", boe, [
              d("span", koe, [
                d("span", {
                  innerHTML: u(zt)("bell")
                }, null, 8, woe),
                Ze(lA, {
                  count: e.feed.unreadCount
                }, null, 8, ["count"])
              ]),
              Ht(" " + y(u(i)("notifications.title")), 1)
            ]),
            d("div", _oe, [
              d("button", {
                type: "button",
                class: Re(["fx-nall__tool", { "is-on": e.feed.mineUnreadOnly }]),
                "aria-pressed": e.feed.mineUnreadOnly,
                "data-testid": "notifications-screen-unread",
                onClick: p
              }, y(u(i)("notifications.unreadOnly")), 11, xoe),
              e.feed.hasUnread ? (f(), h("button", {
                key: 0,
                type: "button",
                class: "fx-nall__tool",
                "data-testid": "notifications-screen-mark-all",
                onClick: $[1] || ($[1] = (k) => e.feed.markAllRead())
              }, y(u(i)("notifications.markAllRead")), 1)) : O("", !0),
              d("button", {
                type: "button",
                class: "fx-nall__close",
                "aria-label": u(i)("modal.close"),
                "data-testid": "notifications-screen-close",
                onClick: $[2] || ($[2] = (k) => e.feed.closePanel())
              }, [
                d("span", {
                  "aria-hidden": "true",
                  innerHTML: u(zt)("close")
                }, null, 8, $oe)
              ], 8, Soe)
            ])
          ]),
          e.feed.mineError ? (f(), h("p", Toe, y(e.feed.mineError), 1)) : O("", !0),
          d("ul", Aoe, [
            !e.feed.mine.length && !e.feed.mineLoading ? (f(), h("li", Eoe, y(u(i)("notifications.empty")), 1)) : O("", !0),
            (f(!0), h(Te, null, nt(e.feed.mine, (k) => (f(), h("li", {
              key: k.id,
              class: "fx-nall__item"
            }, [
              Ze(sA, {
                item: k,
                locale: e.locale,
                onOpen: m
              }, null, 8, ["item", "locale"]),
              k.read_at ? O("", !0) : (f(), h("button", {
                key: 0,
                type: "button",
                class: "fx-nall__read",
                title: u(i)("notifications.markRead"),
                "aria-label": u(i)("notifications.markRead"),
                "data-testid": "notifications-screen-mark-one",
                onClick: (b) => v(k)
              }, [
                d("span", {
                  "aria-hidden": "true",
                  innerHTML: u(zt)("check")
                }, null, 8, zoe)
              ], 8, Coe))
            ]))), 128))
          ]),
          l.value > 1 ? (f(), h("footer", Moe, [
            d("button", {
              type: "button",
              class: "fx-nall__page",
              disabled: r.value <= 1,
              onClick: $[3] || ($[3] = (k) => c(r.value - 1))
            }, y(u(i)("common.prev")), 9, Poe),
            d("span", Ooe, y(u(i)("notifications.pageOf", { page: r.value, pages: l.value, total: e.feed.mineTotal })), 1),
            d("button", {
              type: "button",
              class: "fx-nall__page",
              disabled: r.value >= l.value,
              onClick: $[4] || ($[4] = (k) => c(r.value + 1))
            }, y(u(i)("common.next")), 9, Loe)
          ])) : O("", !0)
        ])
      ], 8, voe)) : O("", !0)
    ]));
  }
}), Roe = "filex", Noe = "0.0.0";
function whe(e) {
  return /^[0-9a-f]{8,}$/i.test(e) ? e.slice(0, 7) : e;
}
function uA(e) {
  const t = String(e ?? "").trim();
  return !t || t === Noe ? "" : `${Roe} ${t}`;
}
const Ioe = {
  key: 0,
  class: "fe-version",
  "data-testid": "product-version"
}, Boe = /* @__PURE__ */ lt({
  __name: "ProductVersion",
  props: {
    version: {}
  },
  setup(e) {
    const t = e, n = A(() => uA(t.version));
    return (a, i) => n.value ? (f(), h("p", Ioe, [
      d("bdi", null, y(n.value), 1)
    ])) : O("", !0);
  }
}), Foe = {
  class: "fx-account__face",
  "aria-hidden": "true"
}, Uoe = ["src"], Hoe = {
  key: 1,
  class: "fx-account__initial"
}, Koe = {
  key: 2,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  focusable: "false"
}, Voe = { class: "fx-acctmenu__who" }, joe = ["data-testid", "onClick"], qoe = ["innerHTML"], Woe = { class: "fx-acctmenu__label" }, Yoe = /* @__PURE__ */ lt({
  __name: "AccountMenu",
  props: {
    actions: {},
    user: {},
    version: {},
    locale: {},
    fallbackLabel: {}
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = A(() => qp(n.user ?? null)), r = A(() => {
      var x;
      return (((x = n.user) == null ? void 0 : x.avatar_url) || "").trim();
    }), l = A(() => {
      const x = i.value;
      return x ? [...x][0].toLocaleUpperCase(gi(n.locale)) : "";
    }), c = A(() => i.value || n.fallbackLabel), p = S(null), m = S({ top: "0px", right: "0px" });
    function v() {
      const x = aA(p.value), w = x == null ? void 0 : x.getBoundingClientRect();
      if (!w) return;
      const { top: $, right: k, left: b } = nb(
        w,
        tb(),
        { dir: ei(x) }
      );
      m.value = { top: $, right: k, left: b };
    }
    return (x, w) => (f(), Ge(u(tP), {
      as: "div",
      class: "fx-account"
    }, {
      default: mt(({ open: $ }) => [
        Ze(u(nP), {
          ref_key: "btnEl",
          ref: p,
          class: Re(["fx-account__btn", { "is-open": $ }]),
          title: c.value,
          "aria-label": c.value,
          "data-testid": "explore-account",
          onClick: v,
          onKeydown: v
        }, {
          default: mt(() => [
            d("span", Foe, [
              r.value ? (f(), h("img", {
                key: 0,
                class: "fx-account__img",
                src: r.value,
                alt: ""
              }, null, 8, Uoe)) : l.value ? (f(), h("span", Hoe, y(l.value), 1)) : (f(), h("svg", Koe, [...w[0] || (w[0] = [
                d("circle", {
                  cx: "12",
                  cy: "8.5",
                  r: "3.5"
                }, null, -1),
                d("path", { d: "M5.5 19.5a6.5 6.5 0 0 1 13 0" }, null, -1)
              ])]))
            ]),
            w[1] || (w[1] = d("svg", {
              class: "fx-account__chev",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              d("path", { d: "M7 10l5 5 5-5" })
            ], -1))
          ]),
          _: 1
        }, 8, ["class", "title", "aria-label"]),
        (f(), Ge(wi, { to: "body" }, [
          Ze(Rr, {
            "enter-active-class": "fx-acct-in",
            "leave-active-class": "fx-acct-out"
          }, {
            default: mt(() => [
              Ze(u(aP), {
                class: "fx-acctmenu",
                style: Yt({ top: m.value.top, right: m.value.right, left: m.value.left }),
                "data-testid": "explore-account-menu"
              }, {
                default: mt(() => [
                  d("p", Voe, y(c.value), 1),
                  (f(!0), h(Te, null, nt(e.actions, (k) => (f(), Ge(u(iP), {
                    key: k.key
                  }, {
                    default: mt(({ active: b }) => [
                      d("button", {
                        type: "button",
                        class: Re(["fx-acctmenu__item", { "is-active": b, "is-separated": k.separated }]),
                        "data-testid": `explore-${k.key}`,
                        onClick: (C) => a("select", k.key)
                      }, [
                        d("span", {
                          class: "fx-acctmenu__icon",
                          "aria-hidden": "true",
                          innerHTML: u(zt)(k.icon || k.key)
                        }, null, 8, qoe),
                        d("span", Woe, y(k.label), 1)
                      ], 10, joe)
                    ]),
                    _: 2
                  }, 1024))), 128)),
                  u(uA)(e.version) ? (f(), Ge(Boe, {
                    key: 0,
                    version: e.version,
                    class: "fx-acctmenu__version"
                  }, null, 8, ["version"])) : O("", !0)
                ]),
                _: 1
              }, 8, ["style"])
            ]),
            _: 1
          })
        ]))
      ]),
      _: 1
    }));
  }
});
function V0(e, t) {
  const n = t.replace(/\/+$/, ""), a = (i, r) => ({
    method: i,
    headers: { "Content-Type": "application/json" },
    ...r === void 0 ? {} : { body: JSON.stringify(r) }
  });
  return {
    updateProfile: (i) => e(`${n}/api/auth/profile`, a("PATCH", i)),
    checkAccount: (i) => e(`${n}/api/auth/account/check`, a("POST", i)),
    changePassword: async (i, r) => {
      await e(`${n}/api/auth/password`, a("POST", { current_password: i, new_password: r }));
    },
    enrollTotp: () => e(`${n}/api/auth/totp/enroll`, a("POST")),
    verifyTotp: async (i) => {
      await e(`${n}/api/auth/totp/verify`, a("POST", { code: i }));
    },
    disableTotp: async (i) => {
      await e(`${n}/api/auth/totp/disable`, a("POST", { code: i }));
    },
    quota: () => e(`${n}/api/files/quota/me`),
    notificationSettings: () => e(`${n}/api/notifications/settings`),
    updateNotificationSettings: (i) => e(`${n}/api/notifications/settings`, a("PATCH", i)),
    pluginActions: () => e(`${n}/api/files/plugins/actions`),
    vaultIdle: async () => (await e(`${n}/api/files/e2e/vault/prefs`)).idle_minutes,
    setVaultIdle: async (i) => (await e(`${n}/api/files/e2e/vault/prefs`, a("PUT", { idle_minutes: i }))).idle_minutes,
    assistant: () => e(`${n}/api/files/assistant`),
    setAssistantPrefs: (i) => e(`${n}/api/files/assistant/prefs`, a("PUT", i)),
    clearAssistantHistory: async () => {
      await e(`${n}/api/files/assistant/conversations`, a("DELETE"));
    }
  };
}
const Goe = 50, Xoe = 15e3;
function Joe(e) {
  const t = e.transport, n = e.errorText ?? ((re) => re instanceof Error ? re.message : String(re)), a = () => {
    var re;
    return ((re = e.alsoStamp) == null ? void 0 : re.call(e)) ?? [];
  }, i = S([]), r = S(!1), l = S([]), c = S(0), p = S(25), m = S(0), v = S(!1), x = S(!1), w = S(null);
  let $ = 0;
  const k = S(!1);
  let b = null, C = 0;
  const T = S(0), E = A(() => T.value > 0);
  async function R() {
    const re = ++C;
    r.value = !0;
    try {
      const [q, le] = await Promise.all([
        t.list({ unread: !1, limit: Goe, offset: 0 }),
        t.unreadCount()
      ]);
      return re !== C || (i.value = q.items ?? [], T.value = le, b = le), !0;
    } catch {
      return !1;
    } finally {
      re === C && (r.value = !1);
    }
  }
  async function z() {
    try {
      T.value = await t.unreadCount();
    } catch {
    }
  }
  async function D() {
    await z(), b !== T.value && await R();
  }
  async function U(re) {
    const q = Math.max(0, Math.floor(Number(re) || 0));
    T.value = q, b !== q && await R();
  }
  async function H() {
    const re = ++$;
    x.value = !0, w.value = null;
    try {
      const q = await t.list({
        unread: v.value,
        limit: p.value,
        offset: m.value
      });
      if (re !== $) return;
      l.value = q.items ?? [], c.value = q.total ?? 0;
    } catch (q) {
      if (re !== $) return;
      w.value = n(q);
    } finally {
      re === $ && (x.value = !1);
    }
  }
  function L(re) {
    m.value = Math.max(0, (re - 1) * p.value);
  }
  function P(re) {
    v.value = re, m.value = 0;
  }
  function K() {
    k.value = !0, m.value = 0, H();
  }
  function N() {
    k.value = !1;
  }
  async function J(re) {
    var se;
    await t.markRead(re);
    const q = (/* @__PURE__ */ new Date()).toISOString(), le = (fe) => fe.id === re && !fe.read_at ? { ...fe, read_at: q } : fe, ve = [i, l, ...a()], ce = ve.some((fe) => fe.value.some((_) => _.id === re && !_.read_at));
    for (const fe of ve) fe.value = fe.value.map(le);
    ce && T.value > 0 && (T.value -= 1, b !== null && b > 0 && (b -= 1)), (se = e.onRead) == null || se.call(e);
  }
  async function j() {
    var le;
    await t.markAllRead();
    const re = (/* @__PURE__ */ new Date()).toISOString(), q = (ve) => ({ ...ve, read_at: ve.read_at ?? re });
    for (const ve of [i, l, ...a()]) ve.value = ve.value.map(q);
    T.value = 0, b !== null && (b = 0), (le = e.onRead) == null || le.call(e), k.value && v.value && (m.value = 0, H());
  }
  return {
    feed: i,
    feedLoading: r,
    unreadCount: T,
    hasUnread: E,
    mine: l,
    mineTotal: c,
    mineLimit: p,
    mineOffset: m,
    mineUnreadOnly: v,
    mineLoading: x,
    mineError: w,
    panelOpen: k,
    refreshFeed: R,
    fetchUnread: z,
    syncUnread: D,
    acceptCount: U,
    fetchMine: H,
    setMinePage: L,
    setMineUnreadFilter: P,
    openPanel: K,
    closePanel: N,
    markRead: J,
    markAllRead: j
  };
}
function Zoe(e, t) {
  const n = `${t.replace(/\/+$/, "")}/api/notifications`;
  return {
    async list(a) {
      const i = [];
      return a.unread && i.push("unread=true"), a.limit != null && i.push(`limit=${encodeURIComponent(String(a.limit))}`), a.offset != null && i.push(`offset=${encodeURIComponent(String(a.offset))}`), await e(
        i.length ? `${n}?${i.join("&")}` : n
      ) ?? { items: [], total: 0 };
    },
    async unreadCount() {
      const a = await e(`${n}/unread-count`);
      return Math.max(0, Number((a == null ? void 0 : a.count) ?? 0) || 0);
    },
    async markRead(a) {
      await e(`${n}/${encodeURIComponent(String(a))}/read`, { method: "POST" });
    },
    async markAllRead() {
      await e(`${n}/read-all`, { method: "POST" });
    }
  };
}
const Qoe = ["view-list", "view-grid", "view-gallery", "inspector", "nav"], ere = ["theme", "density", "timezone", "shortcut-settings"], Ty = "fe:";
function tre(e, t, n = {}) {
  const a = new Set(n.omit ?? []), i = [...e];
  t.filter((r) => !r.divider && !a.has(r.key)).forEach(
    (r, l) => i.push({
      key: `${Ty}${r.key}`,
      label: r.label,
      icon: r.icon || r.key,
      separated: l === 0
    })
  );
  for (const r of n.tail ?? []) i.push({ ...r, separated: r.separated ?? !0 });
  return i;
}
function nre(e) {
  return e.startsWith(Ty) ? e.slice(Ty.length) : null;
}
function Xn(e) {
  return d2({ loader: e, suspensible: !1 });
}
const are = ["dir"], ire = ["title", "aria-label"], ore = { class: "fe__stack" }, rre = { class: "fe__panes" }, sre = {
  key: 0,
  class: "fe-search-cut",
  role: "status"
}, lre = {
  key: 1,
  class: "fe-search-cut fe-nav-more",
  role: "status",
  "data-testid": "nav-more"
}, ure = ["disabled", "aria-busy"], cre = {
  key: 2,
  class: "fe-coverage",
  role: "status",
  "data-testid": "catalog-coverage"
}, dre = { class: "fe-coverage__text" }, fre = ["disabled", "aria-busy"], pre = {
  key: 3,
  class: "fe__presence"
}, hre = ["title"], mre = {
  key: 4,
  class: "fe-e2e-upgrade",
  role: "alert"
}, vre = { class: "fe-e2e-upgrade__text" }, yre = {
  key: 0,
  class: "fe-e2e-upgrade__escrow"
}, gre = { class: "fe-e2e-upgrade__actions" }, bre = ["disabled"], kre = ["disabled"], wre = {
  key: 5,
  class: "fe-e2e-upgrade fe-e2e-upgrade--escrow",
  role: "alert"
}, _re = { class: "fe-e2e-upgrade__text" }, xre = { class: "fe-e2e-upgrade__escrow" }, Sre = {
  key: 0,
  class: "fe-e2e-upgrade__escrow"
}, $re = {
  key: 1,
  class: "fe-e2e-upgrade__pw"
}, Tre = ["disabled"], Are = {
  key: 2,
  class: "fe-form__error",
  role: "alert"
}, Ere = { class: "fe-e2e-upgrade__actions" }, Cre = ["disabled"], zre = ["disabled"], Mre = {
  key: 6,
  class: "fe-e2e-upgrade fe-e2e-upgrade--names",
  role: "status",
  "data-testid": "e2e-convert-strip"
}, Pre = { class: "fe-e2e-upgrade__text" }, Ore = { key: 0 }, Lre = {
  key: 1,
  class: "fe-e2e-upgrade__progress",
  "data-testid": "e2e-convert-progress"
}, Dre = {
  key: 2,
  class: "fe-e2e-upgrade__progress",
  "data-testid": "e2e-convert-large"
}, Rre = {
  key: 3,
  class: "fe-form__error",
  role: "alert"
}, Nre = { class: "fe-e2e-upgrade__actions" }, Ire = {
  key: 7,
  class: "fe-e2e-upgrade fe-e2e-upgrade--names",
  role: "status",
  "data-testid": "e2e-names-progress-strip"
}, Bre = { class: "fe-e2e-upgrade__text" }, Fre = { key: 0 }, Ure = {
  key: 1,
  class: "fe-e2e-upgrade__progress",
  "data-testid": "e2e-names-progress"
}, Hre = {
  key: 2,
  class: "fe-form__error",
  role: "alert"
}, Kre = { class: "fe-e2e-upgrade__actions" }, Vre = {
  key: 8,
  class: "fe-e2e-upgrade fe-e2e-upgrade--rekey",
  role: "status",
  "data-testid": "e2e-rekey-offer"
}, jre = { class: "fe-e2e-upgrade__text" }, qre = {
  key: 0,
  class: "fe-e2e-upgrade__progress",
  "data-testid": "e2e-rekey-progress"
}, Wre = {
  key: 1,
  class: "fe-form__error",
  role: "alert"
}, Yre = { class: "fe-e2e-upgrade__actions" }, Gre = ["disabled"], Xre = {
  key: 10,
  class: "fe-e2e-strip",
  role: "status"
}, Jre = ["innerHTML"], Zre = { class: "fe-e2e-strip__label" }, Qre = {
  class: "fe-e2e-strip__names",
  "data-testid": "e2e-names-status"
}, ese = ["disabled"], tse = {
  key: 11,
  class: "fe-trashbar"
}, nse = { class: "fe-trashbar__text" }, ase = {
  key: 0,
  class: "fe-trashbar__count",
  "data-testid": "trash-summary"
}, ise = {
  key: 0,
  class: "fe-trashbar__shown"
}, ose = ["disabled"], rse = {
  key: 2,
  class: "fe-trashbar__progress",
  role: "status",
  "aria-live": "polite"
}, sse = ["disabled"], lse = {
  key: 2,
  class: "fe-state"
}, use = { class: "fe-state__title" }, cse = { class: "fe-state__path" }, dse = { class: "fe-state__hint" }, fse = { class: "fe-state__actions" }, pse = {
  key: 0,
  class: "fe-state"
}, hse = { class: "fe-state__title" }, mse = { class: "fe-state__hint" }, vse = ["data-testid"], yse = {
  class: "fe-state__art",
  viewBox: "0 0 120 100",
  width: "110",
  height: "92",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, gse = {
  key: 1,
  d: "M60 26l9 18.6 20.4 3-14.8 14.4 3.5 20.4L60 72.8 41.9 82.4l3.5-20.4L30.6 47.6l20.4-3z"
}, bse = { class: "fe-state__title" }, kse = { class: "fe-state__hint" }, wse = {
  key: 2,
  class: "fe-state"
}, _se = { class: "fe-state__title" }, xse = { class: "fe-state__hint" }, Sse = {
  key: 3,
  class: "fe-state"
}, $se = {
  class: "fe-state__art",
  viewBox: "0 0 120 100",
  width: "110",
  height: "92",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, Tse = { key: 0 }, Ase = { class: "fe-state__title" }, Ese = {
  key: 0,
  class: "fe-state__hint"
}, Cse = {
  key: 1,
  class: "fe-state__actions"
}, zse = { class: "fe-overlay__head" }, Mse = { class: "fe-overlay__title" }, Pse = ["title", "aria-label"], Ose = {
  key: 1,
  class: "fe__dragover"
}, Lse = { class: "fe__dragover-card" }, Dse = ["innerHTML"], Rse = ["title", "aria-label"], Nse = {
  key: 3,
  class: "fe-keep-strip",
  role: "status",
  "aria-live": "polite"
}, Ise = { class: "fe-keep-strip__label" }, Bse = {
  key: 0,
  class: "fe-keep-strip__bar",
  "aria-hidden": "true"
}, Fse = {
  key: 0,
  "data-testid": "trash-empty-count"
}, Use = {
  key: 1,
  class: "fe-form__error",
  role: "alert"
}, Hse = {
  key: 2,
  role: "status"
}, Kse = ["disabled"], Vse = { class: "fe-recents__header" }, jse = ["aria-label"], qse = { class: "fe-modal__head" }, Wse = { class: "fe-modal__title" }, Yse = ["aria-label"], Gse = { class: "fe-modal__body" }, Xse = { class: "fe-toast__msg" }, j0 = "brf-file-explorer:view-mode", kf = 250, q0 = 3, W0 = "user-settings", Jse = 800, Y0 = "filex.inspector", G0 = "filex.sidenav", X0 = 250, Ku = 100, Zse = 500, Qse = 2e3, hi = 2500, yn = 6e3, wf = 10 * 60 * 1e3, J0 = 200, kv = "brf-file-explorer:path", ele = 40, tle = "application/x-brf-files", nle = 8 * 1024 * 1024, ale = 10, ile = "/files/edit", Z0 = "filex.tabs", ole = "https://docs.filex.sh/E2E-ENCRYPTION#what-escrow-can-and-cannot-do", rle = 6e4, sle = 2e3, _he = /* @__PURE__ */ lt({
  __name: "FileExplorer",
  props: {
    config: {}
  },
  emits: ["share-created", "file-opened", "error", "upload-progress", "selection-change", "navigate", "refresh", "open-my-shares", "open-app-store", "open-app-home"],
  setup(e, { expose: t, emit: n }) {
    var Rw;
    const a = () => import("./E2eVaultStrip-lqWMwCh6.js"), i = d2(a), r = Xn(() => import("./PreviewModal-BCSLREup.js").then((o) => o.P)), l = Xn(() => import("./QuickLook-DjTB2lRT.js")), c = Xn(() => import("./UserSettingsDialog-Bo4gqKch.js")), p = Xn(() => import("./TimeZoneDialog-dq6oBb8Y.js")), m = Xn(() => import("./LanguageDialog-BjFvJOVk.js")), v = Xn(() => import("./PermissionsModal-B_sjOGzv.js")), x = Xn(() => import("./AdvancedSearch-BgZdKARk.js")), w = Xn(() => import("./CommandPalette-h8b-Zc8J.js")), $ = Xn(() => import("./NewDocumentModal-DxwEghwu.js")), k = Xn(() => import("./ArchiveCreateModal-Cs4QurlK.js")), b = Xn(() => import("./OnboardingTour-Dazi7ki1.js")), C = Xn(() => import("./ShortcutSettings-Cv_D68zp.js")), T = Xn(() => import("./EncryptedFolderModal-vjaags2g.js")), E = Xn(() => import("./E2eSettingsModal-CskNkUpL.js")), R = Xn(() => import("./E2eChangePasswordModal-DjFgIb2C.js")), z = Xn(() => import("./RecoveryKeyModal-Bx7Gp_it.js")), D = Xn(() => import("./E2eRecoveryUnlockModal-gF3LKkxN.js")), U = Xn(() => import("./E2eFileEncryptModal-ctfdnk2e.js")), H = Xn(() => import("./E2eFileUnlockModal-CeSWu7IJ.js")), L = e, P = n, K = S(""), N = A(() => Kie(L.config)), J = A(
      () => F0({
        embedded: N.value,
        chosen: U0(),
        account: K.value,
        browser: Sv(),
        host: L.config.locale
      })
    ), j = A(() => J.value.locale), re = A(
      () => L.config.locale === j.value ? L.config : { ...L.config, locale: j.value }
    ), q = Rl(L.config, { screenLocale: () => j.value }), le = S(null), ve = A(
      () => {
        var o;
        return L.config.permissions ?? ((o = le.value) == null ? void 0 : o.permissions);
      }
    ), ce = A(
      () => {
        var o;
        return L.config.permissions ? L.config.permissionsByFolder : (o = le.value) == null ? void 0 : o.byFolder;
      }
    );
    let se = Promise.resolve();
    function fe() {
      L.config.permissions || (se = q.myPermissions().then(
        (o) => {
          le.value = o && !o.admin ? { permissions: o.permissions, byFolder: o.byFolder } : null;
        },
        () => {
          le.value = null;
        }
      ));
    }
    jt(fe), Wo(J2, () => j.value), Je(j, (o) => yg(o), { immediate: !0 });
    const { t: _, formatDate: ee, dir: Y } = ht(j), B = Qne({
      http: {
        endpoints: q.endpoints,
        authHeaders: (o) => q.authHeaders(o),
        credentialsMode: () => q.credentialsMode(),
        downloadUrl: (o) => q.downloadUrl(o),
        acceptLanguage: () => gi(j.value)
      },
      headersNow: () => q.authHeadersSync(),
      t: (o, s) => _(o, s),
      toast: (o, s) => qt({ message: o }, s ? yn : hi),
      emitError: (o, s) => P("error", { message: o, context: { op: s } }),
      // The lock's holder says which client: the desktop app is the explorer that
      // was handed the shell's hooks.
      clientKind: () => L.config.desktopSync || L.config.dragOut ? "desktop" : "web",
      dropKeys: (o) => aM(o),
      formatCount: (o) => new Intl.NumberFormat(gi(j.value)).format(o),
      onLocked: (o, s) => iM(o, s),
      onChanged: (o) => oM(o),
      onLockSoon: (o, s) => Xz(o, s),
      askName: (o) => F(o)
    }), W = S(null);
    function F(o) {
      return new Promise((s) => {
        W.value = { ...o, resolve: s };
      });
    }
    function V(o) {
      const s = W.value;
      W.value = null, s == null || s.resolve(o);
    }
    function ke(o) {
      return B.rootOf(o) ?? o;
    }
    function qe(o) {
      const s = String(o ?? "").replace(/\/+$/, ""), g = B.rootOf(s);
      if (!g || !B.isOpen(g)) return null;
      const M = B.rows(s) ? s : g, I = B.permOf(g);
      return {
        adapter: M.slice(0, M.indexOf("://")),
        storages: [],
        dirname: M,
        read_only: !1,
        ...I ? { perm: I } : {},
        e2e_root: g,
        e2e_vault_root: g,
        files: Mr(B.rows(M) ?? [])
      };
    }
    function Me(o) {
      const s = String(o.dirname ?? "").replace(/\/+$/, ""), g = typeof o.e2e_vault_root == "string" && o.e2e_vault_root ? o.e2e_vault_root : B.rootOf(s);
      return g ? { ...o, e2e_vault_root: g, files: [] } : o;
    }
    const Fe = {
      ...q,
      index: async (o) => {
        const s = qe(o);
        if (s) return s;
        const g = B.rootOf(String(o ?? ""));
        return Me(await q.index(g ?? o));
      }
    }, We = () => Promise.reject(new Error("vault: not asked")), $t = {
      ...q,
      listShares: (o) => B.rootOf(o) ? We() : q.listShares(o),
      listPermissions: (o) => B.rootOf(o) ? We() : q.listPermissions(o),
      createShare: (o) => B.rootOf(o.path) ? We() : q.createShare(o)
    };
    function St() {
      typeof document < "u" && document.visibilityState === "visible" && B.onVisible();
    }
    jt(() => {
      typeof document < "u" && document.addEventListener("visibilitychange", St), typeof window < "u" && window.addEventListener("pagehide", B.onPageHide);
    }), Tt(() => {
      typeof document < "u" && document.removeEventListener("visibilitychange", St), typeof window < "u" && window.removeEventListener("pagehide", B.onPageHide), B.closeAll("manual");
    });
    const at = k3(q, {
      reload: () => wt(),
      onVault: (o) => B.onEvent(o),
      onAccess: (o) => QE(o)
    }), kt = at.presenceUsers, pt = at.degraded;
    function Ne(o) {
      const s = (o || "").replace(/^\/+|\/+$/g, "");
      if (s === ".trash" || s.startsWith(".trash/")) return null;
      const g = Rt(s);
      return !g || !g.includes("://") || g.startsWith("://") ? null : B.rootOf(g) ?? g;
    }
    jt(() => {
      at.start(), at.subscribe(Ne(Xe.value));
    }), Tt(() => at.stop());
    const ie = x3(L.config.apiBase, q), xe = OO(L.config, q), he = /* @__PURE__ */ new Map(), De = rx(L.config, q, {
      onSettled: (o) => {
        var M, I;
        const s = he.get(o.id);
        if (he.delete(o.id), o.op_type === "trash-empty") {
          wt();
          return;
        }
        const g = sm.get(o.id);
        if (g) {
          sm.delete(o.id), bu(g, !1);
          const X = o.summary || (o.status === "error" ? Xf(o, _).text : "");
          X && o.status !== "cancelled" && qt({ message: X }, o.status === "done" ? hi : yn), Ft.value && zi();
          return;
        }
        if (o.status === "cancelled") {
          const X = o.op_type === "archive-extract" ? _("archive.extraction_cancelled", { count: o.progress_done }) : _("opc.status.aborted");
          tt(X);
        } else if (o.op_type === "restore" && o.summary)
          qt({ message: o.summary }, o.status === "done" ? hi : yn);
        else if (o.status === "error")
          tt(Xf(o, _).text);
        else if (s)
          $d(o.op_type === "rename" ? s.message : `${s.message} (${o.progress_total})`, s.fn);
        else if (o.op_type === "plugin") {
          tt(o.message || _("plugin.done", { label: FA(o) }));
          const X = FS(o, { busy: !!In.value || !!La.value });
          if (X) {
            dh(X.plugin, X.open), (M = Zt.value) == null || M.reload();
            return;
          }
        } else if (o.op_type === "rename")
          tt(_("toast.renamed"));
        else if (o.op_type === "restore")
          tt(_("toast.restored", { n: o.progress_done }));
        else {
          const X = o.op_type === "archive-create" ? _("archive.created") : o.op_type === "archive-extract" ? _("archive.extraction_completed") : o.op_type === "copy" ? _("toast.copied") : o.op_type === "move" ? _("toast.moved") : _("toast.deleted");
          tt(o.op_type.startsWith("archive-") ? X : `${X} (${o.progress_total})`);
        }
        wt(), (I = Zt.value) == null || I.reload();
      }
    }), ot = S(!1), ft = (L.config.rootPath || "").trim(), gt = ft.replace("://", "/").replace(/^\/+|\/+$/g, ""), Ut = gt || L.config.initialPath || "", Xe = S(Ut), Ve = AJ(), Be = (o) => Ve.isNewest(o), ne = S(L.config.defaultAdapter || "brf"), ge = S(Ut), G = S([]), ye = S(""), te = S(!1), Ce = S(""), Ie = S("");
    let _e;
    function Ae() {
      wt(_e);
    }
    const Pe = S(
      (() => {
        try {
          const o = localStorage.getItem(j0);
          if (o === "list" || o === "grid" || o === "gallery") return o;
        } catch {
        }
        return L.config.viewMode ?? "list";
      })()
    ), _t = S("comfortable"), Et = S(""), xn = S(!1), Dt = S({}), bn = S({}), ln = S({});
    let Jt = null;
    function Ln() {
      if (!Jt) {
        const o = ca(L.config);
        Jt = _ie({
          list: async () => {
            const s = await q.jsonFetch(`${o}/api/admin/storages`);
            return Array.isArray(s) ? s : [];
          }
        });
      }
      return Jt;
    }
    function Vn(o) {
      return !!o && o in ln.value;
    }
    const Ft = S(!1), na = S(""), Kt = A(() => Ft.value), bt = S(""), Dn = S(""), Nn = A(
      () => bt.value !== "" && bt.value !== "trash" && bt.value !== "home"
    ), Cn = A(
      () => bt.value === "recent" || bt.value === "starred" || bt.value === "shared" || bt.value === "tag"
    ), fn = A(() => L.config.rememberFolderView !== !1), mn = A(() => {
      if (!fn.value) return "";
      const o = String(Xe.value ?? "").replace(/^\/+|\/+$/g, "");
      if (!o) return G4;
      const [s, ...g] = o.split("/"), M = (L.config.storages ?? []).find((I) => I.name === s);
      return q_((M == null ? void 0 : M.uid) || s, g.join("/"));
    });
    function aa() {
      const o = Kp().v;
      if (o) return o;
      if (!Xs())
        try {
          const s = localStorage.getItem(j0);
          if (s === "list" || s === "grid" || s === "gallery") return s;
        } catch {
        }
      return L.config.viewMode ?? "list";
    }
    Ey(
      ES(() => {
        Xs() && Mn(mn.value);
      })
    );
    let zn = null;
    function Mn(o) {
      if (!o && fn.value) return;
      J4(o);
      const s = o ? t5(o) : {}, g = s.v ?? aa();
      if (g !== Pe.value && (Pe.value = g), s.k) a1(s.k, s.d ?? El(s.k));
      else {
        const M = gg();
        a1(M.key, M.dir);
      }
      zn = { key: o, v: Pe.value, k: t1(), d: n1() };
    }
    jt(() => {
      m5({
        apiBase: L.config.apiBase ?? "",
        headers: Qn,
        credentials: q.credentialsMode()
      });
    }), Je(
      [mn, () => Xs()],
      ([o, s]) => {
        s && Mn(o);
      },
      { immediate: !0, flush: "post" }
    ), Je(
      () => [mn.value, Pe.value, t1(), n1()],
      ([o, s, g, M]) => {
        if (!Xs() || !zn || zn.key !== o) return;
        const I = {};
        s !== zn.v && (I.v = s), (g !== zn.k || M !== zn.d) && (I.k = g, I.d = M), zn = { key: o, v: s, k: g, d: M }, Object.keys(I).length && (o ? _S(o, I) : fn.value || SS(I));
      },
      /* ⚠⚠ `post`, and registered AFTER the applier: a navigation changes
       * `currentFolderKey`, which both watchers depend on. Pre-flush this would
       * run first, while the view state is still the folder you LEFT, and record
       * that folder's setup against the one you arrived in. */
      { flush: "post" }
    ), Je(
      () => Qv(mn.value),
      (o, s) => {
        s && !o && Xs() && Mn(mn.value);
      }
    );
    const rn = S(""), me = S(""), Le = {
      home: ".home",
      recent: ".recent",
      starred: ".starred",
      shared: ".shared",
      drafts: ".drafts"
    };
    function Ue(o) {
      if (!vS(o)) return null;
      const s = String(o ?? "").replace(/^\/+|\/+$/g, ""), g = V4(s);
      return g ? { kind: "tag", tag: g, tagKind: K4(s) } : { kind: s.slice(1), tag: "", tagKind: "" };
    }
    const He = A(() => {
      if (!Sn.value) return "";
      const o = L.config.storages ?? [];
      return o.length === 1 ? o[0].name : "";
    }), xt = A(() => {
      const o = (Xe.value ?? "").replace(/^\/+|\/+$/g, "");
      return gt && o === gt || He.value && o === He.value ? !1 : o.length > 0;
    }), Qe = A(() => bt.value && bt.value !== "trash" ? !0 : Sn.value ? !(Xe.value ?? "").replace(/^\/+|\/+$/g, "") : !1), ue = A(
      () => bt.value === "home" ? "find" : "full"
    );
    function je() {
      if (Ft.value) {
        wt(na.value);
        return;
      }
      if (bt.value) {
        wt(Dn.value);
        return;
      }
      const o = (Xe.value ?? "").replace(/^\/+|\/+$/g, "");
      if (!o || o === gt || He.value && o === He.value) return;
      const s = o.lastIndexOf("/");
      let g = s === -1 ? "" : o.slice(0, s);
      gt && !(g === gt || g.startsWith(gt + "/")) && (g = gt), wt(g);
    }
    const dt = S([]), It = A(
      () => (dt.value.length ? dt.value : G.value).filter((o) => o.type !== "dir")
    ), hn = A(() => {
      var M;
      const o = It.value, s = (M = pn.value) == null ? void 0 : M.path, g = s ? o.findIndex((I) => I.path === s) : -1;
      return { index: g === -1 ? 0 : g + 1, total: g === -1 ? 0 : o.length };
    });
    async function nn(o) {
      const s = It.value, g = s.findIndex((I) => {
        var X;
        return I.path === ((X = pn.value) == null ? void 0 : X.path);
      });
      if (g === -1) return;
      const M = s[g + o];
      if (M) {
        if (Ui(M) && !an.value && !M.e2e_root) {
          la.value = !1, Mt.open(M);
          return;
        }
        if (Yn.value && M.type === "file")
          try {
            await ef(M);
          } catch {
            tt(_("e2e.decrypt_failed"));
            return;
          }
        pn.value = M;
      }
    }
    function ae(o) {
      const s = Date.now(), g = /* @__PURE__ */ new Set([...G.value, ...dt.value]);
      pn.value && g.add(pn.value);
      for (const M of g)
        M.path === o.path && (typeof o.size == "number" && (M.size = o.size), M.last_modified = s);
    }
    const oe = g_(() => dt.value.length ? dt.value : G.value);
    Je(
      () => [...oe.selected.value],
      () => {
        P(
          "selection-change",
          /* wiring:e2 names — `basename` stays what the server calls the item
             (hosts pass it back to the API); an encrypted-names row adds its
             plaintext as `display_name` for a host that draws it. */
          oe.nodes.value.map((s) => ({
            path: s.path,
            basename: Mf(s),
            type: s.type,
            ...s.e2e_stored ? { display_name: s.basename } : {}
          }))
        );
        const o = oe.nodes.value.filter((s) => s.type === "file");
        at.setFocus(o.length === 1 && !B.isVaultRow(o[0]) ? Mf(o[0]) : null);
      }
    );
    const ze = S({ mode: null, items: [], sourcePath: null }), Ke = S(null);
    let it = null;
    function Z() {
      return it || (q.endpoints.capabilities ? (it = (async () => {
        for (let o = 1; o <= q0; o++)
          try {
            Ke.value = await q.capabilities();
            return;
          } catch (s) {
            if (o === q0) {
              P("error", {
                message: `capabilities: ${(s == null ? void 0 : s.message) ?? String(s)}`,
                context: { what: "capabilities", attempts: o }
              });
              return;
            }
            await new Promise((g) => setTimeout(g, 200 * o));
          }
      })(), it) : (it = Promise.resolve(), it));
    }
    const Q = S(!1);
    let we = null;
    function Ye() {
      return we || (we = q.jsonFetch(`${ca(L.config)}/api/auth/me`), we.catch(() => {
        we = null;
      })), we;
    }
    const rt = yZ({
      config: () => L.config,
      capabilities: Ke,
      fetchMe: () => Ye()
    }), vt = L.config.notifications ? c2(
      Joe({
        // The server says each row in the language on screen (`lang=`).
        transport: Zoe(q.jsonFetch, ca(L.config)),
        errorText: (o) => (o == null ? void 0 : o.message) || _("inspector.error"),
        onRead: () => {
          var o, s;
          return (s = (o = L.config.notifications) == null ? void 0 : o.onRead) == null ? void 0 : s.call(o);
        }
      })
    ) : null;
    let Bt = null;
    jt(() => {
      var s;
      const o = L.config.notifications;
      !vt || !o || (vt.refreshFeed(), o.poll !== !1 && (Bt = setInterval(() => void vt.syncUnread(), Xoe)), (s = o.onUnread) == null || s.call(o, (g) => void vt.acceptCount(g)));
    }), Tt(() => {
      Bt && clearInterval(Bt), Bt = null;
    }), Je(j, () => {
      vt && (vt.refreshFeed(), vt.panelOpen && vt.fetchMine());
    });
    const Qt = A(() => {
      var g, M, I;
      const o = (M = (g = L.config.notifications) == null ? void 0 : g.manage) == null ? void 0 : M.href;
      return o && (pa.value || ((I = Un.value) == null ? void 0 : I.role) === "admin") ? o : void 0;
    });
    function en() {
      var o, s;
      (s = (o = L.config.notifications) == null ? void 0 : o.manage) == null || s.open();
    }
    let Ot = () => {
    };
    const kn = new Promise((o) => {
      Ot = o;
    });
    async function Pa(o) {
      var M;
      if (await kn, o.kind === "none") return !1;
      if (o.kind === "share")
        return window.open(rA(o.token, ca(L.config)), "_blank", "noopener"), !0;
      if (o.kind === "app")
        return await Z(), await Oa.refresh(), await pb(`${o.plugin}/${o.view}`), !0;
      const s = eoe(o);
      if (!s) return !1;
      s === Tp ? await wt(Tp) : await wt(Sn.value ? Co(s) : Va(s));
      const g = o.select;
      if (g) {
        const I = G.value.find((X) => H0(X.path, g));
        if (I) {
          oe.click(I.path), await Gt();
          const X = Array.from(((M = Tn.value) == null ? void 0 : M.querySelectorAll("[data-fe-path]")) ?? []).find(
            (de) => H0(de.getAttribute("data-fe-path"), g)
          );
          X == null || X.scrollIntoView({ block: "center" });
        }
      }
      if (o.kind === "folder" && o.open) {
        const I = o.select || s;
        await ch({ plugin: o.open.plugin, action: o.open.action, view: o.open.view, path: I });
      }
      return !0;
    }
    function un(o) {
      Pa(iA(o.target));
    }
    const pe = A(() => {
      var o;
      return (L.config.callerKind ?? ((o = Ke.value) == null ? void 0 : o.caller_kind)) === "user";
    });
    function be() {
      return {
        person: pe.value,
        embedded: N.value,
        host: L.config.locale,
        me: Ye,
        updateProfile: (o) => V0(q.jsonFetch, ca(L.config)).updateProfile(o)
      };
    }
    function Oe() {
      Vie(be()).then((o) => {
        o && (K.value = o);
      });
    }
    let st = !1;
    Je(
      pe,
      (o) => {
        if (!o) {
          K.value = "";
          return;
        }
        st || (st = !0, Oe());
      },
      { immediate: !0 }
    ), Je(
      () => L.config.locale,
      () => {
        N.value || (K.value = "");
      }
    );
    const tn = S(!1), Lt = A(
      () => F0({
        embedded: !0,
        chosen: "",
        account: K.value,
        browser: Sv(),
        host: L.config.locale
      })
    );
    function xa(o) {
      const s = jie(o, be());
      s && pe.value && (K.value = s);
    }
    jt(() => {
      N.value && fP({
        base: ca(L.config),
        headers: () => q.authHeaders(),
        timeoutMs: cP
      });
    });
    const Un = S(((Rw = L.config.account) == null ? void 0 : Rw.person) ?? null);
    jt(() => {
      !L.config.account || L.config.account.person || Ye().then((o) => {
        Un.value = (o == null ? void 0 : o.user) ?? null;
      }).catch(() => {
      });
    });
    const Si = S([]);
    let ir = null;
    function Ul(o) {
      if (!L.config.account) return;
      const s = o.detail;
      !s || !Array.isArray(s.items) || (s.claimed = !0, o.stopPropagation(), Si.value = s.items, ir = typeof s.run == "function" ? s.run : null);
    }
    jt(() => {
      var o;
      return (o = Tn.value) == null ? void 0 : o.addEventListener("fe:header-menu", Ul);
    }), Tt(() => {
      var o;
      return (o = Tn.value) == null ? void 0 : o.removeEventListener("fe:header-menu", Ul);
    });
    const To = A(() => {
      const o = L.config.account;
      if (!o) return [];
      const s = Un.value, g = typeof o.actions == "function" ? o.actions(s) : o.actions ?? [], M = o.settings ? [{ key: W0, label: _("userSettings.open"), icon: "account" }, ...g] : g, I = typeof o.tail == "function" ? o.tail(s) : o.tail ?? [], X = Qoe.filter((Se) => Se !== "inspector" || L.config.showInfoPanel !== !1), de = o.settings ? ere : [];
      return tre(M, Si.value, {
        omit: [...X, ...de, ...o.omit ?? []],
        tail: I
      });
    });
    function ad(o) {
      var g, M;
      const s = nre(o);
      if (s !== null) {
        ir == null || ir(s);
        return;
      }
      if (o === W0 && ((g = L.config.account) != null && g.settings)) {
        id.value = !0;
        return;
      }
      (M = L.config.account) == null || M.select(o, Un.value);
    }
    const id = S(!1), xA = {
      get locale() {
        return String(j.value);
      },
      get user() {
        return Un.value;
      },
      get isAdmin() {
        var o;
        return ((o = Un.value) == null ? void 0 : o.role) === "admin";
      },
      get demoReadOnly() {
        var o;
        return ((o = Ke.value) == null ? void 0 : o.demo_mode) === !0;
      },
      get capabilities() {
        return Ke.value;
      },
      api: V0(q.jsonFetch, ca(L.config)),
      setUser(o) {
        Un.value = { ...Un.value ?? {}, ...o };
      },
      toast(o, s) {
        qt({ message: s }, o === "success" ? hi : yn);
      },
      errorText: (o, s) => (o == null ? void 0 : o.message) || s,
      zone: rO(rt),
      mode: {
        get: () => {
          const o = ku.value === "host" ? L.config.theme || "auto" : ku.value;
          return o === "light" || o === "dark" ? o : "auto";
        },
        set: (o) => sb(o)
      },
      // The rows only the host can carry out (ExplorerConfig.account.settings as
      // an object, task #258): the desktop app's language, its click setting and
      // its own notifications. Read per access, so a host that swaps its config
      // is followed.
      get language() {
        var o;
        return (o = od()) == null ? void 0 : o.language;
      },
      get openTrigger() {
        var o;
        return (o = od()) == null ? void 0 : o.openTrigger;
      },
      get deviceNotifications() {
        var o;
        return (o = od()) == null ? void 0 : o.deviceNotifications;
      }
    };
    function od() {
      var s;
      const o = (s = L.config.account) == null ? void 0 : s.settings;
      return o && typeof o == "object" ? o : void 0;
    }
    function sb(o) {
      var s;
      qk(o), (s = L.config.accountPrefs) != null && s.surface && (o === "light" || o === "dark" || o === "auto") && Zi("theme", o);
    }
    jt(() => {
      var s;
      const o = (s = L.config.accountPrefs) == null ? void 0 : s.surface;
      o && (VF({ surface: o, base: ca(L.config), headers: () => q.authHeaders() }), XF().then((g) => {
        g && ((g.theme === "light" || g.theme === "dark" || g.theme === "auto") && qk(g.theme), AT(g.palette), vZ(g.density));
      }));
    });
    const SA = A(
      () => {
        var o, s;
        return ((o = Ke.value) == null ? void 0 : o.share_link_max_days) ?? ((s = Ke.value) == null ? void 0 : s.share_max_ttl_days) ?? 0;
      }
    ), or = A(() => {
      var o, s;
      return typeof L.config.plugins == "boolean" ? L.config.plugins : ((s = (o = Ke.value) == null ? void 0 : o.app_plugins) == null ? void 0 : s.enabled) === !0;
    }), Oa = u3(q, () => or.value), In = S(null);
    let lb = 0;
    const sh = S(!1);
    let lh;
    Tt(() => clearTimeout(lh));
    function $A(o) {
      const s = ++lb;
      return In.value = { ...o, surface: null, ticket: s }, sh.value = !1, clearTimeout(lh), lh = setTimeout(() => {
        rd(s) && (sh.value = !0);
      }, Jse), s;
    }
    const TA = A(
      () => !!In.value && (In.value.surface !== null || sh.value)
    );
    function rd(o) {
      var s;
      return o > 0 && ((s = In.value) == null ? void 0 : s.ticket) === o;
    }
    const La = S(null);
    function AA(o) {
      return o.filter((s) => s.type === "file").map((s) => ({
        path: s.path,
        name: s.basename,
        size: s.size,
        mime: s.mime_type,
        readOnly: !!s.read_only || !io(s),
        ...s.encrypted ? { encrypted: s.encrypted } : {}
      }));
    }
    const Hl = A(() => or.value ? Oa.views.value : []), Kl = A(() => or.value ? Oa.openRules.value : {}), ub = A(() => ({ onlyOffice: !!rr.value }));
    function rs(o) {
      return { ...ub.value, inEncrypted: an.value || B.isVaultRow(o), e2ePlaintext: !!uh(o) };
    }
    function uh(o) {
      var M;
      if (Wn.value, !o || o.type !== "file" || Ui(o) || ((M = Ke.value) == null ? void 0 : M.apps_e2e_plaintext) !== !0) return null;
      if (B.isVaultRow(o)) return EA(o);
      if (o.encrypted && o.encrypted !== "folder") return null;
      const s = typeof o.e2e_root == "string" && o.e2e_root || (an.value ? Ct.value : null), g = Vt.rootOf(o.path, s);
      return !g || !sn.has(g) ? null : g;
    }
    function EA(o) {
      B.version.value;
      const s = typeof o.vault_root == "string" ? o.vault_root : "";
      return s && B.isOpen(s) ? s : null;
    }
    function Vl(o, s, g) {
      const M = qu(Hl.value, o, s, Kl.value, jl(o), rs(o));
      return M != null && M.view ? ($i.value = s, Ha.value = g === "edit" && io(o) ? "edit" : "view", pn.value = o, la.value = !0, P("file-opened", { path: o.path, basename: o.basename }), Ua(o), !0) : !1;
    }
    function cb(o) {
      return K$(Hl.value, o, Kl.value, rs(o));
    }
    function jl(o) {
      return o ? Lie(Lr(o)) : null;
    }
    const $i = S(null), db = A(
      () => qu(
        Hl.value,
        pn.value,
        $i.value,
        Kl.value,
        jl(pn.value),
        rs(pn.value)
      )
    ), fb = A(() => {
      var o;
      return ((o = db.value) == null ? void 0 : o.view) ?? null;
    }), CA = A(() => Rf(db.value));
    function zA(o) {
      return Rf(o) ? _("ctx.open_with", { app: "ONLYOFFICE" }) : o.view ? _("ctx.open_with", { app: Xt(o.view.label, j.value) || o.view.plugin }) : _("ctx.open_with_builtin");
    }
    function MA(o) {
      var M;
      if (o.length !== 1) return [];
      const { on: s } = cb(o[0]), g = !F$(o[0], rs(o[0])) && ((M = o[0]) == null ? void 0 : M.type) === "file" && eh(Lr(o[0])) && !ub.value.onlyOffice ? [
        {
          key: `open-with:${Ll}`,
          label: _("ctx.open_with", { app: "ONLYOFFICE" }),
          icon: "open",
          testid: `ctx-open-with-${Ll}`,
          ...Fm(!1, pa.value, _("ctx.needs_onlyoffice"))
        }
      ].filter((I) => !I.hidden) : [];
      return s.length < 2 && g.length === 0 ? [] : [
        ...s.map((I) => ({ key: `open-with:${I.id}`, label: zA(I), icon: "open", testid: `ctx-open-with-${I.id}` })),
        ...g,
        ...s.length < 2 ? [] : [{ key: "open-with-choose", label: _("ctx.open_with_choose"), icon: "open", testid: "ctx-open-with-choose" }]
      ];
    }
    const Da = S(null), PA = A(() => cb(Da.value).on), OA = A(
      () => Da.value && !HU(Da.value) ? Lr(Da.value) : ""
    ), LA = A(() => {
      var s;
      const o = Da.value;
      return o ? ((s = qu(Hl.value, o, null, Kl.value, jl(o), rs(o))) == null ? void 0 : s.id) ?? null : null;
    });
    function DA(o, s) {
      const g = Da.value;
      if (!g) return;
      const M = Lr(g);
      if (Da.value = null, s && M && Die(M, o), (Yn.value || B.isVaultRow(g)) && uh(g)) {
        (o === bo || !Vl(g, o, "edit")) && ($i.value = bo, Is(g));
        return;
      }
      Dd(g), $i.value = o, o !== "builtin" && io(g) && (Ha.value = "edit");
    }
    const RA = Rie();
    Tt(RA);
    const NA = A(
      () => or.value ? Oa.views.value.filter((o) => o.placement === "inspector") : []
    ), IA = A(
      () => or.value ? Oa.views.value.filter((o) => o.placement === "home").map((o) => ({ key: `${o.plugin}/${o.id}`, label: Xt(o.label, j.value) || o.id, icon: o.icon })) : []
    );
    async function pb(o) {
      const s = Oa.views.value.find((g) => `${g.plugin}/${g.id}` === o);
      if (s) {
        if (Eo(), L.config.appHomePage === !0) {
          P("open-app-home", { plugin: s.plugin, view: s.id });
          return;
        }
        if (s.ui) {
          La.value = {
            plugin: s.plugin,
            view: s.id,
            placement: "home",
            ui: s.ui,
            label: Xt(s.label, j.value) || s.plugin,
            files: []
          };
          return;
        }
        try {
          const g = await q.pluginView(s.plugin, s.id);
          if (!(g != null && g.surface)) {
            tt(_("plugin.view.error"));
            return;
          }
          In.value = { plugin: s.plugin, view: s.id, surface: g.surface, size: "xl" };
        } catch (g) {
          tt((g == null ? void 0 : g.message) || _("plugin.view.error"));
        }
      }
    }
    const Ti = S(null);
    function BA(o) {
      return or.value ? o3(Oa.actions.value, o, {
        locale: j.value,
        trash: Kt.value,
        e2e: an.value,
        readOnly: te.value || Jb(o),
        // The level each row answers with — the same one the built-in verbs
        // read — so an app's row a viewer could only be refused is not offered.
        permOf: (s) => Lh(s),
        hasIcon: (s) => zt(s) !== "",
        // Greyed rows with the reason are an ADMINISTRATOR's (the server sends
        // `gated` to them only; asked here too, so no other caller draws one).
        needWords: pa.value ? (s) => QO(s, _) : void 0
      }) : [];
    }
    function FA(o) {
      return o.label || o.action || _("opc.kind.plugin");
    }
    function UA(o) {
      var s;
      if (!(!o.plugin || !o.action))
        return (s = Oa.actions.value.find((g) => g.plugin === o.plugin && g.id === o.action)) == null ? void 0 : s.output_mode;
    }
    async function hb(o, s) {
      const g = Oa.byKey(o);
      if (!g || s.length === 0) return;
      if (Xt(g.confirm, j.value)) {
        Ti.value = { action: g, targets: s };
        return;
      }
      await vb(g, s);
    }
    async function HA() {
      const o = Ti.value;
      Ti.value = null, o && await vb(o.action, o.targets);
    }
    function mb(o, s) {
      var Se, $e, ut;
      const g = o.view, M = L.config.pluginPageBase;
      if (!g || M === void 0) return !1;
      const I = { plugin: o.plugin, view: g, path: (Se = s[0]) == null ? void 0 : Se.path }, X = ox(M, I);
      if (((ut = ($e = L.config).openPluginPage) == null ? void 0 : ut.call($e, { ...I, url: X })) === !0) return !0;
      const de = window.open(X, "_blank");
      if (!de)
        return tt(_("plugin.page_view.blocked")), !1;
      try {
        de.opener = null;
      } catch {
      }
      return !0;
    }
    function ql(o, s, g = {}) {
      const M = L.config.refusalToasts !== !1, I = oy(o);
      I ? M && tt(Yr(I, { t: _, formatDate: ee, locale: j.value })) : !g.inDialog && M && qt({ message: g.words ?? Zn(o) }, yn), P("error", { message: (o == null ? void 0 : o.message) ?? String(o), context: s });
    }
    function Wl(o, s, g, M, I = Zn(g)) {
      ql(g, M, { inDialog: o.refuse(s, I), words: I });
    }
    function Zn(o, s = _("toast.failed")) {
      return P2(o, s, { t: _, callerAdmin: pa.value }).text;
    }
    async function vb(o, s) {
      var X;
      const g = Xt(o.label, j.value);
      if (Qf(o.view_placement) && mb(o, s)) return;
      if (o.ui) {
        La.value = {
          plugin: o.plugin,
          view: o.view || o.id,
          placement: "modal",
          ui: o.ui,
          label: g || o.plugin,
          files: AA(s)
        };
        return;
      }
      const M = {
        plugin: o.plugin,
        view: o.view || o.id,
        path: (X = s[0]) == null ? void 0 : X.path,
        paths: s.map((de) => de.path),
        label: g
      }, I = o.view ? $A(M) : 0;
      try {
        const de = await Oa.run(o, s);
        if (de.surface) {
          if (o.view && !rd(I)) return;
          In.value = { ...M, surface: de.surface, ticket: I || ++lb };
          return;
        }
        rd(I) && (In.value = null), de.op && Yl(de.op, g);
      } catch (de) {
        rd(I) && (In.value = null);
        const Se = de, $e = oy(Se);
        $e ? tt(Yr($e, { t: _, formatDate: ee, locale: j.value })) : qt({ message: Zn(Se, _("plugin.failed", { label: g })) }, yn);
      }
    }
    function Yl(o, s) {
      De.register(o);
      const g = s || (typeof o.label == "string" ? o.label : "") || _("opc.kind.plugin");
      tt(_("plugin.queued", { label: g }));
    }
    async function ch(o) {
      if (!o.plugin || !o.path) return !1;
      if (await Z(), !or.value)
        return P("error", {
          message: "app plugins are off on this instance - deep link ignored",
          context: { what: "openAppTarget", plugin: o.plugin, path: o.path }
        }), !1;
      await Oa.refresh();
      const s = G.value.find((M) => M.path === o.path) ?? { path: o.path, basename: o.path.split("/").pop() ?? o.path, type: "file" };
      if (o.action) {
        const M = Oa.byKey(`plugin:${o.plugin}/${o.action}`);
        return M ? (await hb(Zy(M), [s]), !0) : (tt(_("plugin.not_applicable")), P("error", {
          message: `no such plugin action: ${o.plugin}/${o.action}`,
          context: { what: "openAppTarget", path: o.path }
        }), !1);
      }
      if (!o.view) return !1;
      const g = Oa.actions.value.find((M) => M.plugin === o.plugin && M.view === o.view);
      if (g && Qf(g.view_placement) && mb(g, [s]))
        return !0;
      try {
        const M = await q.pluginView(o.plugin, o.view, o.path);
        return M != null && M.surface ? (In.value = { plugin: o.plugin, view: o.view, surface: M.surface, path: o.path }, !0) : (tt(_("plugin.view.error")), !1);
      } catch (M) {
        return tt((M == null ? void 0 : M.message) || _("plugin.view.error")), !1;
      }
    }
    async function dh(o, s) {
      if (!o || !(s != null && s.path)) return;
      In.value = null;
      const g = s.path.indexOf("://"), M = g === -1 ? "" : s.path.slice(0, g), I = Va(s.path).replace(/^\/+|\/+$/g, ""), X = I.lastIndexOf("/"), de = X === -1 ? "" : I.slice(0, X), Se = Sn.value && M ? de ? `${M}/${de}` : M : de;
      try {
        await wt(Se);
      } catch {
      }
      await ch({ plugin: o, action: s.action, view: s.view, path: s.path });
    }
    async function KA(o, s) {
      const g = s.indexOf("://"), M = g === -1 ? "" : s.slice(0, g), I = Va(s).replace(/^\/+|\/+$/g, ""), X = I.lastIndexOf("/"), de = X === -1 ? "" : I.slice(0, X), Se = Sn.value && M ? de ? `${M}/${de}` : M : de;
      await wt(Se);
      const $e = G.value.find((ut) => ut.path === s);
      if ($e) {
        oe.click($e.path);
        return;
      }
      tt(_("plugin.output_missing"));
    }
    const ss = S(/* @__PURE__ */ new Map()), ls = S(!1), Gl = S(!1), Xl = S(null), yb = S(0);
    function gb(o) {
      return typeof o.id != "number" ? !1 : ss.value.get(o.id) ?? o.starred === !0;
    }
    function fh(o, s) {
      const g = new Map(ss.value);
      g.set(o, s), ss.value = g;
    }
    const bb = A(() => {
      const o = /* @__PURE__ */ new Set();
      for (const s of G.value) gb(s) && o.add(s.id);
      for (const [s, g] of ss.value) g && o.add(s);
      return o;
    });
    function kb(o, s) {
      typeof o.id == "number" && fh(o.id, s);
    }
    function ph(o) {
      return gs.value ? o.filter((s) => typeof s.id == "number" && s.type === "file") : [];
    }
    function wb(o) {
      const s = ph(o);
      return s.length > 0 && s.every((g) => gb(g));
    }
    async function _b(o) {
      const s = ph(o);
      if (s.length === 0) return;
      const g = !wb(s), M = {
        apiBase: L.config.apiBase ?? "",
        authHeaders: () => Qn(),
        authCredentials: q.credentialsMode()
      };
      for (const X of s) fh(X.id, g);
      let I = 0;
      await Promise.all(
        s.map(async (X) => {
          try {
            await gT(X.id, g, M);
          } catch {
            I += 1, fh(X.id, !g);
          }
        })
      ), I > 0 && tt(_("star.failed")), bt.value === "starred" && await uu("starred");
    }
    async function Ua(o) {
      if (typeof o.id == "number")
        try {
          const s = L.config.apiBase ?? "";
          await fetch(`${s}/api/files/manager/recent`, {
            method: "POST",
            headers: await Qn({ "Content-Type": "application/json" }),
            credentials: q.credentialsMode(),
            body: JSON.stringify({ node_id: o.id })
          }), yb.value += 1;
        } catch {
        }
    }
    function VA(o) {
      typeof o.id == "number" && (Xl.value = o, Gl.value = !0);
    }
    function jA(o, s = "") {
      Gl.value = !1, _s(o, s);
    }
    function qA() {
      Ph(), bt.value === "tag" && rn.value && _s(rn.value, me.value);
    }
    const WA = sD(qA);
    Tt(WA);
    function YA(o) {
      const s = vd(o) ?? {
        type: "file",
        path: o.path,
        basename: o.name,
        extension: (o.name.split(".").pop() || "").toLowerCase(),
        id: o.id
      };
      ls.value = !1, qa(s);
    }
    function GA(o, s) {
      const g = vd(o);
      g && (ls.value = !1, tm(g, s));
    }
    const rr = A(() => {
      var s, g, M;
      if (L.config.onlyOfficeBase) return L.config.onlyOfficeBase;
      const o = (g = (s = Ke.value) == null ? void 0 : s.external) == null ? void 0 : g.onlyoffice;
      return o && !xv(o) ? null : ((M = Ke.value) == null ? void 0 : M.onlyoffice_url) || null;
    }), pa = A(() => {
      var o;
      return ((o = Ke.value) == null ? void 0 : o.caller_admin) === !0;
    });
    function sd(o) {
      var s, g;
      return ((g = (s = Ke.value) == null ? void 0 : s.queued) == null ? void 0 : g.includes(o)) === !0;
    }
    const xb = A(() => rr.value && q.endpoints.onlyOfficeConfig || null), Jl = A(() => {
      var g, M, I;
      const o = L.config.drawioUrl || L.config.drawioBase;
      if (o) return o;
      const s = (M = (g = Ke.value) == null ? void 0 : g.external) == null ? void 0 : M.drawio;
      return s && !xv(s) ? null : ((I = Ke.value) == null ? void 0 : I.drawio_url) || null;
    }), Sb = A(() => {
      var o;
      return ((o = Ke.value) == null ? void 0 : o.newdoc_types) ?? null;
    }), XA = A(() => {
      const o = Sb.value;
      return !o || o.length === 0 ? !1 : o.some(
        (s) => s.requires === "onlyoffice" ? !!rr.value : s.requires === "drawio" ? !!Jl.value : !0
      );
    }), sr = A(() => {
      var o;
      return !!((o = Ke.value) != null && o.drafts);
    }), us = S(0), hh = S([]), mh = S(0), vh = S(!1), lr = S(null);
    async function yh() {
      if (!sr.value) {
        us.value = 0;
        return;
      }
      try {
        const { count: o, limit: s } = await q.drafts.count();
        us.value = o, mh.value = s;
      } catch {
      }
    }
    async function $b() {
      vh.value = !0;
      try {
        const o = await q.drafts.list();
        hh.value = o.drafts, mh.value = o.limit, us.value = o.count;
      } catch (o) {
        hh.value = [];
        const s = Zn(o);
        P("error", { message: s, context: { op: "nav-view:drafts" } }), tt(s);
      } finally {
        vh.value = !1;
      }
    }
    async function Zl() {
      bt.value === "drafts" ? await $b() : await yh();
    }
    Je(sr, (o) => void (o ? yh() : us.value = 0), { immediate: !0 });
    function JA(o) {
      const s = o.lastIndexOf(".");
      return s > 0 ? o.slice(s + 1).toLowerCase() : "";
    }
    function Tb(o, s = null) {
      const g = {
        type: "file",
        path: o.path,
        basename: o.name,
        extension: JA(o.name),
        storage: o.storage,
        size: o.size,
        file_size: o.size,
        mime_type: o.mime ?? "",
        visibility: "private",
        extra_metadata: {}
      };
      if (yv(L.config, g) === "host") {
        P("file-opened", { path: g.path, basename: g.basename });
        return;
      }
      vs.value = o.type ? { path: g.path, ext: o.type } : null, $i.value = s, pn.value = g, Ha.value = "edit", la.value = !0;
    }
    function Ab(o) {
      tt(_("draft.saved_to", { name: o.name, folder: O2(o.targetDir) }));
    }
    const eo = lie(() => sr.value ? q.drafts : null, (o) => Zn(o));
    async function ZA(o) {
      if (!lr.value) {
        lr.value = o.key;
        try {
          const s = await eo.save(o);
          s && (Ab(s), await Zl());
        } catch (s) {
          qt({ message: Zn(s) }, yn);
        } finally {
          lr.value = null;
        }
      }
    }
    async function QA(o) {
      if (!lr.value) {
        lr.value = o.key;
        try {
          await q.drafts.discard(o.key), tt(_("draft.discarded", { name: o.name })), await Zl();
        } catch (s) {
          qt({ message: Zn(s) }, yn);
        } finally {
          lr.value = null;
        }
      }
    }
    function eE(o) {
      Ab(o), Zl(), !bt.value && !Ft.value && wt();
    }
    function tE() {
      var s;
      const o = ((s = pn.value) == null ? void 0 : s.basename) ?? "";
      tt(_("draft.discarded", { name: o })), Zl();
    }
    function nE() {
      Ql.value = !1, uu("drafts");
    }
    const jn = S([]), Eb = S(null), sa = S(!1), Ql = S(!1), to = S(!1), ha = S(!1), la = S(!1), ld = S(!1), ur = S(!1), cs = S(!1), eu = S([]), Ao = S(null), ds = S(""), gh = S(!1), cr = S(/* @__PURE__ */ new Set()), Ai = S(""), fs = S(!1), ps = S(""), dr = S(null), aE = A(() => {
      var o;
      return eu.value.length !== 1 ? "archive" : ((o = eu.value[0]) == null ? void 0 : o.basename.replace(/\.[^.]+$/, "")) || "archive";
    }), iE = ["zip", "7z", "tar", "tar.gz", "tar.bz2", "tar.xz"], tu = A(() => {
      var s, g;
      return (((g = (s = Ke.value) == null ? void 0 : s.archive) == null ? void 0 : g.allowed_formats) ?? []).filter((M) => iE.includes(M));
    }), oE = A(() => {
      var s, g;
      const o = (g = (s = Ke.value) == null ? void 0 : s.archive) == null ? void 0 : g.default_format;
      return o && tu.value.includes(o) ? o : tu.value.includes("7z") ? "7z" : tu.value[0] ?? "zip";
    }), rE = A(() => {
      var o, s;
      return ((s = (o = Ke.value) == null ? void 0 : o.archive) == null ? void 0 : s.encryption) !== !1;
    }), sE = A(
      () => {
        var o;
        return (((o = Ao.value) == null ? void 0 : o.basename) || "archive").replace(/\.(tar\.(gz|bz2|xz)|zip|7z|rar|tgz|gz|bz2|xz)$/i, "") || "archive";
      }
    ), fr = S(null), hs = gv(to), ms = gv(sa), Sa = gv(ha), { busy: lE, error: uE } = hs, { busy: cE, error: dE } = ms, { busy: fE, error: pE } = Sa, Ei = S(!1), pn = S(null), Ha = S("edit"), vs = S(null), hE = A(
      () => {
        var o;
        return vs.value && ((o = pn.value) == null ? void 0 : o.path) === vs.value.path ? vs.value.ext : null;
      }
    );
    Je(la, (o) => {
      o || (vs.value = null), !o && sr.value && pn.value && Zw(pn.value.path) && Zl();
    });
    const pr = S(!1), si = S(null), ys = S(!1), ud = S("move"), cd = S([]), mE = A(() => (B.version.value, ys.value, B.roots())), vE = A(() => {
      const o = cd.value[0];
      return o ? B.rootOf(o.path) : null;
    }), dd = S(!1), Ra = S(
      (() => {
        try {
          return localStorage.getItem(Y0) === "1";
        } catch {
          return !1;
        }
      })()
    );
    function fd(o) {
      try {
        localStorage.setItem(Y0, o ? "1" : "0");
      } catch {
      }
    }
    function bh() {
      Ra.value = !Ra.value, fd(Ra.value), Ra.value && (no.value = !1);
    }
    function yE() {
      Ra.value || (Ra.value = !0, fd(!0)), no.value = !1;
    }
    const no = S(!1), kh = A(() => {
      var o, s;
      return ((s = (o = Ke.value) == null ? void 0 : o.assistant) == null ? void 0 : s.button) === !0;
    }), gE = UV(
      {
        request: q.rawRequest,
        json: q.jsonFetch,
        failure: (o, s) => fa(o, s, j.value)
      },
      BV(q.endpoints.manager)
    );
    function bE() {
      no.value = !no.value, no.value && Ra.value && (Ra.value = !1, fd(!1));
    }
    const kE = A(() => ia().map((o) => o.path));
    Je(kh, (o) => {
      o || (no.value = !1);
    });
    function Cb() {
      Ra.value && (Ra.value = !1, fd(!1));
    }
    const wE = A(() => C5(L.config.uiProfile)), nu = A(() => wE.value === "simple"), zb = A(() => L.config.showInfoPanel !== !1), au = S(
      (() => {
        try {
          const o = localStorage.getItem(G0);
          if (o === "1") return !0;
          if (o === "0") return !1;
        } catch {
        }
        return !0;
      })()
    );
    function _E(o) {
      try {
        localStorage.setItem(G0, o ? "1" : "0");
      } catch {
      }
    }
    const hr = S(!1), iu = A(() => L.config.sideNav ?? !ft), wh = A(
      () => iu.value && ($a.value ? hr.value : !0)
    ), Mb = A(
      () => iu.value && L.config.trashVisible !== !1
    ), xE = A(
      () => $a.value ? hr.value : au.value
    );
    function Pb() {
      if (iu.value) {
        if ($a.value) {
          hr.value = !hr.value;
          return;
        }
        au.value = !au.value, _E(au.value);
      }
    }
    function Eo() {
      hr.value = !1;
    }
    const _h = S([]), SE = A(() => L.config.connections ?? !nu.value), $E = A(() => L.config.mySharesVisible === !0), pd = A(
      () => {
        var o;
        return (L.config.callerKind ?? ((o = Ke.value) == null ? void 0 : o.caller_kind)) === "app";
      }
    ), gs = A(() => !pd.value), xh = S(!1);
    let Ob = 0;
    Je(
      () => [L.config.appStorePage === !0, pd.value],
      async ([o, s]) => {
        const g = ++Ob;
        if (!IS(o, s)) {
          xh.value = !1;
          return;
        }
        const M = await q.appStoreStatus();
        g === Ob && (xh.value = i1(o, s, M));
      },
      { immediate: !0 }
    );
    const TE = A(() => i1(L.config.appStorePage === !0, pd.value, { visible: xh.value })), bs = S(!1), ou = S(!1);
    function AE() {
      ou.value = !1, bs.value = !0;
    }
    function EE() {
      pd.value || (bs.value = !1, ou.value = !0);
    }
    function hd() {
      bs.value = !1, ou.value = !1;
    }
    const CE = A(() => bs.value || ou.value);
    function zE(o) {
      const s = o instanceof Error ? o.message : String(o);
      P("error", { message: s, context: { op: "connections" } }), tt(s);
    }
    const Sh = A(
      () => nu.value ? ["list", "grid"] : void 0
    );
    IM(() => {
      nu.value && Pe.value === "gallery" && (Pe.value = "grid");
    });
    const ks = S({ ...jo }), ws = S(null), md = S("name"), ME = A(
      () => Et.value || Cn.value ? "relevance" : "sort"
    );
    function PE() {
      ws.value = null, Lb({ ...jo });
    }
    function Lb(o) {
      ks.value = o, oe.clear();
    }
    Je(
      () => `${Xe.value}|${bt.value}`,
      () => {
        al(ks.value) && (ks.value = { ...jo }), Et.value || (ws.value = null);
      }
    );
    const ru = S(!1), Db = S([]);
    Je(ru, async (o) => {
      o && (Db.value = await C_({
        apiBase: L.config.apiBase ?? "",
        authHeaders: () => Qn(),
        authCredentials: q.credentialsMode()
      }));
    });
    const Rb = S(""), OE = A(() => !0);
    function $h(o = ws.value) {
      return dJ(o ?? jo, Date.now(), { showHidden: tc.value });
    }
    const Nb = S(!1);
    async function Ib(o, s, g, M = $h()) {
      var de;
      if (o === "name") {
        const Se = await Aw(g, s), $e = Se ?? await q.search(g, s, M);
        return {
          rows: Mr(await Vt.decorate($e.files, { root: $e.e2e_root || null })),
          truncated: uv($e.files.length, kf, $e.truncated),
          local: !!Se
        };
      }
      const I = await q.globalSearchPage(s, { limit: X0, scope: o, narrow: M }), X = ne.value || ((de = (L.config.storages ?? [])[0]) == null ? void 0 : de.name) || "";
      return {
        rows: Mr(await Vt.decorate(I.hits.map((Se) => Kf(Se, X)))),
        truncated: uv(I.hits.length, X0, I.truncated),
        local: !1
      };
    }
    function LE() {
      const o = Xe.value ?? "";
      return Sn.value ? Td(o) : Rt(o);
    }
    async function DE(o) {
      const s = wy(o), { rows: g, truncated: M, local: I } = await Ib(o.scope, s, LE(), $h(o.filters));
      return {
        count: (I && al(o.filters) ? iy(g, o.filters) : g).length,
        capped: M
      };
    }
    function RE(o) {
      Rb.value = Rt(Xe.value ?? "") || "", Bb.value = o, ru.value = !0;
    }
    const Bb = S("");
    function NE(o) {
      ru.value = !1, md.value = o.scope, ws.value = al(o.filters) ? { ...o.filters } : null;
      const s = wy(o);
      s === Et.value ? wt() : Et.value = s;
    }
    function IE(o) {
      ws.value = null, md.value = "name", bt.value !== "home" && (Et.value = o);
    }
    const Fb = A(() => {
      if (bt.value || Qe.value) return "";
      const o = ne.value;
      if (!o) return "";
      const s = (L.config.storages ?? []).find((g) => g.name === o);
      return (s == null ? void 0 : s.label) || o;
    }), Th = S("");
    function BE(o) {
      Th.value = o, Od.value = !0;
    }
    const su = S(void 0);
    function FE() {
      const o = Rt(Xe.value);
      if (!o || !nk.value) return;
      const s = Xe.value.split("/").filter(Boolean);
      si.value = {
        path: o,
        basename: s.length ? s[s.length - 1] : ne.value,
        type: "dir"
      }, su.value = "drop", pr.value = !0;
    }
    function UE(o) {
      P("share-created", { path: o.path, url: o.url, pin: null }), tt(_("inspector.copied"));
    }
    const Ah = S(null), Ub = S(null), HE = A(() => HJ(Ah.value, zh.value, Ub.value));
    async function Hb() {
      if (!gs.value) {
        Ah.value = null;
        return;
      }
      const o = await q.quotaMe();
      Ah.value = o, Ub.value = UJ(o, zh.value) ? await q.storageUsage() : null;
    }
    function vd(o) {
      return cae(o, {
        storages: L.config.storages ?? [],
        multiStorageRoot: Sn.value
      });
    }
    const ao = S(null), lu = S(!1), yd = A(() => {
      if (!Cn.value) return "";
      const o = mn.value;
      if (!o || !Qv(o)) return "";
      const s = wS(o);
      return s != null && s.k ? `${s.d === "desc" ? "-" : ""}${s.k}` : "";
    });
    Je(yd, (o, s) => {
      o === s || !Cn.value || (bt.value === "tag" && rn.value ? _s(rn.value, me.value) : (bt.value === "recent" || bt.value === "starred" || bt.value === "shared") && uu(bt.value));
    });
    async function gd(o, s = 0) {
      const g = L.config.apiBase ?? "", M = new URLSearchParams({ limit: String(Ku), offset: String(s) });
      yd.value && M.set("sort", yd.value);
      const I = o === "shared" ? `${g}/api/files/manager/shared-with-me?${M}` : o === "starred" ? `${g}/api/files/manager/star/list?${M}` : `${g}/api/files/manager/recent?${M}`, X = await fetch(I, {
        headers: await Qn(),
        // ⚠ NOT 'include' — with a bearer token this is cross-origin for every
        // embedder serving the UI from another origin (the desktop app): a credentialed
        // cross-origin request cannot be answered with `ACAO: *`.
        credentials: q.credentialsMode()
      });
      if (!X.ok) throw new Error(String(X.status));
      const de = await X.json(), Se = (ut) => ({
        rows: ut,
        total: typeof (de == null ? void 0 : de.total) == "number" ? de.total : s + ut.length,
        truncated: (de == null ? void 0 : de.truncated) === !0
      });
      if (o === "shared")
        return _h.value = Array.isArray(de == null ? void 0 : de.storages) ? de.storages : [], Se(await Vt.decorate(Array.isArray(de == null ? void 0 : de.files) ? de.files : []));
      const $e = Array.isArray(de == null ? void 0 : de.nodes) ? de.nodes : [];
      return Se(await Vt.decorate($e.map(vd).filter((ut) => ut !== null)));
    }
    async function KE() {
      const o = ao.value;
      if (!o || !o.truncated || lu.value) return;
      lu.value = !0;
      const s = Xe.value;
      try {
        const g = o.kind === "tag" ? await qb(rn.value, me.value, o.next) : await gd(o.kind, o.next);
        if (Xe.value !== s) return;
        G.value = [...G.value, ...g.rows], ao.value = { kind: o.kind, total: g.total, truncated: g.truncated, next: o.next + Ku };
      } catch (g) {
        tt(g instanceof Error ? g.message : String(g));
      } finally {
        lu.value = !1;
      }
    }
    const Kb = S([]), Vb = S([]), Eh = S(!1), jb = tj(), Ch = A(() => XV(L.config.storages ?? [], jb.saved.value));
    function VE(o) {
      ej(o, Ch.value);
    }
    const zh = A(
      () => Ch.value.map(
        (o) => o.usedPartial !== void 0 || !(o.name in Dt.value) ? o : { ...o, usedPartial: Dt.value[o.name] !== null }
      )
    );
    async function jE() {
      Eh.value = !0;
      try {
        const [o, s] = await Promise.all([
          gd("recent").then((g) => g.rows).catch(() => []),
          gd("starred").then((g) => g.rows).catch(() => [])
        ]);
        Kb.value = o, Vb.value = s;
      } finally {
        Eh.value = !1;
      }
    }
    async function uu(o) {
      Eo();
      const s = Ve.view();
      if (o === "home") {
        bt.value || (Dn.value = Xe.value ?? ""), bt.value = "home", rn.value = "", me.value = "", Ft.value = !1, Ct.value = "", bd(), oe.clear(), G.value = [], ge.value = Le.home, Xe.value = Le.home, ne.value = "", await jE();
        return;
      }
      if (o === "tag") {
        rn.value && await _s(rn.value, me.value);
        return;
      }
      if (o === "drafts") {
        bt.value || (Dn.value = Xe.value ?? ""), bt.value = "drafts", rn.value = "", me.value = "", Ft.value = !1, Ct.value = "", bd(), oe.clear(), G.value = [], ge.value = Le.drafts, Xe.value = Le.drafts, ne.value = "", await $b();
        return;
      }
      if (o === "trash") {
        rC(), await zi(), bt.value = "trash", rn.value = "", me.value = "";
        return;
      }
      ot.value = !0, bt.value || (Dn.value = Xe.value ?? ""), bt.value = o, rn.value = "", me.value = "", Ft.value = !1, Ct.value = "", bd(), oe.clear(), ge.value = Le[o], Xe.value = Le[o], ao.value = null;
      try {
        const g = await gd(o);
        if (!Be(s)) return;
        G.value = g.rows, ao.value = { kind: o, total: g.total, truncated: g.truncated, next: Ku }, ne.value = "";
      } catch (g) {
        if (!Be(s)) return;
        const M = g instanceof Error ? g.message : String(g);
        G.value = [], P("error", { message: M, context: { op: `nav-view:${o}` } }), tt(M);
      } finally {
        Be(s) && (ot.value = !1);
      }
    }
    async function qb(o, s, g) {
      const M = await uD(
        o,
        {
          apiBase: L.config.apiBase ?? "",
          authHeaders: () => Qn(),
          authCredentials: q.credentialsMode()
        },
        { limit: Ku, offset: g, kind: s, sort: yd.value }
      );
      return { rows: await Vt.decorate(M.rows.map(vd).filter((X) => X !== null)), total: M.total, truncated: M.truncated };
    }
    async function _s(o, s = "") {
      Eo();
      const g = String(o ?? "").trim();
      if (!g) return;
      const M = Ve.view();
      ot.value = !0, bt.value || (Dn.value = Xe.value ?? ""), bt.value = "tag", rn.value = g, me.value = s, Ft.value = !1, Ct.value = "", bd(), oe.clear();
      const I = H4(g, s);
      ge.value = I, Xe.value = I, ao.value = null;
      try {
        const X = await qb(g, s, 0);
        if (!Be(M)) return;
        G.value = X.rows, ao.value = { kind: "tag", total: X.total, truncated: X.truncated, next: Ku }, ne.value = "";
      } catch (X) {
        if (!Be(M)) return;
        const de = X instanceof Error ? X.message : String(X);
        G.value = [], P("error", { message: de, context: { op: `nav-view:tag:${s ? `${s}:` : ""}${g}` } }), tt(de);
      } finally {
        Be(M) && (ot.value = !1);
      }
    }
    const Wb = S([]), Mh = S(!1);
    async function Ph(o = !1) {
      wh.value && (Wb.value = await C_({
        apiBase: L.config.apiBase ?? "",
        authHeaders: () => Qn(),
        authCredentials: q.credentialsMode(),
        force: o
      }), Mh.value = !0);
    }
    function qE(o) {
      if (o === "myfiles") {
        Eo(), wt("");
        return;
      }
      uu(o);
    }
    function Yb(o) {
      Eo(), wt(Sn.value ? o : "");
    }
    async function WE() {
      try {
        const o = L.config.apiBase ?? "", s = await fetch(`${o}/api/files/manager/shared-with-me?limit=1`, {
          headers: await Qn(),
          credentials: q.credentialsMode()
        });
        if (!s.ok) return;
        const g = await s.json();
        _h.value = Array.isArray(g == null ? void 0 : g.storages) ? g.storages : [];
      } catch {
      }
    }
    function Oh(o) {
      const s = (o ?? "").replace(/^\/+|\/+$/g, "");
      if (!s) return Sn.value ? _("breadcrumb.root") : ne.value || _("breadcrumb.root");
      const g = s.split("/").pop() || s, M = lp(g, _);
      return M || (Vt.segmentLabel(Rt(s)) ?? g);
    }
    function YE(o) {
      si.value = o, pr.value = !0;
    }
    function cu(o) {
      return te.value ? !1 : o === void 0 || o === "editor" || o === "owner";
    }
    function bd() {
      ye.value = "", te.value = !1;
    }
    const GE = A(() => !!bt.value && bt.value !== "trash");
    function Lh(o) {
      return typeof o.perm == "string" ? o.perm : hae(GE.value, ye.value);
    }
    function Gb(o) {
      if (o.read_only === !0) return !0;
      const s = typeof o.storage == "string" ? o.storage : "";
      return s ? (L.config.storages ?? []).some((g) => g.name === s && g.readOnly === !0) : !1;
    }
    function io(o) {
      return cu(Lh(o)) && !Gb(o);
    }
    const Xb = { none: 0, viewer: 1, editor: 2, owner: 3 };
    function XE(o) {
      if (o.length === 0) return ye.value;
      let s, g = !1;
      for (const M of o) {
        const I = Lh(M);
        if (I === void 0) {
          g = !0;
          continue;
        }
        (s === void 0 || (Xb[I] ?? 0) < (Xb[s] ?? 0)) && (s = I);
      }
      return s ?? (g ? void 0 : ye.value);
    }
    function Jb(o) {
      return o.some(Gb);
    }
    const du = EJ(), Na = BJ();
    Tt(() => Na.dispose());
    function Dh() {
      var s;
      const o = (s = Ke.value) == null ? void 0 : s.e2e_policy;
      return {
        p: [...ce.value ?? []].sort().join(","),
        e: o ? `${o.available}|${o.policy}` : ""
      };
    }
    async function JE() {
      var M, I, X;
      if (await Promise.all([Z(), se]), !((M = Ke.value) != null && M.e2e_policy) && !((I = ce.value) != null && I.length)) return;
      let o;
      try {
        o = (X = await Ye()) == null ? void 0 : X.user;
      } catch {
        o = null;
      }
      const s = ca(L.config) || (typeof location < "u" ? location.origin : ""), g = o && typeof o.id == "number" ? [s, o.id, o.provider_id ?? "", gt].join("|") : null;
      Na.attach(g, Dh()), Ih();
    }
    jt(() => void JE());
    const kd = S({}), wd = /* @__PURE__ */ new Set();
    let Rh = 0;
    Je(
      () => [ve.value, ce.value],
      () => {
        Rh++, wd.clear(), kd.value = {}, Na.sign("p", Dh().p);
      }
    );
    function Zb(o) {
      const s = ce.value;
      if (!(s != null && s.length)) return;
      const g = o.filter((Se) => !Na.fresh("p", Se) && !wd.has(Se));
      if (!g.length) return;
      g.forEach((Se) => wd.add(Se));
      const M = [...s], I = Rh, X = (Se, $e) => {
        if (I !== Rh) return;
        const ut = { ...kd.value };
        g.forEach((et, Pt) => {
          ut[et] = Se[Pt] ?? [], Na.put("p", et, ut[et], $e), wd.delete(et);
        }), kd.value = ut;
      }, de = g.some((Se) => Qb(Se) === void 0) ? du.start() : () => {
      };
      q.allowedAt(g, M).then(
        (Se) => X(Se, !0),
        () => X(g.map(() => M), !1)
      ).finally(de);
    }
    function Qb(o) {
      return kd.value[o] ?? Na.peek("p", o);
    }
    function fu(o, s) {
      var M;
      const g = [...new Set(s.map(ke))];
      return !ve.value || !g.length || !((M = ce.value) != null && M.includes(o)) ? Ms(o) : (Zb(g), g.every((I) => {
        var X;
        return ((X = Qb(I)) == null ? void 0 : X.includes(o)) ?? !1;
      }));
    }
    const _d = S({}), xd = /* @__PURE__ */ new Set();
    let Nh = 0;
    function ZE() {
      Nh++, xd.clear(), _d.value = {}, Na.sign("e", Dh().e);
    }
    Je(
      () => {
        var o, s, g, M;
        return [
          ve.value,
          ce.value,
          (s = (o = Ke.value) == null ? void 0 : o.e2e_policy) == null ? void 0 : s.available,
          (M = (g = Ke.value) == null ? void 0 : g.e2e_policy) == null ? void 0 : M.policy
        ];
      },
      ZE
    );
    function pu(o, s) {
      return `${s}:${o}`;
    }
    async function ek(o) {
      const s = o.filter((de) => {
        const Se = pu(de.path, de.kind);
        return !Na.fresh(`e:${de.kind}`, de.path) && !xd.has(Se);
      });
      if (!s.length) return;
      for (const de of s) xd.add(pu(de.path, de.kind));
      const g = Nh, I = s.some((de) => tk(de.path, de.kind) === void 0) ? du.start() : () => {
      };
      let X = !1;
      try {
        const de = await q.e2eAllowedAt(s, {
          onFailed: () => {
            X = !0;
          }
        });
        if (g !== Nh) return;
        const Se = { ..._d.value };
        s.forEach(($e, ut) => {
          const et = pu($e.path, $e.kind);
          Se[et] = de[ut] ?? "allowed", Na.put(`e:${$e.kind}`, $e.path, Se[et], !X), xd.delete(et);
        }), _d.value = Se;
      } finally {
        I();
      }
    }
    function tk(o, s) {
      return _d.value[pu(o, s)] ?? Na.peek(`e:${s}`, o);
    }
    function Ih() {
      var de, Se;
      if (Ft.value || bt.value || Ce.value || Ie.value) return;
      const o = Rt(Xe.value ?? "");
      if (!o.includes("://") || B.rootOf(o)) return;
      const s = !!((de = Ke.value) != null && de.e2e_policy) && !an.value, g = !!ve.value && !!((Se = ce.value) != null && Se.length);
      if (!s && !g) return;
      const M = /* @__PURE__ */ new Set(), I = /* @__PURE__ */ new Map(), X = ($e, ut) => {
        if ($e === "p")
          g && M.add(ut);
        else if (s) {
          const et = $e.slice(2);
          I.set(pu(ut, et), { path: ut, kind: et });
        }
      };
      X("p", o), X("e:new_folder", o);
      for (const $e of G.value.slice(0, Zse))
        !$e || typeof $e.path != "string" || !$e.path.includes("://") || cc($e) || B.isVaultRow($e) || (X("p", $e.path), !(!io($e) || $e.e2e || $e.e2e_root) && ($e.type === "dir" ? X("e:folder", $e.path) : Ui($e) || X("e:file", $e.path)));
      for (const $e of Na.around(o)) X($e.q, $e.path);
      M.size && Zb([...M].slice(0, 1e3)), I.size && ek([...I.values()].slice(0, 1e3));
    }
    let xs = null;
    function QE(o) {
      if (Na.stale(), o.resync) {
        Ih();
        return;
      }
      xs || (xs = setTimeout(
        () => {
          xs = null, fe(), wt();
        },
        o.all ? Math.random() * Qse : 0
      ));
    }
    Tt(() => {
      xs && clearTimeout(xs), xs = null;
    });
    function Bh(o, s) {
      var I;
      const g = ke(o);
      return ((I = Ke.value) == null ? void 0 : I.e2e_policy) ? (ek([{ path: g, kind: s }]), tk(g, s) ?? "denied") : "allowed";
    }
    const li = A(
      () => cu(ye.value) && fu("files.create", Xe.value ? [Rt(Xe.value)] : [])
    ), Sd = A(
      () => li.value && !Qe.value && !Ft.value
    ), nk = A(
      () => Bd(Xe.value ? [Rt(Xe.value)] : []).uploadLinks
    ), eC = A(
      () => si.value && ve.value ? Bd([si.value.path]) : void 0
    ), Fh = S(null), Tn = S(null), ak = S(null), $a = S(!1), ik = S(!1);
    let Ss, ui;
    function Uh(o) {
      ik.value = !!(o && "matches" in o && o.matches);
    }
    jt(() => {
      var o;
      typeof ResizeObserver < "u" && Tn.value && (Ss = new ResizeObserver((s) => {
        var M, I, X;
        const g = ((I = (M = s[0]) == null ? void 0 : M.contentRect) == null ? void 0 : I.width) ?? ((X = Tn.value) == null ? void 0 : X.clientWidth) ?? 0;
        $a.value = g > 0 && g < 560;
      }), Ss.observe(Tn.value)), typeof window < "u" && window.matchMedia && (ui = window.matchMedia("(pointer: coarse)"), Uh(ui), (o = ui.addEventListener) == null || o.call(ui, "change", Uh));
    }), Tt(() => {
      var o;
      Ss == null || Ss.disconnect(), Ss = void 0, (o = ui == null ? void 0 : ui.removeEventListener) == null || o.call(ui, "change", Uh), ui = void 0;
    });
    const ma = S(null);
    let Ka, $s = null;
    function qt(o, s) {
      ma.value = o, Ka && clearTimeout(Ka), Ka = setTimeout(ok, s);
    }
    function tt(o) {
      qt({ message: o }, hi);
    }
    function ok() {
      Ka = void 0, ma.value = null;
      const o = $s;
      $s = null, o && qt({ message: o.message, source: "drag-out" }, o.ms);
    }
    Tt(() => {
      Ka && clearTimeout(Ka), Ka = void 0, $s = null;
    });
    const Ci = A(() => {
      if (bt.value || Kt.value || Ce.value) return null;
      const o = !!Et.value, s = Va(ge.value).replace(/^\/+|\/+$/g, "") === "";
      return TJ({
        map: Dt.value,
        adapter: ne.value,
        searching: o,
        crossStorage: o && s && Object.keys(Dt.value).length > 1,
        admin: pa.value
      });
    });
    async function tC(o) {
      if (!o || Vn(o)) return;
      ln.value = { ...ln.value, [o]: 0 };
      const s = () => {
        const { [o]: I, ...X } = ln.value;
        ln.value = X;
      };
      let g;
      try {
        const I = ca(L.config), X = await q.jsonFetch(`${I}/api/admin/storages`), de = Array.isArray(X) ? X.find(($e) => $e.name === o) : void 0;
        if (!de) throw new Error("no such storage");
        const Se = await q.jsonFetch(`${I}/api/admin/storages/${de.id}/sync`, { method: "POST" });
        g = de.id, ln.value = { ...ln.value, [o]: g }, tt((Se == null ? void 0 : Se.status) === "running" ? _("coverage.catalog_joined", { storage: o }) : _("coverage.catalog_started"));
      } catch (I) {
        s(), qt({ message: Zn(I) }, yn);
        return;
      }
      const M = await Ln().scan(g);
      s(), M !== null && (M.status === "ok" ? (tt(_("coverage.catalog_done", { storage: o })), await wt()) : M.status === "failed" ? qt({ message: _("coverage.catalog_failed", { storage: o }) }, yn) : M.status === "aborted" ? qt({ message: _("coverage.catalog_stopped", { storage: o }) }, yn) : M.status === "gone" ? qt({ message: _("coverage.catalog_gone", { storage: o }) }, yn) : qt({ message: _("coverage.catalog_unfollowed", { storage: o }) }, yn));
    }
    function $d(o, s) {
      qt({ message: o, actionLabel: _("toast.undo"), action: s, after: { kind: "undo" } }, 8e3);
    }
    function Hh() {
      Ka && clearTimeout(Ka), ok();
    }
    async function nC() {
      const o = ma.value, s = o == null ? void 0 : o.action;
      if (Ka && clearTimeout(Ka), Ka = void 0, ma.value = null, !o || !s) return;
      const g = o.after ?? { kind: "undo" }, M = g.kind === "plain", I = M && o.source ? "drag-out-stopping" : void 0;
      qt({ message: B0(g, "running", void 0, _), source: I }, wf);
      try {
        const X = await s();
        qt({ message: B0(g, "done", X, _), source: I }, hi), M || await wt();
      } catch (X) {
        M ? qt({ message: Zn(X) }, yn) : tt(_("toast.undo_failed"));
      }
    }
    const Sn = A(() => L.config.multiStorageRoot === !0);
    function aC(o) {
      const s = o.replace(/^\/+|\/+$/g, "");
      if (!s) return { adapter: "", rel: "" };
      const g = s.indexOf("/");
      return g === -1 ? { adapter: s, rel: "" } : { adapter: s.slice(0, g), rel: s.slice(g + 1) };
    }
    function Td(o) {
      if (o.includes("://")) return o;
      const { adapter: s, rel: g } = aC(o);
      return s ? g ? `${s}://${g}` : `${s}://` : "";
    }
    function Co(o) {
      const s = o.indexOf("://");
      if (s === -1) return o.replace(/^\/+|\/+$/g, "");
      const g = o.slice(0, s), M = o.slice(s + 3).replace(/^\/+|\/+$/g, "");
      return M ? `${g}/${M}` : g;
    }
    function rk() {
      return (L.config.storages ?? []).map((s) => ({
        type: "dir",
        path: s.name,
        // virtual path (no adapter prefix)
        basename: s.label || s.name,
        extension: "",
        storage: s.name,
        visibility: "private",
        file_size: 0,
        mime_type: "inode/storage",
        extra_metadata: { driver: s.driver, readOnly: s.readOnly }
      }));
    }
    function sk() {
      var o;
      N4(!tc.value), wt(), (o = Zt.value) == null || o.reload();
    }
    function lk() {
      wt(), Hb(), P("refresh");
    }
    function wt(o) {
      return Ve.follow(() => iC(o));
    }
    async function iC(o) {
      var Se;
      xn.value = !1;
      const { ticket: s, want: g } = Ve.begin(o, Xe.value ?? "");
      at.connected.value || Na.stale();
      const M = Ue(g);
      if (M) {
        if (!(M.kind === "trash" ? L.config.trashVisible !== !1 : iu.value))
          return qh(""), await wt("");
        M.kind === "tag" ? await _s(M.tag, M.tagKind) : await uu(M.kind);
        return;
      }
      const I = String(Xe.value ?? "").replace(/^\/+|\/+$/g, ""), X = ($e) => {
        String($e ?? "").replace(/^\/+|\/+$/g, "") !== I && (oe.clear(), dt.value = []);
      };
      ot.value = !0, Ft.value = !1, bt.value = "", rn.value = "", me.value = "";
      let de = g;
      Ve.going(g);
      try {
        if (Ce.value = "", Ie.value = "", gt) {
          const vn = String(de).replace(/^\/+|\/+$/g, "");
          (!vn || !(vn === gt || vn.startsWith(gt + "/"))) && (de = gt);
        }
        if (Sn.value && !Td(de)) {
          if (He.value) return await wt(He.value);
          X(""), Xe.value = "", ne.value = "", ge.value = "", Ct.value = "", G.value = rk();
          return;
        }
        const $e = Sn.value ? Td(de) : Rt(de), ut = B.rootOf($e);
        if (ut) {
          const vn = String($e).replace(/\/+$/, "");
          if (B.isOpen(ut)) {
            const $n = B.rows(vn) ? vn : ut, Fi = Et.value ? B.search($n, Et.value) : B.rows($n);
            if (!Be(s)) return;
            B.touch($n), xn.value = !1, ne.value = $n.slice(0, $n.indexOf("://")), ge.value = $n, ye.value = B.permOf(ut) || "", te.value = !!((Se = B.strips[ut]) != null && Se.readOnly), Ct.value = ut;
            const Ga = Di($n);
            X(Ga), G.value = Mr(Fi ?? []), Xe.value = Ga;
            return;
          }
          if (vn !== ut) return await wt(Di(ut));
        }
        const Pt = !!Et.value && md.value !== "name" ? await Ib(md.value, Et.value, $e) : null;
        let En = !1;
        const At = Pt ? {
          adapter: ne.value,
          storages: (L.config.storages ?? []).map((vn) => vn.name),
          dirname: ge.value,
          read_only: !1,
          files: Pt.rows,
          truncated: Pt.truncated
        } : Et.value ? await (async () => {
          const vn = await Aw($e, Et.value);
          return En = !!vn, vn ?? await q.search($e, Et.value, $h());
        })() : await q.index($e);
        if (!Pt && !Et.value && typeof At.e2e_vault_root == "string" && At.e2e_vault_root) {
          const vn = At.e2e_vault_root.replace(/\/+$/, "");
          if (String(At.dirname ?? "").replace(/\/+$/, "") !== vn)
            return Be(s) ? await wt(Di(vn)) : void 0;
          At.files = [];
        }
        if (At.files = await Vt.decorate(At.files, {
          root: typeof At.e2e_root == "string" && At.e2e_root ? At.e2e_root : null
        }), !Be(s)) return;
        At.files = pae(At.files, At.perm), xn.value = !!Et.value && uv(At.files.length, kf, At.truncated), Nb.value = !!Et.value && (Pt ? Pt.local : En), Array.isArray(At.storage_info) && (Dt.value = $J(At.storage_info), bn.value = $5(At.storage_info)), ne.value = At.adapter, ge.value = At.dirname, ye.value = At.perm || "", te.value = At.read_only === !0, Ct.value = typeof At.e2e_root == "string" ? At.e2e_root : "";
        {
          const vn = String(At.dirname ?? "").replace(/\/+$/, ""), $n = typeof At.e2e_root == "string" ? At.e2e_root.replace(/\/+$/, "") : "";
          B.rootOf(vn) === vn && $n !== vn && B.forget(vn);
        }
        const Ya = Sn.value ? Co(At.dirname) : Va(At.dirname);
        X(Ya), G.value = Mr(At.files), cS(G.value, At.adapter, At.dirname, L.config.trashVisible !== !1, {
          isSearchResult: !!Et.value,
          navOffersTrash: Mb.value
        }) && dS(G.value, At.adapter, q), Xe.value = Ya, Ih();
      } catch ($e) {
        if (!Be(s)) return;
        const ut = $e instanceof Error ? $e.message : String($e), et = $e.status;
        if (et === 404 || et === 403) {
          Ce.value = String(de), X(String(de)), Ct.value = "", G.value = [], P("error", { message: ut, context: { path: o } });
          return;
        }
        Ie.value = ut, _e = typeof de == "string" ? de : void 0, P("error", { message: ut, context: { path: o } }), G.value.length > 0 && tt(ut);
      } finally {
        Be(s) && (ot.value = !1), Ve.end(s);
      }
    }
    function Va(o) {
      const s = o.indexOf("://");
      return s === -1 ? o : o.slice(s + 3);
    }
    function oC() {
      Ce.value = "", qh(""), wt("");
    }
    const Ad = S(null), zo = S(!1), Ed = S(!1), hu = S(!1), Kh = S(null);
    let uk = !1;
    Tt(() => {
      uk = !0, Jt == null || Jt.stop();
    });
    async function rC() {
      try {
        const o = await fetch(`${L.config.apiBase ?? ""}/api/admin/protection`, {
          headers: await Qn(),
          credentials: q.credentialsMode()
        });
        if (!o.ok) {
          Ad.value = null, zo.value = !1;
          return;
        }
        const s = await o.json(), g = s == null ? void 0 : s.trash_retention_days;
        Ad.value = typeof g == "number" && g > 0 ? g : null, zo.value = !0;
      } catch {
      }
    }
    const sC = A(
      () => Ad.value !== null ? _("trash.retention", { days: Ad.value }) : _("trash.retention_unknown")
    ), Ts = S(null), Cd = S("");
    let Vh = 0;
    async function lC() {
      Ts.value = null, Cd.value = "", hu.value = !0;
      const o = ++Vh;
      try {
        const s = await q.trashEmptyPreview();
        o === Vh && (Ts.value = s);
      } catch (s) {
        o === Vh && (Cd.value = Za(s, j.value));
      }
    }
    const ck = A(() => {
      const o = Kh.value;
      return o != null && o.running ? o.summary ?? "" : "";
    });
    async function uC() {
      if (hu.value = !1, !zo.value || Ed.value) return;
      const o = q.endpoints.trashEmpty;
      if (o) {
        Ed.value = !0;
        try {
          const s = await yae({
            start: async () => fetch(q.withScreenLang(o), {
              method: "POST",
              headers: await Qn(),
              credentials: q.credentialsMode()
            }),
            status: async () => fetch(q.withScreenLang(o), { headers: await Qn(), credentials: q.credentialsMode() }),
            locale: j.value,
            /* The run is an ops row: it goes into the operations centre (progress,
             * Cancel) the moment the server names it — a run done within the wait
             * as well, like any other operation the person started. */
            onStart: (g) => {
              g.op_id && De.register({
                id: g.op_id,
                kind: "trash-empty",
                status: g.running ? g.queued ? "pending" : "running" : g.cancelled ? "cancelled" : "ok",
                total: g.total ?? 0,
                done: g.scanned ?? 0
              });
            },
            onProgress: (g) => {
              Kh.value = g;
            },
            onBusy: (g) => {
              g && tt(g);
            },
            stopped: () => uk
          });
          if (s === null || (Ft.value && await zi(), !s.started_at || !s.summary)) return;
          qt({ message: s.summary }, s.error || s.failed ? yn : hi);
        } catch (s) {
          if (s instanceof qT) {
            tt(s.message);
            return;
          }
          const g = Za(s, j.value);
          P("error", { message: (s == null ? void 0 : s.message) ?? String(s), context: { op: "trash:empty" } }), tt(g);
        } finally {
          Kh.value = null, Ed.value = !1;
        }
      }
    }
    const As = S(0), Mo = S(0), zd = S(""), Md = S(!1), cC = A(() => {
      const o = new Intl.NumberFormat(gi(j.value));
      return _("trash.shown_of", { shown: o.format(Mo.value), total: o.format(As.value) });
    });
    function dk(o) {
      return o.map(
        (s) => ({
          type: "file",
          id: s.id,
          /* Which storage's trash it is in: a permanent delete is one job per
             storage, and each job's rows are the ones it deletes. */
          storage_id: s.storage_id,
          /* ⚠ The ORIGINAL path, which the server sends with its leading
             slash: `depo:///x.txt` put an empty segment in the Location
             column ("depo/"), so it is dropped here. */
          path: s.storage_name ? `${s.storage_name}://${s.path.replace(/^\/+/, "")}` : s.path,
          basename: s.name,
          extension: s.name.includes(".") && s.name.split(".").pop() || "",
          storage: s.storage_name || "",
          visibility: "private",
          /* tablo:t1 — ⚠ BOTH. Every view reads `size` (the Size column, the
             info panel); only the upload code reads `file_size`. Setting one of
             the two left every trashed row with a blank Size cell. */
          size: s.size,
          file_size: s.size,
          mime_type: s.mime || "",
          /* The date the Trash's date column prints and sorts by — WHEN it was
             deleted. A trashed row has no modification date to show, and the
             column read "—" for every row. */
          last_modified: Date.parse(s.deleted_at) || void 0,
          extra_metadata: {
            deleted_at: s.deleted_at,
            ttl_days: s.ttl_days ?? null,
            /* A permanent delete is on its way for it (purgeSelection). */
            purging: Ps.value.has(s.id),
            /* #71 — a discarded draft of the asker's: its Location reads
               "Drafts" (ListView), which is where Restore puts it back. */
            ...s.draft ? { draft: !0 } : {}
          },
          /* Who put it here — the Trash draws it where a folder draws the
             owner. Keys absent when nobody is named, as the listing sends. */
          ...s.deleted_by_id !== void 0 ? { deleted_by_id: s.deleted_by_id } : {},
          ...s.deleted_by_name ? { deleted_by_name: s.deleted_by_name } : {},
          ...s.deleted_by_self ? { deleted_by_self: !0 } : {},
          /* wiring:e2 names — the encrypted folder it was deleted from. */
          ...s.e2e_root ? { e2e_root: s.e2e_root } : {}
        })
      );
    }
    async function zi() {
      const o = Ve.view(), s = Ft.value;
      ot.value = !0, na.value = ne.value || "", Ft.value = !0, Ct.value = "", s || oe.clear();
      try {
        const g = await q.listTrash(void 0, { limit: J0 }), M = await Vt.decorate(dk(g.entries));
        if (!Be(o)) return;
        G.value = M, Mo.value = g.entries.length, As.value = g.total, zd.value = g.summary ?? "", ge.value = ".trash", Xe.value = ".trash";
      } catch (g) {
        if (!Be(o)) return;
        const M = g instanceof Error ? g.message : String(g);
        P("error", { message: M, context: { op: "trash-list" } }), tt(M);
      } finally {
        Be(o) && (ot.value = !1);
      }
    }
    async function dC() {
      if (Md.value || Mo.value >= As.value) return;
      const o = Mo.value;
      Md.value = !0;
      try {
        const s = await q.listTrash(void 0, { limit: J0, offset: o }), g = await Vt.decorate(dk(s.entries));
        if (!Ft.value || Mo.value !== o) return;
        G.value = [...G.value, ...g], Mo.value = o + s.entries.length, As.value = s.total, zd.value = s.summary ?? "";
      } catch (s) {
        qt({ message: Zn(s) }, yn);
      } finally {
        Md.value = !1;
      }
    }
    function Rt(o) {
      if (o && o.includes("://")) return o;
      if (Sn.value) {
        const s = Td(o ?? "");
        return s || (ne.value ? `${ne.value}://` : "");
      }
      return o ? `${ne.value}://${o.replace(/^\/+/, "")}` : `${ne.value}://`;
    }
    function Mi(o) {
      const s = o.indexOf("://"), g = (s === -1 ? o : o.slice(s + 3)).replace(/\/+$/, ""), M = g.lastIndexOf("/");
      return M === -1 ? g : g.slice(M + 1);
    }
    function oo(o) {
      const s = o.indexOf("://"), g = s === -1 ? "" : o.slice(0, s + 3), M = (s === -1 ? o : o.slice(s + 3)).replace(/\/+$/, ""), I = M.lastIndexOf("/");
      return I === -1 ? g : g + M.slice(0, I);
    }
    function jh(o, s) {
      const g = (M) => {
        const I = M.indexOf("://"), X = I === -1 ? "" : M.slice(0, I + 3), de = (I === -1 ? M : M.slice(I + 3)).replace(/\/+$/, "");
        return X + de;
      };
      return g(o) === g(s);
    }
    function ja(o, s) {
      return o ? o.endsWith("://") || o.endsWith("/") ? o + s : `${o}/${s}` : s;
    }
    async function fk(o, s) {
      try {
        const g = await q.index(s), M = new Set((g.files ?? []).map((I) => String(I.basename ?? "").toLowerCase()));
        return o.some((I) => M.has(Mi(I).toLowerCase()));
      } catch {
        return !0;
      }
    }
    function pk(o, s, g, M, I) {
      if (!M || !g || I) return;
      const X = s.map((de) => ja(g, Mi(de)));
      X.length !== 0 && he.set(o, {
        message: _("toast.moved"),
        fn: async () => {
          const { op: de } = await q.moveAsync(X, M, g);
          return De.register(de), { queued: !0 };
        }
      });
    }
    Je(
      () => Et.value,
      () => void wt()
    );
    function Pd() {
      return L.config.pathPersist ?? "hash";
    }
    function hk() {
      const o = Pd();
      return o === "hash" || o === "hash+localStorage";
    }
    function fC(o) {
      try {
        return decodeURIComponent(o);
      } catch {
        return o;
      }
    }
    function mk() {
      try {
        return localStorage.getItem(kv) || "";
      } catch {
        return "";
      }
    }
    function vk() {
      const o = window.location.hash || "";
      return o.startsWith("#") ? fC(o.slice(1)).replace(/^\/+|\/+$/g, "") : "";
    }
    function pC() {
      if (typeof window > "u") return "";
      const o = Pd();
      if (o === "none") return "";
      if (o === "localStorage") return mk();
      const s = vk();
      return s || o === "hash" ? s : Ut ? "" : mk();
    }
    function qh(o) {
      if (typeof window > "u") return;
      const s = Pd();
      if (s === "none") return;
      if (s === "localStorage" || s === "hash+localStorage") {
        try {
          o ? localStorage.setItem(kv, o) : localStorage.removeItem(kv);
        } catch {
        }
        if (s === "localStorage") return;
      }
      const g = oA(o), M = g ? `#${g}` : "";
      (window.location.hash || "") !== M && history.replaceState(
        history.state,
        "",
        M || window.location.pathname + window.location.search
      );
    }
    function yk() {
      if (!hk()) return;
      const o = vk();
      o && o !== Xe.value && wt(o);
    }
    Je(Xe, (o) => {
      const s = B.rootOf(Rt(o)) ? Di(B.rootOf(Rt(o))) : o;
      qh(s), P("navigate", { path: s }), at.subscribe(Ne(o));
    }), t({
      reload: () => wt(),
      /* App plugins — a notification's `target.open` lands here (see the
         function's own note for why this is a method and not a prop). */
      openAppTarget: ch,
      /* A notification's destination, carried out in this explorer — the desktop
         app hands a clicked OS notification here (see the function's note). */
      revealNotification: Pa
    }), jt(async () => {
      var s;
      Mp();
      const o = pC();
      try {
        await wt(o || void 0);
      } finally {
        Ot();
      }
      await Gt(), (s = Tn.value) == null || s.focus(), WE(), Ph(), Hb(), Je(wh, (g) => {
        g && !Mh.value && Ph();
      }), hk() && window.addEventListener("hashchange", yk), q.endpoints.opsList && De.startPolling(), Z();
    });
    const Od = S(!1), Ld = S(!1);
    function Wh() {
      return { configured: (L.config.storages ?? []).map((o) => o.name), current: ne.value };
    }
    function Es(o) {
      const s = L.config.accountSearch, g = o.account;
      return !s || !g || g.id === s.self.id ? null : g;
    }
    function mu(o) {
      return xae(o, Es(o) ? { configured: [], current: "" } : Wh());
    }
    async function hC(o) {
      var I;
      if (!o.some((X) => typeof X.e2e_root == "string" && X.e2e_root)) return o;
      const s = ne.value || ((I = (L.config.storages ?? [])[0]) == null ? void 0 : I.name) || "", g = await Promise.all(
        o.map((X) => Vt.decorate([Kf(X, s)]).then((de) => de[0] ?? null))
      ), M = [];
      return o.forEach((X, de) => {
        const Se = g[de];
        Se && M.push(Se.e2e_stored ? { ...X, name: Se.basename, e2e_display_dir: Se.e2e_display_dir } : X);
      }), M;
    }
    async function mC(o) {
      const s = q.globalSearch(o, { limit: 8, scope: "all" }).then(hC), g = L.config.accountSearch;
      if (!g) return s;
      let M = [];
      try {
        M = await g.others() ?? [];
      } catch {
        M = [];
      }
      if (M.length === 0) return s;
      const I = [g.self, ...M], X = await Promise.allSettled([
        s,
        ...M.map((Se) => g.search(Se.id, o, { limit: 8, scope: "all" }))
      ]), de = [];
      return X.forEach((Se, $e) => {
        if (!(Se.status !== "fulfilled" || !Array.isArray(Se.value)))
          for (const ut of Se.value) de.push({ ...ut, account: I[$e] });
      }), de;
    }
    async function vC(o) {
      const s = XT(o);
      if (!s) return;
      const g = o.type === "dir", M = s.lastIndexOf("/"), I = g ? s : M === -1 ? "" : s.slice(0, M);
      let X = I;
      if (Sn.value) {
        const $e = Sy(o, Wh());
        if (!$e) return;
        X = I ? `${$e}/${I}` : $e;
      }
      if (await wt(X), g) return;
      const de = String(o.name ?? s.slice(M + 1)), Se = G.value.find(($e) => $e.type === "file" && $e.basename === de);
      Se && (oe.click(Se.path), qa(Se));
    }
    function Yh(o) {
      return (s) => P("error", { message: (s == null ? void 0 : s.message) ?? String(s), context: { op: o } });
    }
    function yC(o) {
      const s = Es(o), g = L.config.accountSearch;
      if (s && g) {
        const M = mu(o);
        M && Promise.resolve(g.open(s.id, If(M))).catch(Yh("search-open"));
        return;
      }
      vC(o);
    }
    function gC(o, s) {
      const g = mu(o);
      if (!g || s === "drag" && !kp(g)) return !1;
      if (Es(o)) {
        const M = L.config.accountSearch;
        return s === "download" ? !!(M != null && M.download) : !!(M != null && M.dragStart);
      }
      return s === "download" ? !0 : !!fi.value || g.type === "file" && (lv(L.config.auth) || Dk.value);
    }
    function bC(o) {
      if (Es(o)) return;
      const s = mu(o);
      s && u0(s) && Ik(s.path);
    }
    function kC(o) {
      const s = mu(o);
      if (!s) return;
      const g = Es(o);
      if (g) {
        const M = L.config.accountSearch;
        M != null && M.download && Promise.resolve(M.download(g.id, If(s))).catch(Yh("search-download"));
        return;
      }
      Fd([Kf(o, Sy(o, Wh()))]);
    }
    function wC(o, s) {
      const g = mu(o);
      if (!g || !s.dataTransfer || !kp(g)) {
        s.preventDefault();
        return;
      }
      s.dataTransfer.effectAllowed = "copy";
      const M = Es(o);
      if (M) {
        const I = L.config.accountSearch;
        s.preventDefault(), I != null && I.dragStart && Promise.resolve(I.dragStart(M.id, [If(g)])).catch(Yh("drag-out"));
        return;
      }
      Lk(s, [g], null, typeof o.mime == "string" ? o.mime : void 0, !1);
    }
    function _C() {
      zr(), Os();
    }
    jO(Tn, {
      onDelete: () => {
        if (Ft.value && !An.value && !zo.value) {
          oe.isEmpty.value || tt(_("toast.trash_retention"));
          return;
        }
        if (An.value) {
          const o = qn.nodes.value;
          o.length && (Po.value = o, Ei.value = !0, ha.value = !0);
        } else oe.isEmpty.value || (Ei.value = !1, ha.value = !0);
      },
      onRename: () => {
        if (An.value) {
          const o = qn.nodes.value;
          o.length === 1 && (fr.value = o[0], Ei.value = !0, to.value = !0);
        } else oe.nodes.value.length === 1 && (fr.value = oe.nodes.value[0], Ei.value = !1, to.value = !0);
      },
      onSelectAll: () => An.value ? qn.selectAll() : oe.selectAll(),
      onOpen: () => {
        if (An.value) {
          const s = qn.nodes.value[0];
          s && Mz("split", s);
          return;
        }
        const o = oe.nodes.value[0];
        o && qa(o);
      },
      onClose: () => {
        var o;
        if (sa.value = !1, to.value = !1, ha.value = !1, pn.value && Zw(pn.value.path) || (la.value = !1), (o = Fh.value) == null || o.hide(), Hh(), CE.value) {
          hd();
          return;
        }
        if (hr.value) {
          Eo();
          return;
        }
        $a.value && Cb();
      },
      onFocusSearch: () => {
        var o;
        return (o = ak.value) == null ? void 0 : o.focusSearch();
      },
      onCut: () => An.value ? sw() : UC(),
      onCopy: () => An.value ? lw() : HC(),
      onPaste: () => An.value ? void uw() : void Tk(),
      onGoUp: () => {
        var o;
        return An.value ? (o = Zt.value) == null ? void 0 : o.goUp() : je();
      },
      /* cila:c wiring */
      onPathJump: () => {
        Th.value = "", Od.value = !0;
      },
      onShowHelp: () => {
        Ld.value = !0;
      },
      /* /cila:c wiring */
      onQuickLook: () => mz(),
      onToggleHidden: () => sk(),
      onStar: () => void _b(oe.nodes.value),
      onToggleInspector: () => bh(),
      /* wiring:d1 — tab actions (registry: tab-new/close/next/prev) */
      onTabNew: () => ym(),
      onTabClose: () => Xk(vm.value),
      onTabNext: () => Sz(),
      onTabPrev: () => $z(),
      /* /wiring:d1 */
      /* tus:t1 — the menu verbs, routed through the SAME dispatcher the right-click
       * menu and the toolbar use (dispatchItemAction), so a key and a click cannot
       * drift apart. The ones that act on a selection do nothing without one, which
       * is what the menu does too. */
      onNewFolder: () => {
        sa.value = !0;
      },
      onUpload: () => Oo(),
      onRefresh: () => void wt(),
      onDownload: () => void Oi("download", ia()),
      onPreview: () => void Oi("preview", ia()),
      /* The share dialog is a door that makes links: the key opens it only where
         the menu offers Share (a role without any sharing permission gets
         nothing from the key either). */
      onShare: () => {
        const o = ia();
        DC("access", o) && Oi("access", o);
      },
      onTags: () => void Oi("tags", ia()),
      onOpenTab: () => void Oi("open-tab", ia()),
      onCopyPath: () => {
        const o = ia()[0];
        o && Kd(o.path);
      },
      onCopyId: () => void Oi("copy-id", ia()),
      onRestore: () => void Oi("restore", ia()),
      /* /tus:t1 */
      hasSelection: () => !oe.isEmpty.value
    });
    function ia() {
      return An.value ? qn.nodes.value : oe.nodes.value;
    }
    function qa(o) {
      if (o.basename === ".trash") {
        zi();
        return;
      }
      const s = Wc(o, { t: _ });
      if (s) {
        qt({ message: s.why }, 8e3);
        return;
      }
      const g = Yc(o, { t: _ });
      if (g) {
        qt({ message: g.full }, 8e3);
        return;
      }
      if (o.type === "dir") {
        const X = Sn.value ? Co(o.path) : Va(o.path);
        wt(X);
        return;
      }
      if (B.isVaultRow(o) && o.type === "file") {
        if (Vl(o, null, "edit")) return;
        Is(o);
        return;
      }
      if (Ui(o) && !an.value && !o.e2e_root) {
        Mt.open(o);
        return;
      }
      if (o.type === "file" && !an.value && typeof o.e2e_root == "string" && o.e2e_root) {
        const X = Ia(o.path);
        wt(Sn.value ? Co(X) : Va(X));
        return;
      }
      if (Yn.value && o.type === "file") {
        if (Vl(o, null, "edit")) return;
        Is(o);
        return;
      }
      if (Au.value && o.type === "file") return;
      if (yv(L.config, o) === "host") {
        P("file-opened", { path: o.path, basename: o.basename }), Ua(o);
        return;
      }
      const M = (o.extension || "").toLowerCase();
      Ha.value = io(o) ? SC(M) : "view", $i.value = null;
      const I = qu(Hl.value, o, null, Kl.value, jl(o), rs(o));
      I != null && I.view && io(o) ? Ha.value = "edit" : Rf(I) && (Ha.value = "view"), pn.value = o, la.value = !0, P("file-opened", { path: o.path, basename: o.basename }), Ua(o);
    }
    const xC = /* @__PURE__ */ new Set([
      "drawio",
      "dio",
      "pdf",
      "epub",
      "ipynb",
      "tiff",
      "tif",
      "psd",
      "mmd",
      "mermaid",
      "glb",
      "gltf",
      "obj",
      "stl",
      "fbx",
      "3ds",
      "zip",
      "rar",
      "7z",
      "tar",
      "gz",
      "tgz",
      "jpg",
      "jpeg",
      "png",
      "webp",
      "gif",
      "bmp",
      "avif",
      "svg",
      "heic",
      "mp4",
      "webm",
      "mov",
      "mkv",
      "m4v",
      "ogv",
      "mp3",
      "wav",
      "ogg",
      "flac",
      "m4a",
      "aac",
      "opus"
    ]);
    function SC(o) {
      return Tv(o) || xC.has(o) ? "view" : "edit";
    }
    const Gh = S(!1);
    async function $C(o) {
      if (Gh.value) return;
      const s = o ?? oe.nodes.value;
      if (s.length !== 0) {
        Gh.value = !0;
        try {
          if (Ft.value) {
            const I = s.map((de) => de.id).filter((de) => typeof de == "number");
            if (sd("restore")) {
              const { ops: de, summary: Se } = await q.restoreQueued(I);
              for (const $e of de) De.register($e);
              Se && tt(Se), oe.clear();
              return;
            }
            const X = await q.restoreBatch(I);
            qt({ message: X.summary }, X.failed ? yn : hi), oe.clear(), await zi();
            return;
          }
          if (!q.endpoints.restore) return;
          const g = s.map((I) => I.path), { restored: M } = await q.restore(g);
          tt(_("toast.restored", { n: M })), oe.clear(), await wt();
        } catch (g) {
          qt({ message: Zn(g) }, yn), P("error", { message: g.message, context: { op: "restore" } });
        } finally {
          Gh.value = !1;
        }
      }
    }
    function Dd(o) {
      if (B.isVaultRow(o) && o.type === "file") {
        if (Vl(o, null, "view")) return;
        Is(o);
        return;
      }
      if (Ui(o) && !an.value && !o.e2e_root) {
        Mt.open(o);
        return;
      }
      if (Yn.value && o.type === "file") {
        if (Vl(o, null, "view")) return;
        Is(o);
        return;
      }
      Ha.value = "view", $i.value = null, pn.value = o, la.value = !0, Ua(o);
    }
    function TC(o) {
      if (o.type === "dir") {
        const de = Sn.value ? Co(o.path) : Va(o.path);
        wt(de);
        return;
      }
      if (Ui(o) && !an.value && !o.e2e_root) {
        Mt.open(o);
        return;
      }
      if (an.value) {
        Yn.value && Is(o);
        return;
      }
      if (L.config.openInHost) {
        qa(o);
        return;
      }
      if (!io(o)) {
        Dd(o);
        return;
      }
      const s = (o.extension || "").toLowerCase(), g = L.config.openPageBase;
      if (!g) {
        qa(o);
        return;
      }
      const M = Vk(g), I = M.includes("?") ? "&" : "?", X = `${M}${I}path=${encodeURIComponent(o.path)}&type=${encodeURIComponent(s)}&mode=edit`;
      window.open(X, "_blank", "noopener"), P("file-opened", { path: o.path, basename: o.basename }), Ua(o);
    }
    const Pi = S("selection"), Xh = S(""), Po = S([]), AC = S(""), EC = A(() => {
      const o = ia();
      return o.length === 0 ? "none" : o.length === 1 ? o[0].type === "dir" ? "single-dir" : "single-file" : "multi";
    });
    async function Jh(o) {
      const s = ia();
      if (o === "open") {
        s[0] && qa(s[0]);
        return;
      }
      await Oi(o, s);
    }
    const ci = A(() => L.config.desktopSync ?? null), Rd = S([]);
    let gk = !1;
    async function mr() {
      if (!ci.value) return;
      const o = gk ? () => {
      } : du.start();
      try {
        Rd.value = await ci.value.kept(), gk = !0;
      } catch {
      } finally {
        o();
      }
    }
    const Cs = S(null);
    async function bk() {
      const o = ci.value;
      if (o != null && o.status)
        try {
          Cs.value = (await o.status()).active ?? null;
        } catch {
          Cs.value = null;
        }
    }
    let zs = null, Zh = !0;
    function CC() {
      zs || !Zh || (zs = setTimeout(() => {
        zs = null, Zh && (bk(), mr());
      }, 300));
    }
    jt(() => {
      var o, s;
      mr(), bk(), (s = (o = ci.value) == null ? void 0 : o.onChange) == null || s.call(o, CC);
    }), Tt(() => {
      Zh = !1, zs && (clearTimeout(zs), zs = null);
    });
    function vu(o) {
      const s = String(o.path ?? "");
      return s.includes("://") ? s.replace(/\/+$/, "") : `${s}://`;
    }
    function Nd(o, s) {
      return s.endsWith("://") ? o.startsWith(s) && o !== s : o === s ? !1 : o.startsWith(s + "/");
    }
    function Qh(o) {
      return Rd.value.some((s) => s.remote === o) ? "kept" : Rd.value.some((s) => Nd(o, s.remote)) ? "inherited" : Rd.value.some((s) => Nd(s.remote, o)) ? "partial" : "none";
    }
    function kk(o) {
      if (!ci.value || Kt.value || o.basename === ".trash") return null;
      const s = vu(o), g = Cs.value;
      if (g && (s === g.remote || Nd(s, g.remote) || Nd(g.remote, s)))
        return "syncing";
      const M = Qh(s);
      return M === "kept" || M === "inherited" ? "kept" : M === "partial" ? "partial" : "cloud";
    }
    const zC = A(() => {
      const o = Cs.value;
      if (!o) return "";
      const s = o.remote.endsWith("://") ? o.remote.slice(0, -3) : o.remote.slice(o.remote.lastIndexOf("/") + 1);
      return o.phase === "transfer" && o.total > 0 ? _("keep.strip_transfer", {
        name: s,
        done: String(o.done),
        total: String(o.total),
        pct: String(Math.min(100, Math.round(o.done * 100 / o.total)))
      }) : o.phase === "settling" ? _("keep.strip_settling", { name: s }) : _("keep.strip_inventory", { name: s });
    }), wk = A(() => {
      const o = Cs.value;
      return !o || o.phase !== "transfer" || o.total <= 0 ? null : Math.min(100, Math.round(o.done * 100 / o.total));
    });
    function _k(o) {
      const s = o[0], g = String((s == null ? void 0 : s.storage) || (s == null ? void 0 : s.path) || ""), M = T5(g, L.config.storages, bn.value);
      return [
        ...x5(_, {
          manages: A5({ admin: pa.value, level: M }),
          shareUsers: Ms("share.users")
        }),
        ...xk(o)
      ];
    }
    function xk(o) {
      var I, X, de;
      const s = ci.value, g = o.length === 1 && (((I = o[0]) == null ? void 0 : I.type) === "dir" || ((X = o[0]) == null ? void 0 : X.type) === "file");
      if (!s || !g || Kt.value || an.value || ((de = o[0]) == null ? void 0 : de.e2e) === !0) return [];
      const M = Qh(vu(o[0]));
      return [
        { divider: !0, key: "sep-keep", label: "" },
        { key: "keep-local", label: _("ctx.keep_local"), hidden: M === "kept" || M === "inherited" },
        { key: "keep-online", label: _("ctx.keep_online"), hidden: M !== "kept" },
        { key: "keep-inherited", label: _("ctx.keep_inherited"), disabled: !0, hidden: M !== "inherited" },
        { key: "keep-reveal", label: _("ctx.keep_reveal"), hidden: M !== "kept" && M !== "inherited" }
      ];
    }
    const em = S([]);
    let Id = 0;
    async function yu(o, s) {
      var M;
      const g = ++Id;
      if (s.length > 0 && ($k.value, du.count > 0 && typeof window < "u")) {
        const I = (X) => {
          X.type === "keydown" && X.key !== "Escape" || g === Id && Id++;
        };
        window.addEventListener("pointerdown", I, !0), window.addEventListener("keydown", I, !0);
        try {
          await du.settled(ele);
        } finally {
          window.removeEventListener("pointerdown", I, !0), window.removeEventListener("keydown", I, !0);
        }
      }
      g === Id && ((M = Fh.value) == null || M.show(o, s));
    }
    async function tm(o, s) {
      Pi.value = "selection", mr(), oe.has(o.path) || (oe.click(o.path), await Gt()), em.value = oe.nodes.value.length ? [] : [o];
      const g = oe.nodes.value.length ? oe.nodes.value : [o];
      await yu({ clientX: s.clientX, clientY: s.clientY }, g);
    }
    function MC(o) {
      o.preventDefault(), Pi.value = "selection", oe.clear(), em.value = [], yu({ clientX: o.clientX, clientY: o.clientY }, []);
    }
    function PC(o) {
      Pi.value = "breadcrumb", Xh.value = o.adapterPath, AC.value = o.label, yu({ clientX: o.x, clientY: o.y }, []);
    }
    async function Sk(o, s, g) {
      if (mr(), o === "split") {
        pi.value = "split";
        const M = qn.nodes.value;
        s && !qn.has(s.path) && (qn.click(s.path), await Gt());
        const I = qn.nodes.value;
        Po.value = s ? I.length > 0 ? I : M.length > 0 ? M : [s] : [], Pi.value = "pane", await yu({ clientX: g.clientX, clientY: g.clientY }, Po.value);
        return;
      }
      if (pi.value = "main", Pi.value = "selection", !s) {
        oe.clear(), yu({ clientX: g.clientX, clientY: g.clientY }, []);
        return;
      }
      await tm(s, g);
    }
    const $k = A(() => {
      if (Pi.value === "breadcrumb")
        return [
          { key: "open", label: _("ctx.open") },
          { key: "copy-path", label: _("breadcrumb.copy_path") }
        ];
      if (Pi.value === "pane") {
        const X = Po.value;
        return X.length === 0 ? [
          { key: "new-folder", label: _("toolbar.new_folder") },
          { key: "paste", label: _("ctx.paste"), disabled: !ze.value.mode }
        ] : gu(X);
      }
      const o = oe.nodes.value.length ? oe.nodes.value : em.value, s = o.length > 0, g = o.length === 1;
      if (Kt.value)
        return s ? [
          { key: "restore", label: _("ctx.restore"), hidden: !Ms("files.create") },
          ...zo.value ? [
            { divider: !0, key: "sep1", label: "" },
            { key: "delete", label: _("ctx.delete_perm"), danger: !0, hidden: !Ms("files.purge") }
          ] : []
        ] : [];
      const M = (Xe.value ?? "").replace(/^\/+|\/+$/g, "");
      if (Sn.value && M === "")
        return s ? g ? _k(o) : [] : [];
      if (!s) {
        const X = [
          {
            key: "toggle-hidden",
            label: tc.value ? _("ctx.hide_hidden") : _("ctx.show_hidden")
          }
        ];
        return cu(ye.value) ? [
          { key: "new-folder", label: _("toolbar.new_folder") },
          { key: "paste", label: _("ctx.paste"), disabled: !ze.value.mode },
          ...X
        ] : X;
      }
      return gu(o);
    });
    function Ms(o) {
      const s = ve.value;
      return !s || s.includes(o);
    }
    const OC = {
      rename: ["files.rename"],
      cut: ["files.move"],
      "move-to": ["files.move"],
      delete: ["files.delete"],
      download: ["files.download"],
      convert: ["files.create"],
      "copy-to": ["files.create"],
      paste: ["files.create", "files.move"],
      tags: ["files.tag"],
      /* wiring:e2 policy — the four rows that START an encryption make something,
         a key file or a `.fxe`, and the server asks files.create for that beside
         files.encrypt (backend perm.FilesEncrypt: "carved out of files.create,
         which the same write needs as well"). A place can allow the one and deny
         the other; the row is then hidden, not offered to be refused. */
      "fxe-encrypt": ["files.create"],
      "fxe-request": ["files.create"],
      "e2e-convert": ["files.create"],
      "e2e-request": ["files.create"]
    };
    function Bd(o) {
      return b5((s) => fu(s, o));
    }
    function LC(o, s) {
      if (!ve.value || s.length > 0 && s.every((M) => B.isVaultRow(M))) return o;
      const g = s.map((M) => M.path);
      return o.map((M) => {
        if (M.key === "access") {
          const X = s.length > 0 && s.every((de) => de.type === "dir");
          return k5(Bd(g), X) ? M : { ...M, hidden: !0 };
        }
        const I = OC[M.key];
        return I && !I.some((X) => fu(X, g)) ? { ...M, hidden: !0 } : M;
      });
    }
    function DC(o, s) {
      return gu(s).some((g) => g.key === o && !g.hidden && !g.disabled);
    }
    function gu(o) {
      const s = LC(NC(o), o);
      return o.some(WS) ? s.map((g) => g.divider || g.key === "details" ? g : { ...g, disabled: !0 }) : s;
    }
    function RC(o) {
      var X;
      const s = String(o[0].vault_root ?? ""), g = o.length === 1, M = g && o[0].type === "file", I = cu(B.permOf(s)) && !((X = B.strips[s]) != null && X.readOnly) && fu("files.create", [s]) && fu("files.delete", [s]);
      return [
        { key: "preview", label: _("ctx.preview"), hidden: !g, disabled: !M },
        { key: "download", label: _("ctx.download"), disabled: o.length === 0 },
        { key: "details", label: _("ctx.details") },
        { divider: !0, key: "sep1", label: "", hidden: !I },
        { key: "rename", label: _("ctx.rename"), hidden: !g || !I },
        { key: "cut", label: _("ctx.cut"), hidden: !I },
        { key: "copy", label: _("ctx.copy") },
        { key: "paste", label: _("ctx.paste"), hidden: !I, disabled: !ze.value.mode },
        { divider: !0, key: "sep2", label: "", hidden: !I },
        { key: "delete", label: _("ctx.delete"), danger: !0, hidden: !I }
      ];
    }
    function NC(o) {
      var vn, $n, Fi, Ga;
      if (o.length > 0 && o.every((sf) => B.isVaultRow(sf))) return RC(o);
      const s = o.length > 0, g = o.length === 1;
      if (o.some(cc))
        return g ? _k(o) : [];
      const M = g && ((vn = o[0]) == null ? void 0 : vn.type) === "file", I = _("ctx.tags_menu"), X = g && nm(o[0]), de = g && typeof (($n = o[0]) == null ? void 0 : $n.id) == "number", Se = ph(o).length > 0, $e = wb(o), ut = XE(o), et = cu(ut) && !Jb(o), Pt = _("shortcuts.share"), En = String(((Fi = o[0]) == null ? void 0 : Fi.extension) ?? "").toLowerCase(), At = M ? Tv(En) ? Fm(!!rr.value, pa.value, _("ctx.needs_onlyoffice")) : En === "drawio" || En === "dio" ? Fm(!!Jl.value, pa.value, _("ctx.needs_drawio")) : {} : {}, Ya = KT(o, { canWrite: et, inEncrypted: an.value });
      return [
        { key: "open", label: _("ctx.open"), ...At, hidden: !g || At.hidden === !0 },
        { key: "open-tab", label: _("ctx.open_new_tab"), hidden: !g || ((Ga = o[0]) == null ? void 0 : Ga.type) !== "dir" },
        { key: "preview", label: _("ctx.preview"), hidden: !g, disabled: !M },
        /* tasi:m1 — Download works on ANY selection now. It used to disappear the
           moment a second row was ticked, because the only implementation was one
           `window.open` per node and the browser blocks the second popup; there is
           one streaming archive behind it now (lib/downloadSelection), and the
           server expands a selected folder itself, so a lone folder is a zip too.
           Inside an encrypted folder the server has no plaintext to zip: the zip
           is made in this tab (below), and a LOCKED folder downloads one row at
           a time. */
        /* wiring:e2 fxe — inside an unlocked encrypted folder a selection of any
           size downloads DECRYPTED now (a zip made in this tab); the ciphertext is
           "Download encrypted copy" below. */
        { key: "download", label: _("ctx.download"), hidden: !s || Au.value && !g, disabled: !s },
        /* wiring:e2 fxe — single encrypted files, and the ciphertext copy.
           wiring:e2 policy — "Encrypt with E2EE…" asks the answer for the file it
           would encrypt, and becomes "Request encryption…" under the approval
           policy (useE2eFiles menuRows). */
        ...Mt.menuRows(o, {
          canWrite: et,
          inEncrypted: an.value,
          unlockedEncryptedCopy: Yn.value || g && Dw(o[0]) !== null,
          encryptAnswer: Ya ? Bh(Ya.path, "file") : void 0
        }),
        { key: "archive-create", label: _("ctx.archive_create"), hidden: !s || g && X || !et || an.value || tu.value.length === 0, disabled: !s },
        { key: "archive-extract", label: _("ctx.archive_extract"), hidden: !X || !et || an.value, disabled: !X },
        { key: "archive-extract-here", icon: "archive-extract", label: _("archive.extract_here"), hidden: !X || !et || an.value, disabled: !X },
        /* tasi:m1 — VISIBLE and grey above a multi-selection, not gone. Sharing
           really is one item at a time (a share link addresses one node), and the
           row now says so in its tooltip; vanishing taught the reader that filex
           cannot share the thing they are looking at. */
        {
          key: "access",
          label: Pt,
          hidden: !s || !et || BS(o, an.value),
          disabled: !g,
          title: g ? void 0 : _("ctx.access.one_only")
        },
        { key: "details", label: _("ctx.details"), hidden: !s },
        /* wiring:e2 convert — encrypt a folder that already exists, in place.
           wiring:e2 policy — offered where the policy lets this account encrypt
           that folder; where it wants an approval, the menu asks for one. */
        { key: "e2e-convert", label: _("e2e.convert.ctx"), icon: "lock", hidden: !zw(o, et, "allowed") },
        { key: "e2e-request", label: _("e2e.request.ctx"), icon: "lock", hidden: !zw(o, et, "request") },
        /* ⚠ "Copy node id" is NOT here any more (owner's call, 2026-09-13): it is a
           developer's handle on a support ticket, not an everyday verb, and this
           list is rendered by BOTH the right-click menu and the selection bar — so
           one row put it in front of everyone, twice. It lives in the details
           panel now, beside Path and ETag, which is where the other technical
           facts about a file already are. The `copy-id` case below stays: the
           panel dispatches it. */
        { divider: !0, key: "sep1", label: "", hidden: !et },
        { key: "rename", label: _("ctx.rename"), hidden: !g || !et, disabled: !g },
        { key: "cut", label: _("ctx.cut"), hidden: !s || !et, disabled: !s },
        { key: "copy", label: _("ctx.copy"), hidden: !s, disabled: !s },
        /* tasi:m1 — "somewhere else", without the clipboard. Cut+paste has always
           been able to do this, but only by navigating away from the rows you had
           just picked; these two ask WHERE in a dialog and leave the listing where
           it is.
           ⚠ `icon:` is not decoration here — `actionIconSvg` answers '' for a key
           it does not know, and a bar button with no glyph is an empty 28px box.
           They borrow the clipboard verbs' marks, which is what they are. */
        { key: "move-to", label: _("ctx.move_to"), icon: "cut", hidden: !s || !et, disabled: !s },
        { key: "copy-to", label: _("ctx.copy_to"), icon: "copy", hidden: !s, disabled: !s },
        /* Paste needs a destination folder; a virtual view (Recent / Starred /
           Shared / a tag / Home) has none, so it is the one write verb the row
           menu does not carry there — every per-row verb above and below does. */
        { key: "paste", label: _("ctx.paste"), hidden: !et || Qe.value, disabled: !ze.value.mode },
        { divider: !0, key: "sep-meta", label: "", hidden: !de && !Se },
        /* yildiz:s1 — "star must be an action, like a tag" (owner, v0.30.0).
           Beside Tags on purpose: they are the same kind of verb, and this is the
           ONLY star a grid/gallery user reaches with the keyboard. Works on a
           multi-selection; the label follows the selection's state. */
        {
          key: "star",
          label: _($e ? "ctx.unstar" : "ctx.star"),
          icon: $e ? "unstar" : "star",
          hidden: !Se
        },
        { key: "tags", label: I, hidden: !de, disabled: !de },
        /* App plugins — one row per action whose `applies` rule accepts the
           selection, under its own `sep-plugins` divider; `[]` when the feature
           is off, in the trash, or inside an encrypted folder (lib/pluginMenu). */
        ...MA(o),
        ...BA(o),
        ...xk(o),
        { divider: !0, key: "sep2", label: "", hidden: !et },
        { key: "delete", label: _("ctx.delete"), danger: !0, hidden: !s || !et, disabled: !s }
      ];
    }
    const IC = /* @__PURE__ */ new Set(["zip", "7z", "rar", "tar", "gz", "tgz", "bz2", "tbz2", "xz", "txz"]);
    function nm(o) {
      return !!o && o.type === "file" && IC.has((o.extension || "").toLowerCase());
    }
    const BC = A(() => {
      const o = ia();
      if (An.value) return o.length ? gu(o).filter((g) => g.key !== "archive-extract-here") : [];
      if (Kt.value)
        return o.length === 0 ? [] : [
          { key: "restore", label: _("ctx.restore"), hidden: !Ms("files.create") },
          ...zo.value ? [{ key: "delete", label: _("ctx.delete_perm"), danger: !0, hidden: !Ms("files.purge") }] : []
        ];
      const s = (Xe.value ?? "").replace(/^\/+|\/+$/g, "");
      return Sn.value && s === "" ? o.length === 1 ? [{ key: "open", label: _("ctx.open") }] : [] : o.length === 0 ? [] : gu(o).filter((g) => g.key !== "archive-extract-here");
    });
    async function FC(o, s) {
      if (Pi.value === "breadcrumb") {
        o.key === "open" ? wt(Va(Xh.value)) : o.key === "copy-path" && await Kd(Xh.value);
        return;
      }
      if (Pi.value === "pane") {
        await Oi(o.key, Po.value);
        return;
      }
      await Oi(o.key, s);
    }
    function di() {
      return Pi.value === "pane" || An.value;
    }
    async function Oi(o, s) {
      var g, M;
      if (e3(o)) {
        await hb(o, s);
        return;
      }
      if (o === "open-with-choose") {
        s[0] && (Da.value = s[0]);
        return;
      }
      if (o.startsWith("open-with:")) {
        const I = s[0];
        if (I) {
          const X = o.slice(10);
          Dd(I), $i.value = X, X !== "builtin" && io(I) && (Ha.value = "edit");
        }
        return;
      }
      if (Gne(o)) {
        await Mt.dispatch(o, s, (I) => Fd(I, { encrypted: !0 }));
        return;
      }
      switch (o) {
        case "clear-selection":
          An.value ? qn.clear() : oe.clear();
          return;
        case "open":
          s[0] && TC(s[0]);
          break;
        case "preview":
          s[0] && Dd(s[0]);
          break;
        case "e2e-convert":
          s[0] && vM(s[0]);
          break;
        case "e2e-request":
          s[0] && wm(s[0].path, "folder", s[0].basename);
          break;
        case "download":
          await Fd(s);
          break;
        case "archive-create":
          if (s.length === 0) break;
          eu.value = s, fs.value = di(), ds.value = fs.value ? Rt(((g = Zt.value) == null ? void 0 : g.getPath()) ?? "") : Rt(Xe.value), Ai.value = "", ld.value = !0;
          break;
        case "archive-extract":
          if (!s[0] || !nm(s[0])) break;
          Ao.value = s[0], fs.value = di(), ds.value = oo(s[0].path), Ai.value = "", ur.value = !0;
          break;
        case "archive-extract-here":
          if (!s[0] || !nm(s[0])) break;
          Ao.value = s[0], fs.value = di(), ds.value = oo(s[0].path), Ai.value = "", await rm(s[0], ds.value, fs.value);
          break;
        case "move-to":
        case "copy-to":
          if (s.length === 0) break;
          ud.value = o === "move-to" ? "move" : "copy", cd.value = s, dd.value = !1, ys.value = !0;
          break;
        case "keep-local": {
          const I = ci.value;
          if (!I || !s[0]) break;
          const X = vu(s[0]);
          try {
            await I.keep(X, s[0].type === "file" ? "file" : "dir"), await mr(), Qh(X) !== "none" && tt(_("keep.started"));
          } catch (de) {
            await mr(), tt(`${_("keep.failed")}: ${String((de == null ? void 0 : de.message) ?? de)}`);
          }
          break;
        }
        case "keep-online": {
          const I = ci.value;
          if (!I || !s[0]) break;
          try {
            await I.unkeep(vu(s[0]));
          } catch {
          }
          await mr();
          break;
        }
        case "keep-reveal": {
          const I = ci.value;
          I && s[0] && I.reveal(vu(s[0]));
          break;
        }
        case "access":
          s[0] && (si.value = s[0], pr.value = !0);
          break;
        case "storage-access":
          s[0] && (si.value = _5(s[0]), su.value = "perms", pr.value = !0);
          break;
        case "details":
          yE();
          break;
        case "copy-id":
          if (s[0] && typeof s[0].id == "number") {
            const I = s[0].id;
            (M = navigator.clipboard) == null || M.writeText(String(I)).then(
              () => tt(_("toast.node_id_copied", { id: I })),
              () => tt(`#${I}`)
            );
          }
          break;
        case "star":
          await _b(s);
          break;
        case "tags":
          s[0] && VA(s[0]);
          break;
        case "rename":
          s[0] && (fr.value = s[0], Ei.value = di(), to.value = !0);
          break;
        case "cut":
          di() ? sw() : (ze.value = { mode: "cut", items: s, sourcePath: Xe.value }, tt(_("toast.cut_ready")));
          break;
        case "copy":
          di() ? lw() : (ze.value = { mode: "copy", items: s, sourcePath: Xe.value }, tt(_("toast.copy_ready")));
          break;
        case "paste":
          di() ? await uw() : await Tk();
          break;
        case "delete": {
          const I = di();
          I && (Po.value = s), Ei.value = I, ha.value = !0;
          break;
        }
        case "restore":
          s.length > 0 && await $C(s);
          break;
        case "toggle-hidden":
          sk();
          break;
        case "new-folder":
          Ei.value = di(), sa.value = !0;
          break;
        case "duplicate":
          s[0] && await KC(s[0]);
          break;
        case "open-tab":
          s[0] && Jk(s[0]);
          break;
      }
    }
    function UC() {
      oe.isEmpty.value || (ze.value = { mode: "cut", items: oe.nodes.value, sourcePath: Xe.value }, tt(_("toast.cut")));
    }
    function HC() {
      oe.isEmpty.value || (ze.value = { mode: "copy", items: oe.nodes.value, sourcePath: Xe.value }, tt(_("toast.copied")));
    }
    let am = !1;
    async function Tk() {
      const o = ze.value;
      if (!(!o.mode || o.items.length === 0 || am)) {
        am = !0;
        try {
          const s = o.items.map(($e) => $e.path), g = o.sourcePath || "";
          if (o.mode === "cut" && g === Xe.value) {
            tt(_("toast.same_folder_cut"));
            return;
          }
          const I = Rt(Xe.value), X = bw(s, I);
          if (X === "cross") {
            tt(_("e2e.vault.cross"));
            return;
          }
          if (X === "inside") {
            (o.mode === "cut" ? await B.move(s, I) : await B.copy(s, I)) && o.mode === "cut" && (ze.value = { mode: null, items: [], sourcePath: null });
            return;
          }
          const de = D0(s, I, o.mode === "cut" ? "move" : "copy"), Se = await zm(o.mode === "cut" ? "move" : "copy", s, I, Rt(g) || void 0);
          if (Se) {
            Se.undo && Se.ops.length && he.set(Se.ops[Se.ops.length - 1].id, { message: _("toast.moved"), fn: Se.undo }), Se.ops.length && tt(o.mode === "cut" ? _("split.move_queued") : _("split.copy_queued")), ze.value = { mode: null, items: [], sourcePath: null };
            return;
          }
          if (o.mode === "cut") {
            const $e = Rt(g) || void 0, ut = await fk(s, I), { op: et } = await q.moveAsync(s, I, $e);
            pk(et.id, s, I, $e, ut), De.register(et), tt(
              ut ? _("toast.move_kept_both") : de.cross ? _("split.cross_move") : _("split.move_queued")
            );
          } else {
            const { op: $e } = await q.copy(s, I);
            De.register($e), tt(de.cross ? _("split.cross_copy") : _("split.copy_queued"));
          }
          ze.value = { mode: null, items: [], sourcePath: null };
        } catch (s) {
          ql(s, { op: "paste" });
        } finally {
          am = !1;
        }
      }
    }
    async function KC(o) {
      try {
        const { op: s } = await q.copy([o.path], Rt(Xe.value));
        De.register(s);
      } catch (s) {
        ql(s, { op: "duplicate" });
      }
    }
    function VC(o) {
      if (B.isVaultRow(o)) {
        B.download([o]);
        return;
      }
      if (Yn.value) {
        Zz(o);
        return;
      }
      const s = q.downloadUrl(o.path);
      window.open(s, "_blank");
    }
    const im = S(!1);
    async function Fd(o, s = {}) {
      if (o.length !== 0) {
        if (o.every((g) => B.isVaultRow(g))) {
          await B.download(o);
          return;
        }
        if (!(!s.encrypted && await AM(o))) {
          if (o.length === 1 && o[0].type === "file") {
            if (s.encrypted) {
              window.open(q.downloadUrl(o[0].path), "_blank");
              return;
            }
            VC(o[0]);
            return;
          }
          if (!im.value) {
            im.value = !0, qt({ message: _("toast.archive.preparing") }, wf);
            try {
              const g = await _ae(q, o.map((I) => I.path)), M = o.length === 1 && o[0].e2e_stored ? `${o[0].basename}.zip` : g.name;
              tt(_("toast.archive.started", { name: M, count: String(g.files) }));
            } catch (g) {
              const M = g;
              qt({ message: M.status === 409 ? _("toast.archive.empty") : Zn(g) }, yn), P("error", { message: M.message, context: { op: "archive-download" } });
            } finally {
              im.value = !1;
            }
          }
        }
      }
    }
    async function jC(o) {
      var I;
      const s = cd.value;
      if (!o || s.length === 0) {
        ys.value = !1;
        return;
      }
      const g = ud.value === "move", M = di() ? Rt(((I = Zt.value) == null ? void 0 : I.getPath()) ?? "") : Rt(Xe.value);
      dd.value = !0;
      try {
        const X = await Rs(s.map((Se) => Se.path), o, M || void 0, g ? "move" : "copy"), de = Vt.segmentLabel(o) ?? ml(o, o);
        X === "queued" ? tt(g ? _("toast.moved_to", { name: de }) : _("toast.copied_to", { name: de })) : X === "nothing" && tt(_("toast.already_there", { name: de })), g && (X === "queued" || X === "done") && (di() ? qn.clear() : oe.clear());
      } finally {
        dd.value = !1, ys.value = !1;
      }
    }
    async function qC(o) {
      Ql.value = !1;
      const s = o.app ? `${o.app.plugin}/${o.app.view}` : null;
      if (o.draft) {
        us.value += 1, Tb(o.draft, s), yh();
        return;
      }
      const g = o.path.slice(0, o.path.lastIndexOf("/"));
      g && g !== Rt(Xe.value) ? await wt(g) : await wt();
      const M = o.name.lastIndexOf("."), I = G.value.find((X) => X.path === o.path) ?? {
        type: "file",
        path: o.path,
        basename: o.name,
        extension: M > 0 ? o.name.slice(M + 1).toLowerCase() : ""
      };
      if (yv(L.config, I) === "host") {
        P("file-opened", { path: I.path, basename: I.basename }), Ua(I);
        return;
      }
      vs.value = o.ext ? { path: I.path, ext: o.ext } : null, $i.value = s, pn.value = I, Ha.value = io(I) ? "edit" : "view", la.value = !0, P("file-opened", { path: I.path, basename: I.basename }), Ua(I);
    }
    function WC(o) {
      const s = o == null ? void 0 : o.detail;
      if (s)
        try {
          return JSON.parse(s).code;
        } catch {
          return;
        }
    }
    function om(o) {
      const s = o == null ? void 0 : o.detail;
      if (s)
        try {
          const g = JSON.parse(s), M = {
            PASSWORD_REQUIRED: "archive.password_required",
            BAD_PASSWORD: "archive.bad_password",
            TARGET_EXISTS: "archive.target_exists",
            PASSWORD_CHARSET: "archive.password_charset",
            UNSUPPORTED_FORMAT: "archive.error_unsupported",
            ARCHIVE_LIMIT_EXCEEDED: "archive.error_limit",
            PROVIDER_UNAVAILABLE: "archive.error_unavailable"
          };
          if (g.code && M[g.code]) return _(M[g.code]);
          if (g.error) return g.error;
        } catch {
        }
      return (o == null ? void 0 : o.message) || _("toast.failed");
    }
    async function YC(o) {
      gh.value = !0, Ai.value = "";
      try {
        const { op: s } = await q.archiveCreate({
          dest: ja(ds.value, o.name),
          sources: eu.value.map((g) => g.path),
          format: o.format,
          password: o.password,
          encrypt_filenames: o.encrypt_filenames,
          compression: o.compression,
          solid: o.solid,
          dictionary_size_mb: o.dictionary_size_mb
        });
        De.register(s), ld.value = !1, _u.reveal(), tt(_("archive.queued"));
      } catch (s) {
        Ai.value = om(s), P("error", { message: Ai.value, context: { op: "archive-create" } });
      } finally {
        gh.value = !1;
      }
    }
    async function rm(o, s, g, M) {
      var de, Se;
      if (cr.value.has(o.path)) {
        tt(_("archive.already_preparing", { name: o.basename }));
        return;
      }
      cr.value = new Set(cr.value).add(o.path), Ai.value = "";
      const I = _("archive.preparing_extract", { name: o.basename }), X = setTimeout(() => {
        !ur.value && !cs.value && qt({ message: I }, wf);
      }, 600);
      try {
        const $e = await q.archiveExtract(o.path, {
          dest: s,
          password: M
        });
        if (ur.value = !1, cs.value = !1, dr.value = null, ps.value = "", $e.op) {
          De.register($e.op), _u.reveal(), tt(_("archive.extraction_queued"));
          return;
        }
        g ? await ((de = Zt.value) == null ? void 0 : de.reload()) : await wt(), tt(_("archive.extracted", { count: $e.count ?? 0 }));
      } catch ($e) {
        const ut = WC($e);
        if (ut === "PASSWORD_REQUIRED" || ut === "BAD_PASSWORD") {
          dr.value = { target: o, dest: s, inPane: g }, ps.value = ut === "BAD_PASSWORD" ? _("archive.bad_password") : "", ur.value = !1, cs.value = !0;
          return;
        }
        const et = om($e);
        cs.value ? ps.value = et : ur.value ? Ai.value = et : qt({ message: et }, 6e3);
      } finally {
        clearTimeout(X), ((Se = ma.value) == null ? void 0 : Se.message) === I && (ma.value = null);
        const $e = new Set(cr.value);
        $e.delete(o.path), cr.value = $e;
      }
    }
    async function GC(o) {
      const s = Ao.value;
      s && await rm(
        s,
        ja(ds.value, o.folder),
        fs.value
      );
    }
    async function XC(o) {
      const s = dr.value;
      s && (ps.value = "", await rm(s.target, s.dest, s.inPane, o));
    }
    function JC() {
      cs.value = !1, dr.value = null, ps.value = "";
    }
    async function ZC(o) {
      try {
        await q.opsCancel(o), await De.poll();
      } catch (s) {
        const g = De.ops.value.find((I) => I.id === o), M = (g == null ? void 0 : g.op_type) === "archive-create" || (g == null ? void 0 : g.op_type) === "archive-extract";
        qt({ message: M ? om(s) : Zn(s, _("plugin.cancel_failed")) }, yn);
      }
    }
    async function QC(o) {
      var M, I;
      const s = ms.begin();
      if (s === null) return;
      const g = Ei.value;
      try {
        const X = Rt(g ? ((M = Zt.value) == null ? void 0 : M.getPath()) ?? "" : Xe.value);
        if (B.rootOf(X)) {
          await B.mkdir(X, o) && (sa.value = !1, ms.end(s));
          return;
        }
        await Ak(X, o), sa.value = !1, ms.end(s), g ? await ((I = Zt.value) == null ? void 0 : I.reload()) : await wt();
      } catch (X) {
        Wl(ms, s, X, { op: "newfolder" });
      } finally {
        ms.end(s);
      }
    }
    async function Ak(o, s) {
      const g = Ny(await Tw(o, s, { isDir: !0 }));
      return await q.newFolder(o, g), ja(o, g);
    }
    async function ez(o) {
      var I, X;
      const s = fr.value;
      if (!s) return;
      const g = hs.begin();
      if (g === null) return;
      const M = Ei.value;
      try {
        const de = Rt(M ? ((I = Zt.value) == null ? void 0 : I.getPath()) ?? "" : Xe.value), Se = s.path;
        if (B.rootOf(Se)) {
          await B.rename(Se, o) && (to.value = !1, fr.value = null, hs.end(g));
          return;
        }
        const $e = Mf(s), ut = await Tw(
          oo(Se),
          o,
          s.type === "dir" ? { keepIdOf: Se } : {}
        ), et = s.type === "dir" && sd("rename");
        let Pt;
        et ? Pt = (await q.renameQueued(de, Se, ut)).op : await q.rename(de, Se, ut), to.value = !1, fr.value = null, hs.end(g);
        const En = ja(oo(Se), ut), At = ut && ut !== $e ? async () => {
          if (!et) {
            await q.rename(de, En, $e);
            return;
          }
          const Ya = (await q.renameQueued(de, En, $e)).op;
          return Ya && De.register(Ya), { queued: !0 };
        } : null;
        if (Pt) {
          At && he.set(Pt.id, { message: _("toast.renamed"), fn: At }), De.register(Pt), tt(_("toast.rename_queued", { name: o }));
          return;
        }
        M ? await ((X = Zt.value) == null ? void 0 : X.reload()) : await wt(), At && $d(_("toast.renamed"), At);
      } catch (de) {
        const Se = de, $e = de instanceof $w ? _("e2e.names.bad_name", { name: o }) : Se.status === 409 ? _("newdoc.err.exists", { name: o }) : Zn(de);
        Wl(hs, g, de, { op: "rename" }, $e);
      } finally {
        hs.end(g);
      }
    }
    const Ps = S(/* @__PURE__ */ new Set()), sm = /* @__PURE__ */ new Map();
    function bu(o, s) {
      const g = new Set(Ps.value);
      for (const M of o)
        s ? g.add(M) : g.delete(M);
      Ps.value = g;
      for (const M of G.value) {
        const I = M.id, X = M.extra_metadata;
        typeof I == "number" && o.includes(I) && X && (X.purging = s);
      }
    }
    async function tz() {
      const o = oe.nodes.value.map(($e) => $e.id).filter(($e) => typeof $e == "number");
      if (o.length === 0) {
        ha.value = !1;
        return;
      }
      const s = o.filter(($e) => !Ps.value.has($e));
      if (s.length === 0) {
        ha.value = !1, tt(_("trash.row_busy"));
        return;
      }
      const g = Sa.begin();
      if (g === null) return;
      const M = sd("purge");
      bu(s, !0);
      let I;
      try {
        I = await q.purgeBatch(s, { queued: M });
      } catch ($e) {
        bu(s, !1), Sa.end(g), Wl(Sa, g, $e, { op: "purge" });
        return;
      }
      Sa.end(g);
      const X = I.ops ?? [];
      X.length === 0 && bu(s, !1);
      const de = ($e) => {
        var ut;
        return (ut = G.value.find((et) => et.id === $e)) == null ? void 0 : ut.storage_id;
      }, Se = /* @__PURE__ */ new Set();
      for (const $e of X) {
        De.register($e);
        const ut = $e.storage_id, et = X.length === 1 ? s : s.filter((Pt) => de(Pt) === ut);
        for (const Pt of et) Se.add(Pt);
        sm.set($e.id, et);
      }
      if (X.length > 1 && bu(s.filter(($e) => !Se.has($e)), !1), I.done === 0) {
        Wl(Sa, g, new Error(I.summary), { op: "purge" }, I.summary);
        return;
      }
      ha.value = !1, oe.clear(), qt({ message: I.summary }, I.failed ? yn : hi), X.length === 0 && Ft.value && await zi();
    }
    async function nz() {
      var Se, $e, ut;
      if (Sa.busy.value) return;
      if (Ft.value) {
        if (!zo.value) {
          ha.value = !1, tt(_("toast.trash_retention"));
          return;
        }
        await tz();
        return;
      }
      const o = Ei.value, s = o ? Po.value : oe.nodes.value, g = Rt(o ? ((Se = Zt.value) == null ? void 0 : Se.getPath()) ?? "" : Xe.value), M = s.map((et) => et.path);
      if (M.length === 0) {
        ha.value = !1;
        return;
      }
      if (B.rootOf(M[0])) {
        const et = Sa.begin();
        if (et === null) return;
        try {
          await B.remove(M) && (ha.value = !1, o || oe.clear());
        } finally {
          Sa.end(et);
        }
        return;
      }
      const I = s.map((et) => et.id).filter((et) => typeof et == "number"), X = q.endpoints.trashRestore && I.length === s.length ? async () => {
        const et = await q.restoreBatch(I);
        if (et.done === 0) throw new Error(et.summary);
        return { summary: et.summary };
      } : null, de = Sa.begin();
      if (de !== null)
        try {
          if (q.endpoints.deleteAsync) {
            const { op: et } = await q.deleteAsync(M, g);
            X && he.set(et.id, { message: _("toast.trashed"), fn: X }), De.register(et), tt(_("toast.delete_queued")), ha.value = !1, Sa.end(de);
          } else
            await q.deleteItems(g, M), ha.value = !1, Sa.end(de), o ? await (($e = Zt.value) == null ? void 0 : $e.reload()) : await wt(), X && $d(_("toast.trashed"), X);
          o ? (ut = Zt.value) == null || ut.reload() : oe.clear();
        } catch (et) {
          Wl(Sa, de, et, { op: "delete" });
        } finally {
          Sa.end(de);
        }
    }
    function Oo() {
      var o;
      if (!li.value) {
        tt(_("toast.read_only_here"));
        return;
      }
      (o = Eb.value) == null || o.click();
    }
    function az(o) {
      const s = o.target, g = s.files ? Array.from(s.files) : [];
      s.value = "", lm(g);
    }
    async function lm(o, s, g = {}) {
      if (o.length === 0) return;
      const M = s ?? Rt(Xe.value);
      if (B.rootOf(M)) {
        if (!B.isOpen(B.rootOf(M))) {
          tt(_("e2e.upload.locked"));
          return;
        }
        await B.upload(M, o);
        return;
      }
      if (Au.value) {
        tt(_("e2e.upload.locked"));
        return;
      }
      if (Yn.value) {
        const I = await Qz(o, M);
        if (o = I.files, o.length === 0) return;
        if (I.sidecars.length > 0)
          try {
            await q.uploadMultipart(M, I.sidecars);
          } catch (X) {
            P("error", { message: X.message, context: { op: "e2e-name-sidecar" } }), tt(_("e2e.names.write_failed"));
            return;
          }
      }
      for (const I of o) {
        const X = fw.get(I);
        if (X) {
          await um(I, M, X) || tt(_("e2e.upload.streaming_unsupported"));
          continue;
        }
        if (xe.shouldChunk(I)) {
          const de = xe.resumableFor(M, I);
          if (de && tt(
            _("upload.resuming", {
              name: vr.get(I) ?? I.name,
              percent: I.size > 0 ? Math.round(de.offset / I.size * 100) : 0
            })
          ), await um(I, M)) continue;
        }
        await Ck(I, M);
      }
      g.reload !== !1 && await wt();
    }
    function Ek() {
      return an.value ? `${Ct.value}|${Yn.value ? "open" : "locked"}` : "";
    }
    async function iz(o, s) {
      const g = Ek(), M = await Eae(o);
      for (const de of M.unreadable) tt(_("upload.failed", { name: de }));
      if (M.dirs.length === 0) {
        await lm(M.files.map((de) => de.file), s);
        return;
      }
      const I = B.rootOf(s);
      if (I) {
        if (!B.isOpen(I)) {
          tt(_("e2e.upload.locked"));
          return;
        }
        const de = M.files.map(({ file: Se, dir: $e }) => $e ? Mae(Se, `${$e}/${Se.name}`) : Se);
        de.length > 0 && await B.upload(s, de);
        for (const Se of Cae(M)) {
          const $e = Se.lastIndexOf("/");
          await B.mkdir($e === -1 ? s : ja(s, Se.slice(0, $e)), Se.slice($e + 1));
        }
        return;
      }
      if (Au.value) {
        tt(_("e2e.upload.locked"));
        return;
      }
      const X = (de) => Ek() === g ? de() : Promise.reject(new Error("the encrypted folder was left during the upload"));
      await zae(M, s, {
        mkdir: (de, Se) => X(() => Ak(de, Se)),
        upload: (de, Se) => X(() => lm(de, Se, { reload: !1 })),
        failed: (de, Se) => {
          tt(_("upload.failed", { name: de })), P("error", { message: Se.message, context: { op: "upload", file: de } });
        }
      }), await wt();
    }
    async function Ck(o, s) {
      const g = ul(), M = s ?? Rt(Xe.value);
      jn.value = [
        ...jn.value,
        { id: g, file: o, displayName: vr.get(o), path: M, totalBytes: o.size, uploadedBytes: 0, percent: 0, status: "uploading", cancel() {
        } }
      ];
      const I = (X) => {
        const de = jn.value.findIndex(($e) => $e.id === g);
        if (de === -1) return;
        const Se = [...jn.value];
        Se[de] = { ...Se[de], ...X }, jn.value = Se;
      };
      try {
        await q.uploadMultipart(M, [o], (X) => {
          I({ percent: X, uploadedBytes: Math.round(X / 100 * o.size) }), P("upload-progress", { uploadId: g, percent: X, done: X >= 100 });
        }), I({ percent: 100, uploadedBytes: o.size, status: "done" }), P("upload-progress", { uploadId: g, percent: 100, done: !0 });
      } catch (X) {
        const de = X.message;
        I({ status: "error", error: de }), tt(_("upload.failed", { name: o.name })), P("error", {
          message: de,
          context: { op: "upload", file: o.name }
        });
      }
    }
    async function um(o, s, g) {
      const M = ul();
      let I = !1;
      const X = (Se) => {
        if (!I) {
          jn.value = [...jn.value, { ...Se, id: M, displayName: vr.get(o) }], I = !0;
          return;
        }
        const $e = jn.value.findIndex((ut) => ut.id === M);
        if ($e !== -1) {
          const ut = [...jn.value];
          ut[$e] = { ...Se, id: M, displayName: vr.get(o) }, jn.value = ut;
        }
      }, de = s ?? Rt(Xe.value);
      try {
        return await xe.uploadFile({
          path: de,
          file: o,
          source: g,
          onProgress: (Se) => {
            !I && Se.status !== "uploading" && Se.uploadedBytes <= 0 || (X(Se), P("upload-progress", {
              uploadId: Se.uploadId ?? M,
              percent: Se.percent,
              done: Se.status === "done"
            }));
          }
        }), !0;
      } catch (Se) {
        if (Ky(Se))
          return I && (jn.value = jn.value.filter((ut) => ut.id !== M)), !1;
        const $e = Se.message;
        return I || (jn.value = [
          ...jn.value,
          {
            id: M,
            file: o,
            displayName: vr.get(o),
            path: de,
            totalBytes: o.size,
            uploadedBytes: 0,
            percent: 0,
            status: "error",
            error: $e,
            cancel() {
            }
          }
        ], I = !0), tt(_("upload.failed", { name: vr.get(o) ?? o.name })), P("error", { message: $e, context: { op: "upload", file: o.name } }), !0;
      }
    }
    const Lo = S(0), Do = S(!1);
    function cm(o) {
      const s = o.dataTransfer;
      if (!s || s.types && s.types.includes(tle) || Tc()) return !1;
      if (s.items && s.items.length > 0) {
        let g = !1;
        for (const M of Array.from(s.items))
          if (M.kind === "file") {
            g = !0;
            break;
          }
        return g;
      }
      return s.types ? s.types.includes("Files") : !1;
    }
    function oz(o) {
      cm(o) && (o.preventDefault(), Lo.value++, Do.value = !0);
    }
    function rz() {
      Lo.value = Math.max(0, Lo.value - 1), Lo.value === 0 && (Do.value = !1);
    }
    function sz(o) {
      if (ti(o)) {
        o.preventDefault();
        return;
      }
      cm(o) && o.preventDefault();
    }
    function lz(o) {
      if (ti(o)) {
        const g = gy(o) || "", M = Rt(Xe.value), I = Nf(o);
        if (I && g && M && g !== M && !Ft.value && li.value) {
          o.preventDefault(), Lo.value = 0, Do.value = !1, zr(), Os(), Rs(I.map((X) => X.path), M, g);
          return;
        }
      }
      if (ti(o)) {
        Lo.value = 0, Do.value = !1, zr(), Os();
        return;
      }
      if (!cm(o)) {
        Lo.value = 0, Do.value = !1;
        return;
      }
      if (o.preventDefault(), Lo.value = 0, Do.value = !1, !li.value) {
        tt(_("toast.read_only_here"));
        return;
      }
      const s = Sae(o.dataTransfer);
      s.length !== 0 && iz(s, Rt(Xe.value));
    }
    function zk(o) {
      var s;
      (s = o.dataTransfer) != null && s.types.includes("Files") && o.preventDefault();
    }
    function Mk(o) {
      const s = Tn.value, g = o.target;
      s && g && !s.contains(g) && o.preventDefault();
    }
    jt(() => {
      var o, s;
      window.addEventListener("dragover", zk), window.addEventListener("drop", Mk), window.addEventListener("pointerup", Ud), window.addEventListener("blur", Ud), (s = (o = fi.value) == null ? void 0 : o.onProgress) == null || s.call(o, (g) => {
        var I;
        if (!g) return;
        const M = _q(g, { quiet: pm, stoppable: !!((I = fi.value) != null && I.stop), t: _ });
        if (M) {
          if (M.kind === "flash") {
            const X = g.error && g.error !== "cancelled" ? yn : hi;
            I0(ma.value, "drag-out", "end") ? ($s = null, qt({ message: M.message, source: "drag-out" }, X)) : $s = { message: M.message, ms: X };
            return;
          }
          I0(ma.value, "drag-out", "hold") && ($s = null, qt(
            M.stoppable ? {
              message: M.message,
              actionLabel: _("dragout.stop"),
              action: () => {
                var X, de;
                return (de = (X = fi.value) == null ? void 0 : X.stop) == null ? void 0 : de.call(X);
              },
              after: { kind: "plain", running: _("dragout.stopping"), done: _("dragout.stopped") },
              source: "drag-out"
            } : { message: M.message, source: "drag-out" },
            wf
          ));
        }
      });
    });
    function Ud() {
      Tc() && zr();
    }
    function Os() {
      var o;
      (o = fi.value) != null && o.cancel && Promise.resolve(fi.value.cancel()).catch(() => {
      });
    }
    Tt(() => {
      window.removeEventListener("dragover", zk), window.removeEventListener("drop", Mk), window.removeEventListener("hashchange", yk), window.removeEventListener("pointerup", Ud), window.removeEventListener("blur", Ud);
    });
    const dm = A(() => {
      const o = new Set(ze.value.mode === "cut" ? ze.value.items.map((s) => s.path) : []);
      if (Ft.value && Ps.value.size)
        for (const s of G.value) {
          const g = s.id;
          typeof g == "number" && Ps.value.has(g) && o.add(s.path);
        }
      return o;
    });
    function Pk(o, s, g) {
      (o === "split" ? qn : oe).click(s.path, g);
    }
    function Ok(o, s, g) {
      var Se;
      if (!g.dataTransfer) return;
      if (s.basename === ".trash") {
        g.preventDefault();
        return;
      }
      const M = o === "split" ? qn.nodes.value : oe.nodes.value, I = Rt(o === "split" ? ((Se = Zt.value) == null ? void 0 : Se.getPath()) ?? "" : Xe.value), de = (M.some(($e) => $e.path === s.path) ? M : [s]).filter(($e) => !dm.value.has($e.path)).filter(($e) => $e.basename !== ".trash");
      de.length !== 0 && Lk(g, de, I, s.mime_type, bm(o));
    }
    function Lk(o, s, g, M, I) {
      const X = l0(s, { inEncryptedFolder: I });
      if (X) {
        if (fi.value) {
          o.preventDefault(), g !== null && yq(X, g), Promise.resolve(fi.value.start(X)).catch((de) => {
            zr(), Os(), P("error", { message: de.message, context: { op: "drag-out" } });
          }), Uk(X);
          return;
        }
        if (X.length === 1 && X[0] && o.dataTransfer) {
          const de = X[0], Se = lv(L.config.auth) ? q.downloadUrl(de.path) : Rk.take(de.path), $e = Se ? bq(de, Se, M) : null;
          $e && o.dataTransfer.setData("DownloadURL", $e);
        }
      }
    }
    const Dk = S(!0), Rk = wq((o) => bae(q, o), {
      onUnsupported: () => {
        Dk.value = !1;
      }
    }), Nk = A(() => !fi.value && !lv(L.config.auth));
    function Ik(o) {
      !o || !Nk.value || Kt.value || Rk.warm(o);
    }
    function Hd(o) {
      if (o.pointerType === "touch" || !Nk.value) return;
      const s = o.target, g = s && typeof s.closest == "function" ? s.closest("[data-fe-path]") : null, M = g == null ? void 0 : g.getAttribute("data-fe-path");
      if (!M) return;
      const I = G.value.find((X) => X.path === M) ?? xu.value.find((X) => X.path === M);
      I && u0(I) && Ik(I.path);
    }
    jt(() => {
      var o, s;
      (o = Tn.value) == null || o.addEventListener("pointerover", Hd, { passive: !0 }), (s = Tn.value) == null || s.addEventListener("pointerdown", Hd, { capture: !0, passive: !0 });
    }), Tt(() => {
      var o, s;
      (o = Tn.value) == null || o.removeEventListener("pointerover", Hd), (s = Tn.value) == null || s.removeEventListener("pointerdown", Hd, { capture: !0 });
    });
    const fi = A(() => L.config.dragOut ?? null), Bk = S(""), fm = S(!1);
    let pm = !1, Fk;
    Je(
      () => oe.selected.value,
      () => {
        if (!fi.value) return;
        clearTimeout(Fk);
        const o = oe.nodes.value;
        if (o.length === 0 || o.length > ale || o.some((M) => M.type !== "file")) return;
        const s = l0(o, { inEncryptedFolder: an.value });
        !s || o.reduce((M, I) => M + (I.size ?? 0), 0) > nle || (Fk = setTimeout(() => void Uk(s, !0), 400));
      },
      { deep: !0 }
    );
    async function Uk(o, s = !1) {
      const g = fi.value;
      if (!g || fm.value) return;
      const M = kq(o);
      if (M !== Bk.value) {
        fm.value = !0, pm = s;
        try {
          const I = await g.prepare(o);
          I != null && I.ready ? (Bk.value = M, s || tt(_("dragout.ready"))) : I != null && I.error && !s && tt(I.error);
        } catch (I) {
          P("error", { message: I.message, context: { op: "drag-out-prepare" } });
        } finally {
          fm.value = !1, pm = !1;
        }
      }
    }
    async function uz(o, s, g, M) {
      try {
        const I = M ?? Rt(Xe.value), X = await zm("move", o, s, I);
        if (X)
          return X.undo && X.ops.length && he.set(X.ops[X.ops.length - 1].id, { message: _("toast.moved"), fn: X.undo }), X.ops.length && tt(_("split.move_queued")), oe.clear(), "queued";
        const de = await fk(o, s);
        if (q.endpoints.moveAsync) {
          const { op: Se } = await q.moveAsync(o, s, I);
          pk(Se.id, o, s, I, de), De.register(Se), tt(_(de ? "toast.move_kept_both" : "split.move_queued"));
        } else if (await q.move(I, o, s), await wt(), de)
          tt(_("toast.move_kept_both"));
        else {
          const Se = o.map(($e) => ja(s, Mi($e)));
          $d(_("toast.moved"), async () => {
            await q.move(s, Se, I);
          });
        }
        return oe.clear(), q.endpoints.moveAsync ? "queued" : "done";
      } catch (I) {
        return ql(I, { op: g, targetDir: s }), "refused";
      }
    }
    async function Hk(o, s) {
      if (o.type !== "dir") return;
      const g = Nf(s);
      if (!g || g.length === 0) return;
      zr(), Os();
      const M = o.path, I = g.map((X) => X.path).filter((X) => X && X !== M && !M.startsWith(X + "/") && !jh(oo(X), M));
      I.length !== 0 && await Rs(I, M, cw(s));
    }
    async function Kk(o, s) {
      const g = Nf(s);
      if (!g || g.length === 0) return;
      zr(), Os();
      const M = o, I = g.map((X) => X.path).filter((X) => X && X !== M && !M.startsWith(X + "/") && !jh(oo(X), M));
      I.length !== 0 && await Rs(I, M, cw(s));
    }
    function cz(o) {
      o.cancel();
    }
    function dz(o) {
      jn.value = jn.value.filter((s) => s.id !== o.id);
    }
    function fz(o) {
      if (Sn.value && !o) {
        wt("");
        return;
      }
      if (Sn.value) {
        wt(Co(o));
        return;
      }
      wt(Va(o));
    }
    async function Kd(o) {
      try {
        await navigator.clipboard.writeText(o), tt(_("breadcrumb.copy_path"));
      } catch {
      }
    }
    function Qn(o = {}) {
      return q.authHeaders({ ...o });
    }
    function Vk(o) {
      if (/^[a-z][a-z0-9+.-]*:\/\//i.test(o)) return o;
      const s = L.config.apiBase;
      if (!s) return o;
      try {
        return new URL(o, s.endsWith("/") ? s : `${s}/`).toString();
      } catch {
        return o;
      }
    }
    const jk = A(
      () => L.config.viewerBaseUrl ? Vk(L.config.viewerBaseUrl) : Cy(L.config.apiBase, ile)
    ), Vd = S(!1), { themeId: jd, setTheme: pz } = WJ(), { themeMode: ku, setThemeMode: qk } = GJ(), wn = A(
      () => ku.value === "host" ? L.config.theme || "auto" : ku.value
    );
    v5({ locale: j, theme: wn });
    const hz = Nl(), hm = A(
      () => wn.value === "dark" || wn.value !== "light" && hz.value
    );
    Je(
      [jd, hm, Tn],
      () => {
        tZ(jd.value), Tn.value && XJ(Tn.value, jd.value, hm.value);
      },
      { immediate: !0 }
    );
    const wu = S(!1), ro = S(!1), Li = S(null);
    function mz() {
      if (ro.value) {
        ro.value = !1;
        return;
      }
      const o = oe.nodes.value, s = o.length === 1 ? o[0] : null;
      if (!(!s || s.type !== "file" || s.basename === ".trash")) {
        if (Ui(s) && !an.value && !s.e2e_root) {
          Mt.open(s);
          return;
        }
        if (an.value) {
          if (!Yn.value) return;
          (async () => {
            try {
              await ef(s);
            } catch {
              tt(_("e2e.decrypt_failed"));
              return;
            }
            Li.value = s, ro.value = !0, Ua(s);
          })();
          return;
        }
        Li.value = s, ro.value = !0, Ua(s);
      }
    }
    function vz(o) {
      const s = G.value.filter((X) => X.type === "file");
      if (s.length === 0) return;
      const g = Li.value;
      let M = g ? s.findIndex((X) => X.path === g.path) : -1;
      M = M === -1 ? o > 0 ? 0 : s.length - 1 : (M + o + s.length) % s.length;
      const I = s[M];
      !I || I.path === (g == null ? void 0 : g.path) || oe.click(I.path);
    }
    function yz() {
      const o = Li.value;
      ro.value = !1, o && qa(o);
    }
    Je(
      () => oe.nodes.value,
      (o) => {
        var g, M;
        if (!ro.value) return;
        const s = o.length === 1 && o[0].type === "file" ? o[0] : null;
        if (s && s.path !== ((g = Li.value) == null ? void 0 : g.path) && Yn.value) {
          (async () => {
            try {
              await ef(s);
            } catch {
            }
            Li.value = s, Ua(s);
          })();
          return;
        }
        s && s.path !== ((M = Li.value) == null ? void 0 : M.path) && (Li.value = s, Ua(s));
      }
    );
    const _u = sQ();
    function gz(o) {
      jn.value = jn.value.filter((M) => M.id !== o.id);
      const s = o.file, g = o.path || Rt(Xe.value);
      (async () => {
        if (xe.shouldChunk(s) && await um(s, g)) {
          await wt();
          return;
        }
        await Ck(s, g), await wt();
      })();
    }
    const qd = S(!1);
    let Wd;
    function mm() {
      qd.value = !0;
    }
    function bz() {
      var o;
      qd.value = !1, MT(), (o = Tn.value) == null || o.focus();
    }
    function Wk() {
      mm();
    }
    jt(() => {
      var o;
      (o = Tn.value) == null || o.addEventListener("fe:tour-restart", Wk), Wd = dQ(() => {
        qd.value || mm();
      });
    }), Tt(() => {
      var o;
      Wd == null || Wd(), (o = Tn.value) == null || o.removeEventListener("fe:tour-restart", Wk);
    });
    function kz() {
      return Pd() === "none" ? null : ft ? `${Z0}:${ft}` : Z0;
    }
    const Hn = nne({ storageKey: kz() }), wz = Hn.restore(), vm = Hn.activeId, so = A(() => {
      var o;
      return ((o = Hn.activeTab.value) == null ? void 0 : o.split) ?? null;
    });
    function _z(o) {
      const s = (o || "").replace(/^\/+|\/+$/g, ""), g = lp(s.split("/").pop() || s, _);
      if (g) return g;
      if (!s) return Sn.value ? _("breadcrumb.root") : ne.value || _("breadcrumb.root");
      const M = Vt.segmentLabel(Rt(s));
      return M !== null ? M : s.split("/").pop() || s;
    }
    const Yk = A(
      () => Hn.tabs.value.map((o) => ({ id: o.id, label: _z(o.path), split: !!o.split }))
    ), Gk = A(
      () => (
        /* gezinti:g1 — the simple profile has no tab strip at all, not even once a
           second tab exists: tabs were the first thing #14 named as power-user
           chrome. The tab STATE is untouched, so switching the profile back brings
           the strip and its tabs straight back. */
        !nu.value && (Hn.hasMultiple.value || L.config.tabStrip !== "auto" && Yk.value.length > 0)
      )
    );
    Je(Xe, (o) => Hn.syncActive({ path: o })), Je(Pe, (o) => Hn.syncActive({ viewMode: o })), jt(() => {
      wz || Hn.seed(Xe.value ?? "", Pe.value);
    });
    function Yd(o) {
      !fn.value && o.viewMode && o.viewMode !== Pe.value && (Pe.value = o.viewMode);
      const s = () => Mn(mn.value);
      if (o.path === ".trash") {
        zi().then(s, s);
        return;
      }
      wt(o.path).then(s, s);
    }
    function xz(o) {
      const s = Hn.activate(o);
      s && Yd(s);
    }
    function ym() {
      Hn.openTab(Xe.value ?? "", { viewMode: Pe.value, background: !1 });
    }
    function Xk(o) {
      const s = Hn.closeTab(o);
      s && Yd(s);
    }
    function Sz() {
      const o = Hn.step(1);
      o && Yd(o);
    }
    function $z() {
      const o = Hn.step(-1);
      o && Yd(o);
    }
    function Jk(o) {
      if (o.type !== "dir" || o.basename === ".trash") return;
      const s = Sn.value ? Co(o.path) : Va(o.path);
      Hn.openTab(s, { viewMode: Pe.value, background: !0 });
    }
    function Zk(o) {
      if (o.button !== 1) return;
      const s = o.target, g = s && typeof s.closest == "function" ? s.closest("[data-fe-path]") : null, M = g == null ? void 0 : g.getAttribute("data-fe-path");
      if (!M) return;
      const I = G.value.find((X) => X.path === M);
      !I || I.type !== "dir" || I.basename === ".trash" || (o.preventDefault(), Jk(I));
    }
    function Qk(o) {
      if (o.button !== 1) return;
      const s = o.target;
      s && typeof s.closest == "function" && s.closest("[data-fe-path]") && o.preventDefault();
    }
    jt(() => {
      var o, s;
      (o = Tn.value) == null || o.addEventListener("auxclick", Zk), (s = Tn.value) == null || s.addEventListener("mousedown", Qk);
    }), Tt(() => {
      var o, s;
      (o = Tn.value) == null || o.removeEventListener("auxclick", Zk), (s = Tn.value) == null || s.removeEventListener("mousedown", Qk);
    });
    const Tz = S(null), Zt = S(null), xu = S([]), qn = g_(
      () => {
        var o;
        return xu.value.length ? xu.value : ((o = Zt.value) == null ? void 0 : o.visibleNodes()) ?? [];
      }
    ), Su = S({ ...jo }), Az = A(() => {
      var I;
      if (!fn.value) return "";
      const o = String(((I = Zt.value) == null ? void 0 : I.getPath()) ?? "").replace(/^\/+|\/+$/g, "");
      if (!o) return "";
      const [s, ...g] = o.split("/"), M = (L.config.storages ?? []).find((X) => X.name === s);
      return q_((M == null ? void 0 : M.uid) || s, g.join("/"));
    }), Ez = A(
      () => Gk.value || zb.value || $u.value
    ), Gd = A(() => bt.value === "home" ? "home" : bt.value === "drafts" ? "drafts" : ot.value && G.value.length === 0 ? "" : Ce.value ? "notfound" : Ie.value && G.value.length === 0 ? "" : Au.value ? "locked" : ""), $u = A(() => !$a.value && !nu.value), Ls = A(
      () => !!so.value && $u.value
      /* gezinti:g1 */
    );
    function ew() {
      if (so.value) {
        Hn.setSplit(null), pi.value = "main";
        return;
      }
      $u.value && Hn.setSplit({ path: Xe.value ?? "", viewMode: Pe.value });
    }
    function Cz() {
      Hn.setSplit(null), pi.value = "main";
    }
    function zz(o) {
      Hn.setSplit({ ...so.value ?? {}, path: o }), al(Su.value) && (Su.value = { ...jo }), qn.clear(), xu.value = [];
    }
    function Mz(o, s) {
      var g;
      if (s.type === "dir" && s.basename !== ".trash") {
        (g = Zt.value) == null || g.loadFolder(
          /* A multi-storage drive row's path is already the wire form for that
             storage's root; a real row needs converting. The predicate comes from
             `lib/fileIcons`, which is that concept's one home. */
          xi(s) === "storage" ? s.path : Di(s.path)
        );
        return;
      }
      qa(s);
    }
    function Pz() {
      pi.value = "main", zi();
    }
    const tw = A(() => {
      var o;
      return ((o = so.value) == null ? void 0 : o.viewMode) ?? Pe.value;
    });
    function nw(o) {
      so.value && Hn.setSplit({ ...so.value, viewMode: o });
    }
    const gm = A(
      () => An.value ? tw.value : Pe.value
    );
    function aw(o) {
      An.value ? nw(o) : Pe.value = o;
    }
    const pi = S("main");
    function Oz() {
      pi.value = "main";
    }
    Je(Ls, (o) => {
      o || (pi.value = "main");
    });
    const An = A(() => pi.value === "split" && Ls.value), Lz = A(() => Ls.value && pi.value === "main"), Xd = A(() => An.value ? "split" : "main"), Ds = S(null);
    function bm(o) {
      var s;
      return o === "split" ? !!((s = Zt.value) != null && s.e2eRoot()) : an.value;
    }
    const iw = A(
      () => {
        var o;
        return An.value ? ((o = Zt.value) == null ? void 0 : o.getPath()) ?? "" : Xe.value ?? "";
      }
    );
    function Dz(o) {
      var s;
      return o === "split" ? ((s = Zt.value) == null ? void 0 : s.getPath()) ?? "" : Xe.value ?? "";
    }
    function Rz(o) {
      var s;
      return o === "split" ? ((s = Zt.value) == null ? void 0 : s.rowPaths()) ?? [] : G.value.map((g) => g.path);
    }
    Je(
      () => ia(),
      (o) => {
        o.length && (Ds.value = {
          nodes: o,
          pane: Xd.value,
          path: iw.value,
          // Where the item was when it was selected: a held item keeps the
          // folder it came from, whatever folder the pane shows now.
          inEncrypted: bm(Xd.value)
        });
      },
      { deep: !1 }
    );
    const Jd = A(() => {
      const o = Ds.value;
      if (!o || !o.nodes.length || o.pane === "split" && !Ls.value) return !1;
      if (Dz(o.pane) !== o.path) return !0;
      const s = new Set(Rz(o.pane));
      return o.nodes.some((g) => s.has(g.path));
    });
    Je(Jd, (o) => {
      o || (Ds.value = null);
    });
    const Nz = A(() => ia().length === 0 && Jd.value), ow = A(() => {
      var s;
      const o = ia();
      return o.length ? o : Jd.value ? ((s = Ds.value) == null ? void 0 : s.nodes) ?? [] : [];
    }), Iz = A(() => {
      const o = ow.value;
      return o.length === 1 && ve.value ? Bd([o[0].path]) : void 0;
    }), Bz = A(
      () => {
        var o;
        return ia().length ? bm(Xd.value) : Jd.value && ((o = Ds.value) == null ? void 0 : o.inEncrypted) === !0;
      }
    ), Fz = A(
      () => {
        var o;
        return Nz.value ? Oh(((o = Ds.value) == null ? void 0 : o.path) ?? "") : "";
      }
    ), Uz = A(() => Oh(iw.value)), Hz = A(
      () => {
        var o;
        return An.value ? ((o = Zt.value) == null ? void 0 : o.rowCount()) ?? 0 : G.value.length;
      }
    ), Kz = A(
      () => {
        var o;
        return An.value ? ((o = Zt.value) == null ? void 0 : o.dirPerm()) ?? "" : ye.value;
      }
    );
    function Di(o) {
      return Sn.value ? Co(o) : Va(o);
    }
    function rw(o) {
      const s = String(o ?? "").replace(/^\/+|\/+$/g, "");
      return gt && (!s || !(s === gt || s.startsWith(gt + "/"))) ? gt : s;
    }
    function sw() {
      var s;
      const o = qn.nodes.value;
      o.length !== 0 && (ze.value = { mode: "cut", items: o, sourcePath: ((s = Zt.value) == null ? void 0 : s.getPath()) ?? "" }, tt(_("toast.cut")));
    }
    function lw() {
      var s;
      const o = qn.nodes.value;
      o.length !== 0 && (ze.value = { mode: "copy", items: o, sourcePath: ((s = Zt.value) == null ? void 0 : s.getPath()) ?? "" }, tt(_("toast.copied")));
    }
    async function uw() {
      const o = ze.value, s = Zt.value;
      if (!o.mode || o.items.length === 0 || !s) return;
      const g = Rt(s.getPath() ?? ""), M = Rt(o.sourcePath || "") || void 0;
      if (o.mode === "cut" && M === g) {
        tt(_("toast.same_folder_cut"));
        return;
      }
      await Rs(o.items.map((I) => I.path), g, M, o.mode === "copy" ? "copy" : "move"), ze.value = { mode: null, items: [], sourcePath: null };
    }
    function cw(o) {
      return gy(o);
    }
    async function Rs(o, s, g, M = "auto") {
      var $e, ut, et;
      const I = o.filter(
        (Pt) => Pt && Pt !== s && !s.startsWith(Pt + "/") && !jh(oo(Pt), s)
      );
      if (I.length === 0 || !s) return "nothing";
      const X = bw(I, s);
      if (X === "cross")
        return tt(_("e2e.vault.cross")), "refused";
      if (X === "inside") {
        const Pt = M === "copy" ? await B.copy(I, s) : await B.move(I, s);
        return ($e = Zt.value) == null || $e.reload(), Pt ? "done" : "refused";
      }
      const de = D0(I, s, M);
      let Se;
      if (de.kind === "copy")
        try {
          if (await zm("copy", I, s))
            return tt(_("split.copy_queued")), (ut = Zt.value) == null || ut.reload(), "queued";
          const { op: En } = await q.copy(I, s);
          De.register(En), tt(de.cross ? _("split.cross_copy") : _("split.copy_queued")), Se = "queued";
        } catch (Pt) {
          return ql(Pt, { op: "transfer", targetWire: s }), "refused";
        }
      else
        de.cross && tt(_("split.cross_move")), Se = await uz(I, s, "move-transfer", g);
      return (et = Zt.value) == null || et.reload(), Se;
    }
    function dw(o) {
      Rs(o.sources, o.targetWire, o.originWire);
    }
    const sn = O4(), Wn = S(0), fw = /* @__PURE__ */ new WeakMap(), Mt = Jne({
      api: q,
      chunked: xe,
      locale: () => j.value,
      t: (o, s) => _(o, s),
      toast: (o, s) => qt({ message: o }, s ? yn : hi),
      emitError: (o, s) => P("error", { message: o, context: { op: s } }),
      escrowPublicKey: () => _r.value,
      escrowKid: () => Wa.value,
      registerOp: (o) => De.register(o),
      reload: () => wt(),
      openPreview: (o, s) => {
        lo.set(o.path, s), Ha.value = "view", pn.value = o, la.value = !0, P("file-opened", { path: o.path, basename: o.basename }), o.fxe_name && (G.value = G.value.map((g) => g.path === o.path ? { ...g, fxe_name: o.fxe_name } : g));
      },
      showRecoveryKey: (o, s) => {
        No.value = o, Io.value = s, kr.value = "file", Ro.value = !0;
      },
      /* wiring:e2 policy — "Request encryption…" on a plain file. */
      requestEncrypt: (o) => wm(o.path, "file", o.basename)
    }), Tu = A(() => {
      var o;
      return !!((o = pn.value) != null && o.fxe_name);
    }), Vt = z5({
      api: q,
      ring: sn,
      lockedLabel: () => _("e2e.names.locked_item"),
      unreadableLabel: () => _("e2e.names.unreadable_item"),
      fileName: (o) => Mt.realName(o)
    });
    Wo(jc, Vt);
    const Vz = lne((o, s) => {
      Vt.version.value;
      const g = Vt.rootOf(o, s);
      if (!g || !sn.names(g)) return null;
      const M = Vt.segmentLabel(o);
      return !M || M === "…" ? null : { name: M, path: Vt.displayPath(o) };
    });
    Tt(Vz);
    const vr = /* @__PURE__ */ new WeakMap(), pw = S([]), Ct = S(""), lo = /* @__PURE__ */ new Map(), an = A(() => !!Ct.value && !Ft.value), Yn = A(() => (Wn.value, an.value && sn.has(Ct.value))), Au = A(() => (Wn.value, an.value && !sn.has(Ct.value))), Zd = S(!1), km = S(""), yr = S(!1), gr = S(!1), hw = A(
      () => sa.value && !an.value && li.value ? Bh(Rt(Xe.value), "new_folder") : "denied"
    ), br = S(null);
    function wm(o, s, g) {
      br.value = { path: o, kind: s, name: g };
    }
    function jz() {
      sa.value = !1, wm(Rt(Xe.value), "new_folder", Oh(Xe.value));
    }
    function qz(o) {
      br.value = null, tt(o.created ? _("e2e.request.sent") : _("e2e.request.already"));
    }
    const on = S(null), Qd = S(!1), _m = S(!1), uo = S(null), Ro = S(!1), No = S(""), kr = S("created"), Io = S(""), Ns = S(!1), wr = S(""), Eu = S(!1), Bo = S(!1), Cu = S("unlock"), Ri = S(""), Ni = S(!1), Ii = S(""), _r = A(
      () => {
        var o, s;
        return ((s = (o = Ke.value) == null ? void 0 : o.e2e_escrow) == null ? void 0 : s.public_key) || null;
      }
    ), Wa = A(
      () => {
        var o, s;
        return ((s = (o = Ke.value) == null ? void 0 : o.e2e_escrow) == null ? void 0 : s.kid) || null;
      }
    );
    function xm() {
      return sn.get(Ct.value) ?? null;
    }
    function Sm() {
      for (const o of lo.values()) URL.revokeObjectURL(o);
      lo.clear();
    }
    Tt(Sm);
    async function mw(o, s) {
      var Se;
      let g = "";
      try {
        const { blob: $e, url: ut } = await q.fetchBlob(ja(o, ga), { fresh: !0 });
        URL.revokeObjectURL(ut), g = await $e.text();
      } catch {
        return _("e2e.unlock.marker_missing");
      }
      const M = rp(g);
      if (!M) return _("e2e.unlock.marker_missing");
      const I = o === Ct.value;
      if (M.unsupported.length > 0)
        return I && (pw.value = M.unsupported), _("e2e.unlock.unsupported", { features: M.unsupported.join(", ") });
      const X = M.marker;
      I && (on.value = X);
      const de = await eS(X, s);
      return "error" in de ? de.error === "damaged" ? _("e2e.unlock.damaged") : _("e2e.unlock.wrong") : await vw(o, X, de.fmk) ? (I && (X.v === 1 ? (wr.value = s, Ns.value = !0) : U_(X, Wa.value) === "offer" && (Ri.value = s, Cu.value = "unlock", Ii.value = "", Bo.value = !0)), I && await wt(), (Se = Zt.value) == null || Se.reload(), null) : qr(X) ? _("e2e.vault.open_failed") : _("e2e.names.key_failed");
    }
    async function Wz(o) {
      if (!(!o || Zd.value || !Ct.value)) {
        Zd.value = !0, km.value = "";
        try {
          const s = await mw(Ct.value, o);
          s && (km.value = s);
        } finally {
          Zd.value = !1;
        }
      }
    }
    Wo(PT, {
      locked: (o) => (Wn.value, !sn.has(o)),
      unlock: mw,
      recovery: (o) => {
        pi.value = "main", wt(Di(o)).then(() => {
          Ct.value === o && _w();
        });
      }
    });
    async function vw(o, s, g) {
      if (qr(s)) {
        sn.set(o, g, null, null), Vt.setMarker(o, s), Wn.value++, a().catch(() => {
        });
        try {
          await B.open(o, s, g, { perm: o === Ct.value && ye.value || void 0 });
        } catch (X) {
          return sn.lock(o), Wn.value++, P("error", { message: (X == null ? void 0 : X.message) ?? String(X), context: { op: "e2e-vault-open" } }), !1;
        }
        return !0;
      }
      let M = null;
      if (qi(s) && (M = await _4(s, g), !M))
        return !1;
      let I = null;
      return fl(s) && (I = await E4(s, g), !I) ? !1 : (sn.set(o, g, M, I), Vt.setMarker(o, s), Wn.value++, !0);
    }
    function $m() {
      if (!Ct.value) return;
      const o = Ct.value;
      B.isOpen(o) && B.close(o, "manual"), sn.lock(o), Vt.forget(o), Wn.value++, Sm();
      const s = ww(o);
      Bi.value = !1, Hs = null, Us.value = !1, s ? qt({ message: s }, yn) : tt(_("e2e.locked_toast")), wt();
    }
    function yw(o) {
      return il(o.extension);
    }
    async function ef(o) {
      const s = lo.get(o.path);
      if (s) return s;
      if (B.isVaultRow(o)) {
        const de = await B.readUrl(o.path, yw(o));
        return lo.set(o.path, de), de;
      }
      const g = xm();
      if (!g) return null;
      const M = await q.fetchArrayBuffer(o.path);
      if (!Tl(M)) return null;
      const I = await P4(g, sn.previous(Ct.value), M), X = URL.createObjectURL(new Blob([I], { type: yw(o) }));
      return lo.set(o.path, X), X;
    }
    function tf(o) {
      return lo.get(o) ?? q.previewUrl(o);
    }
    async function Is(o) {
      try {
        await ef(o);
      } catch {
        tt(_("e2e.decrypt_failed"));
        return;
      }
      Ha.value = "view", $i.value = bo, pn.value = o, la.value = !0, P("file-opened", { path: o.path, basename: o.basename }), Ua(o);
    }
    const Yz = zU(
      (o) => {
        const s = Vt.rootOf(o, an.value ? Ct.value : null), g = s ? sn.get(s) : void 0;
        return s && g ? { fmk: g, previous: sn.previous(s) ?? null } : null;
      },
      /* a vault's file: the vault engine reads and writes it (useE2eVault). */
      PU(B)
    ), zu = S(!1);
    function Gz(o) {
      zu.value = o;
      const s = pn.value;
      o && s && B.isVaultRow(s) && B.touch(s.path), o || gw();
    }
    Je(la, (o) => {
      o || (zu.value = !1, gw());
    });
    let Mu = null;
    function Xz(o, s) {
      const g = pn.value;
      if (!la.value || !g || !nl(g.path, o) || !zu.value || !s.app_lock_soon || !s.app_lock_soon_keep) return;
      const M = s.app_lock_kept || s.app_lock_soon_keep;
      Mu = {
        message: s.app_lock_soon,
        actionLabel: s.app_lock_soon_keep,
        action: () => B.touch(o),
        after: { kind: "plain", running: M, done: M }
      }, qt(Mu, rle);
    }
    function gw() {
      var o;
      Mu && ((o = ma.value) == null ? void 0 : o.message) === Mu.message && Hh(), Mu = null;
    }
    const Jz = A(() => fb.value && uh(pn.value) ? Yz : null);
    async function Zz(o) {
      if (B.isVaultRow(o)) {
        await B.download([o]);
        return;
      }
      const s = xm();
      if (!s) {
        tt(_("e2e.download.failed"));
        return;
      }
      await Mt.downloadFolderFile(o, s, sn.previous(Ct.value), Ct.value);
    }
    async function Qz(o, s) {
      const g = xm();
      if (!g) return { files: [], sidecars: [] };
      const M = [], I = [];
      await Cm(s);
      const X = !!Vt.writesEncrypted(s);
      for (const de of o)
        if (de.name !== ga) {
          if (X && Gi(de.name)) {
            tt(_("e2e.names.bad_name", { name: de.name }));
            continue;
          }
          try {
            const Se = de.size > ec ? await Mt.folderUploadSource(de, g) : null, $e = Se ? null : await Zv(g, await de.arrayBuffer());
            let ut = de.name;
            if (X) {
              const Pt = await Vt.nameForWrite(s, de.name);
              if (!Pt) throw new Error("e2e: the folder name key is missing");
              ut = Pt.stored, Pt.sidecar && I.push(new File([Pt.sidecar.content], Pt.sidecar.name, { type: "text/plain" }));
            }
            const et = new File($e ? [$e] : [], ut, { type: "application/octet-stream" });
            Se && fw.set(et, Se), X && vr.set(et, de.name), M.push(et);
          } catch (Se) {
            P("error", { message: Se.message, context: { op: "e2e-encrypt" } });
          }
        }
      return { files: M, sidecars: I };
    }
    async function eM(o) {
      if (an.value) {
        tt(_("e2e.create.nested"));
        return;
      }
      if (o.level === "vault") {
        await tM(o);
        return;
      }
      gr.value = !0;
      let s = !1;
      try {
        const g = Rt(Xe.value);
        await q.newFolder(g, o.name), s = !0;
        const { marker: M, fmk: I, recoveryKey: X, names: de } = await Jv(o.password, {
          escrowPublicKey: _r.value,
          encryptNames: o.level === "names"
        }), Se = new File([JSON.stringify(M)], ga, {
          type: "application/json"
        }), $e = ja(g, o.name);
        await q.uploadMultipart($e, [Se]), sn.set($e, I, de ?? null), Vt.setMarker($e, M), Wn.value++, yr.value = !1, No.value = X, Io.value = o.name, kr.value = "created", Ro.value = !0, await wt();
      } catch (g) {
        P("error", { message: g.message, context: { op: "e2e-create" } }), qt({ message: Zn(g, _("e2e.create.failed")) }, yn), s && await wt();
      } finally {
        gr.value = !1;
      }
    }
    async function tM(o) {
      var s;
      if (((s = Ke.value) == null ? void 0 : s.e2e_vault) !== !0) {
        qt({ message: _("e2e.create.failed") }, yn);
        return;
      }
      gr.value = !0;
      try {
        const g = Rt(Xe.value), M = ja(g, o.name), I = await v4(o.password, {
          escrowPublicKey: _r.value,
          packLog2: o.packLog2
        });
        await B.create(M, I.marker, I.index), sn.set(M, I.fmk, null, null), Vt.setMarker(M, I.marker), Wn.value++, a().catch(() => {
        }), await B.open(M, I.marker, I.fmk, { justMade: !0, perm: ye.value || void 0 }), yr.value = !1, No.value = I.recoveryKey, Io.value = o.name, kr.value = "created", Ro.value = !0, await wt();
      } catch (g) {
        P("error", { message: g.message, context: { op: "e2e-vault-create" } }), qt({ message: Zn(g, _("e2e.create.failed")) }, yn);
      } finally {
        gr.value = !1;
      }
    }
    function bw(o, s) {
      const g = B.rootOf(s), M = o.map((I) => B.rootOf(I));
      return !g && M.every((I) => !I) ? "none" : g && B.isOpen(g) && M.every((I) => I === g) ? "inside" : "cross";
    }
    const Tm = A(() => {
      B.version.value;
      const o = Ct.value;
      return o ? B.strips[o] ?? null : null;
    }), Pu = A(() => !!pn.value && B.isVaultRow(pn.value)), nM = A(() => [...oe.nodes.value, ...Po.value].some((o) => B.isVaultRow(o)));
    function Am(o, s) {
      return !!o && (o === s || o.startsWith(s + "/"));
    }
    function kw(o, s) {
      var g;
      for (const [M, I] of [...lo])
        Am(M, o) && ((s || M !== ((g = pn.value) == null ? void 0 : g.path)) && URL.revokeObjectURL(I), lo.delete(M));
    }
    let Em = "";
    function ww(o) {
      const s = pn.value;
      if (!la.value || !s || !nl(s.path, o)) return "";
      const g = zu.value;
      return la.value = !1, zu.value = !1, g ? _("e2e.app_closed_unsaved", { name: s.basename }) : "";
    }
    function aM(o) {
      var s;
      sn.lock(o), Vt.forget(o), Wn.value++, Em = ww(o), Am((s = Li.value) == null ? void 0 : s.path, o) && (ro.value = !1), kw(o, !0);
    }
    function iM(o, s) {
      var M;
      const g = Em;
      if (Em = "", s === "idle") {
        const I = _("e2e.vault.locked_idle_toast", { name: Mi(o) });
        qt({ message: g ? `${I} ${g}` : I }, g ? 12e3 : 8e3);
      } else g && qt({ message: g }, yn);
      (Ct.value === o || Am(Rt(Xe.value), o)) && (Bi.value = !1, wt(Di(o))), (M = Zt.value) == null || M.reload();
    }
    function oM(o) {
      var s;
      kw(o, !1), Ct.value === o && wt(), (s = Zt.value) == null || s.reload();
    }
    async function rM(o) {
      if (!(!on.value || !Ct.value)) {
        _m.value = !0, uo.value = null;
        try {
          let s = null;
          if (o.mode === "recovery") {
            if (s = await tS(on.value, o.value), !s) {
              uo.value = _("e2e.recover.wrong_recovery");
              return;
            }
          } else {
            let g;
            try {
              g = await Wx(o.value);
            } catch {
              uo.value = _("e2e.recover.bad_escrow_key");
              return;
            }
            if (s = await nS(on.value, g), !s) {
              uo.value = _("e2e.recover.wrong_escrow");
              return;
            }
            try {
              const M = await q.e2eEscrowChallenge(Ct.value), I = new Uint8Array(
                await crypto.subtle.decrypt(
                  { name: "RSA-OAEP" },
                  g,
                  ea(M.challenge).buffer
                )
              );
              await q.e2eEscrowUsed({
                path: Ct.value,
                id: M.id,
                nonce: Ma(I)
              });
            } catch (M) {
              uo.value = _("e2e.recover.notify_failed"), P("error", {
                message: M.message,
                context: { op: "e2e-escrow-notify" }
              });
              return;
            }
          }
          if (!await vw(Ct.value, on.value, s)) {
            uo.value = _("e2e.names.key_failed");
            return;
          }
          Qd.value = !1, tt(
            o.mode === "escrow" ? _("e2e.recover.escrow_done") : _("e2e.recover.recovery_done")
          ), await wt(), o.mode === "recovery" && (Hs = o.value, Pw("reset"));
        } catch (s) {
          uo.value = s.message;
        } finally {
          _m.value = !1;
        }
      }
    }
    async function _w() {
      if (!on.value && Ct.value)
        try {
          const { blob: o, url: s } = await q.fetchBlob(ja(Ct.value, ga), { fresh: !0 });
          URL.revokeObjectURL(s);
          const g = rp(await o.text());
          on.value = g && g.unsupported.length === 0 ? g.marker : null;
        } catch {
          on.value = null;
        }
      uo.value = null, Qd.value = !0;
    }
    async function sM() {
      if (!(!on.value || !Ct.value || !wr.value)) {
        Eu.value = !0;
        try {
          const o = await y4(on.value, wr.value, {
            escrowPublicKey: _r.value
          }), s = new File([JSON.stringify(o.marker)], ga, {
            type: "application/json"
          });
          await q.uploadMultipart(Ct.value, [s]), on.value = o.marker, Vt.setMarker(Ct.value, o.marker), Ns.value = !1, wr.value = "", No.value = o.recoveryKey, Io.value = Mi(Ct.value), kr.value = "upgraded", Ro.value = !0;
        } catch (o) {
          P("error", { message: o.message, context: { op: "e2e-upgrade" } }), tt(_("e2e.upgrade.failed"));
        } finally {
          Eu.value = !1;
        }
      }
    }
    const xw = A(() => U_(on.value, Wa.value));
    function lM() {
      Cu.value = "manual", Ri.value = "", Ii.value = "", Bo.value = !0;
    }
    async function Fo(o) {
      const s = new File([JSON.stringify(o)], ga, { type: "application/json" });
      await q.uploadMultipart(Ct.value, [s]), on.value = o, Vt.setMarker(Ct.value, o);
    }
    async function Sw() {
      const o = on.value, s = _r.value;
      if (!(!o || !s || !Ct.value || Ni.value)) {
        if (!Ri.value) {
          Ii.value = _("e2e.escrowoffer.password_required");
          return;
        }
        Ni.value = !0, Ii.value = "";
        try {
          const g = await g4(o, Ri.value, s);
          await Fo(g), Bo.value = !1, Ri.value = "", tt(_("e2e.escrowoffer.done"));
        } catch (g) {
          (g == null ? void 0 : g.name) === "E2eDecryptError" ? Ii.value = _("e2e.escrowoffer.wrong_password") : (Ii.value = _("e2e.escrowoffer.failed"), P("error", { message: g.message, context: { op: "e2e-escrow-offer" } }));
        } finally {
          Ni.value = !1;
        }
      }
    }
    async function uM() {
      const o = on.value;
      if (!(!o || !Ct.value || Ni.value)) {
        Ni.value = !0;
        try {
          await Fo(b4(o, (/* @__PURE__ */ new Date()).toISOString())), Bo.value = !1, Ri.value = "", tt(_("e2e.escrowoffer.declined_toast"));
        } catch (s) {
          Ii.value = _("e2e.escrowoffer.decline_failed"), P("error", { message: s.message, context: { op: "e2e-escrow-decline" } });
        } finally {
          Ni.value = !1;
        }
      }
    }
    function cM() {
      Bo.value = !1, Ri.value = "", Ii.value = "";
    }
    function dM() {
      Ns.value = !1, wr.value = "";
    }
    class $w extends Error {
      constructor(s) {
        super(`e2e: invalid name (${s})`), this.problem = s, this.name = "E2eNameRefused";
      }
    }
    async function Tw(o, s, g = {}) {
      if (await Cm(o), !Vt.writesEncrypted(o)) return s;
      const M = Gi(s);
      if (M) throw new $w(M);
      const I = await Vt.nameForWrite(o, s, g);
      return I ? (I.sidecar && await q.uploadMultipart(o, [
        new File([I.sidecar.content], I.sidecar.name, { type: "text/plain" })
      ]), I.stored) : s;
    }
    async function Cm(o) {
      const s = Ct.value;
      if (!s) return;
      const g = o.replace(/\/+$/, ""), M = s.replace(/\/+$/, "");
      (g === M || g.startsWith(M.endsWith("://") ? M : `${M}/`)) && await Vt.markerFor(s);
    }
    async function zm(o, s, g, M) {
      await Cm(g);
      const I = Vt.writesEncrypted(g);
      if (!I || !sn.names(I) || !s.every((et) => Vt.rootOf(et) === I)) return null;
      const X = [], de = [], Se = (et, Pt) => et.replace(/\/+$/, "") === Pt.replace(/\/+$/, "");
      let $e = /* @__PURE__ */ new Set();
      try {
        $e = new Set(((await q.index(g)).files ?? []).map((et) => et.basename));
      } catch {
      }
      for (const et of s) {
        const Pt = oo(et);
        if (o === "move" && Se(Pt, g)) continue;
        const En = Mi(et), At = await Vt.plainNameOf(et);
        if (!At || At.state === "unreadable" || At.name === null)
          throw new Error(_("e2e.names.move_unreadable"));
        const vn = await fM(et) ? { keepIdOf: et } : {};
        let $n = await Vt.nameForWrite(g, At.name, vn);
        if (!$n) return null;
        for (let Ga = 2; o === "copy" && $e.has($n.stored) && Ga < 100; Ga++)
          $n = await Vt.nameForWrite(g, LT(At.name, Ga), vn);
        if ($e.has($n.stored)) throw new Error(_("e2e.names.move_taken", { name: At.name }));
        $e.add($n.stored), $n.sidecar && await q.uploadMultipart(g, [
          new File([$n.sidecar.content], $n.sidecar.name, { type: "text/plain" })
        ]);
        const { op: Fi } = await q.transferNamed(o, et, g, $n.stored, M);
        De.register(Fi), X.push(Fi), de.push({ moved: ja(g, $n.stored), origin: Pt, name: En });
      }
      return { ops: X, undo: o === "move" ? async () => {
        for (const et of de) {
          const { op: Pt } = await q.transferNamed("move", et.moved, et.origin, et.name);
          De.register(Pt);
        }
        return { queued: !0 };
      } : null };
    }
    async function fM(o) {
      var M;
      const s = G.value.find((I) => I.path === o) ?? (((M = Zt.value) == null ? void 0 : M.visibleNodes()) ?? []).find((I) => I.path === o);
      if (s) return s.type === "dir";
      const g = Il(Mi(o)).kind;
      if (g === "dir" || g === "longdir") return !0;
      if (g === "file" || g === "long") return !1;
      try {
        return ((await q.index(oo(o))).files ?? []).some((X) => X.path === o && X.type === "dir");
      } catch {
        return !1;
      }
    }
    async function Aw(o, s) {
      const g = Vt.writesEncrypted(o);
      if (!g) return null;
      const M = o.indexOf("://"), X = {
        adapter: M === -1 ? ne.value : o.slice(0, M),
        storages: (L.config.storages ?? []).map((ut) => ut.name),
        dirname: o,
        read_only: !1,
        files: [],
        e2e_root: g
      };
      if (!sn.names(g)) return X;
      const de = [], Se = [o];
      let $e = 0;
      for (; Se.length > 0 && de.length < kf && $e < sle; ) {
        const ut = Se.shift();
        $e++;
        let et;
        try {
          et = await q.index(ut);
        } catch {
          continue;
        }
        const Pt = Mr(await Vt.decorate(et.files ?? [], { root: g }));
        for (const En of Pt)
          if (En.type === "dir" && Se.push(En.path), VS(En.basename, s) && de.push(En), de.length >= kf) break;
      }
      return { ...X, files: de, truncated: Se.length > 0 };
    }
    const Bi = S(!1);
    Je(Ct, async (o, s) => {
      if (o === s) return;
      if (Ns.value = !1, wr.value = "", Bo.value = !1, Ri.value = "", Bi.value = !1, xr.value = "", Sr.value = null, pw.value = [], !o) {
        on.value = null;
        return;
      }
      const g = Vt.markerCached(o);
      if (on.value = g === void 0 ? null : g, g === void 0) {
        const M = await Vt.markerFor(o);
        Ct.value === o && (on.value = M);
      }
    });
    const co = S(!1), xr = S(""), Sr = S(null);
    let Bs = !1;
    const nf = A(() => (Wn.value, $4(on.value))), Ew = A(() => nf.value !== "content"), pM = A(() => (Wn.value, T4(on.value))), hM = A(
      () => Ew.value ? G.value.filter((o) => o.e2e_name_state === "plain" || o.e2e_name_state === "unreadable").length : 0
    );
    async function af() {
      var M;
      const o = Ct.value, s = o ? sn.get(o) : void 0;
      let g = on.value;
      if (!o || !s || !g || co.value) return !1;
      Bi.value = !1, co.value = !0, xr.value = "", Bs = !1;
      try {
        if (!qi(g)) {
          const Se = await H_(g, s);
          await Fo(Se.marker), sn.setNames(o, Se.names), Wn.value++, g = Se.marker;
        }
        const I = sn.names(o);
        if (!I) throw new Error("e2e: the folder name key is missing");
        Sr.value = { renamed: 0, failed: 0, seen: 0 };
        const X = Sr.value;
        if (await rne(I, o, {
          list: async (Se) => (await q.index(Se)).files ?? [],
          readSidecar: async (Se, $e) => {
            try {
              return new TextDecoder().decode(await q.fetchArrayBuffer(tl(Se, $e)));
            } catch {
              return null;
            }
          },
          writeSidecar: async (Se, $e, ut) => {
            await q.uploadMultipart(Se, [new File([ut], $e, { type: "text/plain" })]);
          },
          // A folder rename is a job of the queue where the server has one: the
          // queue keeps order, so a folder is renamed after its contents.
          rename: async (Se, $e, ut) => {
            if ($e.type === "dir" && sd("rename")) {
              const et = (await q.renameQueued(Se, $e.path, ut)).op;
              et && De.register(et);
            } else
              await q.rename(Se, $e.path, ut);
          },
          stopped: () => Bs
        }, X), Bs)
          return tt(_("e2e.names.stopped", { n: X.renamed })), !1;
        if (X.failed > 0)
          return xr.value = _("e2e.names.partial", { n: X.failed }), !1;
        const de = on.value ?? g;
        return (M = de.names) != null && M.pending && await Fo(x4(de)), Sr.value = null, tt(_("e2e.names.done", { n: X.renamed })), !0;
      } catch (I) {
        return xr.value = _("e2e.names.failed"), P("error", { message: I.message, context: { op: "e2e-names" } }), !1;
      } finally {
        co.value = !1, await wt();
      }
    }
    const $r = S(null), Uo = S(!1), Tr = S(""), fo = S(null);
    let of = !1, Ou = null;
    const Fs = S(null), Cw = A(() => (Wn.value, V_(on.value)));
    function mM(o, s) {
      const g = o.length === 1 ? o[0] : null;
      return !!g && g.type === "dir" && s && !an.value && !g.e2e && !g.e2e_root && !Kt.value && typeof crypto < "u" && !!crypto.subtle;
    }
    function zw(o, s, g) {
      return mM(o, s) && Bh(o[0].path, "folder") === g;
    }
    function vM(o) {
      $r.value = o, yr.value = !0;
    }
    async function yM(o) {
      const s = [o];
      for (; s.length; ) {
        const g = s.shift(), M = await q.index(g);
        if (g !== o && typeof M.e2e_root == "string" && M.e2e_root) return !0;
        for (const I of M.files ?? [])
          if (I.type === "dir") {
            if (I.e2e) return !0;
            s.push(I.path);
          }
      }
      return !1;
    }
    async function gM(o) {
      const s = $r.value;
      if (!s) return;
      const g = s.path;
      gr.value = !0;
      try {
        if (await yM(g)) {
          tt(_("e2e.convert.nested"));
          return;
        }
        const M = await Jv(o.password, { escrowPublicKey: _r.value });
        let I = M.marker, X = null;
        if (o.level === "names") {
          const de = await H_(I, M.fmk);
          I = de.marker, X = de.names;
        }
        I = C4(I, void 0, o.cleanup ?? { versions: !1, trash: !1 }), await q.uploadMultipart(g, [
          new File([JSON.stringify(I)], ga, { type: "application/json" })
        ]), sn.set(g, M.fmk, X), Vt.setMarker(g, I), Wn.value++, yr.value = !1, $r.value = null, No.value = M.recoveryKey, Io.value = o.name, kr.value = "created", Ro.value = !0, await wt(Di(g)), await Gt(), Ct.value === g && (on.value = I, Mw());
      } catch (M) {
        P("error", { message: M.message, context: { op: "e2e-convert" } }), qt({ message: Zn(M, _("e2e.convert.failed")) }, yn);
      } finally {
        gr.value = !1;
      }
    }
    async function Mw() {
      var X, de, Se;
      const o = Ct.value, s = o ? sn.get(o) : void 0, g = on.value;
      if (!o || !s || !g || !V_(g) || Uo.value) return;
      Uo.value = !0, Tr.value = "", of = !1;
      const M = new AbortController();
      Ou = M, fo.value = { total: 0, done: 0, skipped: 0, tooBig: 0, failed: 0 };
      const I = fo.value;
      try {
        if (await sne(
          o,
          {
            list: async (et) => (await q.index(et)).files ?? [],
            head: (et) => q.fetchHead(et, 16),
            read: (et) => q.fetchArrayBuffer(et),
            write: async (et, Pt, En, At) => {
              await q.uploadMultipart(
                et,
                [new File([En], Pt.basename, { type: "application/octet-stream" })],
                void 0,
                { e2e_convert: "1", ...At ? { expect: At } : {} }
              );
            },
            encrypt: (et) => Zv(s, et),
            /* wiring:e2 convert - over 200 MB: STREAM (0x02), streamed both ways. */
            writeLarge: async (et, Pt, En) => {
              Fs.value = { name: Pt.basename, percent: 0 };
              try {
                return await Mt.convertLarge(Pt, s, En, {
                  signal: M.signal,
                  onProgress: (At) => {
                    Fs.value = { name: Pt.basename, percent: Math.floor(At * 100) };
                  }
                });
              } finally {
                Fs.value = null;
              }
            },
            stopped: () => of
          },
          I,
          { maxBytes: ec }
        ), of) {
          tt(_("e2e.convert.stopped", { n: I.done }));
          return;
        }
        if (I.tooBig > 0 && I.failed === 0) {
          Tr.value = _("e2e.convert.too_large_here", { n: I.tooBig });
          return;
        }
        if (I.failed + I.tooBig > 0) {
          Tr.value = _("e2e.convert.partial", { n: I.failed + I.tooBig });
          return;
        }
        if ((de = (X = on.value) == null ? void 0 : X.names) != null && de.pending && !await af()) return;
        const $e = on.value ?? g, ut = (Se = $e.conv) == null ? void 0 : Se.cleanup;
        await Fo(z4($e)), fo.value = null;
        try {
          const et = await q.e2eCleanup({ path: o, versions: !!(ut != null && ut.versions), trash: !!(ut != null && ut.trash) });
          tt(
            _("e2e.convert.done", {
              n: I.done + I.skipped,
              versions: et.versions_deleted,
              trash: et.trash_purged
            })
          );
        } catch (et) {
          tt(_("e2e.convert.cleanup_failed")), P("error", { message: et.message, context: { op: "e2e-convert-cleanup" } });
        }
      } catch ($e) {
        Tr.value = Zn($e, _("e2e.convert.failed")), P("error", { message: $e.message, context: { op: "e2e-convert" } });
      } finally {
        Uo.value = !1, Ou = null, await wt();
      }
    }
    function bM() {
      of = !0, Ou == null || Ou.abort();
    }
    function kM() {
      Bi.value = !1, Pw("change");
    }
    function wM() {
      Bi.value = !1, lM();
    }
    const Us = S(!1), Mm = S("change"), Lu = S(!1), Ar = S(null);
    let Hs = null;
    const Er = S(!1), Du = S(""), Ks = S(null), _M = A(() => (Wn.value, fl(on.value))), xM = A(() => !!on.value && oS(on.value));
    function Pw(o) {
      Mm.value = o, Ar.value = null, Us.value = !0;
    }
    function SM() {
      if (!Lu.value) {
        if (Mm.value === "reset") {
          $m();
          return;
        }
        Us.value = !1;
      }
    }
    async function $M(o) {
      const s = Ct.value, g = on.value;
      if (!s || !g || Lu.value) return;
      const M = o.proof ?? (Hs ? { recoveryKey: Hs } : null);
      if (!M) {
        Ar.value = _("e2e.password.current_required");
        return;
      }
      const I = "recoveryKey" in M ? "recovery_key" : "password";
      Lu.value = !0, Ar.value = null;
      try {
        if (!o.rotate) {
          const de = await rS(g, M, o.newPassword);
          await Fo(de), Hs = null, Us.value = !1, tt(_("e2e.password.done"));
          return;
        }
        const X = await A4(g, M, o.newPassword, {
          escrowPublicKey: _r.value
        });
        await Fo(X.marker), Ns.value = !1, wr.value = "", sn.set(s, X.fmk, X.names ?? sn.names(s) ?? null, X.previous), Wn.value++, Sm(), Hs = null, Us.value = !1, X.recoveryKeyIsNew && (No.value = X.recoveryKey, Io.value = Mi(s), kr.value = "replaced", Ro.value = !0), await Lw();
      } catch (X) {
        X instanceof cn ? Ar.value = _(I === "recovery_key" ? "e2e.password.wrong_recovery" : "e2e.password.wrong_current") : X instanceof sS ? Ar.value = _("e2e.password.escrow_blocked") : (Ar.value = _("e2e.password.failed"), P("error", { message: X.message, context: { op: "e2e-password" } }));
      } finally {
        Lu.value = !1;
      }
    }
    async function TM(o, s, g) {
      const M = new File([g], s, { type: "application/octet-stream" });
      if (xe.shouldChunk(M)) {
        await xe.uploadFile({ path: o, file: M });
        return;
      }
      await q.uploadMultipart(o, [M]);
    }
    async function Ow(o, s, g) {
      const M = Ks.value;
      let I;
      try {
        I = await q.index(o);
      } catch {
        M.failed++;
        return;
      }
      for (const X of I.files ?? [])
        if (X.basename !== ga) {
          if (X.type === "dir") {
            await Ow(X.path, s, g);
            continue;
          }
          try {
            if ((X.size ?? 0) > ec) {
              await Mt.rewrapLarge(X, s, g) && M.done++;
              continue;
            }
            const de = await q.fetchArrayBuffer(X.path);
            if (!Tl(de)) continue;
            const Se = await lS(de, s, g);
            Se && await TM(o, X.basename, Se), M.done++;
          } catch {
            M.failed++;
          }
        }
    }
    async function Lw() {
      const o = Ct.value, s = o ? sn.get(o) : void 0, g = o ? sn.previous(o) : void 0;
      if (!(!o || !s || !g || Er.value)) {
        Er.value = !0, Du.value = "", Ks.value = { done: 0, failed: 0 };
        try {
          await Ow(o, g, s);
          const M = Ks.value;
          if (M.failed > 0) {
            Du.value = _("e2e.password.rekey_partial", { n: M.failed });
            return;
          }
          const I = on.value;
          I && fl(I) && await Fo(M4(I)), sn.dropPrevious(o), Wn.value++, tt(_("e2e.password.rekey_done", { n: M.done }));
        } catch (M) {
          Du.value = _("e2e.password.failed"), P("error", { message: M.message, context: { op: "e2e-rekey" } });
        } finally {
          Er.value = !1, await wt();
        }
      }
    }
    function rf(o) {
      return o.replace(/\/+$/, "");
    }
    function Dw(o) {
      if (!o || o.type !== "dir" || o.e2e !== !0) return null;
      const s = rf(o.path);
      return sn.roots().find((g) => rf(g) === s) ?? null;
    }
    async function AM(o) {
      const s = o.length === 1 ? o[0] : null;
      if (s && Ui(s) && !an.value && !s.e2e_root)
        return await Mt.download(s), !0;
      let g = null;
      if (Yn.value ? g = Ct.value : s && (g = Dw(s)), !g && o.length > 0) {
        const de = o.map(($e) => Vt.rootOf($e.path, $e.e2e_root ?? null)), Se = de[0];
        Se && de.every(($e) => $e === Se) && (g = sn.roots().find(($e) => rf($e) === rf(Se)) ?? null);
      }
      if (!g) return !1;
      const M = sn.get(g);
      if (!M) return !1;
      if (s && s.type === "file")
        return await Mt.downloadFolderFile(s, M, sn.previous(g), g), !0;
      const I = Vt.segmentLabel(Rt(Xe.value)) ?? Mi(Rt(Xe.value)), X = `${s ? s.basename : I || "filex"}.zip`;
      return await Mt.downloadDecryptedZip(o, {
        root: g,
        fmk: M,
        previous: sn.previous(g),
        decorate: (de, Se) => Vt.decorate(de, Se),
        zipName: X
      }), !0;
    }
    function EM() {
      const o = Mt.tooBig.value;
      if (Mt.closeTooBig(), !o) return;
      if (o.encrypted.kind === "file") {
        window.open(q.downloadUrl(o.encrypted.path), "_blank");
        return;
      }
      const s = { path: o.encrypted.path, basename: Mi(o.encrypted.path), type: "dir" };
      Fd([s], { encrypted: !0 });
    }
    function CM() {
      Ro.value = !1, No.value = "", Io.value = "";
    }
    return (o, s) => {
      var g, M, I, X, de, Se, $e, ut, et, Pt, En, At, Ya, vn, $n, Fi, Ga, sf, Nw, Iw, Bw, Fw, Uw, Hw, Kw, Vw, jw, qw, Ww, Yw;
      return f(), h("div", {
        ref_key: "rootEl",
        ref: Tn,
        class: Re(["fe", {
          "fe--theme-light": wn.value === "light",
          "fe--theme-dark": wn.value === "dark",
          "fe--is-dragover": Do.value,
          "fe--density-compact": _t.value === "compact",
          "fe--narrow": $a.value
        }]),
        dir: u(Y),
        tabindex: "-1",
        onDragenter: oz,
        onDragover: sz,
        onDragleave: rz,
        onDrop: lz,
        onContextmenu: MC
      }, [
        Ze(aD, {
          ref_key: "toolbarRef",
          ref: ak,
          "view-mode": gm.value,
          "search-query": Et.value,
          "trash-active": Kt.value,
          actions: BC.value,
          "selection-mode": EC.value,
          "selection-count": ia().length,
          "selection-pane": Xd.value,
          "paste-enabled": !!ze.value.mode,
          "can-go-up": xt.value,
          "at-virtual-root": Qe.value,
          "can-write": li.value,
          locale: j.value,
          "language-row": N.value && !((g = od()) != null && g.language),
          narrow: $a.value,
          theme: wn.value,
          "inspector-open": Ra.value,
          "assistant-button": kh.value,
          "assistant-open": no.value,
          "nav-open": xE.value,
          "nav-enabled": iu.value,
          "view-modes": Sh.value,
          "scope-label": Fb.value,
          "brand-name": (M = e.config.brand) == null ? void 0 : M.name,
          "brand-mark-url": (I = e.config.brand) == null ? void 0 : I.markUrl,
          "search-escalates": bt.value === "home",
          onOpenPalette: BE,
          onToggleInspector: bh,
          onToggleAssistant: bE,
          onToggleNav: Pb,
          onOpenTheme: s[0] || (s[0] = (Ee) => Vd.value = !0),
          "onUpdate:viewMode": s[1] || (s[1] = (Ee) => aw(Ee)),
          "onUpdate:searchQuery": IE,
          onOpenAdvancedSearch: RE,
          "onUpdate:density": s[2] || (s[2] = (Ee) => _t.value = Ee),
          onOpenShortcutSettings: s[3] || (s[3] = (Ee) => wu.value = !0),
          onOpenTimezone: s[4] || (s[4] = (Ee) => Q.value = !0),
          onOpenLanguage: s[5] || (s[5] = (Ee) => tn.value = !0),
          onNewFolder: s[6] || (s[6] = (Ee) => sa.value = !0),
          onUpload: Oo,
          onRefresh: lk,
          onGoUp: je,
          onAction: Jh,
          onOpenRecents: s[7] || (s[7] = (Ee) => ls.value = !0)
        }, BM({
          "header-actions": mt(() => {
            var Ee;
            return [
              u(vt) ? (f(), Ge(moe, {
                key: 0,
                feed: u(vt),
                locale: j.value,
                "manage-href": Qt.value,
                onOpen: un,
                onManage: en
              }, null, 8, ["feed", "locale", "manage-href"])) : O("", !0),
              e.config.account ? (f(), Ge(Yoe, {
                key: 1,
                actions: To.value,
                user: Un.value,
                version: (Ee = Ke.value) == null ? void 0 : Ee.release,
                locale: j.value,
                "fallback-label": u(_)("explore.account"),
                onSelect: ad
              }, null, 8, ["actions", "user", "version", "locale", "fallback-label"])) : O("", !0),
              On(o.$slots, "header-actions")
            ];
          }),
          _: 2
        }, [
          o.$slots.brand ? {
            name: "brand",
            fn: mt(() => [
              On(o.$slots, "brand")
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["view-mode", "search-query", "trash-active", "actions", "selection-mode", "selection-count", "selection-pane", "paste-enabled", "can-go-up", "at-virtual-root", "can-write", "locale", "language-row", "narrow", "theme", "inspector-open", "assistant-button", "assistant-open", "nav-open", "nav-enabled", "view-modes", "scope-label", "brand-name", "brand-mark-url", "search-escalates", "onOpenPalette", "onToggleInspector", "onToggleNav", "onUpdate:searchQuery", "onOpenAdvancedSearch", "onRefresh"]),
        d("div", {
          class: Re([
            "fe__main",
            { "fe__main--split": Ls.value }
            /* wiring:d1 */
          ])
        }, [
          wh.value ? (f(), Ge(pq, {
            key: 0,
            expanded: au.value,
            narrow: $a.value,
            "active-view": bt.value,
            "active-tag": rn.value,
            "active-tag-kind": me.value,
            tags: Wb.value,
            "tags-loaded": Mh.value,
            "active-storage": ne.value,
            storages: Ch.value,
            "storage-order-custom": u(jb).custom.value,
            onReorderStorages: VE,
            "shared-storages": _h.value,
            "trash-visible": e.config.trashVisible !== !1,
            "drafts-visible": sr.value && gs.value,
            "draft-count": us.value,
            "show-connections": SE.value,
            "show-my-shares": $E.value,
            "show-identity-surfaces": gs.value,
            "can-write": li.value && !Qe.value && !Kt.value,
            locale: j.value,
            "can-request-files": li.value && !Qe.value && !Kt.value && !bt.value && !an.value,
            "request-files-allowed": nk.value,
            "can-new-document": XA.value && !Kt.value && !bt.value && !an.value,
            onNewDocument: s[8] || (s[8] = (Ee) => Ql.value = !0),
            quota: HE.value,
            theme: wn.value,
            onRequestFiles: FE,
            onToggle: Pb,
            onClose: Eo,
            onOpenView: qE,
            onOpenTag: _s,
            onOpenStorage: Yb,
            onUpload: Oo,
            onNewFolder: s[9] || (s[9] = (Ee) => sa.value = !0),
            onOpenConnections: AE,
            onOpenTokens: EE,
            onOpenMyShares: s[10] || (s[10] = (Ee) => P("open-my-shares")),
            "show-app-store": TE.value,
            onOpenAppStore: s[11] || (s[11] = (Ee) => P("open-app-store")),
            apps: IA.value,
            onOpenApp: pb
          }, null, 8, ["expanded", "narrow", "active-view", "active-tag", "active-tag-kind", "tags", "tags-loaded", "active-storage", "storages", "storage-order-custom", "shared-storages", "trash-visible", "drafts-visible", "draft-count", "show-connections", "show-my-shares", "show-identity-surfaces", "can-write", "locale", "can-request-files", "request-files-allowed", "can-new-document", "quota", "theme", "onRequestFiles", "onOpenView", "show-app-store", "apps"])) : O("", !0),
          $a.value && hr.value ? (f(), h("button", {
            key: 1,
            type: "button",
            class: "fe-sidenav__scrim",
            title: u(_)("sidenav.close"),
            "aria-label": u(_)("sidenav.close"),
            onClick: Eo
          }, null, 8, ire)) : O("", !0),
          d("div", ore, [
            Ez.value ? (f(), Ge(wQ, {
              key: 0,
              tabs: Yk.value,
              "active-id": u(vm),
              locale: j.value,
              "hide-tabs": !Gk.value,
              "split-enabled": $u.value,
              "split-active": !!so.value,
              "inspector-enabled": zb.value,
              "inspector-open": Ra.value,
              onSelect: xz,
              onClose: Xk,
              onNew: ym,
              onReorder: s[12] || (s[12] = (Ee, Gn) => u(Hn).move(Ee, Gn)),
              onToggleSplit: ew,
              onToggleInspector: bh
            }, null, 8, ["tabs", "active-id", "locale", "hide-tabs", "split-enabled", "split-active", "inspector-enabled", "inspector-open"])) : O("", !0),
            d("div", rre, [
              Ze($0, {
                "pane-id": "main",
                ref_key: "mainPaneRef",
                ref: Tz,
                api: Fe,
                locale: j.value,
                theme: wn.value,
                focused: Lz.value,
                path: Xe.value,
                qualify: Rt,
                "to-user": Di,
                clamp: rw,
                "root-path": u(ft),
                floor: u(gt),
                "multi-root": Sn.value,
                rows: G.value,
                loading: ot.value,
                error: Ie.value,
                order: ME.value,
                "view-mode": Pe.value,
                "view-modes": Sh.value,
                "open-trigger": L.config.openTrigger,
                "show-crumbs": bt.value !== "home",
                "filter-mode": ue.value,
                "find-label": bt.value === "home" ? u(_)("filter.find.home") : "",
                "show-view-switcher": bt.value !== "home",
                "folder-key": mn.value,
                "show-parent-path": !!Et.value || Nn.value,
                trash: Kt.value,
                clipped: dm.value,
                "extra-filters": ws.value,
                "extra-filters-on-server": !Nb.value,
                "can-write": li.value && !Kt.value,
                "can-paste": !!ze.value.mode,
                selected: u(oe).selected.value,
                filters: ks.value,
                "thumb-src": u(ie).src,
                "folder-previews": ((X = Ke.value) == null ? void 0 : X.folder_previews) !== !1,
                "keep-badge-for": ci.value ? kk : void 0,
                "starred-ids": bb.value,
                "star-overrides": ss.value,
                "star-enabled": gs.value,
                "api-base": L.config.apiBase ?? "",
                "auth-headers": () => Qn(),
                "auth-credentials": u(q).credentialsMode(),
                "e2e-active": an.value,
                "body-override": Gd.value !== "",
                onActivate: Oz,
                onNavigate: fz,
                onOpen: qa,
                onOpenTrash: s[23] || (s[23] = () => zi()),
                onClickRow: s[24] || (s[24] = (Ee, Gn) => Pk("main", Ee, Gn)),
                onContext: s[25] || (s[25] = (Ee, Gn) => Sk("main", Ee, Gn)),
                onClearSelection: s[26] || (s[26] = (Ee) => u(oe).clear()),
                onDisplayOrder: s[27] || (s[27] = (Ee) => dt.value = Ee),
                onItemDragStart: s[28] || (s[28] = (Ee, Gn) => Ok("main", Ee, Gn)),
                onItemDropInto: Hk,
                onTransfer: dw,
                "onUpdate:viewMode": s[29] || (s[29] = (Ee) => Pe.value = Ee),
                "onUpdate:filters": Lb,
                onCrumbContext: PC,
                onCopyPath: Kd,
                onCrumbDrop: Kk,
                onNewFolder: s[30] || (s[30] = (Ee) => sa.value = !0),
                onUpload: Oo,
                onPaste: s[31] || (s[31] = (Ee) => Jh("paste")),
                onSelectAll: s[32] || (s[32] = (Ee) => u(oe).selectAll()),
                onClearFilters: PE,
                onStarChange: kb,
                onRetry: Ae
              }, {
                banners: mt(() => [
                  Et.value && xn.value && !bt.value && !Kt.value ? (f(), h("div", sre, y(u(_)("search.truncated")), 1)) : O("", !0),
                  ao.value && ao.value.truncated && Cn.value && !Et.value ? (f(), h("div", lre, [
                    d("span", null, y(u(_)("nav.more_shown", { shown: G.value.length, total: ao.value.total })), 1),
                    d("button", {
                      type: "button",
                      class: "fe-coverage__action",
                      "data-testid": "nav-more-load",
                      disabled: lu.value,
                      "aria-busy": lu.value ? "true" : void 0,
                      onClick: KE
                    }, y(u(_)("nav.load_more")), 9, ure)
                  ])) : O("", !0),
                  Ci.value ? (f(), h("div", cre, [
                    d("span", dre, y(Vn(Ci.value.storage) ? u(_)("coverage.cataloging", { storage: Ci.value.storage ?? "" }) : u(_)(Ci.value.key, Ci.value.vars)), 1),
                    Ci.value.offerCatalogAll ? (f(), h("button", {
                      key: 0,
                      type: "button",
                      class: "fe-coverage__action",
                      "data-testid": "catalog-coverage-all",
                      disabled: Vn(Ci.value.storage),
                      "aria-busy": Vn(Ci.value.storage) ? "true" : void 0,
                      onClick: s[13] || (s[13] = (Ee) => tC(Ci.value.storage))
                    }, y(Vn(Ci.value.storage) ? u(_)("coverage.catalog_running") : u(_)("coverage.catalog_all")), 9, fre)) : O("", !0)
                  ])) : O("", !0),
                  u(kt).length || u(pt) ? (f(), h("div", pre, [
                    u(kt).length ? (f(), Ge(F3, {
                      key: 0,
                      users: u(kt),
                      locale: j.value
                    }, null, 8, ["users", "locale"])) : O("", !0),
                    u(pt) ? (f(), h("span", {
                      key: 1,
                      class: "fe-connbadge",
                      role: "status",
                      title: u(_)("conn.tooltip")
                    }, [
                      s[115] || (s[115] = d("span", {
                        class: "fe-connbadge__dot",
                        "aria-hidden": "true"
                      }, null, -1)),
                      Ht(" " + y(u(_)("conn.offline")), 1)
                    ], 8, hre)) : O("", !0)
                  ])) : O("", !0),
                  Ns.value ? (f(), h("div", mre, [
                    d("div", vre, [
                      d("strong", null, y(u(_)("e2e.upgrade.title")), 1),
                      d("p", null, y(u(_)("e2e.upgrade.body")), 1),
                      Wa.value ? (f(), h("p", yre, y(u(_)("e2e.upgrade.escrow_note")), 1)) : O("", !0)
                    ]),
                    d("div", gre, [
                      d("button", {
                        type: "button",
                        class: "fe-btn",
                        disabled: Eu.value,
                        onClick: dM
                      }, y(u(_)("e2e.upgrade.decline")), 9, bre),
                      d("button", {
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        disabled: Eu.value,
                        onClick: sM
                      }, y(Eu.value ? u(_)("e2e.upgrade.busy") : u(_)("e2e.upgrade.accept")), 9, kre)
                    ])
                  ])) : O("", !0),
                  Bo.value ? (f(), h("div", wre, [
                    d("div", _re, [
                      d("strong", null, y(u(_)("e2e.escrowoffer.title")), 1),
                      d("p", null, y(u(_)("e2e.escrowoffer.body")), 1),
                      d("p", xre, [
                        Ht(y(u(_)("e2e.escrowoffer.consequence")) + " ", 1),
                        d("a", {
                          href: ole,
                          target: "_blank",
                          rel: "noopener noreferrer"
                        }, y(u(_)("e2e.escrowoffer.learn_more")), 1)
                      ]),
                      Wa.value ? (f(), h("p", Sre, [
                        Ht(y(u(_)("e2e.recover.escrow_kid")) + ": ", 1),
                        d("code", null, y(Wa.value), 1)
                      ])) : O("", !0),
                      Cu.value === "manual" ? (f(), h("label", $re, [
                        d("span", null, y(u(_)("e2e.escrowoffer.password_label")), 1),
                        dn(d("input", {
                          "onUpdate:modelValue": s[14] || (s[14] = (Ee) => Ri.value = Ee),
                          type: "password",
                          class: "fe-input",
                          autocomplete: "current-password",
                          disabled: Ni.value,
                          onKeyup: Ca(Sw, ["enter"])
                        }, null, 40, Tre), [
                          [_n, Ri.value]
                        ])
                      ])) : O("", !0),
                      Ii.value ? (f(), h("p", Are, y(Ii.value), 1)) : O("", !0)
                    ]),
                    d("div", Ere, [
                      d("button", {
                        type: "button",
                        class: "fe-btn",
                        disabled: Ni.value,
                        onClick: s[15] || (s[15] = (Ee) => Cu.value === "manual" ? cM() : uM())
                      }, y(Cu.value === "manual" ? u(_)("e2e.escrowoffer.cancel") : u(_)("e2e.escrowoffer.decline")), 9, Cre),
                      d("button", {
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        disabled: Ni.value,
                        onClick: Sw
                      }, y(Ni.value ? u(_)("e2e.escrowoffer.busy") : u(_)("e2e.escrowoffer.accept")), 9, zre)
                    ])
                  ])) : O("", !0),
                  Yn.value && (Cw.value || Uo.value || Tr.value) ? (f(), h("div", Mre, [
                    d("div", Pre, [
                      d("strong", null, y(Uo.value ? u(_)("e2e.convert.busy") : u(_)("e2e.convert.resume_title")), 1),
                      Uo.value ? O("", !0) : (f(), h("p", Ore, y(u(_)("e2e.convert.resume_body")), 1)),
                      fo.value ? (f(), h("p", Lre, y(u(_)("e2e.convert.progress", {
                        n: fo.value.done + fo.value.skipped,
                        total: fo.value.total,
                        failed: fo.value.failed + fo.value.tooBig
                      })), 1)) : O("", !0),
                      Fs.value ? (f(), h("p", Dre, y(u(_)("e2e.convert.large_progress", { name: Fs.value.name, percent: Fs.value.percent })), 1)) : O("", !0),
                      Tr.value ? (f(), h("p", Rre, y(Tr.value), 1)) : O("", !0)
                    ]),
                    d("div", Nre, [
                      Uo.value ? (f(), h("button", {
                        key: 0,
                        type: "button",
                        class: "fe-btn",
                        "data-testid": "e2e-convert-stop",
                        onClick: bM
                      }, y(u(_)("e2e.names.stop")), 1)) : (f(), h("button", {
                        key: 1,
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        "data-testid": "e2e-convert-resume",
                        onClick: Mw
                      }, y(u(_)("e2e.names.resume")), 1))
                    ])
                  ])) : O("", !0),
                  Yn.value && !Cw.value && !Uo.value && (nf.value === "pending" || co.value || xr.value) ? (f(), h("div", Ire, [
                    d("div", Bre, [
                      d("strong", null, y(co.value ? u(_)("e2e.names.busy") : u(_)("e2e.names.resume_title")), 1),
                      co.value ? O("", !0) : (f(), h("p", Fre, y(u(_)("e2e.names.resume_body")), 1)),
                      Sr.value ? (f(), h("p", Ure, y(u(_)("e2e.names.progress", { n: Sr.value.renamed, failed: Sr.value.failed })), 1)) : O("", !0),
                      xr.value ? (f(), h("p", Hre, y(xr.value), 1)) : O("", !0)
                    ]),
                    d("div", Kre, [
                      co.value ? (f(), h("button", {
                        key: 0,
                        type: "button",
                        class: "fe-btn",
                        "data-testid": "e2e-names-stop",
                        onClick: s[16] || (s[16] = (Ee) => FM(Bs) ? Bs.value = !0 : Bs = !0)
                      }, y(u(_)("e2e.names.stop")), 1)) : (f(), h("button", {
                        key: 1,
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        "data-testid": "e2e-names-resume",
                        onClick: af
                      }, y(u(_)("e2e.names.resume")), 1))
                    ])
                  ])) : O("", !0),
                  Yn.value && (_M.value || Er.value) ? (f(), h("div", Vre, [
                    d("div", jre, [
                      d("strong", null, y(u(_)("e2e.password.resume_title")), 1),
                      d("p", null, y(u(_)("e2e.password.resume_body")), 1),
                      Ks.value ? (f(), h("p", qre, y(u(_)("e2e.password.progress", { n: Ks.value.done, failed: Ks.value.failed })), 1)) : O("", !0),
                      Du.value ? (f(), h("p", Wre, y(Du.value), 1)) : O("", !0)
                    ]),
                    d("div", Yre, [
                      d("button", {
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        "data-testid": "e2e-rekey-resume",
                        disabled: Er.value,
                        onClick: Lw
                      }, y(Er.value ? u(_)("e2e.password.busy") : u(_)("e2e.names.resume")), 9, Gre)
                    ])
                  ])) : O("", !0),
                  Yn.value && Tm.value ? (f(), Ge(u(i), {
                    key: 9,
                    locale: j.value,
                    state: Tm.value,
                    onSettings: s[17] || (s[17] = (Ee) => Bi.value = !0),
                    onLock: $m,
                    onTakeOver: s[18] || (s[18] = (Ee) => u(B).takeOver(Ct.value)),
                    onContinue: s[19] || (s[19] = (Ee) => u(B).continueFromShown(Ct.value)),
                    onDismiss: s[20] || (s[20] = (Ee) => u(B).dismiss(Ct.value))
                  }, null, 8, ["locale", "state"])) : O("", !0),
                  Yn.value && !Tm.value ? (f(), h("div", Xre, [
                    d("span", {
                      class: "fe-e2e-strip__icon",
                      "aria-hidden": "true",
                      innerHTML: u(zt)("lock")
                    }, null, 8, Jre),
                    d("span", Zre, y(u(_)("e2e.strip.label")), 1),
                    d("span", Qre, y(Ew.value ? u(_)("e2e.level.names") : u(_)("e2e.level.content")), 1),
                    d("button", {
                      type: "button",
                      class: "fe-btn fe-e2e-strip__btn",
                      "data-testid": "e2e-settings-open",
                      disabled: Er.value || co.value,
                      onClick: s[21] || (s[21] = (Ee) => Bi.value = !0)
                    }, y(u(_)("e2e.settings.open")), 9, ese),
                    d("button", {
                      type: "button",
                      class: "fe-btn fe-e2e-strip__btn",
                      onClick: $m
                    }, y(u(_)("e2e.strip.lock")), 1)
                  ])) : O("", !0),
                  Ft.value && !ot.value ? (f(), h("div", tse, [
                    d("p", nse, y(sC.value), 1),
                    zd.value ? (f(), h("p", ase, [
                      Ht(y(zd.value), 1),
                      Mo.value < As.value ? (f(), h("span", ise, " · " + y(cC.value), 1)) : O("", !0)
                    ])) : O("", !0),
                    Mo.value < As.value ? (f(), h("button", {
                      key: 1,
                      type: "button",
                      class: "fe-btn fe-trashbar__more",
                      "data-testid": "trash-more",
                      disabled: Md.value,
                      onClick: dC
                    }, y(u(_)("trash.show_more")), 9, ose)) : O("", !0),
                    ck.value ? (f(), h("p", rse, y(ck.value), 1)) : O("", !0),
                    zo.value ? (f(), h("button", {
                      key: 3,
                      type: "button",
                      class: "fe-btn fe-btn--danger fe-trashbar__action",
                      disabled: G.value.length === 0 || Ed.value,
                      "data-testid": "trash-empty",
                      onClick: lC
                    }, y(u(_)("trash.empty_action")), 9, sse)) : O("", !0)
                  ])) : O("", !0)
                ]),
                body: mt(() => [
                  Gd.value === "home" ? (f(), Ge(uY, {
                    key: 0,
                    storages: zh.value,
                    recent: Kb.value,
                    starred: Vb.value,
                    loading: Eh.value,
                    locale: j.value,
                    "match-names": u(q).matchNames,
                    "name-filter": ks.value.name ?? "",
                    "thumb-src": u(ie).src,
                    onOpenStorage: Yb,
                    onOpenNode: qa,
                    onContextNode: tm
                  }, null, 8, ["storages", "recent", "starred", "loading", "locale", "match-names", "name-filter", "thumb-src"])) : Gd.value === "drafts" ? (f(), Ge(wY, {
                    key: 1,
                    drafts: hh.value,
                    loading: vh.value,
                    limit: mh.value,
                    locale: j.value,
                    "name-filter": ks.value.name ?? "",
                    "match-names": u(q).matchNames,
                    "busy-key": lr.value,
                    onOpen: s[22] || (s[22] = (Ee) => Tb(Ee)),
                    onSave: ZA,
                    onDelete: QA
                  }, null, 8, ["drafts", "loading", "limit", "locale", "name-filter", "match-names", "busy-key"])) : Gd.value === "notfound" ? (f(), h("div", lse, [
                    s[116] || (s[116] = d("svg", {
                      class: "fe-state__art",
                      viewBox: "0 0 120 100",
                      width: "110",
                      height: "92",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true"
                    }, [
                      d("path", { d: "M18 36v42a6 6 0 0 0 6 6h72a6 6 0 0 0 6-6V44a6 6 0 0 0-6-6H62l-9-10H24a6 6 0 0 0-6 6z" }),
                      d("path", { d: "M52 55c0-4.6 3.6-8 8-8s8 3.4 8 8c0 5.5-8 4.8-8 11" }),
                      d("circle", {
                        cx: "60",
                        cy: "73",
                        r: "1.6",
                        fill: "currentColor",
                        stroke: "none"
                      })
                    ], -1)),
                    d("p", use, y(u(_)("notFound.title")), 1),
                    d("p", cse, y(Ce.value), 1),
                    d("p", dse, y(u(_)("notFound.desc")), 1),
                    d("div", fse, [
                      d("button", {
                        type: "button",
                        class: "fe-btn",
                        onClick: oC
                      }, y(u(_)("notFound.goRoot")), 1)
                    ])
                  ])) : (f(), Ge(OT, {
                    key: 3,
                    locale: j.value,
                    busy: Zd.value,
                    error: km.value,
                    onUnlock: Wz,
                    onRecovery: _w
                  }, null, 8, ["locale", "busy", "error"]))
                ]),
                empty: mt(() => [
                  Et.value ? (f(), h("div", pse, [
                    s[117] || (s[117] = d("svg", {
                      class: "fe-state__art",
                      viewBox: "0 0 120 100",
                      width: "110",
                      height: "92",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true"
                    }, [
                      d("circle", {
                        cx: "52",
                        cy: "44",
                        r: "22"
                      }),
                      d("path", { d: "M68 61l20 20" }),
                      d("path", { d: "M46 38l12 12M58 38l-12 12" })
                    ], -1)),
                    d("p", hse, y(u(_)("empty.search.title")), 1),
                    d("p", mse, y(u(_)("empty.search.hint")), 1)
                  ])) : bt.value && bt.value !== "trash" ? (f(), h("div", {
                    key: 1,
                    class: "fe-state",
                    "data-testid": `empty-${bt.value}`
                  }, [
                    (f(), h("svg", yse, [
                      bt.value === "recent" ? (f(), h(Te, { key: 0 }, [
                        s[118] || (s[118] = d("circle", {
                          cx: "60",
                          cy: "50",
                          r: "28"
                        }, null, -1)),
                        s[119] || (s[119] = d("path", { d: "M60 32v18l12 8" }, null, -1))
                      ], 64)) : bt.value === "starred" ? (f(), h("path", gse)) : bt.value === "tag" ? (f(), h(Te, { key: 2 }, [
                        s[120] || (s[120] = d("path", { d: "M30 30h24l32 32-24 24-32-32z" }, null, -1)),
                        s[121] || (s[121] = d("circle", {
                          cx: "43",
                          cy: "43",
                          r: "4.5"
                        }, null, -1))
                      ], 64)) : (f(), h(Te, { key: 3 }, [
                        s[122] || (s[122] = d("circle", {
                          cx: "84",
                          cy: "34",
                          r: "9"
                        }, null, -1)),
                        s[123] || (s[123] = d("circle", {
                          cx: "36",
                          cy: "52",
                          r: "9"
                        }, null, -1)),
                        s[124] || (s[124] = d("circle", {
                          cx: "84",
                          cy: "70",
                          r: "9"
                        }, null, -1)),
                        s[125] || (s[125] = d("path", { d: "M44.5 47.5l31-9M44.5 56.5l31 9" }, null, -1))
                      ], 64))
                    ])),
                    d("p", bse, y(bt.value === "tag" ? u(_)("empty.tag.title", { tag: rn.value }) : u(_)(`empty.${bt.value}.title`)), 1),
                    d("p", kse, y(bt.value === "tag" ? u(_)("empty.tag.hint") : u(_)(`empty.${bt.value}.hint`)), 1)
                  ], 8, vse)) : Ft.value ? (f(), h("div", wse, [
                    s[126] || (s[126] = d("svg", {
                      class: "fe-state__art",
                      viewBox: "0 0 120 100",
                      width: "110",
                      height: "92",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true"
                    }, [
                      d("path", { d: "M38 34l4 48a6 6 0 0 0 6 5.6h24a6 6 0 0 0 6-5.6l4-48" }),
                      d("path", { d: "M32 34h56" }),
                      d("path", { d: "M50 34v-6a6 6 0 0 1 6-6h8a6 6 0 0 1 6 6v6" }),
                      d("path", {
                        d: "M52 44v32M60 44v32M68 44v32",
                        opacity: "0.5"
                      })
                    ], -1)),
                    d("p", _se, y(u(_)("empty.trash.title")), 1),
                    d("p", xse, y(u(_)("empty.trash.hint")), 1)
                  ])) : (f(), h("div", Sse, [
                    (f(), h("svg", $se, [
                      s[128] || (s[128] = d("path", { d: "M18 36v42a6 6 0 0 0 6 6h72a6 6 0 0 0 6-6V44a6 6 0 0 0-6-6H62l-9-10H24a6 6 0 0 0-6 6z" }, null, -1)),
                      Sd.value ? (f(), h("g", Tse, [...s[127] || (s[127] = [
                        d("path", {
                          d: "M60 50v14",
                          "stroke-dasharray": "3 4"
                        }, null, -1),
                        d("path", { d: "M53 59l7 8 7-8" }, null, -1)
                      ])])) : O("", !0)
                    ])),
                    d("p", Ase, y(u(_)("empty.folder")), 1),
                    Sd.value ? (f(), h("p", Ese, y(u(_)("empty.hint")), 1)) : O("", !0),
                    Sd.value ? (f(), h("div", Cse, [
                      d("button", {
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        onClick: Oo
                      }, y(u(_)("empty.upload")), 1)
                    ])) : O("", !0)
                  ]))
                ]),
                _: 1
              }, 8, ["api", "locale", "theme", "focused", "path", "root-path", "floor", "multi-root", "rows", "loading", "error", "order", "view-mode", "view-modes", "open-trigger", "show-crumbs", "filter-mode", "find-label", "show-view-switcher", "folder-key", "show-parent-path", "trash", "clipped", "extra-filters", "extra-filters-on-server", "can-write", "can-paste", "selected", "filters", "thumb-src", "folder-previews", "keep-badge-for", "starred-ids", "star-overrides", "star-enabled", "api-base", "auth-headers", "auth-credentials", "e2e-active", "body-override"]),
              Ls.value && so.value ? (f(), Ge($0, {
                ref_key: "splitPaneRef",
                ref: Zt,
                key: "split-" + u(vm),
                "pane-id": "split",
                "self-driven": "",
                closable: "",
                api: Fe,
                locale: j.value,
                theme: wn.value,
                focused: An.value,
                path: so.value.path,
                qualify: Rt,
                "to-user": Di,
                clamp: rw,
                "root-path": u(ft),
                floor: u(gt),
                "multi-root": Sn.value,
                "virtual-rows": rk,
                "trash-visible": e.config.trashVisible !== !1,
                "nav-offers-trash": Mb.value,
                "view-mode": tw.value,
                "view-modes": Sh.value,
                "open-trigger": L.config.openTrigger,
                clipped: dm.value,
                "can-write": li.value,
                "can-paste": !!ze.value.mode,
                selected: u(qn).selected.value,
                filters: Su.value,
                "folder-key": Az.value,
                "thumb-src": u(ie).src,
                "folder-previews": ((de = Ke.value) == null ? void 0 : de.folder_previews) !== !1,
                "keep-badge-for": ci.value ? kk : void 0,
                "starred-ids": bb.value,
                "star-overrides": ss.value,
                "star-enabled": gs.value,
                "api-base": L.config.apiBase ?? "",
                "auth-headers": () => Qn(),
                "auth-credentials": u(q).credentialsMode(),
                onActivate: s[33] || (s[33] = (Ee) => pi.value = "split"),
                onClose: Cz,
                onNavigate: zz,
                onOpen: qa,
                onOpenTrash: Pz,
                onClickRow: s[34] || (s[34] = (Ee, Gn) => Pk("split", Ee, Gn)),
                onContext: s[35] || (s[35] = (Ee, Gn) => Sk("split", Ee, Gn)),
                onClearSelection: s[36] || (s[36] = (Ee) => u(qn).clear()),
                onDisplayOrder: s[37] || (s[37] = (Ee) => xu.value = Ee),
                onItemDragStart: s[38] || (s[38] = (Ee, Gn) => Ok("split", Ee, Gn)),
                onItemDropInto: Hk,
                onTransfer: dw,
                "onUpdate:viewMode": nw,
                "onUpdate:filters": s[39] || (s[39] = (Ee) => Su.value = Ee),
                onCopyPath: Kd,
                onCrumbDrop: Kk,
                onNewFolder: s[40] || (s[40] = (Ee) => sa.value = !0),
                onUpload: Oo,
                onPaste: s[41] || (s[41] = (Ee) => Jh("paste")),
                onSelectAll: s[42] || (s[42] = (Ee) => u(qn).selectAll()),
                onClearFilters: s[43] || (s[43] = (Ee) => Su.value = { ...u(jo) }),
                onStarChange: kb
              }, null, 8, ["api", "locale", "theme", "focused", "path", "root-path", "floor", "multi-root", "trash-visible", "nav-offers-trash", "view-mode", "view-modes", "open-trigger", "clipped", "can-write", "can-paste", "selected", "filters", "folder-key", "thumb-src", "folder-previews", "keep-badge-for", "starred-ids", "star-overrides", "star-enabled", "api-base", "auth-headers", "auth-credentials"])) : O("", !0)
            ])
          ]),
          Ra.value ? (f(), Ge(U9, {
            key: 2,
            api: $t,
            nodes: ow.value,
            "dir-label": Uz.value,
            "dir-count": Hz.value,
            "dir-perm": Kz.value,
            "held-in": Fz.value,
            locale: j.value,
            narrow: $a.value,
            "caller-admin": pa.value,
            sharing: Iz.value,
            "in-encrypted": Bz.value,
            "thumb-src": u(ie).src,
            "api-base": L.config.apiBase ?? "",
            "auth-headers": () => Qn(),
            "auth-credentials": u(q).credentialsMode(),
            "plugin-views": NA.value,
            theme: wn.value,
            storages: (L.config.storages ?? []).map((Ee) => Ee.name),
            "user-name": L.config.userName || "",
            onPluginOp: s[44] || (s[44] = (Ee) => Yl(Ee)),
            onPluginOpen: s[45] || (s[45] = (Ee) => dh(Ee.plugin, Ee.req)),
            onOpenTag: jA,
            onClose: Cb,
            onShareCreated: UE,
            onManagePermissions: YE,
            onToast: tt,
            onChanged: s[46] || (s[46] = () => {
              var Ee;
              return An.value ? void ((Ee = Zt.value) == null ? void 0 : Ee.reload()) : void wt();
            })
          }, null, 8, ["api", "nodes", "dir-label", "dir-count", "dir-perm", "held-in", "locale", "narrow", "caller-admin", "sharing", "in-encrypted", "thumb-src", "api-base", "auth-headers", "auth-credentials", "plugin-views", "theme", "storages", "user-name", "onOpenTag", "onShareCreated"])) : O("", !0),
          no.value && kh.value ? (f(), Ge(IV, {
            key: 3,
            client: u(gE),
            locale: j.value,
            selection: kE.value,
            narrow: $a.value,
            onClose: s[47] || (s[47] = (Ee) => no.value = !1),
            onChanged: s[48] || (s[48] = () => {
              var Ee;
              return An.value ? void ((Ee = Zt.value) == null ? void 0 : Ee.reload()) : void wt();
            })
          }, null, 8, ["client", "locale", "selection", "narrow"])) : O("", !0)
        ], 2),
        bs.value || ou.value ? (f(), h("div", {
          key: 0,
          class: "fe-overlay",
          "data-testid": "explorer-overlay",
          onClick: yt(hd, ["self"])
        }, [
          d("div", {
            class: "fe-overlay__card",
            onClick: s[49] || (s[49] = yt(() => {
            }, ["stop"]))
          }, [
            bs.value ? (f(), Ge(cJ, {
              key: 0,
              config: re.value,
              closable: "",
              onClose: hd,
              onError: zE
            }, null, 8, ["config"])) : (f(), h(Te, { key: 1 }, [
              d("header", zse, [
                d("h2", Mse, y(u(_)("sidenav.apikeys")), 1),
                d("button", {
                  type: "button",
                  class: "fe-overlay__close",
                  title: u(_)("overlay.close"),
                  "aria-label": u(_)("overlay.close"),
                  onClick: hd
                }, " × ", 8, Pse)
              ]),
              Ze(wT, {
                config: re.value,
                full: ""
              }, null, 8, ["config"])
            ], 64))
          ])
        ])) : O("", !0),
        Do.value ? (f(), h("div", Ose, [
          d("div", Lse, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(zt)("upload")
            }, null, 8, Dse),
            d("p", null, y(u(_)("dropzone.hint")), 1)
          ])
        ])) : O("", !0),
        Ze(eR, {
          jobs: jn.value,
          locale: j.value,
          center: u(_u),
          onCancel: cz,
          onDismiss: dz,
          onRetry: gz
        }, null, 8, ["jobs", "locale", "center"]),
        Ze(nR, {
          ops: u(De).ops.value,
          locale: j.value,
          center: u(_u),
          "output-mode-of": UA,
          "caller-admin": pa.value,
          onCancel: ZC,
          onDismiss: s[50] || (s[50] = (Ee) => u(De).dismiss(Ee)),
          onOpen: KA
        }, null, 8, ["ops", "locale", "center", "caller-admin"]),
        Ze(iQ, {
          center: u(_u),
          locale: j.value,
          narrow: $a.value
        }, null, 8, ["center", "locale", "narrow"]),
        $a.value && Sd.value ? (f(), h("button", {
          key: 2,
          type: "button",
          class: "fe-fab",
          title: u(_)("toolbar.upload"),
          "aria-label": u(_)("toolbar.upload"),
          onClick: Oo
        }, [...s[129] || (s[129] = [
          d("svg", {
            class: "fe-ficon",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.2",
            "stroke-linecap": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            d("path", { d: "M12 5v14M5 12h14" })
          ], -1)
        ])], 8, Rse)) : O("", !0),
        Cs.value ? (f(), h("div", Nse, [
          s[130] || (s[130] = d("span", {
            class: "fe-keep-strip__icon",
            "aria-hidden": "true"
          }, "⟳", -1)),
          d("span", Ise, y(zC.value), 1),
          wk.value !== null ? (f(), h("div", Bse, [
            d("div", {
              class: "fe-keep-strip__fill",
              style: Yt({ width: wk.value + "%" })
            }, null, 4)
          ])) : O("", !0)
        ])) : O("", !0),
        Ze(_l, {
          ref_key: "ctxRef",
          ref: Fh,
          locale: j.value,
          theme: wn.value,
          sheet: ik.value,
          actions: $k.value,
          onSelect: FC
        }, null, 8, ["locale", "theme", "sheet", "actions"]),
        Ze(u($), {
          open: Ql.value,
          locale: j.value,
          theme: wn.value,
          api: u(q),
          types: Sb.value,
          "current-path": Rt(Xe.value),
          storages: (L.config.storages ?? []).map((Ee) => Ee.name),
          "only-office-ready": !!rr.value,
          "drawio-ready": !!Jl.value,
          "can-configure": pa.value,
          "withheld-words": ((Se = Ke.value) == null ? void 0 : Se.newdoc_withheld) ?? null,
          drafts: sr.value,
          onClose: s[51] || (s[51] = (Ee) => Ql.value = !1),
          onOpenDrafts: nE,
          onCreated: qC,
          onError: s[52] || (s[52] = (Ee) => P("error", { message: Ee.message, context: { op: "newdoc" } }))
        }, null, 8, ["open", "locale", "theme", "api", "types", "current-path", "storages", "only-office-ready", "drawio-ready", "can-configure", "withheld-words", "drafts"]),
        Ze(Fae, {
          open: sa.value,
          locale: j.value,
          "encrypted-option": hw.value === "allowed",
          "encrypted-request": hw.value === "request",
          busy: u(cE),
          error: u(dE),
          onClose: s[53] || (s[53] = (Ee) => sa.value = !1),
          onSubmit: QC,
          onEncrypted: s[54] || (s[54] = (Ee) => {
            sa.value = !1, yr.value = !0;
          }),
          onRequestEncrypted: jz
        }, null, 8, ["open", "locale", "encrypted-option", "encrypted-request", "busy", "error"]),
        Ze(u(k), {
          open: ld.value,
          locale: j.value,
          count: eu.value.length,
          "suggested-name": aE.value,
          "default-format": oE.value,
          "allowed-formats": tu.value,
          encryption: rE.value,
          busy: gh.value,
          "request-error": Ai.value,
          onClose: s[55] || (s[55] = (Ee) => ld.value = !1),
          onSubmit: YC
        }, null, 8, ["open", "locale", "count", "suggested-name", "default-format", "allowed-formats", "encryption", "busy", "request-error"]),
        Ze(Yae, {
          open: ur.value,
          locale: j.value,
          "archive-name": (($e = Ao.value) == null ? void 0 : $e.basename) || "",
          "suggested-folder": sE.value,
          busy: !!Ao.value && cr.value.has(Ao.value.path),
          error: Ai.value,
          onClose: s[56] || (s[56] = (Ee) => ur.value = !1),
          onSubmit: GC
        }, null, 8, ["open", "locale", "archive-name", "suggested-folder", "busy", "error"]),
        Ze(nie, {
          open: cs.value,
          locale: j.value,
          "archive-name": ((ut = dr.value) == null ? void 0 : ut.target.basename) || ((et = Ao.value) == null ? void 0 : et.basename) || "",
          busy: !!dr.value && cr.value.has(dr.value.target.path),
          error: ps.value,
          onClose: JC,
          onSubmit: XC
        }, null, 8, ["open", "locale", "archive-name", "busy", "error"]),
        Ze(zg, {
          open: ys.value,
          api: Fe,
          "vault-roots": mE.value,
          "vault-from": vE.value,
          locale: j.value,
          mode: ud.value,
          busy: dd.value,
          storages: (L.config.storages ?? []).map((Ee) => Ee.name),
          "start-at": Rt(An.value ? ((Pt = Zt.value) == null ? void 0 : Pt.getPath()) ?? "" : Xe.value),
          moving: ud.value === "move" ? cd.value.filter((Ee) => Ee.type === "dir").map((Ee) => Ee.path) : [],
          onClose: s[57] || (s[57] = (Ee) => ys.value = !1),
          onPick: jC
        }, null, 8, ["open", "api", "vault-roots", "vault-from", "locale", "mode", "busy", "storages", "start-at", "moving"]),
        Ze(u(T), {
          open: yr.value,
          locale: j.value,
          busy: gr.value,
          "escrow-kid": Wa.value,
          existing: $r.value ? $r.value.basename : null,
          "vault-available": ((En = Ke.value) == null ? void 0 : En.e2e_vault) === !0,
          onClose: s[58] || (s[58] = (Ee) => {
            yr.value = !1, $r.value = null;
          }),
          onSubmit: s[59] || (s[59] = (Ee) => $r.value ? gM(Ee) : eM(Ee))
        }, null, 8, ["open", "locale", "busy", "escrow-kid", "existing", "vault-available"]),
        Ze(lae, {
          open: !!br.value,
          locale: j.value,
          api: u(q),
          path: ((At = br.value) == null ? void 0 : At.path) ?? "",
          kind: ((Ya = br.value) == null ? void 0 : Ya.kind) ?? "folder",
          name: ((vn = br.value) == null ? void 0 : vn.name) ?? "",
          onClose: s[60] || (s[60] = (Ee) => br.value = null),
          onSent: qz
        }, null, 8, ["open", "locale", "api", "path", "kind", "name"]),
        Ze(u(z), {
          open: Ro.value,
          locale: j.value,
          "recovery-key": No.value,
          "folder-name": Io.value,
          "escrow-kid": Wa.value,
          variant: kr.value,
          onClose: CM
        }, null, 8, ["open", "locale", "recovery-key", "folder-name", "escrow-kid", "variant"]),
        Ze(u(E), {
          open: Bi.value,
          locale: j.value,
          level: nf.value,
          "can-raise": pM.value,
          "plain-named": hM.value,
          "escrow-state": xw.value === "n/a" || Bo.value ? "n/a" : xw.value,
          busy: co.value,
          onClose: s[61] || (s[61] = (Ee) => Bi.value = !1),
          onRaiseLevel: af,
          onFixNames: af,
          onChangePassword: kM,
          onEscrow: wM
        }, null, 8, ["open", "locale", "level", "can-raise", "plain-named", "escrow-state", "busy"]),
        Ze(u(R), {
          open: Us.value,
          locale: j.value,
          mode: Mm.value,
          "needs-rekey": xM.value,
          vault: nf.value === "vault",
          "has-recovery": u(K_)(on.value),
          "has-escrow": u(Xx)(on.value),
          busy: Lu.value,
          error: Ar.value,
          onClose: SM,
          onSubmit: $M
        }, null, 8, ["open", "locale", "mode", "needs-rekey", "vault", "has-recovery", "has-escrow", "busy", "error"]),
        Ze(u(D), {
          open: Qd.value,
          locale: j.value,
          "has-recovery": u(K_)(on.value),
          "escrow-state": u(Jx)(on.value, Wa.value),
          "escrow-kid": ((Fi = ($n = on.value) == null ? void 0 : $n.esc) == null ? void 0 : Fi.kid) || Wa.value,
          busy: _m.value,
          error: uo.value,
          onClose: s[62] || (s[62] = (Ee) => Qd.value = !1),
          onSubmit: rM
        }, null, 8, ["open", "locale", "has-recovery", "escrow-state", "escrow-kid", "busy", "error"]),
        Ze(u(U), {
          open: !!u(Mt).encryptTarget.value,
          locale: j.value,
          "file-name": ((Ga = u(Mt).encryptTarget.value) == null ? void 0 : Ga.basename) ?? "",
          busy: u(Mt).encryptBusy.value,
          error: u(Mt).encryptError.value,
          progress: u(Mt).encryptProgress.value,
          "escrow-kid": Wa.value,
          "can-purge": pa.value,
          "not-owner": !!u(Mt).encryptTarget.value && !u(jp)(u(Mt).encryptTarget.value),
          "owner-name": u(Mt).encryptTarget.value ? u(wg)(u(Mt).encryptTarget.value) : "",
          onClose: s[63] || (s[63] = (Ee) => u(Mt).closeEncrypt()),
          onSubmit: s[64] || (s[64] = (Ee) => u(Mt).submitEncrypt(Ee))
        }, null, 8, ["open", "locale", "file-name", "busy", "error", "progress", "escrow-kid", "can-purge", "not-owner", "owner-name"]),
        Ze(u(H), {
          open: !!u(Mt).unlockTarget.value,
          locale: j.value,
          intent: u(Mt).unlockIntent.value,
          "file-name": u(Mt).unlockTarget.value ? u(Mt).realName(u(Mt).unlockTarget.value.path) ?? u(Mt).unlockTarget.value.basename : "",
          known: !!u(Mt).unlockTarget.value && !!u(Mt).realName(u(Mt).unlockTarget.value.path),
          "has-recovery": u(Mt).unlockHasRecovery.value,
          busy: u(Mt).unlockBusy.value,
          error: u(Mt).unlockError.value,
          progress: u(Mt).unlockProgress.value,
          "needs-save": u(Mt).unlockNeedsSave.value,
          "escrow-state": u(Mt).unlockEscrow.value,
          "escrow-kid": u(Mt).unlockEscrowKid.value || Wa.value,
          onClose: s[65] || (s[65] = (Ee) => u(Mt).closeUnlock()),
          onSubmit: s[66] || (s[66] = (Ee) => u(Mt).submitUnlock(Ee))
        }, null, 8, ["open", "locale", "intent", "file-name", "known", "has-recovery", "busy", "error", "progress", "needs-save", "escrow-state", "escrow-kid"]),
        Ze(vne, {
          open: !!u(Mt).tooBig.value,
          locale: j.value,
          info: u(Mt).tooBig.value,
          onClose: s[67] || (s[67] = (Ee) => u(Mt).closeTooBig()),
          onDownload: EM
        }, null, 8, ["open", "locale", "info"]),
        Ze(u(R), {
          open: !!u(Mt).pwTarget.value,
          locale: j.value,
          mode: "change",
          subject: "file",
          "needs-rekey": !1,
          "has-recovery": !0,
          "has-escrow": !1,
          busy: u(Mt).pwBusy.value,
          error: u(Mt).pwError.value,
          onClose: s[68] || (s[68] = (Ee) => u(Mt).closePassword()),
          onSubmit: s[69] || (s[69] = (Ee) => u(Mt).submitPassword(Ee))
        }, null, 8, ["open", "locale", "busy", "error"]),
        Ze(pie, {
          open: to.value,
          locale: j.value,
          "current-name": ((sf = fr.value) == null ? void 0 : sf.basename) || "",
          error: u(uE),
          busy: u(lE),
          onClose: s[70] || (s[70] = (Ee) => to.value = !1),
          onSubmit: ez
        }, null, 8, ["open", "locale", "current-name", "error", "busy"]),
        Ze(ta, {
          open: hu.value,
          title: u(_)("trash.empty_confirm_title"),
          size: "sm",
          onClose: s[72] || (s[72] = (Ee) => hu.value = !1)
        }, {
          actions: mt(() => [
            d("button", {
              type: "button",
              class: "fe-btn",
              onClick: s[71] || (s[71] = (Ee) => hu.value = !1)
            }, y(u(_)("modal.delete.cancel")), 1),
            d("button", {
              type: "button",
              class: "fe-btn fe-btn--danger",
              "data-testid": "trash-empty-confirm",
              disabled: !Ts.value || Ts.value.count === 0,
              onClick: uC
            }, y(u(_)("trash.empty_action")), 9, Kse)
          ]),
          default: mt(() => [
            Ts.value ? (f(), h("p", Fse, y(Ts.value.summary), 1)) : Cd.value ? (f(), h("p", Use, y(Cd.value), 1)) : (f(), h("p", Hse, y(u(_)("trash.empty_counting")), 1))
          ]),
          _: 1
        }, 8, ["open", "title"]),
        Ze(yie, {
          open: ha.value,
          locale: j.value,
          count: u(oe).size.value,
          permanent: Ft.value || nM.value,
          busy: u(fE),
          error: u(pE),
          onClose: s[73] || (s[73] = (Ee) => ha.value = !1),
          onConfirm: nz
        }, null, 8, ["open", "locale", "count", "permanent", "busy", "error"]),
        Ze(u(r), {
          open: la.value,
          locale: j.value,
          file: pn.value,
          theme: wn.value,
          "preview-url": (Ee) => tf(Ee),
          "download-url": (Ee) => Yn.value || Tu.value || u(B).rootOf(Ee) ? tf(Ee) : u(q).downloadUrl(Ee),
          "only-office-base": an.value || Tu.value || Pu.value ? null : rr.value,
          "only-office-config-endpoint": xb.value,
          "can-configure": pa.value,
          "new-tab-enabled": !an.value && !Tu.value && !Pu.value,
          "save-text-endpoint": an.value || Tu.value || Pu.value ? null : u(q).endpoints.saveText || null,
          "archive-list-endpoint": Pu.value ? null : u(q).endpoints.archiveList || null,
          "open-mode": Ha.value,
          "open-as": hE.value,
          "auth-headers": () => Qn({ "Content-Type": "application/json" }),
          "auth-credentials": u(q).credentialsMode(),
          "drawio-url": Jl.value,
          "pdf-worker-url": L.config.pdfWorkerUrl || null,
          "pdf-save-url": L.config.pdfSaveUrl || null,
          "viewer-base-url": jk.value,
          index: hn.value.index,
          total: hn.value.total,
          "nav-enabled": hn.value.total > 1,
          "share-enabled": !an.value && !Tu.value && !Pu.value,
          onShare: s[74] || (s[74] = (Ee) => {
            const Gn = Ee ?? pn.value;
            Gn && (si.value = Gn, su.value = void 0, pr.value = !0);
          }),
          "api-base": L.config.apiBase ?? "",
          "drafts-endpoint": sr.value ? u(q).draftsBase : null,
          "app-viewer": fb.value,
          "app-e2e": Jz.value,
          "in-office": CA.value,
          api: u(q),
          "user-name": L.config.userName || "",
          storages: (L.config.storages ?? []).map((Ee) => Ee.name),
          onToast: tt,
          onOp: s[75] || (s[75] = (Ee) => Yl(Ee)),
          onNav: nn,
          onDraftSaved: eE,
          onDraftDiscarded: tE,
          onSaved: ae,
          onAppDirty: Gz,
          onClose: s[76] || (s[76] = (Ee) => la.value = !1)
        }, null, 8, ["open", "locale", "file", "theme", "preview-url", "download-url", "only-office-base", "only-office-config-endpoint", "can-configure", "new-tab-enabled", "save-text-endpoint", "archive-list-endpoint", "open-mode", "open-as", "auth-headers", "auth-credentials", "drawio-url", "pdf-worker-url", "pdf-save-url", "viewer-base-url", "index", "total", "nav-enabled", "share-enabled", "api-base", "drafts-endpoint", "app-viewer", "app-e2e", "in-office", "api", "user-name", "storages", "onAppDirty"]),
        Ze(Hie, {
          open: !!Da.value,
          locale: j.value,
          theme: wn.value,
          name: ((Nw = Da.value) == null ? void 0 : Nw.basename) ?? "",
          kind: OA.value,
          handlers: PA.value,
          current: LA.value,
          remembered: Da.value ? jl(Da.value) : null,
          onCancel: s[77] || (s[77] = (Ee) => Da.value = null),
          onOpen: DA
        }, null, 8, ["open", "locale", "theme", "name", "kind", "handlers", "current", "remembered"]),
        Ze(N0, {
          open: !!W.value,
          kind: "upload",
          locale: j.value,
          theme: wn.value,
          name: ((Iw = W.value) == null ? void 0 : Iw.name) ?? "",
          suggested: ((Bw = W.value) == null ? void 0 : Bw.suggested) ?? "",
          folder: ((Fw = W.value) == null ? void 0 : Fw.folder) ?? "",
          onCancel: s[78] || (s[78] = (Ee) => V(!1)),
          onConfirm: s[79] || (s[79] = (Ee) => V(!0))
        }, null, 8, ["open", "locale", "theme", "name", "suggested", "folder"]),
        Ze(N0, {
          open: !!u(eo).question.value,
          locale: j.value,
          theme: wn.value,
          name: ((Uw = u(eo).question.value) == null ? void 0 : Uw.name) ?? "",
          suggested: ((Hw = u(eo).question.value) == null ? void 0 : Hw.suggested) ?? "",
          folder: ((Kw = u(eo).question.value) == null ? void 0 : Kw.folder) ?? "",
          busy: u(eo).busy.value,
          error: u(eo).error.value,
          onCancel: u(eo).cancel,
          onConfirm: u(eo).confirm
        }, null, 8, ["open", "locale", "theme", "name", "suggested", "folder", "busy", "error", "onCancel", "onConfirm"]),
        La.value ? (f(), Ge(Pie, {
          key: `${La.value.plugin}/${La.value.view}`,
          api: u(q),
          locale: j.value,
          theme: wn.value,
          plugin: La.value.plugin,
          view: La.value.view,
          placement: La.value.placement,
          ui: La.value.ui,
          label: La.value.label,
          files: La.value.files,
          "user-name": L.config.userName || "",
          storages: (L.config.storages ?? []).map((Ee) => Ee.name),
          "start-at": Rt(An.value ? ((Vw = Zt.value) == null ? void 0 : Vw.getPath()) ?? "" : Xe.value),
          onClose: s[80] || (s[80] = (Ee) => La.value = null),
          onToast: tt,
          onOp: s[81] || (s[81] = (Ee) => Yl(Ee))
        }, null, 8, ["api", "locale", "theme", "plugin", "view", "placement", "ui", "label", "files", "user-name", "storages", "start-at"])) : O("", !0),
        In.value ? (f(), Ge(zie, {
          key: 5,
          open: TA.value,
          api: u(q),
          locale: j.value,
          theme: wn.value,
          plugin: In.value.plugin,
          view: In.value.view,
          surface: In.value.surface,
          path: In.value.path,
          paths: In.value.paths,
          size: In.value.size,
          label: In.value.label,
          storages: (L.config.storages ?? []).map((Ee) => Ee.name),
          "start-at": Rt(An.value ? ((jw = Zt.value) == null ? void 0 : jw.getPath()) ?? "" : Xe.value),
          onClose: s[82] || (s[82] = (Ee) => In.value = null),
          onOp: s[83] || (s[83] = (Ee) => Yl(Ee)),
          onToast: tt,
          onOpen: s[84] || (s[84] = (Ee) => {
            var Gn;
            return dh(((Gn = In.value) == null ? void 0 : Gn.plugin) ?? "", Ee);
          })
        }, null, 8, ["open", "api", "locale", "theme", "plugin", "view", "surface", "path", "paths", "size", "label", "storages", "start-at"])) : O("", !0),
        Ze(Q$, {
          open: !!Ti.value,
          locale: j.value,
          theme: wn.value,
          title: Ti.value ? u(Xt)(Ti.value.action.label, j.value) : "",
          message: Ti.value ? u(Xt)(Ti.value.action.confirm, j.value) : "",
          danger: ((qw = Ti.value) == null ? void 0 : qw.action.danger) === !0,
          onClose: s[85] || (s[85] = (Ee) => Ti.value = null),
          onConfirm: HA
        }, null, 8, ["open", "locale", "theme", "title", "message", "danger"]),
        pr.value && si.value ? (f(), Ge(u(v), {
          key: 6,
          api: u(q),
          path: si.value.path,
          "is-dir": si.value.type === "dir",
          locale: j.value,
          "share-max-ttl-days": SA.value,
          "initial-tab": su.value,
          "mail-ready": (Yw = (Ww = Ke.value) == null ? void 0 : Ww.mail) == null ? void 0 : Yw.ready,
          "can-configure": pa.value,
          perm: si.value.perm || ye.value,
          sharing: eC.value,
          onClose: s[86] || (s[86] = (Ee) => {
            pr.value = !1, su.value = void 0;
          })
        }, null, 8, ["api", "path", "is-dir", "locale", "share-max-ttl-days", "initial-tab", "mail-ready", "can-configure", "perm", "sharing"])) : O("", !0),
        Ze(Rr, { name: "fe-modal" }, {
          default: mt(() => [
            ls.value ? (f(), h("div", {
              key: 0,
              class: Re(["fe fe-modal__backdrop fe-recents__backdrop", {
                "fe--theme-light": wn.value === "light",
                "fe--theme-dark": wn.value === "dark"
              }]),
              onClick: s[90] || (s[90] = (Ee) => ls.value = !1)
            }, [
              d("div", {
                class: "fe-recents__panel",
                onClick: s[89] || (s[89] = yt(() => {
                }, ["stop"]))
              }, [
                d("div", Vse, [
                  d("strong", null, y(u(_)("recents.title")), 1),
                  d("button", {
                    class: "fe-recents__close",
                    "aria-label": u(_)("recents.close"),
                    onClick: s[87] || (s[87] = (Ee) => ls.value = !1)
                  }, "×", 8, jse)
                ]),
                Ze(U5, {
                  locale: j.value,
                  "api-base": L.config.apiBase ?? "",
                  "auth-headers": () => Qn(),
                  "auth-credentials": u(q).credentialsMode(),
                  limit: 20,
                  "refresh-key": yb.value,
                  onOpen: YA,
                  onContext: GA,
                  onError: s[88] || (s[88] = (Ee) => P("error", { message: Ee, context: { op: "recents" } }))
                }, null, 8, ["locale", "api-base", "auth-headers", "auth-credentials", "refresh-key"])
              ])
            ], 2)) : O("", !0)
          ]),
          _: 1
        }),
        Ze(Rr, { name: "fe-modal" }, {
          default: mt(() => [
            Gl.value && Xl.value && typeof Xl.value.id == "number" ? (f(), h("div", {
              key: 0,
              class: "fe-modal__backdrop",
              onClick: s[95] || (s[95] = (Ee) => Gl.value = !1)
            }, [
              d("div", {
                class: "fe-modal__card fe-modal__card--md",
                onClick: s[94] || (s[94] = yt(() => {
                }, ["stop"]))
              }, [
                d("header", qse, [
                  d("h2", Wse, y(u(_)("tags.title")) + " - " + y(Xl.value.basename), 1),
                  d("button", {
                    class: "fe-modal__close",
                    "aria-label": u(_)("tags.close"),
                    onClick: s[91] || (s[91] = (Ee) => Gl.value = !1)
                  }, "×", 8, Yse)
                ]),
                d("div", Gse, [
                  Ze(dx, {
                    "node-id": Xl.value.id,
                    locale: j.value,
                    "api-base": L.config.apiBase ?? "",
                    "auth-headers": () => Qn(),
                    "auth-credentials": u(q).credentialsMode(),
                    onOpen: s[92] || (s[92] = (Ee) => {
                    }),
                    onError: s[93] || (s[93] = (Ee) => P("error", { message: Ee, context: { op: "tags" } }))
                  }, null, 8, ["node-id", "locale", "api-base", "auth-headers", "auth-credentials"])
                ])
              ])
            ])) : O("", !0)
          ]),
          _: 1
        }),
        Ze(u(x), {
          open: ru.value,
          locale: j.value,
          theme: wn.value,
          "initial-query": Bb.value,
          "folder-label": Fb.value,
          "path-base": Rb.value,
          "content-search": OE.value,
          count: DE,
          "known-tags": Db.value,
          onClose: s[96] || (s[96] = (Ee) => ru.value = !1),
          onSubmit: NE
        }, null, 8, ["open", "locale", "theme", "initial-query", "folder-label", "path-base", "content-search", "known-tags"]),
        Ze(u(w), {
          "initial-query": Th.value,
          open: Od.value,
          locale: j.value,
          files: G.value,
          "view-mode": Pe.value,
          "can-write": li.value && !Qe.value && !Kt.value,
          "can-go-up": xt.value,
          "global-search": mC,
          "hit-can": gC,
          onClose: s[97] || (s[97] = (Ee) => Od.value = !1),
          onOpenHit: yC,
          onDownloadHit: kC,
          onDragHit: wC,
          onWarmHit: bC,
          onDropInside: _C,
          onOpenNode: qa,
          onNavigate: s[98] || (s[98] = (Ee) => wt(Ee)),
          onNewFolder: s[99] || (s[99] = (Ee) => sa.value = !0),
          onUpload: Oo,
          onToggleView: s[100] || (s[100] = (Ee) => aw(gm.value === "list" ? "grid" : gm.value === "grid" ? "gallery" : "list")),
          onOpenTrash: zi,
          onRefresh: lk,
          onGoUp: je,
          onOpenTheme: s[101] || (s[101] = (Ee) => Vd.value = !0),
          onOpenShortcutSettings: s[102] || (s[102] = (Ee) => wu.value = !0),
          onStartTour: s[103] || (s[103] = (Ee) => mm()),
          "split-enabled": $u.value,
          onTabNew: s[104] || (s[104] = (Ee) => ym()),
          onSplitToggle: s[105] || (s[105] = (Ee) => ew())
        }, null, 8, ["initial-query", "open", "locale", "files", "view-mode", "can-write", "can-go-up", "hit-can", "onOpenHit", "onDownloadHit", "onDragHit", "onWarmHit", "onDropInside", "onRefresh", "split-enabled"]),
        Ze(_J, {
          open: Ld.value,
          locale: j.value,
          onClose: s[106] || (s[106] = (Ee) => Ld.value = !1),
          onCustomize: s[107] || (s[107] = (Ee) => {
            Ld.value = !1, wu.value = !0;
          })
        }, null, 8, ["open", "locale"]),
        id.value ? (f(), Ge(u(c), {
          key: 7,
          modelValue: id.value,
          "onUpdate:modelValue": s[108] || (s[108] = (Ee) => id.value = Ee),
          host: xA
        }, null, 8, ["modelValue"])) : O("", !0),
        u(vt) ? (f(), Ge(Doe, {
          key: 8,
          feed: u(vt),
          locale: j.value,
          onOpen: un
        }, null, 8, ["feed", "locale"])) : O("", !0),
        Ze(mZ, {
          open: Vd.value,
          locale: j.value,
          theme: wn.value,
          dark: hm.value,
          current: u(jd),
          mode: u(ku),
          "host-mode": e.config.theme || "auto",
          onClose: s[109] || (s[109] = (Ee) => Vd.value = !1),
          onSelect: u(pz),
          onMode: s[110] || (s[110] = (Ee) => sb(Ee))
        }, null, 8, ["open", "locale", "theme", "dark", "current", "mode", "host-mode", "onSelect"]),
        d("input", {
          ref_key: "fileInputEl",
          ref: Eb,
          type: "file",
          multiple: "",
          class: "fe__file-input",
          onChange: az
        }, null, 544),
        Ze(Rr, { name: "fe-toast" }, {
          default: mt(() => [
            ma.value ? (f(), h("div", {
              key: 0,
              class: Re(["fe-toast", { "fe-toast--action": !!ma.value.actionLabel }]),
              role: "status",
              onClick: Hh
            }, [
              d("span", Xse, y(ma.value.message), 1),
              ma.value.actionLabel && ma.value.action ? (f(), h("button", {
                key: 0,
                type: "button",
                class: "fe-toast__action",
                onClick: yt(nC, ["stop"])
              }, y(ma.value.actionLabel), 1)) : O("", !0)
            ], 2)) : O("", !0)
          ]),
          _: 1
        }),
        Ze(u(p), {
          open: Q.value,
          locale: j.value,
          theme: wn.value,
          onClose: s[111] || (s[111] = (Ee) => Q.value = !1)
        }, null, 8, ["open", "locale", "theme"]),
        N.value ? (f(), Ge(u(m), {
          key: 9,
          open: tn.value,
          locale: j.value,
          theme: wn.value,
          chosen: u(U0)(),
          fallback: Lt.value,
          personal: pe.value,
          onPick: xa,
          onClose: s[112] || (s[112] = (Ee) => tn.value = !1)
        }, null, 8, ["open", "locale", "theme", "chosen", "fallback", "personal"])) : O("", !0),
        Ze(u(C), {
          open: wu.value,
          locale: j.value,
          theme: wn.value,
          onClose: s[113] || (s[113] = (Ee) => wu.value = !1)
        }, null, 8, ["open", "locale", "theme"]),
        Ze(u(l), {
          open: ro.value,
          locale: j.value,
          file: Li.value,
          theme: wn.value,
          "preview-url": (Ee) => tf(Ee),
          "download-url": (Ee) => Yn.value || u(B).rootOf(Ee) ? tf(Ee) : u(q).downloadUrl(Ee),
          "only-office-base": an.value ? null : rr.value,
          "only-office-config-endpoint": xb.value,
          "can-configure": pa.value,
          "auth-headers": () => Qn({ "Content-Type": "application/json" }),
          "auth-credentials": u(q).credentialsMode(),
          "drawio-url": Jl.value,
          "pdf-worker-url": L.config.pdfWorkerUrl || null,
          "viewer-base-url": jk.value,
          onClose: s[114] || (s[114] = (Ee) => ro.value = !1),
          onNav: vz,
          onOpenFull: yz
        }, null, 8, ["open", "locale", "file", "theme", "preview-url", "download-url", "only-office-base", "only-office-config-endpoint", "can-configure", "auth-headers", "auth-credentials", "drawio-url", "pdf-worker-url", "viewer-base-url"]),
        Ze(u(b), {
          open: qd.value,
          locale: j.value,
          root: Tn.value,
          theme: wn.value,
          onClose: bz
        }, null, 8, ["open", "locale", "root", "theme"])
      ], 42, are);
    };
  }
}), lle = "/web-apps/apps/api/documents/api.js", ule = "/?embed=1&proto=json", cle = 1e4;
function dle(e) {
  return e.trim().replace(/\/+$/, "");
}
function fle(e, t) {
  return new Promise((n) => {
    const a = document.createElement("script");
    let i = !1;
    const r = (c) => {
      i || (i = !0, clearTimeout(l), a.remove(), n(c));
    }, l = setTimeout(() => r("timeout"), t);
    a.async = !0, a.src = e, a.onload = () => r("load"), a.onerror = () => r("error"), document.head.appendChild(a);
  });
}
function ple(e, t) {
  return new Promise((n) => {
    let a = null;
    try {
      a = new URL(e, window.location.href).origin;
    } catch {
      a = null;
    }
    const i = document.createElement("iframe");
    i.setAttribute("aria-hidden", "true"), i.style.cssText = "position:absolute;inset-inline-start:-9999px;width:1px;height:1px;border:0";
    let r = !1;
    const l = (m) => {
      r || (r = !0, clearTimeout(p), window.removeEventListener("message", c), i.remove(), n(m));
    }, c = (m) => {
      if (a && m.origin !== a) return;
      let v = m.data;
      if (typeof v == "string")
        try {
          v = JSON.parse(v);
        } catch {
          return;
        }
      v && typeof v == "object" && v.event === "init" && l("ready");
    };
    window.addEventListener("message", c);
    const p = setTimeout(() => l("timeout"), t);
    i.src = e, document.body.appendChild(i);
  });
}
async function hle(e) {
  try {
    return await fetch(e, { mode: "no-cors", cache: "no-store" }), !0;
  } catch {
    return !1;
  }
}
const mle = {
  loadScript: fle,
  loadFramed: ple,
  reachable: hle,
  hasDocsAPI: () => {
    var e;
    return !!((e = window.DocsAPI) != null && e.DocEditor);
  },
  pageProtocol: () => window.location.protocol,
  now: () => typeof performance < "u" ? performance.now() : Date.now()
};
function vle(e, t) {
  const n = dle(t);
  return n ? e === "onlyoffice" ? n + lle : e === "drawio" ? n + ule : "" : "";
}
async function xhe(e, t, n = {}) {
  const a = { ...mle, ...n.deps ?? {} }, i = n.timeoutMs ?? cle, r = vle(e, t ?? ""), l = e === "onlyoffice" ? "script" : e === "drawio" ? "iframe" : "none";
  if (!r)
    return { service: e, state: "skipped", url: "", ms: 0, mechanism: l };
  if (a.pageProtocol() === "https:" && r.startsWith("http://"))
    return { service: e, state: "blocked-mixed-content", url: r, ms: 0, mechanism: l };
  const c = a.now(), p = () => Math.round(a.now() - c);
  if (l === "script") {
    const m = await a.loadScript(r, i);
    if (m === "timeout") return { service: e, state: "timeout", url: r, ms: p(), mechanism: l };
    if (m === "load")
      return {
        service: e,
        state: a.hasDocsAPI() ? "ok" : "wrong-content",
        url: r,
        ms: p(),
        mechanism: l
      };
    const v = await a.reachable(r);
    return {
      service: e,
      state: v ? "wrong-content" : "unreachable",
      url: r,
      ms: p(),
      mechanism: l
    };
  }
  if (l === "iframe") {
    if (await a.loadFramed(r, i) === "ready") return { service: e, state: "ok", url: r, ms: p(), mechanism: l };
    const v = await a.reachable(r);
    return {
      service: e,
      state: v ? "wrong-content" : "unreachable",
      url: r,
      ms: p(),
      mechanism: l
    };
  }
  return { service: e, state: "skipped", url: "", ms: 0, mechanism: l };
}
const Ay = "filex:remote-images";
function Q0() {
  return nr() && Qi().remoteImages === "on";
}
function yle() {
  return Fl() && nr();
}
function She(e) {
  Zi("remoteImages", e ? "on" : "");
  try {
    window.dispatchEvent(new CustomEvent(Ay, { detail: e }));
  } catch {
  }
}
const gle = {
  class: "fe-remote-ask",
  "data-testid": "remote-image-dialog"
}, ble = { class: "fe-remote-ask__text" }, kle = {
  class: "fe-remote-ask__host",
  dir: "ltr",
  "data-testid": "remote-image-host"
}, wle = {
  key: 0,
  class: "fe-remote-ask__hint",
  "data-testid": "remote-image-hint"
}, $he = /* @__PURE__ */ lt({
  __name: "RemoteImageDialog",
  props: {
    gate: {},
    locale: {},
    theme: {}
  },
  setup(e) {
    const t = e, { t: n } = ht(() => t.locale ?? "en"), a = A(() => t.gate.asking.value), i = A(() => !!a.value && yle());
    return (r, l) => (f(), Ge(ta, {
      open: !!a.value,
      title: u(n)("viewer.remote_image.title"),
      size: "sm",
      theme: e.theme,
      locale: String(e.locale ?? "en"),
      onClose: l[3] || (l[3] = (c) => e.gate.dismiss())
    }, {
      actions: mt(() => {
        var c, p, m, v;
        return [
          d("button", {
            type: "button",
            class: "fe-btn",
            "data-testid": "remote-image-cancel",
            onClick: l[0] || (l[0] = (x) => e.gate.dismiss())
          }, y(u(n)("common.cancel")), 1),
          (c = a.value) != null && c.whole || (((p = a.value) == null ? void 0 : p.others) ?? 0) > 0 ? (f(), h("button", {
            key: 0,
            type: "button",
            class: Re(["fe-btn", { "fe-btn--primary": (m = a.value) == null ? void 0 : m.whole }]),
            "data-testid": "remote-image-load-all",
            onClick: l[1] || (l[1] = (x) => e.gate.acceptAll())
          }, y(u(n)("viewer.remote_image.load_all")), 3)) : O("", !0),
          (v = a.value) != null && v.whole ? O("", !0) : (f(), h("button", {
            key: 1,
            type: "button",
            class: "fe-btn fe-btn--primary",
            "data-testid": "remote-image-load",
            onClick: l[2] || (l[2] = (x) => e.gate.accept())
          }, y(u(n)("viewer.remote_image.load")), 1))
        ];
      }),
      default: mt(() => {
        var c;
        return [
          d("div", gle, [
            d("p", ble, y(u(n)("viewer.remote_image.body")), 1),
            d("p", kle, y((c = a.value) == null ? void 0 : c.host), 1),
            i.value ? (f(), h("p", wle, y(u(n)("viewer.remote_image.setting_hint")), 1)) : O("", !0)
          ])
        ];
      }),
      _: 1
    }, 8, ["open", "title", "theme", "locale"]));
  }
}), cA = Symbol("fe-remote-images"), e2 = "[data-remote-image]";
function t2(e) {
  const t = es(e.getAttribute("data-remote-image") ?? "");
  if (!t) return null;
  if (e.namespaceURI === "http://www.w3.org/2000/svg") {
    const a = dT(e.ownerDocument, t.href, (r) => e.getAttribute(`data-remote-${r.toLowerCase()}`)), i = e.getAttribute("transform");
    return i && a.setAttribute("transform", i), e.replaceWith(a), a.querySelector("img");
  }
  const n = e.ownerDocument.createElement("img");
  n.setAttribute("referrerpolicy", "no-referrer");
  for (const a of sT) {
    const i = e.getAttribute(`data-remote-${a}`);
    i !== null && n.setAttribute(a, i);
  }
  return n.setAttribute("src", t.href), e.replaceWith(n), n;
}
function The(e = () => "en") {
  const { t } = ht(() => e() ?? "en"), n = S(null), a = S(Q0()), i = S(!1), r = /* @__PURE__ */ new Set(), l = [];
  function c() {
    const k = [];
    for (const b of l)
      b.value && k.push(...Array.from(b.value.querySelectorAll(e2)));
    return k;
  }
  function p(k) {
    for (const b of c())
      k(b.getAttribute("data-remote-image") ?? "") && t2(b);
  }
  function m(k) {
    return a.value || i.value || r.has(k);
  }
  function v(k) {
    const b = es(k.getAttribute("data-remote-image") ?? "");
    if (!b) return;
    if (m(b.href)) {
      t2(k);
      return;
    }
    const C = c().filter((T) => T.getAttribute("data-remote-image") !== b.href).length;
    n.value = { src: b.href, host: b.host, others: C };
  }
  function x(k) {
    const b = k.target, C = b && typeof b.closest == "function" ? b.closest(e2) : null, T = k.currentTarget;
    return C && (!T || typeof T.contains != "function" || T.contains(C)) ? C : null;
  }
  const w = () => {
    a.value = Q0();
  }, $ = Jc(w);
  return typeof window < "u" && window.addEventListener(Ay, w), Zo() && Tt(() => {
    $(), typeof window < "u" && window.removeEventListener(Ay, w);
  }), Je(a, (k) => {
    k && (n.value = null, p(() => !0));
  }), {
    asking: n,
    settingOn: a,
    allLoaded: A(() => a.value || i.value),
    askWhole(k) {
      const b = k.map((C) => es(C)).find((C) => !!C);
      !b || a.value || i.value || (n.value = { src: b.href, host: b.host, others: Math.max(0, k.length - 1), whole: !0 });
    },
    policy: () => ({ label: t("viewer.remote_image.label"), load: m }),
    watchRoot(k) {
      l.push(k);
    },
    onClick(k) {
      const b = x(k);
      b && (k.preventDefault(), k.stopPropagation(), v(b));
    },
    onKeydown(k) {
      if (k.key !== "Enter" && k.key !== " ") return;
      const b = x(k);
      b && (k.preventDefault(), k.stopPropagation(), v(b));
    },
    accept() {
      const k = n.value;
      n.value = null, k && (r.add(k.src), p((b) => b === k.src));
    },
    acceptAll() {
      n.value = null, i.value = !0, p(() => !0);
    },
    dismiss() {
      n.value = null;
    },
    reset() {
      n.value = null, i.value = !1, r.clear();
    }
  };
}
function Ahe(e) {
  Wo(cA, e);
}
function Ehe() {
  return Zo() ? bi(cA, null) : null;
}
function Che(e) {
  return e ? e.replace(/diagnose$/, "session") : null;
}
async function zhe(e, t, n) {
  try {
    const a = await e(t, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "state", ...n })
    });
    if (!a.ok) return null;
    const i = await a.json();
    return { stale: i.stale === !0, known: i.known === !0 };
  } catch {
    return null;
  }
}
function Mhe(e, t) {
  return e || t.pending ? "ask" : "reload";
}
function Phe(e, t) {
  return /(^|\/|:\/\/)\.filex-open\//.test(e) ? t.replace(/^[0-9a-f]{12}-/, "") : t;
}
const _le = {
  viewBox: "0 0 32 32",
  "aria-hidden": "true"
}, n2 = /* @__PURE__ */ lt({
  __name: "LogoMark",
  setup(e) {
    return (t, n) => (f(), h("svg", _le, [...n[0] || (n[0] = [
      d("rect", {
        width: "32",
        height: "32",
        rx: "7",
        fill: "var(--fe-primary, #2f6ceb)"
      }, null, -1),
      d("path", {
        d: "M7 11a2 2 0 0 1 2-2h5l2 2h7a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V11z",
        fill: "none",
        stroke: "#fff",
        "stroke-width": "1.8",
        "stroke-linejoin": "round"
      }, null, -1),
      d("path", {
        d: "M11.5 17.5l3 2.5 5.5-6",
        fill: "none",
        stroke: "#fff",
        "stroke-width": "1.8",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)
    ])]));
  }
});
function Ohe(e) {
  return e.trim().toLowerCase();
}
const xle = 250;
function Lhe(e, t = xle) {
  let n = 0, a = null;
  return (i) => {
    const r = ++n;
    return a && (clearTimeout(a.timer), a.resolve(null), a = null), new Promise((l) => {
      a = { timer: setTimeout(() => {
        a = null, e(i).then(
          (p) => l(r === n ? p ?? {} : null),
          () => l(null)
        );
      }, t), resolve: l };
    });
  };
}
function Dhe(e) {
  var n;
  let t = (n = e == null ? void 0 : e.response) == null ? void 0 : n.data;
  if (!t) {
    const a = e == null ? void 0 : e.detail;
    if (typeof a == "string" && a.trim().startsWith("{"))
      try {
        t = JSON.parse(a);
      } catch {
        t = void 0;
      }
  }
  return !t || typeof t.field != "string" || typeof t.message != "string" ? null : { field: t.field, message: t.message };
}
async function Sle(e, { maxPx: t, maxBytes: n }) {
  const a = await $le(e), i = Math.min(a.width, a.height), r = Math.min(t, i), l = document.createElement("canvas");
  l.width = r, l.height = r;
  const c = l.getContext("2d");
  if (!c) throw new Error("canvas unavailable");
  c.fillStyle = "#ffffff", c.fillRect(0, 0, r, r), c.drawImage(
    a,
    (a.width - i) / 2,
    (a.height - i) / 2,
    i,
    i,
    0,
    0,
    r,
    r
  );
  for (const p of [0.85, 0.7, 0.55, 0.4]) {
    const m = l.toDataURL("image/jpeg", p);
    if (m.length <= n) return m;
  }
  if (r > 64)
    return Sle(e, { maxPx: Math.floor(r / 2), maxBytes: n });
  throw new Error("image too large");
}
async function $le(e) {
  if (typeof createImageBitmap == "function")
    return createImageBitmap(e);
  const t = URL.createObjectURL(e);
  try {
    return await new Promise((n, a) => {
      const i = new Image();
      i.onload = () => n(i), i.onerror = () => a(new Error("decode failed")), i.src = t;
    });
  } finally {
    URL.revokeObjectURL(t);
  }
}
const Rhe = [
  "file.uploaded",
  "file.updated",
  "file.upload_failed",
  "file.infected",
  "file.deleted",
  "file.trashed",
  "file.moved",
  "archive.created",
  "archive.extracted",
  "share.created",
  "drop.received",
  "comment.added",
  "e2e.escrow_used",
  "e2e.password_changed",
  "e2e.request_created",
  "e2e.request_decided",
  "plugin.notice",
  // One person's held notifications, told together (backend notify/digest.go).
  // A target receives it only when it ticks it; the person's own switch mutes
  // their digests, and it has no "urgent" switch of its own (DIGEST_EVENT).
  "notification.digest"
], Nhe = "notification.digest";
function dA(e) {
  return e.replace(/\./g, "_");
}
function Ihe(e) {
  return `webhooks.events.${dA(e)}`;
}
function Bhe(e) {
  return `userSettings.notifications.events.${dA(e)}`;
}
const Tle = "filex.notify.push";
function a2(e) {
  const t = e.replace(/-/g, "+").replace(/_/g, "/").replace(/=+$/, ""), n = t + "=".repeat((4 - t.length % 4) % 4), a = atob(n), i = new Uint8Array(a.length);
  for (let r = 0; r < a.length; r++) i[r] = a.charCodeAt(r);
  return i;
}
const Ale = [
  [/Edg(e|A|iOS)?\//, "Edge"],
  [/OPR\/|Opera/, "Opera"],
  [/SamsungBrowser\//, "Samsung Internet"],
  [/Firefox\/|FxiOS\//, "Firefox"],
  [/Chrome\/|CriOS\//, "Chrome"],
  [/Safari\//, "Safari"]
], Ele = [
  [/iPhone/, "iPhone"],
  [/iPad/, "iPad"],
  [/Android/, "Android"],
  [/CrOS/, "ChromeOS"],
  [/Windows/, "Windows"],
  [/Mac OS X|Macintosh/, "macOS"],
  [/Linux/, "Linux"]
];
function Cle(e) {
  const t = (n) => {
    var a;
    return ((a = n.find(([i]) => i.test(e))) == null ? void 0 : a[1]) ?? "";
  };
  return [t(Ale), t(Ele)].filter(Boolean).join(" · ");
}
async function zle(e) {
  const t = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(e));
  return Array.from(new Uint8Array(t), (n) => n.toString(16).padStart(2, "0")).join("");
}
function Mle() {
  try {
    return typeof localStorage > "u" ? null : localStorage;
  } catch {
    return null;
  }
}
function i2(e, t) {
  var i;
  const n = (i = e.options) == null ? void 0 : i.applicationServerKey;
  if (!n) return !1;
  const a = new Uint8Array(n);
  if (a.length !== t.length) return !1;
  for (let r = 0; r < t.length; r++) if (a[r] !== t[r]) return !1;
  return !0;
}
function Ple(e, t) {
  var a, i;
  const n = e.toJSON();
  return {
    endpoint: n.endpoint ?? e.endpoint,
    keys: { p256dh: ((a = n.keys) == null ? void 0 : a.p256dh) ?? "", auth: ((i = n.keys) == null ? void 0 : i.auth) ?? "" },
    label: t
  };
}
async function Ole(e) {
  if (!e || !e.pushManager) return null;
  if (e.active) return e;
  const t = e.installing ?? e.waiting;
  return t ? (await new Promise((n) => {
    const a = setTimeout(n, 1e4);
    t.addEventListener("statechange", () => {
      t.state === "activated" && (clearTimeout(a), n());
    });
  }), e.active ? e : null) : null;
}
function Fhe(e, t) {
  const n = t.storage === void 0 ? Mle() : t.storage, a = t.userId ? `${Tle}.${t.userId}` : "", i = t.sha256 ?? zle, r = t.userAgent ?? (typeof navigator > "u" ? "" : navigator.userAgent ?? "");
  let l = null;
  const c = () => t.notification !== void 0 ? t.notification : typeof window < "u" && "Notification" in window ? window.Notification : null, p = () => t.supported ? t.supported() : typeof window < "u" && "PushManager" in window && typeof navigator < "u" && "serviceWorker" in navigator && c() !== null, m = () => {
    const D = c();
    return !D || !p() ? "unsupported" : D.permission ?? "default";
  }, v = () => {
    if (!a || !n) return !1;
    try {
      return n.getItem(a) === "1";
    } catch {
      return !1;
    }
  }, x = (D) => {
    if (!(!a || !n))
      try {
        D ? n.setItem(a, "1") : n.removeItem(a);
      } catch {
      }
  }, w = async () => {
    try {
      l = await e.status();
    } catch {
      l = null;
    }
    return l;
  }, $ = async () => {
    if (!p()) return null;
    try {
      const D = await t.registration();
      return D != null && D.pushManager ? await D.pushManager.getSubscription() : null;
    } catch {
      return null;
    }
  }, k = async (D) => {
    const U = await Ole(await t.registration());
    if (!U) throw new Error("no service worker");
    const H = a2(D);
    let L = await U.pushManager.getSubscription();
    L && !i2(L, H) && (await L.unsubscribe().catch(() => !1), L = null), L || (L = await U.pushManager.subscribe({ userVisibleOnly: !0, applicationServerKey: H })), await e.subscribe(Ple(L, Cle(r)));
  };
  async function b() {
    var P;
    const D = await w();
    let U = null;
    const H = D ? await $() : null;
    if (H && D)
      try {
        const K = await i(H.endpoint);
        U = ((P = D.devices.find((N) => N.endpoint_hash === K)) == null ? void 0 : P.id) ?? null;
      } catch {
        U = null;
      }
    const L = m();
    return { supported: p(), permission: L, status: D, on: U !== null && L === "granted", thisDevice: U };
  }
  async function C() {
    const D = c();
    if (!D || !p()) return b();
    let U = D.permission;
    if (U === "default") {
      const L = await Promise.resolve(D.requestPermission());
      U = typeof L == "string" ? L : D.permission;
    }
    if (U !== "granted") return b();
    const H = l ?? await w();
    return !(H != null && H.available) || !H.public_key || (await k(H.public_key), x(!0)), b();
  }
  async function T() {
    x(!1);
    const D = await $();
    return D && (await e.forget(D.endpoint).catch(() => {
    }), await D.unsubscribe().catch(() => !1)), b();
  }
  async function E(D) {
    const U = await b();
    if (await e.remove(D), U.thisDevice === D) {
      x(!1);
      const H = await $();
      await (H == null ? void 0 : H.unsubscribe().catch(() => !1));
    }
    return b();
  }
  async function R() {
    if (!v() || m() !== "granted") return;
    const D = await w();
    if (!(!(D != null && D.available) || !D.public_key))
      try {
        const U = await $();
        if (U && i2(U, a2(D.public_key))) {
          const H = await i(U.endpoint);
          if (D.devices.some((L) => L.endpoint_hash === H)) return;
        }
        await k(D.public_key);
      } catch {
      }
  }
  async function z() {
    const D = await $();
    D && (await e.forget(D.endpoint).catch(() => {
    }), await D.unsubscribe().catch(() => !1));
  }
  return {
    state: b,
    enable: C,
    disable: T,
    remove: E,
    test: () => e.test(),
    reconcile: R,
    forgetDevice: z
  };
}
function Or(e) {
  return !e.sections && typeof e.href == "string";
}
function Lle(e) {
  const t = [];
  for (const n of e) {
    if (Or(n)) {
      t.push(n);
      continue;
    }
    const a = (n.sections ?? []).filter((i) => i.items.length > 0);
    a.length > 0 && t.push({ ...n, sections: a });
  }
  return t;
}
function Dle(e) {
  return Or(e) ? e.active === !0 : (e.sections ?? []).some((t) => t.items.some((n) => n.active === !0));
}
function Rle(e, t, n) {
  if (n <= 0) return null;
  switch (e) {
    case "ArrowDown":
      return Math.min(t + 1, n - 1);
    case "ArrowUp":
      return Math.max(t - 1, 0);
    case "Home":
      return 0;
    case "End":
      return n - 1;
    default:
      return null;
  }
}
function Nle(e, t, n, a = "ltr") {
  if (n <= 0) return null;
  const i = qf(e, a);
  return i !== 0 ? (t + i + n) % n : e === "Home" ? 0 : e === "End" ? n - 1 : null;
}
function Ile(e) {
  return e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey && !e.defaultPrevented;
}
const Ble = ["aria-label"], Fle = {
  key: 0,
  class: "fx-mega__bar"
}, Ule = ["href", "aria-current", "data-mega-top", "data-testid", "onClick", "onKeydown"], Hle = ["aria-expanded", "aria-controls", "data-mega-top", "data-testid", "onClick", "onKeydown"], Kle = ["id", "data-mega-panel", "data-testid", "onKeydown"], Vle = ["data-testid"], jle = ["id"], qle = ["aria-labelledby"], Wle = ["href", "aria-current", "data-testid", "onClick"], Yle = {
  class: "fx-mega__icon",
  "aria-hidden": "true"
}, Gle = ["innerHTML"], Xle = { class: "fx-mega__text" }, Jle = { class: "fx-mega__label" }, Zle = {
  key: 0,
  class: "fx-mega__hint"
}, Qle = {
  key: 1,
  class: "fx-mega__list"
}, eue = ["href", "aria-current", "data-testid", "onClick"], tue = {
  class: "fx-mega__icon",
  "aria-hidden": "true"
}, nue = { class: "fx-mega__text" }, aue = { class: "fx-mega__label" }, iue = ["aria-labelledby", "data-testid"], oue = ["id"], rue = ["data-testid"], sue = ["id"], lue = ["aria-labelledby"], uue = ["href", "aria-current", "data-testid", "onClick"], cue = {
  class: "fx-mega__icon",
  "aria-hidden": "true"
}, due = ["innerHTML"], fue = { class: "fx-mega__text" }, pue = { class: "fx-mega__label" }, Uhe = /* @__PURE__ */ lt({
  __name: "MegaMenu",
  props: {
    entries: {},
    label: {},
    mode: { default: "bar" }
  },
  emits: ["navigate"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = `fx-mega-${Math.random().toString(36).slice(2, 10)}`, r = A(() => Lle(n.entries)), l = S(null), c = S(null), p = (U) => `${i}-${U.id}`, m = (U, H) => `${i}-${U.id}-${H}`;
    function v() {
      c.value = null;
    }
    function x(U) {
      c.value = c.value === U ? null : U;
    }
    function w() {
      var U;
      return Array.from(((U = l.value) == null ? void 0 : U.querySelectorAll("[data-mega-top]")) ?? []);
    }
    function $(U) {
      var L;
      const H = (L = l.value) == null ? void 0 : L.querySelector(`[data-mega-panel="${U}"]`);
      return Array.from((H == null ? void 0 : H.querySelectorAll("a.fx-mega__item")) ?? []);
    }
    function k(U) {
      var H;
      return ((H = l.value) == null ? void 0 : H.querySelector(`[data-mega-top="${U}"]`)) ?? null;
    }
    async function b(U, H) {
      var P;
      c.value = U, await Gt();
      const L = $(U);
      (P = H === "first" ? L[0] : L[L.length - 1]) == null || P.focus();
    }
    function C(U, H, L) {
      var N;
      const P = w(), K = Nle(U.key, H, P.length, ei(l.value));
      if (K !== null) {
        U.preventDefault(), v(), (N = P[K]) == null || N.focus();
        return;
      }
      Or(L) || (U.key === "ArrowDown" ? (U.preventDefault(), b(L.id, "first")) : U.key === "ArrowUp" ? (U.preventDefault(), b(L.id, "last")) : U.key === "Escape" && c.value === L.id && (U.preventDefault(), v()));
    }
    function T(U, H) {
      var N, J, j;
      if (U.key === "Escape") {
        U.preventDefault(), U.stopPropagation(), v(), (N = k(H.id)) == null || N.focus();
        return;
      }
      const L = $(H.id), P = L.indexOf(document.activeElement);
      if (P < 0) return;
      if (U.key === "ArrowUp" && P === 0) {
        U.preventDefault(), (J = k(H.id)) == null || J.focus();
        return;
      }
      const K = Rle(U.key, P, L.length);
      K !== null && (U.preventDefault(), (j = L[K]) == null || j.focus());
    }
    function E(U, H) {
      !H.href || !Ile(U) || (U.preventDefault(), v(), a("navigate", { id: H.id, href: H.href }));
    }
    function R(U) {
      const H = U.relatedTarget;
      H && l.value && !l.value.contains(H) && v();
    }
    function z(U) {
      if (c.value === null) return;
      const H = U.target;
      H && l.value && !l.value.contains(H) && v();
    }
    jt(() => document.addEventListener("pointerdown", z, !0)), Tt(() => document.removeEventListener("pointerdown", z, !0));
    const D = A(
      () => r.value.flatMap(
        (U) => Or(U) ? U.active ? [U.id] : [] : (U.sections ?? []).flatMap((H) => H.items.filter((L) => L.active).map((L) => L.id))
      ).join("|")
    );
    return Je(D, v), (U, H) => (f(), h("nav", {
      ref_key: "root",
      ref: l,
      class: Re(["fx-mega", `fx-mega--${e.mode}`]),
      "aria-label": e.label,
      "data-testid": "mega-menu",
      onFocusout: R
    }, [
      e.mode === "bar" ? (f(), h("ul", Fle, [
        (f(!0), h(Te, null, nt(r.value, (L, P) => {
          var K;
          return f(), h("li", {
            key: L.id,
            class: Re(["fx-mega__top", !u(Or)(L) && (((K = L.sections) == null ? void 0 : K.length) ?? 0) <= 1 && "fx-mega__top--narrow"])
          }, [
            u(Or)(L) ? (f(), h("a", {
              key: 0,
              href: L.href,
              class: Re(["fx-mega__toplink", L.active && "is-current"]),
              "aria-current": L.active ? "page" : void 0,
              "data-mega-top": L.id,
              "data-testid": `nav-${L.id}`,
              onClick: (N) => E(N, L),
              onKeydown: (N) => C(N, P, L)
            }, y(L.label), 43, Ule)) : (f(), h(Te, { key: 1 }, [
              d("button", {
                type: "button",
                class: Re(["fx-mega__topbtn", c.value === L.id && "is-open", u(Dle)(L) && "is-current"]),
                "aria-expanded": c.value === L.id ? "true" : "false",
                "aria-controls": p(L),
                "data-mega-top": L.id,
                "data-testid": `nav-top-${L.id}`,
                onClick: (N) => x(L.id),
                onKeydown: (N) => C(N, P, L)
              }, [
                d("span", null, y(L.label), 1),
                H[0] || (H[0] = d("svg", {
                  class: "fx-mega__chev",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true"
                }, [
                  d("path", { d: "m6 9 6 6 6-6" })
                ], -1))
              ], 42, Hle),
              dn(d("div", {
                id: p(L),
                class: "fx-mega__panel",
                "data-mega-panel": L.id,
                "data-testid": `nav-panel-${L.id}`,
                onKeydown: (N) => T(N, L)
              }, [
                (f(!0), h(Te, null, nt(L.sections, (N) => (f(), h("div", {
                  key: N.id,
                  class: "fx-mega__section",
                  "data-testid": `nav-group-${N.id}`
                }, [
                  d("p", {
                    id: m(L, N.id),
                    class: "fx-mega__heading"
                  }, y(N.label), 9, jle),
                  d("ul", {
                    class: "fx-mega__items",
                    "aria-labelledby": m(L, N.id)
                  }, [
                    (f(!0), h(Te, null, nt(N.items, (J) => (f(), h("li", {
                      key: J.id
                    }, [
                      d("a", {
                        href: J.href,
                        class: Re(["fx-mega__item", J.active && "is-current"]),
                        "aria-current": J.active ? "page" : void 0,
                        "data-testid": `nav-${J.id}`,
                        onClick: (j) => E(j, J)
                      }, [
                        d("span", Yle, [
                          J.iconName ? (f(), h("span", {
                            key: 0,
                            class: "fx-mega__glyph",
                            innerHTML: u(zt)(J.iconName)
                          }, null, 8, Gle)) : J.icon ? (f(), Ge(Ki(J.icon), {
                            key: 1,
                            class: "fx-mega__glyph"
                          })) : O("", !0)
                        ]),
                        d("span", Xle, [
                          d("span", Jle, y(J.label), 1),
                          J.hint ? (f(), h("span", Zle, y(J.hint), 1)) : O("", !0)
                        ])
                      ], 10, Wle)
                    ]))), 128))
                  ], 8, qle)
                ], 8, Vle))), 128))
              ], 40, Kle), [
                [UM, c.value === L.id]
              ])
            ], 64))
          ], 2);
        }), 128))
      ])) : (f(), h("div", Qle, [
        (f(!0), h(Te, null, nt(r.value, (L) => (f(), h(Te, {
          key: L.id
        }, [
          u(Or)(L) ? (f(), h("a", {
            key: 0,
            href: L.href,
            class: Re(["fx-mega__item", "fx-mega__item--top", L.active && "is-current"]),
            "aria-current": L.active ? "page" : void 0,
            "data-testid": `nav-${L.id}`,
            onClick: (P) => E(P, L)
          }, [
            d("span", tue, [
              L.icon ? (f(), Ge(Ki(L.icon), {
                key: 0,
                class: "fx-mega__glyph"
              })) : O("", !0)
            ]),
            d("span", nue, [
              d("span", aue, y(L.label), 1)
            ])
          ], 10, eue)) : (f(), h("section", {
            key: 1,
            class: "fx-mega__group",
            "aria-labelledby": p(L),
            "data-testid": `nav-top-${L.id}`
          }, [
            d("p", {
              id: p(L),
              class: "fx-mega__grouphead"
            }, y(L.label), 9, oue),
            (f(!0), h(Te, null, nt(L.sections, (P) => (f(), h("div", {
              key: P.id,
              class: "fx-mega__section",
              "data-testid": `nav-group-${P.id}`
            }, [
              d("p", {
                id: m(L, P.id),
                class: "fx-mega__heading"
              }, y(P.label), 9, sue),
              d("ul", {
                class: "fx-mega__items",
                "aria-labelledby": m(L, P.id)
              }, [
                (f(!0), h(Te, null, nt(P.items, (K) => (f(), h("li", {
                  key: K.id
                }, [
                  d("a", {
                    href: K.href,
                    class: Re(["fx-mega__item", K.active && "is-current"]),
                    "aria-current": K.active ? "page" : void 0,
                    "data-testid": `nav-${K.id}`,
                    onClick: (N) => E(N, K)
                  }, [
                    d("span", cue, [
                      K.iconName ? (f(), h("span", {
                        key: 0,
                        class: "fx-mega__glyph",
                        innerHTML: u(zt)(K.iconName)
                      }, null, 8, due)) : K.icon ? (f(), Ge(Ki(K.icon), {
                        key: 1,
                        class: "fx-mega__glyph"
                      })) : O("", !0)
                    ]),
                    d("span", fue, [
                      d("span", pue, y(K.label), 1)
                    ])
                  ], 10, uue)
                ]))), 128))
              ], 8, lue)
            ], 8, rue))), 128))
          ], 8, iue))
        ], 64))), 128))
      ]))
    ], 42, Ble));
  }
}), hue = [
  "page",
  "setting",
  "app",
  "user",
  "group",
  "key",
  "storage",
  "share",
  "file"
], mue = {
  file: "file",
  user: "user",
  app: "app",
  key: "key",
  group: "group",
  storage: "storage",
  setting: "setting"
}, vue = ["file", "user", "app", "key", "group", "storage", "setting"], yue = 6, fA = 3, pA = 25;
function o2(e) {
  return yo(e ?? "").split(/\s+/).filter((t) => t.length > 0);
}
function hA(e) {
  const t = (e ?? "").replace(/^\s+/, ""), n = /^([A-Za-z]+)\s*:/.exec(t);
  if (n) {
    const i = n[1].toLowerCase(), r = mue[i];
    if (r) {
      const l = t.slice(n[0].length).trim();
      return { kind: r, prefix: i, text: l, words: o2(l) };
    }
  }
  const a = t.trim();
  return { kind: null, prefix: "", text: a, words: o2(a) };
}
function r2(e, t) {
  const n = hA(e);
  return t ? `${t}:${n.text}` : n.text;
}
function gue(e, t) {
  return t === 0 ? !0 : !/[\p{L}\p{N}]/u.test(e[t - 1]);
}
function _f(e, t, n) {
  if (!e) return 0;
  const a = e.indexOf(t);
  return a < 0 ? 0 : a === 0 ? n : gue(e, a) ? Math.round(n * 0.8) : Math.round(n * 0.5);
}
function bue(e, t) {
  if (t.length === 0) return 0;
  const n = yo(e.label ?? ""), a = (e.terms ?? []).map((p) => yo(p)), i = (e.aliases ?? []).map((p) => yo(p)), r = yo(e.detail ?? "");
  let l = 0;
  for (const p of t) {
    let m = _f(n, p, 100);
    for (const v of a) m = Math.max(m, _f(v, p, 70));
    for (const v of i) m = Math.max(m, _f(v, p, 50));
    if (m = Math.max(m, _f(r, p, 25)), m <= 0) return e.found ? 1 : -1;
    l += m;
  }
  const c = t.join(" ");
  return n === c ? l += 300 : a.includes(c) ? l += 200 : i.includes(c) ? l += 150 : n.startsWith(c) && (l += 80), l -= Math.min(n.length, 60) / 10, l;
}
function kue(e, t) {
  if (t.length === 0) return !1;
  const n = t.join(" ");
  return yo(e.label ?? "") === n ? !0 : (e.terms ?? []).some((a) => yo(a) === n);
}
function wue(e, t, n = {}) {
  if (t.words.length === 0) return [];
  const a = /* @__PURE__ */ new Map();
  for (const l of e) {
    if (t.kind && l.kind !== t.kind) continue;
    const c = bue(l, t.words);
    if (c < 0) continue;
    const p = a.get(l.kind) ?? [];
    p.push({ item: l, score: c }), a.set(l.kind, p);
  }
  const i = [], r = [];
  for (const l of hue) {
    const c = a.get(l);
    if (!c || c.length === 0) continue;
    c.sort((v, x) => x.score - v.score);
    const p = n[l] ?? (t.kind ? pA : l === "file" ? fA : yue), m = { kind: l, items: c.slice(0, p).map((v) => v.item), total: c.length };
    (kue(c[0].item, t.words) ? i : r).push(m);
  }
  return [...i, ...r];
}
function Hhe(e) {
  return e.flatMap((t) => t.items);
}
const _ue = ["aria-label", "aria-expanded"], xue = ["innerHTML"], Sue = {
  key: 0,
  class: "fx-psearch__trigger-text"
}, $ue = {
  key: 1,
  class: "fx-psearch__kbd"
}, Tue = ["aria-modal", "aria-label"], Aue = { class: "fx-psearch__field" }, Eue = ["aria-label"], Cue = ["innerHTML"], zue = ["innerHTML"], Mue = ["aria-label", "aria-expanded", "aria-activedescendant", "placeholder"], Pue = ["aria-label"], Oue = ["innerHTML"], Lue = ["aria-label"], Due = ["aria-labelledby", "data-testid"], Rue = ["id"], Nue = ["id", "aria-selected", "data-testid", "data-id", "onMouseenter", "onClick"], Iue = {
  class: "fx-psearch__icon",
  "aria-hidden": "true"
}, Bue = ["innerHTML"], Fue = { class: "fx-psearch__text" }, Uue = { class: "fx-psearch__label" }, Hue = {
  key: 0,
  class: "fx-psearch__detail"
}, Kue = {
  class: "fx-psearch__icon",
  "aria-hidden": "true"
}, Vue = ["innerHTML"], jue = { class: "fx-psearch__text" }, que = { class: "fx-psearch__label" }, Wue = {
  class: "fx-psearch__icon",
  "aria-hidden": "true"
}, Yue = ["innerHTML"], Gue = { class: "fx-psearch__text" }, Xue = { class: "fx-psearch__label" }, Jue = ["aria-label", "title", "onClick"], Zue = ["innerHTML"], Que = {
  key: 0,
  class: "fx-psearch__note"
}, ece = {
  key: 1,
  class: "fx-psearch__note",
  "data-testid": "panel-search-empty"
}, tce = {
  key: 2,
  class: "fx-psearch__note fx-psearch__note--warn",
  role: "alert",
  "data-testid": "panel-search-failed"
}, nce = { class: "fx-psearch__foot" }, ace = { class: "fx-psearch__foot-label" }, ice = ["aria-pressed", "data-testid", "onClick"], oce = {
  class: "fe-sr-only",
  role: "status",
  "aria-live": "polite"
}, s2 = 2, rce = 200, Khe = /* @__PURE__ */ lt({
  __name: "PanelSearch",
  props: {
    locale: {},
    compact: { type: Boolean, default: !1 },
    items: {},
    remote: { type: Function, default: void 0 },
    files: { type: Function, default: void 0 },
    recent: { default: void 0 },
    shortcut: { type: Boolean, default: !0 }
  },
  emits: ["choose"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, { t: r } = ht(() => a.locale), l = `fx-psearch-${Math.random().toString(36).slice(2, 10)}`, c = `${l}-list`, p = S(null), m = S(null), v = S(null), x = S(null), w = S(!1), $ = S(""), k = S(0), b = S(null), C = S(80), T = A(() => hA($.value)), E = S([]), R = S([]), z = S(!1), D = S(!1);
    let U, H = 0;
    function L(he) {
      U && clearTimeout(U);
      const De = ++H;
      if (he.text.length < s2 || !a.remote && !a.files) {
        E.value = [], R.value = [], z.value = !1, D.value = !1;
        return;
      }
      z.value = !0, U = setTimeout(() => void P(he, De), rce);
    }
    async function P(he, De) {
      const ot = !!a.remote && he.kind !== "file" && he.kind !== "page" && he.kind !== "setting", ft = !!a.files && (he.kind === null || he.kind === "file"), gt = he.kind === "file" ? pA : fA, [Ut, Xe] = await Promise.allSettled([
        ot && a.remote ? a.remote(he) : Promise.resolve([]),
        ft && a.files ? a.files(he.text, gt) : Promise.resolve([])
      ]);
      De === H && (E.value = Ut.status === "fulfilled" ? Ut.value.map((Ve) => ({ ...Ve, found: !0 })) : [], R.value = Xe.status === "fulfilled" ? Xe.value.map((Ve) => ({ ...Ve, kind: "file", found: !0 })) : [], D.value = Ut.status === "rejected" || Xe.status === "rejected", z.value = !1);
    }
    Je($, () => {
      k.value = 0, L(T.value);
    });
    const K = S([]);
    async function N() {
      if (a.recent)
        try {
          K.value = await a.recent.list();
        } catch {
        }
    }
    function J(he) {
      const De = he.trim();
      !De || !a.recent || (K.value = [{ id: `local-${De}`, query: De }, ...K.value.filter((ot) => ot.query !== De)], a.recent.add(De).then(N, () => {
      }));
    }
    async function j(he) {
      var De;
      K.value = K.value.filter((ot) => ot.id !== he.id), k.value >= ce.value.length && (k.value = Math.max(0, ce.value.length - 1));
      try {
        await ((De = a.recent) == null ? void 0 : De.remove(he.id));
      } catch {
        await N();
      }
    }
    async function re() {
      var he, De;
      K.value = [], k.value = 0;
      try {
        await ((he = a.recent) == null ? void 0 : he.clear());
      } catch {
        await N();
      }
      (De = v.value) == null || De.focus();
    }
    const q = {
      page: "panelsearch.group.page",
      setting: "panelsearch.group.setting",
      app: "panelsearch.group.app",
      user: "panelsearch.group.user",
      group: "panelsearch.group.group",
      key: "panelsearch.group.key",
      storage: "panelsearch.group.storage",
      share: "panelsearch.group.share",
      file: "panelsearch.group.file"
    }, le = A(() => !!a.files && T.value.kind === null && T.value.text.length >= s2), ve = A(() => {
      let he = 0;
      const De = [], ot = T.value;
      if (ot.words.length === 0)
        return ot.kind === null && K.value.length && De.push({
          key: "recent",
          heading: r("panelsearch.group.recent"),
          rows: K.value.map((gt) => ({ type: "recent", id: `recent:${gt.id}`, index: he++, entry: gt }))
        }), De;
      const ft = wue([...a.items, ...E.value, ...R.value], ot);
      for (const gt of ft)
        De.push({
          key: gt.kind,
          heading: r(q[gt.kind]),
          rows: gt.items.map((Ut) => ({ type: "item", id: `item:${Ut.id}`, index: he++, item: Ut }))
        });
      if (le.value) {
        const gt = De.find((Xe) => Xe.key === "file"), Ut = { type: "files-all", id: "files-all", index: he++ };
        gt ? gt.rows.push(Ut) : De.push({ key: "file", heading: r(q.file), rows: [Ut] });
      }
      return De;
    }), ce = A(() => ve.value.flatMap((he) => he.rows)), se = (he) => `${l}-opt-${he}`, fe = A(() => ce.value.length && k.value < ce.value.length ? se(k.value) : void 0), _ = A(() => {
      if (!w.value || T.value.words.length === 0) return "";
      if (z.value) return r("panelsearch.searching");
      const he = ce.value.filter((De) => De.type === "item").length;
      return he === 0 ? r("panelsearch.empty", { q: T.value.text }) : r("panelsearch.count", { n: he });
    }), ee = A(
      () => T.value.words.length > 0 && !z.value && ce.value.every((he) => he.type !== "item")
    );
    function Y(he) {
      if (he.kind === "file") {
        const De = he.label ?? "", ot = De.lastIndexOf(".");
        return wa({
          type: he.isDir ? "dir" : "file",
          basename: De,
          extension: !he.isDir && ot > 0 ? De.slice(ot + 1) : ""
        });
      }
      return zt(he.iconName ?? B[he.kind]);
    }
    const B = {
      page: "goto",
      setting: "admin",
      app: "plugin",
      user: "account",
      group: "account",
      key: "lock",
      storage: "connect",
      share: "link",
      file: "open"
    };
    function W() {
      const he = p.value;
      if (!(!he || typeof window > "u")) {
        if (C.value = Rc([he]), a.compact) {
          b.value = null;
          return;
        }
        b.value = nb(
          he.getBoundingClientRect(),
          tb(),
          { width: 560, gutter: 16, gap: 6, maxHeight: 620, dir: ei(he) }
        );
      }
    }
    const F = A(() => {
      const he = { zIndex: String(C.value) };
      return b.value && (he.top = b.value.top, he.right = b.value.right, he.left = b.value.left, he.width = b.value.width, he.maxHeight = b.value.maxHeight), he;
    });
    async function V(he) {
      var De, ot;
      w.value || (W(), w.value = !0, N()), typeof he == "string" && ($.value = he), await Gt(), (De = v.value) == null || De.focus(), typeof he != "string" && ((ot = v.value) == null || ot.select());
    }
    function ke(he) {
      w.value && (w.value = !1, U && clearTimeout(U), z.value = !1, he && Gt(() => {
        var De;
        return (De = p.value) == null ? void 0 : De.focus();
      }));
    }
    function qe(he) {
      he.key.length === 1 && !he.ctrlKey && !he.metaKey && !he.altKey && he.key !== " " ? (he.preventDefault(), V(he.key)) : he.key === "ArrowDown" && (he.preventDefault(), V());
    }
    function Me(he) {
      if (he) {
        if (he.type === "recent") {
          $.value = he.entry.query, Gt(() => {
            var De;
            return (De = v.value) == null ? void 0 : De.focus();
          });
          return;
        }
        if (he.type === "files-all") {
          $.value = r2($.value, "file"), Gt(() => {
            var De;
            return (De = v.value) == null ? void 0 : De.focus();
          });
          return;
        }
        J($.value), ke(!1), i("choose", he.item);
      }
    }
    function Fe(he) {
      $.value = r2($.value, he), Gt(() => {
        var De;
        return (De = v.value) == null ? void 0 : De.focus();
      });
    }
    function We() {
      $.value = "", Gt(() => {
        var he;
        return (he = v.value) == null ? void 0 : he.focus();
      });
    }
    function $t(he) {
      const De = ce.value.length;
      De && (k.value = (k.value + he + De) % De, Gt(() => {
        var ft;
        const ot = (ft = x.value) == null ? void 0 : ft.querySelector(`#${se(k.value)}`);
        ot && typeof ot.scrollIntoView == "function" && ot.scrollIntoView({ block: "nearest" });
      }));
    }
    function St(he) {
      switch (he.key) {
        case "ArrowDown":
          he.preventDefault(), $t(1);
          break;
        case "ArrowUp":
          he.preventDefault(), $t(-1);
          break;
        case "Enter":
          if (he.isComposing) return;
          he.preventDefault(), Me(ce.value[k.value] ?? ce.value[0]);
          break;
        case "Escape":
          he.preventDefault(), he.stopPropagation(), ke(!0);
          break;
        case "Delete": {
          const De = ce.value[k.value];
          $.value === "" && (De == null ? void 0 : De.type) === "recent" && (he.preventDefault(), j(De.entry));
          break;
        }
      }
    }
    function at(he) {
      var De, ot;
      return he ? !!((De = m.value) != null && De.contains(he) || (ot = p.value) != null && ot.contains(he)) : !1;
    }
    function kt(he) {
      if (a.compact) return;
      const De = he.relatedTarget;
      De && !at(De) && ke(!1);
    }
    function pt(he) {
      !w.value || a.compact || at(he.target) || ke(!1);
    }
    function Ne(he) {
      var De, ot;
      !a.shortcut || he.defaultPrevented || ix(he, "palette") && (tx(he.target) && !at(he.target) || (he.preventDefault(), w.value ? ((De = v.value) == null || De.focus(), (ot = v.value) == null || ot.select()) : V()));
    }
    function ie() {
      w.value && W();
    }
    jt(() => {
      document.addEventListener("keydown", Ne), document.addEventListener("pointerdown", pt, !0), window.addEventListener("resize", ie);
    }), Tt(() => {
      U && clearTimeout(U), document.removeEventListener("keydown", Ne), document.removeEventListener("pointerdown", pt, !0), window.removeEventListener("resize", ie);
    });
    const xe = A(() => a.shortcut ? qy("palette") : "");
    return t({ openPanel: V, close: ke }), (he, De) => (f(), h("div", {
      class: Re(["fx-psearch", e.compact ? "fx-psearch--compact" : "fx-psearch--box"])
    }, [
      d("button", {
        ref_key: "trigger",
        ref: p,
        type: "button",
        class: "fx-psearch__trigger",
        "aria-label": u(r)("panelsearch.label"),
        "aria-haspopup": "dialog",
        "aria-expanded": w.value ? "true" : "false",
        "data-testid": "panel-search-open",
        onClick: De[0] || (De[0] = (ot) => w.value ? ke(!0) : V()),
        onKeydown: qe
      }, [
        d("span", {
          class: "fx-psearch__glyph",
          "aria-hidden": "true",
          innerHTML: u(zt)("search")
        }, null, 8, xue),
        e.compact ? O("", !0) : (f(), h("span", Sue, y(u(r)("panelsearch.trigger")), 1)),
        !e.compact && xe.value ? (f(), h("kbd", $ue, y(xe.value), 1)) : O("", !0)
      ], 40, _ue),
      (f(), Ge(wi, { to: "body" }, [
        w.value ? (f(), h("div", {
          key: 0,
          ref_key: "layer",
          ref: m,
          class: Re(["fx-psearch__layer", e.compact ? "fx-psearch__layer--full" : "fx-psearch__layer--drop"]),
          style: Yt(F.value),
          role: "dialog",
          "aria-modal": e.compact ? "true" : void 0,
          "aria-label": u(r)("panelsearch.label"),
          "data-testid": "panel-search",
          onFocusout: kt
        }, [
          d("div", Aue, [
            e.compact ? (f(), h("button", {
              key: 0,
              type: "button",
              class: "fx-psearch__iconbtn",
              "aria-label": u(r)("panelsearch.close"),
              "data-testid": "panel-search-close",
              onClick: De[1] || (De[1] = (ot) => ke(!0))
            }, [
              d("span", {
                class: "fx-psearch__glyph",
                "aria-hidden": "true",
                innerHTML: u(zt)("close")
              }, null, 8, Cue)
            ], 8, Eue)) : (f(), h("span", {
              key: 1,
              class: "fx-psearch__glyph fx-psearch__glyph--field",
              "aria-hidden": "true",
              innerHTML: u(zt)("search")
            }, null, 8, zue)),
            dn(d("input", {
              ref_key: "inputEl",
              ref: v,
              "onUpdate:modelValue": De[2] || (De[2] = (ot) => $.value = ot),
              type: "text",
              class: "fx-psearch__input",
              role: "combobox",
              "aria-label": u(r)("panelsearch.label"),
              "aria-autocomplete": "list",
              "aria-expanded": ce.value.length > 0 ? "true" : "false",
              "aria-controls": c,
              "aria-activedescendant": fe.value,
              placeholder: u(r)("panelsearch.placeholder"),
              autocomplete: "off",
              autocapitalize: "off",
              spellcheck: "false",
              enterkeyhint: "search",
              "data-testid": "panel-search-input",
              onKeydown: St
            }, null, 40, Mue), [
              [_n, $.value]
            ]),
            $.value ? (f(), h("button", {
              key: 2,
              type: "button",
              class: "fx-psearch__iconbtn",
              "aria-label": u(r)("panelsearch.clear"),
              "data-testid": "panel-search-clear",
              onClick: We
            }, [
              d("span", {
                class: "fx-psearch__glyph",
                "aria-hidden": "true",
                innerHTML: u(zt)("close")
              }, null, 8, Oue)
            ], 8, Pue)) : O("", !0)
          ]),
          d("div", {
            id: c,
            ref_key: "listEl",
            ref: x,
            class: "fx-psearch__list",
            role: "listbox",
            "aria-label": u(r)("panelsearch.results")
          }, [
            (f(!0), h(Te, null, nt(ve.value, (ot) => (f(), h("div", {
              key: ot.key,
              class: "fx-psearch__group",
              role: "group",
              "aria-labelledby": `${l}-h-${ot.key}`,
              "data-testid": `panel-search-group-${ot.key}`
            }, [
              d("div", {
                id: `${l}-h-${ot.key}`,
                class: "fx-psearch__heading",
                role: "presentation"
              }, y(ot.heading), 9, Rue),
              (f(!0), h(Te, null, nt(ot.rows, (ft) => (f(), h("div", {
                id: se(ft.index),
                key: ft.id,
                class: Re(["fx-psearch__row", ft.index === k.value && "is-active"]),
                role: "option",
                "aria-selected": ft.index === k.value ? "true" : "false",
                "data-testid": ft.type === "item" ? `panel-search-row-${ft.item.kind}` : `panel-search-${ft.type}`,
                "data-id": ft.type === "item" ? ft.item.id : void 0,
                onMousedown: De[3] || (De[3] = yt(() => {
                }, ["prevent"])),
                onMouseenter: (gt) => k.value = ft.index,
                onClick: (gt) => Me(ft)
              }, [
                ft.type === "item" ? (f(), h(Te, { key: 0 }, [
                  d("span", Iue, [
                    ft.item.icon && ft.item.kind !== "file" ? (f(), Ge(Ki(ft.item.icon), {
                      key: 0,
                      class: "fx-psearch__svg"
                    })) : (f(), h("span", {
                      key: 1,
                      class: "fx-psearch__svg",
                      innerHTML: Y(ft.item)
                    }, null, 8, Bue))
                  ]),
                  d("span", Fue, [
                    d("span", Uue, [
                      d("bdi", null, y(ft.item.label), 1)
                    ]),
                    ft.item.detail ? (f(), h("span", Hue, [
                      d("bdi", null, y(ft.item.detail), 1)
                    ])) : O("", !0)
                  ])
                ], 64)) : ft.type === "files-all" ? (f(), h(Te, { key: 1 }, [
                  d("span", Kue, [
                    d("span", {
                      class: "fx-psearch__svg",
                      innerHTML: u(zt)("search")
                    }, null, 8, Vue)
                  ]),
                  d("span", jue, [
                    d("span", que, y(u(r)("panelsearch.files_all", { q: T.value.text })), 1)
                  ])
                ], 64)) : (f(), h(Te, { key: 2 }, [
                  d("span", Wue, [
                    d("span", {
                      class: "fx-psearch__svg",
                      innerHTML: u(zt)("search")
                    }, null, 8, Yue)
                  ]),
                  d("span", Gue, [
                    d("span", Xue, [
                      d("bdi", null, y(ft.entry.query), 1)
                    ])
                  ]),
                  d("button", {
                    type: "button",
                    class: "fx-psearch__iconbtn fx-psearch__remove",
                    tabindex: "-1",
                    "aria-label": u(r)("panelsearch.recent_remove"),
                    title: u(r)("panelsearch.recent_remove"),
                    "data-testid": "panel-search-recent-remove",
                    onClick: yt((gt) => j(ft.entry), ["stop"])
                  }, [
                    d("span", {
                      class: "fx-psearch__glyph",
                      "aria-hidden": "true",
                      innerHTML: u(zt)("close")
                    }, null, 8, Zue)
                  ], 8, Jue)
                ], 64))
              ], 42, Nue))), 128))
            ], 8, Due))), 128)),
            z.value && ce.value.length === 0 ? (f(), h("p", Que, y(u(r)("panelsearch.searching")), 1)) : ee.value ? (f(), h("p", ece, y(u(r)("panelsearch.empty", { q: T.value.text })), 1)) : O("", !0),
            D.value ? (f(), h("p", tce, y(u(r)("panelsearch.failed")), 1)) : O("", !0)
          ], 8, Lue),
          d("div", nce, [
            d("span", ace, y(u(r)("panelsearch.prefixes")), 1),
            (f(!0), h(Te, null, nt(u(vue), (ot) => (f(), h("button", {
              key: ot,
              type: "button",
              class: Re(["fx-psearch__chip", T.value.prefix === ot && "is-on"]),
              "aria-pressed": T.value.prefix === ot ? "true" : "false",
              "data-testid": `panel-search-prefix-${ot}`,
              onMousedown: De[4] || (De[4] = yt(() => {
              }, ["prevent"])),
              onClick: (ft) => Fe(T.value.prefix === ot ? "" : ot)
            }, y(ot) + ":", 43, ice))), 128)),
            T.value.words.length === 0 && T.value.kind === null && K.value.length ? (f(), h("button", {
              key: 0,
              type: "button",
              class: "fx-psearch__clearall",
              "data-testid": "panel-search-recent-clear",
              onMousedown: De[5] || (De[5] = yt(() => {
              }, ["prevent"])),
              onClick: re
            }, y(u(r)("panelsearch.recent_clear")), 33)) : O("", !0)
          ]),
          d("p", oce, y(_.value), 1)
        ], 46, Tue)) : O("", !0)
      ]))
    ], 2));
  }
});
function mA(e, t = {}) {
  return e === "app" ? "wide" : e === "folder" ? t.list ? "wide" : "form" : e === "drop" ? "form" : "gate";
}
function sce(e, t) {
  const n = (t ?? []).map((r) => r.trim().replace(/^\./, "").toLowerCase()).filter(Boolean);
  if (!n.length) return !0;
  const a = e.lastIndexOf("."), i = a > 0 || a === 0 && e.length > 1 ? e.slice(a + 1).toLowerCase() : "";
  return n.includes(i);
}
function lce(e, t, n) {
  const a = { accepted: [], refused: [] }, i = (t == null ? void 0 : t.max_file_size_mb) ?? 0;
  let r = t != null && t.max_files && t.max_files > 0 ? t.max_files : 1 / 0;
  typeof n == "number" && Number.isFinite(n) && (r = Math.min(r, Math.max(0, n)));
  for (const l of e)
    sce(l.name, t == null ? void 0 : t.allowed_ext) ? i > 0 && l.size > i * 1024 * 1024 ? a.refused.push({ file: l, reason: { code: "too_large", name: l.name, mb: i } }) : a.accepted.length >= r ? a.refused.push({ file: l, reason: { code: "too_many", count: r } }) : a.accepted.push(l) : a.refused.push({ file: l, reason: { code: "ext", name: l.name } });
  return a;
}
class uce extends Error {
  constructor(t, n, a) {
    super(a || n || String(t)), this.status = t, this.code = n, this.name = "PublicLinkError";
  }
}
function ab(e, t, n) {
  const a = (e ?? "").replace(/\/+$/, "");
  return (i = "") => `${a}${t}${encodeURIComponent(n)}${i}`;
}
function cce(e, t) {
  return ab(e, "/api/public/s/", t);
}
function dce(e, t) {
  return ab(e, "/api/public/d/", t);
}
function ib(e, t) {
  return ab(e, "/api/p/", t);
}
function vA(e, t) {
  const n = (...i) => (t.fetchImpl ?? fetch)(...i);
  async function a(i, r = {}) {
    const l = { Accept: "application/json", "Accept-Language": t.locale() };
    r.body !== void 0 && (l["Content-Type"] = "application/json");
    const c = await n(e(i), {
      method: r.method ?? "GET",
      headers: l,
      credentials: "same-origin",
      cache: "no-store",
      body: r.body !== void 0 ? JSON.stringify(r.body) : void 0
    });
    let p = null;
    try {
      p = await c.json();
    } catch {
      p = null;
    }
    if (!c.ok) {
      const m = p ?? {};
      throw new uce(c.status, m.error ?? "", m.message);
    }
    return { status: c.status, body: p };
  }
  return {
    /** What the link is and what the visitor may see of it. */
    info: (i = "") => a(i).then((r) => r.body),
    pin: (i) => a("/pin", { method: "POST", body: { pin: i } }).then((r) => r.body),
    /**
     * The app's opening screen.
     *
     * ⚠ There is no `/view` route: an open is `POST /event
     * {"event":"open"}`, because the opening surface and every later one are
     * the same call to the app. One endpoint, one code path in the plugin.
     */
    open: () => a("/event", { method: "POST", body: { event: "open", state: {}, data: {} } }).then(
      (i) => i.body
    ),
    /** `{surface}`, or `{op}` when the server queued a job (202). */
    event: async (i) => {
      var l, c, p;
      const r = await a("/event", {
        method: "POST",
        body: i
      });
      return r.status === 202 || (l = r.body) != null && l.accepted ? { op: { accepted: !0, job_id: (c = r.body) == null ? void 0 : c.job_id }, job_id: (p = r.body) == null ? void 0 : p.job_id } : { surface: r.body.surface };
    },
    /** Where the browser loads an exposed copy from (`pub:N`). */
    fileUrl: (i) => e(`/file/${encodeURIComponent(i)}`),
    /**
     * The same copy, asked for as a DOWNLOAD — the Download button's link.
     * ⚠ Kept apart from `fileUrl` because only this one counts as a download
     * (handlers/public_api.go serveExposed): the page's own viewer loads the
     * document to SHOW it, and the owner ruled on 2026-09-21 that looking at
     * a signing link is not downloading it.
     */
    fileDownloadUrl: (i) => e(`/file/${encodeURIComponent(i)}?download=1`),
    url: e
  };
}
function ob(e, t) {
  const n = vA(e, t), a = S("loading"), i = S(null), r = S(""), l = S(""), c = S(""), p = S(""), m = S(""), v = S(""), x = Wp(
    {
      api: { pluginViewEvent: (E, R, z) => n.event(z) },
      plugin: "",
      view: "",
      locale: t.locale,
      errorText: t.errorText
    },
    {
      onOp: (E) => {
        c.value = String(E.job_id ?? ""), a.value = "accepted";
      },
      onDone: () => {
        a.value !== "accepted" && (a.value = "done");
      },
      onToast: (E) => {
        p.value = E;
      }
    }
  );
  function w(E) {
    const R = E;
    (R == null ? void 0 : R.status) === 404 ? (a.value = "not_found", v.value = "not_found") : (R == null ? void 0 : R.status) === 410 ? (a.value = "gone", v.value = "gone") : (a.value = "error", v.value = "error", m.value = Yi(t.locale(), String((E == null ? void 0 : E.message) ?? E)) || t.errorText());
  }
  async function $() {
    try {
      const E = await n.open(), R = E == null ? void 0 : E.surface;
      if (!R) {
        a.value = "error", m.value = t.errorText();
        return;
      }
      x.setSurface(R), a.value = R.done ? "done" : "ready";
    } catch (E) {
      if ((E == null ? void 0 : E.status) === 401) {
        a.value = "pin";
        return;
      }
      w(E);
    }
  }
  function k(E) {
    return (E == null ? void 0 : E.expired) === !0 || (E == null ? void 0 : E.revoked) === !0;
  }
  async function b(E = "") {
    var R, z, D, U;
    a.value = "loading", m.value = "", v.value = "";
    try {
      i.value = await n.info(E);
    } catch (H) {
      w(H);
      return;
    }
    if (k(i.value)) {
      a.value = "gone", v.value = "gone";
      return;
    }
    if ((R = i.value) != null && R.needs_pin && !((z = i.value) != null && z.unlocked)) {
      a.value = "pin", r.value = ((D = i.value) == null ? void 0 : D.locked) === !0 ? "locked" : "";
      return;
    }
    if ((U = t.hasSurface) != null && U.call(t, i.value)) {
      await $();
      return;
    }
    a.value = "ready";
  }
  const C = S(!1);
  async function T(E) {
    var R;
    if (!C.value) {
      r.value = "", l.value = "", C.value = !0;
      try {
        i.value = await n.pin(E.trim()), k(i.value) ? (a.value = "gone", v.value = "gone") : (R = t.hasSurface) != null && R.call(t, i.value) ? await $() : a.value = "ready";
      } catch (z) {
        const D = z;
        (D == null ? void 0 : D.status) === 429 ? (r.value = "locked", l.value = Yi(t.locale(), D.message ?? "")) : (D == null ? void 0 : D.status) === 401 || (D == null ? void 0 : D.status) === 403 ? r.value = "wrong" : w(z);
      } finally {
        C.value = !1;
      }
    }
  }
  return {
    status: a,
    info: i,
    reason: v,
    pinFailure: r,
    lockMessage: l,
    pinBusy: C,
    failure: m,
    toast: p,
    jobId: c,
    conv: x,
    load: b,
    submitPin: T,
    fileUrl: n.fileUrl,
    fileDownloadUrl: n.fileDownloadUrl,
    /**
     * A `FileRefResolver` for the surface renderer: the URL, plus the name
     * and type the link's own `files[]` already told us.
     *
     * ⚠ The renderer needs the mime to decide how to draw the thing (a
     * picture, an embedded PDF, a link). Handing it a bare URL makes every
     * exposed copy render as "something to download", which is what a
     * `preview` node is specifically not for.
     */
    resolveFile: (E) => {
      var D, U;
      const R = (U = (D = i.value) == null ? void 0 : D.app) == null ? void 0 : U.files, z = R == null ? void 0 : R.find((H) => H.ref === E);
      return { url: n.fileUrl(E), name: z == null ? void 0 : z.name, mime: z == null ? void 0 : z.mime };
    },
    url: n.url
  };
}
function fce(e, t, n = {}) {
  const a = (e ?? "").replace(/\/+$/, ""), i = encodeURIComponent(t);
  return n.path ? `${a}/s/${i}/f/${n.path.split("/").map(encodeURIComponent).join("/")}?download=1` : `${a}/s/${i}?${n.zip ? "zip=1" : "download=1"}`;
}
function pce(e, t) {
  return `${(e ?? "").replace(/\/+$/, "")}/s/${encodeURIComponent(t)}?nojs=1`;
}
function hce(e, t) {
  return {
    ...ob(cce(t.base, e), {
      ...t,
      hasSurface: (a) => (a == null ? void 0 : a.kind) === "app"
    }),
    downloadUrl: (a = {}) => fce(t.base, e, a),
    noJsUrl: () => pce(t.base, e)
  };
}
const mce = /* @__PURE__ */ new Set([504, 524]);
function vce(e, t) {
  const n = ob(dce(t.base, e), t), a = S([]);
  function i(c, p, m) {
    a.value = a.value.map((v, x) => x >= c && x < p ? { ...v, ...m } : v);
  }
  function r(c, p, m) {
    const v = p + c.length;
    return new Promise((x) => {
      let w;
      try {
        w = new XMLHttpRequest();
      } catch {
        i(p, v, { state: "failed", error: t.errorText() }), x();
        return;
      }
      w.open("POST", n.url("/upload")), w.withCredentials = !0, w.setRequestHeader("Accept", "application/json"), w.setRequestHeader("Accept-Language", t.locale()), w.upload.onprogress = (C) => {
        C.lengthComputable && C.total > 0 && i(p, v, { percent: Math.round(C.loaded / C.total * 100) });
      };
      let $ = !1;
      w.upload.onload = () => {
        $ = !0, i(p, v, { state: "saving", percent: 100 });
      };
      const k = () => i(p, v, { state: "unconfirmed", error: (t.unansweredText ?? t.errorText)() });
      w.onload = () => {
        var C;
        if (w.status >= 200 && w.status < 300)
          i(p, v, { state: "done", percent: 100 });
        else {
          let T = "";
          try {
            T = String(((C = JSON.parse(w.responseText)) == null ? void 0 : C.message) ?? "");
          } catch {
            T = "";
          }
          !T && $ && mce.has(w.status) ? k() : i(p, v, { state: "failed", error: T || t.errorText() });
        }
        x();
      }, w.onerror = () => {
        $ ? k() : i(p, v, { state: "failed", error: t.errorText() }), x();
      };
      const b = new FormData();
      for (const C of c) b.append("file", C, C.name);
      for (const C of c) b.append("name[]", C.name);
      m && b.append("uploader_name", m), w.send(b);
    });
  }
  async function l(c, p = {}) {
    const m = n.info.value, { accepted: v, refused: x } = lce(Array.from(c), m == null ? void 0 : m.limits, (m == null ? void 0 : m.uploads_left) ?? null), w = p.refusedText ?? (() => t.errorText());
    if (a.value = [
      ...a.value,
      ...x.map(({ file: k, reason: b }) => ({
        name: k.name,
        size: k.size,
        percent: -1,
        state: "refused",
        error: w(b)
      }))
    ], !v.length) return;
    const $ = a.value.length;
    a.value = [
      ...a.value,
      ...v.map((k) => ({ name: k.name, size: k.size, percent: -1, state: "sending" }))
    ], await r(v, $, (p.name ?? "").trim()), await n.load();
  }
  return { ...n, uploads: a, upload: l };
}
function Vhe(e, t, n = "") {
  return ib(e, t)(n);
}
function jhe(e, t) {
  return vA(ib(t.base, e), t);
}
function qhe(e, t) {
  return ob(ib(t.base, e), { ...t, hasSurface: () => !0 });
}
const yA = Symbol("filex-public-text");
function gA(e) {
  const t = S({}), n = S(""), a = S(!1);
  let i = 0;
  async function r(l) {
    const c = ++i;
    a.value = !1;
    const p = e.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
    try {
      if (!p) return;
      const m = await p(`${Yo(e.base)}/api/public/strings?lang=${encodeURIComponent(l)}`, {
        method: "GET",
        headers: { Accept: "application/json" },
        credentials: "same-origin"
      });
      if (!m.ok) return;
      const v = await m.json();
      if (c !== i) return;
      t.value = v != null && v.strings && typeof v.strings == "object" ? v.strings : {}, n.value = (v == null ? void 0 : v.lang) || l;
    } catch {
    } finally {
      c === i && (a.value = !0);
    }
  }
  return Je(e.locale, (l) => void r(l), { immediate: !0 }), { table: t, lang: n, ready: a };
}
function bA(e) {
  Wo(yA, e);
}
const yce = ["count", "n"];
function kA(e, t, n, a = {}) {
  let i;
  const r = yce.find((l) => l in a);
  if (r !== void 0) {
    const l = Ry(t || "en", Number(a[r]));
    l !== "other" && (i = e[`${n}_${l}`]);
  }
  return i = i || e[n] || "", Object.entries(a).reduce((l, [c, p]) => l.replaceAll(`{${c}}`, String(p)), i);
}
function rb(e) {
  const t = bi(yA, null), n = A(() => (t == null ? void 0 : t.table.value) ?? {}), a = A(() => (t == null ? void 0 : t.lang.value) || (e ? e() : "") || "en"), i = A(() => (t == null ? void 0 : t.ready.value) ?? !0);
  function r(l, c = {}) {
    const p = kA(n.value, a.value, l, c);
    return p ? Yi(a.value, p) : "";
  }
  return { pt: r, ready: i };
}
const gce = { class: "fe-ppage__state" }, bce = { class: "fe-ppage__state-title" }, kce = { class: "fe-surface__text fe-surface__text--muted" }, wce = {
  class: "fe-ppage__srlabel",
  for: "fe-ppage-pin"
}, _ce = ["maxlength", "disabled", "aria-invalid"], xce = {
  key: 0,
  class: "fe-ppage__error",
  role: "alert",
  "data-testid": "public-page-pin-error"
}, Sce = ["disabled"], $ce = /* @__PURE__ */ lt({
  __name: "PublicPinGate",
  props: {
    locale: {},
    busy: { type: Boolean },
    failure: {},
    lockMessage: {},
    maxLength: {}
  },
  emits: ["submit"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = S(""), l = S(null), c = () => n.failure === "wrong" ? i("plugin.page.pin_wrong") : n.failure === "locked" ? i("plugin.page.pin_locked") : "";
    Je(
      () => n.failure,
      async (m) => {
        var v;
        m === "wrong" && (r.value = "", await Gt(), (v = l.value) == null || v.focus());
      }
    ), jt(() => {
      var m;
      return (m = l.value) == null ? void 0 : m.focus();
    });
    function p() {
      var m;
      if (!(n.busy || n.failure === "locked")) {
        if (!r.value.trim()) {
          (m = l.value) == null || m.focus();
          return;
        }
        a("submit", r.value);
      }
    }
    return (m, v) => (f(), h("form", {
      class: "fe-ppage__pin",
      "data-testid": "public-page-pin",
      onSubmit: yt(p, ["prevent"])
    }, [
      d("div", gce, [
        d("h2", bce, y(u(i)("plugin.page.pin_title")), 1),
        d("p", kce, y(u(i)("plugin.page.pin_hint")), 1)
      ]),
      d("label", wce, y(u(i)("plugin.pin.label")), 1),
      dn(d("input", {
        id: "fe-ppage-pin",
        ref_key: "input",
        ref: l,
        "onUpdate:modelValue": v[0] || (v[0] = (x) => r.value = x),
        class: Re(["fe-cfield__input fe-ppage__pinput", { "is-invalid": !!c() }]),
        type: "text",
        inputmode: "numeric",
        autocomplete: "one-time-code",
        spellcheck: "false",
        maxlength: e.maxLength && e.maxLength > 0 ? e.maxLength : void 0,
        disabled: e.busy || e.failure === "locked",
        "aria-invalid": c() ? "true" : void 0,
        "data-testid": "public-page-pin-input"
      }, null, 10, _ce), [
        [_n, r.value]
      ]),
      c() ? (f(), h("p", xce, [
        Ht(y(c()), 1),
        e.lockMessage ? (f(), h(Te, { key: 0 }, [
          Ht(" (" + y(e.lockMessage) + ")", 1)
        ], 64)) : O("", !0)
      ])) : O("", !0),
      d("button", {
        type: "submit",
        class: "fe-btn fe-btn--primary",
        disabled: e.busy || e.failure === "locked",
        "data-testid": "public-page-pin-submit"
      }, y(u(i)("plugin.page.pin_submit")), 9, Sce)
    ], 32));
  }
}), Tce = {
  key: 0,
  class: "fe-plang",
  role: "group",
  "data-testid": "public-language"
}, Ace = ["lang", "aria-pressed", "title", "data-testid", "onClick"], Ece = {
  key: 0,
  class: "fe-plang__src"
}, Cce = /* @__PURE__ */ lt({
  __name: "PublicLanguagePicker",
  props: {
    modelValue: {},
    pluginNote: { type: Function }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = A(() => (oi.value, mo())), r = A(() => i.value.length > 1);
    return (l, c) => r.value ? (f(), h("div", Tce, [
      (f(!0), h(Te, null, nt(i.value, (p) => (f(), h("button", {
        key: p.code,
        type: "button",
        class: Re(["fe-plang__btn", { "is-on": p.code === n.modelValue }]),
        lang: p.code,
        "aria-pressed": p.code === n.modelValue ? "true" : "false",
        title: p.source === "plugin" && p.plugin && e.pluginNote ? e.pluginNote(p.plugin) : void 0,
        "data-testid": `public-language-${p.code}`,
        onClick: (m) => a("update:modelValue", p.code)
      }, [
        Ht(y(p.label) + " ", 1),
        p.source === "plugin" && p.plugin ? (f(), h("small", Ece, y(p.plugin), 1)) : O("", !0)
      ], 10, Ace))), 128))
    ])) : O("", !0);
  }
}), zce = ["dir", "data-state", "data-layout"], Mce = {
  class: "fe-ppage__brand",
  "data-testid": "public-brand"
}, Pce = ["src", "alt"], Oce = { class: "fe-ppage__brandname" }, Lce = ["data-badge"], Dce = {
  key: 0,
  class: "fe-ppage__spinner"
}, Rce = ["stroke-width"], Nce = {
  key: 1,
  d: "M4.5 12.5l5 5 10-11"
}, Ice = {
  key: 1,
  class: "fe-ppage__head"
}, Bce = {
  key: 0,
  class: "fe-ppage__title",
  "data-testid": "public-page-title"
}, Fce = {
  key: 1,
  class: "fe-ppage__subject",
  "data-testid": "public-page-subject"
}, Uce = {
  key: 2,
  class: "fe-ppage__meta",
  "data-testid": "public-page-meta"
}, Hce = { key: 0 }, Kce = {
  key: 1,
  "aria-hidden": "true"
}, Vce = { key: 2 }, jce = {
  key: 3,
  class: "fe-surface__text fe-surface__text--muted",
  "data-testid": "public-page-loading"
}, qce = {
  key: 6,
  class: "fe-ppage__state fe-ppage__state--ok",
  "data-testid": "public-page-accepted"
}, Wce = { class: "fe-ppage__state-title" }, Yce = { class: "fe-surface__text" }, Gce = {
  key: 7,
  class: "fe-ppage__state fe-ppage__state--ok",
  "data-testid": "public-page-done"
}, Xce = { class: "fe-ppage__state-title" }, Jce = { class: "fe-surface__text" }, Zce = {
  key: 8,
  class: "fe-ppage__state",
  "data-testid": "public-page-error"
}, Qce = { class: "fe-ppage__state-title" }, ede = {
  key: 0,
  class: "fe-ppage__error"
}, tde = {
  key: 9,
  class: "fe-ppage__state",
  "data-testid": "public-page-unavailable"
}, nde = { class: "fe-ppage__state-title" }, ade = { class: "fe-surface__text fe-surface__text--muted" }, ide = { class: "fe-ppage__foot" }, ode = {
  key: 0,
  class: "fe-ppage__footline",
  "data-testid": "public-footer-text"
}, rde = {
  key: 1,
  class: "fe-ppage__footmark",
  "data-testid": "public-footer-powered"
}, sde = ["src"], wA = /* @__PURE__ */ lt({
  __name: "PublicShell",
  props: {
    status: {},
    locale: {},
    theme: {},
    brandName: {},
    logoUrl: {},
    accentStyle: {},
    footerText: {},
    hidePoweredBy: { type: Boolean },
    layout: {},
    badge: {},
    title: {},
    subject: {},
    expiresAt: {},
    visitsLeft: {},
    pinMax: {},
    pinBusy: { type: Boolean },
    pinFailure: {},
    lockMessage: {},
    failure: {},
    embedded: { type: Boolean }
  },
  emits: ["pin", "retry", "update:locale"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatDate: r, dir: l } = ht(() => n.locale), { pt: c } = rb(() => String(n.locale)), p = A(() => n.status === "ready"), m = A(() => p.value ? n.layout ?? "form" : "gate"), v = A(
      () => n.theme === "dark" ? "fe--theme-dark" : n.theme === "light" ? "fe--theme-light" : ""
    ), x = A(() => {
      if (!n.expiresAt) return "";
      const T = Date.parse(n.expiresAt);
      return Number.isFinite(T) ? c("expires", { when: r(T, { time: !0 }) }) : "";
    }), w = A(() => {
      const T = n.visitsLeft;
      return T == null || !Number.isFinite(T) ? "" : c("visits_left", { count: T });
    }), $ = A(() => n.status === "pin" ? "lock" : n.status === "accepted" || n.status === "done" ? "check" : n.status === "loading" ? "loading" : p.value ? n.badge ?? "" : "alert"), k = A(
      () => $.value === "check" ? "fe-ppage__badge--ok" : $.value === "alert" ? "fe-ppage__badge--err" : ""
    ), b = A(() => !n.logoUrl && n.brandName === pp);
    function C(T) {
      return c("language_from", { app: T });
    }
    return (T, E) => (f(), h("div", {
      class: Re(["fe fe-ppage", [v.value, `fe-ppage--${m.value}`]]),
      dir: u(l),
      style: Yt(e.accentStyle),
      "data-testid": "public-page",
      "data-state": e.status,
      "data-layout": m.value
    }, [
      d("header", Mce, [
        e.logoUrl ? (f(), h("img", {
          key: 0,
          class: "fe-ppage__logo",
          src: e.logoUrl,
          alt: e.brandName
        }, null, 8, Pce)) : b.value ? (f(), Ge(n2, {
          key: 1,
          class: "fe-ppage__logo"
        })) : O("", !0),
        d("span", Oce, y(e.brandName), 1)
      ]),
      (f(), Ge(Ki(e.embedded ? "div" : "main"), { class: "fe-ppage__card" }, {
        default: mt(() => [
          $.value ? (f(), h("div", {
            key: 0,
            class: Re(["fe-ppage__badge", k.value]),
            "data-testid": "public-page-badge",
            "data-badge": $.value,
            "aria-hidden": "true"
          }, [
            $.value === "loading" ? (f(), h("span", Dce)) : (f(), h("svg", {
              key: 1,
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": $.value === "check" ? 2 : 1.8,
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              $.value === "lock" ? (f(), h(Te, { key: 0 }, [
                E[3] || (E[3] = d("rect", {
                  x: "4.5",
                  y: "10.5",
                  width: "15",
                  height: "9.5",
                  rx: "2"
                }, null, -1)),
                E[4] || (E[4] = d("path", { d: "M8 10.5V7a4 4 0 0 1 8 0v3.5" }, null, -1)),
                E[5] || (E[5] = d("path", { d: "M12 14.5v2" }, null, -1))
              ], 64)) : $.value === "check" ? (f(), h("path", Nce)) : $.value === "alert" ? (f(), h(Te, { key: 2 }, [
                E[6] || (E[6] = d("path", { d: "M10.3 4.2 2.6 17.9a2 2 0 0 0 1.7 3h15.4a2 2 0 0 0 1.7-3L13.7 4.2a2 2 0 0 0-3.4 0z" }, null, -1)),
                E[7] || (E[7] = d("path", { d: "M12 9.5v4.5" }, null, -1)),
                E[8] || (E[8] = d("path", { d: "M12 17.4h.01" }, null, -1))
              ], 64)) : $.value === "folder" ? (f(), h(Te, { key: 3 }, [
                E[9] || (E[9] = d("path", { d: "M3.5 7a2 2 0 0 1 2-2h4l2 2h7a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2V7z" }, null, -1)),
                E[10] || (E[10] = d("path", { d: "M12 10.5V16" }, null, -1)),
                E[11] || (E[11] = d("path", { d: "M9.5 13.5 12 16l2.5-2.5" }, null, -1))
              ], 64)) : (f(), h(Te, { key: 4 }, [
                E[12] || (E[12] = d("path", { d: "M7 3.5h7l4 4V20a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 20V5A1.5 1.5 0 0 1 7.5 3.5z" }, null, -1)),
                E[13] || (E[13] = d("path", { d: "M13.5 3.5V8H18" }, null, -1)),
                E[14] || (E[14] = d("path", { d: "M12 11.5V17" }, null, -1)),
                E[15] || (E[15] = d("path", { d: "M9.5 14.5 12 17l2.5-2.5" }, null, -1))
              ], 64))
            ], 8, Rce))
          ], 10, Lce)) : O("", !0),
          (e.title || e.subject) && p.value ? (f(), h("header", Ice, [
            e.title ? (f(), h("h1", Bce, [
              d("bdi", null, y(e.title), 1)
            ])) : O("", !0),
            e.subject ? (f(), h("p", Fce, y(e.subject), 1)) : O("", !0)
          ])) : O("", !0),
          (x.value || w.value) && p.value ? (f(), h("p", Uce, [
            x.value ? (f(), h("span", Hce, y(x.value), 1)) : O("", !0),
            x.value && w.value ? (f(), h("span", Kce, "·")) : O("", !0),
            w.value ? (f(), h("span", Vce, y(w.value), 1)) : O("", !0)
          ])) : O("", !0),
          e.status === "loading" ? (f(), h("p", jce, y(u(i)("plugin.page.loading")), 1)) : e.status === "pin" ? (f(), Ge($ce, {
            key: 4,
            locale: e.locale,
            busy: e.pinBusy,
            failure: e.pinFailure,
            "lock-message": e.lockMessage,
            "max-length": e.pinMax ?? void 0,
            onSubmit: E[0] || (E[0] = (R) => a("pin", R))
          }, null, 8, ["locale", "busy", "failure", "lock-message", "max-length"])) : p.value ? On(T.$slots, "default", { key: 5 }) : e.status === "accepted" ? (f(), h("div", qce, [
            On(T.$slots, "accepted", {}, () => [
              d("h2", Wce, y(u(i)("plugin.page.accepted_title")), 1),
              d("p", Yce, y(u(i)("plugin.page.accepted_text")), 1)
            ])
          ])) : e.status === "done" ? (f(), h("div", Gce, [
            On(T.$slots, "done", {}, () => [
              d("h2", Xce, y(u(i)("plugin.page.done_title")), 1),
              d("p", Jce, y(u(i)("plugin.page.done_text")), 1)
            ])
          ])) : e.status === "error" ? (f(), h("div", Zce, [
            d("h2", Qce, y(u(i)("plugin.page.error_title")), 1),
            e.failure ? (f(), h("p", ede, y(e.failure), 1)) : O("", !0),
            d("button", {
              type: "button",
              class: "fe-btn fe-btn--primary",
              onClick: E[1] || (E[1] = (R) => a("retry"))
            }, y(u(i)("plugin.page.retry")), 1)
          ])) : (f(), h("div", tde, [
            d("h2", nde, y(u(i)("plugin.page.unavailable_title")), 1),
            d("p", ade, y(u(i)("plugin.page.unavailable_text")), 1)
          ])),
          On(T.$slots, "extra")
        ]),
        _: 3
      })),
      d("footer", ide, [
        Ze(Cce, {
          "model-value": String(e.locale),
          "plugin-note": C,
          "onUpdate:modelValue": E[2] || (E[2] = (R) => a("update:locale", R))
        }, null, 8, ["model-value"]),
        e.footerText ? (f(), h("p", ode, y(e.footerText), 1)) : O("", !0),
        e.hidePoweredBy ? O("", !0) : (f(), h("span", rde, [
          e.logoUrl ? (f(), h("img", {
            key: 0,
            src: e.logoUrl,
            alt: ""
          }, null, 8, sde)) : b.value ? (f(), Ge(n2, { key: 1 })) : O("", !0),
          Ht(" " + y(u(c)("served_by", { name: e.brandName })), 1)
        ]))
      ])
    ], 14, zce));
  }
}), lde = {
  key: 0,
  class: "fe-ppage__actions"
}, ude = {
  key: 1,
  class: "fe-ppage__appfiles",
  "data-testid": "public-page-files"
}, cde = { class: "fe-surface__text" }, dde = {
  key: 0,
  class: "fe-ppage__filesize"
}, fde = ["href", "title", "data-testid"], pde = {
  key: 1,
  class: "fe-ppage__file-one",
  "data-testid": "public-share-unavailable"
}, hde = {
  key: 0,
  class: "fe-surface__text"
}, mde = {
  class: "fe-surface__text fe-surface__text--muted",
  role: "status"
}, vde = {
  key: 2,
  class: "fe-ppage__file-one",
  "data-testid": "public-share-folder"
}, yde = {
  key: 0,
  class: "fe-surface__text"
}, gde = {
  key: 1,
  class: "fe-ppage__crumbs",
  "data-testid": "public-share-crumbs"
}, bde = { class: "fe-ppage__crumb" }, kde = {
  key: 2,
  class: "fe-ppage__files",
  "data-testid": "public-share-entries"
}, wde = ["data-dir"], _de = ["data-testid", "onClick"], xde = ["href", "data-testid"], Sde = {
  key: 2,
  class: "fe-ppage__filesize"
}, $de = {
  key: 3,
  class: "fe-ppage__filesize"
}, Tde = { class: "fe-ppage__actions" }, Ade = ["href"], Ede = ["href"], Cde = {
  key: 3,
  class: "fe-ppage__file-one",
  "data-testid": "public-share-file"
}, zde = ["src", "alt"], Mde = {
  class: "fe-surface__text fe-surface__text--muted",
  "data-testid": "public-share-fileline"
}, Pde = { key: 0 }, Ode = {
  key: 1,
  class: "fe-ppage__filesize"
}, Lde = ["href"], _A = /* @__PURE__ */ lt({
  __name: "PublicShareBody",
  props: {
    link: {},
    locale: {},
    theme: {}
  },
  emits: ["navigate"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatSize: r, formatDate: l } = ht(() => n.locale), { pt: c } = rb(() => String(n.locale)), p = A(() => n.link.info.value), m = A(() => {
      var C;
      return ((C = p.value) == null ? void 0 : C.kind) ?? "file";
    }), v = A(() => {
      var C;
      return ((C = p.value) == null ? void 0 : C.node) ?? null;
    }), x = A(() => {
      var C;
      return ((C = p.value) == null ? void 0 : C.app) ?? null;
    }), w = A(() => {
      var C;
      return ((C = p.value) == null ? void 0 : C.entries) ?? [];
    }), $ = A(() => {
      var C;
      return ((C = p.value) == null ? void 0 : C.unavailable) === !0;
    }), k = A(() => {
      var C;
      return (((C = v.value) == null ? void 0 : C.mime) ?? "").startsWith("image/");
    }), b = A(() => {
      var E;
      const C = (((E = p.value) == null ? void 0 : E.path) ?? "").replace(/\/+$/, "");
      if (!C) return null;
      const T = C.lastIndexOf("/");
      return T <= 0 ? "" : C.slice(0, T);
    });
    return (C, T) => {
      var E, R, z, D, U, H, L, P, K, N, J, j, re, q;
      return m.value === "app" ? (f(), h(Te, { key: 0 }, [
        Ze(Yp, {
          conv: e.link.conv,
          locale: e.locale,
          theme: e.theme,
          "file-url": e.link.resolveFile,
          toast: e.link.toast.value,
          layout: "page",
          "page-height": "min(80vh, 1000px)"
        }, null, 8, ["conv", "locale", "theme", "file-url", "toast"]),
        e.link.conv.footer.value.length ? (f(), h("div", lde, [
          Ze(Gp, {
            conv: e.link.conv,
            locale: e.locale,
            "testid-prefix": "public-page"
          }, null, 8, ["conv", "locale"])
        ])) : O("", !0),
        (R = (E = x.value) == null ? void 0 : E.files) != null && R.length ? (f(), h("section", ude, [
          (f(!0), h(Te, null, nt(((z = x.value) == null ? void 0 : z.files) ?? [], (le) => (f(), h("div", {
            key: le.ref,
            class: "fe-ppage__file-one fe-ppage__appfile"
          }, [
            d("p", cde, [
              d("strong", null, y(u(da)(le.name)), 1),
              le.size ? (f(), h("span", dde, " · " + y(u(r)(le.size)), 1)) : O("", !0)
            ]),
            d("a", {
              class: "fe-btn",
              href: e.link.fileDownloadUrl(le.ref),
              download: "",
              title: u(i)("plugin.page.open_file", { name: u(da)(le.name) }),
              "data-testid": `public-page-file-${le.ref}`
            }, y(u(i)("ctx.download")), 9, fde)
          ]))), 128))
        ])) : O("", !0)
      ], 64)) : $.value ? (f(), h("div", pde, [
        (D = v.value) != null && D.name ? O("", !0) : (f(), h("p", hde, [
          d("strong", null, y(u(da)(((U = p.value) == null ? void 0 : U.subject) ?? "")), 1)
        ])),
        d("p", mde, y(u(c)("err_unavailable_body")), 1)
      ])) : m.value === "folder" ? (f(), h("div", vde, [
        (H = v.value) != null && H.name ? O("", !0) : (f(), h("p", yde, [
          d("strong", null, y(u(da)(((L = p.value) == null ? void 0 : L.subject) ?? "")), 1)
        ])),
        (P = p.value) != null && P.path ? (f(), h("nav", gde, [
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--sm",
            onClick: T[0] || (T[0] = (le) => a("navigate", b.value ?? ""))
          }, y(u(c)("folder_up")), 1),
          d("span", bde, y(u(da)(((K = p.value) == null ? void 0 : K.path) ?? "")), 1)
        ])) : O("", !0),
        w.value.length ? (f(), h("ul", kde, [
          (f(!0), h(Te, null, nt(w.value, (le) => (f(), h("li", {
            key: le.path,
            class: "fe-ppage__file",
            "data-dir": le.is_dir ? "1" : void 0
          }, [
            le.is_dir ? (f(), h("button", {
              key: 0,
              type: "button",
              class: "fe-ppage__entry",
              "data-testid": `public-entry-${le.name}`,
              onClick: (ve) => a("navigate", le.path)
            }, [
              d("bdi", null, y(u(da)(le.name)), 1)
            ], 8, _de)) : (f(), h("a", {
              key: 1,
              href: le.url || e.link.downloadUrl({ path: le.path }),
              class: "fe-ppage__entry",
              "data-testid": `public-entry-${le.name}`,
              download: ""
            }, [
              d("bdi", null, y(u(da)(le.name)), 1)
            ], 8, xde)),
            !le.is_dir && le.size !== void 0 ? (f(), h("span", Sde, y(u(r)(le.size)), 1)) : O("", !0),
            le.modified ? (f(), h("span", $de, y(u(l)(le.modified)), 1)) : O("", !0)
          ], 8, wde))), 128))
        ])) : O("", !0),
        d("div", Tde, [
          d("a", {
            class: "fe-btn fe-btn--primary",
            href: e.link.downloadUrl({ zip: !0 }),
            "data-testid": "public-share-zip"
          }, y(u(c)("folder_zip")), 9, Ade),
          w.value.length ? O("", !0) : (f(), h("a", {
            key: 0,
            class: "fe-btn",
            href: e.link.noJsUrl(),
            "data-testid": "public-share-browse"
          }, y(u(c)("browse")), 9, Ede))
        ])
      ])) : (f(), h("div", Cde, [
        k.value ? (f(), h("img", {
          key: 0,
          class: "fe-ppage__shot",
          src: e.link.downloadUrl(),
          alt: u(da)(((N = v.value) == null ? void 0 : N.name) ?? "")
        }, null, 8, zde)) : O("", !0),
        d("p", Mde, [
          (J = v.value) != null && J.name ? O("", !0) : (f(), h("strong", Pde, y(u(da)(((j = p.value) == null ? void 0 : j.subject) ?? "")), 1)),
          ((re = v.value) == null ? void 0 : re.size) !== void 0 ? (f(), h("span", Ode, y(u(r)((q = v.value) == null ? void 0 : q.size)), 1)) : O("", !0)
        ]),
        d("a", {
          class: "fe-btn fe-btn--primary",
          href: e.link.downloadUrl(),
          "data-testid": "public-share-download"
        }, y(u(i)("ctx.download")), 9, Lde)
      ]));
    };
  }
}), Dde = {
  class: "fe-pdrop",
  "data-testid": "public-request"
}, Rde = {
  key: 0,
  class: "fe-surface__text",
  "data-testid": "public-request-folder"
}, Nde = {
  class: "fe-surface__text fe-surface__text--muted",
  "data-testid": "public-request-lead"
}, Ide = {
  key: 1,
  class: "fe-pdrop__who",
  "data-testid": "public-request-name"
}, Bde = { class: "fe-pdrop__wholabel" }, Fde = ["maxlength", "placeholder", "disabled"], Ude = ["onKeydown"], Hde = { class: "fe-pdrop__lead" }, Kde = {
  key: 0,
  class: "fe-surface__text fe-surface__text--muted"
}, Vde = ["accept", "disabled"], jde = {
  key: 2,
  class: "fe-ppage__meta",
  "data-testid": "public-request-limits"
}, qde = {
  key: 0,
  "aria-hidden": "true"
}, Wde = {
  key: 3,
  class: "fe-pdrop__list",
  "data-testid": "public-request-uploads"
}, Yde = ["data-state"], Gde = { class: "fe-pdrop__name" }, Xde = { class: "fe-ppage__filesize" }, Jde = ["value"], Zde = {
  class: "fe-pdrop__saving",
  role: "status"
}, Qde = {
  key: 2,
  class: "fe-pdrop__ok"
}, efe = {
  key: 3,
  class: "fe-pdrop__unconfirmed",
  role: "status"
}, tfe = {
  key: 4,
  class: "fe-surface__error"
}, nfe = /* @__PURE__ */ lt({
  __name: "PublicRequestBody",
  props: {
    info: {},
    uploads: {},
    locale: {},
    disabled: { type: Boolean },
    hideFolder: { type: Boolean }
  },
  emits: ["files"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = S(""), r = A(() => {
      var R, z;
      return ((z = (R = n.info) == null ? void 0 : R.limits) == null ? void 0 : z.ask_name) === !0;
    });
    function l(R) {
      a("files", R, r.value ? i.value.trim() : "");
    }
    const { formatSize: c } = ht(() => n.locale), { pt: p } = rb(() => String(n.locale)), m = A(() => {
      var z, D;
      const R = (D = (z = n.info) == null ? void 0 : z.limits) == null ? void 0 : D.name_max;
      return typeof R == "number" && R > 0 ? R : void 0;
    }), v = S(null), x = S(!1), w = A(() => {
      var R;
      return ((R = n.info) == null ? void 0 : R.limits) ?? {};
    }), $ = A(() => {
      const R = w.value.allowed_ext ?? [];
      return R.length ? R.map((z) => `.${z.replace(/^\./, "")}`).join(",") : void 0;
    }), k = A(() => {
      var H;
      const R = [], z = w.value.max_file_size_mb;
      z && z > 0 && R.push(p("drop_limit_size", { mb: z }));
      const D = w.value.allowed_ext ?? [];
      D.length && R.push(p("drop_limit_ext", { types: D.map((L) => L.toUpperCase()).join(", ") }));
      const U = (H = n.info) == null ? void 0 : H.uploads_left;
      return U != null && Number.isFinite(U) && R.push(p("files_left", { count: U })), R;
    }), b = A(() => {
      var z;
      const R = (z = n.info) == null ? void 0 : z.uploads_left;
      return R != null && Number.isFinite(R) && R <= 0;
    });
    function C() {
      var R;
      n.disabled || b.value || (R = v.value) == null || R.click();
    }
    function T(R) {
      const z = R.target, D = Array.from(z.files ?? []);
      D.length && l(D), z.value = "";
    }
    function E(R) {
      var D;
      if (x.value = !1, n.disabled || b.value) return;
      const z = Array.from(((D = R.dataTransfer) == null ? void 0 : D.files) ?? []);
      z.length && l(z);
    }
    return (R, z) => {
      var D, U;
      return f(), h("div", Dde, [
        (D = e.info) != null && D.folder && !e.hideFolder ? (f(), h("p", Rde, [
          d("strong", null, y((U = e.info) == null ? void 0 : U.folder), 1)
        ])) : O("", !0),
        d("p", Nde, y(u(p)("drop_sub")), 1),
        r.value && !b.value ? (f(), h("label", Ide, [
          d("span", Bde, y(u(p)("drop_name_label")), 1),
          dn(d("input", {
            "onUpdate:modelValue": z[0] || (z[0] = (H) => i.value = H),
            class: "fe-pdrop__whoinput",
            type: "text",
            maxlength: m.value,
            autocomplete: "name",
            placeholder: u(p)("drop_name_ph"),
            disabled: e.disabled,
            "data-testid": "public-request-name-input"
          }, null, 8, Fde), [
            [_n, i.value]
          ])
        ])) : O("", !0),
        d("div", {
          class: Re(["fe-pdrop__zone", { "is-over": x.value, "is-disabled": e.disabled || b.value }]),
          role: "button",
          tabindex: "0",
          "data-testid": "public-request-drop",
          onClick: C,
          onKeydown: [
            Ca(yt(C, ["prevent"]), ["enter"]),
            Ca(yt(C, ["prevent"]), ["space"])
          ],
          onDragover: z[1] || (z[1] = yt((H) => x.value = !0, ["prevent"])),
          onDragleave: z[2] || (z[2] = (H) => x.value = !1),
          onDrop: yt(E, ["prevent"])
        }, [
          z[3] || (z[3] = d("svg", {
            class: "fe-pdrop__icon",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.7",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            d("path", { d: "M4 14.9A7 7 0 1 1 15.7 8h1.8a4.5 4.5 0 0 1 2.5 8.2" }),
            d("path", { d: "M12 12v9" }),
            d("path", { d: "m16 16-4-4-4 4" })
          ], -1)),
          d("p", Hde, y(b.value ? u(p)("request_full") : u(p)("drop_zone_big")), 1),
          b.value ? O("", !0) : (f(), h("p", Kde, y(u(p)("drop_zone_hint")), 1)),
          d("input", {
            ref_key: "input",
            ref: v,
            class: "fe-pdrop__input",
            type: "file",
            multiple: "",
            accept: $.value,
            disabled: e.disabled || b.value,
            "data-testid": "public-request-input",
            onChange: T
          }, null, 40, Vde)
        ], 42, Ude),
        k.value.length ? (f(), h("p", jde, [
          (f(!0), h(Te, null, nt(k.value, (H, L) => (f(), h(Te, { key: L }, [
            L ? (f(), h("span", qde, "·")) : O("", !0),
            d("span", null, y(H), 1)
          ], 64))), 128))
        ])) : O("", !0),
        e.uploads.length ? (f(), h("ul", Wde, [
          (f(!0), h(Te, null, nt(e.uploads, (H, L) => (f(), h("li", {
            key: `${H.name}-${L}`,
            class: "fe-pdrop__item",
            "data-state": H.state
          }, [
            d("span", Gde, [
              d("bdi", null, y(u(da)(H.name)), 1)
            ]),
            d("span", Xde, y(u(c)(H.size)), 1),
            H.state === "sending" ? (f(), h("progress", {
              key: 0,
              class: "fe-pdrop__bar",
              max: 100,
              value: H.percent >= 0 ? H.percent : void 0
            }, null, 8, Jde)) : H.state === "saving" ? (f(), h(Te, { key: 1 }, [
              z[4] || (z[4] = d("progress", {
                class: "fe-pdrop__bar",
                max: 100
              }, null, -1)),
              d("span", Zde, y(u(p)("upload_saving")), 1)
            ], 64)) : H.state === "done" ? (f(), h("span", Qde, y(u(p)("upload_done")), 1)) : H.state === "unconfirmed" ? (f(), h("span", efe, y(H.error || u(p)("upload_unanswered")), 1)) : (f(), h("span", tfe, y(H.error || u(p)("drop_err_generic")), 1))
          ], 8, Yde))), 128))
        ])) : O("", !0)
      ]);
    };
  }
}), Whe = /* @__PURE__ */ lt({
  __name: "PublicLinkPage",
  props: {
    kind: {},
    token: {},
    base: {},
    locale: {},
    theme: {}
  },
  setup(e) {
    const t = e, n = S(""), a = A(() => {
      if (t.locale) return String(t.locale);
      if (n.value) return n.value;
      const P = Aa(vp("locale"));
      return P && Vf(P) ? P : w2();
    });
    function i(P) {
      const K = Aa(P);
      !K || !Vf(K) || (n.value = K, Gr("locale", K));
    }
    const { t: r } = ht(() => a.value), l = gA({ base: t.base ?? rc(), locale: () => a.value });
    bA(l);
    const c = S(!1);
    Je(
      () => l.ready.value,
      (P) => {
        P && (c.value = !0);
      },
      { immediate: !0 }
    );
    function p(P, K = {}) {
      return kA(l.table.value, l.lang.value || a.value, P, K);
    }
    const m = t.base ?? rc(), v = FB({ base: m }), x = Nl(), w = A(() => {
      const P = t.theme && t.theme !== "auto" ? t.theme : vp("theme") || v.themeDefault.value;
      return P === "light" || P === "dark" ? P : x.value ? "dark" : "light";
    }), $ = {
      base: m,
      locale: () => a.value,
      errorText: () => r("plugin.view.error")
    }, k = t.kind === "share" ? hce(t.token ?? "", $) : null, b = t.kind === "request" ? vce(t.token ?? "", {
      ...$,
      errorText: () => p("drop_err_generic"),
      unansweredText: () => p("upload_unanswered")
    }) : null;
    function C(P) {
      return P.code === "ext" ? p("drop_err_ext", { name: P.name }) : P.code === "too_large" ? p("drop_err_too_large", { name: P.name, mb: P.mb }) : P.count <= 0 ? p("request_full") : p("drop_err_too_many", { count: P.count });
    }
    const T = k ?? b, E = A(() => (k == null ? void 0 : k.info.value) ?? null), R = A(() => (b == null ? void 0 : b.info.value) ?? null), z = A(() => {
      var N, J, j, re, q;
      const P = (N = E.value) == null ? void 0 : N.app, K = Xt((J = k == null ? void 0 : k.conv.current.value) == null ? void 0 : J.title, a.value);
      return P ? K || Xt(P.title, a.value) || "" : da(((re = (j = E.value) == null ? void 0 : j.node) == null ? void 0 : re.name) || ((q = R.value) == null ? void 0 : q.folder) || "");
    }), D = A(() => {
      var K;
      const P = da(((K = T.info.value) == null ? void 0 : K.subject) ?? "");
      return P && P !== z.value ? P : "";
    }), U = A(
      () => {
        var P, K, N;
        return mA(((P = E.value) == null ? void 0 : P.kind) ?? (b ? "drop" : ""), {
          list: (((N = (K = E.value) == null ? void 0 : K.entries) == null ? void 0 : N.length) ?? 0) > 0
        });
      }
    ), H = A(() => {
      var K;
      if (b) return "";
      const P = (K = E.value) == null ? void 0 : K.kind;
      return P === "folder" ? "folder" : P === "app" ? "" : "file";
    });
    function L(P) {
      T.load(P ? `?path=${encodeURIComponent(P)}` : "");
    }
    return Je(z, (P) => {
      P && typeof document < "u" && (document.title = P);
    }), Je(
      a,
      (P) => {
        typeof document < "u" && (document.documentElement.lang = P);
      },
      { immediate: !0 }
    ), Je(a, () => {
      var P;
      T.status.value === "ready" && ((P = E.value) == null ? void 0 : P.kind) === "app" && (T.conv.current.value ? T.conv.post("change") : T.load());
    }), jt(() => {
      if (v.load(), !t.token) {
        T.status.value = "not_found";
        return;
      }
      T.load();
    }), (P, K) => {
      var N, J, j, re;
      return f(), Ge(wA, {
        status: c.value ? u(T).status.value : "loading",
        locale: a.value,
        theme: w.value,
        "brand-name": u(v).name.value,
        "logo-url": u(v).logo.value,
        "accent-style": u(v).accentStyle.value,
        "footer-text": u(v).footerText.value,
        "hide-powered-by": u(v).hidePoweredBy.value,
        layout: U.value,
        badge: H.value,
        title: z.value,
        subject: D.value,
        "expires-at": ((N = u(T).info.value) == null ? void 0 : N.expires_at) ?? null,
        "visits-left": ((J = E.value) == null ? void 0 : J.visits_left) ?? ((j = R.value) == null ? void 0 : j.uploads_left) ?? null,
        "pin-max": ((re = u(T).info.value) == null ? void 0 : re.pin_max) ?? null,
        "pin-busy": u(T).pinBusy.value,
        "pin-failure": u(T).pinFailure.value,
        "lock-message": u(T).lockMessage.value,
        failure: u(T).failure.value,
        onPin: K[1] || (K[1] = (q) => u(T).submitPin(q)),
        onRetry: K[2] || (K[2] = () => u(T).load()),
        "onUpdate:locale": i
      }, {
        default: mt(() => [
          u(k) ? (f(), Ge(_A, {
            key: 0,
            link: u(k),
            locale: a.value,
            theme: w.value,
            onNavigate: L
          }, null, 8, ["link", "locale", "theme"])) : u(b) ? (f(), Ge(nfe, {
            key: 1,
            info: R.value,
            uploads: u(b).uploads.value,
            locale: a.value,
            "hide-folder": "",
            onFiles: K[0] || (K[0] = (q, le) => u(b).upload(q, { name: le, refusedText: C }))
          }, null, 8, ["info", "uploads", "locale"])) : O("", !0)
        ]),
        _: 1
      }, 8, ["status", "locale", "theme", "brand-name", "logo-url", "accent-style", "footer-text", "hide-powered-by", "layout", "badge", "title", "subject", "expires-at", "visits-left", "pin-max", "pin-busy", "pin-failure", "lock-message", "failure"]);
    };
  }
}), afe = {
  class: "fe-ppreview",
  inert: "",
  "data-testid": "public-link-preview"
}, Yhe = /* @__PURE__ */ lt({
  __name: "PublicLinkPreview",
  props: {
    brandName: {},
    logoUrl: {},
    accent: {},
    footerText: {},
    hidePoweredBy: { type: Boolean },
    locale: {},
    theme: {},
    sample: {}
  },
  setup(e) {
    const t = e, n = A(() => t.sample ?? { name: "report-2026.pdf", size: 124e4, mime: "application/pdf" }), a = A(() => ({
      kind: "file",
      node: { name: n.value.name, size: n.value.size, mime: n.value.mime ?? "application/pdf" }
    })), i = A(
      () => ({
        info: S(a.value),
        downloadUrl: () => "#",
        noJsUrl: () => "#"
      })
    ), r = A(() => {
      var l;
      return ((l = t.brandName) == null ? void 0 : l.trim()) || pp;
    });
    return bA(gA({ base: rc(), locale: () => String(t.locale) })), (l, c) => {
      var p, m;
      return f(), h("div", afe, [
        Ze(wA, {
          status: "ready",
          locale: e.locale,
          theme: e.theme ?? "light",
          "brand-name": r.value,
          "logo-url": ((p = e.logoUrl) == null ? void 0 : p.trim()) || "",
          "accent-style": u(b$)(e.accent),
          "footer-text": ((m = e.footerText) == null ? void 0 : m.trim()) || "",
          "hide-powered-by": e.hidePoweredBy === !0,
          layout: u(mA)("file"),
          badge: "file",
          title: n.value.name,
          embedded: ""
        }, {
          default: mt(() => [
            Ze(_A, {
              link: i.value,
              locale: e.locale,
              theme: e.theme ?? "light"
            }, null, 8, ["link", "locale", "theme"])
          ]),
          _: 1
        }, 8, ["locale", "theme", "brand-name", "logo-url", "accent-style", "footer-text", "hide-powered-by", "layout", "title"])
      ]);
    };
  }
}), ife = {
  key: 0,
  class: "fe-apppage__bar"
}, ofe = {
  class: "fe-apppage__title",
  "data-testid": "plugin-page-title"
}, rfe = ["title"], sfe = ["href"], lfe = {
  key: 0,
  class: "fe-surface__text",
  role: "status"
}, ufe = {
  class: "fe-surface__text fe-surface__text--muted",
  "data-testid": "plugin-page-loading"
}, cfe = {
  key: 1,
  class: "fe-surface__text fe-surface__text--muted",
  "data-testid": "plugin-page-loading"
}, dfe = ["data-job"], ffe = {
  class: "fe-apppage__state-title",
  "data-testid": "plugin-page-job-title"
}, pfe = ["role"], hfe = { class: "fe-apppage__state-actions" }, mfe = ["href"], vfe = ["href"], yfe = {
  key: 4,
  class: "fe-apppage__state",
  "data-testid": "plugin-page-done"
}, gfe = { class: "fe-apppage__state-title" }, bfe = { class: "fe-surface__text" }, kfe = { class: "fe-apppage__state-actions" }, wfe = ["href"], _fe = {
  key: 5,
  class: "fe-apppage__state",
  "data-testid": "plugin-page-error"
}, xfe = { class: "fe-apppage__state-title" }, Sfe = {
  key: 0,
  class: "fe-surface__error"
}, $fe = { class: "fe-apppage__state-actions" }, Tfe = ["href"], Afe = {
  key: 4,
  class: "fe-apppage__foot"
}, Ghe = /* @__PURE__ */ lt({
  __name: "PluginPageView",
  props: {
    locale: {},
    theme: {},
    api: {},
    userName: {},
    plugin: {},
    view: {},
    path: {},
    storages: {},
    startAt: {},
    backHref: {},
    opsHref: {},
    mountBase: {},
    frame: {},
    section: {}
  },
  emits: ["op", "section"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, { t: r } = ht(() => a.locale), l = A(() => a.frame === "embedded"), c = A(() => l.value ? "div" : "main"), p = S("loading"), m = S(""), v = S(""), x = S("running"), w = S(""), $ = S(/* @__PURE__ */ new Set());
    function k(ce) {
      const se = b_(ce, {
        plugin: a.plugin,
        base: a.mountBase,
        placementOf: (fe) => $.value.has(fe) ? "page" : void 0
      });
      if (!se.href) return !1;
      try {
        return window.location.assign(se.href), !0;
      } catch {
        return !1;
      }
    }
    function b(ce) {
      if (ce.status === "done") {
        w.value = ce.message ?? "";
        const se = FS(ce);
        if (se && k(se.open)) {
          x.value = "opening";
          return;
        }
        x.value = "done";
        return;
      }
      w.value = Xf(ce, r).text, x.value = "failed";
    }
    const C = rx({}, a.api, { onSettled: b });
    function T(ce) {
      var se;
      x.value = "running", w.value = "", (se = a.api.endpoints) != null && se.opsList && C.register(ce);
    }
    const E = A(() => {
      switch (x.value) {
        case "done":
          return r("plugin.page_view.finished_title");
        case "failed":
          return r("plugin.page_view.failed_title");
        case "opening":
          return r("plugin.page_view.opening_title");
        default:
          return r("plugin.page_view.queued_title");
      }
    }), R = A(() => x.value === "running" ? r("plugin.page_view.queued_text") : x.value === "done" ? w.value || r("plugin.page_view.finished_text") : w.value), z = Wp(
      {
        api: a.api,
        plugin: a.plugin,
        view: a.view,
        path: () => a.path,
        locale: () => a.locale,
        errorText: () => r("plugin.view.error")
      },
      {
        // ⚠ `onOp` fires BEFORE `onDone` (usePluginSurface posts them in that
        // order), so the queued state has to be set after both — otherwise
        // `onDone` would overwrite it with "finished" and the person would never
        // see that a job is running.
        /**
         * v3 §3.0 — "go to this file, and start that screen on it".
         *
         * ⚠ A real navigation, not a tab: this IS a whole page, and the person
         * asked to be taken to a document. The address is the explorer deep link
         * a notification already uses, so the placement question is answered
         * where it is answerable — the explorer knows which of the plugin's
         * views is a `page` and opens that one in its own tab.
         */
        onOpen: (ce) => {
          const se = b_(ce, { plugin: a.plugin, base: a.mountBase });
          if (se.href)
            try {
              if (se.newTab) {
                const fe = window.open(se.href, "_blank");
                fe ? fe.opener = null : window.location.assign(se.href);
              } else
                window.location.assign(se.href);
            } catch {
            }
        },
        onOp: (ce) => {
          i("op", ce), p.value = "queued", T(ce);
        },
        onDone: () => {
          p.value !== "queued" && (p.value = "done");
        },
        onToast: (ce) => v.value = ce
      }
    ), D = z.current, U = A(() => {
      var ce;
      return Xt((ce = D.value) == null ? void 0 : ce.title, a.locale) || a.view;
    }), H = S(a.section ?? ""), L = A(() => {
      var ce;
      return ((ce = D.value) == null ? void 0 : ce.sections) ?? [];
    }), P = A(() => {
      var ce;
      return ((ce = D.value) == null ? void 0 : ce.section) || H.value;
    });
    function K(ce) {
      !ce || ce === P.value || (H.value = ce, i("section", ce), N());
    }
    Je(
      () => a.section,
      (ce) => {
        const se = ce ?? "";
        se !== H.value && (H.value = se, N());
      }
    );
    async function N() {
      var ce;
      D.value || (p.value = "loading"), m.value = "";
      try {
        const se = H.value ? await a.api.pluginView(a.plugin, a.view, a.path, H.value) : await a.api.pluginView(a.plugin, a.view, a.path);
        if (!(se != null && se.surface)) {
          m.value = r("plugin.view.error"), p.value = "error";
          return;
        }
        z.setSurface(se.surface), p.value = "surface";
        const fe = se.surface.section ?? "";
        !H.value && fe && (H.value = fe, i("section", fe, { replace: !0 }));
      } catch (se) {
        m.value = ((ce = r.foreign) == null ? void 0 : ce.call(r, String((se == null ? void 0 : se.message) ?? ""))) || r("plugin.view.error"), p.value = "error";
      }
    }
    const J = S(null), j = S("page"), re = S(!1), q = A(
      () => a.path ? [{ path: a.path, name: a.path.split("/").pop() || a.path }] : []
    );
    async function le() {
      try {
        const ce = await a.api.pluginActions();
        $.value = new Set(
          (ce.actions ?? []).filter((_) => _.plugin === a.plugin && _.view && Qf(_.view_placement)).map((_) => _.view)
        );
        const se = ce.views.find((_) => _.plugin === a.plugin && _.id === a.view && _.ui);
        if (se != null && se.ui) {
          J.value = se.ui, j.value = se.placement === "home" ? "home" : "page";
          return;
        }
        const fe = ce.actions.find((_) => _.plugin === a.plugin && _.view === a.view && _.ui);
        fe != null && fe.ui && (J.value = fe.ui);
      } catch {
      } finally {
        re.value = !0;
      }
    }
    jt(async () => {
      await le(), J.value || N();
    }), t({ reload: N });
    const ve = A(() => {
      var se;
      let ce = !1;
      return Gc((se = z.current.value) == null ? void 0 : se.nodes, (fe) => {
        var _;
        fe.type === "pdf-fields" && ((_ = fe.props) == null ? void 0 : _.mode) !== "define" && (ce = !0);
      }), ce;
    });
    return (ce, se) => (f(), h("div", {
      class: Re(["fe fe-apppage", [
        e.theme === "dark" ? "fe--theme-dark" : e.theme === "light" ? "fe--theme-light" : "",
        { "is-doc": ve.value && !l.value, "fe-apppage--embedded": l.value }
      ]]),
      "data-testid": "plugin-page"
    }, [
      l.value ? O("", !0) : (f(), h("header", ife, [
        d("h1", ofe, y(U.value), 1),
        e.path ? (f(), h("p", {
          key: 0,
          class: "fe-apppage__path",
          title: e.path
        }, y(e.path), 9, rfe)) : O("", !0),
        e.backHref ? (f(), h("a", {
          key: 1,
          class: "fe-btn fe-apppage__back",
          href: e.backHref,
          "data-testid": "plugin-page-back"
        }, y(u(r)("plugin.page_view.back")), 9, sfe)) : O("", !0)
      ])),
      J.value ? (f(), Ge(Ki(c.value), {
        key: 1,
        class: "fe-apppage__body fe-apppage__body--ui"
      }, {
        default: mt(() => [
          Ze(Dg, {
            api: e.api,
            app: e.plugin,
            version: J.value.version,
            view: e.view,
            placement: j.value,
            ui: J.value,
            files: q.value,
            storages: e.storages,
            "start-at": e.startAt,
            locale: e.locale,
            theme: e.theme,
            title: U.value,
            "user-name": e.userName,
            onToast: se[0] || (se[0] = (fe) => v.value = fe.text),
            onOp: se[1] || (se[1] = (fe) => i("op", fe))
          }, null, 8, ["api", "app", "version", "view", "placement", "ui", "files", "storages", "start-at", "locale", "theme", "title", "user-name"]),
          v.value ? (f(), h("p", lfe, y(v.value), 1)) : O("", !0)
        ]),
        _: 1
      })) : re.value ? (f(), Ge(Ki(c.value), {
        key: 3,
        class: "fe-apppage__body"
      }, {
        default: mt(() => [
          p.value === "surface" && L.value.length ? (f(), Ge(JT, {
            key: 0,
            sections: L.value,
            active: P.value,
            locale: e.locale,
            label: U.value,
            disabled: u(z).busy.value,
            onSelect: K
          }, null, 8, ["sections", "active", "locale", "label", "disabled"])) : O("", !0),
          p.value === "loading" ? (f(), h("p", cfe, y(u(r)("plugin.view.loading")), 1)) : p.value === "surface" ? (f(), Ge(Yp, {
            key: 2,
            conv: u(z),
            locale: e.locale,
            theme: e.theme,
            api: e.api,
            plugin: e.plugin,
            storages: e.storages,
            "start-at": e.startAt,
            toast: v.value,
            layout: l.value ? "inline" : "page"
          }, null, 8, ["conv", "locale", "theme", "api", "plugin", "storages", "start-at", "toast", "layout"])) : p.value === "queued" ? (f(), h("div", {
            key: 3,
            class: "fe-apppage__state",
            "data-testid": "plugin-page-queued",
            "data-job": x.value
          }, [
            d("h2", ffe, y(E.value), 1),
            d("p", {
              class: Re(x.value === "failed" ? "fe-surface__error" : "fe-surface__text"),
              role: x.value === "failed" ? "alert" : "status",
              "data-testid": "plugin-page-job-text"
            }, y(R.value), 11, pfe),
            d("div", hfe, [
              e.opsHref ? (f(), h("a", {
                key: 0,
                class: "fe-btn fe-btn--primary",
                href: e.opsHref,
                "data-testid": "plugin-page-ops"
              }, y(u(r)("plugin.page_view.open_ops")), 9, mfe)) : O("", !0),
              e.backHref ? (f(), h("a", {
                key: 1,
                class: "fe-btn",
                href: e.backHref
              }, y(u(r)("plugin.page_view.back")), 9, vfe)) : O("", !0)
            ])
          ], 8, dfe)) : p.value === "done" ? (f(), h("div", yfe, [
            d("h2", gfe, y(u(r)("plugin.page_view.done_title")), 1),
            d("p", bfe, y(u(r)("plugin.page_view.done_text")), 1),
            d("div", kfe, [
              e.backHref ? (f(), h("a", {
                key: 0,
                class: "fe-btn fe-btn--primary",
                href: e.backHref
              }, y(u(r)("plugin.page_view.back")), 9, wfe)) : O("", !0)
            ])
          ])) : (f(), h("div", _fe, [
            d("h2", xfe, y(u(r)("plugin.page_view.error_title")), 1),
            m.value ? (f(), h("p", Sfe, y(m.value), 1)) : O("", !0),
            d("div", $fe, [
              d("button", {
                type: "button",
                class: "fe-btn",
                onClick: se[2] || (se[2] = (fe) => N())
              }, y(u(r)("plugin.page_view.retry")), 1),
              e.backHref ? (f(), h("a", {
                key: 0,
                class: "fe-btn",
                href: e.backHref
              }, y(u(r)("plugin.page_view.back")), 9, Tfe)) : O("", !0)
            ])
          ]))
        ]),
        _: 1
      })) : (f(), Ge(Ki(c.value), {
        key: 2,
        class: "fe-apppage__body"
      }, {
        default: mt(() => [
          d("p", ufe, y(u(r)("plugin.view.loading")), 1)
        ]),
        _: 1
      })),
      p.value === "surface" && u(z).footer.value.length ? (f(), h("footer", Afe, [
        Ze(Gp, {
          conv: u(z),
          locale: e.locale,
          "testid-prefix": "plugin-page"
        }, null, 8, ["conv", "locale"])
      ])) : O("", !0)
    ], 2));
  }
});
function Xhe(e) {
  const t = e.trim().toLowerCase();
  return t === "7z" ? "7z" : t.toUpperCase();
}
const Efe = {
  key: 0,
  class: "fe-connlost",
  role: "status",
  "aria-live": "polite",
  "data-testid": "connection-notice"
}, Cfe = { class: "fe-connlost__text" }, Jhe = /* @__PURE__ */ lt({
  __name: "ConnectionNotice",
  props: {
    locale: {}
  },
  setup(e) {
    const t = e, { t: n } = ht(() => t.locale ?? "en");
    return (a, i) => u(bO) ? (f(), h("div", Efe, [
      i[0] || (i[0] = d("span", {
        class: "fe-connlost__dot",
        "aria-hidden": "true"
      }, null, -1)),
      d("span", Cfe, y(u(n)("err.network")), 1)
    ])) : O("", !0);
  }
});
export {
  Oie as $,
  L7 as A,
  P7 as B,
  S3 as C,
  gi as D,
  Wi as E,
  Mhe as F,
  vle as G,
  J1 as H,
  T3 as I,
  P2 as J,
  $3 as K,
  zhe as L,
  K2 as M,
  Xfe as N,
  UO as O,
  ipe as P,
  ope as Q,
  p3 as R,
  as as S,
  rpe as T,
  spe as U,
  nx as V,
  Dc as W,
  lpe as X,
  pp as Y,
  Rie as Z,
  ta as _,
  Xt as a,
  w5 as a$,
  K$ as a0,
  Kpe as a1,
  sR as a2,
  mo as a3,
  Nl as a4,
  Jfe as a5,
  _pe as a6,
  xpe as a7,
  X4 as a8,
  Rhe as a9,
  w8 as aA,
  zg as aB,
  Fv as aC,
  hx as aD,
  xi as aE,
  zl as aF,
  qf as aG,
  qfe as aH,
  Yfe as aI,
  h$ as aJ,
  qy as aK,
  tx as aL,
  ix as aM,
  ype as aN,
  vpe as aO,
  Hx as aP,
  r4 as aQ,
  op as aR,
  lg as aS,
  q2 as aT,
  H2 as aU,
  eO as aV,
  tO as aW,
  aO as aX,
  Zfe as aY,
  X2 as aZ,
  epe as a_,
  Fm as aa,
  Boe as ab,
  qp as ac,
  sZ as ad,
  wpe as ae,
  kc as af,
  Die as ag,
  mi as ah,
  vhe as ai,
  Bhe as aj,
  Ll as ak,
  Lhe as al,
  Yi as am,
  Sle as an,
  Dhe as ao,
  WJ as ap,
  qJ as aq,
  Zf as ar,
  SS as as,
  phe as at,
  She as au,
  Nhe as av,
  fhe as aw,
  Q0 as ax,
  I2 as ay,
  Ep as az,
  Xo as b,
  oc as b$,
  Vpe as b0,
  g5 as b1,
  QI as b2,
  Za as b3,
  jo as b4,
  rhe as b5,
  ihe as b6,
  ohe as b7,
  wy as b8,
  Bv as b9,
  Jn as bA,
  os as bB,
  Np as bC,
  jx as bD,
  Nc as bE,
  u4 as bF,
  ga as bG,
  Rp as bH,
  ec as bI,
  Cf as bJ,
  So as bK,
  og as bL,
  cn as bM,
  $p as bN,
  Qoe as bO,
  $S as bP,
  Ty as bQ,
  Goe as bR,
  j_ as bS,
  _he as bT,
  $0 as bU,
  kT as bV,
  cP as bW,
  JJ as bX,
  hp as bY,
  n2 as bZ,
  VO as b_,
  dpe as ba,
  mhe as bb,
  sW as bc,
  by as bd,
  yo as be,
  Xhe as bf,
  xle as bg,
  oP as bh,
  Yoe as bi,
  p2 as bj,
  bo as bk,
  IP as bl,
  tr as bm,
  KJ as bn,
  cG as bo,
  Jhe as bp,
  cJ as bq,
  cle as br,
  XS as bs,
  Fa as bt,
  Hm as bu,
  CT as bv,
  kae as bw,
  zP as bx,
  EP as by,
  CP as bz,
  Bfe as c,
  Tp as c$,
  Uhe as c0,
  n5 as c1,
  Spe as c2,
  yX as c3,
  Xoe as c4,
  moe as c5,
  sA as c6,
  Doe as c7,
  DU as c8,
  iQ as c9,
  wA as cA,
  G4 as cB,
  U5 as cC,
  VN as cD,
  OG as cE,
  fy as cF,
  ere as cG,
  UR as cH,
  Cl as cI,
  XG as cJ,
  bie as cK,
  FR as cL,
  EN as cM,
  pT as cN,
  Yp as cO,
  Gp as cP,
  fF as cQ,
  bF as cR,
  v$ as cS,
  RS as cT,
  ST as cU,
  xp as cV,
  Ac as cW,
  Jf as cX,
  Ju as cY,
  JP as cZ,
  zT as c_,
  dhe as ca,
  fA as cb,
  yue as cc,
  hue as cd,
  pA as ce,
  mue as cf,
  vue as cg,
  Pf as ch,
  ry as ci,
  r3 as cj,
  qO as ck,
  w$ as cl,
  IF as cm,
  _c as cn,
  Roe as co,
  Xg as cp,
  yA as cq,
  Khe as cr,
  Ghe as cs,
  Cce as ct,
  uce as cu,
  Whe as cv,
  Yhe as cw,
  $ce as cx,
  nfe as cy,
  _A as cz,
  Tv as d,
  i$ as d$,
  wQ as d0,
  dx as d1,
  mZ as d2,
  wT as d3,
  E5 as d4,
  K0 as d5,
  lA as d6,
  Tle as d7,
  Hpe as d8,
  jpe as d9,
  YT as dA,
  BV as dB,
  UV as dC,
  m5 as dD,
  s5 as dE,
  a2 as dF,
  Cg as dG,
  RY as dH,
  HY as dI,
  NY as dJ,
  LY as dK,
  DY as dL,
  OY as dM,
  Cpe as dN,
  zne as dO,
  Oc as dP,
  hl as dQ,
  Il as dR,
  FJ as dS,
  Nu as dT,
  zy as dU,
  Tpe as dV,
  Lpe as dW,
  ey as dX,
  zpe as dY,
  Npe as dZ,
  KO as d_,
  Upe as da,
  GT as db,
  b$ as dc,
  Vu as dd,
  Vie as de,
  tre as df,
  oO as dg,
  rO as dh,
  cpe as di,
  QP as dj,
  g4 as dk,
  $T as dl,
  nb as dm,
  qpe as dn,
  rc as dp,
  RU as dq,
  Yy as dr,
  Gy as ds,
  Xy as dt,
  vZ as du,
  uhe as dv,
  fR as dw,
  AT as dx,
  XJ as dy,
  Q4 as dz,
  The as e,
  r$ as e$,
  VF as e0,
  bO as e1,
  tpe as e2,
  npe as e3,
  ca as e4,
  _Y as e5,
  U2 as e6,
  $J as e7,
  _T as e8,
  SJ as e9,
  Bpe as eA,
  w2 as eB,
  Cle as eC,
  qD as eD,
  ei as eE,
  _ae as eF,
  $8 as eG,
  JV as eH,
  Ife as eI,
  Hv as eJ,
  U0 as eK,
  Up as eL,
  el as eM,
  oA as eN,
  Zv as eO,
  I_ as eP,
  Kv as eQ,
  b2 as eR,
  Dle as eS,
  Jx as eT,
  Yx as eU,
  U_ as eV,
  dA as eW,
  $y as eX,
  Kie as eY,
  eoe as eZ,
  nre as e_,
  TJ as ea,
  xJ as eb,
  bS as ec,
  Jv as ed,
  Cne as ee,
  O4 as ef,
  ppe as eg,
  Joe as eh,
  _ie as ei,
  Nx as ej,
  Rx as ek,
  Fhe as el,
  Qi as em,
  jq as en,
  b4 as eo,
  sp as ep,
  Yv as eq,
  hv as er,
  Cx as es,
  Kp as et,
  UB as eu,
  zO as ev,
  GV as ew,
  bR as ex,
  er as ey,
  S8 as ez,
  wa as f,
  Ky as f$,
  a$ as f0,
  lR as f1,
  JF as f2,
  TS as f3,
  Qv as f4,
  q_ as f5,
  bpe as f6,
  wS as f7,
  xS as f8,
  the as f9,
  Wx as fA,
  m4 as fB,
  T8 as fC,
  g$ as fD,
  Qw as fE,
  Av as fF,
  Ur as fG,
  s3 as fH,
  Eg as fI,
  $F as fJ,
  Dl as fK,
  Wfe as fL,
  xv as fM,
  n$ as fN,
  Or as fO,
  e8 as fP,
  HO as fQ,
  Zie as fR,
  Rf as fS,
  zp as fT,
  Qf as fU,
  sy as fV,
  Ile as fW,
  bT as fX,
  e3 as fY,
  bc as fZ,
  ju as f_,
  s$ as fa,
  uO as fb,
  h4 as fc,
  mO as fd,
  Xpe as fe,
  Ype as ff,
  Ope as fg,
  Bp as fh,
  eZ as fi,
  A3 as fj,
  Vg as fk,
  Kg as fl,
  UY as fm,
  PY as fn,
  uy as fo,
  xT as fp,
  Vf as fq,
  Tl as fr,
  nr as fs,
  xF as ft,
  IR as fu,
  xae as fv,
  Sy as fw,
  Kf as fx,
  ts as fy,
  XF as fz,
  Phe as g,
  dQ as g$,
  oD as g0,
  WS as g1,
  Wpe as g2,
  ns as g3,
  E2 as g4,
  AP as g5,
  FS as g6,
  Ml as g7,
  SO as g8,
  ml as g9,
  Xx as gA,
  qi as gB,
  K_ as gC,
  q4 as gD,
  ax as gE,
  z_ as gF,
  Ape as gG,
  Epe as gH,
  a0 as gI,
  HU as gJ,
  Gi as gK,
  UJ as gL,
  Cv as gM,
  _g as gN,
  Mg as gO,
  Of as gP,
  Aa as gQ,
  k_ as gR,
  z1 as gS,
  cR as gT,
  Ohe as gU,
  zv as gV,
  Mv as gW,
  bhe as gX,
  ghe as gY,
  Wie as gZ,
  Zoe as g_,
  qS as ga,
  rR as gb,
  Wc as gc,
  MO as gd,
  dP as ge,
  fP as gf,
  HB as gg,
  gA as gh,
  p_ as gi,
  vp as gj,
  WF as gk,
  kl as gl,
  h2 as gm,
  g2 as gn,
  Nfe as go,
  uP as gp,
  bl as gq,
  oi as gr,
  qc as gs,
  aR as gt,
  iR as gu,
  Yr as gv,
  oy as gw,
  RR as gx,
  Ly as gy,
  MT as gz,
  MP as h,
  J_ as h$,
  eh as h0,
  Jc as h1,
  qF as h2,
  ES as h3,
  UP as h4,
  jS as h5,
  tR as h6,
  e_ as h7,
  U$ as h8,
  YO as h9,
  ox as hA,
  Jy as hB,
  FP as hC,
  Ry as hD,
  Gfe as hE,
  Fl as hF,
  S$ as hG,
  jF as hH,
  Mp as hI,
  xhe as hJ,
  uA as hK,
  bA as hL,
  v5 as hM,
  Lle as hN,
  ex as hO,
  mA as hP,
  vA as hQ,
  jhe as hR,
  w0 as hS,
  Vhe as hT,
  kA as hU,
  yhe as hV,
  sP as hW,
  Hp as hX,
  $ne as hY,
  Z4 as hZ,
  aA as h_,
  Lr as ha,
  b_ as hb,
  Lie as hc,
  XV as hd,
  ib as he,
  kue as hf,
  bue as hg,
  wue as hh,
  Hhe as hi,
  o2 as hj,
  Ag as hk,
  mpe as hl,
  hA as hm,
  ih as hn,
  Jpe as ho,
  ahe as hp,
  jie as hq,
  qu as hr,
  Gpe as hs,
  BU as ht,
  m2 as hu,
  Zy as hv,
  ux as hw,
  ZO as hx,
  o3 as hy,
  WO as hz,
  jf as i,
  whe as i$,
  $P as i0,
  jfe as i1,
  lne as i2,
  lP as i3,
  KF as i4,
  HF as i5,
  Ene as i6,
  sO as i7,
  _S as i8,
  UF as i9,
  sne as iA,
  rne as iB,
  Ffe as iC,
  H0 as iD,
  Zi as iE,
  ej as iF,
  ehe as iG,
  Pc as iH,
  Vfe as iI,
  Sf as iJ,
  Dpe as iK,
  Mpe as iL,
  she as iM,
  qie as iN,
  kpe as iO,
  iO as iP,
  e5 as iQ,
  Gr as iR,
  y2 as iS,
  k2 as iT,
  BN as iU,
  YJ as iV,
  BB as iW,
  fce as iX,
  rA as iY,
  pce as iZ,
  cce as i_,
  Qfe as ia,
  $pe as ib,
  Mne as ic,
  gae as id,
  dce as ie,
  Rpe as ig,
  ape as ih,
  Rfe as ii,
  nhe as ij,
  hhe as ik,
  une as il,
  Q2 as im,
  F0 as io,
  t5 as ip,
  iA as iq,
  che as ir,
  C5 as is,
  Pm as it,
  t2 as iu,
  NS as iv,
  Qie as iw,
  pR as ix,
  dR as iy,
  ZS as iz,
  Zw as j,
  LG as j$,
  JS as j0,
  VR as j1,
  Kfe as j2,
  Hfe as j3,
  Nle as j4,
  Rle as j5,
  TF as j6,
  DR as j7,
  HJ as j8,
  Ja as j9,
  gpe as jA,
  tS as jB,
  gR as jC,
  khe as jD,
  roe as jE,
  Dfe as jF,
  y4 as jG,
  Om as jH,
  xY as jI,
  lhe as jJ,
  Rl as jK,
  jO as jL,
  upe as jM,
  JG as jN,
  Yie as jO,
  sQ as jP,
  rx as jQ,
  u3 as jR,
  Wp as jS,
  FB as jT,
  ob as jU,
  qhe as jV,
  vce as jW,
  hce as jX,
  rb as jY,
  qV as jZ,
  dG as j_,
  e4 as ja,
  BR as jb,
  PR as jc,
  m1 as jd,
  Ufe as je,
  tZ as jf,
  NN as jg,
  gS as jh,
  Ipe as ji,
  IN as jj,
  Rv as jk,
  gP as jl,
  ed as jm,
  VJ as jn,
  nO as jo,
  MR as jp,
  J4 as jq,
  pv as jr,
  f2 as js,
  xee as jt,
  wae as ju,
  Yc as jv,
  Cy as jw,
  Ane as jx,
  _4 as jy,
  nS as jz,
  O2 as k,
  g_ as k0,
  tj as k1,
  y5 as k2,
  nne as k3,
  GJ as k4,
  gX as k5,
  OO as k6,
  V0 as k7,
  Zx as k8,
  Fpe as k9,
  qr as kA,
  hpe as kB,
  Zne as kC,
  h5 as ka,
  Xs as kb,
  o5 as kc,
  H$ as kd,
  Sg as ke,
  Ihe as kf,
  Ppe as kg,
  Zpe as kh,
  r2 as ki,
  o_ as kj,
  ig as kk,
  Ux as kl,
  fpe as km,
  Ehe as kn,
  Qpe as ko,
  NB as kp,
  nie as kq,
  Ng as kr,
  Ma as ks,
  LT as kt,
  mv as ku,
  Qs as kv,
  Uf as kw,
  Xa as kx,
  il as ky,
  Wne as kz,
  Qr as l,
  lie as m,
  zt as n,
  Che as o,
  Ahe as p,
  jg as q,
  es as r,
  Dg as s,
  N0 as t,
  ht as u,
  da as v,
  $he as w,
  A2 as x,
  Lfe as y,
  fa as z
};
//# sourceMappingURL=index-D3wrbmdG.js.map
